// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./shepherd.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[1].oneOf[7].use[3]!../../../node_modules/react-scripts/node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[7].use[4]!./mermaid.min.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/materialdesignicons-webfont.eot?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/materialdesignicons-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/materialdesignicons-webfont.woff2?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/materialdesignicons-webfont.woff?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/materialdesignicons-webfont.ttf?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/boxicons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/boxicons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/boxicons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/boxicons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/boxicons.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/la-brands-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/la-brands-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/la-brands-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/la-brands-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/la-brands-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/la-regular-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/la-regular-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/la-regular-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/la-regular-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/la-regular-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/la-solid-900.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/la-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/la-solid-900.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/la-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/la-solid-900.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/remixicon.eot?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../fonts/remixicon.woff2?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../fonts/remixicon.woff?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../fonts/remixicon.ttf?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../fonts/remixicon.svg?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23f9b298%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%230ab39c%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23f06548%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23f06548%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27var%28--vz-body-color%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23da5a2b%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("../fonts/hkgrotesk-light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("../fonts/hkgrotesk-light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("../fonts/hkgrotesk-regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("../fonts/hkgrotesk-regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("../fonts/hkgrotesk-medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("../fonts/hkgrotesk-medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("../fonts/hkgrotesk-semibold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("../fonts/hkgrotesk-semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("../fonts/hkgrotesk-bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("../images/sidebar/img-1.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("../images/sidebar/img-2.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("../images/sidebar/img-3.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("../images/sidebar/img-4.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23adb5bd%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("../images/modal-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 version=%271.1%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 xmlns:svgjs=%27http://svgjs.com/svgjs%27 width=%271440%27 height=%27560%27 preserveAspectRatio=%27none%27 viewBox=%270 0 1440 560%27%3e%3cg mask=%27url%28%26quot%3b%23SvgjsMask1016%26quot%3b%29%27 fill=%27none%27%3e%3crect width=%271440%27 height=%27560%27 x=%270%27 y=%270%27 fill=%27rgba%2864%2c 81%2c 137%2c 1%29%27%3e%3c/rect%3e%3cpath d=%27M0%2c650.704C122.328%2c648.746%2c159.175%2c473.043%2c255.674%2c397.837C339.724%2c332.333%2c461.529%2c324.924%2c526.449%2c240.421C598.428%2c146.73%2c655.546%2c24.847%2c631.015%2c-90.726C606.666%2c-205.444%2c482.926%2c-263.497%2c401.565%2c-347.958C325.215%2c-427.217%2c275.543%2c-549.012%2c167.826%2c-571.563C60.344%2c-594.065%2c-27.703%2c-482.932%2c-135.163%2c-460.325C-256.336%2c-434.833%2c-401.929%2c-509.651%2c-497.972%2c-431.495C-592.807%2c-354.321%2c-579.865%2c-206.886%2c-595.603%2c-85.635C-611.133%2c34.016%2c-656.761%2c169.183%2c-588.884%2c268.934C-520.854%2c368.909%2c-362.458%2c340.324%2c-260.989%2c406.106C-158.875%2c472.306%2c-121.679%2c652.651%2c0%2c650.704%27 fill=%27%2333416e%27%3e%3c/path%3e%3cpath d=%27M1440 995.672C1519.728 984.741 1563.12 899.779 1626.466 850.1469999999999 1682.6390000000001 806.135 1756.261 782.602 1791.2939999999999 720.431 1827.571 656.052 1835.537 577.6610000000001 1820.814 505.247 1806.518 434.933 1753.2640000000001 383.16999999999996 1710.941 325.228 1664.475 261.614 1634.992 175.16000000000003 1560.657 149.07999999999998 1485.96 122.87299999999999 1402.146 155.543 1332.03 192.289 1269.541 225.038 1232.754 287.251 1189.969 343.347 1149.925 395.849 1115.781 448.9 1089.96 509.672 1056 589.599 988.9680000000001 671.1659999999999 1015.557 753.837 1041.91 835.774 1142.714 863.61 1217.498 906.22 1288.388 946.611 1359.167 1006.755 1440 995.672%27 fill=%27%234d61a4%27%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id=%27SvgjsMask1016%27%3e%3crect width=%271440%27 height=%27560%27 fill=%27white%27%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23ced4da%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23ced4da%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_66___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_67___ = new URL("../images/flags/us.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_68___ = new URL("../images/kuzelogo.jpeg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_69___ = new URL("../images/cover-pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_70___ = new URL("../images/nft/marketplace.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_71___ = new URL("../images/chat-bg-pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_72___ = new URL("../images/file.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_73___ = new URL("../images/landing/bg-pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_74___ = new URL("../images/new.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400..700&family=Inter:wght@100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "?#iefix&v=6.5.95" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "?#boxicons" });
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#lineawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#lineawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___, { hash: "#lineawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___, { hash: "#remixicon" });
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_66___);
var ___CSS_LOADER_URL_REPLACEMENT_71___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_67___);
var ___CSS_LOADER_URL_REPLACEMENT_72___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_68___);
var ___CSS_LOADER_URL_REPLACEMENT_73___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_69___);
var ___CSS_LOADER_URL_REPLACEMENT_74___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_70___);
var ___CSS_LOADER_URL_REPLACEMENT_75___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_71___);
var ___CSS_LOADER_URL_REPLACEMENT_76___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_72___);
var ___CSS_LOADER_URL_REPLACEMENT_77___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_73___);
var ___CSS_LOADER_URL_REPLACEMENT_78___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_74___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
Template Name: Velzon - Admin & Dashboard Template
Author: Themesbrand
Version: 2.4.0
Website: https://Themesbrand.com/
Contact: Themesbrand@gmail.com
File: Icons Css File
*/
/* MaterialDesignIcons.com */
@font-face {
  font-family: "Material Design Icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: normal;
  font-style: normal; }

.mdi:before,
.mdi-set {
  display: inline-block;
  font: normal normal normal 24px/1 "Material Design Icons";
  font-size: inherit;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; }

.mdi-ab-testing::before {
  content: "\\F01C9"; }

.mdi-abacus::before {
  content: "\\F16E0"; }

.mdi-abjad-arabic::before {
  content: "\\F1328"; }

.mdi-abjad-hebrew::before {
  content: "\\F1329"; }

.mdi-abugida-devanagari::before {
  content: "\\F132A"; }

.mdi-abugida-thai::before {
  content: "\\F132B"; }

.mdi-access-point::before {
  content: "\\F0003"; }

.mdi-access-point-check::before {
  content: "\\F1538"; }

.mdi-access-point-minus::before {
  content: "\\F1539"; }

.mdi-access-point-network::before {
  content: "\\F0002"; }

.mdi-access-point-network-off::before {
  content: "\\F0BE1"; }

.mdi-access-point-off::before {
  content: "\\F1511"; }

.mdi-access-point-plus::before {
  content: "\\F153A"; }

.mdi-access-point-remove::before {
  content: "\\F153B"; }

.mdi-account::before {
  content: "\\F0004"; }

.mdi-account-alert::before {
  content: "\\F0005"; }

.mdi-account-alert-outline::before {
  content: "\\F0B50"; }

.mdi-account-arrow-down::before {
  content: "\\F1868"; }

.mdi-account-arrow-down-outline::before {
  content: "\\F1869"; }

.mdi-account-arrow-left::before {
  content: "\\F0B51"; }

.mdi-account-arrow-left-outline::before {
  content: "\\F0B52"; }

.mdi-account-arrow-right::before {
  content: "\\F0B53"; }

.mdi-account-arrow-right-outline::before {
  content: "\\F0B54"; }

.mdi-account-arrow-up::before {
  content: "\\F1867"; }

.mdi-account-arrow-up-outline::before {
  content: "\\F186A"; }

.mdi-account-box::before {
  content: "\\F0006"; }

.mdi-account-box-multiple::before {
  content: "\\F0934"; }

.mdi-account-box-multiple-outline::before {
  content: "\\F100A"; }

.mdi-account-box-outline::before {
  content: "\\F0007"; }

.mdi-account-cancel::before {
  content: "\\F12DF"; }

.mdi-account-cancel-outline::before {
  content: "\\F12E0"; }

.mdi-account-cash::before {
  content: "\\F1097"; }

.mdi-account-cash-outline::before {
  content: "\\F1098"; }

.mdi-account-check::before {
  content: "\\F0008"; }

.mdi-account-check-outline::before {
  content: "\\F0BE2"; }

.mdi-account-child::before {
  content: "\\F0A89"; }

.mdi-account-child-circle::before {
  content: "\\F0A8A"; }

.mdi-account-child-outline::before {
  content: "\\F10C8"; }

.mdi-account-circle::before {
  content: "\\F0009"; }

.mdi-account-circle-outline::before {
  content: "\\F0B55"; }

.mdi-account-clock::before {
  content: "\\F0B56"; }

.mdi-account-clock-outline::before {
  content: "\\F0B57"; }

.mdi-account-cog::before {
  content: "\\F1370"; }

.mdi-account-cog-outline::before {
  content: "\\F1371"; }

.mdi-account-convert::before {
  content: "\\F000A"; }

.mdi-account-convert-outline::before {
  content: "\\F1301"; }

.mdi-account-cowboy-hat::before {
  content: "\\F0E9B"; }

.mdi-account-cowboy-hat-outline::before {
  content: "\\F17F3"; }

.mdi-account-details::before {
  content: "\\F0631"; }

.mdi-account-details-outline::before {
  content: "\\F1372"; }

.mdi-account-edit::before {
  content: "\\F06BC"; }

.mdi-account-edit-outline::before {
  content: "\\F0FFB"; }

.mdi-account-eye::before {
  content: "\\F0420"; }

.mdi-account-eye-outline::before {
  content: "\\F127B"; }

.mdi-account-filter::before {
  content: "\\F0936"; }

.mdi-account-filter-outline::before {
  content: "\\F0F9D"; }

.mdi-account-group::before {
  content: "\\F0849"; }

.mdi-account-group-outline::before {
  content: "\\F0B58"; }

.mdi-account-hard-hat::before {
  content: "\\F05B5"; }

.mdi-account-heart::before {
  content: "\\F0899"; }

.mdi-account-heart-outline::before {
  content: "\\F0BE3"; }

.mdi-account-injury::before {
  content: "\\F1815"; }

.mdi-account-injury-outline::before {
  content: "\\F1816"; }

.mdi-account-key::before {
  content: "\\F000B"; }

.mdi-account-key-outline::before {
  content: "\\F0BE4"; }

.mdi-account-lock::before {
  content: "\\F115E"; }

.mdi-account-lock-open::before {
  content: "\\F1960"; }

.mdi-account-lock-open-outline::before {
  content: "\\F1961"; }

.mdi-account-lock-outline::before {
  content: "\\F115F"; }

.mdi-account-minus::before {
  content: "\\F000D"; }

.mdi-account-minus-outline::before {
  content: "\\F0AEC"; }

.mdi-account-multiple::before {
  content: "\\F000E"; }

.mdi-account-multiple-check::before {
  content: "\\F08C5"; }

.mdi-account-multiple-check-outline::before {
  content: "\\F11FE"; }

.mdi-account-multiple-minus::before {
  content: "\\F05D3"; }

.mdi-account-multiple-minus-outline::before {
  content: "\\F0BE5"; }

.mdi-account-multiple-outline::before {
  content: "\\F000F"; }

.mdi-account-multiple-plus::before {
  content: "\\F0010"; }

.mdi-account-multiple-plus-outline::before {
  content: "\\F0800"; }

.mdi-account-multiple-remove::before {
  content: "\\F120A"; }

.mdi-account-multiple-remove-outline::before {
  content: "\\F120B"; }

.mdi-account-music::before {
  content: "\\F0803"; }

.mdi-account-music-outline::before {
  content: "\\F0CE9"; }

.mdi-account-network::before {
  content: "\\F0011"; }

.mdi-account-network-outline::before {
  content: "\\F0BE6"; }

.mdi-account-off::before {
  content: "\\F0012"; }

.mdi-account-off-outline::before {
  content: "\\F0BE7"; }

.mdi-account-outline::before {
  content: "\\F0013"; }

.mdi-account-plus::before {
  content: "\\F0014"; }

.mdi-account-plus-outline::before {
  content: "\\F0801"; }

.mdi-account-question::before {
  content: "\\F0B59"; }

.mdi-account-question-outline::before {
  content: "\\F0B5A"; }

.mdi-account-reactivate::before {
  content: "\\F152B"; }

.mdi-account-reactivate-outline::before {
  content: "\\F152C"; }

.mdi-account-remove::before {
  content: "\\F0015"; }

.mdi-account-remove-outline::before {
  content: "\\F0AED"; }

.mdi-account-search::before {
  content: "\\F0016"; }

.mdi-account-search-outline::before {
  content: "\\F0935"; }

.mdi-account-settings::before {
  content: "\\F0630"; }

.mdi-account-settings-outline::before {
  content: "\\F10C9"; }

.mdi-account-star::before {
  content: "\\F0017"; }

.mdi-account-star-outline::before {
  content: "\\F0BE8"; }

.mdi-account-supervisor::before {
  content: "\\F0A8B"; }

.mdi-account-supervisor-circle::before {
  content: "\\F0A8C"; }

.mdi-account-supervisor-circle-outline::before {
  content: "\\F14EC"; }

.mdi-account-supervisor-outline::before {
  content: "\\F112D"; }

.mdi-account-switch::before {
  content: "\\F0019"; }

.mdi-account-switch-outline::before {
  content: "\\F04CB"; }

.mdi-account-sync::before {
  content: "\\F191B"; }

.mdi-account-sync-outline::before {
  content: "\\F191C"; }

.mdi-account-tie::before {
  content: "\\F0CE3"; }

.mdi-account-tie-hat::before {
  content: "\\F1898"; }

.mdi-account-tie-hat-outline::before {
  content: "\\F1899"; }

.mdi-account-tie-outline::before {
  content: "\\F10CA"; }

.mdi-account-tie-voice::before {
  content: "\\F1308"; }

.mdi-account-tie-voice-off::before {
  content: "\\F130A"; }

.mdi-account-tie-voice-off-outline::before {
  content: "\\F130B"; }

.mdi-account-tie-voice-outline::before {
  content: "\\F1309"; }

.mdi-account-voice::before {
  content: "\\F05CB"; }

.mdi-account-voice-off::before {
  content: "\\F0ED4"; }

.mdi-account-wrench::before {
  content: "\\F189A"; }

.mdi-account-wrench-outline::before {
  content: "\\F189B"; }

.mdi-adjust::before {
  content: "\\F001A"; }

.mdi-advertisements::before {
  content: "\\F192A"; }

.mdi-advertisements-off::before {
  content: "\\F192B"; }

.mdi-air-conditioner::before {
  content: "\\F001B"; }

.mdi-air-filter::before {
  content: "\\F0D43"; }

.mdi-air-horn::before {
  content: "\\F0DAC"; }

.mdi-air-humidifier::before {
  content: "\\F1099"; }

.mdi-air-humidifier-off::before {
  content: "\\F1466"; }

.mdi-air-purifier::before {
  content: "\\F0D44"; }

.mdi-airbag::before {
  content: "\\F0BE9"; }

.mdi-airballoon::before {
  content: "\\F001C"; }

.mdi-airballoon-outline::before {
  content: "\\F100B"; }

.mdi-airplane::before {
  content: "\\F001D"; }

.mdi-airplane-alert::before {
  content: "\\F187A"; }

.mdi-airplane-check::before {
  content: "\\F187B"; }

.mdi-airplane-clock::before {
  content: "\\F187C"; }

.mdi-airplane-cog::before {
  content: "\\F187D"; }

.mdi-airplane-edit::before {
  content: "\\F187E"; }

.mdi-airplane-landing::before {
  content: "\\F05D4"; }

.mdi-airplane-marker::before {
  content: "\\F187F"; }

.mdi-airplane-minus::before {
  content: "\\F1880"; }

.mdi-airplane-off::before {
  content: "\\F001E"; }

.mdi-airplane-plus::before {
  content: "\\F1881"; }

.mdi-airplane-remove::before {
  content: "\\F1882"; }

.mdi-airplane-search::before {
  content: "\\F1883"; }

.mdi-airplane-settings::before {
  content: "\\F1884"; }

.mdi-airplane-takeoff::before {
  content: "\\F05D5"; }

.mdi-airport::before {
  content: "\\F084B"; }

.mdi-alarm::before {
  content: "\\F0020"; }

.mdi-alarm-bell::before {
  content: "\\F078E"; }

.mdi-alarm-check::before {
  content: "\\F0021"; }

.mdi-alarm-light::before {
  content: "\\F078F"; }

.mdi-alarm-light-off::before {
  content: "\\F171E"; }

.mdi-alarm-light-off-outline::before {
  content: "\\F171F"; }

.mdi-alarm-light-outline::before {
  content: "\\F0BEA"; }

.mdi-alarm-multiple::before {
  content: "\\F0022"; }

.mdi-alarm-note::before {
  content: "\\F0E71"; }

.mdi-alarm-note-off::before {
  content: "\\F0E72"; }

.mdi-alarm-off::before {
  content: "\\F0023"; }

.mdi-alarm-panel::before {
  content: "\\F15C4"; }

.mdi-alarm-panel-outline::before {
  content: "\\F15C5"; }

.mdi-alarm-plus::before {
  content: "\\F0024"; }

.mdi-alarm-snooze::before {
  content: "\\F068E"; }

.mdi-album::before {
  content: "\\F0025"; }

.mdi-alert::before {
  content: "\\F0026"; }

.mdi-alert-box::before {
  content: "\\F0027"; }

.mdi-alert-box-outline::before {
  content: "\\F0CE4"; }

.mdi-alert-circle::before {
  content: "\\F0028"; }

.mdi-alert-circle-check::before {
  content: "\\F11ED"; }

.mdi-alert-circle-check-outline::before {
  content: "\\F11EE"; }

.mdi-alert-circle-outline::before {
  content: "\\F05D6"; }

.mdi-alert-decagram::before {
  content: "\\F06BD"; }

.mdi-alert-decagram-outline::before {
  content: "\\F0CE5"; }

.mdi-alert-minus::before {
  content: "\\F14BB"; }

.mdi-alert-minus-outline::before {
  content: "\\F14BE"; }

.mdi-alert-octagon::before {
  content: "\\F0029"; }

.mdi-alert-octagon-outline::before {
  content: "\\F0CE6"; }

.mdi-alert-octagram::before {
  content: "\\F0767"; }

.mdi-alert-octagram-outline::before {
  content: "\\F0CE7"; }

.mdi-alert-outline::before {
  content: "\\F002A"; }

.mdi-alert-plus::before {
  content: "\\F14BA"; }

.mdi-alert-plus-outline::before {
  content: "\\F14BD"; }

.mdi-alert-remove::before {
  content: "\\F14BC"; }

.mdi-alert-remove-outline::before {
  content: "\\F14BF"; }

.mdi-alert-rhombus::before {
  content: "\\F11CE"; }

.mdi-alert-rhombus-outline::before {
  content: "\\F11CF"; }

.mdi-alien::before {
  content: "\\F089A"; }

.mdi-alien-outline::before {
  content: "\\F10CB"; }

.mdi-align-horizontal-center::before {
  content: "\\F11C3"; }

.mdi-align-horizontal-distribute::before {
  content: "\\F1962"; }

.mdi-align-horizontal-left::before {
  content: "\\F11C2"; }

.mdi-align-horizontal-right::before {
  content: "\\F11C4"; }

.mdi-align-vertical-bottom::before {
  content: "\\F11C5"; }

.mdi-align-vertical-center::before {
  content: "\\F11C6"; }

.mdi-align-vertical-distribute::before {
  content: "\\F1963"; }

.mdi-align-vertical-top::before {
  content: "\\F11C7"; }

.mdi-all-inclusive::before {
  content: "\\F06BE"; }

.mdi-all-inclusive-box::before {
  content: "\\F188D"; }

.mdi-all-inclusive-box-outline::before {
  content: "\\F188E"; }

.mdi-allergy::before {
  content: "\\F1258"; }

.mdi-alpha::before {
  content: "\\F002B"; }

.mdi-alpha-a::before {
  content: "\\F0AEE"; }

.mdi-alpha-a-box::before {
  content: "\\F0B08"; }

.mdi-alpha-a-box-outline::before {
  content: "\\F0BEB"; }

.mdi-alpha-a-circle::before {
  content: "\\F0BEC"; }

.mdi-alpha-a-circle-outline::before {
  content: "\\F0BED"; }

.mdi-alpha-b::before {
  content: "\\F0AEF"; }

.mdi-alpha-b-box::before {
  content: "\\F0B09"; }

.mdi-alpha-b-box-outline::before {
  content: "\\F0BEE"; }

.mdi-alpha-b-circle::before {
  content: "\\F0BEF"; }

.mdi-alpha-b-circle-outline::before {
  content: "\\F0BF0"; }

.mdi-alpha-c::before {
  content: "\\F0AF0"; }

.mdi-alpha-c-box::before {
  content: "\\F0B0A"; }

.mdi-alpha-c-box-outline::before {
  content: "\\F0BF1"; }

.mdi-alpha-c-circle::before {
  content: "\\F0BF2"; }

.mdi-alpha-c-circle-outline::before {
  content: "\\F0BF3"; }

.mdi-alpha-d::before {
  content: "\\F0AF1"; }

.mdi-alpha-d-box::before {
  content: "\\F0B0B"; }

.mdi-alpha-d-box-outline::before {
  content: "\\F0BF4"; }

.mdi-alpha-d-circle::before {
  content: "\\F0BF5"; }

.mdi-alpha-d-circle-outline::before {
  content: "\\F0BF6"; }

.mdi-alpha-e::before {
  content: "\\F0AF2"; }

.mdi-alpha-e-box::before {
  content: "\\F0B0C"; }

.mdi-alpha-e-box-outline::before {
  content: "\\F0BF7"; }

.mdi-alpha-e-circle::before {
  content: "\\F0BF8"; }

.mdi-alpha-e-circle-outline::before {
  content: "\\F0BF9"; }

.mdi-alpha-f::before {
  content: "\\F0AF3"; }

.mdi-alpha-f-box::before {
  content: "\\F0B0D"; }

.mdi-alpha-f-box-outline::before {
  content: "\\F0BFA"; }

.mdi-alpha-f-circle::before {
  content: "\\F0BFB"; }

.mdi-alpha-f-circle-outline::before {
  content: "\\F0BFC"; }

.mdi-alpha-g::before {
  content: "\\F0AF4"; }

.mdi-alpha-g-box::before {
  content: "\\F0B0E"; }

.mdi-alpha-g-box-outline::before {
  content: "\\F0BFD"; }

.mdi-alpha-g-circle::before {
  content: "\\F0BFE"; }

.mdi-alpha-g-circle-outline::before {
  content: "\\F0BFF"; }

.mdi-alpha-h::before {
  content: "\\F0AF5"; }

.mdi-alpha-h-box::before {
  content: "\\F0B0F"; }

.mdi-alpha-h-box-outline::before {
  content: "\\F0C00"; }

.mdi-alpha-h-circle::before {
  content: "\\F0C01"; }

.mdi-alpha-h-circle-outline::before {
  content: "\\F0C02"; }

.mdi-alpha-i::before {
  content: "\\F0AF6"; }

.mdi-alpha-i-box::before {
  content: "\\F0B10"; }

.mdi-alpha-i-box-outline::before {
  content: "\\F0C03"; }

.mdi-alpha-i-circle::before {
  content: "\\F0C04"; }

.mdi-alpha-i-circle-outline::before {
  content: "\\F0C05"; }

.mdi-alpha-j::before {
  content: "\\F0AF7"; }

.mdi-alpha-j-box::before {
  content: "\\F0B11"; }

.mdi-alpha-j-box-outline::before {
  content: "\\F0C06"; }

.mdi-alpha-j-circle::before {
  content: "\\F0C07"; }

.mdi-alpha-j-circle-outline::before {
  content: "\\F0C08"; }

.mdi-alpha-k::before {
  content: "\\F0AF8"; }

.mdi-alpha-k-box::before {
  content: "\\F0B12"; }

.mdi-alpha-k-box-outline::before {
  content: "\\F0C09"; }

.mdi-alpha-k-circle::before {
  content: "\\F0C0A"; }

.mdi-alpha-k-circle-outline::before {
  content: "\\F0C0B"; }

.mdi-alpha-l::before {
  content: "\\F0AF9"; }

.mdi-alpha-l-box::before {
  content: "\\F0B13"; }

.mdi-alpha-l-box-outline::before {
  content: "\\F0C0C"; }

.mdi-alpha-l-circle::before {
  content: "\\F0C0D"; }

.mdi-alpha-l-circle-outline::before {
  content: "\\F0C0E"; }

.mdi-alpha-m::before {
  content: "\\F0AFA"; }

.mdi-alpha-m-box::before {
  content: "\\F0B14"; }

.mdi-alpha-m-box-outline::before {
  content: "\\F0C0F"; }

.mdi-alpha-m-circle::before {
  content: "\\F0C10"; }

.mdi-alpha-m-circle-outline::before {
  content: "\\F0C11"; }

.mdi-alpha-n::before {
  content: "\\F0AFB"; }

.mdi-alpha-n-box::before {
  content: "\\F0B15"; }

.mdi-alpha-n-box-outline::before {
  content: "\\F0C12"; }

.mdi-alpha-n-circle::before {
  content: "\\F0C13"; }

.mdi-alpha-n-circle-outline::before {
  content: "\\F0C14"; }

.mdi-alpha-o::before {
  content: "\\F0AFC"; }

.mdi-alpha-o-box::before {
  content: "\\F0B16"; }

.mdi-alpha-o-box-outline::before {
  content: "\\F0C15"; }

.mdi-alpha-o-circle::before {
  content: "\\F0C16"; }

.mdi-alpha-o-circle-outline::before {
  content: "\\F0C17"; }

.mdi-alpha-p::before {
  content: "\\F0AFD"; }

.mdi-alpha-p-box::before {
  content: "\\F0B17"; }

.mdi-alpha-p-box-outline::before {
  content: "\\F0C18"; }

.mdi-alpha-p-circle::before {
  content: "\\F0C19"; }

.mdi-alpha-p-circle-outline::before {
  content: "\\F0C1A"; }

.mdi-alpha-q::before {
  content: "\\F0AFE"; }

.mdi-alpha-q-box::before {
  content: "\\F0B18"; }

.mdi-alpha-q-box-outline::before {
  content: "\\F0C1B"; }

.mdi-alpha-q-circle::before {
  content: "\\F0C1C"; }

.mdi-alpha-q-circle-outline::before {
  content: "\\F0C1D"; }

.mdi-alpha-r::before {
  content: "\\F0AFF"; }

.mdi-alpha-r-box::before {
  content: "\\F0B19"; }

.mdi-alpha-r-box-outline::before {
  content: "\\F0C1E"; }

.mdi-alpha-r-circle::before {
  content: "\\F0C1F"; }

.mdi-alpha-r-circle-outline::before {
  content: "\\F0C20"; }

.mdi-alpha-s::before {
  content: "\\F0B00"; }

.mdi-alpha-s-box::before {
  content: "\\F0B1A"; }

.mdi-alpha-s-box-outline::before {
  content: "\\F0C21"; }

.mdi-alpha-s-circle::before {
  content: "\\F0C22"; }

.mdi-alpha-s-circle-outline::before {
  content: "\\F0C23"; }

.mdi-alpha-t::before {
  content: "\\F0B01"; }

.mdi-alpha-t-box::before {
  content: "\\F0B1B"; }

.mdi-alpha-t-box-outline::before {
  content: "\\F0C24"; }

.mdi-alpha-t-circle::before {
  content: "\\F0C25"; }

.mdi-alpha-t-circle-outline::before {
  content: "\\F0C26"; }

.mdi-alpha-u::before {
  content: "\\F0B02"; }

.mdi-alpha-u-box::before {
  content: "\\F0B1C"; }

.mdi-alpha-u-box-outline::before {
  content: "\\F0C27"; }

.mdi-alpha-u-circle::before {
  content: "\\F0C28"; }

.mdi-alpha-u-circle-outline::before {
  content: "\\F0C29"; }

.mdi-alpha-v::before {
  content: "\\F0B03"; }

.mdi-alpha-v-box::before {
  content: "\\F0B1D"; }

.mdi-alpha-v-box-outline::before {
  content: "\\F0C2A"; }

.mdi-alpha-v-circle::before {
  content: "\\F0C2B"; }

.mdi-alpha-v-circle-outline::before {
  content: "\\F0C2C"; }

.mdi-alpha-w::before {
  content: "\\F0B04"; }

.mdi-alpha-w-box::before {
  content: "\\F0B1E"; }

.mdi-alpha-w-box-outline::before {
  content: "\\F0C2D"; }

.mdi-alpha-w-circle::before {
  content: "\\F0C2E"; }

.mdi-alpha-w-circle-outline::before {
  content: "\\F0C2F"; }

.mdi-alpha-x::before {
  content: "\\F0B05"; }

.mdi-alpha-x-box::before {
  content: "\\F0B1F"; }

.mdi-alpha-x-box-outline::before {
  content: "\\F0C30"; }

.mdi-alpha-x-circle::before {
  content: "\\F0C31"; }

.mdi-alpha-x-circle-outline::before {
  content: "\\F0C32"; }

.mdi-alpha-y::before {
  content: "\\F0B06"; }

.mdi-alpha-y-box::before {
  content: "\\F0B20"; }

.mdi-alpha-y-box-outline::before {
  content: "\\F0C33"; }

.mdi-alpha-y-circle::before {
  content: "\\F0C34"; }

.mdi-alpha-y-circle-outline::before {
  content: "\\F0C35"; }

.mdi-alpha-z::before {
  content: "\\F0B07"; }

.mdi-alpha-z-box::before {
  content: "\\F0B21"; }

.mdi-alpha-z-box-outline::before {
  content: "\\F0C36"; }

.mdi-alpha-z-circle::before {
  content: "\\F0C37"; }

.mdi-alpha-z-circle-outline::before {
  content: "\\F0C38"; }

.mdi-alphabet-aurebesh::before {
  content: "\\F132C"; }

.mdi-alphabet-cyrillic::before {
  content: "\\F132D"; }

.mdi-alphabet-greek::before {
  content: "\\F132E"; }

.mdi-alphabet-latin::before {
  content: "\\F132F"; }

.mdi-alphabet-piqad::before {
  content: "\\F1330"; }

.mdi-alphabet-tengwar::before {
  content: "\\F1337"; }

.mdi-alphabetical::before {
  content: "\\F002C"; }

.mdi-alphabetical-off::before {
  content: "\\F100C"; }

.mdi-alphabetical-variant::before {
  content: "\\F100D"; }

.mdi-alphabetical-variant-off::before {
  content: "\\F100E"; }

.mdi-altimeter::before {
  content: "\\F05D7"; }

.mdi-ambulance::before {
  content: "\\F002F"; }

.mdi-ammunition::before {
  content: "\\F0CE8"; }

.mdi-ampersand::before {
  content: "\\F0A8D"; }

.mdi-amplifier::before {
  content: "\\F0030"; }

.mdi-amplifier-off::before {
  content: "\\F11B5"; }

.mdi-anchor::before {
  content: "\\F0031"; }

.mdi-android::before {
  content: "\\F0032"; }

.mdi-android-messages::before {
  content: "\\F0D45"; }

.mdi-android-studio::before {
  content: "\\F0034"; }

.mdi-angle-acute::before {
  content: "\\F0937"; }

.mdi-angle-obtuse::before {
  content: "\\F0938"; }

.mdi-angle-right::before {
  content: "\\F0939"; }

.mdi-angular::before {
  content: "\\F06B2"; }

.mdi-angularjs::before {
  content: "\\F06BF"; }

.mdi-animation::before {
  content: "\\F05D8"; }

.mdi-animation-outline::before {
  content: "\\F0A8F"; }

.mdi-animation-play::before {
  content: "\\F093A"; }

.mdi-animation-play-outline::before {
  content: "\\F0A90"; }

.mdi-ansible::before {
  content: "\\F109A"; }

.mdi-antenna::before {
  content: "\\F1119"; }

.mdi-anvil::before {
  content: "\\F089B"; }

.mdi-apache-kafka::before {
  content: "\\F100F"; }

.mdi-api::before {
  content: "\\F109B"; }

.mdi-api-off::before {
  content: "\\F1257"; }

.mdi-apple::before {
  content: "\\F0035"; }

.mdi-apple-finder::before {
  content: "\\F0036"; }

.mdi-apple-icloud::before {
  content: "\\F0038"; }

.mdi-apple-ios::before {
  content: "\\F0037"; }

.mdi-apple-keyboard-caps::before {
  content: "\\F0632"; }

.mdi-apple-keyboard-command::before {
  content: "\\F0633"; }

.mdi-apple-keyboard-control::before {
  content: "\\F0634"; }

.mdi-apple-keyboard-option::before {
  content: "\\F0635"; }

.mdi-apple-keyboard-shift::before {
  content: "\\F0636"; }

.mdi-apple-safari::before {
  content: "\\F0039"; }

.mdi-application::before {
  content: "\\F08C6"; }

.mdi-application-array::before {
  content: "\\F10F5"; }

.mdi-application-array-outline::before {
  content: "\\F10F6"; }

.mdi-application-braces::before {
  content: "\\F10F7"; }

.mdi-application-braces-outline::before {
  content: "\\F10F8"; }

.mdi-application-brackets::before {
  content: "\\F0C8B"; }

.mdi-application-brackets-outline::before {
  content: "\\F0C8C"; }

.mdi-application-cog::before {
  content: "\\F0675"; }

.mdi-application-cog-outline::before {
  content: "\\F1577"; }

.mdi-application-edit::before {
  content: "\\F00AE"; }

.mdi-application-edit-outline::before {
  content: "\\F0619"; }

.mdi-application-export::before {
  content: "\\F0DAD"; }

.mdi-application-import::before {
  content: "\\F0DAE"; }

.mdi-application-outline::before {
  content: "\\F0614"; }

.mdi-application-parentheses::before {
  content: "\\F10F9"; }

.mdi-application-parentheses-outline::before {
  content: "\\F10FA"; }

.mdi-application-settings::before {
  content: "\\F0B60"; }

.mdi-application-settings-outline::before {
  content: "\\F1555"; }

.mdi-application-variable::before {
  content: "\\F10FB"; }

.mdi-application-variable-outline::before {
  content: "\\F10FC"; }

.mdi-approximately-equal::before {
  content: "\\F0F9E"; }

.mdi-approximately-equal-box::before {
  content: "\\F0F9F"; }

.mdi-apps::before {
  content: "\\F003B"; }

.mdi-apps-box::before {
  content: "\\F0D46"; }

.mdi-arch::before {
  content: "\\F08C7"; }

.mdi-archive::before {
  content: "\\F003C"; }

.mdi-archive-alert::before {
  content: "\\F14FD"; }

.mdi-archive-alert-outline::before {
  content: "\\F14FE"; }

.mdi-archive-arrow-down::before {
  content: "\\F1259"; }

.mdi-archive-arrow-down-outline::before {
  content: "\\F125A"; }

.mdi-archive-arrow-up::before {
  content: "\\F125B"; }

.mdi-archive-arrow-up-outline::before {
  content: "\\F125C"; }

.mdi-archive-cancel::before {
  content: "\\F174B"; }

.mdi-archive-cancel-outline::before {
  content: "\\F174C"; }

.mdi-archive-check::before {
  content: "\\F174D"; }

.mdi-archive-check-outline::before {
  content: "\\F174E"; }

.mdi-archive-clock::before {
  content: "\\F174F"; }

.mdi-archive-clock-outline::before {
  content: "\\F1750"; }

.mdi-archive-cog::before {
  content: "\\F1751"; }

.mdi-archive-cog-outline::before {
  content: "\\F1752"; }

.mdi-archive-edit::before {
  content: "\\F1753"; }

.mdi-archive-edit-outline::before {
  content: "\\F1754"; }

.mdi-archive-eye::before {
  content: "\\F1755"; }

.mdi-archive-eye-outline::before {
  content: "\\F1756"; }

.mdi-archive-lock::before {
  content: "\\F1757"; }

.mdi-archive-lock-open::before {
  content: "\\F1758"; }

.mdi-archive-lock-open-outline::before {
  content: "\\F1759"; }

.mdi-archive-lock-outline::before {
  content: "\\F175A"; }

.mdi-archive-marker::before {
  content: "\\F175B"; }

.mdi-archive-marker-outline::before {
  content: "\\F175C"; }

.mdi-archive-minus::before {
  content: "\\F175D"; }

.mdi-archive-minus-outline::before {
  content: "\\F175E"; }

.mdi-archive-music::before {
  content: "\\F175F"; }

.mdi-archive-music-outline::before {
  content: "\\F1760"; }

.mdi-archive-off::before {
  content: "\\F1761"; }

.mdi-archive-off-outline::before {
  content: "\\F1762"; }

.mdi-archive-outline::before {
  content: "\\F120E"; }

.mdi-archive-plus::before {
  content: "\\F1763"; }

.mdi-archive-plus-outline::before {
  content: "\\F1764"; }

.mdi-archive-refresh::before {
  content: "\\F1765"; }

.mdi-archive-refresh-outline::before {
  content: "\\F1766"; }

.mdi-archive-remove::before {
  content: "\\F1767"; }

.mdi-archive-remove-outline::before {
  content: "\\F1768"; }

.mdi-archive-search::before {
  content: "\\F1769"; }

.mdi-archive-search-outline::before {
  content: "\\F176A"; }

.mdi-archive-settings::before {
  content: "\\F176B"; }

.mdi-archive-settings-outline::before {
  content: "\\F176C"; }

.mdi-archive-star::before {
  content: "\\F176D"; }

.mdi-archive-star-outline::before {
  content: "\\F176E"; }

.mdi-archive-sync::before {
  content: "\\F176F"; }

.mdi-archive-sync-outline::before {
  content: "\\F1770"; }

.mdi-arm-flex::before {
  content: "\\F0FD7"; }

.mdi-arm-flex-outline::before {
  content: "\\F0FD6"; }

.mdi-arrange-bring-forward::before {
  content: "\\F003D"; }

.mdi-arrange-bring-to-front::before {
  content: "\\F003E"; }

.mdi-arrange-send-backward::before {
  content: "\\F003F"; }

.mdi-arrange-send-to-back::before {
  content: "\\F0040"; }

.mdi-arrow-all::before {
  content: "\\F0041"; }

.mdi-arrow-bottom-left::before {
  content: "\\F0042"; }

.mdi-arrow-bottom-left-bold-box::before {
  content: "\\F1964"; }

.mdi-arrow-bottom-left-bold-box-outline::before {
  content: "\\F1965"; }

.mdi-arrow-bottom-left-bold-outline::before {
  content: "\\F09B7"; }

.mdi-arrow-bottom-left-thick::before {
  content: "\\F09B8"; }

.mdi-arrow-bottom-left-thin::before {
  content: "\\F19B6"; }

.mdi-arrow-bottom-left-thin-circle-outline::before {
  content: "\\F1596"; }

.mdi-arrow-bottom-right::before {
  content: "\\F0043"; }

.mdi-arrow-bottom-right-bold-box::before {
  content: "\\F1966"; }

.mdi-arrow-bottom-right-bold-box-outline::before {
  content: "\\F1967"; }

.mdi-arrow-bottom-right-bold-outline::before {
  content: "\\F09B9"; }

.mdi-arrow-bottom-right-thick::before {
  content: "\\F09BA"; }

.mdi-arrow-bottom-right-thin::before {
  content: "\\F19B7"; }

.mdi-arrow-bottom-right-thin-circle-outline::before {
  content: "\\F1595"; }

.mdi-arrow-collapse::before {
  content: "\\F0615"; }

.mdi-arrow-collapse-all::before {
  content: "\\F0044"; }

.mdi-arrow-collapse-down::before {
  content: "\\F0792"; }

.mdi-arrow-collapse-horizontal::before {
  content: "\\F084C"; }

.mdi-arrow-collapse-left::before {
  content: "\\F0793"; }

.mdi-arrow-collapse-right::before {
  content: "\\F0794"; }

.mdi-arrow-collapse-up::before {
  content: "\\F0795"; }

.mdi-arrow-collapse-vertical::before {
  content: "\\F084D"; }

.mdi-arrow-decision::before {
  content: "\\F09BB"; }

.mdi-arrow-decision-auto::before {
  content: "\\F09BC"; }

.mdi-arrow-decision-auto-outline::before {
  content: "\\F09BD"; }

.mdi-arrow-decision-outline::before {
  content: "\\F09BE"; }

.mdi-arrow-down::before {
  content: "\\F0045"; }

.mdi-arrow-down-bold::before {
  content: "\\F072E"; }

.mdi-arrow-down-bold-box::before {
  content: "\\F072F"; }

.mdi-arrow-down-bold-box-outline::before {
  content: "\\F0730"; }

.mdi-arrow-down-bold-circle::before {
  content: "\\F0047"; }

.mdi-arrow-down-bold-circle-outline::before {
  content: "\\F0048"; }

.mdi-arrow-down-bold-hexagon-outline::before {
  content: "\\F0049"; }

.mdi-arrow-down-bold-outline::before {
  content: "\\F09BF"; }

.mdi-arrow-down-box::before {
  content: "\\F06C0"; }

.mdi-arrow-down-circle::before {
  content: "\\F0CDB"; }

.mdi-arrow-down-circle-outline::before {
  content: "\\F0CDC"; }

.mdi-arrow-down-drop-circle::before {
  content: "\\F004A"; }

.mdi-arrow-down-drop-circle-outline::before {
  content: "\\F004B"; }

.mdi-arrow-down-left::before {
  content: "\\F17A1"; }

.mdi-arrow-down-left-bold::before {
  content: "\\F17A2"; }

.mdi-arrow-down-right::before {
  content: "\\F17A3"; }

.mdi-arrow-down-right-bold::before {
  content: "\\F17A4"; }

.mdi-arrow-down-thick::before {
  content: "\\F0046"; }

.mdi-arrow-down-thin::before {
  content: "\\F19B3"; }

.mdi-arrow-down-thin-circle-outline::before {
  content: "\\F1599"; }

.mdi-arrow-expand::before {
  content: "\\F0616"; }

.mdi-arrow-expand-all::before {
  content: "\\F004C"; }

.mdi-arrow-expand-down::before {
  content: "\\F0796"; }

.mdi-arrow-expand-horizontal::before {
  content: "\\F084E"; }

.mdi-arrow-expand-left::before {
  content: "\\F0797"; }

.mdi-arrow-expand-right::before {
  content: "\\F0798"; }

.mdi-arrow-expand-up::before {
  content: "\\F0799"; }

.mdi-arrow-expand-vertical::before {
  content: "\\F084F"; }

.mdi-arrow-horizontal-lock::before {
  content: "\\F115B"; }

.mdi-arrow-left::before {
  content: "\\F004D"; }

.mdi-arrow-left-bold::before {
  content: "\\F0731"; }

.mdi-arrow-left-bold-box::before {
  content: "\\F0732"; }

.mdi-arrow-left-bold-box-outline::before {
  content: "\\F0733"; }

.mdi-arrow-left-bold-circle::before {
  content: "\\F004F"; }

.mdi-arrow-left-bold-circle-outline::before {
  content: "\\F0050"; }

.mdi-arrow-left-bold-hexagon-outline::before {
  content: "\\F0051"; }

.mdi-arrow-left-bold-outline::before {
  content: "\\F09C0"; }

.mdi-arrow-left-bottom::before {
  content: "\\F17A5"; }

.mdi-arrow-left-bottom-bold::before {
  content: "\\F17A6"; }

.mdi-arrow-left-box::before {
  content: "\\F06C1"; }

.mdi-arrow-left-circle::before {
  content: "\\F0CDD"; }

.mdi-arrow-left-circle-outline::before {
  content: "\\F0CDE"; }

.mdi-arrow-left-drop-circle::before {
  content: "\\F0052"; }

.mdi-arrow-left-drop-circle-outline::before {
  content: "\\F0053"; }

.mdi-arrow-left-right::before {
  content: "\\F0E73"; }

.mdi-arrow-left-right-bold::before {
  content: "\\F0E74"; }

.mdi-arrow-left-right-bold-outline::before {
  content: "\\F09C1"; }

.mdi-arrow-left-thick::before {
  content: "\\F004E"; }

.mdi-arrow-left-thin::before {
  content: "\\F19B1"; }

.mdi-arrow-left-thin-circle-outline::before {
  content: "\\F159A"; }

.mdi-arrow-left-top::before {
  content: "\\F17A7"; }

.mdi-arrow-left-top-bold::before {
  content: "\\F17A8"; }

.mdi-arrow-projectile::before {
  content: "\\F1840"; }

.mdi-arrow-projectile-multiple::before {
  content: "\\F183F"; }

.mdi-arrow-right::before {
  content: "\\F0054"; }

.mdi-arrow-right-bold::before {
  content: "\\F0734"; }

.mdi-arrow-right-bold-box::before {
  content: "\\F0735"; }

.mdi-arrow-right-bold-box-outline::before {
  content: "\\F0736"; }

.mdi-arrow-right-bold-circle::before {
  content: "\\F0056"; }

.mdi-arrow-right-bold-circle-outline::before {
  content: "\\F0057"; }

.mdi-arrow-right-bold-hexagon-outline::before {
  content: "\\F0058"; }

.mdi-arrow-right-bold-outline::before {
  content: "\\F09C2"; }

.mdi-arrow-right-bottom::before {
  content: "\\F17A9"; }

.mdi-arrow-right-bottom-bold::before {
  content: "\\F17AA"; }

.mdi-arrow-right-box::before {
  content: "\\F06C2"; }

.mdi-arrow-right-circle::before {
  content: "\\F0CDF"; }

.mdi-arrow-right-circle-outline::before {
  content: "\\F0CE0"; }

.mdi-arrow-right-drop-circle::before {
  content: "\\F0059"; }

.mdi-arrow-right-drop-circle-outline::before {
  content: "\\F005A"; }

.mdi-arrow-right-thick::before {
  content: "\\F0055"; }

.mdi-arrow-right-thin::before {
  content: "\\F19B0"; }

.mdi-arrow-right-thin-circle-outline::before {
  content: "\\F1598"; }

.mdi-arrow-right-top::before {
  content: "\\F17AB"; }

.mdi-arrow-right-top-bold::before {
  content: "\\F17AC"; }

.mdi-arrow-split-horizontal::before {
  content: "\\F093B"; }

.mdi-arrow-split-vertical::before {
  content: "\\F093C"; }

.mdi-arrow-top-left::before {
  content: "\\F005B"; }

.mdi-arrow-top-left-bold-box::before {
  content: "\\F1968"; }

.mdi-arrow-top-left-bold-box-outline::before {
  content: "\\F1969"; }

.mdi-arrow-top-left-bold-outline::before {
  content: "\\F09C3"; }

.mdi-arrow-top-left-bottom-right::before {
  content: "\\F0E75"; }

.mdi-arrow-top-left-bottom-right-bold::before {
  content: "\\F0E76"; }

.mdi-arrow-top-left-thick::before {
  content: "\\F09C4"; }

.mdi-arrow-top-left-thin::before {
  content: "\\F19B5"; }

.mdi-arrow-top-left-thin-circle-outline::before {
  content: "\\F1593"; }

.mdi-arrow-top-right::before {
  content: "\\F005C"; }

.mdi-arrow-top-right-bold-box::before {
  content: "\\F196A"; }

.mdi-arrow-top-right-bold-box-outline::before {
  content: "\\F196B"; }

.mdi-arrow-top-right-bold-outline::before {
  content: "\\F09C5"; }

.mdi-arrow-top-right-bottom-left::before {
  content: "\\F0E77"; }

.mdi-arrow-top-right-bottom-left-bold::before {
  content: "\\F0E78"; }

.mdi-arrow-top-right-thick::before {
  content: "\\F09C6"; }

.mdi-arrow-top-right-thin::before {
  content: "\\F19B4"; }

.mdi-arrow-top-right-thin-circle-outline::before {
  content: "\\F1594"; }

.mdi-arrow-u-down-left::before {
  content: "\\F17AD"; }

.mdi-arrow-u-down-left-bold::before {
  content: "\\F17AE"; }

.mdi-arrow-u-down-right::before {
  content: "\\F17AF"; }

.mdi-arrow-u-down-right-bold::before {
  content: "\\F17B0"; }

.mdi-arrow-u-left-bottom::before {
  content: "\\F17B1"; }

.mdi-arrow-u-left-bottom-bold::before {
  content: "\\F17B2"; }

.mdi-arrow-u-left-top::before {
  content: "\\F17B3"; }

.mdi-arrow-u-left-top-bold::before {
  content: "\\F17B4"; }

.mdi-arrow-u-right-bottom::before {
  content: "\\F17B5"; }

.mdi-arrow-u-right-bottom-bold::before {
  content: "\\F17B6"; }

.mdi-arrow-u-right-top::before {
  content: "\\F17B7"; }

.mdi-arrow-u-right-top-bold::before {
  content: "\\F17B8"; }

.mdi-arrow-u-up-left::before {
  content: "\\F17B9"; }

.mdi-arrow-u-up-left-bold::before {
  content: "\\F17BA"; }

.mdi-arrow-u-up-right::before {
  content: "\\F17BB"; }

.mdi-arrow-u-up-right-bold::before {
  content: "\\F17BC"; }

.mdi-arrow-up::before {
  content: "\\F005D"; }

.mdi-arrow-up-bold::before {
  content: "\\F0737"; }

.mdi-arrow-up-bold-box::before {
  content: "\\F0738"; }

.mdi-arrow-up-bold-box-outline::before {
  content: "\\F0739"; }

.mdi-arrow-up-bold-circle::before {
  content: "\\F005F"; }

.mdi-arrow-up-bold-circle-outline::before {
  content: "\\F0060"; }

.mdi-arrow-up-bold-hexagon-outline::before {
  content: "\\F0061"; }

.mdi-arrow-up-bold-outline::before {
  content: "\\F09C7"; }

.mdi-arrow-up-box::before {
  content: "\\F06C3"; }

.mdi-arrow-up-circle::before {
  content: "\\F0CE1"; }

.mdi-arrow-up-circle-outline::before {
  content: "\\F0CE2"; }

.mdi-arrow-up-down::before {
  content: "\\F0E79"; }

.mdi-arrow-up-down-bold::before {
  content: "\\F0E7A"; }

.mdi-arrow-up-down-bold-outline::before {
  content: "\\F09C8"; }

.mdi-arrow-up-drop-circle::before {
  content: "\\F0062"; }

.mdi-arrow-up-drop-circle-outline::before {
  content: "\\F0063"; }

.mdi-arrow-up-left::before {
  content: "\\F17BD"; }

.mdi-arrow-up-left-bold::before {
  content: "\\F17BE"; }

.mdi-arrow-up-right::before {
  content: "\\F17BF"; }

.mdi-arrow-up-right-bold::before {
  content: "\\F17C0"; }

.mdi-arrow-up-thick::before {
  content: "\\F005E"; }

.mdi-arrow-up-thin::before {
  content: "\\F19B2"; }

.mdi-arrow-up-thin-circle-outline::before {
  content: "\\F1597"; }

.mdi-arrow-vertical-lock::before {
  content: "\\F115C"; }

.mdi-artstation::before {
  content: "\\F0B5B"; }

.mdi-aspect-ratio::before {
  content: "\\F0A24"; }

.mdi-assistant::before {
  content: "\\F0064"; }

.mdi-asterisk::before {
  content: "\\F06C4"; }

.mdi-at::before {
  content: "\\F0065"; }

.mdi-atlassian::before {
  content: "\\F0804"; }

.mdi-atm::before {
  content: "\\F0D47"; }

.mdi-atom::before {
  content: "\\F0768"; }

.mdi-atom-variant::before {
  content: "\\F0E7B"; }

.mdi-attachment::before {
  content: "\\F0066"; }

.mdi-audio-input-rca::before {
  content: "\\F186B"; }

.mdi-audio-input-stereo-minijack::before {
  content: "\\F186C"; }

.mdi-audio-input-xlr::before {
  content: "\\F186D"; }

.mdi-audio-video::before {
  content: "\\F093D"; }

.mdi-audio-video-off::before {
  content: "\\F11B6"; }

.mdi-augmented-reality::before {
  content: "\\F0850"; }

.mdi-auto-download::before {
  content: "\\F137E"; }

.mdi-auto-fix::before {
  content: "\\F0068"; }

.mdi-auto-upload::before {
  content: "\\F0069"; }

.mdi-autorenew::before {
  content: "\\F006A"; }

.mdi-av-timer::before {
  content: "\\F006B"; }

.mdi-aws::before {
  content: "\\F0E0F"; }

.mdi-axe::before {
  content: "\\F08C8"; }

.mdi-axe-battle::before {
  content: "\\F1842"; }

.mdi-axis::before {
  content: "\\F0D48"; }

.mdi-axis-arrow::before {
  content: "\\F0D49"; }

.mdi-axis-arrow-info::before {
  content: "\\F140E"; }

.mdi-axis-arrow-lock::before {
  content: "\\F0D4A"; }

.mdi-axis-lock::before {
  content: "\\F0D4B"; }

.mdi-axis-x-arrow::before {
  content: "\\F0D4C"; }

.mdi-axis-x-arrow-lock::before {
  content: "\\F0D4D"; }

.mdi-axis-x-rotate-clockwise::before {
  content: "\\F0D4E"; }

.mdi-axis-x-rotate-counterclockwise::before {
  content: "\\F0D4F"; }

.mdi-axis-x-y-arrow-lock::before {
  content: "\\F0D50"; }

.mdi-axis-y-arrow::before {
  content: "\\F0D51"; }

.mdi-axis-y-arrow-lock::before {
  content: "\\F0D52"; }

.mdi-axis-y-rotate-clockwise::before {
  content: "\\F0D53"; }

.mdi-axis-y-rotate-counterclockwise::before {
  content: "\\F0D54"; }

.mdi-axis-z-arrow::before {
  content: "\\F0D55"; }

.mdi-axis-z-arrow-lock::before {
  content: "\\F0D56"; }

.mdi-axis-z-rotate-clockwise::before {
  content: "\\F0D57"; }

.mdi-axis-z-rotate-counterclockwise::before {
  content: "\\F0D58"; }

.mdi-babel::before {
  content: "\\F0A25"; }

.mdi-baby::before {
  content: "\\F006C"; }

.mdi-baby-bottle::before {
  content: "\\F0F39"; }

.mdi-baby-bottle-outline::before {
  content: "\\F0F3A"; }

.mdi-baby-buggy::before {
  content: "\\F13E0"; }

.mdi-baby-carriage::before {
  content: "\\F068F"; }

.mdi-baby-carriage-off::before {
  content: "\\F0FA0"; }

.mdi-baby-face::before {
  content: "\\F0E7C"; }

.mdi-baby-face-outline::before {
  content: "\\F0E7D"; }

.mdi-backburger::before {
  content: "\\F006D"; }

.mdi-backspace::before {
  content: "\\F006E"; }

.mdi-backspace-outline::before {
  content: "\\F0B5C"; }

.mdi-backspace-reverse::before {
  content: "\\F0E7E"; }

.mdi-backspace-reverse-outline::before {
  content: "\\F0E7F"; }

.mdi-backup-restore::before {
  content: "\\F006F"; }

.mdi-bacteria::before {
  content: "\\F0ED5"; }

.mdi-bacteria-outline::before {
  content: "\\F0ED6"; }

.mdi-badge-account::before {
  content: "\\F0DA7"; }

.mdi-badge-account-alert::before {
  content: "\\F0DA8"; }

.mdi-badge-account-alert-outline::before {
  content: "\\F0DA9"; }

.mdi-badge-account-horizontal::before {
  content: "\\F0E0D"; }

.mdi-badge-account-horizontal-outline::before {
  content: "\\F0E0E"; }

.mdi-badge-account-outline::before {
  content: "\\F0DAA"; }

.mdi-badminton::before {
  content: "\\F0851"; }

.mdi-bag-carry-on::before {
  content: "\\F0F3B"; }

.mdi-bag-carry-on-check::before {
  content: "\\F0D65"; }

.mdi-bag-carry-on-off::before {
  content: "\\F0F3C"; }

.mdi-bag-checked::before {
  content: "\\F0F3D"; }

.mdi-bag-personal::before {
  content: "\\F0E10"; }

.mdi-bag-personal-off::before {
  content: "\\F0E11"; }

.mdi-bag-personal-off-outline::before {
  content: "\\F0E12"; }

.mdi-bag-personal-outline::before {
  content: "\\F0E13"; }

.mdi-bag-suitcase::before {
  content: "\\F158B"; }

.mdi-bag-suitcase-off::before {
  content: "\\F158D"; }

.mdi-bag-suitcase-off-outline::before {
  content: "\\F158E"; }

.mdi-bag-suitcase-outline::before {
  content: "\\F158C"; }

.mdi-baguette::before {
  content: "\\F0F3E"; }

.mdi-balcony::before {
  content: "\\F1817"; }

.mdi-balloon::before {
  content: "\\F0A26"; }

.mdi-ballot::before {
  content: "\\F09C9"; }

.mdi-ballot-outline::before {
  content: "\\F09CA"; }

.mdi-ballot-recount::before {
  content: "\\F0C39"; }

.mdi-ballot-recount-outline::before {
  content: "\\F0C3A"; }

.mdi-bandage::before {
  content: "\\F0DAF"; }

.mdi-bank::before {
  content: "\\F0070"; }

.mdi-bank-check::before {
  content: "\\F1655"; }

.mdi-bank-minus::before {
  content: "\\F0DB0"; }

.mdi-bank-off::before {
  content: "\\F1656"; }

.mdi-bank-off-outline::before {
  content: "\\F1657"; }

.mdi-bank-outline::before {
  content: "\\F0E80"; }

.mdi-bank-plus::before {
  content: "\\F0DB1"; }

.mdi-bank-remove::before {
  content: "\\F0DB2"; }

.mdi-bank-transfer::before {
  content: "\\F0A27"; }

.mdi-bank-transfer-in::before {
  content: "\\F0A28"; }

.mdi-bank-transfer-out::before {
  content: "\\F0A29"; }

.mdi-barcode::before {
  content: "\\F0071"; }

.mdi-barcode-off::before {
  content: "\\F1236"; }

.mdi-barcode-scan::before {
  content: "\\F0072"; }

.mdi-barley::before {
  content: "\\F0073"; }

.mdi-barley-off::before {
  content: "\\F0B5D"; }

.mdi-barn::before {
  content: "\\F0B5E"; }

.mdi-barrel::before {
  content: "\\F0074"; }

.mdi-baseball::before {
  content: "\\F0852"; }

.mdi-baseball-bat::before {
  content: "\\F0853"; }

.mdi-baseball-diamond::before {
  content: "\\F15EC"; }

.mdi-baseball-diamond-outline::before {
  content: "\\F15ED"; }

.mdi-bash::before {
  content: "\\F1183"; }

.mdi-basket::before {
  content: "\\F0076"; }

.mdi-basket-check::before {
  content: "\\F18E5"; }

.mdi-basket-check-outline::before {
  content: "\\F18E6"; }

.mdi-basket-fill::before {
  content: "\\F0077"; }

.mdi-basket-minus::before {
  content: "\\F1523"; }

.mdi-basket-minus-outline::before {
  content: "\\F1524"; }

.mdi-basket-off::before {
  content: "\\F1525"; }

.mdi-basket-off-outline::before {
  content: "\\F1526"; }

.mdi-basket-outline::before {
  content: "\\F1181"; }

.mdi-basket-plus::before {
  content: "\\F1527"; }

.mdi-basket-plus-outline::before {
  content: "\\F1528"; }

.mdi-basket-remove::before {
  content: "\\F1529"; }

.mdi-basket-remove-outline::before {
  content: "\\F152A"; }

.mdi-basket-unfill::before {
  content: "\\F0078"; }

.mdi-basketball::before {
  content: "\\F0806"; }

.mdi-basketball-hoop::before {
  content: "\\F0C3B"; }

.mdi-basketball-hoop-outline::before {
  content: "\\F0C3C"; }

.mdi-bat::before {
  content: "\\F0B5F"; }

.mdi-bathtub::before {
  content: "\\F1818"; }

.mdi-bathtub-outline::before {
  content: "\\F1819"; }

.mdi-battery::before {
  content: "\\F0079"; }

.mdi-battery-10::before {
  content: "\\F007A"; }

.mdi-battery-10-bluetooth::before {
  content: "\\F093E"; }

.mdi-battery-20::before {
  content: "\\F007B"; }

.mdi-battery-20-bluetooth::before {
  content: "\\F093F"; }

.mdi-battery-30::before {
  content: "\\F007C"; }

.mdi-battery-30-bluetooth::before {
  content: "\\F0940"; }

.mdi-battery-40::before {
  content: "\\F007D"; }

.mdi-battery-40-bluetooth::before {
  content: "\\F0941"; }

.mdi-battery-50::before {
  content: "\\F007E"; }

.mdi-battery-50-bluetooth::before {
  content: "\\F0942"; }

.mdi-battery-60::before {
  content: "\\F007F"; }

.mdi-battery-60-bluetooth::before {
  content: "\\F0943"; }

.mdi-battery-70::before {
  content: "\\F0080"; }

.mdi-battery-70-bluetooth::before {
  content: "\\F0944"; }

.mdi-battery-80::before {
  content: "\\F0081"; }

.mdi-battery-80-bluetooth::before {
  content: "\\F0945"; }

.mdi-battery-90::before {
  content: "\\F0082"; }

.mdi-battery-90-bluetooth::before {
  content: "\\F0946"; }

.mdi-battery-alert::before {
  content: "\\F0083"; }

.mdi-battery-alert-bluetooth::before {
  content: "\\F0947"; }

.mdi-battery-alert-variant::before {
  content: "\\F10CC"; }

.mdi-battery-alert-variant-outline::before {
  content: "\\F10CD"; }

.mdi-battery-arrow-down::before {
  content: "\\F17DE"; }

.mdi-battery-arrow-down-outline::before {
  content: "\\F17DF"; }

.mdi-battery-arrow-up::before {
  content: "\\F17E0"; }

.mdi-battery-arrow-up-outline::before {
  content: "\\F17E1"; }

.mdi-battery-bluetooth::before {
  content: "\\F0948"; }

.mdi-battery-bluetooth-variant::before {
  content: "\\F0949"; }

.mdi-battery-charging::before {
  content: "\\F0084"; }

.mdi-battery-charging-10::before {
  content: "\\F089C"; }

.mdi-battery-charging-100::before {
  content: "\\F0085"; }

.mdi-battery-charging-20::before {
  content: "\\F0086"; }

.mdi-battery-charging-30::before {
  content: "\\F0087"; }

.mdi-battery-charging-40::before {
  content: "\\F0088"; }

.mdi-battery-charging-50::before {
  content: "\\F089D"; }

.mdi-battery-charging-60::before {
  content: "\\F0089"; }

.mdi-battery-charging-70::before {
  content: "\\F089E"; }

.mdi-battery-charging-80::before {
  content: "\\F008A"; }

.mdi-battery-charging-90::before {
  content: "\\F008B"; }

.mdi-battery-charging-high::before {
  content: "\\F12A6"; }

.mdi-battery-charging-low::before {
  content: "\\F12A4"; }

.mdi-battery-charging-medium::before {
  content: "\\F12A5"; }

.mdi-battery-charging-outline::before {
  content: "\\F089F"; }

.mdi-battery-charging-wireless::before {
  content: "\\F0807"; }

.mdi-battery-charging-wireless-10::before {
  content: "\\F0808"; }

.mdi-battery-charging-wireless-20::before {
  content: "\\F0809"; }

.mdi-battery-charging-wireless-30::before {
  content: "\\F080A"; }

.mdi-battery-charging-wireless-40::before {
  content: "\\F080B"; }

.mdi-battery-charging-wireless-50::before {
  content: "\\F080C"; }

.mdi-battery-charging-wireless-60::before {
  content: "\\F080D"; }

.mdi-battery-charging-wireless-70::before {
  content: "\\F080E"; }

.mdi-battery-charging-wireless-80::before {
  content: "\\F080F"; }

.mdi-battery-charging-wireless-90::before {
  content: "\\F0810"; }

.mdi-battery-charging-wireless-alert::before {
  content: "\\F0811"; }

.mdi-battery-charging-wireless-outline::before {
  content: "\\F0812"; }

.mdi-battery-check::before {
  content: "\\F17E2"; }

.mdi-battery-check-outline::before {
  content: "\\F17E3"; }

.mdi-battery-heart::before {
  content: "\\F120F"; }

.mdi-battery-heart-outline::before {
  content: "\\F1210"; }

.mdi-battery-heart-variant::before {
  content: "\\F1211"; }

.mdi-battery-high::before {
  content: "\\F12A3"; }

.mdi-battery-lock::before {
  content: "\\F179C"; }

.mdi-battery-lock-open::before {
  content: "\\F179D"; }

.mdi-battery-low::before {
  content: "\\F12A1"; }

.mdi-battery-medium::before {
  content: "\\F12A2"; }

.mdi-battery-minus::before {
  content: "\\F17E4"; }

.mdi-battery-minus-outline::before {
  content: "\\F17E5"; }

.mdi-battery-minus-variant::before {
  content: "\\F008C"; }

.mdi-battery-negative::before {
  content: "\\F008D"; }

.mdi-battery-off::before {
  content: "\\F125D"; }

.mdi-battery-off-outline::before {
  content: "\\F125E"; }

.mdi-battery-outline::before {
  content: "\\F008E"; }

.mdi-battery-plus::before {
  content: "\\F17E6"; }

.mdi-battery-plus-outline::before {
  content: "\\F17E7"; }

.mdi-battery-plus-variant::before {
  content: "\\F008F"; }

.mdi-battery-positive::before {
  content: "\\F0090"; }

.mdi-battery-remove::before {
  content: "\\F17E8"; }

.mdi-battery-remove-outline::before {
  content: "\\F17E9"; }

.mdi-battery-sync::before {
  content: "\\F1834"; }

.mdi-battery-sync-outline::before {
  content: "\\F1835"; }

.mdi-battery-unknown::before {
  content: "\\F0091"; }

.mdi-battery-unknown-bluetooth::before {
  content: "\\F094A"; }

.mdi-beach::before {
  content: "\\F0092"; }

.mdi-beaker::before {
  content: "\\F0CEA"; }

.mdi-beaker-alert::before {
  content: "\\F1229"; }

.mdi-beaker-alert-outline::before {
  content: "\\F122A"; }

.mdi-beaker-check::before {
  content: "\\F122B"; }

.mdi-beaker-check-outline::before {
  content: "\\F122C"; }

.mdi-beaker-minus::before {
  content: "\\F122D"; }

.mdi-beaker-minus-outline::before {
  content: "\\F122E"; }

.mdi-beaker-outline::before {
  content: "\\F0690"; }

.mdi-beaker-plus::before {
  content: "\\F122F"; }

.mdi-beaker-plus-outline::before {
  content: "\\F1230"; }

.mdi-beaker-question::before {
  content: "\\F1231"; }

.mdi-beaker-question-outline::before {
  content: "\\F1232"; }

.mdi-beaker-remove::before {
  content: "\\F1233"; }

.mdi-beaker-remove-outline::before {
  content: "\\F1234"; }

.mdi-bed::before {
  content: "\\F02E3"; }

.mdi-bed-double::before {
  content: "\\F0FD4"; }

.mdi-bed-double-outline::before {
  content: "\\F0FD3"; }

.mdi-bed-empty::before {
  content: "\\F08A0"; }

.mdi-bed-king::before {
  content: "\\F0FD2"; }

.mdi-bed-king-outline::before {
  content: "\\F0FD1"; }

.mdi-bed-outline::before {
  content: "\\F0099"; }

.mdi-bed-queen::before {
  content: "\\F0FD0"; }

.mdi-bed-queen-outline::before {
  content: "\\F0FDB"; }

.mdi-bed-single::before {
  content: "\\F106D"; }

.mdi-bed-single-outline::before {
  content: "\\F106E"; }

.mdi-bee::before {
  content: "\\F0FA1"; }

.mdi-bee-flower::before {
  content: "\\F0FA2"; }

.mdi-beehive-off-outline::before {
  content: "\\F13ED"; }

.mdi-beehive-outline::before {
  content: "\\F10CE"; }

.mdi-beekeeper::before {
  content: "\\F14E2"; }

.mdi-beer::before {
  content: "\\F0098"; }

.mdi-beer-outline::before {
  content: "\\F130C"; }

.mdi-bell::before {
  content: "\\F009A"; }

.mdi-bell-alert::before {
  content: "\\F0D59"; }

.mdi-bell-alert-outline::before {
  content: "\\F0E81"; }

.mdi-bell-badge::before {
  content: "\\F116B"; }

.mdi-bell-badge-outline::before {
  content: "\\F0178"; }

.mdi-bell-cancel::before {
  content: "\\F13E7"; }

.mdi-bell-cancel-outline::before {
  content: "\\F13E8"; }

.mdi-bell-check::before {
  content: "\\F11E5"; }

.mdi-bell-check-outline::before {
  content: "\\F11E6"; }

.mdi-bell-circle::before {
  content: "\\F0D5A"; }

.mdi-bell-circle-outline::before {
  content: "\\F0D5B"; }

.mdi-bell-minus::before {
  content: "\\F13E9"; }

.mdi-bell-minus-outline::before {
  content: "\\F13EA"; }

.mdi-bell-off::before {
  content: "\\F009B"; }

.mdi-bell-off-outline::before {
  content: "\\F0A91"; }

.mdi-bell-outline::before {
  content: "\\F009C"; }

.mdi-bell-plus::before {
  content: "\\F009D"; }

.mdi-bell-plus-outline::before {
  content: "\\F0A92"; }

.mdi-bell-remove::before {
  content: "\\F13EB"; }

.mdi-bell-remove-outline::before {
  content: "\\F13EC"; }

.mdi-bell-ring::before {
  content: "\\F009E"; }

.mdi-bell-ring-outline::before {
  content: "\\F009F"; }

.mdi-bell-sleep::before {
  content: "\\F00A0"; }

.mdi-bell-sleep-outline::before {
  content: "\\F0A93"; }

.mdi-beta::before {
  content: "\\F00A1"; }

.mdi-betamax::before {
  content: "\\F09CB"; }

.mdi-biathlon::before {
  content: "\\F0E14"; }

.mdi-bicycle::before {
  content: "\\F109C"; }

.mdi-bicycle-basket::before {
  content: "\\F1235"; }

.mdi-bicycle-cargo::before {
  content: "\\F189C"; }

.mdi-bicycle-electric::before {
  content: "\\F15B4"; }

.mdi-bicycle-penny-farthing::before {
  content: "\\F15E9"; }

.mdi-bike::before {
  content: "\\F00A3"; }

.mdi-bike-fast::before {
  content: "\\F111F"; }

.mdi-billboard::before {
  content: "\\F1010"; }

.mdi-billiards::before {
  content: "\\F0B61"; }

.mdi-billiards-rack::before {
  content: "\\F0B62"; }

.mdi-binoculars::before {
  content: "\\F00A5"; }

.mdi-bio::before {
  content: "\\F00A6"; }

.mdi-biohazard::before {
  content: "\\F00A7"; }

.mdi-bird::before {
  content: "\\F15C6"; }

.mdi-bitbucket::before {
  content: "\\F00A8"; }

.mdi-bitcoin::before {
  content: "\\F0813"; }

.mdi-black-mesa::before {
  content: "\\F00A9"; }

.mdi-blender::before {
  content: "\\F0CEB"; }

.mdi-blender-outline::before {
  content: "\\F181A"; }

.mdi-blender-software::before {
  content: "\\F00AB"; }

.mdi-blinds::before {
  content: "\\F00AC"; }

.mdi-blinds-open::before {
  content: "\\F1011"; }

.mdi-block-helper::before {
  content: "\\F00AD"; }

.mdi-blood-bag::before {
  content: "\\F0CEC"; }

.mdi-bluetooth::before {
  content: "\\F00AF"; }

.mdi-bluetooth-audio::before {
  content: "\\F00B0"; }

.mdi-bluetooth-connect::before {
  content: "\\F00B1"; }

.mdi-bluetooth-off::before {
  content: "\\F00B2"; }

.mdi-bluetooth-settings::before {
  content: "\\F00B3"; }

.mdi-bluetooth-transfer::before {
  content: "\\F00B4"; }

.mdi-blur::before {
  content: "\\F00B5"; }

.mdi-blur-linear::before {
  content: "\\F00B6"; }

.mdi-blur-off::before {
  content: "\\F00B7"; }

.mdi-blur-radial::before {
  content: "\\F00B8"; }

.mdi-bolt::before {
  content: "\\F0DB3"; }

.mdi-bomb::before {
  content: "\\F0691"; }

.mdi-bomb-off::before {
  content: "\\F06C5"; }

.mdi-bone::before {
  content: "\\F00B9"; }

.mdi-book::before {
  content: "\\F00BA"; }

.mdi-book-account::before {
  content: "\\F13AD"; }

.mdi-book-account-outline::before {
  content: "\\F13AE"; }

.mdi-book-alert::before {
  content: "\\F167C"; }

.mdi-book-alert-outline::before {
  content: "\\F167D"; }

.mdi-book-alphabet::before {
  content: "\\F061D"; }

.mdi-book-arrow-down::before {
  content: "\\F167E"; }

.mdi-book-arrow-down-outline::before {
  content: "\\F167F"; }

.mdi-book-arrow-left::before {
  content: "\\F1680"; }

.mdi-book-arrow-left-outline::before {
  content: "\\F1681"; }

.mdi-book-arrow-right::before {
  content: "\\F1682"; }

.mdi-book-arrow-right-outline::before {
  content: "\\F1683"; }

.mdi-book-arrow-up::before {
  content: "\\F1684"; }

.mdi-book-arrow-up-outline::before {
  content: "\\F1685"; }

.mdi-book-cancel::before {
  content: "\\F1686"; }

.mdi-book-cancel-outline::before {
  content: "\\F1687"; }

.mdi-book-check::before {
  content: "\\F14F3"; }

.mdi-book-check-outline::before {
  content: "\\F14F4"; }

.mdi-book-clock::before {
  content: "\\F1688"; }

.mdi-book-clock-outline::before {
  content: "\\F1689"; }

.mdi-book-cog::before {
  content: "\\F168A"; }

.mdi-book-cog-outline::before {
  content: "\\F168B"; }

.mdi-book-cross::before {
  content: "\\F00A2"; }

.mdi-book-edit::before {
  content: "\\F168C"; }

.mdi-book-edit-outline::before {
  content: "\\F168D"; }

.mdi-book-education::before {
  content: "\\F16C9"; }

.mdi-book-education-outline::before {
  content: "\\F16CA"; }

.mdi-book-information-variant::before {
  content: "\\F106F"; }

.mdi-book-lock::before {
  content: "\\F079A"; }

.mdi-book-lock-open::before {
  content: "\\F079B"; }

.mdi-book-lock-open-outline::before {
  content: "\\F168E"; }

.mdi-book-lock-outline::before {
  content: "\\F168F"; }

.mdi-book-marker::before {
  content: "\\F1690"; }

.mdi-book-marker-outline::before {
  content: "\\F1691"; }

.mdi-book-minus::before {
  content: "\\F05D9"; }

.mdi-book-minus-multiple::before {
  content: "\\F0A94"; }

.mdi-book-minus-multiple-outline::before {
  content: "\\F090B"; }

.mdi-book-minus-outline::before {
  content: "\\F1692"; }

.mdi-book-multiple::before {
  content: "\\F00BB"; }

.mdi-book-multiple-outline::before {
  content: "\\F0436"; }

.mdi-book-music::before {
  content: "\\F0067"; }

.mdi-book-music-outline::before {
  content: "\\F1693"; }

.mdi-book-off::before {
  content: "\\F1694"; }

.mdi-book-off-outline::before {
  content: "\\F1695"; }

.mdi-book-open::before {
  content: "\\F00BD"; }

.mdi-book-open-blank-variant::before {
  content: "\\F00BE"; }

.mdi-book-open-outline::before {
  content: "\\F0B63"; }

.mdi-book-open-page-variant::before {
  content: "\\F05DA"; }

.mdi-book-open-page-variant-outline::before {
  content: "\\F15D6"; }

.mdi-book-open-variant::before {
  content: "\\F14F7"; }

.mdi-book-outline::before {
  content: "\\F0B64"; }

.mdi-book-play::before {
  content: "\\F0E82"; }

.mdi-book-play-outline::before {
  content: "\\F0E83"; }

.mdi-book-plus::before {
  content: "\\F05DB"; }

.mdi-book-plus-multiple::before {
  content: "\\F0A95"; }

.mdi-book-plus-multiple-outline::before {
  content: "\\F0ADE"; }

.mdi-book-plus-outline::before {
  content: "\\F1696"; }

.mdi-book-refresh::before {
  content: "\\F1697"; }

.mdi-book-refresh-outline::before {
  content: "\\F1698"; }

.mdi-book-remove::before {
  content: "\\F0A97"; }

.mdi-book-remove-multiple::before {
  content: "\\F0A96"; }

.mdi-book-remove-multiple-outline::before {
  content: "\\F04CA"; }

.mdi-book-remove-outline::before {
  content: "\\F1699"; }

.mdi-book-search::before {
  content: "\\F0E84"; }

.mdi-book-search-outline::before {
  content: "\\F0E85"; }

.mdi-book-settings::before {
  content: "\\F169A"; }

.mdi-book-settings-outline::before {
  content: "\\F169B"; }

.mdi-book-sync::before {
  content: "\\F169C"; }

.mdi-book-sync-outline::before {
  content: "\\F16C8"; }

.mdi-book-variant::before {
  content: "\\F00BF"; }

.mdi-book-variant-multiple::before {
  content: "\\F00BC"; }

.mdi-bookmark::before {
  content: "\\F00C0"; }

.mdi-bookmark-box-multiple::before {
  content: "\\F196C"; }

.mdi-bookmark-box-multiple-outline::before {
  content: "\\F196D"; }

.mdi-bookmark-check::before {
  content: "\\F00C1"; }

.mdi-bookmark-check-outline::before {
  content: "\\F137B"; }

.mdi-bookmark-minus::before {
  content: "\\F09CC"; }

.mdi-bookmark-minus-outline::before {
  content: "\\F09CD"; }

.mdi-bookmark-multiple::before {
  content: "\\F0E15"; }

.mdi-bookmark-multiple-outline::before {
  content: "\\F0E16"; }

.mdi-bookmark-music::before {
  content: "\\F00C2"; }

.mdi-bookmark-music-outline::before {
  content: "\\F1379"; }

.mdi-bookmark-off::before {
  content: "\\F09CE"; }

.mdi-bookmark-off-outline::before {
  content: "\\F09CF"; }

.mdi-bookmark-outline::before {
  content: "\\F00C3"; }

.mdi-bookmark-plus::before {
  content: "\\F00C5"; }

.mdi-bookmark-plus-outline::before {
  content: "\\F00C4"; }

.mdi-bookmark-remove::before {
  content: "\\F00C6"; }

.mdi-bookmark-remove-outline::before {
  content: "\\F137A"; }

.mdi-bookshelf::before {
  content: "\\F125F"; }

.mdi-boom-gate::before {
  content: "\\F0E86"; }

.mdi-boom-gate-alert::before {
  content: "\\F0E87"; }

.mdi-boom-gate-alert-outline::before {
  content: "\\F0E88"; }

.mdi-boom-gate-arrow-down::before {
  content: "\\F0E89"; }

.mdi-boom-gate-arrow-down-outline::before {
  content: "\\F0E8A"; }

.mdi-boom-gate-arrow-up::before {
  content: "\\F0E8C"; }

.mdi-boom-gate-arrow-up-outline::before {
  content: "\\F0E8D"; }

.mdi-boom-gate-outline::before {
  content: "\\F0E8B"; }

.mdi-boom-gate-up::before {
  content: "\\F17F9"; }

.mdi-boom-gate-up-outline::before {
  content: "\\F17FA"; }

.mdi-boombox::before {
  content: "\\F05DC"; }

.mdi-boomerang::before {
  content: "\\F10CF"; }

.mdi-bootstrap::before {
  content: "\\F06C6"; }

.mdi-border-all::before {
  content: "\\F00C7"; }

.mdi-border-all-variant::before {
  content: "\\F08A1"; }

.mdi-border-bottom::before {
  content: "\\F00C8"; }

.mdi-border-bottom-variant::before {
  content: "\\F08A2"; }

.mdi-border-color::before {
  content: "\\F00C9"; }

.mdi-border-horizontal::before {
  content: "\\F00CA"; }

.mdi-border-inside::before {
  content: "\\F00CB"; }

.mdi-border-left::before {
  content: "\\F00CC"; }

.mdi-border-left-variant::before {
  content: "\\F08A3"; }

.mdi-border-none::before {
  content: "\\F00CD"; }

.mdi-border-none-variant::before {
  content: "\\F08A4"; }

.mdi-border-outside::before {
  content: "\\F00CE"; }

.mdi-border-right::before {
  content: "\\F00CF"; }

.mdi-border-right-variant::before {
  content: "\\F08A5"; }

.mdi-border-style::before {
  content: "\\F00D0"; }

.mdi-border-top::before {
  content: "\\F00D1"; }

.mdi-border-top-variant::before {
  content: "\\F08A6"; }

.mdi-border-vertical::before {
  content: "\\F00D2"; }

.mdi-bottle-soda::before {
  content: "\\F1070"; }

.mdi-bottle-soda-classic::before {
  content: "\\F1071"; }

.mdi-bottle-soda-classic-outline::before {
  content: "\\F1363"; }

.mdi-bottle-soda-outline::before {
  content: "\\F1072"; }

.mdi-bottle-tonic::before {
  content: "\\F112E"; }

.mdi-bottle-tonic-outline::before {
  content: "\\F112F"; }

.mdi-bottle-tonic-plus::before {
  content: "\\F1130"; }

.mdi-bottle-tonic-plus-outline::before {
  content: "\\F1131"; }

.mdi-bottle-tonic-skull::before {
  content: "\\F1132"; }

.mdi-bottle-tonic-skull-outline::before {
  content: "\\F1133"; }

.mdi-bottle-wine::before {
  content: "\\F0854"; }

.mdi-bottle-wine-outline::before {
  content: "\\F1310"; }

.mdi-bow-arrow::before {
  content: "\\F1841"; }

.mdi-bow-tie::before {
  content: "\\F0678"; }

.mdi-bowl::before {
  content: "\\F028E"; }

.mdi-bowl-mix::before {
  content: "\\F0617"; }

.mdi-bowl-mix-outline::before {
  content: "\\F02E4"; }

.mdi-bowl-outline::before {
  content: "\\F02A9"; }

.mdi-bowling::before {
  content: "\\F00D3"; }

.mdi-box::before {
  content: "\\F00D4"; }

.mdi-box-cutter::before {
  content: "\\F00D5"; }

.mdi-box-cutter-off::before {
  content: "\\F0B4A"; }

.mdi-box-shadow::before {
  content: "\\F0637"; }

.mdi-boxing-glove::before {
  content: "\\F0B65"; }

.mdi-braille::before {
  content: "\\F09D0"; }

.mdi-brain::before {
  content: "\\F09D1"; }

.mdi-bread-slice::before {
  content: "\\F0CEE"; }

.mdi-bread-slice-outline::before {
  content: "\\F0CEF"; }

.mdi-bridge::before {
  content: "\\F0618"; }

.mdi-briefcase::before {
  content: "\\F00D6"; }

.mdi-briefcase-account::before {
  content: "\\F0CF0"; }

.mdi-briefcase-account-outline::before {
  content: "\\F0CF1"; }

.mdi-briefcase-check::before {
  content: "\\F00D7"; }

.mdi-briefcase-check-outline::before {
  content: "\\F131E"; }

.mdi-briefcase-clock::before {
  content: "\\F10D0"; }

.mdi-briefcase-clock-outline::before {
  content: "\\F10D1"; }

.mdi-briefcase-download::before {
  content: "\\F00D8"; }

.mdi-briefcase-download-outline::before {
  content: "\\F0C3D"; }

.mdi-briefcase-edit::before {
  content: "\\F0A98"; }

.mdi-briefcase-edit-outline::before {
  content: "\\F0C3E"; }

.mdi-briefcase-eye::before {
  content: "\\F17D9"; }

.mdi-briefcase-eye-outline::before {
  content: "\\F17DA"; }

.mdi-briefcase-minus::before {
  content: "\\F0A2A"; }

.mdi-briefcase-minus-outline::before {
  content: "\\F0C3F"; }

.mdi-briefcase-off::before {
  content: "\\F1658"; }

.mdi-briefcase-off-outline::before {
  content: "\\F1659"; }

.mdi-briefcase-outline::before {
  content: "\\F0814"; }

.mdi-briefcase-plus::before {
  content: "\\F0A2B"; }

.mdi-briefcase-plus-outline::before {
  content: "\\F0C40"; }

.mdi-briefcase-remove::before {
  content: "\\F0A2C"; }

.mdi-briefcase-remove-outline::before {
  content: "\\F0C41"; }

.mdi-briefcase-search::before {
  content: "\\F0A2D"; }

.mdi-briefcase-search-outline::before {
  content: "\\F0C42"; }

.mdi-briefcase-upload::before {
  content: "\\F00D9"; }

.mdi-briefcase-upload-outline::before {
  content: "\\F0C43"; }

.mdi-briefcase-variant::before {
  content: "\\F1494"; }

.mdi-briefcase-variant-off::before {
  content: "\\F165A"; }

.mdi-briefcase-variant-off-outline::before {
  content: "\\F165B"; }

.mdi-briefcase-variant-outline::before {
  content: "\\F1495"; }

.mdi-brightness-1::before {
  content: "\\F00DA"; }

.mdi-brightness-2::before {
  content: "\\F00DB"; }

.mdi-brightness-3::before {
  content: "\\F00DC"; }

.mdi-brightness-4::before {
  content: "\\F00DD"; }

.mdi-brightness-5::before {
  content: "\\F00DE"; }

.mdi-brightness-6::before {
  content: "\\F00DF"; }

.mdi-brightness-7::before {
  content: "\\F00E0"; }

.mdi-brightness-auto::before {
  content: "\\F00E1"; }

.mdi-brightness-percent::before {
  content: "\\F0CF2"; }

.mdi-broadcast::before {
  content: "\\F1720"; }

.mdi-broadcast-off::before {
  content: "\\F1721"; }

.mdi-broom::before {
  content: "\\F00E2"; }

.mdi-brush::before {
  content: "\\F00E3"; }

.mdi-brush-off::before {
  content: "\\F1771"; }

.mdi-brush-variant::before {
  content: "\\F1813"; }

.mdi-bucket::before {
  content: "\\F1415"; }

.mdi-bucket-outline::before {
  content: "\\F1416"; }

.mdi-buffet::before {
  content: "\\F0578"; }

.mdi-bug::before {
  content: "\\F00E4"; }

.mdi-bug-check::before {
  content: "\\F0A2E"; }

.mdi-bug-check-outline::before {
  content: "\\F0A2F"; }

.mdi-bug-outline::before {
  content: "\\F0A30"; }

.mdi-bugle::before {
  content: "\\F0DB4"; }

.mdi-bulldozer::before {
  content: "\\F0B22"; }

.mdi-bullet::before {
  content: "\\F0CF3"; }

.mdi-bulletin-board::before {
  content: "\\F00E5"; }

.mdi-bullhorn::before {
  content: "\\F00E6"; }

.mdi-bullhorn-outline::before {
  content: "\\F0B23"; }

.mdi-bullhorn-variant::before {
  content: "\\F196E"; }

.mdi-bullhorn-variant-outline::before {
  content: "\\F196F"; }

.mdi-bullseye::before {
  content: "\\F05DD"; }

.mdi-bullseye-arrow::before {
  content: "\\F08C9"; }

.mdi-bulma::before {
  content: "\\F12E7"; }

.mdi-bunk-bed::before {
  content: "\\F1302"; }

.mdi-bunk-bed-outline::before {
  content: "\\F0097"; }

.mdi-bus::before {
  content: "\\F00E7"; }

.mdi-bus-alert::before {
  content: "\\F0A99"; }

.mdi-bus-articulated-end::before {
  content: "\\F079C"; }

.mdi-bus-articulated-front::before {
  content: "\\F079D"; }

.mdi-bus-clock::before {
  content: "\\F08CA"; }

.mdi-bus-double-decker::before {
  content: "\\F079E"; }

.mdi-bus-electric::before {
  content: "\\F191D"; }

.mdi-bus-marker::before {
  content: "\\F1212"; }

.mdi-bus-multiple::before {
  content: "\\F0F3F"; }

.mdi-bus-school::before {
  content: "\\F079F"; }

.mdi-bus-side::before {
  content: "\\F07A0"; }

.mdi-bus-stop::before {
  content: "\\F1012"; }

.mdi-bus-stop-covered::before {
  content: "\\F1013"; }

.mdi-bus-stop-uncovered::before {
  content: "\\F1014"; }

.mdi-butterfly::before {
  content: "\\F1589"; }

.mdi-butterfly-outline::before {
  content: "\\F158A"; }

.mdi-cabin-a-frame::before {
  content: "\\F188C"; }

.mdi-cable-data::before {
  content: "\\F1394"; }

.mdi-cached::before {
  content: "\\F00E8"; }

.mdi-cactus::before {
  content: "\\F0DB5"; }

.mdi-cake::before {
  content: "\\F00E9"; }

.mdi-cake-layered::before {
  content: "\\F00EA"; }

.mdi-cake-variant::before {
  content: "\\F00EB"; }

.mdi-cake-variant-outline::before {
  content: "\\F17F0"; }

.mdi-calculator::before {
  content: "\\F00EC"; }

.mdi-calculator-variant::before {
  content: "\\F0A9A"; }

.mdi-calculator-variant-outline::before {
  content: "\\F15A6"; }

.mdi-calendar::before {
  content: "\\F00ED"; }

.mdi-calendar-account::before {
  content: "\\F0ED7"; }

.mdi-calendar-account-outline::before {
  content: "\\F0ED8"; }

.mdi-calendar-alert::before {
  content: "\\F0A31"; }

.mdi-calendar-arrow-left::before {
  content: "\\F1134"; }

.mdi-calendar-arrow-right::before {
  content: "\\F1135"; }

.mdi-calendar-blank::before {
  content: "\\F00EE"; }

.mdi-calendar-blank-multiple::before {
  content: "\\F1073"; }

.mdi-calendar-blank-outline::before {
  content: "\\F0B66"; }

.mdi-calendar-check::before {
  content: "\\F00EF"; }

.mdi-calendar-check-outline::before {
  content: "\\F0C44"; }

.mdi-calendar-clock::before {
  content: "\\F00F0"; }

.mdi-calendar-clock-outline::before {
  content: "\\F16E1"; }

.mdi-calendar-collapse-horizontal::before {
  content: "\\F189D"; }

.mdi-calendar-cursor::before {
  content: "\\F157B"; }

.mdi-calendar-edit::before {
  content: "\\F08A7"; }

.mdi-calendar-end::before {
  content: "\\F166C"; }

.mdi-calendar-expand-horizontal::before {
  content: "\\F189E"; }

.mdi-calendar-export::before {
  content: "\\F0B24"; }

.mdi-calendar-heart::before {
  content: "\\F09D2"; }

.mdi-calendar-import::before {
  content: "\\F0B25"; }

.mdi-calendar-lock::before {
  content: "\\F1641"; }

.mdi-calendar-lock-outline::before {
  content: "\\F1642"; }

.mdi-calendar-minus::before {
  content: "\\F0D5C"; }

.mdi-calendar-month::before {
  content: "\\F0E17"; }

.mdi-calendar-month-outline::before {
  content: "\\F0E18"; }

.mdi-calendar-multiple::before {
  content: "\\F00F1"; }

.mdi-calendar-multiple-check::before {
  content: "\\F00F2"; }

.mdi-calendar-multiselect::before {
  content: "\\F0A32"; }

.mdi-calendar-outline::before {
  content: "\\F0B67"; }

.mdi-calendar-plus::before {
  content: "\\F00F3"; }

.mdi-calendar-question::before {
  content: "\\F0692"; }

.mdi-calendar-range::before {
  content: "\\F0679"; }

.mdi-calendar-range-outline::before {
  content: "\\F0B68"; }

.mdi-calendar-refresh::before {
  content: "\\F01E1"; }

.mdi-calendar-refresh-outline::before {
  content: "\\F0203"; }

.mdi-calendar-remove::before {
  content: "\\F00F4"; }

.mdi-calendar-remove-outline::before {
  content: "\\F0C45"; }

.mdi-calendar-search::before {
  content: "\\F094C"; }

.mdi-calendar-star::before {
  content: "\\F09D3"; }

.mdi-calendar-start::before {
  content: "\\F166D"; }

.mdi-calendar-sync::before {
  content: "\\F0E8E"; }

.mdi-calendar-sync-outline::before {
  content: "\\F0E8F"; }

.mdi-calendar-text::before {
  content: "\\F00F5"; }

.mdi-calendar-text-outline::before {
  content: "\\F0C46"; }

.mdi-calendar-today::before {
  content: "\\F00F6"; }

.mdi-calendar-week::before {
  content: "\\F0A33"; }

.mdi-calendar-week-begin::before {
  content: "\\F0A34"; }

.mdi-calendar-weekend::before {
  content: "\\F0ED9"; }

.mdi-calendar-weekend-outline::before {
  content: "\\F0EDA"; }

.mdi-call-made::before {
  content: "\\F00F7"; }

.mdi-call-merge::before {
  content: "\\F00F8"; }

.mdi-call-missed::before {
  content: "\\F00F9"; }

.mdi-call-received::before {
  content: "\\F00FA"; }

.mdi-call-split::before {
  content: "\\F00FB"; }

.mdi-camcorder::before {
  content: "\\F00FC"; }

.mdi-camcorder-off::before {
  content: "\\F00FF"; }

.mdi-camera::before {
  content: "\\F0100"; }

.mdi-camera-account::before {
  content: "\\F08CB"; }

.mdi-camera-burst::before {
  content: "\\F0693"; }

.mdi-camera-control::before {
  content: "\\F0B69"; }

.mdi-camera-document::before {
  content: "\\F1871"; }

.mdi-camera-document-off::before {
  content: "\\F1872"; }

.mdi-camera-enhance::before {
  content: "\\F0101"; }

.mdi-camera-enhance-outline::before {
  content: "\\F0B6A"; }

.mdi-camera-flip::before {
  content: "\\F15D9"; }

.mdi-camera-flip-outline::before {
  content: "\\F15DA"; }

.mdi-camera-front::before {
  content: "\\F0102"; }

.mdi-camera-front-variant::before {
  content: "\\F0103"; }

.mdi-camera-gopro::before {
  content: "\\F07A1"; }

.mdi-camera-image::before {
  content: "\\F08CC"; }

.mdi-camera-iris::before {
  content: "\\F0104"; }

.mdi-camera-marker::before {
  content: "\\F19A7"; }

.mdi-camera-marker-outline::before {
  content: "\\F19A8"; }

.mdi-camera-metering-center::before {
  content: "\\F07A2"; }

.mdi-camera-metering-matrix::before {
  content: "\\F07A3"; }

.mdi-camera-metering-partial::before {
  content: "\\F07A4"; }

.mdi-camera-metering-spot::before {
  content: "\\F07A5"; }

.mdi-camera-off::before {
  content: "\\F05DF"; }

.mdi-camera-off-outline::before {
  content: "\\F19BF"; }

.mdi-camera-outline::before {
  content: "\\F0D5D"; }

.mdi-camera-party-mode::before {
  content: "\\F0105"; }

.mdi-camera-plus::before {
  content: "\\F0EDB"; }

.mdi-camera-plus-outline::before {
  content: "\\F0EDC"; }

.mdi-camera-rear::before {
  content: "\\F0106"; }

.mdi-camera-rear-variant::before {
  content: "\\F0107"; }

.mdi-camera-retake::before {
  content: "\\F0E19"; }

.mdi-camera-retake-outline::before {
  content: "\\F0E1A"; }

.mdi-camera-switch::before {
  content: "\\F0108"; }

.mdi-camera-switch-outline::before {
  content: "\\F084A"; }

.mdi-camera-timer::before {
  content: "\\F0109"; }

.mdi-camera-wireless::before {
  content: "\\F0DB6"; }

.mdi-camera-wireless-outline::before {
  content: "\\F0DB7"; }

.mdi-campfire::before {
  content: "\\F0EDD"; }

.mdi-cancel::before {
  content: "\\F073A"; }

.mdi-candelabra::before {
  content: "\\F17D2"; }

.mdi-candelabra-fire::before {
  content: "\\F17D3"; }

.mdi-candle::before {
  content: "\\F05E2"; }

.mdi-candy::before {
  content: "\\F1970"; }

.mdi-candy-off::before {
  content: "\\F1971"; }

.mdi-candy-off-outline::before {
  content: "\\F1972"; }

.mdi-candy-outline::before {
  content: "\\F1973"; }

.mdi-candycane::before {
  content: "\\F010A"; }

.mdi-cannabis::before {
  content: "\\F07A6"; }

.mdi-cannabis-off::before {
  content: "\\F166E"; }

.mdi-caps-lock::before {
  content: "\\F0A9B"; }

.mdi-car::before {
  content: "\\F010B"; }

.mdi-car-2-plus::before {
  content: "\\F1015"; }

.mdi-car-3-plus::before {
  content: "\\F1016"; }

.mdi-car-arrow-left::before {
  content: "\\F13B2"; }

.mdi-car-arrow-right::before {
  content: "\\F13B3"; }

.mdi-car-back::before {
  content: "\\F0E1B"; }

.mdi-car-battery::before {
  content: "\\F010C"; }

.mdi-car-brake-abs::before {
  content: "\\F0C47"; }

.mdi-car-brake-alert::before {
  content: "\\F0C48"; }

.mdi-car-brake-fluid-level::before {
  content: "\\F1909"; }

.mdi-car-brake-hold::before {
  content: "\\F0D5E"; }

.mdi-car-brake-low-pressure::before {
  content: "\\F190A"; }

.mdi-car-brake-parking::before {
  content: "\\F0D5F"; }

.mdi-car-brake-retarder::before {
  content: "\\F1017"; }

.mdi-car-brake-temperature::before {
  content: "\\F190B"; }

.mdi-car-brake-worn-linings::before {
  content: "\\F190C"; }

.mdi-car-child-seat::before {
  content: "\\F0FA3"; }

.mdi-car-clock::before {
  content: "\\F1974"; }

.mdi-car-clutch::before {
  content: "\\F1018"; }

.mdi-car-cog::before {
  content: "\\F13CC"; }

.mdi-car-connected::before {
  content: "\\F010D"; }

.mdi-car-convertible::before {
  content: "\\F07A7"; }

.mdi-car-coolant-level::before {
  content: "\\F1019"; }

.mdi-car-cruise-control::before {
  content: "\\F0D60"; }

.mdi-car-defrost-front::before {
  content: "\\F0D61"; }

.mdi-car-defrost-rear::before {
  content: "\\F0D62"; }

.mdi-car-door::before {
  content: "\\F0B6B"; }

.mdi-car-door-lock::before {
  content: "\\F109D"; }

.mdi-car-electric::before {
  content: "\\F0B6C"; }

.mdi-car-electric-outline::before {
  content: "\\F15B5"; }

.mdi-car-emergency::before {
  content: "\\F160F"; }

.mdi-car-esp::before {
  content: "\\F0C49"; }

.mdi-car-estate::before {
  content: "\\F07A8"; }

.mdi-car-hatchback::before {
  content: "\\F07A9"; }

.mdi-car-info::before {
  content: "\\F11BE"; }

.mdi-car-key::before {
  content: "\\F0B6D"; }

.mdi-car-lifted-pickup::before {
  content: "\\F152D"; }

.mdi-car-light-alert::before {
  content: "\\F190D"; }

.mdi-car-light-dimmed::before {
  content: "\\F0C4A"; }

.mdi-car-light-fog::before {
  content: "\\F0C4B"; }

.mdi-car-light-high::before {
  content: "\\F0C4C"; }

.mdi-car-limousine::before {
  content: "\\F08CD"; }

.mdi-car-multiple::before {
  content: "\\F0B6E"; }

.mdi-car-off::before {
  content: "\\F0E1C"; }

.mdi-car-outline::before {
  content: "\\F14ED"; }

.mdi-car-parking-lights::before {
  content: "\\F0D63"; }

.mdi-car-pickup::before {
  content: "\\F07AA"; }

.mdi-car-seat::before {
  content: "\\F0FA4"; }

.mdi-car-seat-cooler::before {
  content: "\\F0FA5"; }

.mdi-car-seat-heater::before {
  content: "\\F0FA6"; }

.mdi-car-select::before {
  content: "\\F1879"; }

.mdi-car-settings::before {
  content: "\\F13CD"; }

.mdi-car-shift-pattern::before {
  content: "\\F0F40"; }

.mdi-car-side::before {
  content: "\\F07AB"; }

.mdi-car-speed-limiter::before {
  content: "\\F190E"; }

.mdi-car-sports::before {
  content: "\\F07AC"; }

.mdi-car-tire-alert::before {
  content: "\\F0C4D"; }

.mdi-car-traction-control::before {
  content: "\\F0D64"; }

.mdi-car-turbocharger::before {
  content: "\\F101A"; }

.mdi-car-wash::before {
  content: "\\F010E"; }

.mdi-car-windshield::before {
  content: "\\F101B"; }

.mdi-car-windshield-outline::before {
  content: "\\F101C"; }

.mdi-car-wireless::before {
  content: "\\F1878"; }

.mdi-car-wrench::before {
  content: "\\F1814"; }

.mdi-carabiner::before {
  content: "\\F14C0"; }

.mdi-caravan::before {
  content: "\\F07AD"; }

.mdi-card::before {
  content: "\\F0B6F"; }

.mdi-card-account-details::before {
  content: "\\F05D2"; }

.mdi-card-account-details-outline::before {
  content: "\\F0DAB"; }

.mdi-card-account-details-star::before {
  content: "\\F02A3"; }

.mdi-card-account-details-star-outline::before {
  content: "\\F06DB"; }

.mdi-card-account-mail::before {
  content: "\\F018E"; }

.mdi-card-account-mail-outline::before {
  content: "\\F0E98"; }

.mdi-card-account-phone::before {
  content: "\\F0E99"; }

.mdi-card-account-phone-outline::before {
  content: "\\F0E9A"; }

.mdi-card-bulleted::before {
  content: "\\F0B70"; }

.mdi-card-bulleted-off::before {
  content: "\\F0B71"; }

.mdi-card-bulleted-off-outline::before {
  content: "\\F0B72"; }

.mdi-card-bulleted-outline::before {
  content: "\\F0B73"; }

.mdi-card-bulleted-settings::before {
  content: "\\F0B74"; }

.mdi-card-bulleted-settings-outline::before {
  content: "\\F0B75"; }

.mdi-card-minus::before {
  content: "\\F1600"; }

.mdi-card-minus-outline::before {
  content: "\\F1601"; }

.mdi-card-multiple::before {
  content: "\\F17F1"; }

.mdi-card-multiple-outline::before {
  content: "\\F17F2"; }

.mdi-card-off::before {
  content: "\\F1602"; }

.mdi-card-off-outline::before {
  content: "\\F1603"; }

.mdi-card-outline::before {
  content: "\\F0B76"; }

.mdi-card-plus::before {
  content: "\\F11FF"; }

.mdi-card-plus-outline::before {
  content: "\\F1200"; }

.mdi-card-remove::before {
  content: "\\F1604"; }

.mdi-card-remove-outline::before {
  content: "\\F1605"; }

.mdi-card-search::before {
  content: "\\F1074"; }

.mdi-card-search-outline::before {
  content: "\\F1075"; }

.mdi-card-text::before {
  content: "\\F0B77"; }

.mdi-card-text-outline::before {
  content: "\\F0B78"; }

.mdi-cards::before {
  content: "\\F0638"; }

.mdi-cards-club::before {
  content: "\\F08CE"; }

.mdi-cards-club-outline::before {
  content: "\\F189F"; }

.mdi-cards-diamond::before {
  content: "\\F08CF"; }

.mdi-cards-diamond-outline::before {
  content: "\\F101D"; }

.mdi-cards-heart::before {
  content: "\\F08D0"; }

.mdi-cards-heart-outline::before {
  content: "\\F18A0"; }

.mdi-cards-outline::before {
  content: "\\F0639"; }

.mdi-cards-playing::before {
  content: "\\F18A1"; }

.mdi-cards-playing-club::before {
  content: "\\F18A2"; }

.mdi-cards-playing-club-multiple::before {
  content: "\\F18A3"; }

.mdi-cards-playing-club-multiple-outline::before {
  content: "\\F18A4"; }

.mdi-cards-playing-club-outline::before {
  content: "\\F18A5"; }

.mdi-cards-playing-diamond::before {
  content: "\\F18A6"; }

.mdi-cards-playing-diamond-multiple::before {
  content: "\\F18A7"; }

.mdi-cards-playing-diamond-multiple-outline::before {
  content: "\\F18A8"; }

.mdi-cards-playing-diamond-outline::before {
  content: "\\F18A9"; }

.mdi-cards-playing-heart::before {
  content: "\\F18AA"; }

.mdi-cards-playing-heart-multiple::before {
  content: "\\F18AB"; }

.mdi-cards-playing-heart-multiple-outline::before {
  content: "\\F18AC"; }

.mdi-cards-playing-heart-outline::before {
  content: "\\F18AD"; }

.mdi-cards-playing-outline::before {
  content: "\\F063A"; }

.mdi-cards-playing-spade::before {
  content: "\\F18AE"; }

.mdi-cards-playing-spade-multiple::before {
  content: "\\F18AF"; }

.mdi-cards-playing-spade-multiple-outline::before {
  content: "\\F18B0"; }

.mdi-cards-playing-spade-outline::before {
  content: "\\F18B1"; }

.mdi-cards-spade::before {
  content: "\\F08D1"; }

.mdi-cards-spade-outline::before {
  content: "\\F18B2"; }

.mdi-cards-variant::before {
  content: "\\F06C7"; }

.mdi-carrot::before {
  content: "\\F010F"; }

.mdi-cart::before {
  content: "\\F0110"; }

.mdi-cart-arrow-down::before {
  content: "\\F0D66"; }

.mdi-cart-arrow-right::before {
  content: "\\F0C4E"; }

.mdi-cart-arrow-up::before {
  content: "\\F0D67"; }

.mdi-cart-check::before {
  content: "\\F15EA"; }

.mdi-cart-heart::before {
  content: "\\F18E0"; }

.mdi-cart-minus::before {
  content: "\\F0D68"; }

.mdi-cart-off::before {
  content: "\\F066B"; }

.mdi-cart-outline::before {
  content: "\\F0111"; }

.mdi-cart-plus::before {
  content: "\\F0112"; }

.mdi-cart-remove::before {
  content: "\\F0D69"; }

.mdi-cart-variant::before {
  content: "\\F15EB"; }

.mdi-case-sensitive-alt::before {
  content: "\\F0113"; }

.mdi-cash::before {
  content: "\\F0114"; }

.mdi-cash-100::before {
  content: "\\F0115"; }

.mdi-cash-check::before {
  content: "\\F14EE"; }

.mdi-cash-fast::before {
  content: "\\F185C"; }

.mdi-cash-lock::before {
  content: "\\F14EA"; }

.mdi-cash-lock-open::before {
  content: "\\F14EB"; }

.mdi-cash-marker::before {
  content: "\\F0DB8"; }

.mdi-cash-minus::before {
  content: "\\F1260"; }

.mdi-cash-multiple::before {
  content: "\\F0116"; }

.mdi-cash-plus::before {
  content: "\\F1261"; }

.mdi-cash-refund::before {
  content: "\\F0A9C"; }

.mdi-cash-register::before {
  content: "\\F0CF4"; }

.mdi-cash-remove::before {
  content: "\\F1262"; }

.mdi-cassette::before {
  content: "\\F09D4"; }

.mdi-cast::before {
  content: "\\F0118"; }

.mdi-cast-audio::before {
  content: "\\F101E"; }

.mdi-cast-audio-variant::before {
  content: "\\F1749"; }

.mdi-cast-connected::before {
  content: "\\F0119"; }

.mdi-cast-education::before {
  content: "\\F0E1D"; }

.mdi-cast-off::before {
  content: "\\F078A"; }

.mdi-cast-variant::before {
  content: "\\F001F"; }

.mdi-castle::before {
  content: "\\F011A"; }

.mdi-cat::before {
  content: "\\F011B"; }

.mdi-cctv::before {
  content: "\\F07AE"; }

.mdi-cctv-off::before {
  content: "\\F185F"; }

.mdi-ceiling-fan::before {
  content: "\\F1797"; }

.mdi-ceiling-fan-light::before {
  content: "\\F1798"; }

.mdi-ceiling-light::before {
  content: "\\F0769"; }

.mdi-ceiling-light-multiple::before {
  content: "\\F18DD"; }

.mdi-ceiling-light-multiple-outline::before {
  content: "\\F18DE"; }

.mdi-ceiling-light-outline::before {
  content: "\\F17C7"; }

.mdi-cellphone::before {
  content: "\\F011C"; }

.mdi-cellphone-arrow-down::before {
  content: "\\F09D5"; }

.mdi-cellphone-basic::before {
  content: "\\F011E"; }

.mdi-cellphone-charging::before {
  content: "\\F1397"; }

.mdi-cellphone-check::before {
  content: "\\F17FD"; }

.mdi-cellphone-cog::before {
  content: "\\F0951"; }

.mdi-cellphone-dock::before {
  content: "\\F011F"; }

.mdi-cellphone-information::before {
  content: "\\F0F41"; }

.mdi-cellphone-key::before {
  content: "\\F094E"; }

.mdi-cellphone-link::before {
  content: "\\F0121"; }

.mdi-cellphone-link-off::before {
  content: "\\F0122"; }

.mdi-cellphone-lock::before {
  content: "\\F094F"; }

.mdi-cellphone-marker::before {
  content: "\\F183A"; }

.mdi-cellphone-message::before {
  content: "\\F08D3"; }

.mdi-cellphone-message-off::before {
  content: "\\F10D2"; }

.mdi-cellphone-nfc::before {
  content: "\\F0E90"; }

.mdi-cellphone-nfc-off::before {
  content: "\\F12D8"; }

.mdi-cellphone-off::before {
  content: "\\F0950"; }

.mdi-cellphone-play::before {
  content: "\\F101F"; }

.mdi-cellphone-remove::before {
  content: "\\F094D"; }

.mdi-cellphone-screenshot::before {
  content: "\\F0A35"; }

.mdi-cellphone-settings::before {
  content: "\\F0123"; }

.mdi-cellphone-sound::before {
  content: "\\F0952"; }

.mdi-cellphone-text::before {
  content: "\\F08D2"; }

.mdi-cellphone-wireless::before {
  content: "\\F0815"; }

.mdi-centos::before {
  content: "\\F111A"; }

.mdi-certificate::before {
  content: "\\F0124"; }

.mdi-certificate-outline::before {
  content: "\\F1188"; }

.mdi-chair-rolling::before {
  content: "\\F0F48"; }

.mdi-chair-school::before {
  content: "\\F0125"; }

.mdi-chandelier::before {
  content: "\\F1793"; }

.mdi-charity::before {
  content: "\\F0C4F"; }

.mdi-chart-arc::before {
  content: "\\F0126"; }

.mdi-chart-areaspline::before {
  content: "\\F0127"; }

.mdi-chart-areaspline-variant::before {
  content: "\\F0E91"; }

.mdi-chart-bar::before {
  content: "\\F0128"; }

.mdi-chart-bar-stacked::before {
  content: "\\F076A"; }

.mdi-chart-bell-curve::before {
  content: "\\F0C50"; }

.mdi-chart-bell-curve-cumulative::before {
  content: "\\F0FA7"; }

.mdi-chart-box::before {
  content: "\\F154D"; }

.mdi-chart-box-outline::before {
  content: "\\F154E"; }

.mdi-chart-box-plus-outline::before {
  content: "\\F154F"; }

.mdi-chart-bubble::before {
  content: "\\F05E3"; }

.mdi-chart-donut::before {
  content: "\\F07AF"; }

.mdi-chart-donut-variant::before {
  content: "\\F07B0"; }

.mdi-chart-gantt::before {
  content: "\\F066C"; }

.mdi-chart-histogram::before {
  content: "\\F0129"; }

.mdi-chart-line::before {
  content: "\\F012A"; }

.mdi-chart-line-stacked::before {
  content: "\\F076B"; }

.mdi-chart-line-variant::before {
  content: "\\F07B1"; }

.mdi-chart-multiline::before {
  content: "\\F08D4"; }

.mdi-chart-multiple::before {
  content: "\\F1213"; }

.mdi-chart-pie::before {
  content: "\\F012B"; }

.mdi-chart-ppf::before {
  content: "\\F1380"; }

.mdi-chart-sankey::before {
  content: "\\F11DF"; }

.mdi-chart-sankey-variant::before {
  content: "\\F11E0"; }

.mdi-chart-scatter-plot::before {
  content: "\\F0E92"; }

.mdi-chart-scatter-plot-hexbin::before {
  content: "\\F066D"; }

.mdi-chart-timeline::before {
  content: "\\F066E"; }

.mdi-chart-timeline-variant::before {
  content: "\\F0E93"; }

.mdi-chart-timeline-variant-shimmer::before {
  content: "\\F15B6"; }

.mdi-chart-tree::before {
  content: "\\F0E94"; }

.mdi-chart-waterfall::before {
  content: "\\F1918"; }

.mdi-chat::before {
  content: "\\F0B79"; }

.mdi-chat-alert::before {
  content: "\\F0B7A"; }

.mdi-chat-alert-outline::before {
  content: "\\F12C9"; }

.mdi-chat-minus::before {
  content: "\\F1410"; }

.mdi-chat-minus-outline::before {
  content: "\\F1413"; }

.mdi-chat-outline::before {
  content: "\\F0EDE"; }

.mdi-chat-plus::before {
  content: "\\F140F"; }

.mdi-chat-plus-outline::before {
  content: "\\F1412"; }

.mdi-chat-processing::before {
  content: "\\F0B7B"; }

.mdi-chat-processing-outline::before {
  content: "\\F12CA"; }

.mdi-chat-question::before {
  content: "\\F1738"; }

.mdi-chat-question-outline::before {
  content: "\\F1739"; }

.mdi-chat-remove::before {
  content: "\\F1411"; }

.mdi-chat-remove-outline::before {
  content: "\\F1414"; }

.mdi-chat-sleep::before {
  content: "\\F12D1"; }

.mdi-chat-sleep-outline::before {
  content: "\\F12D2"; }

.mdi-check::before {
  content: "\\F012C"; }

.mdi-check-all::before {
  content: "\\F012D"; }

.mdi-check-bold::before {
  content: "\\F0E1E"; }

.mdi-check-circle::before {
  content: "\\F05E0"; }

.mdi-check-circle-outline::before {
  content: "\\F05E1"; }

.mdi-check-decagram::before {
  content: "\\F0791"; }

.mdi-check-decagram-outline::before {
  content: "\\F1740"; }

.mdi-check-network::before {
  content: "\\F0C53"; }

.mdi-check-network-outline::before {
  content: "\\F0C54"; }

.mdi-check-outline::before {
  content: "\\F0855"; }

.mdi-check-underline::before {
  content: "\\F0E1F"; }

.mdi-check-underline-circle::before {
  content: "\\F0E20"; }

.mdi-check-underline-circle-outline::before {
  content: "\\F0E21"; }

.mdi-checkbook::before {
  content: "\\F0A9D"; }

.mdi-checkbox-blank::before {
  content: "\\F012E"; }

.mdi-checkbox-blank-badge::before {
  content: "\\F1176"; }

.mdi-checkbox-blank-badge-outline::before {
  content: "\\F0117"; }

.mdi-checkbox-blank-circle::before {
  content: "\\F012F"; }

.mdi-checkbox-blank-circle-outline::before {
  content: "\\F0130"; }

.mdi-checkbox-blank-off::before {
  content: "\\F12EC"; }

.mdi-checkbox-blank-off-outline::before {
  content: "\\F12ED"; }

.mdi-checkbox-blank-outline::before {
  content: "\\F0131"; }

.mdi-checkbox-intermediate::before {
  content: "\\F0856"; }

.mdi-checkbox-marked::before {
  content: "\\F0132"; }

.mdi-checkbox-marked-circle::before {
  content: "\\F0133"; }

.mdi-checkbox-marked-circle-outline::before {
  content: "\\F0134"; }

.mdi-checkbox-marked-circle-plus-outline::before {
  content: "\\F1927"; }

.mdi-checkbox-marked-outline::before {
  content: "\\F0135"; }

.mdi-checkbox-multiple-blank::before {
  content: "\\F0136"; }

.mdi-checkbox-multiple-blank-circle::before {
  content: "\\F063B"; }

.mdi-checkbox-multiple-blank-circle-outline::before {
  content: "\\F063C"; }

.mdi-checkbox-multiple-blank-outline::before {
  content: "\\F0137"; }

.mdi-checkbox-multiple-marked::before {
  content: "\\F0138"; }

.mdi-checkbox-multiple-marked-circle::before {
  content: "\\F063D"; }

.mdi-checkbox-multiple-marked-circle-outline::before {
  content: "\\F063E"; }

.mdi-checkbox-multiple-marked-outline::before {
  content: "\\F0139"; }

.mdi-checkbox-multiple-outline::before {
  content: "\\F0C51"; }

.mdi-checkbox-outline::before {
  content: "\\F0C52"; }

.mdi-checkerboard::before {
  content: "\\F013A"; }

.mdi-checkerboard-minus::before {
  content: "\\F1202"; }

.mdi-checkerboard-plus::before {
  content: "\\F1201"; }

.mdi-checkerboard-remove::before {
  content: "\\F1203"; }

.mdi-cheese::before {
  content: "\\F12B9"; }

.mdi-cheese-off::before {
  content: "\\F13EE"; }

.mdi-chef-hat::before {
  content: "\\F0B7C"; }

.mdi-chemical-weapon::before {
  content: "\\F013B"; }

.mdi-chess-bishop::before {
  content: "\\F085C"; }

.mdi-chess-king::before {
  content: "\\F0857"; }

.mdi-chess-knight::before {
  content: "\\F0858"; }

.mdi-chess-pawn::before {
  content: "\\F0859"; }

.mdi-chess-queen::before {
  content: "\\F085A"; }

.mdi-chess-rook::before {
  content: "\\F085B"; }

.mdi-chevron-double-down::before {
  content: "\\F013C"; }

.mdi-chevron-double-left::before {
  content: "\\F013D"; }

.mdi-chevron-double-right::before {
  content: "\\F013E"; }

.mdi-chevron-double-up::before {
  content: "\\F013F"; }

.mdi-chevron-down::before {
  content: "\\F0140"; }

.mdi-chevron-down-box::before {
  content: "\\F09D6"; }

.mdi-chevron-down-box-outline::before {
  content: "\\F09D7"; }

.mdi-chevron-down-circle::before {
  content: "\\F0B26"; }

.mdi-chevron-down-circle-outline::before {
  content: "\\F0B27"; }

.mdi-chevron-left::before {
  content: "\\F0141"; }

.mdi-chevron-left-box::before {
  content: "\\F09D8"; }

.mdi-chevron-left-box-outline::before {
  content: "\\F09D9"; }

.mdi-chevron-left-circle::before {
  content: "\\F0B28"; }

.mdi-chevron-left-circle-outline::before {
  content: "\\F0B29"; }

.mdi-chevron-right::before {
  content: "\\F0142"; }

.mdi-chevron-right-box::before {
  content: "\\F09DA"; }

.mdi-chevron-right-box-outline::before {
  content: "\\F09DB"; }

.mdi-chevron-right-circle::before {
  content: "\\F0B2A"; }

.mdi-chevron-right-circle-outline::before {
  content: "\\F0B2B"; }

.mdi-chevron-triple-down::before {
  content: "\\F0DB9"; }

.mdi-chevron-triple-left::before {
  content: "\\F0DBA"; }

.mdi-chevron-triple-right::before {
  content: "\\F0DBB"; }

.mdi-chevron-triple-up::before {
  content: "\\F0DBC"; }

.mdi-chevron-up::before {
  content: "\\F0143"; }

.mdi-chevron-up-box::before {
  content: "\\F09DC"; }

.mdi-chevron-up-box-outline::before {
  content: "\\F09DD"; }

.mdi-chevron-up-circle::before {
  content: "\\F0B2C"; }

.mdi-chevron-up-circle-outline::before {
  content: "\\F0B2D"; }

.mdi-chili-alert::before {
  content: "\\F17EA"; }

.mdi-chili-alert-outline::before {
  content: "\\F17EB"; }

.mdi-chili-hot::before {
  content: "\\F07B2"; }

.mdi-chili-hot-outline::before {
  content: "\\F17EC"; }

.mdi-chili-medium::before {
  content: "\\F07B3"; }

.mdi-chili-medium-outline::before {
  content: "\\F17ED"; }

.mdi-chili-mild::before {
  content: "\\F07B4"; }

.mdi-chili-mild-outline::before {
  content: "\\F17EE"; }

.mdi-chili-off::before {
  content: "\\F1467"; }

.mdi-chili-off-outline::before {
  content: "\\F17EF"; }

.mdi-chip::before {
  content: "\\F061A"; }

.mdi-church::before {
  content: "\\F0144"; }

.mdi-cigar::before {
  content: "\\F1189"; }

.mdi-cigar-off::before {
  content: "\\F141B"; }

.mdi-circle::before {
  content: "\\F0765"; }

.mdi-circle-box::before {
  content: "\\F15DC"; }

.mdi-circle-box-outline::before {
  content: "\\F15DD"; }

.mdi-circle-double::before {
  content: "\\F0E95"; }

.mdi-circle-edit-outline::before {
  content: "\\F08D5"; }

.mdi-circle-expand::before {
  content: "\\F0E96"; }

.mdi-circle-half::before {
  content: "\\F1395"; }

.mdi-circle-half-full::before {
  content: "\\F1396"; }

.mdi-circle-medium::before {
  content: "\\F09DE"; }

.mdi-circle-multiple::before {
  content: "\\F0B38"; }

.mdi-circle-multiple-outline::before {
  content: "\\F0695"; }

.mdi-circle-off-outline::before {
  content: "\\F10D3"; }

.mdi-circle-opacity::before {
  content: "\\F1853"; }

.mdi-circle-outline::before {
  content: "\\F0766"; }

.mdi-circle-slice-1::before {
  content: "\\F0A9E"; }

.mdi-circle-slice-2::before {
  content: "\\F0A9F"; }

.mdi-circle-slice-3::before {
  content: "\\F0AA0"; }

.mdi-circle-slice-4::before {
  content: "\\F0AA1"; }

.mdi-circle-slice-5::before {
  content: "\\F0AA2"; }

.mdi-circle-slice-6::before {
  content: "\\F0AA3"; }

.mdi-circle-slice-7::before {
  content: "\\F0AA4"; }

.mdi-circle-slice-8::before {
  content: "\\F0AA5"; }

.mdi-circle-small::before {
  content: "\\F09DF"; }

.mdi-circular-saw::before {
  content: "\\F0E22"; }

.mdi-city::before {
  content: "\\F0146"; }

.mdi-city-variant::before {
  content: "\\F0A36"; }

.mdi-city-variant-outline::before {
  content: "\\F0A37"; }

.mdi-clipboard::before {
  content: "\\F0147"; }

.mdi-clipboard-account::before {
  content: "\\F0148"; }

.mdi-clipboard-account-outline::before {
  content: "\\F0C55"; }

.mdi-clipboard-alert::before {
  content: "\\F0149"; }

.mdi-clipboard-alert-outline::before {
  content: "\\F0CF7"; }

.mdi-clipboard-arrow-down::before {
  content: "\\F014A"; }

.mdi-clipboard-arrow-down-outline::before {
  content: "\\F0C56"; }

.mdi-clipboard-arrow-left::before {
  content: "\\F014B"; }

.mdi-clipboard-arrow-left-outline::before {
  content: "\\F0CF8"; }

.mdi-clipboard-arrow-right::before {
  content: "\\F0CF9"; }

.mdi-clipboard-arrow-right-outline::before {
  content: "\\F0CFA"; }

.mdi-clipboard-arrow-up::before {
  content: "\\F0C57"; }

.mdi-clipboard-arrow-up-outline::before {
  content: "\\F0C58"; }

.mdi-clipboard-check::before {
  content: "\\F014E"; }

.mdi-clipboard-check-multiple::before {
  content: "\\F1263"; }

.mdi-clipboard-check-multiple-outline::before {
  content: "\\F1264"; }

.mdi-clipboard-check-outline::before {
  content: "\\F08A8"; }

.mdi-clipboard-clock::before {
  content: "\\F16E2"; }

.mdi-clipboard-clock-outline::before {
  content: "\\F16E3"; }

.mdi-clipboard-edit::before {
  content: "\\F14E5"; }

.mdi-clipboard-edit-outline::before {
  content: "\\F14E6"; }

.mdi-clipboard-file::before {
  content: "\\F1265"; }

.mdi-clipboard-file-outline::before {
  content: "\\F1266"; }

.mdi-clipboard-flow::before {
  content: "\\F06C8"; }

.mdi-clipboard-flow-outline::before {
  content: "\\F1117"; }

.mdi-clipboard-list::before {
  content: "\\F10D4"; }

.mdi-clipboard-list-outline::before {
  content: "\\F10D5"; }

.mdi-clipboard-minus::before {
  content: "\\F1618"; }

.mdi-clipboard-minus-outline::before {
  content: "\\F1619"; }

.mdi-clipboard-multiple::before {
  content: "\\F1267"; }

.mdi-clipboard-multiple-outline::before {
  content: "\\F1268"; }

.mdi-clipboard-off::before {
  content: "\\F161A"; }

.mdi-clipboard-off-outline::before {
  content: "\\F161B"; }

.mdi-clipboard-outline::before {
  content: "\\F014C"; }

.mdi-clipboard-play::before {
  content: "\\F0C59"; }

.mdi-clipboard-play-multiple::before {
  content: "\\F1269"; }

.mdi-clipboard-play-multiple-outline::before {
  content: "\\F126A"; }

.mdi-clipboard-play-outline::before {
  content: "\\F0C5A"; }

.mdi-clipboard-plus::before {
  content: "\\F0751"; }

.mdi-clipboard-plus-outline::before {
  content: "\\F131F"; }

.mdi-clipboard-pulse::before {
  content: "\\F085D"; }

.mdi-clipboard-pulse-outline::before {
  content: "\\F085E"; }

.mdi-clipboard-remove::before {
  content: "\\F161C"; }

.mdi-clipboard-remove-outline::before {
  content: "\\F161D"; }

.mdi-clipboard-search::before {
  content: "\\F161E"; }

.mdi-clipboard-search-outline::before {
  content: "\\F161F"; }

.mdi-clipboard-text::before {
  content: "\\F014D"; }

.mdi-clipboard-text-clock::before {
  content: "\\F18F9"; }

.mdi-clipboard-text-clock-outline::before {
  content: "\\F18FA"; }

.mdi-clipboard-text-multiple::before {
  content: "\\F126B"; }

.mdi-clipboard-text-multiple-outline::before {
  content: "\\F126C"; }

.mdi-clipboard-text-off::before {
  content: "\\F1620"; }

.mdi-clipboard-text-off-outline::before {
  content: "\\F1621"; }

.mdi-clipboard-text-outline::before {
  content: "\\F0A38"; }

.mdi-clipboard-text-play::before {
  content: "\\F0C5B"; }

.mdi-clipboard-text-play-outline::before {
  content: "\\F0C5C"; }

.mdi-clipboard-text-search::before {
  content: "\\F1622"; }

.mdi-clipboard-text-search-outline::before {
  content: "\\F1623"; }

.mdi-clippy::before {
  content: "\\F014F"; }

.mdi-clock::before {
  content: "\\F0954"; }

.mdi-clock-alert::before {
  content: "\\F0955"; }

.mdi-clock-alert-outline::before {
  content: "\\F05CE"; }

.mdi-clock-check::before {
  content: "\\F0FA8"; }

.mdi-clock-check-outline::before {
  content: "\\F0FA9"; }

.mdi-clock-digital::before {
  content: "\\F0E97"; }

.mdi-clock-edit::before {
  content: "\\F19BA"; }

.mdi-clock-edit-outline::before {
  content: "\\F19BB"; }

.mdi-clock-end::before {
  content: "\\F0151"; }

.mdi-clock-fast::before {
  content: "\\F0152"; }

.mdi-clock-in::before {
  content: "\\F0153"; }

.mdi-clock-minus::before {
  content: "\\F1863"; }

.mdi-clock-minus-outline::before {
  content: "\\F1864"; }

.mdi-clock-out::before {
  content: "\\F0154"; }

.mdi-clock-outline::before {
  content: "\\F0150"; }

.mdi-clock-plus::before {
  content: "\\F1861"; }

.mdi-clock-plus-outline::before {
  content: "\\F1862"; }

.mdi-clock-remove::before {
  content: "\\F1865"; }

.mdi-clock-remove-outline::before {
  content: "\\F1866"; }

.mdi-clock-start::before {
  content: "\\F0155"; }

.mdi-clock-time-eight::before {
  content: "\\F1446"; }

.mdi-clock-time-eight-outline::before {
  content: "\\F1452"; }

.mdi-clock-time-eleven::before {
  content: "\\F1449"; }

.mdi-clock-time-eleven-outline::before {
  content: "\\F1455"; }

.mdi-clock-time-five::before {
  content: "\\F1443"; }

.mdi-clock-time-five-outline::before {
  content: "\\F144F"; }

.mdi-clock-time-four::before {
  content: "\\F1442"; }

.mdi-clock-time-four-outline::before {
  content: "\\F144E"; }

.mdi-clock-time-nine::before {
  content: "\\F1447"; }

.mdi-clock-time-nine-outline::before {
  content: "\\F1453"; }

.mdi-clock-time-one::before {
  content: "\\F143F"; }

.mdi-clock-time-one-outline::before {
  content: "\\F144B"; }

.mdi-clock-time-seven::before {
  content: "\\F1445"; }

.mdi-clock-time-seven-outline::before {
  content: "\\F1451"; }

.mdi-clock-time-six::before {
  content: "\\F1444"; }

.mdi-clock-time-six-outline::before {
  content: "\\F1450"; }

.mdi-clock-time-ten::before {
  content: "\\F1448"; }

.mdi-clock-time-ten-outline::before {
  content: "\\F1454"; }

.mdi-clock-time-three::before {
  content: "\\F1441"; }

.mdi-clock-time-three-outline::before {
  content: "\\F144D"; }

.mdi-clock-time-twelve::before {
  content: "\\F144A"; }

.mdi-clock-time-twelve-outline::before {
  content: "\\F1456"; }

.mdi-clock-time-two::before {
  content: "\\F1440"; }

.mdi-clock-time-two-outline::before {
  content: "\\F144C"; }

.mdi-close::before {
  content: "\\F0156"; }

.mdi-close-box::before {
  content: "\\F0157"; }

.mdi-close-box-multiple::before {
  content: "\\F0C5D"; }

.mdi-close-box-multiple-outline::before {
  content: "\\F0C5E"; }

.mdi-close-box-outline::before {
  content: "\\F0158"; }

.mdi-close-circle::before {
  content: "\\F0159"; }

.mdi-close-circle-multiple::before {
  content: "\\F062A"; }

.mdi-close-circle-multiple-outline::before {
  content: "\\F0883"; }

.mdi-close-circle-outline::before {
  content: "\\F015A"; }

.mdi-close-network::before {
  content: "\\F015B"; }

.mdi-close-network-outline::before {
  content: "\\F0C5F"; }

.mdi-close-octagon::before {
  content: "\\F015C"; }

.mdi-close-octagon-outline::before {
  content: "\\F015D"; }

.mdi-close-outline::before {
  content: "\\F06C9"; }

.mdi-close-thick::before {
  content: "\\F1398"; }

.mdi-closed-caption::before {
  content: "\\F015E"; }

.mdi-closed-caption-outline::before {
  content: "\\F0DBD"; }

.mdi-cloud::before {
  content: "\\F015F"; }

.mdi-cloud-alert::before {
  content: "\\F09E0"; }

.mdi-cloud-braces::before {
  content: "\\F07B5"; }

.mdi-cloud-check::before {
  content: "\\F0160"; }

.mdi-cloud-check-outline::before {
  content: "\\F12CC"; }

.mdi-cloud-circle::before {
  content: "\\F0161"; }

.mdi-cloud-download::before {
  content: "\\F0162"; }

.mdi-cloud-download-outline::before {
  content: "\\F0B7D"; }

.mdi-cloud-lock::before {
  content: "\\F11F1"; }

.mdi-cloud-lock-outline::before {
  content: "\\F11F2"; }

.mdi-cloud-off-outline::before {
  content: "\\F0164"; }

.mdi-cloud-outline::before {
  content: "\\F0163"; }

.mdi-cloud-print::before {
  content: "\\F0165"; }

.mdi-cloud-print-outline::before {
  content: "\\F0166"; }

.mdi-cloud-question::before {
  content: "\\F0A39"; }

.mdi-cloud-refresh::before {
  content: "\\F052A"; }

.mdi-cloud-search::before {
  content: "\\F0956"; }

.mdi-cloud-search-outline::before {
  content: "\\F0957"; }

.mdi-cloud-sync::before {
  content: "\\F063F"; }

.mdi-cloud-sync-outline::before {
  content: "\\F12D6"; }

.mdi-cloud-tags::before {
  content: "\\F07B6"; }

.mdi-cloud-upload::before {
  content: "\\F0167"; }

.mdi-cloud-upload-outline::before {
  content: "\\F0B7E"; }

.mdi-clover::before {
  content: "\\F0816"; }

.mdi-coach-lamp::before {
  content: "\\F1020"; }

.mdi-coat-rack::before {
  content: "\\F109E"; }

.mdi-code-array::before {
  content: "\\F0168"; }

.mdi-code-braces::before {
  content: "\\F0169"; }

.mdi-code-braces-box::before {
  content: "\\F10D6"; }

.mdi-code-brackets::before {
  content: "\\F016A"; }

.mdi-code-equal::before {
  content: "\\F016B"; }

.mdi-code-greater-than::before {
  content: "\\F016C"; }

.mdi-code-greater-than-or-equal::before {
  content: "\\F016D"; }

.mdi-code-json::before {
  content: "\\F0626"; }

.mdi-code-less-than::before {
  content: "\\F016E"; }

.mdi-code-less-than-or-equal::before {
  content: "\\F016F"; }

.mdi-code-not-equal::before {
  content: "\\F0170"; }

.mdi-code-not-equal-variant::before {
  content: "\\F0171"; }

.mdi-code-parentheses::before {
  content: "\\F0172"; }

.mdi-code-parentheses-box::before {
  content: "\\F10D7"; }

.mdi-code-string::before {
  content: "\\F0173"; }

.mdi-code-tags::before {
  content: "\\F0174"; }

.mdi-code-tags-check::before {
  content: "\\F0694"; }

.mdi-codepen::before {
  content: "\\F0175"; }

.mdi-coffee::before {
  content: "\\F0176"; }

.mdi-coffee-maker::before {
  content: "\\F109F"; }

.mdi-coffee-maker-check::before {
  content: "\\F1931"; }

.mdi-coffee-maker-check-outline::before {
  content: "\\F1932"; }

.mdi-coffee-maker-outline::before {
  content: "\\F181B"; }

.mdi-coffee-off::before {
  content: "\\F0FAA"; }

.mdi-coffee-off-outline::before {
  content: "\\F0FAB"; }

.mdi-coffee-outline::before {
  content: "\\F06CA"; }

.mdi-coffee-to-go::before {
  content: "\\F0177"; }

.mdi-coffee-to-go-outline::before {
  content: "\\F130E"; }

.mdi-coffin::before {
  content: "\\F0B7F"; }

.mdi-cog::before {
  content: "\\F0493"; }

.mdi-cog-box::before {
  content: "\\F0494"; }

.mdi-cog-clockwise::before {
  content: "\\F11DD"; }

.mdi-cog-counterclockwise::before {
  content: "\\F11DE"; }

.mdi-cog-off::before {
  content: "\\F13CE"; }

.mdi-cog-off-outline::before {
  content: "\\F13CF"; }

.mdi-cog-outline::before {
  content: "\\F08BB"; }

.mdi-cog-pause::before {
  content: "\\F1933"; }

.mdi-cog-pause-outline::before {
  content: "\\F1934"; }

.mdi-cog-play::before {
  content: "\\F1935"; }

.mdi-cog-play-outline::before {
  content: "\\F1936"; }

.mdi-cog-refresh::before {
  content: "\\F145E"; }

.mdi-cog-refresh-outline::before {
  content: "\\F145F"; }

.mdi-cog-stop::before {
  content: "\\F1937"; }

.mdi-cog-stop-outline::before {
  content: "\\F1938"; }

.mdi-cog-sync::before {
  content: "\\F1460"; }

.mdi-cog-sync-outline::before {
  content: "\\F1461"; }

.mdi-cog-transfer::before {
  content: "\\F105B"; }

.mdi-cog-transfer-outline::before {
  content: "\\F105C"; }

.mdi-cogs::before {
  content: "\\F08D6"; }

.mdi-collage::before {
  content: "\\F0640"; }

.mdi-collapse-all::before {
  content: "\\F0AA6"; }

.mdi-collapse-all-outline::before {
  content: "\\F0AA7"; }

.mdi-color-helper::before {
  content: "\\F0179"; }

.mdi-comma::before {
  content: "\\F0E23"; }

.mdi-comma-box::before {
  content: "\\F0E2B"; }

.mdi-comma-box-outline::before {
  content: "\\F0E24"; }

.mdi-comma-circle::before {
  content: "\\F0E25"; }

.mdi-comma-circle-outline::before {
  content: "\\F0E26"; }

.mdi-comment::before {
  content: "\\F017A"; }

.mdi-comment-account::before {
  content: "\\F017B"; }

.mdi-comment-account-outline::before {
  content: "\\F017C"; }

.mdi-comment-alert::before {
  content: "\\F017D"; }

.mdi-comment-alert-outline::before {
  content: "\\F017E"; }

.mdi-comment-arrow-left::before {
  content: "\\F09E1"; }

.mdi-comment-arrow-left-outline::before {
  content: "\\F09E2"; }

.mdi-comment-arrow-right::before {
  content: "\\F09E3"; }

.mdi-comment-arrow-right-outline::before {
  content: "\\F09E4"; }

.mdi-comment-bookmark::before {
  content: "\\F15AE"; }

.mdi-comment-bookmark-outline::before {
  content: "\\F15AF"; }

.mdi-comment-check::before {
  content: "\\F017F"; }

.mdi-comment-check-outline::before {
  content: "\\F0180"; }

.mdi-comment-edit::before {
  content: "\\F11BF"; }

.mdi-comment-edit-outline::before {
  content: "\\F12C4"; }

.mdi-comment-eye::before {
  content: "\\F0A3A"; }

.mdi-comment-eye-outline::before {
  content: "\\F0A3B"; }

.mdi-comment-flash::before {
  content: "\\F15B0"; }

.mdi-comment-flash-outline::before {
  content: "\\F15B1"; }

.mdi-comment-minus::before {
  content: "\\F15DF"; }

.mdi-comment-minus-outline::before {
  content: "\\F15E0"; }

.mdi-comment-multiple::before {
  content: "\\F085F"; }

.mdi-comment-multiple-outline::before {
  content: "\\F0181"; }

.mdi-comment-off::before {
  content: "\\F15E1"; }

.mdi-comment-off-outline::before {
  content: "\\F15E2"; }

.mdi-comment-outline::before {
  content: "\\F0182"; }

.mdi-comment-plus::before {
  content: "\\F09E5"; }

.mdi-comment-plus-outline::before {
  content: "\\F0183"; }

.mdi-comment-processing::before {
  content: "\\F0184"; }

.mdi-comment-processing-outline::before {
  content: "\\F0185"; }

.mdi-comment-question::before {
  content: "\\F0817"; }

.mdi-comment-question-outline::before {
  content: "\\F0186"; }

.mdi-comment-quote::before {
  content: "\\F1021"; }

.mdi-comment-quote-outline::before {
  content: "\\F1022"; }

.mdi-comment-remove::before {
  content: "\\F05DE"; }

.mdi-comment-remove-outline::before {
  content: "\\F0187"; }

.mdi-comment-search::before {
  content: "\\F0A3C"; }

.mdi-comment-search-outline::before {
  content: "\\F0A3D"; }

.mdi-comment-text::before {
  content: "\\F0188"; }

.mdi-comment-text-multiple::before {
  content: "\\F0860"; }

.mdi-comment-text-multiple-outline::before {
  content: "\\F0861"; }

.mdi-comment-text-outline::before {
  content: "\\F0189"; }

.mdi-compare::before {
  content: "\\F018A"; }

.mdi-compare-horizontal::before {
  content: "\\F1492"; }

.mdi-compare-remove::before {
  content: "\\F18B3"; }

.mdi-compare-vertical::before {
  content: "\\F1493"; }

.mdi-compass::before {
  content: "\\F018B"; }

.mdi-compass-off::before {
  content: "\\F0B80"; }

.mdi-compass-off-outline::before {
  content: "\\F0B81"; }

.mdi-compass-outline::before {
  content: "\\F018C"; }

.mdi-compass-rose::before {
  content: "\\F1382"; }

.mdi-cone::before {
  content: "\\F194C"; }

.mdi-cone-off::before {
  content: "\\F194D"; }

.mdi-connection::before {
  content: "\\F1616"; }

.mdi-console::before {
  content: "\\F018D"; }

.mdi-console-line::before {
  content: "\\F07B7"; }

.mdi-console-network::before {
  content: "\\F08A9"; }

.mdi-console-network-outline::before {
  content: "\\F0C60"; }

.mdi-consolidate::before {
  content: "\\F10D8"; }

.mdi-contactless-payment::before {
  content: "\\F0D6A"; }

.mdi-contactless-payment-circle::before {
  content: "\\F0321"; }

.mdi-contactless-payment-circle-outline::before {
  content: "\\F0408"; }

.mdi-contacts::before {
  content: "\\F06CB"; }

.mdi-contacts-outline::before {
  content: "\\F05B8"; }

.mdi-contain::before {
  content: "\\F0A3E"; }

.mdi-contain-end::before {
  content: "\\F0A3F"; }

.mdi-contain-start::before {
  content: "\\F0A40"; }

.mdi-content-copy::before {
  content: "\\F018F"; }

.mdi-content-cut::before {
  content: "\\F0190"; }

.mdi-content-duplicate::before {
  content: "\\F0191"; }

.mdi-content-paste::before {
  content: "\\F0192"; }

.mdi-content-save::before {
  content: "\\F0193"; }

.mdi-content-save-alert::before {
  content: "\\F0F42"; }

.mdi-content-save-alert-outline::before {
  content: "\\F0F43"; }

.mdi-content-save-all::before {
  content: "\\F0194"; }

.mdi-content-save-all-outline::before {
  content: "\\F0F44"; }

.mdi-content-save-check::before {
  content: "\\F18EA"; }

.mdi-content-save-check-outline::before {
  content: "\\F18EB"; }

.mdi-content-save-cog::before {
  content: "\\F145B"; }

.mdi-content-save-cog-outline::before {
  content: "\\F145C"; }

.mdi-content-save-edit::before {
  content: "\\F0CFB"; }

.mdi-content-save-edit-outline::before {
  content: "\\F0CFC"; }

.mdi-content-save-move::before {
  content: "\\F0E27"; }

.mdi-content-save-move-outline::before {
  content: "\\F0E28"; }

.mdi-content-save-off::before {
  content: "\\F1643"; }

.mdi-content-save-off-outline::before {
  content: "\\F1644"; }

.mdi-content-save-outline::before {
  content: "\\F0818"; }

.mdi-content-save-settings::before {
  content: "\\F061B"; }

.mdi-content-save-settings-outline::before {
  content: "\\F0B2E"; }

.mdi-contrast::before {
  content: "\\F0195"; }

.mdi-contrast-box::before {
  content: "\\F0196"; }

.mdi-contrast-circle::before {
  content: "\\F0197"; }

.mdi-controller-classic::before {
  content: "\\F0B82"; }

.mdi-controller-classic-outline::before {
  content: "\\F0B83"; }

.mdi-cookie::before {
  content: "\\F0198"; }

.mdi-cookie-alert::before {
  content: "\\F16D0"; }

.mdi-cookie-alert-outline::before {
  content: "\\F16D1"; }

.mdi-cookie-check::before {
  content: "\\F16D2"; }

.mdi-cookie-check-outline::before {
  content: "\\F16D3"; }

.mdi-cookie-clock::before {
  content: "\\F16E4"; }

.mdi-cookie-clock-outline::before {
  content: "\\F16E5"; }

.mdi-cookie-cog::before {
  content: "\\F16D4"; }

.mdi-cookie-cog-outline::before {
  content: "\\F16D5"; }

.mdi-cookie-edit::before {
  content: "\\F16E6"; }

.mdi-cookie-edit-outline::before {
  content: "\\F16E7"; }

.mdi-cookie-lock::before {
  content: "\\F16E8"; }

.mdi-cookie-lock-outline::before {
  content: "\\F16E9"; }

.mdi-cookie-minus::before {
  content: "\\F16DA"; }

.mdi-cookie-minus-outline::before {
  content: "\\F16DB"; }

.mdi-cookie-off::before {
  content: "\\F16EA"; }

.mdi-cookie-off-outline::before {
  content: "\\F16EB"; }

.mdi-cookie-outline::before {
  content: "\\F16DE"; }

.mdi-cookie-plus::before {
  content: "\\F16D6"; }

.mdi-cookie-plus-outline::before {
  content: "\\F16D7"; }

.mdi-cookie-refresh::before {
  content: "\\F16EC"; }

.mdi-cookie-refresh-outline::before {
  content: "\\F16ED"; }

.mdi-cookie-remove::before {
  content: "\\F16D8"; }

.mdi-cookie-remove-outline::before {
  content: "\\F16D9"; }

.mdi-cookie-settings::before {
  content: "\\F16DC"; }

.mdi-cookie-settings-outline::before {
  content: "\\F16DD"; }

.mdi-coolant-temperature::before {
  content: "\\F03C8"; }

.mdi-copyleft::before {
  content: "\\F1939"; }

.mdi-copyright::before {
  content: "\\F05E6"; }

.mdi-cordova::before {
  content: "\\F0958"; }

.mdi-corn::before {
  content: "\\F07B8"; }

.mdi-corn-off::before {
  content: "\\F13EF"; }

.mdi-cosine-wave::before {
  content: "\\F1479"; }

.mdi-counter::before {
  content: "\\F0199"; }

.mdi-countertop::before {
  content: "\\F181C"; }

.mdi-countertop-outline::before {
  content: "\\F181D"; }

.mdi-cow::before {
  content: "\\F019A"; }

.mdi-cow-off::before {
  content: "\\F18FC"; }

.mdi-cpu-32-bit::before {
  content: "\\F0EDF"; }

.mdi-cpu-64-bit::before {
  content: "\\F0EE0"; }

.mdi-cradle::before {
  content: "\\F198B"; }

.mdi-cradle-outline::before {
  content: "\\F1991"; }

.mdi-crane::before {
  content: "\\F0862"; }

.mdi-creation::before {
  content: "\\F0674"; }

.mdi-creative-commons::before {
  content: "\\F0D6B"; }

.mdi-credit-card::before {
  content: "\\F0FEF"; }

.mdi-credit-card-check::before {
  content: "\\F13D0"; }

.mdi-credit-card-check-outline::before {
  content: "\\F13D1"; }

.mdi-credit-card-chip::before {
  content: "\\F190F"; }

.mdi-credit-card-chip-outline::before {
  content: "\\F1910"; }

.mdi-credit-card-clock::before {
  content: "\\F0EE1"; }

.mdi-credit-card-clock-outline::before {
  content: "\\F0EE2"; }

.mdi-credit-card-edit::before {
  content: "\\F17D7"; }

.mdi-credit-card-edit-outline::before {
  content: "\\F17D8"; }

.mdi-credit-card-fast::before {
  content: "\\F1911"; }

.mdi-credit-card-fast-outline::before {
  content: "\\F1912"; }

.mdi-credit-card-lock::before {
  content: "\\F18E7"; }

.mdi-credit-card-lock-outline::before {
  content: "\\F18E8"; }

.mdi-credit-card-marker::before {
  content: "\\F06A8"; }

.mdi-credit-card-marker-outline::before {
  content: "\\F0DBE"; }

.mdi-credit-card-minus::before {
  content: "\\F0FAC"; }

.mdi-credit-card-minus-outline::before {
  content: "\\F0FAD"; }

.mdi-credit-card-multiple::before {
  content: "\\F0FF0"; }

.mdi-credit-card-multiple-outline::before {
  content: "\\F019C"; }

.mdi-credit-card-off::before {
  content: "\\F0FF1"; }

.mdi-credit-card-off-outline::before {
  content: "\\F05E4"; }

.mdi-credit-card-outline::before {
  content: "\\F019B"; }

.mdi-credit-card-plus::before {
  content: "\\F0FF2"; }

.mdi-credit-card-plus-outline::before {
  content: "\\F0676"; }

.mdi-credit-card-refresh::before {
  content: "\\F1645"; }

.mdi-credit-card-refresh-outline::before {
  content: "\\F1646"; }

.mdi-credit-card-refund::before {
  content: "\\F0FF3"; }

.mdi-credit-card-refund-outline::before {
  content: "\\F0AA8"; }

.mdi-credit-card-remove::before {
  content: "\\F0FAE"; }

.mdi-credit-card-remove-outline::before {
  content: "\\F0FAF"; }

.mdi-credit-card-scan::before {
  content: "\\F0FF4"; }

.mdi-credit-card-scan-outline::before {
  content: "\\F019D"; }

.mdi-credit-card-search::before {
  content: "\\F1647"; }

.mdi-credit-card-search-outline::before {
  content: "\\F1648"; }

.mdi-credit-card-settings::before {
  content: "\\F0FF5"; }

.mdi-credit-card-settings-outline::before {
  content: "\\F08D7"; }

.mdi-credit-card-sync::before {
  content: "\\F1649"; }

.mdi-credit-card-sync-outline::before {
  content: "\\F164A"; }

.mdi-credit-card-wireless::before {
  content: "\\F0802"; }

.mdi-credit-card-wireless-off::before {
  content: "\\F057A"; }

.mdi-credit-card-wireless-off-outline::before {
  content: "\\F057B"; }

.mdi-credit-card-wireless-outline::before {
  content: "\\F0D6C"; }

.mdi-cricket::before {
  content: "\\F0D6D"; }

.mdi-crop::before {
  content: "\\F019E"; }

.mdi-crop-free::before {
  content: "\\F019F"; }

.mdi-crop-landscape::before {
  content: "\\F01A0"; }

.mdi-crop-portrait::before {
  content: "\\F01A1"; }

.mdi-crop-rotate::before {
  content: "\\F0696"; }

.mdi-crop-square::before {
  content: "\\F01A2"; }

.mdi-cross::before {
  content: "\\F0953"; }

.mdi-cross-bolnisi::before {
  content: "\\F0CED"; }

.mdi-cross-celtic::before {
  content: "\\F0CF5"; }

.mdi-cross-outline::before {
  content: "\\F0CF6"; }

.mdi-crosshairs::before {
  content: "\\F01A3"; }

.mdi-crosshairs-gps::before {
  content: "\\F01A4"; }

.mdi-crosshairs-off::before {
  content: "\\F0F45"; }

.mdi-crosshairs-question::before {
  content: "\\F1136"; }

.mdi-crowd::before {
  content: "\\F1975"; }

.mdi-crown::before {
  content: "\\F01A5"; }

.mdi-crown-circle::before {
  content: "\\F17DC"; }

.mdi-crown-circle-outline::before {
  content: "\\F17DD"; }

.mdi-crown-outline::before {
  content: "\\F11D0"; }

.mdi-cryengine::before {
  content: "\\F0959"; }

.mdi-crystal-ball::before {
  content: "\\F0B2F"; }

.mdi-cube::before {
  content: "\\F01A6"; }

.mdi-cube-off::before {
  content: "\\F141C"; }

.mdi-cube-off-outline::before {
  content: "\\F141D"; }

.mdi-cube-outline::before {
  content: "\\F01A7"; }

.mdi-cube-scan::before {
  content: "\\F0B84"; }

.mdi-cube-send::before {
  content: "\\F01A8"; }

.mdi-cube-unfolded::before {
  content: "\\F01A9"; }

.mdi-cup::before {
  content: "\\F01AA"; }

.mdi-cup-off::before {
  content: "\\F05E5"; }

.mdi-cup-off-outline::before {
  content: "\\F137D"; }

.mdi-cup-outline::before {
  content: "\\F130F"; }

.mdi-cup-water::before {
  content: "\\F01AB"; }

.mdi-cupboard::before {
  content: "\\F0F46"; }

.mdi-cupboard-outline::before {
  content: "\\F0F47"; }

.mdi-cupcake::before {
  content: "\\F095A"; }

.mdi-curling::before {
  content: "\\F0863"; }

.mdi-currency-bdt::before {
  content: "\\F0864"; }

.mdi-currency-brl::before {
  content: "\\F0B85"; }

.mdi-currency-btc::before {
  content: "\\F01AC"; }

.mdi-currency-cny::before {
  content: "\\F07BA"; }

.mdi-currency-eth::before {
  content: "\\F07BB"; }

.mdi-currency-eur::before {
  content: "\\F01AD"; }

.mdi-currency-eur-off::before {
  content: "\\F1315"; }

.mdi-currency-gbp::before {
  content: "\\F01AE"; }

.mdi-currency-ils::before {
  content: "\\F0C61"; }

.mdi-currency-inr::before {
  content: "\\F01AF"; }

.mdi-currency-jpy::before {
  content: "\\F07BC"; }

.mdi-currency-krw::before {
  content: "\\F07BD"; }

.mdi-currency-kzt::before {
  content: "\\F0865"; }

.mdi-currency-mnt::before {
  content: "\\F1512"; }

.mdi-currency-ngn::before {
  content: "\\F01B0"; }

.mdi-currency-php::before {
  content: "\\F09E6"; }

.mdi-currency-rial::before {
  content: "\\F0E9C"; }

.mdi-currency-rub::before {
  content: "\\F01B1"; }

.mdi-currency-rupee::before {
  content: "\\F1976"; }

.mdi-currency-sign::before {
  content: "\\F07BE"; }

.mdi-currency-try::before {
  content: "\\F01B2"; }

.mdi-currency-twd::before {
  content: "\\F07BF"; }

.mdi-currency-usd::before {
  content: "\\F01C1"; }

.mdi-currency-usd-off::before {
  content: "\\F067A"; }

.mdi-current-ac::before {
  content: "\\F1480"; }

.mdi-current-dc::before {
  content: "\\F095C"; }

.mdi-cursor-default::before {
  content: "\\F01C0"; }

.mdi-cursor-default-click::before {
  content: "\\F0CFD"; }

.mdi-cursor-default-click-outline::before {
  content: "\\F0CFE"; }

.mdi-cursor-default-gesture::before {
  content: "\\F1127"; }

.mdi-cursor-default-gesture-outline::before {
  content: "\\F1128"; }

.mdi-cursor-default-outline::before {
  content: "\\F01BF"; }

.mdi-cursor-move::before {
  content: "\\F01BE"; }

.mdi-cursor-pointer::before {
  content: "\\F01BD"; }

.mdi-cursor-text::before {
  content: "\\F05E7"; }

.mdi-curtains::before {
  content: "\\F1846"; }

.mdi-curtains-closed::before {
  content: "\\F1847"; }

.mdi-cylinder::before {
  content: "\\F194E"; }

.mdi-cylinder-off::before {
  content: "\\F194F"; }

.mdi-dance-ballroom::before {
  content: "\\F15FB"; }

.mdi-dance-pole::before {
  content: "\\F1578"; }

.mdi-data-matrix::before {
  content: "\\F153C"; }

.mdi-data-matrix-edit::before {
  content: "\\F153D"; }

.mdi-data-matrix-minus::before {
  content: "\\F153E"; }

.mdi-data-matrix-plus::before {
  content: "\\F153F"; }

.mdi-data-matrix-remove::before {
  content: "\\F1540"; }

.mdi-data-matrix-scan::before {
  content: "\\F1541"; }

.mdi-database::before {
  content: "\\F01BC"; }

.mdi-database-alert::before {
  content: "\\F163A"; }

.mdi-database-alert-outline::before {
  content: "\\F1624"; }

.mdi-database-arrow-down::before {
  content: "\\F163B"; }

.mdi-database-arrow-down-outline::before {
  content: "\\F1625"; }

.mdi-database-arrow-left::before {
  content: "\\F163C"; }

.mdi-database-arrow-left-outline::before {
  content: "\\F1626"; }

.mdi-database-arrow-right::before {
  content: "\\F163D"; }

.mdi-database-arrow-right-outline::before {
  content: "\\F1627"; }

.mdi-database-arrow-up::before {
  content: "\\F163E"; }

.mdi-database-arrow-up-outline::before {
  content: "\\F1628"; }

.mdi-database-check::before {
  content: "\\F0AA9"; }

.mdi-database-check-outline::before {
  content: "\\F1629"; }

.mdi-database-clock::before {
  content: "\\F163F"; }

.mdi-database-clock-outline::before {
  content: "\\F162A"; }

.mdi-database-cog::before {
  content: "\\F164B"; }

.mdi-database-cog-outline::before {
  content: "\\F164C"; }

.mdi-database-edit::before {
  content: "\\F0B86"; }

.mdi-database-edit-outline::before {
  content: "\\F162B"; }

.mdi-database-export::before {
  content: "\\F095E"; }

.mdi-database-export-outline::before {
  content: "\\F162C"; }

.mdi-database-eye::before {
  content: "\\F191F"; }

.mdi-database-eye-off::before {
  content: "\\F1920"; }

.mdi-database-eye-off-outline::before {
  content: "\\F1921"; }

.mdi-database-eye-outline::before {
  content: "\\F1922"; }

.mdi-database-import::before {
  content: "\\F095D"; }

.mdi-database-import-outline::before {
  content: "\\F162D"; }

.mdi-database-lock::before {
  content: "\\F0AAA"; }

.mdi-database-lock-outline::before {
  content: "\\F162E"; }

.mdi-database-marker::before {
  content: "\\F12F6"; }

.mdi-database-marker-outline::before {
  content: "\\F162F"; }

.mdi-database-minus::before {
  content: "\\F01BB"; }

.mdi-database-minus-outline::before {
  content: "\\F1630"; }

.mdi-database-off::before {
  content: "\\F1640"; }

.mdi-database-off-outline::before {
  content: "\\F1631"; }

.mdi-database-outline::before {
  content: "\\F1632"; }

.mdi-database-plus::before {
  content: "\\F01BA"; }

.mdi-database-plus-outline::before {
  content: "\\F1633"; }

.mdi-database-refresh::before {
  content: "\\F05C2"; }

.mdi-database-refresh-outline::before {
  content: "\\F1634"; }

.mdi-database-remove::before {
  content: "\\F0D00"; }

.mdi-database-remove-outline::before {
  content: "\\F1635"; }

.mdi-database-search::before {
  content: "\\F0866"; }

.mdi-database-search-outline::before {
  content: "\\F1636"; }

.mdi-database-settings::before {
  content: "\\F0D01"; }

.mdi-database-settings-outline::before {
  content: "\\F1637"; }

.mdi-database-sync::before {
  content: "\\F0CFF"; }

.mdi-database-sync-outline::before {
  content: "\\F1638"; }

.mdi-death-star::before {
  content: "\\F08D8"; }

.mdi-death-star-variant::before {
  content: "\\F08D9"; }

.mdi-deathly-hallows::before {
  content: "\\F0B87"; }

.mdi-debian::before {
  content: "\\F08DA"; }

.mdi-debug-step-into::before {
  content: "\\F01B9"; }

.mdi-debug-step-out::before {
  content: "\\F01B8"; }

.mdi-debug-step-over::before {
  content: "\\F01B7"; }

.mdi-decagram::before {
  content: "\\F076C"; }

.mdi-decagram-outline::before {
  content: "\\F076D"; }

.mdi-decimal::before {
  content: "\\F10A1"; }

.mdi-decimal-comma::before {
  content: "\\F10A2"; }

.mdi-decimal-comma-decrease::before {
  content: "\\F10A3"; }

.mdi-decimal-comma-increase::before {
  content: "\\F10A4"; }

.mdi-decimal-decrease::before {
  content: "\\F01B6"; }

.mdi-decimal-increase::before {
  content: "\\F01B5"; }

.mdi-delete::before {
  content: "\\F01B4"; }

.mdi-delete-alert::before {
  content: "\\F10A5"; }

.mdi-delete-alert-outline::before {
  content: "\\F10A6"; }

.mdi-delete-circle::before {
  content: "\\F0683"; }

.mdi-delete-circle-outline::before {
  content: "\\F0B88"; }

.mdi-delete-clock::before {
  content: "\\F1556"; }

.mdi-delete-clock-outline::before {
  content: "\\F1557"; }

.mdi-delete-empty::before {
  content: "\\F06CC"; }

.mdi-delete-empty-outline::before {
  content: "\\F0E9D"; }

.mdi-delete-forever::before {
  content: "\\F05E8"; }

.mdi-delete-forever-outline::before {
  content: "\\F0B89"; }

.mdi-delete-off::before {
  content: "\\F10A7"; }

.mdi-delete-off-outline::before {
  content: "\\F10A8"; }

.mdi-delete-outline::before {
  content: "\\F09E7"; }

.mdi-delete-restore::before {
  content: "\\F0819"; }

.mdi-delete-sweep::before {
  content: "\\F05E9"; }

.mdi-delete-sweep-outline::before {
  content: "\\F0C62"; }

.mdi-delete-variant::before {
  content: "\\F01B3"; }

.mdi-delta::before {
  content: "\\F01C2"; }

.mdi-desk::before {
  content: "\\F1239"; }

.mdi-desk-lamp::before {
  content: "\\F095F"; }

.mdi-deskphone::before {
  content: "\\F01C3"; }

.mdi-desktop-classic::before {
  content: "\\F07C0"; }

.mdi-desktop-mac::before {
  content: "\\F01C4"; }

.mdi-desktop-mac-dashboard::before {
  content: "\\F09E8"; }

.mdi-desktop-tower::before {
  content: "\\F01C5"; }

.mdi-desktop-tower-monitor::before {
  content: "\\F0AAB"; }

.mdi-details::before {
  content: "\\F01C6"; }

.mdi-dev-to::before {
  content: "\\F0D6E"; }

.mdi-developer-board::before {
  content: "\\F0697"; }

.mdi-deviantart::before {
  content: "\\F01C7"; }

.mdi-devices::before {
  content: "\\F0FB0"; }

.mdi-dharmachakra::before {
  content: "\\F094B"; }

.mdi-diabetes::before {
  content: "\\F1126"; }

.mdi-dialpad::before {
  content: "\\F061C"; }

.mdi-diameter::before {
  content: "\\F0C63"; }

.mdi-diameter-outline::before {
  content: "\\F0C64"; }

.mdi-diameter-variant::before {
  content: "\\F0C65"; }

.mdi-diamond::before {
  content: "\\F0B8A"; }

.mdi-diamond-outline::before {
  content: "\\F0B8B"; }

.mdi-diamond-stone::before {
  content: "\\F01C8"; }

.mdi-dice-1::before {
  content: "\\F01CA"; }

.mdi-dice-1-outline::before {
  content: "\\F114A"; }

.mdi-dice-2::before {
  content: "\\F01CB"; }

.mdi-dice-2-outline::before {
  content: "\\F114B"; }

.mdi-dice-3::before {
  content: "\\F01CC"; }

.mdi-dice-3-outline::before {
  content: "\\F114C"; }

.mdi-dice-4::before {
  content: "\\F01CD"; }

.mdi-dice-4-outline::before {
  content: "\\F114D"; }

.mdi-dice-5::before {
  content: "\\F01CE"; }

.mdi-dice-5-outline::before {
  content: "\\F114E"; }

.mdi-dice-6::before {
  content: "\\F01CF"; }

.mdi-dice-6-outline::before {
  content: "\\F114F"; }

.mdi-dice-d10::before {
  content: "\\F1153"; }

.mdi-dice-d10-outline::before {
  content: "\\F076F"; }

.mdi-dice-d12::before {
  content: "\\F1154"; }

.mdi-dice-d12-outline::before {
  content: "\\F0867"; }

.mdi-dice-d20::before {
  content: "\\F1155"; }

.mdi-dice-d20-outline::before {
  content: "\\F05EA"; }

.mdi-dice-d4::before {
  content: "\\F1150"; }

.mdi-dice-d4-outline::before {
  content: "\\F05EB"; }

.mdi-dice-d6::before {
  content: "\\F1151"; }

.mdi-dice-d6-outline::before {
  content: "\\F05ED"; }

.mdi-dice-d8::before {
  content: "\\F1152"; }

.mdi-dice-d8-outline::before {
  content: "\\F05EC"; }

.mdi-dice-multiple::before {
  content: "\\F076E"; }

.mdi-dice-multiple-outline::before {
  content: "\\F1156"; }

.mdi-digital-ocean::before {
  content: "\\F1237"; }

.mdi-dip-switch::before {
  content: "\\F07C1"; }

.mdi-directions::before {
  content: "\\F01D0"; }

.mdi-directions-fork::before {
  content: "\\F0641"; }

.mdi-disc::before {
  content: "\\F05EE"; }

.mdi-disc-alert::before {
  content: "\\F01D1"; }

.mdi-disc-player::before {
  content: "\\F0960"; }

.mdi-discord::before {
  content: "\\F066F"; }

.mdi-dishwasher::before {
  content: "\\F0AAC"; }

.mdi-dishwasher-alert::before {
  content: "\\F11B8"; }

.mdi-dishwasher-off::before {
  content: "\\F11B9"; }

.mdi-disqus::before {
  content: "\\F01D2"; }

.mdi-distribute-horizontal-center::before {
  content: "\\F11C9"; }

.mdi-distribute-horizontal-left::before {
  content: "\\F11C8"; }

.mdi-distribute-horizontal-right::before {
  content: "\\F11CA"; }

.mdi-distribute-vertical-bottom::before {
  content: "\\F11CB"; }

.mdi-distribute-vertical-center::before {
  content: "\\F11CC"; }

.mdi-distribute-vertical-top::before {
  content: "\\F11CD"; }

.mdi-diversify::before {
  content: "\\F1877"; }

.mdi-diving::before {
  content: "\\F1977"; }

.mdi-diving-flippers::before {
  content: "\\F0DBF"; }

.mdi-diving-helmet::before {
  content: "\\F0DC0"; }

.mdi-diving-scuba::before {
  content: "\\F0DC1"; }

.mdi-diving-scuba-flag::before {
  content: "\\F0DC2"; }

.mdi-diving-scuba-tank::before {
  content: "\\F0DC3"; }

.mdi-diving-scuba-tank-multiple::before {
  content: "\\F0DC4"; }

.mdi-diving-snorkel::before {
  content: "\\F0DC5"; }

.mdi-division::before {
  content: "\\F01D4"; }

.mdi-division-box::before {
  content: "\\F01D5"; }

.mdi-dlna::before {
  content: "\\F0A41"; }

.mdi-dna::before {
  content: "\\F0684"; }

.mdi-dns::before {
  content: "\\F01D6"; }

.mdi-dns-outline::before {
  content: "\\F0B8C"; }

.mdi-dock-bottom::before {
  content: "\\F10A9"; }

.mdi-dock-left::before {
  content: "\\F10AA"; }

.mdi-dock-right::before {
  content: "\\F10AB"; }

.mdi-dock-top::before {
  content: "\\F1513"; }

.mdi-dock-window::before {
  content: "\\F10AC"; }

.mdi-docker::before {
  content: "\\F0868"; }

.mdi-doctor::before {
  content: "\\F0A42"; }

.mdi-dog::before {
  content: "\\F0A43"; }

.mdi-dog-service::before {
  content: "\\F0AAD"; }

.mdi-dog-side::before {
  content: "\\F0A44"; }

.mdi-dog-side-off::before {
  content: "\\F16EE"; }

.mdi-dolby::before {
  content: "\\F06B3"; }

.mdi-dolly::before {
  content: "\\F0E9E"; }

.mdi-dolphin::before {
  content: "\\F18B4"; }

.mdi-domain::before {
  content: "\\F01D7"; }

.mdi-domain-off::before {
  content: "\\F0D6F"; }

.mdi-domain-plus::before {
  content: "\\F10AD"; }

.mdi-domain-remove::before {
  content: "\\F10AE"; }

.mdi-dome-light::before {
  content: "\\F141E"; }

.mdi-domino-mask::before {
  content: "\\F1023"; }

.mdi-donkey::before {
  content: "\\F07C2"; }

.mdi-door::before {
  content: "\\F081A"; }

.mdi-door-closed::before {
  content: "\\F081B"; }

.mdi-door-closed-lock::before {
  content: "\\F10AF"; }

.mdi-door-open::before {
  content: "\\F081C"; }

.mdi-door-sliding::before {
  content: "\\F181E"; }

.mdi-door-sliding-lock::before {
  content: "\\F181F"; }

.mdi-door-sliding-open::before {
  content: "\\F1820"; }

.mdi-doorbell::before {
  content: "\\F12E6"; }

.mdi-doorbell-video::before {
  content: "\\F0869"; }

.mdi-dot-net::before {
  content: "\\F0AAE"; }

.mdi-dots-circle::before {
  content: "\\F1978"; }

.mdi-dots-grid::before {
  content: "\\F15FC"; }

.mdi-dots-hexagon::before {
  content: "\\F15FF"; }

.mdi-dots-horizontal::before {
  content: "\\F01D8"; }

.mdi-dots-horizontal-circle::before {
  content: "\\F07C3"; }

.mdi-dots-horizontal-circle-outline::before {
  content: "\\F0B8D"; }

.mdi-dots-square::before {
  content: "\\F15FD"; }

.mdi-dots-triangle::before {
  content: "\\F15FE"; }

.mdi-dots-vertical::before {
  content: "\\F01D9"; }

.mdi-dots-vertical-circle::before {
  content: "\\F07C4"; }

.mdi-dots-vertical-circle-outline::before {
  content: "\\F0B8E"; }

.mdi-download::before {
  content: "\\F01DA"; }

.mdi-download-box::before {
  content: "\\F1462"; }

.mdi-download-box-outline::before {
  content: "\\F1463"; }

.mdi-download-circle::before {
  content: "\\F1464"; }

.mdi-download-circle-outline::before {
  content: "\\F1465"; }

.mdi-download-lock::before {
  content: "\\F1320"; }

.mdi-download-lock-outline::before {
  content: "\\F1321"; }

.mdi-download-multiple::before {
  content: "\\F09E9"; }

.mdi-download-network::before {
  content: "\\F06F4"; }

.mdi-download-network-outline::before {
  content: "\\F0C66"; }

.mdi-download-off::before {
  content: "\\F10B0"; }

.mdi-download-off-outline::before {
  content: "\\F10B1"; }

.mdi-download-outline::before {
  content: "\\F0B8F"; }

.mdi-drag::before {
  content: "\\F01DB"; }

.mdi-drag-horizontal::before {
  content: "\\F01DC"; }

.mdi-drag-horizontal-variant::before {
  content: "\\F12F0"; }

.mdi-drag-variant::before {
  content: "\\F0B90"; }

.mdi-drag-vertical::before {
  content: "\\F01DD"; }

.mdi-drag-vertical-variant::before {
  content: "\\F12F1"; }

.mdi-drama-masks::before {
  content: "\\F0D02"; }

.mdi-draw::before {
  content: "\\F0F49"; }

.mdi-draw-pen::before {
  content: "\\F19B9"; }

.mdi-drawing::before {
  content: "\\F01DE"; }

.mdi-drawing-box::before {
  content: "\\F01DF"; }

.mdi-dresser::before {
  content: "\\F0F4A"; }

.mdi-dresser-outline::before {
  content: "\\F0F4B"; }

.mdi-drone::before {
  content: "\\F01E2"; }

.mdi-dropbox::before {
  content: "\\F01E3"; }

.mdi-drupal::before {
  content: "\\F01E4"; }

.mdi-duck::before {
  content: "\\F01E5"; }

.mdi-dumbbell::before {
  content: "\\F01E6"; }

.mdi-dump-truck::before {
  content: "\\F0C67"; }

.mdi-ear-hearing::before {
  content: "\\F07C5"; }

.mdi-ear-hearing-off::before {
  content: "\\F0A45"; }

.mdi-earbuds::before {
  content: "\\F184F"; }

.mdi-earbuds-off::before {
  content: "\\F1850"; }

.mdi-earbuds-off-outline::before {
  content: "\\F1851"; }

.mdi-earbuds-outline::before {
  content: "\\F1852"; }

.mdi-earth::before {
  content: "\\F01E7"; }

.mdi-earth-arrow-right::before {
  content: "\\F1311"; }

.mdi-earth-box::before {
  content: "\\F06CD"; }

.mdi-earth-box-minus::before {
  content: "\\F1407"; }

.mdi-earth-box-off::before {
  content: "\\F06CE"; }

.mdi-earth-box-plus::before {
  content: "\\F1406"; }

.mdi-earth-box-remove::before {
  content: "\\F1408"; }

.mdi-earth-minus::before {
  content: "\\F1404"; }

.mdi-earth-off::before {
  content: "\\F01E8"; }

.mdi-earth-plus::before {
  content: "\\F1403"; }

.mdi-earth-remove::before {
  content: "\\F1405"; }

.mdi-egg::before {
  content: "\\F0AAF"; }

.mdi-egg-easter::before {
  content: "\\F0AB0"; }

.mdi-egg-fried::before {
  content: "\\F184A"; }

.mdi-egg-off::before {
  content: "\\F13F0"; }

.mdi-egg-off-outline::before {
  content: "\\F13F1"; }

.mdi-egg-outline::before {
  content: "\\F13F2"; }

.mdi-eiffel-tower::before {
  content: "\\F156B"; }

.mdi-eight-track::before {
  content: "\\F09EA"; }

.mdi-eject::before {
  content: "\\F01EA"; }

.mdi-eject-outline::before {
  content: "\\F0B91"; }

.mdi-electric-switch::before {
  content: "\\F0E9F"; }

.mdi-electric-switch-closed::before {
  content: "\\F10D9"; }

.mdi-electron-framework::before {
  content: "\\F1024"; }

.mdi-elephant::before {
  content: "\\F07C6"; }

.mdi-elevation-decline::before {
  content: "\\F01EB"; }

.mdi-elevation-rise::before {
  content: "\\F01EC"; }

.mdi-elevator::before {
  content: "\\F01ED"; }

.mdi-elevator-down::before {
  content: "\\F12C2"; }

.mdi-elevator-passenger::before {
  content: "\\F1381"; }

.mdi-elevator-passenger-off::before {
  content: "\\F1979"; }

.mdi-elevator-passenger-off-outline::before {
  content: "\\F197A"; }

.mdi-elevator-passenger-outline::before {
  content: "\\F197B"; }

.mdi-elevator-up::before {
  content: "\\F12C1"; }

.mdi-ellipse::before {
  content: "\\F0EA0"; }

.mdi-ellipse-outline::before {
  content: "\\F0EA1"; }

.mdi-email::before {
  content: "\\F01EE"; }

.mdi-email-alert::before {
  content: "\\F06CF"; }

.mdi-email-alert-outline::before {
  content: "\\F0D42"; }

.mdi-email-box::before {
  content: "\\F0D03"; }

.mdi-email-check::before {
  content: "\\F0AB1"; }

.mdi-email-check-outline::before {
  content: "\\F0AB2"; }

.mdi-email-edit::before {
  content: "\\F0EE3"; }

.mdi-email-edit-outline::before {
  content: "\\F0EE4"; }

.mdi-email-fast::before {
  content: "\\F186F"; }

.mdi-email-fast-outline::before {
  content: "\\F1870"; }

.mdi-email-lock::before {
  content: "\\F01F1"; }

.mdi-email-mark-as-unread::before {
  content: "\\F0B92"; }

.mdi-email-minus::before {
  content: "\\F0EE5"; }

.mdi-email-minus-outline::before {
  content: "\\F0EE6"; }

.mdi-email-multiple::before {
  content: "\\F0EE7"; }

.mdi-email-multiple-outline::before {
  content: "\\F0EE8"; }

.mdi-email-newsletter::before {
  content: "\\F0FB1"; }

.mdi-email-off::before {
  content: "\\F13E3"; }

.mdi-email-off-outline::before {
  content: "\\F13E4"; }

.mdi-email-open::before {
  content: "\\F01EF"; }

.mdi-email-open-multiple::before {
  content: "\\F0EE9"; }

.mdi-email-open-multiple-outline::before {
  content: "\\F0EEA"; }

.mdi-email-open-outline::before {
  content: "\\F05EF"; }

.mdi-email-outline::before {
  content: "\\F01F0"; }

.mdi-email-plus::before {
  content: "\\F09EB"; }

.mdi-email-plus-outline::before {
  content: "\\F09EC"; }

.mdi-email-receive::before {
  content: "\\F10DA"; }

.mdi-email-receive-outline::before {
  content: "\\F10DB"; }

.mdi-email-remove::before {
  content: "\\F1661"; }

.mdi-email-remove-outline::before {
  content: "\\F1662"; }

.mdi-email-seal::before {
  content: "\\F195B"; }

.mdi-email-seal-outline::before {
  content: "\\F195C"; }

.mdi-email-search::before {
  content: "\\F0961"; }

.mdi-email-search-outline::before {
  content: "\\F0962"; }

.mdi-email-send::before {
  content: "\\F10DC"; }

.mdi-email-send-outline::before {
  content: "\\F10DD"; }

.mdi-email-sync::before {
  content: "\\F12C7"; }

.mdi-email-sync-outline::before {
  content: "\\F12C8"; }

.mdi-email-variant::before {
  content: "\\F05F0"; }

.mdi-ember::before {
  content: "\\F0B30"; }

.mdi-emby::before {
  content: "\\F06B4"; }

.mdi-emoticon::before {
  content: "\\F0C68"; }

.mdi-emoticon-angry::before {
  content: "\\F0C69"; }

.mdi-emoticon-angry-outline::before {
  content: "\\F0C6A"; }

.mdi-emoticon-confused::before {
  content: "\\F10DE"; }

.mdi-emoticon-confused-outline::before {
  content: "\\F10DF"; }

.mdi-emoticon-cool::before {
  content: "\\F0C6B"; }

.mdi-emoticon-cool-outline::before {
  content: "\\F01F3"; }

.mdi-emoticon-cry::before {
  content: "\\F0C6C"; }

.mdi-emoticon-cry-outline::before {
  content: "\\F0C6D"; }

.mdi-emoticon-dead::before {
  content: "\\F0C6E"; }

.mdi-emoticon-dead-outline::before {
  content: "\\F069B"; }

.mdi-emoticon-devil::before {
  content: "\\F0C6F"; }

.mdi-emoticon-devil-outline::before {
  content: "\\F01F4"; }

.mdi-emoticon-excited::before {
  content: "\\F0C70"; }

.mdi-emoticon-excited-outline::before {
  content: "\\F069C"; }

.mdi-emoticon-frown::before {
  content: "\\F0F4C"; }

.mdi-emoticon-frown-outline::before {
  content: "\\F0F4D"; }

.mdi-emoticon-happy::before {
  content: "\\F0C71"; }

.mdi-emoticon-happy-outline::before {
  content: "\\F01F5"; }

.mdi-emoticon-kiss::before {
  content: "\\F0C72"; }

.mdi-emoticon-kiss-outline::before {
  content: "\\F0C73"; }

.mdi-emoticon-lol::before {
  content: "\\F1214"; }

.mdi-emoticon-lol-outline::before {
  content: "\\F1215"; }

.mdi-emoticon-neutral::before {
  content: "\\F0C74"; }

.mdi-emoticon-neutral-outline::before {
  content: "\\F01F6"; }

.mdi-emoticon-outline::before {
  content: "\\F01F2"; }

.mdi-emoticon-poop::before {
  content: "\\F01F7"; }

.mdi-emoticon-poop-outline::before {
  content: "\\F0C75"; }

.mdi-emoticon-sad::before {
  content: "\\F0C76"; }

.mdi-emoticon-sad-outline::before {
  content: "\\F01F8"; }

.mdi-emoticon-sick::before {
  content: "\\F157C"; }

.mdi-emoticon-sick-outline::before {
  content: "\\F157D"; }

.mdi-emoticon-tongue::before {
  content: "\\F01F9"; }

.mdi-emoticon-tongue-outline::before {
  content: "\\F0C77"; }

.mdi-emoticon-wink::before {
  content: "\\F0C78"; }

.mdi-emoticon-wink-outline::before {
  content: "\\F0C79"; }

.mdi-engine::before {
  content: "\\F01FA"; }

.mdi-engine-off::before {
  content: "\\F0A46"; }

.mdi-engine-off-outline::before {
  content: "\\F0A47"; }

.mdi-engine-outline::before {
  content: "\\F01FB"; }

.mdi-epsilon::before {
  content: "\\F10E0"; }

.mdi-equal::before {
  content: "\\F01FC"; }

.mdi-equal-box::before {
  content: "\\F01FD"; }

.mdi-equalizer::before {
  content: "\\F0EA2"; }

.mdi-equalizer-outline::before {
  content: "\\F0EA3"; }

.mdi-eraser::before {
  content: "\\F01FE"; }

.mdi-eraser-variant::before {
  content: "\\F0642"; }

.mdi-escalator::before {
  content: "\\F01FF"; }

.mdi-escalator-box::before {
  content: "\\F1399"; }

.mdi-escalator-down::before {
  content: "\\F12C0"; }

.mdi-escalator-up::before {
  content: "\\F12BF"; }

.mdi-eslint::before {
  content: "\\F0C7A"; }

.mdi-et::before {
  content: "\\F0AB3"; }

.mdi-ethereum::before {
  content: "\\F086A"; }

.mdi-ethernet::before {
  content: "\\F0200"; }

.mdi-ethernet-cable::before {
  content: "\\F0201"; }

.mdi-ethernet-cable-off::before {
  content: "\\F0202"; }

.mdi-ev-plug-ccs1::before {
  content: "\\F1519"; }

.mdi-ev-plug-ccs2::before {
  content: "\\F151A"; }

.mdi-ev-plug-chademo::before {
  content: "\\F151B"; }

.mdi-ev-plug-tesla::before {
  content: "\\F151C"; }

.mdi-ev-plug-type1::before {
  content: "\\F151D"; }

.mdi-ev-plug-type2::before {
  content: "\\F151E"; }

.mdi-ev-station::before {
  content: "\\F05F1"; }

.mdi-evernote::before {
  content: "\\F0204"; }

.mdi-excavator::before {
  content: "\\F1025"; }

.mdi-exclamation::before {
  content: "\\F0205"; }

.mdi-exclamation-thick::before {
  content: "\\F1238"; }

.mdi-exit-run::before {
  content: "\\F0A48"; }

.mdi-exit-to-app::before {
  content: "\\F0206"; }

.mdi-expand-all::before {
  content: "\\F0AB4"; }

.mdi-expand-all-outline::before {
  content: "\\F0AB5"; }

.mdi-expansion-card::before {
  content: "\\F08AE"; }

.mdi-expansion-card-variant::before {
  content: "\\F0FB2"; }

.mdi-exponent::before {
  content: "\\F0963"; }

.mdi-exponent-box::before {
  content: "\\F0964"; }

.mdi-export::before {
  content: "\\F0207"; }

.mdi-export-variant::before {
  content: "\\F0B93"; }

.mdi-eye::before {
  content: "\\F0208"; }

.mdi-eye-arrow-left::before {
  content: "\\F18FD"; }

.mdi-eye-arrow-left-outline::before {
  content: "\\F18FE"; }

.mdi-eye-arrow-right::before {
  content: "\\F18FF"; }

.mdi-eye-arrow-right-outline::before {
  content: "\\F1900"; }

.mdi-eye-check::before {
  content: "\\F0D04"; }

.mdi-eye-check-outline::before {
  content: "\\F0D05"; }

.mdi-eye-circle::before {
  content: "\\F0B94"; }

.mdi-eye-circle-outline::before {
  content: "\\F0B95"; }

.mdi-eye-minus::before {
  content: "\\F1026"; }

.mdi-eye-minus-outline::before {
  content: "\\F1027"; }

.mdi-eye-off::before {
  content: "\\F0209"; }

.mdi-eye-off-outline::before {
  content: "\\F06D1"; }

.mdi-eye-outline::before {
  content: "\\F06D0"; }

.mdi-eye-plus::before {
  content: "\\F086B"; }

.mdi-eye-plus-outline::before {
  content: "\\F086C"; }

.mdi-eye-refresh::before {
  content: "\\F197C"; }

.mdi-eye-refresh-outline::before {
  content: "\\F197D"; }

.mdi-eye-remove::before {
  content: "\\F15E3"; }

.mdi-eye-remove-outline::before {
  content: "\\F15E4"; }

.mdi-eye-settings::before {
  content: "\\F086D"; }

.mdi-eye-settings-outline::before {
  content: "\\F086E"; }

.mdi-eyedropper::before {
  content: "\\F020A"; }

.mdi-eyedropper-minus::before {
  content: "\\F13DD"; }

.mdi-eyedropper-off::before {
  content: "\\F13DF"; }

.mdi-eyedropper-plus::before {
  content: "\\F13DC"; }

.mdi-eyedropper-remove::before {
  content: "\\F13DE"; }

.mdi-eyedropper-variant::before {
  content: "\\F020B"; }

.mdi-face-agent::before {
  content: "\\F0D70"; }

.mdi-face-man::before {
  content: "\\F0643"; }

.mdi-face-man-outline::before {
  content: "\\F0B96"; }

.mdi-face-man-profile::before {
  content: "\\F0644"; }

.mdi-face-man-shimmer::before {
  content: "\\F15CC"; }

.mdi-face-man-shimmer-outline::before {
  content: "\\F15CD"; }

.mdi-face-mask::before {
  content: "\\F1586"; }

.mdi-face-mask-outline::before {
  content: "\\F1587"; }

.mdi-face-recognition::before {
  content: "\\F0C7B"; }

.mdi-face-woman::before {
  content: "\\F1077"; }

.mdi-face-woman-outline::before {
  content: "\\F1078"; }

.mdi-face-woman-profile::before {
  content: "\\F1076"; }

.mdi-face-woman-shimmer::before {
  content: "\\F15CE"; }

.mdi-face-woman-shimmer-outline::before {
  content: "\\F15CF"; }

.mdi-facebook::before {
  content: "\\F020C"; }

.mdi-facebook-gaming::before {
  content: "\\F07DD"; }

.mdi-facebook-messenger::before {
  content: "\\F020E"; }

.mdi-facebook-workplace::before {
  content: "\\F0B31"; }

.mdi-factory::before {
  content: "\\F020F"; }

.mdi-family-tree::before {
  content: "\\F160E"; }

.mdi-fan::before {
  content: "\\F0210"; }

.mdi-fan-alert::before {
  content: "\\F146C"; }

.mdi-fan-auto::before {
  content: "\\F171D"; }

.mdi-fan-chevron-down::before {
  content: "\\F146D"; }

.mdi-fan-chevron-up::before {
  content: "\\F146E"; }

.mdi-fan-minus::before {
  content: "\\F1470"; }

.mdi-fan-off::before {
  content: "\\F081D"; }

.mdi-fan-plus::before {
  content: "\\F146F"; }

.mdi-fan-remove::before {
  content: "\\F1471"; }

.mdi-fan-speed-1::before {
  content: "\\F1472"; }

.mdi-fan-speed-2::before {
  content: "\\F1473"; }

.mdi-fan-speed-3::before {
  content: "\\F1474"; }

.mdi-fast-forward::before {
  content: "\\F0211"; }

.mdi-fast-forward-10::before {
  content: "\\F0D71"; }

.mdi-fast-forward-15::before {
  content: "\\F193A"; }

.mdi-fast-forward-30::before {
  content: "\\F0D06"; }

.mdi-fast-forward-5::before {
  content: "\\F11F8"; }

.mdi-fast-forward-60::before {
  content: "\\F160B"; }

.mdi-fast-forward-outline::before {
  content: "\\F06D2"; }

.mdi-fax::before {
  content: "\\F0212"; }

.mdi-feather::before {
  content: "\\F06D3"; }

.mdi-feature-search::before {
  content: "\\F0A49"; }

.mdi-feature-search-outline::before {
  content: "\\F0A4A"; }

.mdi-fedora::before {
  content: "\\F08DB"; }

.mdi-fence::before {
  content: "\\F179A"; }

.mdi-fence-electric::before {
  content: "\\F17F6"; }

.mdi-fencing::before {
  content: "\\F14C1"; }

.mdi-ferris-wheel::before {
  content: "\\F0EA4"; }

.mdi-ferry::before {
  content: "\\F0213"; }

.mdi-file::before {
  content: "\\F0214"; }

.mdi-file-account::before {
  content: "\\F073B"; }

.mdi-file-account-outline::before {
  content: "\\F1028"; }

.mdi-file-alert::before {
  content: "\\F0A4B"; }

.mdi-file-alert-outline::before {
  content: "\\F0A4C"; }

.mdi-file-cabinet::before {
  content: "\\F0AB6"; }

.mdi-file-cad::before {
  content: "\\F0EEB"; }

.mdi-file-cad-box::before {
  content: "\\F0EEC"; }

.mdi-file-cancel::before {
  content: "\\F0DC6"; }

.mdi-file-cancel-outline::before {
  content: "\\F0DC7"; }

.mdi-file-certificate::before {
  content: "\\F1186"; }

.mdi-file-certificate-outline::before {
  content: "\\F1187"; }

.mdi-file-chart::before {
  content: "\\F0215"; }

.mdi-file-chart-outline::before {
  content: "\\F1029"; }

.mdi-file-check::before {
  content: "\\F0216"; }

.mdi-file-check-outline::before {
  content: "\\F0E29"; }

.mdi-file-clock::before {
  content: "\\F12E1"; }

.mdi-file-clock-outline::before {
  content: "\\F12E2"; }

.mdi-file-cloud::before {
  content: "\\F0217"; }

.mdi-file-cloud-outline::before {
  content: "\\F102A"; }

.mdi-file-code::before {
  content: "\\F022E"; }

.mdi-file-code-outline::before {
  content: "\\F102B"; }

.mdi-file-cog::before {
  content: "\\F107B"; }

.mdi-file-cog-outline::before {
  content: "\\F107C"; }

.mdi-file-compare::before {
  content: "\\F08AA"; }

.mdi-file-delimited::before {
  content: "\\F0218"; }

.mdi-file-delimited-outline::before {
  content: "\\F0EA5"; }

.mdi-file-document::before {
  content: "\\F0219"; }

.mdi-file-document-edit::before {
  content: "\\F0DC8"; }

.mdi-file-document-edit-outline::before {
  content: "\\F0DC9"; }

.mdi-file-document-multiple::before {
  content: "\\F1517"; }

.mdi-file-document-multiple-outline::before {
  content: "\\F1518"; }

.mdi-file-document-outline::before {
  content: "\\F09EE"; }

.mdi-file-download::before {
  content: "\\F0965"; }

.mdi-file-download-outline::before {
  content: "\\F0966"; }

.mdi-file-edit::before {
  content: "\\F11E7"; }

.mdi-file-edit-outline::before {
  content: "\\F11E8"; }

.mdi-file-excel::before {
  content: "\\F021B"; }

.mdi-file-excel-box::before {
  content: "\\F021C"; }

.mdi-file-excel-box-outline::before {
  content: "\\F102C"; }

.mdi-file-excel-outline::before {
  content: "\\F102D"; }

.mdi-file-export::before {
  content: "\\F021D"; }

.mdi-file-export-outline::before {
  content: "\\F102E"; }

.mdi-file-eye::before {
  content: "\\F0DCA"; }

.mdi-file-eye-outline::before {
  content: "\\F0DCB"; }

.mdi-file-find::before {
  content: "\\F021E"; }

.mdi-file-find-outline::before {
  content: "\\F0B97"; }

.mdi-file-gif-box::before {
  content: "\\F0D78"; }

.mdi-file-hidden::before {
  content: "\\F0613"; }

.mdi-file-image::before {
  content: "\\F021F"; }

.mdi-file-image-marker::before {
  content: "\\F1772"; }

.mdi-file-image-marker-outline::before {
  content: "\\F1773"; }

.mdi-file-image-minus::before {
  content: "\\F193B"; }

.mdi-file-image-minus-outline::before {
  content: "\\F193C"; }

.mdi-file-image-outline::before {
  content: "\\F0EB0"; }

.mdi-file-image-plus::before {
  content: "\\F193D"; }

.mdi-file-image-plus-outline::before {
  content: "\\F193E"; }

.mdi-file-image-remove::before {
  content: "\\F193F"; }

.mdi-file-image-remove-outline::before {
  content: "\\F1940"; }

.mdi-file-import::before {
  content: "\\F0220"; }

.mdi-file-import-outline::before {
  content: "\\F102F"; }

.mdi-file-jpg-box::before {
  content: "\\F0225"; }

.mdi-file-key::before {
  content: "\\F1184"; }

.mdi-file-key-outline::before {
  content: "\\F1185"; }

.mdi-file-link::before {
  content: "\\F1177"; }

.mdi-file-link-outline::before {
  content: "\\F1178"; }

.mdi-file-lock::before {
  content: "\\F0221"; }

.mdi-file-lock-outline::before {
  content: "\\F1030"; }

.mdi-file-marker::before {
  content: "\\F1774"; }

.mdi-file-marker-outline::before {
  content: "\\F1775"; }

.mdi-file-move::before {
  content: "\\F0AB9"; }

.mdi-file-move-outline::before {
  content: "\\F1031"; }

.mdi-file-multiple::before {
  content: "\\F0222"; }

.mdi-file-multiple-outline::before {
  content: "\\F1032"; }

.mdi-file-music::before {
  content: "\\F0223"; }

.mdi-file-music-outline::before {
  content: "\\F0E2A"; }

.mdi-file-outline::before {
  content: "\\F0224"; }

.mdi-file-pdf-box::before {
  content: "\\F0226"; }

.mdi-file-percent::before {
  content: "\\F081E"; }

.mdi-file-percent-outline::before {
  content: "\\F1033"; }

.mdi-file-phone::before {
  content: "\\F1179"; }

.mdi-file-phone-outline::before {
  content: "\\F117A"; }

.mdi-file-plus::before {
  content: "\\F0752"; }

.mdi-file-plus-outline::before {
  content: "\\F0EED"; }

.mdi-file-png-box::before {
  content: "\\F0E2D"; }

.mdi-file-powerpoint::before {
  content: "\\F0227"; }

.mdi-file-powerpoint-box::before {
  content: "\\F0228"; }

.mdi-file-powerpoint-box-outline::before {
  content: "\\F1034"; }

.mdi-file-powerpoint-outline::before {
  content: "\\F1035"; }

.mdi-file-presentation-box::before {
  content: "\\F0229"; }

.mdi-file-question::before {
  content: "\\F086F"; }

.mdi-file-question-outline::before {
  content: "\\F1036"; }

.mdi-file-refresh::before {
  content: "\\F0918"; }

.mdi-file-refresh-outline::before {
  content: "\\F0541"; }

.mdi-file-remove::before {
  content: "\\F0B98"; }

.mdi-file-remove-outline::before {
  content: "\\F1037"; }

.mdi-file-replace::before {
  content: "\\F0B32"; }

.mdi-file-replace-outline::before {
  content: "\\F0B33"; }

.mdi-file-restore::before {
  content: "\\F0670"; }

.mdi-file-restore-outline::before {
  content: "\\F1038"; }

.mdi-file-search::before {
  content: "\\F0C7C"; }

.mdi-file-search-outline::before {
  content: "\\F0C7D"; }

.mdi-file-send::before {
  content: "\\F022A"; }

.mdi-file-send-outline::before {
  content: "\\F1039"; }

.mdi-file-settings::before {
  content: "\\F1079"; }

.mdi-file-settings-outline::before {
  content: "\\F107A"; }

.mdi-file-sign::before {
  content: "\\F19C3"; }

.mdi-file-star::before {
  content: "\\F103A"; }

.mdi-file-star-outline::before {
  content: "\\F103B"; }

.mdi-file-swap::before {
  content: "\\F0FB4"; }

.mdi-file-swap-outline::before {
  content: "\\F0FB5"; }

.mdi-file-sync::before {
  content: "\\F1216"; }

.mdi-file-sync-outline::before {
  content: "\\F1217"; }

.mdi-file-table::before {
  content: "\\F0C7E"; }

.mdi-file-table-box::before {
  content: "\\F10E1"; }

.mdi-file-table-box-multiple::before {
  content: "\\F10E2"; }

.mdi-file-table-box-multiple-outline::before {
  content: "\\F10E3"; }

.mdi-file-table-box-outline::before {
  content: "\\F10E4"; }

.mdi-file-table-outline::before {
  content: "\\F0C7F"; }

.mdi-file-tree::before {
  content: "\\F0645"; }

.mdi-file-tree-outline::before {
  content: "\\F13D2"; }

.mdi-file-undo::before {
  content: "\\F08DC"; }

.mdi-file-undo-outline::before {
  content: "\\F103C"; }

.mdi-file-upload::before {
  content: "\\F0A4D"; }

.mdi-file-upload-outline::before {
  content: "\\F0A4E"; }

.mdi-file-video::before {
  content: "\\F022B"; }

.mdi-file-video-outline::before {
  content: "\\F0E2C"; }

.mdi-file-word::before {
  content: "\\F022C"; }

.mdi-file-word-box::before {
  content: "\\F022D"; }

.mdi-file-word-box-outline::before {
  content: "\\F103D"; }

.mdi-file-word-outline::before {
  content: "\\F103E"; }

.mdi-film::before {
  content: "\\F022F"; }

.mdi-filmstrip::before {
  content: "\\F0230"; }

.mdi-filmstrip-box::before {
  content: "\\F0332"; }

.mdi-filmstrip-box-multiple::before {
  content: "\\F0D18"; }

.mdi-filmstrip-off::before {
  content: "\\F0231"; }

.mdi-filter::before {
  content: "\\F0232"; }

.mdi-filter-check::before {
  content: "\\F18EC"; }

.mdi-filter-check-outline::before {
  content: "\\F18ED"; }

.mdi-filter-menu::before {
  content: "\\F10E5"; }

.mdi-filter-menu-outline::before {
  content: "\\F10E6"; }

.mdi-filter-minus::before {
  content: "\\F0EEE"; }

.mdi-filter-minus-outline::before {
  content: "\\F0EEF"; }

.mdi-filter-off::before {
  content: "\\F14EF"; }

.mdi-filter-off-outline::before {
  content: "\\F14F0"; }

.mdi-filter-outline::before {
  content: "\\F0233"; }

.mdi-filter-plus::before {
  content: "\\F0EF0"; }

.mdi-filter-plus-outline::before {
  content: "\\F0EF1"; }

.mdi-filter-remove::before {
  content: "\\F0234"; }

.mdi-filter-remove-outline::before {
  content: "\\F0235"; }

.mdi-filter-variant::before {
  content: "\\F0236"; }

.mdi-filter-variant-minus::before {
  content: "\\F1112"; }

.mdi-filter-variant-plus::before {
  content: "\\F1113"; }

.mdi-filter-variant-remove::before {
  content: "\\F103F"; }

.mdi-finance::before {
  content: "\\F081F"; }

.mdi-find-replace::before {
  content: "\\F06D4"; }

.mdi-fingerprint::before {
  content: "\\F0237"; }

.mdi-fingerprint-off::before {
  content: "\\F0EB1"; }

.mdi-fire::before {
  content: "\\F0238"; }

.mdi-fire-alert::before {
  content: "\\F15D7"; }

.mdi-fire-circle::before {
  content: "\\F1807"; }

.mdi-fire-extinguisher::before {
  content: "\\F0EF2"; }

.mdi-fire-hydrant::before {
  content: "\\F1137"; }

.mdi-fire-hydrant-alert::before {
  content: "\\F1138"; }

.mdi-fire-hydrant-off::before {
  content: "\\F1139"; }

.mdi-fire-off::before {
  content: "\\F1722"; }

.mdi-fire-truck::before {
  content: "\\F08AB"; }

.mdi-firebase::before {
  content: "\\F0967"; }

.mdi-firefox::before {
  content: "\\F0239"; }

.mdi-fireplace::before {
  content: "\\F0E2E"; }

.mdi-fireplace-off::before {
  content: "\\F0E2F"; }

.mdi-firewire::before {
  content: "\\F05BE"; }

.mdi-firework::before {
  content: "\\F0E30"; }

.mdi-firework-off::before {
  content: "\\F1723"; }

.mdi-fish::before {
  content: "\\F023A"; }

.mdi-fish-off::before {
  content: "\\F13F3"; }

.mdi-fishbowl::before {
  content: "\\F0EF3"; }

.mdi-fishbowl-outline::before {
  content: "\\F0EF4"; }

.mdi-fit-to-page::before {
  content: "\\F0EF5"; }

.mdi-fit-to-page-outline::before {
  content: "\\F0EF6"; }

.mdi-fit-to-screen::before {
  content: "\\F18F4"; }

.mdi-fit-to-screen-outline::before {
  content: "\\F18F5"; }

.mdi-flag::before {
  content: "\\F023B"; }

.mdi-flag-checkered::before {
  content: "\\F023C"; }

.mdi-flag-minus::before {
  content: "\\F0B99"; }

.mdi-flag-minus-outline::before {
  content: "\\F10B2"; }

.mdi-flag-off::before {
  content: "\\F18EE"; }

.mdi-flag-off-outline::before {
  content: "\\F18EF"; }

.mdi-flag-outline::before {
  content: "\\F023D"; }

.mdi-flag-plus::before {
  content: "\\F0B9A"; }

.mdi-flag-plus-outline::before {
  content: "\\F10B3"; }

.mdi-flag-remove::before {
  content: "\\F0B9B"; }

.mdi-flag-remove-outline::before {
  content: "\\F10B4"; }

.mdi-flag-triangle::before {
  content: "\\F023F"; }

.mdi-flag-variant::before {
  content: "\\F0240"; }

.mdi-flag-variant-outline::before {
  content: "\\F023E"; }

.mdi-flare::before {
  content: "\\F0D72"; }

.mdi-flash::before {
  content: "\\F0241"; }

.mdi-flash-alert::before {
  content: "\\F0EF7"; }

.mdi-flash-alert-outline::before {
  content: "\\F0EF8"; }

.mdi-flash-auto::before {
  content: "\\F0242"; }

.mdi-flash-off::before {
  content: "\\F0243"; }

.mdi-flash-outline::before {
  content: "\\F06D5"; }

.mdi-flash-red-eye::before {
  content: "\\F067B"; }

.mdi-flashlight::before {
  content: "\\F0244"; }

.mdi-flashlight-off::before {
  content: "\\F0245"; }

.mdi-flask::before {
  content: "\\F0093"; }

.mdi-flask-empty::before {
  content: "\\F0094"; }

.mdi-flask-empty-minus::before {
  content: "\\F123A"; }

.mdi-flask-empty-minus-outline::before {
  content: "\\F123B"; }

.mdi-flask-empty-off::before {
  content: "\\F13F4"; }

.mdi-flask-empty-off-outline::before {
  content: "\\F13F5"; }

.mdi-flask-empty-outline::before {
  content: "\\F0095"; }

.mdi-flask-empty-plus::before {
  content: "\\F123C"; }

.mdi-flask-empty-plus-outline::before {
  content: "\\F123D"; }

.mdi-flask-empty-remove::before {
  content: "\\F123E"; }

.mdi-flask-empty-remove-outline::before {
  content: "\\F123F"; }

.mdi-flask-minus::before {
  content: "\\F1240"; }

.mdi-flask-minus-outline::before {
  content: "\\F1241"; }

.mdi-flask-off::before {
  content: "\\F13F6"; }

.mdi-flask-off-outline::before {
  content: "\\F13F7"; }

.mdi-flask-outline::before {
  content: "\\F0096"; }

.mdi-flask-plus::before {
  content: "\\F1242"; }

.mdi-flask-plus-outline::before {
  content: "\\F1243"; }

.mdi-flask-remove::before {
  content: "\\F1244"; }

.mdi-flask-remove-outline::before {
  content: "\\F1245"; }

.mdi-flask-round-bottom::before {
  content: "\\F124B"; }

.mdi-flask-round-bottom-empty::before {
  content: "\\F124C"; }

.mdi-flask-round-bottom-empty-outline::before {
  content: "\\F124D"; }

.mdi-flask-round-bottom-outline::before {
  content: "\\F124E"; }

.mdi-fleur-de-lis::before {
  content: "\\F1303"; }

.mdi-flip-horizontal::before {
  content: "\\F10E7"; }

.mdi-flip-to-back::before {
  content: "\\F0247"; }

.mdi-flip-to-front::before {
  content: "\\F0248"; }

.mdi-flip-vertical::before {
  content: "\\F10E8"; }

.mdi-floor-lamp::before {
  content: "\\F08DD"; }

.mdi-floor-lamp-dual::before {
  content: "\\F1040"; }

.mdi-floor-lamp-dual-outline::before {
  content: "\\F17CE"; }

.mdi-floor-lamp-outline::before {
  content: "\\F17C8"; }

.mdi-floor-lamp-torchiere::before {
  content: "\\F1747"; }

.mdi-floor-lamp-torchiere-outline::before {
  content: "\\F17D6"; }

.mdi-floor-lamp-torchiere-variant::before {
  content: "\\F1041"; }

.mdi-floor-lamp-torchiere-variant-outline::before {
  content: "\\F17CF"; }

.mdi-floor-plan::before {
  content: "\\F0821"; }

.mdi-floppy::before {
  content: "\\F0249"; }

.mdi-floppy-variant::before {
  content: "\\F09EF"; }

.mdi-flower::before {
  content: "\\F024A"; }

.mdi-flower-outline::before {
  content: "\\F09F0"; }

.mdi-flower-pollen::before {
  content: "\\F1885"; }

.mdi-flower-pollen-outline::before {
  content: "\\F1886"; }

.mdi-flower-poppy::before {
  content: "\\F0D08"; }

.mdi-flower-tulip::before {
  content: "\\F09F1"; }

.mdi-flower-tulip-outline::before {
  content: "\\F09F2"; }

.mdi-focus-auto::before {
  content: "\\F0F4E"; }

.mdi-focus-field::before {
  content: "\\F0F4F"; }

.mdi-focus-field-horizontal::before {
  content: "\\F0F50"; }

.mdi-focus-field-vertical::before {
  content: "\\F0F51"; }

.mdi-folder::before {
  content: "\\F024B"; }

.mdi-folder-account::before {
  content: "\\F024C"; }

.mdi-folder-account-outline::before {
  content: "\\F0B9C"; }

.mdi-folder-alert::before {
  content: "\\F0DCC"; }

.mdi-folder-alert-outline::before {
  content: "\\F0DCD"; }

.mdi-folder-check::before {
  content: "\\F197E"; }

.mdi-folder-check-outline::before {
  content: "\\F197F"; }

.mdi-folder-clock::before {
  content: "\\F0ABA"; }

.mdi-folder-clock-outline::before {
  content: "\\F0ABB"; }

.mdi-folder-cog::before {
  content: "\\F107F"; }

.mdi-folder-cog-outline::before {
  content: "\\F1080"; }

.mdi-folder-download::before {
  content: "\\F024D"; }

.mdi-folder-download-outline::before {
  content: "\\F10E9"; }

.mdi-folder-edit::before {
  content: "\\F08DE"; }

.mdi-folder-edit-outline::before {
  content: "\\F0DCE"; }

.mdi-folder-eye::before {
  content: "\\F178A"; }

.mdi-folder-eye-outline::before {
  content: "\\F178B"; }

.mdi-folder-google-drive::before {
  content: "\\F024E"; }

.mdi-folder-heart::before {
  content: "\\F10EA"; }

.mdi-folder-heart-outline::before {
  content: "\\F10EB"; }

.mdi-folder-hidden::before {
  content: "\\F179E"; }

.mdi-folder-home::before {
  content: "\\F10B5"; }

.mdi-folder-home-outline::before {
  content: "\\F10B6"; }

.mdi-folder-image::before {
  content: "\\F024F"; }

.mdi-folder-information::before {
  content: "\\F10B7"; }

.mdi-folder-information-outline::before {
  content: "\\F10B8"; }

.mdi-folder-key::before {
  content: "\\F08AC"; }

.mdi-folder-key-network::before {
  content: "\\F08AD"; }

.mdi-folder-key-network-outline::before {
  content: "\\F0C80"; }

.mdi-folder-key-outline::before {
  content: "\\F10EC"; }

.mdi-folder-lock::before {
  content: "\\F0250"; }

.mdi-folder-lock-open::before {
  content: "\\F0251"; }

.mdi-folder-marker::before {
  content: "\\F126D"; }

.mdi-folder-marker-outline::before {
  content: "\\F126E"; }

.mdi-folder-move::before {
  content: "\\F0252"; }

.mdi-folder-move-outline::before {
  content: "\\F1246"; }

.mdi-folder-multiple::before {
  content: "\\F0253"; }

.mdi-folder-multiple-image::before {
  content: "\\F0254"; }

.mdi-folder-multiple-outline::before {
  content: "\\F0255"; }

.mdi-folder-multiple-plus::before {
  content: "\\F147E"; }

.mdi-folder-multiple-plus-outline::before {
  content: "\\F147F"; }

.mdi-folder-music::before {
  content: "\\F1359"; }

.mdi-folder-music-outline::before {
  content: "\\F135A"; }

.mdi-folder-network::before {
  content: "\\F0870"; }

.mdi-folder-network-outline::before {
  content: "\\F0C81"; }

.mdi-folder-open::before {
  content: "\\F0770"; }

.mdi-folder-open-outline::before {
  content: "\\F0DCF"; }

.mdi-folder-outline::before {
  content: "\\F0256"; }

.mdi-folder-plus::before {
  content: "\\F0257"; }

.mdi-folder-plus-outline::before {
  content: "\\F0B9D"; }

.mdi-folder-pound::before {
  content: "\\F0D09"; }

.mdi-folder-pound-outline::before {
  content: "\\F0D0A"; }

.mdi-folder-refresh::before {
  content: "\\F0749"; }

.mdi-folder-refresh-outline::before {
  content: "\\F0542"; }

.mdi-folder-remove::before {
  content: "\\F0258"; }

.mdi-folder-remove-outline::before {
  content: "\\F0B9E"; }

.mdi-folder-search::before {
  content: "\\F0968"; }

.mdi-folder-search-outline::before {
  content: "\\F0969"; }

.mdi-folder-settings::before {
  content: "\\F107D"; }

.mdi-folder-settings-outline::before {
  content: "\\F107E"; }

.mdi-folder-star::before {
  content: "\\F069D"; }

.mdi-folder-star-multiple::before {
  content: "\\F13D3"; }

.mdi-folder-star-multiple-outline::before {
  content: "\\F13D4"; }

.mdi-folder-star-outline::before {
  content: "\\F0B9F"; }

.mdi-folder-swap::before {
  content: "\\F0FB6"; }

.mdi-folder-swap-outline::before {
  content: "\\F0FB7"; }

.mdi-folder-sync::before {
  content: "\\F0D0B"; }

.mdi-folder-sync-outline::before {
  content: "\\F0D0C"; }

.mdi-folder-table::before {
  content: "\\F12E3"; }

.mdi-folder-table-outline::before {
  content: "\\F12E4"; }

.mdi-folder-text::before {
  content: "\\F0C82"; }

.mdi-folder-text-outline::before {
  content: "\\F0C83"; }

.mdi-folder-upload::before {
  content: "\\F0259"; }

.mdi-folder-upload-outline::before {
  content: "\\F10ED"; }

.mdi-folder-zip::before {
  content: "\\F06EB"; }

.mdi-folder-zip-outline::before {
  content: "\\F07B9"; }

.mdi-font-awesome::before {
  content: "\\F003A"; }

.mdi-food::before {
  content: "\\F025A"; }

.mdi-food-apple::before {
  content: "\\F025B"; }

.mdi-food-apple-outline::before {
  content: "\\F0C84"; }

.mdi-food-croissant::before {
  content: "\\F07C8"; }

.mdi-food-drumstick::before {
  content: "\\F141F"; }

.mdi-food-drumstick-off::before {
  content: "\\F1468"; }

.mdi-food-drumstick-off-outline::before {
  content: "\\F1469"; }

.mdi-food-drumstick-outline::before {
  content: "\\F1420"; }

.mdi-food-fork-drink::before {
  content: "\\F05F2"; }

.mdi-food-halal::before {
  content: "\\F1572"; }

.mdi-food-hot-dog::before {
  content: "\\F184B"; }

.mdi-food-kosher::before {
  content: "\\F1573"; }

.mdi-food-off::before {
  content: "\\F05F3"; }

.mdi-food-off-outline::before {
  content: "\\F1915"; }

.mdi-food-outline::before {
  content: "\\F1916"; }

.mdi-food-steak::before {
  content: "\\F146A"; }

.mdi-food-steak-off::before {
  content: "\\F146B"; }

.mdi-food-takeout-box::before {
  content: "\\F1836"; }

.mdi-food-takeout-box-outline::before {
  content: "\\F1837"; }

.mdi-food-turkey::before {
  content: "\\F171C"; }

.mdi-food-variant::before {
  content: "\\F025C"; }

.mdi-food-variant-off::before {
  content: "\\F13E5"; }

.mdi-foot-print::before {
  content: "\\F0F52"; }

.mdi-football::before {
  content: "\\F025D"; }

.mdi-football-australian::before {
  content: "\\F025E"; }

.mdi-football-helmet::before {
  content: "\\F025F"; }

.mdi-forest::before {
  content: "\\F1897"; }

.mdi-forklift::before {
  content: "\\F07C9"; }

.mdi-form-dropdown::before {
  content: "\\F1400"; }

.mdi-form-select::before {
  content: "\\F1401"; }

.mdi-form-textarea::before {
  content: "\\F1095"; }

.mdi-form-textbox::before {
  content: "\\F060E"; }

.mdi-form-textbox-lock::before {
  content: "\\F135D"; }

.mdi-form-textbox-password::before {
  content: "\\F07F5"; }

.mdi-format-align-bottom::before {
  content: "\\F0753"; }

.mdi-format-align-center::before {
  content: "\\F0260"; }

.mdi-format-align-justify::before {
  content: "\\F0261"; }

.mdi-format-align-left::before {
  content: "\\F0262"; }

.mdi-format-align-middle::before {
  content: "\\F0754"; }

.mdi-format-align-right::before {
  content: "\\F0263"; }

.mdi-format-align-top::before {
  content: "\\F0755"; }

.mdi-format-annotation-minus::before {
  content: "\\F0ABC"; }

.mdi-format-annotation-plus::before {
  content: "\\F0646"; }

.mdi-format-bold::before {
  content: "\\F0264"; }

.mdi-format-clear::before {
  content: "\\F0265"; }

.mdi-format-color-fill::before {
  content: "\\F0266"; }

.mdi-format-color-highlight::before {
  content: "\\F0E31"; }

.mdi-format-color-marker-cancel::before {
  content: "\\F1313"; }

.mdi-format-color-text::before {
  content: "\\F069E"; }

.mdi-format-columns::before {
  content: "\\F08DF"; }

.mdi-format-float-center::before {
  content: "\\F0267"; }

.mdi-format-float-left::before {
  content: "\\F0268"; }

.mdi-format-float-none::before {
  content: "\\F0269"; }

.mdi-format-float-right::before {
  content: "\\F026A"; }

.mdi-format-font::before {
  content: "\\F06D6"; }

.mdi-format-font-size-decrease::before {
  content: "\\F09F3"; }

.mdi-format-font-size-increase::before {
  content: "\\F09F4"; }

.mdi-format-header-1::before {
  content: "\\F026B"; }

.mdi-format-header-2::before {
  content: "\\F026C"; }

.mdi-format-header-3::before {
  content: "\\F026D"; }

.mdi-format-header-4::before {
  content: "\\F026E"; }

.mdi-format-header-5::before {
  content: "\\F026F"; }

.mdi-format-header-6::before {
  content: "\\F0270"; }

.mdi-format-header-decrease::before {
  content: "\\F0271"; }

.mdi-format-header-equal::before {
  content: "\\F0272"; }

.mdi-format-header-increase::before {
  content: "\\F0273"; }

.mdi-format-header-pound::before {
  content: "\\F0274"; }

.mdi-format-horizontal-align-center::before {
  content: "\\F061E"; }

.mdi-format-horizontal-align-left::before {
  content: "\\F061F"; }

.mdi-format-horizontal-align-right::before {
  content: "\\F0620"; }

.mdi-format-indent-decrease::before {
  content: "\\F0275"; }

.mdi-format-indent-increase::before {
  content: "\\F0276"; }

.mdi-format-italic::before {
  content: "\\F0277"; }

.mdi-format-letter-case::before {
  content: "\\F0B34"; }

.mdi-format-letter-case-lower::before {
  content: "\\F0B35"; }

.mdi-format-letter-case-upper::before {
  content: "\\F0B36"; }

.mdi-format-letter-ends-with::before {
  content: "\\F0FB8"; }

.mdi-format-letter-matches::before {
  content: "\\F0FB9"; }

.mdi-format-letter-spacing::before {
  content: "\\F1956"; }

.mdi-format-letter-starts-with::before {
  content: "\\F0FBA"; }

.mdi-format-line-spacing::before {
  content: "\\F0278"; }

.mdi-format-line-style::before {
  content: "\\F05C8"; }

.mdi-format-line-weight::before {
  content: "\\F05C9"; }

.mdi-format-list-bulleted::before {
  content: "\\F0279"; }

.mdi-format-list-bulleted-square::before {
  content: "\\F0DD0"; }

.mdi-format-list-bulleted-triangle::before {
  content: "\\F0EB2"; }

.mdi-format-list-bulleted-type::before {
  content: "\\F027A"; }

.mdi-format-list-checkbox::before {
  content: "\\F096A"; }

.mdi-format-list-checks::before {
  content: "\\F0756"; }

.mdi-format-list-group::before {
  content: "\\F1860"; }

.mdi-format-list-numbered::before {
  content: "\\F027B"; }

.mdi-format-list-numbered-rtl::before {
  content: "\\F0D0D"; }

.mdi-format-list-text::before {
  content: "\\F126F"; }

.mdi-format-overline::before {
  content: "\\F0EB3"; }

.mdi-format-page-break::before {
  content: "\\F06D7"; }

.mdi-format-page-split::before {
  content: "\\F1917"; }

.mdi-format-paint::before {
  content: "\\F027C"; }

.mdi-format-paragraph::before {
  content: "\\F027D"; }

.mdi-format-pilcrow::before {
  content: "\\F06D8"; }

.mdi-format-quote-close::before {
  content: "\\F027E"; }

.mdi-format-quote-close-outline::before {
  content: "\\F11A8"; }

.mdi-format-quote-open::before {
  content: "\\F0757"; }

.mdi-format-quote-open-outline::before {
  content: "\\F11A7"; }

.mdi-format-rotate-90::before {
  content: "\\F06AA"; }

.mdi-format-section::before {
  content: "\\F069F"; }

.mdi-format-size::before {
  content: "\\F027F"; }

.mdi-format-strikethrough::before {
  content: "\\F0280"; }

.mdi-format-strikethrough-variant::before {
  content: "\\F0281"; }

.mdi-format-subscript::before {
  content: "\\F0282"; }

.mdi-format-superscript::before {
  content: "\\F0283"; }

.mdi-format-text::before {
  content: "\\F0284"; }

.mdi-format-text-rotation-angle-down::before {
  content: "\\F0FBB"; }

.mdi-format-text-rotation-angle-up::before {
  content: "\\F0FBC"; }

.mdi-format-text-rotation-down::before {
  content: "\\F0D73"; }

.mdi-format-text-rotation-down-vertical::before {
  content: "\\F0FBD"; }

.mdi-format-text-rotation-none::before {
  content: "\\F0D74"; }

.mdi-format-text-rotation-up::before {
  content: "\\F0FBE"; }

.mdi-format-text-rotation-vertical::before {
  content: "\\F0FBF"; }

.mdi-format-text-variant::before {
  content: "\\F0E32"; }

.mdi-format-text-variant-outline::before {
  content: "\\F150F"; }

.mdi-format-text-wrapping-clip::before {
  content: "\\F0D0E"; }

.mdi-format-text-wrapping-overflow::before {
  content: "\\F0D0F"; }

.mdi-format-text-wrapping-wrap::before {
  content: "\\F0D10"; }

.mdi-format-textbox::before {
  content: "\\F0D11"; }

.mdi-format-textdirection-l-to-r::before {
  content: "\\F0285"; }

.mdi-format-textdirection-r-to-l::before {
  content: "\\F0286"; }

.mdi-format-title::before {
  content: "\\F05F4"; }

.mdi-format-underline::before {
  content: "\\F0287"; }

.mdi-format-underline-wavy::before {
  content: "\\F18E9"; }

.mdi-format-vertical-align-bottom::before {
  content: "\\F0621"; }

.mdi-format-vertical-align-center::before {
  content: "\\F0622"; }

.mdi-format-vertical-align-top::before {
  content: "\\F0623"; }

.mdi-format-wrap-inline::before {
  content: "\\F0288"; }

.mdi-format-wrap-square::before {
  content: "\\F0289"; }

.mdi-format-wrap-tight::before {
  content: "\\F028A"; }

.mdi-format-wrap-top-bottom::before {
  content: "\\F028B"; }

.mdi-forum::before {
  content: "\\F028C"; }

.mdi-forum-outline::before {
  content: "\\F0822"; }

.mdi-forward::before {
  content: "\\F028D"; }

.mdi-forwardburger::before {
  content: "\\F0D75"; }

.mdi-fountain::before {
  content: "\\F096B"; }

.mdi-fountain-pen::before {
  content: "\\F0D12"; }

.mdi-fountain-pen-tip::before {
  content: "\\F0D13"; }

.mdi-fraction-one-half::before {
  content: "\\F1992"; }

.mdi-freebsd::before {
  content: "\\F08E0"; }

.mdi-french-fries::before {
  content: "\\F1957"; }

.mdi-frequently-asked-questions::before {
  content: "\\F0EB4"; }

.mdi-fridge::before {
  content: "\\F0290"; }

.mdi-fridge-alert::before {
  content: "\\F11B1"; }

.mdi-fridge-alert-outline::before {
  content: "\\F11B2"; }

.mdi-fridge-bottom::before {
  content: "\\F0292"; }

.mdi-fridge-industrial::before {
  content: "\\F15EE"; }

.mdi-fridge-industrial-alert::before {
  content: "\\F15EF"; }

.mdi-fridge-industrial-alert-outline::before {
  content: "\\F15F0"; }

.mdi-fridge-industrial-off::before {
  content: "\\F15F1"; }

.mdi-fridge-industrial-off-outline::before {
  content: "\\F15F2"; }

.mdi-fridge-industrial-outline::before {
  content: "\\F15F3"; }

.mdi-fridge-off::before {
  content: "\\F11AF"; }

.mdi-fridge-off-outline::before {
  content: "\\F11B0"; }

.mdi-fridge-outline::before {
  content: "\\F028F"; }

.mdi-fridge-top::before {
  content: "\\F0291"; }

.mdi-fridge-variant::before {
  content: "\\F15F4"; }

.mdi-fridge-variant-alert::before {
  content: "\\F15F5"; }

.mdi-fridge-variant-alert-outline::before {
  content: "\\F15F6"; }

.mdi-fridge-variant-off::before {
  content: "\\F15F7"; }

.mdi-fridge-variant-off-outline::before {
  content: "\\F15F8"; }

.mdi-fridge-variant-outline::before {
  content: "\\F15F9"; }

.mdi-fruit-cherries::before {
  content: "\\F1042"; }

.mdi-fruit-cherries-off::before {
  content: "\\F13F8"; }

.mdi-fruit-citrus::before {
  content: "\\F1043"; }

.mdi-fruit-citrus-off::before {
  content: "\\F13F9"; }

.mdi-fruit-grapes::before {
  content: "\\F1044"; }

.mdi-fruit-grapes-outline::before {
  content: "\\F1045"; }

.mdi-fruit-pineapple::before {
  content: "\\F1046"; }

.mdi-fruit-watermelon::before {
  content: "\\F1047"; }

.mdi-fuel::before {
  content: "\\F07CA"; }

.mdi-fuel-cell::before {
  content: "\\F18B5"; }

.mdi-fullscreen::before {
  content: "\\F0293"; }

.mdi-fullscreen-exit::before {
  content: "\\F0294"; }

.mdi-function::before {
  content: "\\F0295"; }

.mdi-function-variant::before {
  content: "\\F0871"; }

.mdi-furigana-horizontal::before {
  content: "\\F1081"; }

.mdi-furigana-vertical::before {
  content: "\\F1082"; }

.mdi-fuse::before {
  content: "\\F0C85"; }

.mdi-fuse-alert::before {
  content: "\\F142D"; }

.mdi-fuse-blade::before {
  content: "\\F0C86"; }

.mdi-fuse-off::before {
  content: "\\F142C"; }

.mdi-gamepad::before {
  content: "\\F0296"; }

.mdi-gamepad-circle::before {
  content: "\\F0E33"; }

.mdi-gamepad-circle-down::before {
  content: "\\F0E34"; }

.mdi-gamepad-circle-left::before {
  content: "\\F0E35"; }

.mdi-gamepad-circle-outline::before {
  content: "\\F0E36"; }

.mdi-gamepad-circle-right::before {
  content: "\\F0E37"; }

.mdi-gamepad-circle-up::before {
  content: "\\F0E38"; }

.mdi-gamepad-down::before {
  content: "\\F0E39"; }

.mdi-gamepad-left::before {
  content: "\\F0E3A"; }

.mdi-gamepad-outline::before {
  content: "\\F1919"; }

.mdi-gamepad-right::before {
  content: "\\F0E3B"; }

.mdi-gamepad-round::before {
  content: "\\F0E3C"; }

.mdi-gamepad-round-down::before {
  content: "\\F0E3D"; }

.mdi-gamepad-round-left::before {
  content: "\\F0E3E"; }

.mdi-gamepad-round-outline::before {
  content: "\\F0E3F"; }

.mdi-gamepad-round-right::before {
  content: "\\F0E40"; }

.mdi-gamepad-round-up::before {
  content: "\\F0E41"; }

.mdi-gamepad-square::before {
  content: "\\F0EB5"; }

.mdi-gamepad-square-outline::before {
  content: "\\F0EB6"; }

.mdi-gamepad-up::before {
  content: "\\F0E42"; }

.mdi-gamepad-variant::before {
  content: "\\F0297"; }

.mdi-gamepad-variant-outline::before {
  content: "\\F0EB7"; }

.mdi-gamma::before {
  content: "\\F10EE"; }

.mdi-gantry-crane::before {
  content: "\\F0DD1"; }

.mdi-garage::before {
  content: "\\F06D9"; }

.mdi-garage-alert::before {
  content: "\\F0872"; }

.mdi-garage-alert-variant::before {
  content: "\\F12D5"; }

.mdi-garage-lock::before {
  content: "\\F17FB"; }

.mdi-garage-open::before {
  content: "\\F06DA"; }

.mdi-garage-open-variant::before {
  content: "\\F12D4"; }

.mdi-garage-variant::before {
  content: "\\F12D3"; }

.mdi-garage-variant-lock::before {
  content: "\\F17FC"; }

.mdi-gas-cylinder::before {
  content: "\\F0647"; }

.mdi-gas-station::before {
  content: "\\F0298"; }

.mdi-gas-station-off::before {
  content: "\\F1409"; }

.mdi-gas-station-off-outline::before {
  content: "\\F140A"; }

.mdi-gas-station-outline::before {
  content: "\\F0EB8"; }

.mdi-gate::before {
  content: "\\F0299"; }

.mdi-gate-alert::before {
  content: "\\F17F8"; }

.mdi-gate-and::before {
  content: "\\F08E1"; }

.mdi-gate-arrow-left::before {
  content: "\\F17F7"; }

.mdi-gate-arrow-right::before {
  content: "\\F1169"; }

.mdi-gate-nand::before {
  content: "\\F08E2"; }

.mdi-gate-nor::before {
  content: "\\F08E3"; }

.mdi-gate-not::before {
  content: "\\F08E4"; }

.mdi-gate-open::before {
  content: "\\F116A"; }

.mdi-gate-or::before {
  content: "\\F08E5"; }

.mdi-gate-xnor::before {
  content: "\\F08E6"; }

.mdi-gate-xor::before {
  content: "\\F08E7"; }

.mdi-gatsby::before {
  content: "\\F0E43"; }

.mdi-gauge::before {
  content: "\\F029A"; }

.mdi-gauge-empty::before {
  content: "\\F0873"; }

.mdi-gauge-full::before {
  content: "\\F0874"; }

.mdi-gauge-low::before {
  content: "\\F0875"; }

.mdi-gavel::before {
  content: "\\F029B"; }

.mdi-gender-female::before {
  content: "\\F029C"; }

.mdi-gender-male::before {
  content: "\\F029D"; }

.mdi-gender-male-female::before {
  content: "\\F029E"; }

.mdi-gender-male-female-variant::before {
  content: "\\F113F"; }

.mdi-gender-non-binary::before {
  content: "\\F1140"; }

.mdi-gender-transgender::before {
  content: "\\F029F"; }

.mdi-gentoo::before {
  content: "\\F08E8"; }

.mdi-gesture::before {
  content: "\\F07CB"; }

.mdi-gesture-double-tap::before {
  content: "\\F073C"; }

.mdi-gesture-pinch::before {
  content: "\\F0ABD"; }

.mdi-gesture-spread::before {
  content: "\\F0ABE"; }

.mdi-gesture-swipe::before {
  content: "\\F0D76"; }

.mdi-gesture-swipe-down::before {
  content: "\\F073D"; }

.mdi-gesture-swipe-horizontal::before {
  content: "\\F0ABF"; }

.mdi-gesture-swipe-left::before {
  content: "\\F073E"; }

.mdi-gesture-swipe-right::before {
  content: "\\F073F"; }

.mdi-gesture-swipe-up::before {
  content: "\\F0740"; }

.mdi-gesture-swipe-vertical::before {
  content: "\\F0AC0"; }

.mdi-gesture-tap::before {
  content: "\\F0741"; }

.mdi-gesture-tap-box::before {
  content: "\\F12A9"; }

.mdi-gesture-tap-button::before {
  content: "\\F12A8"; }

.mdi-gesture-tap-hold::before {
  content: "\\F0D77"; }

.mdi-gesture-two-double-tap::before {
  content: "\\F0742"; }

.mdi-gesture-two-tap::before {
  content: "\\F0743"; }

.mdi-ghost::before {
  content: "\\F02A0"; }

.mdi-ghost-off::before {
  content: "\\F09F5"; }

.mdi-ghost-off-outline::before {
  content: "\\F165C"; }

.mdi-ghost-outline::before {
  content: "\\F165D"; }

.mdi-gift::before {
  content: "\\F0E44"; }

.mdi-gift-off::before {
  content: "\\F16EF"; }

.mdi-gift-off-outline::before {
  content: "\\F16F0"; }

.mdi-gift-open::before {
  content: "\\F16F1"; }

.mdi-gift-open-outline::before {
  content: "\\F16F2"; }

.mdi-gift-outline::before {
  content: "\\F02A1"; }

.mdi-git::before {
  content: "\\F02A2"; }

.mdi-github::before {
  content: "\\F02A4"; }

.mdi-gitlab::before {
  content: "\\F0BA0"; }

.mdi-glass-cocktail::before {
  content: "\\F0356"; }

.mdi-glass-cocktail-off::before {
  content: "\\F15E6"; }

.mdi-glass-flute::before {
  content: "\\F02A5"; }

.mdi-glass-fragile::before {
  content: "\\F1873"; }

.mdi-glass-mug::before {
  content: "\\F02A6"; }

.mdi-glass-mug-off::before {
  content: "\\F15E7"; }

.mdi-glass-mug-variant::before {
  content: "\\F1116"; }

.mdi-glass-mug-variant-off::before {
  content: "\\F15E8"; }

.mdi-glass-pint-outline::before {
  content: "\\F130D"; }

.mdi-glass-stange::before {
  content: "\\F02A7"; }

.mdi-glass-tulip::before {
  content: "\\F02A8"; }

.mdi-glass-wine::before {
  content: "\\F0876"; }

.mdi-glasses::before {
  content: "\\F02AA"; }

.mdi-globe-light::before {
  content: "\\F12D7"; }

.mdi-globe-model::before {
  content: "\\F08E9"; }

.mdi-gmail::before {
  content: "\\F02AB"; }

.mdi-gnome::before {
  content: "\\F02AC"; }

.mdi-go-kart::before {
  content: "\\F0D79"; }

.mdi-go-kart-track::before {
  content: "\\F0D7A"; }

.mdi-gog::before {
  content: "\\F0BA1"; }

.mdi-gold::before {
  content: "\\F124F"; }

.mdi-golf::before {
  content: "\\F0823"; }

.mdi-golf-cart::before {
  content: "\\F11A4"; }

.mdi-golf-tee::before {
  content: "\\F1083"; }

.mdi-gondola::before {
  content: "\\F0686"; }

.mdi-goodreads::before {
  content: "\\F0D7B"; }

.mdi-google::before {
  content: "\\F02AD"; }

.mdi-google-ads::before {
  content: "\\F0C87"; }

.mdi-google-analytics::before {
  content: "\\F07CC"; }

.mdi-google-assistant::before {
  content: "\\F07CD"; }

.mdi-google-cardboard::before {
  content: "\\F02AE"; }

.mdi-google-chrome::before {
  content: "\\F02AF"; }

.mdi-google-circles::before {
  content: "\\F02B0"; }

.mdi-google-circles-communities::before {
  content: "\\F02B1"; }

.mdi-google-circles-extended::before {
  content: "\\F02B2"; }

.mdi-google-circles-group::before {
  content: "\\F02B3"; }

.mdi-google-classroom::before {
  content: "\\F02C0"; }

.mdi-google-cloud::before {
  content: "\\F11F6"; }

.mdi-google-controller::before {
  content: "\\F02B4"; }

.mdi-google-controller-off::before {
  content: "\\F02B5"; }

.mdi-google-downasaur::before {
  content: "\\F1362"; }

.mdi-google-drive::before {
  content: "\\F02B6"; }

.mdi-google-earth::before {
  content: "\\F02B7"; }

.mdi-google-fit::before {
  content: "\\F096C"; }

.mdi-google-glass::before {
  content: "\\F02B8"; }

.mdi-google-hangouts::before {
  content: "\\F02C9"; }

.mdi-google-home::before {
  content: "\\F0824"; }

.mdi-google-keep::before {
  content: "\\F06DC"; }

.mdi-google-lens::before {
  content: "\\F09F6"; }

.mdi-google-maps::before {
  content: "\\F05F5"; }

.mdi-google-my-business::before {
  content: "\\F1048"; }

.mdi-google-nearby::before {
  content: "\\F02B9"; }

.mdi-google-play::before {
  content: "\\F02BC"; }

.mdi-google-plus::before {
  content: "\\F02BD"; }

.mdi-google-podcast::before {
  content: "\\F0EB9"; }

.mdi-google-spreadsheet::before {
  content: "\\F09F7"; }

.mdi-google-street-view::before {
  content: "\\F0C88"; }

.mdi-google-translate::before {
  content: "\\F02BF"; }

.mdi-gradient-horizontal::before {
  content: "\\F174A"; }

.mdi-gradient-vertical::before {
  content: "\\F06A0"; }

.mdi-grain::before {
  content: "\\F0D7C"; }

.mdi-graph::before {
  content: "\\F1049"; }

.mdi-graph-outline::before {
  content: "\\F104A"; }

.mdi-graphql::before {
  content: "\\F0877"; }

.mdi-grass::before {
  content: "\\F1510"; }

.mdi-grave-stone::before {
  content: "\\F0BA2"; }

.mdi-grease-pencil::before {
  content: "\\F0648"; }

.mdi-greater-than::before {
  content: "\\F096D"; }

.mdi-greater-than-or-equal::before {
  content: "\\F096E"; }

.mdi-greenhouse::before {
  content: "\\F002D"; }

.mdi-grid::before {
  content: "\\F02C1"; }

.mdi-grid-large::before {
  content: "\\F0758"; }

.mdi-grid-off::before {
  content: "\\F02C2"; }

.mdi-grill::before {
  content: "\\F0E45"; }

.mdi-grill-outline::before {
  content: "\\F118A"; }

.mdi-group::before {
  content: "\\F02C3"; }

.mdi-guitar-acoustic::before {
  content: "\\F0771"; }

.mdi-guitar-electric::before {
  content: "\\F02C4"; }

.mdi-guitar-pick::before {
  content: "\\F02C5"; }

.mdi-guitar-pick-outline::before {
  content: "\\F02C6"; }

.mdi-guy-fawkes-mask::before {
  content: "\\F0825"; }

.mdi-hail::before {
  content: "\\F0AC1"; }

.mdi-hair-dryer::before {
  content: "\\F10EF"; }

.mdi-hair-dryer-outline::before {
  content: "\\F10F0"; }

.mdi-halloween::before {
  content: "\\F0BA3"; }

.mdi-hamburger::before {
  content: "\\F0685"; }

.mdi-hamburger-check::before {
  content: "\\F1776"; }

.mdi-hamburger-minus::before {
  content: "\\F1777"; }

.mdi-hamburger-off::before {
  content: "\\F1778"; }

.mdi-hamburger-plus::before {
  content: "\\F1779"; }

.mdi-hamburger-remove::before {
  content: "\\F177A"; }

.mdi-hammer::before {
  content: "\\F08EA"; }

.mdi-hammer-screwdriver::before {
  content: "\\F1322"; }

.mdi-hammer-sickle::before {
  content: "\\F1887"; }

.mdi-hammer-wrench::before {
  content: "\\F1323"; }

.mdi-hand-back-left::before {
  content: "\\F0E46"; }

.mdi-hand-back-left-off::before {
  content: "\\F1830"; }

.mdi-hand-back-left-off-outline::before {
  content: "\\F1832"; }

.mdi-hand-back-left-outline::before {
  content: "\\F182C"; }

.mdi-hand-back-right::before {
  content: "\\F0E47"; }

.mdi-hand-back-right-off::before {
  content: "\\F1831"; }

.mdi-hand-back-right-off-outline::before {
  content: "\\F1833"; }

.mdi-hand-back-right-outline::before {
  content: "\\F182D"; }

.mdi-hand-clap::before {
  content: "\\F194B"; }

.mdi-hand-coin::before {
  content: "\\F188F"; }

.mdi-hand-coin-outline::before {
  content: "\\F1890"; }

.mdi-hand-extended::before {
  content: "\\F18B6"; }

.mdi-hand-extended-outline::before {
  content: "\\F18B7"; }

.mdi-hand-front-left::before {
  content: "\\F182B"; }

.mdi-hand-front-left-outline::before {
  content: "\\F182E"; }

.mdi-hand-front-right::before {
  content: "\\F0A4F"; }

.mdi-hand-front-right-outline::before {
  content: "\\F182F"; }

.mdi-hand-heart::before {
  content: "\\F10F1"; }

.mdi-hand-heart-outline::before {
  content: "\\F157E"; }

.mdi-hand-okay::before {
  content: "\\F0A50"; }

.mdi-hand-peace::before {
  content: "\\F0A51"; }

.mdi-hand-peace-variant::before {
  content: "\\F0A52"; }

.mdi-hand-pointing-down::before {
  content: "\\F0A53"; }

.mdi-hand-pointing-left::before {
  content: "\\F0A54"; }

.mdi-hand-pointing-right::before {
  content: "\\F02C7"; }

.mdi-hand-pointing-up::before {
  content: "\\F0A55"; }

.mdi-hand-saw::before {
  content: "\\F0E48"; }

.mdi-hand-wash::before {
  content: "\\F157F"; }

.mdi-hand-wash-outline::before {
  content: "\\F1580"; }

.mdi-hand-water::before {
  content: "\\F139F"; }

.mdi-hand-wave::before {
  content: "\\F1821"; }

.mdi-hand-wave-outline::before {
  content: "\\F1822"; }

.mdi-handball::before {
  content: "\\F0F53"; }

.mdi-handcuffs::before {
  content: "\\F113E"; }

.mdi-hands-pray::before {
  content: "\\F0579"; }

.mdi-handshake::before {
  content: "\\F1218"; }

.mdi-handshake-outline::before {
  content: "\\F15A1"; }

.mdi-hanger::before {
  content: "\\F02C8"; }

.mdi-hard-hat::before {
  content: "\\F096F"; }

.mdi-harddisk::before {
  content: "\\F02CA"; }

.mdi-harddisk-plus::before {
  content: "\\F104B"; }

.mdi-harddisk-remove::before {
  content: "\\F104C"; }

.mdi-hat-fedora::before {
  content: "\\F0BA4"; }

.mdi-hazard-lights::before {
  content: "\\F0C89"; }

.mdi-hdr::before {
  content: "\\F0D7D"; }

.mdi-hdr-off::before {
  content: "\\F0D7E"; }

.mdi-head::before {
  content: "\\F135E"; }

.mdi-head-alert::before {
  content: "\\F1338"; }

.mdi-head-alert-outline::before {
  content: "\\F1339"; }

.mdi-head-check::before {
  content: "\\F133A"; }

.mdi-head-check-outline::before {
  content: "\\F133B"; }

.mdi-head-cog::before {
  content: "\\F133C"; }

.mdi-head-cog-outline::before {
  content: "\\F133D"; }

.mdi-head-dots-horizontal::before {
  content: "\\F133E"; }

.mdi-head-dots-horizontal-outline::before {
  content: "\\F133F"; }

.mdi-head-flash::before {
  content: "\\F1340"; }

.mdi-head-flash-outline::before {
  content: "\\F1341"; }

.mdi-head-heart::before {
  content: "\\F1342"; }

.mdi-head-heart-outline::before {
  content: "\\F1343"; }

.mdi-head-lightbulb::before {
  content: "\\F1344"; }

.mdi-head-lightbulb-outline::before {
  content: "\\F1345"; }

.mdi-head-minus::before {
  content: "\\F1346"; }

.mdi-head-minus-outline::before {
  content: "\\F1347"; }

.mdi-head-outline::before {
  content: "\\F135F"; }

.mdi-head-plus::before {
  content: "\\F1348"; }

.mdi-head-plus-outline::before {
  content: "\\F1349"; }

.mdi-head-question::before {
  content: "\\F134A"; }

.mdi-head-question-outline::before {
  content: "\\F134B"; }

.mdi-head-remove::before {
  content: "\\F134C"; }

.mdi-head-remove-outline::before {
  content: "\\F134D"; }

.mdi-head-snowflake::before {
  content: "\\F134E"; }

.mdi-head-snowflake-outline::before {
  content: "\\F134F"; }

.mdi-head-sync::before {
  content: "\\F1350"; }

.mdi-head-sync-outline::before {
  content: "\\F1351"; }

.mdi-headphones::before {
  content: "\\F02CB"; }

.mdi-headphones-bluetooth::before {
  content: "\\F0970"; }

.mdi-headphones-box::before {
  content: "\\F02CC"; }

.mdi-headphones-off::before {
  content: "\\F07CE"; }

.mdi-headphones-settings::before {
  content: "\\F02CD"; }

.mdi-headset::before {
  content: "\\F02CE"; }

.mdi-headset-dock::before {
  content: "\\F02CF"; }

.mdi-headset-off::before {
  content: "\\F02D0"; }

.mdi-heart::before {
  content: "\\F02D1"; }

.mdi-heart-box::before {
  content: "\\F02D2"; }

.mdi-heart-box-outline::before {
  content: "\\F02D3"; }

.mdi-heart-broken::before {
  content: "\\F02D4"; }

.mdi-heart-broken-outline::before {
  content: "\\F0D14"; }

.mdi-heart-circle::before {
  content: "\\F0971"; }

.mdi-heart-circle-outline::before {
  content: "\\F0972"; }

.mdi-heart-cog::before {
  content: "\\F1663"; }

.mdi-heart-cog-outline::before {
  content: "\\F1664"; }

.mdi-heart-flash::before {
  content: "\\F0EF9"; }

.mdi-heart-half::before {
  content: "\\F06DF"; }

.mdi-heart-half-full::before {
  content: "\\F06DE"; }

.mdi-heart-half-outline::before {
  content: "\\F06E0"; }

.mdi-heart-minus::before {
  content: "\\F142F"; }

.mdi-heart-minus-outline::before {
  content: "\\F1432"; }

.mdi-heart-multiple::before {
  content: "\\F0A56"; }

.mdi-heart-multiple-outline::before {
  content: "\\F0A57"; }

.mdi-heart-off::before {
  content: "\\F0759"; }

.mdi-heart-off-outline::before {
  content: "\\F1434"; }

.mdi-heart-outline::before {
  content: "\\F02D5"; }

.mdi-heart-plus::before {
  content: "\\F142E"; }

.mdi-heart-plus-outline::before {
  content: "\\F1431"; }

.mdi-heart-pulse::before {
  content: "\\F05F6"; }

.mdi-heart-remove::before {
  content: "\\F1430"; }

.mdi-heart-remove-outline::before {
  content: "\\F1433"; }

.mdi-heart-settings::before {
  content: "\\F1665"; }

.mdi-heart-settings-outline::before {
  content: "\\F1666"; }

.mdi-helicopter::before {
  content: "\\F0AC2"; }

.mdi-help::before {
  content: "\\F02D6"; }

.mdi-help-box::before {
  content: "\\F078B"; }

.mdi-help-circle::before {
  content: "\\F02D7"; }

.mdi-help-circle-outline::before {
  content: "\\F0625"; }

.mdi-help-network::before {
  content: "\\F06F5"; }

.mdi-help-network-outline::before {
  content: "\\F0C8A"; }

.mdi-help-rhombus::before {
  content: "\\F0BA5"; }

.mdi-help-rhombus-outline::before {
  content: "\\F0BA6"; }

.mdi-hexadecimal::before {
  content: "\\F12A7"; }

.mdi-hexagon::before {
  content: "\\F02D8"; }

.mdi-hexagon-multiple::before {
  content: "\\F06E1"; }

.mdi-hexagon-multiple-outline::before {
  content: "\\F10F2"; }

.mdi-hexagon-outline::before {
  content: "\\F02D9"; }

.mdi-hexagon-slice-1::before {
  content: "\\F0AC3"; }

.mdi-hexagon-slice-2::before {
  content: "\\F0AC4"; }

.mdi-hexagon-slice-3::before {
  content: "\\F0AC5"; }

.mdi-hexagon-slice-4::before {
  content: "\\F0AC6"; }

.mdi-hexagon-slice-5::before {
  content: "\\F0AC7"; }

.mdi-hexagon-slice-6::before {
  content: "\\F0AC8"; }

.mdi-hexagram::before {
  content: "\\F0AC9"; }

.mdi-hexagram-outline::before {
  content: "\\F0ACA"; }

.mdi-high-definition::before {
  content: "\\F07CF"; }

.mdi-high-definition-box::before {
  content: "\\F0878"; }

.mdi-highway::before {
  content: "\\F05F7"; }

.mdi-hiking::before {
  content: "\\F0D7F"; }

.mdi-history::before {
  content: "\\F02DA"; }

.mdi-hockey-puck::before {
  content: "\\F0879"; }

.mdi-hockey-sticks::before {
  content: "\\F087A"; }

.mdi-hololens::before {
  content: "\\F02DB"; }

.mdi-home::before {
  content: "\\F02DC"; }

.mdi-home-account::before {
  content: "\\F0826"; }

.mdi-home-alert::before {
  content: "\\F087B"; }

.mdi-home-alert-outline::before {
  content: "\\F15D0"; }

.mdi-home-analytics::before {
  content: "\\F0EBA"; }

.mdi-home-assistant::before {
  content: "\\F07D0"; }

.mdi-home-automation::before {
  content: "\\F07D1"; }

.mdi-home-battery::before {
  content: "\\F1901"; }

.mdi-home-battery-outline::before {
  content: "\\F1902"; }

.mdi-home-circle::before {
  content: "\\F07D2"; }

.mdi-home-circle-outline::before {
  content: "\\F104D"; }

.mdi-home-city::before {
  content: "\\F0D15"; }

.mdi-home-city-outline::before {
  content: "\\F0D16"; }

.mdi-home-edit::before {
  content: "\\F1159"; }

.mdi-home-edit-outline::before {
  content: "\\F115A"; }

.mdi-home-export-outline::before {
  content: "\\F0F9B"; }

.mdi-home-flood::before {
  content: "\\F0EFA"; }

.mdi-home-floor-0::before {
  content: "\\F0DD2"; }

.mdi-home-floor-1::before {
  content: "\\F0D80"; }

.mdi-home-floor-2::before {
  content: "\\F0D81"; }

.mdi-home-floor-3::before {
  content: "\\F0D82"; }

.mdi-home-floor-a::before {
  content: "\\F0D83"; }

.mdi-home-floor-b::before {
  content: "\\F0D84"; }

.mdi-home-floor-g::before {
  content: "\\F0D85"; }

.mdi-home-floor-l::before {
  content: "\\F0D86"; }

.mdi-home-floor-negative-1::before {
  content: "\\F0DD3"; }

.mdi-home-group::before {
  content: "\\F0DD4"; }

.mdi-home-group-minus::before {
  content: "\\F19C1"; }

.mdi-home-group-plus::before {
  content: "\\F19C0"; }

.mdi-home-group-remove::before {
  content: "\\F19C2"; }

.mdi-home-heart::before {
  content: "\\F0827"; }

.mdi-home-import-outline::before {
  content: "\\F0F9C"; }

.mdi-home-lightbulb::before {
  content: "\\F1251"; }

.mdi-home-lightbulb-outline::before {
  content: "\\F1252"; }

.mdi-home-lightning-bolt::before {
  content: "\\F1903"; }

.mdi-home-lightning-bolt-outline::before {
  content: "\\F1904"; }

.mdi-home-lock::before {
  content: "\\F08EB"; }

.mdi-home-lock-open::before {
  content: "\\F08EC"; }

.mdi-home-map-marker::before {
  content: "\\F05F8"; }

.mdi-home-minus::before {
  content: "\\F0974"; }

.mdi-home-minus-outline::before {
  content: "\\F13D5"; }

.mdi-home-modern::before {
  content: "\\F02DD"; }

.mdi-home-outline::before {
  content: "\\F06A1"; }

.mdi-home-plus::before {
  content: "\\F0975"; }

.mdi-home-plus-outline::before {
  content: "\\F13D6"; }

.mdi-home-remove::before {
  content: "\\F1247"; }

.mdi-home-remove-outline::before {
  content: "\\F13D7"; }

.mdi-home-roof::before {
  content: "\\F112B"; }

.mdi-home-search::before {
  content: "\\F13B0"; }

.mdi-home-search-outline::before {
  content: "\\F13B1"; }

.mdi-home-switch::before {
  content: "\\F1794"; }

.mdi-home-switch-outline::before {
  content: "\\F1795"; }

.mdi-home-thermometer::before {
  content: "\\F0F54"; }

.mdi-home-thermometer-outline::before {
  content: "\\F0F55"; }

.mdi-home-variant::before {
  content: "\\F02DE"; }

.mdi-home-variant-outline::before {
  content: "\\F0BA7"; }

.mdi-hook::before {
  content: "\\F06E2"; }

.mdi-hook-off::before {
  content: "\\F06E3"; }

.mdi-hoop-house::before {
  content: "\\F0E56"; }

.mdi-hops::before {
  content: "\\F02DF"; }

.mdi-horizontal-rotate-clockwise::before {
  content: "\\F10F3"; }

.mdi-horizontal-rotate-counterclockwise::before {
  content: "\\F10F4"; }

.mdi-horse::before {
  content: "\\F15BF"; }

.mdi-horse-human::before {
  content: "\\F15C0"; }

.mdi-horse-variant::before {
  content: "\\F15C1"; }

.mdi-horse-variant-fast::before {
  content: "\\F186E"; }

.mdi-horseshoe::before {
  content: "\\F0A58"; }

.mdi-hospital::before {
  content: "\\F0FF6"; }

.mdi-hospital-box::before {
  content: "\\F02E0"; }

.mdi-hospital-box-outline::before {
  content: "\\F0FF7"; }

.mdi-hospital-building::before {
  content: "\\F02E1"; }

.mdi-hospital-marker::before {
  content: "\\F02E2"; }

.mdi-hot-tub::before {
  content: "\\F0828"; }

.mdi-hours-24::before {
  content: "\\F1478"; }

.mdi-hubspot::before {
  content: "\\F0D17"; }

.mdi-hulu::before {
  content: "\\F0829"; }

.mdi-human::before {
  content: "\\F02E6"; }

.mdi-human-baby-changing-table::before {
  content: "\\F138B"; }

.mdi-human-cane::before {
  content: "\\F1581"; }

.mdi-human-capacity-decrease::before {
  content: "\\F159B"; }

.mdi-human-capacity-increase::before {
  content: "\\F159C"; }

.mdi-human-child::before {
  content: "\\F02E7"; }

.mdi-human-dolly::before {
  content: "\\F1980"; }

.mdi-human-edit::before {
  content: "\\F14E8"; }

.mdi-human-female::before {
  content: "\\F0649"; }

.mdi-human-female-boy::before {
  content: "\\F0A59"; }

.mdi-human-female-dance::before {
  content: "\\F15C9"; }

.mdi-human-female-female::before {
  content: "\\F0A5A"; }

.mdi-human-female-girl::before {
  content: "\\F0A5B"; }

.mdi-human-greeting::before {
  content: "\\F17C4"; }

.mdi-human-greeting-proximity::before {
  content: "\\F159D"; }

.mdi-human-greeting-variant::before {
  content: "\\F064A"; }

.mdi-human-handsdown::before {
  content: "\\F064B"; }

.mdi-human-handsup::before {
  content: "\\F064C"; }

.mdi-human-male::before {
  content: "\\F064D"; }

.mdi-human-male-board::before {
  content: "\\F0890"; }

.mdi-human-male-board-poll::before {
  content: "\\F0846"; }

.mdi-human-male-boy::before {
  content: "\\F0A5C"; }

.mdi-human-male-child::before {
  content: "\\F138C"; }

.mdi-human-male-female::before {
  content: "\\F02E8"; }

.mdi-human-male-female-child::before {
  content: "\\F1823"; }

.mdi-human-male-girl::before {
  content: "\\F0A5D"; }

.mdi-human-male-height::before {
  content: "\\F0EFB"; }

.mdi-human-male-height-variant::before {
  content: "\\F0EFC"; }

.mdi-human-male-male::before {
  content: "\\F0A5E"; }

.mdi-human-non-binary::before {
  content: "\\F1848"; }

.mdi-human-pregnant::before {
  content: "\\F05CF"; }

.mdi-human-queue::before {
  content: "\\F1571"; }

.mdi-human-scooter::before {
  content: "\\F11E9"; }

.mdi-human-wheelchair::before {
  content: "\\F138D"; }

.mdi-human-white-cane::before {
  content: "\\F1981"; }

.mdi-humble-bundle::before {
  content: "\\F0744"; }

.mdi-hvac::before {
  content: "\\F1352"; }

.mdi-hvac-off::before {
  content: "\\F159E"; }

.mdi-hydraulic-oil-level::before {
  content: "\\F1324"; }

.mdi-hydraulic-oil-temperature::before {
  content: "\\F1325"; }

.mdi-hydro-power::before {
  content: "\\F12E5"; }

.mdi-hydrogen-station::before {
  content: "\\F1894"; }

.mdi-ice-cream::before {
  content: "\\F082A"; }

.mdi-ice-cream-off::before {
  content: "\\F0E52"; }

.mdi-ice-pop::before {
  content: "\\F0EFD"; }

.mdi-id-card::before {
  content: "\\F0FC0"; }

.mdi-identifier::before {
  content: "\\F0EFE"; }

.mdi-ideogram-cjk::before {
  content: "\\F1331"; }

.mdi-ideogram-cjk-variant::before {
  content: "\\F1332"; }

.mdi-image::before {
  content: "\\F02E9"; }

.mdi-image-album::before {
  content: "\\F02EA"; }

.mdi-image-area::before {
  content: "\\F02EB"; }

.mdi-image-area-close::before {
  content: "\\F02EC"; }

.mdi-image-auto-adjust::before {
  content: "\\F0FC1"; }

.mdi-image-broken::before {
  content: "\\F02ED"; }

.mdi-image-broken-variant::before {
  content: "\\F02EE"; }

.mdi-image-edit::before {
  content: "\\F11E3"; }

.mdi-image-edit-outline::before {
  content: "\\F11E4"; }

.mdi-image-filter-black-white::before {
  content: "\\F02F0"; }

.mdi-image-filter-center-focus::before {
  content: "\\F02F1"; }

.mdi-image-filter-center-focus-strong::before {
  content: "\\F0EFF"; }

.mdi-image-filter-center-focus-strong-outline::before {
  content: "\\F0F00"; }

.mdi-image-filter-center-focus-weak::before {
  content: "\\F02F2"; }

.mdi-image-filter-drama::before {
  content: "\\F02F3"; }

.mdi-image-filter-frames::before {
  content: "\\F02F4"; }

.mdi-image-filter-hdr::before {
  content: "\\F02F5"; }

.mdi-image-filter-none::before {
  content: "\\F02F6"; }

.mdi-image-filter-tilt-shift::before {
  content: "\\F02F7"; }

.mdi-image-filter-vintage::before {
  content: "\\F02F8"; }

.mdi-image-frame::before {
  content: "\\F0E49"; }

.mdi-image-marker::before {
  content: "\\F177B"; }

.mdi-image-marker-outline::before {
  content: "\\F177C"; }

.mdi-image-minus::before {
  content: "\\F1419"; }

.mdi-image-move::before {
  content: "\\F09F8"; }

.mdi-image-multiple::before {
  content: "\\F02F9"; }

.mdi-image-multiple-outline::before {
  content: "\\F02EF"; }

.mdi-image-off::before {
  content: "\\F082B"; }

.mdi-image-off-outline::before {
  content: "\\F11D1"; }

.mdi-image-outline::before {
  content: "\\F0976"; }

.mdi-image-plus::before {
  content: "\\F087C"; }

.mdi-image-remove::before {
  content: "\\F1418"; }

.mdi-image-search::before {
  content: "\\F0977"; }

.mdi-image-search-outline::before {
  content: "\\F0978"; }

.mdi-image-size-select-actual::before {
  content: "\\F0C8D"; }

.mdi-image-size-select-large::before {
  content: "\\F0C8E"; }

.mdi-image-size-select-small::before {
  content: "\\F0C8F"; }

.mdi-image-text::before {
  content: "\\F160D"; }

.mdi-import::before {
  content: "\\F02FA"; }

.mdi-inbox::before {
  content: "\\F0687"; }

.mdi-inbox-arrow-down::before {
  content: "\\F02FB"; }

.mdi-inbox-arrow-down-outline::before {
  content: "\\F1270"; }

.mdi-inbox-arrow-up::before {
  content: "\\F03D1"; }

.mdi-inbox-arrow-up-outline::before {
  content: "\\F1271"; }

.mdi-inbox-full::before {
  content: "\\F1272"; }

.mdi-inbox-full-outline::before {
  content: "\\F1273"; }

.mdi-inbox-multiple::before {
  content: "\\F08B0"; }

.mdi-inbox-multiple-outline::before {
  content: "\\F0BA8"; }

.mdi-inbox-outline::before {
  content: "\\F1274"; }

.mdi-inbox-remove::before {
  content: "\\F159F"; }

.mdi-inbox-remove-outline::before {
  content: "\\F15A0"; }

.mdi-incognito::before {
  content: "\\F05F9"; }

.mdi-incognito-circle::before {
  content: "\\F1421"; }

.mdi-incognito-circle-off::before {
  content: "\\F1422"; }

.mdi-incognito-off::before {
  content: "\\F0075"; }

.mdi-induction::before {
  content: "\\F184C"; }

.mdi-infinity::before {
  content: "\\F06E4"; }

.mdi-information::before {
  content: "\\F02FC"; }

.mdi-information-off::before {
  content: "\\F178C"; }

.mdi-information-off-outline::before {
  content: "\\F178D"; }

.mdi-information-outline::before {
  content: "\\F02FD"; }

.mdi-information-variant::before {
  content: "\\F064E"; }

.mdi-instagram::before {
  content: "\\F02FE"; }

.mdi-instrument-triangle::before {
  content: "\\F104E"; }

.mdi-integrated-circuit-chip::before {
  content: "\\F1913"; }

.mdi-invert-colors::before {
  content: "\\F0301"; }

.mdi-invert-colors-off::before {
  content: "\\F0E4A"; }

.mdi-iobroker::before {
  content: "\\F12E8"; }

.mdi-ip::before {
  content: "\\F0A5F"; }

.mdi-ip-network::before {
  content: "\\F0A60"; }

.mdi-ip-network-outline::before {
  content: "\\F0C90"; }

.mdi-ip-outline::before {
  content: "\\F1982"; }

.mdi-ipod::before {
  content: "\\F0C91"; }

.mdi-iron::before {
  content: "\\F1824"; }

.mdi-iron-board::before {
  content: "\\F1838"; }

.mdi-iron-outline::before {
  content: "\\F1825"; }

.mdi-island::before {
  content: "\\F104F"; }

.mdi-iv-bag::before {
  content: "\\F10B9"; }

.mdi-jabber::before {
  content: "\\F0DD5"; }

.mdi-jeepney::before {
  content: "\\F0302"; }

.mdi-jellyfish::before {
  content: "\\F0F01"; }

.mdi-jellyfish-outline::before {
  content: "\\F0F02"; }

.mdi-jira::before {
  content: "\\F0303"; }

.mdi-jquery::before {
  content: "\\F087D"; }

.mdi-jsfiddle::before {
  content: "\\F0304"; }

.mdi-jump-rope::before {
  content: "\\F12FF"; }

.mdi-kabaddi::before {
  content: "\\F0D87"; }

.mdi-kangaroo::before {
  content: "\\F1558"; }

.mdi-karate::before {
  content: "\\F082C"; }

.mdi-kayaking::before {
  content: "\\F08AF"; }

.mdi-keg::before {
  content: "\\F0305"; }

.mdi-kettle::before {
  content: "\\F05FA"; }

.mdi-kettle-alert::before {
  content: "\\F1317"; }

.mdi-kettle-alert-outline::before {
  content: "\\F1318"; }

.mdi-kettle-off::before {
  content: "\\F131B"; }

.mdi-kettle-off-outline::before {
  content: "\\F131C"; }

.mdi-kettle-outline::before {
  content: "\\F0F56"; }

.mdi-kettle-pour-over::before {
  content: "\\F173C"; }

.mdi-kettle-steam::before {
  content: "\\F1319"; }

.mdi-kettle-steam-outline::before {
  content: "\\F131A"; }

.mdi-kettlebell::before {
  content: "\\F1300"; }

.mdi-key::before {
  content: "\\F0306"; }

.mdi-key-alert::before {
  content: "\\F1983"; }

.mdi-key-alert-outline::before {
  content: "\\F1984"; }

.mdi-key-arrow-right::before {
  content: "\\F1312"; }

.mdi-key-chain::before {
  content: "\\F1574"; }

.mdi-key-chain-variant::before {
  content: "\\F1575"; }

.mdi-key-change::before {
  content: "\\F0307"; }

.mdi-key-link::before {
  content: "\\F119F"; }

.mdi-key-minus::before {
  content: "\\F0308"; }

.mdi-key-outline::before {
  content: "\\F0DD6"; }

.mdi-key-plus::before {
  content: "\\F0309"; }

.mdi-key-remove::before {
  content: "\\F030A"; }

.mdi-key-star::before {
  content: "\\F119E"; }

.mdi-key-variant::before {
  content: "\\F030B"; }

.mdi-key-wireless::before {
  content: "\\F0FC2"; }

.mdi-keyboard::before {
  content: "\\F030C"; }

.mdi-keyboard-backspace::before {
  content: "\\F030D"; }

.mdi-keyboard-caps::before {
  content: "\\F030E"; }

.mdi-keyboard-close::before {
  content: "\\F030F"; }

.mdi-keyboard-esc::before {
  content: "\\F12B7"; }

.mdi-keyboard-f1::before {
  content: "\\F12AB"; }

.mdi-keyboard-f10::before {
  content: "\\F12B4"; }

.mdi-keyboard-f11::before {
  content: "\\F12B5"; }

.mdi-keyboard-f12::before {
  content: "\\F12B6"; }

.mdi-keyboard-f2::before {
  content: "\\F12AC"; }

.mdi-keyboard-f3::before {
  content: "\\F12AD"; }

.mdi-keyboard-f4::before {
  content: "\\F12AE"; }

.mdi-keyboard-f5::before {
  content: "\\F12AF"; }

.mdi-keyboard-f6::before {
  content: "\\F12B0"; }

.mdi-keyboard-f7::before {
  content: "\\F12B1"; }

.mdi-keyboard-f8::before {
  content: "\\F12B2"; }

.mdi-keyboard-f9::before {
  content: "\\F12B3"; }

.mdi-keyboard-off::before {
  content: "\\F0310"; }

.mdi-keyboard-off-outline::before {
  content: "\\F0E4B"; }

.mdi-keyboard-outline::before {
  content: "\\F097B"; }

.mdi-keyboard-return::before {
  content: "\\F0311"; }

.mdi-keyboard-settings::before {
  content: "\\F09F9"; }

.mdi-keyboard-settings-outline::before {
  content: "\\F09FA"; }

.mdi-keyboard-space::before {
  content: "\\F1050"; }

.mdi-keyboard-tab::before {
  content: "\\F0312"; }

.mdi-keyboard-tab-reverse::before {
  content: "\\F0325"; }

.mdi-keyboard-variant::before {
  content: "\\F0313"; }

.mdi-khanda::before {
  content: "\\F10FD"; }

.mdi-kickstarter::before {
  content: "\\F0745"; }

.mdi-kite::before {
  content: "\\F1985"; }

.mdi-kite-outline::before {
  content: "\\F1986"; }

.mdi-kitesurfing::before {
  content: "\\F1744"; }

.mdi-klingon::before {
  content: "\\F135B"; }

.mdi-knife::before {
  content: "\\F09FB"; }

.mdi-knife-military::before {
  content: "\\F09FC"; }

.mdi-koala::before {
  content: "\\F173F"; }

.mdi-kodi::before {
  content: "\\F0314"; }

.mdi-kubernetes::before {
  content: "\\F10FE"; }

.mdi-label::before {
  content: "\\F0315"; }

.mdi-label-multiple::before {
  content: "\\F1375"; }

.mdi-label-multiple-outline::before {
  content: "\\F1376"; }

.mdi-label-off::before {
  content: "\\F0ACB"; }

.mdi-label-off-outline::before {
  content: "\\F0ACC"; }

.mdi-label-outline::before {
  content: "\\F0316"; }

.mdi-label-percent::before {
  content: "\\F12EA"; }

.mdi-label-percent-outline::before {
  content: "\\F12EB"; }

.mdi-label-variant::before {
  content: "\\F0ACD"; }

.mdi-label-variant-outline::before {
  content: "\\F0ACE"; }

.mdi-ladder::before {
  content: "\\F15A2"; }

.mdi-ladybug::before {
  content: "\\F082D"; }

.mdi-lambda::before {
  content: "\\F0627"; }

.mdi-lamp::before {
  content: "\\F06B5"; }

.mdi-lamp-outline::before {
  content: "\\F17D0"; }

.mdi-lamps::before {
  content: "\\F1576"; }

.mdi-lamps-outline::before {
  content: "\\F17D1"; }

.mdi-lan::before {
  content: "\\F0317"; }

.mdi-lan-check::before {
  content: "\\F12AA"; }

.mdi-lan-connect::before {
  content: "\\F0318"; }

.mdi-lan-disconnect::before {
  content: "\\F0319"; }

.mdi-lan-pending::before {
  content: "\\F031A"; }

.mdi-language-c::before {
  content: "\\F0671"; }

.mdi-language-cpp::before {
  content: "\\F0672"; }

.mdi-language-csharp::before {
  content: "\\F031B"; }

.mdi-language-css3::before {
  content: "\\F031C"; }

.mdi-language-fortran::before {
  content: "\\F121A"; }

.mdi-language-go::before {
  content: "\\F07D3"; }

.mdi-language-haskell::before {
  content: "\\F0C92"; }

.mdi-language-html5::before {
  content: "\\F031D"; }

.mdi-language-java::before {
  content: "\\F0B37"; }

.mdi-language-javascript::before {
  content: "\\F031E"; }

.mdi-language-kotlin::before {
  content: "\\F1219"; }

.mdi-language-lua::before {
  content: "\\F08B1"; }

.mdi-language-markdown::before {
  content: "\\F0354"; }

.mdi-language-markdown-outline::before {
  content: "\\F0F5B"; }

.mdi-language-php::before {
  content: "\\F031F"; }

.mdi-language-python::before {
  content: "\\F0320"; }

.mdi-language-r::before {
  content: "\\F07D4"; }

.mdi-language-ruby::before {
  content: "\\F0D2D"; }

.mdi-language-ruby-on-rails::before {
  content: "\\F0ACF"; }

.mdi-language-rust::before {
  content: "\\F1617"; }

.mdi-language-swift::before {
  content: "\\F06E5"; }

.mdi-language-typescript::before {
  content: "\\F06E6"; }

.mdi-language-xaml::before {
  content: "\\F0673"; }

.mdi-laptop::before {
  content: "\\F0322"; }

.mdi-laptop-off::before {
  content: "\\F06E7"; }

.mdi-laravel::before {
  content: "\\F0AD0"; }

.mdi-laser-pointer::before {
  content: "\\F1484"; }

.mdi-lasso::before {
  content: "\\F0F03"; }

.mdi-lastpass::before {
  content: "\\F0446"; }

.mdi-latitude::before {
  content: "\\F0F57"; }

.mdi-launch::before {
  content: "\\F0327"; }

.mdi-lava-lamp::before {
  content: "\\F07D5"; }

.mdi-layers::before {
  content: "\\F0328"; }

.mdi-layers-edit::before {
  content: "\\F1892"; }

.mdi-layers-minus::before {
  content: "\\F0E4C"; }

.mdi-layers-off::before {
  content: "\\F0329"; }

.mdi-layers-off-outline::before {
  content: "\\F09FD"; }

.mdi-layers-outline::before {
  content: "\\F09FE"; }

.mdi-layers-plus::before {
  content: "\\F0E4D"; }

.mdi-layers-remove::before {
  content: "\\F0E4E"; }

.mdi-layers-search::before {
  content: "\\F1206"; }

.mdi-layers-search-outline::before {
  content: "\\F1207"; }

.mdi-layers-triple::before {
  content: "\\F0F58"; }

.mdi-layers-triple-outline::before {
  content: "\\F0F59"; }

.mdi-lead-pencil::before {
  content: "\\F064F"; }

.mdi-leaf::before {
  content: "\\F032A"; }

.mdi-leaf-circle::before {
  content: "\\F1905"; }

.mdi-leaf-circle-outline::before {
  content: "\\F1906"; }

.mdi-leaf-maple::before {
  content: "\\F0C93"; }

.mdi-leaf-maple-off::before {
  content: "\\F12DA"; }

.mdi-leaf-off::before {
  content: "\\F12D9"; }

.mdi-leak::before {
  content: "\\F0DD7"; }

.mdi-leak-off::before {
  content: "\\F0DD8"; }

.mdi-led-off::before {
  content: "\\F032B"; }

.mdi-led-on::before {
  content: "\\F032C"; }

.mdi-led-outline::before {
  content: "\\F032D"; }

.mdi-led-strip::before {
  content: "\\F07D6"; }

.mdi-led-strip-variant::before {
  content: "\\F1051"; }

.mdi-led-variant-off::before {
  content: "\\F032E"; }

.mdi-led-variant-on::before {
  content: "\\F032F"; }

.mdi-led-variant-outline::before {
  content: "\\F0330"; }

.mdi-leek::before {
  content: "\\F117D"; }

.mdi-less-than::before {
  content: "\\F097C"; }

.mdi-less-than-or-equal::before {
  content: "\\F097D"; }

.mdi-library::before {
  content: "\\F0331"; }

.mdi-library-shelves::before {
  content: "\\F0BA9"; }

.mdi-license::before {
  content: "\\F0FC3"; }

.mdi-lifebuoy::before {
  content: "\\F087E"; }

.mdi-light-flood-down::before {
  content: "\\F1987"; }

.mdi-light-flood-up::before {
  content: "\\F1988"; }

.mdi-light-recessed::before {
  content: "\\F179B"; }

.mdi-light-switch::before {
  content: "\\F097E"; }

.mdi-lightbulb::before {
  content: "\\F0335"; }

.mdi-lightbulb-auto::before {
  content: "\\F1800"; }

.mdi-lightbulb-auto-outline::before {
  content: "\\F1801"; }

.mdi-lightbulb-cfl::before {
  content: "\\F1208"; }

.mdi-lightbulb-cfl-off::before {
  content: "\\F1209"; }

.mdi-lightbulb-cfl-spiral::before {
  content: "\\F1275"; }

.mdi-lightbulb-cfl-spiral-off::before {
  content: "\\F12C3"; }

.mdi-lightbulb-fluorescent-tube::before {
  content: "\\F1804"; }

.mdi-lightbulb-fluorescent-tube-outline::before {
  content: "\\F1805"; }

.mdi-lightbulb-group::before {
  content: "\\F1253"; }

.mdi-lightbulb-group-off::before {
  content: "\\F12CD"; }

.mdi-lightbulb-group-off-outline::before {
  content: "\\F12CE"; }

.mdi-lightbulb-group-outline::before {
  content: "\\F1254"; }

.mdi-lightbulb-multiple::before {
  content: "\\F1255"; }

.mdi-lightbulb-multiple-off::before {
  content: "\\F12CF"; }

.mdi-lightbulb-multiple-off-outline::before {
  content: "\\F12D0"; }

.mdi-lightbulb-multiple-outline::before {
  content: "\\F1256"; }

.mdi-lightbulb-off::before {
  content: "\\F0E4F"; }

.mdi-lightbulb-off-outline::before {
  content: "\\F0E50"; }

.mdi-lightbulb-on::before {
  content: "\\F06E8"; }

.mdi-lightbulb-on-outline::before {
  content: "\\F06E9"; }

.mdi-lightbulb-outline::before {
  content: "\\F0336"; }

.mdi-lightbulb-spot::before {
  content: "\\F17F4"; }

.mdi-lightbulb-spot-off::before {
  content: "\\F17F5"; }

.mdi-lightbulb-variant::before {
  content: "\\F1802"; }

.mdi-lightbulb-variant-outline::before {
  content: "\\F1803"; }

.mdi-lighthouse::before {
  content: "\\F09FF"; }

.mdi-lighthouse-on::before {
  content: "\\F0A00"; }

.mdi-lightning-bolt::before {
  content: "\\F140B"; }

.mdi-lightning-bolt-circle::before {
  content: "\\F0820"; }

.mdi-lightning-bolt-outline::before {
  content: "\\F140C"; }

.mdi-line-scan::before {
  content: "\\F0624"; }

.mdi-lingerie::before {
  content: "\\F1476"; }

.mdi-link::before {
  content: "\\F0337"; }

.mdi-link-box::before {
  content: "\\F0D1A"; }

.mdi-link-box-outline::before {
  content: "\\F0D1B"; }

.mdi-link-box-variant::before {
  content: "\\F0D1C"; }

.mdi-link-box-variant-outline::before {
  content: "\\F0D1D"; }

.mdi-link-lock::before {
  content: "\\F10BA"; }

.mdi-link-off::before {
  content: "\\F0338"; }

.mdi-link-plus::before {
  content: "\\F0C94"; }

.mdi-link-variant::before {
  content: "\\F0339"; }

.mdi-link-variant-minus::before {
  content: "\\F10FF"; }

.mdi-link-variant-off::before {
  content: "\\F033A"; }

.mdi-link-variant-plus::before {
  content: "\\F1100"; }

.mdi-link-variant-remove::before {
  content: "\\F1101"; }

.mdi-linkedin::before {
  content: "\\F033B"; }

.mdi-linux::before {
  content: "\\F033D"; }

.mdi-linux-mint::before {
  content: "\\F08ED"; }

.mdi-lipstick::before {
  content: "\\F13B5"; }

.mdi-liquid-spot::before {
  content: "\\F1826"; }

.mdi-liquor::before {
  content: "\\F191E"; }

.mdi-list-status::before {
  content: "\\F15AB"; }

.mdi-litecoin::before {
  content: "\\F0A61"; }

.mdi-loading::before {
  content: "\\F0772"; }

.mdi-location-enter::before {
  content: "\\F0FC4"; }

.mdi-location-exit::before {
  content: "\\F0FC5"; }

.mdi-lock::before {
  content: "\\F033E"; }

.mdi-lock-alert::before {
  content: "\\F08EE"; }

.mdi-lock-alert-outline::before {
  content: "\\F15D1"; }

.mdi-lock-check::before {
  content: "\\F139A"; }

.mdi-lock-check-outline::before {
  content: "\\F16A8"; }

.mdi-lock-clock::before {
  content: "\\F097F"; }

.mdi-lock-minus::before {
  content: "\\F16A9"; }

.mdi-lock-minus-outline::before {
  content: "\\F16AA"; }

.mdi-lock-off::before {
  content: "\\F1671"; }

.mdi-lock-off-outline::before {
  content: "\\F1672"; }

.mdi-lock-open::before {
  content: "\\F033F"; }

.mdi-lock-open-alert::before {
  content: "\\F139B"; }

.mdi-lock-open-alert-outline::before {
  content: "\\F15D2"; }

.mdi-lock-open-check::before {
  content: "\\F139C"; }

.mdi-lock-open-check-outline::before {
  content: "\\F16AB"; }

.mdi-lock-open-minus::before {
  content: "\\F16AC"; }

.mdi-lock-open-minus-outline::before {
  content: "\\F16AD"; }

.mdi-lock-open-outline::before {
  content: "\\F0340"; }

.mdi-lock-open-plus::before {
  content: "\\F16AE"; }

.mdi-lock-open-plus-outline::before {
  content: "\\F16AF"; }

.mdi-lock-open-remove::before {
  content: "\\F16B0"; }

.mdi-lock-open-remove-outline::before {
  content: "\\F16B1"; }

.mdi-lock-open-variant::before {
  content: "\\F0FC6"; }

.mdi-lock-open-variant-outline::before {
  content: "\\F0FC7"; }

.mdi-lock-outline::before {
  content: "\\F0341"; }

.mdi-lock-pattern::before {
  content: "\\F06EA"; }

.mdi-lock-plus::before {
  content: "\\F05FB"; }

.mdi-lock-plus-outline::before {
  content: "\\F16B2"; }

.mdi-lock-question::before {
  content: "\\F08EF"; }

.mdi-lock-remove::before {
  content: "\\F16B3"; }

.mdi-lock-remove-outline::before {
  content: "\\F16B4"; }

.mdi-lock-reset::before {
  content: "\\F0773"; }

.mdi-lock-smart::before {
  content: "\\F08B2"; }

.mdi-locker::before {
  content: "\\F07D7"; }

.mdi-locker-multiple::before {
  content: "\\F07D8"; }

.mdi-login::before {
  content: "\\F0342"; }

.mdi-login-variant::before {
  content: "\\F05FC"; }

.mdi-logout::before {
  content: "\\F0343"; }

.mdi-logout-variant::before {
  content: "\\F05FD"; }

.mdi-longitude::before {
  content: "\\F0F5A"; }

.mdi-looks::before {
  content: "\\F0344"; }

.mdi-lotion::before {
  content: "\\F1582"; }

.mdi-lotion-outline::before {
  content: "\\F1583"; }

.mdi-lotion-plus::before {
  content: "\\F1584"; }

.mdi-lotion-plus-outline::before {
  content: "\\F1585"; }

.mdi-loupe::before {
  content: "\\F0345"; }

.mdi-lumx::before {
  content: "\\F0346"; }

.mdi-lungs::before {
  content: "\\F1084"; }

.mdi-mace::before {
  content: "\\F1843"; }

.mdi-magazine-pistol::before {
  content: "\\F0324"; }

.mdi-magazine-rifle::before {
  content: "\\F0323"; }

.mdi-magic-staff::before {
  content: "\\F1844"; }

.mdi-magnet::before {
  content: "\\F0347"; }

.mdi-magnet-on::before {
  content: "\\F0348"; }

.mdi-magnify::before {
  content: "\\F0349"; }

.mdi-magnify-close::before {
  content: "\\F0980"; }

.mdi-magnify-expand::before {
  content: "\\F1874"; }

.mdi-magnify-minus::before {
  content: "\\F034A"; }

.mdi-magnify-minus-cursor::before {
  content: "\\F0A62"; }

.mdi-magnify-minus-outline::before {
  content: "\\F06EC"; }

.mdi-magnify-plus::before {
  content: "\\F034B"; }

.mdi-magnify-plus-cursor::before {
  content: "\\F0A63"; }

.mdi-magnify-plus-outline::before {
  content: "\\F06ED"; }

.mdi-magnify-remove-cursor::before {
  content: "\\F120C"; }

.mdi-magnify-remove-outline::before {
  content: "\\F120D"; }

.mdi-magnify-scan::before {
  content: "\\F1276"; }

.mdi-mail::before {
  content: "\\F0EBB"; }

.mdi-mailbox::before {
  content: "\\F06EE"; }

.mdi-mailbox-open::before {
  content: "\\F0D88"; }

.mdi-mailbox-open-outline::before {
  content: "\\F0D89"; }

.mdi-mailbox-open-up::before {
  content: "\\F0D8A"; }

.mdi-mailbox-open-up-outline::before {
  content: "\\F0D8B"; }

.mdi-mailbox-outline::before {
  content: "\\F0D8C"; }

.mdi-mailbox-up::before {
  content: "\\F0D8D"; }

.mdi-mailbox-up-outline::before {
  content: "\\F0D8E"; }

.mdi-manjaro::before {
  content: "\\F160A"; }

.mdi-map::before {
  content: "\\F034D"; }

.mdi-map-check::before {
  content: "\\F0EBC"; }

.mdi-map-check-outline::before {
  content: "\\F0EBD"; }

.mdi-map-clock::before {
  content: "\\F0D1E"; }

.mdi-map-clock-outline::before {
  content: "\\F0D1F"; }

.mdi-map-legend::before {
  content: "\\F0A01"; }

.mdi-map-marker::before {
  content: "\\F034E"; }

.mdi-map-marker-account::before {
  content: "\\F18E3"; }

.mdi-map-marker-account-outline::before {
  content: "\\F18E4"; }

.mdi-map-marker-alert::before {
  content: "\\F0F05"; }

.mdi-map-marker-alert-outline::before {
  content: "\\F0F06"; }

.mdi-map-marker-check::before {
  content: "\\F0C95"; }

.mdi-map-marker-check-outline::before {
  content: "\\F12FB"; }

.mdi-map-marker-circle::before {
  content: "\\F034F"; }

.mdi-map-marker-distance::before {
  content: "\\F08F0"; }

.mdi-map-marker-down::before {
  content: "\\F1102"; }

.mdi-map-marker-left::before {
  content: "\\F12DB"; }

.mdi-map-marker-left-outline::before {
  content: "\\F12DD"; }

.mdi-map-marker-minus::before {
  content: "\\F0650"; }

.mdi-map-marker-minus-outline::before {
  content: "\\F12F9"; }

.mdi-map-marker-multiple::before {
  content: "\\F0350"; }

.mdi-map-marker-multiple-outline::before {
  content: "\\F1277"; }

.mdi-map-marker-off::before {
  content: "\\F0351"; }

.mdi-map-marker-off-outline::before {
  content: "\\F12FD"; }

.mdi-map-marker-outline::before {
  content: "\\F07D9"; }

.mdi-map-marker-path::before {
  content: "\\F0D20"; }

.mdi-map-marker-plus::before {
  content: "\\F0651"; }

.mdi-map-marker-plus-outline::before {
  content: "\\F12F8"; }

.mdi-map-marker-question::before {
  content: "\\F0F07"; }

.mdi-map-marker-question-outline::before {
  content: "\\F0F08"; }

.mdi-map-marker-radius::before {
  content: "\\F0352"; }

.mdi-map-marker-radius-outline::before {
  content: "\\F12FC"; }

.mdi-map-marker-remove::before {
  content: "\\F0F09"; }

.mdi-map-marker-remove-outline::before {
  content: "\\F12FA"; }

.mdi-map-marker-remove-variant::before {
  content: "\\F0F0A"; }

.mdi-map-marker-right::before {
  content: "\\F12DC"; }

.mdi-map-marker-right-outline::before {
  content: "\\F12DE"; }

.mdi-map-marker-star::before {
  content: "\\F1608"; }

.mdi-map-marker-star-outline::before {
  content: "\\F1609"; }

.mdi-map-marker-up::before {
  content: "\\F1103"; }

.mdi-map-minus::before {
  content: "\\F0981"; }

.mdi-map-outline::before {
  content: "\\F0982"; }

.mdi-map-plus::before {
  content: "\\F0983"; }

.mdi-map-search::before {
  content: "\\F0984"; }

.mdi-map-search-outline::before {
  content: "\\F0985"; }

.mdi-mapbox::before {
  content: "\\F0BAA"; }

.mdi-margin::before {
  content: "\\F0353"; }

.mdi-marker::before {
  content: "\\F0652"; }

.mdi-marker-cancel::before {
  content: "\\F0DD9"; }

.mdi-marker-check::before {
  content: "\\F0355"; }

.mdi-mastodon::before {
  content: "\\F0AD1"; }

.mdi-material-design::before {
  content: "\\F0986"; }

.mdi-material-ui::before {
  content: "\\F0357"; }

.mdi-math-compass::before {
  content: "\\F0358"; }

.mdi-math-cos::before {
  content: "\\F0C96"; }

.mdi-math-integral::before {
  content: "\\F0FC8"; }

.mdi-math-integral-box::before {
  content: "\\F0FC9"; }

.mdi-math-log::before {
  content: "\\F1085"; }

.mdi-math-norm::before {
  content: "\\F0FCA"; }

.mdi-math-norm-box::before {
  content: "\\F0FCB"; }

.mdi-math-sin::before {
  content: "\\F0C97"; }

.mdi-math-tan::before {
  content: "\\F0C98"; }

.mdi-matrix::before {
  content: "\\F0628"; }

.mdi-medal::before {
  content: "\\F0987"; }

.mdi-medal-outline::before {
  content: "\\F1326"; }

.mdi-medical-bag::before {
  content: "\\F06EF"; }

.mdi-meditation::before {
  content: "\\F117B"; }

.mdi-memory::before {
  content: "\\F035B"; }

.mdi-menorah::before {
  content: "\\F17D4"; }

.mdi-menorah-fire::before {
  content: "\\F17D5"; }

.mdi-menu::before {
  content: "\\F035C"; }

.mdi-menu-down::before {
  content: "\\F035D"; }

.mdi-menu-down-outline::before {
  content: "\\F06B6"; }

.mdi-menu-left::before {
  content: "\\F035E"; }

.mdi-menu-left-outline::before {
  content: "\\F0A02"; }

.mdi-menu-open::before {
  content: "\\F0BAB"; }

.mdi-menu-right::before {
  content: "\\F035F"; }

.mdi-menu-right-outline::before {
  content: "\\F0A03"; }

.mdi-menu-swap::before {
  content: "\\F0A64"; }

.mdi-menu-swap-outline::before {
  content: "\\F0A65"; }

.mdi-menu-up::before {
  content: "\\F0360"; }

.mdi-menu-up-outline::before {
  content: "\\F06B7"; }

.mdi-merge::before {
  content: "\\F0F5C"; }

.mdi-message::before {
  content: "\\F0361"; }

.mdi-message-alert::before {
  content: "\\F0362"; }

.mdi-message-alert-outline::before {
  content: "\\F0A04"; }

.mdi-message-arrow-left::before {
  content: "\\F12F2"; }

.mdi-message-arrow-left-outline::before {
  content: "\\F12F3"; }

.mdi-message-arrow-right::before {
  content: "\\F12F4"; }

.mdi-message-arrow-right-outline::before {
  content: "\\F12F5"; }

.mdi-message-badge::before {
  content: "\\F1941"; }

.mdi-message-badge-outline::before {
  content: "\\F1942"; }

.mdi-message-bookmark::before {
  content: "\\F15AC"; }

.mdi-message-bookmark-outline::before {
  content: "\\F15AD"; }

.mdi-message-bulleted::before {
  content: "\\F06A2"; }

.mdi-message-bulleted-off::before {
  content: "\\F06A3"; }

.mdi-message-cog::before {
  content: "\\F06F1"; }

.mdi-message-cog-outline::before {
  content: "\\F1172"; }

.mdi-message-draw::before {
  content: "\\F0363"; }

.mdi-message-flash::before {
  content: "\\F15A9"; }

.mdi-message-flash-outline::before {
  content: "\\F15AA"; }

.mdi-message-image::before {
  content: "\\F0364"; }

.mdi-message-image-outline::before {
  content: "\\F116C"; }

.mdi-message-lock::before {
  content: "\\F0FCC"; }

.mdi-message-lock-outline::before {
  content: "\\F116D"; }

.mdi-message-minus::before {
  content: "\\F116E"; }

.mdi-message-minus-outline::before {
  content: "\\F116F"; }

.mdi-message-off::before {
  content: "\\F164D"; }

.mdi-message-off-outline::before {
  content: "\\F164E"; }

.mdi-message-outline::before {
  content: "\\F0365"; }

.mdi-message-plus::before {
  content: "\\F0653"; }

.mdi-message-plus-outline::before {
  content: "\\F10BB"; }

.mdi-message-processing::before {
  content: "\\F0366"; }

.mdi-message-processing-outline::before {
  content: "\\F1170"; }

.mdi-message-question::before {
  content: "\\F173A"; }

.mdi-message-question-outline::before {
  content: "\\F173B"; }

.mdi-message-reply::before {
  content: "\\F0367"; }

.mdi-message-reply-outline::before {
  content: "\\F173D"; }

.mdi-message-reply-text::before {
  content: "\\F0368"; }

.mdi-message-reply-text-outline::before {
  content: "\\F173E"; }

.mdi-message-settings::before {
  content: "\\F06F0"; }

.mdi-message-settings-outline::before {
  content: "\\F1171"; }

.mdi-message-star::before {
  content: "\\F069A"; }

.mdi-message-star-outline::before {
  content: "\\F1250"; }

.mdi-message-text::before {
  content: "\\F0369"; }

.mdi-message-text-clock::before {
  content: "\\F1173"; }

.mdi-message-text-clock-outline::before {
  content: "\\F1174"; }

.mdi-message-text-lock::before {
  content: "\\F0FCD"; }

.mdi-message-text-lock-outline::before {
  content: "\\F1175"; }

.mdi-message-text-outline::before {
  content: "\\F036A"; }

.mdi-message-video::before {
  content: "\\F036B"; }

.mdi-meteor::before {
  content: "\\F0629"; }

.mdi-metronome::before {
  content: "\\F07DA"; }

.mdi-metronome-tick::before {
  content: "\\F07DB"; }

.mdi-micro-sd::before {
  content: "\\F07DC"; }

.mdi-microphone::before {
  content: "\\F036C"; }

.mdi-microphone-minus::before {
  content: "\\F08B3"; }

.mdi-microphone-off::before {
  content: "\\F036D"; }

.mdi-microphone-outline::before {
  content: "\\F036E"; }

.mdi-microphone-plus::before {
  content: "\\F08B4"; }

.mdi-microphone-question::before {
  content: "\\F1989"; }

.mdi-microphone-question-outline::before {
  content: "\\F198A"; }

.mdi-microphone-settings::before {
  content: "\\F036F"; }

.mdi-microphone-variant::before {
  content: "\\F0370"; }

.mdi-microphone-variant-off::before {
  content: "\\F0371"; }

.mdi-microscope::before {
  content: "\\F0654"; }

.mdi-microsoft::before {
  content: "\\F0372"; }

.mdi-microsoft-access::before {
  content: "\\F138E"; }

.mdi-microsoft-azure::before {
  content: "\\F0805"; }

.mdi-microsoft-azure-devops::before {
  content: "\\F0FD5"; }

.mdi-microsoft-bing::before {
  content: "\\F00A4"; }

.mdi-microsoft-dynamics-365::before {
  content: "\\F0988"; }

.mdi-microsoft-edge::before {
  content: "\\F01E9"; }

.mdi-microsoft-excel::before {
  content: "\\F138F"; }

.mdi-microsoft-internet-explorer::before {
  content: "\\F0300"; }

.mdi-microsoft-office::before {
  content: "\\F03C6"; }

.mdi-microsoft-onedrive::before {
  content: "\\F03CA"; }

.mdi-microsoft-onenote::before {
  content: "\\F0747"; }

.mdi-microsoft-outlook::before {
  content: "\\F0D22"; }

.mdi-microsoft-powerpoint::before {
  content: "\\F1390"; }

.mdi-microsoft-sharepoint::before {
  content: "\\F1391"; }

.mdi-microsoft-teams::before {
  content: "\\F02BB"; }

.mdi-microsoft-visual-studio::before {
  content: "\\F0610"; }

.mdi-microsoft-visual-studio-code::before {
  content: "\\F0A1E"; }

.mdi-microsoft-windows::before {
  content: "\\F05B3"; }

.mdi-microsoft-windows-classic::before {
  content: "\\F0A21"; }

.mdi-microsoft-word::before {
  content: "\\F1392"; }

.mdi-microsoft-xbox::before {
  content: "\\F05B9"; }

.mdi-microsoft-xbox-controller::before {
  content: "\\F05BA"; }

.mdi-microsoft-xbox-controller-battery-alert::before {
  content: "\\F074B"; }

.mdi-microsoft-xbox-controller-battery-charging::before {
  content: "\\F0A22"; }

.mdi-microsoft-xbox-controller-battery-empty::before {
  content: "\\F074C"; }

.mdi-microsoft-xbox-controller-battery-full::before {
  content: "\\F074D"; }

.mdi-microsoft-xbox-controller-battery-low::before {
  content: "\\F074E"; }

.mdi-microsoft-xbox-controller-battery-medium::before {
  content: "\\F074F"; }

.mdi-microsoft-xbox-controller-battery-unknown::before {
  content: "\\F0750"; }

.mdi-microsoft-xbox-controller-menu::before {
  content: "\\F0E6F"; }

.mdi-microsoft-xbox-controller-off::before {
  content: "\\F05BB"; }

.mdi-microsoft-xbox-controller-view::before {
  content: "\\F0E70"; }

.mdi-microwave::before {
  content: "\\F0C99"; }

.mdi-microwave-off::before {
  content: "\\F1423"; }

.mdi-middleware::before {
  content: "\\F0F5D"; }

.mdi-middleware-outline::before {
  content: "\\F0F5E"; }

.mdi-midi::before {
  content: "\\F08F1"; }

.mdi-midi-port::before {
  content: "\\F08F2"; }

.mdi-mine::before {
  content: "\\F0DDA"; }

.mdi-minecraft::before {
  content: "\\F0373"; }

.mdi-mini-sd::before {
  content: "\\F0A05"; }

.mdi-minidisc::before {
  content: "\\F0A06"; }

.mdi-minus::before {
  content: "\\F0374"; }

.mdi-minus-box::before {
  content: "\\F0375"; }

.mdi-minus-box-multiple::before {
  content: "\\F1141"; }

.mdi-minus-box-multiple-outline::before {
  content: "\\F1142"; }

.mdi-minus-box-outline::before {
  content: "\\F06F2"; }

.mdi-minus-circle::before {
  content: "\\F0376"; }

.mdi-minus-circle-multiple::before {
  content: "\\F035A"; }

.mdi-minus-circle-multiple-outline::before {
  content: "\\F0AD3"; }

.mdi-minus-circle-off::before {
  content: "\\F1459"; }

.mdi-minus-circle-off-outline::before {
  content: "\\F145A"; }

.mdi-minus-circle-outline::before {
  content: "\\F0377"; }

.mdi-minus-network::before {
  content: "\\F0378"; }

.mdi-minus-network-outline::before {
  content: "\\F0C9A"; }

.mdi-minus-thick::before {
  content: "\\F1639"; }

.mdi-mirror::before {
  content: "\\F11FD"; }

.mdi-mirror-rectangle::before {
  content: "\\F179F"; }

.mdi-mirror-variant::before {
  content: "\\F17A0"; }

.mdi-mixed-martial-arts::before {
  content: "\\F0D8F"; }

.mdi-mixed-reality::before {
  content: "\\F087F"; }

.mdi-molecule::before {
  content: "\\F0BAC"; }

.mdi-molecule-co::before {
  content: "\\F12FE"; }

.mdi-molecule-co2::before {
  content: "\\F07E4"; }

.mdi-monitor::before {
  content: "\\F0379"; }

.mdi-monitor-cellphone::before {
  content: "\\F0989"; }

.mdi-monitor-cellphone-star::before {
  content: "\\F098A"; }

.mdi-monitor-dashboard::before {
  content: "\\F0A07"; }

.mdi-monitor-edit::before {
  content: "\\F12C6"; }

.mdi-monitor-eye::before {
  content: "\\F13B4"; }

.mdi-monitor-lock::before {
  content: "\\F0DDB"; }

.mdi-monitor-multiple::before {
  content: "\\F037A"; }

.mdi-monitor-off::before {
  content: "\\F0D90"; }

.mdi-monitor-screenshot::before {
  content: "\\F0E51"; }

.mdi-monitor-share::before {
  content: "\\F1483"; }

.mdi-monitor-shimmer::before {
  content: "\\F1104"; }

.mdi-monitor-small::before {
  content: "\\F1876"; }

.mdi-monitor-speaker::before {
  content: "\\F0F5F"; }

.mdi-monitor-speaker-off::before {
  content: "\\F0F60"; }

.mdi-monitor-star::before {
  content: "\\F0DDC"; }

.mdi-moon-first-quarter::before {
  content: "\\F0F61"; }

.mdi-moon-full::before {
  content: "\\F0F62"; }

.mdi-moon-last-quarter::before {
  content: "\\F0F63"; }

.mdi-moon-new::before {
  content: "\\F0F64"; }

.mdi-moon-waning-crescent::before {
  content: "\\F0F65"; }

.mdi-moon-waning-gibbous::before {
  content: "\\F0F66"; }

.mdi-moon-waxing-crescent::before {
  content: "\\F0F67"; }

.mdi-moon-waxing-gibbous::before {
  content: "\\F0F68"; }

.mdi-moped::before {
  content: "\\F1086"; }

.mdi-moped-electric::before {
  content: "\\F15B7"; }

.mdi-moped-electric-outline::before {
  content: "\\F15B8"; }

.mdi-moped-outline::before {
  content: "\\F15B9"; }

.mdi-more::before {
  content: "\\F037B"; }

.mdi-mortar-pestle::before {
  content: "\\F1748"; }

.mdi-mortar-pestle-plus::before {
  content: "\\F03F1"; }

.mdi-mosque::before {
  content: "\\F1827"; }

.mdi-mother-heart::before {
  content: "\\F1314"; }

.mdi-mother-nurse::before {
  content: "\\F0D21"; }

.mdi-motion::before {
  content: "\\F15B2"; }

.mdi-motion-outline::before {
  content: "\\F15B3"; }

.mdi-motion-pause::before {
  content: "\\F1590"; }

.mdi-motion-pause-outline::before {
  content: "\\F1592"; }

.mdi-motion-play::before {
  content: "\\F158F"; }

.mdi-motion-play-outline::before {
  content: "\\F1591"; }

.mdi-motion-sensor::before {
  content: "\\F0D91"; }

.mdi-motion-sensor-off::before {
  content: "\\F1435"; }

.mdi-motorbike::before {
  content: "\\F037C"; }

.mdi-motorbike-electric::before {
  content: "\\F15BA"; }

.mdi-mouse::before {
  content: "\\F037D"; }

.mdi-mouse-bluetooth::before {
  content: "\\F098B"; }

.mdi-mouse-move-down::before {
  content: "\\F1550"; }

.mdi-mouse-move-up::before {
  content: "\\F1551"; }

.mdi-mouse-move-vertical::before {
  content: "\\F1552"; }

.mdi-mouse-off::before {
  content: "\\F037E"; }

.mdi-mouse-variant::before {
  content: "\\F037F"; }

.mdi-mouse-variant-off::before {
  content: "\\F0380"; }

.mdi-move-resize::before {
  content: "\\F0655"; }

.mdi-move-resize-variant::before {
  content: "\\F0656"; }

.mdi-movie::before {
  content: "\\F0381"; }

.mdi-movie-check::before {
  content: "\\F16F3"; }

.mdi-movie-check-outline::before {
  content: "\\F16F4"; }

.mdi-movie-cog::before {
  content: "\\F16F5"; }

.mdi-movie-cog-outline::before {
  content: "\\F16F6"; }

.mdi-movie-edit::before {
  content: "\\F1122"; }

.mdi-movie-edit-outline::before {
  content: "\\F1123"; }

.mdi-movie-filter::before {
  content: "\\F1124"; }

.mdi-movie-filter-outline::before {
  content: "\\F1125"; }

.mdi-movie-minus::before {
  content: "\\F16F7"; }

.mdi-movie-minus-outline::before {
  content: "\\F16F8"; }

.mdi-movie-off::before {
  content: "\\F16F9"; }

.mdi-movie-off-outline::before {
  content: "\\F16FA"; }

.mdi-movie-open::before {
  content: "\\F0FCE"; }

.mdi-movie-open-check::before {
  content: "\\F16FB"; }

.mdi-movie-open-check-outline::before {
  content: "\\F16FC"; }

.mdi-movie-open-cog::before {
  content: "\\F16FD"; }

.mdi-movie-open-cog-outline::before {
  content: "\\F16FE"; }

.mdi-movie-open-edit::before {
  content: "\\F16FF"; }

.mdi-movie-open-edit-outline::before {
  content: "\\F1700"; }

.mdi-movie-open-minus::before {
  content: "\\F1701"; }

.mdi-movie-open-minus-outline::before {
  content: "\\F1702"; }

.mdi-movie-open-off::before {
  content: "\\F1703"; }

.mdi-movie-open-off-outline::before {
  content: "\\F1704"; }

.mdi-movie-open-outline::before {
  content: "\\F0FCF"; }

.mdi-movie-open-play::before {
  content: "\\F1705"; }

.mdi-movie-open-play-outline::before {
  content: "\\F1706"; }

.mdi-movie-open-plus::before {
  content: "\\F1707"; }

.mdi-movie-open-plus-outline::before {
  content: "\\F1708"; }

.mdi-movie-open-remove::before {
  content: "\\F1709"; }

.mdi-movie-open-remove-outline::before {
  content: "\\F170A"; }

.mdi-movie-open-settings::before {
  content: "\\F170B"; }

.mdi-movie-open-settings-outline::before {
  content: "\\F170C"; }

.mdi-movie-open-star::before {
  content: "\\F170D"; }

.mdi-movie-open-star-outline::before {
  content: "\\F170E"; }

.mdi-movie-outline::before {
  content: "\\F0DDD"; }

.mdi-movie-play::before {
  content: "\\F170F"; }

.mdi-movie-play-outline::before {
  content: "\\F1710"; }

.mdi-movie-plus::before {
  content: "\\F1711"; }

.mdi-movie-plus-outline::before {
  content: "\\F1712"; }

.mdi-movie-remove::before {
  content: "\\F1713"; }

.mdi-movie-remove-outline::before {
  content: "\\F1714"; }

.mdi-movie-roll::before {
  content: "\\F07DE"; }

.mdi-movie-search::before {
  content: "\\F11D2"; }

.mdi-movie-search-outline::before {
  content: "\\F11D3"; }

.mdi-movie-settings::before {
  content: "\\F1715"; }

.mdi-movie-settings-outline::before {
  content: "\\F1716"; }

.mdi-movie-star::before {
  content: "\\F1717"; }

.mdi-movie-star-outline::before {
  content: "\\F1718"; }

.mdi-mower::before {
  content: "\\F166F"; }

.mdi-mower-bag::before {
  content: "\\F1670"; }

.mdi-muffin::before {
  content: "\\F098C"; }

.mdi-multicast::before {
  content: "\\F1893"; }

.mdi-multiplication::before {
  content: "\\F0382"; }

.mdi-multiplication-box::before {
  content: "\\F0383"; }

.mdi-mushroom::before {
  content: "\\F07DF"; }

.mdi-mushroom-off::before {
  content: "\\F13FA"; }

.mdi-mushroom-off-outline::before {
  content: "\\F13FB"; }

.mdi-mushroom-outline::before {
  content: "\\F07E0"; }

.mdi-music::before {
  content: "\\F075A"; }

.mdi-music-accidental-double-flat::before {
  content: "\\F0F69"; }

.mdi-music-accidental-double-sharp::before {
  content: "\\F0F6A"; }

.mdi-music-accidental-flat::before {
  content: "\\F0F6B"; }

.mdi-music-accidental-natural::before {
  content: "\\F0F6C"; }

.mdi-music-accidental-sharp::before {
  content: "\\F0F6D"; }

.mdi-music-box::before {
  content: "\\F0384"; }

.mdi-music-box-multiple::before {
  content: "\\F0333"; }

.mdi-music-box-multiple-outline::before {
  content: "\\F0F04"; }

.mdi-music-box-outline::before {
  content: "\\F0385"; }

.mdi-music-circle::before {
  content: "\\F0386"; }

.mdi-music-circle-outline::before {
  content: "\\F0AD4"; }

.mdi-music-clef-alto::before {
  content: "\\F0F6E"; }

.mdi-music-clef-bass::before {
  content: "\\F0F6F"; }

.mdi-music-clef-treble::before {
  content: "\\F0F70"; }

.mdi-music-note::before {
  content: "\\F0387"; }

.mdi-music-note-bluetooth::before {
  content: "\\F05FE"; }

.mdi-music-note-bluetooth-off::before {
  content: "\\F05FF"; }

.mdi-music-note-eighth::before {
  content: "\\F0388"; }

.mdi-music-note-eighth-dotted::before {
  content: "\\F0F71"; }

.mdi-music-note-half::before {
  content: "\\F0389"; }

.mdi-music-note-half-dotted::before {
  content: "\\F0F72"; }

.mdi-music-note-off::before {
  content: "\\F038A"; }

.mdi-music-note-off-outline::before {
  content: "\\F0F73"; }

.mdi-music-note-outline::before {
  content: "\\F0F74"; }

.mdi-music-note-plus::before {
  content: "\\F0DDE"; }

.mdi-music-note-quarter::before {
  content: "\\F038B"; }

.mdi-music-note-quarter-dotted::before {
  content: "\\F0F75"; }

.mdi-music-note-sixteenth::before {
  content: "\\F038C"; }

.mdi-music-note-sixteenth-dotted::before {
  content: "\\F0F76"; }

.mdi-music-note-whole::before {
  content: "\\F038D"; }

.mdi-music-note-whole-dotted::before {
  content: "\\F0F77"; }

.mdi-music-off::before {
  content: "\\F075B"; }

.mdi-music-rest-eighth::before {
  content: "\\F0F78"; }

.mdi-music-rest-half::before {
  content: "\\F0F79"; }

.mdi-music-rest-quarter::before {
  content: "\\F0F7A"; }

.mdi-music-rest-sixteenth::before {
  content: "\\F0F7B"; }

.mdi-music-rest-whole::before {
  content: "\\F0F7C"; }

.mdi-mustache::before {
  content: "\\F15DE"; }

.mdi-nail::before {
  content: "\\F0DDF"; }

.mdi-nas::before {
  content: "\\F08F3"; }

.mdi-nativescript::before {
  content: "\\F0880"; }

.mdi-nature::before {
  content: "\\F038E"; }

.mdi-nature-people::before {
  content: "\\F038F"; }

.mdi-navigation::before {
  content: "\\F0390"; }

.mdi-navigation-outline::before {
  content: "\\F1607"; }

.mdi-navigation-variant::before {
  content: "\\F18F0"; }

.mdi-navigation-variant-outline::before {
  content: "\\F18F1"; }

.mdi-near-me::before {
  content: "\\F05CD"; }

.mdi-necklace::before {
  content: "\\F0F0B"; }

.mdi-needle::before {
  content: "\\F0391"; }

.mdi-netflix::before {
  content: "\\F0746"; }

.mdi-network::before {
  content: "\\F06F3"; }

.mdi-network-off::before {
  content: "\\F0C9B"; }

.mdi-network-off-outline::before {
  content: "\\F0C9C"; }

.mdi-network-outline::before {
  content: "\\F0C9D"; }

.mdi-network-strength-1::before {
  content: "\\F08F4"; }

.mdi-network-strength-1-alert::before {
  content: "\\F08F5"; }

.mdi-network-strength-2::before {
  content: "\\F08F6"; }

.mdi-network-strength-2-alert::before {
  content: "\\F08F7"; }

.mdi-network-strength-3::before {
  content: "\\F08F8"; }

.mdi-network-strength-3-alert::before {
  content: "\\F08F9"; }

.mdi-network-strength-4::before {
  content: "\\F08FA"; }

.mdi-network-strength-4-alert::before {
  content: "\\F08FB"; }

.mdi-network-strength-4-cog::before {
  content: "\\F191A"; }

.mdi-network-strength-off::before {
  content: "\\F08FC"; }

.mdi-network-strength-off-outline::before {
  content: "\\F08FD"; }

.mdi-network-strength-outline::before {
  content: "\\F08FE"; }

.mdi-new-box::before {
  content: "\\F0394"; }

.mdi-newspaper::before {
  content: "\\F0395"; }

.mdi-newspaper-check::before {
  content: "\\F1943"; }

.mdi-newspaper-minus::before {
  content: "\\F0F0C"; }

.mdi-newspaper-plus::before {
  content: "\\F0F0D"; }

.mdi-newspaper-remove::before {
  content: "\\F1944"; }

.mdi-newspaper-variant::before {
  content: "\\F1001"; }

.mdi-newspaper-variant-multiple::before {
  content: "\\F1002"; }

.mdi-newspaper-variant-multiple-outline::before {
  content: "\\F1003"; }

.mdi-newspaper-variant-outline::before {
  content: "\\F1004"; }

.mdi-nfc::before {
  content: "\\F0396"; }

.mdi-nfc-search-variant::before {
  content: "\\F0E53"; }

.mdi-nfc-tap::before {
  content: "\\F0397"; }

.mdi-nfc-variant::before {
  content: "\\F0398"; }

.mdi-nfc-variant-off::before {
  content: "\\F0E54"; }

.mdi-ninja::before {
  content: "\\F0774"; }

.mdi-nintendo-game-boy::before {
  content: "\\F1393"; }

.mdi-nintendo-switch::before {
  content: "\\F07E1"; }

.mdi-nintendo-wii::before {
  content: "\\F05AB"; }

.mdi-nintendo-wiiu::before {
  content: "\\F072D"; }

.mdi-nix::before {
  content: "\\F1105"; }

.mdi-nodejs::before {
  content: "\\F0399"; }

.mdi-noodles::before {
  content: "\\F117E"; }

.mdi-not-equal::before {
  content: "\\F098D"; }

.mdi-not-equal-variant::before {
  content: "\\F098E"; }

.mdi-note::before {
  content: "\\F039A"; }

.mdi-note-alert::before {
  content: "\\F177D"; }

.mdi-note-alert-outline::before {
  content: "\\F177E"; }

.mdi-note-check::before {
  content: "\\F177F"; }

.mdi-note-check-outline::before {
  content: "\\F1780"; }

.mdi-note-edit::before {
  content: "\\F1781"; }

.mdi-note-edit-outline::before {
  content: "\\F1782"; }

.mdi-note-minus::before {
  content: "\\F164F"; }

.mdi-note-minus-outline::before {
  content: "\\F1650"; }

.mdi-note-multiple::before {
  content: "\\F06B8"; }

.mdi-note-multiple-outline::before {
  content: "\\F06B9"; }

.mdi-note-off::before {
  content: "\\F1783"; }

.mdi-note-off-outline::before {
  content: "\\F1784"; }

.mdi-note-outline::before {
  content: "\\F039B"; }

.mdi-note-plus::before {
  content: "\\F039C"; }

.mdi-note-plus-outline::before {
  content: "\\F039D"; }

.mdi-note-remove::before {
  content: "\\F1651"; }

.mdi-note-remove-outline::before {
  content: "\\F1652"; }

.mdi-note-search::before {
  content: "\\F1653"; }

.mdi-note-search-outline::before {
  content: "\\F1654"; }

.mdi-note-text::before {
  content: "\\F039E"; }

.mdi-note-text-outline::before {
  content: "\\F11D7"; }

.mdi-notebook::before {
  content: "\\F082E"; }

.mdi-notebook-check::before {
  content: "\\F14F5"; }

.mdi-notebook-check-outline::before {
  content: "\\F14F6"; }

.mdi-notebook-edit::before {
  content: "\\F14E7"; }

.mdi-notebook-edit-outline::before {
  content: "\\F14E9"; }

.mdi-notebook-minus::before {
  content: "\\F1610"; }

.mdi-notebook-minus-outline::before {
  content: "\\F1611"; }

.mdi-notebook-multiple::before {
  content: "\\F0E55"; }

.mdi-notebook-outline::before {
  content: "\\F0EBF"; }

.mdi-notebook-plus::before {
  content: "\\F1612"; }

.mdi-notebook-plus-outline::before {
  content: "\\F1613"; }

.mdi-notebook-remove::before {
  content: "\\F1614"; }

.mdi-notebook-remove-outline::before {
  content: "\\F1615"; }

.mdi-notification-clear-all::before {
  content: "\\F039F"; }

.mdi-npm::before {
  content: "\\F06F7"; }

.mdi-nuke::before {
  content: "\\F06A4"; }

.mdi-null::before {
  content: "\\F07E2"; }

.mdi-numeric::before {
  content: "\\F03A0"; }

.mdi-numeric-0::before {
  content: "\\F0B39"; }

.mdi-numeric-0-box::before {
  content: "\\F03A1"; }

.mdi-numeric-0-box-multiple::before {
  content: "\\F0F0E"; }

.mdi-numeric-0-box-multiple-outline::before {
  content: "\\F03A2"; }

.mdi-numeric-0-box-outline::before {
  content: "\\F03A3"; }

.mdi-numeric-0-circle::before {
  content: "\\F0C9E"; }

.mdi-numeric-0-circle-outline::before {
  content: "\\F0C9F"; }

.mdi-numeric-1::before {
  content: "\\F0B3A"; }

.mdi-numeric-1-box::before {
  content: "\\F03A4"; }

.mdi-numeric-1-box-multiple::before {
  content: "\\F0F0F"; }

.mdi-numeric-1-box-multiple-outline::before {
  content: "\\F03A5"; }

.mdi-numeric-1-box-outline::before {
  content: "\\F03A6"; }

.mdi-numeric-1-circle::before {
  content: "\\F0CA0"; }

.mdi-numeric-1-circle-outline::before {
  content: "\\F0CA1"; }

.mdi-numeric-10::before {
  content: "\\F0FE9"; }

.mdi-numeric-10-box::before {
  content: "\\F0F7D"; }

.mdi-numeric-10-box-multiple::before {
  content: "\\F0FEA"; }

.mdi-numeric-10-box-multiple-outline::before {
  content: "\\F0FEB"; }

.mdi-numeric-10-box-outline::before {
  content: "\\F0F7E"; }

.mdi-numeric-10-circle::before {
  content: "\\F0FEC"; }

.mdi-numeric-10-circle-outline::before {
  content: "\\F0FED"; }

.mdi-numeric-2::before {
  content: "\\F0B3B"; }

.mdi-numeric-2-box::before {
  content: "\\F03A7"; }

.mdi-numeric-2-box-multiple::before {
  content: "\\F0F10"; }

.mdi-numeric-2-box-multiple-outline::before {
  content: "\\F03A8"; }

.mdi-numeric-2-box-outline::before {
  content: "\\F03A9"; }

.mdi-numeric-2-circle::before {
  content: "\\F0CA2"; }

.mdi-numeric-2-circle-outline::before {
  content: "\\F0CA3"; }

.mdi-numeric-3::before {
  content: "\\F0B3C"; }

.mdi-numeric-3-box::before {
  content: "\\F03AA"; }

.mdi-numeric-3-box-multiple::before {
  content: "\\F0F11"; }

.mdi-numeric-3-box-multiple-outline::before {
  content: "\\F03AB"; }

.mdi-numeric-3-box-outline::before {
  content: "\\F03AC"; }

.mdi-numeric-3-circle::before {
  content: "\\F0CA4"; }

.mdi-numeric-3-circle-outline::before {
  content: "\\F0CA5"; }

.mdi-numeric-4::before {
  content: "\\F0B3D"; }

.mdi-numeric-4-box::before {
  content: "\\F03AD"; }

.mdi-numeric-4-box-multiple::before {
  content: "\\F0F12"; }

.mdi-numeric-4-box-multiple-outline::before {
  content: "\\F03B2"; }

.mdi-numeric-4-box-outline::before {
  content: "\\F03AE"; }

.mdi-numeric-4-circle::before {
  content: "\\F0CA6"; }

.mdi-numeric-4-circle-outline::before {
  content: "\\F0CA7"; }

.mdi-numeric-5::before {
  content: "\\F0B3E"; }

.mdi-numeric-5-box::before {
  content: "\\F03B1"; }

.mdi-numeric-5-box-multiple::before {
  content: "\\F0F13"; }

.mdi-numeric-5-box-multiple-outline::before {
  content: "\\F03AF"; }

.mdi-numeric-5-box-outline::before {
  content: "\\F03B0"; }

.mdi-numeric-5-circle::before {
  content: "\\F0CA8"; }

.mdi-numeric-5-circle-outline::before {
  content: "\\F0CA9"; }

.mdi-numeric-6::before {
  content: "\\F0B3F"; }

.mdi-numeric-6-box::before {
  content: "\\F03B3"; }

.mdi-numeric-6-box-multiple::before {
  content: "\\F0F14"; }

.mdi-numeric-6-box-multiple-outline::before {
  content: "\\F03B4"; }

.mdi-numeric-6-box-outline::before {
  content: "\\F03B5"; }

.mdi-numeric-6-circle::before {
  content: "\\F0CAA"; }

.mdi-numeric-6-circle-outline::before {
  content: "\\F0CAB"; }

.mdi-numeric-7::before {
  content: "\\F0B40"; }

.mdi-numeric-7-box::before {
  content: "\\F03B6"; }

.mdi-numeric-7-box-multiple::before {
  content: "\\F0F15"; }

.mdi-numeric-7-box-multiple-outline::before {
  content: "\\F03B7"; }

.mdi-numeric-7-box-outline::before {
  content: "\\F03B8"; }

.mdi-numeric-7-circle::before {
  content: "\\F0CAC"; }

.mdi-numeric-7-circle-outline::before {
  content: "\\F0CAD"; }

.mdi-numeric-8::before {
  content: "\\F0B41"; }

.mdi-numeric-8-box::before {
  content: "\\F03B9"; }

.mdi-numeric-8-box-multiple::before {
  content: "\\F0F16"; }

.mdi-numeric-8-box-multiple-outline::before {
  content: "\\F03BA"; }

.mdi-numeric-8-box-outline::before {
  content: "\\F03BB"; }

.mdi-numeric-8-circle::before {
  content: "\\F0CAE"; }

.mdi-numeric-8-circle-outline::before {
  content: "\\F0CAF"; }

.mdi-numeric-9::before {
  content: "\\F0B42"; }

.mdi-numeric-9-box::before {
  content: "\\F03BC"; }

.mdi-numeric-9-box-multiple::before {
  content: "\\F0F17"; }

.mdi-numeric-9-box-multiple-outline::before {
  content: "\\F03BD"; }

.mdi-numeric-9-box-outline::before {
  content: "\\F03BE"; }

.mdi-numeric-9-circle::before {
  content: "\\F0CB0"; }

.mdi-numeric-9-circle-outline::before {
  content: "\\F0CB1"; }

.mdi-numeric-9-plus::before {
  content: "\\F0FEE"; }

.mdi-numeric-9-plus-box::before {
  content: "\\F03BF"; }

.mdi-numeric-9-plus-box-multiple::before {
  content: "\\F0F18"; }

.mdi-numeric-9-plus-box-multiple-outline::before {
  content: "\\F03C0"; }

.mdi-numeric-9-plus-box-outline::before {
  content: "\\F03C1"; }

.mdi-numeric-9-plus-circle::before {
  content: "\\F0CB2"; }

.mdi-numeric-9-plus-circle-outline::before {
  content: "\\F0CB3"; }

.mdi-numeric-negative-1::before {
  content: "\\F1052"; }

.mdi-numeric-positive-1::before {
  content: "\\F15CB"; }

.mdi-nut::before {
  content: "\\F06F8"; }

.mdi-nutrition::before {
  content: "\\F03C2"; }

.mdi-nuxt::before {
  content: "\\F1106"; }

.mdi-oar::before {
  content: "\\F067C"; }

.mdi-ocarina::before {
  content: "\\F0DE0"; }

.mdi-oci::before {
  content: "\\F12E9"; }

.mdi-ocr::before {
  content: "\\F113A"; }

.mdi-octagon::before {
  content: "\\F03C3"; }

.mdi-octagon-outline::before {
  content: "\\F03C4"; }

.mdi-octagram::before {
  content: "\\F06F9"; }

.mdi-octagram-outline::before {
  content: "\\F0775"; }

.mdi-octahedron::before {
  content: "\\F1950"; }

.mdi-octahedron-off::before {
  content: "\\F1951"; }

.mdi-odnoklassniki::before {
  content: "\\F03C5"; }

.mdi-offer::before {
  content: "\\F121B"; }

.mdi-office-building::before {
  content: "\\F0991"; }

.mdi-office-building-cog::before {
  content: "\\F1949"; }

.mdi-office-building-cog-outline::before {
  content: "\\F194A"; }

.mdi-office-building-marker::before {
  content: "\\F1520"; }

.mdi-office-building-marker-outline::before {
  content: "\\F1521"; }

.mdi-office-building-outline::before {
  content: "\\F151F"; }

.mdi-oil::before {
  content: "\\F03C7"; }

.mdi-oil-lamp::before {
  content: "\\F0F19"; }

.mdi-oil-level::before {
  content: "\\F1053"; }

.mdi-oil-temperature::before {
  content: "\\F0FF8"; }

.mdi-om::before {
  content: "\\F0973"; }

.mdi-omega::before {
  content: "\\F03C9"; }

.mdi-one-up::before {
  content: "\\F0BAD"; }

.mdi-onepassword::before {
  content: "\\F0881"; }

.mdi-opacity::before {
  content: "\\F05CC"; }

.mdi-open-in-app::before {
  content: "\\F03CB"; }

.mdi-open-in-new::before {
  content: "\\F03CC"; }

.mdi-open-source-initiative::before {
  content: "\\F0BAE"; }

.mdi-openid::before {
  content: "\\F03CD"; }

.mdi-opera::before {
  content: "\\F03CE"; }

.mdi-orbit::before {
  content: "\\F0018"; }

.mdi-orbit-variant::before {
  content: "\\F15DB"; }

.mdi-order-alphabetical-ascending::before {
  content: "\\F020D"; }

.mdi-order-alphabetical-descending::before {
  content: "\\F0D07"; }

.mdi-order-bool-ascending::before {
  content: "\\F02BE"; }

.mdi-order-bool-ascending-variant::before {
  content: "\\F098F"; }

.mdi-order-bool-descending::before {
  content: "\\F1384"; }

.mdi-order-bool-descending-variant::before {
  content: "\\F0990"; }

.mdi-order-numeric-ascending::before {
  content: "\\F0545"; }

.mdi-order-numeric-descending::before {
  content: "\\F0546"; }

.mdi-origin::before {
  content: "\\F0B43"; }

.mdi-ornament::before {
  content: "\\F03CF"; }

.mdi-ornament-variant::before {
  content: "\\F03D0"; }

.mdi-outdoor-lamp::before {
  content: "\\F1054"; }

.mdi-overscan::before {
  content: "\\F1005"; }

.mdi-owl::before {
  content: "\\F03D2"; }

.mdi-pac-man::before {
  content: "\\F0BAF"; }

.mdi-package::before {
  content: "\\F03D3"; }

.mdi-package-down::before {
  content: "\\F03D4"; }

.mdi-package-up::before {
  content: "\\F03D5"; }

.mdi-package-variant::before {
  content: "\\F03D6"; }

.mdi-package-variant-closed::before {
  content: "\\F03D7"; }

.mdi-page-first::before {
  content: "\\F0600"; }

.mdi-page-last::before {
  content: "\\F0601"; }

.mdi-page-layout-body::before {
  content: "\\F06FA"; }

.mdi-page-layout-footer::before {
  content: "\\F06FB"; }

.mdi-page-layout-header::before {
  content: "\\F06FC"; }

.mdi-page-layout-header-footer::before {
  content: "\\F0F7F"; }

.mdi-page-layout-sidebar-left::before {
  content: "\\F06FD"; }

.mdi-page-layout-sidebar-right::before {
  content: "\\F06FE"; }

.mdi-page-next::before {
  content: "\\F0BB0"; }

.mdi-page-next-outline::before {
  content: "\\F0BB1"; }

.mdi-page-previous::before {
  content: "\\F0BB2"; }

.mdi-page-previous-outline::before {
  content: "\\F0BB3"; }

.mdi-pail::before {
  content: "\\F1417"; }

.mdi-pail-minus::before {
  content: "\\F1437"; }

.mdi-pail-minus-outline::before {
  content: "\\F143C"; }

.mdi-pail-off::before {
  content: "\\F1439"; }

.mdi-pail-off-outline::before {
  content: "\\F143E"; }

.mdi-pail-outline::before {
  content: "\\F143A"; }

.mdi-pail-plus::before {
  content: "\\F1436"; }

.mdi-pail-plus-outline::before {
  content: "\\F143B"; }

.mdi-pail-remove::before {
  content: "\\F1438"; }

.mdi-pail-remove-outline::before {
  content: "\\F143D"; }

.mdi-palette::before {
  content: "\\F03D8"; }

.mdi-palette-advanced::before {
  content: "\\F03D9"; }

.mdi-palette-outline::before {
  content: "\\F0E0C"; }

.mdi-palette-swatch::before {
  content: "\\F08B5"; }

.mdi-palette-swatch-outline::before {
  content: "\\F135C"; }

.mdi-palette-swatch-variant::before {
  content: "\\F195A"; }

.mdi-palm-tree::before {
  content: "\\F1055"; }

.mdi-pan::before {
  content: "\\F0BB4"; }

.mdi-pan-bottom-left::before {
  content: "\\F0BB5"; }

.mdi-pan-bottom-right::before {
  content: "\\F0BB6"; }

.mdi-pan-down::before {
  content: "\\F0BB7"; }

.mdi-pan-horizontal::before {
  content: "\\F0BB8"; }

.mdi-pan-left::before {
  content: "\\F0BB9"; }

.mdi-pan-right::before {
  content: "\\F0BBA"; }

.mdi-pan-top-left::before {
  content: "\\F0BBB"; }

.mdi-pan-top-right::before {
  content: "\\F0BBC"; }

.mdi-pan-up::before {
  content: "\\F0BBD"; }

.mdi-pan-vertical::before {
  content: "\\F0BBE"; }

.mdi-panda::before {
  content: "\\F03DA"; }

.mdi-pandora::before {
  content: "\\F03DB"; }

.mdi-panorama::before {
  content: "\\F03DC"; }

.mdi-panorama-fisheye::before {
  content: "\\F03DD"; }

.mdi-panorama-horizontal::before {
  content: "\\F1928"; }

.mdi-panorama-horizontal-outline::before {
  content: "\\F03DE"; }

.mdi-panorama-outline::before {
  content: "\\F198C"; }

.mdi-panorama-sphere::before {
  content: "\\F198D"; }

.mdi-panorama-sphere-outline::before {
  content: "\\F198E"; }

.mdi-panorama-variant::before {
  content: "\\F198F"; }

.mdi-panorama-variant-outline::before {
  content: "\\F1990"; }

.mdi-panorama-vertical::before {
  content: "\\F1929"; }

.mdi-panorama-vertical-outline::before {
  content: "\\F03DF"; }

.mdi-panorama-wide-angle::before {
  content: "\\F195F"; }

.mdi-panorama-wide-angle-outline::before {
  content: "\\F03E0"; }

.mdi-paper-cut-vertical::before {
  content: "\\F03E1"; }

.mdi-paper-roll::before {
  content: "\\F1157"; }

.mdi-paper-roll-outline::before {
  content: "\\F1158"; }

.mdi-paperclip::before {
  content: "\\F03E2"; }

.mdi-parachute::before {
  content: "\\F0CB4"; }

.mdi-parachute-outline::before {
  content: "\\F0CB5"; }

.mdi-paragliding::before {
  content: "\\F1745"; }

.mdi-parking::before {
  content: "\\F03E3"; }

.mdi-party-popper::before {
  content: "\\F1056"; }

.mdi-passport::before {
  content: "\\F07E3"; }

.mdi-passport-biometric::before {
  content: "\\F0DE1"; }

.mdi-pasta::before {
  content: "\\F1160"; }

.mdi-patio-heater::before {
  content: "\\F0F80"; }

.mdi-patreon::before {
  content: "\\F0882"; }

.mdi-pause::before {
  content: "\\F03E4"; }

.mdi-pause-circle::before {
  content: "\\F03E5"; }

.mdi-pause-circle-outline::before {
  content: "\\F03E6"; }

.mdi-pause-octagon::before {
  content: "\\F03E7"; }

.mdi-pause-octagon-outline::before {
  content: "\\F03E8"; }

.mdi-paw::before {
  content: "\\F03E9"; }

.mdi-paw-off::before {
  content: "\\F0657"; }

.mdi-paw-off-outline::before {
  content: "\\F1676"; }

.mdi-paw-outline::before {
  content: "\\F1675"; }

.mdi-peace::before {
  content: "\\F0884"; }

.mdi-peanut::before {
  content: "\\F0FFC"; }

.mdi-peanut-off::before {
  content: "\\F0FFD"; }

.mdi-peanut-off-outline::before {
  content: "\\F0FFF"; }

.mdi-peanut-outline::before {
  content: "\\F0FFE"; }

.mdi-pen::before {
  content: "\\F03EA"; }

.mdi-pen-lock::before {
  content: "\\F0DE2"; }

.mdi-pen-minus::before {
  content: "\\F0DE3"; }

.mdi-pen-off::before {
  content: "\\F0DE4"; }

.mdi-pen-plus::before {
  content: "\\F0DE5"; }

.mdi-pen-remove::before {
  content: "\\F0DE6"; }

.mdi-pencil::before {
  content: "\\F03EB"; }

.mdi-pencil-box::before {
  content: "\\F03EC"; }

.mdi-pencil-box-multiple::before {
  content: "\\F1144"; }

.mdi-pencil-box-multiple-outline::before {
  content: "\\F1145"; }

.mdi-pencil-box-outline::before {
  content: "\\F03ED"; }

.mdi-pencil-circle::before {
  content: "\\F06FF"; }

.mdi-pencil-circle-outline::before {
  content: "\\F0776"; }

.mdi-pencil-lock::before {
  content: "\\F03EE"; }

.mdi-pencil-lock-outline::before {
  content: "\\F0DE7"; }

.mdi-pencil-minus::before {
  content: "\\F0DE8"; }

.mdi-pencil-minus-outline::before {
  content: "\\F0DE9"; }

.mdi-pencil-off::before {
  content: "\\F03EF"; }

.mdi-pencil-off-outline::before {
  content: "\\F0DEA"; }

.mdi-pencil-outline::before {
  content: "\\F0CB6"; }

.mdi-pencil-plus::before {
  content: "\\F0DEB"; }

.mdi-pencil-plus-outline::before {
  content: "\\F0DEC"; }

.mdi-pencil-remove::before {
  content: "\\F0DED"; }

.mdi-pencil-remove-outline::before {
  content: "\\F0DEE"; }

.mdi-pencil-ruler::before {
  content: "\\F1353"; }

.mdi-penguin::before {
  content: "\\F0EC0"; }

.mdi-pentagon::before {
  content: "\\F0701"; }

.mdi-pentagon-outline::before {
  content: "\\F0700"; }

.mdi-pentagram::before {
  content: "\\F1667"; }

.mdi-percent::before {
  content: "\\F03F0"; }

.mdi-percent-outline::before {
  content: "\\F1278"; }

.mdi-periodic-table::before {
  content: "\\F08B6"; }

.mdi-perspective-less::before {
  content: "\\F0D23"; }

.mdi-perspective-more::before {
  content: "\\F0D24"; }

.mdi-ph::before {
  content: "\\F17C5"; }

.mdi-phone::before {
  content: "\\F03F2"; }

.mdi-phone-alert::before {
  content: "\\F0F1A"; }

.mdi-phone-alert-outline::before {
  content: "\\F118E"; }

.mdi-phone-bluetooth::before {
  content: "\\F03F3"; }

.mdi-phone-bluetooth-outline::before {
  content: "\\F118F"; }

.mdi-phone-cancel::before {
  content: "\\F10BC"; }

.mdi-phone-cancel-outline::before {
  content: "\\F1190"; }

.mdi-phone-check::before {
  content: "\\F11A9"; }

.mdi-phone-check-outline::before {
  content: "\\F11AA"; }

.mdi-phone-classic::before {
  content: "\\F0602"; }

.mdi-phone-classic-off::before {
  content: "\\F1279"; }

.mdi-phone-dial::before {
  content: "\\F1559"; }

.mdi-phone-dial-outline::before {
  content: "\\F155A"; }

.mdi-phone-forward::before {
  content: "\\F03F4"; }

.mdi-phone-forward-outline::before {
  content: "\\F1191"; }

.mdi-phone-hangup::before {
  content: "\\F03F5"; }

.mdi-phone-hangup-outline::before {
  content: "\\F1192"; }

.mdi-phone-in-talk::before {
  content: "\\F03F6"; }

.mdi-phone-in-talk-outline::before {
  content: "\\F1182"; }

.mdi-phone-incoming::before {
  content: "\\F03F7"; }

.mdi-phone-incoming-outline::before {
  content: "\\F1193"; }

.mdi-phone-lock::before {
  content: "\\F03F8"; }

.mdi-phone-lock-outline::before {
  content: "\\F1194"; }

.mdi-phone-log::before {
  content: "\\F03F9"; }

.mdi-phone-log-outline::before {
  content: "\\F1195"; }

.mdi-phone-message::before {
  content: "\\F1196"; }

.mdi-phone-message-outline::before {
  content: "\\F1197"; }

.mdi-phone-minus::before {
  content: "\\F0658"; }

.mdi-phone-minus-outline::before {
  content: "\\F1198"; }

.mdi-phone-missed::before {
  content: "\\F03FA"; }

.mdi-phone-missed-outline::before {
  content: "\\F11A5"; }

.mdi-phone-off::before {
  content: "\\F0DEF"; }

.mdi-phone-off-outline::before {
  content: "\\F11A6"; }

.mdi-phone-outgoing::before {
  content: "\\F03FB"; }

.mdi-phone-outgoing-outline::before {
  content: "\\F1199"; }

.mdi-phone-outline::before {
  content: "\\F0DF0"; }

.mdi-phone-paused::before {
  content: "\\F03FC"; }

.mdi-phone-paused-outline::before {
  content: "\\F119A"; }

.mdi-phone-plus::before {
  content: "\\F0659"; }

.mdi-phone-plus-outline::before {
  content: "\\F119B"; }

.mdi-phone-refresh::before {
  content: "\\F1993"; }

.mdi-phone-refresh-outline::before {
  content: "\\F1994"; }

.mdi-phone-remove::before {
  content: "\\F152F"; }

.mdi-phone-remove-outline::before {
  content: "\\F1530"; }

.mdi-phone-return::before {
  content: "\\F082F"; }

.mdi-phone-return-outline::before {
  content: "\\F119C"; }

.mdi-phone-ring::before {
  content: "\\F11AB"; }

.mdi-phone-ring-outline::before {
  content: "\\F11AC"; }

.mdi-phone-rotate-landscape::before {
  content: "\\F0885"; }

.mdi-phone-rotate-portrait::before {
  content: "\\F0886"; }

.mdi-phone-settings::before {
  content: "\\F03FD"; }

.mdi-phone-settings-outline::before {
  content: "\\F119D"; }

.mdi-phone-sync::before {
  content: "\\F1995"; }

.mdi-phone-sync-outline::before {
  content: "\\F1996"; }

.mdi-phone-voip::before {
  content: "\\F03FE"; }

.mdi-pi::before {
  content: "\\F03FF"; }

.mdi-pi-box::before {
  content: "\\F0400"; }

.mdi-pi-hole::before {
  content: "\\F0DF1"; }

.mdi-piano::before {
  content: "\\F067D"; }

.mdi-piano-off::before {
  content: "\\F0698"; }

.mdi-pickaxe::before {
  content: "\\F08B7"; }

.mdi-picture-in-picture-bottom-right::before {
  content: "\\F0E57"; }

.mdi-picture-in-picture-bottom-right-outline::before {
  content: "\\F0E58"; }

.mdi-picture-in-picture-top-right::before {
  content: "\\F0E59"; }

.mdi-picture-in-picture-top-right-outline::before {
  content: "\\F0E5A"; }

.mdi-pier::before {
  content: "\\F0887"; }

.mdi-pier-crane::before {
  content: "\\F0888"; }

.mdi-pig::before {
  content: "\\F0401"; }

.mdi-pig-variant::before {
  content: "\\F1006"; }

.mdi-pig-variant-outline::before {
  content: "\\F1678"; }

.mdi-piggy-bank::before {
  content: "\\F1007"; }

.mdi-piggy-bank-outline::before {
  content: "\\F1679"; }

.mdi-pill::before {
  content: "\\F0402"; }

.mdi-pillar::before {
  content: "\\F0702"; }

.mdi-pin::before {
  content: "\\F0403"; }

.mdi-pin-off::before {
  content: "\\F0404"; }

.mdi-pin-off-outline::before {
  content: "\\F0930"; }

.mdi-pin-outline::before {
  content: "\\F0931"; }

.mdi-pine-tree::before {
  content: "\\F0405"; }

.mdi-pine-tree-box::before {
  content: "\\F0406"; }

.mdi-pine-tree-fire::before {
  content: "\\F141A"; }

.mdi-pinterest::before {
  content: "\\F0407"; }

.mdi-pinwheel::before {
  content: "\\F0AD5"; }

.mdi-pinwheel-outline::before {
  content: "\\F0AD6"; }

.mdi-pipe::before {
  content: "\\F07E5"; }

.mdi-pipe-disconnected::before {
  content: "\\F07E6"; }

.mdi-pipe-leak::before {
  content: "\\F0889"; }

.mdi-pipe-valve::before {
  content: "\\F184D"; }

.mdi-pipe-wrench::before {
  content: "\\F1354"; }

.mdi-pirate::before {
  content: "\\F0A08"; }

.mdi-pistol::before {
  content: "\\F0703"; }

.mdi-piston::before {
  content: "\\F088A"; }

.mdi-pitchfork::before {
  content: "\\F1553"; }

.mdi-pizza::before {
  content: "\\F0409"; }

.mdi-play::before {
  content: "\\F040A"; }

.mdi-play-box::before {
  content: "\\F127A"; }

.mdi-play-box-multiple::before {
  content: "\\F0D19"; }

.mdi-play-box-multiple-outline::before {
  content: "\\F13E6"; }

.mdi-play-box-outline::before {
  content: "\\F040B"; }

.mdi-play-circle::before {
  content: "\\F040C"; }

.mdi-play-circle-outline::before {
  content: "\\F040D"; }

.mdi-play-network::before {
  content: "\\F088B"; }

.mdi-play-network-outline::before {
  content: "\\F0CB7"; }

.mdi-play-outline::before {
  content: "\\F0F1B"; }

.mdi-play-pause::before {
  content: "\\F040E"; }

.mdi-play-protected-content::before {
  content: "\\F040F"; }

.mdi-play-speed::before {
  content: "\\F08FF"; }

.mdi-playlist-check::before {
  content: "\\F05C7"; }

.mdi-playlist-edit::before {
  content: "\\F0900"; }

.mdi-playlist-minus::before {
  content: "\\F0410"; }

.mdi-playlist-music::before {
  content: "\\F0CB8"; }

.mdi-playlist-music-outline::before {
  content: "\\F0CB9"; }

.mdi-playlist-play::before {
  content: "\\F0411"; }

.mdi-playlist-plus::before {
  content: "\\F0412"; }

.mdi-playlist-remove::before {
  content: "\\F0413"; }

.mdi-playlist-star::before {
  content: "\\F0DF2"; }

.mdi-plex::before {
  content: "\\F06BA"; }

.mdi-pliers::before {
  content: "\\F19A4"; }

.mdi-plus::before {
  content: "\\F0415"; }

.mdi-plus-box::before {
  content: "\\F0416"; }

.mdi-plus-box-multiple::before {
  content: "\\F0334"; }

.mdi-plus-box-multiple-outline::before {
  content: "\\F1143"; }

.mdi-plus-box-outline::before {
  content: "\\F0704"; }

.mdi-plus-circle::before {
  content: "\\F0417"; }

.mdi-plus-circle-multiple::before {
  content: "\\F034C"; }

.mdi-plus-circle-multiple-outline::before {
  content: "\\F0418"; }

.mdi-plus-circle-outline::before {
  content: "\\F0419"; }

.mdi-plus-minus::before {
  content: "\\F0992"; }

.mdi-plus-minus-box::before {
  content: "\\F0993"; }

.mdi-plus-minus-variant::before {
  content: "\\F14C9"; }

.mdi-plus-network::before {
  content: "\\F041A"; }

.mdi-plus-network-outline::before {
  content: "\\F0CBA"; }

.mdi-plus-outline::before {
  content: "\\F0705"; }

.mdi-plus-thick::before {
  content: "\\F11EC"; }

.mdi-podcast::before {
  content: "\\F0994"; }

.mdi-podium::before {
  content: "\\F0D25"; }

.mdi-podium-bronze::before {
  content: "\\F0D26"; }

.mdi-podium-gold::before {
  content: "\\F0D27"; }

.mdi-podium-silver::before {
  content: "\\F0D28"; }

.mdi-point-of-sale::before {
  content: "\\F0D92"; }

.mdi-pokeball::before {
  content: "\\F041D"; }

.mdi-pokemon-go::before {
  content: "\\F0A09"; }

.mdi-poker-chip::before {
  content: "\\F0830"; }

.mdi-polaroid::before {
  content: "\\F041E"; }

.mdi-police-badge::before {
  content: "\\F1167"; }

.mdi-police-badge-outline::before {
  content: "\\F1168"; }

.mdi-police-station::before {
  content: "\\F1839"; }

.mdi-poll::before {
  content: "\\F041F"; }

.mdi-polo::before {
  content: "\\F14C3"; }

.mdi-polymer::before {
  content: "\\F0421"; }

.mdi-pool::before {
  content: "\\F0606"; }

.mdi-popcorn::before {
  content: "\\F0422"; }

.mdi-post::before {
  content: "\\F1008"; }

.mdi-post-outline::before {
  content: "\\F1009"; }

.mdi-postage-stamp::before {
  content: "\\F0CBB"; }

.mdi-pot::before {
  content: "\\F02E5"; }

.mdi-pot-mix::before {
  content: "\\F065B"; }

.mdi-pot-mix-outline::before {
  content: "\\F0677"; }

.mdi-pot-outline::before {
  content: "\\F02FF"; }

.mdi-pot-steam::before {
  content: "\\F065A"; }

.mdi-pot-steam-outline::before {
  content: "\\F0326"; }

.mdi-pound::before {
  content: "\\F0423"; }

.mdi-pound-box::before {
  content: "\\F0424"; }

.mdi-pound-box-outline::before {
  content: "\\F117F"; }

.mdi-power::before {
  content: "\\F0425"; }

.mdi-power-cycle::before {
  content: "\\F0901"; }

.mdi-power-off::before {
  content: "\\F0902"; }

.mdi-power-on::before {
  content: "\\F0903"; }

.mdi-power-plug::before {
  content: "\\F06A5"; }

.mdi-power-plug-off::before {
  content: "\\F06A6"; }

.mdi-power-plug-off-outline::before {
  content: "\\F1424"; }

.mdi-power-plug-outline::before {
  content: "\\F1425"; }

.mdi-power-settings::before {
  content: "\\F0426"; }

.mdi-power-sleep::before {
  content: "\\F0904"; }

.mdi-power-socket::before {
  content: "\\F0427"; }

.mdi-power-socket-au::before {
  content: "\\F0905"; }

.mdi-power-socket-ch::before {
  content: "\\F0FB3"; }

.mdi-power-socket-de::before {
  content: "\\F1107"; }

.mdi-power-socket-eu::before {
  content: "\\F07E7"; }

.mdi-power-socket-fr::before {
  content: "\\F1108"; }

.mdi-power-socket-it::before {
  content: "\\F14FF"; }

.mdi-power-socket-jp::before {
  content: "\\F1109"; }

.mdi-power-socket-uk::before {
  content: "\\F07E8"; }

.mdi-power-socket-us::before {
  content: "\\F07E9"; }

.mdi-power-standby::before {
  content: "\\F0906"; }

.mdi-powershell::before {
  content: "\\F0A0A"; }

.mdi-prescription::before {
  content: "\\F0706"; }

.mdi-presentation::before {
  content: "\\F0428"; }

.mdi-presentation-play::before {
  content: "\\F0429"; }

.mdi-pretzel::before {
  content: "\\F1562"; }

.mdi-printer::before {
  content: "\\F042A"; }

.mdi-printer-3d::before {
  content: "\\F042B"; }

.mdi-printer-3d-nozzle::before {
  content: "\\F0E5B"; }

.mdi-printer-3d-nozzle-alert::before {
  content: "\\F11C0"; }

.mdi-printer-3d-nozzle-alert-outline::before {
  content: "\\F11C1"; }

.mdi-printer-3d-nozzle-heat::before {
  content: "\\F18B8"; }

.mdi-printer-3d-nozzle-heat-outline::before {
  content: "\\F18B9"; }

.mdi-printer-3d-nozzle-outline::before {
  content: "\\F0E5C"; }

.mdi-printer-alert::before {
  content: "\\F042C"; }

.mdi-printer-check::before {
  content: "\\F1146"; }

.mdi-printer-eye::before {
  content: "\\F1458"; }

.mdi-printer-off::before {
  content: "\\F0E5D"; }

.mdi-printer-off-outline::before {
  content: "\\F1785"; }

.mdi-printer-outline::before {
  content: "\\F1786"; }

.mdi-printer-pos::before {
  content: "\\F1057"; }

.mdi-printer-search::before {
  content: "\\F1457"; }

.mdi-printer-settings::before {
  content: "\\F0707"; }

.mdi-printer-wireless::before {
  content: "\\F0A0B"; }

.mdi-priority-high::before {
  content: "\\F0603"; }

.mdi-priority-low::before {
  content: "\\F0604"; }

.mdi-professional-hexagon::before {
  content: "\\F042D"; }

.mdi-progress-alert::before {
  content: "\\F0CBC"; }

.mdi-progress-check::before {
  content: "\\F0995"; }

.mdi-progress-clock::before {
  content: "\\F0996"; }

.mdi-progress-close::before {
  content: "\\F110A"; }

.mdi-progress-download::before {
  content: "\\F0997"; }

.mdi-progress-pencil::before {
  content: "\\F1787"; }

.mdi-progress-question::before {
  content: "\\F1522"; }

.mdi-progress-star::before {
  content: "\\F1788"; }

.mdi-progress-upload::before {
  content: "\\F0998"; }

.mdi-progress-wrench::before {
  content: "\\F0CBD"; }

.mdi-projector::before {
  content: "\\F042E"; }

.mdi-projector-screen::before {
  content: "\\F042F"; }

.mdi-projector-screen-off::before {
  content: "\\F180D"; }

.mdi-projector-screen-off-outline::before {
  content: "\\F180E"; }

.mdi-projector-screen-outline::before {
  content: "\\F1724"; }

.mdi-projector-screen-variant::before {
  content: "\\F180F"; }

.mdi-projector-screen-variant-off::before {
  content: "\\F1810"; }

.mdi-projector-screen-variant-off-outline::before {
  content: "\\F1811"; }

.mdi-projector-screen-variant-outline::before {
  content: "\\F1812"; }

.mdi-propane-tank::before {
  content: "\\F1357"; }

.mdi-propane-tank-outline::before {
  content: "\\F1358"; }

.mdi-protocol::before {
  content: "\\F0FD8"; }

.mdi-publish::before {
  content: "\\F06A7"; }

.mdi-publish-off::before {
  content: "\\F1945"; }

.mdi-pulse::before {
  content: "\\F0430"; }

.mdi-pump::before {
  content: "\\F1402"; }

.mdi-pumpkin::before {
  content: "\\F0BBF"; }

.mdi-purse::before {
  content: "\\F0F1C"; }

.mdi-purse-outline::before {
  content: "\\F0F1D"; }

.mdi-puzzle::before {
  content: "\\F0431"; }

.mdi-puzzle-check::before {
  content: "\\F1426"; }

.mdi-puzzle-check-outline::before {
  content: "\\F1427"; }

.mdi-puzzle-edit::before {
  content: "\\F14D3"; }

.mdi-puzzle-edit-outline::before {
  content: "\\F14D9"; }

.mdi-puzzle-heart::before {
  content: "\\F14D4"; }

.mdi-puzzle-heart-outline::before {
  content: "\\F14DA"; }

.mdi-puzzle-minus::before {
  content: "\\F14D1"; }

.mdi-puzzle-minus-outline::before {
  content: "\\F14D7"; }

.mdi-puzzle-outline::before {
  content: "\\F0A66"; }

.mdi-puzzle-plus::before {
  content: "\\F14D0"; }

.mdi-puzzle-plus-outline::before {
  content: "\\F14D6"; }

.mdi-puzzle-remove::before {
  content: "\\F14D2"; }

.mdi-puzzle-remove-outline::before {
  content: "\\F14D8"; }

.mdi-puzzle-star::before {
  content: "\\F14D5"; }

.mdi-puzzle-star-outline::before {
  content: "\\F14DB"; }

.mdi-pyramid::before {
  content: "\\F1952"; }

.mdi-pyramid-off::before {
  content: "\\F1953"; }

.mdi-qi::before {
  content: "\\F0999"; }

.mdi-qqchat::before {
  content: "\\F0605"; }

.mdi-qrcode::before {
  content: "\\F0432"; }

.mdi-qrcode-edit::before {
  content: "\\F08B8"; }

.mdi-qrcode-minus::before {
  content: "\\F118C"; }

.mdi-qrcode-plus::before {
  content: "\\F118B"; }

.mdi-qrcode-remove::before {
  content: "\\F118D"; }

.mdi-qrcode-scan::before {
  content: "\\F0433"; }

.mdi-quadcopter::before {
  content: "\\F0434"; }

.mdi-quality-high::before {
  content: "\\F0435"; }

.mdi-quality-low::before {
  content: "\\F0A0C"; }

.mdi-quality-medium::before {
  content: "\\F0A0D"; }

.mdi-quora::before {
  content: "\\F0D29"; }

.mdi-rabbit::before {
  content: "\\F0907"; }

.mdi-racing-helmet::before {
  content: "\\F0D93"; }

.mdi-racquetball::before {
  content: "\\F0D94"; }

.mdi-radar::before {
  content: "\\F0437"; }

.mdi-radiator::before {
  content: "\\F0438"; }

.mdi-radiator-disabled::before {
  content: "\\F0AD7"; }

.mdi-radiator-off::before {
  content: "\\F0AD8"; }

.mdi-radio::before {
  content: "\\F0439"; }

.mdi-radio-am::before {
  content: "\\F0CBE"; }

.mdi-radio-fm::before {
  content: "\\F0CBF"; }

.mdi-radio-handheld::before {
  content: "\\F043A"; }

.mdi-radio-off::before {
  content: "\\F121C"; }

.mdi-radio-tower::before {
  content: "\\F043B"; }

.mdi-radioactive::before {
  content: "\\F043C"; }

.mdi-radioactive-circle::before {
  content: "\\F185D"; }

.mdi-radioactive-circle-outline::before {
  content: "\\F185E"; }

.mdi-radioactive-off::before {
  content: "\\F0EC1"; }

.mdi-radiobox-blank::before {
  content: "\\F043D"; }

.mdi-radiobox-marked::before {
  content: "\\F043E"; }

.mdi-radiology-box::before {
  content: "\\F14C5"; }

.mdi-radiology-box-outline::before {
  content: "\\F14C6"; }

.mdi-radius::before {
  content: "\\F0CC0"; }

.mdi-radius-outline::before {
  content: "\\F0CC1"; }

.mdi-railroad-light::before {
  content: "\\F0F1E"; }

.mdi-rake::before {
  content: "\\F1544"; }

.mdi-raspberry-pi::before {
  content: "\\F043F"; }

.mdi-ray-end::before {
  content: "\\F0440"; }

.mdi-ray-end-arrow::before {
  content: "\\F0441"; }

.mdi-ray-start::before {
  content: "\\F0442"; }

.mdi-ray-start-arrow::before {
  content: "\\F0443"; }

.mdi-ray-start-end::before {
  content: "\\F0444"; }

.mdi-ray-start-vertex-end::before {
  content: "\\F15D8"; }

.mdi-ray-vertex::before {
  content: "\\F0445"; }

.mdi-razor-double-edge::before {
  content: "\\F1997"; }

.mdi-razor-single-edge::before {
  content: "\\F1998"; }

.mdi-react::before {
  content: "\\F0708"; }

.mdi-read::before {
  content: "\\F0447"; }

.mdi-receipt::before {
  content: "\\F0449"; }

.mdi-record::before {
  content: "\\F044A"; }

.mdi-record-circle::before {
  content: "\\F0EC2"; }

.mdi-record-circle-outline::before {
  content: "\\F0EC3"; }

.mdi-record-player::before {
  content: "\\F099A"; }

.mdi-record-rec::before {
  content: "\\F044B"; }

.mdi-rectangle::before {
  content: "\\F0E5E"; }

.mdi-rectangle-outline::before {
  content: "\\F0E5F"; }

.mdi-recycle::before {
  content: "\\F044C"; }

.mdi-recycle-variant::before {
  content: "\\F139D"; }

.mdi-reddit::before {
  content: "\\F044D"; }

.mdi-redhat::before {
  content: "\\F111B"; }

.mdi-redo::before {
  content: "\\F044E"; }

.mdi-redo-variant::before {
  content: "\\F044F"; }

.mdi-reflect-horizontal::before {
  content: "\\F0A0E"; }

.mdi-reflect-vertical::before {
  content: "\\F0A0F"; }

.mdi-refresh::before {
  content: "\\F0450"; }

.mdi-refresh-auto::before {
  content: "\\F18F2"; }

.mdi-refresh-circle::before {
  content: "\\F1377"; }

.mdi-regex::before {
  content: "\\F0451"; }

.mdi-registered-trademark::before {
  content: "\\F0A67"; }

.mdi-reiterate::before {
  content: "\\F1588"; }

.mdi-relation-many-to-many::before {
  content: "\\F1496"; }

.mdi-relation-many-to-one::before {
  content: "\\F1497"; }

.mdi-relation-many-to-one-or-many::before {
  content: "\\F1498"; }

.mdi-relation-many-to-only-one::before {
  content: "\\F1499"; }

.mdi-relation-many-to-zero-or-many::before {
  content: "\\F149A"; }

.mdi-relation-many-to-zero-or-one::before {
  content: "\\F149B"; }

.mdi-relation-one-or-many-to-many::before {
  content: "\\F149C"; }

.mdi-relation-one-or-many-to-one::before {
  content: "\\F149D"; }

.mdi-relation-one-or-many-to-one-or-many::before {
  content: "\\F149E"; }

.mdi-relation-one-or-many-to-only-one::before {
  content: "\\F149F"; }

.mdi-relation-one-or-many-to-zero-or-many::before {
  content: "\\F14A0"; }

.mdi-relation-one-or-many-to-zero-or-one::before {
  content: "\\F14A1"; }

.mdi-relation-one-to-many::before {
  content: "\\F14A2"; }

.mdi-relation-one-to-one::before {
  content: "\\F14A3"; }

.mdi-relation-one-to-one-or-many::before {
  content: "\\F14A4"; }

.mdi-relation-one-to-only-one::before {
  content: "\\F14A5"; }

.mdi-relation-one-to-zero-or-many::before {
  content: "\\F14A6"; }

.mdi-relation-one-to-zero-or-one::before {
  content: "\\F14A7"; }

.mdi-relation-only-one-to-many::before {
  content: "\\F14A8"; }

.mdi-relation-only-one-to-one::before {
  content: "\\F14A9"; }

.mdi-relation-only-one-to-one-or-many::before {
  content: "\\F14AA"; }

.mdi-relation-only-one-to-only-one::before {
  content: "\\F14AB"; }

.mdi-relation-only-one-to-zero-or-many::before {
  content: "\\F14AC"; }

.mdi-relation-only-one-to-zero-or-one::before {
  content: "\\F14AD"; }

.mdi-relation-zero-or-many-to-many::before {
  content: "\\F14AE"; }

.mdi-relation-zero-or-many-to-one::before {
  content: "\\F14AF"; }

.mdi-relation-zero-or-many-to-one-or-many::before {
  content: "\\F14B0"; }

.mdi-relation-zero-or-many-to-only-one::before {
  content: "\\F14B1"; }

.mdi-relation-zero-or-many-to-zero-or-many::before {
  content: "\\F14B2"; }

.mdi-relation-zero-or-many-to-zero-or-one::before {
  content: "\\F14B3"; }

.mdi-relation-zero-or-one-to-many::before {
  content: "\\F14B4"; }

.mdi-relation-zero-or-one-to-one::before {
  content: "\\F14B5"; }

.mdi-relation-zero-or-one-to-one-or-many::before {
  content: "\\F14B6"; }

.mdi-relation-zero-or-one-to-only-one::before {
  content: "\\F14B7"; }

.mdi-relation-zero-or-one-to-zero-or-many::before {
  content: "\\F14B8"; }

.mdi-relation-zero-or-one-to-zero-or-one::before {
  content: "\\F14B9"; }

.mdi-relative-scale::before {
  content: "\\F0452"; }

.mdi-reload::before {
  content: "\\F0453"; }

.mdi-reload-alert::before {
  content: "\\F110B"; }

.mdi-reminder::before {
  content: "\\F088C"; }

.mdi-remote::before {
  content: "\\F0454"; }

.mdi-remote-desktop::before {
  content: "\\F08B9"; }

.mdi-remote-off::before {
  content: "\\F0EC4"; }

.mdi-remote-tv::before {
  content: "\\F0EC5"; }

.mdi-remote-tv-off::before {
  content: "\\F0EC6"; }

.mdi-rename-box::before {
  content: "\\F0455"; }

.mdi-reorder-horizontal::before {
  content: "\\F0688"; }

.mdi-reorder-vertical::before {
  content: "\\F0689"; }

.mdi-repeat::before {
  content: "\\F0456"; }

.mdi-repeat-off::before {
  content: "\\F0457"; }

.mdi-repeat-once::before {
  content: "\\F0458"; }

.mdi-repeat-variant::before {
  content: "\\F0547"; }

.mdi-replay::before {
  content: "\\F0459"; }

.mdi-reply::before {
  content: "\\F045A"; }

.mdi-reply-all::before {
  content: "\\F045B"; }

.mdi-reply-all-outline::before {
  content: "\\F0F1F"; }

.mdi-reply-circle::before {
  content: "\\F11AE"; }

.mdi-reply-outline::before {
  content: "\\F0F20"; }

.mdi-reproduction::before {
  content: "\\F045C"; }

.mdi-resistor::before {
  content: "\\F0B44"; }

.mdi-resistor-nodes::before {
  content: "\\F0B45"; }

.mdi-resize::before {
  content: "\\F0A68"; }

.mdi-resize-bottom-right::before {
  content: "\\F045D"; }

.mdi-responsive::before {
  content: "\\F045E"; }

.mdi-restart::before {
  content: "\\F0709"; }

.mdi-restart-alert::before {
  content: "\\F110C"; }

.mdi-restart-off::before {
  content: "\\F0D95"; }

.mdi-restore::before {
  content: "\\F099B"; }

.mdi-restore-alert::before {
  content: "\\F110D"; }

.mdi-rewind::before {
  content: "\\F045F"; }

.mdi-rewind-10::before {
  content: "\\F0D2A"; }

.mdi-rewind-15::before {
  content: "\\F1946"; }

.mdi-rewind-30::before {
  content: "\\F0D96"; }

.mdi-rewind-5::before {
  content: "\\F11F9"; }

.mdi-rewind-60::before {
  content: "\\F160C"; }

.mdi-rewind-outline::before {
  content: "\\F070A"; }

.mdi-rhombus::before {
  content: "\\F070B"; }

.mdi-rhombus-medium::before {
  content: "\\F0A10"; }

.mdi-rhombus-medium-outline::before {
  content: "\\F14DC"; }

.mdi-rhombus-outline::before {
  content: "\\F070C"; }

.mdi-rhombus-split::before {
  content: "\\F0A11"; }

.mdi-rhombus-split-outline::before {
  content: "\\F14DD"; }

.mdi-ribbon::before {
  content: "\\F0460"; }

.mdi-rice::before {
  content: "\\F07EA"; }

.mdi-rickshaw::before {
  content: "\\F15BB"; }

.mdi-rickshaw-electric::before {
  content: "\\F15BC"; }

.mdi-ring::before {
  content: "\\F07EB"; }

.mdi-rivet::before {
  content: "\\F0E60"; }

.mdi-road::before {
  content: "\\F0461"; }

.mdi-road-variant::before {
  content: "\\F0462"; }

.mdi-robber::before {
  content: "\\F1058"; }

.mdi-robot::before {
  content: "\\F06A9"; }

.mdi-robot-angry::before {
  content: "\\F169D"; }

.mdi-robot-angry-outline::before {
  content: "\\F169E"; }

.mdi-robot-confused::before {
  content: "\\F169F"; }

.mdi-robot-confused-outline::before {
  content: "\\F16A0"; }

.mdi-robot-dead::before {
  content: "\\F16A1"; }

.mdi-robot-dead-outline::before {
  content: "\\F16A2"; }

.mdi-robot-excited::before {
  content: "\\F16A3"; }

.mdi-robot-excited-outline::before {
  content: "\\F16A4"; }

.mdi-robot-happy::before {
  content: "\\F1719"; }

.mdi-robot-happy-outline::before {
  content: "\\F171A"; }

.mdi-robot-industrial::before {
  content: "\\F0B46"; }

.mdi-robot-love::before {
  content: "\\F16A5"; }

.mdi-robot-love-outline::before {
  content: "\\F16A6"; }

.mdi-robot-mower::before {
  content: "\\F11F7"; }

.mdi-robot-mower-outline::before {
  content: "\\F11F3"; }

.mdi-robot-off::before {
  content: "\\F16A7"; }

.mdi-robot-off-outline::before {
  content: "\\F167B"; }

.mdi-robot-outline::before {
  content: "\\F167A"; }

.mdi-robot-vacuum::before {
  content: "\\F070D"; }

.mdi-robot-vacuum-variant::before {
  content: "\\F0908"; }

.mdi-rocket::before {
  content: "\\F0463"; }

.mdi-rocket-launch::before {
  content: "\\F14DE"; }

.mdi-rocket-launch-outline::before {
  content: "\\F14DF"; }

.mdi-rocket-outline::before {
  content: "\\F13AF"; }

.mdi-rodent::before {
  content: "\\F1327"; }

.mdi-roller-skate::before {
  content: "\\F0D2B"; }

.mdi-roller-skate-off::before {
  content: "\\F0145"; }

.mdi-rollerblade::before {
  content: "\\F0D2C"; }

.mdi-rollerblade-off::before {
  content: "\\F002E"; }

.mdi-rollupjs::before {
  content: "\\F0BC0"; }

.mdi-roman-numeral-1::before {
  content: "\\F1088"; }

.mdi-roman-numeral-10::before {
  content: "\\F1091"; }

.mdi-roman-numeral-2::before {
  content: "\\F1089"; }

.mdi-roman-numeral-3::before {
  content: "\\F108A"; }

.mdi-roman-numeral-4::before {
  content: "\\F108B"; }

.mdi-roman-numeral-5::before {
  content: "\\F108C"; }

.mdi-roman-numeral-6::before {
  content: "\\F108D"; }

.mdi-roman-numeral-7::before {
  content: "\\F108E"; }

.mdi-roman-numeral-8::before {
  content: "\\F108F"; }

.mdi-roman-numeral-9::before {
  content: "\\F1090"; }

.mdi-room-service::before {
  content: "\\F088D"; }

.mdi-room-service-outline::before {
  content: "\\F0D97"; }

.mdi-rotate-360::before {
  content: "\\F1999"; }

.mdi-rotate-3d::before {
  content: "\\F0EC7"; }

.mdi-rotate-3d-variant::before {
  content: "\\F0464"; }

.mdi-rotate-left::before {
  content: "\\F0465"; }

.mdi-rotate-left-variant::before {
  content: "\\F0466"; }

.mdi-rotate-orbit::before {
  content: "\\F0D98"; }

.mdi-rotate-right::before {
  content: "\\F0467"; }

.mdi-rotate-right-variant::before {
  content: "\\F0468"; }

.mdi-rounded-corner::before {
  content: "\\F0607"; }

.mdi-router::before {
  content: "\\F11E2"; }

.mdi-router-network::before {
  content: "\\F1087"; }

.mdi-router-wireless::before {
  content: "\\F0469"; }

.mdi-router-wireless-off::before {
  content: "\\F15A3"; }

.mdi-router-wireless-settings::before {
  content: "\\F0A69"; }

.mdi-routes::before {
  content: "\\F046A"; }

.mdi-routes-clock::before {
  content: "\\F1059"; }

.mdi-rowing::before {
  content: "\\F0608"; }

.mdi-rss::before {
  content: "\\F046B"; }

.mdi-rss-box::before {
  content: "\\F046C"; }

.mdi-rss-off::before {
  content: "\\F0F21"; }

.mdi-rug::before {
  content: "\\F1475"; }

.mdi-rugby::before {
  content: "\\F0D99"; }

.mdi-ruler::before {
  content: "\\F046D"; }

.mdi-ruler-square::before {
  content: "\\F0CC2"; }

.mdi-ruler-square-compass::before {
  content: "\\F0EBE"; }

.mdi-run::before {
  content: "\\F070E"; }

.mdi-run-fast::before {
  content: "\\F046E"; }

.mdi-rv-truck::before {
  content: "\\F11D4"; }

.mdi-sack::before {
  content: "\\F0D2E"; }

.mdi-sack-percent::before {
  content: "\\F0D2F"; }

.mdi-safe::before {
  content: "\\F0A6A"; }

.mdi-safe-square::before {
  content: "\\F127C"; }

.mdi-safe-square-outline::before {
  content: "\\F127D"; }

.mdi-safety-goggles::before {
  content: "\\F0D30"; }

.mdi-sail-boat::before {
  content: "\\F0EC8"; }

.mdi-sale::before {
  content: "\\F046F"; }

.mdi-salesforce::before {
  content: "\\F088E"; }

.mdi-sass::before {
  content: "\\F07EC"; }

.mdi-satellite::before {
  content: "\\F0470"; }

.mdi-satellite-uplink::before {
  content: "\\F0909"; }

.mdi-satellite-variant::before {
  content: "\\F0471"; }

.mdi-sausage::before {
  content: "\\F08BA"; }

.mdi-sausage-off::before {
  content: "\\F1789"; }

.mdi-saw-blade::before {
  content: "\\F0E61"; }

.mdi-sawtooth-wave::before {
  content: "\\F147A"; }

.mdi-saxophone::before {
  content: "\\F0609"; }

.mdi-scale::before {
  content: "\\F0472"; }

.mdi-scale-balance::before {
  content: "\\F05D1"; }

.mdi-scale-bathroom::before {
  content: "\\F0473"; }

.mdi-scale-off::before {
  content: "\\F105A"; }

.mdi-scale-unbalanced::before {
  content: "\\F19B8"; }

.mdi-scan-helper::before {
  content: "\\F13D8"; }

.mdi-scanner::before {
  content: "\\F06AB"; }

.mdi-scanner-off::before {
  content: "\\F090A"; }

.mdi-scatter-plot::before {
  content: "\\F0EC9"; }

.mdi-scatter-plot-outline::before {
  content: "\\F0ECA"; }

.mdi-scent::before {
  content: "\\F1958"; }

.mdi-scent-off::before {
  content: "\\F1959"; }

.mdi-school::before {
  content: "\\F0474"; }

.mdi-school-outline::before {
  content: "\\F1180"; }

.mdi-scissors-cutting::before {
  content: "\\F0A6B"; }

.mdi-scooter::before {
  content: "\\F15BD"; }

.mdi-scooter-electric::before {
  content: "\\F15BE"; }

.mdi-scoreboard::before {
  content: "\\F127E"; }

.mdi-scoreboard-outline::before {
  content: "\\F127F"; }

.mdi-screen-rotation::before {
  content: "\\F0475"; }

.mdi-screen-rotation-lock::before {
  content: "\\F0478"; }

.mdi-screw-flat-top::before {
  content: "\\F0DF3"; }

.mdi-screw-lag::before {
  content: "\\F0DF4"; }

.mdi-screw-machine-flat-top::before {
  content: "\\F0DF5"; }

.mdi-screw-machine-round-top::before {
  content: "\\F0DF6"; }

.mdi-screw-round-top::before {
  content: "\\F0DF7"; }

.mdi-screwdriver::before {
  content: "\\F0476"; }

.mdi-script::before {
  content: "\\F0BC1"; }

.mdi-script-outline::before {
  content: "\\F0477"; }

.mdi-script-text::before {
  content: "\\F0BC2"; }

.mdi-script-text-key::before {
  content: "\\F1725"; }

.mdi-script-text-key-outline::before {
  content: "\\F1726"; }

.mdi-script-text-outline::before {
  content: "\\F0BC3"; }

.mdi-script-text-play::before {
  content: "\\F1727"; }

.mdi-script-text-play-outline::before {
  content: "\\F1728"; }

.mdi-sd::before {
  content: "\\F0479"; }

.mdi-seal::before {
  content: "\\F047A"; }

.mdi-seal-variant::before {
  content: "\\F0FD9"; }

.mdi-search-web::before {
  content: "\\F070F"; }

.mdi-seat::before {
  content: "\\F0CC3"; }

.mdi-seat-flat::before {
  content: "\\F047B"; }

.mdi-seat-flat-angled::before {
  content: "\\F047C"; }

.mdi-seat-individual-suite::before {
  content: "\\F047D"; }

.mdi-seat-legroom-extra::before {
  content: "\\F047E"; }

.mdi-seat-legroom-normal::before {
  content: "\\F047F"; }

.mdi-seat-legroom-reduced::before {
  content: "\\F0480"; }

.mdi-seat-outline::before {
  content: "\\F0CC4"; }

.mdi-seat-passenger::before {
  content: "\\F1249"; }

.mdi-seat-recline-extra::before {
  content: "\\F0481"; }

.mdi-seat-recline-normal::before {
  content: "\\F0482"; }

.mdi-seatbelt::before {
  content: "\\F0CC5"; }

.mdi-security::before {
  content: "\\F0483"; }

.mdi-security-network::before {
  content: "\\F0484"; }

.mdi-seed::before {
  content: "\\F0E62"; }

.mdi-seed-off::before {
  content: "\\F13FD"; }

.mdi-seed-off-outline::before {
  content: "\\F13FE"; }

.mdi-seed-outline::before {
  content: "\\F0E63"; }

.mdi-seesaw::before {
  content: "\\F15A4"; }

.mdi-segment::before {
  content: "\\F0ECB"; }

.mdi-select::before {
  content: "\\F0485"; }

.mdi-select-all::before {
  content: "\\F0486"; }

.mdi-select-color::before {
  content: "\\F0D31"; }

.mdi-select-compare::before {
  content: "\\F0AD9"; }

.mdi-select-drag::before {
  content: "\\F0A6C"; }

.mdi-select-group::before {
  content: "\\F0F82"; }

.mdi-select-inverse::before {
  content: "\\F0487"; }

.mdi-select-marker::before {
  content: "\\F1280"; }

.mdi-select-multiple::before {
  content: "\\F1281"; }

.mdi-select-multiple-marker::before {
  content: "\\F1282"; }

.mdi-select-off::before {
  content: "\\F0488"; }

.mdi-select-place::before {
  content: "\\F0FDA"; }

.mdi-select-remove::before {
  content: "\\F17C1"; }

.mdi-select-search::before {
  content: "\\F1204"; }

.mdi-selection::before {
  content: "\\F0489"; }

.mdi-selection-drag::before {
  content: "\\F0A6D"; }

.mdi-selection-ellipse::before {
  content: "\\F0D32"; }

.mdi-selection-ellipse-arrow-inside::before {
  content: "\\F0F22"; }

.mdi-selection-ellipse-remove::before {
  content: "\\F17C2"; }

.mdi-selection-marker::before {
  content: "\\F1283"; }

.mdi-selection-multiple::before {
  content: "\\F1285"; }

.mdi-selection-multiple-marker::before {
  content: "\\F1284"; }

.mdi-selection-off::before {
  content: "\\F0777"; }

.mdi-selection-remove::before {
  content: "\\F17C3"; }

.mdi-selection-search::before {
  content: "\\F1205"; }

.mdi-semantic-web::before {
  content: "\\F1316"; }

.mdi-send::before {
  content: "\\F048A"; }

.mdi-send-check::before {
  content: "\\F1161"; }

.mdi-send-check-outline::before {
  content: "\\F1162"; }

.mdi-send-circle::before {
  content: "\\F0DF8"; }

.mdi-send-circle-outline::before {
  content: "\\F0DF9"; }

.mdi-send-clock::before {
  content: "\\F1163"; }

.mdi-send-clock-outline::before {
  content: "\\F1164"; }

.mdi-send-lock::before {
  content: "\\F07ED"; }

.mdi-send-lock-outline::before {
  content: "\\F1166"; }

.mdi-send-outline::before {
  content: "\\F1165"; }

.mdi-serial-port::before {
  content: "\\F065C"; }

.mdi-server::before {
  content: "\\F048B"; }

.mdi-server-minus::before {
  content: "\\F048C"; }

.mdi-server-network::before {
  content: "\\F048D"; }

.mdi-server-network-off::before {
  content: "\\F048E"; }

.mdi-server-off::before {
  content: "\\F048F"; }

.mdi-server-plus::before {
  content: "\\F0490"; }

.mdi-server-remove::before {
  content: "\\F0491"; }

.mdi-server-security::before {
  content: "\\F0492"; }

.mdi-set-all::before {
  content: "\\F0778"; }

.mdi-set-center::before {
  content: "\\F0779"; }

.mdi-set-center-right::before {
  content: "\\F077A"; }

.mdi-set-left::before {
  content: "\\F077B"; }

.mdi-set-left-center::before {
  content: "\\F077C"; }

.mdi-set-left-right::before {
  content: "\\F077D"; }

.mdi-set-merge::before {
  content: "\\F14E0"; }

.mdi-set-none::before {
  content: "\\F077E"; }

.mdi-set-right::before {
  content: "\\F077F"; }

.mdi-set-split::before {
  content: "\\F14E1"; }

.mdi-set-square::before {
  content: "\\F145D"; }

.mdi-set-top-box::before {
  content: "\\F099F"; }

.mdi-settings-helper::before {
  content: "\\F0A6E"; }

.mdi-shaker::before {
  content: "\\F110E"; }

.mdi-shaker-outline::before {
  content: "\\F110F"; }

.mdi-shape::before {
  content: "\\F0831"; }

.mdi-shape-circle-plus::before {
  content: "\\F065D"; }

.mdi-shape-outline::before {
  content: "\\F0832"; }

.mdi-shape-oval-plus::before {
  content: "\\F11FA"; }

.mdi-shape-plus::before {
  content: "\\F0495"; }

.mdi-shape-polygon-plus::before {
  content: "\\F065E"; }

.mdi-shape-rectangle-plus::before {
  content: "\\F065F"; }

.mdi-shape-square-plus::before {
  content: "\\F0660"; }

.mdi-shape-square-rounded-plus::before {
  content: "\\F14FA"; }

.mdi-share::before {
  content: "\\F0496"; }

.mdi-share-all::before {
  content: "\\F11F4"; }

.mdi-share-all-outline::before {
  content: "\\F11F5"; }

.mdi-share-circle::before {
  content: "\\F11AD"; }

.mdi-share-off::before {
  content: "\\F0F23"; }

.mdi-share-off-outline::before {
  content: "\\F0F24"; }

.mdi-share-outline::before {
  content: "\\F0932"; }

.mdi-share-variant::before {
  content: "\\F0497"; }

.mdi-share-variant-outline::before {
  content: "\\F1514"; }

.mdi-shark::before {
  content: "\\F18BA"; }

.mdi-shark-fin::before {
  content: "\\F1673"; }

.mdi-shark-fin-outline::before {
  content: "\\F1674"; }

.mdi-shark-off::before {
  content: "\\F18BB"; }

.mdi-sheep::before {
  content: "\\F0CC6"; }

.mdi-shield::before {
  content: "\\F0498"; }

.mdi-shield-account::before {
  content: "\\F088F"; }

.mdi-shield-account-outline::before {
  content: "\\F0A12"; }

.mdi-shield-account-variant::before {
  content: "\\F15A7"; }

.mdi-shield-account-variant-outline::before {
  content: "\\F15A8"; }

.mdi-shield-airplane::before {
  content: "\\F06BB"; }

.mdi-shield-airplane-outline::before {
  content: "\\F0CC7"; }

.mdi-shield-alert::before {
  content: "\\F0ECC"; }

.mdi-shield-alert-outline::before {
  content: "\\F0ECD"; }

.mdi-shield-bug::before {
  content: "\\F13DA"; }

.mdi-shield-bug-outline::before {
  content: "\\F13DB"; }

.mdi-shield-car::before {
  content: "\\F0F83"; }

.mdi-shield-check::before {
  content: "\\F0565"; }

.mdi-shield-check-outline::before {
  content: "\\F0CC8"; }

.mdi-shield-cross::before {
  content: "\\F0CC9"; }

.mdi-shield-cross-outline::before {
  content: "\\F0CCA"; }

.mdi-shield-crown::before {
  content: "\\F18BC"; }

.mdi-shield-crown-outline::before {
  content: "\\F18BD"; }

.mdi-shield-edit::before {
  content: "\\F11A0"; }

.mdi-shield-edit-outline::before {
  content: "\\F11A1"; }

.mdi-shield-half::before {
  content: "\\F1360"; }

.mdi-shield-half-full::before {
  content: "\\F0780"; }

.mdi-shield-home::before {
  content: "\\F068A"; }

.mdi-shield-home-outline::before {
  content: "\\F0CCB"; }

.mdi-shield-key::before {
  content: "\\F0BC4"; }

.mdi-shield-key-outline::before {
  content: "\\F0BC5"; }

.mdi-shield-link-variant::before {
  content: "\\F0D33"; }

.mdi-shield-link-variant-outline::before {
  content: "\\F0D34"; }

.mdi-shield-lock::before {
  content: "\\F099D"; }

.mdi-shield-lock-open::before {
  content: "\\F199A"; }

.mdi-shield-lock-open-outline::before {
  content: "\\F199B"; }

.mdi-shield-lock-outline::before {
  content: "\\F0CCC"; }

.mdi-shield-moon::before {
  content: "\\F1828"; }

.mdi-shield-moon-outline::before {
  content: "\\F1829"; }

.mdi-shield-off::before {
  content: "\\F099E"; }

.mdi-shield-off-outline::before {
  content: "\\F099C"; }

.mdi-shield-outline::before {
  content: "\\F0499"; }

.mdi-shield-plus::before {
  content: "\\F0ADA"; }

.mdi-shield-plus-outline::before {
  content: "\\F0ADB"; }

.mdi-shield-refresh::before {
  content: "\\F00AA"; }

.mdi-shield-refresh-outline::before {
  content: "\\F01E0"; }

.mdi-shield-remove::before {
  content: "\\F0ADC"; }

.mdi-shield-remove-outline::before {
  content: "\\F0ADD"; }

.mdi-shield-search::before {
  content: "\\F0D9A"; }

.mdi-shield-star::before {
  content: "\\F113B"; }

.mdi-shield-star-outline::before {
  content: "\\F113C"; }

.mdi-shield-sun::before {
  content: "\\F105D"; }

.mdi-shield-sun-outline::before {
  content: "\\F105E"; }

.mdi-shield-sword::before {
  content: "\\F18BE"; }

.mdi-shield-sword-outline::before {
  content: "\\F18BF"; }

.mdi-shield-sync::before {
  content: "\\F11A2"; }

.mdi-shield-sync-outline::before {
  content: "\\F11A3"; }

.mdi-shimmer::before {
  content: "\\F1545"; }

.mdi-ship-wheel::before {
  content: "\\F0833"; }

.mdi-shipping-pallet::before {
  content: "\\F184E"; }

.mdi-shoe-ballet::before {
  content: "\\F15CA"; }

.mdi-shoe-cleat::before {
  content: "\\F15C7"; }

.mdi-shoe-formal::before {
  content: "\\F0B47"; }

.mdi-shoe-heel::before {
  content: "\\F0B48"; }

.mdi-shoe-print::before {
  content: "\\F0DFA"; }

.mdi-shoe-sneaker::before {
  content: "\\F15C8"; }

.mdi-shopping::before {
  content: "\\F049A"; }

.mdi-shopping-music::before {
  content: "\\F049B"; }

.mdi-shopping-outline::before {
  content: "\\F11D5"; }

.mdi-shopping-search::before {
  content: "\\F0F84"; }

.mdi-shore::before {
  content: "\\F14F9"; }

.mdi-shovel::before {
  content: "\\F0710"; }

.mdi-shovel-off::before {
  content: "\\F0711"; }

.mdi-shower::before {
  content: "\\F09A0"; }

.mdi-shower-head::before {
  content: "\\F09A1"; }

.mdi-shredder::before {
  content: "\\F049C"; }

.mdi-shuffle::before {
  content: "\\F049D"; }

.mdi-shuffle-disabled::before {
  content: "\\F049E"; }

.mdi-shuffle-variant::before {
  content: "\\F049F"; }

.mdi-shuriken::before {
  content: "\\F137F"; }

.mdi-sickle::before {
  content: "\\F18C0"; }

.mdi-sigma::before {
  content: "\\F04A0"; }

.mdi-sigma-lower::before {
  content: "\\F062B"; }

.mdi-sign-caution::before {
  content: "\\F04A1"; }

.mdi-sign-direction::before {
  content: "\\F0781"; }

.mdi-sign-direction-minus::before {
  content: "\\F1000"; }

.mdi-sign-direction-plus::before {
  content: "\\F0FDC"; }

.mdi-sign-direction-remove::before {
  content: "\\F0FDD"; }

.mdi-sign-pole::before {
  content: "\\F14F8"; }

.mdi-sign-real-estate::before {
  content: "\\F1118"; }

.mdi-sign-text::before {
  content: "\\F0782"; }

.mdi-signal::before {
  content: "\\F04A2"; }

.mdi-signal-2g::before {
  content: "\\F0712"; }

.mdi-signal-3g::before {
  content: "\\F0713"; }

.mdi-signal-4g::before {
  content: "\\F0714"; }

.mdi-signal-5g::before {
  content: "\\F0A6F"; }

.mdi-signal-cellular-1::before {
  content: "\\F08BC"; }

.mdi-signal-cellular-2::before {
  content: "\\F08BD"; }

.mdi-signal-cellular-3::before {
  content: "\\F08BE"; }

.mdi-signal-cellular-outline::before {
  content: "\\F08BF"; }

.mdi-signal-distance-variant::before {
  content: "\\F0E64"; }

.mdi-signal-hspa::before {
  content: "\\F0715"; }

.mdi-signal-hspa-plus::before {
  content: "\\F0716"; }

.mdi-signal-off::before {
  content: "\\F0783"; }

.mdi-signal-variant::before {
  content: "\\F060A"; }

.mdi-signature::before {
  content: "\\F0DFB"; }

.mdi-signature-freehand::before {
  content: "\\F0DFC"; }

.mdi-signature-image::before {
  content: "\\F0DFD"; }

.mdi-signature-text::before {
  content: "\\F0DFE"; }

.mdi-silo::before {
  content: "\\F0B49"; }

.mdi-silverware::before {
  content: "\\F04A3"; }

.mdi-silverware-clean::before {
  content: "\\F0FDE"; }

.mdi-silverware-fork::before {
  content: "\\F04A4"; }

.mdi-silverware-fork-knife::before {
  content: "\\F0A70"; }

.mdi-silverware-spoon::before {
  content: "\\F04A5"; }

.mdi-silverware-variant::before {
  content: "\\F04A6"; }

.mdi-sim::before {
  content: "\\F04A7"; }

.mdi-sim-alert::before {
  content: "\\F04A8"; }

.mdi-sim-alert-outline::before {
  content: "\\F15D3"; }

.mdi-sim-off::before {
  content: "\\F04A9"; }

.mdi-sim-off-outline::before {
  content: "\\F15D4"; }

.mdi-sim-outline::before {
  content: "\\F15D5"; }

.mdi-simple-icons::before {
  content: "\\F131D"; }

.mdi-sina-weibo::before {
  content: "\\F0ADF"; }

.mdi-sine-wave::before {
  content: "\\F095B"; }

.mdi-sitemap::before {
  content: "\\F04AA"; }

.mdi-sitemap-outline::before {
  content: "\\F199C"; }

.mdi-size-l::before {
  content: "\\F13A6"; }

.mdi-size-m::before {
  content: "\\F13A5"; }

.mdi-size-s::before {
  content: "\\F13A4"; }

.mdi-size-xl::before {
  content: "\\F13A7"; }

.mdi-size-xs::before {
  content: "\\F13A3"; }

.mdi-size-xxl::before {
  content: "\\F13A8"; }

.mdi-size-xxs::before {
  content: "\\F13A2"; }

.mdi-size-xxxl::before {
  content: "\\F13A9"; }

.mdi-skate::before {
  content: "\\F0D35"; }

.mdi-skate-off::before {
  content: "\\F0699"; }

.mdi-skateboard::before {
  content: "\\F14C2"; }

.mdi-skateboarding::before {
  content: "\\F0501"; }

.mdi-skew-less::before {
  content: "\\F0D36"; }

.mdi-skew-more::before {
  content: "\\F0D37"; }

.mdi-ski::before {
  content: "\\F1304"; }

.mdi-ski-cross-country::before {
  content: "\\F1305"; }

.mdi-ski-water::before {
  content: "\\F1306"; }

.mdi-skip-backward::before {
  content: "\\F04AB"; }

.mdi-skip-backward-outline::before {
  content: "\\F0F25"; }

.mdi-skip-forward::before {
  content: "\\F04AC"; }

.mdi-skip-forward-outline::before {
  content: "\\F0F26"; }

.mdi-skip-next::before {
  content: "\\F04AD"; }

.mdi-skip-next-circle::before {
  content: "\\F0661"; }

.mdi-skip-next-circle-outline::before {
  content: "\\F0662"; }

.mdi-skip-next-outline::before {
  content: "\\F0F27"; }

.mdi-skip-previous::before {
  content: "\\F04AE"; }

.mdi-skip-previous-circle::before {
  content: "\\F0663"; }

.mdi-skip-previous-circle-outline::before {
  content: "\\F0664"; }

.mdi-skip-previous-outline::before {
  content: "\\F0F28"; }

.mdi-skull::before {
  content: "\\F068C"; }

.mdi-skull-crossbones::before {
  content: "\\F0BC6"; }

.mdi-skull-crossbones-outline::before {
  content: "\\F0BC7"; }

.mdi-skull-outline::before {
  content: "\\F0BC8"; }

.mdi-skull-scan::before {
  content: "\\F14C7"; }

.mdi-skull-scan-outline::before {
  content: "\\F14C8"; }

.mdi-skype::before {
  content: "\\F04AF"; }

.mdi-skype-business::before {
  content: "\\F04B0"; }

.mdi-slack::before {
  content: "\\F04B1"; }

.mdi-slash-forward::before {
  content: "\\F0FDF"; }

.mdi-slash-forward-box::before {
  content: "\\F0FE0"; }

.mdi-sledding::before {
  content: "\\F041B"; }

.mdi-sleep::before {
  content: "\\F04B2"; }

.mdi-sleep-off::before {
  content: "\\F04B3"; }

.mdi-slide::before {
  content: "\\F15A5"; }

.mdi-slope-downhill::before {
  content: "\\F0DFF"; }

.mdi-slope-uphill::before {
  content: "\\F0E00"; }

.mdi-slot-machine::before {
  content: "\\F1114"; }

.mdi-slot-machine-outline::before {
  content: "\\F1115"; }

.mdi-smart-card::before {
  content: "\\F10BD"; }

.mdi-smart-card-off::before {
  content: "\\F18F7"; }

.mdi-smart-card-off-outline::before {
  content: "\\F18F8"; }

.mdi-smart-card-outline::before {
  content: "\\F10BE"; }

.mdi-smart-card-reader::before {
  content: "\\F10BF"; }

.mdi-smart-card-reader-outline::before {
  content: "\\F10C0"; }

.mdi-smog::before {
  content: "\\F0A71"; }

.mdi-smoke::before {
  content: "\\F1799"; }

.mdi-smoke-detector::before {
  content: "\\F0392"; }

.mdi-smoke-detector-alert::before {
  content: "\\F192E"; }

.mdi-smoke-detector-alert-outline::before {
  content: "\\F192F"; }

.mdi-smoke-detector-off::before {
  content: "\\F1809"; }

.mdi-smoke-detector-off-outline::before {
  content: "\\F180A"; }

.mdi-smoke-detector-outline::before {
  content: "\\F1808"; }

.mdi-smoke-detector-variant::before {
  content: "\\F180B"; }

.mdi-smoke-detector-variant-alert::before {
  content: "\\F1930"; }

.mdi-smoke-detector-variant-off::before {
  content: "\\F180C"; }

.mdi-smoking::before {
  content: "\\F04B4"; }

.mdi-smoking-off::before {
  content: "\\F04B5"; }

.mdi-smoking-pipe::before {
  content: "\\F140D"; }

.mdi-smoking-pipe-off::before {
  content: "\\F1428"; }

.mdi-snail::before {
  content: "\\F1677"; }

.mdi-snake::before {
  content: "\\F150E"; }

.mdi-snapchat::before {
  content: "\\F04B6"; }

.mdi-snowboard::before {
  content: "\\F1307"; }

.mdi-snowflake::before {
  content: "\\F0717"; }

.mdi-snowflake-alert::before {
  content: "\\F0F29"; }

.mdi-snowflake-melt::before {
  content: "\\F12CB"; }

.mdi-snowflake-off::before {
  content: "\\F14E3"; }

.mdi-snowflake-variant::before {
  content: "\\F0F2A"; }

.mdi-snowman::before {
  content: "\\F04B7"; }

.mdi-snowmobile::before {
  content: "\\F06DD"; }

.mdi-soccer::before {
  content: "\\F04B8"; }

.mdi-soccer-field::before {
  content: "\\F0834"; }

.mdi-social-distance-2-meters::before {
  content: "\\F1579"; }

.mdi-social-distance-6-feet::before {
  content: "\\F157A"; }

.mdi-sofa::before {
  content: "\\F04B9"; }

.mdi-sofa-outline::before {
  content: "\\F156D"; }

.mdi-sofa-single::before {
  content: "\\F156E"; }

.mdi-sofa-single-outline::before {
  content: "\\F156F"; }

.mdi-solar-panel::before {
  content: "\\F0D9B"; }

.mdi-solar-panel-large::before {
  content: "\\F0D9C"; }

.mdi-solar-power::before {
  content: "\\F0A72"; }

.mdi-soldering-iron::before {
  content: "\\F1092"; }

.mdi-solid::before {
  content: "\\F068D"; }

.mdi-sony-playstation::before {
  content: "\\F0414"; }

.mdi-sort::before {
  content: "\\F04BA"; }

.mdi-sort-alphabetical-ascending::before {
  content: "\\F05BD"; }

.mdi-sort-alphabetical-ascending-variant::before {
  content: "\\F1148"; }

.mdi-sort-alphabetical-descending::before {
  content: "\\F05BF"; }

.mdi-sort-alphabetical-descending-variant::before {
  content: "\\F1149"; }

.mdi-sort-alphabetical-variant::before {
  content: "\\F04BB"; }

.mdi-sort-ascending::before {
  content: "\\F04BC"; }

.mdi-sort-bool-ascending::before {
  content: "\\F1385"; }

.mdi-sort-bool-ascending-variant::before {
  content: "\\F1386"; }

.mdi-sort-bool-descending::before {
  content: "\\F1387"; }

.mdi-sort-bool-descending-variant::before {
  content: "\\F1388"; }

.mdi-sort-calendar-ascending::before {
  content: "\\F1547"; }

.mdi-sort-calendar-descending::before {
  content: "\\F1548"; }

.mdi-sort-clock-ascending::before {
  content: "\\F1549"; }

.mdi-sort-clock-ascending-outline::before {
  content: "\\F154A"; }

.mdi-sort-clock-descending::before {
  content: "\\F154B"; }

.mdi-sort-clock-descending-outline::before {
  content: "\\F154C"; }

.mdi-sort-descending::before {
  content: "\\F04BD"; }

.mdi-sort-numeric-ascending::before {
  content: "\\F1389"; }

.mdi-sort-numeric-ascending-variant::before {
  content: "\\F090D"; }

.mdi-sort-numeric-descending::before {
  content: "\\F138A"; }

.mdi-sort-numeric-descending-variant::before {
  content: "\\F0AD2"; }

.mdi-sort-numeric-variant::before {
  content: "\\F04BE"; }

.mdi-sort-reverse-variant::before {
  content: "\\F033C"; }

.mdi-sort-variant::before {
  content: "\\F04BF"; }

.mdi-sort-variant-lock::before {
  content: "\\F0CCD"; }

.mdi-sort-variant-lock-open::before {
  content: "\\F0CCE"; }

.mdi-sort-variant-remove::before {
  content: "\\F1147"; }

.mdi-soundbar::before {
  content: "\\F17DB"; }

.mdi-soundcloud::before {
  content: "\\F04C0"; }

.mdi-source-branch::before {
  content: "\\F062C"; }

.mdi-source-branch-check::before {
  content: "\\F14CF"; }

.mdi-source-branch-minus::before {
  content: "\\F14CB"; }

.mdi-source-branch-plus::before {
  content: "\\F14CA"; }

.mdi-source-branch-refresh::before {
  content: "\\F14CD"; }

.mdi-source-branch-remove::before {
  content: "\\F14CC"; }

.mdi-source-branch-sync::before {
  content: "\\F14CE"; }

.mdi-source-commit::before {
  content: "\\F0718"; }

.mdi-source-commit-end::before {
  content: "\\F0719"; }

.mdi-source-commit-end-local::before {
  content: "\\F071A"; }

.mdi-source-commit-local::before {
  content: "\\F071B"; }

.mdi-source-commit-next-local::before {
  content: "\\F071C"; }

.mdi-source-commit-start::before {
  content: "\\F071D"; }

.mdi-source-commit-start-next-local::before {
  content: "\\F071E"; }

.mdi-source-fork::before {
  content: "\\F04C1"; }

.mdi-source-merge::before {
  content: "\\F062D"; }

.mdi-source-pull::before {
  content: "\\F04C2"; }

.mdi-source-repository::before {
  content: "\\F0CCF"; }

.mdi-source-repository-multiple::before {
  content: "\\F0CD0"; }

.mdi-soy-sauce::before {
  content: "\\F07EE"; }

.mdi-soy-sauce-off::before {
  content: "\\F13FC"; }

.mdi-spa::before {
  content: "\\F0CD1"; }

.mdi-spa-outline::before {
  content: "\\F0CD2"; }

.mdi-space-invaders::before {
  content: "\\F0BC9"; }

.mdi-space-station::before {
  content: "\\F1383"; }

.mdi-spade::before {
  content: "\\F0E65"; }

.mdi-speaker::before {
  content: "\\F04C3"; }

.mdi-speaker-bluetooth::before {
  content: "\\F09A2"; }

.mdi-speaker-multiple::before {
  content: "\\F0D38"; }

.mdi-speaker-off::before {
  content: "\\F04C4"; }

.mdi-speaker-wireless::before {
  content: "\\F071F"; }

.mdi-spear::before {
  content: "\\F1845"; }

.mdi-speedometer::before {
  content: "\\F04C5"; }

.mdi-speedometer-medium::before {
  content: "\\F0F85"; }

.mdi-speedometer-slow::before {
  content: "\\F0F86"; }

.mdi-spellcheck::before {
  content: "\\F04C6"; }

.mdi-sphere::before {
  content: "\\F1954"; }

.mdi-sphere-off::before {
  content: "\\F1955"; }

.mdi-spider::before {
  content: "\\F11EA"; }

.mdi-spider-thread::before {
  content: "\\F11EB"; }

.mdi-spider-web::before {
  content: "\\F0BCA"; }

.mdi-spirit-level::before {
  content: "\\F14F1"; }

.mdi-spoon-sugar::before {
  content: "\\F1429"; }

.mdi-spotify::before {
  content: "\\F04C7"; }

.mdi-spotlight::before {
  content: "\\F04C8"; }

.mdi-spotlight-beam::before {
  content: "\\F04C9"; }

.mdi-spray::before {
  content: "\\F0665"; }

.mdi-spray-bottle::before {
  content: "\\F0AE0"; }

.mdi-sprinkler::before {
  content: "\\F105F"; }

.mdi-sprinkler-fire::before {
  content: "\\F199D"; }

.mdi-sprinkler-variant::before {
  content: "\\F1060"; }

.mdi-sprout::before {
  content: "\\F0E66"; }

.mdi-sprout-outline::before {
  content: "\\F0E67"; }

.mdi-square::before {
  content: "\\F0764"; }

.mdi-square-circle::before {
  content: "\\F1500"; }

.mdi-square-edit-outline::before {
  content: "\\F090C"; }

.mdi-square-medium::before {
  content: "\\F0A13"; }

.mdi-square-medium-outline::before {
  content: "\\F0A14"; }

.mdi-square-off::before {
  content: "\\F12EE"; }

.mdi-square-off-outline::before {
  content: "\\F12EF"; }

.mdi-square-opacity::before {
  content: "\\F1854"; }

.mdi-square-outline::before {
  content: "\\F0763"; }

.mdi-square-root::before {
  content: "\\F0784"; }

.mdi-square-root-box::before {
  content: "\\F09A3"; }

.mdi-square-rounded::before {
  content: "\\F14FB"; }

.mdi-square-rounded-outline::before {
  content: "\\F14FC"; }

.mdi-square-small::before {
  content: "\\F0A15"; }

.mdi-square-wave::before {
  content: "\\F147B"; }

.mdi-squeegee::before {
  content: "\\F0AE1"; }

.mdi-ssh::before {
  content: "\\F08C0"; }

.mdi-stack-exchange::before {
  content: "\\F060B"; }

.mdi-stack-overflow::before {
  content: "\\F04CC"; }

.mdi-stackpath::before {
  content: "\\F0359"; }

.mdi-stadium::before {
  content: "\\F0FF9"; }

.mdi-stadium-variant::before {
  content: "\\F0720"; }

.mdi-stairs::before {
  content: "\\F04CD"; }

.mdi-stairs-box::before {
  content: "\\F139E"; }

.mdi-stairs-down::before {
  content: "\\F12BE"; }

.mdi-stairs-up::before {
  content: "\\F12BD"; }

.mdi-stamper::before {
  content: "\\F0D39"; }

.mdi-standard-definition::before {
  content: "\\F07EF"; }

.mdi-star::before {
  content: "\\F04CE"; }

.mdi-star-box::before {
  content: "\\F0A73"; }

.mdi-star-box-multiple::before {
  content: "\\F1286"; }

.mdi-star-box-multiple-outline::before {
  content: "\\F1287"; }

.mdi-star-box-outline::before {
  content: "\\F0A74"; }

.mdi-star-check::before {
  content: "\\F1566"; }

.mdi-star-check-outline::before {
  content: "\\F156A"; }

.mdi-star-circle::before {
  content: "\\F04CF"; }

.mdi-star-circle-outline::before {
  content: "\\F09A4"; }

.mdi-star-cog::before {
  content: "\\F1668"; }

.mdi-star-cog-outline::before {
  content: "\\F1669"; }

.mdi-star-crescent::before {
  content: "\\F0979"; }

.mdi-star-david::before {
  content: "\\F097A"; }

.mdi-star-face::before {
  content: "\\F09A5"; }

.mdi-star-four-points::before {
  content: "\\F0AE2"; }

.mdi-star-four-points-outline::before {
  content: "\\F0AE3"; }

.mdi-star-half::before {
  content: "\\F0246"; }

.mdi-star-half-full::before {
  content: "\\F04D0"; }

.mdi-star-minus::before {
  content: "\\F1564"; }

.mdi-star-minus-outline::before {
  content: "\\F1568"; }

.mdi-star-off::before {
  content: "\\F04D1"; }

.mdi-star-off-outline::before {
  content: "\\F155B"; }

.mdi-star-outline::before {
  content: "\\F04D2"; }

.mdi-star-plus::before {
  content: "\\F1563"; }

.mdi-star-plus-outline::before {
  content: "\\F1567"; }

.mdi-star-remove::before {
  content: "\\F1565"; }

.mdi-star-remove-outline::before {
  content: "\\F1569"; }

.mdi-star-settings::before {
  content: "\\F166A"; }

.mdi-star-settings-outline::before {
  content: "\\F166B"; }

.mdi-star-shooting::before {
  content: "\\F1741"; }

.mdi-star-shooting-outline::before {
  content: "\\F1742"; }

.mdi-star-three-points::before {
  content: "\\F0AE4"; }

.mdi-star-three-points-outline::before {
  content: "\\F0AE5"; }

.mdi-state-machine::before {
  content: "\\F11EF"; }

.mdi-steam::before {
  content: "\\F04D3"; }

.mdi-steering::before {
  content: "\\F04D4"; }

.mdi-steering-off::before {
  content: "\\F090E"; }

.mdi-step-backward::before {
  content: "\\F04D5"; }

.mdi-step-backward-2::before {
  content: "\\F04D6"; }

.mdi-step-forward::before {
  content: "\\F04D7"; }

.mdi-step-forward-2::before {
  content: "\\F04D8"; }

.mdi-stethoscope::before {
  content: "\\F04D9"; }

.mdi-sticker::before {
  content: "\\F1364"; }

.mdi-sticker-alert::before {
  content: "\\F1365"; }

.mdi-sticker-alert-outline::before {
  content: "\\F1366"; }

.mdi-sticker-check::before {
  content: "\\F1367"; }

.mdi-sticker-check-outline::before {
  content: "\\F1368"; }

.mdi-sticker-circle-outline::before {
  content: "\\F05D0"; }

.mdi-sticker-emoji::before {
  content: "\\F0785"; }

.mdi-sticker-minus::before {
  content: "\\F1369"; }

.mdi-sticker-minus-outline::before {
  content: "\\F136A"; }

.mdi-sticker-outline::before {
  content: "\\F136B"; }

.mdi-sticker-plus::before {
  content: "\\F136C"; }

.mdi-sticker-plus-outline::before {
  content: "\\F136D"; }

.mdi-sticker-remove::before {
  content: "\\F136E"; }

.mdi-sticker-remove-outline::before {
  content: "\\F136F"; }

.mdi-sticker-text::before {
  content: "\\F178E"; }

.mdi-sticker-text-outline::before {
  content: "\\F178F"; }

.mdi-stocking::before {
  content: "\\F04DA"; }

.mdi-stomach::before {
  content: "\\F1093"; }

.mdi-stool::before {
  content: "\\F195D"; }

.mdi-stool-outline::before {
  content: "\\F195E"; }

.mdi-stop::before {
  content: "\\F04DB"; }

.mdi-stop-circle::before {
  content: "\\F0666"; }

.mdi-stop-circle-outline::before {
  content: "\\F0667"; }

.mdi-store::before {
  content: "\\F04DC"; }

.mdi-store-24-hour::before {
  content: "\\F04DD"; }

.mdi-store-alert::before {
  content: "\\F18C1"; }

.mdi-store-alert-outline::before {
  content: "\\F18C2"; }

.mdi-store-check::before {
  content: "\\F18C3"; }

.mdi-store-check-outline::before {
  content: "\\F18C4"; }

.mdi-store-clock::before {
  content: "\\F18C5"; }

.mdi-store-clock-outline::before {
  content: "\\F18C6"; }

.mdi-store-cog::before {
  content: "\\F18C7"; }

.mdi-store-cog-outline::before {
  content: "\\F18C8"; }

.mdi-store-edit::before {
  content: "\\F18C9"; }

.mdi-store-edit-outline::before {
  content: "\\F18CA"; }

.mdi-store-marker::before {
  content: "\\F18CB"; }

.mdi-store-marker-outline::before {
  content: "\\F18CC"; }

.mdi-store-minus::before {
  content: "\\F165E"; }

.mdi-store-minus-outline::before {
  content: "\\F18CD"; }

.mdi-store-off::before {
  content: "\\F18CE"; }

.mdi-store-off-outline::before {
  content: "\\F18CF"; }

.mdi-store-outline::before {
  content: "\\F1361"; }

.mdi-store-plus::before {
  content: "\\F165F"; }

.mdi-store-plus-outline::before {
  content: "\\F18D0"; }

.mdi-store-remove::before {
  content: "\\F1660"; }

.mdi-store-remove-outline::before {
  content: "\\F18D1"; }

.mdi-store-search::before {
  content: "\\F18D2"; }

.mdi-store-search-outline::before {
  content: "\\F18D3"; }

.mdi-store-settings::before {
  content: "\\F18D4"; }

.mdi-store-settings-outline::before {
  content: "\\F18D5"; }

.mdi-storefront::before {
  content: "\\F07C7"; }

.mdi-storefront-outline::before {
  content: "\\F10C1"; }

.mdi-stove::before {
  content: "\\F04DE"; }

.mdi-strategy::before {
  content: "\\F11D6"; }

.mdi-stretch-to-page::before {
  content: "\\F0F2B"; }

.mdi-stretch-to-page-outline::before {
  content: "\\F0F2C"; }

.mdi-string-lights::before {
  content: "\\F12BA"; }

.mdi-string-lights-off::before {
  content: "\\F12BB"; }

.mdi-subdirectory-arrow-left::before {
  content: "\\F060C"; }

.mdi-subdirectory-arrow-right::before {
  content: "\\F060D"; }

.mdi-submarine::before {
  content: "\\F156C"; }

.mdi-subtitles::before {
  content: "\\F0A16"; }

.mdi-subtitles-outline::before {
  content: "\\F0A17"; }

.mdi-subway::before {
  content: "\\F06AC"; }

.mdi-subway-alert-variant::before {
  content: "\\F0D9D"; }

.mdi-subway-variant::before {
  content: "\\F04DF"; }

.mdi-summit::before {
  content: "\\F0786"; }

.mdi-sun-compass::before {
  content: "\\F19A5"; }

.mdi-sun-snowflake::before {
  content: "\\F1796"; }

.mdi-sun-thermometer::before {
  content: "\\F18D6"; }

.mdi-sun-thermometer-outline::before {
  content: "\\F18D7"; }

.mdi-sun-wireless::before {
  content: "\\F17FE"; }

.mdi-sun-wireless-outline::before {
  content: "\\F17FF"; }

.mdi-sunglasses::before {
  content: "\\F04E0"; }

.mdi-surfing::before {
  content: "\\F1746"; }

.mdi-surround-sound::before {
  content: "\\F05C5"; }

.mdi-surround-sound-2-0::before {
  content: "\\F07F0"; }

.mdi-surround-sound-2-1::before {
  content: "\\F1729"; }

.mdi-surround-sound-3-1::before {
  content: "\\F07F1"; }

.mdi-surround-sound-5-1::before {
  content: "\\F07F2"; }

.mdi-surround-sound-5-1-2::before {
  content: "\\F172A"; }

.mdi-surround-sound-7-1::before {
  content: "\\F07F3"; }

.mdi-svg::before {
  content: "\\F0721"; }

.mdi-swap-horizontal::before {
  content: "\\F04E1"; }

.mdi-swap-horizontal-bold::before {
  content: "\\F0BCD"; }

.mdi-swap-horizontal-circle::before {
  content: "\\F0FE1"; }

.mdi-swap-horizontal-circle-outline::before {
  content: "\\F0FE2"; }

.mdi-swap-horizontal-variant::before {
  content: "\\F08C1"; }

.mdi-swap-vertical::before {
  content: "\\F04E2"; }

.mdi-swap-vertical-bold::before {
  content: "\\F0BCE"; }

.mdi-swap-vertical-circle::before {
  content: "\\F0FE3"; }

.mdi-swap-vertical-circle-outline::before {
  content: "\\F0FE4"; }

.mdi-swap-vertical-variant::before {
  content: "\\F08C2"; }

.mdi-swim::before {
  content: "\\F04E3"; }

.mdi-switch::before {
  content: "\\F04E4"; }

.mdi-sword::before {
  content: "\\F04E5"; }

.mdi-sword-cross::before {
  content: "\\F0787"; }

.mdi-syllabary-hangul::before {
  content: "\\F1333"; }

.mdi-syllabary-hiragana::before {
  content: "\\F1334"; }

.mdi-syllabary-katakana::before {
  content: "\\F1335"; }

.mdi-syllabary-katakana-halfwidth::before {
  content: "\\F1336"; }

.mdi-symbol::before {
  content: "\\F1501"; }

.mdi-symfony::before {
  content: "\\F0AE6"; }

.mdi-sync::before {
  content: "\\F04E6"; }

.mdi-sync-alert::before {
  content: "\\F04E7"; }

.mdi-sync-circle::before {
  content: "\\F1378"; }

.mdi-sync-off::before {
  content: "\\F04E8"; }

.mdi-tab::before {
  content: "\\F04E9"; }

.mdi-tab-minus::before {
  content: "\\F0B4B"; }

.mdi-tab-plus::before {
  content: "\\F075C"; }

.mdi-tab-remove::before {
  content: "\\F0B4C"; }

.mdi-tab-search::before {
  content: "\\F199E"; }

.mdi-tab-unselected::before {
  content: "\\F04EA"; }

.mdi-table::before {
  content: "\\F04EB"; }

.mdi-table-account::before {
  content: "\\F13B9"; }

.mdi-table-alert::before {
  content: "\\F13BA"; }

.mdi-table-arrow-down::before {
  content: "\\F13BB"; }

.mdi-table-arrow-left::before {
  content: "\\F13BC"; }

.mdi-table-arrow-right::before {
  content: "\\F13BD"; }

.mdi-table-arrow-up::before {
  content: "\\F13BE"; }

.mdi-table-border::before {
  content: "\\F0A18"; }

.mdi-table-cancel::before {
  content: "\\F13BF"; }

.mdi-table-chair::before {
  content: "\\F1061"; }

.mdi-table-check::before {
  content: "\\F13C0"; }

.mdi-table-clock::before {
  content: "\\F13C1"; }

.mdi-table-cog::before {
  content: "\\F13C2"; }

.mdi-table-column::before {
  content: "\\F0835"; }

.mdi-table-column-plus-after::before {
  content: "\\F04EC"; }

.mdi-table-column-plus-before::before {
  content: "\\F04ED"; }

.mdi-table-column-remove::before {
  content: "\\F04EE"; }

.mdi-table-column-width::before {
  content: "\\F04EF"; }

.mdi-table-edit::before {
  content: "\\F04F0"; }

.mdi-table-eye::before {
  content: "\\F1094"; }

.mdi-table-eye-off::before {
  content: "\\F13C3"; }

.mdi-table-furniture::before {
  content: "\\F05BC"; }

.mdi-table-headers-eye::before {
  content: "\\F121D"; }

.mdi-table-headers-eye-off::before {
  content: "\\F121E"; }

.mdi-table-heart::before {
  content: "\\F13C4"; }

.mdi-table-key::before {
  content: "\\F13C5"; }

.mdi-table-large::before {
  content: "\\F04F1"; }

.mdi-table-large-plus::before {
  content: "\\F0F87"; }

.mdi-table-large-remove::before {
  content: "\\F0F88"; }

.mdi-table-lock::before {
  content: "\\F13C6"; }

.mdi-table-merge-cells::before {
  content: "\\F09A6"; }

.mdi-table-minus::before {
  content: "\\F13C7"; }

.mdi-table-multiple::before {
  content: "\\F13C8"; }

.mdi-table-network::before {
  content: "\\F13C9"; }

.mdi-table-of-contents::before {
  content: "\\F0836"; }

.mdi-table-off::before {
  content: "\\F13CA"; }

.mdi-table-picnic::before {
  content: "\\F1743"; }

.mdi-table-pivot::before {
  content: "\\F183C"; }

.mdi-table-plus::before {
  content: "\\F0A75"; }

.mdi-table-refresh::before {
  content: "\\F13A0"; }

.mdi-table-remove::before {
  content: "\\F0A76"; }

.mdi-table-row::before {
  content: "\\F0837"; }

.mdi-table-row-height::before {
  content: "\\F04F2"; }

.mdi-table-row-plus-after::before {
  content: "\\F04F3"; }

.mdi-table-row-plus-before::before {
  content: "\\F04F4"; }

.mdi-table-row-remove::before {
  content: "\\F04F5"; }

.mdi-table-search::before {
  content: "\\F090F"; }

.mdi-table-settings::before {
  content: "\\F0838"; }

.mdi-table-split-cell::before {
  content: "\\F142A"; }

.mdi-table-star::before {
  content: "\\F13CB"; }

.mdi-table-sync::before {
  content: "\\F13A1"; }

.mdi-table-tennis::before {
  content: "\\F0E68"; }

.mdi-tablet::before {
  content: "\\F04F6"; }

.mdi-tablet-android::before {
  content: "\\F04F7"; }

.mdi-tablet-cellphone::before {
  content: "\\F09A7"; }

.mdi-tablet-dashboard::before {
  content: "\\F0ECE"; }

.mdi-taco::before {
  content: "\\F0762"; }

.mdi-tag::before {
  content: "\\F04F9"; }

.mdi-tag-arrow-down::before {
  content: "\\F172B"; }

.mdi-tag-arrow-down-outline::before {
  content: "\\F172C"; }

.mdi-tag-arrow-left::before {
  content: "\\F172D"; }

.mdi-tag-arrow-left-outline::before {
  content: "\\F172E"; }

.mdi-tag-arrow-right::before {
  content: "\\F172F"; }

.mdi-tag-arrow-right-outline::before {
  content: "\\F1730"; }

.mdi-tag-arrow-up::before {
  content: "\\F1731"; }

.mdi-tag-arrow-up-outline::before {
  content: "\\F1732"; }

.mdi-tag-faces::before {
  content: "\\F04FA"; }

.mdi-tag-heart::before {
  content: "\\F068B"; }

.mdi-tag-heart-outline::before {
  content: "\\F0BCF"; }

.mdi-tag-minus::before {
  content: "\\F0910"; }

.mdi-tag-minus-outline::before {
  content: "\\F121F"; }

.mdi-tag-multiple::before {
  content: "\\F04FB"; }

.mdi-tag-multiple-outline::before {
  content: "\\F12F7"; }

.mdi-tag-off::before {
  content: "\\F1220"; }

.mdi-tag-off-outline::before {
  content: "\\F1221"; }

.mdi-tag-outline::before {
  content: "\\F04FC"; }

.mdi-tag-plus::before {
  content: "\\F0722"; }

.mdi-tag-plus-outline::before {
  content: "\\F1222"; }

.mdi-tag-remove::before {
  content: "\\F0723"; }

.mdi-tag-remove-outline::before {
  content: "\\F1223"; }

.mdi-tag-search::before {
  content: "\\F1907"; }

.mdi-tag-search-outline::before {
  content: "\\F1908"; }

.mdi-tag-text::before {
  content: "\\F1224"; }

.mdi-tag-text-outline::before {
  content: "\\F04FD"; }

.mdi-tailwind::before {
  content: "\\F13FF"; }

.mdi-tangram::before {
  content: "\\F04F8"; }

.mdi-tank::before {
  content: "\\F0D3A"; }

.mdi-tanker-truck::before {
  content: "\\F0FE5"; }

.mdi-tape-drive::before {
  content: "\\F16DF"; }

.mdi-tape-measure::before {
  content: "\\F0B4D"; }

.mdi-target::before {
  content: "\\F04FE"; }

.mdi-target-account::before {
  content: "\\F0BD0"; }

.mdi-target-variant::before {
  content: "\\F0A77"; }

.mdi-taxi::before {
  content: "\\F04FF"; }

.mdi-tea::before {
  content: "\\F0D9E"; }

.mdi-tea-outline::before {
  content: "\\F0D9F"; }

.mdi-teamviewer::before {
  content: "\\F0500"; }

.mdi-teddy-bear::before {
  content: "\\F18FB"; }

.mdi-telescope::before {
  content: "\\F0B4E"; }

.mdi-television::before {
  content: "\\F0502"; }

.mdi-television-ambient-light::before {
  content: "\\F1356"; }

.mdi-television-box::before {
  content: "\\F0839"; }

.mdi-television-classic::before {
  content: "\\F07F4"; }

.mdi-television-classic-off::before {
  content: "\\F083A"; }

.mdi-television-guide::before {
  content: "\\F0503"; }

.mdi-television-off::before {
  content: "\\F083B"; }

.mdi-television-pause::before {
  content: "\\F0F89"; }

.mdi-television-play::before {
  content: "\\F0ECF"; }

.mdi-television-shimmer::before {
  content: "\\F1110"; }

.mdi-television-stop::before {
  content: "\\F0F8A"; }

.mdi-temperature-celsius::before {
  content: "\\F0504"; }

.mdi-temperature-fahrenheit::before {
  content: "\\F0505"; }

.mdi-temperature-kelvin::before {
  content: "\\F0506"; }

.mdi-tennis::before {
  content: "\\F0DA0"; }

.mdi-tennis-ball::before {
  content: "\\F0507"; }

.mdi-tent::before {
  content: "\\F0508"; }

.mdi-terraform::before {
  content: "\\F1062"; }

.mdi-terrain::before {
  content: "\\F0509"; }

.mdi-test-tube::before {
  content: "\\F0668"; }

.mdi-test-tube-empty::before {
  content: "\\F0911"; }

.mdi-test-tube-off::before {
  content: "\\F0912"; }

.mdi-text::before {
  content: "\\F09A8"; }

.mdi-text-account::before {
  content: "\\F1570"; }

.mdi-text-box::before {
  content: "\\F021A"; }

.mdi-text-box-check::before {
  content: "\\F0EA6"; }

.mdi-text-box-check-outline::before {
  content: "\\F0EA7"; }

.mdi-text-box-minus::before {
  content: "\\F0EA8"; }

.mdi-text-box-minus-outline::before {
  content: "\\F0EA9"; }

.mdi-text-box-multiple::before {
  content: "\\F0AB7"; }

.mdi-text-box-multiple-outline::before {
  content: "\\F0AB8"; }

.mdi-text-box-outline::before {
  content: "\\F09ED"; }

.mdi-text-box-plus::before {
  content: "\\F0EAA"; }

.mdi-text-box-plus-outline::before {
  content: "\\F0EAB"; }

.mdi-text-box-remove::before {
  content: "\\F0EAC"; }

.mdi-text-box-remove-outline::before {
  content: "\\F0EAD"; }

.mdi-text-box-search::before {
  content: "\\F0EAE"; }

.mdi-text-box-search-outline::before {
  content: "\\F0EAF"; }

.mdi-text-long::before {
  content: "\\F09AA"; }

.mdi-text-recognition::before {
  content: "\\F113D"; }

.mdi-text-search::before {
  content: "\\F13B8"; }

.mdi-text-shadow::before {
  content: "\\F0669"; }

.mdi-text-short::before {
  content: "\\F09A9"; }

.mdi-text-to-speech::before {
  content: "\\F050A"; }

.mdi-text-to-speech-off::before {
  content: "\\F050B"; }

.mdi-texture::before {
  content: "\\F050C"; }

.mdi-texture-box::before {
  content: "\\F0FE6"; }

.mdi-theater::before {
  content: "\\F050D"; }

.mdi-theme-light-dark::before {
  content: "\\F050E"; }

.mdi-thermometer::before {
  content: "\\F050F"; }

.mdi-thermometer-alert::before {
  content: "\\F0E01"; }

.mdi-thermometer-bluetooth::before {
  content: "\\F1895"; }

.mdi-thermometer-chevron-down::before {
  content: "\\F0E02"; }

.mdi-thermometer-chevron-up::before {
  content: "\\F0E03"; }

.mdi-thermometer-high::before {
  content: "\\F10C2"; }

.mdi-thermometer-lines::before {
  content: "\\F0510"; }

.mdi-thermometer-low::before {
  content: "\\F10C3"; }

.mdi-thermometer-minus::before {
  content: "\\F0E04"; }

.mdi-thermometer-off::before {
  content: "\\F1531"; }

.mdi-thermometer-plus::before {
  content: "\\F0E05"; }

.mdi-thermostat::before {
  content: "\\F0393"; }

.mdi-thermostat-box::before {
  content: "\\F0891"; }

.mdi-thought-bubble::before {
  content: "\\F07F6"; }

.mdi-thought-bubble-outline::before {
  content: "\\F07F7"; }

.mdi-thumb-down::before {
  content: "\\F0511"; }

.mdi-thumb-down-outline::before {
  content: "\\F0512"; }

.mdi-thumb-up::before {
  content: "\\F0513"; }

.mdi-thumb-up-outline::before {
  content: "\\F0514"; }

.mdi-thumbs-up-down::before {
  content: "\\F0515"; }

.mdi-thumbs-up-down-outline::before {
  content: "\\F1914"; }

.mdi-ticket::before {
  content: "\\F0516"; }

.mdi-ticket-account::before {
  content: "\\F0517"; }

.mdi-ticket-confirmation::before {
  content: "\\F0518"; }

.mdi-ticket-confirmation-outline::before {
  content: "\\F13AA"; }

.mdi-ticket-outline::before {
  content: "\\F0913"; }

.mdi-ticket-percent::before {
  content: "\\F0724"; }

.mdi-ticket-percent-outline::before {
  content: "\\F142B"; }

.mdi-tie::before {
  content: "\\F0519"; }

.mdi-tilde::before {
  content: "\\F0725"; }

.mdi-tilde-off::before {
  content: "\\F18F3"; }

.mdi-timelapse::before {
  content: "\\F051A"; }

.mdi-timeline::before {
  content: "\\F0BD1"; }

.mdi-timeline-alert::before {
  content: "\\F0F95"; }

.mdi-timeline-alert-outline::before {
  content: "\\F0F98"; }

.mdi-timeline-check::before {
  content: "\\F1532"; }

.mdi-timeline-check-outline::before {
  content: "\\F1533"; }

.mdi-timeline-clock::before {
  content: "\\F11FB"; }

.mdi-timeline-clock-outline::before {
  content: "\\F11FC"; }

.mdi-timeline-help::before {
  content: "\\F0F99"; }

.mdi-timeline-help-outline::before {
  content: "\\F0F9A"; }

.mdi-timeline-minus::before {
  content: "\\F1534"; }

.mdi-timeline-minus-outline::before {
  content: "\\F1535"; }

.mdi-timeline-outline::before {
  content: "\\F0BD2"; }

.mdi-timeline-plus::before {
  content: "\\F0F96"; }

.mdi-timeline-plus-outline::before {
  content: "\\F0F97"; }

.mdi-timeline-remove::before {
  content: "\\F1536"; }

.mdi-timeline-remove-outline::before {
  content: "\\F1537"; }

.mdi-timeline-text::before {
  content: "\\F0BD3"; }

.mdi-timeline-text-outline::before {
  content: "\\F0BD4"; }

.mdi-timer::before {
  content: "\\F13AB"; }

.mdi-timer-10::before {
  content: "\\F051C"; }

.mdi-timer-3::before {
  content: "\\F051D"; }

.mdi-timer-cog::before {
  content: "\\F1925"; }

.mdi-timer-cog-outline::before {
  content: "\\F1926"; }

.mdi-timer-off::before {
  content: "\\F13AC"; }

.mdi-timer-off-outline::before {
  content: "\\F051E"; }

.mdi-timer-outline::before {
  content: "\\F051B"; }

.mdi-timer-sand::before {
  content: "\\F051F"; }

.mdi-timer-sand-complete::before {
  content: "\\F199F"; }

.mdi-timer-sand-empty::before {
  content: "\\F06AD"; }

.mdi-timer-sand-full::before {
  content: "\\F078C"; }

.mdi-timer-sand-paused::before {
  content: "\\F19A0"; }

.mdi-timer-settings::before {
  content: "\\F1923"; }

.mdi-timer-settings-outline::before {
  content: "\\F1924"; }

.mdi-timetable::before {
  content: "\\F0520"; }

.mdi-tire::before {
  content: "\\F1896"; }

.mdi-toaster::before {
  content: "\\F1063"; }

.mdi-toaster-off::before {
  content: "\\F11B7"; }

.mdi-toaster-oven::before {
  content: "\\F0CD3"; }

.mdi-toggle-switch::before {
  content: "\\F0521"; }

.mdi-toggle-switch-off::before {
  content: "\\F0522"; }

.mdi-toggle-switch-off-outline::before {
  content: "\\F0A19"; }

.mdi-toggle-switch-outline::before {
  content: "\\F0A1A"; }

.mdi-toilet::before {
  content: "\\F09AB"; }

.mdi-toolbox::before {
  content: "\\F09AC"; }

.mdi-toolbox-outline::before {
  content: "\\F09AD"; }

.mdi-tools::before {
  content: "\\F1064"; }

.mdi-tooltip::before {
  content: "\\F0523"; }

.mdi-tooltip-account::before {
  content: "\\F000C"; }

.mdi-tooltip-cellphone::before {
  content: "\\F183B"; }

.mdi-tooltip-check::before {
  content: "\\F155C"; }

.mdi-tooltip-check-outline::before {
  content: "\\F155D"; }

.mdi-tooltip-edit::before {
  content: "\\F0524"; }

.mdi-tooltip-edit-outline::before {
  content: "\\F12C5"; }

.mdi-tooltip-image::before {
  content: "\\F0525"; }

.mdi-tooltip-image-outline::before {
  content: "\\F0BD5"; }

.mdi-tooltip-minus::before {
  content: "\\F155E"; }

.mdi-tooltip-minus-outline::before {
  content: "\\F155F"; }

.mdi-tooltip-outline::before {
  content: "\\F0526"; }

.mdi-tooltip-plus::before {
  content: "\\F0BD6"; }

.mdi-tooltip-plus-outline::before {
  content: "\\F0527"; }

.mdi-tooltip-remove::before {
  content: "\\F1560"; }

.mdi-tooltip-remove-outline::before {
  content: "\\F1561"; }

.mdi-tooltip-text::before {
  content: "\\F0528"; }

.mdi-tooltip-text-outline::before {
  content: "\\F0BD7"; }

.mdi-tooth::before {
  content: "\\F08C3"; }

.mdi-tooth-outline::before {
  content: "\\F0529"; }

.mdi-toothbrush::before {
  content: "\\F1129"; }

.mdi-toothbrush-electric::before {
  content: "\\F112C"; }

.mdi-toothbrush-paste::before {
  content: "\\F112A"; }

.mdi-torch::before {
  content: "\\F1606"; }

.mdi-tortoise::before {
  content: "\\F0D3B"; }

.mdi-toslink::before {
  content: "\\F12B8"; }

.mdi-tournament::before {
  content: "\\F09AE"; }

.mdi-tow-truck::before {
  content: "\\F083C"; }

.mdi-tower-beach::before {
  content: "\\F0681"; }

.mdi-tower-fire::before {
  content: "\\F0682"; }

.mdi-town-hall::before {
  content: "\\F1875"; }

.mdi-toy-brick::before {
  content: "\\F1288"; }

.mdi-toy-brick-marker::before {
  content: "\\F1289"; }

.mdi-toy-brick-marker-outline::before {
  content: "\\F128A"; }

.mdi-toy-brick-minus::before {
  content: "\\F128B"; }

.mdi-toy-brick-minus-outline::before {
  content: "\\F128C"; }

.mdi-toy-brick-outline::before {
  content: "\\F128D"; }

.mdi-toy-brick-plus::before {
  content: "\\F128E"; }

.mdi-toy-brick-plus-outline::before {
  content: "\\F128F"; }

.mdi-toy-brick-remove::before {
  content: "\\F1290"; }

.mdi-toy-brick-remove-outline::before {
  content: "\\F1291"; }

.mdi-toy-brick-search::before {
  content: "\\F1292"; }

.mdi-toy-brick-search-outline::before {
  content: "\\F1293"; }

.mdi-track-light::before {
  content: "\\F0914"; }

.mdi-trackpad::before {
  content: "\\F07F8"; }

.mdi-trackpad-lock::before {
  content: "\\F0933"; }

.mdi-tractor::before {
  content: "\\F0892"; }

.mdi-tractor-variant::before {
  content: "\\F14C4"; }

.mdi-trademark::before {
  content: "\\F0A78"; }

.mdi-traffic-cone::before {
  content: "\\F137C"; }

.mdi-traffic-light::before {
  content: "\\F052B"; }

.mdi-traffic-light-outline::before {
  content: "\\F182A"; }

.mdi-train::before {
  content: "\\F052C"; }

.mdi-train-car::before {
  content: "\\F0BD8"; }

.mdi-train-car-passenger::before {
  content: "\\F1733"; }

.mdi-train-car-passenger-door::before {
  content: "\\F1734"; }

.mdi-train-car-passenger-door-open::before {
  content: "\\F1735"; }

.mdi-train-car-passenger-variant::before {
  content: "\\F1736"; }

.mdi-train-variant::before {
  content: "\\F08C4"; }

.mdi-tram::before {
  content: "\\F052D"; }

.mdi-tram-side::before {
  content: "\\F0FE7"; }

.mdi-transcribe::before {
  content: "\\F052E"; }

.mdi-transcribe-close::before {
  content: "\\F052F"; }

.mdi-transfer::before {
  content: "\\F1065"; }

.mdi-transfer-down::before {
  content: "\\F0DA1"; }

.mdi-transfer-left::before {
  content: "\\F0DA2"; }

.mdi-transfer-right::before {
  content: "\\F0530"; }

.mdi-transfer-up::before {
  content: "\\F0DA3"; }

.mdi-transit-connection::before {
  content: "\\F0D3C"; }

.mdi-transit-connection-horizontal::before {
  content: "\\F1546"; }

.mdi-transit-connection-variant::before {
  content: "\\F0D3D"; }

.mdi-transit-detour::before {
  content: "\\F0F8B"; }

.mdi-transit-skip::before {
  content: "\\F1515"; }

.mdi-transit-transfer::before {
  content: "\\F06AE"; }

.mdi-transition::before {
  content: "\\F0915"; }

.mdi-transition-masked::before {
  content: "\\F0916"; }

.mdi-translate::before {
  content: "\\F05CA"; }

.mdi-translate-off::before {
  content: "\\F0E06"; }

.mdi-transmission-tower::before {
  content: "\\F0D3E"; }

.mdi-transmission-tower-export::before {
  content: "\\F192C"; }

.mdi-transmission-tower-import::before {
  content: "\\F192D"; }

.mdi-trash-can::before {
  content: "\\F0A79"; }

.mdi-trash-can-outline::before {
  content: "\\F0A7A"; }

.mdi-tray::before {
  content: "\\F1294"; }

.mdi-tray-alert::before {
  content: "\\F1295"; }

.mdi-tray-arrow-down::before {
  content: "\\F0120"; }

.mdi-tray-arrow-up::before {
  content: "\\F011D"; }

.mdi-tray-full::before {
  content: "\\F1296"; }

.mdi-tray-minus::before {
  content: "\\F1297"; }

.mdi-tray-plus::before {
  content: "\\F1298"; }

.mdi-tray-remove::before {
  content: "\\F1299"; }

.mdi-treasure-chest::before {
  content: "\\F0726"; }

.mdi-tree::before {
  content: "\\F0531"; }

.mdi-tree-outline::before {
  content: "\\F0E69"; }

.mdi-trello::before {
  content: "\\F0532"; }

.mdi-trending-down::before {
  content: "\\F0533"; }

.mdi-trending-neutral::before {
  content: "\\F0534"; }

.mdi-trending-up::before {
  content: "\\F0535"; }

.mdi-triangle::before {
  content: "\\F0536"; }

.mdi-triangle-outline::before {
  content: "\\F0537"; }

.mdi-triangle-wave::before {
  content: "\\F147C"; }

.mdi-triforce::before {
  content: "\\F0BD9"; }

.mdi-trophy::before {
  content: "\\F0538"; }

.mdi-trophy-award::before {
  content: "\\F0539"; }

.mdi-trophy-broken::before {
  content: "\\F0DA4"; }

.mdi-trophy-outline::before {
  content: "\\F053A"; }

.mdi-trophy-variant::before {
  content: "\\F053B"; }

.mdi-trophy-variant-outline::before {
  content: "\\F053C"; }

.mdi-truck::before {
  content: "\\F053D"; }

.mdi-truck-cargo-container::before {
  content: "\\F18D8"; }

.mdi-truck-check::before {
  content: "\\F0CD4"; }

.mdi-truck-check-outline::before {
  content: "\\F129A"; }

.mdi-truck-delivery::before {
  content: "\\F053E"; }

.mdi-truck-delivery-outline::before {
  content: "\\F129B"; }

.mdi-truck-fast::before {
  content: "\\F0788"; }

.mdi-truck-fast-outline::before {
  content: "\\F129C"; }

.mdi-truck-flatbed::before {
  content: "\\F1891"; }

.mdi-truck-minus::before {
  content: "\\F19AE"; }

.mdi-truck-minus-outline::before {
  content: "\\F19BD"; }

.mdi-truck-outline::before {
  content: "\\F129D"; }

.mdi-truck-plus::before {
  content: "\\F19AD"; }

.mdi-truck-plus-outline::before {
  content: "\\F19BC"; }

.mdi-truck-remove::before {
  content: "\\F19AF"; }

.mdi-truck-remove-outline::before {
  content: "\\F19BE"; }

.mdi-truck-snowflake::before {
  content: "\\F19A6"; }

.mdi-truck-trailer::before {
  content: "\\F0727"; }

.mdi-trumpet::before {
  content: "\\F1096"; }

.mdi-tshirt-crew::before {
  content: "\\F0A7B"; }

.mdi-tshirt-crew-outline::before {
  content: "\\F053F"; }

.mdi-tshirt-v::before {
  content: "\\F0A7C"; }

.mdi-tshirt-v-outline::before {
  content: "\\F0540"; }

.mdi-tumble-dryer::before {
  content: "\\F0917"; }

.mdi-tumble-dryer-alert::before {
  content: "\\F11BA"; }

.mdi-tumble-dryer-off::before {
  content: "\\F11BB"; }

.mdi-tune::before {
  content: "\\F062E"; }

.mdi-tune-variant::before {
  content: "\\F1542"; }

.mdi-tune-vertical::before {
  content: "\\F066A"; }

.mdi-tune-vertical-variant::before {
  content: "\\F1543"; }

.mdi-tunnel::before {
  content: "\\F183D"; }

.mdi-tunnel-outline::before {
  content: "\\F183E"; }

.mdi-turkey::before {
  content: "\\F171B"; }

.mdi-turnstile::before {
  content: "\\F0CD5"; }

.mdi-turnstile-outline::before {
  content: "\\F0CD6"; }

.mdi-turtle::before {
  content: "\\F0CD7"; }

.mdi-twitch::before {
  content: "\\F0543"; }

.mdi-twitter::before {
  content: "\\F0544"; }

.mdi-two-factor-authentication::before {
  content: "\\F09AF"; }

.mdi-typewriter::before {
  content: "\\F0F2D"; }

.mdi-ubisoft::before {
  content: "\\F0BDA"; }

.mdi-ubuntu::before {
  content: "\\F0548"; }

.mdi-ufo::before {
  content: "\\F10C4"; }

.mdi-ufo-outline::before {
  content: "\\F10C5"; }

.mdi-ultra-high-definition::before {
  content: "\\F07F9"; }

.mdi-umbraco::before {
  content: "\\F0549"; }

.mdi-umbrella::before {
  content: "\\F054A"; }

.mdi-umbrella-beach::before {
  content: "\\F188A"; }

.mdi-umbrella-beach-outline::before {
  content: "\\F188B"; }

.mdi-umbrella-closed::before {
  content: "\\F09B0"; }

.mdi-umbrella-closed-outline::before {
  content: "\\F13E2"; }

.mdi-umbrella-closed-variant::before {
  content: "\\F13E1"; }

.mdi-umbrella-outline::before {
  content: "\\F054B"; }

.mdi-undo::before {
  content: "\\F054C"; }

.mdi-undo-variant::before {
  content: "\\F054D"; }

.mdi-unfold-less-horizontal::before {
  content: "\\F054E"; }

.mdi-unfold-less-vertical::before {
  content: "\\F0760"; }

.mdi-unfold-more-horizontal::before {
  content: "\\F054F"; }

.mdi-unfold-more-vertical::before {
  content: "\\F0761"; }

.mdi-ungroup::before {
  content: "\\F0550"; }

.mdi-unicode::before {
  content: "\\F0ED0"; }

.mdi-unicorn::before {
  content: "\\F15C2"; }

.mdi-unicorn-variant::before {
  content: "\\F15C3"; }

.mdi-unicycle::before {
  content: "\\F15E5"; }

.mdi-unity::before {
  content: "\\F06AF"; }

.mdi-unreal::before {
  content: "\\F09B1"; }

.mdi-update::before {
  content: "\\F06B0"; }

.mdi-upload::before {
  content: "\\F0552"; }

.mdi-upload-lock::before {
  content: "\\F1373"; }

.mdi-upload-lock-outline::before {
  content: "\\F1374"; }

.mdi-upload-multiple::before {
  content: "\\F083D"; }

.mdi-upload-network::before {
  content: "\\F06F6"; }

.mdi-upload-network-outline::before {
  content: "\\F0CD8"; }

.mdi-upload-off::before {
  content: "\\F10C6"; }

.mdi-upload-off-outline::before {
  content: "\\F10C7"; }

.mdi-upload-outline::before {
  content: "\\F0E07"; }

.mdi-usb::before {
  content: "\\F0553"; }

.mdi-usb-flash-drive::before {
  content: "\\F129E"; }

.mdi-usb-flash-drive-outline::before {
  content: "\\F129F"; }

.mdi-usb-port::before {
  content: "\\F11F0"; }

.mdi-vacuum::before {
  content: "\\F19A1"; }

.mdi-vacuum-outline::before {
  content: "\\F19A2"; }

.mdi-valve::before {
  content: "\\F1066"; }

.mdi-valve-closed::before {
  content: "\\F1067"; }

.mdi-valve-open::before {
  content: "\\F1068"; }

.mdi-van-passenger::before {
  content: "\\F07FA"; }

.mdi-van-utility::before {
  content: "\\F07FB"; }

.mdi-vanish::before {
  content: "\\F07FC"; }

.mdi-vanish-quarter::before {
  content: "\\F1554"; }

.mdi-vanity-light::before {
  content: "\\F11E1"; }

.mdi-variable::before {
  content: "\\F0AE7"; }

.mdi-variable-box::before {
  content: "\\F1111"; }

.mdi-vector-arrange-above::before {
  content: "\\F0554"; }

.mdi-vector-arrange-below::before {
  content: "\\F0555"; }

.mdi-vector-bezier::before {
  content: "\\F0AE8"; }

.mdi-vector-circle::before {
  content: "\\F0556"; }

.mdi-vector-circle-variant::before {
  content: "\\F0557"; }

.mdi-vector-combine::before {
  content: "\\F0558"; }

.mdi-vector-curve::before {
  content: "\\F0559"; }

.mdi-vector-difference::before {
  content: "\\F055A"; }

.mdi-vector-difference-ab::before {
  content: "\\F055B"; }

.mdi-vector-difference-ba::before {
  content: "\\F055C"; }

.mdi-vector-ellipse::before {
  content: "\\F0893"; }

.mdi-vector-intersection::before {
  content: "\\F055D"; }

.mdi-vector-line::before {
  content: "\\F055E"; }

.mdi-vector-link::before {
  content: "\\F0FE8"; }

.mdi-vector-point::before {
  content: "\\F055F"; }

.mdi-vector-polygon::before {
  content: "\\F0560"; }

.mdi-vector-polygon-variant::before {
  content: "\\F1856"; }

.mdi-vector-polyline::before {
  content: "\\F0561"; }

.mdi-vector-polyline-edit::before {
  content: "\\F1225"; }

.mdi-vector-polyline-minus::before {
  content: "\\F1226"; }

.mdi-vector-polyline-plus::before {
  content: "\\F1227"; }

.mdi-vector-polyline-remove::before {
  content: "\\F1228"; }

.mdi-vector-radius::before {
  content: "\\F074A"; }

.mdi-vector-rectangle::before {
  content: "\\F05C6"; }

.mdi-vector-selection::before {
  content: "\\F0562"; }

.mdi-vector-square::before {
  content: "\\F0001"; }

.mdi-vector-square-close::before {
  content: "\\F1857"; }

.mdi-vector-square-edit::before {
  content: "\\F18D9"; }

.mdi-vector-square-minus::before {
  content: "\\F18DA"; }

.mdi-vector-square-open::before {
  content: "\\F1858"; }

.mdi-vector-square-plus::before {
  content: "\\F18DB"; }

.mdi-vector-square-remove::before {
  content: "\\F18DC"; }

.mdi-vector-triangle::before {
  content: "\\F0563"; }

.mdi-vector-union::before {
  content: "\\F0564"; }

.mdi-vhs::before {
  content: "\\F0A1B"; }

.mdi-vibrate::before {
  content: "\\F0566"; }

.mdi-vibrate-off::before {
  content: "\\F0CD9"; }

.mdi-video::before {
  content: "\\F0567"; }

.mdi-video-3d::before {
  content: "\\F07FD"; }

.mdi-video-3d-off::before {
  content: "\\F13D9"; }

.mdi-video-3d-variant::before {
  content: "\\F0ED1"; }

.mdi-video-4k-box::before {
  content: "\\F083E"; }

.mdi-video-account::before {
  content: "\\F0919"; }

.mdi-video-box::before {
  content: "\\F00FD"; }

.mdi-video-box-off::before {
  content: "\\F00FE"; }

.mdi-video-check::before {
  content: "\\F1069"; }

.mdi-video-check-outline::before {
  content: "\\F106A"; }

.mdi-video-high-definition::before {
  content: "\\F152E"; }

.mdi-video-image::before {
  content: "\\F091A"; }

.mdi-video-input-antenna::before {
  content: "\\F083F"; }

.mdi-video-input-component::before {
  content: "\\F0840"; }

.mdi-video-input-hdmi::before {
  content: "\\F0841"; }

.mdi-video-input-scart::before {
  content: "\\F0F8C"; }

.mdi-video-input-svideo::before {
  content: "\\F0842"; }

.mdi-video-marker::before {
  content: "\\F19A9"; }

.mdi-video-marker-outline::before {
  content: "\\F19AA"; }

.mdi-video-minus::before {
  content: "\\F09B2"; }

.mdi-video-minus-outline::before {
  content: "\\F02BA"; }

.mdi-video-off::before {
  content: "\\F0568"; }

.mdi-video-off-outline::before {
  content: "\\F0BDB"; }

.mdi-video-outline::before {
  content: "\\F0BDC"; }

.mdi-video-plus::before {
  content: "\\F09B3"; }

.mdi-video-plus-outline::before {
  content: "\\F01D3"; }

.mdi-video-stabilization::before {
  content: "\\F091B"; }

.mdi-video-switch::before {
  content: "\\F0569"; }

.mdi-video-switch-outline::before {
  content: "\\F0790"; }

.mdi-video-vintage::before {
  content: "\\F0A1C"; }

.mdi-video-wireless::before {
  content: "\\F0ED2"; }

.mdi-video-wireless-outline::before {
  content: "\\F0ED3"; }

.mdi-view-agenda::before {
  content: "\\F056A"; }

.mdi-view-agenda-outline::before {
  content: "\\F11D8"; }

.mdi-view-array::before {
  content: "\\F056B"; }

.mdi-view-array-outline::before {
  content: "\\F1485"; }

.mdi-view-carousel::before {
  content: "\\F056C"; }

.mdi-view-carousel-outline::before {
  content: "\\F1486"; }

.mdi-view-column::before {
  content: "\\F056D"; }

.mdi-view-column-outline::before {
  content: "\\F1487"; }

.mdi-view-comfy::before {
  content: "\\F0E6A"; }

.mdi-view-comfy-outline::before {
  content: "\\F1488"; }

.mdi-view-compact::before {
  content: "\\F0E6B"; }

.mdi-view-compact-outline::before {
  content: "\\F0E6C"; }

.mdi-view-dashboard::before {
  content: "\\F056E"; }

.mdi-view-dashboard-edit::before {
  content: "\\F1947"; }

.mdi-view-dashboard-edit-outline::before {
  content: "\\F1948"; }

.mdi-view-dashboard-outline::before {
  content: "\\F0A1D"; }

.mdi-view-dashboard-variant::before {
  content: "\\F0843"; }

.mdi-view-dashboard-variant-outline::before {
  content: "\\F1489"; }

.mdi-view-day::before {
  content: "\\F056F"; }

.mdi-view-day-outline::before {
  content: "\\F148A"; }

.mdi-view-gallery::before {
  content: "\\F1888"; }

.mdi-view-gallery-outline::before {
  content: "\\F1889"; }

.mdi-view-grid::before {
  content: "\\F0570"; }

.mdi-view-grid-outline::before {
  content: "\\F11D9"; }

.mdi-view-grid-plus::before {
  content: "\\F0F8D"; }

.mdi-view-grid-plus-outline::before {
  content: "\\F11DA"; }

.mdi-view-headline::before {
  content: "\\F0571"; }

.mdi-view-list::before {
  content: "\\F0572"; }

.mdi-view-list-outline::before {
  content: "\\F148B"; }

.mdi-view-module::before {
  content: "\\F0573"; }

.mdi-view-module-outline::before {
  content: "\\F148C"; }

.mdi-view-parallel::before {
  content: "\\F0728"; }

.mdi-view-parallel-outline::before {
  content: "\\F148D"; }

.mdi-view-quilt::before {
  content: "\\F0574"; }

.mdi-view-quilt-outline::before {
  content: "\\F148E"; }

.mdi-view-sequential::before {
  content: "\\F0729"; }

.mdi-view-sequential-outline::before {
  content: "\\F148F"; }

.mdi-view-split-horizontal::before {
  content: "\\F0BCB"; }

.mdi-view-split-vertical::before {
  content: "\\F0BCC"; }

.mdi-view-stream::before {
  content: "\\F0575"; }

.mdi-view-stream-outline::before {
  content: "\\F1490"; }

.mdi-view-week::before {
  content: "\\F0576"; }

.mdi-view-week-outline::before {
  content: "\\F1491"; }

.mdi-vimeo::before {
  content: "\\F0577"; }

.mdi-violin::before {
  content: "\\F060F"; }

.mdi-virtual-reality::before {
  content: "\\F0894"; }

.mdi-virus::before {
  content: "\\F13B6"; }

.mdi-virus-off::before {
  content: "\\F18E1"; }

.mdi-virus-off-outline::before {
  content: "\\F18E2"; }

.mdi-virus-outline::before {
  content: "\\F13B7"; }

.mdi-vlc::before {
  content: "\\F057C"; }

.mdi-voicemail::before {
  content: "\\F057D"; }

.mdi-volleyball::before {
  content: "\\F09B4"; }

.mdi-volume-high::before {
  content: "\\F057E"; }

.mdi-volume-low::before {
  content: "\\F057F"; }

.mdi-volume-medium::before {
  content: "\\F0580"; }

.mdi-volume-minus::before {
  content: "\\F075E"; }

.mdi-volume-mute::before {
  content: "\\F075F"; }

.mdi-volume-off::before {
  content: "\\F0581"; }

.mdi-volume-plus::before {
  content: "\\F075D"; }

.mdi-volume-source::before {
  content: "\\F1120"; }

.mdi-volume-variant-off::before {
  content: "\\F0E08"; }

.mdi-volume-vibrate::before {
  content: "\\F1121"; }

.mdi-vote::before {
  content: "\\F0A1F"; }

.mdi-vote-outline::before {
  content: "\\F0A20"; }

.mdi-vpn::before {
  content: "\\F0582"; }

.mdi-vuejs::before {
  content: "\\F0844"; }

.mdi-vuetify::before {
  content: "\\F0E6D"; }

.mdi-walk::before {
  content: "\\F0583"; }

.mdi-wall::before {
  content: "\\F07FE"; }

.mdi-wall-sconce::before {
  content: "\\F091C"; }

.mdi-wall-sconce-flat::before {
  content: "\\F091D"; }

.mdi-wall-sconce-flat-outline::before {
  content: "\\F17C9"; }

.mdi-wall-sconce-flat-variant::before {
  content: "\\F041C"; }

.mdi-wall-sconce-flat-variant-outline::before {
  content: "\\F17CA"; }

.mdi-wall-sconce-outline::before {
  content: "\\F17CB"; }

.mdi-wall-sconce-round::before {
  content: "\\F0748"; }

.mdi-wall-sconce-round-outline::before {
  content: "\\F17CC"; }

.mdi-wall-sconce-round-variant::before {
  content: "\\F091E"; }

.mdi-wall-sconce-round-variant-outline::before {
  content: "\\F17CD"; }

.mdi-wallet::before {
  content: "\\F0584"; }

.mdi-wallet-giftcard::before {
  content: "\\F0585"; }

.mdi-wallet-membership::before {
  content: "\\F0586"; }

.mdi-wallet-outline::before {
  content: "\\F0BDD"; }

.mdi-wallet-plus::before {
  content: "\\F0F8E"; }

.mdi-wallet-plus-outline::before {
  content: "\\F0F8F"; }

.mdi-wallet-travel::before {
  content: "\\F0587"; }

.mdi-wallpaper::before {
  content: "\\F0E09"; }

.mdi-wan::before {
  content: "\\F0588"; }

.mdi-wardrobe::before {
  content: "\\F0F90"; }

.mdi-wardrobe-outline::before {
  content: "\\F0F91"; }

.mdi-warehouse::before {
  content: "\\F0F81"; }

.mdi-washing-machine::before {
  content: "\\F072A"; }

.mdi-washing-machine-alert::before {
  content: "\\F11BC"; }

.mdi-washing-machine-off::before {
  content: "\\F11BD"; }

.mdi-watch::before {
  content: "\\F0589"; }

.mdi-watch-export::before {
  content: "\\F058A"; }

.mdi-watch-export-variant::before {
  content: "\\F0895"; }

.mdi-watch-import::before {
  content: "\\F058B"; }

.mdi-watch-import-variant::before {
  content: "\\F0896"; }

.mdi-watch-variant::before {
  content: "\\F0897"; }

.mdi-watch-vibrate::before {
  content: "\\F06B1"; }

.mdi-watch-vibrate-off::before {
  content: "\\F0CDA"; }

.mdi-water::before {
  content: "\\F058C"; }

.mdi-water-alert::before {
  content: "\\F1502"; }

.mdi-water-alert-outline::before {
  content: "\\F1503"; }

.mdi-water-boiler::before {
  content: "\\F0F92"; }

.mdi-water-boiler-alert::before {
  content: "\\F11B3"; }

.mdi-water-boiler-off::before {
  content: "\\F11B4"; }

.mdi-water-check::before {
  content: "\\F1504"; }

.mdi-water-check-outline::before {
  content: "\\F1505"; }

.mdi-water-circle::before {
  content: "\\F1806"; }

.mdi-water-minus::before {
  content: "\\F1506"; }

.mdi-water-minus-outline::before {
  content: "\\F1507"; }

.mdi-water-off::before {
  content: "\\F058D"; }

.mdi-water-off-outline::before {
  content: "\\F1508"; }

.mdi-water-opacity::before {
  content: "\\F1855"; }

.mdi-water-outline::before {
  content: "\\F0E0A"; }

.mdi-water-percent::before {
  content: "\\F058E"; }

.mdi-water-percent-alert::before {
  content: "\\F1509"; }

.mdi-water-plus::before {
  content: "\\F150A"; }

.mdi-water-plus-outline::before {
  content: "\\F150B"; }

.mdi-water-polo::before {
  content: "\\F12A0"; }

.mdi-water-pump::before {
  content: "\\F058F"; }

.mdi-water-pump-off::before {
  content: "\\F0F93"; }

.mdi-water-remove::before {
  content: "\\F150C"; }

.mdi-water-remove-outline::before {
  content: "\\F150D"; }

.mdi-water-sync::before {
  content: "\\F17C6"; }

.mdi-water-well::before {
  content: "\\F106B"; }

.mdi-water-well-outline::before {
  content: "\\F106C"; }

.mdi-waterfall::before {
  content: "\\F1849"; }

.mdi-watering-can::before {
  content: "\\F1481"; }

.mdi-watering-can-outline::before {
  content: "\\F1482"; }

.mdi-watermark::before {
  content: "\\F0612"; }

.mdi-wave::before {
  content: "\\F0F2E"; }

.mdi-waveform::before {
  content: "\\F147D"; }

.mdi-waves::before {
  content: "\\F078D"; }

.mdi-waves-arrow-left::before {
  content: "\\F1859"; }

.mdi-waves-arrow-right::before {
  content: "\\F185A"; }

.mdi-waves-arrow-up::before {
  content: "\\F185B"; }

.mdi-waze::before {
  content: "\\F0BDE"; }

.mdi-weather-cloudy::before {
  content: "\\F0590"; }

.mdi-weather-cloudy-alert::before {
  content: "\\F0F2F"; }

.mdi-weather-cloudy-arrow-right::before {
  content: "\\F0E6E"; }

.mdi-weather-cloudy-clock::before {
  content: "\\F18F6"; }

.mdi-weather-fog::before {
  content: "\\F0591"; }

.mdi-weather-hail::before {
  content: "\\F0592"; }

.mdi-weather-hazy::before {
  content: "\\F0F30"; }

.mdi-weather-hurricane::before {
  content: "\\F0898"; }

.mdi-weather-lightning::before {
  content: "\\F0593"; }

.mdi-weather-lightning-rainy::before {
  content: "\\F067E"; }

.mdi-weather-night::before {
  content: "\\F0594"; }

.mdi-weather-night-partly-cloudy::before {
  content: "\\F0F31"; }

.mdi-weather-partly-cloudy::before {
  content: "\\F0595"; }

.mdi-weather-partly-lightning::before {
  content: "\\F0F32"; }

.mdi-weather-partly-rainy::before {
  content: "\\F0F33"; }

.mdi-weather-partly-snowy::before {
  content: "\\F0F34"; }

.mdi-weather-partly-snowy-rainy::before {
  content: "\\F0F35"; }

.mdi-weather-pouring::before {
  content: "\\F0596"; }

.mdi-weather-rainy::before {
  content: "\\F0597"; }

.mdi-weather-snowy::before {
  content: "\\F0598"; }

.mdi-weather-snowy-heavy::before {
  content: "\\F0F36"; }

.mdi-weather-snowy-rainy::before {
  content: "\\F067F"; }

.mdi-weather-sunny::before {
  content: "\\F0599"; }

.mdi-weather-sunny-alert::before {
  content: "\\F0F37"; }

.mdi-weather-sunny-off::before {
  content: "\\F14E4"; }

.mdi-weather-sunset::before {
  content: "\\F059A"; }

.mdi-weather-sunset-down::before {
  content: "\\F059B"; }

.mdi-weather-sunset-up::before {
  content: "\\F059C"; }

.mdi-weather-tornado::before {
  content: "\\F0F38"; }

.mdi-weather-windy::before {
  content: "\\F059D"; }

.mdi-weather-windy-variant::before {
  content: "\\F059E"; }

.mdi-web::before {
  content: "\\F059F"; }

.mdi-web-box::before {
  content: "\\F0F94"; }

.mdi-web-cancel::before {
  content: "\\F1790"; }

.mdi-web-check::before {
  content: "\\F0789"; }

.mdi-web-clock::before {
  content: "\\F124A"; }

.mdi-web-minus::before {
  content: "\\F10A0"; }

.mdi-web-off::before {
  content: "\\F0A8E"; }

.mdi-web-plus::before {
  content: "\\F0033"; }

.mdi-web-refresh::before {
  content: "\\F1791"; }

.mdi-web-remove::before {
  content: "\\F0551"; }

.mdi-web-sync::before {
  content: "\\F1792"; }

.mdi-webcam::before {
  content: "\\F05A0"; }

.mdi-webcam-off::before {
  content: "\\F1737"; }

.mdi-webhook::before {
  content: "\\F062F"; }

.mdi-webpack::before {
  content: "\\F072B"; }

.mdi-webrtc::before {
  content: "\\F1248"; }

.mdi-wechat::before {
  content: "\\F0611"; }

.mdi-weight::before {
  content: "\\F05A1"; }

.mdi-weight-gram::before {
  content: "\\F0D3F"; }

.mdi-weight-kilogram::before {
  content: "\\F05A2"; }

.mdi-weight-lifter::before {
  content: "\\F115D"; }

.mdi-weight-pound::before {
  content: "\\F09B5"; }

.mdi-whatsapp::before {
  content: "\\F05A3"; }

.mdi-wheel-barrow::before {
  content: "\\F14F2"; }

.mdi-wheelchair-accessibility::before {
  content: "\\F05A4"; }

.mdi-whistle::before {
  content: "\\F09B6"; }

.mdi-whistle-outline::before {
  content: "\\F12BC"; }

.mdi-white-balance-auto::before {
  content: "\\F05A5"; }

.mdi-white-balance-incandescent::before {
  content: "\\F05A6"; }

.mdi-white-balance-iridescent::before {
  content: "\\F05A7"; }

.mdi-white-balance-sunny::before {
  content: "\\F05A8"; }

.mdi-widgets::before {
  content: "\\F072C"; }

.mdi-widgets-outline::before {
  content: "\\F1355"; }

.mdi-wifi::before {
  content: "\\F05A9"; }

.mdi-wifi-alert::before {
  content: "\\F16B5"; }

.mdi-wifi-arrow-down::before {
  content: "\\F16B6"; }

.mdi-wifi-arrow-left::before {
  content: "\\F16B7"; }

.mdi-wifi-arrow-left-right::before {
  content: "\\F16B8"; }

.mdi-wifi-arrow-right::before {
  content: "\\F16B9"; }

.mdi-wifi-arrow-up::before {
  content: "\\F16BA"; }

.mdi-wifi-arrow-up-down::before {
  content: "\\F16BB"; }

.mdi-wifi-cancel::before {
  content: "\\F16BC"; }

.mdi-wifi-check::before {
  content: "\\F16BD"; }

.mdi-wifi-cog::before {
  content: "\\F16BE"; }

.mdi-wifi-lock::before {
  content: "\\F16BF"; }

.mdi-wifi-lock-open::before {
  content: "\\F16C0"; }

.mdi-wifi-marker::before {
  content: "\\F16C1"; }

.mdi-wifi-minus::before {
  content: "\\F16C2"; }

.mdi-wifi-off::before {
  content: "\\F05AA"; }

.mdi-wifi-plus::before {
  content: "\\F16C3"; }

.mdi-wifi-refresh::before {
  content: "\\F16C4"; }

.mdi-wifi-remove::before {
  content: "\\F16C5"; }

.mdi-wifi-settings::before {
  content: "\\F16C6"; }

.mdi-wifi-star::before {
  content: "\\F0E0B"; }

.mdi-wifi-strength-1::before {
  content: "\\F091F"; }

.mdi-wifi-strength-1-alert::before {
  content: "\\F0920"; }

.mdi-wifi-strength-1-lock::before {
  content: "\\F0921"; }

.mdi-wifi-strength-1-lock-open::before {
  content: "\\F16CB"; }

.mdi-wifi-strength-2::before {
  content: "\\F0922"; }

.mdi-wifi-strength-2-alert::before {
  content: "\\F0923"; }

.mdi-wifi-strength-2-lock::before {
  content: "\\F0924"; }

.mdi-wifi-strength-2-lock-open::before {
  content: "\\F16CC"; }

.mdi-wifi-strength-3::before {
  content: "\\F0925"; }

.mdi-wifi-strength-3-alert::before {
  content: "\\F0926"; }

.mdi-wifi-strength-3-lock::before {
  content: "\\F0927"; }

.mdi-wifi-strength-3-lock-open::before {
  content: "\\F16CD"; }

.mdi-wifi-strength-4::before {
  content: "\\F0928"; }

.mdi-wifi-strength-4-alert::before {
  content: "\\F0929"; }

.mdi-wifi-strength-4-lock::before {
  content: "\\F092A"; }

.mdi-wifi-strength-4-lock-open::before {
  content: "\\F16CE"; }

.mdi-wifi-strength-alert-outline::before {
  content: "\\F092B"; }

.mdi-wifi-strength-lock-open-outline::before {
  content: "\\F16CF"; }

.mdi-wifi-strength-lock-outline::before {
  content: "\\F092C"; }

.mdi-wifi-strength-off::before {
  content: "\\F092D"; }

.mdi-wifi-strength-off-outline::before {
  content: "\\F092E"; }

.mdi-wifi-strength-outline::before {
  content: "\\F092F"; }

.mdi-wifi-sync::before {
  content: "\\F16C7"; }

.mdi-wikipedia::before {
  content: "\\F05AC"; }

.mdi-wind-turbine::before {
  content: "\\F0DA5"; }

.mdi-wind-turbine-alert::before {
  content: "\\F19AB"; }

.mdi-wind-turbine-check::before {
  content: "\\F19AC"; }

.mdi-window-close::before {
  content: "\\F05AD"; }

.mdi-window-closed::before {
  content: "\\F05AE"; }

.mdi-window-closed-variant::before {
  content: "\\F11DB"; }

.mdi-window-maximize::before {
  content: "\\F05AF"; }

.mdi-window-minimize::before {
  content: "\\F05B0"; }

.mdi-window-open::before {
  content: "\\F05B1"; }

.mdi-window-open-variant::before {
  content: "\\F11DC"; }

.mdi-window-restore::before {
  content: "\\F05B2"; }

.mdi-window-shutter::before {
  content: "\\F111C"; }

.mdi-window-shutter-alert::before {
  content: "\\F111D"; }

.mdi-window-shutter-open::before {
  content: "\\F111E"; }

.mdi-windsock::before {
  content: "\\F15FA"; }

.mdi-wiper::before {
  content: "\\F0AE9"; }

.mdi-wiper-wash::before {
  content: "\\F0DA6"; }

.mdi-wiper-wash-alert::before {
  content: "\\F18DF"; }

.mdi-wizard-hat::before {
  content: "\\F1477"; }

.mdi-wordpress::before {
  content: "\\F05B4"; }

.mdi-wrap::before {
  content: "\\F05B6"; }

.mdi-wrap-disabled::before {
  content: "\\F0BDF"; }

.mdi-wrench::before {
  content: "\\F05B7"; }

.mdi-wrench-clock::before {
  content: "\\F19A3"; }

.mdi-wrench-outline::before {
  content: "\\F0BE0"; }

.mdi-xamarin::before {
  content: "\\F0845"; }

.mdi-xml::before {
  content: "\\F05C0"; }

.mdi-xmpp::before {
  content: "\\F07FF"; }

.mdi-yahoo::before {
  content: "\\F0B4F"; }

.mdi-yeast::before {
  content: "\\F05C1"; }

.mdi-yin-yang::before {
  content: "\\F0680"; }

.mdi-yoga::before {
  content: "\\F117C"; }

.mdi-youtube::before {
  content: "\\F05C3"; }

.mdi-youtube-gaming::before {
  content: "\\F0848"; }

.mdi-youtube-studio::before {
  content: "\\F0847"; }

.mdi-youtube-subscription::before {
  content: "\\F0D40"; }

.mdi-youtube-tv::before {
  content: "\\F0448"; }

.mdi-yurt::before {
  content: "\\F1516"; }

.mdi-z-wave::before {
  content: "\\F0AEA"; }

.mdi-zend::before {
  content: "\\F0AEB"; }

.mdi-zigbee::before {
  content: "\\F0D41"; }

.mdi-zip-box::before {
  content: "\\F05C4"; }

.mdi-zip-box-outline::before {
  content: "\\F0FFA"; }

.mdi-zip-disk::before {
  content: "\\F0A23"; }

.mdi-zodiac-aquarius::before {
  content: "\\F0A7D"; }

.mdi-zodiac-aries::before {
  content: "\\F0A7E"; }

.mdi-zodiac-cancer::before {
  content: "\\F0A7F"; }

.mdi-zodiac-capricorn::before {
  content: "\\F0A80"; }

.mdi-zodiac-gemini::before {
  content: "\\F0A81"; }

.mdi-zodiac-leo::before {
  content: "\\F0A82"; }

.mdi-zodiac-libra::before {
  content: "\\F0A83"; }

.mdi-zodiac-pisces::before {
  content: "\\F0A84"; }

.mdi-zodiac-sagittarius::before {
  content: "\\F0A85"; }

.mdi-zodiac-scorpio::before {
  content: "\\F0A86"; }

.mdi-zodiac-taurus::before {
  content: "\\F0A87"; }

.mdi-zodiac-virgo::before {
  content: "\\F0A88"; }

.mdi-blank::before {
  content: "\\F68C";
  visibility: hidden; }

.mdi-18px.mdi-set, .mdi-18px.mdi:before {
  font-size: 18px; }

.mdi-24px.mdi-set, .mdi-24px.mdi:before {
  font-size: 24px; }

.mdi-36px.mdi-set, .mdi-36px.mdi:before {
  font-size: 36px; }

.mdi-48px.mdi-set, .mdi-48px.mdi:before {
  font-size: 48px; }

.mdi-dark:before {
  color: rgba(0, 0, 0, 0.54); }

.mdi-dark.mdi-inactive:before {
  color: rgba(0, 0, 0, 0.26); }

.mdi-light:before {
  color: white; }

.mdi-light.mdi-inactive:before {
  color: rgba(255, 255, 255, 0.3); }

.mdi-rotate-45 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(45deg);
            transform: scaleX(-1) rotate(45deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: scaleY(-1) rotate(45deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-45:before {
  transform: rotate(45deg); }

.mdi-rotate-90 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(90deg);
            transform: scaleX(-1) rotate(90deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(90deg);
            -ms-transform: rotate(90deg);
            transform: scaleY(-1) rotate(90deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-90:before {
  transform: rotate(90deg); }

.mdi-rotate-135 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(135deg);
            transform: scaleX(-1) rotate(135deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(135deg);
            -ms-transform: rotate(135deg);
            transform: scaleY(-1) rotate(135deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-135:before {
  transform: rotate(135deg); }

.mdi-rotate-180 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(180deg);
            transform: scaleX(-1) rotate(180deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(180deg);
            -ms-transform: rotate(180deg);
            transform: scaleY(-1) rotate(180deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-180:before {
  transform: rotate(180deg); }

.mdi-rotate-225 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(225deg);
            transform: scaleX(-1) rotate(225deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(225deg);
            -ms-transform: rotate(225deg);
            transform: scaleY(-1) rotate(225deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-225:before {
  transform: rotate(225deg); }

.mdi-rotate-270 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(270deg);
            transform: scaleX(-1) rotate(270deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(270deg);
            -ms-transform: rotate(270deg);
            transform: scaleY(-1) rotate(270deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-270:before {
  transform: rotate(270deg); }

.mdi-rotate-315 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(315deg);
            transform: scaleX(-1) rotate(315deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(315deg);
            -ms-transform: rotate(315deg);
            transform: scaleY(-1) rotate(315deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-315:before {
  transform: rotate(315deg); }

.mdi-flip-h:before {
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH"; }

.mdi-flip-v:before {
  transform: scaleY(-1);
  filter: FlipV;
  -ms-filter: "FlipV"; }

.mdi-spin:before {
  animation: mdi-spin 2s infinite linear; }

@keyframes mdi-spin {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(359deg); } }

/*# sourceMappingURL=materialdesignicons.css.map */
@font-face {
  font-family: 'boxicons';
  font-weight: normal;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("svg"); }

.bx {
  font-family: 'boxicons' !important;
  font-weight: normal;
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
  display: inline-block;
  text-transform: none;
  speak: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; }

.bx-ul {
  margin-left: 2em;
  padding-left: 0;
  list-style: none; }

.bx-ul > li {
  position: relative; }

.bx-ul .bx {
  font-size: inherit;
  line-height: inherit;
  position: absolute;
  left: -2em;
  width: 2em;
  text-align: center; }

@keyframes spin {
  0% {
    transform: rotate(0); }
  100% {
    transform: rotate(359deg); } }

@keyframes burst {
  0% {
    transform: scale(1);
    opacity: 1; }
  90% {
    transform: scale(1.5);
    opacity: 0; } }

@keyframes flashing {
  0% {
    opacity: 1; }
  45% {
    opacity: 0; }
  90% {
    opacity: 1; } }

@keyframes fade-left {
  0% {
    transform: translateX(0);
    opacity: 1; }
  75% {
    transform: translateX(-20px);
    opacity: 0; } }

@keyframes fade-right {
  0% {
    transform: translateX(0);
    opacity: 1; }
  75% {
    transform: translateX(20px);
    opacity: 0; } }

@keyframes fade-up {
  0% {
    transform: translateY(0);
    opacity: 1; }
  75% {
    transform: translateY(-20px);
    opacity: 0; } }

@keyframes fade-down {
  0% {
    transform: translateY(0);
    opacity: 1; }
  75% {
    transform: translateY(20px);
    opacity: 0; } }

@keyframes tada {
  from {
    transform: scale3d(1, 1, 1); }
  10%,
  20% {
    transform: scale3d(0.95, 0.95, 0.95) rotate3d(0, 0, 1, -10deg); }
  30%,
  50%,
  70%,
  90% {
    transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg); }
  40%,
  60%,
  80% {
    transform: rotate3d(0, 0, 1, -10deg); }
  to {
    transform: scale3d(1, 1, 1); } }

.bx-spin {
  animation: spin 2s linear infinite; }

.bx-spin-hover:hover {
  animation: spin 2s linear infinite; }

.bx-tada {
  animation: tada 1.5s ease infinite; }

.bx-tada-hover:hover {
  animation: tada 1.5s ease infinite; }

.bx-flashing {
  animation: flashing 1.5s infinite linear; }

.bx-flashing-hover:hover {
  animation: flashing 1.5s infinite linear; }

.bx-burst {
  animation: burst 1.5s infinite linear; }

.bx-burst-hover:hover {
  animation: burst 1.5s infinite linear; }

.bx-fade-up {
  animation: fade-up 1.5s infinite linear; }

.bx-fade-up-hover:hover {
  animation: fade-up 1.5s infinite linear; }

.bx-fade-down {
  animation: fade-down 1.5s infinite linear; }

.bx-fade-down-hover:hover {
  animation: fade-down 1.5s infinite linear; }

.bx-fade-left {
  animation: fade-left 1.5s infinite linear; }

.bx-fade-left-hover:hover {
  animation: fade-left 1.5s infinite linear; }

.bx-fade-right {
  animation: fade-right 1.5s infinite linear; }

.bx-fade-right-hover:hover {
  animation: fade-right 1.5s infinite linear; }

.bx-xs {
  font-size: 1rem !important; }

.bx-sm {
  font-size: 1.55rem !important; }

.bx-md {
  font-size: 2.25rem !important; }

.bx-lg {
  font-size: 3rem !important; }

.bx-fw {
  font-size: 1.2857142857em;
  line-height: .8em;
  width: 1.2857142857em;
  height: .8em;
  margin-top: -0.2em !important;
  vertical-align: middle; }

.bx-pull-left {
  float: left;
  margin-right: 0.3em !important; }

.bx-pull-right {
  float: right;
  margin-left: 0.3em !important; }

.bx-rotate-90 {
  transform: rotate(90deg);
  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=1)'; }

.bx-rotate-180 {
  transform: rotate(180deg);
  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2)'; }

.bx-rotate-270 {
  transform: rotate(270deg);
  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=3)'; }

.bx-flip-horizontal {
  transform: scaleX(-1);
  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)'; }

.bx-flip-vertical {
  transform: scaleY(-1);
  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)'; }

.bx-border {
  padding: .25em;
  border: 0.07em solid rgba(0, 0, 0, 0.1);
  border-radius: .25em; }

.bx-border-circle {
  padding: .25em;
  border: 0.07em solid rgba(0, 0, 0, 0.1);
  border-radius: 50%; }

.bxl-meta:before {
  content: "\\ef27"; }

.bx-lemon:before {
  content: "\\ef28"; }

.bxs-lemon:before {
  content: "\\ef29"; }

.bx-cricket-ball:before {
  content: "\\ef0c"; }

.bx-baguette:before {
  content: "\\ef0d"; }

.bx-bowl-hot:before {
  content: "\\ef0e"; }

.bx-bowl-rice:before {
  content: "\\ef0f"; }

.bx-cable-car:before {
  content: "\\ef10"; }

.bx-candles:before {
  content: "\\ef11"; }

.bx-circle-half:before {
  content: "\\ef12"; }

.bx-circle-quarter:before {
  content: "\\ef13"; }

.bx-circle-three-quarter:before {
  content: "\\ef14"; }

.bx-cross:before {
  content: "\\ef15"; }

.bx-fork:before {
  content: "\\ef16"; }

.bx-knife:before {
  content: "\\ef17"; }

.bx-money-withdraw:before {
  content: "\\ef18"; }

.bx-popsicle:before {
  content: "\\ef19"; }

.bx-scatter-chart:before {
  content: "\\ef1a"; }

.bxs-baguette:before {
  content: "\\ef1b"; }

.bxs-bowl-hot:before {
  content: "\\ef1c"; }

.bxs-bowl-rice:before {
  content: "\\ef1d"; }

.bxs-cable-car:before {
  content: "\\ef1e"; }

.bxs-circle-half:before {
  content: "\\ef1f"; }

.bxs-circle-quarter:before {
  content: "\\ef20"; }

.bxs-circle-three-quarter:before {
  content: "\\ef21"; }

.bxs-cricket-ball:before {
  content: "\\ef22"; }

.bxs-invader:before {
  content: "\\ef23"; }

.bx-male-female:before {
  content: "\\ef24"; }

.bxs-popsicle:before {
  content: "\\ef25"; }

.bxs-tree-alt:before {
  content: "\\ef26"; }

.bxl-venmo:before {
  content: "\\e900"; }

.bxl-upwork:before {
  content: "\\e901"; }

.bxl-netlify:before {
  content: "\\e902"; }

.bxl-java:before {
  content: "\\e903"; }

.bxl-heroku:before {
  content: "\\e904"; }

.bxl-go-lang:before {
  content: "\\e905"; }

.bxl-gmail:before {
  content: "\\e906"; }

.bxl-flask:before {
  content: "\\e907"; }

.bxl-99designs:before {
  content: "\\e908"; }

.bxl-500px:before {
  content: "\\e909"; }

.bxl-adobe:before {
  content: "\\e90a"; }

.bxl-airbnb:before {
  content: "\\e90b"; }

.bxl-algolia:before {
  content: "\\e90c"; }

.bxl-amazon:before {
  content: "\\e90d"; }

.bxl-android:before {
  content: "\\e90e"; }

.bxl-angular:before {
  content: "\\e90f"; }

.bxl-apple:before {
  content: "\\e910"; }

.bxl-audible:before {
  content: "\\e911"; }

.bxl-aws:before {
  content: "\\e912"; }

.bxl-baidu:before {
  content: "\\e913"; }

.bxl-behance:before {
  content: "\\e914"; }

.bxl-bing:before {
  content: "\\e915"; }

.bxl-bitcoin:before {
  content: "\\e916"; }

.bxl-blender:before {
  content: "\\e917"; }

.bxl-blogger:before {
  content: "\\e918"; }

.bxl-bootstrap:before {
  content: "\\e919"; }

.bxl-chrome:before {
  content: "\\e91a"; }

.bxl-codepen:before {
  content: "\\e91b"; }

.bxl-c-plus-plus:before {
  content: "\\e91c"; }

.bxl-creative-commons:before {
  content: "\\e91d"; }

.bxl-css3:before {
  content: "\\e91e"; }

.bxl-dailymotion:before {
  content: "\\e91f"; }

.bxl-deviantart:before {
  content: "\\e920"; }

.bxl-dev-to:before {
  content: "\\e921"; }

.bxl-digg:before {
  content: "\\e922"; }

.bxl-digitalocean:before {
  content: "\\e923"; }

.bxl-discord:before {
  content: "\\e924"; }

.bxl-discord-alt:before {
  content: "\\e925"; }

.bxl-discourse:before {
  content: "\\e926"; }

.bxl-django:before {
  content: "\\e927"; }

.bxl-docker:before {
  content: "\\e928"; }

.bxl-dribbble:before {
  content: "\\e929"; }

.bxl-dropbox:before {
  content: "\\e92a"; }

.bxl-drupal:before {
  content: "\\e92b"; }

.bxl-ebay:before {
  content: "\\e92c"; }

.bxl-edge:before {
  content: "\\e92d"; }

.bxl-etsy:before {
  content: "\\e92e"; }

.bxl-facebook:before {
  content: "\\e92f"; }

.bxl-facebook-circle:before {
  content: "\\e930"; }

.bxl-facebook-square:before {
  content: "\\e931"; }

.bxl-figma:before {
  content: "\\e932"; }

.bxl-firebase:before {
  content: "\\e933"; }

.bxl-firefox:before {
  content: "\\e934"; }

.bxl-flickr:before {
  content: "\\e935"; }

.bxl-flickr-square:before {
  content: "\\e936"; }

.bxl-flutter:before {
  content: "\\e937"; }

.bxl-foursquare:before {
  content: "\\e938"; }

.bxl-git:before {
  content: "\\e939"; }

.bxl-github:before {
  content: "\\e93a"; }

.bxl-gitlab:before {
  content: "\\e93b"; }

.bxl-google:before {
  content: "\\e93c"; }

.bxl-google-cloud:before {
  content: "\\e93d"; }

.bxl-google-plus:before {
  content: "\\e93e"; }

.bxl-google-plus-circle:before {
  content: "\\e93f"; }

.bxl-html5:before {
  content: "\\e940"; }

.bxl-imdb:before {
  content: "\\e941"; }

.bxl-instagram:before {
  content: "\\e942"; }

.bxl-instagram-alt:before {
  content: "\\e943"; }

.bxl-internet-explorer:before {
  content: "\\e944"; }

.bxl-invision:before {
  content: "\\e945"; }

.bxl-javascript:before {
  content: "\\e946"; }

.bxl-joomla:before {
  content: "\\e947"; }

.bxl-jquery:before {
  content: "\\e948"; }

.bxl-jsfiddle:before {
  content: "\\e949"; }

.bxl-kickstarter:before {
  content: "\\e94a"; }

.bxl-kubernetes:before {
  content: "\\e94b"; }

.bxl-less:before {
  content: "\\e94c"; }

.bxl-linkedin:before {
  content: "\\e94d"; }

.bxl-linkedin-square:before {
  content: "\\e94e"; }

.bxl-magento:before {
  content: "\\e94f"; }

.bxl-mailchimp:before {
  content: "\\e950"; }

.bxl-markdown:before {
  content: "\\e951"; }

.bxl-mastercard:before {
  content: "\\e952"; }

.bxl-mastodon:before {
  content: "\\e953"; }

.bxl-medium:before {
  content: "\\e954"; }

.bxl-medium-old:before {
  content: "\\e955"; }

.bxl-medium-square:before {
  content: "\\e956"; }

.bxl-messenger:before {
  content: "\\e957"; }

.bxl-microsoft:before {
  content: "\\e958"; }

.bxl-microsoft-teams:before {
  content: "\\e959"; }

.bxl-nodejs:before {
  content: "\\e95a"; }

.bxl-ok-ru:before {
  content: "\\e95b"; }

.bxl-opera:before {
  content: "\\e95c"; }

.bxl-patreon:before {
  content: "\\e95d"; }

.bxl-paypal:before {
  content: "\\e95e"; }

.bxl-periscope:before {
  content: "\\e95f"; }

.bxl-php:before {
  content: "\\e960"; }

.bxl-pinterest:before {
  content: "\\e961"; }

.bxl-pinterest-alt:before {
  content: "\\e962"; }

.bxl-play-store:before {
  content: "\\e963"; }

.bxl-pocket:before {
  content: "\\e964"; }

.bxl-product-hunt:before {
  content: "\\e965"; }

.bxl-python:before {
  content: "\\e966"; }

.bxl-quora:before {
  content: "\\e967"; }

.bxl-react:before {
  content: "\\e968"; }

.bxl-redbubble:before {
  content: "\\e969"; }

.bxl-reddit:before {
  content: "\\e96a"; }

.bxl-redux:before {
  content: "\\e96b"; }

.bxl-sass:before {
  content: "\\e96c"; }

.bxl-shopify:before {
  content: "\\e96d"; }

.bxl-sketch:before {
  content: "\\e96e"; }

.bxl-skype:before {
  content: "\\e96f"; }

.bxl-slack:before {
  content: "\\e970"; }

.bxl-slack-old:before {
  content: "\\e971"; }

.bxl-snapchat:before {
  content: "\\e972"; }

.bxl-soundcloud:before {
  content: "\\e973"; }

.bxl-spotify:before {
  content: "\\e974"; }

.bxl-spring-boot:before {
  content: "\\e975"; }

.bxl-squarespace:before {
  content: "\\e976"; }

.bxl-stack-overflow:before {
  content: "\\e977"; }

.bxl-steam:before {
  content: "\\e978"; }

.bxl-stripe:before {
  content: "\\e979"; }

.bxl-tailwind-css:before {
  content: "\\e97a"; }

.bxl-telegram:before {
  content: "\\e97b"; }

.bxl-tiktok:before {
  content: "\\e97c"; }

.bxl-trello:before {
  content: "\\e97d"; }

.bxl-trip-advisor:before {
  content: "\\e97e"; }

.bxl-tumblr:before {
  content: "\\e97f"; }

.bxl-tux:before {
  content: "\\e980"; }

.bxl-twitch:before {
  content: "\\e981"; }

.bxl-twitter:before {
  content: "\\e982"; }

.bxl-unity:before {
  content: "\\e983"; }

.bxl-unsplash:before {
  content: "\\e984"; }

.bxl-vimeo:before {
  content: "\\e985"; }

.bxl-visa:before {
  content: "\\e986"; }

.bxl-visual-studio:before {
  content: "\\e987"; }

.bxl-vk:before {
  content: "\\e988"; }

.bxl-vuejs:before {
  content: "\\e989"; }

.bxl-whatsapp:before {
  content: "\\e98a"; }

.bxl-whatsapp-square:before {
  content: "\\e98b"; }

.bxl-wikipedia:before {
  content: "\\e98c"; }

.bxl-windows:before {
  content: "\\e98d"; }

.bxl-wix:before {
  content: "\\e98e"; }

.bxl-wordpress:before {
  content: "\\e98f"; }

.bxl-yahoo:before {
  content: "\\e990"; }

.bxl-yelp:before {
  content: "\\e991"; }

.bxl-youtube:before {
  content: "\\e992"; }

.bxl-zoom:before {
  content: "\\e993"; }

.bx-collapse-alt:before {
  content: "\\e994"; }

.bx-collapse-horizontal:before {
  content: "\\e995"; }

.bx-collapse-vertical:before {
  content: "\\e996"; }

.bx-expand-horizontal:before {
  content: "\\e997"; }

.bx-expand-vertical:before {
  content: "\\e998"; }

.bx-injection:before {
  content: "\\e999"; }

.bx-leaf:before {
  content: "\\e99a"; }

.bx-math:before {
  content: "\\e99b"; }

.bx-party:before {
  content: "\\e99c"; }

.bx-abacus:before {
  content: "\\e99d"; }

.bx-accessibility:before {
  content: "\\e99e"; }

.bx-add-to-queue:before {
  content: "\\e99f"; }

.bx-adjust:before {
  content: "\\e9a0"; }

.bx-alarm:before {
  content: "\\e9a1"; }

.bx-alarm-add:before {
  content: "\\e9a2"; }

.bx-alarm-exclamation:before {
  content: "\\e9a3"; }

.bx-alarm-off:before {
  content: "\\e9a4"; }

.bx-alarm-snooze:before {
  content: "\\e9a5"; }

.bx-album:before {
  content: "\\e9a6"; }

.bx-align-justify:before {
  content: "\\e9a7"; }

.bx-align-left:before {
  content: "\\e9a8"; }

.bx-align-middle:before {
  content: "\\e9a9"; }

.bx-align-right:before {
  content: "\\e9aa"; }

.bx-analyse:before {
  content: "\\e9ab"; }

.bx-anchor:before {
  content: "\\e9ac"; }

.bx-angry:before {
  content: "\\e9ad"; }

.bx-aperture:before {
  content: "\\e9ae"; }

.bx-arch:before {
  content: "\\e9af"; }

.bx-archive:before {
  content: "\\e9b0"; }

.bx-archive-in:before {
  content: "\\e9b1"; }

.bx-archive-out:before {
  content: "\\e9b2"; }

.bx-area:before {
  content: "\\e9b3"; }

.bx-arrow-back:before {
  content: "\\e9b4"; }

.bx-arrow-from-bottom:before {
  content: "\\e9b5"; }

.bx-arrow-from-left:before {
  content: "\\e9b6"; }

.bx-arrow-from-right:before {
  content: "\\e9b7"; }

.bx-arrow-from-top:before {
  content: "\\e9b8"; }

.bx-arrow-to-bottom:before {
  content: "\\e9b9"; }

.bx-arrow-to-left:before {
  content: "\\e9ba"; }

.bx-arrow-to-right:before {
  content: "\\e9bb"; }

.bx-arrow-to-top:before {
  content: "\\e9bc"; }

.bx-at:before {
  content: "\\e9bd"; }

.bx-atom:before {
  content: "\\e9be"; }

.bx-award:before {
  content: "\\e9bf"; }

.bx-badge:before {
  content: "\\e9c0"; }

.bx-badge-check:before {
  content: "\\e9c1"; }

.bx-ball:before {
  content: "\\e9c2"; }

.bx-band-aid:before {
  content: "\\e9c3"; }

.bx-bar-chart:before {
  content: "\\e9c4"; }

.bx-bar-chart-alt:before {
  content: "\\e9c5"; }

.bx-bar-chart-alt-2:before {
  content: "\\e9c6"; }

.bx-bar-chart-square:before {
  content: "\\e9c7"; }

.bx-barcode:before {
  content: "\\e9c8"; }

.bx-barcode-reader:before {
  content: "\\e9c9"; }

.bx-baseball:before {
  content: "\\e9ca"; }

.bx-basket:before {
  content: "\\e9cb"; }

.bx-basketball:before {
  content: "\\e9cc"; }

.bx-bath:before {
  content: "\\e9cd"; }

.bx-battery:before {
  content: "\\e9ce"; }

.bx-bed:before {
  content: "\\e9cf"; }

.bx-been-here:before {
  content: "\\e9d0"; }

.bx-beer:before {
  content: "\\e9d1"; }

.bx-bell:before {
  content: "\\e9d2"; }

.bx-bell-minus:before {
  content: "\\e9d3"; }

.bx-bell-off:before {
  content: "\\e9d4"; }

.bx-bell-plus:before {
  content: "\\e9d5"; }

.bx-bible:before {
  content: "\\e9d6"; }

.bx-bitcoin:before {
  content: "\\e9d7"; }

.bx-blanket:before {
  content: "\\e9d8"; }

.bx-block:before {
  content: "\\e9d9"; }

.bx-bluetooth:before {
  content: "\\e9da"; }

.bx-body:before {
  content: "\\e9db"; }

.bx-bold:before {
  content: "\\e9dc"; }

.bx-bolt-circle:before {
  content: "\\e9dd"; }

.bx-bomb:before {
  content: "\\e9de"; }

.bx-bone:before {
  content: "\\e9df"; }

.bx-bong:before {
  content: "\\e9e0"; }

.bx-book:before {
  content: "\\e9e1"; }

.bx-book-add:before {
  content: "\\e9e2"; }

.bx-book-alt:before {
  content: "\\e9e3"; }

.bx-book-bookmark:before {
  content: "\\e9e4"; }

.bx-book-content:before {
  content: "\\e9e5"; }

.bx-book-heart:before {
  content: "\\e9e6"; }

.bx-bookmark:before {
  content: "\\e9e7"; }

.bx-bookmark-alt:before {
  content: "\\e9e8"; }

.bx-bookmark-alt-minus:before {
  content: "\\e9e9"; }

.bx-bookmark-alt-plus:before {
  content: "\\e9ea"; }

.bx-bookmark-heart:before {
  content: "\\e9eb"; }

.bx-bookmark-minus:before {
  content: "\\e9ec"; }

.bx-bookmark-plus:before {
  content: "\\e9ed"; }

.bx-bookmarks:before {
  content: "\\e9ee"; }

.bx-book-open:before {
  content: "\\e9ef"; }

.bx-book-reader:before {
  content: "\\e9f0"; }

.bx-border-all:before {
  content: "\\e9f1"; }

.bx-border-bottom:before {
  content: "\\e9f2"; }

.bx-border-inner:before {
  content: "\\e9f3"; }

.bx-border-left:before {
  content: "\\e9f4"; }

.bx-border-none:before {
  content: "\\e9f5"; }

.bx-border-outer:before {
  content: "\\e9f6"; }

.bx-border-radius:before {
  content: "\\e9f7"; }

.bx-border-right:before {
  content: "\\e9f8"; }

.bx-border-top:before {
  content: "\\e9f9"; }

.bx-bot:before {
  content: "\\e9fa"; }

.bx-bowling-ball:before {
  content: "\\e9fb"; }

.bx-box:before {
  content: "\\e9fc"; }

.bx-bracket:before {
  content: "\\e9fd"; }

.bx-braille:before {
  content: "\\e9fe"; }

.bx-brain:before {
  content: "\\e9ff"; }

.bx-briefcase:before {
  content: "\\ea00"; }

.bx-briefcase-alt:before {
  content: "\\ea01"; }

.bx-briefcase-alt-2:before {
  content: "\\ea02"; }

.bx-brightness:before {
  content: "\\ea03"; }

.bx-brightness-half:before {
  content: "\\ea04"; }

.bx-broadcast:before {
  content: "\\ea05"; }

.bx-brush:before {
  content: "\\ea06"; }

.bx-brush-alt:before {
  content: "\\ea07"; }

.bx-bug:before {
  content: "\\ea08"; }

.bx-bug-alt:before {
  content: "\\ea09"; }

.bx-building:before {
  content: "\\ea0a"; }

.bx-building-house:before {
  content: "\\ea0b"; }

.bx-buildings:before {
  content: "\\ea0c"; }

.bx-bulb:before {
  content: "\\ea0d"; }

.bx-bullseye:before {
  content: "\\ea0e"; }

.bx-buoy:before {
  content: "\\ea0f"; }

.bx-bus:before {
  content: "\\ea10"; }

.bx-bus-school:before {
  content: "\\ea11"; }

.bx-cabinet:before {
  content: "\\ea12"; }

.bx-cake:before {
  content: "\\ea13"; }

.bx-calculator:before {
  content: "\\ea14"; }

.bx-calendar:before {
  content: "\\ea15"; }

.bx-calendar-alt:before {
  content: "\\ea16"; }

.bx-calendar-check:before {
  content: "\\ea17"; }

.bx-calendar-edit:before {
  content: "\\ea18"; }

.bx-calendar-event:before {
  content: "\\ea19"; }

.bx-calendar-exclamation:before {
  content: "\\ea1a"; }

.bx-calendar-heart:before {
  content: "\\ea1b"; }

.bx-calendar-minus:before {
  content: "\\ea1c"; }

.bx-calendar-plus:before {
  content: "\\ea1d"; }

.bx-calendar-star:before {
  content: "\\ea1e"; }

.bx-calendar-week:before {
  content: "\\ea1f"; }

.bx-calendar-x:before {
  content: "\\ea20"; }

.bx-camera:before {
  content: "\\ea21"; }

.bx-camera-home:before {
  content: "\\ea22"; }

.bx-camera-movie:before {
  content: "\\ea23"; }

.bx-camera-off:before {
  content: "\\ea24"; }

.bx-capsule:before {
  content: "\\ea25"; }

.bx-captions:before {
  content: "\\ea26"; }

.bx-car:before {
  content: "\\ea27"; }

.bx-card:before {
  content: "\\ea28"; }

.bx-caret-down:before {
  content: "\\ea29"; }

.bx-caret-down-circle:before {
  content: "\\ea2a"; }

.bx-caret-down-square:before {
  content: "\\ea2b"; }

.bx-caret-left:before {
  content: "\\ea2c"; }

.bx-caret-left-circle:before {
  content: "\\ea2d"; }

.bx-caret-left-square:before {
  content: "\\ea2e"; }

.bx-caret-right:before {
  content: "\\ea2f"; }

.bx-caret-right-circle:before {
  content: "\\ea30"; }

.bx-caret-right-square:before {
  content: "\\ea31"; }

.bx-caret-up:before {
  content: "\\ea32"; }

.bx-caret-up-circle:before {
  content: "\\ea33"; }

.bx-caret-up-square:before {
  content: "\\ea34"; }

.bx-carousel:before {
  content: "\\ea35"; }

.bx-cart:before {
  content: "\\ea36"; }

.bx-cart-alt:before {
  content: "\\ea37"; }

.bx-cast:before {
  content: "\\ea38"; }

.bx-category:before {
  content: "\\ea39"; }

.bx-category-alt:before {
  content: "\\ea3a"; }

.bx-cctv:before {
  content: "\\ea3b"; }

.bx-certification:before {
  content: "\\ea3c"; }

.bx-chair:before {
  content: "\\ea3d"; }

.bx-chalkboard:before {
  content: "\\ea3e"; }

.bx-chart:before {
  content: "\\ea3f"; }

.bx-chat:before {
  content: "\\ea40"; }

.bx-check:before {
  content: "\\ea41"; }

.bx-checkbox:before {
  content: "\\ea42"; }

.bx-checkbox-checked:before {
  content: "\\ea43"; }

.bx-checkbox-minus:before {
  content: "\\ea44"; }

.bx-checkbox-square:before {
  content: "\\ea45"; }

.bx-check-circle:before {
  content: "\\ea46"; }

.bx-check-double:before {
  content: "\\ea47"; }

.bx-check-shield:before {
  content: "\\ea48"; }

.bx-check-square:before {
  content: "\\ea49"; }

.bx-chevron-down:before {
  content: "\\ea4a"; }

.bx-chevron-down-circle:before {
  content: "\\ea4b"; }

.bx-chevron-down-square:before {
  content: "\\ea4c"; }

.bx-chevron-left:before {
  content: "\\ea4d"; }

.bx-chevron-left-circle:before {
  content: "\\ea4e"; }

.bx-chevron-left-square:before {
  content: "\\ea4f"; }

.bx-chevron-right:before {
  content: "\\ea50"; }

.bx-chevron-right-circle:before {
  content: "\\ea51"; }

.bx-chevron-right-square:before {
  content: "\\ea52"; }

.bx-chevrons-down:before {
  content: "\\ea53"; }

.bx-chevrons-left:before {
  content: "\\ea54"; }

.bx-chevrons-right:before {
  content: "\\ea55"; }

.bx-chevrons-up:before {
  content: "\\ea56"; }

.bx-chevron-up:before {
  content: "\\ea57"; }

.bx-chevron-up-circle:before {
  content: "\\ea58"; }

.bx-chevron-up-square:before {
  content: "\\ea59"; }

.bx-chip:before {
  content: "\\ea5a"; }

.bx-church:before {
  content: "\\ea5b"; }

.bx-circle:before {
  content: "\\ea5c"; }

.bx-clinic:before {
  content: "\\ea5d"; }

.bx-clipboard:before {
  content: "\\ea5e"; }

.bx-closet:before {
  content: "\\ea5f"; }

.bx-cloud:before {
  content: "\\ea60"; }

.bx-cloud-download:before {
  content: "\\ea61"; }

.bx-cloud-drizzle:before {
  content: "\\ea62"; }

.bx-cloud-lightning:before {
  content: "\\ea63"; }

.bx-cloud-light-rain:before {
  content: "\\ea64"; }

.bx-cloud-rain:before {
  content: "\\ea65"; }

.bx-cloud-snow:before {
  content: "\\ea66"; }

.bx-cloud-upload:before {
  content: "\\ea67"; }

.bx-code:before {
  content: "\\ea68"; }

.bx-code-alt:before {
  content: "\\ea69"; }

.bx-code-block:before {
  content: "\\ea6a"; }

.bx-code-curly:before {
  content: "\\ea6b"; }

.bx-coffee:before {
  content: "\\ea6c"; }

.bx-coffee-togo:before {
  content: "\\ea6d"; }

.bx-cog:before {
  content: "\\ea6e"; }

.bx-coin:before {
  content: "\\ea6f"; }

.bx-coin-stack:before {
  content: "\\ea70"; }

.bx-collapse:before {
  content: "\\ea71"; }

.bx-collection:before {
  content: "\\ea72"; }

.bx-color-fill:before {
  content: "\\ea73"; }

.bx-columns:before {
  content: "\\ea74"; }

.bx-command:before {
  content: "\\ea75"; }

.bx-comment:before {
  content: "\\ea76"; }

.bx-comment-add:before {
  content: "\\ea77"; }

.bx-comment-check:before {
  content: "\\ea78"; }

.bx-comment-detail:before {
  content: "\\ea79"; }

.bx-comment-dots:before {
  content: "\\ea7a"; }

.bx-comment-edit:before {
  content: "\\ea7b"; }

.bx-comment-error:before {
  content: "\\ea7c"; }

.bx-comment-minus:before {
  content: "\\ea7d"; }

.bx-comment-x:before {
  content: "\\ea7e"; }

.bx-compass:before {
  content: "\\ea7f"; }

.bx-confused:before {
  content: "\\ea80"; }

.bx-conversation:before {
  content: "\\ea81"; }

.bx-cookie:before {
  content: "\\ea82"; }

.bx-cool:before {
  content: "\\ea83"; }

.bx-copy:before {
  content: "\\ea84"; }

.bx-copy-alt:before {
  content: "\\ea85"; }

.bx-copyright:before {
  content: "\\ea86"; }

.bx-credit-card:before {
  content: "\\ea87"; }

.bx-credit-card-alt:before {
  content: "\\ea88"; }

.bx-credit-card-front:before {
  content: "\\ea89"; }

.bx-crop:before {
  content: "\\ea8a"; }

.bx-crosshair:before {
  content: "\\ea8b"; }

.bx-crown:before {
  content: "\\ea8c"; }

.bx-cube:before {
  content: "\\ea8d"; }

.bx-cube-alt:before {
  content: "\\ea8e"; }

.bx-cuboid:before {
  content: "\\ea8f"; }

.bx-current-location:before {
  content: "\\ea90"; }

.bx-customize:before {
  content: "\\ea91"; }

.bx-cut:before {
  content: "\\ea92"; }

.bx-cycling:before {
  content: "\\ea93"; }

.bx-cylinder:before {
  content: "\\ea94"; }

.bx-data:before {
  content: "\\ea95"; }

.bx-desktop:before {
  content: "\\ea96"; }

.bx-detail:before {
  content: "\\ea97"; }

.bx-devices:before {
  content: "\\ea98"; }

.bx-dialpad:before {
  content: "\\ea99"; }

.bx-dialpad-alt:before {
  content: "\\ea9a"; }

.bx-diamond:before {
  content: "\\ea9b"; }

.bx-dice-1:before {
  content: "\\ea9c"; }

.bx-dice-2:before {
  content: "\\ea9d"; }

.bx-dice-3:before {
  content: "\\ea9e"; }

.bx-dice-4:before {
  content: "\\ea9f"; }

.bx-dice-5:before {
  content: "\\eaa0"; }

.bx-dice-6:before {
  content: "\\eaa1"; }

.bx-directions:before {
  content: "\\eaa2"; }

.bx-disc:before {
  content: "\\eaa3"; }

.bx-dish:before {
  content: "\\eaa4"; }

.bx-dislike:before {
  content: "\\eaa5"; }

.bx-dizzy:before {
  content: "\\eaa6"; }

.bx-dna:before {
  content: "\\eaa7"; }

.bx-dock-bottom:before {
  content: "\\eaa8"; }

.bx-dock-left:before {
  content: "\\eaa9"; }

.bx-dock-right:before {
  content: "\\eaaa"; }

.bx-dock-top:before {
  content: "\\eaab"; }

.bx-dollar:before {
  content: "\\eaac"; }

.bx-dollar-circle:before {
  content: "\\eaad"; }

.bx-donate-blood:before {
  content: "\\eaae"; }

.bx-donate-heart:before {
  content: "\\eaaf"; }

.bx-door-open:before {
  content: "\\eab0"; }

.bx-dots-horizontal:before {
  content: "\\eab1"; }

.bx-dots-horizontal-rounded:before {
  content: "\\eab2"; }

.bx-dots-vertical:before {
  content: "\\eab3"; }

.bx-dots-vertical-rounded:before {
  content: "\\eab4"; }

.bx-doughnut-chart:before {
  content: "\\eab5"; }

.bx-down-arrow:before {
  content: "\\eab6"; }

.bx-down-arrow-alt:before {
  content: "\\eab7"; }

.bx-down-arrow-circle:before {
  content: "\\eab8"; }

.bx-download:before {
  content: "\\eab9"; }

.bx-downvote:before {
  content: "\\eaba"; }

.bx-drink:before {
  content: "\\eabb"; }

.bx-droplet:before {
  content: "\\eabc"; }

.bx-dumbbell:before {
  content: "\\eabd"; }

.bx-duplicate:before {
  content: "\\eabe"; }

.bx-edit:before {
  content: "\\eabf"; }

.bx-edit-alt:before {
  content: "\\eac0"; }

.bx-envelope:before {
  content: "\\eac1"; }

.bx-envelope-open:before {
  content: "\\eac2"; }

.bx-equalizer:before {
  content: "\\eac3"; }

.bx-eraser:before {
  content: "\\eac4"; }

.bx-error:before {
  content: "\\eac5"; }

.bx-error-alt:before {
  content: "\\eac6"; }

.bx-error-circle:before {
  content: "\\eac7"; }

.bx-euro:before {
  content: "\\eac8"; }

.bx-exclude:before {
  content: "\\eac9"; }

.bx-exit:before {
  content: "\\eaca"; }

.bx-exit-fullscreen:before {
  content: "\\eacb"; }

.bx-expand:before {
  content: "\\eacc"; }

.bx-expand-alt:before {
  content: "\\eacd"; }

.bx-export:before {
  content: "\\eace"; }

.bx-extension:before {
  content: "\\eacf"; }

.bx-face:before {
  content: "\\ead0"; }

.bx-fast-forward:before {
  content: "\\ead1"; }

.bx-fast-forward-circle:before {
  content: "\\ead2"; }

.bx-female:before {
  content: "\\ead3"; }

.bx-female-sign:before {
  content: "\\ead4"; }

.bx-file:before {
  content: "\\ead5"; }

.bx-file-blank:before {
  content: "\\ead6"; }

.bx-file-find:before {
  content: "\\ead7"; }

.bx-film:before {
  content: "\\ead8"; }

.bx-filter:before {
  content: "\\ead9"; }

.bx-filter-alt:before {
  content: "\\eada"; }

.bx-fingerprint:before {
  content: "\\eadb"; }

.bx-first-aid:before {
  content: "\\eadc"; }

.bx-first-page:before {
  content: "\\eadd"; }

.bx-flag:before {
  content: "\\eade"; }

.bx-folder:before {
  content: "\\eadf"; }

.bx-folder-minus:before {
  content: "\\eae0"; }

.bx-folder-open:before {
  content: "\\eae1"; }

.bx-folder-plus:before {
  content: "\\eae2"; }

.bx-font:before {
  content: "\\eae3"; }

.bx-font-color:before {
  content: "\\eae4"; }

.bx-font-family:before {
  content: "\\eae5"; }

.bx-font-size:before {
  content: "\\eae6"; }

.bx-food-menu:before {
  content: "\\eae7"; }

.bx-food-tag:before {
  content: "\\eae8"; }

.bx-football:before {
  content: "\\eae9"; }

.bx-fridge:before {
  content: "\\eaea"; }

.bx-fullscreen:before {
  content: "\\eaeb"; }

.bx-game:before {
  content: "\\eaec"; }

.bx-gas-pump:before {
  content: "\\eaed"; }

.bx-ghost:before {
  content: "\\eaee"; }

.bx-gift:before {
  content: "\\eaef"; }

.bx-git-branch:before {
  content: "\\eaf0"; }

.bx-git-commit:before {
  content: "\\eaf1"; }

.bx-git-compare:before {
  content: "\\eaf2"; }

.bx-git-merge:before {
  content: "\\eaf3"; }

.bx-git-pull-request:before {
  content: "\\eaf4"; }

.bx-git-repo-forked:before {
  content: "\\eaf5"; }

.bx-glasses:before {
  content: "\\eaf6"; }

.bx-glasses-alt:before {
  content: "\\eaf7"; }

.bx-globe:before {
  content: "\\eaf8"; }

.bx-globe-alt:before {
  content: "\\eaf9"; }

.bx-grid:before {
  content: "\\eafa"; }

.bx-grid-alt:before {
  content: "\\eafb"; }

.bx-grid-horizontal:before {
  content: "\\eafc"; }

.bx-grid-small:before {
  content: "\\eafd"; }

.bx-grid-vertical:before {
  content: "\\eafe"; }

.bx-group:before {
  content: "\\eaff"; }

.bx-handicap:before {
  content: "\\eb00"; }

.bx-happy:before {
  content: "\\eb01"; }

.bx-happy-alt:before {
  content: "\\eb02"; }

.bx-happy-beaming:before {
  content: "\\eb03"; }

.bx-happy-heart-eyes:before {
  content: "\\eb04"; }

.bx-hash:before {
  content: "\\eb05"; }

.bx-hdd:before {
  content: "\\eb06"; }

.bx-heading:before {
  content: "\\eb07"; }

.bx-headphone:before {
  content: "\\eb08"; }

.bx-health:before {
  content: "\\eb09"; }

.bx-heart:before {
  content: "\\eb0a"; }

.bx-heart-circle:before {
  content: "\\eb0b"; }

.bx-heart-square:before {
  content: "\\eb0c"; }

.bx-help-circle:before {
  content: "\\eb0d"; }

.bx-hide:before {
  content: "\\eb0e"; }

.bx-highlight:before {
  content: "\\eb0f"; }

.bx-history:before {
  content: "\\eb10"; }

.bx-hive:before {
  content: "\\eb11"; }

.bx-home:before {
  content: "\\eb12"; }

.bx-home-alt:before {
  content: "\\eb13"; }

.bx-home-circle:before {
  content: "\\eb14"; }

.bx-home-heart:before {
  content: "\\eb15"; }

.bx-home-smile:before {
  content: "\\eb16"; }

.bx-horizontal-center:before {
  content: "\\eb17"; }

.bx-hotel:before {
  content: "\\eb18"; }

.bx-hourglass:before {
  content: "\\eb19"; }

.bx-id-card:before {
  content: "\\eb1a"; }

.bx-image:before {
  content: "\\eb1b"; }

.bx-image-add:before {
  content: "\\eb1c"; }

.bx-image-alt:before {
  content: "\\eb1d"; }

.bx-images:before {
  content: "\\eb1e"; }

.bx-import:before {
  content: "\\eb1f"; }

.bx-infinite:before {
  content: "\\eb20"; }

.bx-info-circle:before {
  content: "\\eb21"; }

.bx-info-square:before {
  content: "\\eb22"; }

.bx-intersect:before {
  content: "\\eb23"; }

.bx-italic:before {
  content: "\\eb24"; }

.bx-joystick:before {
  content: "\\eb25"; }

.bx-joystick-alt:before {
  content: "\\eb26"; }

.bx-joystick-button:before {
  content: "\\eb27"; }

.bx-key:before {
  content: "\\eb28"; }

.bx-label:before {
  content: "\\eb29"; }

.bx-landscape:before {
  content: "\\eb2a"; }

.bx-laptop:before {
  content: "\\eb2b"; }

.bx-last-page:before {
  content: "\\eb2c"; }

.bx-laugh:before {
  content: "\\eb2d"; }

.bx-layer:before {
  content: "\\eb2e"; }

.bx-layer-minus:before {
  content: "\\eb2f"; }

.bx-layer-plus:before {
  content: "\\eb30"; }

.bx-layout:before {
  content: "\\eb31"; }

.bx-left-arrow:before {
  content: "\\eb32"; }

.bx-left-arrow-alt:before {
  content: "\\eb33"; }

.bx-left-arrow-circle:before {
  content: "\\eb34"; }

.bx-left-down-arrow-circle:before {
  content: "\\eb35"; }

.bx-left-indent:before {
  content: "\\eb36"; }

.bx-left-top-arrow-circle:before {
  content: "\\eb37"; }

.bx-library:before {
  content: "\\eb38"; }

.bx-like:before {
  content: "\\eb39"; }

.bx-line-chart:before {
  content: "\\eb3a"; }

.bx-line-chart-down:before {
  content: "\\eb3b"; }

.bx-link:before {
  content: "\\eb3c"; }

.bx-link-alt:before {
  content: "\\eb3d"; }

.bx-link-external:before {
  content: "\\eb3e"; }

.bx-lira:before {
  content: "\\eb3f"; }

.bx-list-check:before {
  content: "\\eb40"; }

.bx-list-minus:before {
  content: "\\eb41"; }

.bx-list-ol:before {
  content: "\\eb42"; }

.bx-list-plus:before {
  content: "\\eb43"; }

.bx-list-ul:before {
  content: "\\eb44"; }

.bx-loader:before {
  content: "\\eb45"; }

.bx-loader-alt:before {
  content: "\\eb46"; }

.bx-loader-circle:before {
  content: "\\eb47"; }

.bx-location-plus:before {
  content: "\\eb48"; }

.bx-lock:before {
  content: "\\eb49"; }

.bx-lock-alt:before {
  content: "\\eb4a"; }

.bx-lock-open:before {
  content: "\\eb4b"; }

.bx-lock-open-alt:before {
  content: "\\eb4c"; }

.bx-log-in:before {
  content: "\\eb4d"; }

.bx-log-in-circle:before {
  content: "\\eb4e"; }

.bx-log-out:before {
  content: "\\eb4f"; }

.bx-log-out-circle:before {
  content: "\\eb50"; }

.bx-low-vision:before {
  content: "\\eb51"; }

.bx-magnet:before {
  content: "\\eb52"; }

.bx-mail-send:before {
  content: "\\eb53"; }

.bx-male:before {
  content: "\\eb54"; }

.bx-male-sign:before {
  content: "\\eb55"; }

.bx-map:before {
  content: "\\eb56"; }

.bx-map-alt:before {
  content: "\\eb57"; }

.bx-map-pin:before {
  content: "\\eb58"; }

.bx-mask:before {
  content: "\\eb59"; }

.bx-medal:before {
  content: "\\eb5a"; }

.bx-meh:before {
  content: "\\eb5b"; }

.bx-meh-alt:before {
  content: "\\eb5c"; }

.bx-meh-blank:before {
  content: "\\eb5d"; }

.bx-memory-card:before {
  content: "\\eb5e"; }

.bx-menu:before {
  content: "\\eb5f"; }

.bx-menu-alt-left:before {
  content: "\\eb60"; }

.bx-menu-alt-right:before {
  content: "\\eb61"; }

.bx-merge:before {
  content: "\\eb62"; }

.bx-message:before {
  content: "\\eb63"; }

.bx-message-add:before {
  content: "\\eb64"; }

.bx-message-alt:before {
  content: "\\eb65"; }

.bx-message-alt-add:before {
  content: "\\eb66"; }

.bx-message-alt-check:before {
  content: "\\eb67"; }

.bx-message-alt-detail:before {
  content: "\\eb68"; }

.bx-message-alt-dots:before {
  content: "\\eb69"; }

.bx-message-alt-edit:before {
  content: "\\eb6a"; }

.bx-message-alt-error:before {
  content: "\\eb6b"; }

.bx-message-alt-minus:before {
  content: "\\eb6c"; }

.bx-message-alt-x:before {
  content: "\\eb6d"; }

.bx-message-check:before {
  content: "\\eb6e"; }

.bx-message-detail:before {
  content: "\\eb6f"; }

.bx-message-dots:before {
  content: "\\eb70"; }

.bx-message-edit:before {
  content: "\\eb71"; }

.bx-message-error:before {
  content: "\\eb72"; }

.bx-message-minus:before {
  content: "\\eb73"; }

.bx-message-rounded:before {
  content: "\\eb74"; }

.bx-message-rounded-add:before {
  content: "\\eb75"; }

.bx-message-rounded-check:before {
  content: "\\eb76"; }

.bx-message-rounded-detail:before {
  content: "\\eb77"; }

.bx-message-rounded-dots:before {
  content: "\\eb78"; }

.bx-message-rounded-edit:before {
  content: "\\eb79"; }

.bx-message-rounded-error:before {
  content: "\\eb7a"; }

.bx-message-rounded-minus:before {
  content: "\\eb7b"; }

.bx-message-rounded-x:before {
  content: "\\eb7c"; }

.bx-message-square:before {
  content: "\\eb7d"; }

.bx-message-square-add:before {
  content: "\\eb7e"; }

.bx-message-square-check:before {
  content: "\\eb7f"; }

.bx-message-square-detail:before {
  content: "\\eb80"; }

.bx-message-square-dots:before {
  content: "\\eb81"; }

.bx-message-square-edit:before {
  content: "\\eb82"; }

.bx-message-square-error:before {
  content: "\\eb83"; }

.bx-message-square-minus:before {
  content: "\\eb84"; }

.bx-message-square-x:before {
  content: "\\eb85"; }

.bx-message-x:before {
  content: "\\eb86"; }

.bx-meteor:before {
  content: "\\eb87"; }

.bx-microchip:before {
  content: "\\eb88"; }

.bx-microphone:before {
  content: "\\eb89"; }

.bx-microphone-off:before {
  content: "\\eb8a"; }

.bx-minus:before {
  content: "\\eb8b"; }

.bx-minus-back:before {
  content: "\\eb8c"; }

.bx-minus-circle:before {
  content: "\\eb8d"; }

.bx-minus-front:before {
  content: "\\eb8e"; }

.bx-mobile:before {
  content: "\\eb8f"; }

.bx-mobile-alt:before {
  content: "\\eb90"; }

.bx-mobile-landscape:before {
  content: "\\eb91"; }

.bx-mobile-vibration:before {
  content: "\\eb92"; }

.bx-money:before {
  content: "\\eb93"; }

.bx-moon:before {
  content: "\\eb94"; }

.bx-mouse:before {
  content: "\\eb95"; }

.bx-mouse-alt:before {
  content: "\\eb96"; }

.bx-move:before {
  content: "\\eb97"; }

.bx-move-horizontal:before {
  content: "\\eb98"; }

.bx-move-vertical:before {
  content: "\\eb99"; }

.bx-movie:before {
  content: "\\eb9a"; }

.bx-movie-play:before {
  content: "\\eb9b"; }

.bx-music:before {
  content: "\\eb9c"; }

.bx-navigation:before {
  content: "\\eb9d"; }

.bx-network-chart:before {
  content: "\\eb9e"; }

.bx-news:before {
  content: "\\eb9f"; }

.bx-no-entry:before {
  content: "\\eba0"; }

.bx-note:before {
  content: "\\eba1"; }

.bx-notepad:before {
  content: "\\eba2"; }

.bx-notification:before {
  content: "\\eba3"; }

.bx-notification-off:before {
  content: "\\eba4"; }

.bx-outline:before {
  content: "\\eba5"; }

.bx-package:before {
  content: "\\eba6"; }

.bx-paint:before {
  content: "\\eba7"; }

.bx-paint-roll:before {
  content: "\\eba8"; }

.bx-palette:before {
  content: "\\eba9"; }

.bx-paperclip:before {
  content: "\\ebaa"; }

.bx-paper-plane:before {
  content: "\\ebab"; }

.bx-paragraph:before {
  content: "\\ebac"; }

.bx-paste:before {
  content: "\\ebad"; }

.bx-pause:before {
  content: "\\ebae"; }

.bx-pause-circle:before {
  content: "\\ebaf"; }

.bx-pen:before {
  content: "\\ebb0"; }

.bx-pencil:before {
  content: "\\ebb1"; }

.bx-phone:before {
  content: "\\ebb2"; }

.bx-phone-call:before {
  content: "\\ebb3"; }

.bx-phone-incoming:before {
  content: "\\ebb4"; }

.bx-phone-off:before {
  content: "\\ebb5"; }

.bx-phone-outgoing:before {
  content: "\\ebb6"; }

.bx-photo-album:before {
  content: "\\ebb7"; }

.bx-pie-chart:before {
  content: "\\ebb8"; }

.bx-pie-chart-alt:before {
  content: "\\ebb9"; }

.bx-pie-chart-alt-2:before {
  content: "\\ebba"; }

.bx-pin:before {
  content: "\\ebbb"; }

.bx-planet:before {
  content: "\\ebbc"; }

.bx-play:before {
  content: "\\ebbd"; }

.bx-play-circle:before {
  content: "\\ebbe"; }

.bx-plug:before {
  content: "\\ebbf"; }

.bx-plus:before {
  content: "\\ebc0"; }

.bx-plus-circle:before {
  content: "\\ebc1"; }

.bx-plus-medical:before {
  content: "\\ebc2"; }

.bx-podcast:before {
  content: "\\ebc3"; }

.bx-pointer:before {
  content: "\\ebc4"; }

.bx-poll:before {
  content: "\\ebc5"; }

.bx-polygon:before {
  content: "\\ebc6"; }

.bx-pound:before {
  content: "\\ebc7"; }

.bx-power-off:before {
  content: "\\ebc8"; }

.bx-printer:before {
  content: "\\ebc9"; }

.bx-pulse:before {
  content: "\\ebca"; }

.bx-purchase-tag:before {
  content: "\\ebcb"; }

.bx-purchase-tag-alt:before {
  content: "\\ebcc"; }

.bx-pyramid:before {
  content: "\\ebcd"; }

.bx-qr:before {
  content: "\\ebce"; }

.bx-qr-scan:before {
  content: "\\ebcf"; }

.bx-question-mark:before {
  content: "\\ebd0"; }

.bx-radar:before {
  content: "\\ebd1"; }

.bx-radio:before {
  content: "\\ebd2"; }

.bx-radio-circle:before {
  content: "\\ebd3"; }

.bx-radio-circle-marked:before {
  content: "\\ebd4"; }

.bx-receipt:before {
  content: "\\ebd5"; }

.bx-rectangle:before {
  content: "\\ebd6"; }

.bx-recycle:before {
  content: "\\ebd7"; }

.bx-redo:before {
  content: "\\ebd8"; }

.bx-refresh:before {
  content: "\\ebd9"; }

.bx-registered:before {
  content: "\\ebda"; }

.bx-rename:before {
  content: "\\ebdb"; }

.bx-repeat:before {
  content: "\\ebdc"; }

.bx-reply:before {
  content: "\\ebdd"; }

.bx-reply-all:before {
  content: "\\ebde"; }

.bx-repost:before {
  content: "\\ebdf"; }

.bx-reset:before {
  content: "\\ebe0"; }

.bx-restaurant:before {
  content: "\\ebe1"; }

.bx-revision:before {
  content: "\\ebe2"; }

.bx-rewind:before {
  content: "\\ebe3"; }

.bx-rewind-circle:before {
  content: "\\ebe4"; }

.bx-right-arrow:before {
  content: "\\ebe5"; }

.bx-right-arrow-alt:before {
  content: "\\ebe6"; }

.bx-right-arrow-circle:before {
  content: "\\ebe7"; }

.bx-right-down-arrow-circle:before {
  content: "\\ebe8"; }

.bx-right-indent:before {
  content: "\\ebe9"; }

.bx-right-top-arrow-circle:before {
  content: "\\ebea"; }

.bx-rocket:before {
  content: "\\ebeb"; }

.bx-rotate-left:before {
  content: "\\ebec"; }

.bx-rotate-right:before {
  content: "\\ebed"; }

.bx-rss:before {
  content: "\\ebee"; }

.bx-ruble:before {
  content: "\\ebef"; }

.bx-ruler:before {
  content: "\\ebf0"; }

.bx-run:before {
  content: "\\ebf1"; }

.bx-rupee:before {
  content: "\\ebf2"; }

.bx-sad:before {
  content: "\\ebf3"; }

.bx-save:before {
  content: "\\ebf4"; }

.bx-scan:before {
  content: "\\ebf5"; }

.bx-screenshot:before {
  content: "\\ebf6"; }

.bx-search:before {
  content: "\\ebf7"; }

.bx-search-alt:before {
  content: "\\ebf8"; }

.bx-search-alt-2:before {
  content: "\\ebf9"; }

.bx-selection:before {
  content: "\\ebfa"; }

.bx-select-multiple:before {
  content: "\\ebfb"; }

.bx-send:before {
  content: "\\ebfc"; }

.bx-server:before {
  content: "\\ebfd"; }

.bx-shape-circle:before {
  content: "\\ebfe"; }

.bx-shape-polygon:before {
  content: "\\ebff"; }

.bx-shape-square:before {
  content: "\\ec00"; }

.bx-shape-triangle:before {
  content: "\\ec01"; }

.bx-share:before {
  content: "\\ec02"; }

.bx-share-alt:before {
  content: "\\ec03"; }

.bx-shekel:before {
  content: "\\ec04"; }

.bx-shield:before {
  content: "\\ec05"; }

.bx-shield-alt:before {
  content: "\\ec06"; }

.bx-shield-alt-2:before {
  content: "\\ec07"; }

.bx-shield-quarter:before {
  content: "\\ec08"; }

.bx-shield-x:before {
  content: "\\ec09"; }

.bx-shocked:before {
  content: "\\ec0a"; }

.bx-shopping-bag:before {
  content: "\\ec0b"; }

.bx-show:before {
  content: "\\ec0c"; }

.bx-show-alt:before {
  content: "\\ec0d"; }

.bx-shuffle:before {
  content: "\\ec0e"; }

.bx-sidebar:before {
  content: "\\ec0f"; }

.bx-sitemap:before {
  content: "\\ec10"; }

.bx-skip-next:before {
  content: "\\ec11"; }

.bx-skip-next-circle:before {
  content: "\\ec12"; }

.bx-skip-previous:before {
  content: "\\ec13"; }

.bx-skip-previous-circle:before {
  content: "\\ec14"; }

.bx-sleepy:before {
  content: "\\ec15"; }

.bx-slider:before {
  content: "\\ec16"; }

.bx-slider-alt:before {
  content: "\\ec17"; }

.bx-slideshow:before {
  content: "\\ec18"; }

.bx-smile:before {
  content: "\\ec19"; }

.bx-sort:before {
  content: "\\ec1a"; }

.bx-sort-alt-2:before {
  content: "\\ec1b"; }

.bx-sort-a-z:before {
  content: "\\ec1c"; }

.bx-sort-down:before {
  content: "\\ec1d"; }

.bx-sort-up:before {
  content: "\\ec1e"; }

.bx-sort-z-a:before {
  content: "\\ec1f"; }

.bx-spa:before {
  content: "\\ec20"; }

.bx-space-bar:before {
  content: "\\ec21"; }

.bx-speaker:before {
  content: "\\ec22"; }

.bx-spray-can:before {
  content: "\\ec23"; }

.bx-spreadsheet:before {
  content: "\\ec24"; }

.bx-square:before {
  content: "\\ec25"; }

.bx-square-rounded:before {
  content: "\\ec26"; }

.bx-star:before {
  content: "\\ec27"; }

.bx-station:before {
  content: "\\ec28"; }

.bx-stats:before {
  content: "\\ec29"; }

.bx-sticker:before {
  content: "\\ec2a"; }

.bx-stop:before {
  content: "\\ec2b"; }

.bx-stop-circle:before {
  content: "\\ec2c"; }

.bx-stopwatch:before {
  content: "\\ec2d"; }

.bx-store:before {
  content: "\\ec2e"; }

.bx-store-alt:before {
  content: "\\ec2f"; }

.bx-street-view:before {
  content: "\\ec30"; }

.bx-strikethrough:before {
  content: "\\ec31"; }

.bx-subdirectory-left:before {
  content: "\\ec32"; }

.bx-subdirectory-right:before {
  content: "\\ec33"; }

.bx-sun:before {
  content: "\\ec34"; }

.bx-support:before {
  content: "\\ec35"; }

.bx-swim:before {
  content: "\\ec36"; }

.bx-sync:before {
  content: "\\ec37"; }

.bx-tab:before {
  content: "\\ec38"; }

.bx-table:before {
  content: "\\ec39"; }

.bx-tachometer:before {
  content: "\\ec3a"; }

.bx-tag:before {
  content: "\\ec3b"; }

.bx-tag-alt:before {
  content: "\\ec3c"; }

.bx-target-lock:before {
  content: "\\ec3d"; }

.bx-task:before {
  content: "\\ec3e"; }

.bx-task-x:before {
  content: "\\ec3f"; }

.bx-taxi:before {
  content: "\\ec40"; }

.bx-tennis-ball:before {
  content: "\\ec41"; }

.bx-terminal:before {
  content: "\\ec42"; }

.bx-test-tube:before {
  content: "\\ec43"; }

.bx-text:before {
  content: "\\ec44"; }

.bx-time:before {
  content: "\\ec45"; }

.bx-time-five:before {
  content: "\\ec46"; }

.bx-timer:before {
  content: "\\ec47"; }

.bx-tired:before {
  content: "\\ec48"; }

.bx-toggle-left:before {
  content: "\\ec49"; }

.bx-toggle-right:before {
  content: "\\ec4a"; }

.bx-tone:before {
  content: "\\ec4b"; }

.bx-traffic-cone:before {
  content: "\\ec4c"; }

.bx-train:before {
  content: "\\ec4d"; }

.bx-transfer:before {
  content: "\\ec4e"; }

.bx-transfer-alt:before {
  content: "\\ec4f"; }

.bx-trash:before {
  content: "\\ec50"; }

.bx-trash-alt:before {
  content: "\\ec51"; }

.bx-trending-down:before {
  content: "\\ec52"; }

.bx-trending-up:before {
  content: "\\ec53"; }

.bx-trim:before {
  content: "\\ec54"; }

.bx-trip:before {
  content: "\\ec55"; }

.bx-trophy:before {
  content: "\\ec56"; }

.bx-tv:before {
  content: "\\ec57"; }

.bx-underline:before {
  content: "\\ec58"; }

.bx-undo:before {
  content: "\\ec59"; }

.bx-unite:before {
  content: "\\ec5a"; }

.bx-unlink:before {
  content: "\\ec5b"; }

.bx-up-arrow:before {
  content: "\\ec5c"; }

.bx-up-arrow-alt:before {
  content: "\\ec5d"; }

.bx-up-arrow-circle:before {
  content: "\\ec5e"; }

.bx-upload:before {
  content: "\\ec5f"; }

.bx-upside-down:before {
  content: "\\ec60"; }

.bx-upvote:before {
  content: "\\ec61"; }

.bx-usb:before {
  content: "\\ec62"; }

.bx-user:before {
  content: "\\ec63"; }

.bx-user-check:before {
  content: "\\ec64"; }

.bx-user-circle:before {
  content: "\\ec65"; }

.bx-user-minus:before {
  content: "\\ec66"; }

.bx-user-pin:before {
  content: "\\ec67"; }

.bx-user-plus:before {
  content: "\\ec68"; }

.bx-user-voice:before {
  content: "\\ec69"; }

.bx-user-x:before {
  content: "\\ec6a"; }

.bx-vector:before {
  content: "\\ec6b"; }

.bx-vertical-center:before {
  content: "\\ec6c"; }

.bx-vial:before {
  content: "\\ec6d"; }

.bx-video:before {
  content: "\\ec6e"; }

.bx-video-off:before {
  content: "\\ec6f"; }

.bx-video-plus:before {
  content: "\\ec70"; }

.bx-video-recording:before {
  content: "\\ec71"; }

.bx-voicemail:before {
  content: "\\ec72"; }

.bx-volume:before {
  content: "\\ec73"; }

.bx-volume-full:before {
  content: "\\ec74"; }

.bx-volume-low:before {
  content: "\\ec75"; }

.bx-volume-mute:before {
  content: "\\ec76"; }

.bx-walk:before {
  content: "\\ec77"; }

.bx-wallet:before {
  content: "\\ec78"; }

.bx-wallet-alt:before {
  content: "\\ec79"; }

.bx-water:before {
  content: "\\ec7a"; }

.bx-webcam:before {
  content: "\\ec7b"; }

.bx-wifi:before {
  content: "\\ec7c"; }

.bx-wifi-0:before {
  content: "\\ec7d"; }

.bx-wifi-1:before {
  content: "\\ec7e"; }

.bx-wifi-2:before {
  content: "\\ec7f"; }

.bx-wifi-off:before {
  content: "\\ec80"; }

.bx-wind:before {
  content: "\\ec81"; }

.bx-window:before {
  content: "\\ec82"; }

.bx-window-alt:before {
  content: "\\ec83"; }

.bx-window-close:before {
  content: "\\ec84"; }

.bx-window-open:before {
  content: "\\ec85"; }

.bx-windows:before {
  content: "\\ec86"; }

.bx-wine:before {
  content: "\\ec87"; }

.bx-wink-smile:before {
  content: "\\ec88"; }

.bx-wink-tongue:before {
  content: "\\ec89"; }

.bx-won:before {
  content: "\\ec8a"; }

.bx-world:before {
  content: "\\ec8b"; }

.bx-wrench:before {
  content: "\\ec8c"; }

.bx-x:before {
  content: "\\ec8d"; }

.bx-x-circle:before {
  content: "\\ec8e"; }

.bx-yen:before {
  content: "\\ec8f"; }

.bx-zoom-in:before {
  content: "\\ec90"; }

.bx-zoom-out:before {
  content: "\\ec91"; }

.bxs-party:before {
  content: "\\ec92"; }

.bxs-hot:before {
  content: "\\ec93"; }

.bxs-droplet:before {
  content: "\\ec94"; }

.bxs-cat:before {
  content: "\\ec95"; }

.bxs-dog:before {
  content: "\\ec96"; }

.bxs-injection:before {
  content: "\\ec97"; }

.bxs-leaf:before {
  content: "\\ec98"; }

.bxs-add-to-queue:before {
  content: "\\ec99"; }

.bxs-adjust:before {
  content: "\\ec9a"; }

.bxs-adjust-alt:before {
  content: "\\ec9b"; }

.bxs-alarm:before {
  content: "\\ec9c"; }

.bxs-alarm-add:before {
  content: "\\ec9d"; }

.bxs-alarm-exclamation:before {
  content: "\\ec9e"; }

.bxs-alarm-off:before {
  content: "\\ec9f"; }

.bxs-alarm-snooze:before {
  content: "\\eca0"; }

.bxs-album:before {
  content: "\\eca1"; }

.bxs-ambulance:before {
  content: "\\eca2"; }

.bxs-analyse:before {
  content: "\\eca3"; }

.bxs-angry:before {
  content: "\\eca4"; }

.bxs-arch:before {
  content: "\\eca5"; }

.bxs-archive:before {
  content: "\\eca6"; }

.bxs-archive-in:before {
  content: "\\eca7"; }

.bxs-archive-out:before {
  content: "\\eca8"; }

.bxs-area:before {
  content: "\\eca9"; }

.bxs-arrow-from-bottom:before {
  content: "\\ecaa"; }

.bxs-arrow-from-left:before {
  content: "\\ecab"; }

.bxs-arrow-from-right:before {
  content: "\\ecac"; }

.bxs-arrow-from-top:before {
  content: "\\ecad"; }

.bxs-arrow-to-bottom:before {
  content: "\\ecae"; }

.bxs-arrow-to-left:before {
  content: "\\ecaf"; }

.bxs-arrow-to-right:before {
  content: "\\ecb0"; }

.bxs-arrow-to-top:before {
  content: "\\ecb1"; }

.bxs-award:before {
  content: "\\ecb2"; }

.bxs-baby-carriage:before {
  content: "\\ecb3"; }

.bxs-backpack:before {
  content: "\\ecb4"; }

.bxs-badge:before {
  content: "\\ecb5"; }

.bxs-badge-check:before {
  content: "\\ecb6"; }

.bxs-badge-dollar:before {
  content: "\\ecb7"; }

.bxs-ball:before {
  content: "\\ecb8"; }

.bxs-band-aid:before {
  content: "\\ecb9"; }

.bxs-bank:before {
  content: "\\ecba"; }

.bxs-bar-chart-alt-2:before {
  content: "\\ecbb"; }

.bxs-bar-chart-square:before {
  content: "\\ecbc"; }

.bxs-barcode:before {
  content: "\\ecbd"; }

.bxs-baseball:before {
  content: "\\ecbe"; }

.bxs-basket:before {
  content: "\\ecbf"; }

.bxs-basketball:before {
  content: "\\ecc0"; }

.bxs-bath:before {
  content: "\\ecc1"; }

.bxs-battery:before {
  content: "\\ecc2"; }

.bxs-battery-charging:before {
  content: "\\ecc3"; }

.bxs-battery-full:before {
  content: "\\ecc4"; }

.bxs-battery-low:before {
  content: "\\ecc5"; }

.bxs-bed:before {
  content: "\\ecc6"; }

.bxs-been-here:before {
  content: "\\ecc7"; }

.bxs-beer:before {
  content: "\\ecc8"; }

.bxs-bell:before {
  content: "\\ecc9"; }

.bxs-bell-minus:before {
  content: "\\ecca"; }

.bxs-bell-off:before {
  content: "\\eccb"; }

.bxs-bell-plus:before {
  content: "\\eccc"; }

.bxs-bell-ring:before {
  content: "\\eccd"; }

.bxs-bible:before {
  content: "\\ecce"; }

.bxs-binoculars:before {
  content: "\\eccf"; }

.bxs-blanket:before {
  content: "\\ecd0"; }

.bxs-bolt:before {
  content: "\\ecd1"; }

.bxs-bolt-circle:before {
  content: "\\ecd2"; }

.bxs-bomb:before {
  content: "\\ecd3"; }

.bxs-bone:before {
  content: "\\ecd4"; }

.bxs-bong:before {
  content: "\\ecd5"; }

.bxs-book:before {
  content: "\\ecd6"; }

.bxs-book-add:before {
  content: "\\ecd7"; }

.bxs-book-alt:before {
  content: "\\ecd8"; }

.bxs-book-bookmark:before {
  content: "\\ecd9"; }

.bxs-book-content:before {
  content: "\\ecda"; }

.bxs-book-heart:before {
  content: "\\ecdb"; }

.bxs-bookmark:before {
  content: "\\ecdc"; }

.bxs-bookmark-alt:before {
  content: "\\ecdd"; }

.bxs-bookmark-alt-minus:before {
  content: "\\ecde"; }

.bxs-bookmark-alt-plus:before {
  content: "\\ecdf"; }

.bxs-bookmark-heart:before {
  content: "\\ece0"; }

.bxs-bookmark-minus:before {
  content: "\\ece1"; }

.bxs-bookmark-plus:before {
  content: "\\ece2"; }

.bxs-bookmarks:before {
  content: "\\ece3"; }

.bxs-bookmark-star:before {
  content: "\\ece4"; }

.bxs-book-open:before {
  content: "\\ece5"; }

.bxs-book-reader:before {
  content: "\\ece6"; }

.bxs-bot:before {
  content: "\\ece7"; }

.bxs-bowling-ball:before {
  content: "\\ece8"; }

.bxs-box:before {
  content: "\\ece9"; }

.bxs-brain:before {
  content: "\\ecea"; }

.bxs-briefcase:before {
  content: "\\eceb"; }

.bxs-briefcase-alt:before {
  content: "\\ecec"; }

.bxs-briefcase-alt-2:before {
  content: "\\eced"; }

.bxs-brightness:before {
  content: "\\ecee"; }

.bxs-brightness-half:before {
  content: "\\ecef"; }

.bxs-brush:before {
  content: "\\ecf0"; }

.bxs-brush-alt:before {
  content: "\\ecf1"; }

.bxs-bug:before {
  content: "\\ecf2"; }

.bxs-bug-alt:before {
  content: "\\ecf3"; }

.bxs-building:before {
  content: "\\ecf4"; }

.bxs-building-house:before {
  content: "\\ecf5"; }

.bxs-buildings:before {
  content: "\\ecf6"; }

.bxs-bulb:before {
  content: "\\ecf7"; }

.bxs-bullseye:before {
  content: "\\ecf8"; }

.bxs-buoy:before {
  content: "\\ecf9"; }

.bxs-bus:before {
  content: "\\ecfa"; }

.bxs-business:before {
  content: "\\ecfb"; }

.bxs-bus-school:before {
  content: "\\ecfc"; }

.bxs-cabinet:before {
  content: "\\ecfd"; }

.bxs-cake:before {
  content: "\\ecfe"; }

.bxs-calculator:before {
  content: "\\ecff"; }

.bxs-calendar:before {
  content: "\\ed00"; }

.bxs-calendar-alt:before {
  content: "\\ed01"; }

.bxs-calendar-check:before {
  content: "\\ed02"; }

.bxs-calendar-edit:before {
  content: "\\ed03"; }

.bxs-calendar-event:before {
  content: "\\ed04"; }

.bxs-calendar-exclamation:before {
  content: "\\ed05"; }

.bxs-calendar-heart:before {
  content: "\\ed06"; }

.bxs-calendar-minus:before {
  content: "\\ed07"; }

.bxs-calendar-plus:before {
  content: "\\ed08"; }

.bxs-calendar-star:before {
  content: "\\ed09"; }

.bxs-calendar-week:before {
  content: "\\ed0a"; }

.bxs-calendar-x:before {
  content: "\\ed0b"; }

.bxs-camera:before {
  content: "\\ed0c"; }

.bxs-camera-home:before {
  content: "\\ed0d"; }

.bxs-camera-movie:before {
  content: "\\ed0e"; }

.bxs-camera-off:before {
  content: "\\ed0f"; }

.bxs-camera-plus:before {
  content: "\\ed10"; }

.bxs-capsule:before {
  content: "\\ed11"; }

.bxs-captions:before {
  content: "\\ed12"; }

.bxs-car:before {
  content: "\\ed13"; }

.bxs-car-battery:before {
  content: "\\ed14"; }

.bxs-car-crash:before {
  content: "\\ed15"; }

.bxs-card:before {
  content: "\\ed16"; }

.bxs-caret-down-circle:before {
  content: "\\ed17"; }

.bxs-caret-down-square:before {
  content: "\\ed18"; }

.bxs-caret-left-circle:before {
  content: "\\ed19"; }

.bxs-caret-left-square:before {
  content: "\\ed1a"; }

.bxs-caret-right-circle:before {
  content: "\\ed1b"; }

.bxs-caret-right-square:before {
  content: "\\ed1c"; }

.bxs-caret-up-circle:before {
  content: "\\ed1d"; }

.bxs-caret-up-square:before {
  content: "\\ed1e"; }

.bxs-car-garage:before {
  content: "\\ed1f"; }

.bxs-car-mechanic:before {
  content: "\\ed20"; }

.bxs-carousel:before {
  content: "\\ed21"; }

.bxs-cart:before {
  content: "\\ed22"; }

.bxs-cart-add:before {
  content: "\\ed23"; }

.bxs-cart-alt:before {
  content: "\\ed24"; }

.bxs-cart-download:before {
  content: "\\ed25"; }

.bxs-car-wash:before {
  content: "\\ed26"; }

.bxs-category:before {
  content: "\\ed27"; }

.bxs-category-alt:before {
  content: "\\ed28"; }

.bxs-cctv:before {
  content: "\\ed29"; }

.bxs-certification:before {
  content: "\\ed2a"; }

.bxs-chalkboard:before {
  content: "\\ed2b"; }

.bxs-chart:before {
  content: "\\ed2c"; }

.bxs-chat:before {
  content: "\\ed2d"; }

.bxs-checkbox:before {
  content: "\\ed2e"; }

.bxs-checkbox-checked:before {
  content: "\\ed2f"; }

.bxs-checkbox-minus:before {
  content: "\\ed30"; }

.bxs-check-circle:before {
  content: "\\ed31"; }

.bxs-check-shield:before {
  content: "\\ed32"; }

.bxs-check-square:before {
  content: "\\ed33"; }

.bxs-chess:before {
  content: "\\ed34"; }

.bxs-chevron-down:before {
  content: "\\ed35"; }

.bxs-chevron-down-circle:before {
  content: "\\ed36"; }

.bxs-chevron-down-square:before {
  content: "\\ed37"; }

.bxs-chevron-left:before {
  content: "\\ed38"; }

.bxs-chevron-left-circle:before {
  content: "\\ed39"; }

.bxs-chevron-left-square:before {
  content: "\\ed3a"; }

.bxs-chevron-right:before {
  content: "\\ed3b"; }

.bxs-chevron-right-circle:before {
  content: "\\ed3c"; }

.bxs-chevron-right-square:before {
  content: "\\ed3d"; }

.bxs-chevrons-down:before {
  content: "\\ed3e"; }

.bxs-chevrons-left:before {
  content: "\\ed3f"; }

.bxs-chevrons-right:before {
  content: "\\ed40"; }

.bxs-chevrons-up:before {
  content: "\\ed41"; }

.bxs-chevron-up:before {
  content: "\\ed42"; }

.bxs-chevron-up-circle:before {
  content: "\\ed43"; }

.bxs-chevron-up-square:before {
  content: "\\ed44"; }

.bxs-chip:before {
  content: "\\ed45"; }

.bxs-church:before {
  content: "\\ed46"; }

.bxs-circle:before {
  content: "\\ed47"; }

.bxs-city:before {
  content: "\\ed48"; }

.bxs-clinic:before {
  content: "\\ed49"; }

.bxs-cloud:before {
  content: "\\ed4a"; }

.bxs-cloud-download:before {
  content: "\\ed4b"; }

.bxs-cloud-lightning:before {
  content: "\\ed4c"; }

.bxs-cloud-rain:before {
  content: "\\ed4d"; }

.bxs-cloud-upload:before {
  content: "\\ed4e"; }

.bxs-coffee:before {
  content: "\\ed4f"; }

.bxs-coffee-alt:before {
  content: "\\ed50"; }

.bxs-coffee-togo:before {
  content: "\\ed51"; }

.bxs-cog:before {
  content: "\\ed52"; }

.bxs-coin:before {
  content: "\\ed53"; }

.bxs-coin-stack:before {
  content: "\\ed54"; }

.bxs-collection:before {
  content: "\\ed55"; }

.bxs-color-fill:before {
  content: "\\ed56"; }

.bxs-comment:before {
  content: "\\ed57"; }

.bxs-comment-add:before {
  content: "\\ed58"; }

.bxs-comment-check:before {
  content: "\\ed59"; }

.bxs-comment-detail:before {
  content: "\\ed5a"; }

.bxs-comment-dots:before {
  content: "\\ed5b"; }

.bxs-comment-edit:before {
  content: "\\ed5c"; }

.bxs-comment-error:before {
  content: "\\ed5d"; }

.bxs-comment-minus:before {
  content: "\\ed5e"; }

.bxs-comment-x:before {
  content: "\\ed5f"; }

.bxs-compass:before {
  content: "\\ed60"; }

.bxs-component:before {
  content: "\\ed61"; }

.bxs-confused:before {
  content: "\\ed62"; }

.bxs-contact:before {
  content: "\\ed63"; }

.bxs-conversation:before {
  content: "\\ed64"; }

.bxs-cookie:before {
  content: "\\ed65"; }

.bxs-cool:before {
  content: "\\ed66"; }

.bxs-copy:before {
  content: "\\ed67"; }

.bxs-copy-alt:before {
  content: "\\ed68"; }

.bxs-copyright:before {
  content: "\\ed69"; }

.bxs-coupon:before {
  content: "\\ed6a"; }

.bxs-credit-card:before {
  content: "\\ed6b"; }

.bxs-credit-card-alt:before {
  content: "\\ed6c"; }

.bxs-credit-card-front:before {
  content: "\\ed6d"; }

.bxs-crop:before {
  content: "\\ed6e"; }

.bxs-crown:before {
  content: "\\ed6f"; }

.bxs-cube:before {
  content: "\\ed70"; }

.bxs-cube-alt:before {
  content: "\\ed71"; }

.bxs-cuboid:before {
  content: "\\ed72"; }

.bxs-customize:before {
  content: "\\ed73"; }

.bxs-cylinder:before {
  content: "\\ed74"; }

.bxs-dashboard:before {
  content: "\\ed75"; }

.bxs-data:before {
  content: "\\ed76"; }

.bxs-detail:before {
  content: "\\ed77"; }

.bxs-devices:before {
  content: "\\ed78"; }

.bxs-diamond:before {
  content: "\\ed79"; }

.bxs-dice-1:before {
  content: "\\ed7a"; }

.bxs-dice-2:before {
  content: "\\ed7b"; }

.bxs-dice-3:before {
  content: "\\ed7c"; }

.bxs-dice-4:before {
  content: "\\ed7d"; }

.bxs-dice-5:before {
  content: "\\ed7e"; }

.bxs-dice-6:before {
  content: "\\ed7f"; }

.bxs-direction-left:before {
  content: "\\ed80"; }

.bxs-direction-right:before {
  content: "\\ed81"; }

.bxs-directions:before {
  content: "\\ed82"; }

.bxs-disc:before {
  content: "\\ed83"; }

.bxs-discount:before {
  content: "\\ed84"; }

.bxs-dish:before {
  content: "\\ed85"; }

.bxs-dislike:before {
  content: "\\ed86"; }

.bxs-dizzy:before {
  content: "\\ed87"; }

.bxs-dock-bottom:before {
  content: "\\ed88"; }

.bxs-dock-left:before {
  content: "\\ed89"; }

.bxs-dock-right:before {
  content: "\\ed8a"; }

.bxs-dock-top:before {
  content: "\\ed8b"; }

.bxs-dollar-circle:before {
  content: "\\ed8c"; }

.bxs-donate-blood:before {
  content: "\\ed8d"; }

.bxs-donate-heart:before {
  content: "\\ed8e"; }

.bxs-door-open:before {
  content: "\\ed8f"; }

.bxs-doughnut-chart:before {
  content: "\\ed90"; }

.bxs-down-arrow:before {
  content: "\\ed91"; }

.bxs-down-arrow-alt:before {
  content: "\\ed92"; }

.bxs-down-arrow-circle:before {
  content: "\\ed93"; }

.bxs-down-arrow-square:before {
  content: "\\ed94"; }

.bxs-download:before {
  content: "\\ed95"; }

.bxs-downvote:before {
  content: "\\ed96"; }

.bxs-drink:before {
  content: "\\ed97"; }

.bxs-droplet-half:before {
  content: "\\ed98"; }

.bxs-dryer:before {
  content: "\\ed99"; }

.bxs-duplicate:before {
  content: "\\ed9a"; }

.bxs-edit:before {
  content: "\\ed9b"; }

.bxs-edit-alt:before {
  content: "\\ed9c"; }

.bxs-edit-location:before {
  content: "\\ed9d"; }

.bxs-eject:before {
  content: "\\ed9e"; }

.bxs-envelope:before {
  content: "\\ed9f"; }

.bxs-envelope-open:before {
  content: "\\eda0"; }

.bxs-eraser:before {
  content: "\\eda1"; }

.bxs-error:before {
  content: "\\eda2"; }

.bxs-error-alt:before {
  content: "\\eda3"; }

.bxs-error-circle:before {
  content: "\\eda4"; }

.bxs-ev-station:before {
  content: "\\eda5"; }

.bxs-exit:before {
  content: "\\eda6"; }

.bxs-extension:before {
  content: "\\eda7"; }

.bxs-eyedropper:before {
  content: "\\eda8"; }

.bxs-face:before {
  content: "\\eda9"; }

.bxs-face-mask:before {
  content: "\\edaa"; }

.bxs-factory:before {
  content: "\\edab"; }

.bxs-fast-forward-circle:before {
  content: "\\edac"; }

.bxs-file:before {
  content: "\\edad"; }

.bxs-file-archive:before {
  content: "\\edae"; }

.bxs-file-blank:before {
  content: "\\edaf"; }

.bxs-file-css:before {
  content: "\\edb0"; }

.bxs-file-doc:before {
  content: "\\edb1"; }

.bxs-file-export:before {
  content: "\\edb2"; }

.bxs-file-find:before {
  content: "\\edb3"; }

.bxs-file-gif:before {
  content: "\\edb4"; }

.bxs-file-html:before {
  content: "\\edb5"; }

.bxs-file-image:before {
  content: "\\edb6"; }

.bxs-file-import:before {
  content: "\\edb7"; }

.bxs-file-jpg:before {
  content: "\\edb8"; }

.bxs-file-js:before {
  content: "\\edb9"; }

.bxs-file-json:before {
  content: "\\edba"; }

.bxs-file-md:before {
  content: "\\edbb"; }

.bxs-file-pdf:before {
  content: "\\edbc"; }

.bxs-file-plus:before {
  content: "\\edbd"; }

.bxs-file-png:before {
  content: "\\edbe"; }

.bxs-file-txt:before {
  content: "\\edbf"; }

.bxs-film:before {
  content: "\\edc0"; }

.bxs-filter-alt:before {
  content: "\\edc1"; }

.bxs-first-aid:before {
  content: "\\edc2"; }

.bxs-flag:before {
  content: "\\edc3"; }

.bxs-flag-alt:before {
  content: "\\edc4"; }

.bxs-flag-checkered:before {
  content: "\\edc5"; }

.bxs-flame:before {
  content: "\\edc6"; }

.bxs-flask:before {
  content: "\\edc7"; }

.bxs-florist:before {
  content: "\\edc8"; }

.bxs-folder:before {
  content: "\\edc9"; }

.bxs-folder-minus:before {
  content: "\\edca"; }

.bxs-folder-open:before {
  content: "\\edcb"; }

.bxs-folder-plus:before {
  content: "\\edcc"; }

.bxs-food-menu:before {
  content: "\\edcd"; }

.bxs-fridge:before {
  content: "\\edce"; }

.bxs-game:before {
  content: "\\edcf"; }

.bxs-gas-pump:before {
  content: "\\edd0"; }

.bxs-ghost:before {
  content: "\\edd1"; }

.bxs-gift:before {
  content: "\\edd2"; }

.bxs-graduation:before {
  content: "\\edd3"; }

.bxs-grid:before {
  content: "\\edd4"; }

.bxs-grid-alt:before {
  content: "\\edd5"; }

.bxs-group:before {
  content: "\\edd6"; }

.bxs-guitar-amp:before {
  content: "\\edd7"; }

.bxs-hand:before {
  content: "\\edd8"; }

.bxs-hand-down:before {
  content: "\\edd9"; }

.bxs-hand-left:before {
  content: "\\edda"; }

.bxs-hand-right:before {
  content: "\\eddb"; }

.bxs-hand-up:before {
  content: "\\eddc"; }

.bxs-happy:before {
  content: "\\eddd"; }

.bxs-happy-alt:before {
  content: "\\edde"; }

.bxs-happy-beaming:before {
  content: "\\eddf"; }

.bxs-happy-heart-eyes:before {
  content: "\\ede0"; }

.bxs-hdd:before {
  content: "\\ede1"; }

.bxs-heart:before {
  content: "\\ede2"; }

.bxs-heart-circle:before {
  content: "\\ede3"; }

.bxs-heart-square:before {
  content: "\\ede4"; }

.bxs-help-circle:before {
  content: "\\ede5"; }

.bxs-hide:before {
  content: "\\ede6"; }

.bxs-home:before {
  content: "\\ede7"; }

.bxs-home-circle:before {
  content: "\\ede8"; }

.bxs-home-heart:before {
  content: "\\ede9"; }

.bxs-home-smile:before {
  content: "\\edea"; }

.bxs-hotel:before {
  content: "\\edeb"; }

.bxs-hourglass:before {
  content: "\\edec"; }

.bxs-hourglass-bottom:before {
  content: "\\eded"; }

.bxs-hourglass-top:before {
  content: "\\edee"; }

.bxs-id-card:before {
  content: "\\edef"; }

.bxs-image:before {
  content: "\\edf0"; }

.bxs-image-add:before {
  content: "\\edf1"; }

.bxs-image-alt:before {
  content: "\\edf2"; }

.bxs-inbox:before {
  content: "\\edf3"; }

.bxs-info-circle:before {
  content: "\\edf4"; }

.bxs-info-square:before {
  content: "\\edf5"; }

.bxs-institution:before {
  content: "\\edf6"; }

.bxs-joystick:before {
  content: "\\edf7"; }

.bxs-joystick-alt:before {
  content: "\\edf8"; }

.bxs-joystick-button:before {
  content: "\\edf9"; }

.bxs-key:before {
  content: "\\edfa"; }

.bxs-keyboard:before {
  content: "\\edfb"; }

.bxs-label:before {
  content: "\\edfc"; }

.bxs-landmark:before {
  content: "\\edfd"; }

.bxs-landscape:before {
  content: "\\edfe"; }

.bxs-laugh:before {
  content: "\\edff"; }

.bxs-layer:before {
  content: "\\ee00"; }

.bxs-layer-minus:before {
  content: "\\ee01"; }

.bxs-layer-plus:before {
  content: "\\ee02"; }

.bxs-layout:before {
  content: "\\ee03"; }

.bxs-left-arrow:before {
  content: "\\ee04"; }

.bxs-left-arrow-alt:before {
  content: "\\ee05"; }

.bxs-left-arrow-circle:before {
  content: "\\ee06"; }

.bxs-left-arrow-square:before {
  content: "\\ee07"; }

.bxs-left-down-arrow-circle:before {
  content: "\\ee08"; }

.bxs-left-top-arrow-circle:before {
  content: "\\ee09"; }

.bxs-like:before {
  content: "\\ee0a"; }

.bxs-location-plus:before {
  content: "\\ee0b"; }

.bxs-lock:before {
  content: "\\ee0c"; }

.bxs-lock-alt:before {
  content: "\\ee0d"; }

.bxs-lock-open:before {
  content: "\\ee0e"; }

.bxs-lock-open-alt:before {
  content: "\\ee0f"; }

.bxs-log-in:before {
  content: "\\ee10"; }

.bxs-log-in-circle:before {
  content: "\\ee11"; }

.bxs-log-out:before {
  content: "\\ee12"; }

.bxs-log-out-circle:before {
  content: "\\ee13"; }

.bxs-low-vision:before {
  content: "\\ee14"; }

.bxs-magic-wand:before {
  content: "\\ee15"; }

.bxs-magnet:before {
  content: "\\ee16"; }

.bxs-map:before {
  content: "\\ee17"; }

.bxs-map-alt:before {
  content: "\\ee18"; }

.bxs-map-pin:before {
  content: "\\ee19"; }

.bxs-mask:before {
  content: "\\ee1a"; }

.bxs-medal:before {
  content: "\\ee1b"; }

.bxs-megaphone:before {
  content: "\\ee1c"; }

.bxs-meh:before {
  content: "\\ee1d"; }

.bxs-meh-alt:before {
  content: "\\ee1e"; }

.bxs-meh-blank:before {
  content: "\\ee1f"; }

.bxs-memory-card:before {
  content: "\\ee20"; }

.bxs-message:before {
  content: "\\ee21"; }

.bxs-message-add:before {
  content: "\\ee22"; }

.bxs-message-alt:before {
  content: "\\ee23"; }

.bxs-message-alt-add:before {
  content: "\\ee24"; }

.bxs-message-alt-check:before {
  content: "\\ee25"; }

.bxs-message-alt-detail:before {
  content: "\\ee26"; }

.bxs-message-alt-dots:before {
  content: "\\ee27"; }

.bxs-message-alt-edit:before {
  content: "\\ee28"; }

.bxs-message-alt-error:before {
  content: "\\ee29"; }

.bxs-message-alt-minus:before {
  content: "\\ee2a"; }

.bxs-message-alt-x:before {
  content: "\\ee2b"; }

.bxs-message-check:before {
  content: "\\ee2c"; }

.bxs-message-detail:before {
  content: "\\ee2d"; }

.bxs-message-dots:before {
  content: "\\ee2e"; }

.bxs-message-edit:before {
  content: "\\ee2f"; }

.bxs-message-error:before {
  content: "\\ee30"; }

.bxs-message-minus:before {
  content: "\\ee31"; }

.bxs-message-rounded:before {
  content: "\\ee32"; }

.bxs-message-rounded-add:before {
  content: "\\ee33"; }

.bxs-message-rounded-check:before {
  content: "\\ee34"; }

.bxs-message-rounded-detail:before {
  content: "\\ee35"; }

.bxs-message-rounded-dots:before {
  content: "\\ee36"; }

.bxs-message-rounded-edit:before {
  content: "\\ee37"; }

.bxs-message-rounded-error:before {
  content: "\\ee38"; }

.bxs-message-rounded-minus:before {
  content: "\\ee39"; }

.bxs-message-rounded-x:before {
  content: "\\ee3a"; }

.bxs-message-square:before {
  content: "\\ee3b"; }

.bxs-message-square-add:before {
  content: "\\ee3c"; }

.bxs-message-square-check:before {
  content: "\\ee3d"; }

.bxs-message-square-detail:before {
  content: "\\ee3e"; }

.bxs-message-square-dots:before {
  content: "\\ee3f"; }

.bxs-message-square-edit:before {
  content: "\\ee40"; }

.bxs-message-square-error:before {
  content: "\\ee41"; }

.bxs-message-square-minus:before {
  content: "\\ee42"; }

.bxs-message-square-x:before {
  content: "\\ee43"; }

.bxs-message-x:before {
  content: "\\ee44"; }

.bxs-meteor:before {
  content: "\\ee45"; }

.bxs-microchip:before {
  content: "\\ee46"; }

.bxs-microphone:before {
  content: "\\ee47"; }

.bxs-microphone-alt:before {
  content: "\\ee48"; }

.bxs-microphone-off:before {
  content: "\\ee49"; }

.bxs-minus-circle:before {
  content: "\\ee4a"; }

.bxs-minus-square:before {
  content: "\\ee4b"; }

.bxs-mobile:before {
  content: "\\ee4c"; }

.bxs-mobile-vibration:before {
  content: "\\ee4d"; }

.bxs-moon:before {
  content: "\\ee4e"; }

.bxs-mouse:before {
  content: "\\ee4f"; }

.bxs-mouse-alt:before {
  content: "\\ee50"; }

.bxs-movie:before {
  content: "\\ee51"; }

.bxs-movie-play:before {
  content: "\\ee52"; }

.bxs-music:before {
  content: "\\ee53"; }

.bxs-navigation:before {
  content: "\\ee54"; }

.bxs-network-chart:before {
  content: "\\ee55"; }

.bxs-news:before {
  content: "\\ee56"; }

.bxs-no-entry:before {
  content: "\\ee57"; }

.bxs-note:before {
  content: "\\ee58"; }

.bxs-notepad:before {
  content: "\\ee59"; }

.bxs-notification:before {
  content: "\\ee5a"; }

.bxs-notification-off:before {
  content: "\\ee5b"; }

.bxs-offer:before {
  content: "\\ee5c"; }

.bxs-package:before {
  content: "\\ee5d"; }

.bxs-paint:before {
  content: "\\ee5e"; }

.bxs-paint-roll:before {
  content: "\\ee5f"; }

.bxs-palette:before {
  content: "\\ee60"; }

.bxs-paper-plane:before {
  content: "\\ee61"; }

.bxs-parking:before {
  content: "\\ee62"; }

.bxs-paste:before {
  content: "\\ee63"; }

.bxs-pen:before {
  content: "\\ee64"; }

.bxs-pencil:before {
  content: "\\ee65"; }

.bxs-phone:before {
  content: "\\ee66"; }

.bxs-phone-call:before {
  content: "\\ee67"; }

.bxs-phone-incoming:before {
  content: "\\ee68"; }

.bxs-phone-off:before {
  content: "\\ee69"; }

.bxs-phone-outgoing:before {
  content: "\\ee6a"; }

.bxs-photo-album:before {
  content: "\\ee6b"; }

.bxs-piano:before {
  content: "\\ee6c"; }

.bxs-pie-chart:before {
  content: "\\ee6d"; }

.bxs-pie-chart-alt:before {
  content: "\\ee6e"; }

.bxs-pie-chart-alt-2:before {
  content: "\\ee6f"; }

.bxs-pin:before {
  content: "\\ee70"; }

.bxs-pizza:before {
  content: "\\ee71"; }

.bxs-plane:before {
  content: "\\ee72"; }

.bxs-plane-alt:before {
  content: "\\ee73"; }

.bxs-plane-land:before {
  content: "\\ee74"; }

.bxs-planet:before {
  content: "\\ee75"; }

.bxs-plane-take-off:before {
  content: "\\ee76"; }

.bxs-playlist:before {
  content: "\\ee77"; }

.bxs-plug:before {
  content: "\\ee78"; }

.bxs-plus-circle:before {
  content: "\\ee79"; }

.bxs-plus-square:before {
  content: "\\ee7a"; }

.bxs-pointer:before {
  content: "\\ee7b"; }

.bxs-polygon:before {
  content: "\\ee7c"; }

.bxs-printer:before {
  content: "\\ee7d"; }

.bxs-purchase-tag:before {
  content: "\\ee7e"; }

.bxs-purchase-tag-alt:before {
  content: "\\ee7f"; }

.bxs-pyramid:before {
  content: "\\ee80"; }

.bxs-quote-alt-left:before {
  content: "\\ee81"; }

.bxs-quote-alt-right:before {
  content: "\\ee82"; }

.bxs-quote-left:before {
  content: "\\ee83"; }

.bxs-quote-right:before {
  content: "\\ee84"; }

.bxs-quote-single-left:before {
  content: "\\ee85"; }

.bxs-quote-single-right:before {
  content: "\\ee86"; }

.bxs-radiation:before {
  content: "\\ee87"; }

.bxs-radio:before {
  content: "\\ee88"; }

.bxs-receipt:before {
  content: "\\ee89"; }

.bxs-rectangle:before {
  content: "\\ee8a"; }

.bxs-registered:before {
  content: "\\ee8b"; }

.bxs-rename:before {
  content: "\\ee8c"; }

.bxs-report:before {
  content: "\\ee8d"; }

.bxs-rewind-circle:before {
  content: "\\ee8e"; }

.bxs-right-arrow:before {
  content: "\\ee8f"; }

.bxs-right-arrow-alt:before {
  content: "\\ee90"; }

.bxs-right-arrow-circle:before {
  content: "\\ee91"; }

.bxs-right-arrow-square:before {
  content: "\\ee92"; }

.bxs-right-down-arrow-circle:before {
  content: "\\ee93"; }

.bxs-right-top-arrow-circle:before {
  content: "\\ee94"; }

.bxs-rocket:before {
  content: "\\ee95"; }

.bxs-ruler:before {
  content: "\\ee96"; }

.bxs-sad:before {
  content: "\\ee97"; }

.bxs-save:before {
  content: "\\ee98"; }

.bxs-school:before {
  content: "\\ee99"; }

.bxs-search:before {
  content: "\\ee9a"; }

.bxs-search-alt-2:before {
  content: "\\ee9b"; }

.bxs-select-multiple:before {
  content: "\\ee9c"; }

.bxs-send:before {
  content: "\\ee9d"; }

.bxs-server:before {
  content: "\\ee9e"; }

.bxs-shapes:before {
  content: "\\ee9f"; }

.bxs-share:before {
  content: "\\eea0"; }

.bxs-share-alt:before {
  content: "\\eea1"; }

.bxs-shield:before {
  content: "\\eea2"; }

.bxs-shield-alt-2:before {
  content: "\\eea3"; }

.bxs-shield-x:before {
  content: "\\eea4"; }

.bxs-ship:before {
  content: "\\eea5"; }

.bxs-shocked:before {
  content: "\\eea6"; }

.bxs-shopping-bag:before {
  content: "\\eea7"; }

.bxs-shopping-bag-alt:before {
  content: "\\eea8"; }

.bxs-shopping-bags:before {
  content: "\\eea9"; }

.bxs-show:before {
  content: "\\eeaa"; }

.bxs-skip-next-circle:before {
  content: "\\eeab"; }

.bxs-skip-previous-circle:before {
  content: "\\eeac"; }

.bxs-skull:before {
  content: "\\eead"; }

.bxs-sleepy:before {
  content: "\\eeae"; }

.bxs-slideshow:before {
  content: "\\eeaf"; }

.bxs-smile:before {
  content: "\\eeb0"; }

.bxs-sort-alt:before {
  content: "\\eeb1"; }

.bxs-spa:before {
  content: "\\eeb2"; }

.bxs-speaker:before {
  content: "\\eeb3"; }

.bxs-spray-can:before {
  content: "\\eeb4"; }

.bxs-spreadsheet:before {
  content: "\\eeb5"; }

.bxs-square:before {
  content: "\\eeb6"; }

.bxs-square-rounded:before {
  content: "\\eeb7"; }

.bxs-star:before {
  content: "\\eeb8"; }

.bxs-star-half:before {
  content: "\\eeb9"; }

.bxs-sticker:before {
  content: "\\eeba"; }

.bxs-stopwatch:before {
  content: "\\eebb"; }

.bxs-store:before {
  content: "\\eebc"; }

.bxs-store-alt:before {
  content: "\\eebd"; }

.bxs-sun:before {
  content: "\\eebe"; }

.bxs-tachometer:before {
  content: "\\eebf"; }

.bxs-tag:before {
  content: "\\eec0"; }

.bxs-tag-alt:before {
  content: "\\eec1"; }

.bxs-tag-x:before {
  content: "\\eec2"; }

.bxs-taxi:before {
  content: "\\eec3"; }

.bxs-tennis-ball:before {
  content: "\\eec4"; }

.bxs-terminal:before {
  content: "\\eec5"; }

.bxs-thermometer:before {
  content: "\\eec6"; }

.bxs-time:before {
  content: "\\eec7"; }

.bxs-time-five:before {
  content: "\\eec8"; }

.bxs-timer:before {
  content: "\\eec9"; }

.bxs-tired:before {
  content: "\\eeca"; }

.bxs-toggle-left:before {
  content: "\\eecb"; }

.bxs-toggle-right:before {
  content: "\\eecc"; }

.bxs-tone:before {
  content: "\\eecd"; }

.bxs-torch:before {
  content: "\\eece"; }

.bxs-to-top:before {
  content: "\\eecf"; }

.bxs-traffic:before {
  content: "\\eed0"; }

.bxs-traffic-barrier:before {
  content: "\\eed1"; }

.bxs-traffic-cone:before {
  content: "\\eed2"; }

.bxs-train:before {
  content: "\\eed3"; }

.bxs-trash:before {
  content: "\\eed4"; }

.bxs-trash-alt:before {
  content: "\\eed5"; }

.bxs-tree:before {
  content: "\\eed6"; }

.bxs-trophy:before {
  content: "\\eed7"; }

.bxs-truck:before {
  content: "\\eed8"; }

.bxs-t-shirt:before {
  content: "\\eed9"; }

.bxs-tv:before {
  content: "\\eeda"; }

.bxs-up-arrow:before {
  content: "\\eedb"; }

.bxs-up-arrow-alt:before {
  content: "\\eedc"; }

.bxs-up-arrow-circle:before {
  content: "\\eedd"; }

.bxs-up-arrow-square:before {
  content: "\\eede"; }

.bxs-upside-down:before {
  content: "\\eedf"; }

.bxs-upvote:before {
  content: "\\eee0"; }

.bxs-user:before {
  content: "\\eee1"; }

.bxs-user-account:before {
  content: "\\eee2"; }

.bxs-user-badge:before {
  content: "\\eee3"; }

.bxs-user-check:before {
  content: "\\eee4"; }

.bxs-user-circle:before {
  content: "\\eee5"; }

.bxs-user-detail:before {
  content: "\\eee6"; }

.bxs-user-minus:before {
  content: "\\eee7"; }

.bxs-user-pin:before {
  content: "\\eee8"; }

.bxs-user-plus:before {
  content: "\\eee9"; }

.bxs-user-rectangle:before {
  content: "\\eeea"; }

.bxs-user-voice:before {
  content: "\\eeeb"; }

.bxs-user-x:before {
  content: "\\eeec"; }

.bxs-vector:before {
  content: "\\eeed"; }

.bxs-vial:before {
  content: "\\eeee"; }

.bxs-video:before {
  content: "\\eeef"; }

.bxs-video-off:before {
  content: "\\eef0"; }

.bxs-video-plus:before {
  content: "\\eef1"; }

.bxs-video-recording:before {
  content: "\\eef2"; }

.bxs-videos:before {
  content: "\\eef3"; }

.bxs-virus:before {
  content: "\\eef4"; }

.bxs-virus-block:before {
  content: "\\eef5"; }

.bxs-volume:before {
  content: "\\eef6"; }

.bxs-volume-full:before {
  content: "\\eef7"; }

.bxs-volume-low:before {
  content: "\\eef8"; }

.bxs-volume-mute:before {
  content: "\\eef9"; }

.bxs-wallet:before {
  content: "\\eefa"; }

.bxs-wallet-alt:before {
  content: "\\eefb"; }

.bxs-washer:before {
  content: "\\eefc"; }

.bxs-watch:before {
  content: "\\eefd"; }

.bxs-watch-alt:before {
  content: "\\eefe"; }

.bxs-webcam:before {
  content: "\\eeff"; }

.bxs-widget:before {
  content: "\\ef00"; }

.bxs-window-alt:before {
  content: "\\ef01"; }

.bxs-wine:before {
  content: "\\ef02"; }

.bxs-wink-smile:before {
  content: "\\ef03"; }

.bxs-wink-tongue:before {
  content: "\\ef04"; }

.bxs-wrench:before {
  content: "\\ef05"; }

.bxs-x-circle:before {
  content: "\\ef06"; }

.bxs-x-square:before {
  content: "\\ef07"; }

.bxs-yin-yang:before {
  content: "\\ef08"; }

.bxs-zap:before {
  content: "\\ef09"; }

.bxs-zoom-in:before {
  content: "\\ef0a"; }

.bxs-zoom-out:before {
  content: "\\ef0b"; }

.la,
.las,
.lar,
.lal,
.lad,
.lab {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1; }

.la-lg {
  font-size: 1.33333em;
  line-height: 0.75em;
  vertical-align: -.0667em; }

.la-xs {
  font-size: .75em; }

.la-sm {
  font-size: .875em; }

.la-1x {
  font-size: 1em; }

.la-2x {
  font-size: 2em; }

.la-3x {
  font-size: 3em; }

.la-4x {
  font-size: 4em; }

.la-5x {
  font-size: 5em; }

.la-6x {
  font-size: 6em; }

.la-7x {
  font-size: 7em; }

.la-8x {
  font-size: 8em; }

.la-9x {
  font-size: 9em; }

.la-10x {
  font-size: 10em; }

.la-fw {
  text-align: center;
  width: 1.25em; }

.la-ul {
  list-style-type: none;
  margin-left: 2.5em;
  padding-left: 0; }

.la-ul > li {
  position: relative; }

.la-li {
  left: -2em;
  position: absolute;
  text-align: center;
  width: 2em;
  line-height: inherit; }

.la-border {
  border: solid 0.08em #eee;
  border-radius: .1em;
  padding: .2em .25em .15em; }

.la-pull-left {
  float: left; }

.la-pull-right {
  float: right; }

.la.la-pull-left,
.las.la-pull-left,
.lar.la-pull-left,
.lal.la-pull-left,
.lab.la-pull-left {
  margin-right: .3em; }

.la.la-pull-right,
.las.la-pull-right,
.lar.la-pull-right,
.lal.la-pull-right,
.lab.la-pull-right {
  margin-left: .3em; }

.la-spin {
  animation: la-spin 2s infinite linear; }

.la-pulse {
  animation: la-spin 1s infinite steps(8); }

@keyframes la-spin {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

.la-rotate-90 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
  transform: rotate(90deg); }

.la-rotate-180 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
  transform: rotate(180deg); }

.la-rotate-270 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
  transform: rotate(270deg); }

.la-flip-horizontal {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
  transform: scale(-1, 1); }

.la-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(1, -1); }

.la-flip-both, .la-flip-horizontal.la-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(-1, -1); }

:root .la-rotate-90,
:root .la-rotate-180,
:root .la-rotate-270,
:root .la-flip-horizontal,
:root .la-flip-vertical,
:root .la-flip-both {
  filter: none; }

.la-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em; }

.la-stack-1x,
.la-stack-2x {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%; }

.la-stack-1x {
  line-height: inherit; }

.la-stack-2x {
  font-size: 2em; }

.la-inverse {
  color: #fff; }

/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
readers do not read off random characters that represent icons */
.la-500px:before {
  content: "\\f26e"; }

.la-accessible-icon:before {
  content: "\\f368"; }

.la-accusoft:before {
  content: "\\f369"; }

.la-acquisitions-incorporated:before {
  content: "\\f6af"; }

.la-ad:before {
  content: "\\f641"; }

.la-address-book:before {
  content: "\\f2b9"; }

.la-address-card:before {
  content: "\\f2bb"; }

.la-adjust:before {
  content: "\\f042"; }

.la-adn:before {
  content: "\\f170"; }

.la-adobe:before {
  content: "\\f778"; }

.la-adversal:before {
  content: "\\f36a"; }

.la-affiliatetheme:before {
  content: "\\f36b"; }

.la-air-freshener:before {
  content: "\\f5d0"; }

.la-airbnb:before {
  content: "\\f834"; }

.la-algolia:before {
  content: "\\f36c"; }

.la-align-center:before {
  content: "\\f037"; }

.la-align-justify:before {
  content: "\\f039"; }

.la-align-left:before {
  content: "\\f036"; }

.la-align-right:before {
  content: "\\f038"; }

.la-alipay:before {
  content: "\\f642"; }

.la-allergies:before {
  content: "\\f461"; }

.la-amazon:before {
  content: "\\f270"; }

.la-amazon-pay:before {
  content: "\\f42c"; }

.la-ambulance:before {
  content: "\\f0f9"; }

.la-american-sign-language-interpreting:before {
  content: "\\f2a3"; }

.la-amilia:before {
  content: "\\f36d"; }

.la-anchor:before {
  content: "\\f13d"; }

.la-android:before {
  content: "\\f17b"; }

.la-angellist:before {
  content: "\\f209"; }

.la-angle-double-down:before {
  content: "\\f103"; }

.la-angle-double-left:before {
  content: "\\f100"; }

.la-angle-double-right:before {
  content: "\\f101"; }

.la-angle-double-up:before {
  content: "\\f102"; }

.la-angle-down:before {
  content: "\\f107"; }

.la-angle-left:before {
  content: "\\f104"; }

.la-angle-right:before {
  content: "\\f105"; }

.la-angle-up:before {
  content: "\\f106"; }

.la-angry:before {
  content: "\\f556"; }

.la-angrycreative:before {
  content: "\\f36e"; }

.la-angular:before {
  content: "\\f420"; }

.la-ankh:before {
  content: "\\f644"; }

.la-app-store:before {
  content: "\\f36f"; }

.la-app-store-ios:before {
  content: "\\f370"; }

.la-apper:before {
  content: "\\f371"; }

.la-apple:before {
  content: "\\f179"; }

.la-apple-alt:before {
  content: "\\f5d1"; }

.la-apple-pay:before {
  content: "\\f415"; }

.la-archive:before {
  content: "\\f187"; }

.la-archway:before {
  content: "\\f557"; }

.la-arrow-alt-circle-down:before {
  content: "\\f358"; }

.la-arrow-alt-circle-left:before {
  content: "\\f359"; }

.la-arrow-alt-circle-right:before {
  content: "\\f35a"; }

.la-arrow-alt-circle-up:before {
  content: "\\f35b"; }

.la-arrow-circle-down:before {
  content: "\\f0ab"; }

.la-arrow-circle-left:before {
  content: "\\f0a8"; }

.la-arrow-circle-right:before {
  content: "\\f0a9"; }

.la-arrow-circle-up:before {
  content: "\\f0aa"; }

.la-arrow-down:before {
  content: "\\f063"; }

.la-arrow-left:before {
  content: "\\f060"; }

.la-arrow-right:before {
  content: "\\f061"; }

.la-arrow-up:before {
  content: "\\f062"; }

.la-arrows-alt:before {
  content: "\\f0b2"; }

.la-arrows-alt-h:before {
  content: "\\f337"; }

.la-arrows-alt-v:before {
  content: "\\f338"; }

.la-artstation:before {
  content: "\\f77a"; }

.la-assistive-listening-systems:before {
  content: "\\f2a2"; }

.la-asterisk:before {
  content: "\\f069"; }

.la-asymmetrik:before {
  content: "\\f372"; }

.la-at:before {
  content: "\\f1fa"; }

.la-atlas:before {
  content: "\\f558"; }

.la-atlassian:before {
  content: "\\f77b"; }

.la-atom:before {
  content: "\\f5d2"; }

.la-audible:before {
  content: "\\f373"; }

.la-audio-description:before {
  content: "\\f29e"; }

.la-autoprefixer:before {
  content: "\\f41c"; }

.la-avianex:before {
  content: "\\f374"; }

.la-aviato:before {
  content: "\\f421"; }

.la-award:before {
  content: "\\f559"; }

.la-aws:before {
  content: "\\f375"; }

.la-baby:before {
  content: "\\f77c"; }

.la-baby-carriage:before {
  content: "\\f77d"; }

.la-backspace:before {
  content: "\\f55a"; }

.la-backward:before {
  content: "\\f04a"; }

.la-bacon:before {
  content: "\\f7e5"; }

.la-balance-scale:before {
  content: "\\f24e"; }

.la-balance-scale-left:before {
  content: "\\f515"; }

.la-balance-scale-right:before {
  content: "\\f516"; }

.la-ban:before {
  content: "\\f05e"; }

.la-band-aid:before {
  content: "\\f462"; }

.la-bandcamp:before {
  content: "\\f2d5"; }

.la-barcode:before {
  content: "\\f02a"; }

.la-bars:before {
  content: "\\f0c9"; }

.la-baseball-ball:before {
  content: "\\f433"; }

.la-basketball-ball:before {
  content: "\\f434"; }

.la-bath:before {
  content: "\\f2cd"; }

.la-battery-empty:before {
  content: "\\f244"; }

.la-battery-full:before {
  content: "\\f240"; }

.la-battery-half:before {
  content: "\\f242"; }

.la-battery-quarter:before {
  content: "\\f243"; }

.la-battery-three-quarters:before {
  content: "\\f241"; }

.la-battle-net:before {
  content: "\\f835"; }

.la-bed:before {
  content: "\\f236"; }

.la-beer:before {
  content: "\\f0fc"; }

.la-behance:before {
  content: "\\f1b4"; }

.la-behance-square:before {
  content: "\\f1b5"; }

.la-bell:before {
  content: "\\f0f3"; }

.la-bell-slash:before {
  content: "\\f1f6"; }

.la-bezier-curve:before {
  content: "\\f55b"; }

.la-bible:before {
  content: "\\f647"; }

.la-bicycle:before {
  content: "\\f206"; }

.la-biking:before {
  content: "\\f84a"; }

.la-bimobject:before {
  content: "\\f378"; }

.la-binoculars:before {
  content: "\\f1e5"; }

.la-biohazard:before {
  content: "\\f780"; }

.la-birthday-cake:before {
  content: "\\f1fd"; }

.la-bitbucket:before {
  content: "\\f171"; }

.la-bitcoin:before {
  content: "\\f379"; }

.la-bity:before {
  content: "\\f37a"; }

.la-black-tie:before {
  content: "\\f27e"; }

.la-blackberry:before {
  content: "\\f37b"; }

.la-blender:before {
  content: "\\f517"; }

.la-blender-phone:before {
  content: "\\f6b6"; }

.la-blind:before {
  content: "\\f29d"; }

.la-blog:before {
  content: "\\f781"; }

.la-blogger:before {
  content: "\\f37c"; }

.la-blogger-b:before {
  content: "\\f37d"; }

.la-bluetooth:before {
  content: "\\f293"; }

.la-bluetooth-b:before {
  content: "\\f294"; }

.la-bold:before {
  content: "\\f032"; }

.la-bolt:before {
  content: "\\f0e7"; }

.la-bomb:before {
  content: "\\f1e2"; }

.la-bone:before {
  content: "\\f5d7"; }

.la-bong:before {
  content: "\\f55c"; }

.la-book:before {
  content: "\\f02d"; }

.la-book-dead:before {
  content: "\\f6b7"; }

.la-book-medical:before {
  content: "\\f7e6"; }

.la-book-open:before {
  content: "\\f518"; }

.la-book-reader:before {
  content: "\\f5da"; }

.la-bookmark:before {
  content: "\\f02e"; }

.la-bootstrap:before {
  content: "\\f836"; }

.la-border-all:before {
  content: "\\f84c"; }

.la-border-none:before {
  content: "\\f850"; }

.la-border-style:before {
  content: "\\f853"; }

.la-bowling-ball:before {
  content: "\\f436"; }

.la-box:before {
  content: "\\f466"; }

.la-box-open:before {
  content: "\\f49e"; }

.la-boxes:before {
  content: "\\f468"; }

.la-braille:before {
  content: "\\f2a1"; }

.la-brain:before {
  content: "\\f5dc"; }

.la-bread-slice:before {
  content: "\\f7ec"; }

.la-briefcase:before {
  content: "\\f0b1"; }

.la-briefcase-medical:before {
  content: "\\f469"; }

.la-broadcast-tower:before {
  content: "\\f519"; }

.la-broom:before {
  content: "\\f51a"; }

.la-brush:before {
  content: "\\f55d"; }

.la-btc:before {
  content: "\\f15a"; }

.la-buffer:before {
  content: "\\f837"; }

.la-bug:before {
  content: "\\f188"; }

.la-building:before {
  content: "\\f1ad"; }

.la-bullhorn:before {
  content: "\\f0a1"; }

.la-bullseye:before {
  content: "\\f140"; }

.la-burn:before {
  content: "\\f46a"; }

.la-buromobelexperte:before {
  content: "\\f37f"; }

.la-bus:before {
  content: "\\f207"; }

.la-bus-alt:before {
  content: "\\f55e"; }

.la-business-time:before {
  content: "\\f64a"; }

.la-buy-n-large:before {
  content: "\\f8a6"; }

.la-buysellads:before {
  content: "\\f20d"; }

.la-calculator:before {
  content: "\\f1ec"; }

.la-calendar:before {
  content: "\\f133"; }

.la-calendar-alt:before {
  content: "\\f073"; }

.la-calendar-check:before {
  content: "\\f274"; }

.la-calendar-day:before {
  content: "\\f783"; }

.la-calendar-minus:before {
  content: "\\f272"; }

.la-calendar-plus:before {
  content: "\\f271"; }

.la-calendar-times:before {
  content: "\\f273"; }

.la-calendar-week:before {
  content: "\\f784"; }

.la-camera:before {
  content: "\\f030"; }

.la-camera-retro:before {
  content: "\\f083"; }

.la-campground:before {
  content: "\\f6bb"; }

.la-canadian-maple-leaf:before {
  content: "\\f785"; }

.la-candy-cane:before {
  content: "\\f786"; }

.la-cannabis:before {
  content: "\\f55f"; }

.la-capsules:before {
  content: "\\f46b"; }

.la-car:before {
  content: "\\f1b9"; }

.la-car-alt:before {
  content: "\\f5de"; }

.la-car-battery:before {
  content: "\\f5df"; }

.la-car-crash:before {
  content: "\\f5e1"; }

.la-car-side:before {
  content: "\\f5e4"; }

.la-caret-down:before {
  content: "\\f0d7"; }

.la-caret-left:before {
  content: "\\f0d9"; }

.la-caret-right:before {
  content: "\\f0da"; }

.la-caret-square-down:before {
  content: "\\f150"; }

.la-caret-square-left:before {
  content: "\\f191"; }

.la-caret-square-right:before {
  content: "\\f152"; }

.la-caret-square-up:before {
  content: "\\f151"; }

.la-caret-up:before {
  content: "\\f0d8"; }

.la-carrot:before {
  content: "\\f787"; }

.la-cart-arrow-down:before {
  content: "\\f218"; }

.la-cart-plus:before {
  content: "\\f217"; }

.la-cash-register:before {
  content: "\\f788"; }

.la-cat:before {
  content: "\\f6be"; }

.la-cc-amazon-pay:before {
  content: "\\f42d"; }

.la-cc-amex:before {
  content: "\\f1f3"; }

.la-cc-apple-pay:before {
  content: "\\f416"; }

.la-cc-diners-club:before {
  content: "\\f24c"; }

.la-cc-discover:before {
  content: "\\f1f2"; }

.la-cc-jcb:before {
  content: "\\f24b"; }

.la-cc-mastercard:before {
  content: "\\f1f1"; }

.la-cc-paypal:before {
  content: "\\f1f4"; }

.la-cc-stripe:before {
  content: "\\f1f5"; }

.la-cc-visa:before {
  content: "\\f1f0"; }

.la-centercode:before {
  content: "\\f380"; }

.la-centos:before {
  content: "\\f789"; }

.la-certificate:before {
  content: "\\f0a3"; }

.la-chair:before {
  content: "\\f6c0"; }

.la-chalkboard:before {
  content: "\\f51b"; }

.la-chalkboard-teacher:before {
  content: "\\f51c"; }

.la-charging-station:before {
  content: "\\f5e7"; }

.la-chart-area:before {
  content: "\\f1fe"; }

.la-chart-bar:before {
  content: "\\f080"; }

.la-chart-line:before {
  content: "\\f201"; }

.la-chart-pie:before {
  content: "\\f200"; }

.la-check:before {
  content: "\\f00c"; }

.la-check-circle:before {
  content: "\\f058"; }

.la-check-double:before {
  content: "\\f560"; }

.la-check-square:before {
  content: "\\f14a"; }

.la-cheese:before {
  content: "\\f7ef"; }

.la-chess:before {
  content: "\\f439"; }

.la-chess-bishop:before {
  content: "\\f43a"; }

.la-chess-board:before {
  content: "\\f43c"; }

.la-chess-king:before {
  content: "\\f43f"; }

.la-chess-knight:before {
  content: "\\f441"; }

.la-chess-pawn:before {
  content: "\\f443"; }

.la-chess-queen:before {
  content: "\\f445"; }

.la-chess-rook:before {
  content: "\\f447"; }

.la-chevron-circle-down:before {
  content: "\\f13a"; }

.la-chevron-circle-left:before {
  content: "\\f137"; }

.la-chevron-circle-right:before {
  content: "\\f138"; }

.la-chevron-circle-up:before {
  content: "\\f139"; }

.la-chevron-down:before {
  content: "\\f078"; }

.la-chevron-left:before {
  content: "\\f053"; }

.la-chevron-right:before {
  content: "\\f054"; }

.la-chevron-up:before {
  content: "\\f077"; }

.la-child:before {
  content: "\\f1ae"; }

.la-chrome:before {
  content: "\\f268"; }

.la-chromecast:before {
  content: "\\f838"; }

.la-church:before {
  content: "\\f51d"; }

.la-circle:before {
  content: "\\f111"; }

.la-circle-notch:before {
  content: "\\f1ce"; }

.la-city:before {
  content: "\\f64f"; }

.la-clinic-medical:before {
  content: "\\f7f2"; }

.la-clipboard:before {
  content: "\\f328"; }

.la-clipboard-check:before {
  content: "\\f46c"; }

.la-clipboard-list:before {
  content: "\\f46d"; }

.la-clock:before {
  content: "\\f017"; }

.la-clone:before {
  content: "\\f24d"; }

.la-closed-captioning:before {
  content: "\\f20a"; }

.la-cloud:before {
  content: "\\f0c2"; }

.la-cloud-download-alt:before {
  content: "\\f381"; }

.la-cloud-meatball:before {
  content: "\\f73b"; }

.la-cloud-moon:before {
  content: "\\f6c3"; }

.la-cloud-moon-rain:before {
  content: "\\f73c"; }

.la-cloud-rain:before {
  content: "\\f73d"; }

.la-cloud-showers-heavy:before {
  content: "\\f740"; }

.la-cloud-sun:before {
  content: "\\f6c4"; }

.la-cloud-sun-rain:before {
  content: "\\f743"; }

.la-cloud-upload-alt:before {
  content: "\\f382"; }

.la-cloudscale:before {
  content: "\\f383"; }

.la-cloudsmith:before {
  content: "\\f384"; }

.la-cloudversify:before {
  content: "\\f385"; }

.la-cocktail:before {
  content: "\\f561"; }

.la-code:before {
  content: "\\f121"; }

.la-code-branch:before {
  content: "\\f126"; }

.la-codepen:before {
  content: "\\f1cb"; }

.la-codiepie:before {
  content: "\\f284"; }

.la-coffee:before {
  content: "\\f0f4"; }

.la-cog:before {
  content: "\\f013"; }

.la-cogs:before {
  content: "\\f085"; }

.la-coins:before {
  content: "\\f51e"; }

.la-columns:before {
  content: "\\f0db"; }

.la-comment:before {
  content: "\\f075"; }

.la-comment-alt:before {
  content: "\\f27a"; }

.la-comment-dollar:before {
  content: "\\f651"; }

.la-comment-dots:before {
  content: "\\f4ad"; }

.la-comment-medical:before {
  content: "\\f7f5"; }

.la-comment-slash:before {
  content: "\\f4b3"; }

.la-comments:before {
  content: "\\f086"; }

.la-comments-dollar:before {
  content: "\\f653"; }

.la-compact-disc:before {
  content: "\\f51f"; }

.la-compass:before {
  content: "\\f14e"; }

.la-compress:before {
  content: "\\f066"; }

.la-compress-arrows-alt:before {
  content: "\\f78c"; }

.la-concierge-bell:before {
  content: "\\f562"; }

.la-confluence:before {
  content: "\\f78d"; }

.la-connectdevelop:before {
  content: "\\f20e"; }

.la-contao:before {
  content: "\\f26d"; }

.la-cookie:before {
  content: "\\f563"; }

.la-cookie-bite:before {
  content: "\\f564"; }

.la-copy:before {
  content: "\\f0c5"; }

.la-copyright:before {
  content: "\\f1f9"; }

.la-cotton-bureau:before {
  content: "\\f89e"; }

.la-couch:before {
  content: "\\f4b8"; }

.la-cpanel:before {
  content: "\\f388"; }

.la-creative-commons:before {
  content: "\\f25e"; }

.la-creative-commons-by:before {
  content: "\\f4e7"; }

.la-creative-commons-nc:before {
  content: "\\f4e8"; }

.la-creative-commons-nc-eu:before {
  content: "\\f4e9"; }

.la-creative-commons-nc-jp:before {
  content: "\\f4ea"; }

.la-creative-commons-nd:before {
  content: "\\f4eb"; }

.la-creative-commons-pd:before {
  content: "\\f4ec"; }

.la-creative-commons-pd-alt:before {
  content: "\\f4ed"; }

.la-creative-commons-remix:before {
  content: "\\f4ee"; }

.la-creative-commons-sa:before {
  content: "\\f4ef"; }

.la-creative-commons-sampling:before {
  content: "\\f4f0"; }

.la-creative-commons-sampling-plus:before {
  content: "\\f4f1"; }

.la-creative-commons-share:before {
  content: "\\f4f2"; }

.la-creative-commons-zero:before {
  content: "\\f4f3"; }

.la-credit-card:before {
  content: "\\f09d"; }

.la-critical-role:before {
  content: "\\f6c9"; }

.la-crop:before {
  content: "\\f125"; }

.la-crop-alt:before {
  content: "\\f565"; }

.la-cross:before {
  content: "\\f654"; }

.la-crosshairs:before {
  content: "\\f05b"; }

.la-crow:before {
  content: "\\f520"; }

.la-crown:before {
  content: "\\f521"; }

.la-crutch:before {
  content: "\\f7f7"; }

.la-css3:before {
  content: "\\f13c"; }

.la-css3-alt:before {
  content: "\\f38b"; }

.la-cube:before {
  content: "\\f1b2"; }

.la-cubes:before {
  content: "\\f1b3"; }

.la-cut:before {
  content: "\\f0c4"; }

.la-cuttlefish:before {
  content: "\\f38c"; }

.la-d-and-d:before {
  content: "\\f38d"; }

.la-d-and-d-beyond:before {
  content: "\\f6ca"; }

.la-dashcube:before {
  content: "\\f210"; }

.la-database:before {
  content: "\\f1c0"; }

.la-deaf:before {
  content: "\\f2a4"; }

.la-delicious:before {
  content: "\\f1a5"; }

.la-democrat:before {
  content: "\\f747"; }

.la-deploydog:before {
  content: "\\f38e"; }

.la-deskpro:before {
  content: "\\f38f"; }

.la-desktop:before {
  content: "\\f108"; }

.la-dev:before {
  content: "\\f6cc"; }

.la-deviantart:before {
  content: "\\f1bd"; }

.la-dharmachakra:before {
  content: "\\f655"; }

.la-dhl:before {
  content: "\\f790"; }

.la-diagnoses:before {
  content: "\\f470"; }

.la-diaspora:before {
  content: "\\f791"; }

.la-dice:before {
  content: "\\f522"; }

.la-dice-d20:before {
  content: "\\f6cf"; }

.la-dice-d6:before {
  content: "\\f6d1"; }

.la-dice-five:before {
  content: "\\f523"; }

.la-dice-four:before {
  content: "\\f524"; }

.la-dice-one:before {
  content: "\\f525"; }

.la-dice-six:before {
  content: "\\f526"; }

.la-dice-three:before {
  content: "\\f527"; }

.la-dice-two:before {
  content: "\\f528"; }

.la-digg:before {
  content: "\\f1a6"; }

.la-digital-ocean:before {
  content: "\\f391"; }

.la-digital-tachograph:before {
  content: "\\f566"; }

.la-directions:before {
  content: "\\f5eb"; }

.la-discord:before {
  content: "\\f392"; }

.la-discourse:before {
  content: "\\f393"; }

.la-divide:before {
  content: "\\f529"; }

.la-dizzy:before {
  content: "\\f567"; }

.la-dna:before {
  content: "\\f471"; }

.la-dochub:before {
  content: "\\f394"; }

.la-docker:before {
  content: "\\f395"; }

.la-dog:before {
  content: "\\f6d3"; }

.la-dollar-sign:before {
  content: "\\f155"; }

.la-dolly:before {
  content: "\\f472"; }

.la-dolly-flatbed:before {
  content: "\\f474"; }

.la-donate:before {
  content: "\\f4b9"; }

.la-door-closed:before {
  content: "\\f52a"; }

.la-door-open:before {
  content: "\\f52b"; }

.la-dot-circle:before {
  content: "\\f192"; }

.la-dove:before {
  content: "\\f4ba"; }

.la-download:before {
  content: "\\f019"; }

.la-draft2digital:before {
  content: "\\f396"; }

.la-drafting-compass:before {
  content: "\\f568"; }

.la-dragon:before {
  content: "\\f6d5"; }

.la-draw-polygon:before {
  content: "\\f5ee"; }

.la-dribbble:before {
  content: "\\f17d"; }

.la-dribbble-square:before {
  content: "\\f397"; }

.la-dropbox:before {
  content: "\\f16b"; }

.la-drum:before {
  content: "\\f569"; }

.la-drum-steelpan:before {
  content: "\\f56a"; }

.la-drumstick-bite:before {
  content: "\\f6d7"; }

.la-drupal:before {
  content: "\\f1a9"; }

.la-dumbbell:before {
  content: "\\f44b"; }

.la-dumpster:before {
  content: "\\f793"; }

.la-dumpster-fire:before {
  content: "\\f794"; }

.la-dungeon:before {
  content: "\\f6d9"; }

.la-dyalog:before {
  content: "\\f399"; }

.la-earlybirds:before {
  content: "\\f39a"; }

.la-ebay:before {
  content: "\\f4f4"; }

.la-edge:before {
  content: "\\f282"; }

.la-edit:before {
  content: "\\f044"; }

.la-egg:before {
  content: "\\f7fb"; }

.la-eject:before {
  content: "\\f052"; }

.la-elementor:before {
  content: "\\f430"; }

.la-ellipsis-h:before {
  content: "\\f141"; }

.la-ellipsis-v:before {
  content: "\\f142"; }

.la-ello:before {
  content: "\\f5f1"; }

.la-ember:before {
  content: "\\f423"; }

.la-empire:before {
  content: "\\f1d1"; }

.la-envelope:before {
  content: "\\f0e0"; }

.la-envelope-open:before {
  content: "\\f2b6"; }

.la-envelope-open-text:before {
  content: "\\f658"; }

.la-envelope-square:before {
  content: "\\f199"; }

.la-envira:before {
  content: "\\f299"; }

.la-equals:before {
  content: "\\f52c"; }

.la-eraser:before {
  content: "\\f12d"; }

.la-erlang:before {
  content: "\\f39d"; }

.la-ethereum:before {
  content: "\\f42e"; }

.la-ethernet:before {
  content: "\\f796"; }

.la-etsy:before {
  content: "\\f2d7"; }

.la-euro-sign:before {
  content: "\\f153"; }

.la-evernote:before {
  content: "\\f839"; }

.la-exchange-alt:before {
  content: "\\f362"; }

.la-exclamation:before {
  content: "\\f12a"; }

.la-exclamation-circle:before {
  content: "\\f06a"; }

.la-exclamation-triangle:before {
  content: "\\f071"; }

.la-expand:before {
  content: "\\f065"; }

.la-expand-arrows-alt:before {
  content: "\\f31e"; }

.la-expeditedssl:before {
  content: "\\f23e"; }

.la-external-link-alt:before {
  content: "\\f35d"; }

.la-external-link-square-alt:before {
  content: "\\f360"; }

.la-eye:before {
  content: "\\f06e"; }

.la-eye-dropper:before {
  content: "\\f1fb"; }

.la-eye-slash:before {
  content: "\\f070"; }

.la-facebook:before {
  content: "\\f09a"; }

.la-facebook-f:before {
  content: "\\f39e"; }

.la-facebook-messenger:before {
  content: "\\f39f"; }

.la-facebook-square:before {
  content: "\\f082"; }

.la-fan:before {
  content: "\\f863"; }

.la-fantasy-flight-games:before {
  content: "\\f6dc"; }

.la-fast-backward:before {
  content: "\\f049"; }

.la-fast-forward:before {
  content: "\\f050"; }

.la-fax:before {
  content: "\\f1ac"; }

.la-feather:before {
  content: "\\f52d"; }

.la-feather-alt:before {
  content: "\\f56b"; }

.la-fedex:before {
  content: "\\f797"; }

.la-fedora:before {
  content: "\\f798"; }

.la-female:before {
  content: "\\f182"; }

.la-fighter-jet:before {
  content: "\\f0fb"; }

.la-figma:before {
  content: "\\f799"; }

.la-file:before {
  content: "\\f15b"; }

.la-file-alt:before {
  content: "\\f15c"; }

.la-file-archive:before {
  content: "\\f1c6"; }

.la-file-audio:before {
  content: "\\f1c7"; }

.la-file-code:before {
  content: "\\f1c9"; }

.la-file-contract:before {
  content: "\\f56c"; }

.la-file-csv:before {
  content: "\\f6dd"; }

.la-file-download:before {
  content: "\\f56d"; }

.la-file-excel:before {
  content: "\\f1c3"; }

.la-file-export:before {
  content: "\\f56e"; }

.la-file-image:before {
  content: "\\f1c5"; }

.la-file-import:before {
  content: "\\f56f"; }

.la-file-invoice:before {
  content: "\\f570"; }

.la-file-invoice-dollar:before {
  content: "\\f571"; }

.la-file-medical:before {
  content: "\\f477"; }

.la-file-medical-alt:before {
  content: "\\f478"; }

.la-file-pdf:before {
  content: "\\f1c1"; }

.la-file-powerpoint:before {
  content: "\\f1c4"; }

.la-file-prescription:before {
  content: "\\f572"; }

.la-file-signature:before {
  content: "\\f573"; }

.la-file-upload:before {
  content: "\\f574"; }

.la-file-video:before {
  content: "\\f1c8"; }

.la-file-word:before {
  content: "\\f1c2"; }

.la-fill:before {
  content: "\\f575"; }

.la-fill-drip:before {
  content: "\\f576"; }

.la-film:before {
  content: "\\f008"; }

.la-filter:before {
  content: "\\f0b0"; }

.la-fingerprint:before {
  content: "\\f577"; }

.la-fire:before {
  content: "\\f06d"; }

.la-fire-alt:before {
  content: "\\f7e4"; }

.la-fire-extinguisher:before {
  content: "\\f134"; }

.la-firefox:before {
  content: "\\f269"; }

.la-first-aid:before {
  content: "\\f479"; }

.la-first-order:before {
  content: "\\f2b0"; }

.la-first-order-alt:before {
  content: "\\f50a"; }

.la-firstdraft:before {
  content: "\\f3a1"; }

.la-fish:before {
  content: "\\f578"; }

.la-fist-raised:before {
  content: "\\f6de"; }

.la-flag:before {
  content: "\\f024"; }

.la-flag-checkered:before {
  content: "\\f11e"; }

.la-flag-usa:before {
  content: "\\f74d"; }

.la-flask:before {
  content: "\\f0c3"; }

.la-flickr:before {
  content: "\\f16e"; }

.la-flipboard:before {
  content: "\\f44d"; }

.la-flushed:before {
  content: "\\f579"; }

.la-fly:before {
  content: "\\f417"; }

.la-folder:before {
  content: "\\f07b"; }

.la-folder-minus:before {
  content: "\\f65d"; }

.la-folder-open:before {
  content: "\\f07c"; }

.la-folder-plus:before {
  content: "\\f65e"; }

.la-font:before {
  content: "\\f031"; }

.la-font-awesome:before {
  content: "\\f2b4"; }

.la-font-awesome-alt:before {
  content: "\\f35c"; }

.la-font-awesome-flag:before {
  content: "\\f425"; }

.la-font-awesome-logo-full:before {
  content: "\\f4e6"; }

.la-fonticons:before {
  content: "\\f280"; }

.la-fonticons-fi:before {
  content: "\\f3a2"; }

.la-football-ball:before {
  content: "\\f44e"; }

.la-fort-awesome:before {
  content: "\\f286"; }

.la-fort-awesome-alt:before {
  content: "\\f3a3"; }

.la-forumbee:before {
  content: "\\f211"; }

.la-forward:before {
  content: "\\f04e"; }

.la-foursquare:before {
  content: "\\f180"; }

.la-free-code-camp:before {
  content: "\\f2c5"; }

.la-freebsd:before {
  content: "\\f3a4"; }

.la-frog:before {
  content: "\\f52e"; }

.la-frown:before {
  content: "\\f119"; }

.la-frown-open:before {
  content: "\\f57a"; }

.la-fulcrum:before {
  content: "\\f50b"; }

.la-funnel-dollar:before {
  content: "\\f662"; }

.la-futbol:before {
  content: "\\f1e3"; }

.la-galactic-republic:before {
  content: "\\f50c"; }

.la-galactic-senate:before {
  content: "\\f50d"; }

.la-gamepad:before {
  content: "\\f11b"; }

.la-gas-pump:before {
  content: "\\f52f"; }

.la-gavel:before {
  content: "\\f0e3"; }

.la-gem:before {
  content: "\\f3a5"; }

.la-genderless:before {
  content: "\\f22d"; }

.la-get-pocket:before {
  content: "\\f265"; }

.la-gg:before {
  content: "\\f260"; }

.la-gg-circle:before {
  content: "\\f261"; }

.la-ghost:before {
  content: "\\f6e2"; }

.la-gift:before {
  content: "\\f06b"; }

.la-gifts:before {
  content: "\\f79c"; }

.la-git:before {
  content: "\\f1d3"; }

.la-git-alt:before {
  content: "\\f841"; }

.la-git-square:before {
  content: "\\f1d2"; }

.la-github:before {
  content: "\\f09b"; }

.la-github-alt:before {
  content: "\\f113"; }

.la-github-square:before {
  content: "\\f092"; }

.la-gitkraken:before {
  content: "\\f3a6"; }

.la-gitlab:before {
  content: "\\f296"; }

.la-gitter:before {
  content: "\\f426"; }

.la-glass-cheers:before {
  content: "\\f79f"; }

.la-glass-martini:before {
  content: "\\f000"; }

.la-glass-martini-alt:before {
  content: "\\f57b"; }

.la-glass-whiskey:before {
  content: "\\f7a0"; }

.la-glasses:before {
  content: "\\f530"; }

.la-glide:before {
  content: "\\f2a5"; }

.la-glide-g:before {
  content: "\\f2a6"; }

.la-globe:before {
  content: "\\f0ac"; }

.la-globe-africa:before {
  content: "\\f57c"; }

.la-globe-americas:before {
  content: "\\f57d"; }

.la-globe-asia:before {
  content: "\\f57e"; }

.la-globe-europe:before {
  content: "\\f7a2"; }

.la-gofore:before {
  content: "\\f3a7"; }

.la-golf-ball:before {
  content: "\\f450"; }

.la-goodreads:before {
  content: "\\f3a8"; }

.la-goodreads-g:before {
  content: "\\f3a9"; }

.la-google:before {
  content: "\\f1a0"; }

.la-google-drive:before {
  content: "\\f3aa"; }

.la-google-play:before {
  content: "\\f3ab"; }

.la-google-plus:before {
  content: "\\f2b3"; }

.la-google-plus-g:before {
  content: "\\f0d5"; }

.la-google-plus-square:before {
  content: "\\f0d4"; }

.la-google-wallet:before {
  content: "\\f1ee"; }

.la-gopuram:before {
  content: "\\f664"; }

.la-graduation-cap:before {
  content: "\\f19d"; }

.la-gratipay:before {
  content: "\\f184"; }

.la-grav:before {
  content: "\\f2d6"; }

.la-greater-than:before {
  content: "\\f531"; }

.la-greater-than-equal:before {
  content: "\\f532"; }

.la-grimace:before {
  content: "\\f57f"; }

.la-grin:before {
  content: "\\f580"; }

.la-grin-alt:before {
  content: "\\f581"; }

.la-grin-beam:before {
  content: "\\f582"; }

.la-grin-beam-sweat:before {
  content: "\\f583"; }

.la-grin-hearts:before {
  content: "\\f584"; }

.la-grin-squint:before {
  content: "\\f585"; }

.la-grin-squint-tears:before {
  content: "\\f586"; }

.la-grin-stars:before {
  content: "\\f587"; }

.la-grin-tears:before {
  content: "\\f588"; }

.la-grin-tongue:before {
  content: "\\f589"; }

.la-grin-tongue-squint:before {
  content: "\\f58a"; }

.la-grin-tongue-wink:before {
  content: "\\f58b"; }

.la-grin-wink:before {
  content: "\\f58c"; }

.la-grip-horizontal:before {
  content: "\\f58d"; }

.la-grip-lines:before {
  content: "\\f7a4"; }

.la-grip-lines-vertical:before {
  content: "\\f7a5"; }

.la-grip-vertical:before {
  content: "\\f58e"; }

.la-gripfire:before {
  content: "\\f3ac"; }

.la-grunt:before {
  content: "\\f3ad"; }

.la-guitar:before {
  content: "\\f7a6"; }

.la-gulp:before {
  content: "\\f3ae"; }

.la-h-square:before {
  content: "\\f0fd"; }

.la-hacker-news:before {
  content: "\\f1d4"; }

.la-hacker-news-square:before {
  content: "\\f3af"; }

.la-hackerrank:before {
  content: "\\f5f7"; }

.la-hamburger:before {
  content: "\\f805"; }

.la-hammer:before {
  content: "\\f6e3"; }

.la-hamsa:before {
  content: "\\f665"; }

.la-hand-holding:before {
  content: "\\f4bd"; }

.la-hand-holding-heart:before {
  content: "\\f4be"; }

.la-hand-holding-usd:before {
  content: "\\f4c0"; }

.la-hand-lizard:before {
  content: "\\f258"; }

.la-hand-middle-finger:before {
  content: "\\f806"; }

.la-hand-paper:before {
  content: "\\f256"; }

.la-hand-peace:before {
  content: "\\f25b"; }

.la-hand-point-down:before {
  content: "\\f0a7"; }

.la-hand-point-left:before {
  content: "\\f0a5"; }

.la-hand-point-right:before {
  content: "\\f0a4"; }

.la-hand-point-up:before {
  content: "\\f0a6"; }

.la-hand-pointer:before {
  content: "\\f25a"; }

.la-hand-rock:before {
  content: "\\f255"; }

.la-hand-scissors:before {
  content: "\\f257"; }

.la-hand-spock:before {
  content: "\\f259"; }

.la-hands:before {
  content: "\\f4c2"; }

.la-hands-helping:before {
  content: "\\f4c4"; }

.la-handshake:before {
  content: "\\f2b5"; }

.la-hanukiah:before {
  content: "\\f6e6"; }

.la-hard-hat:before {
  content: "\\f807"; }

.la-hashtag:before {
  content: "\\f292"; }

.la-hat-cowboy:before {
  content: "\\f8c0"; }

.la-hat-cowboy-side:before {
  content: "\\f8c1"; }

.la-hat-wizard:before {
  content: "\\f6e8"; }

.la-haykal:before {
  content: "\\f666"; }

.la-hdd:before {
  content: "\\f0a0"; }

.la-heading:before {
  content: "\\f1dc"; }

.la-headphones:before {
  content: "\\f025"; }

.la-headphones-alt:before {
  content: "\\f58f"; }

.la-headset:before {
  content: "\\f590"; }

.la-heart:before {
  content: "\\f004"; }

.la-heart-broken:before {
  content: "\\f7a9"; }

.la-heartbeat:before {
  content: "\\f21e"; }

.la-helicopter:before {
  content: "\\f533"; }

.la-highlighter:before {
  content: "\\f591"; }

.la-hiking:before {
  content: "\\f6ec"; }

.la-hippo:before {
  content: "\\f6ed"; }

.la-hips:before {
  content: "\\f452"; }

.la-hire-a-helper:before {
  content: "\\f3b0"; }

.la-history:before {
  content: "\\f1da"; }

.la-hockey-puck:before {
  content: "\\f453"; }

.la-holly-berry:before {
  content: "\\f7aa"; }

.la-home:before {
  content: "\\f015"; }

.la-hooli:before {
  content: "\\f427"; }

.la-hornbill:before {
  content: "\\f592"; }

.la-horse:before {
  content: "\\f6f0"; }

.la-horse-head:before {
  content: "\\f7ab"; }

.la-hospital:before {
  content: "\\f0f8"; }

.la-hospital-alt:before {
  content: "\\f47d"; }

.la-hospital-symbol:before {
  content: "\\f47e"; }

.la-hot-tub:before {
  content: "\\f593"; }

.la-hotdog:before {
  content: "\\f80f"; }

.la-hotel:before {
  content: "\\f594"; }

.la-hotjar:before {
  content: "\\f3b1"; }

.la-hourglass:before {
  content: "\\f254"; }

.la-hourglass-end:before {
  content: "\\f253"; }

.la-hourglass-half:before {
  content: "\\f252"; }

.la-hourglass-start:before {
  content: "\\f251"; }

.la-house-damage:before {
  content: "\\f6f1"; }

.la-houzz:before {
  content: "\\f27c"; }

.la-hryvnia:before {
  content: "\\f6f2"; }

.la-html5:before {
  content: "\\f13b"; }

.la-hubspot:before {
  content: "\\f3b2"; }

.la-i-cursor:before {
  content: "\\f246"; }

.la-ice-cream:before {
  content: "\\f810"; }

.la-icicles:before {
  content: "\\f7ad"; }

.la-icons:before {
  content: "\\f86d"; }

.la-id-badge:before {
  content: "\\f2c1"; }

.la-id-card:before {
  content: "\\f2c2"; }

.la-id-card-alt:before {
  content: "\\f47f"; }

.la-igloo:before {
  content: "\\f7ae"; }

.la-image:before {
  content: "\\f03e"; }

.la-images:before {
  content: "\\f302"; }

.la-imdb:before {
  content: "\\f2d8"; }

.la-inbox:before {
  content: "\\f01c"; }

.la-indent:before {
  content: "\\f03c"; }

.la-industry:before {
  content: "\\f275"; }

.la-infinity:before {
  content: "\\f534"; }

.la-info:before {
  content: "\\f129"; }

.la-info-circle:before {
  content: "\\f05a"; }

.la-instagram:before {
  content: "\\f16d"; }

.la-intercom:before {
  content: "\\f7af"; }

.la-internet-explorer:before {
  content: "\\f26b"; }

.la-invision:before {
  content: "\\f7b0"; }

.la-ioxhost:before {
  content: "\\f208"; }

.la-italic:before {
  content: "\\f033"; }

.la-itch-io:before {
  content: "\\f83a"; }

.la-itunes:before {
  content: "\\f3b4"; }

.la-itunes-note:before {
  content: "\\f3b5"; }

.la-java:before {
  content: "\\f4e4"; }

.la-jedi:before {
  content: "\\f669"; }

.la-jedi-order:before {
  content: "\\f50e"; }

.la-jenkins:before {
  content: "\\f3b6"; }

.la-jira:before {
  content: "\\f7b1"; }

.la-joget:before {
  content: "\\f3b7"; }

.la-joint:before {
  content: "\\f595"; }

.la-joomla:before {
  content: "\\f1aa"; }

.la-journal-whills:before {
  content: "\\f66a"; }

.la-js:before {
  content: "\\f3b8"; }

.la-js-square:before {
  content: "\\f3b9"; }

.la-jsfiddle:before {
  content: "\\f1cc"; }

.la-kaaba:before {
  content: "\\f66b"; }

.la-kaggle:before {
  content: "\\f5fa"; }

.la-key:before {
  content: "\\f084"; }

.la-keybase:before {
  content: "\\f4f5"; }

.la-keyboard:before {
  content: "\\f11c"; }

.la-keycdn:before {
  content: "\\f3ba"; }

.la-khanda:before {
  content: "\\f66d"; }

.la-kickstarter:before {
  content: "\\f3bb"; }

.la-kickstarter-k:before {
  content: "\\f3bc"; }

.la-kiss:before {
  content: "\\f596"; }

.la-kiss-beam:before {
  content: "\\f597"; }

.la-kiss-wink-heart:before {
  content: "\\f598"; }

.la-kiwi-bird:before {
  content: "\\f535"; }

.la-korvue:before {
  content: "\\f42f"; }

.la-landmark:before {
  content: "\\f66f"; }

.la-language:before {
  content: "\\f1ab"; }

.la-laptop:before {
  content: "\\f109"; }

.la-laptop-code:before {
  content: "\\f5fc"; }

.la-laptop-medical:before {
  content: "\\f812"; }

.la-laravel:before {
  content: "\\f3bd"; }

.la-lastfm:before {
  content: "\\f202"; }

.la-lastfm-square:before {
  content: "\\f203"; }

.la-laugh:before {
  content: "\\f599"; }

.la-laugh-beam:before {
  content: "\\f59a"; }

.la-laugh-squint:before {
  content: "\\f59b"; }

.la-laugh-wink:before {
  content: "\\f59c"; }

.la-layer-group:before {
  content: "\\f5fd"; }

.la-leaf:before {
  content: "\\f06c"; }

.la-leanpub:before {
  content: "\\f212"; }

.la-lemon:before {
  content: "\\f094"; }

.la-less:before {
  content: "\\f41d"; }

.la-less-than:before {
  content: "\\f536"; }

.la-less-than-equal:before {
  content: "\\f537"; }

.la-level-down-alt:before {
  content: "\\f3be"; }

.la-level-up-alt:before {
  content: "\\f3bf"; }

.la-life-ring:before {
  content: "\\f1cd"; }

.la-lightbulb:before {
  content: "\\f0eb"; }

.la-line:before {
  content: "\\f3c0"; }

.la-link:before {
  content: "\\f0c1"; }

.la-linkedin:before {
  content: "\\f08c"; }

.la-linkedin-in:before {
  content: "\\f0e1"; }

.la-linode:before {
  content: "\\f2b8"; }

.la-linux:before {
  content: "\\f17c"; }

.la-lira-sign:before {
  content: "\\f195"; }

.la-list:before {
  content: "\\f03a"; }

.la-list-alt:before {
  content: "\\f022"; }

.la-list-ol:before {
  content: "\\f0cb"; }

.la-list-ul:before {
  content: "\\f0ca"; }

.la-location-arrow:before {
  content: "\\f124"; }

.la-lock:before {
  content: "\\f023"; }

.la-lock-open:before {
  content: "\\f3c1"; }

.la-long-arrow-alt-down:before {
  content: "\\f309"; }

.la-long-arrow-alt-left:before {
  content: "\\f30a"; }

.la-long-arrow-alt-right:before {
  content: "\\f30b"; }

.la-long-arrow-alt-up:before {
  content: "\\f30c"; }

.la-low-vision:before {
  content: "\\f2a8"; }

.la-luggage-cart:before {
  content: "\\f59d"; }

.la-lyft:before {
  content: "\\f3c3"; }

.la-magento:before {
  content: "\\f3c4"; }

.la-magic:before {
  content: "\\f0d0"; }

.la-magnet:before {
  content: "\\f076"; }

.la-mail-bulk:before {
  content: "\\f674"; }

.la-mailchimp:before {
  content: "\\f59e"; }

.la-male:before {
  content: "\\f183"; }

.la-mandalorian:before {
  content: "\\f50f"; }

.la-map:before {
  content: "\\f279"; }

.la-map-marked:before {
  content: "\\f59f"; }

.la-map-marked-alt:before {
  content: "\\f5a0"; }

.la-map-marker:before {
  content: "\\f041"; }

.la-map-marker-alt:before {
  content: "\\f3c5"; }

.la-map-pin:before {
  content: "\\f276"; }

.la-map-signs:before {
  content: "\\f277"; }

.la-markdown:before {
  content: "\\f60f"; }

.la-marker:before {
  content: "\\f5a1"; }

.la-mars:before {
  content: "\\f222"; }

.la-mars-double:before {
  content: "\\f227"; }

.la-mars-stroke:before {
  content: "\\f229"; }

.la-mars-stroke-h:before {
  content: "\\f22b"; }

.la-mars-stroke-v:before {
  content: "\\f22a"; }

.la-mask:before {
  content: "\\f6fa"; }

.la-mastodon:before {
  content: "\\f4f6"; }

.la-maxcdn:before {
  content: "\\f136"; }

.la-mdb:before {
  content: "\\f8ca"; }

.la-medal:before {
  content: "\\f5a2"; }

.la-medapps:before {
  content: "\\f3c6"; }

.la-medium:before {
  content: "\\f23a"; }

.la-medium-m:before {
  content: "\\f3c7"; }

.la-medkit:before {
  content: "\\f0fa"; }

.la-medrt:before {
  content: "\\f3c8"; }

.la-meetup:before {
  content: "\\f2e0"; }

.la-megaport:before {
  content: "\\f5a3"; }

.la-meh:before {
  content: "\\f11a"; }

.la-meh-blank:before {
  content: "\\f5a4"; }

.la-meh-rolling-eyes:before {
  content: "\\f5a5"; }

.la-memory:before {
  content: "\\f538"; }

.la-mendeley:before {
  content: "\\f7b3"; }

.la-menorah:before {
  content: "\\f676"; }

.la-mercury:before {
  content: "\\f223"; }

.la-meteor:before {
  content: "\\f753"; }

.la-microchip:before {
  content: "\\f2db"; }

.la-microphone:before {
  content: "\\f130"; }

.la-microphone-alt:before {
  content: "\\f3c9"; }

.la-microphone-alt-slash:before {
  content: "\\f539"; }

.la-microphone-slash:before {
  content: "\\f131"; }

.la-microscope:before {
  content: "\\f610"; }

.la-microsoft:before {
  content: "\\f3ca"; }

.la-minus:before {
  content: "\\f068"; }

.la-minus-circle:before {
  content: "\\f056"; }

.la-minus-square:before {
  content: "\\f146"; }

.la-mitten:before {
  content: "\\f7b5"; }

.la-mix:before {
  content: "\\f3cb"; }

.la-mixcloud:before {
  content: "\\f289"; }

.la-mizuni:before {
  content: "\\f3cc"; }

.la-mobile:before {
  content: "\\f10b"; }

.la-mobile-alt:before {
  content: "\\f3cd"; }

.la-modx:before {
  content: "\\f285"; }

.la-monero:before {
  content: "\\f3d0"; }

.la-money-bill:before {
  content: "\\f0d6"; }

.la-money-bill-alt:before {
  content: "\\f3d1"; }

.la-money-bill-wave:before {
  content: "\\f53a"; }

.la-money-bill-wave-alt:before {
  content: "\\f53b"; }

.la-money-check:before {
  content: "\\f53c"; }

.la-money-check-alt:before {
  content: "\\f53d"; }

.la-monument:before {
  content: "\\f5a6"; }

.la-moon:before {
  content: "\\f186"; }

.la-mortar-pestle:before {
  content: "\\f5a7"; }

.la-mosque:before {
  content: "\\f678"; }

.la-motorcycle:before {
  content: "\\f21c"; }

.la-mountain:before {
  content: "\\f6fc"; }

.la-mouse:before {
  content: "\\f8cc"; }

.la-mouse-pointer:before {
  content: "\\f245"; }

.la-mug-hot:before {
  content: "\\f7b6"; }

.la-music:before {
  content: "\\f001"; }

.la-napster:before {
  content: "\\f3d2"; }

.la-neos:before {
  content: "\\f612"; }

.la-network-wired:before {
  content: "\\f6ff"; }

.la-neuter:before {
  content: "\\f22c"; }

.la-newspaper:before {
  content: "\\f1ea"; }

.la-nimblr:before {
  content: "\\f5a8"; }

.la-node:before {
  content: "\\f419"; }

.la-node-js:before {
  content: "\\f3d3"; }

.la-not-equal:before {
  content: "\\f53e"; }

.la-notes-medical:before {
  content: "\\f481"; }

.la-npm:before {
  content: "\\f3d4"; }

.la-ns8:before {
  content: "\\f3d5"; }

.la-nutritionix:before {
  content: "\\f3d6"; }

.la-object-group:before {
  content: "\\f247"; }

.la-object-ungroup:before {
  content: "\\f248"; }

.la-odnoklassniki:before {
  content: "\\f263"; }

.la-odnoklassniki-square:before {
  content: "\\f264"; }

.la-oil-can:before {
  content: "\\f613"; }

.la-old-republic:before {
  content: "\\f510"; }

.la-om:before {
  content: "\\f679"; }

.la-opencart:before {
  content: "\\f23d"; }

.la-openid:before {
  content: "\\f19b"; }

.la-opera:before {
  content: "\\f26a"; }

.la-optin-monster:before {
  content: "\\f23c"; }

.la-orcid:before {
  content: "\\f8d2"; }

.la-osi:before {
  content: "\\f41a"; }

.la-otter:before {
  content: "\\f700"; }

.la-outdent:before {
  content: "\\f03b"; }

.la-page4:before {
  content: "\\f3d7"; }

.la-pagelines:before {
  content: "\\f18c"; }

.la-pager:before {
  content: "\\f815"; }

.la-paint-brush:before {
  content: "\\f1fc"; }

.la-paint-roller:before {
  content: "\\f5aa"; }

.la-palette:before {
  content: "\\f53f"; }

.la-palfed:before {
  content: "\\f3d8"; }

.la-pallet:before {
  content: "\\f482"; }

.la-paper-plane:before {
  content: "\\f1d8"; }

.la-paperclip:before {
  content: "\\f0c6"; }

.la-parachute-box:before {
  content: "\\f4cd"; }

.la-paragraph:before {
  content: "\\f1dd"; }

.la-parking:before {
  content: "\\f540"; }

.la-passport:before {
  content: "\\f5ab"; }

.la-pastafarianism:before {
  content: "\\f67b"; }

.la-paste:before {
  content: "\\f0ea"; }

.la-patreon:before {
  content: "\\f3d9"; }

.la-pause:before {
  content: "\\f04c"; }

.la-pause-circle:before {
  content: "\\f28b"; }

.la-paw:before {
  content: "\\f1b0"; }

.la-paypal:before {
  content: "\\f1ed"; }

.la-peace:before {
  content: "\\f67c"; }

.la-pen:before {
  content: "\\f304"; }

.la-pen-alt:before {
  content: "\\f305"; }

.la-pen-fancy:before {
  content: "\\f5ac"; }

.la-pen-nib:before {
  content: "\\f5ad"; }

.la-pen-square:before {
  content: "\\f14b"; }

.la-pencil-alt:before {
  content: "\\f303"; }

.la-pencil-ruler:before {
  content: "\\f5ae"; }

.la-penny-arcade:before {
  content: "\\f704"; }

.la-people-carry:before {
  content: "\\f4ce"; }

.la-pepper-hot:before {
  content: "\\f816"; }

.la-percent:before {
  content: "\\f295"; }

.la-percentage:before {
  content: "\\f541"; }

.la-periscope:before {
  content: "\\f3da"; }

.la-person-booth:before {
  content: "\\f756"; }

.la-phabricator:before {
  content: "\\f3db"; }

.la-phoenix-framework:before {
  content: "\\f3dc"; }

.la-phoenix-squadron:before {
  content: "\\f511"; }

.la-phone:before {
  content: "\\f095"; }

.la-phone-alt:before {
  content: "\\f879"; }

.la-phone-slash:before {
  content: "\\f3dd"; }

.la-phone-square:before {
  content: "\\f098"; }

.la-phone-square-alt:before {
  content: "\\f87b"; }

.la-phone-volume:before {
  content: "\\f2a0"; }

.la-photo-video:before {
  content: "\\f87c"; }

.la-php:before {
  content: "\\f457"; }

.la-pied-piper:before {
  content: "\\f2ae"; }

.la-pied-piper-alt:before {
  content: "\\f1a8"; }

.la-pied-piper-hat:before {
  content: "\\f4e5"; }

.la-pied-piper-pp:before {
  content: "\\f1a7"; }

.la-piggy-bank:before {
  content: "\\f4d3"; }

.la-pills:before {
  content: "\\f484"; }

.la-pinterest:before {
  content: "\\f0d2"; }

.la-pinterest-p:before {
  content: "\\f231"; }

.la-pinterest-square:before {
  content: "\\f0d3"; }

.la-pizza-slice:before {
  content: "\\f818"; }

.la-place-of-worship:before {
  content: "\\f67f"; }

.la-plane:before {
  content: "\\f072"; }

.la-plane-arrival:before {
  content: "\\f5af"; }

.la-plane-departure:before {
  content: "\\f5b0"; }

.la-play:before {
  content: "\\f04b"; }

.la-play-circle:before {
  content: "\\f144"; }

.la-playstation:before {
  content: "\\f3df"; }

.la-plug:before {
  content: "\\f1e6"; }

.la-plus:before {
  content: "\\f067"; }

.la-plus-circle:before {
  content: "\\f055"; }

.la-plus-square:before {
  content: "\\f0fe"; }

.la-podcast:before {
  content: "\\f2ce"; }

.la-poll:before {
  content: "\\f681"; }

.la-poll-h:before {
  content: "\\f682"; }

.la-poo:before {
  content: "\\f2fe"; }

.la-poo-storm:before {
  content: "\\f75a"; }

.la-poop:before {
  content: "\\f619"; }

.la-portrait:before {
  content: "\\f3e0"; }

.la-pound-sign:before {
  content: "\\f154"; }

.la-power-off:before {
  content: "\\f011"; }

.la-pray:before {
  content: "\\f683"; }

.la-praying-hands:before {
  content: "\\f684"; }

.la-prescription:before {
  content: "\\f5b1"; }

.la-prescription-bottle:before {
  content: "\\f485"; }

.la-prescription-bottle-alt:before {
  content: "\\f486"; }

.la-print:before {
  content: "\\f02f"; }

.la-procedures:before {
  content: "\\f487"; }

.la-product-hunt:before {
  content: "\\f288"; }

.la-project-diagram:before {
  content: "\\f542"; }

.la-pushed:before {
  content: "\\f3e1"; }

.la-puzzle-piece:before {
  content: "\\f12e"; }

.la-python:before {
  content: "\\f3e2"; }

.la-qq:before {
  content: "\\f1d6"; }

.la-qrcode:before {
  content: "\\f029"; }

.la-question:before {
  content: "\\f128"; }

.la-question-circle:before {
  content: "\\f059"; }

.la-quidditch:before {
  content: "\\f458"; }

.la-quinscape:before {
  content: "\\f459"; }

.la-quora:before {
  content: "\\f2c4"; }

.la-quote-left:before {
  content: "\\f10d"; }

.la-quote-right:before {
  content: "\\f10e"; }

.la-quran:before {
  content: "\\f687"; }

.la-r-project:before {
  content: "\\f4f7"; }

.la-radiation:before {
  content: "\\f7b9"; }

.la-radiation-alt:before {
  content: "\\f7ba"; }

.la-rainbow:before {
  content: "\\f75b"; }

.la-random:before {
  content: "\\f074"; }

.la-raspberry-pi:before {
  content: "\\f7bb"; }

.la-ravelry:before {
  content: "\\f2d9"; }

.la-react:before {
  content: "\\f41b"; }

.la-reacteurope:before {
  content: "\\f75d"; }

.la-readme:before {
  content: "\\f4d5"; }

.la-rebel:before {
  content: "\\f1d0"; }

.la-receipt:before {
  content: "\\f543"; }

.la-record-vinyl:before {
  content: "\\f8d9"; }

.la-recycle:before {
  content: "\\f1b8"; }

.la-red-river:before {
  content: "\\f3e3"; }

.la-reddit:before {
  content: "\\f1a1"; }

.la-reddit-alien:before {
  content: "\\f281"; }

.la-reddit-square:before {
  content: "\\f1a2"; }

.la-redhat:before {
  content: "\\f7bc"; }

.la-redo:before {
  content: "\\f01e"; }

.la-redo-alt:before {
  content: "\\f2f9"; }

.la-registered:before {
  content: "\\f25d"; }

.la-remove-format:before {
  content: "\\f87d"; }

.la-renren:before {
  content: "\\f18b"; }

.la-reply:before {
  content: "\\f3e5"; }

.la-reply-all:before {
  content: "\\f122"; }

.la-replyd:before {
  content: "\\f3e6"; }

.la-republican:before {
  content: "\\f75e"; }

.la-researchgate:before {
  content: "\\f4f8"; }

.la-resolving:before {
  content: "\\f3e7"; }

.la-restroom:before {
  content: "\\f7bd"; }

.la-retweet:before {
  content: "\\f079"; }

.la-rev:before {
  content: "\\f5b2"; }

.la-ribbon:before {
  content: "\\f4d6"; }

.la-ring:before {
  content: "\\f70b"; }

.la-road:before {
  content: "\\f018"; }

.la-robot:before {
  content: "\\f544"; }

.la-rocket:before {
  content: "\\f135"; }

.la-rocketchat:before {
  content: "\\f3e8"; }

.la-rockrms:before {
  content: "\\f3e9"; }

.la-route:before {
  content: "\\f4d7"; }

.la-rss:before {
  content: "\\f09e"; }

.la-rss-square:before {
  content: "\\f143"; }

.la-ruble-sign:before {
  content: "\\f158"; }

.la-ruler:before {
  content: "\\f545"; }

.la-ruler-combined:before {
  content: "\\f546"; }

.la-ruler-horizontal:before {
  content: "\\f547"; }

.la-ruler-vertical:before {
  content: "\\f548"; }

.la-running:before {
  content: "\\f70c"; }

.la-rupee-sign:before {
  content: "\\f156"; }

.la-sad-cry:before {
  content: "\\f5b3"; }

.la-sad-tear:before {
  content: "\\f5b4"; }

.la-safari:before {
  content: "\\f267"; }

.la-salesforce:before {
  content: "\\f83b"; }

.la-sass:before {
  content: "\\f41e"; }

.la-satellite:before {
  content: "\\f7bf"; }

.la-satellite-dish:before {
  content: "\\f7c0"; }

.la-save:before {
  content: "\\f0c7"; }

.la-schlix:before {
  content: "\\f3ea"; }

.la-school:before {
  content: "\\f549"; }

.la-screwdriver:before {
  content: "\\f54a"; }

.la-scribd:before {
  content: "\\f28a"; }

.la-scroll:before {
  content: "\\f70e"; }

.la-sd-card:before {
  content: "\\f7c2"; }

.la-search:before {
  content: "\\f002"; }

.la-search-dollar:before {
  content: "\\f688"; }

.la-search-location:before {
  content: "\\f689"; }

.la-search-minus:before {
  content: "\\f010"; }

.la-search-plus:before {
  content: "\\f00e"; }

.la-searchengin:before {
  content: "\\f3eb"; }

.la-seedling:before {
  content: "\\f4d8"; }

.la-sellcast:before {
  content: "\\f2da"; }

.la-sellsy:before {
  content: "\\f213"; }

.la-server:before {
  content: "\\f233"; }

.la-servicestack:before {
  content: "\\f3ec"; }

.la-shapes:before {
  content: "\\f61f"; }

.la-share:before {
  content: "\\f064"; }

.la-share-alt:before {
  content: "\\f1e0"; }

.la-share-alt-square:before {
  content: "\\f1e1"; }

.la-share-square:before {
  content: "\\f14d"; }

.la-shekel-sign:before {
  content: "\\f20b"; }

.la-shield-alt:before {
  content: "\\f3ed"; }

.la-ship:before {
  content: "\\f21a"; }

.la-shipping-fast:before {
  content: "\\f48b"; }

.la-shirtsinbulk:before {
  content: "\\f214"; }

.la-shoe-prints:before {
  content: "\\f54b"; }

.la-shopping-bag:before {
  content: "\\f290"; }

.la-shopping-basket:before {
  content: "\\f291"; }

.la-shopping-cart:before {
  content: "\\f07a"; }

.la-shopware:before {
  content: "\\f5b5"; }

.la-shower:before {
  content: "\\f2cc"; }

.la-shuttle-van:before {
  content: "\\f5b6"; }

.la-sign:before {
  content: "\\f4d9"; }

.la-sign-in-alt:before {
  content: "\\f2f6"; }

.la-sign-language:before {
  content: "\\f2a7"; }

.la-sign-out-alt:before {
  content: "\\f2f5"; }

.la-signal:before {
  content: "\\f012"; }

.la-signature:before {
  content: "\\f5b7"; }

.la-sim-card:before {
  content: "\\f7c4"; }

.la-simplybuilt:before {
  content: "\\f215"; }

.la-sistrix:before {
  content: "\\f3ee"; }

.la-sitemap:before {
  content: "\\f0e8"; }

.la-sith:before {
  content: "\\f512"; }

.la-skating:before {
  content: "\\f7c5"; }

.la-sketch:before {
  content: "\\f7c6"; }

.la-skiing:before {
  content: "\\f7c9"; }

.la-skiing-nordic:before {
  content: "\\f7ca"; }

.la-skull:before {
  content: "\\f54c"; }

.la-skull-crossbones:before {
  content: "\\f714"; }

.la-skyatlas:before {
  content: "\\f216"; }

.la-skype:before {
  content: "\\f17e"; }

.la-slack:before {
  content: "\\f198"; }

.la-slack-hash:before {
  content: "\\f3ef"; }

.la-slash:before {
  content: "\\f715"; }

.la-sleigh:before {
  content: "\\f7cc"; }

.la-sliders-h:before {
  content: "\\f1de"; }

.la-slideshare:before {
  content: "\\f1e7"; }

.la-smile:before {
  content: "\\f118"; }

.la-smile-beam:before {
  content: "\\f5b8"; }

.la-smile-wink:before {
  content: "\\f4da"; }

.la-smog:before {
  content: "\\f75f"; }

.la-smoking:before {
  content: "\\f48d"; }

.la-smoking-ban:before {
  content: "\\f54d"; }

.la-sms:before {
  content: "\\f7cd"; }

.la-snapchat:before {
  content: "\\f2ab"; }

.la-snapchat-ghost:before {
  content: "\\f2ac"; }

.la-snapchat-square:before {
  content: "\\f2ad"; }

.la-snowboarding:before {
  content: "\\f7ce"; }

.la-snowflake:before {
  content: "\\f2dc"; }

.la-snowman:before {
  content: "\\f7d0"; }

.la-snowplow:before {
  content: "\\f7d2"; }

.la-socks:before {
  content: "\\f696"; }

.la-solar-panel:before {
  content: "\\f5ba"; }

.la-sort:before {
  content: "\\f0dc"; }

.la-sort-alpha-down:before {
  content: "\\f15d"; }

.la-sort-alpha-down-alt:before {
  content: "\\f881"; }

.la-sort-alpha-up:before {
  content: "\\f15e"; }

.la-sort-alpha-up-alt:before {
  content: "\\f882"; }

.la-sort-amount-down:before {
  content: "\\f160"; }

.la-sort-amount-down-alt:before {
  content: "\\f884"; }

.la-sort-amount-up:before {
  content: "\\f161"; }

.la-sort-amount-up-alt:before {
  content: "\\f885"; }

.la-sort-down:before {
  content: "\\f0dd"; }

.la-sort-numeric-down:before {
  content: "\\f162"; }

.la-sort-numeric-down-alt:before {
  content: "\\f886"; }

.la-sort-numeric-up:before {
  content: "\\f163"; }

.la-sort-numeric-up-alt:before {
  content: "\\f887"; }

.la-sort-up:before {
  content: "\\f0de"; }

.la-soundcloud:before {
  content: "\\f1be"; }

.la-sourcetree:before {
  content: "\\f7d3"; }

.la-spa:before {
  content: "\\f5bb"; }

.la-space-shuttle:before {
  content: "\\f197"; }

.la-speakap:before {
  content: "\\f3f3"; }

.la-speaker-deck:before {
  content: "\\f83c"; }

.la-spell-check:before {
  content: "\\f891"; }

.la-spider:before {
  content: "\\f717"; }

.la-spinner:before {
  content: "\\f110"; }

.la-splotch:before {
  content: "\\f5bc"; }

.la-spotify:before {
  content: "\\f1bc"; }

.la-spray-can:before {
  content: "\\f5bd"; }

.la-square:before {
  content: "\\f0c8"; }

.la-square-full:before {
  content: "\\f45c"; }

.la-square-root-alt:before {
  content: "\\f698"; }

.la-squarespace:before {
  content: "\\f5be"; }

.la-stack-exchange:before {
  content: "\\f18d"; }

.la-stack-overflow:before {
  content: "\\f16c"; }

.la-stackpath:before {
  content: "\\f842"; }

.la-stamp:before {
  content: "\\f5bf"; }

.la-star:before {
  content: "\\f005"; }

.la-star-and-crescent:before {
  content: "\\f699"; }

.la-star-half:before {
  content: "\\f089"; }

.la-star-half-alt:before {
  content: "\\f5c0"; }

.la-star-of-david:before {
  content: "\\f69a"; }

.la-star-of-life:before {
  content: "\\f621"; }

.la-staylinked:before {
  content: "\\f3f5"; }

.la-steam:before {
  content: "\\f1b6"; }

.la-steam-square:before {
  content: "\\f1b7"; }

.la-steam-symbol:before {
  content: "\\f3f6"; }

.la-step-backward:before {
  content: "\\f048"; }

.la-step-forward:before {
  content: "\\f051"; }

.la-stethoscope:before {
  content: "\\f0f1"; }

.la-sticker-mule:before {
  content: "\\f3f7"; }

.la-sticky-note:before {
  content: "\\f249"; }

.la-stop:before {
  content: "\\f04d"; }

.la-stop-circle:before {
  content: "\\f28d"; }

.la-stopwatch:before {
  content: "\\f2f2"; }

.la-store:before {
  content: "\\f54e"; }

.la-store-alt:before {
  content: "\\f54f"; }

.la-strava:before {
  content: "\\f428"; }

.la-stream:before {
  content: "\\f550"; }

.la-street-view:before {
  content: "\\f21d"; }

.la-strikethrough:before {
  content: "\\f0cc"; }

.la-stripe:before {
  content: "\\f429"; }

.la-stripe-s:before {
  content: "\\f42a"; }

.la-stroopwafel:before {
  content: "\\f551"; }

.la-studiovinari:before {
  content: "\\f3f8"; }

.la-stumbleupon:before {
  content: "\\f1a4"; }

.la-stumbleupon-circle:before {
  content: "\\f1a3"; }

.la-subscript:before {
  content: "\\f12c"; }

.la-subway:before {
  content: "\\f239"; }

.la-suitcase:before {
  content: "\\f0f2"; }

.la-suitcase-rolling:before {
  content: "\\f5c1"; }

.la-sun:before {
  content: "\\f185"; }

.la-superpowers:before {
  content: "\\f2dd"; }

.la-superscript:before {
  content: "\\f12b"; }

.la-supple:before {
  content: "\\f3f9"; }

.la-surprise:before {
  content: "\\f5c2"; }

.la-suse:before {
  content: "\\f7d6"; }

.la-swatchbook:before {
  content: "\\f5c3"; }

.la-swift:before {
  content: "\\f8e1"; }

.la-swimmer:before {
  content: "\\f5c4"; }

.la-swimming-pool:before {
  content: "\\f5c5"; }

.la-symfony:before {
  content: "\\f83d"; }

.la-synagogue:before {
  content: "\\f69b"; }

.la-sync:before {
  content: "\\f021"; }

.la-sync-alt:before {
  content: "\\f2f1"; }

.la-syringe:before {
  content: "\\f48e"; }

.la-table:before {
  content: "\\f0ce"; }

.la-table-tennis:before {
  content: "\\f45d"; }

.la-tablet:before {
  content: "\\f10a"; }

.la-tablet-alt:before {
  content: "\\f3fa"; }

.la-tablets:before {
  content: "\\f490"; }

.la-tachometer-alt:before {
  content: "\\f3fd"; }

.la-tag:before {
  content: "\\f02b"; }

.la-tags:before {
  content: "\\f02c"; }

.la-tape:before {
  content: "\\f4db"; }

.la-tasks:before {
  content: "\\f0ae"; }

.la-taxi:before {
  content: "\\f1ba"; }

.la-teamspeak:before {
  content: "\\f4f9"; }

.la-teeth:before {
  content: "\\f62e"; }

.la-teeth-open:before {
  content: "\\f62f"; }

.la-telegram:before {
  content: "\\f2c6"; }

.la-telegram-plane:before {
  content: "\\f3fe"; }

.la-temperature-high:before {
  content: "\\f769"; }

.la-temperature-low:before {
  content: "\\f76b"; }

.la-tencent-weibo:before {
  content: "\\f1d5"; }

.la-tenge:before {
  content: "\\f7d7"; }

.la-terminal:before {
  content: "\\f120"; }

.la-text-height:before {
  content: "\\f034"; }

.la-text-width:before {
  content: "\\f035"; }

.la-th:before {
  content: "\\f00a"; }

.la-th-large:before {
  content: "\\f009"; }

.la-th-list:before {
  content: "\\f00b"; }

.la-the-red-yeti:before {
  content: "\\f69d"; }

.la-theater-masks:before {
  content: "\\f630"; }

.la-themeco:before {
  content: "\\f5c6"; }

.la-themeisle:before {
  content: "\\f2b2"; }

.la-thermometer:before {
  content: "\\f491"; }

.la-thermometer-empty:before {
  content: "\\f2cb"; }

.la-thermometer-full:before {
  content: "\\f2c7"; }

.la-thermometer-half:before {
  content: "\\f2c9"; }

.la-thermometer-quarter:before {
  content: "\\f2ca"; }

.la-thermometer-three-quarters:before {
  content: "\\f2c8"; }

.la-think-peaks:before {
  content: "\\f731"; }

.la-thumbs-down:before {
  content: "\\f165"; }

.la-thumbs-up:before {
  content: "\\f164"; }

.la-thumbtack:before {
  content: "\\f08d"; }

.la-ticket-alt:before {
  content: "\\f3ff"; }

.la-times:before {
  content: "\\f00d"; }

.la-times-circle:before {
  content: "\\f057"; }

.la-tint:before {
  content: "\\f043"; }

.la-tint-slash:before {
  content: "\\f5c7"; }

.la-tired:before {
  content: "\\f5c8"; }

.la-toggle-off:before {
  content: "\\f204"; }

.la-toggle-on:before {
  content: "\\f205"; }

.la-toilet:before {
  content: "\\f7d8"; }

.la-toilet-paper:before {
  content: "\\f71e"; }

.la-toolbox:before {
  content: "\\f552"; }

.la-tools:before {
  content: "\\f7d9"; }

.la-tooth:before {
  content: "\\f5c9"; }

.la-torah:before {
  content: "\\f6a0"; }

.la-torii-gate:before {
  content: "\\f6a1"; }

.la-tractor:before {
  content: "\\f722"; }

.la-trade-federation:before {
  content: "\\f513"; }

.la-trademark:before {
  content: "\\f25c"; }

.la-traffic-light:before {
  content: "\\f637"; }

.la-train:before {
  content: "\\f238"; }

.la-tram:before {
  content: "\\f7da"; }

.la-transgender:before {
  content: "\\f224"; }

.la-transgender-alt:before {
  content: "\\f225"; }

.la-trash:before {
  content: "\\f1f8"; }

.la-trash-alt:before {
  content: "\\f2ed"; }

.la-trash-restore:before {
  content: "\\f829"; }

.la-trash-restore-alt:before {
  content: "\\f82a"; }

.la-tree:before {
  content: "\\f1bb"; }

.la-trello:before {
  content: "\\f181"; }

.la-tripadvisor:before {
  content: "\\f262"; }

.la-trophy:before {
  content: "\\f091"; }

.la-truck:before {
  content: "\\f0d1"; }

.la-truck-loading:before {
  content: "\\f4de"; }

.la-truck-monster:before {
  content: "\\f63b"; }

.la-truck-moving:before {
  content: "\\f4df"; }

.la-truck-pickup:before {
  content: "\\f63c"; }

.la-tshirt:before {
  content: "\\f553"; }

.la-tty:before {
  content: "\\f1e4"; }

.la-tumblr:before {
  content: "\\f173"; }

.la-tumblr-square:before {
  content: "\\f174"; }

.la-tv:before {
  content: "\\f26c"; }

.la-twitch:before {
  content: "\\f1e8"; }

.la-twitter:before {
  content: "\\f099"; }

.la-twitter-square:before {
  content: "\\f081"; }

.la-typo3:before {
  content: "\\f42b"; }

.la-uber:before {
  content: "\\f402"; }

.la-ubuntu:before {
  content: "\\f7df"; }

.la-uikit:before {
  content: "\\f403"; }

.la-umbraco:before {
  content: "\\f8e8"; }

.la-umbrella:before {
  content: "\\f0e9"; }

.la-umbrella-beach:before {
  content: "\\f5ca"; }

.la-underline:before {
  content: "\\f0cd"; }

.la-undo:before {
  content: "\\f0e2"; }

.la-undo-alt:before {
  content: "\\f2ea"; }

.la-uniregistry:before {
  content: "\\f404"; }

.la-universal-access:before {
  content: "\\f29a"; }

.la-university:before {
  content: "\\f19c"; }

.la-unlink:before {
  content: "\\f127"; }

.la-unlock:before {
  content: "\\f09c"; }

.la-unlock-alt:before {
  content: "\\f13e"; }

.la-untappd:before {
  content: "\\f405"; }

.la-upload:before {
  content: "\\f093"; }

.la-ups:before {
  content: "\\f7e0"; }

.la-usb:before {
  content: "\\f287"; }

.la-user:before {
  content: "\\f007"; }

.la-user-alt:before {
  content: "\\f406"; }

.la-user-alt-slash:before {
  content: "\\f4fa"; }

.la-user-astronaut:before {
  content: "\\f4fb"; }

.la-user-check:before {
  content: "\\f4fc"; }

.la-user-circle:before {
  content: "\\f2bd"; }

.la-user-clock:before {
  content: "\\f4fd"; }

.la-user-cog:before {
  content: "\\f4fe"; }

.la-user-edit:before {
  content: "\\f4ff"; }

.la-user-friends:before {
  content: "\\f500"; }

.la-user-graduate:before {
  content: "\\f501"; }

.la-user-injured:before {
  content: "\\f728"; }

.la-user-lock:before {
  content: "\\f502"; }

.la-user-md:before {
  content: "\\f0f0"; }

.la-user-minus:before {
  content: "\\f503"; }

.la-user-ninja:before {
  content: "\\f504"; }

.la-user-nurse:before {
  content: "\\f82f"; }

.la-user-plus:before {
  content: "\\f234"; }

.la-user-secret:before {
  content: "\\f21b"; }

.la-user-shield:before {
  content: "\\f505"; }

.la-user-slash:before {
  content: "\\f506"; }

.la-user-tag:before {
  content: "\\f507"; }

.la-user-tie:before {
  content: "\\f508"; }

.la-user-times:before {
  content: "\\f235"; }

.la-users:before {
  content: "\\f0c0"; }

.la-users-cog:before {
  content: "\\f509"; }

.la-usps:before {
  content: "\\f7e1"; }

.la-ussunnah:before {
  content: "\\f407"; }

.la-utensil-spoon:before {
  content: "\\f2e5"; }

.la-utensils:before {
  content: "\\f2e7"; }

.la-vaadin:before {
  content: "\\f408"; }

.la-vector-square:before {
  content: "\\f5cb"; }

.la-venus:before {
  content: "\\f221"; }

.la-venus-double:before {
  content: "\\f226"; }

.la-venus-mars:before {
  content: "\\f228"; }

.la-viacoin:before {
  content: "\\f237"; }

.la-viadeo:before {
  content: "\\f2a9"; }

.la-viadeo-square:before {
  content: "\\f2aa"; }

.la-vial:before {
  content: "\\f492"; }

.la-vials:before {
  content: "\\f493"; }

.la-viber:before {
  content: "\\f409"; }

.la-video:before {
  content: "\\f03d"; }

.la-video-slash:before {
  content: "\\f4e2"; }

.la-vihara:before {
  content: "\\f6a7"; }

.la-vimeo:before {
  content: "\\f40a"; }

.la-vimeo-square:before {
  content: "\\f194"; }

.la-vimeo-v:before {
  content: "\\f27d"; }

.la-vine:before {
  content: "\\f1ca"; }

.la-vk:before {
  content: "\\f189"; }

.la-vnv:before {
  content: "\\f40b"; }

.la-voicemail:before {
  content: "\\f897"; }

.la-volleyball-ball:before {
  content: "\\f45f"; }

.la-volume-down:before {
  content: "\\f027"; }

.la-volume-mute:before {
  content: "\\f6a9"; }

.la-volume-off:before {
  content: "\\f026"; }

.la-volume-up:before {
  content: "\\f028"; }

.la-vote-yea:before {
  content: "\\f772"; }

.la-vr-cardboard:before {
  content: "\\f729"; }

.la-vuejs:before {
  content: "\\f41f"; }

.la-walking:before {
  content: "\\f554"; }

.la-wallet:before {
  content: "\\f555"; }

.la-warehouse:before {
  content: "\\f494"; }

.la-water:before {
  content: "\\f773"; }

.la-wave-square:before {
  content: "\\f83e"; }

.la-waze:before {
  content: "\\f83f"; }

.la-weebly:before {
  content: "\\f5cc"; }

.la-weibo:before {
  content: "\\f18a"; }

.la-weight:before {
  content: "\\f496"; }

.la-weight-hanging:before {
  content: "\\f5cd"; }

.la-weixin:before {
  content: "\\f1d7"; }

.la-whatsapp:before {
  content: "\\f232"; }

.la-whatsapp-square:before {
  content: "\\f40c"; }

.la-wheelchair:before {
  content: "\\f193"; }

.la-whmcs:before {
  content: "\\f40d"; }

.la-wifi:before {
  content: "\\f1eb"; }

.la-wikipedia-w:before {
  content: "\\f266"; }

.la-wind:before {
  content: "\\f72e"; }

.la-window-close:before {
  content: "\\f410"; }

.la-window-maximize:before {
  content: "\\f2d0"; }

.la-window-minimize:before {
  content: "\\f2d1"; }

.la-window-restore:before {
  content: "\\f2d2"; }

.la-windows:before {
  content: "\\f17a"; }

.la-wine-bottle:before {
  content: "\\f72f"; }

.la-wine-glass:before {
  content: "\\f4e3"; }

.la-wine-glass-alt:before {
  content: "\\f5ce"; }

.la-wix:before {
  content: "\\f5cf"; }

.la-wizards-of-the-coast:before {
  content: "\\f730"; }

.la-wolf-pack-battalion:before {
  content: "\\f514"; }

.la-won-sign:before {
  content: "\\f159"; }

.la-wordpress:before {
  content: "\\f19a"; }

.la-wordpress-simple:before {
  content: "\\f411"; }

.la-wpbeginner:before {
  content: "\\f297"; }

.la-wpexplorer:before {
  content: "\\f2de"; }

.la-wpforms:before {
  content: "\\f298"; }

.la-wpressr:before {
  content: "\\f3e4"; }

.la-wrench:before {
  content: "\\f0ad"; }

.la-x-ray:before {
  content: "\\f497"; }

.la-xbox:before {
  content: "\\f412"; }

.la-xing:before {
  content: "\\f168"; }

.la-xing-square:before {
  content: "\\f169"; }

.la-y-combinator:before {
  content: "\\f23b"; }

.la-yahoo:before {
  content: "\\f19e"; }

.la-yammer:before {
  content: "\\f840"; }

.la-yandex:before {
  content: "\\f413"; }

.la-yandex-international:before {
  content: "\\f414"; }

.la-yarn:before {
  content: "\\f7e3"; }

.la-yelp:before {
  content: "\\f1e9"; }

.la-yen-sign:before {
  content: "\\f157"; }

.la-yin-yang:before {
  content: "\\f6ad"; }

.la-yoast:before {
  content: "\\f2b1"; }

.la-youtube:before {
  content: "\\f167"; }

.la-youtube-square:before {
  content: "\\f431"; }

.la-zhihu:before {
  content: "\\f63f"; }

.sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px; }

.sr-only-focusable:active, .sr-only-focusable:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  width: auto; }

@font-face {
  font-family: 'Line Awesome Brands';
  font-style: normal;
  font-weight: normal;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("svg"); }

.lab {
  font-family: 'Line Awesome Brands'; }

@font-face {
  font-family: 'Line Awesome Free';
  font-style: normal;
  font-weight: 400;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("svg"); }

.lar {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

@font-face {
  font-family: 'Line Awesome Free';
  font-style: normal;
  font-weight: 900;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("svg"); }

.la,
.las {
  font-family: 'Line Awesome Free';
  font-weight: 900; }

.la.la-glass:before {
  content: "\\f000"; }

.la.la-meetup {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-star-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-star-o:before {
  content: "\\f005"; }

.la.la-remove:before {
  content: "\\f00d"; }

.la.la-close:before {
  content: "\\f00d"; }

.la.la-gear:before {
  content: "\\f013"; }

.la.la-trash-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-trash-o:before {
  content: "\\f2ed"; }

.la.la-file-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-o:before {
  content: "\\f15b"; }

.la.la-clock-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-clock-o:before {
  content: "\\f017"; }

.la.la-arrow-circle-o-down {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-arrow-circle-o-down:before {
  content: "\\f358"; }

.la.la-arrow-circle-o-up {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-arrow-circle-o-up:before {
  content: "\\f35b"; }

.la.la-play-circle-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-play-circle-o:before {
  content: "\\f144"; }

.la.la-repeat:before {
  content: "\\f01e"; }

.la.la-rotate-right:before {
  content: "\\f01e"; }

.la.la-refresh:before {
  content: "\\f021"; }

.la.la-list-alt {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-dedent:before {
  content: "\\f03b"; }

.la.la-video-camera:before {
  content: "\\f03d"; }

.la.la-picture-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-picture-o:before {
  content: "\\f03e"; }

.la.la-photo {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-photo:before {
  content: "\\f03e"; }

.la.la-image {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-image:before {
  content: "\\f03e"; }

.la.la-pencil:before {
  content: "\\f303"; }

.la.la-map-marker:before {
  content: "\\f3c5"; }

.la.la-pencil-square-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-pencil-square-o:before {
  content: "\\f044"; }

.la.la-share-square-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-share-square-o:before {
  content: "\\f14d"; }

.la.la-check-square-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-check-square-o:before {
  content: "\\f14a"; }

.la.la-arrows:before {
  content: "\\f0b2"; }

.la.la-times-circle-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-times-circle-o:before {
  content: "\\f057"; }

.la.la-check-circle-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-check-circle-o:before {
  content: "\\f058"; }

.la.la-mail-forward:before {
  content: "\\f064"; }

.la.la-eye {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-eye-slash {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-warning:before {
  content: "\\f071"; }

.la.la-calendar:before {
  content: "\\f073"; }

.la.la-arrows-v:before {
  content: "\\f338"; }

.la.la-arrows-h:before {
  content: "\\f337"; }

.la.la-bar-chart {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-bar-chart:before {
  content: "\\f080"; }

.la.la-bar-chart-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-bar-chart-o:before {
  content: "\\f080"; }

.la.la-twitter-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-facebook-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-gears:before {
  content: "\\f085"; }

.la.la-thumbs-o-up {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-thumbs-o-up:before {
  content: "\\f164"; }

.la.la-thumbs-o-down {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-thumbs-o-down:before {
  content: "\\f165"; }

.la.la-heart-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-heart-o:before {
  content: "\\f004"; }

.la.la-sign-out:before {
  content: "\\f2f5"; }

.la.la-linkedin-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-linkedin-square:before {
  content: "\\f08c"; }

.la.la-thumb-tack:before {
  content: "\\f08d"; }

.la.la-external-link:before {
  content: "\\f35d"; }

.la.la-sign-in:before {
  content: "\\f2f6"; }

.la.la-github-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-lemon-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-lemon-o:before {
  content: "\\f094"; }

.la.la-square-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-square-o:before {
  content: "\\f0c8"; }

.la.la-bookmark-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-bookmark-o:before {
  content: "\\f02e"; }

.la.la-twitter {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-facebook {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-facebook:before {
  content: "\\f39e"; }

.la.la-facebook-f {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-facebook-f:before {
  content: "\\f39e"; }

.la.la-github {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-credit-card {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-feed:before {
  content: "\\f09e"; }

.la.la-hdd-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hdd-o:before {
  content: "\\f0a0"; }

.la.la-hand-o-right {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-o-right:before {
  content: "\\f0a4"; }

.la.la-hand-o-left {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-o-left:before {
  content: "\\f0a5"; }

.la.la-hand-o-up {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-o-up:before {
  content: "\\f0a6"; }

.la.la-hand-o-down {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-o-down:before {
  content: "\\f0a7"; }

.la.la-arrows-alt:before {
  content: "\\f31e"; }

.la.la-group:before {
  content: "\\f0c0"; }

.la.la-chain:before {
  content: "\\f0c1"; }

.la.la-scissors:before {
  content: "\\f0c4"; }

.la.la-files-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-files-o:before {
  content: "\\f0c5"; }

.la.la-floppy-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-floppy-o:before {
  content: "\\f0c7"; }

.la.la-navicon:before {
  content: "\\f0c9"; }

.la.la-reorder:before {
  content: "\\f0c9"; }

.la.la-pinterest {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-pinterest-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-google-plus-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-google-plus {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-google-plus:before {
  content: "\\f0d5"; }

.la.la-money {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-money:before {
  content: "\\f3d1"; }

.la.la-unsorted:before {
  content: "\\f0dc"; }

.la.la-sort-desc:before {
  content: "\\f0dd"; }

.la.la-sort-asc:before {
  content: "\\f0de"; }

.la.la-linkedin {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-linkedin:before {
  content: "\\f0e1"; }

.la.la-rotate-left:before {
  content: "\\f0e2"; }

.la.la-legal:before {
  content: "\\f0e3"; }

.la.la-tachometer:before {
  content: "\\f3fd"; }

.la.la-dashboard:before {
  content: "\\f3fd"; }

.la.la-comment-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-comment-o:before {
  content: "\\f075"; }

.la.la-comments-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-comments-o:before {
  content: "\\f086"; }

.la.la-flash:before {
  content: "\\f0e7"; }

.la.la-clipboard {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-paste {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-paste:before {
  content: "\\f328"; }

.la.la-lightbulb-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-lightbulb-o:before {
  content: "\\f0eb"; }

.la.la-exchange:before {
  content: "\\f362"; }

.la.la-cloud-download:before {
  content: "\\f381"; }

.la.la-cloud-upload:before {
  content: "\\f382"; }

.la.la-bell-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-bell-o:before {
  content: "\\f0f3"; }

.la.la-cutlery:before {
  content: "\\f2e7"; }

.la.la-file-text-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-text-o:before {
  content: "\\f15c"; }

.la.la-building-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-building-o:before {
  content: "\\f1ad"; }

.la.la-hospital-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hospital-o:before {
  content: "\\f0f8"; }

.la.la-tablet:before {
  content: "\\f3fa"; }

.la.la-mobile:before {
  content: "\\f3cd"; }

.la.la-mobile-phone:before {
  content: "\\f3cd"; }

.la.la-circle-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-circle-o:before {
  content: "\\f111"; }

.la.la-mail-reply:before {
  content: "\\f3e5"; }

.la.la-github-alt {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-folder-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-folder-o:before {
  content: "\\f07b"; }

.la.la-folder-open-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-folder-open-o:before {
  content: "\\f07c"; }

.la.la-smile-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-smile-o:before {
  content: "\\f118"; }

.la.la-frown-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-frown-o:before {
  content: "\\f119"; }

.la.la-meh-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-meh-o:before {
  content: "\\f11a"; }

.la.la-keyboard-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-keyboard-o:before {
  content: "\\f11c"; }

.la.la-flag-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-flag-o:before {
  content: "\\f024"; }

.la.la-mail-reply-all:before {
  content: "\\f122"; }

.la.la-star-half-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-star-half-o:before {
  content: "\\f089"; }

.la.la-star-half-empty {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-star-half-empty:before {
  content: "\\f089"; }

.la.la-star-half-full {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-star-half-full:before {
  content: "\\f089"; }

.la.la-code-fork:before {
  content: "\\f126"; }

.la.la-chain-broken:before {
  content: "\\f127"; }

.la.la-shield:before {
  content: "\\f3ed"; }

.la.la-calendar-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-calendar-o:before {
  content: "\\f133"; }

.la.la-maxcdn {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-html5 {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-css3 {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-ticket:before {
  content: "\\f3ff"; }

.la.la-minus-square-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-minus-square-o:before {
  content: "\\f146"; }

.la.la-level-up:before {
  content: "\\f3bf"; }

.la.la-level-down:before {
  content: "\\f3be"; }

.la.la-pencil-square:before {
  content: "\\f14b"; }

.la.la-external-link-square:before {
  content: "\\f360"; }

.la.la-compass {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-caret-square-o-down {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-caret-square-o-down:before {
  content: "\\f150"; }

.la.la-toggle-down {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-toggle-down:before {
  content: "\\f150"; }

.la.la-caret-square-o-up {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-caret-square-o-up:before {
  content: "\\f151"; }

.la.la-toggle-up {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-toggle-up:before {
  content: "\\f151"; }

.la.la-caret-square-o-right {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-caret-square-o-right:before {
  content: "\\f152"; }

.la.la-toggle-right {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-toggle-right:before {
  content: "\\f152"; }

.la.la-eur:before {
  content: "\\f153"; }

.la.la-euro:before {
  content: "\\f153"; }

.la.la-gbp:before {
  content: "\\f154"; }

.la.la-usd:before {
  content: "\\f155"; }

.la.la-dollar:before {
  content: "\\f155"; }

.la.la-inr:before {
  content: "\\f156"; }

.la.la-rupee:before {
  content: "\\f156"; }

.la.la-jpy:before {
  content: "\\f157"; }

.la.la-cny:before {
  content: "\\f157"; }

.la.la-rmb:before {
  content: "\\f157"; }

.la.la-yen:before {
  content: "\\f157"; }

.la.la-rub:before {
  content: "\\f158"; }

.la.la-ruble:before {
  content: "\\f158"; }

.la.la-rouble:before {
  content: "\\f158"; }

.la.la-krw:before {
  content: "\\f159"; }

.la.la-won:before {
  content: "\\f159"; }

.la.la-btc {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-bitcoin {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-bitcoin:before {
  content: "\\f15a"; }

.la.la-file-text:before {
  content: "\\f15c"; }

.la.la-sort-alpha-asc:before {
  content: "\\f15d"; }

.la.la-sort-alpha-desc:before {
  content: "\\f881"; }

.la.la-sort-amount-asc:before {
  content: "\\f160"; }

.la.la-sort-amount-desc:before {
  content: "\\f884"; }

.la.la-sort-numeric-asc:before {
  content: "\\f162"; }

.la.la-sort-numeric-desc:before {
  content: "\\f886"; }

.la.la-youtube-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-youtube {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-xing {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-xing-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-youtube-play {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-youtube-play:before {
  content: "\\f167"; }

.la.la-dropbox {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-stack-overflow {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-instagram {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-flickr {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-adn {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-bitbucket {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-bitbucket-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-bitbucket-square:before {
  content: "\\f171"; }

.la.la-tumblr {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-tumblr-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-long-arrow-down:before {
  content: "\\f309"; }

.la.la-long-arrow-up:before {
  content: "\\f30c"; }

.la.la-long-arrow-left:before {
  content: "\\f30a"; }

.la.la-long-arrow-right:before {
  content: "\\f30b"; }

.la.la-apple {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-windows {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-android {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-linux {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-dribbble {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-skype {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-foursquare {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-trello {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-gratipay {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-gittip {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-gittip:before {
  content: "\\f184"; }

.la.la-sun-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-sun-o:before {
  content: "\\f185"; }

.la.la-moon-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-moon-o:before {
  content: "\\f186"; }

.la.la-vk {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-weibo {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-renren {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-pagelines {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-stack-exchange {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-arrow-circle-o-right {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-arrow-circle-o-right:before {
  content: "\\f35a"; }

.la.la-arrow-circle-o-left {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-arrow-circle-o-left:before {
  content: "\\f359"; }

.la.la-caret-square-o-left {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-caret-square-o-left:before {
  content: "\\f191"; }

.la.la-toggle-left {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-toggle-left:before {
  content: "\\f191"; }

.la.la-dot-circle-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-dot-circle-o:before {
  content: "\\f192"; }

.la.la-vimeo-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-try:before {
  content: "\\f195"; }

.la.la-turkish-lira:before {
  content: "\\f195"; }

.la.la-plus-square-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-plus-square-o:before {
  content: "\\f0fe"; }

.la.la-slack {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-wordpress {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-openid {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-institution:before {
  content: "\\f19c"; }

.la.la-bank:before {
  content: "\\f19c"; }

.la.la-mortar-board:before {
  content: "\\f19d"; }

.la.la-yahoo {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-google {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-reddit {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-reddit-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-stumbleupon-circle {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-stumbleupon {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-delicious {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-digg {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-pied-piper-pp {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-pied-piper-alt {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-drupal {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-joomla {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-spoon:before {
  content: "\\f2e5"; }

.la.la-behance {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-behance-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-steam {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-steam-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-automobile:before {
  content: "\\f1b9"; }

.la.la-cab:before {
  content: "\\f1ba"; }

.la.la-envelope-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-envelope-o:before {
  content: "\\f0e0"; }

.la.la-deviantart {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-soundcloud {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-file-pdf-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-pdf-o:before {
  content: "\\f1c1"; }

.la.la-file-word-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-word-o:before {
  content: "\\f1c2"; }

.la.la-file-excel-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-excel-o:before {
  content: "\\f1c3"; }

.la.la-file-powerpoint-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-powerpoint-o:before {
  content: "\\f1c4"; }

.la.la-file-image-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-image-o:before {
  content: "\\f1c5"; }

.la.la-file-photo-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-photo-o:before {
  content: "\\f1c5"; }

.la.la-file-picture-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-picture-o:before {
  content: "\\f1c5"; }

.la.la-file-archive-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-archive-o:before {
  content: "\\f1c6"; }

.la.la-file-zip-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-zip-o:before {
  content: "\\f1c6"; }

.la.la-file-audio-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-audio-o:before {
  content: "\\f1c7"; }

.la.la-file-sound-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-sound-o:before {
  content: "\\f1c7"; }

.la.la-file-video-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-video-o:before {
  content: "\\f1c8"; }

.la.la-file-movie-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-movie-o:before {
  content: "\\f1c8"; }

.la.la-file-code-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-code-o:before {
  content: "\\f1c9"; }

.la.la-vine {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-codepen {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-jsfiddle {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-life-ring {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-life-bouy {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-life-bouy:before {
  content: "\\f1cd"; }

.la.la-life-buoy {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-life-buoy:before {
  content: "\\f1cd"; }

.la.la-life-saver {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-life-saver:before {
  content: "\\f1cd"; }

.la.la-support {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-support:before {
  content: "\\f1cd"; }

.la.la-circle-o-notch:before {
  content: "\\f1ce"; }

.la.la-rebel {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-ra {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-ra:before {
  content: "\\f1d0"; }

.la.la-resistance {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-resistance:before {
  content: "\\f1d0"; }

.la.la-empire {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-ge {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-ge:before {
  content: "\\f1d1"; }

.la.la-git-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-git {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-hacker-news {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-y-combinator-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-y-combinator-square:before {
  content: "\\f1d4"; }

.la.la-yc-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-yc-square:before {
  content: "\\f1d4"; }

.la.la-tencent-weibo {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-qq {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-weixin {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-wechat {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-wechat:before {
  content: "\\f1d7"; }

.la.la-send:before {
  content: "\\f1d8"; }

.la.la-paper-plane-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-paper-plane-o:before {
  content: "\\f1d8"; }

.la.la-send-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-send-o:before {
  content: "\\f1d8"; }

.la.la-circle-thin {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-circle-thin:before {
  content: "\\f111"; }

.la.la-header:before {
  content: "\\f1dc"; }

.la.la-sliders:before {
  content: "\\f1de"; }

.la.la-futbol-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-futbol-o:before {
  content: "\\f1e3"; }

.la.la-soccer-ball-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-soccer-ball-o:before {
  content: "\\f1e3"; }

.la.la-slideshare {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-twitch {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-yelp {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-newspaper-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-newspaper-o:before {
  content: "\\f1ea"; }

.la.la-paypal {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-google-wallet {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-cc-visa {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-cc-mastercard {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-cc-discover {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-cc-amex {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-cc-paypal {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-cc-stripe {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-bell-slash-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-bell-slash-o:before {
  content: "\\f1f6"; }

.la.la-trash:before {
  content: "\\f2ed"; }

.la.la-copyright {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-eyedropper:before {
  content: "\\f1fb"; }

.la.la-area-chart:before {
  content: "\\f1fe"; }

.la.la-pie-chart:before {
  content: "\\f200"; }

.la.la-line-chart:before {
  content: "\\f201"; }

.la.la-lastfm {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-lastfm-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-ioxhost {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-angellist {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-cc {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-cc:before {
  content: "\\f20a"; }

.la.la-ils:before {
  content: "\\f20b"; }

.la.la-shekel:before {
  content: "\\f20b"; }

.la.la-sheqel:before {
  content: "\\f20b"; }

.la.la-meanpath {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-meanpath:before {
  content: "\\f2b4"; }

.la.la-buysellads {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-connectdevelop {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-dashcube {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-forumbee {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-leanpub {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-sellsy {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-shirtsinbulk {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-simplybuilt {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-skyatlas {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-diamond {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-diamond:before {
  content: "\\f3a5"; }

.la.la-intersex:before {
  content: "\\f224"; }

.la.la-facebook-official {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-facebook-official:before {
  content: "\\f09a"; }

.la.la-pinterest-p {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-whatsapp {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-hotel:before {
  content: "\\f236"; }

.la.la-viacoin {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-medium {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-y-combinator {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-yc {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-yc:before {
  content: "\\f23b"; }

.la.la-optin-monster {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-opencart {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-expeditedssl {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-battery-4:before {
  content: "\\f240"; }

.la.la-battery:before {
  content: "\\f240"; }

.la.la-battery-3:before {
  content: "\\f241"; }

.la.la-battery-2:before {
  content: "\\f242"; }

.la.la-battery-1:before {
  content: "\\f243"; }

.la.la-battery-0:before {
  content: "\\f244"; }

.la.la-object-group {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-object-ungroup {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-sticky-note-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-sticky-note-o:before {
  content: "\\f249"; }

.la.la-cc-jcb {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-cc-diners-club {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-clone {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hourglass-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hourglass-o:before {
  content: "\\f254"; }

.la.la-hourglass-1:before {
  content: "\\f251"; }

.la.la-hourglass-2:before {
  content: "\\f252"; }

.la.la-hourglass-3:before {
  content: "\\f253"; }

.la.la-hand-rock-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-rock-o:before {
  content: "\\f255"; }

.la.la-hand-grab-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-grab-o:before {
  content: "\\f255"; }

.la.la-hand-paper-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-paper-o:before {
  content: "\\f256"; }

.la.la-hand-stop-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-stop-o:before {
  content: "\\f256"; }

.la.la-hand-scissors-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-scissors-o:before {
  content: "\\f257"; }

.la.la-hand-lizard-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-lizard-o:before {
  content: "\\f258"; }

.la.la-hand-spock-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-spock-o:before {
  content: "\\f259"; }

.la.la-hand-pointer-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-pointer-o:before {
  content: "\\f25a"; }

.la.la-hand-peace-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-peace-o:before {
  content: "\\f25b"; }

.la.la-registered {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-creative-commons {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-gg {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-gg-circle {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-tripadvisor {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-odnoklassniki {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-odnoklassniki-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-get-pocket {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-wikipedia-w {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-safari {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-chrome {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-firefox {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-opera {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-internet-explorer {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-television:before {
  content: "\\f26c"; }

.la.la-contao {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-500px {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-amazon {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-calendar-plus-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-calendar-plus-o:before {
  content: "\\f271"; }

.la.la-calendar-minus-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-calendar-minus-o:before {
  content: "\\f272"; }

.la.la-calendar-times-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-calendar-times-o:before {
  content: "\\f273"; }

.la.la-calendar-check-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-calendar-check-o:before {
  content: "\\f274"; }

.la.la-map-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-map-o:before {
  content: "\\f279"; }

.la.la-commenting:before {
  content: "\\f4ad"; }

.la.la-commenting-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-commenting-o:before {
  content: "\\f4ad"; }

.la.la-houzz {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-vimeo {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-vimeo:before {
  content: "\\f27d"; }

.la.la-black-tie {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-fonticons {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-reddit-alien {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-edge {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-credit-card-alt:before {
  content: "\\f09d"; }

.la.la-codiepie {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-modx {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-fort-awesome {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-usb {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-product-hunt {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-mixcloud {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-scribd {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-pause-circle-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-pause-circle-o:before {
  content: "\\f28b"; }

.la.la-stop-circle-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-stop-circle-o:before {
  content: "\\f28d"; }

.la.la-bluetooth {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-bluetooth-b {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-gitlab {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-wpbeginner {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-wpforms {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-envira {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-wheelchair-alt {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-wheelchair-alt:before {
  content: "\\f368"; }

.la.la-question-circle-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-question-circle-o:before {
  content: "\\f059"; }

.la.la-volume-control-phone:before {
  content: "\\f2a0"; }

.la.la-asl-interpreting:before {
  content: "\\f2a3"; }

.la.la-deafness:before {
  content: "\\f2a4"; }

.la.la-hard-of-hearing:before {
  content: "\\f2a4"; }

.la.la-glide {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-glide-g {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-signing:before {
  content: "\\f2a7"; }

.la.la-viadeo {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-viadeo-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-snapchat {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-snapchat-ghost {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-snapchat-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-pied-piper {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-first-order {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-yoast {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-themeisle {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-google-plus-official {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-google-plus-official:before {
  content: "\\f2b3"; }

.la.la-google-plus-circle {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-google-plus-circle:before {
  content: "\\f2b3"; }

.la.la-font-awesome {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-fa {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-fa:before {
  content: "\\f2b4"; }

.la.la-handshake-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-handshake-o:before {
  content: "\\f2b5"; }

.la.la-envelope-open-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-envelope-open-o:before {
  content: "\\f2b6"; }

.la.la-linode {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-address-book-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-address-book-o:before {
  content: "\\f2b9"; }

.la.la-vcard:before {
  content: "\\f2bb"; }

.la.la-address-card-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-address-card-o:before {
  content: "\\f2bb"; }

.la.la-vcard-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-vcard-o:before {
  content: "\\f2bb"; }

.la.la-user-circle-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-user-circle-o:before {
  content: "\\f2bd"; }

.la.la-user-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-user-o:before {
  content: "\\f007"; }

.la.la-id-badge {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-drivers-license:before {
  content: "\\f2c2"; }

.la.la-id-card-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-id-card-o:before {
  content: "\\f2c2"; }

.la.la-drivers-license-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-drivers-license-o:before {
  content: "\\f2c2"; }

.la.la-quora {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-free-code-camp {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-telegram {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-thermometer-4:before {
  content: "\\f2c7"; }

.la.la-thermometer:before {
  content: "\\f2c7"; }

.la.la-thermometer-3:before {
  content: "\\f2c8"; }

.la.la-thermometer-2:before {
  content: "\\f2c9"; }

.la.la-thermometer-1:before {
  content: "\\f2ca"; }

.la.la-thermometer-0:before {
  content: "\\f2cb"; }

.la.la-bathtub:before {
  content: "\\f2cd"; }

.la.la-s15:before {
  content: "\\f2cd"; }

.la.la-window-maximize {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-window-restore {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-times-rectangle:before {
  content: "\\f410"; }

.la.la-window-close-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-window-close-o:before {
  content: "\\f410"; }

.la.la-times-rectangle-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-times-rectangle-o:before {
  content: "\\f410"; }

.la.la-bandcamp {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-grav {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-etsy {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-imdb {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-ravelry {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-eercast {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-eercast:before {
  content: "\\f2da"; }

.la.la-snowflake-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-snowflake-o:before {
  content: "\\f2dc"; }

.la.la-superpowers {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-wpexplorer {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-spotify {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

/*
* Remix Icon v2.5.0
* https://remixicon.com
* https://github.com/Remix-Design/RemixIcon
*
* Copyright RemixIcon.com
* Released under the Apache License Version 2.0
*
* Date: 2020-05-23
*/
@font-face {
  font-family: "remixicon";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  /* IE9*/
  src: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("svg");
  /* iOS 4.1- */
  font-display: swap; }

[class^="ri-"], [class*=" ri-"] {
  font-family: 'remixicon' !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; }

.ri-lg {
  font-size: 1.3333em;
  line-height: 0.75em;
  vertical-align: -.0667em; }

.ri-xl {
  font-size: 1.5em;
  line-height: 0.6666em;
  vertical-align: -.075em; }

.ri-xxs {
  font-size: .5em; }

.ri-xs {
  font-size: .75em; }

.ri-sm {
  font-size: .875em; }

.ri-1x {
  font-size: 1em; }

.ri-2x {
  font-size: 2em; }

.ri-3x {
  font-size: 3em; }

.ri-4x {
  font-size: 4em; }

.ri-5x {
  font-size: 5em; }

.ri-6x {
  font-size: 6em; }

.ri-7x {
  font-size: 7em; }

.ri-8x {
  font-size: 8em; }

.ri-9x {
  font-size: 9em; }

.ri-10x {
  font-size: 10em; }

.ri-fw {
  text-align: center;
  width: 1.25em; }

.ri-24-hours-fill:before {
  content: "\\ea01"; }

.ri-24-hours-line:before {
  content: "\\ea02"; }

.ri-4k-fill:before {
  content: "\\ea03"; }

.ri-4k-line:before {
  content: "\\ea04"; }

.ri-a-b:before {
  content: "\\ea05"; }

.ri-account-box-fill:before {
  content: "\\ea06"; }

.ri-account-box-line:before {
  content: "\\ea07"; }

.ri-account-circle-fill:before {
  content: "\\ea08"; }

.ri-account-circle-line:before {
  content: "\\ea09"; }

.ri-account-pin-box-fill:before {
  content: "\\ea0a"; }

.ri-account-pin-box-line:before {
  content: "\\ea0b"; }

.ri-account-pin-circle-fill:before {
  content: "\\ea0c"; }

.ri-account-pin-circle-line:before {
  content: "\\ea0d"; }

.ri-add-box-fill:before {
  content: "\\ea0e"; }

.ri-add-box-line:before {
  content: "\\ea0f"; }

.ri-add-circle-fill:before {
  content: "\\ea10"; }

.ri-add-circle-line:before {
  content: "\\ea11"; }

.ri-add-fill:before {
  content: "\\ea12"; }

.ri-add-line:before {
  content: "\\ea13"; }

.ri-admin-fill:before {
  content: "\\ea14"; }

.ri-admin-line:before {
  content: "\\ea15"; }

.ri-advertisement-fill:before {
  content: "\\ea16"; }

.ri-advertisement-line:before {
  content: "\\ea17"; }

.ri-airplay-fill:before {
  content: "\\ea18"; }

.ri-airplay-line:before {
  content: "\\ea19"; }

.ri-alarm-fill:before {
  content: "\\ea1a"; }

.ri-alarm-line:before {
  content: "\\ea1b"; }

.ri-alarm-warning-fill:before {
  content: "\\ea1c"; }

.ri-alarm-warning-line:before {
  content: "\\ea1d"; }

.ri-album-fill:before {
  content: "\\ea1e"; }

.ri-album-line:before {
  content: "\\ea1f"; }

.ri-alert-fill:before {
  content: "\\ea20"; }

.ri-alert-line:before {
  content: "\\ea21"; }

.ri-aliens-fill:before {
  content: "\\ea22"; }

.ri-aliens-line:before {
  content: "\\ea23"; }

.ri-align-bottom:before {
  content: "\\ea24"; }

.ri-align-center:before {
  content: "\\ea25"; }

.ri-align-justify:before {
  content: "\\ea26"; }

.ri-align-left:before {
  content: "\\ea27"; }

.ri-align-right:before {
  content: "\\ea28"; }

.ri-align-top:before {
  content: "\\ea29"; }

.ri-align-vertically:before {
  content: "\\ea2a"; }

.ri-alipay-fill:before {
  content: "\\ea2b"; }

.ri-alipay-line:before {
  content: "\\ea2c"; }

.ri-amazon-fill:before {
  content: "\\ea2d"; }

.ri-amazon-line:before {
  content: "\\ea2e"; }

.ri-anchor-fill:before {
  content: "\\ea2f"; }

.ri-anchor-line:before {
  content: "\\ea30"; }

.ri-ancient-gate-fill:before {
  content: "\\ea31"; }

.ri-ancient-gate-line:before {
  content: "\\ea32"; }

.ri-ancient-pavilion-fill:before {
  content: "\\ea33"; }

.ri-ancient-pavilion-line:before {
  content: "\\ea34"; }

.ri-android-fill:before {
  content: "\\ea35"; }

.ri-android-line:before {
  content: "\\ea36"; }

.ri-angularjs-fill:before {
  content: "\\ea37"; }

.ri-angularjs-line:before {
  content: "\\ea38"; }

.ri-anticlockwise-2-fill:before {
  content: "\\ea39"; }

.ri-anticlockwise-2-line:before {
  content: "\\ea3a"; }

.ri-anticlockwise-fill:before {
  content: "\\ea3b"; }

.ri-anticlockwise-line:before {
  content: "\\ea3c"; }

.ri-app-store-fill:before {
  content: "\\ea3d"; }

.ri-app-store-line:before {
  content: "\\ea3e"; }

.ri-apple-fill:before {
  content: "\\ea3f"; }

.ri-apple-line:before {
  content: "\\ea40"; }

.ri-apps-2-fill:before {
  content: "\\ea41"; }

.ri-apps-2-line:before {
  content: "\\ea42"; }

.ri-apps-fill:before {
  content: "\\ea43"; }

.ri-apps-line:before {
  content: "\\ea44"; }

.ri-archive-drawer-fill:before {
  content: "\\ea45"; }

.ri-archive-drawer-line:before {
  content: "\\ea46"; }

.ri-archive-fill:before {
  content: "\\ea47"; }

.ri-archive-line:before {
  content: "\\ea48"; }

.ri-arrow-down-circle-fill:before {
  content: "\\ea49"; }

.ri-arrow-down-circle-line:before {
  content: "\\ea4a"; }

.ri-arrow-down-fill:before {
  content: "\\ea4b"; }

.ri-arrow-down-line:before {
  content: "\\ea4c"; }

.ri-arrow-down-s-fill:before {
  content: "\\ea4d"; }

.ri-arrow-down-s-line:before {
  content: "\\ea4e"; }

.ri-arrow-drop-down-fill:before {
  content: "\\ea4f"; }

.ri-arrow-drop-down-line:before {
  content: "\\ea50"; }

.ri-arrow-drop-left-fill:before {
  content: "\\ea51"; }

.ri-arrow-drop-left-line:before {
  content: "\\ea52"; }

.ri-arrow-drop-right-fill:before {
  content: "\\ea53"; }

.ri-arrow-drop-right-line:before {
  content: "\\ea54"; }

.ri-arrow-drop-up-fill:before {
  content: "\\ea55"; }

.ri-arrow-drop-up-line:before {
  content: "\\ea56"; }

.ri-arrow-go-back-fill:before {
  content: "\\ea57"; }

.ri-arrow-go-back-line:before {
  content: "\\ea58"; }

.ri-arrow-go-forward-fill:before {
  content: "\\ea59"; }

.ri-arrow-go-forward-line:before {
  content: "\\ea5a"; }

.ri-arrow-left-circle-fill:before {
  content: "\\ea5b"; }

.ri-arrow-left-circle-line:before {
  content: "\\ea5c"; }

.ri-arrow-left-down-fill:before {
  content: "\\ea5d"; }

.ri-arrow-left-down-line:before {
  content: "\\ea5e"; }

.ri-arrow-left-fill:before {
  content: "\\ea5f"; }

.ri-arrow-left-line:before {
  content: "\\ea60"; }

.ri-arrow-left-right-fill:before {
  content: "\\ea61"; }

.ri-arrow-left-right-line:before {
  content: "\\ea62"; }

.ri-arrow-left-s-fill:before {
  content: "\\ea63"; }

.ri-arrow-left-s-line:before {
  content: "\\ea64"; }

.ri-arrow-left-up-fill:before {
  content: "\\ea65"; }

.ri-arrow-left-up-line:before {
  content: "\\ea66"; }

.ri-arrow-right-circle-fill:before {
  content: "\\ea67"; }

.ri-arrow-right-circle-line:before {
  content: "\\ea68"; }

.ri-arrow-right-down-fill:before {
  content: "\\ea69"; }

.ri-arrow-right-down-line:before {
  content: "\\ea6a"; }

.ri-arrow-right-fill:before {
  content: "\\ea6b"; }

.ri-arrow-right-line:before {
  content: "\\ea6c"; }

.ri-arrow-right-s-fill:before {
  content: "\\ea6d"; }

.ri-arrow-right-s-line:before {
  content: "\\ea6e"; }

.ri-arrow-right-up-fill:before {
  content: "\\ea6f"; }

.ri-arrow-right-up-line:before {
  content: "\\ea70"; }

.ri-arrow-up-circle-fill:before {
  content: "\\ea71"; }

.ri-arrow-up-circle-line:before {
  content: "\\ea72"; }

.ri-arrow-up-down-fill:before {
  content: "\\ea73"; }

.ri-arrow-up-down-line:before {
  content: "\\ea74"; }

.ri-arrow-up-fill:before {
  content: "\\ea75"; }

.ri-arrow-up-line:before {
  content: "\\ea76"; }

.ri-arrow-up-s-fill:before {
  content: "\\ea77"; }

.ri-arrow-up-s-line:before {
  content: "\\ea78"; }

.ri-artboard-2-fill:before {
  content: "\\ea79"; }

.ri-artboard-2-line:before {
  content: "\\ea7a"; }

.ri-artboard-fill:before {
  content: "\\ea7b"; }

.ri-artboard-line:before {
  content: "\\ea7c"; }

.ri-article-fill:before {
  content: "\\ea7d"; }

.ri-article-line:before {
  content: "\\ea7e"; }

.ri-aspect-ratio-fill:before {
  content: "\\ea7f"; }

.ri-aspect-ratio-line:before {
  content: "\\ea80"; }

.ri-asterisk:before {
  content: "\\ea81"; }

.ri-at-fill:before {
  content: "\\ea82"; }

.ri-at-line:before {
  content: "\\ea83"; }

.ri-attachment-2:before {
  content: "\\ea84"; }

.ri-attachment-fill:before {
  content: "\\ea85"; }

.ri-attachment-line:before {
  content: "\\ea86"; }

.ri-auction-fill:before {
  content: "\\ea87"; }

.ri-auction-line:before {
  content: "\\ea88"; }

.ri-award-fill:before {
  content: "\\ea89"; }

.ri-award-line:before {
  content: "\\ea8a"; }

.ri-baidu-fill:before {
  content: "\\ea8b"; }

.ri-baidu-line:before {
  content: "\\ea8c"; }

.ri-ball-pen-fill:before {
  content: "\\ea8d"; }

.ri-ball-pen-line:before {
  content: "\\ea8e"; }

.ri-bank-card-2-fill:before {
  content: "\\ea8f"; }

.ri-bank-card-2-line:before {
  content: "\\ea90"; }

.ri-bank-card-fill:before {
  content: "\\ea91"; }

.ri-bank-card-line:before {
  content: "\\ea92"; }

.ri-bank-fill:before {
  content: "\\ea93"; }

.ri-bank-line:before {
  content: "\\ea94"; }

.ri-bar-chart-2-fill:before {
  content: "\\ea95"; }

.ri-bar-chart-2-line:before {
  content: "\\ea96"; }

.ri-bar-chart-box-fill:before {
  content: "\\ea97"; }

.ri-bar-chart-box-line:before {
  content: "\\ea98"; }

.ri-bar-chart-fill:before {
  content: "\\ea99"; }

.ri-bar-chart-grouped-fill:before {
  content: "\\ea9a"; }

.ri-bar-chart-grouped-line:before {
  content: "\\ea9b"; }

.ri-bar-chart-horizontal-fill:before {
  content: "\\ea9c"; }

.ri-bar-chart-horizontal-line:before {
  content: "\\ea9d"; }

.ri-bar-chart-line:before {
  content: "\\ea9e"; }

.ri-barcode-box-fill:before {
  content: "\\ea9f"; }

.ri-barcode-box-line:before {
  content: "\\eaa0"; }

.ri-barcode-fill:before {
  content: "\\eaa1"; }

.ri-barcode-line:before {
  content: "\\eaa2"; }

.ri-barricade-fill:before {
  content: "\\eaa3"; }

.ri-barricade-line:before {
  content: "\\eaa4"; }

.ri-base-station-fill:before {
  content: "\\eaa5"; }

.ri-base-station-line:before {
  content: "\\eaa6"; }

.ri-basketball-fill:before {
  content: "\\eaa7"; }

.ri-basketball-line:before {
  content: "\\eaa8"; }

.ri-battery-2-charge-fill:before {
  content: "\\eaa9"; }

.ri-battery-2-charge-line:before {
  content: "\\eaaa"; }

.ri-battery-2-fill:before {
  content: "\\eaab"; }

.ri-battery-2-line:before {
  content: "\\eaac"; }

.ri-battery-charge-fill:before {
  content: "\\eaad"; }

.ri-battery-charge-line:before {
  content: "\\eaae"; }

.ri-battery-fill:before {
  content: "\\eaaf"; }

.ri-battery-line:before {
  content: "\\eab0"; }

.ri-battery-low-fill:before {
  content: "\\eab1"; }

.ri-battery-low-line:before {
  content: "\\eab2"; }

.ri-battery-saver-fill:before {
  content: "\\eab3"; }

.ri-battery-saver-line:before {
  content: "\\eab4"; }

.ri-battery-share-fill:before {
  content: "\\eab5"; }

.ri-battery-share-line:before {
  content: "\\eab6"; }

.ri-bear-smile-fill:before {
  content: "\\eab7"; }

.ri-bear-smile-line:before {
  content: "\\eab8"; }

.ri-behance-fill:before {
  content: "\\eab9"; }

.ri-behance-line:before {
  content: "\\eaba"; }

.ri-bell-fill:before {
  content: "\\eabb"; }

.ri-bell-line:before {
  content: "\\eabc"; }

.ri-bike-fill:before {
  content: "\\eabd"; }

.ri-bike-line:before {
  content: "\\eabe"; }

.ri-bilibili-fill:before {
  content: "\\eabf"; }

.ri-bilibili-line:before {
  content: "\\eac0"; }

.ri-bill-fill:before {
  content: "\\eac1"; }

.ri-bill-line:before {
  content: "\\eac2"; }

.ri-billiards-fill:before {
  content: "\\eac3"; }

.ri-billiards-line:before {
  content: "\\eac4"; }

.ri-bit-coin-fill:before {
  content: "\\eac5"; }

.ri-bit-coin-line:before {
  content: "\\eac6"; }

.ri-blaze-fill:before {
  content: "\\eac7"; }

.ri-blaze-line:before {
  content: "\\eac8"; }

.ri-bluetooth-connect-fill:before {
  content: "\\eac9"; }

.ri-bluetooth-connect-line:before {
  content: "\\eaca"; }

.ri-bluetooth-fill:before {
  content: "\\eacb"; }

.ri-bluetooth-line:before {
  content: "\\eacc"; }

.ri-blur-off-fill:before {
  content: "\\eacd"; }

.ri-blur-off-line:before {
  content: "\\eace"; }

.ri-body-scan-fill:before {
  content: "\\eacf"; }

.ri-body-scan-line:before {
  content: "\\ead0"; }

.ri-bold:before {
  content: "\\ead1"; }

.ri-book-2-fill:before {
  content: "\\ead2"; }

.ri-book-2-line:before {
  content: "\\ead3"; }

.ri-book-3-fill:before {
  content: "\\ead4"; }

.ri-book-3-line:before {
  content: "\\ead5"; }

.ri-book-fill:before {
  content: "\\ead6"; }

.ri-book-line:before {
  content: "\\ead7"; }

.ri-book-mark-fill:before {
  content: "\\ead8"; }

.ri-book-mark-line:before {
  content: "\\ead9"; }

.ri-book-open-fill:before {
  content: "\\eada"; }

.ri-book-open-line:before {
  content: "\\eadb"; }

.ri-book-read-fill:before {
  content: "\\eadc"; }

.ri-book-read-line:before {
  content: "\\eadd"; }

.ri-booklet-fill:before {
  content: "\\eade"; }

.ri-booklet-line:before {
  content: "\\eadf"; }

.ri-bookmark-2-fill:before {
  content: "\\eae0"; }

.ri-bookmark-2-line:before {
  content: "\\eae1"; }

.ri-bookmark-3-fill:before {
  content: "\\eae2"; }

.ri-bookmark-3-line:before {
  content: "\\eae3"; }

.ri-bookmark-fill:before {
  content: "\\eae4"; }

.ri-bookmark-line:before {
  content: "\\eae5"; }

.ri-boxing-fill:before {
  content: "\\eae6"; }

.ri-boxing-line:before {
  content: "\\eae7"; }

.ri-braces-fill:before {
  content: "\\eae8"; }

.ri-braces-line:before {
  content: "\\eae9"; }

.ri-brackets-fill:before {
  content: "\\eaea"; }

.ri-brackets-line:before {
  content: "\\eaeb"; }

.ri-briefcase-2-fill:before {
  content: "\\eaec"; }

.ri-briefcase-2-line:before {
  content: "\\eaed"; }

.ri-briefcase-3-fill:before {
  content: "\\eaee"; }

.ri-briefcase-3-line:before {
  content: "\\eaef"; }

.ri-briefcase-4-fill:before {
  content: "\\eaf0"; }

.ri-briefcase-4-line:before {
  content: "\\eaf1"; }

.ri-briefcase-5-fill:before {
  content: "\\eaf2"; }

.ri-briefcase-5-line:before {
  content: "\\eaf3"; }

.ri-briefcase-fill:before {
  content: "\\eaf4"; }

.ri-briefcase-line:before {
  content: "\\eaf5"; }

.ri-bring-forward:before {
  content: "\\eaf6"; }

.ri-bring-to-front:before {
  content: "\\eaf7"; }

.ri-broadcast-fill:before {
  content: "\\eaf8"; }

.ri-broadcast-line:before {
  content: "\\eaf9"; }

.ri-brush-2-fill:before {
  content: "\\eafa"; }

.ri-brush-2-line:before {
  content: "\\eafb"; }

.ri-brush-3-fill:before {
  content: "\\eafc"; }

.ri-brush-3-line:before {
  content: "\\eafd"; }

.ri-brush-4-fill:before {
  content: "\\eafe"; }

.ri-brush-4-line:before {
  content: "\\eaff"; }

.ri-brush-fill:before {
  content: "\\eb00"; }

.ri-brush-line:before {
  content: "\\eb01"; }

.ri-bubble-chart-fill:before {
  content: "\\eb02"; }

.ri-bubble-chart-line:before {
  content: "\\eb03"; }

.ri-bug-2-fill:before {
  content: "\\eb04"; }

.ri-bug-2-line:before {
  content: "\\eb05"; }

.ri-bug-fill:before {
  content: "\\eb06"; }

.ri-bug-line:before {
  content: "\\eb07"; }

.ri-building-2-fill:before {
  content: "\\eb08"; }

.ri-building-2-line:before {
  content: "\\eb09"; }

.ri-building-3-fill:before {
  content: "\\eb0a"; }

.ri-building-3-line:before {
  content: "\\eb0b"; }

.ri-building-4-fill:before {
  content: "\\eb0c"; }

.ri-building-4-line:before {
  content: "\\eb0d"; }

.ri-building-fill:before {
  content: "\\eb0e"; }

.ri-building-line:before {
  content: "\\eb0f"; }

.ri-bus-2-fill:before {
  content: "\\eb10"; }

.ri-bus-2-line:before {
  content: "\\eb11"; }

.ri-bus-fill:before {
  content: "\\eb12"; }

.ri-bus-line:before {
  content: "\\eb13"; }

.ri-bus-wifi-fill:before {
  content: "\\eb14"; }

.ri-bus-wifi-line:before {
  content: "\\eb15"; }

.ri-cactus-fill:before {
  content: "\\eb16"; }

.ri-cactus-line:before {
  content: "\\eb17"; }

.ri-cake-2-fill:before {
  content: "\\eb18"; }

.ri-cake-2-line:before {
  content: "\\eb19"; }

.ri-cake-3-fill:before {
  content: "\\eb1a"; }

.ri-cake-3-line:before {
  content: "\\eb1b"; }

.ri-cake-fill:before {
  content: "\\eb1c"; }

.ri-cake-line:before {
  content: "\\eb1d"; }

.ri-calculator-fill:before {
  content: "\\eb1e"; }

.ri-calculator-line:before {
  content: "\\eb1f"; }

.ri-calendar-2-fill:before {
  content: "\\eb20"; }

.ri-calendar-2-line:before {
  content: "\\eb21"; }

.ri-calendar-check-fill:before {
  content: "\\eb22"; }

.ri-calendar-check-line:before {
  content: "\\eb23"; }

.ri-calendar-event-fill:before {
  content: "\\eb24"; }

.ri-calendar-event-line:before {
  content: "\\eb25"; }

.ri-calendar-fill:before {
  content: "\\eb26"; }

.ri-calendar-line:before {
  content: "\\eb27"; }

.ri-calendar-todo-fill:before {
  content: "\\eb28"; }

.ri-calendar-todo-line:before {
  content: "\\eb29"; }

.ri-camera-2-fill:before {
  content: "\\eb2a"; }

.ri-camera-2-line:before {
  content: "\\eb2b"; }

.ri-camera-3-fill:before {
  content: "\\eb2c"; }

.ri-camera-3-line:before {
  content: "\\eb2d"; }

.ri-camera-fill:before {
  content: "\\eb2e"; }

.ri-camera-lens-fill:before {
  content: "\\eb2f"; }

.ri-camera-lens-line:before {
  content: "\\eb30"; }

.ri-camera-line:before {
  content: "\\eb31"; }

.ri-camera-off-fill:before {
  content: "\\eb32"; }

.ri-camera-off-line:before {
  content: "\\eb33"; }

.ri-camera-switch-fill:before {
  content: "\\eb34"; }

.ri-camera-switch-line:before {
  content: "\\eb35"; }

.ri-capsule-fill:before {
  content: "\\eb36"; }

.ri-capsule-line:before {
  content: "\\eb37"; }

.ri-car-fill:before {
  content: "\\eb38"; }

.ri-car-line:before {
  content: "\\eb39"; }

.ri-car-washing-fill:before {
  content: "\\eb3a"; }

.ri-car-washing-line:before {
  content: "\\eb3b"; }

.ri-caravan-fill:before {
  content: "\\eb3c"; }

.ri-caravan-line:before {
  content: "\\eb3d"; }

.ri-cast-fill:before {
  content: "\\eb3e"; }

.ri-cast-line:before {
  content: "\\eb3f"; }

.ri-cellphone-fill:before {
  content: "\\eb40"; }

.ri-cellphone-line:before {
  content: "\\eb41"; }

.ri-celsius-fill:before {
  content: "\\eb42"; }

.ri-celsius-line:before {
  content: "\\eb43"; }

.ri-centos-fill:before {
  content: "\\eb44"; }

.ri-centos-line:before {
  content: "\\eb45"; }

.ri-character-recognition-fill:before {
  content: "\\eb46"; }

.ri-character-recognition-line:before {
  content: "\\eb47"; }

.ri-charging-pile-2-fill:before {
  content: "\\eb48"; }

.ri-charging-pile-2-line:before {
  content: "\\eb49"; }

.ri-charging-pile-fill:before {
  content: "\\eb4a"; }

.ri-charging-pile-line:before {
  content: "\\eb4b"; }

.ri-chat-1-fill:before {
  content: "\\eb4c"; }

.ri-chat-1-line:before {
  content: "\\eb4d"; }

.ri-chat-2-fill:before {
  content: "\\eb4e"; }

.ri-chat-2-line:before {
  content: "\\eb4f"; }

.ri-chat-3-fill:before {
  content: "\\eb50"; }

.ri-chat-3-line:before {
  content: "\\eb51"; }

.ri-chat-4-fill:before {
  content: "\\eb52"; }

.ri-chat-4-line:before {
  content: "\\eb53"; }

.ri-chat-check-fill:before {
  content: "\\eb54"; }

.ri-chat-check-line:before {
  content: "\\eb55"; }

.ri-chat-delete-fill:before {
  content: "\\eb56"; }

.ri-chat-delete-line:before {
  content: "\\eb57"; }

.ri-chat-download-fill:before {
  content: "\\eb58"; }

.ri-chat-download-line:before {
  content: "\\eb59"; }

.ri-chat-follow-up-fill:before {
  content: "\\eb5a"; }

.ri-chat-follow-up-line:before {
  content: "\\eb5b"; }

.ri-chat-forward-fill:before {
  content: "\\eb5c"; }

.ri-chat-forward-line:before {
  content: "\\eb5d"; }

.ri-chat-heart-fill:before {
  content: "\\eb5e"; }

.ri-chat-heart-line:before {
  content: "\\eb5f"; }

.ri-chat-history-fill:before {
  content: "\\eb60"; }

.ri-chat-history-line:before {
  content: "\\eb61"; }

.ri-chat-new-fill:before {
  content: "\\eb62"; }

.ri-chat-new-line:before {
  content: "\\eb63"; }

.ri-chat-off-fill:before {
  content: "\\eb64"; }

.ri-chat-off-line:before {
  content: "\\eb65"; }

.ri-chat-poll-fill:before {
  content: "\\eb66"; }

.ri-chat-poll-line:before {
  content: "\\eb67"; }

.ri-chat-private-fill:before {
  content: "\\eb68"; }

.ri-chat-private-line:before {
  content: "\\eb69"; }

.ri-chat-quote-fill:before {
  content: "\\eb6a"; }

.ri-chat-quote-line:before {
  content: "\\eb6b"; }

.ri-chat-settings-fill:before {
  content: "\\eb6c"; }

.ri-chat-settings-line:before {
  content: "\\eb6d"; }

.ri-chat-smile-2-fill:before {
  content: "\\eb6e"; }

.ri-chat-smile-2-line:before {
  content: "\\eb6f"; }

.ri-chat-smile-3-fill:before {
  content: "\\eb70"; }

.ri-chat-smile-3-line:before {
  content: "\\eb71"; }

.ri-chat-smile-fill:before {
  content: "\\eb72"; }

.ri-chat-smile-line:before {
  content: "\\eb73"; }

.ri-chat-upload-fill:before {
  content: "\\eb74"; }

.ri-chat-upload-line:before {
  content: "\\eb75"; }

.ri-chat-voice-fill:before {
  content: "\\eb76"; }

.ri-chat-voice-line:before {
  content: "\\eb77"; }

.ri-check-double-fill:before {
  content: "\\eb78"; }

.ri-check-double-line:before {
  content: "\\eb79"; }

.ri-check-fill:before {
  content: "\\eb7a"; }

.ri-check-line:before {
  content: "\\eb7b"; }

.ri-checkbox-blank-circle-fill:before {
  content: "\\eb7c"; }

.ri-checkbox-blank-circle-line:before {
  content: "\\eb7d"; }

.ri-checkbox-blank-fill:before {
  content: "\\eb7e"; }

.ri-checkbox-blank-line:before {
  content: "\\eb7f"; }

.ri-checkbox-circle-fill:before {
  content: "\\eb80"; }

.ri-checkbox-circle-line:before {
  content: "\\eb81"; }

.ri-checkbox-fill:before {
  content: "\\eb82"; }

.ri-checkbox-indeterminate-fill:before {
  content: "\\eb83"; }

.ri-checkbox-indeterminate-line:before {
  content: "\\eb84"; }

.ri-checkbox-line:before {
  content: "\\eb85"; }

.ri-checkbox-multiple-blank-fill:before {
  content: "\\eb86"; }

.ri-checkbox-multiple-blank-line:before {
  content: "\\eb87"; }

.ri-checkbox-multiple-fill:before {
  content: "\\eb88"; }

.ri-checkbox-multiple-line:before {
  content: "\\eb89"; }

.ri-china-railway-fill:before {
  content: "\\eb8a"; }

.ri-china-railway-line:before {
  content: "\\eb8b"; }

.ri-chrome-fill:before {
  content: "\\eb8c"; }

.ri-chrome-line:before {
  content: "\\eb8d"; }

.ri-clapperboard-fill:before {
  content: "\\eb8e"; }

.ri-clapperboard-line:before {
  content: "\\eb8f"; }

.ri-clipboard-fill:before {
  content: "\\eb90"; }

.ri-clipboard-line:before {
  content: "\\eb91"; }

.ri-clockwise-2-fill:before {
  content: "\\eb92"; }

.ri-clockwise-2-line:before {
  content: "\\eb93"; }

.ri-clockwise-fill:before {
  content: "\\eb94"; }

.ri-clockwise-line:before {
  content: "\\eb95"; }

.ri-close-circle-fill:before {
  content: "\\eb96"; }

.ri-close-circle-line:before {
  content: "\\eb97"; }

.ri-close-fill:before {
  content: "\\eb98"; }

.ri-close-line:before {
  content: "\\eb99"; }

.ri-closed-captioning-fill:before {
  content: "\\eb9a"; }

.ri-closed-captioning-line:before {
  content: "\\eb9b"; }

.ri-cloud-fill:before {
  content: "\\eb9c"; }

.ri-cloud-line:before {
  content: "\\eb9d"; }

.ri-cloud-off-fill:before {
  content: "\\eb9e"; }

.ri-cloud-off-line:before {
  content: "\\eb9f"; }

.ri-cloud-windy-fill:before {
  content: "\\eba0"; }

.ri-cloud-windy-line:before {
  content: "\\eba1"; }

.ri-cloudy-2-fill:before {
  content: "\\eba2"; }

.ri-cloudy-2-line:before {
  content: "\\eba3"; }

.ri-cloudy-fill:before {
  content: "\\eba4"; }

.ri-cloudy-line:before {
  content: "\\eba5"; }

.ri-code-box-fill:before {
  content: "\\eba6"; }

.ri-code-box-line:before {
  content: "\\eba7"; }

.ri-code-fill:before {
  content: "\\eba8"; }

.ri-code-line:before {
  content: "\\eba9"; }

.ri-code-s-fill:before {
  content: "\\ebaa"; }

.ri-code-s-line:before {
  content: "\\ebab"; }

.ri-code-s-slash-fill:before {
  content: "\\ebac"; }

.ri-code-s-slash-line:before {
  content: "\\ebad"; }

.ri-code-view:before {
  content: "\\ebae"; }

.ri-codepen-fill:before {
  content: "\\ebaf"; }

.ri-codepen-line:before {
  content: "\\ebb0"; }

.ri-coin-fill:before {
  content: "\\ebb1"; }

.ri-coin-line:before {
  content: "\\ebb2"; }

.ri-coins-fill:before {
  content: "\\ebb3"; }

.ri-coins-line:before {
  content: "\\ebb4"; }

.ri-collage-fill:before {
  content: "\\ebb5"; }

.ri-collage-line:before {
  content: "\\ebb6"; }

.ri-command-fill:before {
  content: "\\ebb7"; }

.ri-command-line:before {
  content: "\\ebb8"; }

.ri-community-fill:before {
  content: "\\ebb9"; }

.ri-community-line:before {
  content: "\\ebba"; }

.ri-compass-2-fill:before {
  content: "\\ebbb"; }

.ri-compass-2-line:before {
  content: "\\ebbc"; }

.ri-compass-3-fill:before {
  content: "\\ebbd"; }

.ri-compass-3-line:before {
  content: "\\ebbe"; }

.ri-compass-4-fill:before {
  content: "\\ebbf"; }

.ri-compass-4-line:before {
  content: "\\ebc0"; }

.ri-compass-discover-fill:before {
  content: "\\ebc1"; }

.ri-compass-discover-line:before {
  content: "\\ebc2"; }

.ri-compass-fill:before {
  content: "\\ebc3"; }

.ri-compass-line:before {
  content: "\\ebc4"; }

.ri-compasses-2-fill:before {
  content: "\\ebc5"; }

.ri-compasses-2-line:before {
  content: "\\ebc6"; }

.ri-compasses-fill:before {
  content: "\\ebc7"; }

.ri-compasses-line:before {
  content: "\\ebc8"; }

.ri-computer-fill:before {
  content: "\\ebc9"; }

.ri-computer-line:before {
  content: "\\ebca"; }

.ri-contacts-book-2-fill:before {
  content: "\\ebcb"; }

.ri-contacts-book-2-line:before {
  content: "\\ebcc"; }

.ri-contacts-book-fill:before {
  content: "\\ebcd"; }

.ri-contacts-book-line:before {
  content: "\\ebce"; }

.ri-contacts-book-upload-fill:before {
  content: "\\ebcf"; }

.ri-contacts-book-upload-line:before {
  content: "\\ebd0"; }

.ri-contacts-fill:before {
  content: "\\ebd1"; }

.ri-contacts-line:before {
  content: "\\ebd2"; }

.ri-contrast-2-fill:before {
  content: "\\ebd3"; }

.ri-contrast-2-line:before {
  content: "\\ebd4"; }

.ri-contrast-drop-2-fill:before {
  content: "\\ebd5"; }

.ri-contrast-drop-2-line:before {
  content: "\\ebd6"; }

.ri-contrast-drop-fill:before {
  content: "\\ebd7"; }

.ri-contrast-drop-line:before {
  content: "\\ebd8"; }

.ri-contrast-fill:before {
  content: "\\ebd9"; }

.ri-contrast-line:before {
  content: "\\ebda"; }

.ri-copper-coin-fill:before {
  content: "\\ebdb"; }

.ri-copper-coin-line:before {
  content: "\\ebdc"; }

.ri-copper-diamond-fill:before {
  content: "\\ebdd"; }

.ri-copper-diamond-line:before {
  content: "\\ebde"; }

.ri-copyleft-fill:before {
  content: "\\ebdf"; }

.ri-copyleft-line:before {
  content: "\\ebe0"; }

.ri-copyright-fill:before {
  content: "\\ebe1"; }

.ri-copyright-line:before {
  content: "\\ebe2"; }

.ri-coreos-fill:before {
  content: "\\ebe3"; }

.ri-coreos-line:before {
  content: "\\ebe4"; }

.ri-coupon-2-fill:before {
  content: "\\ebe5"; }

.ri-coupon-2-line:before {
  content: "\\ebe6"; }

.ri-coupon-3-fill:before {
  content: "\\ebe7"; }

.ri-coupon-3-line:before {
  content: "\\ebe8"; }

.ri-coupon-4-fill:before {
  content: "\\ebe9"; }

.ri-coupon-4-line:before {
  content: "\\ebea"; }

.ri-coupon-5-fill:before {
  content: "\\ebeb"; }

.ri-coupon-5-line:before {
  content: "\\ebec"; }

.ri-coupon-fill:before {
  content: "\\ebed"; }

.ri-coupon-line:before {
  content: "\\ebee"; }

.ri-cpu-fill:before {
  content: "\\ebef"; }

.ri-cpu-line:before {
  content: "\\ebf0"; }

.ri-creative-commons-by-fill:before {
  content: "\\ebf1"; }

.ri-creative-commons-by-line:before {
  content: "\\ebf2"; }

.ri-creative-commons-fill:before {
  content: "\\ebf3"; }

.ri-creative-commons-line:before {
  content: "\\ebf4"; }

.ri-creative-commons-nc-fill:before {
  content: "\\ebf5"; }

.ri-creative-commons-nc-line:before {
  content: "\\ebf6"; }

.ri-creative-commons-nd-fill:before {
  content: "\\ebf7"; }

.ri-creative-commons-nd-line:before {
  content: "\\ebf8"; }

.ri-creative-commons-sa-fill:before {
  content: "\\ebf9"; }

.ri-creative-commons-sa-line:before {
  content: "\\ebfa"; }

.ri-creative-commons-zero-fill:before {
  content: "\\ebfb"; }

.ri-creative-commons-zero-line:before {
  content: "\\ebfc"; }

.ri-criminal-fill:before {
  content: "\\ebfd"; }

.ri-criminal-line:before {
  content: "\\ebfe"; }

.ri-crop-2-fill:before {
  content: "\\ebff"; }

.ri-crop-2-line:before {
  content: "\\ec00"; }

.ri-crop-fill:before {
  content: "\\ec01"; }

.ri-crop-line:before {
  content: "\\ec02"; }

.ri-css3-fill:before {
  content: "\\ec03"; }

.ri-css3-line:before {
  content: "\\ec04"; }

.ri-cup-fill:before {
  content: "\\ec05"; }

.ri-cup-line:before {
  content: "\\ec06"; }

.ri-currency-fill:before {
  content: "\\ec07"; }

.ri-currency-line:before {
  content: "\\ec08"; }

.ri-cursor-fill:before {
  content: "\\ec09"; }

.ri-cursor-line:before {
  content: "\\ec0a"; }

.ri-customer-service-2-fill:before {
  content: "\\ec0b"; }

.ri-customer-service-2-line:before {
  content: "\\ec0c"; }

.ri-customer-service-fill:before {
  content: "\\ec0d"; }

.ri-customer-service-line:before {
  content: "\\ec0e"; }

.ri-dashboard-2-fill:before {
  content: "\\ec0f"; }

.ri-dashboard-2-line:before {
  content: "\\ec10"; }

.ri-dashboard-3-fill:before {
  content: "\\ec11"; }

.ri-dashboard-3-line:before {
  content: "\\ec12"; }

.ri-dashboard-fill:before {
  content: "\\ec13"; }

.ri-dashboard-line:before {
  content: "\\ec14"; }

.ri-database-2-fill:before {
  content: "\\ec15"; }

.ri-database-2-line:before {
  content: "\\ec16"; }

.ri-database-fill:before {
  content: "\\ec17"; }

.ri-database-line:before {
  content: "\\ec18"; }

.ri-delete-back-2-fill:before {
  content: "\\ec19"; }

.ri-delete-back-2-line:before {
  content: "\\ec1a"; }

.ri-delete-back-fill:before {
  content: "\\ec1b"; }

.ri-delete-back-line:before {
  content: "\\ec1c"; }

.ri-delete-bin-2-fill:before {
  content: "\\ec1d"; }

.ri-delete-bin-2-line:before {
  content: "\\ec1e"; }

.ri-delete-bin-3-fill:before {
  content: "\\ec1f"; }

.ri-delete-bin-3-line:before {
  content: "\\ec20"; }

.ri-delete-bin-4-fill:before {
  content: "\\ec21"; }

.ri-delete-bin-4-line:before {
  content: "\\ec22"; }

.ri-delete-bin-5-fill:before {
  content: "\\ec23"; }

.ri-delete-bin-5-line:before {
  content: "\\ec24"; }

.ri-delete-bin-6-fill:before {
  content: "\\ec25"; }

.ri-delete-bin-6-line:before {
  content: "\\ec26"; }

.ri-delete-bin-7-fill:before {
  content: "\\ec27"; }

.ri-delete-bin-7-line:before {
  content: "\\ec28"; }

.ri-delete-bin-fill:before {
  content: "\\ec29"; }

.ri-delete-bin-line:before {
  content: "\\ec2a"; }

.ri-delete-column:before {
  content: "\\ec2b"; }

.ri-delete-row:before {
  content: "\\ec2c"; }

.ri-device-fill:before {
  content: "\\ec2d"; }

.ri-device-line:before {
  content: "\\ec2e"; }

.ri-device-recover-fill:before {
  content: "\\ec2f"; }

.ri-device-recover-line:before {
  content: "\\ec30"; }

.ri-dingding-fill:before {
  content: "\\ec31"; }

.ri-dingding-line:before {
  content: "\\ec32"; }

.ri-direction-fill:before {
  content: "\\ec33"; }

.ri-direction-line:before {
  content: "\\ec34"; }

.ri-disc-fill:before {
  content: "\\ec35"; }

.ri-disc-line:before {
  content: "\\ec36"; }

.ri-discord-fill:before {
  content: "\\ec37"; }

.ri-discord-line:before {
  content: "\\ec38"; }

.ri-discuss-fill:before {
  content: "\\ec39"; }

.ri-discuss-line:before {
  content: "\\ec3a"; }

.ri-dislike-fill:before {
  content: "\\ec3b"; }

.ri-dislike-line:before {
  content: "\\ec3c"; }

.ri-disqus-fill:before {
  content: "\\ec3d"; }

.ri-disqus-line:before {
  content: "\\ec3e"; }

.ri-divide-fill:before {
  content: "\\ec3f"; }

.ri-divide-line:before {
  content: "\\ec40"; }

.ri-donut-chart-fill:before {
  content: "\\ec41"; }

.ri-donut-chart-line:before {
  content: "\\ec42"; }

.ri-door-closed-fill:before {
  content: "\\ec43"; }

.ri-door-closed-line:before {
  content: "\\ec44"; }

.ri-door-fill:before {
  content: "\\ec45"; }

.ri-door-line:before {
  content: "\\ec46"; }

.ri-door-lock-box-fill:before {
  content: "\\ec47"; }

.ri-door-lock-box-line:before {
  content: "\\ec48"; }

.ri-door-lock-fill:before {
  content: "\\ec49"; }

.ri-door-lock-line:before {
  content: "\\ec4a"; }

.ri-door-open-fill:before {
  content: "\\ec4b"; }

.ri-door-open-line:before {
  content: "\\ec4c"; }

.ri-dossier-fill:before {
  content: "\\ec4d"; }

.ri-dossier-line:before {
  content: "\\ec4e"; }

.ri-douban-fill:before {
  content: "\\ec4f"; }

.ri-douban-line:before {
  content: "\\ec50"; }

.ri-double-quotes-l:before {
  content: "\\ec51"; }

.ri-double-quotes-r:before {
  content: "\\ec52"; }

.ri-download-2-fill:before {
  content: "\\ec53"; }

.ri-download-2-line:before {
  content: "\\ec54"; }

.ri-download-cloud-2-fill:before {
  content: "\\ec55"; }

.ri-download-cloud-2-line:before {
  content: "\\ec56"; }

.ri-download-cloud-fill:before {
  content: "\\ec57"; }

.ri-download-cloud-line:before {
  content: "\\ec58"; }

.ri-download-fill:before {
  content: "\\ec59"; }

.ri-download-line:before {
  content: "\\ec5a"; }

.ri-draft-fill:before {
  content: "\\ec5b"; }

.ri-draft-line:before {
  content: "\\ec5c"; }

.ri-drag-drop-fill:before {
  content: "\\ec5d"; }

.ri-drag-drop-line:before {
  content: "\\ec5e"; }

.ri-drag-move-2-fill:before {
  content: "\\ec5f"; }

.ri-drag-move-2-line:before {
  content: "\\ec60"; }

.ri-drag-move-fill:before {
  content: "\\ec61"; }

.ri-drag-move-line:before {
  content: "\\ec62"; }

.ri-dribbble-fill:before {
  content: "\\ec63"; }

.ri-dribbble-line:before {
  content: "\\ec64"; }

.ri-drive-fill:before {
  content: "\\ec65"; }

.ri-drive-line:before {
  content: "\\ec66"; }

.ri-drizzle-fill:before {
  content: "\\ec67"; }

.ri-drizzle-line:before {
  content: "\\ec68"; }

.ri-drop-fill:before {
  content: "\\ec69"; }

.ri-drop-line:before {
  content: "\\ec6a"; }

.ri-dropbox-fill:before {
  content: "\\ec6b"; }

.ri-dropbox-line:before {
  content: "\\ec6c"; }

.ri-dual-sim-1-fill:before {
  content: "\\ec6d"; }

.ri-dual-sim-1-line:before {
  content: "\\ec6e"; }

.ri-dual-sim-2-fill:before {
  content: "\\ec6f"; }

.ri-dual-sim-2-line:before {
  content: "\\ec70"; }

.ri-dv-fill:before {
  content: "\\ec71"; }

.ri-dv-line:before {
  content: "\\ec72"; }

.ri-dvd-fill:before {
  content: "\\ec73"; }

.ri-dvd-line:before {
  content: "\\ec74"; }

.ri-e-bike-2-fill:before {
  content: "\\ec75"; }

.ri-e-bike-2-line:before {
  content: "\\ec76"; }

.ri-e-bike-fill:before {
  content: "\\ec77"; }

.ri-e-bike-line:before {
  content: "\\ec78"; }

.ri-earth-fill:before {
  content: "\\ec79"; }

.ri-earth-line:before {
  content: "\\ec7a"; }

.ri-earthquake-fill:before {
  content: "\\ec7b"; }

.ri-earthquake-line:before {
  content: "\\ec7c"; }

.ri-edge-fill:before {
  content: "\\ec7d"; }

.ri-edge-line:before {
  content: "\\ec7e"; }

.ri-edit-2-fill:before {
  content: "\\ec7f"; }

.ri-edit-2-line:before {
  content: "\\ec80"; }

.ri-edit-box-fill:before {
  content: "\\ec81"; }

.ri-edit-box-line:before {
  content: "\\ec82"; }

.ri-edit-circle-fill:before {
  content: "\\ec83"; }

.ri-edit-circle-line:before {
  content: "\\ec84"; }

.ri-edit-fill:before {
  content: "\\ec85"; }

.ri-edit-line:before {
  content: "\\ec86"; }

.ri-eject-fill:before {
  content: "\\ec87"; }

.ri-eject-line:before {
  content: "\\ec88"; }

.ri-emotion-2-fill:before {
  content: "\\ec89"; }

.ri-emotion-2-line:before {
  content: "\\ec8a"; }

.ri-emotion-fill:before {
  content: "\\ec8b"; }

.ri-emotion-happy-fill:before {
  content: "\\ec8c"; }

.ri-emotion-happy-line:before {
  content: "\\ec8d"; }

.ri-emotion-laugh-fill:before {
  content: "\\ec8e"; }

.ri-emotion-laugh-line:before {
  content: "\\ec8f"; }

.ri-emotion-line:before {
  content: "\\ec90"; }

.ri-emotion-normal-fill:before {
  content: "\\ec91"; }

.ri-emotion-normal-line:before {
  content: "\\ec92"; }

.ri-emotion-sad-fill:before {
  content: "\\ec93"; }

.ri-emotion-sad-line:before {
  content: "\\ec94"; }

.ri-emotion-unhappy-fill:before {
  content: "\\ec95"; }

.ri-emotion-unhappy-line:before {
  content: "\\ec96"; }

.ri-empathize-fill:before {
  content: "\\ec97"; }

.ri-empathize-line:before {
  content: "\\ec98"; }

.ri-emphasis-cn:before {
  content: "\\ec99"; }

.ri-emphasis:before {
  content: "\\ec9a"; }

.ri-english-input:before {
  content: "\\ec9b"; }

.ri-equalizer-fill:before {
  content: "\\ec9c"; }

.ri-equalizer-line:before {
  content: "\\ec9d"; }

.ri-eraser-fill:before {
  content: "\\ec9e"; }

.ri-eraser-line:before {
  content: "\\ec9f"; }

.ri-error-warning-fill:before {
  content: "\\eca0"; }

.ri-error-warning-line:before {
  content: "\\eca1"; }

.ri-evernote-fill:before {
  content: "\\eca2"; }

.ri-evernote-line:before {
  content: "\\eca3"; }

.ri-exchange-box-fill:before {
  content: "\\eca4"; }

.ri-exchange-box-line:before {
  content: "\\eca5"; }

.ri-exchange-cny-fill:before {
  content: "\\eca6"; }

.ri-exchange-cny-line:before {
  content: "\\eca7"; }

.ri-exchange-dollar-fill:before {
  content: "\\eca8"; }

.ri-exchange-dollar-line:before {
  content: "\\eca9"; }

.ri-exchange-fill:before {
  content: "\\ecaa"; }

.ri-exchange-funds-fill:before {
  content: "\\ecab"; }

.ri-exchange-funds-line:before {
  content: "\\ecac"; }

.ri-exchange-line:before {
  content: "\\ecad"; }

.ri-external-link-fill:before {
  content: "\\ecae"; }

.ri-external-link-line:before {
  content: "\\ecaf"; }

.ri-eye-2-fill:before {
  content: "\\ecb0"; }

.ri-eye-2-line:before {
  content: "\\ecb1"; }

.ri-eye-close-fill:before {
  content: "\\ecb2"; }

.ri-eye-close-line:before {
  content: "\\ecb3"; }

.ri-eye-fill:before {
  content: "\\ecb4"; }

.ri-eye-line:before {
  content: "\\ecb5"; }

.ri-eye-off-fill:before {
  content: "\\ecb6"; }

.ri-eye-off-line:before {
  content: "\\ecb7"; }

.ri-facebook-box-fill:before {
  content: "\\ecb8"; }

.ri-facebook-box-line:before {
  content: "\\ecb9"; }

.ri-facebook-circle-fill:before {
  content: "\\ecba"; }

.ri-facebook-circle-line:before {
  content: "\\ecbb"; }

.ri-facebook-fill:before {
  content: "\\ecbc"; }

.ri-facebook-line:before {
  content: "\\ecbd"; }

.ri-fahrenheit-fill:before {
  content: "\\ecbe"; }

.ri-fahrenheit-line:before {
  content: "\\ecbf"; }

.ri-feedback-fill:before {
  content: "\\ecc0"; }

.ri-feedback-line:before {
  content: "\\ecc1"; }

.ri-file-2-fill:before {
  content: "\\ecc2"; }

.ri-file-2-line:before {
  content: "\\ecc3"; }

.ri-file-3-fill:before {
  content: "\\ecc4"; }

.ri-file-3-line:before {
  content: "\\ecc5"; }

.ri-file-4-fill:before {
  content: "\\ecc6"; }

.ri-file-4-line:before {
  content: "\\ecc7"; }

.ri-file-add-fill:before {
  content: "\\ecc8"; }

.ri-file-add-line:before {
  content: "\\ecc9"; }

.ri-file-chart-2-fill:before {
  content: "\\ecca"; }

.ri-file-chart-2-line:before {
  content: "\\eccb"; }

.ri-file-chart-fill:before {
  content: "\\eccc"; }

.ri-file-chart-line:before {
  content: "\\eccd"; }

.ri-file-cloud-fill:before {
  content: "\\ecce"; }

.ri-file-cloud-line:before {
  content: "\\eccf"; }

.ri-file-code-fill:before {
  content: "\\ecd0"; }

.ri-file-code-line:before {
  content: "\\ecd1"; }

.ri-file-copy-2-fill:before {
  content: "\\ecd2"; }

.ri-file-copy-2-line:before {
  content: "\\ecd3"; }

.ri-file-copy-fill:before {
  content: "\\ecd4"; }

.ri-file-copy-line:before {
  content: "\\ecd5"; }

.ri-file-damage-fill:before {
  content: "\\ecd6"; }

.ri-file-damage-line:before {
  content: "\\ecd7"; }

.ri-file-download-fill:before {
  content: "\\ecd8"; }

.ri-file-download-line:before {
  content: "\\ecd9"; }

.ri-file-edit-fill:before {
  content: "\\ecda"; }

.ri-file-edit-line:before {
  content: "\\ecdb"; }

.ri-file-excel-2-fill:before {
  content: "\\ecdc"; }

.ri-file-excel-2-line:before {
  content: "\\ecdd"; }

.ri-file-excel-fill:before {
  content: "\\ecde"; }

.ri-file-excel-line:before {
  content: "\\ecdf"; }

.ri-file-fill:before {
  content: "\\ece0"; }

.ri-file-forbid-fill:before {
  content: "\\ece1"; }

.ri-file-forbid-line:before {
  content: "\\ece2"; }

.ri-file-gif-fill:before {
  content: "\\ece3"; }

.ri-file-gif-line:before {
  content: "\\ece4"; }

.ri-file-history-fill:before {
  content: "\\ece5"; }

.ri-file-history-line:before {
  content: "\\ece6"; }

.ri-file-hwp-fill:before {
  content: "\\ece7"; }

.ri-file-hwp-line:before {
  content: "\\ece8"; }

.ri-file-info-fill:before {
  content: "\\ece9"; }

.ri-file-info-line:before {
  content: "\\ecea"; }

.ri-file-line:before {
  content: "\\eceb"; }

.ri-file-list-2-fill:before {
  content: "\\ecec"; }

.ri-file-list-2-line:before {
  content: "\\eced"; }

.ri-file-list-3-fill:before {
  content: "\\ecee"; }

.ri-file-list-3-line:before {
  content: "\\ecef"; }

.ri-file-list-fill:before {
  content: "\\ecf0"; }

.ri-file-list-line:before {
  content: "\\ecf1"; }

.ri-file-lock-fill:before {
  content: "\\ecf2"; }

.ri-file-lock-line:before {
  content: "\\ecf3"; }

.ri-file-mark-fill:before {
  content: "\\ecf4"; }

.ri-file-mark-line:before {
  content: "\\ecf5"; }

.ri-file-music-fill:before {
  content: "\\ecf6"; }

.ri-file-music-line:before {
  content: "\\ecf7"; }

.ri-file-paper-2-fill:before {
  content: "\\ecf8"; }

.ri-file-paper-2-line:before {
  content: "\\ecf9"; }

.ri-file-paper-fill:before {
  content: "\\ecfa"; }

.ri-file-paper-line:before {
  content: "\\ecfb"; }

.ri-file-pdf-fill:before {
  content: "\\ecfc"; }

.ri-file-pdf-line:before {
  content: "\\ecfd"; }

.ri-file-ppt-2-fill:before {
  content: "\\ecfe"; }

.ri-file-ppt-2-line:before {
  content: "\\ecff"; }

.ri-file-ppt-fill:before {
  content: "\\ed00"; }

.ri-file-ppt-line:before {
  content: "\\ed01"; }

.ri-file-reduce-fill:before {
  content: "\\ed02"; }

.ri-file-reduce-line:before {
  content: "\\ed03"; }

.ri-file-search-fill:before {
  content: "\\ed04"; }

.ri-file-search-line:before {
  content: "\\ed05"; }

.ri-file-settings-fill:before {
  content: "\\ed06"; }

.ri-file-settings-line:before {
  content: "\\ed07"; }

.ri-file-shield-2-fill:before {
  content: "\\ed08"; }

.ri-file-shield-2-line:before {
  content: "\\ed09"; }

.ri-file-shield-fill:before {
  content: "\\ed0a"; }

.ri-file-shield-line:before {
  content: "\\ed0b"; }

.ri-file-shred-fill:before {
  content: "\\ed0c"; }

.ri-file-shred-line:before {
  content: "\\ed0d"; }

.ri-file-text-fill:before {
  content: "\\ed0e"; }

.ri-file-text-line:before {
  content: "\\ed0f"; }

.ri-file-transfer-fill:before {
  content: "\\ed10"; }

.ri-file-transfer-line:before {
  content: "\\ed11"; }

.ri-file-unknow-fill:before {
  content: "\\ed12"; }

.ri-file-unknow-line:before {
  content: "\\ed13"; }

.ri-file-upload-fill:before {
  content: "\\ed14"; }

.ri-file-upload-line:before {
  content: "\\ed15"; }

.ri-file-user-fill:before {
  content: "\\ed16"; }

.ri-file-user-line:before {
  content: "\\ed17"; }

.ri-file-warning-fill:before {
  content: "\\ed18"; }

.ri-file-warning-line:before {
  content: "\\ed19"; }

.ri-file-word-2-fill:before {
  content: "\\ed1a"; }

.ri-file-word-2-line:before {
  content: "\\ed1b"; }

.ri-file-word-fill:before {
  content: "\\ed1c"; }

.ri-file-word-line:before {
  content: "\\ed1d"; }

.ri-file-zip-fill:before {
  content: "\\ed1e"; }

.ri-file-zip-line:before {
  content: "\\ed1f"; }

.ri-film-fill:before {
  content: "\\ed20"; }

.ri-film-line:before {
  content: "\\ed21"; }

.ri-filter-2-fill:before {
  content: "\\ed22"; }

.ri-filter-2-line:before {
  content: "\\ed23"; }

.ri-filter-3-fill:before {
  content: "\\ed24"; }

.ri-filter-3-line:before {
  content: "\\ed25"; }

.ri-filter-fill:before {
  content: "\\ed26"; }

.ri-filter-line:before {
  content: "\\ed27"; }

.ri-filter-off-fill:before {
  content: "\\ed28"; }

.ri-filter-off-line:before {
  content: "\\ed29"; }

.ri-find-replace-fill:before {
  content: "\\ed2a"; }

.ri-find-replace-line:before {
  content: "\\ed2b"; }

.ri-finder-fill:before {
  content: "\\ed2c"; }

.ri-finder-line:before {
  content: "\\ed2d"; }

.ri-fingerprint-2-fill:before {
  content: "\\ed2e"; }

.ri-fingerprint-2-line:before {
  content: "\\ed2f"; }

.ri-fingerprint-fill:before {
  content: "\\ed30"; }

.ri-fingerprint-line:before {
  content: "\\ed31"; }

.ri-fire-fill:before {
  content: "\\ed32"; }

.ri-fire-line:before {
  content: "\\ed33"; }

.ri-firefox-fill:before {
  content: "\\ed34"; }

.ri-firefox-line:before {
  content: "\\ed35"; }

.ri-first-aid-kit-fill:before {
  content: "\\ed36"; }

.ri-first-aid-kit-line:before {
  content: "\\ed37"; }

.ri-flag-2-fill:before {
  content: "\\ed38"; }

.ri-flag-2-line:before {
  content: "\\ed39"; }

.ri-flag-fill:before {
  content: "\\ed3a"; }

.ri-flag-line:before {
  content: "\\ed3b"; }

.ri-flashlight-fill:before {
  content: "\\ed3c"; }

.ri-flashlight-line:before {
  content: "\\ed3d"; }

.ri-flask-fill:before {
  content: "\\ed3e"; }

.ri-flask-line:before {
  content: "\\ed3f"; }

.ri-flight-land-fill:before {
  content: "\\ed40"; }

.ri-flight-land-line:before {
  content: "\\ed41"; }

.ri-flight-takeoff-fill:before {
  content: "\\ed42"; }

.ri-flight-takeoff-line:before {
  content: "\\ed43"; }

.ri-flood-fill:before {
  content: "\\ed44"; }

.ri-flood-line:before {
  content: "\\ed45"; }

.ri-flow-chart:before {
  content: "\\ed46"; }

.ri-flutter-fill:before {
  content: "\\ed47"; }

.ri-flutter-line:before {
  content: "\\ed48"; }

.ri-focus-2-fill:before {
  content: "\\ed49"; }

.ri-focus-2-line:before {
  content: "\\ed4a"; }

.ri-focus-3-fill:before {
  content: "\\ed4b"; }

.ri-focus-3-line:before {
  content: "\\ed4c"; }

.ri-focus-fill:before {
  content: "\\ed4d"; }

.ri-focus-line:before {
  content: "\\ed4e"; }

.ri-foggy-fill:before {
  content: "\\ed4f"; }

.ri-foggy-line:before {
  content: "\\ed50"; }

.ri-folder-2-fill:before {
  content: "\\ed51"; }

.ri-folder-2-line:before {
  content: "\\ed52"; }

.ri-folder-3-fill:before {
  content: "\\ed53"; }

.ri-folder-3-line:before {
  content: "\\ed54"; }

.ri-folder-4-fill:before {
  content: "\\ed55"; }

.ri-folder-4-line:before {
  content: "\\ed56"; }

.ri-folder-5-fill:before {
  content: "\\ed57"; }

.ri-folder-5-line:before {
  content: "\\ed58"; }

.ri-folder-add-fill:before {
  content: "\\ed59"; }

.ri-folder-add-line:before {
  content: "\\ed5a"; }

.ri-folder-chart-2-fill:before {
  content: "\\ed5b"; }

.ri-folder-chart-2-line:before {
  content: "\\ed5c"; }

.ri-folder-chart-fill:before {
  content: "\\ed5d"; }

.ri-folder-chart-line:before {
  content: "\\ed5e"; }

.ri-folder-download-fill:before {
  content: "\\ed5f"; }

.ri-folder-download-line:before {
  content: "\\ed60"; }

.ri-folder-fill:before {
  content: "\\ed61"; }

.ri-folder-forbid-fill:before {
  content: "\\ed62"; }

.ri-folder-forbid-line:before {
  content: "\\ed63"; }

.ri-folder-history-fill:before {
  content: "\\ed64"; }

.ri-folder-history-line:before {
  content: "\\ed65"; }

.ri-folder-info-fill:before {
  content: "\\ed66"; }

.ri-folder-info-line:before {
  content: "\\ed67"; }

.ri-folder-keyhole-fill:before {
  content: "\\ed68"; }

.ri-folder-keyhole-line:before {
  content: "\\ed69"; }

.ri-folder-line:before {
  content: "\\ed6a"; }

.ri-folder-lock-fill:before {
  content: "\\ed6b"; }

.ri-folder-lock-line:before {
  content: "\\ed6c"; }

.ri-folder-music-fill:before {
  content: "\\ed6d"; }

.ri-folder-music-line:before {
  content: "\\ed6e"; }

.ri-folder-open-fill:before {
  content: "\\ed6f"; }

.ri-folder-open-line:before {
  content: "\\ed70"; }

.ri-folder-received-fill:before {
  content: "\\ed71"; }

.ri-folder-received-line:before {
  content: "\\ed72"; }

.ri-folder-reduce-fill:before {
  content: "\\ed73"; }

.ri-folder-reduce-line:before {
  content: "\\ed74"; }

.ri-folder-settings-fill:before {
  content: "\\ed75"; }

.ri-folder-settings-line:before {
  content: "\\ed76"; }

.ri-folder-shared-fill:before {
  content: "\\ed77"; }

.ri-folder-shared-line:before {
  content: "\\ed78"; }

.ri-folder-shield-2-fill:before {
  content: "\\ed79"; }

.ri-folder-shield-2-line:before {
  content: "\\ed7a"; }

.ri-folder-shield-fill:before {
  content: "\\ed7b"; }

.ri-folder-shield-line:before {
  content: "\\ed7c"; }

.ri-folder-transfer-fill:before {
  content: "\\ed7d"; }

.ri-folder-transfer-line:before {
  content: "\\ed7e"; }

.ri-folder-unknow-fill:before {
  content: "\\ed7f"; }

.ri-folder-unknow-line:before {
  content: "\\ed80"; }

.ri-folder-upload-fill:before {
  content: "\\ed81"; }

.ri-folder-upload-line:before {
  content: "\\ed82"; }

.ri-folder-user-fill:before {
  content: "\\ed83"; }

.ri-folder-user-line:before {
  content: "\\ed84"; }

.ri-folder-warning-fill:before {
  content: "\\ed85"; }

.ri-folder-warning-line:before {
  content: "\\ed86"; }

.ri-folder-zip-fill:before {
  content: "\\ed87"; }

.ri-folder-zip-line:before {
  content: "\\ed88"; }

.ri-folders-fill:before {
  content: "\\ed89"; }

.ri-folders-line:before {
  content: "\\ed8a"; }

.ri-font-color:before {
  content: "\\ed8b"; }

.ri-font-size-2:before {
  content: "\\ed8c"; }

.ri-font-size:before {
  content: "\\ed8d"; }

.ri-football-fill:before {
  content: "\\ed8e"; }

.ri-football-line:before {
  content: "\\ed8f"; }

.ri-footprint-fill:before {
  content: "\\ed90"; }

.ri-footprint-line:before {
  content: "\\ed91"; }

.ri-forbid-2-fill:before {
  content: "\\ed92"; }

.ri-forbid-2-line:before {
  content: "\\ed93"; }

.ri-forbid-fill:before {
  content: "\\ed94"; }

.ri-forbid-line:before {
  content: "\\ed95"; }

.ri-format-clear:before {
  content: "\\ed96"; }

.ri-fridge-fill:before {
  content: "\\ed97"; }

.ri-fridge-line:before {
  content: "\\ed98"; }

.ri-fullscreen-exit-fill:before {
  content: "\\ed99"; }

.ri-fullscreen-exit-line:before {
  content: "\\ed9a"; }

.ri-fullscreen-fill:before {
  content: "\\ed9b"; }

.ri-fullscreen-line:before {
  content: "\\ed9c"; }

.ri-function-fill:before {
  content: "\\ed9d"; }

.ri-function-line:before {
  content: "\\ed9e"; }

.ri-functions:before {
  content: "\\ed9f"; }

.ri-funds-box-fill:before {
  content: "\\eda0"; }

.ri-funds-box-line:before {
  content: "\\eda1"; }

.ri-funds-fill:before {
  content: "\\eda2"; }

.ri-funds-line:before {
  content: "\\eda3"; }

.ri-gallery-fill:before {
  content: "\\eda4"; }

.ri-gallery-line:before {
  content: "\\eda5"; }

.ri-gallery-upload-fill:before {
  content: "\\eda6"; }

.ri-gallery-upload-line:before {
  content: "\\eda7"; }

.ri-game-fill:before {
  content: "\\eda8"; }

.ri-game-line:before {
  content: "\\eda9"; }

.ri-gamepad-fill:before {
  content: "\\edaa"; }

.ri-gamepad-line:before {
  content: "\\edab"; }

.ri-gas-station-fill:before {
  content: "\\edac"; }

.ri-gas-station-line:before {
  content: "\\edad"; }

.ri-gatsby-fill:before {
  content: "\\edae"; }

.ri-gatsby-line:before {
  content: "\\edaf"; }

.ri-genderless-fill:before {
  content: "\\edb0"; }

.ri-genderless-line:before {
  content: "\\edb1"; }

.ri-ghost-2-fill:before {
  content: "\\edb2"; }

.ri-ghost-2-line:before {
  content: "\\edb3"; }

.ri-ghost-fill:before {
  content: "\\edb4"; }

.ri-ghost-line:before {
  content: "\\edb5"; }

.ri-ghost-smile-fill:before {
  content: "\\edb6"; }

.ri-ghost-smile-line:before {
  content: "\\edb7"; }

.ri-gift-2-fill:before {
  content: "\\edb8"; }

.ri-gift-2-line:before {
  content: "\\edb9"; }

.ri-gift-fill:before {
  content: "\\edba"; }

.ri-gift-line:before {
  content: "\\edbb"; }

.ri-git-branch-fill:before {
  content: "\\edbc"; }

.ri-git-branch-line:before {
  content: "\\edbd"; }

.ri-git-commit-fill:before {
  content: "\\edbe"; }

.ri-git-commit-line:before {
  content: "\\edbf"; }

.ri-git-merge-fill:before {
  content: "\\edc0"; }

.ri-git-merge-line:before {
  content: "\\edc1"; }

.ri-git-pull-request-fill:before {
  content: "\\edc2"; }

.ri-git-pull-request-line:before {
  content: "\\edc3"; }

.ri-git-repository-commits-fill:before {
  content: "\\edc4"; }

.ri-git-repository-commits-line:before {
  content: "\\edc5"; }

.ri-git-repository-fill:before {
  content: "\\edc6"; }

.ri-git-repository-line:before {
  content: "\\edc7"; }

.ri-git-repository-private-fill:before {
  content: "\\edc8"; }

.ri-git-repository-private-line:before {
  content: "\\edc9"; }

.ri-github-fill:before {
  content: "\\edca"; }

.ri-github-line:before {
  content: "\\edcb"; }

.ri-gitlab-fill:before {
  content: "\\edcc"; }

.ri-gitlab-line:before {
  content: "\\edcd"; }

.ri-global-fill:before {
  content: "\\edce"; }

.ri-global-line:before {
  content: "\\edcf"; }

.ri-globe-fill:before {
  content: "\\edd0"; }

.ri-globe-line:before {
  content: "\\edd1"; }

.ri-goblet-fill:before {
  content: "\\edd2"; }

.ri-goblet-line:before {
  content: "\\edd3"; }

.ri-google-fill:before {
  content: "\\edd4"; }

.ri-google-line:before {
  content: "\\edd5"; }

.ri-google-play-fill:before {
  content: "\\edd6"; }

.ri-google-play-line:before {
  content: "\\edd7"; }

.ri-government-fill:before {
  content: "\\edd8"; }

.ri-government-line:before {
  content: "\\edd9"; }

.ri-gps-fill:before {
  content: "\\edda"; }

.ri-gps-line:before {
  content: "\\eddb"; }

.ri-gradienter-fill:before {
  content: "\\eddc"; }

.ri-gradienter-line:before {
  content: "\\eddd"; }

.ri-grid-fill:before {
  content: "\\edde"; }

.ri-grid-line:before {
  content: "\\eddf"; }

.ri-group-2-fill:before {
  content: "\\ede0"; }

.ri-group-2-line:before {
  content: "\\ede1"; }

.ri-group-fill:before {
  content: "\\ede2"; }

.ri-group-line:before {
  content: "\\ede3"; }

.ri-guide-fill:before {
  content: "\\ede4"; }

.ri-guide-line:before {
  content: "\\ede5"; }

.ri-h-1:before {
  content: "\\ede6"; }

.ri-h-2:before {
  content: "\\ede7"; }

.ri-h-3:before {
  content: "\\ede8"; }

.ri-h-4:before {
  content: "\\ede9"; }

.ri-h-5:before {
  content: "\\edea"; }

.ri-h-6:before {
  content: "\\edeb"; }

.ri-hail-fill:before {
  content: "\\edec"; }

.ri-hail-line:before {
  content: "\\eded"; }

.ri-hammer-fill:before {
  content: "\\edee"; }

.ri-hammer-line:before {
  content: "\\edef"; }

.ri-hand-coin-fill:before {
  content: "\\edf0"; }

.ri-hand-coin-line:before {
  content: "\\edf1"; }

.ri-hand-heart-fill:before {
  content: "\\edf2"; }

.ri-hand-heart-line:before {
  content: "\\edf3"; }

.ri-hand-sanitizer-fill:before {
  content: "\\edf4"; }

.ri-hand-sanitizer-line:before {
  content: "\\edf5"; }

.ri-handbag-fill:before {
  content: "\\edf6"; }

.ri-handbag-line:before {
  content: "\\edf7"; }

.ri-hard-drive-2-fill:before {
  content: "\\edf8"; }

.ri-hard-drive-2-line:before {
  content: "\\edf9"; }

.ri-hard-drive-fill:before {
  content: "\\edfa"; }

.ri-hard-drive-line:before {
  content: "\\edfb"; }

.ri-hashtag:before {
  content: "\\edfc"; }

.ri-haze-2-fill:before {
  content: "\\edfd"; }

.ri-haze-2-line:before {
  content: "\\edfe"; }

.ri-haze-fill:before {
  content: "\\edff"; }

.ri-haze-line:before {
  content: "\\ee00"; }

.ri-hd-fill:before {
  content: "\\ee01"; }

.ri-hd-line:before {
  content: "\\ee02"; }

.ri-heading:before {
  content: "\\ee03"; }

.ri-headphone-fill:before {
  content: "\\ee04"; }

.ri-headphone-line:before {
  content: "\\ee05"; }

.ri-health-book-fill:before {
  content: "\\ee06"; }

.ri-health-book-line:before {
  content: "\\ee07"; }

.ri-heart-2-fill:before {
  content: "\\ee08"; }

.ri-heart-2-line:before {
  content: "\\ee09"; }

.ri-heart-3-fill:before {
  content: "\\ee0a"; }

.ri-heart-3-line:before {
  content: "\\ee0b"; }

.ri-heart-add-fill:before {
  content: "\\ee0c"; }

.ri-heart-add-line:before {
  content: "\\ee0d"; }

.ri-heart-fill:before {
  content: "\\ee0e"; }

.ri-heart-line:before {
  content: "\\ee0f"; }

.ri-heart-pulse-fill:before {
  content: "\\ee10"; }

.ri-heart-pulse-line:before {
  content: "\\ee11"; }

.ri-hearts-fill:before {
  content: "\\ee12"; }

.ri-hearts-line:before {
  content: "\\ee13"; }

.ri-heavy-showers-fill:before {
  content: "\\ee14"; }

.ri-heavy-showers-line:before {
  content: "\\ee15"; }

.ri-history-fill:before {
  content: "\\ee16"; }

.ri-history-line:before {
  content: "\\ee17"; }

.ri-home-2-fill:before {
  content: "\\ee18"; }

.ri-home-2-line:before {
  content: "\\ee19"; }

.ri-home-3-fill:before {
  content: "\\ee1a"; }

.ri-home-3-line:before {
  content: "\\ee1b"; }

.ri-home-4-fill:before {
  content: "\\ee1c"; }

.ri-home-4-line:before {
  content: "\\ee1d"; }

.ri-home-5-fill:before {
  content: "\\ee1e"; }

.ri-home-5-line:before {
  content: "\\ee1f"; }

.ri-home-6-fill:before {
  content: "\\ee20"; }

.ri-home-6-line:before {
  content: "\\ee21"; }

.ri-home-7-fill:before {
  content: "\\ee22"; }

.ri-home-7-line:before {
  content: "\\ee23"; }

.ri-home-8-fill:before {
  content: "\\ee24"; }

.ri-home-8-line:before {
  content: "\\ee25"; }

.ri-home-fill:before {
  content: "\\ee26"; }

.ri-home-gear-fill:before {
  content: "\\ee27"; }

.ri-home-gear-line:before {
  content: "\\ee28"; }

.ri-home-heart-fill:before {
  content: "\\ee29"; }

.ri-home-heart-line:before {
  content: "\\ee2a"; }

.ri-home-line:before {
  content: "\\ee2b"; }

.ri-home-smile-2-fill:before {
  content: "\\ee2c"; }

.ri-home-smile-2-line:before {
  content: "\\ee2d"; }

.ri-home-smile-fill:before {
  content: "\\ee2e"; }

.ri-home-smile-line:before {
  content: "\\ee2f"; }

.ri-home-wifi-fill:before {
  content: "\\ee30"; }

.ri-home-wifi-line:before {
  content: "\\ee31"; }

.ri-honor-of-kings-fill:before {
  content: "\\ee32"; }

.ri-honor-of-kings-line:before {
  content: "\\ee33"; }

.ri-honour-fill:before {
  content: "\\ee34"; }

.ri-honour-line:before {
  content: "\\ee35"; }

.ri-hospital-fill:before {
  content: "\\ee36"; }

.ri-hospital-line:before {
  content: "\\ee37"; }

.ri-hotel-bed-fill:before {
  content: "\\ee38"; }

.ri-hotel-bed-line:before {
  content: "\\ee39"; }

.ri-hotel-fill:before {
  content: "\\ee3a"; }

.ri-hotel-line:before {
  content: "\\ee3b"; }

.ri-hotspot-fill:before {
  content: "\\ee3c"; }

.ri-hotspot-line:before {
  content: "\\ee3d"; }

.ri-hq-fill:before {
  content: "\\ee3e"; }

.ri-hq-line:before {
  content: "\\ee3f"; }

.ri-html5-fill:before {
  content: "\\ee40"; }

.ri-html5-line:before {
  content: "\\ee41"; }

.ri-ie-fill:before {
  content: "\\ee42"; }

.ri-ie-line:before {
  content: "\\ee43"; }

.ri-image-2-fill:before {
  content: "\\ee44"; }

.ri-image-2-line:before {
  content: "\\ee45"; }

.ri-image-add-fill:before {
  content: "\\ee46"; }

.ri-image-add-line:before {
  content: "\\ee47"; }

.ri-image-edit-fill:before {
  content: "\\ee48"; }

.ri-image-edit-line:before {
  content: "\\ee49"; }

.ri-image-fill:before {
  content: "\\ee4a"; }

.ri-image-line:before {
  content: "\\ee4b"; }

.ri-inbox-archive-fill:before {
  content: "\\ee4c"; }

.ri-inbox-archive-line:before {
  content: "\\ee4d"; }

.ri-inbox-fill:before {
  content: "\\ee4e"; }

.ri-inbox-line:before {
  content: "\\ee4f"; }

.ri-inbox-unarchive-fill:before {
  content: "\\ee50"; }

.ri-inbox-unarchive-line:before {
  content: "\\ee51"; }

.ri-increase-decrease-fill:before {
  content: "\\ee52"; }

.ri-increase-decrease-line:before {
  content: "\\ee53"; }

.ri-indent-decrease:before {
  content: "\\ee54"; }

.ri-indent-increase:before {
  content: "\\ee55"; }

.ri-indeterminate-circle-fill:before {
  content: "\\ee56"; }

.ri-indeterminate-circle-line:before {
  content: "\\ee57"; }

.ri-information-fill:before {
  content: "\\ee58"; }

.ri-information-line:before {
  content: "\\ee59"; }

.ri-infrared-thermometer-fill:before {
  content: "\\ee5a"; }

.ri-infrared-thermometer-line:before {
  content: "\\ee5b"; }

.ri-ink-bottle-fill:before {
  content: "\\ee5c"; }

.ri-ink-bottle-line:before {
  content: "\\ee5d"; }

.ri-input-cursor-move:before {
  content: "\\ee5e"; }

.ri-input-method-fill:before {
  content: "\\ee5f"; }

.ri-input-method-line:before {
  content: "\\ee60"; }

.ri-insert-column-left:before {
  content: "\\ee61"; }

.ri-insert-column-right:before {
  content: "\\ee62"; }

.ri-insert-row-bottom:before {
  content: "\\ee63"; }

.ri-insert-row-top:before {
  content: "\\ee64"; }

.ri-instagram-fill:before {
  content: "\\ee65"; }

.ri-instagram-line:before {
  content: "\\ee66"; }

.ri-install-fill:before {
  content: "\\ee67"; }

.ri-install-line:before {
  content: "\\ee68"; }

.ri-invision-fill:before {
  content: "\\ee69"; }

.ri-invision-line:before {
  content: "\\ee6a"; }

.ri-italic:before {
  content: "\\ee6b"; }

.ri-kakao-talk-fill:before {
  content: "\\ee6c"; }

.ri-kakao-talk-line:before {
  content: "\\ee6d"; }

.ri-key-2-fill:before {
  content: "\\ee6e"; }

.ri-key-2-line:before {
  content: "\\ee6f"; }

.ri-key-fill:before {
  content: "\\ee70"; }

.ri-key-line:before {
  content: "\\ee71"; }

.ri-keyboard-box-fill:before {
  content: "\\ee72"; }

.ri-keyboard-box-line:before {
  content: "\\ee73"; }

.ri-keyboard-fill:before {
  content: "\\ee74"; }

.ri-keyboard-line:before {
  content: "\\ee75"; }

.ri-keynote-fill:before {
  content: "\\ee76"; }

.ri-keynote-line:before {
  content: "\\ee77"; }

.ri-knife-blood-fill:before {
  content: "\\ee78"; }

.ri-knife-blood-line:before {
  content: "\\ee79"; }

.ri-knife-fill:before {
  content: "\\ee7a"; }

.ri-knife-line:before {
  content: "\\ee7b"; }

.ri-landscape-fill:before {
  content: "\\ee7c"; }

.ri-landscape-line:before {
  content: "\\ee7d"; }

.ri-layout-2-fill:before {
  content: "\\ee7e"; }

.ri-layout-2-line:before {
  content: "\\ee7f"; }

.ri-layout-3-fill:before {
  content: "\\ee80"; }

.ri-layout-3-line:before {
  content: "\\ee81"; }

.ri-layout-4-fill:before {
  content: "\\ee82"; }

.ri-layout-4-line:before {
  content: "\\ee83"; }

.ri-layout-5-fill:before {
  content: "\\ee84"; }

.ri-layout-5-line:before {
  content: "\\ee85"; }

.ri-layout-6-fill:before {
  content: "\\ee86"; }

.ri-layout-6-line:before {
  content: "\\ee87"; }

.ri-layout-bottom-2-fill:before {
  content: "\\ee88"; }

.ri-layout-bottom-2-line:before {
  content: "\\ee89"; }

.ri-layout-bottom-fill:before {
  content: "\\ee8a"; }

.ri-layout-bottom-line:before {
  content: "\\ee8b"; }

.ri-layout-column-fill:before {
  content: "\\ee8c"; }

.ri-layout-column-line:before {
  content: "\\ee8d"; }

.ri-layout-fill:before {
  content: "\\ee8e"; }

.ri-layout-grid-fill:before {
  content: "\\ee8f"; }

.ri-layout-grid-line:before {
  content: "\\ee90"; }

.ri-layout-left-2-fill:before {
  content: "\\ee91"; }

.ri-layout-left-2-line:before {
  content: "\\ee92"; }

.ri-layout-left-fill:before {
  content: "\\ee93"; }

.ri-layout-left-line:before {
  content: "\\ee94"; }

.ri-layout-line:before {
  content: "\\ee95"; }

.ri-layout-masonry-fill:before {
  content: "\\ee96"; }

.ri-layout-masonry-line:before {
  content: "\\ee97"; }

.ri-layout-right-2-fill:before {
  content: "\\ee98"; }

.ri-layout-right-2-line:before {
  content: "\\ee99"; }

.ri-layout-right-fill:before {
  content: "\\ee9a"; }

.ri-layout-right-line:before {
  content: "\\ee9b"; }

.ri-layout-row-fill:before {
  content: "\\ee9c"; }

.ri-layout-row-line:before {
  content: "\\ee9d"; }

.ri-layout-top-2-fill:before {
  content: "\\ee9e"; }

.ri-layout-top-2-line:before {
  content: "\\ee9f"; }

.ri-layout-top-fill:before {
  content: "\\eea0"; }

.ri-layout-top-line:before {
  content: "\\eea1"; }

.ri-leaf-fill:before {
  content: "\\eea2"; }

.ri-leaf-line:before {
  content: "\\eea3"; }

.ri-lifebuoy-fill:before {
  content: "\\eea4"; }

.ri-lifebuoy-line:before {
  content: "\\eea5"; }

.ri-lightbulb-fill:before {
  content: "\\eea6"; }

.ri-lightbulb-flash-fill:before {
  content: "\\eea7"; }

.ri-lightbulb-flash-line:before {
  content: "\\eea8"; }

.ri-lightbulb-line:before {
  content: "\\eea9"; }

.ri-line-chart-fill:before {
  content: "\\eeaa"; }

.ri-line-chart-line:before {
  content: "\\eeab"; }

.ri-line-fill:before {
  content: "\\eeac"; }

.ri-line-height:before {
  content: "\\eead"; }

.ri-line-line:before {
  content: "\\eeae"; }

.ri-link-m:before {
  content: "\\eeaf"; }

.ri-link-unlink-m:before {
  content: "\\eeb0"; }

.ri-link-unlink:before {
  content: "\\eeb1"; }

.ri-link:before {
  content: "\\eeb2"; }

.ri-linkedin-box-fill:before {
  content: "\\eeb3"; }

.ri-linkedin-box-line:before {
  content: "\\eeb4"; }

.ri-linkedin-fill:before {
  content: "\\eeb5"; }

.ri-linkedin-line:before {
  content: "\\eeb6"; }

.ri-links-fill:before {
  content: "\\eeb7"; }

.ri-links-line:before {
  content: "\\eeb8"; }

.ri-list-check-2:before {
  content: "\\eeb9"; }

.ri-list-check:before {
  content: "\\eeba"; }

.ri-list-ordered:before {
  content: "\\eebb"; }

.ri-list-settings-fill:before {
  content: "\\eebc"; }

.ri-list-settings-line:before {
  content: "\\eebd"; }

.ri-list-unordered:before {
  content: "\\eebe"; }

.ri-live-fill:before {
  content: "\\eebf"; }

.ri-live-line:before {
  content: "\\eec0"; }

.ri-loader-2-fill:before {
  content: "\\eec1"; }

.ri-loader-2-line:before {
  content: "\\eec2"; }

.ri-loader-3-fill:before {
  content: "\\eec3"; }

.ri-loader-3-line:before {
  content: "\\eec4"; }

.ri-loader-4-fill:before {
  content: "\\eec5"; }

.ri-loader-4-line:before {
  content: "\\eec6"; }

.ri-loader-5-fill:before {
  content: "\\eec7"; }

.ri-loader-5-line:before {
  content: "\\eec8"; }

.ri-loader-fill:before {
  content: "\\eec9"; }

.ri-loader-line:before {
  content: "\\eeca"; }

.ri-lock-2-fill:before {
  content: "\\eecb"; }

.ri-lock-2-line:before {
  content: "\\eecc"; }

.ri-lock-fill:before {
  content: "\\eecd"; }

.ri-lock-line:before {
  content: "\\eece"; }

.ri-lock-password-fill:before {
  content: "\\eecf"; }

.ri-lock-password-line:before {
  content: "\\eed0"; }

.ri-lock-unlock-fill:before {
  content: "\\eed1"; }

.ri-lock-unlock-line:before {
  content: "\\eed2"; }

.ri-login-box-fill:before {
  content: "\\eed3"; }

.ri-login-box-line:before {
  content: "\\eed4"; }

.ri-login-circle-fill:before {
  content: "\\eed5"; }

.ri-login-circle-line:before {
  content: "\\eed6"; }

.ri-logout-box-fill:before {
  content: "\\eed7"; }

.ri-logout-box-line:before {
  content: "\\eed8"; }

.ri-logout-box-r-fill:before {
  content: "\\eed9"; }

.ri-logout-box-r-line:before {
  content: "\\eeda"; }

.ri-logout-circle-fill:before {
  content: "\\eedb"; }

.ri-logout-circle-line:before {
  content: "\\eedc"; }

.ri-logout-circle-r-fill:before {
  content: "\\eedd"; }

.ri-logout-circle-r-line:before {
  content: "\\eede"; }

.ri-luggage-cart-fill:before {
  content: "\\eedf"; }

.ri-luggage-cart-line:before {
  content: "\\eee0"; }

.ri-luggage-deposit-fill:before {
  content: "\\eee1"; }

.ri-luggage-deposit-line:before {
  content: "\\eee2"; }

.ri-lungs-fill:before {
  content: "\\eee3"; }

.ri-lungs-line:before {
  content: "\\eee4"; }

.ri-mac-fill:before {
  content: "\\eee5"; }

.ri-mac-line:before {
  content: "\\eee6"; }

.ri-macbook-fill:before {
  content: "\\eee7"; }

.ri-macbook-line:before {
  content: "\\eee8"; }

.ri-magic-fill:before {
  content: "\\eee9"; }

.ri-magic-line:before {
  content: "\\eeea"; }

.ri-mail-add-fill:before {
  content: "\\eeeb"; }

.ri-mail-add-line:before {
  content: "\\eeec"; }

.ri-mail-check-fill:before {
  content: "\\eeed"; }

.ri-mail-check-line:before {
  content: "\\eeee"; }

.ri-mail-close-fill:before {
  content: "\\eeef"; }

.ri-mail-close-line:before {
  content: "\\eef0"; }

.ri-mail-download-fill:before {
  content: "\\eef1"; }

.ri-mail-download-line:before {
  content: "\\eef2"; }

.ri-mail-fill:before {
  content: "\\eef3"; }

.ri-mail-forbid-fill:before {
  content: "\\eef4"; }

.ri-mail-forbid-line:before {
  content: "\\eef5"; }

.ri-mail-line:before {
  content: "\\eef6"; }

.ri-mail-lock-fill:before {
  content: "\\eef7"; }

.ri-mail-lock-line:before {
  content: "\\eef8"; }

.ri-mail-open-fill:before {
  content: "\\eef9"; }

.ri-mail-open-line:before {
  content: "\\eefa"; }

.ri-mail-send-fill:before {
  content: "\\eefb"; }

.ri-mail-send-line:before {
  content: "\\eefc"; }

.ri-mail-settings-fill:before {
  content: "\\eefd"; }

.ri-mail-settings-line:before {
  content: "\\eefe"; }

.ri-mail-star-fill:before {
  content: "\\eeff"; }

.ri-mail-star-line:before {
  content: "\\ef00"; }

.ri-mail-unread-fill:before {
  content: "\\ef01"; }

.ri-mail-unread-line:before {
  content: "\\ef02"; }

.ri-mail-volume-fill:before {
  content: "\\ef03"; }

.ri-mail-volume-line:before {
  content: "\\ef04"; }

.ri-map-2-fill:before {
  content: "\\ef05"; }

.ri-map-2-line:before {
  content: "\\ef06"; }

.ri-map-fill:before {
  content: "\\ef07"; }

.ri-map-line:before {
  content: "\\ef08"; }

.ri-map-pin-2-fill:before {
  content: "\\ef09"; }

.ri-map-pin-2-line:before {
  content: "\\ef0a"; }

.ri-map-pin-3-fill:before {
  content: "\\ef0b"; }

.ri-map-pin-3-line:before {
  content: "\\ef0c"; }

.ri-map-pin-4-fill:before {
  content: "\\ef0d"; }

.ri-map-pin-4-line:before {
  content: "\\ef0e"; }

.ri-map-pin-5-fill:before {
  content: "\\ef0f"; }

.ri-map-pin-5-line:before {
  content: "\\ef10"; }

.ri-map-pin-add-fill:before {
  content: "\\ef11"; }

.ri-map-pin-add-line:before {
  content: "\\ef12"; }

.ri-map-pin-fill:before {
  content: "\\ef13"; }

.ri-map-pin-line:before {
  content: "\\ef14"; }

.ri-map-pin-range-fill:before {
  content: "\\ef15"; }

.ri-map-pin-range-line:before {
  content: "\\ef16"; }

.ri-map-pin-time-fill:before {
  content: "\\ef17"; }

.ri-map-pin-time-line:before {
  content: "\\ef18"; }

.ri-map-pin-user-fill:before {
  content: "\\ef19"; }

.ri-map-pin-user-line:before {
  content: "\\ef1a"; }

.ri-mark-pen-fill:before {
  content: "\\ef1b"; }

.ri-mark-pen-line:before {
  content: "\\ef1c"; }

.ri-markdown-fill:before {
  content: "\\ef1d"; }

.ri-markdown-line:before {
  content: "\\ef1e"; }

.ri-markup-fill:before {
  content: "\\ef1f"; }

.ri-markup-line:before {
  content: "\\ef20"; }

.ri-mastercard-fill:before {
  content: "\\ef21"; }

.ri-mastercard-line:before {
  content: "\\ef22"; }

.ri-mastodon-fill:before {
  content: "\\ef23"; }

.ri-mastodon-line:before {
  content: "\\ef24"; }

.ri-medal-2-fill:before {
  content: "\\ef25"; }

.ri-medal-2-line:before {
  content: "\\ef26"; }

.ri-medal-fill:before {
  content: "\\ef27"; }

.ri-medal-line:before {
  content: "\\ef28"; }

.ri-medicine-bottle-fill:before {
  content: "\\ef29"; }

.ri-medicine-bottle-line:before {
  content: "\\ef2a"; }

.ri-medium-fill:before {
  content: "\\ef2b"; }

.ri-medium-line:before {
  content: "\\ef2c"; }

.ri-men-fill:before {
  content: "\\ef2d"; }

.ri-men-line:before {
  content: "\\ef2e"; }

.ri-mental-health-fill:before {
  content: "\\ef2f"; }

.ri-mental-health-line:before {
  content: "\\ef30"; }

.ri-menu-2-fill:before {
  content: "\\ef31"; }

.ri-menu-2-line:before {
  content: "\\ef32"; }

.ri-menu-3-fill:before {
  content: "\\ef33"; }

.ri-menu-3-line:before {
  content: "\\ef34"; }

.ri-menu-4-fill:before {
  content: "\\ef35"; }

.ri-menu-4-line:before {
  content: "\\ef36"; }

.ri-menu-5-fill:before {
  content: "\\ef37"; }

.ri-menu-5-line:before {
  content: "\\ef38"; }

.ri-menu-add-fill:before {
  content: "\\ef39"; }

.ri-menu-add-line:before {
  content: "\\ef3a"; }

.ri-menu-fill:before {
  content: "\\ef3b"; }

.ri-menu-fold-fill:before {
  content: "\\ef3c"; }

.ri-menu-fold-line:before {
  content: "\\ef3d"; }

.ri-menu-line:before {
  content: "\\ef3e"; }

.ri-menu-unfold-fill:before {
  content: "\\ef3f"; }

.ri-menu-unfold-line:before {
  content: "\\ef40"; }

.ri-merge-cells-horizontal:before {
  content: "\\ef41"; }

.ri-merge-cells-vertical:before {
  content: "\\ef42"; }

.ri-message-2-fill:before {
  content: "\\ef43"; }

.ri-message-2-line:before {
  content: "\\ef44"; }

.ri-message-3-fill:before {
  content: "\\ef45"; }

.ri-message-3-line:before {
  content: "\\ef46"; }

.ri-message-fill:before {
  content: "\\ef47"; }

.ri-message-line:before {
  content: "\\ef48"; }

.ri-messenger-fill:before {
  content: "\\ef49"; }

.ri-messenger-line:before {
  content: "\\ef4a"; }

.ri-meteor-fill:before {
  content: "\\ef4b"; }

.ri-meteor-line:before {
  content: "\\ef4c"; }

.ri-mic-2-fill:before {
  content: "\\ef4d"; }

.ri-mic-2-line:before {
  content: "\\ef4e"; }

.ri-mic-fill:before {
  content: "\\ef4f"; }

.ri-mic-line:before {
  content: "\\ef50"; }

.ri-mic-off-fill:before {
  content: "\\ef51"; }

.ri-mic-off-line:before {
  content: "\\ef52"; }

.ri-mickey-fill:before {
  content: "\\ef53"; }

.ri-mickey-line:before {
  content: "\\ef54"; }

.ri-microscope-fill:before {
  content: "\\ef55"; }

.ri-microscope-line:before {
  content: "\\ef56"; }

.ri-microsoft-fill:before {
  content: "\\ef57"; }

.ri-microsoft-line:before {
  content: "\\ef58"; }

.ri-mind-map:before {
  content: "\\ef59"; }

.ri-mini-program-fill:before {
  content: "\\ef5a"; }

.ri-mini-program-line:before {
  content: "\\ef5b"; }

.ri-mist-fill:before {
  content: "\\ef5c"; }

.ri-mist-line:before {
  content: "\\ef5d"; }

.ri-money-cny-box-fill:before {
  content: "\\ef5e"; }

.ri-money-cny-box-line:before {
  content: "\\ef5f"; }

.ri-money-cny-circle-fill:before {
  content: "\\ef60"; }

.ri-money-cny-circle-line:before {
  content: "\\ef61"; }

.ri-money-dollar-box-fill:before {
  content: "\\ef62"; }

.ri-money-dollar-box-line:before {
  content: "\\ef63"; }

.ri-money-dollar-circle-fill:before {
  content: "\\ef64"; }

.ri-money-dollar-circle-line:before {
  content: "\\ef65"; }

.ri-money-euro-box-fill:before {
  content: "\\ef66"; }

.ri-money-euro-box-line:before {
  content: "\\ef67"; }

.ri-money-euro-circle-fill:before {
  content: "\\ef68"; }

.ri-money-euro-circle-line:before {
  content: "\\ef69"; }

.ri-money-pound-box-fill:before {
  content: "\\ef6a"; }

.ri-money-pound-box-line:before {
  content: "\\ef6b"; }

.ri-money-pound-circle-fill:before {
  content: "\\ef6c"; }

.ri-money-pound-circle-line:before {
  content: "\\ef6d"; }

.ri-moon-clear-fill:before {
  content: "\\ef6e"; }

.ri-moon-clear-line:before {
  content: "\\ef6f"; }

.ri-moon-cloudy-fill:before {
  content: "\\ef70"; }

.ri-moon-cloudy-line:before {
  content: "\\ef71"; }

.ri-moon-fill:before {
  content: "\\ef72"; }

.ri-moon-foggy-fill:before {
  content: "\\ef73"; }

.ri-moon-foggy-line:before {
  content: "\\ef74"; }

.ri-moon-line:before {
  content: "\\ef75"; }

.ri-more-2-fill:before {
  content: "\\ef76"; }

.ri-more-2-line:before {
  content: "\\ef77"; }

.ri-more-fill:before {
  content: "\\ef78"; }

.ri-more-line:before {
  content: "\\ef79"; }

.ri-motorbike-fill:before {
  content: "\\ef7a"; }

.ri-motorbike-line:before {
  content: "\\ef7b"; }

.ri-mouse-fill:before {
  content: "\\ef7c"; }

.ri-mouse-line:before {
  content: "\\ef7d"; }

.ri-movie-2-fill:before {
  content: "\\ef7e"; }

.ri-movie-2-line:before {
  content: "\\ef7f"; }

.ri-movie-fill:before {
  content: "\\ef80"; }

.ri-movie-line:before {
  content: "\\ef81"; }

.ri-music-2-fill:before {
  content: "\\ef82"; }

.ri-music-2-line:before {
  content: "\\ef83"; }

.ri-music-fill:before {
  content: "\\ef84"; }

.ri-music-line:before {
  content: "\\ef85"; }

.ri-mv-fill:before {
  content: "\\ef86"; }

.ri-mv-line:before {
  content: "\\ef87"; }

.ri-navigation-fill:before {
  content: "\\ef88"; }

.ri-navigation-line:before {
  content: "\\ef89"; }

.ri-netease-cloud-music-fill:before {
  content: "\\ef8a"; }

.ri-netease-cloud-music-line:before {
  content: "\\ef8b"; }

.ri-netflix-fill:before {
  content: "\\ef8c"; }

.ri-netflix-line:before {
  content: "\\ef8d"; }

.ri-newspaper-fill:before {
  content: "\\ef8e"; }

.ri-newspaper-line:before {
  content: "\\ef8f"; }

.ri-node-tree:before {
  content: "\\ef90"; }

.ri-notification-2-fill:before {
  content: "\\ef91"; }

.ri-notification-2-line:before {
  content: "\\ef92"; }

.ri-notification-3-fill:before {
  content: "\\ef93"; }

.ri-notification-3-line:before {
  content: "\\ef94"; }

.ri-notification-4-fill:before {
  content: "\\ef95"; }

.ri-notification-4-line:before {
  content: "\\ef96"; }

.ri-notification-badge-fill:before {
  content: "\\ef97"; }

.ri-notification-badge-line:before {
  content: "\\ef98"; }

.ri-notification-fill:before {
  content: "\\ef99"; }

.ri-notification-line:before {
  content: "\\ef9a"; }

.ri-notification-off-fill:before {
  content: "\\ef9b"; }

.ri-notification-off-line:before {
  content: "\\ef9c"; }

.ri-npmjs-fill:before {
  content: "\\ef9d"; }

.ri-npmjs-line:before {
  content: "\\ef9e"; }

.ri-number-0:before {
  content: "\\ef9f"; }

.ri-number-1:before {
  content: "\\efa0"; }

.ri-number-2:before {
  content: "\\efa1"; }

.ri-number-3:before {
  content: "\\efa2"; }

.ri-number-4:before {
  content: "\\efa3"; }

.ri-number-5:before {
  content: "\\efa4"; }

.ri-number-6:before {
  content: "\\efa5"; }

.ri-number-7:before {
  content: "\\efa6"; }

.ri-number-8:before {
  content: "\\efa7"; }

.ri-number-9:before {
  content: "\\efa8"; }

.ri-numbers-fill:before {
  content: "\\efa9"; }

.ri-numbers-line:before {
  content: "\\efaa"; }

.ri-nurse-fill:before {
  content: "\\efab"; }

.ri-nurse-line:before {
  content: "\\efac"; }

.ri-oil-fill:before {
  content: "\\efad"; }

.ri-oil-line:before {
  content: "\\efae"; }

.ri-omega:before {
  content: "\\efaf"; }

.ri-open-arm-fill:before {
  content: "\\efb0"; }

.ri-open-arm-line:before {
  content: "\\efb1"; }

.ri-open-source-fill:before {
  content: "\\efb2"; }

.ri-open-source-line:before {
  content: "\\efb3"; }

.ri-opera-fill:before {
  content: "\\efb4"; }

.ri-opera-line:before {
  content: "\\efb5"; }

.ri-order-play-fill:before {
  content: "\\efb6"; }

.ri-order-play-line:before {
  content: "\\efb7"; }

.ri-organization-chart:before {
  content: "\\efb8"; }

.ri-outlet-2-fill:before {
  content: "\\efb9"; }

.ri-outlet-2-line:before {
  content: "\\efba"; }

.ri-outlet-fill:before {
  content: "\\efbb"; }

.ri-outlet-line:before {
  content: "\\efbc"; }

.ri-page-separator:before {
  content: "\\efbd"; }

.ri-pages-fill:before {
  content: "\\efbe"; }

.ri-pages-line:before {
  content: "\\efbf"; }

.ri-paint-brush-fill:before {
  content: "\\efc0"; }

.ri-paint-brush-line:before {
  content: "\\efc1"; }

.ri-paint-fill:before {
  content: "\\efc2"; }

.ri-paint-line:before {
  content: "\\efc3"; }

.ri-palette-fill:before {
  content: "\\efc4"; }

.ri-palette-line:before {
  content: "\\efc5"; }

.ri-pantone-fill:before {
  content: "\\efc6"; }

.ri-pantone-line:before {
  content: "\\efc7"; }

.ri-paragraph:before {
  content: "\\efc8"; }

.ri-parent-fill:before {
  content: "\\efc9"; }

.ri-parent-line:before {
  content: "\\efca"; }

.ri-parentheses-fill:before {
  content: "\\efcb"; }

.ri-parentheses-line:before {
  content: "\\efcc"; }

.ri-parking-box-fill:before {
  content: "\\efcd"; }

.ri-parking-box-line:before {
  content: "\\efce"; }

.ri-parking-fill:before {
  content: "\\efcf"; }

.ri-parking-line:before {
  content: "\\efd0"; }

.ri-passport-fill:before {
  content: "\\efd1"; }

.ri-passport-line:before {
  content: "\\efd2"; }

.ri-patreon-fill:before {
  content: "\\efd3"; }

.ri-patreon-line:before {
  content: "\\efd4"; }

.ri-pause-circle-fill:before {
  content: "\\efd5"; }

.ri-pause-circle-line:before {
  content: "\\efd6"; }

.ri-pause-fill:before {
  content: "\\efd7"; }

.ri-pause-line:before {
  content: "\\efd8"; }

.ri-pause-mini-fill:before {
  content: "\\efd9"; }

.ri-pause-mini-line:before {
  content: "\\efda"; }

.ri-paypal-fill:before {
  content: "\\efdb"; }

.ri-paypal-line:before {
  content: "\\efdc"; }

.ri-pen-nib-fill:before {
  content: "\\efdd"; }

.ri-pen-nib-line:before {
  content: "\\efde"; }

.ri-pencil-fill:before {
  content: "\\efdf"; }

.ri-pencil-line:before {
  content: "\\efe0"; }

.ri-pencil-ruler-2-fill:before {
  content: "\\efe1"; }

.ri-pencil-ruler-2-line:before {
  content: "\\efe2"; }

.ri-pencil-ruler-fill:before {
  content: "\\efe3"; }

.ri-pencil-ruler-line:before {
  content: "\\efe4"; }

.ri-percent-fill:before {
  content: "\\efe5"; }

.ri-percent-line:before {
  content: "\\efe6"; }

.ri-phone-camera-fill:before {
  content: "\\efe7"; }

.ri-phone-camera-line:before {
  content: "\\efe8"; }

.ri-phone-fill:before {
  content: "\\efe9"; }

.ri-phone-find-fill:before {
  content: "\\efea"; }

.ri-phone-find-line:before {
  content: "\\efeb"; }

.ri-phone-line:before {
  content: "\\efec"; }

.ri-phone-lock-fill:before {
  content: "\\efed"; }

.ri-phone-lock-line:before {
  content: "\\efee"; }

.ri-picture-in-picture-2-fill:before {
  content: "\\efef"; }

.ri-picture-in-picture-2-line:before {
  content: "\\eff0"; }

.ri-picture-in-picture-exit-fill:before {
  content: "\\eff1"; }

.ri-picture-in-picture-exit-line:before {
  content: "\\eff2"; }

.ri-picture-in-picture-fill:before {
  content: "\\eff3"; }

.ri-picture-in-picture-line:before {
  content: "\\eff4"; }

.ri-pie-chart-2-fill:before {
  content: "\\eff5"; }

.ri-pie-chart-2-line:before {
  content: "\\eff6"; }

.ri-pie-chart-box-fill:before {
  content: "\\eff7"; }

.ri-pie-chart-box-line:before {
  content: "\\eff8"; }

.ri-pie-chart-fill:before {
  content: "\\eff9"; }

.ri-pie-chart-line:before {
  content: "\\effa"; }

.ri-pin-distance-fill:before {
  content: "\\effb"; }

.ri-pin-distance-line:before {
  content: "\\effc"; }

.ri-ping-pong-fill:before {
  content: "\\effd"; }

.ri-ping-pong-line:before {
  content: "\\effe"; }

.ri-pinterest-fill:before {
  content: "\\efff"; }

.ri-pinterest-line:before {
  content: "\\f000"; }

.ri-pinyin-input:before {
  content: "\\f001"; }

.ri-pixelfed-fill:before {
  content: "\\f002"; }

.ri-pixelfed-line:before {
  content: "\\f003"; }

.ri-plane-fill:before {
  content: "\\f004"; }

.ri-plane-line:before {
  content: "\\f005"; }

.ri-plant-fill:before {
  content: "\\f006"; }

.ri-plant-line:before {
  content: "\\f007"; }

.ri-play-circle-fill:before {
  content: "\\f008"; }

.ri-play-circle-line:before {
  content: "\\f009"; }

.ri-play-fill:before {
  content: "\\f00a"; }

.ri-play-line:before {
  content: "\\f00b"; }

.ri-play-list-2-fill:before {
  content: "\\f00c"; }

.ri-play-list-2-line:before {
  content: "\\f00d"; }

.ri-play-list-add-fill:before {
  content: "\\f00e"; }

.ri-play-list-add-line:before {
  content: "\\f00f"; }

.ri-play-list-fill:before {
  content: "\\f010"; }

.ri-play-list-line:before {
  content: "\\f011"; }

.ri-play-mini-fill:before {
  content: "\\f012"; }

.ri-play-mini-line:before {
  content: "\\f013"; }

.ri-playstation-fill:before {
  content: "\\f014"; }

.ri-playstation-line:before {
  content: "\\f015"; }

.ri-plug-2-fill:before {
  content: "\\f016"; }

.ri-plug-2-line:before {
  content: "\\f017"; }

.ri-plug-fill:before {
  content: "\\f018"; }

.ri-plug-line:before {
  content: "\\f019"; }

.ri-polaroid-2-fill:before {
  content: "\\f01a"; }

.ri-polaroid-2-line:before {
  content: "\\f01b"; }

.ri-polaroid-fill:before {
  content: "\\f01c"; }

.ri-polaroid-line:before {
  content: "\\f01d"; }

.ri-police-car-fill:before {
  content: "\\f01e"; }

.ri-police-car-line:before {
  content: "\\f01f"; }

.ri-price-tag-2-fill:before {
  content: "\\f020"; }

.ri-price-tag-2-line:before {
  content: "\\f021"; }

.ri-price-tag-3-fill:before {
  content: "\\f022"; }

.ri-price-tag-3-line:before {
  content: "\\f023"; }

.ri-price-tag-fill:before {
  content: "\\f024"; }

.ri-price-tag-line:before {
  content: "\\f025"; }

.ri-printer-cloud-fill:before {
  content: "\\f026"; }

.ri-printer-cloud-line:before {
  content: "\\f027"; }

.ri-printer-fill:before {
  content: "\\f028"; }

.ri-printer-line:before {
  content: "\\f029"; }

.ri-product-hunt-fill:before {
  content: "\\f02a"; }

.ri-product-hunt-line:before {
  content: "\\f02b"; }

.ri-profile-fill:before {
  content: "\\f02c"; }

.ri-profile-line:before {
  content: "\\f02d"; }

.ri-projector-2-fill:before {
  content: "\\f02e"; }

.ri-projector-2-line:before {
  content: "\\f02f"; }

.ri-projector-fill:before {
  content: "\\f030"; }

.ri-projector-line:before {
  content: "\\f031"; }

.ri-psychotherapy-fill:before {
  content: "\\f032"; }

.ri-psychotherapy-line:before {
  content: "\\f033"; }

.ri-pulse-fill:before {
  content: "\\f034"; }

.ri-pulse-line:before {
  content: "\\f035"; }

.ri-pushpin-2-fill:before {
  content: "\\f036"; }

.ri-pushpin-2-line:before {
  content: "\\f037"; }

.ri-pushpin-fill:before {
  content: "\\f038"; }

.ri-pushpin-line:before {
  content: "\\f039"; }

.ri-qq-fill:before {
  content: "\\f03a"; }

.ri-qq-line:before {
  content: "\\f03b"; }

.ri-qr-code-fill:before {
  content: "\\f03c"; }

.ri-qr-code-line:before {
  content: "\\f03d"; }

.ri-qr-scan-2-fill:before {
  content: "\\f03e"; }

.ri-qr-scan-2-line:before {
  content: "\\f03f"; }

.ri-qr-scan-fill:before {
  content: "\\f040"; }

.ri-qr-scan-line:before {
  content: "\\f041"; }

.ri-question-answer-fill:before {
  content: "\\f042"; }

.ri-question-answer-line:before {
  content: "\\f043"; }

.ri-question-fill:before {
  content: "\\f044"; }

.ri-question-line:before {
  content: "\\f045"; }

.ri-question-mark:before {
  content: "\\f046"; }

.ri-questionnaire-fill:before {
  content: "\\f047"; }

.ri-questionnaire-line:before {
  content: "\\f048"; }

.ri-quill-pen-fill:before {
  content: "\\f049"; }

.ri-quill-pen-line:before {
  content: "\\f04a"; }

.ri-radar-fill:before {
  content: "\\f04b"; }

.ri-radar-line:before {
  content: "\\f04c"; }

.ri-radio-2-fill:before {
  content: "\\f04d"; }

.ri-radio-2-line:before {
  content: "\\f04e"; }

.ri-radio-button-fill:before {
  content: "\\f04f"; }

.ri-radio-button-line:before {
  content: "\\f050"; }

.ri-radio-fill:before {
  content: "\\f051"; }

.ri-radio-line:before {
  content: "\\f052"; }

.ri-rainbow-fill:before {
  content: "\\f053"; }

.ri-rainbow-line:before {
  content: "\\f054"; }

.ri-rainy-fill:before {
  content: "\\f055"; }

.ri-rainy-line:before {
  content: "\\f056"; }

.ri-reactjs-fill:before {
  content: "\\f057"; }

.ri-reactjs-line:before {
  content: "\\f058"; }

.ri-record-circle-fill:before {
  content: "\\f059"; }

.ri-record-circle-line:before {
  content: "\\f05a"; }

.ri-record-mail-fill:before {
  content: "\\f05b"; }

.ri-record-mail-line:before {
  content: "\\f05c"; }

.ri-recycle-fill:before {
  content: "\\f05d"; }

.ri-recycle-line:before {
  content: "\\f05e"; }

.ri-red-packet-fill:before {
  content: "\\f05f"; }

.ri-red-packet-line:before {
  content: "\\f060"; }

.ri-reddit-fill:before {
  content: "\\f061"; }

.ri-reddit-line:before {
  content: "\\f062"; }

.ri-refresh-fill:before {
  content: "\\f063"; }

.ri-refresh-line:before {
  content: "\\f064"; }

.ri-refund-2-fill:before {
  content: "\\f065"; }

.ri-refund-2-line:before {
  content: "\\f066"; }

.ri-refund-fill:before {
  content: "\\f067"; }

.ri-refund-line:before {
  content: "\\f068"; }

.ri-registered-fill:before {
  content: "\\f069"; }

.ri-registered-line:before {
  content: "\\f06a"; }

.ri-remixicon-fill:before {
  content: "\\f06b"; }

.ri-remixicon-line:before {
  content: "\\f06c"; }

.ri-remote-control-2-fill:before {
  content: "\\f06d"; }

.ri-remote-control-2-line:before {
  content: "\\f06e"; }

.ri-remote-control-fill:before {
  content: "\\f06f"; }

.ri-remote-control-line:before {
  content: "\\f070"; }

.ri-repeat-2-fill:before {
  content: "\\f071"; }

.ri-repeat-2-line:before {
  content: "\\f072"; }

.ri-repeat-fill:before {
  content: "\\f073"; }

.ri-repeat-line:before {
  content: "\\f074"; }

.ri-repeat-one-fill:before {
  content: "\\f075"; }

.ri-repeat-one-line:before {
  content: "\\f076"; }

.ri-reply-all-fill:before {
  content: "\\f077"; }

.ri-reply-all-line:before {
  content: "\\f078"; }

.ri-reply-fill:before {
  content: "\\f079"; }

.ri-reply-line:before {
  content: "\\f07a"; }

.ri-reserved-fill:before {
  content: "\\f07b"; }

.ri-reserved-line:before {
  content: "\\f07c"; }

.ri-rest-time-fill:before {
  content: "\\f07d"; }

.ri-rest-time-line:before {
  content: "\\f07e"; }

.ri-restart-fill:before {
  content: "\\f07f"; }

.ri-restart-line:before {
  content: "\\f080"; }

.ri-restaurant-2-fill:before {
  content: "\\f081"; }

.ri-restaurant-2-line:before {
  content: "\\f082"; }

.ri-restaurant-fill:before {
  content: "\\f083"; }

.ri-restaurant-line:before {
  content: "\\f084"; }

.ri-rewind-fill:before {
  content: "\\f085"; }

.ri-rewind-line:before {
  content: "\\f086"; }

.ri-rewind-mini-fill:before {
  content: "\\f087"; }

.ri-rewind-mini-line:before {
  content: "\\f088"; }

.ri-rhythm-fill:before {
  content: "\\f089"; }

.ri-rhythm-line:before {
  content: "\\f08a"; }

.ri-riding-fill:before {
  content: "\\f08b"; }

.ri-riding-line:before {
  content: "\\f08c"; }

.ri-road-map-fill:before {
  content: "\\f08d"; }

.ri-road-map-line:before {
  content: "\\f08e"; }

.ri-roadster-fill:before {
  content: "\\f08f"; }

.ri-roadster-line:before {
  content: "\\f090"; }

.ri-robot-fill:before {
  content: "\\f091"; }

.ri-robot-line:before {
  content: "\\f092"; }

.ri-rocket-2-fill:before {
  content: "\\f093"; }

.ri-rocket-2-line:before {
  content: "\\f094"; }

.ri-rocket-fill:before {
  content: "\\f095"; }

.ri-rocket-line:before {
  content: "\\f096"; }

.ri-rotate-lock-fill:before {
  content: "\\f097"; }

.ri-rotate-lock-line:before {
  content: "\\f098"; }

.ri-rounded-corner:before {
  content: "\\f099"; }

.ri-route-fill:before {
  content: "\\f09a"; }

.ri-route-line:before {
  content: "\\f09b"; }

.ri-router-fill:before {
  content: "\\f09c"; }

.ri-router-line:before {
  content: "\\f09d"; }

.ri-rss-fill:before {
  content: "\\f09e"; }

.ri-rss-line:before {
  content: "\\f09f"; }

.ri-ruler-2-fill:before {
  content: "\\f0a0"; }

.ri-ruler-2-line:before {
  content: "\\f0a1"; }

.ri-ruler-fill:before {
  content: "\\f0a2"; }

.ri-ruler-line:before {
  content: "\\f0a3"; }

.ri-run-fill:before {
  content: "\\f0a4"; }

.ri-run-line:before {
  content: "\\f0a5"; }

.ri-safari-fill:before {
  content: "\\f0a6"; }

.ri-safari-line:before {
  content: "\\f0a7"; }

.ri-safe-2-fill:before {
  content: "\\f0a8"; }

.ri-safe-2-line:before {
  content: "\\f0a9"; }

.ri-safe-fill:before {
  content: "\\f0aa"; }

.ri-safe-line:before {
  content: "\\f0ab"; }

.ri-sailboat-fill:before {
  content: "\\f0ac"; }

.ri-sailboat-line:before {
  content: "\\f0ad"; }

.ri-save-2-fill:before {
  content: "\\f0ae"; }

.ri-save-2-line:before {
  content: "\\f0af"; }

.ri-save-3-fill:before {
  content: "\\f0b0"; }

.ri-save-3-line:before {
  content: "\\f0b1"; }

.ri-save-fill:before {
  content: "\\f0b2"; }

.ri-save-line:before {
  content: "\\f0b3"; }

.ri-scales-2-fill:before {
  content: "\\f0b4"; }

.ri-scales-2-line:before {
  content: "\\f0b5"; }

.ri-scales-3-fill:before {
  content: "\\f0b6"; }

.ri-scales-3-line:before {
  content: "\\f0b7"; }

.ri-scales-fill:before {
  content: "\\f0b8"; }

.ri-scales-line:before {
  content: "\\f0b9"; }

.ri-scan-2-fill:before {
  content: "\\f0ba"; }

.ri-scan-2-line:before {
  content: "\\f0bb"; }

.ri-scan-fill:before {
  content: "\\f0bc"; }

.ri-scan-line:before {
  content: "\\f0bd"; }

.ri-scissors-2-fill:before {
  content: "\\f0be"; }

.ri-scissors-2-line:before {
  content: "\\f0bf"; }

.ri-scissors-cut-fill:before {
  content: "\\f0c0"; }

.ri-scissors-cut-line:before {
  content: "\\f0c1"; }

.ri-scissors-fill:before {
  content: "\\f0c2"; }

.ri-scissors-line:before {
  content: "\\f0c3"; }

.ri-screenshot-2-fill:before {
  content: "\\f0c4"; }

.ri-screenshot-2-line:before {
  content: "\\f0c5"; }

.ri-screenshot-fill:before {
  content: "\\f0c6"; }

.ri-screenshot-line:before {
  content: "\\f0c7"; }

.ri-sd-card-fill:before {
  content: "\\f0c8"; }

.ri-sd-card-line:before {
  content: "\\f0c9"; }

.ri-sd-card-mini-fill:before {
  content: "\\f0ca"; }

.ri-sd-card-mini-line:before {
  content: "\\f0cb"; }

.ri-search-2-fill:before {
  content: "\\f0cc"; }

.ri-search-2-line:before {
  content: "\\f0cd"; }

.ri-search-eye-fill:before {
  content: "\\f0ce"; }

.ri-search-eye-line:before {
  content: "\\f0cf"; }

.ri-search-fill:before {
  content: "\\f0d0"; }

.ri-search-line:before {
  content: "\\f0d1"; }

.ri-secure-payment-fill:before {
  content: "\\f0d2"; }

.ri-secure-payment-line:before {
  content: "\\f0d3"; }

.ri-seedling-fill:before {
  content: "\\f0d4"; }

.ri-seedling-line:before {
  content: "\\f0d5"; }

.ri-send-backward:before {
  content: "\\f0d6"; }

.ri-send-plane-2-fill:before {
  content: "\\f0d7"; }

.ri-send-plane-2-line:before {
  content: "\\f0d8"; }

.ri-send-plane-fill:before {
  content: "\\f0d9"; }

.ri-send-plane-line:before {
  content: "\\f0da"; }

.ri-send-to-back:before {
  content: "\\f0db"; }

.ri-sensor-fill:before {
  content: "\\f0dc"; }

.ri-sensor-line:before {
  content: "\\f0dd"; }

.ri-separator:before {
  content: "\\f0de"; }

.ri-server-fill:before {
  content: "\\f0df"; }

.ri-server-line:before {
  content: "\\f0e0"; }

.ri-service-fill:before {
  content: "\\f0e1"; }

.ri-service-line:before {
  content: "\\f0e2"; }

.ri-settings-2-fill:before {
  content: "\\f0e3"; }

.ri-settings-2-line:before {
  content: "\\f0e4"; }

.ri-settings-3-fill:before {
  content: "\\f0e5"; }

.ri-settings-3-line:before {
  content: "\\f0e6"; }

.ri-settings-4-fill:before {
  content: "\\f0e7"; }

.ri-settings-4-line:before {
  content: "\\f0e8"; }

.ri-settings-5-fill:before {
  content: "\\f0e9"; }

.ri-settings-5-line:before {
  content: "\\f0ea"; }

.ri-settings-6-fill:before {
  content: "\\f0eb"; }

.ri-settings-6-line:before {
  content: "\\f0ec"; }

.ri-settings-fill:before {
  content: "\\f0ed"; }

.ri-settings-line:before {
  content: "\\f0ee"; }

.ri-shape-2-fill:before {
  content: "\\f0ef"; }

.ri-shape-2-line:before {
  content: "\\f0f0"; }

.ri-shape-fill:before {
  content: "\\f0f1"; }

.ri-shape-line:before {
  content: "\\f0f2"; }

.ri-share-box-fill:before {
  content: "\\f0f3"; }

.ri-share-box-line:before {
  content: "\\f0f4"; }

.ri-share-circle-fill:before {
  content: "\\f0f5"; }

.ri-share-circle-line:before {
  content: "\\f0f6"; }

.ri-share-fill:before {
  content: "\\f0f7"; }

.ri-share-forward-2-fill:before {
  content: "\\f0f8"; }

.ri-share-forward-2-line:before {
  content: "\\f0f9"; }

.ri-share-forward-box-fill:before {
  content: "\\f0fa"; }

.ri-share-forward-box-line:before {
  content: "\\f0fb"; }

.ri-share-forward-fill:before {
  content: "\\f0fc"; }

.ri-share-forward-line:before {
  content: "\\f0fd"; }

.ri-share-line:before {
  content: "\\f0fe"; }

.ri-shield-check-fill:before {
  content: "\\f0ff"; }

.ri-shield-check-line:before {
  content: "\\f100"; }

.ri-shield-cross-fill:before {
  content: "\\f101"; }

.ri-shield-cross-line:before {
  content: "\\f102"; }

.ri-shield-fill:before {
  content: "\\f103"; }

.ri-shield-flash-fill:before {
  content: "\\f104"; }

.ri-shield-flash-line:before {
  content: "\\f105"; }

.ri-shield-keyhole-fill:before {
  content: "\\f106"; }

.ri-shield-keyhole-line:before {
  content: "\\f107"; }

.ri-shield-line:before {
  content: "\\f108"; }

.ri-shield-star-fill:before {
  content: "\\f109"; }

.ri-shield-star-line:before {
  content: "\\f10a"; }

.ri-shield-user-fill:before {
  content: "\\f10b"; }

.ri-shield-user-line:before {
  content: "\\f10c"; }

.ri-ship-2-fill:before {
  content: "\\f10d"; }

.ri-ship-2-line:before {
  content: "\\f10e"; }

.ri-ship-fill:before {
  content: "\\f10f"; }

.ri-ship-line:before {
  content: "\\f110"; }

.ri-shirt-fill:before {
  content: "\\f111"; }

.ri-shirt-line:before {
  content: "\\f112"; }

.ri-shopping-bag-2-fill:before {
  content: "\\f113"; }

.ri-shopping-bag-2-line:before {
  content: "\\f114"; }

.ri-shopping-bag-3-fill:before {
  content: "\\f115"; }

.ri-shopping-bag-3-line:before {
  content: "\\f116"; }

.ri-shopping-bag-fill:before {
  content: "\\f117"; }

.ri-shopping-bag-line:before {
  content: "\\f118"; }

.ri-shopping-basket-2-fill:before {
  content: "\\f119"; }

.ri-shopping-basket-2-line:before {
  content: "\\f11a"; }

.ri-shopping-basket-fill:before {
  content: "\\f11b"; }

.ri-shopping-basket-line:before {
  content: "\\f11c"; }

.ri-shopping-cart-2-fill:before {
  content: "\\f11d"; }

.ri-shopping-cart-2-line:before {
  content: "\\f11e"; }

.ri-shopping-cart-fill:before {
  content: "\\f11f"; }

.ri-shopping-cart-line:before {
  content: "\\f120"; }

.ri-showers-fill:before {
  content: "\\f121"; }

.ri-showers-line:before {
  content: "\\f122"; }

.ri-shuffle-fill:before {
  content: "\\f123"; }

.ri-shuffle-line:before {
  content: "\\f124"; }

.ri-shut-down-fill:before {
  content: "\\f125"; }

.ri-shut-down-line:before {
  content: "\\f126"; }

.ri-side-bar-fill:before {
  content: "\\f127"; }

.ri-side-bar-line:before {
  content: "\\f128"; }

.ri-signal-tower-fill:before {
  content: "\\f129"; }

.ri-signal-tower-line:before {
  content: "\\f12a"; }

.ri-signal-wifi-1-fill:before {
  content: "\\f12b"; }

.ri-signal-wifi-1-line:before {
  content: "\\f12c"; }

.ri-signal-wifi-2-fill:before {
  content: "\\f12d"; }

.ri-signal-wifi-2-line:before {
  content: "\\f12e"; }

.ri-signal-wifi-3-fill:before {
  content: "\\f12f"; }

.ri-signal-wifi-3-line:before {
  content: "\\f130"; }

.ri-signal-wifi-error-fill:before {
  content: "\\f131"; }

.ri-signal-wifi-error-line:before {
  content: "\\f132"; }

.ri-signal-wifi-fill:before {
  content: "\\f133"; }

.ri-signal-wifi-line:before {
  content: "\\f134"; }

.ri-signal-wifi-off-fill:before {
  content: "\\f135"; }

.ri-signal-wifi-off-line:before {
  content: "\\f136"; }

.ri-sim-card-2-fill:before {
  content: "\\f137"; }

.ri-sim-card-2-line:before {
  content: "\\f138"; }

.ri-sim-card-fill:before {
  content: "\\f139"; }

.ri-sim-card-line:before {
  content: "\\f13a"; }

.ri-single-quotes-l:before {
  content: "\\f13b"; }

.ri-single-quotes-r:before {
  content: "\\f13c"; }

.ri-sip-fill:before {
  content: "\\f13d"; }

.ri-sip-line:before {
  content: "\\f13e"; }

.ri-skip-back-fill:before {
  content: "\\f13f"; }

.ri-skip-back-line:before {
  content: "\\f140"; }

.ri-skip-back-mini-fill:before {
  content: "\\f141"; }

.ri-skip-back-mini-line:before {
  content: "\\f142"; }

.ri-skip-forward-fill:before {
  content: "\\f143"; }

.ri-skip-forward-line:before {
  content: "\\f144"; }

.ri-skip-forward-mini-fill:before {
  content: "\\f145"; }

.ri-skip-forward-mini-line:before {
  content: "\\f146"; }

.ri-skull-2-fill:before {
  content: "\\f147"; }

.ri-skull-2-line:before {
  content: "\\f148"; }

.ri-skull-fill:before {
  content: "\\f149"; }

.ri-skull-line:before {
  content: "\\f14a"; }

.ri-skype-fill:before {
  content: "\\f14b"; }

.ri-skype-line:before {
  content: "\\f14c"; }

.ri-slack-fill:before {
  content: "\\f14d"; }

.ri-slack-line:before {
  content: "\\f14e"; }

.ri-slice-fill:before {
  content: "\\f14f"; }

.ri-slice-line:before {
  content: "\\f150"; }

.ri-slideshow-2-fill:before {
  content: "\\f151"; }

.ri-slideshow-2-line:before {
  content: "\\f152"; }

.ri-slideshow-3-fill:before {
  content: "\\f153"; }

.ri-slideshow-3-line:before {
  content: "\\f154"; }

.ri-slideshow-4-fill:before {
  content: "\\f155"; }

.ri-slideshow-4-line:before {
  content: "\\f156"; }

.ri-slideshow-fill:before {
  content: "\\f157"; }

.ri-slideshow-line:before {
  content: "\\f158"; }

.ri-smartphone-fill:before {
  content: "\\f159"; }

.ri-smartphone-line:before {
  content: "\\f15a"; }

.ri-snapchat-fill:before {
  content: "\\f15b"; }

.ri-snapchat-line:before {
  content: "\\f15c"; }

.ri-snowy-fill:before {
  content: "\\f15d"; }

.ri-snowy-line:before {
  content: "\\f15e"; }

.ri-sort-asc:before {
  content: "\\f15f"; }

.ri-sort-desc:before {
  content: "\\f160"; }

.ri-sound-module-fill:before {
  content: "\\f161"; }

.ri-sound-module-line:before {
  content: "\\f162"; }

.ri-soundcloud-fill:before {
  content: "\\f163"; }

.ri-soundcloud-line:before {
  content: "\\f164"; }

.ri-space-ship-fill:before {
  content: "\\f165"; }

.ri-space-ship-line:before {
  content: "\\f166"; }

.ri-space:before {
  content: "\\f167"; }

.ri-spam-2-fill:before {
  content: "\\f168"; }

.ri-spam-2-line:before {
  content: "\\f169"; }

.ri-spam-3-fill:before {
  content: "\\f16a"; }

.ri-spam-3-line:before {
  content: "\\f16b"; }

.ri-spam-fill:before {
  content: "\\f16c"; }

.ri-spam-line:before {
  content: "\\f16d"; }

.ri-speaker-2-fill:before {
  content: "\\f16e"; }

.ri-speaker-2-line:before {
  content: "\\f16f"; }

.ri-speaker-3-fill:before {
  content: "\\f170"; }

.ri-speaker-3-line:before {
  content: "\\f171"; }

.ri-speaker-fill:before {
  content: "\\f172"; }

.ri-speaker-line:before {
  content: "\\f173"; }

.ri-spectrum-fill:before {
  content: "\\f174"; }

.ri-spectrum-line:before {
  content: "\\f175"; }

.ri-speed-fill:before {
  content: "\\f176"; }

.ri-speed-line:before {
  content: "\\f177"; }

.ri-speed-mini-fill:before {
  content: "\\f178"; }

.ri-speed-mini-line:before {
  content: "\\f179"; }

.ri-split-cells-horizontal:before {
  content: "\\f17a"; }

.ri-split-cells-vertical:before {
  content: "\\f17b"; }

.ri-spotify-fill:before {
  content: "\\f17c"; }

.ri-spotify-line:before {
  content: "\\f17d"; }

.ri-spy-fill:before {
  content: "\\f17e"; }

.ri-spy-line:before {
  content: "\\f17f"; }

.ri-stack-fill:before {
  content: "\\f180"; }

.ri-stack-line:before {
  content: "\\f181"; }

.ri-stack-overflow-fill:before {
  content: "\\f182"; }

.ri-stack-overflow-line:before {
  content: "\\f183"; }

.ri-stackshare-fill:before {
  content: "\\f184"; }

.ri-stackshare-line:before {
  content: "\\f185"; }

.ri-star-fill:before {
  content: "\\f186"; }

.ri-star-half-fill:before {
  content: "\\f187"; }

.ri-star-half-line:before {
  content: "\\f188"; }

.ri-star-half-s-fill:before {
  content: "\\f189"; }

.ri-star-half-s-line:before {
  content: "\\f18a"; }

.ri-star-line:before {
  content: "\\f18b"; }

.ri-star-s-fill:before {
  content: "\\f18c"; }

.ri-star-s-line:before {
  content: "\\f18d"; }

.ri-star-smile-fill:before {
  content: "\\f18e"; }

.ri-star-smile-line:before {
  content: "\\f18f"; }

.ri-steam-fill:before {
  content: "\\f190"; }

.ri-steam-line:before {
  content: "\\f191"; }

.ri-steering-2-fill:before {
  content: "\\f192"; }

.ri-steering-2-line:before {
  content: "\\f193"; }

.ri-steering-fill:before {
  content: "\\f194"; }

.ri-steering-line:before {
  content: "\\f195"; }

.ri-stethoscope-fill:before {
  content: "\\f196"; }

.ri-stethoscope-line:before {
  content: "\\f197"; }

.ri-sticky-note-2-fill:before {
  content: "\\f198"; }

.ri-sticky-note-2-line:before {
  content: "\\f199"; }

.ri-sticky-note-fill:before {
  content: "\\f19a"; }

.ri-sticky-note-line:before {
  content: "\\f19b"; }

.ri-stock-fill:before {
  content: "\\f19c"; }

.ri-stock-line:before {
  content: "\\f19d"; }

.ri-stop-circle-fill:before {
  content: "\\f19e"; }

.ri-stop-circle-line:before {
  content: "\\f19f"; }

.ri-stop-fill:before {
  content: "\\f1a0"; }

.ri-stop-line:before {
  content: "\\f1a1"; }

.ri-stop-mini-fill:before {
  content: "\\f1a2"; }

.ri-stop-mini-line:before {
  content: "\\f1a3"; }

.ri-store-2-fill:before {
  content: "\\f1a4"; }

.ri-store-2-line:before {
  content: "\\f1a5"; }

.ri-store-3-fill:before {
  content: "\\f1a6"; }

.ri-store-3-line:before {
  content: "\\f1a7"; }

.ri-store-fill:before {
  content: "\\f1a8"; }

.ri-store-line:before {
  content: "\\f1a9"; }

.ri-strikethrough-2:before {
  content: "\\f1aa"; }

.ri-strikethrough:before {
  content: "\\f1ab"; }

.ri-subscript-2:before {
  content: "\\f1ac"; }

.ri-subscript:before {
  content: "\\f1ad"; }

.ri-subtract-fill:before {
  content: "\\f1ae"; }

.ri-subtract-line:before {
  content: "\\f1af"; }

.ri-subway-fill:before {
  content: "\\f1b0"; }

.ri-subway-line:before {
  content: "\\f1b1"; }

.ri-subway-wifi-fill:before {
  content: "\\f1b2"; }

.ri-subway-wifi-line:before {
  content: "\\f1b3"; }

.ri-suitcase-2-fill:before {
  content: "\\f1b4"; }

.ri-suitcase-2-line:before {
  content: "\\f1b5"; }

.ri-suitcase-3-fill:before {
  content: "\\f1b6"; }

.ri-suitcase-3-line:before {
  content: "\\f1b7"; }

.ri-suitcase-fill:before {
  content: "\\f1b8"; }

.ri-suitcase-line:before {
  content: "\\f1b9"; }

.ri-sun-cloudy-fill:before {
  content: "\\f1ba"; }

.ri-sun-cloudy-line:before {
  content: "\\f1bb"; }

.ri-sun-fill:before {
  content: "\\f1bc"; }

.ri-sun-foggy-fill:before {
  content: "\\f1bd"; }

.ri-sun-foggy-line:before {
  content: "\\f1be"; }

.ri-sun-line:before {
  content: "\\f1bf"; }

.ri-superscript-2:before {
  content: "\\f1c0"; }

.ri-superscript:before {
  content: "\\f1c1"; }

.ri-surgical-mask-fill:before {
  content: "\\f1c2"; }

.ri-surgical-mask-line:before {
  content: "\\f1c3"; }

.ri-surround-sound-fill:before {
  content: "\\f1c4"; }

.ri-surround-sound-line:before {
  content: "\\f1c5"; }

.ri-survey-fill:before {
  content: "\\f1c6"; }

.ri-survey-line:before {
  content: "\\f1c7"; }

.ri-swap-box-fill:before {
  content: "\\f1c8"; }

.ri-swap-box-line:before {
  content: "\\f1c9"; }

.ri-swap-fill:before {
  content: "\\f1ca"; }

.ri-swap-line:before {
  content: "\\f1cb"; }

.ri-switch-fill:before {
  content: "\\f1cc"; }

.ri-switch-line:before {
  content: "\\f1cd"; }

.ri-sword-fill:before {
  content: "\\f1ce"; }

.ri-sword-line:before {
  content: "\\f1cf"; }

.ri-syringe-fill:before {
  content: "\\f1d0"; }

.ri-syringe-line:before {
  content: "\\f1d1"; }

.ri-t-box-fill:before {
  content: "\\f1d2"; }

.ri-t-box-line:before {
  content: "\\f1d3"; }

.ri-t-shirt-2-fill:before {
  content: "\\f1d4"; }

.ri-t-shirt-2-line:before {
  content: "\\f1d5"; }

.ri-t-shirt-air-fill:before {
  content: "\\f1d6"; }

.ri-t-shirt-air-line:before {
  content: "\\f1d7"; }

.ri-t-shirt-fill:before {
  content: "\\f1d8"; }

.ri-t-shirt-line:before {
  content: "\\f1d9"; }

.ri-table-2:before {
  content: "\\f1da"; }

.ri-table-alt-fill:before {
  content: "\\f1db"; }

.ri-table-alt-line:before {
  content: "\\f1dc"; }

.ri-table-fill:before {
  content: "\\f1dd"; }

.ri-table-line:before {
  content: "\\f1de"; }

.ri-tablet-fill:before {
  content: "\\f1df"; }

.ri-tablet-line:before {
  content: "\\f1e0"; }

.ri-takeaway-fill:before {
  content: "\\f1e1"; }

.ri-takeaway-line:before {
  content: "\\f1e2"; }

.ri-taobao-fill:before {
  content: "\\f1e3"; }

.ri-taobao-line:before {
  content: "\\f1e4"; }

.ri-tape-fill:before {
  content: "\\f1e5"; }

.ri-tape-line:before {
  content: "\\f1e6"; }

.ri-task-fill:before {
  content: "\\f1e7"; }

.ri-task-line:before {
  content: "\\f1e8"; }

.ri-taxi-fill:before {
  content: "\\f1e9"; }

.ri-taxi-line:before {
  content: "\\f1ea"; }

.ri-taxi-wifi-fill:before {
  content: "\\f1eb"; }

.ri-taxi-wifi-line:before {
  content: "\\f1ec"; }

.ri-team-fill:before {
  content: "\\f1ed"; }

.ri-team-line:before {
  content: "\\f1ee"; }

.ri-telegram-fill:before {
  content: "\\f1ef"; }

.ri-telegram-line:before {
  content: "\\f1f0"; }

.ri-temp-cold-fill:before {
  content: "\\f1f1"; }

.ri-temp-cold-line:before {
  content: "\\f1f2"; }

.ri-temp-hot-fill:before {
  content: "\\f1f3"; }

.ri-temp-hot-line:before {
  content: "\\f1f4"; }

.ri-terminal-box-fill:before {
  content: "\\f1f5"; }

.ri-terminal-box-line:before {
  content: "\\f1f6"; }

.ri-terminal-fill:before {
  content: "\\f1f7"; }

.ri-terminal-line:before {
  content: "\\f1f8"; }

.ri-terminal-window-fill:before {
  content: "\\f1f9"; }

.ri-terminal-window-line:before {
  content: "\\f1fa"; }

.ri-test-tube-fill:before {
  content: "\\f1fb"; }

.ri-test-tube-line:before {
  content: "\\f1fc"; }

.ri-text-direction-l:before {
  content: "\\f1fd"; }

.ri-text-direction-r:before {
  content: "\\f1fe"; }

.ri-text-spacing:before {
  content: "\\f1ff"; }

.ri-text-wrap:before {
  content: "\\f200"; }

.ri-text:before {
  content: "\\f201"; }

.ri-thermometer-fill:before {
  content: "\\f202"; }

.ri-thermometer-line:before {
  content: "\\f203"; }

.ri-thumb-down-fill:before {
  content: "\\f204"; }

.ri-thumb-down-line:before {
  content: "\\f205"; }

.ri-thumb-up-fill:before {
  content: "\\f206"; }

.ri-thumb-up-line:before {
  content: "\\f207"; }

.ri-thunderstorms-fill:before {
  content: "\\f208"; }

.ri-thunderstorms-line:before {
  content: "\\f209"; }

.ri-ticket-2-fill:before {
  content: "\\f20a"; }

.ri-ticket-2-line:before {
  content: "\\f20b"; }

.ri-ticket-fill:before {
  content: "\\f20c"; }

.ri-ticket-line:before {
  content: "\\f20d"; }

.ri-time-fill:before {
  content: "\\f20e"; }

.ri-time-line:before {
  content: "\\f20f"; }

.ri-timer-2-fill:before {
  content: "\\f210"; }

.ri-timer-2-line:before {
  content: "\\f211"; }

.ri-timer-fill:before {
  content: "\\f212"; }

.ri-timer-flash-fill:before {
  content: "\\f213"; }

.ri-timer-flash-line:before {
  content: "\\f214"; }

.ri-timer-line:before {
  content: "\\f215"; }

.ri-todo-fill:before {
  content: "\\f216"; }

.ri-todo-line:before {
  content: "\\f217"; }

.ri-toggle-fill:before {
  content: "\\f218"; }

.ri-toggle-line:before {
  content: "\\f219"; }

.ri-tools-fill:before {
  content: "\\f21a"; }

.ri-tools-line:before {
  content: "\\f21b"; }

.ri-tornado-fill:before {
  content: "\\f21c"; }

.ri-tornado-line:before {
  content: "\\f21d"; }

.ri-trademark-fill:before {
  content: "\\f21e"; }

.ri-trademark-line:before {
  content: "\\f21f"; }

.ri-traffic-light-fill:before {
  content: "\\f220"; }

.ri-traffic-light-line:before {
  content: "\\f221"; }

.ri-train-fill:before {
  content: "\\f222"; }

.ri-train-line:before {
  content: "\\f223"; }

.ri-train-wifi-fill:before {
  content: "\\f224"; }

.ri-train-wifi-line:before {
  content: "\\f225"; }

.ri-translate-2:before {
  content: "\\f226"; }

.ri-translate:before {
  content: "\\f227"; }

.ri-travesti-fill:before {
  content: "\\f228"; }

.ri-travesti-line:before {
  content: "\\f229"; }

.ri-treasure-map-fill:before {
  content: "\\f22a"; }

.ri-treasure-map-line:before {
  content: "\\f22b"; }

.ri-trello-fill:before {
  content: "\\f22c"; }

.ri-trello-line:before {
  content: "\\f22d"; }

.ri-trophy-fill:before {
  content: "\\f22e"; }

.ri-trophy-line:before {
  content: "\\f22f"; }

.ri-truck-fill:before {
  content: "\\f230"; }

.ri-truck-line:before {
  content: "\\f231"; }

.ri-tumblr-fill:before {
  content: "\\f232"; }

.ri-tumblr-line:before {
  content: "\\f233"; }

.ri-tv-2-fill:before {
  content: "\\f234"; }

.ri-tv-2-line:before {
  content: "\\f235"; }

.ri-tv-fill:before {
  content: "\\f236"; }

.ri-tv-line:before {
  content: "\\f237"; }

.ri-twitch-fill:before {
  content: "\\f238"; }

.ri-twitch-line:before {
  content: "\\f239"; }

.ri-twitter-fill:before {
  content: "\\f23a"; }

.ri-twitter-line:before {
  content: "\\f23b"; }

.ri-typhoon-fill:before {
  content: "\\f23c"; }

.ri-typhoon-line:before {
  content: "\\f23d"; }

.ri-u-disk-fill:before {
  content: "\\f23e"; }

.ri-u-disk-line:before {
  content: "\\f23f"; }

.ri-ubuntu-fill:before {
  content: "\\f240"; }

.ri-ubuntu-line:before {
  content: "\\f241"; }

.ri-umbrella-fill:before {
  content: "\\f242"; }

.ri-umbrella-line:before {
  content: "\\f243"; }

.ri-underline:before {
  content: "\\f244"; }

.ri-uninstall-fill:before {
  content: "\\f245"; }

.ri-uninstall-line:before {
  content: "\\f246"; }

.ri-unsplash-fill:before {
  content: "\\f247"; }

.ri-unsplash-line:before {
  content: "\\f248"; }

.ri-upload-2-fill:before {
  content: "\\f249"; }

.ri-upload-2-line:before {
  content: "\\f24a"; }

.ri-upload-cloud-2-fill:before {
  content: "\\f24b"; }

.ri-upload-cloud-2-line:before {
  content: "\\f24c"; }

.ri-upload-cloud-fill:before {
  content: "\\f24d"; }

.ri-upload-cloud-line:before {
  content: "\\f24e"; }

.ri-upload-fill:before {
  content: "\\f24f"; }

.ri-upload-line:before {
  content: "\\f250"; }

.ri-usb-fill:before {
  content: "\\f251"; }

.ri-usb-line:before {
  content: "\\f252"; }

.ri-user-2-fill:before {
  content: "\\f253"; }

.ri-user-2-line:before {
  content: "\\f254"; }

.ri-user-3-fill:before {
  content: "\\f255"; }

.ri-user-3-line:before {
  content: "\\f256"; }

.ri-user-4-fill:before {
  content: "\\f257"; }

.ri-user-4-line:before {
  content: "\\f258"; }

.ri-user-5-fill:before {
  content: "\\f259"; }

.ri-user-5-line:before {
  content: "\\f25a"; }

.ri-user-6-fill:before {
  content: "\\f25b"; }

.ri-user-6-line:before {
  content: "\\f25c"; }

.ri-user-add-fill:before {
  content: "\\f25d"; }

.ri-user-add-line:before {
  content: "\\f25e"; }

.ri-user-fill:before {
  content: "\\f25f"; }

.ri-user-follow-fill:before {
  content: "\\f260"; }

.ri-user-follow-line:before {
  content: "\\f261"; }

.ri-user-heart-fill:before {
  content: "\\f262"; }

.ri-user-heart-line:before {
  content: "\\f263"; }

.ri-user-line:before {
  content: "\\f264"; }

.ri-user-location-fill:before {
  content: "\\f265"; }

.ri-user-location-line:before {
  content: "\\f266"; }

.ri-user-received-2-fill:before {
  content: "\\f267"; }

.ri-user-received-2-line:before {
  content: "\\f268"; }

.ri-user-received-fill:before {
  content: "\\f269"; }

.ri-user-received-line:before {
  content: "\\f26a"; }

.ri-user-search-fill:before {
  content: "\\f26b"; }

.ri-user-search-line:before {
  content: "\\f26c"; }

.ri-user-settings-fill:before {
  content: "\\f26d"; }

.ri-user-settings-line:before {
  content: "\\f26e"; }

.ri-user-shared-2-fill:before {
  content: "\\f26f"; }

.ri-user-shared-2-line:before {
  content: "\\f270"; }

.ri-user-shared-fill:before {
  content: "\\f271"; }

.ri-user-shared-line:before {
  content: "\\f272"; }

.ri-user-smile-fill:before {
  content: "\\f273"; }

.ri-user-smile-line:before {
  content: "\\f274"; }

.ri-user-star-fill:before {
  content: "\\f275"; }

.ri-user-star-line:before {
  content: "\\f276"; }

.ri-user-unfollow-fill:before {
  content: "\\f277"; }

.ri-user-unfollow-line:before {
  content: "\\f278"; }

.ri-user-voice-fill:before {
  content: "\\f279"; }

.ri-user-voice-line:before {
  content: "\\f27a"; }

.ri-video-add-fill:before {
  content: "\\f27b"; }

.ri-video-add-line:before {
  content: "\\f27c"; }

.ri-video-chat-fill:before {
  content: "\\f27d"; }

.ri-video-chat-line:before {
  content: "\\f27e"; }

.ri-video-download-fill:before {
  content: "\\f27f"; }

.ri-video-download-line:before {
  content: "\\f280"; }

.ri-video-fill:before {
  content: "\\f281"; }

.ri-video-line:before {
  content: "\\f282"; }

.ri-video-upload-fill:before {
  content: "\\f283"; }

.ri-video-upload-line:before {
  content: "\\f284"; }

.ri-vidicon-2-fill:before {
  content: "\\f285"; }

.ri-vidicon-2-line:before {
  content: "\\f286"; }

.ri-vidicon-fill:before {
  content: "\\f287"; }

.ri-vidicon-line:before {
  content: "\\f288"; }

.ri-vimeo-fill:before {
  content: "\\f289"; }

.ri-vimeo-line:before {
  content: "\\f28a"; }

.ri-vip-crown-2-fill:before {
  content: "\\f28b"; }

.ri-vip-crown-2-line:before {
  content: "\\f28c"; }

.ri-vip-crown-fill:before {
  content: "\\f28d"; }

.ri-vip-crown-line:before {
  content: "\\f28e"; }

.ri-vip-diamond-fill:before {
  content: "\\f28f"; }

.ri-vip-diamond-line:before {
  content: "\\f290"; }

.ri-vip-fill:before {
  content: "\\f291"; }

.ri-vip-line:before {
  content: "\\f292"; }

.ri-virus-fill:before {
  content: "\\f293"; }

.ri-virus-line:before {
  content: "\\f294"; }

.ri-visa-fill:before {
  content: "\\f295"; }

.ri-visa-line:before {
  content: "\\f296"; }

.ri-voice-recognition-fill:before {
  content: "\\f297"; }

.ri-voice-recognition-line:before {
  content: "\\f298"; }

.ri-voiceprint-fill:before {
  content: "\\f299"; }

.ri-voiceprint-line:before {
  content: "\\f29a"; }

.ri-volume-down-fill:before {
  content: "\\f29b"; }

.ri-volume-down-line:before {
  content: "\\f29c"; }

.ri-volume-mute-fill:before {
  content: "\\f29d"; }

.ri-volume-mute-line:before {
  content: "\\f29e"; }

.ri-volume-off-vibrate-fill:before {
  content: "\\f29f"; }

.ri-volume-off-vibrate-line:before {
  content: "\\f2a0"; }

.ri-volume-up-fill:before {
  content: "\\f2a1"; }

.ri-volume-up-line:before {
  content: "\\f2a2"; }

.ri-volume-vibrate-fill:before {
  content: "\\f2a3"; }

.ri-volume-vibrate-line:before {
  content: "\\f2a4"; }

.ri-vuejs-fill:before {
  content: "\\f2a5"; }

.ri-vuejs-line:before {
  content: "\\f2a6"; }

.ri-walk-fill:before {
  content: "\\f2a7"; }

.ri-walk-line:before {
  content: "\\f2a8"; }

.ri-wallet-2-fill:before {
  content: "\\f2a9"; }

.ri-wallet-2-line:before {
  content: "\\f2aa"; }

.ri-wallet-3-fill:before {
  content: "\\f2ab"; }

.ri-wallet-3-line:before {
  content: "\\f2ac"; }

.ri-wallet-fill:before {
  content: "\\f2ad"; }

.ri-wallet-line:before {
  content: "\\f2ae"; }

.ri-water-flash-fill:before {
  content: "\\f2af"; }

.ri-water-flash-line:before {
  content: "\\f2b0"; }

.ri-webcam-fill:before {
  content: "\\f2b1"; }

.ri-webcam-line:before {
  content: "\\f2b2"; }

.ri-wechat-2-fill:before {
  content: "\\f2b3"; }

.ri-wechat-2-line:before {
  content: "\\f2b4"; }

.ri-wechat-fill:before {
  content: "\\f2b5"; }

.ri-wechat-line:before {
  content: "\\f2b6"; }

.ri-wechat-pay-fill:before {
  content: "\\f2b7"; }

.ri-wechat-pay-line:before {
  content: "\\f2b8"; }

.ri-weibo-fill:before {
  content: "\\f2b9"; }

.ri-weibo-line:before {
  content: "\\f2ba"; }

.ri-whatsapp-fill:before {
  content: "\\f2bb"; }

.ri-whatsapp-line:before {
  content: "\\f2bc"; }

.ri-wheelchair-fill:before {
  content: "\\f2bd"; }

.ri-wheelchair-line:before {
  content: "\\f2be"; }

.ri-wifi-fill:before {
  content: "\\f2bf"; }

.ri-wifi-line:before {
  content: "\\f2c0"; }

.ri-wifi-off-fill:before {
  content: "\\f2c1"; }

.ri-wifi-off-line:before {
  content: "\\f2c2"; }

.ri-window-2-fill:before {
  content: "\\f2c3"; }

.ri-window-2-line:before {
  content: "\\f2c4"; }

.ri-window-fill:before {
  content: "\\f2c5"; }

.ri-window-line:before {
  content: "\\f2c6"; }

.ri-windows-fill:before {
  content: "\\f2c7"; }

.ri-windows-line:before {
  content: "\\f2c8"; }

.ri-windy-fill:before {
  content: "\\f2c9"; }

.ri-windy-line:before {
  content: "\\f2ca"; }

.ri-wireless-charging-fill:before {
  content: "\\f2cb"; }

.ri-wireless-charging-line:before {
  content: "\\f2cc"; }

.ri-women-fill:before {
  content: "\\f2cd"; }

.ri-women-line:before {
  content: "\\f2ce"; }

.ri-wubi-input:before {
  content: "\\f2cf"; }

.ri-xbox-fill:before {
  content: "\\f2d0"; }

.ri-xbox-line:before {
  content: "\\f2d1"; }

.ri-xing-fill:before {
  content: "\\f2d2"; }

.ri-xing-line:before {
  content: "\\f2d3"; }

.ri-youtube-fill:before {
  content: "\\f2d4"; }

.ri-youtube-line:before {
  content: "\\f2d5"; }

.ri-zcool-fill:before {
  content: "\\f2d6"; }

.ri-zcool-line:before {
  content: "\\f2d7"; }

.ri-zhihu-fill:before {
  content: "\\f2d8"; }

.ri-zhihu-line:before {
  content: "\\f2d9"; }

.ri-zoom-in-fill:before {
  content: "\\f2da"; }

.ri-zoom-in-line:before {
  content: "\\f2db"; }

.ri-zoom-out-fill:before {
  content: "\\f2dc"; }

.ri-zoom-out-line:before {
  content: "\\f2dd"; }

.ri-zzz-fill:before {
  content: "\\f2de"; }

.ri-zzz-line:before {
  content: "\\f2df"; }

/*
Template Name: Velzon - Admin & Dashboard Template
Author: Themesbrand
Version: 2.4.0
Website: https://Themesbrand.com/
Contact: Themesbrand@gmail.com
File: Custom Bootstrap Css File
*/
/*!
   * Bootstrap  v5.2.3 (https://getbootstrap.com/)
   * Copyright 2011-2022 The Bootstrap Authors
   * Copyright 2011-2022 Twitter, Inc.
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   */
:root {
  --vz-blue: #3577f1;
  --vz-indigo: #F26430;
  --vz-purple: #F28322;
  --vz-pink: #f672a7;
  --vz-red: #f06548;
  --vz-orange: #208C3B;
  --vz-yellow: #3FBF48;
  --vz-green: #0ab39c;
  --vz-teal: #02a8b5;
  --vz-cyan: #299cdb;
  --vz-white: #fff;
  --vz-gray: #878a99;
  --vz-gray-dark: #343a40;
  --vz-gray-100: #f3f6f9;
  --vz-gray-200: #eff2f7;
  --vz-gray-300: #e9ebec;
  --vz-gray-400: #ced4da;
  --vz-gray-500: #adb5bd;
  --vz-gray-600: #878a99;
  --vz-gray-700: #495057;
  --vz-gray-800: #343a40;
  --vz-gray-900: #212529;
  --vz-primary: #F26430;
  --vz-secondary: #208C3B;
  --vz-success: #0ab39c;
  --vz-info: #299cdb;
  --vz-warning: #3FBF48;
  --vz-danger: #f06548;
  --vz-light: #f3f6f9;
  --vz-dark: #212529;
  --vz-primary-rgb: 242, 100, 48;
  --vz-secondary-rgb: 32, 140, 59;
  --vz-success-rgb: 10, 179, 156;
  --vz-info-rgb: 41, 156, 219;
  --vz-warning-rgb: 63, 191, 72;
  --vz-danger-rgb: 240, 101, 72;
  --vz-light-rgb: 243, 246, 249;
  --vz-dark-rgb: 33, 37, 41;
  --vz-white-rgb: 255, 255, 255;
  --vz-black-rgb: 0, 0, 0;
  --vz-body-color-rgb: 33, 37, 41;
  --vz-body-bg-rgb: 243, 243, 249;
  --vz-font-sans-serif: "Poppins", sans-serif;
  --vz-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --vz-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --vz-body-font-family: var(--vz-font-sans-serif);
  --vz-body-font-size: 0.8125rem;
  --vz-body-font-weight: 400;
  --vz-body-line-height: 1.5;
  --vz-body-color: #212529;
  --vz-body-bg: #f3f3f9;
  --vz-border-width: 1px;
  --vz-border-style: solid;
  --vz-border-color: var(--vz-border-color);
  --vz-border-color-translucent: rgba(0, 0, 0, 0.175);
  --vz-border-radius: 0.25rem;
  --vz-border-radius-sm: 0.2rem;
  --vz-border-radius-lg: 0.3rem;
  --vz-border-radius-xl: 1rem;
  --vz-border-radius-2xl: 2rem;
  --vz-border-radius-pill: 50rem;
  --vz-link-color: var(--vz-link-color);
  --vz-link-hover-color: var(--vz-link-hover-color);
  --vz-code-color: #f672a7;
  --vz-highlight-bg: #fcf8e3; }

*,
*::before,
*::after {
  box-sizing: border-box; }

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth; } }

body {
  margin: 0;
  font-family: var(--vz-body-font-family);
  font-size: var(--vz-body-font-size);
  font-weight: var(--vz-body-font-weight);
  line-height: var(--vz-body-line-height);
  color: var(--vz-body-color);
  text-align: var(--vz-body-text-align);
  background-color: var(--vz-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: 1px solid;
  opacity: 0.25; }

h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 500;
  line-height: 1.2; }

h1, .h1 {
  font-size: calc(1.32813rem + 0.9375vw); }
  @media (min-width: 1200px) {
    h1, .h1 {
      font-size: 2.03125rem; } }

h2, .h2 {
  font-size: calc(1.2875rem + 0.45vw); }
  @media (min-width: 1200px) {
    h2, .h2 {
      font-size: 1.625rem; } }

h3, .h3 {
  font-size: calc(1.26719rem + 0.20625vw); }
  @media (min-width: 1200px) {
    h3, .h3 {
      font-size: 1.42188rem; } }

h4, .h4 {
  font-size: 1.21875rem; }

h5, .h5 {
  font-size: 1.01563rem; }
  @media (min-width: 1200px) {
    h5, .h5 {
      font-size: 1.01562rem; } }

h6, .h6 {
  font-size: 0.8125rem; }

p {
  margin-top: 0;
  margin-bottom: 1rem; }

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none; }

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit; }

ol,
ul {
  padding-left: 2rem; }

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem; }

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0; }

dt {
  font-weight: 600; }

dd {
  margin-bottom: .5rem;
  margin-left: 0; }

blockquote {
  margin: 0 0 1rem; }

b,
strong {
  font-weight: bolder; }

small, .small {
  font-size: 0.875em; }

mark, .mark {
  padding: 0.2em;
  background-color: var(--vz-highlight-bg); }

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline; }

sub {
  bottom: -.25em; }

sup {
  top: -.5em; }

a {
  color: var(--vz-link-color);
  text-decoration: underline; }
  a:hover {
    color: var(--vz-link-hover-color); }

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none; }

pre,
code,
kbd,
samp {
  font-family: var(--vz-font-monospace);
  font-size: 1em; }

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em; }
  pre code {
    font-size: inherit;
    color: inherit;
    word-break: normal; }

code {
  font-size: 0.875em;
  color: var(--vz-code-color);
  word-wrap: break-word; }
  a > code {
    color: inherit; }

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 0.875em;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem; }
  kbd kbd {
    padding: 0;
    font-size: 1em;
    font-weight: 700; }

figure {
  margin: 0 0 1rem; }

img,
svg {
  vertical-align: middle; }

table {
  caption-side: bottom;
  border-collapse: collapse; }

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #878a99;
  text-align: left; }

th {
  text-align: inherit;
  text-align: -webkit-match-parent; }

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0; }

label {
  display: inline-block; }

button {
  border-radius: 0; }

button:focus:not(:focus-visible) {
  outline: 0; }

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit; }

button,
select {
  text-transform: none; }

[role="button"] {
  cursor: pointer; }

select {
  word-wrap: normal; }
  select:disabled {
    opacity: 1; }

[list]:not([type="date"]):not([type="datetime-local"]):not([type="month"]):not([type="week"]):not([type="time"])::-webkit-calendar-picker-indicator {
  display: none !important; }

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button; }
  button:not(:disabled),
  [type="button"]:not(:disabled),
  [type="reset"]:not(:disabled),
  [type="submit"]:not(:disabled) {
    cursor: pointer; }

::-moz-focus-inner {
  padding: 0;
  border-style: none; }

textarea {
  resize: vertical; }

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0; }

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit; }
  @media (min-width: 1200px) {
    legend {
      font-size: 1.5rem; } }
  legend + * {
    clear: left; }

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0; }

::-webkit-inner-spin-button {
  height: auto; }

[type="search"] {
  outline-offset: -2px;
  -webkit-appearance: textfield; }

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none; }

::-webkit-color-swatch-wrapper {
  padding: 0; }

::file-selector-button {
  font: inherit;
  -webkit-appearance: button; }

output {
  display: inline-block; }

iframe {
  border: 0; }

summary {
  display: list-item;
  cursor: pointer; }

progress {
  vertical-align: baseline; }

[hidden] {
  display: none !important; }

.lead {
  font-size: 1.01563rem;
  font-weight: 300; }
  @media (min-width: 1200px) {
    .lead {
      font-size: 1.01562rem; } }

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-1 {
      font-size: 5rem; } }

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-2 {
      font-size: 4.5rem; } }

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-3 {
      font-size: 4rem; } }

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-4 {
      font-size: 3.5rem; } }

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-5 {
      font-size: 3rem; } }

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-6 {
      font-size: 2.5rem; } }

.list-unstyled {
  padding-left: 0;
  list-style: none; }

.list-inline {
  padding-left: 0;
  list-style: none; }

.list-inline-item {
  display: inline-block; }
  .list-inline-item:not(:last-child) {
    margin-right: 0.5rem; }

.initialism {
  font-size: 0.875em;
  text-transform: uppercase; }

.blockquote {
  margin-bottom: 1rem;
  font-size: 0.89375rem; }
  .blockquote > :last-child {
    margin-bottom: 0; }

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #878a99; }
  .blockquote-footer::before {
    content: "\\2014\\00A0"; }

.img-fluid {
  max-width: 100%;
  height: auto; }

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--vz-body-bg);
  border: 1px solid var(--vz-border-color);
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto; }

.figure {
  display: inline-block; }

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1; }

.figure-caption {
  font-size: 0.875em;
  color: #878a99; }

.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl,
.container-xxl {
  --vz-gutter-x: 1rem;
  --vz-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--vz-gutter-x) * .5);
  padding-left: calc(var(--vz-gutter-x) * .5);
  margin-right: auto;
  margin-left: auto; }

@media (min-width: 576px) {
  .container, .container-sm {
    max-width: 540px; } }

@media (min-width: 768px) {
  .container, .container-sm, .container-md {
    max-width: 720px; } }

@media (min-width: 992px) {
  .container, .container-sm, .container-md, .container-lg {
    max-width: 960px; } }

@media (min-width: 1200px) {
  .container, .container-sm, .container-md, .container-lg, .container-xl {
    max-width: 1140px; } }

@media (min-width: 1400px) {
  .container, .container-sm, .container-md, .container-lg, .container-xl, .container-xxl {
    max-width: 1320px; } }

.row {
  --vz-gutter-x: 1rem;
  --vz-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--vz-gutter-y));
  margin-right: calc(-.5 * var(--vz-gutter-x));
  margin-left: calc(-.5 * var(--vz-gutter-x)); }
  .row > * {
    flex-shrink: 0;
    width: 100%;
    max-width: 100%;
    padding-right: calc(var(--vz-gutter-x) * .5);
    padding-left: calc(var(--vz-gutter-x) * .5);
    margin-top: var(--vz-gutter-y); }

.col {
  flex: 1 0; }

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto; }

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%; }

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%; }

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333%; }

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%; }

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%; }

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66667%; }

.col-auto {
  flex: 0 0 auto;
  width: auto; }

.col-1 {
  flex: 0 0 auto;
  width: 8.33333%; }

.col-2 {
  flex: 0 0 auto;
  width: 16.66667%; }

.col-3 {
  flex: 0 0 auto;
  width: 25%; }

.col-4 {
  flex: 0 0 auto;
  width: 33.33333%; }

.col-5 {
  flex: 0 0 auto;
  width: 41.66667%; }

.col-6 {
  flex: 0 0 auto;
  width: 50%; }

.col-7 {
  flex: 0 0 auto;
  width: 58.33333%; }

.col-8 {
  flex: 0 0 auto;
  width: 66.66667%; }

.col-9 {
  flex: 0 0 auto;
  width: 75%; }

.col-10 {
  flex: 0 0 auto;
  width: 83.33333%; }

.col-11 {
  flex: 0 0 auto;
  width: 91.66667%; }

.col-12 {
  flex: 0 0 auto;
  width: 100%; }

.offset-1 {
  margin-left: 8.33333%; }

.offset-2 {
  margin-left: 16.66667%; }

.offset-3 {
  margin-left: 25%; }

.offset-4 {
  margin-left: 33.33333%; }

.offset-5 {
  margin-left: 41.66667%; }

.offset-6 {
  margin-left: 50%; }

.offset-7 {
  margin-left: 58.33333%; }

.offset-8 {
  margin-left: 66.66667%; }

.offset-9 {
  margin-left: 75%; }

.offset-10 {
  margin-left: 83.33333%; }

.offset-11 {
  margin-left: 91.66667%; }

.g-0,
.gx-0 {
  --vz-gutter-x: 0; }

.g-0,
.gy-0 {
  --vz-gutter-y: 0; }

.g-1,
.gx-1 {
  --vz-gutter-x: 0.25rem; }

.g-1,
.gy-1 {
  --vz-gutter-y: 0.25rem; }

.g-2,
.gx-2 {
  --vz-gutter-x: 0.5rem; }

.g-2,
.gy-2 {
  --vz-gutter-y: 0.5rem; }

.g-3,
.gx-3 {
  --vz-gutter-x: 1rem; }

.g-3,
.gy-3 {
  --vz-gutter-y: 1rem; }

.g-4,
.gx-4 {
  --vz-gutter-x: 1.5rem; }

.g-4,
.gy-4 {
  --vz-gutter-y: 1.5rem; }

.g-5,
.gx-5 {
  --vz-gutter-x: 3rem; }

.g-5,
.gy-5 {
  --vz-gutter-y: 3rem; }

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0; }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-sm-0 {
    margin-left: 0; }
  .offset-sm-1 {
    margin-left: 8.33333%; }
  .offset-sm-2 {
    margin-left: 16.66667%; }
  .offset-sm-3 {
    margin-left: 25%; }
  .offset-sm-4 {
    margin-left: 33.33333%; }
  .offset-sm-5 {
    margin-left: 41.66667%; }
  .offset-sm-6 {
    margin-left: 50%; }
  .offset-sm-7 {
    margin-left: 58.33333%; }
  .offset-sm-8 {
    margin-left: 66.66667%; }
  .offset-sm-9 {
    margin-left: 75%; }
  .offset-sm-10 {
    margin-left: 83.33333%; }
  .offset-sm-11 {
    margin-left: 91.66667%; }
  .g-sm-0,
  .gx-sm-0 {
    --vz-gutter-x: 0; }
  .g-sm-0,
  .gy-sm-0 {
    --vz-gutter-y: 0; }
  .g-sm-1,
  .gx-sm-1 {
    --vz-gutter-x: 0.25rem; }
  .g-sm-1,
  .gy-sm-1 {
    --vz-gutter-y: 0.25rem; }
  .g-sm-2,
  .gx-sm-2 {
    --vz-gutter-x: 0.5rem; }
  .g-sm-2,
  .gy-sm-2 {
    --vz-gutter-y: 0.5rem; }
  .g-sm-3,
  .gx-sm-3 {
    --vz-gutter-x: 1rem; }
  .g-sm-3,
  .gy-sm-3 {
    --vz-gutter-y: 1rem; }
  .g-sm-4,
  .gx-sm-4 {
    --vz-gutter-x: 1.5rem; }
  .g-sm-4,
  .gy-sm-4 {
    --vz-gutter-y: 1.5rem; }
  .g-sm-5,
  .gx-sm-5 {
    --vz-gutter-x: 3rem; }
  .g-sm-5,
  .gy-sm-5 {
    --vz-gutter-y: 3rem; } }

@media (min-width: 768px) {
  .col-md {
    flex: 1 0; }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-md-0 {
    margin-left: 0; }
  .offset-md-1 {
    margin-left: 8.33333%; }
  .offset-md-2 {
    margin-left: 16.66667%; }
  .offset-md-3 {
    margin-left: 25%; }
  .offset-md-4 {
    margin-left: 33.33333%; }
  .offset-md-5 {
    margin-left: 41.66667%; }
  .offset-md-6 {
    margin-left: 50%; }
  .offset-md-7 {
    margin-left: 58.33333%; }
  .offset-md-8 {
    margin-left: 66.66667%; }
  .offset-md-9 {
    margin-left: 75%; }
  .offset-md-10 {
    margin-left: 83.33333%; }
  .offset-md-11 {
    margin-left: 91.66667%; }
  .g-md-0,
  .gx-md-0 {
    --vz-gutter-x: 0; }
  .g-md-0,
  .gy-md-0 {
    --vz-gutter-y: 0; }
  .g-md-1,
  .gx-md-1 {
    --vz-gutter-x: 0.25rem; }
  .g-md-1,
  .gy-md-1 {
    --vz-gutter-y: 0.25rem; }
  .g-md-2,
  .gx-md-2 {
    --vz-gutter-x: 0.5rem; }
  .g-md-2,
  .gy-md-2 {
    --vz-gutter-y: 0.5rem; }
  .g-md-3,
  .gx-md-3 {
    --vz-gutter-x: 1rem; }
  .g-md-3,
  .gy-md-3 {
    --vz-gutter-y: 1rem; }
  .g-md-4,
  .gx-md-4 {
    --vz-gutter-x: 1.5rem; }
  .g-md-4,
  .gy-md-4 {
    --vz-gutter-y: 1.5rem; }
  .g-md-5,
  .gx-md-5 {
    --vz-gutter-x: 3rem; }
  .g-md-5,
  .gy-md-5 {
    --vz-gutter-y: 3rem; } }

@media (min-width: 992px) {
  .col-lg {
    flex: 1 0; }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-lg-0 {
    margin-left: 0; }
  .offset-lg-1 {
    margin-left: 8.33333%; }
  .offset-lg-2 {
    margin-left: 16.66667%; }
  .offset-lg-3 {
    margin-left: 25%; }
  .offset-lg-4 {
    margin-left: 33.33333%; }
  .offset-lg-5 {
    margin-left: 41.66667%; }
  .offset-lg-6 {
    margin-left: 50%; }
  .offset-lg-7 {
    margin-left: 58.33333%; }
  .offset-lg-8 {
    margin-left: 66.66667%; }
  .offset-lg-9 {
    margin-left: 75%; }
  .offset-lg-10 {
    margin-left: 83.33333%; }
  .offset-lg-11 {
    margin-left: 91.66667%; }
  .g-lg-0,
  .gx-lg-0 {
    --vz-gutter-x: 0; }
  .g-lg-0,
  .gy-lg-0 {
    --vz-gutter-y: 0; }
  .g-lg-1,
  .gx-lg-1 {
    --vz-gutter-x: 0.25rem; }
  .g-lg-1,
  .gy-lg-1 {
    --vz-gutter-y: 0.25rem; }
  .g-lg-2,
  .gx-lg-2 {
    --vz-gutter-x: 0.5rem; }
  .g-lg-2,
  .gy-lg-2 {
    --vz-gutter-y: 0.5rem; }
  .g-lg-3,
  .gx-lg-3 {
    --vz-gutter-x: 1rem; }
  .g-lg-3,
  .gy-lg-3 {
    --vz-gutter-y: 1rem; }
  .g-lg-4,
  .gx-lg-4 {
    --vz-gutter-x: 1.5rem; }
  .g-lg-4,
  .gy-lg-4 {
    --vz-gutter-y: 1.5rem; }
  .g-lg-5,
  .gx-lg-5 {
    --vz-gutter-x: 3rem; }
  .g-lg-5,
  .gy-lg-5 {
    --vz-gutter-y: 3rem; } }

@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0; }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-xl-0 {
    margin-left: 0; }
  .offset-xl-1 {
    margin-left: 8.33333%; }
  .offset-xl-2 {
    margin-left: 16.66667%; }
  .offset-xl-3 {
    margin-left: 25%; }
  .offset-xl-4 {
    margin-left: 33.33333%; }
  .offset-xl-5 {
    margin-left: 41.66667%; }
  .offset-xl-6 {
    margin-left: 50%; }
  .offset-xl-7 {
    margin-left: 58.33333%; }
  .offset-xl-8 {
    margin-left: 66.66667%; }
  .offset-xl-9 {
    margin-left: 75%; }
  .offset-xl-10 {
    margin-left: 83.33333%; }
  .offset-xl-11 {
    margin-left: 91.66667%; }
  .g-xl-0,
  .gx-xl-0 {
    --vz-gutter-x: 0; }
  .g-xl-0,
  .gy-xl-0 {
    --vz-gutter-y: 0; }
  .g-xl-1,
  .gx-xl-1 {
    --vz-gutter-x: 0.25rem; }
  .g-xl-1,
  .gy-xl-1 {
    --vz-gutter-y: 0.25rem; }
  .g-xl-2,
  .gx-xl-2 {
    --vz-gutter-x: 0.5rem; }
  .g-xl-2,
  .gy-xl-2 {
    --vz-gutter-y: 0.5rem; }
  .g-xl-3,
  .gx-xl-3 {
    --vz-gutter-x: 1rem; }
  .g-xl-3,
  .gy-xl-3 {
    --vz-gutter-y: 1rem; }
  .g-xl-4,
  .gx-xl-4 {
    --vz-gutter-x: 1.5rem; }
  .g-xl-4,
  .gy-xl-4 {
    --vz-gutter-y: 1.5rem; }
  .g-xl-5,
  .gx-xl-5 {
    --vz-gutter-x: 3rem; }
  .g-xl-5,
  .gy-xl-5 {
    --vz-gutter-y: 3rem; } }

@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0; }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-xxl-0 {
    margin-left: 0; }
  .offset-xxl-1 {
    margin-left: 8.33333%; }
  .offset-xxl-2 {
    margin-left: 16.66667%; }
  .offset-xxl-3 {
    margin-left: 25%; }
  .offset-xxl-4 {
    margin-left: 33.33333%; }
  .offset-xxl-5 {
    margin-left: 41.66667%; }
  .offset-xxl-6 {
    margin-left: 50%; }
  .offset-xxl-7 {
    margin-left: 58.33333%; }
  .offset-xxl-8 {
    margin-left: 66.66667%; }
  .offset-xxl-9 {
    margin-left: 75%; }
  .offset-xxl-10 {
    margin-left: 83.33333%; }
  .offset-xxl-11 {
    margin-left: 91.66667%; }
  .g-xxl-0,
  .gx-xxl-0 {
    --vz-gutter-x: 0; }
  .g-xxl-0,
  .gy-xxl-0 {
    --vz-gutter-y: 0; }
  .g-xxl-1,
  .gx-xxl-1 {
    --vz-gutter-x: 0.25rem; }
  .g-xxl-1,
  .gy-xxl-1 {
    --vz-gutter-y: 0.25rem; }
  .g-xxl-2,
  .gx-xxl-2 {
    --vz-gutter-x: 0.5rem; }
  .g-xxl-2,
  .gy-xxl-2 {
    --vz-gutter-y: 0.5rem; }
  .g-xxl-3,
  .gx-xxl-3 {
    --vz-gutter-x: 1rem; }
  .g-xxl-3,
  .gy-xxl-3 {
    --vz-gutter-y: 1rem; }
  .g-xxl-4,
  .gx-xxl-4 {
    --vz-gutter-x: 1.5rem; }
  .g-xxl-4,
  .gy-xxl-4 {
    --vz-gutter-y: 1.5rem; }
  .g-xxl-5,
  .gx-xxl-5 {
    --vz-gutter-x: 3rem; }
  .g-xxl-5,
  .gy-xxl-5 {
    --vz-gutter-y: 3rem; } }

.table {
  --vz-table-color: var(--vz-body-color);
  --vz-table-bg: transparent;
  --vz-table-border-color: var(--vz-border-color);
  --vz-table-accent-bg: transparent;
  --vz-table-striped-color: var(--vz-body-color);
  --vz-table-striped-bg: rgba(var(--vz-dark-rgb), 0.02);
  --vz-table-active-color: var(--vz-body-color);
  --vz-table-active-bg: rgba(var(--vz-light-rgb), 1);
  --vz-table-hover-color: var(--vz-body-color);
  --vz-table-hover-bg: rgba(var(--vz-light-rgb), 1);
  width: 100%;
  margin-bottom: 1rem;
  color: var(--vz-table-color);
  vertical-align: top;
  border-color: var(--vz-table-border-color); }
  .table > :not(caption) > * > * {
    padding: 0.75rem 0.6rem;
    background-color: var(--vz-table-bg);
    border-bottom-width: 1px;
    box-shadow: inset 0 0 0 9999px var(--vz-table-accent-bg); }
  .table > tbody {
    vertical-align: inherit; }
  .table > thead {
    vertical-align: bottom; }

.table-group-divider {
  border-top: 2px solid var(--vz-border-color); }

.caption-top {
  caption-side: top; }

.table-sm > :not(caption) > * > * {
  padding: 0.3rem 0.25rem; }

.table-bordered > :not(caption) > * {
  border-width: 1px 0; }
  .table-bordered > :not(caption) > * > * {
    border-width: 0 1px; }

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0; }

.table-borderless > :not(:first-child) {
  border-top-width: 0; }

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --vz-table-accent-bg: var(--vz-table-striped-bg);
  color: var(--vz-table-striped-color); }

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --vz-table-accent-bg: var(--vz-table-striped-bg);
  color: var(--vz-table-striped-color); }

.table-active {
  --vz-table-accent-bg: var(--vz-table-active-bg);
  color: var(--vz-table-active-color); }

.table-hover > tbody > tr:hover > * {
  --vz-table-accent-bg: var(--vz-table-hover-bg);
  color: var(--vz-table-hover-color); }

.table-primary {
  --vz-table-color: #000;
  --vz-table-bg: #fce0d6;
  --vz-table-border-color: #e3cac1;
  --vz-table-striped-bg: #f7dcd2;
  --vz-table-striped-color: #000;
  --vz-table-active-bg: black;
  --vz-table-active-color: #fff;
  --vz-table-hover-bg: black;
  --vz-table-hover-color: #fff;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color); }

.table-secondary {
  --vz-table-color: #000;
  --vz-table-bg: #d2e8d8;
  --vz-table-border-color: #bdd1c2;
  --vz-table-striped-bg: #cee3d4;
  --vz-table-striped-color: #000;
  --vz-table-active-bg: black;
  --vz-table-active-color: #fff;
  --vz-table-hover-bg: black;
  --vz-table-hover-color: #fff;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color); }

.table-success {
  --vz-table-color: #000;
  --vz-table-bg: #cef0eb;
  --vz-table-border-color: #b9d8d4;
  --vz-table-striped-bg: #caebe6;
  --vz-table-striped-color: #000;
  --vz-table-active-bg: black;
  --vz-table-active-color: #fff;
  --vz-table-hover-bg: black;
  --vz-table-hover-color: #fff;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color); }

.table-info {
  --vz-table-color: #000;
  --vz-table-bg: #d4ebf8;
  --vz-table-border-color: #bfd4df;
  --vz-table-striped-bg: #d0e6f3;
  --vz-table-striped-color: #000;
  --vz-table-active-bg: black;
  --vz-table-active-color: #fff;
  --vz-table-hover-bg: black;
  --vz-table-hover-color: #fff;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color); }

.table-warning {
  --vz-table-color: #000;
  --vz-table-bg: #d9f2da;
  --vz-table-border-color: #c3dac4;
  --vz-table-striped-bg: #d5edd6;
  --vz-table-striped-color: #000;
  --vz-table-active-bg: black;
  --vz-table-active-color: #fff;
  --vz-table-hover-bg: black;
  --vz-table-hover-color: #fff;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color); }

.table-danger {
  --vz-table-color: #000;
  --vz-table-bg: #fce0da;
  --vz-table-border-color: #e3cac4;
  --vz-table-striped-bg: #f7dcd6;
  --vz-table-striped-color: #000;
  --vz-table-active-bg: black;
  --vz-table-active-color: #fff;
  --vz-table-hover-bg: black;
  --vz-table-hover-color: #fff;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color); }

.table-light {
  --vz-table-color: #000;
  --vz-table-bg: #f3f6f9;
  --vz-table-border-color: #dbdde0;
  --vz-table-striped-bg: #eef1f4;
  --vz-table-striped-color: #000;
  --vz-table-active-bg: black;
  --vz-table-active-color: #fff;
  --vz-table-hover-bg: black;
  --vz-table-hover-color: #fff;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color); }

.table-dark {
  --vz-table-color: #fff;
  --vz-table-bg: #212529;
  --vz-table-border-color: #373b3e;
  --vz-table-striped-bg: #25292d;
  --vz-table-striped-color: #fff;
  --vz-table-active-bg: white;
  --vz-table-active-color: #000;
  --vz-table-hover-bg: white;
  --vz-table-hover-color: #000;
  color: var(--vz-table-color);
  border-color: var(--vz-table-border-color); }

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; }

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

.form-label {
  margin-bottom: 0.5rem; }

.col-form-label {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.5; }

.col-form-label-lg {
  padding-top: calc(0.7rem + 1px);
  padding-bottom: calc(0.7rem + 1px);
  font-size: 1.01563rem; }
  @media (min-width: 1200px) {
    .col-form-label-lg {
      font-size: 1.01562rem; } }

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.71094rem; }

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #878a99; }

.form-control {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  background-color: var(--vz-input-bg);
  background-clip: padding-box;
  border: 1px solid var(--vz-input-border);
  appearance: none;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .form-control {
      transition: none; } }
  .form-control[type="file"] {
    overflow: hidden; }
    .form-control[type="file"]:not(:disabled):not([readonly]) {
      cursor: pointer; }
  .form-control:focus {
    color: var(--vz-body-color);
    background-color: var(--vz-input-bg);
    border-color: var(--vz-input-focus-border);
    outline: 0;
    box-shadow: 0 0 0 0 rgba(242, 100, 48, 0.25); }
  .form-control::-webkit-date-and-time-value {
    height: 1.5em; }
  .form-control::placeholder {
    color: #878a99;
    opacity: 1; }
  .form-control:disabled {
    background-color: var(--vz-input-disabled-bg);
    opacity: 1; }
  .form-control::file-selector-button {
    padding: 0.5rem 0.9rem;
    margin: -0.5rem -0.9rem;
    margin-inline-end: 0.9rem;
    color: var(--vz-body-color);
    background-color: var(--vz-input-group-addon-bg);
    pointer-events: none;
    border-color: inherit;
    border-style: solid;
    border-width: 0;
    border-inline-end-width: 1px;
    border-radius: 0;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-control::file-selector-button {
        transition: none; } }
  .form-control:hover:not(:disabled):not([readonly])::file-selector-button {
    background-color: var(--vz-input-group-addon-bg); }

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.5rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--vz-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0; }
  .form-control-plaintext:focus {
    outline: 0; }
  .form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
    padding-right: 0;
    padding-left: 0; }

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.71094rem;
  border-radius: 0.2rem; }
  .form-control-sm::file-selector-button {
    padding: 0.25rem 0.5rem;
    margin: -0.25rem -0.5rem;
    margin-inline-end: 0.5rem; }

.form-control-lg {
  min-height: calc(1.5em + 1.4rem + 2px);
  padding: 0.7rem 1.2rem;
  font-size: 1.01563rem;
  border-radius: 0.3rem; }
  @media (min-width: 1200px) {
    .form-control-lg {
      font-size: 1.01562rem; } }
  .form-control-lg::file-selector-button {
    padding: 0.7rem 1.2rem;
    margin: -0.7rem -1.2rem;
    margin-inline-end: 1.2rem; }

textarea.form-control {
  min-height: calc(1.5em + 1rem + 2px); }

textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px); }

textarea.form-control-lg {
  min-height: calc(1.5em + 1.4rem + 2px); }

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem; }
  .form-control-color:not(:disabled):not([readonly]) {
    cursor: pointer; }
  .form-control-color::-moz-color-swatch {
    border: 0 !important;
    border-radius: 0.25rem; }
  .form-control-color::-webkit-color-swatch {
    border-radius: 0.25rem; }
  .form-control-color.form-control-sm {
    height: calc(1.5em + 0.5rem + 2px); }
  .form-control-color.form-control-lg {
    height: calc(1.5em + 1.4rem + 2px); }

.form-select {
  display: block;
  width: 100%;
  padding: 0.5rem 2.7rem 0.5rem 0.9rem;
  -moz-padding-start: calc(0.9rem - 3px);
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  background-color: var(--vz-input-bg);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  background-repeat: no-repeat;
  background-position: right 0.9rem center;
  background-size: 16px 12px;
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none; }
  @media (prefers-reduced-motion: reduce) {
    .form-select {
      transition: none; } }
  .form-select:focus {
    border-color: var(--vz-input-focus-border);
    outline: 0;
    box-shadow: 0 0 0 0 rgba(242, 100, 48, 0.25); }
  .form-select[multiple], .form-select[size]:not([size="1"]) {
    padding-right: 0.9rem;
    background-image: none; }
  .form-select:disabled {
    background-color: var(--vz-input-disabled-bg); }
  .form-select:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 var(--vz-body-color); }

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.71094rem;
  border-radius: 0.2rem; }

.form-select-lg {
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
  padding-left: 1.2rem;
  font-size: 1.01563rem;
  border-radius: 0.3rem; }
  @media (min-width: 1200px) {
    .form-select-lg {
      font-size: 1.01562rem; } }

.form-check {
  display: block;
  min-height: 1.21875rem;
  padding-left: 1.6em;
  margin-bottom: 0.125rem; }
  .form-check .form-check-input {
    float: left;
    margin-left: -1.6em; }

.form-check-reverse {
  padding-right: 1.6em;
  padding-left: 0;
  text-align: right; }
  .form-check-reverse .form-check-input {
    float: right;
    margin-right: -1.6em;
    margin-left: 0; }

.form-check-input {
  width: 1.1em;
  height: 1.1em;
  margin-top: 0.2em;
  vertical-align: top;
  background-color: var(--vz-input-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid var(--vz-input-check-border);
  appearance: none;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact; }
  .form-check-input[type="checkbox"] {
    border-radius: 0.25em; }
  .form-check-input[type="radio"] {
    border-radius: 50%; }
  .form-check-input:active {
    filter: brightness(90%); }
  .form-check-input:focus {
    border-color: var(--vz-input-focus-border);
    outline: 0;
    box-shadow: 0 0 0 0 rgba(242, 100, 48, 0.25); }
  .form-check-input:checked {
    background-color: #F26430;
    border-color: #F26430; }
    .form-check-input:checked[type="checkbox"] {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___}); }
    .form-check-input:checked[type="radio"] {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___}); }
  .form-check-input[type="checkbox"]:indeterminate {
    background-color: #F26430;
    border-color: #F26430;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___}); }
  .form-check-input:disabled {
    pointer-events: none;
    filter: none;
    opacity: 0.5; }
  .form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
    cursor: default;
    opacity: 0.5; }

.form-switch {
  padding-left: 2.5em; }
  .form-switch .form-check-input {
    width: 2em;
    margin-left: -2.5em;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
    background-position: left center;
    border-radius: 2em;
    transition: background-position 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-switch .form-check-input {
        transition: none; } }
    .form-switch .form-check-input:focus {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___}); }
    .form-switch .form-check-input:checked {
      background-position: right center;
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___}); }
  .form-switch.form-check-reverse {
    padding-right: 2.5em;
    padding-left: 0; }
    .form-switch.form-check-reverse .form-check-input {
      margin-right: -2.5em;
      margin-left: 0; }

.form-check-inline {
  display: inline-block;
  margin-right: 1rem; }

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none; }
  .btn-check[disabled] + .btn, .btn-check:disabled + .btn {
    pointer-events: none;
    filter: none;
    opacity: 0.65; }

.form-range {
  width: 100%;
  height: 1rem;
  padding: 0;
  background-color: transparent;
  appearance: none; }
  .form-range:focus {
    outline: 0; }
    .form-range:focus::-webkit-slider-thumb {
      box-shadow: 0 0 0 1px #f3f3f9, 0 0 0 0 rgba(242, 100, 48, 0.25); }
    .form-range:focus::-moz-range-thumb {
      box-shadow: 0 0 0 1px #f3f3f9, 0 0 0 0 rgba(242, 100, 48, 0.25); }
  .form-range::-moz-focus-outer {
    border: 0; }
  .form-range::-webkit-slider-thumb {
    width: 1rem;
    height: 1rem;
    margin-top: -0.25rem;
    background-color: #F26430;
    border: 0;
    border-radius: 1rem;
    -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    appearance: none; }
    @media (prefers-reduced-motion: reduce) {
      .form-range::-webkit-slider-thumb {
        -webkit-transition: none;
        transition: none; } }
    .form-range::-webkit-slider-thumb:active {
      background-color: #fbd1c1; }
  .form-range::-webkit-slider-runnable-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: var(--vz-gray-300);
    border-color: transparent;
    border-radius: 1rem; }
  .form-range::-moz-range-thumb {
    width: 1rem;
    height: 1rem;
    background-color: #F26430;
    border: 0;
    border-radius: 1rem;
    -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    appearance: none; }
    @media (prefers-reduced-motion: reduce) {
      .form-range::-moz-range-thumb {
        -moz-transition: none;
        transition: none; } }
    .form-range::-moz-range-thumb:active {
      background-color: #fbd1c1; }
  .form-range::-moz-range-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: var(--vz-gray-300);
    border-color: transparent;
    border-radius: 1rem; }
  .form-range:disabled {
    pointer-events: none; }
    .form-range:disabled::-webkit-slider-thumb {
      background-color: #adb5bd; }
    .form-range:disabled::-moz-range-thumb {
      background-color: #adb5bd; }

.form-floating {
  position: relative; }
  .form-floating > .form-control,
  .form-floating > .form-control-plaintext,
  .form-floating > .form-select {
    height: calc(3.5rem + 2px);
    line-height: 1.25; }
  .form-floating > label {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 1rem 0.9rem;
    overflow: hidden;
    text-align: start;
    text-overflow: ellipsis;
    white-space: nowrap;
    pointer-events: none;
    border: 1px solid transparent;
    transform-origin: 0 0;
    transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-floating > label {
        transition: none; } }
  .form-floating > .form-control,
  .form-floating > .form-control-plaintext {
    padding: 1rem 0.9rem; }
    .form-floating > .form-control::placeholder,
    .form-floating > .form-control-plaintext::placeholder {
      color: transparent; }
    .form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
    .form-floating > .form-control-plaintext:focus,
    .form-floating > .form-control-plaintext:not(:placeholder-shown) {
      padding-top: 1.625rem;
      padding-bottom: 0.625rem; }
    .form-floating > .form-control:-webkit-autofill,
    .form-floating > .form-control-plaintext:-webkit-autofill {
      padding-top: 1.625rem;
      padding-bottom: 0.625rem; }
  .form-floating > .form-select {
    padding-top: 1.625rem;
    padding-bottom: 0.625rem; }
  .form-floating > .form-control:focus ~ label,
  .form-floating > .form-control:not(:placeholder-shown) ~ label,
  .form-floating > .form-control-plaintext ~ label,
  .form-floating > .form-select ~ label {
    opacity: 0.65;
    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem); }
  .form-floating > .form-control:-webkit-autofill ~ label {
    opacity: 0.65;
    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem); }
  .form-floating > .form-control-plaintext ~ label {
    border-width: 1px 0; }

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%; }
  .input-group > .form-control,
  .input-group > .form-select,
  .input-group > .form-floating {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0; }
  .input-group > .form-control:focus,
  .input-group > .form-select:focus,
  .input-group > .form-floating:focus-within {
    z-index: 5; }
  .input-group .btn {
    position: relative;
    z-index: 2; }
    .input-group .btn:focus {
      z-index: 5; }

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.9rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--vz-input-group-addon-bg);
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem; }

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.7rem 1.2rem;
  font-size: 1.01563rem;
  border-radius: 0.3rem; }
  @media (min-width: 1200px) {
    .input-group-lg > .form-control,
    .input-group-lg > .form-select,
    .input-group-lg > .input-group-text,
    .input-group-lg > .btn {
      font-size: 1.01562rem; } }

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.71094rem;
  border-radius: 0.2rem; }

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3.6rem; }

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n + 3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.input-group.has-validation > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n + 4),
.input-group.has-validation > .form-floating:nth-last-child(n + 3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n + 3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #0ab39c; }

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.7rem;
  margin-top: .1rem;
  font-size: 0.71094rem;
  color: #fff;
  background-color: rgba(10, 179, 156, 0.9);
  border-radius: 0.2rem; }

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block; }

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #0ab39c;
  padding-right: calc(1.5em + 1rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.25rem) center;
  background-size: calc(0.75em + 0.5rem) calc(0.75em + 0.5rem); }
  .was-validated .form-control:valid:focus, .form-control.is-valid:focus {
    border-color: #0ab39c;
    box-shadow: 0 0 0 0 rgba(10, 179, 156, 0.25); }

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 1rem);
  background-position: top calc(0.375em + 0.25rem) right calc(0.375em + 0.25rem); }

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: #0ab39c; }
  .was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
    padding-right: 4.95rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___}), url(${___CSS_LOADER_URL_REPLACEMENT_41___});
    background-position: right 0.9rem center, center right 2.7rem;
    background-size: 16px 12px, calc(0.75em + 0.5rem) calc(0.75em + 0.5rem); }
  .was-validated .form-select:valid:focus, .form-select.is-valid:focus {
    border-color: #0ab39c;
    box-shadow: 0 0 0 0 rgba(10, 179, 156, 0.25); }

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 1rem)); }

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: #0ab39c; }
  .was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
    background-color: #0ab39c; }
  .was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
    box-shadow: 0 0 0 0 rgba(10, 179, 156, 0.25); }
  .was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
    color: #0ab39c; }

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: .5em; }

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid, .was-validated
.input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid, .was-validated
.input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3; }

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #f06548; }

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.7rem;
  margin-top: .1rem;
  font-size: 0.71094rem;
  color: #fff;
  background-color: rgba(240, 101, 72, 0.9);
  border-radius: 0.2rem; }

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block; }

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #f06548;
  padding-right: calc(1.5em + 1rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.25rem) center;
  background-size: calc(0.75em + 0.5rem) calc(0.75em + 0.5rem); }
  .was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
    border-color: #f06548;
    box-shadow: 0 0 0 0 rgba(240, 101, 72, 0.25); }

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 1rem);
  background-position: top calc(0.375em + 0.25rem) right calc(0.375em + 0.25rem); }

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: #f06548; }
  .was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
    padding-right: 4.95rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___}), url(${___CSS_LOADER_URL_REPLACEMENT_42___});
    background-position: right 0.9rem center, center right 2.7rem;
    background-size: 16px 12px, calc(0.75em + 0.5rem) calc(0.75em + 0.5rem); }
  .was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
    border-color: #f06548;
    box-shadow: 0 0 0 0 rgba(240, 101, 72, 0.25); }

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 1rem)); }

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: #f06548; }
  .was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
    background-color: #f06548; }
  .was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
    box-shadow: 0 0 0 0 rgba(240, 101, 72, 0.25); }
  .was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
    color: #f06548; }

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: .5em; }

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid, .was-validated
.input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid, .was-validated
.input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4; }

.btn {
  --vz-btn-padding-x: 0.9rem;
  --vz-btn-padding-y: 0.5rem;
  --vz-btn-font-family: ;
  --vz-btn-font-size: 0.8125rem;
  --vz-btn-font-weight: 400;
  --vz-btn-line-height: 1.5;
  --vz-btn-color: #212529;
  --vz-btn-bg: transparent;
  --vz-btn-border-width: 1px;
  --vz-btn-border-color: transparent;
  --vz-btn-border-radius: 0.25rem;
  --vz-btn-hover-border-color: transparent;
  --vz-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --vz-btn-disabled-opacity: 0.65;
  --vz-btn-focus-box-shadow: 0 0 0 0 rgba(var(--vz-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--vz-btn-padding-y) var(--vz-btn-padding-x);
  font-family: var(--vz-btn-font-family);
  font-size: var(--vz-btn-font-size);
  font-weight: var(--vz-btn-font-weight);
  line-height: var(--vz-btn-line-height);
  color: var(--vz-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--vz-btn-border-width) solid var(--vz-btn-border-color);
  border-radius: var(--vz-btn-border-radius);
  background-color: var(--vz-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .btn {
      transition: none; } }
  .btn:hover {
    color: var(--vz-btn-hover-color);
    background-color: var(--vz-btn-hover-bg);
    border-color: var(--vz-btn-hover-border-color); }
  .btn-check + .btn:hover {
    color: var(--vz-btn-color);
    background-color: var(--vz-btn-bg);
    border-color: var(--vz-btn-border-color); }
  .btn:focus-visible {
    color: var(--vz-btn-hover-color);
    background-color: var(--vz-btn-hover-bg);
    border-color: var(--vz-btn-hover-border-color);
    outline: 0;
    box-shadow: var(--vz-btn-focus-box-shadow); }
  .btn-check:focus-visible + .btn {
    border-color: var(--vz-btn-hover-border-color);
    outline: 0;
    box-shadow: var(--vz-btn-focus-box-shadow); }
  .btn-check:checked + .btn,
  :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
    color: var(--vz-btn-active-color);
    background-color: var(--vz-btn-active-bg);
    border-color: var(--vz-btn-active-border-color); }
    .btn-check:checked + .btn:focus-visible,
    :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
      box-shadow: var(--vz-btn-focus-box-shadow); }
  .btn:disabled, .btn.disabled,
  fieldset:disabled .btn {
    color: var(--vz-btn-disabled-color);
    pointer-events: none;
    background-color: var(--vz-btn-disabled-bg);
    border-color: var(--vz-btn-disabled-border-color);
    opacity: var(--vz-btn-disabled-opacity); }

.btn-primary {
  --vz-btn-color: #fff;
  --vz-btn-bg: #F26430;
  --vz-btn-border-color: #F26430;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #ce5529;
  --vz-btn-hover-border-color: #c25026;
  --vz-btn-focus-shadow-rgb: 244, 123, 79;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #c25026;
  --vz-btn-active-border-color: #b64b24;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #F26430;
  --vz-btn-disabled-border-color: #F26430; }

.btn-secondary {
  --vz-btn-color: #fff;
  --vz-btn-bg: #208C3B;
  --vz-btn-border-color: #208C3B;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #1b7732;
  --vz-btn-hover-border-color: #1a702f;
  --vz-btn-focus-shadow-rgb: 65, 157, 88;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #1a702f;
  --vz-btn-active-border-color: #18692c;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #208C3B;
  --vz-btn-disabled-border-color: #208C3B; }

.btn-success {
  --vz-btn-color: #fff;
  --vz-btn-bg: #0ab39c;
  --vz-btn-border-color: #0ab39c;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #099885;
  --vz-btn-hover-border-color: #088f7d;
  --vz-btn-focus-shadow-rgb: 47, 190, 171;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #088f7d;
  --vz-btn-active-border-color: #088675;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #0ab39c;
  --vz-btn-disabled-border-color: #0ab39c; }

.btn-info {
  --vz-btn-color: #fff;
  --vz-btn-bg: #299cdb;
  --vz-btn-border-color: #299cdb;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #2385ba;
  --vz-btn-hover-border-color: #217daf;
  --vz-btn-focus-shadow-rgb: 73, 171, 224;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #217daf;
  --vz-btn-active-border-color: #1f75a4;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #299cdb;
  --vz-btn-disabled-border-color: #299cdb; }

.btn-warning {
  --vz-btn-color: #fff;
  --vz-btn-bg: #3FBF48;
  --vz-btn-border-color: #3FBF48;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #36a23d;
  --vz-btn-hover-border-color: #32993a;
  --vz-btn-focus-shadow-rgb: 92, 201, 99;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #32993a;
  --vz-btn-active-border-color: #2f8f36;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #3FBF48;
  --vz-btn-disabled-border-color: #3FBF48; }

.btn-danger {
  --vz-btn-color: #fff;
  --vz-btn-bg: #f06548;
  --vz-btn-border-color: #f06548;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #cc563d;
  --vz-btn-hover-border-color: #c0513a;
  --vz-btn-focus-shadow-rgb: 242, 124, 99;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #c0513a;
  --vz-btn-active-border-color: #b44c36;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #f06548;
  --vz-btn-disabled-border-color: #f06548; }

.btn-light {
  --vz-btn-color: #000;
  --vz-btn-bg: #f3f6f9;
  --vz-btn-border-color: #f3f6f9;
  --vz-btn-hover-color: #000;
  --vz-btn-hover-bg: #cfd1d4;
  --vz-btn-hover-border-color: #c2c5c7;
  --vz-btn-focus-shadow-rgb: 207, 209, 212;
  --vz-btn-active-color: #000;
  --vz-btn-active-bg: #c2c5c7;
  --vz-btn-active-border-color: #b6b9bb;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #000;
  --vz-btn-disabled-bg: #f3f6f9;
  --vz-btn-disabled-border-color: #f3f6f9; }

.btn-dark {
  --vz-btn-color: #fff;
  --vz-btn-bg: #212529;
  --vz-btn-border-color: #212529;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #424649;
  --vz-btn-hover-border-color: #373b3e;
  --vz-btn-focus-shadow-rgb: 66, 70, 73;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #4d5154;
  --vz-btn-active-border-color: #373b3e;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #fff;
  --vz-btn-disabled-bg: #212529;
  --vz-btn-disabled-border-color: #212529; }

.btn-outline-primary {
  --vz-btn-color: #F26430;
  --vz-btn-border-color: #F26430;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #F26430;
  --vz-btn-hover-border-color: #F26430;
  --vz-btn-focus-shadow-rgb: 242, 100, 48;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #F26430;
  --vz-btn-active-border-color: #F26430;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #F26430;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #F26430;
  --vz-gradient: none; }

.btn-outline-secondary {
  --vz-btn-color: #208C3B;
  --vz-btn-border-color: #208C3B;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #208C3B;
  --vz-btn-hover-border-color: #208C3B;
  --vz-btn-focus-shadow-rgb: 32, 140, 59;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #208C3B;
  --vz-btn-active-border-color: #208C3B;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #208C3B;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #208C3B;
  --vz-gradient: none; }

.btn-outline-success {
  --vz-btn-color: #0ab39c;
  --vz-btn-border-color: #0ab39c;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #0ab39c;
  --vz-btn-hover-border-color: #0ab39c;
  --vz-btn-focus-shadow-rgb: 10, 179, 156;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #0ab39c;
  --vz-btn-active-border-color: #0ab39c;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #0ab39c;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #0ab39c;
  --vz-gradient: none; }

.btn-outline-info {
  --vz-btn-color: #299cdb;
  --vz-btn-border-color: #299cdb;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #299cdb;
  --vz-btn-hover-border-color: #299cdb;
  --vz-btn-focus-shadow-rgb: 41, 156, 219;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #299cdb;
  --vz-btn-active-border-color: #299cdb;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #299cdb;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #299cdb;
  --vz-gradient: none; }

.btn-outline-warning {
  --vz-btn-color: #3FBF48;
  --vz-btn-border-color: #3FBF48;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #3FBF48;
  --vz-btn-hover-border-color: #3FBF48;
  --vz-btn-focus-shadow-rgb: 63, 191, 72;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #3FBF48;
  --vz-btn-active-border-color: #3FBF48;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #3FBF48;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #3FBF48;
  --vz-gradient: none; }

.btn-outline-danger {
  --vz-btn-color: #f06548;
  --vz-btn-border-color: #f06548;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #f06548;
  --vz-btn-hover-border-color: #f06548;
  --vz-btn-focus-shadow-rgb: 240, 101, 72;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #f06548;
  --vz-btn-active-border-color: #f06548;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #f06548;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #f06548;
  --vz-gradient: none; }

.btn-outline-light {
  --vz-btn-color: #f3f6f9;
  --vz-btn-border-color: #f3f6f9;
  --vz-btn-hover-color: #000;
  --vz-btn-hover-bg: #f3f6f9;
  --vz-btn-hover-border-color: #f3f6f9;
  --vz-btn-focus-shadow-rgb: 243, 246, 249;
  --vz-btn-active-color: #000;
  --vz-btn-active-bg: #f3f6f9;
  --vz-btn-active-border-color: #f3f6f9;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #f3f6f9;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #f3f6f9;
  --vz-gradient: none; }

.btn-outline-dark {
  --vz-btn-color: #212529;
  --vz-btn-border-color: #212529;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #212529;
  --vz-btn-hover-border-color: #212529;
  --vz-btn-focus-shadow-rgb: 33, 37, 41;
  --vz-btn-active-color: #fff;
  --vz-btn-active-bg: #212529;
  --vz-btn-active-border-color: #212529;
  --vz-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --vz-btn-disabled-color: #212529;
  --vz-btn-disabled-bg: transparent;
  --vz-btn-disabled-border-color: #212529;
  --vz-gradient: none; }

.btn-link {
  --vz-btn-font-weight: 400;
  --vz-btn-color: var(--vz-link-color);
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: var(--vz-link-hover-color);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-active-color: var(--vz-link-hover-color);
  --vz-btn-active-border-color: transparent;
  --vz-btn-disabled-color: #878a99;
  --vz-btn-disabled-border-color: transparent;
  --vz-btn-box-shadow: none;
  --vz-btn-focus-shadow-rgb: 244, 123, 79;
  text-decoration: underline; }
  .btn-link:focus-visible {
    color: var(--vz-btn-color); }
  .btn-link:hover {
    color: var(--vz-btn-hover-color); }

.btn-lg, .btn-group-lg > .btn {
  --vz-btn-padding-y: 0.7rem;
  --vz-btn-padding-x: 1.2rem;
  --vz-btn-font-size: 1.01563rem;
  --vz-btn-border-radius: 0.3rem; }
  @media (min-width: 1200px) {
    .btn-lg, .btn-group-lg > .btn {
      --vz-btn-font-size: 1.01562rem; } }

.btn-sm, .btn-group-sm > .btn {
  --vz-btn-padding-y: 0.25rem;
  --vz-btn-padding-x: 0.5rem;
  --vz-btn-font-size: 0.71094rem;
  --vz-btn-border-radius: 0.2rem; }

.fade {
  transition: opacity 0.15s linear; }
  @media (prefers-reduced-motion: reduce) {
    .fade {
      transition: none; } }
  .fade:not(.show) {
    opacity: 0; }

.collapse:not(.show) {
  display: none; }

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease; }
  @media (prefers-reduced-motion: reduce) {
    .collapsing {
      transition: none; } }
  .collapsing.collapse-horizontal {
    width: 0;
    height: auto;
    transition: width 0.35s ease; }
    @media (prefers-reduced-motion: reduce) {
      .collapsing.collapse-horizontal {
        transition: none; } }

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative; }

.dropdown-toggle {
  white-space: nowrap; }

.dropdown-menu {
  --vz-dropdown-zindex: 1000;
  --vz-dropdown-min-width: 10rem;
  --vz-dropdown-padding-x: 0;
  --vz-dropdown-padding-y: 0.5rem;
  --vz-dropdown-spacer: 0.125rem;
  --vz-dropdown-font-size: 0.8125rem;
  --vz-dropdown-color: var(--vz-body-color);
  --vz-dropdown-bg: #fff;
  --vz-dropdown-border-color: var(--vz-border-color);
  --vz-dropdown-border-radius: 0.3rem;
  --vz-dropdown-border-width: 0;
  --vz-dropdown-inner-border-radius: 0.3rem;
  --vz-dropdown-divider-bg: var(--vz-border-color);
  --vz-dropdown-divider-margin-y: 0.5rem;
  --vz-dropdown-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  --vz-dropdown-link-color: #212529;
  --vz-dropdown-link-hover-color: #1e2125;
  --vz-dropdown-link-hover-bg: #f3f6f9;
  --vz-dropdown-link-active-color: #1e2125;
  --vz-dropdown-link-active-bg: #f3f6f9;
  --vz-dropdown-link-disabled-color: #adb5bd;
  --vz-dropdown-item-padding-x: 1.2rem;
  --vz-dropdown-item-padding-y: 0.35rem;
  --vz-dropdown-header-color: #878a99;
  --vz-dropdown-header-padding-x: 1.2rem;
  --vz-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--vz-dropdown-zindex);
  display: none;
  min-width: var(--vz-dropdown-min-width);
  padding: var(--vz-dropdown-padding-y) var(--vz-dropdown-padding-x);
  margin: 0;
  font-size: var(--vz-dropdown-font-size);
  color: var(--vz-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--vz-dropdown-bg);
  background-clip: padding-box;
  border: var(--vz-dropdown-border-width) solid var(--vz-dropdown-border-color);
  border-radius: var(--vz-dropdown-border-radius); }
  .dropdown-menu[data-bs-popper] {
    top: 100%;
    left: 0;
    margin-top: var(--vz-dropdown-spacer); }

.dropdown-menu-start {
  --bs-position: start; }
  .dropdown-menu-start[data-bs-popper] {
    right: auto;
    left: 0; }

.dropdown-menu-end {
  --bs-position: end; }
  .dropdown-menu-end[data-bs-popper] {
    right: 0;
    left: auto; }

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start; }
    .dropdown-menu-sm-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-sm-end {
    --bs-position: end; }
    .dropdown-menu-sm-end[data-bs-popper] {
      right: 0;
      left: auto; } }

@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start; }
    .dropdown-menu-md-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-md-end {
    --bs-position: end; }
    .dropdown-menu-md-end[data-bs-popper] {
      right: 0;
      left: auto; } }

@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start; }
    .dropdown-menu-lg-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-lg-end {
    --bs-position: end; }
    .dropdown-menu-lg-end[data-bs-popper] {
      right: 0;
      left: auto; } }

@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start; }
    .dropdown-menu-xl-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-xl-end {
    --bs-position: end; }
    .dropdown-menu-xl-end[data-bs-popper] {
      right: 0;
      left: auto; } }

@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start; }
    .dropdown-menu-xxl-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-xxl-end {
    --bs-position: end; }
    .dropdown-menu-xxl-end[data-bs-popper] {
      right: 0;
      left: auto; } }

.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--vz-dropdown-spacer); }

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--vz-dropdown-spacer); }

.dropend .dropdown-toggle::after {
  vertical-align: 0; }

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--vz-dropdown-spacer); }

.dropstart .dropdown-toggle::before {
  vertical-align: 0; }

.dropdown-divider {
  height: 0;
  margin: var(--vz-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--vz-dropdown-divider-bg);
  opacity: 1; }

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--vz-dropdown-item-padding-y) var(--vz-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--vz-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0; }
  .dropdown-item:hover, .dropdown-item:focus {
    color: var(--vz-dropdown-link-hover-color);
    background-color: var(--vz-dropdown-link-hover-bg); }
  .dropdown-item.active, .dropdown-item:active {
    color: var(--vz-dropdown-link-active-color);
    text-decoration: none;
    background-color: var(--vz-dropdown-link-active-bg); }
  .dropdown-item.disabled, .dropdown-item:disabled {
    color: var(--vz-dropdown-link-disabled-color);
    pointer-events: none;
    background-color: transparent; }

.dropdown-menu.show {
  display: block; }

.dropdown-header {
  display: block;
  padding: var(--vz-dropdown-header-padding-y) var(--vz-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.71094rem;
  color: var(--vz-dropdown-header-color);
  white-space: nowrap; }

.dropdown-item-text {
  display: block;
  padding: var(--vz-dropdown-item-padding-y) var(--vz-dropdown-item-padding-x);
  color: var(--vz-dropdown-link-color); }

.dropdown-menu-dark {
  --vz-dropdown-color: #e9ebec;
  --vz-dropdown-bg: #343a40;
  --vz-dropdown-border-color: var(--vz-border-color);
  --vz-dropdown-box-shadow: ;
  --vz-dropdown-link-color: #e9ebec;
  --vz-dropdown-link-hover-color: #fff;
  --vz-dropdown-divider-bg: var(--vz-border-color);
  --vz-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --vz-dropdown-link-active-color: #fff;
  --vz-dropdown-link-active-bg: #3f474e;
  --vz-dropdown-link-disabled-color: #adb5bd;
  --vz-dropdown-header-color: #adb5bd; }

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle; }
  .btn-group > .btn,
  .btn-group-vertical > .btn {
    position: relative;
    flex: 1 1 auto; }
  .btn-group > .btn-check:checked + .btn,
  .btn-group > .btn-check:focus + .btn,
  .btn-group > .btn:hover,
  .btn-group > .btn:focus,
  .btn-group > .btn:active,
  .btn-group > .btn.active,
  .btn-group-vertical > .btn-check:checked + .btn,
  .btn-group-vertical > .btn-check:focus + .btn,
  .btn-group-vertical > .btn:hover,
  .btn-group-vertical > .btn:focus,
  .btn-group-vertical > .btn:active,
  .btn-group-vertical > .btn.active {
    z-index: 1; }

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; }
  .btn-toolbar .input-group {
    width: auto; }

.btn-group {
  border-radius: 0.25rem; }
  .btn-group > :not(.btn-check:first-child) + .btn,
  .btn-group > .btn-group:not(:first-child) {
    margin-left: -1px; }
  .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
  .btn-group > .btn.dropdown-toggle-split:first-child,
  .btn-group > .btn-group:not(:last-child) > .btn {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0; }
  .btn-group > .btn:nth-child(n + 3),
  .btn-group > :not(.btn-check) + .btn,
  .btn-group > .btn-group:not(:first-child) > .btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0; }

.dropdown-toggle-split {
  padding-right: 0.675rem;
  padding-left: 0.675rem; }
  .dropdown-toggle-split::after,
  .dropup .dropdown-toggle-split::after,
  .dropend .dropdown-toggle-split::after {
    margin-left: 0; }
  .dropstart .dropdown-toggle-split::before {
    margin-right: 0; }

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem; }

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.9rem;
  padding-left: 0.9rem; }

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center; }
  .btn-group-vertical > .btn,
  .btn-group-vertical > .btn-group {
    width: 100%; }
  .btn-group-vertical > .btn:not(:first-child),
  .btn-group-vertical > .btn-group:not(:first-child) {
    margin-top: -1px; }
  .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
  .btn-group-vertical > .btn-group:not(:last-child) > .btn {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0; }
  .btn-group-vertical > .btn ~ .btn,
  .btn-group-vertical > .btn-group:not(:first-child) > .btn {
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

.nav {
  --vz-nav-link-padding-x: 1rem;
  --vz-nav-link-padding-y: 0.5rem;
  --vz-nav-link-font-weight: ;
  --vz-nav-link-color: var(--vz-link-color);
  --vz-nav-link-hover-color: var(--vz-link-hover-color);
  --vz-nav-link-disabled-color: #878a99;
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none; }

.nav-link {
  display: block;
  padding: var(--vz-nav-link-padding-y) var(--vz-nav-link-padding-x);
  font-size: var(--vz-nav-link-font-size);
  font-weight: var(--vz-nav-link-font-weight);
  color: var(--vz-nav-link-color);
  text-decoration: none;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .nav-link {
      transition: none; } }
  .nav-link:hover, .nav-link:focus {
    color: var(--vz-nav-link-hover-color); }
  .nav-link.disabled {
    color: var(--vz-nav-link-disabled-color);
    pointer-events: none;
    cursor: default; }

.nav-tabs {
  --vz-nav-tabs-border-width: 1px;
  --vz-nav-tabs-border-color: var(--vz-gray-300);
  --vz-nav-tabs-border-radius: 0.25rem;
  --vz-nav-tabs-link-hover-border-color: var(--vz-gray-300) var(--vz-gray-300) var(--vz-gray-300);
  --vz-nav-tabs-link-active-color: #495057;
  --vz-nav-tabs-link-active-bg: var(--vz-nav-tabs-link-active-bg);
  --vz-nav-tabs-link-active-border-color: var(--vz-gray-300) var(--vz-gray-300) var(--vz-nav-tabs-link-active-bg);
  border-bottom: var(--vz-nav-tabs-border-width) solid var(--vz-nav-tabs-border-color); }
  .nav-tabs .nav-link {
    margin-bottom: calc(-1 * var(--vz-nav-tabs-border-width));
    background: none;
    border: var(--vz-nav-tabs-border-width) solid transparent;
    border-top-left-radius: var(--vz-nav-tabs-border-radius);
    border-top-right-radius: var(--vz-nav-tabs-border-radius); }
    .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
      isolation: isolate;
      border-color: var(--vz-nav-tabs-link-hover-border-color); }
    .nav-tabs .nav-link.disabled, .nav-tabs .nav-link:disabled {
      color: var(--vz-nav-link-disabled-color);
      background-color: transparent;
      border-color: transparent; }
  .nav-tabs .nav-link.active,
  .nav-tabs .nav-item.show .nav-link {
    color: var(--vz-nav-tabs-link-active-color);
    background-color: var(--vz-nav-tabs-link-active-bg);
    border-color: var(--vz-nav-tabs-link-active-border-color); }
  .nav-tabs .dropdown-menu {
    margin-top: calc(-1 * var(--vz-nav-tabs-border-width));
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

.nav-pills {
  --vz-nav-pills-border-radius: 0.25rem;
  --vz-nav-pills-link-active-color: #fff;
  --vz-nav-pills-link-active-bg: #F26430; }
  .nav-pills .nav-link {
    background: none;
    border: 0;
    border-radius: var(--vz-nav-pills-border-radius); }
    .nav-pills .nav-link:disabled {
      color: var(--vz-nav-link-disabled-color);
      background-color: transparent;
      border-color: transparent; }
  .nav-pills .nav-link.active,
  .nav-pills .show > .nav-link {
    color: var(--vz-nav-pills-link-active-color);
    background-color: var(--vz-nav-pills-link-active-bg); }

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center; }

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center; }

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%; }

.tab-content > .tab-pane {
  display: none; }

.tab-content > .active {
  display: block; }

.navbar {
  --vz-navbar-padding-x: 0;
  --vz-navbar-padding-y: 0.5rem;
  --vz-navbar-color: rgba(0, 0, 0, 0.55);
  --vz-navbar-hover-color: rgba(0, 0, 0, 0.7);
  --vz-navbar-disabled-color: rgba(0, 0, 0, 0.3);
  --vz-navbar-active-color: rgba(0, 0, 0, 0.9);
  --vz-navbar-brand-padding-y: 0.34766rem;
  --vz-navbar-brand-margin-end: 1rem;
  --vz-navbar-brand-font-size: 1.01562rem;
  --vz-navbar-brand-color: rgba(0, 0, 0, 0.9);
  --vz-navbar-brand-hover-color: rgba(0, 0, 0, 0.9);
  --vz-navbar-nav-link-padding-x: 0.5rem;
  --vz-navbar-toggler-padding-y: 0.25rem;
  --vz-navbar-toggler-padding-x: 0.75rem;
  --vz-navbar-toggler-font-size: 1.01562rem;
  --vz-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  --vz-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);
  --vz-navbar-toggler-border-radius: 0.25rem;
  --vz-navbar-toggler-focus-width: 0;
  --vz-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--vz-navbar-padding-y) var(--vz-navbar-padding-x); }
  .navbar > .container,
  .navbar > .container-fluid, .navbar > .container-sm, .navbar > .container-md, .navbar > .container-lg, .navbar > .container-xl, .navbar > .container-xxl {
    display: flex;
    flex-wrap: inherit;
    align-items: center;
    justify-content: space-between; }

.navbar-brand {
  padding-top: var(--vz-navbar-brand-padding-y);
  padding-bottom: var(--vz-navbar-brand-padding-y);
  margin-right: var(--vz-navbar-brand-margin-end);
  font-size: var(--vz-navbar-brand-font-size);
  color: var(--vz-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap; }
  .navbar-brand:hover, .navbar-brand:focus {
    color: var(--vz-navbar-brand-hover-color); }

.navbar-nav {
  --vz-nav-link-padding-x: 0;
  --vz-nav-link-padding-y: 0.5rem;
  --vz-nav-link-font-weight: ;
  --vz-nav-link-color: var(--vz-navbar-color);
  --vz-nav-link-hover-color: var(--vz-navbar-hover-color);
  --vz-nav-link-disabled-color: var(--vz-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none; }
  .navbar-nav .show > .nav-link,
  .navbar-nav .nav-link.active {
    color: var(--vz-navbar-active-color); }
  .navbar-nav .dropdown-menu {
    position: static; }

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--vz-navbar-color); }
  .navbar-text a,
  .navbar-text a:hover,
  .navbar-text a:focus {
    color: var(--vz-navbar-active-color); }

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center; }

.navbar-toggler {
  padding: var(--vz-navbar-toggler-padding-y) var(--vz-navbar-toggler-padding-x);
  font-size: var(--vz-navbar-toggler-font-size);
  line-height: 1;
  color: var(--vz-navbar-color);
  background-color: transparent;
  border: var(--vz-border-width) solid var(--vz-navbar-toggler-border-color);
  border-radius: var(--vz-navbar-toggler-border-radius);
  transition: var(--vz-navbar-toggler-transition); }
  @media (prefers-reduced-motion: reduce) {
    .navbar-toggler {
      transition: none; } }
  .navbar-toggler:hover {
    text-decoration: none; }
  .navbar-toggler:focus {
    text-decoration: none;
    outline: 0;
    box-shadow: 0 0 0 var(--vz-navbar-toggler-focus-width); }

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--vz-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%; }

.navbar-nav-scroll {
  max-height: var(--vz-scroll-height, 75vh);
  overflow-y: auto; }

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-sm .navbar-nav {
      flex-direction: row; }
      .navbar-expand-sm .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-sm .navbar-nav .nav-link {
        padding-right: var(--vz-navbar-nav-link-padding-x);
        padding-left: var(--vz-navbar-nav-link-padding-x); }
    .navbar-expand-sm .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-sm .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-sm .navbar-toggler {
      display: none; }
    .navbar-expand-sm .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-sm .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-sm .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-md .navbar-nav {
      flex-direction: row; }
      .navbar-expand-md .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-md .navbar-nav .nav-link {
        padding-right: var(--vz-navbar-nav-link-padding-x);
        padding-left: var(--vz-navbar-nav-link-padding-x); }
    .navbar-expand-md .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-md .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-md .navbar-toggler {
      display: none; }
    .navbar-expand-md .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-md .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-md .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-lg .navbar-nav {
      flex-direction: row; }
      .navbar-expand-lg .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: var(--vz-navbar-nav-link-padding-x);
        padding-left: var(--vz-navbar-nav-link-padding-x); }
    .navbar-expand-lg .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-lg .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-lg .navbar-toggler {
      display: none; }
    .navbar-expand-lg .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-lg .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-lg .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-xl .navbar-nav {
      flex-direction: row; }
      .navbar-expand-xl .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-xl .navbar-nav .nav-link {
        padding-right: var(--vz-navbar-nav-link-padding-x);
        padding-left: var(--vz-navbar-nav-link-padding-x); }
    .navbar-expand-xl .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-xl .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-xl .navbar-toggler {
      display: none; }
    .navbar-expand-xl .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-xl .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-xl .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-xxl .navbar-nav {
      flex-direction: row; }
      .navbar-expand-xxl .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-xxl .navbar-nav .nav-link {
        padding-right: var(--vz-navbar-nav-link-padding-x);
        padding-left: var(--vz-navbar-nav-link-padding-x); }
    .navbar-expand-xxl .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-xxl .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-xxl .navbar-toggler {
      display: none; }
    .navbar-expand-xxl .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-xxl .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-xxl .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start; }
  .navbar-expand .navbar-nav {
    flex-direction: row; }
    .navbar-expand .navbar-nav .dropdown-menu {
      position: absolute; }
    .navbar-expand .navbar-nav .nav-link {
      padding-right: var(--vz-navbar-nav-link-padding-x);
      padding-left: var(--vz-navbar-nav-link-padding-x); }
  .navbar-expand .navbar-nav-scroll {
    overflow: visible; }
  .navbar-expand .navbar-collapse {
    display: flex !important;
    flex-basis: auto; }
  .navbar-expand .navbar-toggler {
    display: none; }
  .navbar-expand .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none; }
    .navbar-expand .offcanvas .offcanvas-header {
      display: none; }
    .navbar-expand .offcanvas .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible; }

.navbar-dark {
  --vz-navbar-color: rgba(255, 255, 255, 0.55);
  --vz-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --vz-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --vz-navbar-active-color: #fff;
  --vz-navbar-brand-color: #fff;
  --vz-navbar-brand-hover-color: #fff;
  --vz-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --vz-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_44___}); }

.card {
  --vz-card-spacer-y: 1rem;
  --vz-card-spacer-x: 1rem;
  --vz-card-title-spacer-y: 0.5rem;
  --vz-card-border-width: 0;
  --vz-card-border-color: rgba(0, 0, 0, 0.125);
  --vz-card-border-radius: 0.25rem;
  --vz-card-box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  --vz-card-inner-border-radius: 0.25rem;
  --vz-card-cap-padding-y: 1rem;
  --vz-card-cap-padding-x: 1rem;
  --vz-card-cap-bg: #fff;
  --vz-card-cap-color: ;
  --vz-card-height: ;
  --vz-card-color: ;
  --vz-card-bg: #fff;
  --vz-card-img-overlay-padding: 1rem;
  --vz-card-group-margin: 0.5rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--vz-card-height);
  word-wrap: break-word;
  background-color: var(--vz-card-bg);
  background-clip: border-box;
  border: var(--vz-card-border-width) solid var(--vz-card-border-color);
  border-radius: var(--vz-card-border-radius); }
  .card > hr {
    margin-right: 0;
    margin-left: 0; }
  .card > .list-group {
    border-top: inherit;
    border-bottom: inherit; }
    .card > .list-group:first-child {
      border-top-width: 0;
      border-top-left-radius: var(--vz-card-inner-border-radius);
      border-top-right-radius: var(--vz-card-inner-border-radius); }
    .card > .list-group:last-child {
      border-bottom-width: 0;
      border-bottom-right-radius: var(--vz-card-inner-border-radius);
      border-bottom-left-radius: var(--vz-card-inner-border-radius); }
  .card > .card-header + .list-group,
  .card > .list-group + .card-footer {
    border-top: 0; }

.card-body {
  flex: 1 1 auto;
  padding: var(--vz-card-spacer-y) var(--vz-card-spacer-x);
  color: var(--vz-card-color); }

.card-title {
  margin-bottom: var(--vz-card-title-spacer-y); }

.card-subtitle {
  margin-top: calc(-.5 * var(--vz-card-title-spacer-y));
  margin-bottom: 0; }

.card-text:last-child {
  margin-bottom: 0; }

.card-link + .card-link {
  margin-left: var(--vz-card-spacer-x); }

.card-header {
  padding: var(--vz-card-cap-padding-y) var(--vz-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--vz-card-cap-color);
  background-color: var(--vz-card-cap-bg);
  border-bottom: var(--vz-card-border-width) solid var(--vz-card-border-color); }
  .card-header:first-child {
    border-radius: var(--vz-card-inner-border-radius) var(--vz-card-inner-border-radius) 0 0; }

.card-footer {
  padding: var(--vz-card-cap-padding-y) var(--vz-card-cap-padding-x);
  color: var(--vz-card-cap-color);
  background-color: var(--vz-card-cap-bg);
  border-top: var(--vz-card-border-width) solid var(--vz-card-border-color); }
  .card-footer:last-child {
    border-radius: 0 0 var(--vz-card-inner-border-radius) var(--vz-card-inner-border-radius); }

.card-header-tabs {
  margin-right: calc(-.5 * var(--vz-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--vz-card-cap-padding-y));
  margin-left: calc(-.5 * var(--vz-card-cap-padding-x));
  border-bottom: 0; }
  .card-header-tabs .nav-link.active {
    background-color: var(--vz-card-bg);
    border-bottom-color: var(--vz-card-bg); }

.card-header-pills {
  margin-right: calc(-.5 * var(--vz-card-cap-padding-x));
  margin-left: calc(-.5 * var(--vz-card-cap-padding-x)); }

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--vz-card-img-overlay-padding);
  border-radius: var(--vz-card-inner-border-radius); }

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%; }

.card-img,
.card-img-top {
  border-top-left-radius: var(--vz-card-inner-border-radius);
  border-top-right-radius: var(--vz-card-inner-border-radius); }

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--vz-card-inner-border-radius);
  border-bottom-left-radius: var(--vz-card-inner-border-radius); }

.card-group > .card {
  margin-bottom: var(--vz-card-group-margin); }

@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap; }
    .card-group > .card {
      flex: 1 0;
      margin-bottom: 0; }
      .card-group > .card + .card {
        margin-left: 0;
        border-left: 0; }
      .card-group > .card:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0; }
        .card-group > .card:not(:last-child) .card-img-top,
        .card-group > .card:not(:last-child) .card-header {
          border-top-right-radius: 0; }
        .card-group > .card:not(:last-child) .card-img-bottom,
        .card-group > .card:not(:last-child) .card-footer {
          border-bottom-right-radius: 0; }
      .card-group > .card:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0; }
        .card-group > .card:not(:first-child) .card-img-top,
        .card-group > .card:not(:first-child) .card-header {
          border-top-left-radius: 0; }
        .card-group > .card:not(:first-child) .card-img-bottom,
        .card-group > .card:not(:first-child) .card-footer {
          border-bottom-left-radius: 0; } }

.accordion {
  --vz-accordion-color: var(--vz-body-color);
  --vz-accordion-bg: #fff;
  --vz-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --vz-accordion-border-color: var(--vz-border-color);
  --vz-accordion-border-width: 1px;
  --vz-accordion-border-radius: 0.25rem;
  --vz-accordion-inner-border-radius: calc(0.25rem - 1px);
  --vz-accordion-btn-padding-x: 1.25rem;
  --vz-accordion-btn-padding-y: 1rem;
  --vz-accordion-btn-color: var(--vz-body-color);
  --vz-accordion-btn-bg: #fff;
  --vz-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
  --vz-accordion-btn-icon-width: 0.75rem;
  --vz-accordion-btn-icon-transform: rotate(-180deg);
  --vz-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --vz-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
  --vz-accordion-btn-focus-border-color: var(--vz-input-focus-border);
  --vz-accordion-btn-focus-box-shadow: inset 0 -1px 0 var(--vz-border-color);
  --vz-accordion-body-padding-x: 1.25rem;
  --vz-accordion-body-padding-y: 1rem;
  --vz-accordion-active-color: #da5a2b;
  --vz-accordion-active-bg: rgba(242, 100, 48, 0.05); }

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--vz-accordion-btn-padding-y) var(--vz-accordion-btn-padding-x);
  font-size: 0.8125rem;
  color: var(--vz-accordion-btn-color);
  text-align: left;
  background-color: var(--vz-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--vz-accordion-transition); }
  @media (prefers-reduced-motion: reduce) {
    .accordion-button {
      transition: none; } }
  .accordion-button:not(.collapsed) {
    color: var(--vz-accordion-active-color);
    background-color: var(--vz-accordion-active-bg);
    box-shadow: inset 0 calc(-1 * var(--vz-accordion-border-width)) 0 var(--vz-accordion-border-color); }
    .accordion-button:not(.collapsed)::after {
      background-image: var(--vz-accordion-btn-active-icon);
      transform: var(--vz-accordion-btn-icon-transform); }
  .accordion-button::after {
    flex-shrink: 0;
    width: var(--vz-accordion-btn-icon-width);
    height: var(--vz-accordion-btn-icon-width);
    margin-left: auto;
    content: "";
    background-image: var(--vz-accordion-btn-icon);
    background-repeat: no-repeat;
    background-size: var(--vz-accordion-btn-icon-width);
    transition: var(--vz-accordion-btn-icon-transition); }
    @media (prefers-reduced-motion: reduce) {
      .accordion-button::after {
        transition: none; } }
  .accordion-button:hover {
    z-index: 2; }
  .accordion-button:focus {
    z-index: 3;
    border-color: var(--vz-accordion-btn-focus-border-color);
    outline: 0;
    box-shadow: var(--vz-accordion-btn-focus-box-shadow); }

.accordion-header {
  margin-bottom: 0; }

.accordion-item {
  color: var(--vz-accordion-color);
  background-color: var(--vz-accordion-bg);
  border: var(--vz-accordion-border-width) solid var(--vz-accordion-border-color); }
  .accordion-item:first-of-type {
    border-top-left-radius: var(--vz-accordion-border-radius);
    border-top-right-radius: var(--vz-accordion-border-radius); }
    .accordion-item:first-of-type .accordion-button {
      border-top-left-radius: var(--vz-accordion-inner-border-radius);
      border-top-right-radius: var(--vz-accordion-inner-border-radius); }
  .accordion-item:not(:first-of-type) {
    border-top: 0; }
  .accordion-item:last-of-type {
    border-bottom-right-radius: var(--vz-accordion-border-radius);
    border-bottom-left-radius: var(--vz-accordion-border-radius); }
    .accordion-item:last-of-type .accordion-button.collapsed {
      border-bottom-right-radius: var(--vz-accordion-inner-border-radius);
      border-bottom-left-radius: var(--vz-accordion-inner-border-radius); }
    .accordion-item:last-of-type .accordion-collapse {
      border-bottom-right-radius: var(--vz-accordion-border-radius);
      border-bottom-left-radius: var(--vz-accordion-border-radius); }

.accordion-body {
  padding: var(--vz-accordion-body-padding-y) var(--vz-accordion-body-padding-x); }

.accordion-flush .accordion-collapse {
  border-width: 0; }

.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0; }
  .accordion-flush .accordion-item:first-child {
    border-top: 0; }
  .accordion-flush .accordion-item:last-child {
    border-bottom: 0; }
  .accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {
    border-radius: 0; }

.breadcrumb {
  --vz-breadcrumb-padding-x: 0;
  --vz-breadcrumb-padding-y: 0;
  --vz-breadcrumb-margin-bottom: 1rem;
  --vz-breadcrumb-bg: ;
  --vz-breadcrumb-border-radius: ;
  --vz-breadcrumb-divider-color: #878a99;
  --vz-breadcrumb-item-padding-x: 0.5rem;
  --vz-breadcrumb-item-active-color: #878a99;
  display: flex;
  flex-wrap: wrap;
  padding: var(--vz-breadcrumb-padding-y) var(--vz-breadcrumb-padding-x);
  margin-bottom: var(--vz-breadcrumb-margin-bottom);
  font-size: var(--vz-breadcrumb-font-size);
  list-style: none;
  background-color: var(--vz-breadcrumb-bg);
  border-radius: var(--vz-breadcrumb-border-radius); }

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--vz-breadcrumb-item-padding-x); }
  .breadcrumb-item + .breadcrumb-item::before {
    float: left;
    padding-right: var(--vz-breadcrumb-item-padding-x);
    color: var(--vz-breadcrumb-divider-color);
    content: var(--vz-breadcrumb-divider, "󰅂") /* rtl: var(--vz-breadcrumb-divider, "󰅂") */; }

.breadcrumb-item.active {
  color: var(--vz-breadcrumb-item-active-color); }

.pagination {
  --vz-pagination-padding-x: 0.75rem;
  --vz-pagination-padding-y: 0.375rem;
  --vz-pagination-font-size: 0.8125rem;
  --vz-pagination-color: var(--vz-link-color);
  --vz-pagination-bg: var(--vz-card-bg-custom);
  --vz-pagination-border-width: 1px;
  --vz-pagination-border-color: var(--vz-border-color);
  --vz-pagination-border-radius: 0.25rem;
  --vz-pagination-hover-color: var(--vz-link-hover-color);
  --vz-pagination-hover-bg: #eff2f7;
  --vz-pagination-hover-border-color: var(--vz-border-color);
  --vz-pagination-focus-color: var(--vz-link-hover-color);
  --vz-pagination-focus-bg: #eff2f7;
  --vz-pagination-focus-box-shadow: 0 0 0 0 rgba(242, 100, 48, 0.25);
  --vz-pagination-active-color: #fff;
  --vz-pagination-active-bg: #F26430;
  --vz-pagination-active-border-color: #F26430;
  --vz-pagination-disabled-color: #878a99;
  --vz-pagination-disabled-bg: var(--vz-card-bg-custom);
  --vz-pagination-disabled-border-color: var(--vz-border-color);
  display: flex;
  padding-left: 0;
  list-style: none; }

.page-link {
  position: relative;
  display: block;
  padding: var(--vz-pagination-padding-y) var(--vz-pagination-padding-x);
  font-size: var(--vz-pagination-font-size);
  color: var(--vz-pagination-color);
  text-decoration: none;
  background-color: var(--vz-pagination-bg);
  border: var(--vz-pagination-border-width) solid var(--vz-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .page-link {
      transition: none; } }
  .page-link:hover {
    z-index: 2;
    color: var(--vz-pagination-hover-color);
    background-color: var(--vz-pagination-hover-bg);
    border-color: var(--vz-pagination-hover-border-color); }
  .page-link:focus {
    z-index: 3;
    color: var(--vz-pagination-focus-color);
    background-color: var(--vz-pagination-focus-bg);
    outline: 0;
    box-shadow: var(--vz-pagination-focus-box-shadow); }
  .page-link.active,
  .active > .page-link {
    z-index: 3;
    color: var(--vz-pagination-active-color);
    background-color: var(--vz-pagination-active-bg);
    border-color: var(--vz-pagination-active-border-color); }
  .page-link.disabled,
  .disabled > .page-link {
    color: var(--vz-pagination-disabled-color);
    pointer-events: none;
    background-color: var(--vz-pagination-disabled-bg);
    border-color: var(--vz-pagination-disabled-border-color); }

.page-item:not(:first-child) .page-link {
  margin-left: -1px; }

.page-item:first-child .page-link {
  border-top-left-radius: var(--vz-pagination-border-radius);
  border-bottom-left-radius: var(--vz-pagination-border-radius); }

.page-item:last-child .page-link {
  border-top-right-radius: var(--vz-pagination-border-radius);
  border-bottom-right-radius: var(--vz-pagination-border-radius); }

.pagination-lg {
  --vz-pagination-padding-x: 1.2rem;
  --vz-pagination-padding-y: 0.6rem;
  --vz-pagination-font-size: 1.01563rem;
  --vz-pagination-border-radius: 0.3rem; }
  @media (min-width: 1200px) {
    .pagination-lg {
      --vz-pagination-font-size: 1.01562rem; } }

.pagination-sm {
  --vz-pagination-padding-x: 0.5rem;
  --vz-pagination-padding-y: 0.25rem;
  --vz-pagination-font-size: 0.71094rem;
  --vz-pagination-border-radius: 0.2rem; }

.badge {
  --vz-badge-padding-x: 0.65em;
  --vz-badge-padding-y: 0.35em;
  --vz-badge-font-size: 0.75em;
  --vz-badge-font-weight: 600;
  --vz-badge-color: #fff;
  --vz-badge-border-radius: 0.25rem;
  display: inline-block;
  padding: var(--vz-badge-padding-y) var(--vz-badge-padding-x);
  font-size: var(--vz-badge-font-size);
  font-weight: var(--vz-badge-font-weight);
  line-height: 1;
  color: var(--vz-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--vz-badge-border-radius); }
  .badge:empty {
    display: none; }

.btn .badge {
  position: relative;
  top: -1px; }

.alert {
  --vz-alert-bg: transparent;
  --vz-alert-padding-x: 1rem;
  --vz-alert-padding-y: 0.8rem;
  --vz-alert-margin-bottom: 1rem;
  --vz-alert-color: inherit;
  --vz-alert-border-color: transparent;
  --vz-alert-border: 1px solid var(--vz-alert-border-color);
  --vz-alert-border-radius: 0.25rem;
  position: relative;
  padding: var(--vz-alert-padding-y) var(--vz-alert-padding-x);
  margin-bottom: var(--vz-alert-margin-bottom);
  color: var(--vz-alert-color);
  background-color: var(--vz-alert-bg);
  border: var(--vz-alert-border);
  border-radius: var(--vz-alert-border-radius); }

.alert-heading {
  color: inherit; }

.alert-link {
  font-weight: 600; }

.alert-dismissible {
  padding-right: 3rem; }
  .alert-dismissible .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    padding: 1rem 1rem; }

.alert-primary {
  --vz-alert-color: #b64b24;
  --vz-alert-bg: #fde8e0;
  --vz-alert-border-color: #fbd1c1; }
  .alert-primary .alert-link {
    color: #923c1d; }

.alert-secondary {
  --vz-alert-color: #18692c;
  --vz-alert-bg: #deeee2;
  --vz-alert-border-color: #bcddc4; }
  .alert-secondary .alert-link {
    color: #135423; }

.alert-success {
  --vz-alert-color: #088675;
  --vz-alert-bg: #daf4f0;
  --vz-alert-border-color: #b6e8e1; }
  .alert-success .alert-link {
    color: #066b5e; }

.alert-info {
  --vz-alert-color: #1f75a4;
  --vz-alert-bg: #dff0fa;
  --vz-alert-border-color: #bfe1f4; }
  .alert-info .alert-link {
    color: #195e83; }

.alert-warning {
  --vz-alert-color: #2f8f36;
  --vz-alert-bg: #e2f5e4;
  --vz-alert-border-color: #c5ecc8; }
  .alert-warning .alert-link {
    color: #26722b; }

.alert-danger {
  --vz-alert-color: #b44c36;
  --vz-alert-bg: #fde8e4;
  --vz-alert-border-color: #fbd1c8; }
  .alert-danger .alert-link {
    color: #903d2b; }

.alert-light {
  --vz-alert-color: #b6b9bb;
  --vz-alert-bg: #fdfefe;
  --vz-alert-border-color: #fbfcfd; }
  .alert-light .alert-link {
    color: #929496; }

.alert-dark {
  --vz-alert-color: #191c1f;
  --vz-alert-bg: #dededf;
  --vz-alert-border-color: #bcbebf; }
  .alert-dark .alert-link {
    color: #141619; }

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 0.625rem; } }

.progress {
  --vz-progress-height: 0.625rem;
  --vz-progress-font-size: 0.60938rem;
  --vz-progress-bg: #eff2f7;
  --vz-progress-border-radius: 0.25rem;
  --vz-progress-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --vz-progress-bar-color: #fff;
  --vz-progress-bar-bg: #F26430;
  --vz-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--vz-progress-height);
  overflow: hidden;
  font-size: var(--vz-progress-font-size);
  background-color: var(--vz-progress-bg);
  border-radius: var(--vz-progress-border-radius); }

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--vz-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--vz-progress-bar-bg);
  transition: var(--vz-progress-bar-transition); }
  @media (prefers-reduced-motion: reduce) {
    .progress-bar {
      transition: none; } }

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--vz-progress-height) var(--vz-progress-height); }

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes; }
  @media (prefers-reduced-motion: reduce) {
    .progress-bar-animated {
      animation: none; } }

.list-group {
  --vz-list-group-color: var(--vz-body-color);
  --vz-list-group-bg: var(--vz-card-bg-custom);
  --vz-list-group-border-color: var(--vz-border-color);
  --vz-list-group-border-width: 1px;
  --vz-list-group-border-radius: 0.25rem;
  --vz-list-group-item-padding-x: 1rem;
  --vz-list-group-item-padding-y: 0.7rem;
  --vz-list-group-action-color: var(--vz-body-color);
  --vz-list-group-action-hover-color: var(--vz-body-color);
  --vz-list-group-action-hover-bg: var(--vz-list-group-hover-bg);
  --vz-list-group-action-active-color: var(--vz-body-color);
  --vz-list-group-action-active-bg: var(--vz-list-group-hover-bg);
  --vz-list-group-disabled-color: #878a99;
  --vz-list-group-disabled-bg: var(--vz-card-bg-custom);
  --vz-list-group-active-color: #fff;
  --vz-list-group-active-bg: #F26430;
  --vz-list-group-active-border-color: #F26430;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--vz-list-group-border-radius); }

.list-group-numbered {
  list-style-type: none;
  counter-reset: section; }
  .list-group-numbered > .list-group-item::before {
    content: counters(section, ".") ". ";
    counter-increment: section; }

.list-group-item-action {
  width: 100%;
  color: var(--vz-list-group-action-color);
  text-align: inherit; }
  .list-group-item-action:hover, .list-group-item-action:focus {
    z-index: 1;
    color: var(--vz-list-group-action-hover-color);
    text-decoration: none;
    background-color: var(--vz-list-group-action-hover-bg); }
  .list-group-item-action:active {
    color: var(--vz-list-group-action-active-color);
    background-color: var(--vz-list-group-action-active-bg); }

.list-group-item {
  position: relative;
  display: block;
  padding: var(--vz-list-group-item-padding-y) var(--vz-list-group-item-padding-x);
  color: var(--vz-list-group-color);
  text-decoration: none;
  background-color: var(--vz-list-group-bg);
  border: var(--vz-list-group-border-width) solid var(--vz-list-group-border-color); }
  .list-group-item:first-child {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit; }
  .list-group-item:last-child {
    border-bottom-right-radius: inherit;
    border-bottom-left-radius: inherit; }
  .list-group-item.disabled, .list-group-item:disabled {
    color: var(--vz-list-group-disabled-color);
    pointer-events: none;
    background-color: var(--vz-list-group-disabled-bg); }
  .list-group-item.active {
    z-index: 2;
    color: var(--vz-list-group-active-color);
    background-color: var(--vz-list-group-active-bg);
    border-color: var(--vz-list-group-active-border-color); }
  .list-group-item + .list-group-item {
    border-top-width: 0; }
    .list-group-item + .list-group-item.active {
      margin-top: calc(-1 * var(--vz-list-group-border-width));
      border-top-width: var(--vz-list-group-border-width); }

.list-group-horizontal {
  flex-direction: row; }
  .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--vz-list-group-border-radius);
    border-top-right-radius: 0; }
  .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--vz-list-group-border-radius);
    border-bottom-left-radius: 0; }
  .list-group-horizontal > .list-group-item.active {
    margin-top: 0; }
  .list-group-horizontal > .list-group-item + .list-group-item {
    border-top-width: var(--vz-list-group-border-width);
    border-left-width: 0; }
    .list-group-horizontal > .list-group-item + .list-group-item.active {
      margin-left: calc(-1 * var(--vz-list-group-border-width));
      border-left-width: var(--vz-list-group-border-width); }

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row; }
    .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--vz-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--vz-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-sm > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-sm > .list-group-item + .list-group-item {
      border-top-width: var(--vz-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--vz-list-group-border-width));
        border-left-width: var(--vz-list-group-border-width); } }

@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row; }
    .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--vz-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--vz-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-md > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-md > .list-group-item + .list-group-item {
      border-top-width: var(--vz-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-md > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--vz-list-group-border-width));
        border-left-width: var(--vz-list-group-border-width); } }

@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row; }
    .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--vz-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--vz-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-lg > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-lg > .list-group-item + .list-group-item {
      border-top-width: var(--vz-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--vz-list-group-border-width));
        border-left-width: var(--vz-list-group-border-width); } }

@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row; }
    .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--vz-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--vz-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-xl > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-xl > .list-group-item + .list-group-item {
      border-top-width: var(--vz-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--vz-list-group-border-width));
        border-left-width: var(--vz-list-group-border-width); } }

@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row; }
    .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--vz-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--vz-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-xxl > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-xxl > .list-group-item + .list-group-item {
      border-top-width: var(--vz-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--vz-list-group-border-width));
        border-left-width: var(--vz-list-group-border-width); } }

.list-group-flush {
  border-radius: 0; }
  .list-group-flush > .list-group-item {
    border-width: 0 0 var(--vz-list-group-border-width); }
    .list-group-flush > .list-group-item:last-child {
      border-bottom-width: 0; }

.list-group-item-primary {
  color: #913c1d;
  background-color: #fce0d6; }
  .list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
    color: #913c1d;
    background-color: #e3cac1; }
  .list-group-item-primary.list-group-item-action.active {
    color: #fff;
    background-color: #913c1d;
    border-color: #913c1d; }

.list-group-item-secondary {
  color: #135423;
  background-color: #d2e8d8; }
  .list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
    color: #135423;
    background-color: #bdd1c2; }
  .list-group-item-secondary.list-group-item-action.active {
    color: #fff;
    background-color: #135423;
    border-color: #135423; }

.list-group-item-success {
  color: #066b5e;
  background-color: #cef0eb; }
  .list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
    color: #066b5e;
    background-color: #b9d8d4; }
  .list-group-item-success.list-group-item-action.active {
    color: #fff;
    background-color: #066b5e;
    border-color: #066b5e; }

.list-group-item-info {
  color: #195e83;
  background-color: #d4ebf8; }
  .list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
    color: #195e83;
    background-color: #bfd4df; }
  .list-group-item-info.list-group-item-action.active {
    color: #fff;
    background-color: #195e83;
    border-color: #195e83; }

.list-group-item-warning {
  color: #26732b;
  background-color: #d9f2da; }
  .list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
    color: #26732b;
    background-color: #c3dac4; }
  .list-group-item-warning.list-group-item-action.active {
    color: #fff;
    background-color: #26732b;
    border-color: #26732b; }

.list-group-item-danger {
  color: #903d2b;
  background-color: #fce0da; }
  .list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
    color: #903d2b;
    background-color: #e3cac4; }
  .list-group-item-danger.list-group-item-action.active {
    color: #fff;
    background-color: #903d2b;
    border-color: #903d2b; }

.list-group-item-light {
  color: #929495;
  background-color: #fdfdfe; }
  .list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
    color: #929495;
    background-color: #e4e4e5; }
  .list-group-item-light.list-group-item-action.active {
    color: #fff;
    background-color: #929495;
    border-color: #929495; }

.list-group-item-dark {
  color: #141619;
  background-color: #d3d3d4; }
  .list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
    color: #141619;
    background-color: #bebebf; }
  .list-group-item-dark.list-group-item-action.active {
    color: #fff;
    background-color: #141619;
    border-color: #141619; }

.btn-close {
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: #000;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_47___}) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: 0.5; }
  .btn-close:hover {
    color: #000;
    text-decoration: none;
    opacity: 0.75; }
  .btn-close:focus {
    outline: 0;
    box-shadow: 0 0 0 0 rgba(242, 100, 48, 0.25);
    opacity: 1; }
  .btn-close:disabled, .btn-close.disabled {
    pointer-events: none;
    -webkit-user-select: none;
            user-select: none;
    opacity: 0.25; }

.btn-close-white {
  filter: invert(1) grayscale(100%) brightness(200%); }

.toast {
  --vz-toast-zindex: 1090;
  --vz-toast-padding-x: 0.75rem;
  --vz-toast-padding-y: 0.5rem;
  --vz-toast-spacing: 1rem;
  --vz-toast-max-width: 350px;
  --vz-toast-font-size: 0.875rem;
  --vz-toast-color: ;
  --vz-toast-bg: rgba(255, 255, 255, 0.85);
  --vz-toast-border-width: 1px;
  --vz-toast-border-color: rgba(0, 0, 0, 0.1);
  --vz-toast-border-radius: 0.25rem;
  --vz-toast-box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  --vz-toast-header-color: #878a99;
  --vz-toast-header-bg: rgba(255, 255, 255, 0.85);
  --vz-toast-header-border-color: rgba(0, 0, 0, 0.05);
  width: var(--vz-toast-max-width);
  max-width: 100%;
  font-size: var(--vz-toast-font-size);
  color: var(--vz-toast-color);
  pointer-events: auto;
  background-color: var(--vz-toast-bg);
  background-clip: padding-box;
  border: var(--vz-toast-border-width) solid var(--vz-toast-border-color);
  box-shadow: var(--vz-toast-box-shadow);
  border-radius: var(--vz-toast-border-radius); }
  .toast.showing {
    opacity: 0; }
  .toast:not(.show) {
    display: none; }

.toast-container {
  --vz-toast-zindex: 1090;
  position: absolute;
  z-index: var(--vz-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none; }
  .toast-container > :not(:last-child) {
    margin-bottom: var(--vz-toast-spacing); }

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--vz-toast-padding-y) var(--vz-toast-padding-x);
  color: var(--vz-toast-header-color);
  background-color: var(--vz-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--vz-toast-border-width) solid var(--vz-toast-header-border-color);
  border-top-left-radius: calc(var(--vz-toast-border-radius) - var(--vz-toast-border-width));
  border-top-right-radius: calc(var(--vz-toast-border-radius) - var(--vz-toast-border-width)); }
  .toast-header .btn-close {
    margin-right: calc(-.5 * var(--vz-toast-padding-x));
    margin-left: var(--vz-toast-padding-x); }

.toast-body {
  padding: var(--vz-toast-padding-x);
  word-wrap: break-word; }

.modal {
  --vz-modal-zindex: 1055;
  --vz-modal-width: 500px;
  --vz-modal-padding: 1.25rem;
  --vz-modal-margin: 0.5rem;
  --vz-modal-color: ;
  --vz-modal-bg: #fff;
  --vz-modal-border-color: var(--vz-border-color);
  --vz-modal-border-width: 1px;
  --vz-modal-border-radius: 0.3rem;
  --vz-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --vz-modal-inner-border-radius: calc(0.3rem - 1px);
  --vz-modal-header-padding-x: 1.25rem;
  --vz-modal-header-padding-y: 1.25rem;
  --vz-modal-header-padding: 1.25rem 1.25rem;
  --vz-modal-header-border-color: var(--vz-border-color);
  --vz-modal-header-border-width: 0;
  --vz-modal-title-line-height: 1.5;
  --vz-modal-footer-gap: 0.5rem;
  --vz-modal-footer-bg: ;
  --vz-modal-footer-border-color: var(--vz-border-color);
  --vz-modal-footer-border-width: 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--vz-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0; }

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--vz-modal-margin);
  pointer-events: none; }
  .modal.fade .modal-dialog {
    transition: transform 0.3s ease-out;
    transform: translate(0, -50px); }
    @media (prefers-reduced-motion: reduce) {
      .modal.fade .modal-dialog {
        transition: none; } }
  .modal.show .modal-dialog {
    transform: none; }
  .modal.modal-static .modal-dialog {
    transform: scale(1.02); }

.modal-dialog-scrollable {
  height: calc(100% - var(--vz-modal-margin) * 2); }
  .modal-dialog-scrollable .modal-content {
    max-height: 100%;
    overflow: hidden; }
  .modal-dialog-scrollable .modal-body {
    overflow-y: auto; }

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--vz-modal-margin) * 2); }

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--vz-modal-color);
  pointer-events: auto;
  background-color: var(--vz-modal-bg);
  background-clip: padding-box;
  border: var(--vz-modal-border-width) solid var(--vz-modal-border-color);
  border-radius: var(--vz-modal-border-radius);
  outline: 0; }

.modal-backdrop {
  --vz-backdrop-zindex: 1050;
  --vz-backdrop-bg: #000;
  --vz-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--vz-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--vz-backdrop-bg); }
  .modal-backdrop.fade {
    opacity: 0; }
  .modal-backdrop.show {
    opacity: var(--vz-backdrop-opacity); }

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--vz-modal-header-padding);
  border-bottom: var(--vz-modal-header-border-width) solid var(--vz-modal-header-border-color);
  border-top-left-radius: var(--vz-modal-inner-border-radius);
  border-top-right-radius: var(--vz-modal-inner-border-radius); }
  .modal-header .btn-close {
    padding: calc(var(--vz-modal-header-padding-y) * .5) calc(var(--vz-modal-header-padding-x) * .5);
    margin: calc(-.5 * var(--vz-modal-header-padding-y)) calc(-.5 * var(--vz-modal-header-padding-x)) calc(-.5 * var(--vz-modal-header-padding-y)) auto; }

.modal-title {
  margin-bottom: 0;
  line-height: var(--vz-modal-title-line-height); }

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--vz-modal-padding); }

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--vz-modal-padding) - var(--vz-modal-footer-gap) * .5);
  background-color: var(--vz-modal-footer-bg);
  border-top: var(--vz-modal-footer-border-width) solid var(--vz-modal-footer-border-color);
  border-bottom-right-radius: var(--vz-modal-inner-border-radius);
  border-bottom-left-radius: var(--vz-modal-inner-border-radius); }
  .modal-footer > * {
    margin: calc(var(--vz-modal-footer-gap) * .5); }

@media (min-width: 576px) {
  .modal {
    --vz-modal-margin: 1.75rem;
    --vz-modal-box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15); }
  .modal-dialog {
    max-width: var(--vz-modal-width);
    margin-right: auto;
    margin-left: auto; }
  .modal-sm {
    --vz-modal-width: 300px; } }

@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --vz-modal-width: 800px; } }

@media (min-width: 1200px) {
  .modal-xl {
    --vz-modal-width: 1140px; } }

.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0; }
  .modal-fullscreen .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0; }
  .modal-fullscreen .modal-header,
  .modal-fullscreen .modal-footer {
    border-radius: 0; }
  .modal-fullscreen .modal-body {
    overflow-y: auto; }

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-sm-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-sm-down .modal-header,
    .modal-fullscreen-sm-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-sm-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-md-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-md-down .modal-header,
    .modal-fullscreen-md-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-md-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-lg-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-lg-down .modal-header,
    .modal-fullscreen-lg-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-lg-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-xl-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-xl-down .modal-header,
    .modal-fullscreen-xl-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-xl-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-xxl-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-xxl-down .modal-header,
    .modal-fullscreen-xxl-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-xxl-down .modal-body {
      overflow-y: auto; } }

.tooltip {
  --vz-tooltip-zindex: 1080;
  --vz-tooltip-max-width: 200px;
  --vz-tooltip-padding-x: 0.7rem;
  --vz-tooltip-padding-y: 0.4rem;
  --vz-tooltip-margin: 0;
  --vz-tooltip-font-size: 0.71094rem;
  --vz-tooltip-color: #fff;
  --vz-tooltip-bg: #000;
  --vz-tooltip-border-radius: 0.2rem;
  --vz-tooltip-opacity: 0.9;
  --vz-tooltip-arrow-width: 0.8rem;
  --vz-tooltip-arrow-height: 0.4rem;
  z-index: var(--vz-tooltip-zindex);
  display: block;
  padding: var(--vz-tooltip-arrow-height);
  margin: var(--vz-tooltip-margin);
  font-family: var(--vz-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--vz-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0; }
  .tooltip.show {
    opacity: var(--vz-tooltip-opacity); }
  .tooltip .tooltip-arrow {
    display: block;
    width: var(--vz-tooltip-arrow-width);
    height: var(--vz-tooltip-arrow-height); }
    .tooltip .tooltip-arrow::before {
      position: absolute;
      content: "";
      border-color: transparent;
      border-style: solid; }

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="top"] .tooltip-arrow {
  bottom: 0; }
  .bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="top"] .tooltip-arrow::before {
    top: -1px;
    border-width: var(--vz-tooltip-arrow-height) calc(var(--vz-tooltip-arrow-width) * .5) 0;
    border-top-color: var(--vz-tooltip-bg); }

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="right"] .tooltip-arrow {
  left: 0;
  width: var(--vz-tooltip-arrow-height);
  height: var(--vz-tooltip-arrow-width); }
  .bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="right"] .tooltip-arrow::before {
    right: -1px;
    border-width: calc(var(--vz-tooltip-arrow-width) * .5) var(--vz-tooltip-arrow-height) calc(var(--vz-tooltip-arrow-width) * .5) 0;
    border-right-color: var(--vz-tooltip-bg); }

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="bottom"] .tooltip-arrow {
  top: 0; }
  .bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="bottom"] .tooltip-arrow::before {
    bottom: -1px;
    border-width: 0 calc(var(--vz-tooltip-arrow-width) * .5) var(--vz-tooltip-arrow-height);
    border-bottom-color: var(--vz-tooltip-bg); }

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="left"] .tooltip-arrow {
  right: 0;
  width: var(--vz-tooltip-arrow-height);
  height: var(--vz-tooltip-arrow-width); }
  .bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="left"] .tooltip-arrow::before {
    left: -1px;
    border-width: calc(var(--vz-tooltip-arrow-width) * .5) 0 calc(var(--vz-tooltip-arrow-width) * .5) var(--vz-tooltip-arrow-height);
    border-left-color: var(--vz-tooltip-bg); }

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--vz-tooltip-max-width);
  padding: var(--vz-tooltip-padding-y) var(--vz-tooltip-padding-x);
  color: var(--vz-tooltip-color);
  text-align: center;
  background-color: var(--vz-tooltip-bg);
  border-radius: var(--vz-tooltip-border-radius); }

.popover {
  --vz-popover-zindex: 1070;
  --vz-popover-max-width: 276px;
  --vz-popover-font-size: 0.8125rem;
  --vz-popover-bg: #fff;
  --vz-popover-border-width: 1px;
  --vz-popover-border-color: var(--vz-border-color);
  --vz-popover-border-radius: 0.25rem;
  --vz-popover-inner-border-radius: calc(0.25rem - 1px);
  --vz-popover-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  --vz-popover-header-padding-x: 1rem;
  --vz-popover-header-padding-y: 0.7rem;
  --vz-popover-header-font-size: 0.8125rem;
  --vz-popover-header-color: ;
  --vz-popover-header-bg: var(--vz-popover-bg);
  --vz-popover-body-padding-x: 1rem;
  --vz-popover-body-padding-y: 1rem;
  --vz-popover-body-color: var(--vz-body-color);
  --vz-popover-arrow-width: 1rem;
  --vz-popover-arrow-height: 0.5rem;
  --vz-popover-arrow-border: var(--vz-popover-border-color);
  z-index: var(--vz-popover-zindex);
  display: block;
  max-width: var(--vz-popover-max-width);
  font-family: var(--vz-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--vz-popover-font-size);
  word-wrap: break-word;
  background-color: var(--vz-popover-bg);
  background-clip: padding-box;
  border: var(--vz-popover-border-width) solid var(--vz-popover-border-color);
  border-radius: var(--vz-popover-border-radius); }
  .popover .popover-arrow {
    display: block;
    width: var(--vz-popover-arrow-width);
    height: var(--vz-popover-arrow-height); }
    .popover .popover-arrow::before, .popover .popover-arrow::after {
      position: absolute;
      display: block;
      content: "";
      border-color: transparent;
      border-style: solid;
      border-width: 0; }

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow {
  bottom: calc(-1 * (var(--vz-popover-arrow-height)) - var(--vz-popover-border-width)); }
  .bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::after {
    border-width: var(--vz-popover-arrow-height) calc(var(--vz-popover-arrow-width) * .5) 0; }
  .bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::before {
    bottom: 0;
    border-top-color: var(--vz-popover-arrow-border); }
  .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::after {
    bottom: var(--vz-popover-border-width);
    border-top-color: var(--vz-popover-bg); }

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow {
  left: calc(-1 * (var(--vz-popover-arrow-height)) - var(--vz-popover-border-width));
  width: var(--vz-popover-arrow-height);
  height: var(--vz-popover-arrow-width); }
  .bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::after {
    border-width: calc(var(--vz-popover-arrow-width) * .5) var(--vz-popover-arrow-height) calc(var(--vz-popover-arrow-width) * .5) 0; }
  .bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::before {
    left: 0;
    border-right-color: var(--vz-popover-arrow-border); }
  .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::after {
    left: var(--vz-popover-border-width);
    border-right-color: var(--vz-popover-bg); }

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow {
  top: calc(-1 * (var(--vz-popover-arrow-height)) - var(--vz-popover-border-width)); }
  .bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::after {
    border-width: 0 calc(var(--vz-popover-arrow-width) * .5) var(--vz-popover-arrow-height); }
  .bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::before {
    top: 0;
    border-bottom-color: var(--vz-popover-arrow-border); }
  .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::after {
    top: var(--vz-popover-border-width);
    border-bottom-color: var(--vz-popover-bg); }

.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^="bottom"] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--vz-popover-arrow-width);
  margin-left: calc(-.5 * var(--vz-popover-arrow-width));
  content: "";
  border-bottom: var(--vz-popover-border-width) solid var(--vz-popover-header-bg); }

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow {
  right: calc(-1 * (var(--vz-popover-arrow-height)) - var(--vz-popover-border-width));
  width: var(--vz-popover-arrow-height);
  height: var(--vz-popover-arrow-width); }
  .bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::after {
    border-width: calc(var(--vz-popover-arrow-width) * .5) 0 calc(var(--vz-popover-arrow-width) * .5) var(--vz-popover-arrow-height); }
  .bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::before {
    right: 0;
    border-left-color: var(--vz-popover-arrow-border); }
  .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::after {
    right: var(--vz-popover-border-width);
    border-left-color: var(--vz-popover-bg); }

/* rtl:end:ignore */
.popover-header {
  padding: var(--vz-popover-header-padding-y) var(--vz-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--vz-popover-header-font-size);
  color: var(--vz-popover-header-color);
  background-color: var(--vz-popover-header-bg);
  border-bottom: var(--vz-popover-border-width) solid var(--vz-popover-border-color);
  border-top-left-radius: var(--vz-popover-inner-border-radius);
  border-top-right-radius: var(--vz-popover-inner-border-radius); }
  .popover-header:empty {
    display: none; }

.popover-body {
  padding: var(--vz-popover-body-padding-y) var(--vz-popover-body-padding-x);
  color: var(--vz-popover-body-color); }

.carousel {
  position: relative; }

.carousel.pointer-event {
  touch-action: pan-y; }

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden; }
  .carousel-inner::after {
    display: block;
    clear: both;
    content: ""; }

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-item {
      transition: none; } }

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block; }

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%); }

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%); }

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none; }

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1; }

.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-fade .active.carousel-item-start,
    .carousel-fade .active.carousel-item-end {
      transition: none; } }

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-control-prev,
    .carousel-control-next {
      transition: none; } }
  .carousel-control-prev:hover, .carousel-control-prev:focus,
  .carousel-control-next:hover,
  .carousel-control-next:focus {
    color: #fff;
    text-decoration: none;
    outline: 0;
    opacity: 0.9; }

.carousel-control-prev {
  left: 0; }

.carousel-control-next {
  right: 0; }

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%; }

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___}); }

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___}); }

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
  list-style: none; }
  .carousel-indicators [data-bs-target] {
    box-sizing: content-box;
    flex: 0 1 auto;
    width: 30px;
    height: 3px;
    padding: 0;
    margin-right: 3px;
    margin-left: 3px;
    text-indent: -999px;
    cursor: pointer;
    background-color: #fff;
    background-clip: padding-box;
    border: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    opacity: 0.5;
    transition: opacity 0.6s ease; }
    @media (prefers-reduced-motion: reduce) {
      .carousel-indicators [data-bs-target] {
        transition: none; } }
  .carousel-indicators .active {
    opacity: 1; }

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center; }

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100); }

.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000; }

.carousel-dark .carousel-caption {
  color: #000; }

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--vz-spinner-width);
  height: var(--vz-spinner-height);
  vertical-align: var(--vz-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--vz-spinner-animation-speed) linear infinite var(--vz-spinner-animation-name); }

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */; } }

.spinner-border {
  --vz-spinner-width: 2rem;
  --vz-spinner-height: 2rem;
  --vz-spinner-vertical-align: -0.125em;
  --vz-spinner-border-width: 0.25em;
  --vz-spinner-animation-speed: 0.75s;
  --vz-spinner-animation-name: spinner-border;
  border: var(--vz-spinner-border-width) solid currentcolor;
  border-right-color: transparent; }

.spinner-border-sm {
  --vz-spinner-width: 1rem;
  --vz-spinner-height: 1rem;
  --vz-spinner-border-width: 0.2em; }

@keyframes spinner-grow {
  0% {
    transform: scale(0); }
  50% {
    opacity: 1;
    transform: none; } }

.spinner-grow {
  --vz-spinner-width: 2rem;
  --vz-spinner-height: 2rem;
  --vz-spinner-vertical-align: -0.125em;
  --vz-spinner-animation-speed: 0.75s;
  --vz-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0; }

.spinner-grow-sm {
  --vz-spinner-width: 1rem;
  --vz-spinner-height: 1rem; }

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --vz-spinner-animation-speed: 1.5s; } }

.offcanvas-sm, .offcanvas-md, .offcanvas-lg, .offcanvas-xl, .offcanvas-xxl, .offcanvas {
  --vz-offcanvas-zindex: 1045;
  --vz-offcanvas-width: 400px;
  --vz-offcanvas-height: 30vh;
  --vz-offcanvas-padding-x: 1.25rem;
  --vz-offcanvas-padding-y: 1.25rem;
  --vz-offcanvas-color: ;
  --vz-offcanvas-bg: #fff;
  --vz-offcanvas-border-width: 1px;
  --vz-offcanvas-border-color: var(--vz-border-color);
  --vz-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); }

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--vz-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--vz-offcanvas-color);
    visibility: hidden;
    background-color: var(--vz-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out; } }
  @media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-sm {
      transition: none; } }

@media (max-width: 575.98px) {
    .offcanvas-sm.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--vz-offcanvas-width);
      border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-sm.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--vz-offcanvas-width);
      border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-sm.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--vz-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-sm.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--vz-offcanvas-height);
      max-height: 100%;
      border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
      transform: none; }
    .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
      visibility: visible; } }

@media (min-width: 576px) {
  .offcanvas-sm {
    --vz-offcanvas-height: auto;
    --vz-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-sm .offcanvas-header {
      display: none; }
    .offcanvas-sm .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--vz-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--vz-offcanvas-color);
    visibility: hidden;
    background-color: var(--vz-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out; } }
  @media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-md {
      transition: none; } }

@media (max-width: 767.98px) {
    .offcanvas-md.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--vz-offcanvas-width);
      border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-md.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--vz-offcanvas-width);
      border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-md.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--vz-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-md.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--vz-offcanvas-height);
      max-height: 100%;
      border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
      transform: none; }
    .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
      visibility: visible; } }

@media (min-width: 768px) {
  .offcanvas-md {
    --vz-offcanvas-height: auto;
    --vz-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-md .offcanvas-header {
      display: none; }
    .offcanvas-md .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--vz-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--vz-offcanvas-color);
    visibility: hidden;
    background-color: var(--vz-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out; } }
  @media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-lg {
      transition: none; } }

@media (max-width: 991.98px) {
    .offcanvas-lg.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--vz-offcanvas-width);
      border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-lg.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--vz-offcanvas-width);
      border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-lg.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--vz-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-lg.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--vz-offcanvas-height);
      max-height: 100%;
      border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
      transform: none; }
    .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
      visibility: visible; } }

@media (min-width: 992px) {
  .offcanvas-lg {
    --vz-offcanvas-height: auto;
    --vz-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-lg .offcanvas-header {
      display: none; }
    .offcanvas-lg .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--vz-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--vz-offcanvas-color);
    visibility: hidden;
    background-color: var(--vz-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out; } }
  @media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-xl {
      transition: none; } }

@media (max-width: 1199.98px) {
    .offcanvas-xl.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--vz-offcanvas-width);
      border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-xl.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--vz-offcanvas-width);
      border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-xl.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--vz-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-xl.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--vz-offcanvas-height);
      max-height: 100%;
      border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
      transform: none; }
    .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
      visibility: visible; } }

@media (min-width: 1200px) {
  .offcanvas-xl {
    --vz-offcanvas-height: auto;
    --vz-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-xl .offcanvas-header {
      display: none; }
    .offcanvas-xl .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--vz-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--vz-offcanvas-color);
    visibility: hidden;
    background-color: var(--vz-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out; } }
  @media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-xxl {
      transition: none; } }

@media (max-width: 1399.98px) {
    .offcanvas-xxl.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--vz-offcanvas-width);
      border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-xxl.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--vz-offcanvas-width);
      border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-xxl.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--vz-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-xxl.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--vz-offcanvas-height);
      max-height: 100%;
      border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
      transform: none; }
    .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
      visibility: visible; } }

@media (min-width: 1400px) {
  .offcanvas-xxl {
    --vz-offcanvas-height: auto;
    --vz-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-xxl .offcanvas-header {
      display: none; }
    .offcanvas-xxl .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--vz-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--vz-offcanvas-color);
  visibility: hidden;
  background-color: var(--vz-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: transform 0.3s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .offcanvas {
      transition: none; } }
  .offcanvas.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--vz-offcanvas-width);
    border-right: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(-100%); }
  .offcanvas.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--vz-offcanvas-width);
    border-left: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateX(100%); }
  .offcanvas.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(-100%); }
  .offcanvas.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--vz-offcanvas-height);
    max-height: 100%;
    border-top: var(--vz-offcanvas-border-width) solid var(--vz-offcanvas-border-color);
    transform: translateY(100%); }
  .offcanvas.showing, .offcanvas.show:not(.hiding) {
    transform: none; }
  .offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
    visibility: visible; }

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000; }
  .offcanvas-backdrop.fade {
    opacity: 0; }
  .offcanvas-backdrop.show {
    opacity: 0.5; }

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--vz-offcanvas-padding-y) var(--vz-offcanvas-padding-x); }
  .offcanvas-header .btn-close {
    padding: calc(var(--vz-offcanvas-padding-y) * .5) calc(var(--vz-offcanvas-padding-x) * .5);
    margin-top: calc(-.5 * var(--vz-offcanvas-padding-y));
    margin-right: calc(-.5 * var(--vz-offcanvas-padding-x));
    margin-bottom: calc(-.5 * var(--vz-offcanvas-padding-y)); }

.offcanvas-title {
  margin-bottom: 0;
  line-height: 1.5; }

.offcanvas-body {
  flex-grow: 1;
  padding: var(--vz-offcanvas-padding-y) var(--vz-offcanvas-padding-x);
  overflow-y: auto; }

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5; }
  .placeholder.btn::before {
    display: inline-block;
    content: ""; }

.placeholder-xs {
  min-height: .6em; }

.placeholder-sm {
  min-height: .8em; }

.placeholder-lg {
  min-height: 1.2em; }

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite; }

@keyframes placeholder-glow {
  50% {
    opacity: 0.2; } }

.placeholder-wave {
  mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite; }

@keyframes placeholder-wave {
  100% {
    mask-position: -200% 0%; } }

.clearfix::after {
  display: block;
  clear: both;
  content: ""; }

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(242, 100, 48, var(--vz-bg-opacity, 1)) !important; }

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(32, 140, 59, var(--vz-bg-opacity, 1)) !important; }

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(10, 179, 156, var(--vz-bg-opacity, 1)) !important; }

.text-bg-info {
  color: #fff !important;
  background-color: RGBA(41, 156, 219, var(--vz-bg-opacity, 1)) !important; }

.text-bg-warning {
  color: #fff !important;
  background-color: RGBA(63, 191, 72, var(--vz-bg-opacity, 1)) !important; }

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(240, 101, 72, var(--vz-bg-opacity, 1)) !important; }

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(243, 246, 249, var(--vz-bg-opacity, 1)) !important; }

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(33, 37, 41, var(--vz-bg-opacity, 1)) !important; }

.link-primary {
  color: #F26430 !important; }
  .link-primary:hover, .link-primary:focus {
    color: #c25026 !important; }

.link-secondary {
  color: #208C3B !important; }
  .link-secondary:hover, .link-secondary:focus {
    color: #1a702f !important; }

.link-success {
  color: #0ab39c !important; }
  .link-success:hover, .link-success:focus {
    color: #088f7d !important; }

.link-info {
  color: #299cdb !important; }
  .link-info:hover, .link-info:focus {
    color: #217daf !important; }

.link-warning {
  color: #3FBF48 !important; }
  .link-warning:hover, .link-warning:focus {
    color: #32993a !important; }

.link-danger {
  color: #f06548 !important; }
  .link-danger:hover, .link-danger:focus {
    color: #c0513a !important; }

.link-light {
  color: #f3f6f9 !important; }
  .link-light:hover, .link-light:focus {
    color: #f5f8fa !important; }

.link-dark {
  color: #212529 !important; }
  .link-dark:hover, .link-dark:focus {
    color: #1a1e21 !important; }

.ratio {
  position: relative;
  width: 100%; }
  .ratio::before {
    display: block;
    padding-top: var(--vz-aspect-ratio);
    content: ""; }
  .ratio > * {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%; }

.ratio-1x1 {
  --vz-aspect-ratio: 100%; }

.ratio-4x3 {
  --vz-aspect-ratio: calc(3 / 4 * 100%); }

.ratio-16x9 {
  --vz-aspect-ratio: calc(9 / 16 * 100%); }

.ratio-21x9 {
  --vz-aspect-ratio: calc(9 / 21 * 100%); }

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030; }

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030; }

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020; }

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020; }

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch; }

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch; }

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important; }

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: ""; }

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.vr {
  display: inline-block;
  align-self: stretch;
  width: 1px;
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25; }

.align-baseline {
  vertical-align: baseline !important; }

.align-top {
  vertical-align: top !important; }

.align-middle {
  vertical-align: middle !important; }

.align-bottom {
  vertical-align: bottom !important; }

.align-text-bottom {
  vertical-align: text-bottom !important; }

.align-text-top {
  vertical-align: text-top !important; }

.float-start {
  float: left !important; }

.float-end {
  float: right !important; }

.float-none {
  float: none !important; }

.opacity-0 {
  opacity: 0 !important; }

.opacity-25 {
  opacity: 0.25 !important; }

.opacity-50 {
  opacity: 0.5 !important; }

.opacity-75 {
  opacity: 0.75 !important; }

.opacity-100 {
  opacity: 1 !important; }

.overflow-auto {
  overflow: auto !important; }

.overflow-hidden {
  overflow: hidden !important; }

.overflow-visible {
  overflow: visible !important; }

.overflow-scroll {
  overflow: scroll !important; }

.d-inline {
  display: inline !important; }

.d-inline-block {
  display: inline-block !important; }

.d-block {
  display: block !important; }

.d-grid {
  display: grid !important; }

.d-table {
  display: table !important; }

.d-table-row {
  display: table-row !important; }

.d-table-cell {
  display: table-cell !important; }

.d-flex {
  display: flex !important; }

.d-inline-flex {
  display: inline-flex !important; }

.d-none {
  display: none !important; }

.shadow {
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15) !important; }

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important; }

.shadow-lg {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12) !important; }

.shadow-none {
  box-shadow: none !important; }

.position-static {
  position: static !important; }

.position-relative {
  position: relative !important; }

.position-absolute {
  position: absolute !important; }

.position-fixed {
  position: fixed !important; }

.position-sticky {
  position: sticky !important; }

.top-0 {
  top: 0 !important; }

.top-50 {
  top: 50% !important; }

.top-100 {
  top: 100% !important; }

.bottom-0 {
  bottom: 0 !important; }

.bottom-50 {
  bottom: 50% !important; }

.bottom-100 {
  bottom: 100% !important; }

.start-0 {
  left: 0 !important; }

.start-50 {
  left: 50% !important; }

.start-100 {
  left: 100% !important; }

.end-0 {
  right: 0 !important; }

.end-50 {
  right: 50% !important; }

.end-100 {
  right: 100% !important; }

.translate-middle {
  transform: translate(-50%, -50%) !important; }

.translate-middle-x {
  transform: translateX(-50%) !important; }

.translate-middle-y {
  transform: translateY(-50%) !important; }

.border {
  border: var(--vz-border-width) var(--vz-border-style) var(--vz-border-color) !important; }

.border-0 {
  border: 0 !important; }

.border-top {
  border-top: var(--vz-border-width) var(--vz-border-style) var(--vz-border-color) !important; }

.border-top-0 {
  border-top: 0 !important; }

.border-end {
  border-right: var(--vz-border-width) var(--vz-border-style) var(--vz-border-color) !important; }

.border-end-0 {
  border-right: 0 !important; }

.border-bottom {
  border-bottom: var(--vz-border-width) var(--vz-border-style) var(--vz-border-color) !important; }

.border-bottom-0 {
  border-bottom: 0 !important; }

.border-start {
  border-left: var(--vz-border-width) var(--vz-border-style) var(--vz-border-color) !important; }

.border-start-0 {
  border-left: 0 !important; }

.border-primary {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-primary-rgb), var(--vz-border-opacity)) !important; }

.border-secondary {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-secondary-rgb), var(--vz-border-opacity)) !important; }

.border-success {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-success-rgb), var(--vz-border-opacity)) !important; }

.border-info {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-info-rgb), var(--vz-border-opacity)) !important; }

.border-warning {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-warning-rgb), var(--vz-border-opacity)) !important; }

.border-danger {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-danger-rgb), var(--vz-border-opacity)) !important; }

.border-light {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-light-rgb), var(--vz-border-opacity)) !important; }

.border-dark {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-dark-rgb), var(--vz-border-opacity)) !important; }

.border-white {
  --vz-border-opacity: 1;
  border-color: rgba(var(--vz-white-rgb), var(--vz-border-opacity)) !important; }

.border-1 {
  --vz-border-width: 1px; }

.border-2 {
  --vz-border-width: 2px; }

.border-3 {
  --vz-border-width: 3px; }

.border-4 {
  --vz-border-width: 4px; }

.border-5 {
  --vz-border-width: 5px; }

.border-opacity-10 {
  --vz-border-opacity: 0.1; }

.border-opacity-25 {
  --vz-border-opacity: 0.25; }

.border-opacity-50 {
  --vz-border-opacity: 0.5; }

.border-opacity-75 {
  --vz-border-opacity: 0.75; }

.border-opacity-100 {
  --vz-border-opacity: 1; }

.w-25 {
  width: 25% !important; }

.w-50 {
  width: 50% !important; }

.w-75 {
  width: 75% !important; }

.w-100 {
  width: 100% !important; }

.w-auto {
  width: auto !important; }

.mw-100 {
  max-width: 100% !important; }

.vw-100 {
  width: 100vw !important; }

.min-vw-100 {
  min-width: 100vw !important; }

.h-25 {
  height: 25% !important; }

.h-50 {
  height: 50% !important; }

.h-75 {
  height: 75% !important; }

.h-100 {
  height: 100% !important; }

.h-auto {
  height: auto !important; }

.mh-100 {
  max-height: 100% !important; }

.vh-100 {
  height: 100vh !important; }

.min-vh-100 {
  min-height: 100vh !important; }

.flex-fill {
  flex: 1 1 auto !important; }

.flex-row {
  flex-direction: row !important; }

.flex-column {
  flex-direction: column !important; }

.flex-row-reverse {
  flex-direction: row-reverse !important; }

.flex-column-reverse {
  flex-direction: column-reverse !important; }

.flex-grow-0 {
  flex-grow: 0 !important; }

.flex-grow-1 {
  flex-grow: 1 !important; }

.flex-shrink-0 {
  flex-shrink: 0 !important; }

.flex-shrink-1 {
  flex-shrink: 1 !important; }

.flex-wrap {
  flex-wrap: wrap !important; }

.flex-nowrap {
  flex-wrap: nowrap !important; }

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important; }

.justify-content-start {
  justify-content: flex-start !important; }

.justify-content-end {
  justify-content: flex-end !important; }

.justify-content-center {
  justify-content: center !important; }

.justify-content-between {
  justify-content: space-between !important; }

.justify-content-around {
  justify-content: space-around !important; }

.justify-content-evenly {
  justify-content: space-evenly !important; }

.align-items-start {
  align-items: flex-start !important; }

.align-items-end {
  align-items: flex-end !important; }

.align-items-center {
  align-items: center !important; }

.align-items-baseline {
  align-items: baseline !important; }

.align-items-stretch {
  align-items: stretch !important; }

.align-content-start {
  align-content: flex-start !important; }

.align-content-end {
  align-content: flex-end !important; }

.align-content-center {
  align-content: center !important; }

.align-content-between {
  align-content: space-between !important; }

.align-content-around {
  align-content: space-around !important; }

.align-content-stretch {
  align-content: stretch !important; }

.align-self-auto {
  align-self: auto !important; }

.align-self-start {
  align-self: flex-start !important; }

.align-self-end {
  align-self: flex-end !important; }

.align-self-center {
  align-self: center !important; }

.align-self-baseline {
  align-self: baseline !important; }

.align-self-stretch {
  align-self: stretch !important; }

.order-first {
  order: -1 !important; }

.order-0 {
  order: 0 !important; }

.order-1 {
  order: 1 !important; }

.order-2 {
  order: 2 !important; }

.order-3 {
  order: 3 !important; }

.order-4 {
  order: 4 !important; }

.order-5 {
  order: 5 !important; }

.order-last {
  order: 6 !important; }

.m-0 {
  margin: 0 !important; }

.m-1 {
  margin: 0.25rem !important; }

.m-2 {
  margin: 0.5rem !important; }

.m-3 {
  margin: 1rem !important; }

.m-4 {
  margin: 1.5rem !important; }

.m-5 {
  margin: 3rem !important; }

.m-auto {
  margin: auto !important; }

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important; }

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important; }

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important; }

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important; }

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important; }

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important; }

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important; }

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important; }

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important; }

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important; }

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important; }

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important; }

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important; }

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important; }

.mt-0 {
  margin-top: 0 !important; }

.mt-1 {
  margin-top: 0.25rem !important; }

.mt-2 {
  margin-top: 0.5rem !important; }

.mt-3 {
  margin-top: 1rem !important; }

.mt-4 {
  margin-top: 1.5rem !important; }

.mt-5 {
  margin-top: 3rem !important; }

.mt-auto {
  margin-top: auto !important; }

.me-0 {
  margin-right: 0 !important; }

.me-1 {
  margin-right: 0.25rem !important; }

.me-2 {
  margin-right: 0.5rem !important; }

.me-3 {
  margin-right: 1rem !important; }

.me-4 {
  margin-right: 1.5rem !important; }

.me-5 {
  margin-right: 3rem !important; }

.me-auto {
  margin-right: auto !important; }

.mb-0 {
  margin-bottom: 0 !important; }

.mb-1 {
  margin-bottom: 0.25rem !important; }

.mb-2 {
  margin-bottom: 0.5rem !important; }

.mb-3 {
  margin-bottom: 1rem !important; }

.mb-4 {
  margin-bottom: 1.5rem !important; }

.mb-5 {
  margin-bottom: 3rem !important; }

.mb-auto {
  margin-bottom: auto !important; }

.ms-0 {
  margin-left: 0 !important; }

.ms-1 {
  margin-left: 0.25rem !important; }

.ms-2 {
  margin-left: 0.5rem !important; }

.ms-3 {
  margin-left: 1rem !important; }

.ms-4 {
  margin-left: 1.5rem !important; }

.ms-5 {
  margin-left: 3rem !important; }

.ms-auto {
  margin-left: auto !important; }

.m-n1 {
  margin: -0.25rem !important; }

.m-n2 {
  margin: -0.5rem !important; }

.m-n3 {
  margin: -1rem !important; }

.m-n4 {
  margin: -1.5rem !important; }

.m-n5 {
  margin: -3rem !important; }

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important; }

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important; }

.mx-n3 {
  margin-right: -1rem !important;
  margin-left: -1rem !important; }

.mx-n4 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important; }

.mx-n5 {
  margin-right: -3rem !important;
  margin-left: -3rem !important; }

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important; }

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important; }

.my-n3 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important; }

.my-n4 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important; }

.my-n5 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important; }

.mt-n1 {
  margin-top: -0.25rem !important; }

.mt-n2 {
  margin-top: -0.5rem !important; }

.mt-n3 {
  margin-top: -1rem !important; }

.mt-n4 {
  margin-top: -1.5rem !important; }

.mt-n5 {
  margin-top: -3rem !important; }

.me-n1 {
  margin-right: -0.25rem !important; }

.me-n2 {
  margin-right: -0.5rem !important; }

.me-n3 {
  margin-right: -1rem !important; }

.me-n4 {
  margin-right: -1.5rem !important; }

.me-n5 {
  margin-right: -3rem !important; }

.mb-n1 {
  margin-bottom: -0.25rem !important; }

.mb-n2 {
  margin-bottom: -0.5rem !important; }

.mb-n3 {
  margin-bottom: -1rem !important; }

.mb-n4 {
  margin-bottom: -1.5rem !important; }

.mb-n5 {
  margin-bottom: -3rem !important; }

.ms-n1 {
  margin-left: -0.25rem !important; }

.ms-n2 {
  margin-left: -0.5rem !important; }

.ms-n3 {
  margin-left: -1rem !important; }

.ms-n4 {
  margin-left: -1.5rem !important; }

.ms-n5 {
  margin-left: -3rem !important; }

.p-0 {
  padding: 0 !important; }

.p-1 {
  padding: 0.25rem !important; }

.p-2 {
  padding: 0.5rem !important; }

.p-3 {
  padding: 1rem !important; }

.p-4 {
  padding: 1.5rem !important; }

.p-5 {
  padding: 3rem !important; }

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important; }

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important; }

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important; }

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important; }

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important; }

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important; }

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important; }

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important; }

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important; }

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important; }

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important; }

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important; }

.pt-0 {
  padding-top: 0 !important; }

.pt-1 {
  padding-top: 0.25rem !important; }

.pt-2 {
  padding-top: 0.5rem !important; }

.pt-3 {
  padding-top: 1rem !important; }

.pt-4 {
  padding-top: 1.5rem !important; }

.pt-5 {
  padding-top: 3rem !important; }

.pe-0 {
  padding-right: 0 !important; }

.pe-1 {
  padding-right: 0.25rem !important; }

.pe-2 {
  padding-right: 0.5rem !important; }

.pe-3 {
  padding-right: 1rem !important; }

.pe-4 {
  padding-right: 1.5rem !important; }

.pe-5 {
  padding-right: 3rem !important; }

.pb-0 {
  padding-bottom: 0 !important; }

.pb-1 {
  padding-bottom: 0.25rem !important; }

.pb-2 {
  padding-bottom: 0.5rem !important; }

.pb-3 {
  padding-bottom: 1rem !important; }

.pb-4 {
  padding-bottom: 1.5rem !important; }

.pb-5 {
  padding-bottom: 3rem !important; }

.ps-0 {
  padding-left: 0 !important; }

.ps-1 {
  padding-left: 0.25rem !important; }

.ps-2 {
  padding-left: 0.5rem !important; }

.ps-3 {
  padding-left: 1rem !important; }

.ps-4 {
  padding-left: 1.5rem !important; }

.ps-5 {
  padding-left: 3rem !important; }

.gap-0 {
  gap: 0 !important; }

.gap-1 {
  gap: 0.25rem !important; }

.gap-2 {
  gap: 0.5rem !important; }

.gap-3 {
  gap: 1rem !important; }

.gap-4 {
  gap: 1.5rem !important; }

.gap-5 {
  gap: 3rem !important; }

.font-monospace {
  font-family: var(--vz-font-monospace) !important; }

.fs-1 {
  font-size: calc(1.32813rem + 0.9375vw) !important; }

.fs-2 {
  font-size: calc(1.2875rem + 0.45vw) !important; }

.fs-3 {
  font-size: calc(1.26719rem + 0.20625vw) !important; }

.fs-4 {
  font-size: 1.21875rem !important; }

.fs-5 {
  font-size: 1.01563rem !important; }

.fs-6 {
  font-size: 0.8125rem !important; }

.fst-italic {
  font-style: italic !important; }

.fst-normal {
  font-style: normal !important; }

.fw-light {
  font-weight: 300 !important; }

.fw-lighter {
  font-weight: lighter !important; }

.fw-normal {
  font-weight: 400 !important; }

.fw-bold {
  font-weight: 700 !important; }

.fw-semibold {
  font-weight: 600 !important; }

.fw-bolder {
  font-weight: bolder !important; }

.lh-1 {
  line-height: 1 !important; }

.lh-sm {
  line-height: 1.25 !important; }

.lh-base {
  line-height: 1.5 !important; }

.lh-lg {
  line-height: 2 !important; }

.text-start {
  text-align: left !important; }

.text-end {
  text-align: right !important; }

.text-center {
  text-align: center !important; }

.text-decoration-none {
  text-decoration: none !important; }

.text-decoration-underline {
  text-decoration: underline !important; }

.text-decoration-line-through {
  text-decoration: line-through !important; }

.text-lowercase {
  text-transform: lowercase !important; }

.text-uppercase {
  text-transform: uppercase !important; }

.text-capitalize {
  text-transform: capitalize !important; }

.text-wrap {
  white-space: normal !important; }

.text-nowrap {
  white-space: nowrap !important; }

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important; }

/* rtl:end:remove */
.text-primary {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-primary-rgb), var(--vz-text-opacity)) !important; }

.text-secondary {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-secondary-rgb), var(--vz-text-opacity)) !important; }

.text-success {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-success-rgb), var(--vz-text-opacity)) !important; }

.text-info {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-info-rgb), var(--vz-text-opacity)) !important; }

.text-warning {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-warning-rgb), var(--vz-text-opacity)) !important; }

.text-danger {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-danger-rgb), var(--vz-text-opacity)) !important; }

.text-light {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-light-rgb), var(--vz-text-opacity)) !important; }

.text-dark {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-dark-rgb), var(--vz-text-opacity)) !important; }

.text-black {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-black-rgb), var(--vz-text-opacity)) !important; }

.text-white {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-white-rgb), var(--vz-text-opacity)) !important; }

.text-body {
  --vz-text-opacity: 1;
  color: rgba(var(--vz-body-color-rgb), var(--vz-text-opacity)) !important; }

.text-muted {
  --vz-text-opacity: 1;
  color: #878a99 !important; }

.text-black-50 {
  --vz-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important; }

.text-white-50 {
  --vz-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important; }

.text-reset {
  --vz-text-opacity: 1;
  color: inherit !important; }

.text-opacity-25 {
  --vz-text-opacity: 0.25; }

.text-opacity-50 {
  --vz-text-opacity: 0.5; }

.text-opacity-75 {
  --vz-text-opacity: 0.75; }

.text-opacity-100 {
  --vz-text-opacity: 1; }

.bg-primary {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-primary-rgb), var(--vz-bg-opacity)) !important; }

.bg-secondary {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-secondary-rgb), var(--vz-bg-opacity)) !important; }

.bg-success {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-success-rgb), var(--vz-bg-opacity)) !important; }

.bg-info {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-info-rgb), var(--vz-bg-opacity)) !important; }

.bg-warning {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-warning-rgb), var(--vz-bg-opacity)) !important; }

.bg-danger {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-danger-rgb), var(--vz-bg-opacity)) !important; }

.bg-light {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-light-rgb), var(--vz-bg-opacity)) !important; }

.bg-dark {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-dark-rgb), var(--vz-bg-opacity)) !important; }

.bg-black {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-black-rgb), var(--vz-bg-opacity)) !important; }

.bg-white {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-white-rgb), var(--vz-bg-opacity)) !important; }

.bg-body {
  --vz-bg-opacity: 1;
  background-color: rgba(var(--vz-body-bg-rgb), var(--vz-bg-opacity)) !important; }

.bg-transparent {
  --vz-bg-opacity: 1;
  background-color: transparent !important; }

.bg-opacity-10 {
  --vz-bg-opacity: 0.1; }

.bg-opacity-25 {
  --vz-bg-opacity: 0.25; }

.bg-opacity-50 {
  --vz-bg-opacity: 0.5; }

.bg-opacity-75 {
  --vz-bg-opacity: 0.75; }

.bg-opacity-100 {
  --vz-bg-opacity: 1; }

.bg-gradient {
  background-image: var(--vz-gradient) !important; }

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important; }

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important; }

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important; }

.pe-none {
  pointer-events: none !important; }

.pe-auto {
  pointer-events: auto !important; }

.rounded {
  border-radius: var(--vz-border-radius) !important; }

.rounded-0 {
  border-radius: 0 !important; }

.rounded-1 {
  border-radius: var(--vz-border-radius-sm) !important; }

.rounded-2 {
  border-radius: var(--vz-border-radius) !important; }

.rounded-3 {
  border-radius: var(--vz-border-radius-lg) !important; }

.rounded-4 {
  border-radius: var(--vz-border-radius-xl) !important; }

.rounded-5 {
  border-radius: var(--vz-border-radius-2xl) !important; }

.rounded-circle {
  border-radius: 50% !important; }

.rounded-pill {
  border-radius: var(--vz-border-radius-pill) !important; }

.rounded-top {
  border-top-left-radius: var(--vz-border-radius) !important;
  border-top-right-radius: var(--vz-border-radius) !important; }

.rounded-end {
  border-top-right-radius: var(--vz-border-radius) !important;
  border-bottom-right-radius: var(--vz-border-radius) !important; }

.rounded-bottom {
  border-bottom-right-radius: var(--vz-border-radius) !important;
  border-bottom-left-radius: var(--vz-border-radius) !important; }

.rounded-start {
  border-bottom-left-radius: var(--vz-border-radius) !important;
  border-top-left-radius: var(--vz-border-radius) !important; }

.visible {
  visibility: visible !important; }

.invisible {
  visibility: hidden !important; }

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important; }
  .float-sm-end {
    float: right !important; }
  .float-sm-none {
    float: none !important; }
  .d-sm-inline {
    display: inline !important; }
  .d-sm-inline-block {
    display: inline-block !important; }
  .d-sm-block {
    display: block !important; }
  .d-sm-grid {
    display: grid !important; }
  .d-sm-table {
    display: table !important; }
  .d-sm-table-row {
    display: table-row !important; }
  .d-sm-table-cell {
    display: table-cell !important; }
  .d-sm-flex {
    display: flex !important; }
  .d-sm-inline-flex {
    display: inline-flex !important; }
  .d-sm-none {
    display: none !important; }
  .flex-sm-fill {
    flex: 1 1 auto !important; }
  .flex-sm-row {
    flex-direction: row !important; }
  .flex-sm-column {
    flex-direction: column !important; }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-sm-grow-0 {
    flex-grow: 0 !important; }
  .flex-sm-grow-1 {
    flex-grow: 1 !important; }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-sm-wrap {
    flex-wrap: wrap !important; }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important; }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-sm-start {
    justify-content: flex-start !important; }
  .justify-content-sm-end {
    justify-content: flex-end !important; }
  .justify-content-sm-center {
    justify-content: center !important; }
  .justify-content-sm-between {
    justify-content: space-between !important; }
  .justify-content-sm-around {
    justify-content: space-around !important; }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important; }
  .align-items-sm-start {
    align-items: flex-start !important; }
  .align-items-sm-end {
    align-items: flex-end !important; }
  .align-items-sm-center {
    align-items: center !important; }
  .align-items-sm-baseline {
    align-items: baseline !important; }
  .align-items-sm-stretch {
    align-items: stretch !important; }
  .align-content-sm-start {
    align-content: flex-start !important; }
  .align-content-sm-end {
    align-content: flex-end !important; }
  .align-content-sm-center {
    align-content: center !important; }
  .align-content-sm-between {
    align-content: space-between !important; }
  .align-content-sm-around {
    align-content: space-around !important; }
  .align-content-sm-stretch {
    align-content: stretch !important; }
  .align-self-sm-auto {
    align-self: auto !important; }
  .align-self-sm-start {
    align-self: flex-start !important; }
  .align-self-sm-end {
    align-self: flex-end !important; }
  .align-self-sm-center {
    align-self: center !important; }
  .align-self-sm-baseline {
    align-self: baseline !important; }
  .align-self-sm-stretch {
    align-self: stretch !important; }
  .order-sm-first {
    order: -1 !important; }
  .order-sm-0 {
    order: 0 !important; }
  .order-sm-1 {
    order: 1 !important; }
  .order-sm-2 {
    order: 2 !important; }
  .order-sm-3 {
    order: 3 !important; }
  .order-sm-4 {
    order: 4 !important; }
  .order-sm-5 {
    order: 5 !important; }
  .order-sm-last {
    order: 6 !important; }
  .m-sm-0 {
    margin: 0 !important; }
  .m-sm-1 {
    margin: 0.25rem !important; }
  .m-sm-2 {
    margin: 0.5rem !important; }
  .m-sm-3 {
    margin: 1rem !important; }
  .m-sm-4 {
    margin: 1.5rem !important; }
  .m-sm-5 {
    margin: 3rem !important; }
  .m-sm-auto {
    margin: auto !important; }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-sm-0 {
    margin-top: 0 !important; }
  .mt-sm-1 {
    margin-top: 0.25rem !important; }
  .mt-sm-2 {
    margin-top: 0.5rem !important; }
  .mt-sm-3 {
    margin-top: 1rem !important; }
  .mt-sm-4 {
    margin-top: 1.5rem !important; }
  .mt-sm-5 {
    margin-top: 3rem !important; }
  .mt-sm-auto {
    margin-top: auto !important; }
  .me-sm-0 {
    margin-right: 0 !important; }
  .me-sm-1 {
    margin-right: 0.25rem !important; }
  .me-sm-2 {
    margin-right: 0.5rem !important; }
  .me-sm-3 {
    margin-right: 1rem !important; }
  .me-sm-4 {
    margin-right: 1.5rem !important; }
  .me-sm-5 {
    margin-right: 3rem !important; }
  .me-sm-auto {
    margin-right: auto !important; }
  .mb-sm-0 {
    margin-bottom: 0 !important; }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important; }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important; }
  .mb-sm-3 {
    margin-bottom: 1rem !important; }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important; }
  .mb-sm-5 {
    margin-bottom: 3rem !important; }
  .mb-sm-auto {
    margin-bottom: auto !important; }
  .ms-sm-0 {
    margin-left: 0 !important; }
  .ms-sm-1 {
    margin-left: 0.25rem !important; }
  .ms-sm-2 {
    margin-left: 0.5rem !important; }
  .ms-sm-3 {
    margin-left: 1rem !important; }
  .ms-sm-4 {
    margin-left: 1.5rem !important; }
  .ms-sm-5 {
    margin-left: 3rem !important; }
  .ms-sm-auto {
    margin-left: auto !important; }
  .m-sm-n1 {
    margin: -0.25rem !important; }
  .m-sm-n2 {
    margin: -0.5rem !important; }
  .m-sm-n3 {
    margin: -1rem !important; }
  .m-sm-n4 {
    margin: -1.5rem !important; }
  .m-sm-n5 {
    margin: -3rem !important; }
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important; }
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important; }
  .mx-sm-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important; }
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important; }
  .mx-sm-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important; }
  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important; }
  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important; }
  .my-sm-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important; }
  .my-sm-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important; }
  .my-sm-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important; }
  .mt-sm-n1 {
    margin-top: -0.25rem !important; }
  .mt-sm-n2 {
    margin-top: -0.5rem !important; }
  .mt-sm-n3 {
    margin-top: -1rem !important; }
  .mt-sm-n4 {
    margin-top: -1.5rem !important; }
  .mt-sm-n5 {
    margin-top: -3rem !important; }
  .me-sm-n1 {
    margin-right: -0.25rem !important; }
  .me-sm-n2 {
    margin-right: -0.5rem !important; }
  .me-sm-n3 {
    margin-right: -1rem !important; }
  .me-sm-n4 {
    margin-right: -1.5rem !important; }
  .me-sm-n5 {
    margin-right: -3rem !important; }
  .mb-sm-n1 {
    margin-bottom: -0.25rem !important; }
  .mb-sm-n2 {
    margin-bottom: -0.5rem !important; }
  .mb-sm-n3 {
    margin-bottom: -1rem !important; }
  .mb-sm-n4 {
    margin-bottom: -1.5rem !important; }
  .mb-sm-n5 {
    margin-bottom: -3rem !important; }
  .ms-sm-n1 {
    margin-left: -0.25rem !important; }
  .ms-sm-n2 {
    margin-left: -0.5rem !important; }
  .ms-sm-n3 {
    margin-left: -1rem !important; }
  .ms-sm-n4 {
    margin-left: -1.5rem !important; }
  .ms-sm-n5 {
    margin-left: -3rem !important; }
  .p-sm-0 {
    padding: 0 !important; }
  .p-sm-1 {
    padding: 0.25rem !important; }
  .p-sm-2 {
    padding: 0.5rem !important; }
  .p-sm-3 {
    padding: 1rem !important; }
  .p-sm-4 {
    padding: 1.5rem !important; }
  .p-sm-5 {
    padding: 3rem !important; }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-sm-0 {
    padding-top: 0 !important; }
  .pt-sm-1 {
    padding-top: 0.25rem !important; }
  .pt-sm-2 {
    padding-top: 0.5rem !important; }
  .pt-sm-3 {
    padding-top: 1rem !important; }
  .pt-sm-4 {
    padding-top: 1.5rem !important; }
  .pt-sm-5 {
    padding-top: 3rem !important; }
  .pe-sm-0 {
    padding-right: 0 !important; }
  .pe-sm-1 {
    padding-right: 0.25rem !important; }
  .pe-sm-2 {
    padding-right: 0.5rem !important; }
  .pe-sm-3 {
    padding-right: 1rem !important; }
  .pe-sm-4 {
    padding-right: 1.5rem !important; }
  .pe-sm-5 {
    padding-right: 3rem !important; }
  .pb-sm-0 {
    padding-bottom: 0 !important; }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important; }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important; }
  .pb-sm-3 {
    padding-bottom: 1rem !important; }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important; }
  .pb-sm-5 {
    padding-bottom: 3rem !important; }
  .ps-sm-0 {
    padding-left: 0 !important; }
  .ps-sm-1 {
    padding-left: 0.25rem !important; }
  .ps-sm-2 {
    padding-left: 0.5rem !important; }
  .ps-sm-3 {
    padding-left: 1rem !important; }
  .ps-sm-4 {
    padding-left: 1.5rem !important; }
  .ps-sm-5 {
    padding-left: 3rem !important; }
  .gap-sm-0 {
    gap: 0 !important; }
  .gap-sm-1 {
    gap: 0.25rem !important; }
  .gap-sm-2 {
    gap: 0.5rem !important; }
  .gap-sm-3 {
    gap: 1rem !important; }
  .gap-sm-4 {
    gap: 1.5rem !important; }
  .gap-sm-5 {
    gap: 3rem !important; }
  .text-sm-start {
    text-align: left !important; }
  .text-sm-end {
    text-align: right !important; }
  .text-sm-center {
    text-align: center !important; } }

@media (min-width: 768px) {
  .float-md-start {
    float: left !important; }
  .float-md-end {
    float: right !important; }
  .float-md-none {
    float: none !important; }
  .d-md-inline {
    display: inline !important; }
  .d-md-inline-block {
    display: inline-block !important; }
  .d-md-block {
    display: block !important; }
  .d-md-grid {
    display: grid !important; }
  .d-md-table {
    display: table !important; }
  .d-md-table-row {
    display: table-row !important; }
  .d-md-table-cell {
    display: table-cell !important; }
  .d-md-flex {
    display: flex !important; }
  .d-md-inline-flex {
    display: inline-flex !important; }
  .d-md-none {
    display: none !important; }
  .flex-md-fill {
    flex: 1 1 auto !important; }
  .flex-md-row {
    flex-direction: row !important; }
  .flex-md-column {
    flex-direction: column !important; }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-md-grow-0 {
    flex-grow: 0 !important; }
  .flex-md-grow-1 {
    flex-grow: 1 !important; }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-md-wrap {
    flex-wrap: wrap !important; }
  .flex-md-nowrap {
    flex-wrap: nowrap !important; }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-md-start {
    justify-content: flex-start !important; }
  .justify-content-md-end {
    justify-content: flex-end !important; }
  .justify-content-md-center {
    justify-content: center !important; }
  .justify-content-md-between {
    justify-content: space-between !important; }
  .justify-content-md-around {
    justify-content: space-around !important; }
  .justify-content-md-evenly {
    justify-content: space-evenly !important; }
  .align-items-md-start {
    align-items: flex-start !important; }
  .align-items-md-end {
    align-items: flex-end !important; }
  .align-items-md-center {
    align-items: center !important; }
  .align-items-md-baseline {
    align-items: baseline !important; }
  .align-items-md-stretch {
    align-items: stretch !important; }
  .align-content-md-start {
    align-content: flex-start !important; }
  .align-content-md-end {
    align-content: flex-end !important; }
  .align-content-md-center {
    align-content: center !important; }
  .align-content-md-between {
    align-content: space-between !important; }
  .align-content-md-around {
    align-content: space-around !important; }
  .align-content-md-stretch {
    align-content: stretch !important; }
  .align-self-md-auto {
    align-self: auto !important; }
  .align-self-md-start {
    align-self: flex-start !important; }
  .align-self-md-end {
    align-self: flex-end !important; }
  .align-self-md-center {
    align-self: center !important; }
  .align-self-md-baseline {
    align-self: baseline !important; }
  .align-self-md-stretch {
    align-self: stretch !important; }
  .order-md-first {
    order: -1 !important; }
  .order-md-0 {
    order: 0 !important; }
  .order-md-1 {
    order: 1 !important; }
  .order-md-2 {
    order: 2 !important; }
  .order-md-3 {
    order: 3 !important; }
  .order-md-4 {
    order: 4 !important; }
  .order-md-5 {
    order: 5 !important; }
  .order-md-last {
    order: 6 !important; }
  .m-md-0 {
    margin: 0 !important; }
  .m-md-1 {
    margin: 0.25rem !important; }
  .m-md-2 {
    margin: 0.5rem !important; }
  .m-md-3 {
    margin: 1rem !important; }
  .m-md-4 {
    margin: 1.5rem !important; }
  .m-md-5 {
    margin: 3rem !important; }
  .m-md-auto {
    margin: auto !important; }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-md-0 {
    margin-top: 0 !important; }
  .mt-md-1 {
    margin-top: 0.25rem !important; }
  .mt-md-2 {
    margin-top: 0.5rem !important; }
  .mt-md-3 {
    margin-top: 1rem !important; }
  .mt-md-4 {
    margin-top: 1.5rem !important; }
  .mt-md-5 {
    margin-top: 3rem !important; }
  .mt-md-auto {
    margin-top: auto !important; }
  .me-md-0 {
    margin-right: 0 !important; }
  .me-md-1 {
    margin-right: 0.25rem !important; }
  .me-md-2 {
    margin-right: 0.5rem !important; }
  .me-md-3 {
    margin-right: 1rem !important; }
  .me-md-4 {
    margin-right: 1.5rem !important; }
  .me-md-5 {
    margin-right: 3rem !important; }
  .me-md-auto {
    margin-right: auto !important; }
  .mb-md-0 {
    margin-bottom: 0 !important; }
  .mb-md-1 {
    margin-bottom: 0.25rem !important; }
  .mb-md-2 {
    margin-bottom: 0.5rem !important; }
  .mb-md-3 {
    margin-bottom: 1rem !important; }
  .mb-md-4 {
    margin-bottom: 1.5rem !important; }
  .mb-md-5 {
    margin-bottom: 3rem !important; }
  .mb-md-auto {
    margin-bottom: auto !important; }
  .ms-md-0 {
    margin-left: 0 !important; }
  .ms-md-1 {
    margin-left: 0.25rem !important; }
  .ms-md-2 {
    margin-left: 0.5rem !important; }
  .ms-md-3 {
    margin-left: 1rem !important; }
  .ms-md-4 {
    margin-left: 1.5rem !important; }
  .ms-md-5 {
    margin-left: 3rem !important; }
  .ms-md-auto {
    margin-left: auto !important; }
  .m-md-n1 {
    margin: -0.25rem !important; }
  .m-md-n2 {
    margin: -0.5rem !important; }
  .m-md-n3 {
    margin: -1rem !important; }
  .m-md-n4 {
    margin: -1.5rem !important; }
  .m-md-n5 {
    margin: -3rem !important; }
  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important; }
  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important; }
  .mx-md-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important; }
  .mx-md-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important; }
  .mx-md-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important; }
  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important; }
  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important; }
  .my-md-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important; }
  .my-md-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important; }
  .my-md-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important; }
  .mt-md-n1 {
    margin-top: -0.25rem !important; }
  .mt-md-n2 {
    margin-top: -0.5rem !important; }
  .mt-md-n3 {
    margin-top: -1rem !important; }
  .mt-md-n4 {
    margin-top: -1.5rem !important; }
  .mt-md-n5 {
    margin-top: -3rem !important; }
  .me-md-n1 {
    margin-right: -0.25rem !important; }
  .me-md-n2 {
    margin-right: -0.5rem !important; }
  .me-md-n3 {
    margin-right: -1rem !important; }
  .me-md-n4 {
    margin-right: -1.5rem !important; }
  .me-md-n5 {
    margin-right: -3rem !important; }
  .mb-md-n1 {
    margin-bottom: -0.25rem !important; }
  .mb-md-n2 {
    margin-bottom: -0.5rem !important; }
  .mb-md-n3 {
    margin-bottom: -1rem !important; }
  .mb-md-n4 {
    margin-bottom: -1.5rem !important; }
  .mb-md-n5 {
    margin-bottom: -3rem !important; }
  .ms-md-n1 {
    margin-left: -0.25rem !important; }
  .ms-md-n2 {
    margin-left: -0.5rem !important; }
  .ms-md-n3 {
    margin-left: -1rem !important; }
  .ms-md-n4 {
    margin-left: -1.5rem !important; }
  .ms-md-n5 {
    margin-left: -3rem !important; }
  .p-md-0 {
    padding: 0 !important; }
  .p-md-1 {
    padding: 0.25rem !important; }
  .p-md-2 {
    padding: 0.5rem !important; }
  .p-md-3 {
    padding: 1rem !important; }
  .p-md-4 {
    padding: 1.5rem !important; }
  .p-md-5 {
    padding: 3rem !important; }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-md-0 {
    padding-top: 0 !important; }
  .pt-md-1 {
    padding-top: 0.25rem !important; }
  .pt-md-2 {
    padding-top: 0.5rem !important; }
  .pt-md-3 {
    padding-top: 1rem !important; }
  .pt-md-4 {
    padding-top: 1.5rem !important; }
  .pt-md-5 {
    padding-top: 3rem !important; }
  .pe-md-0 {
    padding-right: 0 !important; }
  .pe-md-1 {
    padding-right: 0.25rem !important; }
  .pe-md-2 {
    padding-right: 0.5rem !important; }
  .pe-md-3 {
    padding-right: 1rem !important; }
  .pe-md-4 {
    padding-right: 1.5rem !important; }
  .pe-md-5 {
    padding-right: 3rem !important; }
  .pb-md-0 {
    padding-bottom: 0 !important; }
  .pb-md-1 {
    padding-bottom: 0.25rem !important; }
  .pb-md-2 {
    padding-bottom: 0.5rem !important; }
  .pb-md-3 {
    padding-bottom: 1rem !important; }
  .pb-md-4 {
    padding-bottom: 1.5rem !important; }
  .pb-md-5 {
    padding-bottom: 3rem !important; }
  .ps-md-0 {
    padding-left: 0 !important; }
  .ps-md-1 {
    padding-left: 0.25rem !important; }
  .ps-md-2 {
    padding-left: 0.5rem !important; }
  .ps-md-3 {
    padding-left: 1rem !important; }
  .ps-md-4 {
    padding-left: 1.5rem !important; }
  .ps-md-5 {
    padding-left: 3rem !important; }
  .gap-md-0 {
    gap: 0 !important; }
  .gap-md-1 {
    gap: 0.25rem !important; }
  .gap-md-2 {
    gap: 0.5rem !important; }
  .gap-md-3 {
    gap: 1rem !important; }
  .gap-md-4 {
    gap: 1.5rem !important; }
  .gap-md-5 {
    gap: 3rem !important; }
  .text-md-start {
    text-align: left !important; }
  .text-md-end {
    text-align: right !important; }
  .text-md-center {
    text-align: center !important; } }

@media (min-width: 992px) {
  .float-lg-start {
    float: left !important; }
  .float-lg-end {
    float: right !important; }
  .float-lg-none {
    float: none !important; }
  .d-lg-inline {
    display: inline !important; }
  .d-lg-inline-block {
    display: inline-block !important; }
  .d-lg-block {
    display: block !important; }
  .d-lg-grid {
    display: grid !important; }
  .d-lg-table {
    display: table !important; }
  .d-lg-table-row {
    display: table-row !important; }
  .d-lg-table-cell {
    display: table-cell !important; }
  .d-lg-flex {
    display: flex !important; }
  .d-lg-inline-flex {
    display: inline-flex !important; }
  .d-lg-none {
    display: none !important; }
  .flex-lg-fill {
    flex: 1 1 auto !important; }
  .flex-lg-row {
    flex-direction: row !important; }
  .flex-lg-column {
    flex-direction: column !important; }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-lg-grow-0 {
    flex-grow: 0 !important; }
  .flex-lg-grow-1 {
    flex-grow: 1 !important; }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-lg-wrap {
    flex-wrap: wrap !important; }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important; }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-lg-start {
    justify-content: flex-start !important; }
  .justify-content-lg-end {
    justify-content: flex-end !important; }
  .justify-content-lg-center {
    justify-content: center !important; }
  .justify-content-lg-between {
    justify-content: space-between !important; }
  .justify-content-lg-around {
    justify-content: space-around !important; }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important; }
  .align-items-lg-start {
    align-items: flex-start !important; }
  .align-items-lg-end {
    align-items: flex-end !important; }
  .align-items-lg-center {
    align-items: center !important; }
  .align-items-lg-baseline {
    align-items: baseline !important; }
  .align-items-lg-stretch {
    align-items: stretch !important; }
  .align-content-lg-start {
    align-content: flex-start !important; }
  .align-content-lg-end {
    align-content: flex-end !important; }
  .align-content-lg-center {
    align-content: center !important; }
  .align-content-lg-between {
    align-content: space-between !important; }
  .align-content-lg-around {
    align-content: space-around !important; }
  .align-content-lg-stretch {
    align-content: stretch !important; }
  .align-self-lg-auto {
    align-self: auto !important; }
  .align-self-lg-start {
    align-self: flex-start !important; }
  .align-self-lg-end {
    align-self: flex-end !important; }
  .align-self-lg-center {
    align-self: center !important; }
  .align-self-lg-baseline {
    align-self: baseline !important; }
  .align-self-lg-stretch {
    align-self: stretch !important; }
  .order-lg-first {
    order: -1 !important; }
  .order-lg-0 {
    order: 0 !important; }
  .order-lg-1 {
    order: 1 !important; }
  .order-lg-2 {
    order: 2 !important; }
  .order-lg-3 {
    order: 3 !important; }
  .order-lg-4 {
    order: 4 !important; }
  .order-lg-5 {
    order: 5 !important; }
  .order-lg-last {
    order: 6 !important; }
  .m-lg-0 {
    margin: 0 !important; }
  .m-lg-1 {
    margin: 0.25rem !important; }
  .m-lg-2 {
    margin: 0.5rem !important; }
  .m-lg-3 {
    margin: 1rem !important; }
  .m-lg-4 {
    margin: 1.5rem !important; }
  .m-lg-5 {
    margin: 3rem !important; }
  .m-lg-auto {
    margin: auto !important; }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-lg-0 {
    margin-top: 0 !important; }
  .mt-lg-1 {
    margin-top: 0.25rem !important; }
  .mt-lg-2 {
    margin-top: 0.5rem !important; }
  .mt-lg-3 {
    margin-top: 1rem !important; }
  .mt-lg-4 {
    margin-top: 1.5rem !important; }
  .mt-lg-5 {
    margin-top: 3rem !important; }
  .mt-lg-auto {
    margin-top: auto !important; }
  .me-lg-0 {
    margin-right: 0 !important; }
  .me-lg-1 {
    margin-right: 0.25rem !important; }
  .me-lg-2 {
    margin-right: 0.5rem !important; }
  .me-lg-3 {
    margin-right: 1rem !important; }
  .me-lg-4 {
    margin-right: 1.5rem !important; }
  .me-lg-5 {
    margin-right: 3rem !important; }
  .me-lg-auto {
    margin-right: auto !important; }
  .mb-lg-0 {
    margin-bottom: 0 !important; }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important; }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important; }
  .mb-lg-3 {
    margin-bottom: 1rem !important; }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important; }
  .mb-lg-5 {
    margin-bottom: 3rem !important; }
  .mb-lg-auto {
    margin-bottom: auto !important; }
  .ms-lg-0 {
    margin-left: 0 !important; }
  .ms-lg-1 {
    margin-left: 0.25rem !important; }
  .ms-lg-2 {
    margin-left: 0.5rem !important; }
  .ms-lg-3 {
    margin-left: 1rem !important; }
  .ms-lg-4 {
    margin-left: 1.5rem !important; }
  .ms-lg-5 {
    margin-left: 3rem !important; }
  .ms-lg-auto {
    margin-left: auto !important; }
  .m-lg-n1 {
    margin: -0.25rem !important; }
  .m-lg-n2 {
    margin: -0.5rem !important; }
  .m-lg-n3 {
    margin: -1rem !important; }
  .m-lg-n4 {
    margin: -1.5rem !important; }
  .m-lg-n5 {
    margin: -3rem !important; }
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important; }
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important; }
  .mx-lg-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important; }
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important; }
  .mx-lg-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important; }
  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important; }
  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important; }
  .my-lg-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important; }
  .my-lg-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important; }
  .my-lg-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important; }
  .mt-lg-n1 {
    margin-top: -0.25rem !important; }
  .mt-lg-n2 {
    margin-top: -0.5rem !important; }
  .mt-lg-n3 {
    margin-top: -1rem !important; }
  .mt-lg-n4 {
    margin-top: -1.5rem !important; }
  .mt-lg-n5 {
    margin-top: -3rem !important; }
  .me-lg-n1 {
    margin-right: -0.25rem !important; }
  .me-lg-n2 {
    margin-right: -0.5rem !important; }
  .me-lg-n3 {
    margin-right: -1rem !important; }
  .me-lg-n4 {
    margin-right: -1.5rem !important; }
  .me-lg-n5 {
    margin-right: -3rem !important; }
  .mb-lg-n1 {
    margin-bottom: -0.25rem !important; }
  .mb-lg-n2 {
    margin-bottom: -0.5rem !important; }
  .mb-lg-n3 {
    margin-bottom: -1rem !important; }
  .mb-lg-n4 {
    margin-bottom: -1.5rem !important; }
  .mb-lg-n5 {
    margin-bottom: -3rem !important; }
  .ms-lg-n1 {
    margin-left: -0.25rem !important; }
  .ms-lg-n2 {
    margin-left: -0.5rem !important; }
  .ms-lg-n3 {
    margin-left: -1rem !important; }
  .ms-lg-n4 {
    margin-left: -1.5rem !important; }
  .ms-lg-n5 {
    margin-left: -3rem !important; }
  .p-lg-0 {
    padding: 0 !important; }
  .p-lg-1 {
    padding: 0.25rem !important; }
  .p-lg-2 {
    padding: 0.5rem !important; }
  .p-lg-3 {
    padding: 1rem !important; }
  .p-lg-4 {
    padding: 1.5rem !important; }
  .p-lg-5 {
    padding: 3rem !important; }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-lg-0 {
    padding-top: 0 !important; }
  .pt-lg-1 {
    padding-top: 0.25rem !important; }
  .pt-lg-2 {
    padding-top: 0.5rem !important; }
  .pt-lg-3 {
    padding-top: 1rem !important; }
  .pt-lg-4 {
    padding-top: 1.5rem !important; }
  .pt-lg-5 {
    padding-top: 3rem !important; }
  .pe-lg-0 {
    padding-right: 0 !important; }
  .pe-lg-1 {
    padding-right: 0.25rem !important; }
  .pe-lg-2 {
    padding-right: 0.5rem !important; }
  .pe-lg-3 {
    padding-right: 1rem !important; }
  .pe-lg-4 {
    padding-right: 1.5rem !important; }
  .pe-lg-5 {
    padding-right: 3rem !important; }
  .pb-lg-0 {
    padding-bottom: 0 !important; }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important; }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important; }
  .pb-lg-3 {
    padding-bottom: 1rem !important; }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important; }
  .pb-lg-5 {
    padding-bottom: 3rem !important; }
  .ps-lg-0 {
    padding-left: 0 !important; }
  .ps-lg-1 {
    padding-left: 0.25rem !important; }
  .ps-lg-2 {
    padding-left: 0.5rem !important; }
  .ps-lg-3 {
    padding-left: 1rem !important; }
  .ps-lg-4 {
    padding-left: 1.5rem !important; }
  .ps-lg-5 {
    padding-left: 3rem !important; }
  .gap-lg-0 {
    gap: 0 !important; }
  .gap-lg-1 {
    gap: 0.25rem !important; }
  .gap-lg-2 {
    gap: 0.5rem !important; }
  .gap-lg-3 {
    gap: 1rem !important; }
  .gap-lg-4 {
    gap: 1.5rem !important; }
  .gap-lg-5 {
    gap: 3rem !important; }
  .text-lg-start {
    text-align: left !important; }
  .text-lg-end {
    text-align: right !important; }
  .text-lg-center {
    text-align: center !important; } }

@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important; }
  .float-xl-end {
    float: right !important; }
  .float-xl-none {
    float: none !important; }
  .d-xl-inline {
    display: inline !important; }
  .d-xl-inline-block {
    display: inline-block !important; }
  .d-xl-block {
    display: block !important; }
  .d-xl-grid {
    display: grid !important; }
  .d-xl-table {
    display: table !important; }
  .d-xl-table-row {
    display: table-row !important; }
  .d-xl-table-cell {
    display: table-cell !important; }
  .d-xl-flex {
    display: flex !important; }
  .d-xl-inline-flex {
    display: inline-flex !important; }
  .d-xl-none {
    display: none !important; }
  .flex-xl-fill {
    flex: 1 1 auto !important; }
  .flex-xl-row {
    flex-direction: row !important; }
  .flex-xl-column {
    flex-direction: column !important; }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-xl-grow-0 {
    flex-grow: 0 !important; }
  .flex-xl-grow-1 {
    flex-grow: 1 !important; }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-xl-wrap {
    flex-wrap: wrap !important; }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important; }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-xl-start {
    justify-content: flex-start !important; }
  .justify-content-xl-end {
    justify-content: flex-end !important; }
  .justify-content-xl-center {
    justify-content: center !important; }
  .justify-content-xl-between {
    justify-content: space-between !important; }
  .justify-content-xl-around {
    justify-content: space-around !important; }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important; }
  .align-items-xl-start {
    align-items: flex-start !important; }
  .align-items-xl-end {
    align-items: flex-end !important; }
  .align-items-xl-center {
    align-items: center !important; }
  .align-items-xl-baseline {
    align-items: baseline !important; }
  .align-items-xl-stretch {
    align-items: stretch !important; }
  .align-content-xl-start {
    align-content: flex-start !important; }
  .align-content-xl-end {
    align-content: flex-end !important; }
  .align-content-xl-center {
    align-content: center !important; }
  .align-content-xl-between {
    align-content: space-between !important; }
  .align-content-xl-around {
    align-content: space-around !important; }
  .align-content-xl-stretch {
    align-content: stretch !important; }
  .align-self-xl-auto {
    align-self: auto !important; }
  .align-self-xl-start {
    align-self: flex-start !important; }
  .align-self-xl-end {
    align-self: flex-end !important; }
  .align-self-xl-center {
    align-self: center !important; }
  .align-self-xl-baseline {
    align-self: baseline !important; }
  .align-self-xl-stretch {
    align-self: stretch !important; }
  .order-xl-first {
    order: -1 !important; }
  .order-xl-0 {
    order: 0 !important; }
  .order-xl-1 {
    order: 1 !important; }
  .order-xl-2 {
    order: 2 !important; }
  .order-xl-3 {
    order: 3 !important; }
  .order-xl-4 {
    order: 4 !important; }
  .order-xl-5 {
    order: 5 !important; }
  .order-xl-last {
    order: 6 !important; }
  .m-xl-0 {
    margin: 0 !important; }
  .m-xl-1 {
    margin: 0.25rem !important; }
  .m-xl-2 {
    margin: 0.5rem !important; }
  .m-xl-3 {
    margin: 1rem !important; }
  .m-xl-4 {
    margin: 1.5rem !important; }
  .m-xl-5 {
    margin: 3rem !important; }
  .m-xl-auto {
    margin: auto !important; }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-xl-0 {
    margin-top: 0 !important; }
  .mt-xl-1 {
    margin-top: 0.25rem !important; }
  .mt-xl-2 {
    margin-top: 0.5rem !important; }
  .mt-xl-3 {
    margin-top: 1rem !important; }
  .mt-xl-4 {
    margin-top: 1.5rem !important; }
  .mt-xl-5 {
    margin-top: 3rem !important; }
  .mt-xl-auto {
    margin-top: auto !important; }
  .me-xl-0 {
    margin-right: 0 !important; }
  .me-xl-1 {
    margin-right: 0.25rem !important; }
  .me-xl-2 {
    margin-right: 0.5rem !important; }
  .me-xl-3 {
    margin-right: 1rem !important; }
  .me-xl-4 {
    margin-right: 1.5rem !important; }
  .me-xl-5 {
    margin-right: 3rem !important; }
  .me-xl-auto {
    margin-right: auto !important; }
  .mb-xl-0 {
    margin-bottom: 0 !important; }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important; }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important; }
  .mb-xl-3 {
    margin-bottom: 1rem !important; }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important; }
  .mb-xl-5 {
    margin-bottom: 3rem !important; }
  .mb-xl-auto {
    margin-bottom: auto !important; }
  .ms-xl-0 {
    margin-left: 0 !important; }
  .ms-xl-1 {
    margin-left: 0.25rem !important; }
  .ms-xl-2 {
    margin-left: 0.5rem !important; }
  .ms-xl-3 {
    margin-left: 1rem !important; }
  .ms-xl-4 {
    margin-left: 1.5rem !important; }
  .ms-xl-5 {
    margin-left: 3rem !important; }
  .ms-xl-auto {
    margin-left: auto !important; }
  .m-xl-n1 {
    margin: -0.25rem !important; }
  .m-xl-n2 {
    margin: -0.5rem !important; }
  .m-xl-n3 {
    margin: -1rem !important; }
  .m-xl-n4 {
    margin: -1.5rem !important; }
  .m-xl-n5 {
    margin: -3rem !important; }
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important; }
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important; }
  .mx-xl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important; }
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important; }
  .mx-xl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important; }
  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important; }
  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important; }
  .my-xl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important; }
  .my-xl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important; }
  .my-xl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important; }
  .mt-xl-n1 {
    margin-top: -0.25rem !important; }
  .mt-xl-n2 {
    margin-top: -0.5rem !important; }
  .mt-xl-n3 {
    margin-top: -1rem !important; }
  .mt-xl-n4 {
    margin-top: -1.5rem !important; }
  .mt-xl-n5 {
    margin-top: -3rem !important; }
  .me-xl-n1 {
    margin-right: -0.25rem !important; }
  .me-xl-n2 {
    margin-right: -0.5rem !important; }
  .me-xl-n3 {
    margin-right: -1rem !important; }
  .me-xl-n4 {
    margin-right: -1.5rem !important; }
  .me-xl-n5 {
    margin-right: -3rem !important; }
  .mb-xl-n1 {
    margin-bottom: -0.25rem !important; }
  .mb-xl-n2 {
    margin-bottom: -0.5rem !important; }
  .mb-xl-n3 {
    margin-bottom: -1rem !important; }
  .mb-xl-n4 {
    margin-bottom: -1.5rem !important; }
  .mb-xl-n5 {
    margin-bottom: -3rem !important; }
  .ms-xl-n1 {
    margin-left: -0.25rem !important; }
  .ms-xl-n2 {
    margin-left: -0.5rem !important; }
  .ms-xl-n3 {
    margin-left: -1rem !important; }
  .ms-xl-n4 {
    margin-left: -1.5rem !important; }
  .ms-xl-n5 {
    margin-left: -3rem !important; }
  .p-xl-0 {
    padding: 0 !important; }
  .p-xl-1 {
    padding: 0.25rem !important; }
  .p-xl-2 {
    padding: 0.5rem !important; }
  .p-xl-3 {
    padding: 1rem !important; }
  .p-xl-4 {
    padding: 1.5rem !important; }
  .p-xl-5 {
    padding: 3rem !important; }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-xl-0 {
    padding-top: 0 !important; }
  .pt-xl-1 {
    padding-top: 0.25rem !important; }
  .pt-xl-2 {
    padding-top: 0.5rem !important; }
  .pt-xl-3 {
    padding-top: 1rem !important; }
  .pt-xl-4 {
    padding-top: 1.5rem !important; }
  .pt-xl-5 {
    padding-top: 3rem !important; }
  .pe-xl-0 {
    padding-right: 0 !important; }
  .pe-xl-1 {
    padding-right: 0.25rem !important; }
  .pe-xl-2 {
    padding-right: 0.5rem !important; }
  .pe-xl-3 {
    padding-right: 1rem !important; }
  .pe-xl-4 {
    padding-right: 1.5rem !important; }
  .pe-xl-5 {
    padding-right: 3rem !important; }
  .pb-xl-0 {
    padding-bottom: 0 !important; }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important; }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important; }
  .pb-xl-3 {
    padding-bottom: 1rem !important; }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important; }
  .pb-xl-5 {
    padding-bottom: 3rem !important; }
  .ps-xl-0 {
    padding-left: 0 !important; }
  .ps-xl-1 {
    padding-left: 0.25rem !important; }
  .ps-xl-2 {
    padding-left: 0.5rem !important; }
  .ps-xl-3 {
    padding-left: 1rem !important; }
  .ps-xl-4 {
    padding-left: 1.5rem !important; }
  .ps-xl-5 {
    padding-left: 3rem !important; }
  .gap-xl-0 {
    gap: 0 !important; }
  .gap-xl-1 {
    gap: 0.25rem !important; }
  .gap-xl-2 {
    gap: 0.5rem !important; }
  .gap-xl-3 {
    gap: 1rem !important; }
  .gap-xl-4 {
    gap: 1.5rem !important; }
  .gap-xl-5 {
    gap: 3rem !important; }
  .text-xl-start {
    text-align: left !important; }
  .text-xl-end {
    text-align: right !important; }
  .text-xl-center {
    text-align: center !important; } }

@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important; }
  .float-xxl-end {
    float: right !important; }
  .float-xxl-none {
    float: none !important; }
  .d-xxl-inline {
    display: inline !important; }
  .d-xxl-inline-block {
    display: inline-block !important; }
  .d-xxl-block {
    display: block !important; }
  .d-xxl-grid {
    display: grid !important; }
  .d-xxl-table {
    display: table !important; }
  .d-xxl-table-row {
    display: table-row !important; }
  .d-xxl-table-cell {
    display: table-cell !important; }
  .d-xxl-flex {
    display: flex !important; }
  .d-xxl-inline-flex {
    display: inline-flex !important; }
  .d-xxl-none {
    display: none !important; }
  .flex-xxl-fill {
    flex: 1 1 auto !important; }
  .flex-xxl-row {
    flex-direction: row !important; }
  .flex-xxl-column {
    flex-direction: column !important; }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important; }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important; }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-xxl-wrap {
    flex-wrap: wrap !important; }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important; }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-xxl-start {
    justify-content: flex-start !important; }
  .justify-content-xxl-end {
    justify-content: flex-end !important; }
  .justify-content-xxl-center {
    justify-content: center !important; }
  .justify-content-xxl-between {
    justify-content: space-between !important; }
  .justify-content-xxl-around {
    justify-content: space-around !important; }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important; }
  .align-items-xxl-start {
    align-items: flex-start !important; }
  .align-items-xxl-end {
    align-items: flex-end !important; }
  .align-items-xxl-center {
    align-items: center !important; }
  .align-items-xxl-baseline {
    align-items: baseline !important; }
  .align-items-xxl-stretch {
    align-items: stretch !important; }
  .align-content-xxl-start {
    align-content: flex-start !important; }
  .align-content-xxl-end {
    align-content: flex-end !important; }
  .align-content-xxl-center {
    align-content: center !important; }
  .align-content-xxl-between {
    align-content: space-between !important; }
  .align-content-xxl-around {
    align-content: space-around !important; }
  .align-content-xxl-stretch {
    align-content: stretch !important; }
  .align-self-xxl-auto {
    align-self: auto !important; }
  .align-self-xxl-start {
    align-self: flex-start !important; }
  .align-self-xxl-end {
    align-self: flex-end !important; }
  .align-self-xxl-center {
    align-self: center !important; }
  .align-self-xxl-baseline {
    align-self: baseline !important; }
  .align-self-xxl-stretch {
    align-self: stretch !important; }
  .order-xxl-first {
    order: -1 !important; }
  .order-xxl-0 {
    order: 0 !important; }
  .order-xxl-1 {
    order: 1 !important; }
  .order-xxl-2 {
    order: 2 !important; }
  .order-xxl-3 {
    order: 3 !important; }
  .order-xxl-4 {
    order: 4 !important; }
  .order-xxl-5 {
    order: 5 !important; }
  .order-xxl-last {
    order: 6 !important; }
  .m-xxl-0 {
    margin: 0 !important; }
  .m-xxl-1 {
    margin: 0.25rem !important; }
  .m-xxl-2 {
    margin: 0.5rem !important; }
  .m-xxl-3 {
    margin: 1rem !important; }
  .m-xxl-4 {
    margin: 1.5rem !important; }
  .m-xxl-5 {
    margin: 3rem !important; }
  .m-xxl-auto {
    margin: auto !important; }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-xxl-0 {
    margin-top: 0 !important; }
  .mt-xxl-1 {
    margin-top: 0.25rem !important; }
  .mt-xxl-2 {
    margin-top: 0.5rem !important; }
  .mt-xxl-3 {
    margin-top: 1rem !important; }
  .mt-xxl-4 {
    margin-top: 1.5rem !important; }
  .mt-xxl-5 {
    margin-top: 3rem !important; }
  .mt-xxl-auto {
    margin-top: auto !important; }
  .me-xxl-0 {
    margin-right: 0 !important; }
  .me-xxl-1 {
    margin-right: 0.25rem !important; }
  .me-xxl-2 {
    margin-right: 0.5rem !important; }
  .me-xxl-3 {
    margin-right: 1rem !important; }
  .me-xxl-4 {
    margin-right: 1.5rem !important; }
  .me-xxl-5 {
    margin-right: 3rem !important; }
  .me-xxl-auto {
    margin-right: auto !important; }
  .mb-xxl-0 {
    margin-bottom: 0 !important; }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important; }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important; }
  .mb-xxl-3 {
    margin-bottom: 1rem !important; }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important; }
  .mb-xxl-5 {
    margin-bottom: 3rem !important; }
  .mb-xxl-auto {
    margin-bottom: auto !important; }
  .ms-xxl-0 {
    margin-left: 0 !important; }
  .ms-xxl-1 {
    margin-left: 0.25rem !important; }
  .ms-xxl-2 {
    margin-left: 0.5rem !important; }
  .ms-xxl-3 {
    margin-left: 1rem !important; }
  .ms-xxl-4 {
    margin-left: 1.5rem !important; }
  .ms-xxl-5 {
    margin-left: 3rem !important; }
  .ms-xxl-auto {
    margin-left: auto !important; }
  .m-xxl-n1 {
    margin: -0.25rem !important; }
  .m-xxl-n2 {
    margin: -0.5rem !important; }
  .m-xxl-n3 {
    margin: -1rem !important; }
  .m-xxl-n4 {
    margin: -1.5rem !important; }
  .m-xxl-n5 {
    margin: -3rem !important; }
  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important; }
  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important; }
  .mx-xxl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important; }
  .mx-xxl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important; }
  .mx-xxl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important; }
  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important; }
  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important; }
  .my-xxl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important; }
  .my-xxl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important; }
  .my-xxl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important; }
  .mt-xxl-n1 {
    margin-top: -0.25rem !important; }
  .mt-xxl-n2 {
    margin-top: -0.5rem !important; }
  .mt-xxl-n3 {
    margin-top: -1rem !important; }
  .mt-xxl-n4 {
    margin-top: -1.5rem !important; }
  .mt-xxl-n5 {
    margin-top: -3rem !important; }
  .me-xxl-n1 {
    margin-right: -0.25rem !important; }
  .me-xxl-n2 {
    margin-right: -0.5rem !important; }
  .me-xxl-n3 {
    margin-right: -1rem !important; }
  .me-xxl-n4 {
    margin-right: -1.5rem !important; }
  .me-xxl-n5 {
    margin-right: -3rem !important; }
  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important; }
  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important; }
  .mb-xxl-n3 {
    margin-bottom: -1rem !important; }
  .mb-xxl-n4 {
    margin-bottom: -1.5rem !important; }
  .mb-xxl-n5 {
    margin-bottom: -3rem !important; }
  .ms-xxl-n1 {
    margin-left: -0.25rem !important; }
  .ms-xxl-n2 {
    margin-left: -0.5rem !important; }
  .ms-xxl-n3 {
    margin-left: -1rem !important; }
  .ms-xxl-n4 {
    margin-left: -1.5rem !important; }
  .ms-xxl-n5 {
    margin-left: -3rem !important; }
  .p-xxl-0 {
    padding: 0 !important; }
  .p-xxl-1 {
    padding: 0.25rem !important; }
  .p-xxl-2 {
    padding: 0.5rem !important; }
  .p-xxl-3 {
    padding: 1rem !important; }
  .p-xxl-4 {
    padding: 1.5rem !important; }
  .p-xxl-5 {
    padding: 3rem !important; }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-xxl-0 {
    padding-top: 0 !important; }
  .pt-xxl-1 {
    padding-top: 0.25rem !important; }
  .pt-xxl-2 {
    padding-top: 0.5rem !important; }
  .pt-xxl-3 {
    padding-top: 1rem !important; }
  .pt-xxl-4 {
    padding-top: 1.5rem !important; }
  .pt-xxl-5 {
    padding-top: 3rem !important; }
  .pe-xxl-0 {
    padding-right: 0 !important; }
  .pe-xxl-1 {
    padding-right: 0.25rem !important; }
  .pe-xxl-2 {
    padding-right: 0.5rem !important; }
  .pe-xxl-3 {
    padding-right: 1rem !important; }
  .pe-xxl-4 {
    padding-right: 1.5rem !important; }
  .pe-xxl-5 {
    padding-right: 3rem !important; }
  .pb-xxl-0 {
    padding-bottom: 0 !important; }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important; }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important; }
  .pb-xxl-3 {
    padding-bottom: 1rem !important; }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important; }
  .pb-xxl-5 {
    padding-bottom: 3rem !important; }
  .ps-xxl-0 {
    padding-left: 0 !important; }
  .ps-xxl-1 {
    padding-left: 0.25rem !important; }
  .ps-xxl-2 {
    padding-left: 0.5rem !important; }
  .ps-xxl-3 {
    padding-left: 1rem !important; }
  .ps-xxl-4 {
    padding-left: 1.5rem !important; }
  .ps-xxl-5 {
    padding-left: 3rem !important; }
  .gap-xxl-0 {
    gap: 0 !important; }
  .gap-xxl-1 {
    gap: 0.25rem !important; }
  .gap-xxl-2 {
    gap: 0.5rem !important; }
  .gap-xxl-3 {
    gap: 1rem !important; }
  .gap-xxl-4 {
    gap: 1.5rem !important; }
  .gap-xxl-5 {
    gap: 3rem !important; }
  .text-xxl-start {
    text-align: left !important; }
  .text-xxl-end {
    text-align: right !important; }
  .text-xxl-center {
    text-align: center !important; } }

@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.03125rem !important; }
  .fs-2 {
    font-size: 1.625rem !important; }
  .fs-3 {
    font-size: 1.42188rem !important; }
  .fs-5 {
    font-size: 1.01562rem !important; } }

@media print {
  .d-print-inline {
    display: inline !important; }
  .d-print-inline-block {
    display: inline-block !important; }
  .d-print-block {
    display: block !important; }
  .d-print-grid {
    display: grid !important; }
  .d-print-table {
    display: table !important; }
  .d-print-table-row {
    display: table-row !important; }
  .d-print-table-cell {
    display: table-cell !important; }
  .d-print-flex {
    display: flex !important; }
  .d-print-inline-flex {
    display: inline-flex !important; }
  .d-print-none {
    display: none !important; } }

/*
Template Name: Velzon - Admin & Dashboard Template
Author: Themesbrand
Version: 2.4.0
Website: https://themesbrand.com/
Contact: support@themesbrand.com
File: Main Css File
*/
@font-face {
  font-family: "hkgrotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
  src: local("hkgrotesk light"), url(${___CSS_LOADER_URL_REPLACEMENT_51___}) format("woff");
  font-weight: 300; }

@font-face {
  font-family: "hkgrotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
  src: local("hkgrotesk regular"), url(${___CSS_LOADER_URL_REPLACEMENT_53___}) format("woff");
  font-weight: 400; }

@font-face {
  font-family: "hkgrotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
  src: local("hkgrotesk medium"), url(${___CSS_LOADER_URL_REPLACEMENT_55___}) format("woff");
  font-weight: 500; }

@font-face {
  font-family: "hkgrotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
  src: local("hkgrotesk semibold"), url(${___CSS_LOADER_URL_REPLACEMENT_57___}) format("woff");
  font-weight: 600; }

@font-face {
  font-family: "hkgrotesk";
  src: local("hkgrotesk bold"), url(${___CSS_LOADER_URL_REPLACEMENT_58___}) format("woff");
  font-weight: 700; }

:root {
  --vz-vertical-menu-bg:                      #fff;
  --vz-vertical-menu-item-color:              #6d7080;
  --vz-vertical-menu-item-hover-color:        #F26430;
  --vz-vertical-menu-item-active-color:       #F26430;
  --vz-vertical-menu-sub-item-color:          #7c7f90;
  --vz-vertical-menu-sub-item-hover-color:    #F26430;
  --vz-vertical-menu-sub-item-active-color:   #F26430;
  --vz-vertical-menu-title-color:             #919da9;
  --vz-vertical-menu-bg-dark:                 #F26430;
  --vz-vertical-menu-item-color-dark:         #e0dcdc;
  --vz-vertical-menu-item-hover-color-dark:   #fff;
  --vz-vertical-menu-item-active-color-dark:  #fff;
  --vz-vertical-menu-sub-item-color-dark:     #e0dcdc;
  --vz-vertical-menu-sub-item-hover-color-dark: #fff;
  --vz-vertical-menu-sub-item-active-color-dark: #fff;
  --vz-vertical-menu-title-color-dark:         #c1c6cb;
  --vz-header-bg:  #fff;
  --vz-header-item-color:  #e9ecef;
  --vz-header-bg-dark:  #F26430;
  --vz-header-item-color-dark:  #b0c4d9;
  --vz-topbar-search-bg: #f3f3f9;
  --vz-topbar-user-bg: #f3f3f9;
  --vz-topbar-user-bg-dark: #088F7D;
  --vz-footer-bg: #fff;
  --vz-footer-color: #98a6ad;
  --vz-topnav-bg: #fff;
  --vz-topnav-item-color: #6d7080;
  --vz-topnav-item-color-active: #F26430;
  --vz-twocolumn-menu-iconview-bg: #fff;
  --vz-twocolumn-menu-bg:  #fff;
  --vz-twocolumn-menu-iconview-bg-dark: var(--vz-vertical-menu-bg-dark);
  --vz-twocolumn-menu-bg-dark:  #f36b3a;
  --vz-twocolumn-menu-item-color-dark: var(--vz-vertical-menu-item-color-dark);
  --vz-twocolumn-menu-item-active-color-dark:  #fff;
  --vz-twocolumn-menu-item-active-bg-dark:  rgba(255, 255, 255, 0.15);
  --vz-boxed-body-bg: #e5e5f2;
  --vz-heading-color: #495057;
  --vz-link-color: #F26430;
  --vz-link-hover-color: #F26430;
  --vz-border-color:  #e9ebec;
  --vz-card-bg-custom: #fff;
  --vz-card-logo-dark: block;
  --vz-card-logo-light: none;
  --vz-list-group-hover-bg: #f3f6f9;
  --vz-input-bg: #fff;
  --vz-input-border: #ced4da;
  --vz-input-focus-border: #f9b298;
  --vz-input-disabled-bg: #eff2f7;
  --vz-input-group-addon-bg: #eff2f7;
  --vz-input-check-border: var(--vz-input-border); }
  :root .nav-tabs {
    --vz-nav-tabs-link-active-bg:           #f3f3f9; }
  :root .choices, :root .flatpickr-calendar, :root .ck, :root .ql-toolbar, :root .select2-container, :root .menu-dropdown {
    --vz-choices-bg:                        #fff;
    --vz-choices-link-color:                #212529;
    --vz-choices-link-hover-bg:             #f3f6f9;
    --vz-choices-link-active-color:         #1e2125; }

[data-layout-mode="dark"] {
  --vz-gray-100: #1a1d21;
  --vz-gray-200: #212529;
  --vz-gray-300: #2a2f34;
  --vz-gray-400: #878a99;
  --vz-gray-500: #adb5bd;
  --vz-gray-600: #bfc8e2;
  --vz-gray-700: #ced4da;
  --vz-gray-800: #eff2f7;
  --vz-gray-900: #f3f6f9;
  --vz-body-bg:  #1a1d21;
  --vz-body-bg-rgb:  26, 29, 33;
  --vz-body-color: #ced4da;
  --vz-body-color-rgb: 206, 212, 218;
  --vz-vertical-menu-bg:                      #212529;
  --vz-vertical-menu-item-color:              #5f6270;
  --vz-vertical-menu-item-hover-color:        #F26430;
  --vz-vertical-menu-item-active-color:       #F26430;
  --vz-vertical-menu-sub-item-color:          #686b7b;
  --vz-vertical-menu-sub-item-hover-color:    #F26430;
  --vz-vertical-menu-sub-item-active-color:   #F26430;
  --vz-vertical-menu-title-color:             #878a99;
  --vz-vertical-menu-bg-dark:                 #212529;
  --vz-vertical-menu-item-color-dark:         #878a99;
  --vz-vertical-menu-item-hover-color-dark:   #fff;
  --vz-vertical-menu-item-active-color-dark:  #fff;
  --vz-vertical-menu-sub-item-color-dark:     #7c7f90;
  --vz-vertical-menu-sub-item-hover-color-dark: #fff;
  --vz-vertical-menu-sub-item-active-color-dark: #fff;
  --vz-vertical-menu-title-color-dark:         #5f6270;
  --vz-header-bg:  #292e32;
  --vz-header-item-color:  #e9ecef;
  --vz-header-bg-dark:  #F26430;
  --vz-header-item-color-dark:  #b0c4d9;
  --vz-topbar-search-bg: #202328;
  --vz-topbar-user-bg: #31373c;
  --vz-topbar-user-bg-dark: #088f7d;
  --vz-footer-bg: #212529;
  --vz-footer-color: #878a99;
  --vz-topnav-bg: #272b30;
  --vz-topnav-item-color: #878a99;
  --vz-topnav-item-color-active: #fff;
  --vz-twocolumn-menu-iconview-bg: #fff;
  --vz-twocolumn-menu-bg:  #fff;
  --vz-twocolumn-menu-iconview-bg-dark: var(--vz-vertical-menu-bg-dark);
  --vz-twocolumn-menu-bg-dark:  #30363a;
  --vz-twocolumn-menu-item-color-dark: var(--vz-vertical-menu-item-color-dark);
  --vz-twocolumn-menu-item-active-color-dark:  #fff;
  --vz-twocolumn-menu-item-active-bg-dark:  rgba(255, 255, 255, 0.15);
  --vz-boxed-body-bg: #111316;
  --vz-heading-color: #ced4da;
  --vz-light: #2a2f34;
  --vz-light-rgb: 42, 47, 52;
  --vz-dark: #eff2f7;
  --vz-dark-rgb: 239, 242, 247;
  --vz-link-color: #ced4da;
  --vz-link-hover-color: #ced4da;
  --vz-border-color:  #32383e;
  --vz-card-bg-custom:                        #212529;
  --vz-card-logo-dark:                        none;
  --vz-card-logo-light:                       block;
  --vz-list-group-hover-bg:                   #272b30;
  --vz-input-bg:                              #262a2f;
  --vz-input-border:                          #2a2f34;
  --vz-input-focus-border:                    #33393f;
  --vz-input-disabled-bg:                     #212529;
  --vz-input-group-addon-bg:                  #2a2f34;
  --vz-input-check-border:                    #33393f; }
  [data-layout-mode="dark"] .dropdown-menu {
    --vz-dropdown-bg:                         #292e33;
    --vz-dropdown-link-color:                 #adb5bd;
    --vz-dropdown-link-hover-color:           #b9bfc4;
    --vz-dropdown-link-hover-bg:              #2f343a;
    --vz-dropdown-border-width:               1px;
    --vz-dropdown-link-active-color:          #adb5bd;
    --vz-dropdown-link-active-bg:             #2f343a; }
  [data-layout-mode="dark"] .choices, [data-layout-mode="dark"] .flatpickr-calendar, [data-layout-mode="dark"] .ck, [data-layout-mode="dark"] .ql-toolbar, [data-layout-mode="dark"] .select2-container, [data-layout-mode="dark"] .menu-dropdown {
    --vz-choices-bg:                          #292e33;
    --vz-choices-link-color:                  #adb5bd;
    --vz-choices-link-hover-bg:               #2f343a;
    --vz-choices-link-active-color:           #dbdde0; }
  [data-layout-mode="dark"] .btn-light {
    --vz-btn-color:                           var(--vz-dark);
    --vz-btn-bg:                              var(--vz-light);
    --vz-btn-border-color:                    var(--vz-light); }
  [data-layout-mode="dark"] .btn-outline-light {
    --vz-btn-color:                           var(--vz-dark);
    --vz-btn-bg:                              transparent;
    --vz-btn-border-color:                    var(--vz-light); }
  [data-layout-mode="dark"] .btn-light, [data-layout-mode="dark"] .btn-outline-light {
    --vz-btn-hover-color:                     var(--vz-dark);
    --vz-btn-hover-bg:                        rgba(var(--vz-light-rgb), 0.75);
    --vz-btn-hover-border-color:              rgba(var(--vz-light-rgb), 0.75); }
  [data-layout-mode="dark"] .btn-dark {
    --vz-btn-color:                           var(--vz-light);
    --vz-btn-bg:                              var(--vz-dark);
    --vz-btn-border-color:                    var(--vz-dark); }
  [data-layout-mode="dark"] .btn-outline-dark {
    --vz-btn-color:                           var(--vz-dark);
    --vz-btn-bg:                              transparent;
    --vz-btn-border-color:                    var(--vz-dark); }
  [data-layout-mode="dark"] .btn-dark, [data-layout-mode="dark"] .btn-outline-dark {
    --vz-btn-hover-color:                     var(--vz-light);
    --vz-btn-hover-bg:                        rgba(var(--vz-dark-rgb), 0.75);
    --vz-btn-hover-border-color:              rgba(var(--vz-dark-rgb), 0.75); }
  [data-layout-mode="dark"] .card {
    --vz-card-bg:                             #212529;
    --vz-card-cap-bg:                         #212529; }
  [data-layout-mode="dark"] .modal {
    --vz-modal-bg:                            #212529; }
  [data-layout-mode="dark"] .nav-tabs {
    --vz-nav-tabs-link-active-color:          #f3f6f9;
    --vz-nav-tabs-link-active-bg:             #2a2f34; }
  [data-layout-mode="dark"] .accordion {
    --vz-accordion-button-active-color:       #fff;
    --vz-accordion-bg:                        #212529;
    --vz-accordion-btn-bg:                    #212529; }
  [data-layout-mode="dark"] :is(.offcanvas, .offcanvas-lg, .offcanvas-md, .offcanvas-sm, .offcanvas-xl, .offcanvas-xxl) {
    --vz-offcanvas-bg:                        #212529; }
  [data-layout-mode="dark"] .progress {
    --vz-progress-bg:                         #2a2f34; }
  [data-layout-mode="dark"] .table {
    --vz-table-striped-bg:                          rgba(255, 255, 255, 0.03);
    --vz-table-active-bg:                          rgba(255, 255, 255, 0.07);
    --vz-table-hover-bg:                          rgba(255, 255, 255, 0.07); }
  [data-layout-mode="dark"] .table-light {
    --vz-table-color:                                #fff;
    --vz-table-bg:                                   rgba(255, 255, 255, 0.05);
    --vz-table-border-color:                         var(--vz-border-color);
    --vz-table-striped-bg:                           rgba(255, 255, 255, 0.07);
    --vz-table-striped-color:                        #fff; }
  [data-layout-mode="dark"] .toast {
    --vz-toast-bg:                            rgba(42, 47, 52, 0.85);
    --vz-toast-header-bg:                     rgba(42, 47, 52, 0.85);
    --vz-toast-border-color:                  rgba(255, 255, 255, 0.1);
    --vz-toast-header-border-color:           rgba(255, 255, 255, 0.05); }
  [data-layout-mode="dark"] .popover {
    --vz-popover-bg:                          #23282c; }
  [data-layout-mode="dark"] .pagination {
    --vz-pagination-hover-bg:                   #2a2f34;
    --vz-pagination-focus-bg:                   #2a2f34; }

[data-sidebar="gradient"] {
  --vz-vertical-menu-bg-gradient:             linear-gradient(to right, var(--vz-primary), var(--vz-success));
  --vz-vertical-menu-border-gradient:         var(--vz-success);
  --vz-twocolumn-menu-bg-dark:                var(--vz-success); }

[data-sidebar="gradient-2"] {
  --vz-vertical-menu-bg-gradient:             linear-gradient(to right, var(--vz-info), var(--vz-secondary));
  --vz-vertical-menu-border-gradient:         var(--vz-secondary);
  --vz-twocolumn-menu-bg-dark:                var(--vz-secondary); }

[data-sidebar="gradient-3"] {
  --vz-vertical-menu-bg-gradient:             linear-gradient(to right, var(--vz-info), var(--vz-success));
  --vz-vertical-menu-border-gradient:         var(--vz-success);
  --vz-twocolumn-menu-bg-dark:                var(--vz-success); }

[data-sidebar="gradient-4"] {
  --vz-vertical-menu-bg-gradient:             linear-gradient(to right, #1a1d21, var(--vz-primary));
  --vz-vertical-menu-border-gradient:         var(--vz-primary);
  --vz-twocolumn-menu-bg-dark:                var(--vz-primary); }

#page-topbar {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1000;
  background-color: var(--vz-header-bg);
  transition: all 0.1s ease-out;
  border: 1px solid none; }
  #page-topbar.topbar-shadow {
    box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15); }
  @media (min-width: 768px) {
    #page-topbar {
      left: 250px; } }

.navbar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  height: 70px;
  padding: 0 1rem 0 calc(1rem / 2); }
  @media (max-width: 767.98px) {
    .navbar-header {
      padding: 0 calc(1rem / 2) 0 calc(1rem / 2); } }
  .navbar-header .topbar-head-dropdown .dropdown-menu.show {
    top: 13px !important; }
  .navbar-header .btn-topbar {
    height: 42px;
    width: 42px; }
    @media (max-width: 360px) {
      .navbar-header .btn-topbar {
        height: 36px;
        width: 36px; } }
  .navbar-header .user-name-text {
    color: var(--vz-gray-700); }

/* Search */
.app-search {
  padding: calc(32px / 2) 0; }
  .app-search .form-control {
    border: none;
    height: 38px;
    padding-left: 40px;
    padding-right: 30px;
    background-color: var(--vz-topbar-search-bg);
    box-shadow: none; }
  .app-search span.search-widget-icon {
    position: absolute;
    z-index: 10;
    font-size: 18px;
    line-height: 38px;
    left: 13px;
    top: 0;
    color: #878a99; }
  .app-search .search-widget-icon-close {
    right: 7px;
    left: auto !important; }
  @media (max-width: 1023.99px) {
    .app-search {
      padding-left: calc(1rem / 2); } }

.megamenu-list li {
  position: relative;
  padding: 5px 0px; }
  .megamenu-list li a {
    color: var(--vz-body-color); }

@media (max-width: 767.98px) {
  .logo span.logo-lg {
    display: none; }
  .logo span.logo-sm {
    display: inline-block; } }

.header-item {
  height: 70px;
  display: flex;
  align-items: center; }

.header-profile-user {
  height: 45px;
  width: 45px;
  margin-left: 10px; }

.topbar-badge-sm {
  right: 0;
  top: 7px !important; }

.topbar-badge {
  right: -9px;
  top: 4px !important; }

@media (min-width: 768px) {
  .topbar-user {
    background-color: transparent; } }

.topbar-user .dropdown-menu {
  top: 6px !important; }

.notification-item {
  padding: 0.75rem 1rem;
  white-space: inherit;
  position: relative; }
  .notification-item .form-check-input {
    position: relative;
    z-index: 2; }

.dropdown-icon-item {
  display: block;
  border-radius: 3px;
  line-height: 34px;
  text-align: center;
  padding: 15px 0 9px;
  border: 1px solid transparent;
  color: var(--vz-dropdown-link-color); }
  .dropdown-icon-item img {
    height: 24px; }
  .dropdown-icon-item span {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; }
  .dropdown-icon-item:hover {
    background-color: var(--vz-dropdown-link-hover-bg); }

.fullscreen-enable [data-toggle="fullscreen"] .bx-fullscreen::before {
  content: "\\eacb"; }

[data-layout-mode="dark"] .light-dark-mode .bx-moon::before {
  content: "\\ec34"; }

[data-topbar="dark"] #page-topbar {
  background-color: var(--vz-header-bg-dark);
  border-color: var(--vz-header-bg-dark); }

[data-topbar="dark"] .navbar-header .btn-topbar {
  color: var(--vz-header-item-color-dark); }
  [data-topbar="dark"] .navbar-header .btn-topbar:hover, [data-topbar="dark"] .navbar-header .btn-topbar:focus {
    background-color: rgba(255, 255, 255, 0.07);
    color: #fff; }

@media (min-width: 767.99px) {
  [data-topbar="dark"] .topbar-user {
    background-color: var(--vz-topbar-user-bg-dark); } }

[data-topbar="dark"] .topbar-user .user-name-text {
  color: rgba(255, 255, 255, 0.85) !important; }

[data-topbar="dark"] .topbar-user .user-name-sub-text {
  color: var(--vz-header-item-color-dark) !important; }

[data-topbar="dark"] .logo-dark {
  display: none; }

[data-topbar="dark"] .logo-light {
  display: inline-block; }

[data-topbar="dark"] .app-search .form-control {
  background-color: rgba(255, 255, 255, 0.05);
  color: #fff; }

[data-topbar="dark"] .app-search span.search-widget-icon,
[data-topbar="dark"] .app-search input.form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.5); }

[data-topbar="dark"] .hamburger-icon span {
  background-color: #e9ebec; }

@media (max-width: 600px) {
  .navbar-header .dropdown {
    position: static; }
    .navbar-header .dropdown .dropdown-menu {
      width: 100%; } }

@media (max-width: 767.98px) {
  #search-dropdown-reponsive {
    top: 54px !important; } }

@media (min-width: 1024.1px) {
  [data-layout="vertical"][data-layout-style="detached"] #page-topbar {
    left: 0 !important;
    box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15); }
  [data-layout="vertical"][data-layout-style="detached"] .horizontal-logo {
    display: inline-block;
    padding-left: 0; }
  [data-layout="vertical"][data-layout-style="detached"] .topnav-hamburger {
    visibility: hidden; }
  [data-layout="vertical"][data-layout-style="detached"] .layout-width {
    max-width: 95%;
    margin: 0 auto; }
  [data-layout="vertical"][data-layout-style="detached"]:is([data-sidebar-size="sm"], [data-sidebar-size="sm-hover"]) .navbar-brand-box {
    background-color: transparent !important;
    position: relative;
    width: auto;
    text-align: left; }
    [data-layout="vertical"][data-layout-style="detached"]:is([data-sidebar-size="sm"], [data-sidebar-size="sm-hover"]) .navbar-brand-box .logo-sm {
      display: none; }
    [data-layout="vertical"][data-layout-style="detached"]:is([data-sidebar-size="sm"], [data-sidebar-size="sm-hover"]) .navbar-brand-box .logo-lg {
      display: block; } }

[data-layout="vertical"][data-layout-style="detached"][data-topbar="dark"] .horizontal-logo .logo-dark {
  display: none; }

[data-layout="vertical"][data-layout-style="detached"][data-topbar="dark"] .horizontal-logo .logo-light {
  display: block; }

[data-layout="horizontal"] #page-topbar {
  left: 0;
  border-bottom: 1px solid var(--vz-gray-300); }
  @media (min-width: 1024.1px) {
    [data-layout="horizontal"] #page-topbar.topbar-shadow {
      box-shadow: none; } }

[data-layout="horizontal"] .page-content {
  padding: calc(45px + 1rem) calc(1rem / 2) 60px calc(1rem / 2); }
  @media (min-width: 1024.1px) {
    [data-layout="horizontal"] .page-content {
      margin-top: 70px; } }
  @media (max-width: 1024.1px) {
    [data-layout="horizontal"] .page-content {
      padding: calc(45px + 1rem * 1.8) calc(1rem / 2) 60px calc(1rem / 2); } }

@media (min-width: 1024.1px) {
  [data-layout="horizontal"][data-layout-width="boxed"] .page-content {
    min-height: calc(100vh - 130px); } }

@media (min-width: 768px) {
  [data-layout="vertical"]:is([data-sidebar-size="sm"], [data-sidebar-size="sm-hover"]) #page-topbar {
    left: 70px; }
  [data-layout="vertical"][data-sidebar-size="md"] #page-topbar {
    left: 180px; }
  [data-layout="twocolumn"] #page-topbar {
    left: calc(70px + 220px); } }

[data-layout="twocolumn"] .horizontal-logo {
  display: none; }

.page-title-box {
  padding: 10px 1rem;
  background-color: var(--vz-card-bg-custom);
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  border-bottom: 1px solid none;
  margin: -23px -1rem 1rem -1rem; }
  .page-title-box .breadcrumb {
    background-color: transparent;
    padding: 0; }
  .page-title-box h4, .page-title-box .h4 {
    font-weight: 700;
    font-size: 15px !important;
    text-transform: uppercase; }

[data-layout="horizontal"] .page-title-box {
  padding: 1.2rem 0;
  background-color: transparent !important;
  border-bottom: none;
  border-top: none;
  box-shadow: none;
  margin: 0; }
  @media (min-width: 1024.1px) {
    [data-layout="horizontal"] .page-title-box {
      margin: -19px 0 0 0; } }

[data-layout="vertical"][data-layout-style="detached"] .page-title-box {
  padding: 1.2rem 0;
  background-color: transparent !important;
  border-bottom: none;
  border-top: none;
  box-shadow: none;
  margin: 0; }
  @media (min-width: 1024.1px) {
    [data-layout="vertical"][data-layout-style="detached"] .page-title-box {
      margin: -19px 0 0 0; } }

.footer {
  bottom: 0;
  padding: 20px calc(1rem * 0.5);
  position: absolute;
  right: 0;
  color: var(--vz-footer-color);
  left: 250px;
  height: 60px;
  background-color: var(--vz-footer-bg); }
  @media (max-width: 991.98px) {
    .footer {
      left: 0; } }

[data-layout="vertical"]:is([data-sidebar-size="sm"], [data-sidebar-size="sm-hover"]) .footer {
  left: 70px; }
  @media (max-width: 767.98px) {
    [data-layout="vertical"]:is([data-sidebar-size="sm"], [data-sidebar-size="sm-hover"]) .footer {
      left: 0; } }

[data-layout="vertical"][data-sidebar-size="md"] .footer {
  left: 180px; }
  @media (max-width: 991.98px) {
    [data-layout="vertical"][data-sidebar-size="md"] .footer {
      left: 0; } }

[data-layout="horizontal"] .footer {
  left: 0 !important; }

@media (min-width: 1024.1px) {
  [data-layout="vertical"][data-layout-style="detached"] .footer {
    left: 0 !important;
    background-color: transparent; } }

@media (min-width: 768.1px) {
  [data-layout="twocolumn"] .footer {
    left: calc(70px + 220px); } }

.app-content {
  margin-left: 250px;
  overflow: hidden; }
  .app-content .content {
    padding: 0 15px 10px 15px;
    margin-top: 70px; }

.main-content {
  transition: all 0.1s ease-out; }
  @media (min-width: 768px) {
    .main-content {
      margin-left: 250px; } }

.page-content {
  padding: 1rem calc(1rem) 60px calc(1rem); }

.navbar-menu {
  width: 250px;
  z-index: 1002;
  background: var(--vz-vertical-menu-bg);
  border-right: 1px solid #fff;
  bottom: 0;
  margin-top: 0;
  position: fixed;
  top: 0;
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  padding: 0 0 calc(70px + 25px) 0;
  transition: all 0.1s ease-out; }
  .navbar-menu .navbar-nav .nav-link {
    display: flex;
    align-items: center;
    padding: 0.625rem 1.5rem;
    color: var(--vz-vertical-menu-item-color);
    font-size: 1rem;
    font-family: "hkgrotesk", sans-serif; }
    .navbar-menu .navbar-nav .nav-link.active {
      color: var(--vz-vertical-menu-item-active-color); }
    .navbar-menu .navbar-nav .nav-link:hover {
      color: var(--vz-vertical-menu-item-hover-color); }
    .navbar-menu .navbar-nav .nav-link i {
      display: inline-block;
      min-width: 1.75rem;
      font-size: 18px;
      line-height: inherit; }
    .navbar-menu .navbar-nav .nav-link svg {
      width: 18px;
      margin-right: 0.665rem;
      color: var(--vz-vertical-menu-item-color); }
    .navbar-menu .navbar-nav .nav-link .badge {
      margin-left: auto;
      margin-right: -2px;
      z-index: 1; }
    .navbar-menu .navbar-nav .nav-link:hover {
      color: var(--vz-vertical-menu-item-hover-color); }
      .navbar-menu .navbar-nav .nav-link:hover .icon-dual {
        color: var(--vz-vertical-menu-item-hover-color);
        fill: rgba(242, 100, 48, 0.16); }
    .navbar-menu .navbar-nav .nav-link[data-bs-toggle="collapse"]:after {
      display: block;
      content: "\\F0142";
      font-family: "Material Design Icons";
      margin-left: auto;
      transition: transform 0.2s;
      font-size: 1.05rem;
      position: absolute;
      right: 18px;
      color: var(--vz-vertical-menu-title-color); }
    .navbar-menu .navbar-nav .nav-link[data-bs-toggle="collapse"][aria-expanded="true"] {
      color: var(--vz-vertical-menu-item-active-color); }
      .navbar-menu .navbar-nav .nav-link[data-bs-toggle="collapse"][aria-expanded="true"] .icon-dual {
        color: var(--vz-vertical-menu-item-hover-color);
        fill: rgba(242, 100, 48, 0.16); }
      .navbar-menu .navbar-nav .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:after {
        transform: rotate(90deg);
        color: var(--vz-vertical-menu-item-active-color); }
      .navbar-menu .navbar-nav .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:before {
        opacity: 1;
        background-color: var(--vz-vertical-menu-item-active-color); }
    .navbar-menu .navbar-nav .nav-link.collapsed.active::after {
      transform: rotate(90deg); }
  .navbar-menu .navbar-nav .nav-sm {
    padding-left: 1.75rem; }
    .navbar-menu .navbar-nav .nav-sm .nav-link {
      padding: 0.55rem 1.5rem !important;
      color: var(--vz-vertical-menu-sub-item-color);
      white-space: none;
      position: relative;
      font-size: 0.813rem;
      font-family: "Poppins", sans-serif; }
      .navbar-menu .navbar-nav .nav-sm .nav-link:before {
        content: "";
        width: 6px;
        height: 1.5px;
        background-color: var(--vz-vertical-menu-sub-item-color);
        position: absolute;
        left: 2px;
        top: 16.5px;
        transition: all 0.4s ease-in-out;
        opacity: 0.5; }
      .navbar-menu .navbar-nav .nav-sm .nav-link:hover {
        color: var(--vz-vertical-menu-sub-item-hover-color); }
        .navbar-menu .navbar-nav .nav-sm .nav-link:hover:before {
          background-color: var(--vz-vertical-menu-sub-item-hover-color) !important;
          opacity: 1; }
      .navbar-menu .navbar-nav .nav-sm .nav-link.active {
        color: var(--vz-vertical-menu-item-active-color); }
        .navbar-menu .navbar-nav .nav-sm .nav-link.active:before {
          background-color: var(--vz-vertical-menu-item-active-color); }
    .navbar-menu .navbar-nav .nav-sm .nav-sm {
      padding-left: 15px; }
      .navbar-menu .navbar-nav .nav-sm .nav-sm .nav-link:before {
        height: 5px;
        width: 5px;
        left: 5px;
        border-radius: 50%;
        background-color: transparent;
        border: 1px solid;
        top: 16px; }
  .navbar-menu .btn-vertical-sm-hover {
    color: #878a99;
    display: none; }

.navbar-brand-box {
  padding: 0 1.3rem;
  text-align: center;
  transition: all 0.1s ease-out; }
  @media (max-width: 767.98px) {
    .navbar-brand-box {
      display: none; } }

.hamburger-icon {
  width: 20px;
  height: 14px;
  position: relative;
  cursor: pointer;
  display: inline-block; }
  .hamburger-icon span {
    background-color: #878a99;
    position: absolute;
    border-radius: 2px;
    transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);
    width: 100%;
    height: 2px;
    display: block;
    left: 0px; }
    .hamburger-icon span:nth-child(1) {
      top: 0;
      width: 80%; }
    .hamburger-icon span:nth-child(2) {
      top: 6px; }
    .hamburger-icon span:nth-child(3) {
      bottom: 0;
      width: 60%; }
  .vertical-menu-btn:hover .hamburger-icon:not(.open) span:nth-child(1) {
    top: -1px; }
  .vertical-menu-btn:hover .hamburger-icon:not(.open) span:nth-child(3) {
    bottom: -1px; }
  .hamburger-icon.open {
    transform: rotate(-90deg); }
    .hamburger-icon.open span:nth-child(1) {
      left: 1px;
      top: 5px;
      width: 20px;
      transform: rotate(90deg);
      transition-delay: 150ms; }
    .hamburger-icon.open span:nth-child(2) {
      left: 3px;
      top: 13px;
      width: 10px;
      transform: rotate(45deg);
      transition-delay: 50ms; }
    .hamburger-icon.open span:nth-child(3) {
      left: 9px;
      top: 13px;
      width: 10px;
      transform: rotate(-45deg);
      transition-delay: 100ms; }

.logo {
  line-height: 70px; }
  .logo .logo-sm {
    display: none; }

.logo-light {
  display: none; }

:is([data-layout="vertical"], [data-layout="semibox"]) .app-menu .row {
  margin: 0; }
  :is([data-layout="vertical"], [data-layout="semibox"]) .app-menu .row > * {
    width: 100%;
    padding: 0; }

@media (max-width: 767.98px) {
  :is([data-layout="vertical"], [data-layout="semibox"]) .app-menu {
    margin-left: -100%;
    padding: 10px 0 20px 0; } }

:is([data-layout="vertical"], [data-layout="semibox"]) .navbar-menu .container-fluid, :is([data-layout="vertical"], [data-layout="semibox"]) .navbar-menu .container-sm, :is([data-layout="vertical"], [data-layout="semibox"]) .navbar-menu .container-md, :is([data-layout="vertical"], [data-layout="semibox"]) .navbar-menu .container-lg, :is([data-layout="vertical"], [data-layout="semibox"]) .navbar-menu .container-xl, :is([data-layout="vertical"], [data-layout="semibox"]) .navbar-menu .container-xxl {
  padding: 0; }

@media (max-width: 767.98px) {
  :is([data-layout="vertical"], [data-layout="semibox"]) .navbar-brand-box {
    display: none; } }

:is([data-layout="vertical"], [data-layout="semibox"]) .horizontal-logo {
  display: none; }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .main-content {
  margin-left: 70px; }
  @media (max-width: 767.98px) {
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .main-content {
      margin-left: 0; } }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .logo span.logo-lg {
  display: none; }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .logo span.logo-sm {
  display: inline-block; }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .btn-vertical-sm-hover {
  display: inline-block; }

@media (min-width: 768px) {
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .topnav-hamburger {
    display: none; } }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu {
  width: 70px; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu .btn-vertical-sm-hover {
    display: none; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu .btn-vertical-sm-hover i.ri-record-circle-line:before {
      content: "\\EB7D"; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .badge {
    display: none; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .menu-title {
    text-align: center; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .menu-title span {
      display: none; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .menu-title i {
      display: block;
      line-height: 36px;
      font-size: 1rem; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .nav-link span {
    display: none; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .nav-link i {
    font-size: 22px; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .nav-link i.las, :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .nav-link i.lar, :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .nav-link i.lab {
      font-size: 24px; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .nav-link svg {
    margin-right: 0px; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .nav-link:after, :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .nav-link:before {
    display: none; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .menu-dropdown {
    display: none; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu:hover {
    width: 250px !important; }
    @media (min-width: 1024.99px) {
      :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu:hover .btn-vertical-sm-hover {
        display: inline-block; }
      :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu:hover .navbar-brand-box {
        text-align: left; } }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu:hover .navbar-nav .menu-dropdown.show {
      display: block; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu:hover .nav-link i {
      font-size: 18px; }
      :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu:hover .nav-link i.las, :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu:hover .nav-link i.lar, :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu:hover .nav-link i.lab {
        font-size: 20px; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu:hover .nav-link svg {
      margin-right: 0.665rem; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu:hover .nav-link span, :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu:hover .nav-link:after, :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu:hover .nav-link:before {
      display: inline-block; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu:hover .logo span.logo-lg {
      display: inline-block; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu:hover .logo span.logo-sm {
      display: none; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu:hover .menu-title {
      text-align: left; }
      :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu:hover .menu-title span {
        display: inline-block; }
      :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover"] .navbar-menu:hover .menu-title i {
        display: none; }

:is([data-layout="vertical"], [data-layout="semibox"]):is([data-sidebar-size="sm-hover"], [data-sidebar-size="sm-hover-active"]) .navbar-header {
  padding-top: calc(\$grid-gutter-width*0.5); }
  @media (min-width: 1025px) {
    :is([data-layout="vertical"], [data-layout="semibox"]):is([data-sidebar-size="sm-hover"], [data-sidebar-size="sm-hover-active"]) .navbar-header {
      padding-left: 1rem; } }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover-active"] .navbar-brand-box {
  text-align: left; }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover-active"] .topnav-hamburger {
  display: none; }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm-hover-active"] .btn-vertical-sm-hover {
  display: inline-block; }

@media (min-width: 768px) {
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] {
    min-height: 1400px; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .main-content {
      margin-left: 70px; } }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] #page-topbar {
  /*  z-index: calc(1002 + 1); */ }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-brand-box {
  position: fixed;
  padding: 0;
  width: 70px;
  z-index: 1;
  top: 0;
  background: var(--vz-vertical-menu-bg); }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .logo span.logo-lg {
  display: none; }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .logo span.logo-sm {
  display: inline-block; }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu {
  position: absolute;
  width: 70px !important;
  padding-top: 70px; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .simplebar-mask,
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .simplebar-content-wrapper {
    overflow: visible !important; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .simplebar-scrollbar,
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .vertical-menu-btn {
    display: none !important; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .simplebar-offset {
    bottom: 0 !important; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .badge {
    display: none !important; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .menu-title {
    text-align: center;
    font-size: 1rem; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .menu-title span {
      display: none; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .menu-title i {
      display: block;
      line-height: 36px; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-link span {
    display: none; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-link i {
    font-size: 22px; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-link svg {
    margin-right: 0px; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-link:after, :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-link:before {
    display: none; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .menu-dropdown {
    display: none;
    height: auto !important; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-item {
    position: relative; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link {
      position: relative;
      width: calc(200px + 70px);
      color: #fff;
      background-color: var(--vz-vertical-menu-bg-dark);
      transition: none; }
      :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link .icon-dual {
        color: var(--vz-vertical-menu-item-hover-color-dark);
        fill: rgba(255, 255, 255, 0.16); }
      :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link span {
        display: inline-block;
        padding-left: 25px; }
      :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link:after {
        display: block;
        transform: rotate(90deg);
        color: #fff; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-item:hover .nav-link span {
      display: inline-block; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-item:hover > .menu-dropdown {
      display: block;
      left: 70px;
      position: absolute;
      width: 200px;
      background: var(--vz-vertical-menu-bg);
      height: auto !important;
      padding: 0.5rem 0;
      border-radius: 0 0 3px 3px;
      box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12); }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm {
    padding: 0; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link {
      color: var(--vz-vertical-menu-item-hover-color); }
      :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link:after {
        color: inherit; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm .nav-link:after {
      display: block !important;
      transform: rotate(0deg) !important; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm .menu-dropdown {
      left: 100% !important;
      top: 0;
      border-radius: 3px !important; }

@media (min-width: 768px) {
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="md"] .main-content {
    margin-left: 180px; } }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="md"] .navbar-brand-box {
  width: 180px; }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="md"] .navbar-menu {
  width: 180px !important; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="md"] .navbar-menu .navbar-nav .nav-link {
    display: block;
    text-align: center;
    padding: 0.55rem 0.525rem; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="md"] .navbar-menu .navbar-nav .nav-link i {
      display: block; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="md"] .navbar-menu .navbar-nav .nav-link svg {
      display: block;
      margin-left: auto;
      margin-right: auto; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="md"] .navbar-menu .navbar-nav .nav-link:before {
      display: none !important; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="md"] .navbar-menu .navbar-nav .nav-link[data-bs-toggle="collapse"]:after {
      position: relative;
      display: inline-block;
      right: 0;
      top: 3px; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="md"] .navbar-menu .navbar-nav .nav-link.menu-link[data-bs-toggle="collapse"]:after {
      display: none; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="md"] .navbar-menu .navbar-nav .badge {
    display: none !important; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="md"] .navbar-menu .navbar-nav .nav-sm {
    padding-left: 0; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="md"] .navbar-menu .menu-title {
    text-align: center; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar-size="md"] .navbar-menu .menu-title span {
      text-decoration: underline; }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-menu {
  background: var(--vz-vertical-menu-bg-dark);
  border-right: 1px solid var(--vz-vertical-menu-bg-dark); }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-menu .hamburger-icon span {
    background-color: var(--vz-vertical-menu-item-color-dark); }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-menu .btn-vertical-sm-hover {
    color: var(--vz-vertical-menu-item-color-dark); }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-nav .nav-link {
  color: var(--vz-vertical-menu-item-color-dark); }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-nav .nav-link.active {
    color: var(--vz-vertical-menu-item-active-color-dark); }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-nav .nav-link[data-bs-toggle="collapse"]:after {
    color: inherit; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-nav .nav-link[data-bs-toggle="collapse"][aria-expanded="true"] {
    color: var(--vz-vertical-menu-item-active-color-dark); }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-nav .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:after {
      color: inherit; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-nav .nav-link[data-bs-toggle="collapse"][aria-expanded="true"] .icon-dual {
      color: var(--vz-vertical-menu-item-active-color-dark);
      fill: rgba(255, 255, 255, 0.1); }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-nav .nav-link svg {
    color: var(--vz-vertical-menu-item-color-dark);
    fill: rgba(255, 255, 255, 0.1); }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-nav .nav-link:hover {
    color: var(--vz-vertical-menu-item-hover-color-dark); }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-nav .nav-link:hover .icon-dual {
      color: var(--vz-vertical-menu-item-hover-color-dark);
      fill: rgba(255, 255, 255, 0.16); }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-nav > .nav-item .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color-dark); }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-nav > .nav-item .nav-link.active .icon-dual {
    color: var(--vz-vertical-menu-item-hover-color-dark);
    fill: rgba(255, 255, 255, 0.16); }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-nav .nav-sm .nav-link {
  color: var(--vz-vertical-menu-sub-item-color-dark); }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-nav .nav-sm .nav-link:before {
    background-color: var(--vz-vertical-menu-sub-item-color-dark) !important; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-nav .nav-sm .nav-link:hover {
    color: var(--vz-vertical-menu-item-hover-color-dark); }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-nav .nav-sm .nav-link:hover:before {
      background-color: var(--vz-vertical-menu-item-hover-color-dark) !important; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-nav .nav-sm .nav-link.active {
    color: var(--vz-vertical-menu-item-active-color-dark); }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-nav .nav-sm .nav-sm .nav-link:before {
  background-color: transparent !important; }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-nav .nav-sm .nav-sm .nav-link:hover:before {
  background-color: var(--vz-vertical-menu-item-hover-color-dark) !important; }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-nav .nav-sm .nav-sm .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color-dark); }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .navbar-nav .nav-sm .nav-sm .nav-link.active:before {
    background-color: var(--vz-vertical-menu-item-active-color-dark) !important; }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"][data-sidebar-size="sm"] .navbar-brand-box {
  background: var(--vz-vertical-menu-bg-dark); }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-item:hover > .menu-dropdown {
  background: var(--vz-vertical-menu-bg-dark); }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm {
  padding: 0; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm .nav-link:after {
    display: block !important;
    transform: rotate(0deg) !important; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link {
    color: var(--vz-vertical-menu-item-active-color-dark); }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link:after {
      color: inherit; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm .menu-dropdown {
    left: 100% !important;
    top: 0;
    border-radius: 3px !important; }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .menu-title {
  color: var(--vz-vertical-menu-title-color-dark); }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .logo-dark {
  display: none; }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="dark"] .logo-light {
  display: inline-block; }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="light"] .logo-dark {
  display: inline-block; }

:is([data-layout="vertical"], [data-layout="semibox"])[data-sidebar="light"] .logo-light {
  display: none; }

:is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style="detached"] #layout-wrapper,
:is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style="detached"] .main-content {
  min-height: 100vh; }

@media (min-width: 1024.1px) {
  :is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style="detached"] .main-content {
    position: relative; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style="detached"] #layout-wrapper {
    max-width: 100%;
    margin: 0 auto;
    /* padding-left: \$grid-gutter-width; */
    /* templatletin default ayarını kaldırdım */ }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style="detached"] .navbar-header {
    padding-left: 1rem; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style="detached"] .navbar-menu {
    padding: 0;
    border-right: var(--vz-vertical-menu-bg);
    border-radius: 0 38px 38px 0;
    padding: 10px 0;
    z-index: 1; }
    :is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style="detached"] .navbar-menu .navbar-brand-box {
      display: none; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style="detached"]:is(
  [data-sidebar="dark"],
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"]) .logo-dark {
    display: inline-block; }
  :is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style="detached"]:is(
  [data-sidebar="dark"],
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"]) .logo-light {
    display: none; } }

:is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style="detached"] .footer {
  border-top: 1px dashed var(--vz-border-color); }

:is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style="detached"] .auth-page-wrapper .footer {
  border-top: none; }

@media (min-width: 768px) {
  :is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style="detached"][data-sidebar-size="sm"] #layout-wrapper,
  :is([data-layout="vertical"], [data-layout="semibox"])[data-layout-style="detached"][data-sidebar-size="sm"] .main-content {
    min-height: 1400px; } }

:is([data-layout="vertical"], [data-layout="semibox"]):is(
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"]) .logo-dark {
  display: none; }

:is([data-layout="vertical"], [data-layout="semibox"]):is(
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"]) .logo-light {
  display: inline-block; }

.menu-title {
  letter-spacing: 0.05em;
  cursor: default;
  font-size: 11px;
  text-transform: uppercase;
  color: var(--vz-vertical-menu-title-color);
  font-weight: 600; }
  .menu-title span {
    padding: 12px 20px;
    display: inline-block; }
  .menu-title i {
    display: none; }

.vertical-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(33, 37, 41, 0.35);
  z-index: 1003;
  display: none; }

.vertical-sidebar-enable .vertical-overlay {
  display: block; }

.vertical-sidebar-enable .app-menu {
  margin-left: 0 !important;
  z-index: 1004; }

[dir="rtl"] .navbar-menu .navbar-nav .nav-link[data-bs-toggle="collapse"]:after {
  transform: rotate(180deg); }

[dir="rtl"] .navbar-menu .navbar-nav .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:after {
  transform: rotate(270deg); }

:is(
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"]) .navbar-menu {
  background: var(--vz-vertical-menu-bg-gradient);
  border-right: 1px solid var(--vz-vertical-menu-border-gradient); }
  :is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"]) .navbar-menu .hamburger-icon span {
    background-color: rgba(255, 255, 255, 0.5); }
  :is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"]) .navbar-menu .btn-vertical-sm-hover {
    color: rgba(255, 255, 255, 0.5); }

:is(
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"]) .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.5); }
  :is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"]) .navbar-nav .nav-link.active {
    color: var(--vz-vertical-menu-item-active-color-dark); }
  :is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"]) .navbar-nav .nav-link[data-bs-toggle="collapse"]:after {
    color: inherit; }
  :is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"]) .navbar-nav .nav-link[data-bs-toggle="collapse"][aria-expanded="true"] {
    color: var(--vz-vertical-menu-item-active-color-dark); }
    :is(
    [data-sidebar="gradient"],
    [data-sidebar="gradient-2"],
    [data-sidebar="gradient-3"],
    [data-sidebar="gradient-4"]) .navbar-nav .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:after {
      color: inherit; }
    :is(
    [data-sidebar="gradient"],
    [data-sidebar="gradient-2"],
    [data-sidebar="gradient-3"],
    [data-sidebar="gradient-4"]) .navbar-nav .nav-link[data-bs-toggle="collapse"][aria-expanded="true"] .icon-dual {
      color: var(--vz-vertical-menu-item-active-color-dark);
      fill: rgba(255, 255, 255, 0.1); }
  :is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"]) .navbar-nav .nav-link svg {
    color: rgba(255, 255, 255, 0.5);
    fill: rgba(255, 255, 255, 0.1); }
  :is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"]) .navbar-nav .nav-link:hover {
    color: var(--vz-vertical-menu-item-hover-color-dark); }
    :is(
    [data-sidebar="gradient"],
    [data-sidebar="gradient-2"],
    [data-sidebar="gradient-3"],
    [data-sidebar="gradient-4"]) .navbar-nav .nav-link:hover .icon-dual {
      color: var(--vz-vertical-menu-item-hover-color-dark);
      fill: rgba(255, 255, 255, 0.16); }

:is(
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"]) .navbar-nav > .nav-item .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color-dark); }
  :is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"]) .navbar-nav > .nav-item .nav-link.active .icon-dual {
    color: var(--vz-vertical-menu-item-hover-color-dark);
    fill: rgba(255, 255, 255, 0.16); }

:is(
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"]) .navbar-nav .nav-sm .nav-link {
  color: rgba(255, 255, 255, 0.5); }
  :is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"]) .navbar-nav .nav-sm .nav-link:before {
    background-color: rgba(255, 255, 255, 0.5) !important; }
  :is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"]) .navbar-nav .nav-sm .nav-link:hover {
    color: var(--vz-vertical-menu-item-hover-color-dark); }
    :is(
    [data-sidebar="gradient"],
    [data-sidebar="gradient-2"],
    [data-sidebar="gradient-3"],
    [data-sidebar="gradient-4"]) .navbar-nav .nav-sm .nav-link:hover:before {
      background-color: var(--vz-vertical-menu-item-hover-color-dark) !important; }
  :is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"]) .navbar-nav .nav-sm .nav-link.active {
    color: var(--vz-vertical-menu-item-active-color-dark); }

:is(
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"]) .navbar-nav .nav-sm .nav-sm .nav-link:before {
  background-color: transparent !important; }

:is(
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"]) .navbar-nav .nav-sm .nav-sm .nav-link:hover:before {
  background-color: var(--vz-vertical-menu-item-hover-color-dark) !important; }

:is(
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"]) .navbar-nav .nav-sm .nav-sm .nav-link.active {
  color: var(--vz-vertical-menu-item-active-color-dark); }
  :is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"]) .navbar-nav .nav-sm .nav-sm .nav-link.active:before {
    background-color: var(--vz-vertical-menu-item-active-color-dark) !important; }

:is(
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"])[data-sidebar-size="sm"] .navbar-brand-box {
  background: var(--vz-vertical-menu-bg-gradient); }

:is(
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-item:hover > .menu-dropdown {
  background: var(--vz-vertical-menu-bg-dark); }

:is(
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm {
  padding: 0; }
  :is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm .nav-link:after {
    display: block !important;
    transform: rotate(0deg) !important; }
  :is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link {
    color: var(--vz-vertical-menu-item-active-color-dark); }
    :is(
    [data-sidebar="gradient"],
    [data-sidebar="gradient-2"],
    [data-sidebar="gradient-3"],
    [data-sidebar="gradient-4"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link:after {
      color: inherit; }
  :is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"])[data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm .menu-dropdown {
    left: 100% !important;
    top: 0;
    border-radius: 3px !important; }

:is(
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"])[data-sidebar-size="sm"][data-layout="vertical"] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link {
  background: var(--vz-vertical-menu-bg-gradient); }

:is(
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"]) .menu-title {
  color: rgba(255, 255, 255, 0.5); }

.bg-vertical-gradient {
  background: linear-gradient(to right, var(--vz-primary), var(--vz-success)); }

.bg-vertical-gradient-2 {
  background: linear-gradient(to right, var(--vz-info), var(--vz-secondary)); }

.bg-vertical-gradient-3 {
  background: linear-gradient(to right, var(--vz-info), var(--vz-success)); }

.bg-vertical-gradient-4 {
  background: linear-gradient(to right, var(--vz-dark), var(--vz-primary)); }

.sidebar-background {
  position: absolute;
  z-index: -1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: 50%;
  opacity: 0.07; }

[data-sidebar-image="img-1"] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_59___}); }

[data-sidebar-image="img-2"] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_60___}); }

[data-sidebar-image="img-3"] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___}); }

[data-sidebar-image="img-4"] .sidebar-background {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___}); }

[data-layout="semibox"] .page-title-box {
  padding: 10px 0;
  background-color: transparent;
  box-shadow: none;
  margin: -15px 0 1.5rem 0; }

@media (min-width: 768px) {
  [data-layout="semibox"][data-sidebar-size="sm"] .main-content, [data-layout="semibox"][data-sidebar-size="sm-hover"] .main-content {
    margin-left: 70px; }
  [data-layout="semibox"][data-sidebar-size="sm"] #page-topbar, [data-layout="semibox"][data-sidebar-size="sm-hover"] #page-topbar {
    left: 70px; }
  [data-layout="semibox"][data-sidebar-size="sm"] .footer, [data-layout="semibox"][data-sidebar-size="sm-hover"] .footer {
    left: 70px; }
  [data-layout="semibox"][data-sidebar-size="md"] #page-topbar {
    left: 180px; }
  [data-layout="semibox"][data-sidebar-size="md"] .footer {
    left: 180px; } }

@media (min-width: 1440px) {
  [data-layout="semibox"] .page-content {
    padding: calc(70px + 1rem * 2) calc(1rem * 0.5) 60px calc(1rem * 0.5); }
  [data-layout="semibox"] .navbar-menu {
    margin: 25px;
    border-radius: 0.25rem; }
  [data-layout="semibox"] .main-content {
    margin-left: calc(250px + 25px);
    padding: 0 110px; }
  [data-layout="semibox"] .footer {
    left: calc( 250px + 110px + 1rem + 25px);
    right: calc(110px + 1rem); }
  [data-layout="semibox"] #page-topbar {
    left: calc( 250px + 110px + 1rem + 25px);
    right: calc(110px + 1rem);
    top: 25px;
    border-radius: 0.25rem;
    transition: all 0.5s ease; }
    [data-layout="semibox"] #page-topbar.topbar-shadow {
      top: 0px; }
  [data-layout="semibox"][data-sidebar-size="md"] .main-content {
    margin-left: calc(180px + 25px); }
  [data-layout="semibox"][data-sidebar-size="md"] #page-topbar {
    left: calc( 180px + 110px + 1rem + 25px); }
  [data-layout="semibox"][data-sidebar-size="md"] .footer {
    left: calc( 180px + 110px + 1rem + 25px); }
  [data-layout="semibox"][data-sidebar-size="sm"] .main-content {
    margin-left: calc(70px + 25px); }
  [data-layout="semibox"][data-sidebar-size="sm"] .navbar-brand-box {
    top: 25px; }
  [data-layout="semibox"][data-sidebar-size="sm"] #page-topbar {
    left: calc( 70px + 110px + 1rem + 25px); }
  [data-layout="semibox"][data-sidebar-size="sm"] .footer {
    left: calc( 70px + 110px + 1rem + 25px); }
  [data-layout="semibox"][data-sidebar-size="sm-hover"] .main-content {
    margin-left: calc(70px + 25px); }
  [data-layout="semibox"][data-sidebar-size="sm-hover"] #page-topbar {
    left: calc( 70px + 110px + 1rem + 25px); }
  [data-layout="semibox"][data-sidebar-size="sm-hover"] .footer {
    left: calc( 70px + 110px + 1rem + 25px); } }

[data-layout="semibox"] .mx-n4 {
  margin-left: 0px !important;
  margin-right: 0px !important; }
  [data-layout="semibox"] .mx-n4.p-1 {
    padding-left: 0px !important;
    padding-right: 0px !important; }

[data-layout="horizontal"] .main-content {
  margin-left: 0; }

@media (min-width: 1024.1px) {
  [data-layout="horizontal"] .layout-width,
  [data-layout="horizontal"] .container-fluid,
  [data-layout="horizontal"] .container-sm,
  [data-layout="horizontal"] .container-md,
  [data-layout="horizontal"] .container-lg,
  [data-layout="horizontal"] .container-xl,
  [data-layout="horizontal"] .container-xxl {
    max-width: 90%;
    margin: 0 auto; }
  [data-layout="horizontal"] .topnav-hamburger {
    visibility: hidden; } }

[data-layout="horizontal"] .horizontal-logo {
  padding-left: calc(1rem / 2); }
  @media (max-width: 1024.98px) {
    [data-layout="horizontal"] .horizontal-logo {
      padding-left: 1rem; } }

[data-layout="horizontal"] .navbar-menu {
  background: var(--vz-topnav-bg);
  border-right-color: transparent;
  padding: 0 calc(1rem / 2);
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  margin-top: 70px;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 100;
  width: 100%;
  bottom: auto; }
  @media (max-width: 575.98px) {
    [data-layout="horizontal"] .navbar-menu .container-fluid, [data-layout="horizontal"] .navbar-menu .container-sm, [data-layout="horizontal"] .navbar-menu .container-md, [data-layout="horizontal"] .navbar-menu .container-lg, [data-layout="horizontal"] .navbar-menu .container-xl, [data-layout="horizontal"] .navbar-menu .container-xxl {
      padding: 0; } }
  [data-layout="horizontal"] .navbar-menu .navbar-nav {
    flex-direction: row; }
    [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-sm {
      padding-left: 0; }
      [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-sm .nav-link:before {
        opacity: 0 !important; }
      [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-sm .nav-link:hover, [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-sm .nav-link.active {
        color: var(--vz-topnav-item-color-active); }
    [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-link {
      color: var(--vz-topnav-item-color);
      padding: 0.75rem 1.5rem; }
      [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-link i {
        line-height: 1; }
      [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-link.active {
        color: var(--vz-topnav-item-color-active); }
        [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-link.active:after {
          color: var(--vz-topnav-item-color-active); }
        [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-link.active .icon-dual {
          color: var(--vz-topnav-item-color-active);
          fill: rgba(242, 100, 48, 0.1); }
      [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] {
        color: var(--vz-topnav-item-color-active); }
        [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] .icon-dual {
          color: var(--vz-topnav-item-color-active);
          fill: rgba(242, 100, 48, 0.1); }
        [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:after {
          color: var(--vz-topnav-item-color-active); }
      [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-link:hover .icon-dual {
        color: var(--vz-topnav-item-color-active);
        fill: rgba(242, 100, 48, 0.1); }
    [data-layout="horizontal"] .navbar-menu .navbar-nav > .nav-item > .nav-link[data-bs-toggle=collapse]:after {
      right: 0px;
      transform: rotate(90deg) !important; }
    [data-layout="horizontal"] .navbar-menu .navbar-nav > li:nth-of-type(2) > .nav-link.menu-link {
      padding-left: 0; }
  [data-layout="horizontal"] .navbar-menu .navbar-brand-box {
    display: none; }

[data-layout="horizontal"] .navbar-nav .nav-item {
  position: relative; }
  [data-layout="horizontal"] .navbar-nav .nav-item .nav-link[data-bs-toggle=collapse]:after {
    right: 10px;
    transform: rotate(0deg) !important; }
  [data-layout="horizontal"] .navbar-nav .nav-item > .nav-link > .badge {
    display: none; }
  [data-layout="horizontal"] .navbar-nav .nav-item:hover > .nav-link {
    color: var(--vz-topnav-item-color-active); }
    [data-layout="horizontal"] .navbar-nav .nav-item:hover > .nav-link .icon-dual {
      color: var(--vz-topnav-item-color-active);
      fill: rgba(242, 100, 48, 0.1); }
    [data-layout="horizontal"] .navbar-nav .nav-item:hover > .nav-link:after {
      color: var(--vz-topnav-item-color-active); }
  @media (min-width: 1024.1px) {
    [data-layout="horizontal"] .navbar-nav .nav-item:hover > .menu-dropdown {
      display: block;
      height: auto !important; } }
  [data-layout="horizontal"] .navbar-nav .nav-item.active {
    color: var(--vz-topnav-item-color-active); }

[data-layout="horizontal"] .menu-dropdown {
  position: absolute;
  min-width: 12rem;
  padding: 0.5rem 0;
  box-shadow: 0 0px 5px rgba(15, 34, 58, 0.15);
  animation-name: DropDownSlide;
  animation-duration: .3s;
  animation-fill-mode: both;
  margin: 0;
  z-index: 1000;
  background-color: var(--vz-choices-bg);
  background-clip: padding-box;
  border: 0 solid var(--vz-border-color);
  border-radius: 0.3rem;
  display: none; }
  [data-layout="horizontal"] .menu-dropdown .menu-dropdown {
    top: 0;
    left: 100%; }

[data-layout="horizontal"] .mega-dropdown-menu {
  width: 40rem; }

[data-layout="horizontal"] .menu-title {
  display: none; }

[data-layout="horizontal"] .dropdown-custom-right {
  left: -100% !important;
  right: 100%; }

@media (max-width: 1024px) {
  [data-layout="horizontal"] .navbar-menu {
    display: none; }
  [data-layout="horizontal"] .menu .navbar-menu {
    display: block;
    max-height: 360px;
    overflow-y: auto;
    padding-left: 0; }
    [data-layout="horizontal"] .menu .navbar-menu .navbar-nav {
      flex-direction: column; }
      [data-layout="horizontal"] .menu .navbar-menu .navbar-nav > li:nth-of-type(2) > .nav-link.menu-link {
        padding-left: 1.5rem; }
      [data-layout="horizontal"] .menu .navbar-menu .navbar-nav .nav-sm .nav-link:before {
        opacity: 1 !important; }
  [data-layout="horizontal"] .menu .menu-dropdown {
    position: relative;
    min-width: 100%;
    box-shadow: none;
    padding-left: 28px;
    left: 0;
    animation: none;
    padding-top: 0; }
    [data-layout="horizontal"] .menu .menu-dropdown.show {
      display: block; }
  [data-layout="horizontal"] .menu .dropdown-custom-right {
    left: 0 !important; }
  [data-layout="horizontal"] .menu .nav-item .nav-link[data-bs-toggle=collapse]:after {
    right: 0px; }
  [data-layout="horizontal"] .menu .mega-dropdown-menu {
    width: 100%; } }

[data-layout-mode="dark"][data-topbar="light"] .navbar-header .horizontal-logo .logo-dark {
  display: none; }

[data-layout-mode="dark"][data-topbar="light"] .navbar-header .horizontal-logo .logo-light {
  display: block; }

[dir="rtl"][data-layout=horizontal] .navbar-menu .navbar-nav > .nav-item > .nav-link[data-bs-toggle=collapse]:after {
  transform: rotate(-90deg) !important; }

[dir="rtl"][data-layout=horizontal] .navbar-nav .nav-item .nav-link[data-bs-toggle=collapse]:after {
  transform: rotate(-180deg) !important; }

[data-layout="twocolumn"] .app-menu {
  padding-bottom: 0;
  width: 220px;
  left: 70px; }
  [data-layout="twocolumn"] .app-menu .menu-link {
    letter-spacing: .05em;
    cursor: default;
    font-size: 11px;
    text-transform: uppercase;
    color: var(--vz-vertical-menu-title-color) !important;
    font-weight: 600; }
    [data-layout="twocolumn"] .app-menu .menu-link:after {
      display: none !important; }
    [data-layout="twocolumn"] .app-menu .menu-link i {
      display: none; }
  [data-layout="twocolumn"] .app-menu .navbar-nav {
    height: calc(100vh - 70px); }
    @media (max-width: 767.98px) {
      [data-layout="twocolumn"] .app-menu .navbar-nav {
        padding-top: 16px; } }
    [data-layout="twocolumn"] .app-menu .navbar-nav > li:not(.twocolumn-item-show) {
      display: none; }
    [data-layout="twocolumn"] .app-menu .navbar-nav .twocolumn-item-show > div {
      display: block !important;
      height: auto !important; }
    [data-layout="twocolumn"] .app-menu .navbar-nav > .nav-item > .menu-dropdown {
      display: block !important;
      height: auto !important; }
    [data-layout="twocolumn"] .app-menu .navbar-nav .nav-item .menu-dropdown .row {
      margin: 0; }
      [data-layout="twocolumn"] .app-menu .navbar-nav .nav-item .menu-dropdown .row .col-lg-4 {
        width: 100%;
        padding: 0; }
    [data-layout="twocolumn"] .app-menu .navbar-nav .nav-sm .nav-link {
      color: var(--vz-vertical-menu-item-color); }
      [data-layout="twocolumn"] .app-menu .navbar-nav .nav-sm .nav-link.active {
        color: var(--vz-vertical-menu-item-active-color); }
  [data-layout="twocolumn"] .app-menu .container-fluid, [data-layout="twocolumn"] .app-menu .container-sm, [data-layout="twocolumn"] .app-menu .container-md, [data-layout="twocolumn"] .app-menu .container-lg, [data-layout="twocolumn"] .app-menu .container-xl, [data-layout="twocolumn"] .app-menu .container-xxl {
    padding: 0; }

[data-layout="twocolumn"] .main-content {
  margin-left: calc(220px + 70px); }
  @media (max-width: 767.98px) {
    [data-layout="twocolumn"] .main-content {
      margin-left: 70px; } }

[data-layout="twocolumn"] .twocolumn-iconview {
  width: 70px;
  background-color: var(--vz-twocolumn-menu-iconview-bg);
  height: 100%;
  left: -70px;
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  top: 0;
  position: absolute;
  padding: 0;
  text-align: center; }
  [data-layout="twocolumn"] .twocolumn-iconview li {
    position: relative;
    list-style: none; }
    [data-layout="twocolumn"] .twocolumn-iconview li .nav-icon::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0; }
  [data-layout="twocolumn"] .twocolumn-iconview .nav-icon {
    width: 42px;
    height: 42px;
    line-height: 42px;
    color: var(--vz-vertical-menu-item-color);
    z-index: 1;
    font-size: 22px;
    text-align: center;
    border-radius: 3px;
    margin: 5px 0;
    display: inline-flex;
    justify-content: center;
    align-items: center; }
    [data-layout="twocolumn"] .twocolumn-iconview .nav-icon .icon-dual {
      width: 18px;
      color: var(--vz-vertical-menu-item-color); }
    [data-layout="twocolumn"] .twocolumn-iconview .nav-icon.active {
      background-color: rgba(242, 100, 48, 0.15);
      color: #F26430; }
      [data-layout="twocolumn"] .twocolumn-iconview .nav-icon.active .icon-dual {
        color: #F26430;
        fill: rgba(242, 100, 48, 0.1); }

[data-layout="twocolumn"] .menu-title {
  display: none; }

@media (max-width: 991.98px) {
  [data-layout="twocolumn"] .logo span.logo-lg {
    display: block; }
  [data-layout="twocolumn"] .logo span.logo-sm {
    display: none; } }

[data-layout="twocolumn"][data-sidebar="light"] .app-menu .navbar-brand-box .logo-light {
  display: none; }

[data-layout="twocolumn"][data-sidebar="light"] .app-menu .navbar-brand-box .logo-dark {
  display: block; }

[data-layout="twocolumn"][data-sidebar="dark"] .twocolumn-iconview {
  background-color: var(--vz-twocolumn-menu-iconview-bg-dark); }
  [data-layout="twocolumn"][data-sidebar="dark"] .twocolumn-iconview .nav-icon {
    color: var(--vz-twocolumn-menu-item-color-dark); }
    [data-layout="twocolumn"][data-sidebar="dark"] .twocolumn-iconview .nav-icon.active {
      color: var(--vz-twocolumn-menu-item-active-color-dark);
      background-color: var(--vz-twocolumn-menu-item-active-bg-dark); }

[data-layout="twocolumn"][data-sidebar="dark"] .app-menu {
  background-color: var(--vz-twocolumn-menu-bg-dark);
  border-right-color: var(--vz-twocolumn-menu-bg-dark); }
  [data-layout="twocolumn"][data-sidebar="dark"] .app-menu .navbar-brand-box .logo-light {
    display: block; }
  [data-layout="twocolumn"][data-sidebar="dark"] .app-menu .navbar-brand-box .logo-dark {
    display: none; }
  [data-layout="twocolumn"][data-sidebar="dark"] .app-menu .navbar-nav .nav-sm .nav-link {
    color: var(--vz-twocolumn-menu-item-color-dark); }

[data-layout="twocolumn"][data-sidebar="dark"] .navbar-menu .navbar-nav .nav-sm .nav-link:hover, [data-layout="twocolumn"][data-sidebar="dark"] .navbar-menu .navbar-nav .nav-sm .nav-link.active {
  color: var(--vz-twocolumn-menu-item-active-color-dark); }
  [data-layout="twocolumn"][data-sidebar="dark"] .navbar-menu .navbar-nav .nav-sm .nav-link:hover::before, [data-layout="twocolumn"][data-sidebar="dark"] .navbar-menu .navbar-nav .nav-sm .nav-link.active::before {
    background-color: var(--vz-twocolumn-menu-item-active-color-dark) !important; }

[data-layout="twocolumn"][data-sidebar="dark"] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] {
  color: var(--vz-twocolumn-menu-item-active-color-dark); }
  [data-layout="twocolumn"][data-sidebar="dark"] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:before {
    background-color: var(--vz-twocolumn-menu-item-active-color-dark); }
  [data-layout="twocolumn"][data-sidebar="dark"] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]::after {
    color: var(--vz-twocolumn-menu-item-active-color-dark) !important; }

[data-layout="twocolumn"]:is(
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"]) .twocolumn-iconview {
  background-color: var(--vz-twocolumn-menu-iconview-bg-dark); }
  [data-layout="twocolumn"]:is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"]) .twocolumn-iconview .nav-icon {
    color: rgba(255, 255, 255, 0.6); }
    [data-layout="twocolumn"]:is(
    [data-sidebar="gradient"],
    [data-sidebar="gradient-2"],
    [data-sidebar="gradient-3"],
    [data-sidebar="gradient-4"]) .twocolumn-iconview .nav-icon.active {
      color: var(--vz-twocolumn-menu-item-active-color-dark);
      background-color: var(--vz-twocolumn-menu-item-active-bg-dark); }

[data-layout="twocolumn"]:is(
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"]) .app-menu {
  background-color: var(--vz-twocolumn-menu-bg-dark);
  border-right-color: var(--vz-twocolumn-menu-bg-dark); }
  [data-layout="twocolumn"]:is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"]) .app-menu .navbar-brand-box .logo-light {
    display: block; }
  [data-layout="twocolumn"]:is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"]) .app-menu .navbar-brand-box .logo-dark {
    display: none; }
  [data-layout="twocolumn"]:is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"]) .app-menu .navbar-nav .nav-sm .nav-link {
    color: rgba(255, 255, 255, 0.6); }

[data-layout="twocolumn"]:is(
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"]) .navbar-menu .navbar-nav .nav-sm .nav-link:hover, [data-layout="twocolumn"]:is(
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"]) .navbar-menu .navbar-nav .nav-sm .nav-link.active {
  color: var(--vz-twocolumn-menu-item-active-color-dark); }
  [data-layout="twocolumn"]:is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"]) .navbar-menu .navbar-nav .nav-sm .nav-link:hover::before, [data-layout="twocolumn"]:is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"]) .navbar-menu .navbar-nav .nav-sm .nav-link.active::before {
    background-color: var(--vz-twocolumn-menu-item-active-color-dark) !important; }

[data-layout="twocolumn"]:is(
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"]) .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] {
  color: var(--vz-twocolumn-menu-item-active-color-dark); }
  [data-layout="twocolumn"]:is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"]) .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:before {
    background-color: var(--vz-twocolumn-menu-item-active-color-dark); }
  [data-layout="twocolumn"]:is(
  [data-sidebar="gradient"],
  [data-sidebar="gradient-2"],
  [data-sidebar="gradient-3"],
  [data-sidebar="gradient-4"]) .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]::after {
    color: var(--vz-twocolumn-menu-item-active-color-dark) !important; }

[data-layout="twocolumn"]:is(
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"])[data-layout-mode="dark"] .app-menu {
  border-right-color: #495057; }

[data-layout="twocolumn"] .twocolumn-panel .app-menu {
  width: 0;
  border-right: 0; }
  @media (max-width: 575.98px) {
    [data-layout="twocolumn"] .twocolumn-panel .app-menu {
      display: none; } }

[data-layout="twocolumn"] .twocolumn-panel .navbar-brand-box,
[data-layout="twocolumn"] .twocolumn-panel .navbar-nav {
  display: none; }

[data-layout="twocolumn"] .twocolumn-panel .main-content {
  margin-left: 70px; }

[data-layout="twocolumn"] .twocolumn-panel #page-topbar,
[data-layout="twocolumn"] .twocolumn-panel .footer {
  left: 70px; }

@media (max-width: 575.98px) {
  [data-layout="twocolumn"] .twocolumn-panel .main-content {
    margin-left: 0; }
  [data-layout="twocolumn"] .twocolumn-panel #page-topbar,
  [data-layout="twocolumn"] .twocolumn-panel .footer {
    left: 0; } }

@media (max-width: 767.98px) {
  [data-layout="twocolumn"] #page-topbar,
  [data-layout="twocolumn"] .footer {
    left: 70px; } }

@media (max-width: 575.98px) {
  [data-layout="twocolumn"] .main-content {
    margin-left: 0; }
  [data-layout="twocolumn"] #page-topbar,
  [data-layout="twocolumn"] .footer {
    left: 0; } }

[data-layout-width="boxed"] body {
  background-color: var(--vz-boxed-body-bg); }

[data-layout-width="boxed"] #layout-wrapper {
  max-width: 1300px;
  margin: 0 auto;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  background-color: var(--vz-body-bg); }

[data-layout-width="boxed"][data-layout="vertical"] #layout-wrapper {
  min-height: 100vh; }

[data-layout-width="boxed"] #page-topbar,
[data-layout-width="boxed"] .footer {
  max-width: 1300px;
  margin: 0 auto;
  left: 0 !important; }

@media (min-width: 768px) {
  [data-layout-width="boxed"][data-sidebar-size="sm-hover"][data-layout="vertical"] #layout-wrapper, [data-layout-width="boxed"][data-sidebar-size="sm"][data-layout="vertical"] #layout-wrapper {
    min-height: 1400px; } }

@media (max-width: 767.98px) {
  [data-layout-width="boxed"][data-sidebar-size="sm-hover"][data-layout="vertical"] .main-content, [data-layout-width="boxed"][data-sidebar-size="sm"][data-layout="vertical"] .main-content {
    margin-left: 0; } }

[data-layout-width="boxed"][data-sidebar-size="sm-hover"] #page-topbar,
[data-layout-width="boxed"][data-sidebar-size="sm-hover"] .footer, [data-layout-width="boxed"][data-sidebar-size="sm"] #page-topbar,
[data-layout-width="boxed"][data-sidebar-size="sm"] .footer {
  left: 0 !important;
  max-width: calc(1300px - 70px); }
  @media (min-width: 768px) {
    [data-layout-width="boxed"][data-sidebar-size="sm-hover"] #page-topbar,
    [data-layout-width="boxed"][data-sidebar-size="sm-hover"] .footer, [data-layout-width="boxed"][data-sidebar-size="sm"] #page-topbar,
    [data-layout-width="boxed"][data-sidebar-size="sm"] .footer {
      left: 70px !important; } }

[data-layout-width="boxed"][data-sidebar-size="sm-hover-active"] #page-topbar,
[data-layout-width="boxed"][data-sidebar-size="sm-hover-active"] .footer, [data-layout-width="boxed"][data-sidebar-size="lg"] #page-topbar,
[data-layout-width="boxed"][data-sidebar-size="lg"] .footer {
  max-width: calc(1300px - 250px); }
  @media (min-width: 768px) {
    [data-layout-width="boxed"][data-sidebar-size="sm-hover-active"] #page-topbar,
    [data-layout-width="boxed"][data-sidebar-size="sm-hover-active"] .footer, [data-layout-width="boxed"][data-sidebar-size="lg"] #page-topbar,
    [data-layout-width="boxed"][data-sidebar-size="lg"] .footer {
      left: 250px !important; } }

[data-layout-width="boxed"][data-sidebar-size="md"] #page-topbar,
[data-layout-width="boxed"][data-sidebar-size="md"] .footer {
  max-width: calc(1300px - 180px); }
  @media (min-width: 768px) {
    [data-layout-width="boxed"][data-sidebar-size="md"] #page-topbar,
    [data-layout-width="boxed"][data-sidebar-size="md"] .footer {
      left: 180px !important; } }

[data-layout-width="boxed"][data-layout="vertical"][data-layout-style="detached"] body {
  background-color: var(--vz-body-bg); }

@media (min-width: 1024.1px) {
  [data-layout-width="boxed"][data-layout="vertical"][data-layout-style="detached"] #layout-wrapper {
    max-width: 1300px;
    box-shadow: none; }
  [data-layout-width="boxed"][data-layout="vertical"][data-layout-style="detached"] .layout-width {
    max-width: 1300px; } }

[data-layout-width="boxed"][data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm-hover"] #page-topbar,
[data-layout-width="boxed"][data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm-hover"] .footer, [data-layout-width="boxed"][data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm"] #page-topbar,
[data-layout-width="boxed"][data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm"] .footer, [data-layout-width="boxed"][data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="md"] #page-topbar,
[data-layout-width="boxed"][data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="md"] .footer, [data-layout-width="boxed"][data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="lg"] #page-topbar,
[data-layout-width="boxed"][data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="lg"] .footer {
  max-width: 100%;
  left: 0 !important; }

[data-layout="horizontal"][data-layout-width="boxed"] #page-topbar,
[data-layout="horizontal"][data-layout-width="boxed"] #layout-wrapper,
[data-layout="horizontal"][data-layout-width="boxed"] .footer {
  max-width: 100%; }

[data-layout="horizontal"][data-layout-width="boxed"] .container-fluid, [data-layout="horizontal"][data-layout-width="boxed"] .container-sm, [data-layout="horizontal"][data-layout-width="boxed"] .container-md, [data-layout="horizontal"][data-layout-width="boxed"] .container-lg, [data-layout="horizontal"][data-layout-width="boxed"] .container-xl, [data-layout="horizontal"][data-layout-width="boxed"] .container-xxl,
[data-layout="horizontal"][data-layout-width="boxed"] .navbar-header {
  max-width: 1300px; }

[data-layout="horizontal"][data-layout-width="boxed"] .navbar-header {
  padding: 0 calc(1rem / 2) 0 0; }

[data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="sm-hover"] #page-topbar,
[data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="sm-hover"] .footer,
[data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="sm"] [data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="sm-hover-active"] #page-topbar,
[data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="sm"] [data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="sm-hover-active"] .footer, [data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="lg"] #page-topbar,
[data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="lg"] .footer {
  left: 0 !important; }

@media (min-width: 992px) {
  [data-layout-position="scrollable"] #page-topbar,
  [data-layout-position="scrollable"] .navbar-menu {
    position: absolute; }
  [data-layout-position="scrollable"][data-layout="horizontal"] #page-topbar,
  [data-layout-position="scrollable"][data-layout="horizontal"] .topnav {
    position: absolute; } }

@media (min-width: 768px) {
  [data-layout="semibox"][data-sidebar-visibility="hidden"] .navbar-menu {
    display: none; }
  [data-layout="semibox"][data-sidebar-visibility="hidden"] .horizontal-logo {
    display: inline-block;
    width: auto; }
  [data-layout="semibox"][data-sidebar-visibility="hidden"] .footer {
    left: 0; }
  [data-layout="semibox"][data-sidebar-visibility="hidden"] #page-topbar {
    left: 0; }
  [data-layout="semibox"][data-sidebar-visibility="hidden"] .main-content {
    margin-left: 0px; }
  [data-layout="semibox"][data-sidebar-visibility="hidden"][data-sidebar-size="sm"] .navbar-brand-box, [data-layout="semibox"][data-sidebar-visibility="hidden"][data-sidebar-size="sm-hover"] .navbar-brand-box {
    position: static;
    padding: 0 1.3rem; }
  [data-layout="semibox"][data-sidebar-visibility="hidden"][data-sidebar-size="sm"] .logo span.logo-lg, [data-layout="semibox"][data-sidebar-visibility="hidden"][data-sidebar-size="sm-hover"] .logo span.logo-lg {
    display: inline-block; }
  [data-layout="semibox"][data-sidebar-visibility="hidden"][data-sidebar-size="sm"] .logo span.logo-sm, [data-layout="semibox"][data-sidebar-visibility="hidden"][data-sidebar-size="sm-hover"] .logo span.logo-sm {
    display: none; } }

[data-layout="semibox"][data-sidebar-visibility="hidden"]:is(
[data-sidebar="dark"],
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"]) .logo-dark {
  display: inline-block; }

[data-layout="semibox"][data-sidebar-visibility="hidden"]:is(
[data-sidebar="dark"],
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"]) .logo-light {
  display: none; }

[data-layout="semibox"][data-sidebar-visibility="hidden"][data-topbar="dark"]:is(
[data-sidebar="dark"],
[data-sidebar="light"],
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"]) .logo-dark {
  display: none; }

[data-layout="semibox"][data-sidebar-visibility="hidden"][data-topbar="dark"]:is(
[data-sidebar="dark"],
[data-sidebar="light"],
[data-sidebar="gradient"],
[data-sidebar="gradient-2"],
[data-sidebar="gradient-3"],
[data-sidebar="gradient-4"]) .logo-light {
  display: block; }

@media (min-width: 1440px) {
  [data-layout="semibox"][data-sidebar-visibility="hidden"] .navbar-menu {
    display: none; }
  [data-layout="semibox"][data-sidebar-visibility="hidden"] .horizontal-logo {
    display: inline-block;
    width: auto; }
  [data-layout="semibox"][data-sidebar-visibility="hidden"] .footer {
    left: calc(110px + 1rem); }
  [data-layout="semibox"][data-sidebar-visibility="hidden"] #page-topbar {
    left: calc(110px + 1rem); }
  [data-layout="semibox"][data-sidebar-visibility="hidden"] .main-content {
    margin-left: 0px; }
  [data-layout="semibox"][data-sidebar-visibility="hidden"][data-sidebar-size="sm"] .navbar-brand-box, [data-layout="semibox"][data-sidebar-visibility="hidden"][data-sidebar-size="sm-hover"] .navbar-brand-box {
    position: static;
    padding: 0 1.3rem; }
  [data-layout="semibox"][data-sidebar-visibility="hidden"][data-sidebar-size="sm"] .logo span.logo-lg, [data-layout="semibox"][data-sidebar-visibility="hidden"][data-sidebar-size="sm-hover"] .logo span.logo-lg {
    display: inline-block; }
  [data-layout="semibox"][data-sidebar-visibility="hidden"][data-sidebar-size="sm"] .logo span.logo-sm, [data-layout="semibox"][data-sidebar-visibility="hidden"][data-sidebar-size="sm-hover"] .logo span.logo-sm {
    display: none; } }

/*!
 * Waves v0.7.6
 * http://fian.my.id/Waves 
 * 
 * Copyright 2014-2018 Alfiana E. Sibuea and other contributors 
 * Released under the MIT license 
 * https://github.com/fians/Waves/blob/master/LICENSE */
.waves-effect {
  position: relative;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  -webkit-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent; }

.waves-effect .waves-ripple {
  position: absolute;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin-top: -50px;
  margin-left: -50px;
  opacity: 0;
  background: rgba(0, 0, 0, 0.2);
  background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
  transition: all 0.5s ease-out;
  transition-property: transform, opacity;
  transform: scale(0) translate(0, 0);
  pointer-events: none; }

.waves-effect.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
  background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%); }

.waves-effect.waves-classic .waves-ripple {
  background: rgba(0, 0, 0, 0.2); }

.waves-effect.waves-classic.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4); }

.waves-notransition {
  transition: none !important; }

.waves-button,
.waves-circle {
  transform: translateZ(0);
  -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%); }

.waves-button,
.waves-button:hover,
.waves-button:visited,
.waves-button-input {
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  border: none;
  outline: none;
  color: inherit;
  background-color: rgba(0, 0, 0, 0);
  font-size: 1em;
  line-height: 1em;
  text-align: center;
  text-decoration: none;
  z-index: 1; }

.waves-button {
  padding: 0.85em 1.1em;
  border-radius: 0.2em; }

.waves-button-input {
  margin: 0;
  padding: 0.85em 1.1em; }

.waves-input-wrapper {
  border-radius: 0.2em;
  vertical-align: bottom; }

.waves-input-wrapper.waves-button {
  padding: 0; }

.waves-input-wrapper .waves-button-input {
  position: relative;
  top: 0;
  left: 0;
  z-index: 1; }

.waves-circle {
  text-align: center;
  width: 2.5em;
  height: 2.5em;
  line-height: 2.5em;
  border-radius: 50%; }

.waves-float {
  -webkit-mask-image: none;
  box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);
  transition: all 300ms; }

.waves-float:active {
  box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3); }

.waves-block {
  display: block; }

.waves-effect.waves-light .waves-ripple {
  background-color: rgba(255, 255, 255, 0.4); }

.waves-effect.waves-primary .waves-ripple {
  background-color: rgba(242, 100, 48, 0.4); }

.waves-effect.waves-success .waves-ripple {
  background-color: rgba(10, 179, 156, 0.4); }

.waves-effect.waves-info .waves-ripple {
  background-color: rgba(41, 156, 219, 0.4); }

.waves-effect.waves-warning .waves-ripple {
  background-color: rgba(63, 191, 72, 0.4); }

.waves-effect.waves-danger .waves-ripple {
  background-color: rgba(240, 101, 72, 0.4); }

.avatar-xxs {
  height: 1.5rem;
  width: 1.5rem; }

.avatar-xs {
  height: 2rem;
  width: 2rem; }

.avatar-sm {
  height: 3rem;
  width: 3rem; }

.avatar-md {
  height: 4.5rem;
  width: 4.5rem; }

.avatar-lg {
  height: 6rem;
  width: 6rem; }

.avatar-xl {
  height: 7.5rem;
  width: 7.5rem; }

.avatar-title {
  align-items: center;
  background-color: #F26430;
  color: #fff;
  display: flex;
  font-weight: 500;
  height: 100%;
  justify-content: center;
  width: 100%; }

.avatar-group {
  padding-left: 12px;
  display: flex;
  flex-wrap: wrap; }
  .avatar-group .avatar-group-item {
    margin-left: -12px;
    border: 2px solid var(--vz-card-bg-custom);
    border-radius: 50%;
    transition: all 0.2s; }
    .avatar-group .avatar-group-item:hover {
      position: relative;
      transform: translateY(-2px);
      z-index: 1; }

.accordion .accordion-button {
  font-weight: 500; }

.accordion .accordion-body {
  color: #878a99; }

.accordion.accordion-icon-none .accordion-button::after {
  content: "";
  background-image: none !important; }

.accordion.accordion-icon-none .accordion-button:not(.collapsed)::after {
  content: ""; }

.custom-accordionwithicon .accordion-button::after {
  background-image: none !important;
  font-family: "Material Design Icons";
  content: "\\F0142";
  font-size: 1.1rem;
  vertical-align: middle;
  line-height: 0.8; }

.custom-accordionwithicon .accordion-button:not(.collapsed)::after {
  background-image: none !important;
  content: "\\F0140";
  margin-right: -3px; }

.custom-accordionwithicon-plus .accordion-button::after {
  background-image: none !important;
  font-family: "Material Design Icons";
  content: "\\F0415";
  font-size: 1.1rem;
  vertical-align: middle;
  line-height: 0.8; }

.custom-accordionwithicon-plus .accordion-button:not(.collapsed)::after {
  background-image: none !important;
  content: "\\F0374";
  margin-right: -3px; }

.lefticon-accordion .accordion-button {
  padding-left: 2.75rem; }
  .lefticon-accordion .accordion-button::after {
    position: absolute;
    left: 1.25rem;
    top: 14px; }
  .lefticon-accordion .accordion-button:not(.collapsed)::after {
    top: 20px; }

.accordion-border-box .accordion-item {
  border-top: 1px solid var(--vz-border-color);
  border-radius: 0.25rem; }
  .accordion-border-box .accordion-item:not(:first-of-type) {
    margin-top: 8px; }
  .accordion-border-box .accordion-item .accordion-button {
    border-radius: 0.25rem; }
    .accordion-border-box .accordion-item .accordion-button:not(.collapsed) {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0; }

.custom-accordion-border .accordion-item {
  border-left: 3px solid var(--vz-border-color); }

.accordion-primary .accordion-item {
  border-color: rgba(242, 100, 48, 0.6); }
  .accordion-primary .accordion-item .accordion-button {
    box-shadow: none; }
    .accordion-primary .accordion-item .accordion-button:not(.collapsed) {
      color: #F26430;
      background-color: rgba(242, 100, 48, 0.1) !important; }
    .accordion-primary .accordion-item .accordion-button::after {
      color: #F26430; }

.accordion-fill-primary .accordion-item .accordion-button {
  box-shadow: none; }
  .accordion-fill-primary .accordion-item .accordion-button:not(.collapsed) {
    color: #fff;
    background-color: #F26430 !important; }

.accordion-secondary .accordion-item {
  border-color: rgba(32, 140, 59, 0.6); }
  .accordion-secondary .accordion-item .accordion-button {
    box-shadow: none; }
    .accordion-secondary .accordion-item .accordion-button:not(.collapsed) {
      color: #208C3B;
      background-color: rgba(32, 140, 59, 0.1) !important; }
    .accordion-secondary .accordion-item .accordion-button::after {
      color: #208C3B; }

.accordion-fill-secondary .accordion-item .accordion-button {
  box-shadow: none; }
  .accordion-fill-secondary .accordion-item .accordion-button:not(.collapsed) {
    color: #fff;
    background-color: #208C3B !important; }

.accordion-success .accordion-item {
  border-color: rgba(10, 179, 156, 0.6); }
  .accordion-success .accordion-item .accordion-button {
    box-shadow: none; }
    .accordion-success .accordion-item .accordion-button:not(.collapsed) {
      color: #0ab39c;
      background-color: rgba(10, 179, 156, 0.1) !important; }
    .accordion-success .accordion-item .accordion-button::after {
      color: #0ab39c; }

.accordion-fill-success .accordion-item .accordion-button {
  box-shadow: none; }
  .accordion-fill-success .accordion-item .accordion-button:not(.collapsed) {
    color: #fff;
    background-color: #0ab39c !important; }

.accordion-info .accordion-item {
  border-color: rgba(41, 156, 219, 0.6); }
  .accordion-info .accordion-item .accordion-button {
    box-shadow: none; }
    .accordion-info .accordion-item .accordion-button:not(.collapsed) {
      color: #299cdb;
      background-color: rgba(41, 156, 219, 0.1) !important; }
    .accordion-info .accordion-item .accordion-button::after {
      color: #299cdb; }

.accordion-fill-info .accordion-item .accordion-button {
  box-shadow: none; }
  .accordion-fill-info .accordion-item .accordion-button:not(.collapsed) {
    color: #fff;
    background-color: #299cdb !important; }

.accordion-warning .accordion-item {
  border-color: rgba(63, 191, 72, 0.6); }
  .accordion-warning .accordion-item .accordion-button {
    box-shadow: none; }
    .accordion-warning .accordion-item .accordion-button:not(.collapsed) {
      color: #3FBF48;
      background-color: rgba(63, 191, 72, 0.1) !important; }
    .accordion-warning .accordion-item .accordion-button::after {
      color: #3FBF48; }

.accordion-fill-warning .accordion-item .accordion-button {
  box-shadow: none; }
  .accordion-fill-warning .accordion-item .accordion-button:not(.collapsed) {
    color: #fff;
    background-color: #3FBF48 !important; }

.accordion-danger .accordion-item {
  border-color: rgba(240, 101, 72, 0.6); }
  .accordion-danger .accordion-item .accordion-button {
    box-shadow: none; }
    .accordion-danger .accordion-item .accordion-button:not(.collapsed) {
      color: #f06548;
      background-color: rgba(240, 101, 72, 0.1) !important; }
    .accordion-danger .accordion-item .accordion-button::after {
      color: #f06548; }

.accordion-fill-danger .accordion-item .accordion-button {
  box-shadow: none; }
  .accordion-fill-danger .accordion-item .accordion-button:not(.collapsed) {
    color: #fff;
    background-color: #f06548 !important; }

.accordion-light .accordion-item {
  border-color: rgba(243, 246, 249, 0.6); }
  .accordion-light .accordion-item .accordion-button {
    box-shadow: none; }
    .accordion-light .accordion-item .accordion-button:not(.collapsed) {
      color: #f3f6f9;
      background-color: rgba(243, 246, 249, 0.1) !important; }
    .accordion-light .accordion-item .accordion-button::after {
      color: #f3f6f9; }

.accordion-fill-light .accordion-item .accordion-button {
  box-shadow: none; }
  .accordion-fill-light .accordion-item .accordion-button:not(.collapsed) {
    color: #fff;
    background-color: #f3f6f9 !important; }

.accordion-dark .accordion-item {
  border-color: rgba(33, 37, 41, 0.6); }
  .accordion-dark .accordion-item .accordion-button {
    box-shadow: none; }
    .accordion-dark .accordion-item .accordion-button:not(.collapsed) {
      color: #212529;
      background-color: rgba(33, 37, 41, 0.1) !important; }
    .accordion-dark .accordion-item .accordion-button::after {
      color: #212529; }

.accordion-fill-dark .accordion-item .accordion-button {
  box-shadow: none; }
  .accordion-fill-dark .accordion-item .accordion-button:not(.collapsed) {
    color: #fff;
    background-color: #212529 !important; }

[data-layout-mode="dark"] .accordion-button:not(.collapsed) {
  color: var(--vz-accordion-button-active-color); }
  [data-layout-mode="dark"] .accordion-button:not(.collapsed):after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___}); }

[data-layout-mode="dark"] .accordion-button:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___}); }

[dir="rtl"] .custom-accordionwithicon .accordion-button::after {
  transform: rotate(180deg); }

.fs-10 {
  font-size: 10px !important; }

.fs-11 {
  font-size: 11px !important; }

.fs-12 {
  font-size: 12px !important; }

.fs-13 {
  font-size: 13px !important; }

.fs-14 {
  font-size: 14px !important; }

.fs-15 {
  font-size: 15px !important; }

.fs-16 {
  font-size: 16px !important; }

.fs-17 {
  font-size: 17px !important; }

.fs-18 {
  font-size: 18px !important; }

.fs-19 {
  font-size: 19px !important; }

.fs-20 {
  font-size: 20px !important; }

.fs-21 {
  font-size: 21px !important; }

.fs-22 {
  font-size: 22px !important; }

.fs-23 {
  font-size: 23px !important; }

.fs-24 {
  font-size: 24px !important; }

.fs-36 {
  font-size: 36px !important; }

.fs-48 {
  font-size: 48px !important; }

.border-dark {
  border-color: var(--vz-dark) !important; }

.border-light {
  border-color: var(--vz-light) !important; }

.border-double {
  border-style: double !important; }

.border-top-double {
  border-top-style: double !important; }

.border-bottom-double {
  border-bottom-style: double !important; }

.border-end-double {
  border-right-style: double !important; }

.border-start-double {
  border-left-style: double !important; }

.list-group-flush.border-double {
  border: none !important; }
  .list-group-flush.border-double .list-group-item {
    border-style: double !important; }

.border-dashed {
  border-style: dashed !important; }

.border-top-dashed {
  border-top-style: dashed !important; }

.border-bottom-dashed {
  border-bottom-style: dashed !important; }

.border-end-dashed {
  border-right-style: dashed !important; }

.border-start-dashed {
  border-left-style: dashed !important; }

.list-group-flush.border-dashed {
  border: none !important; }
  .list-group-flush.border-dashed .list-group-item {
    border-style: dashed !important; }

.border-groove {
  border-style: groove !important; }

.border-top-groove {
  border-top-style: groove !important; }

.border-bottom-groove {
  border-bottom-style: groove !important; }

.border-end-groove {
  border-right-style: groove !important; }

.border-start-groove {
  border-left-style: groove !important; }

.list-group-flush.border-groove {
  border: none !important; }
  .list-group-flush.border-groove .list-group-item {
    border-style: groove !important; }

.border-outset {
  border-style: outset !important; }

.border-top-outset {
  border-top-style: outset !important; }

.border-bottom-outset {
  border-bottom-style: outset !important; }

.border-end-outset {
  border-right-style: outset !important; }

.border-start-outset {
  border-left-style: outset !important; }

.list-group-flush.border-outset {
  border: none !important; }
  .list-group-flush.border-outset .list-group-item {
    border-style: outset !important; }

.border-ridge {
  border-style: ridge !important; }

.border-top-ridge {
  border-top-style: ridge !important; }

.border-bottom-ridge {
  border-bottom-style: ridge !important; }

.border-end-ridge {
  border-right-style: ridge !important; }

.border-start-ridge {
  border-left-style: ridge !important; }

.list-group-flush.border-ridge {
  border: none !important; }
  .list-group-flush.border-ridge .list-group-item {
    border-style: ridge !important; }

.border-dotted {
  border-style: dotted !important; }

.border-top-dotted {
  border-top-style: dotted !important; }

.border-bottom-dotted {
  border-bottom-style: dotted !important; }

.border-end-dotted {
  border-right-style: dotted !important; }

.border-start-dotted {
  border-left-style: dotted !important; }

.list-group-flush.border-dotted {
  border: none !important; }
  .list-group-flush.border-dotted .list-group-item {
    border-style: dotted !important; }

.border-inset {
  border-style: inset !important; }

.border-top-inset {
  border-top-style: inset !important; }

.border-bottom-inset {
  border-bottom-style: inset !important; }

.border-end-inset {
  border-right-style: inset !important; }

.border-start-inset {
  border-left-style: inset !important; }

.list-group-flush.border-inset {
  border: none !important; }
  .list-group-flush.border-inset .list-group-item {
    border-style: inset !important; }

[data-layout-mode="dark"] .link-dark, [data-layout-mode="dark"] .link-light {
  color: var(--vz-dark) !important; }
  [data-layout-mode="dark"] .link-dark:is(:focus, :hover), [data-layout-mode="dark"] .link-light:is(:focus, :hover) {
    color: rgba(var(--vz-dark-rgb), 0.75) !important; }

.ff-base {
  font-family: var(--vz-font-sans-serif); }

.ff-secondary {
  font-family: "hkgrotesk", sans-serif; }

.fw-medium {
  font-weight: 500; }

.flex-1 {
  flex: 1 1; }

.social-list-item {
  height: 2rem;
  width: 2rem;
  line-height: calc(2rem - 4px);
  display: block;
  border: 2px solid #adb5bd;
  border-radius: 50%;
  color: #adb5bd;
  text-align: center;
  transition: all 0.4s; }
  .social-list-item:hover {
    color: #878a99;
    background-color: #eff2f7; }

.bg-pattern {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_65___}) #fff; }

.w-xs {
  min-width: 80px; }

.w-sm {
  min-width: 95px; }

.w-md {
  min-width: 110px; }

.w-lg {
  min-width: 140px; }

.w-xl {
  min-width: 160px; }

.icon-xs {
  height: 16px;
  width: 16px; }

.icon-sm {
  height: 18px;
  width: 18px; }

.icon-md {
  height: 22px;
  width: 22px; }

.icon-lg {
  height: 24px;
  width: 24px; }

.icon-xl {
  height: 28px;
  width: 28px; }

.icon-xxl {
  height: 32px;
  width: 32px; }

.icon-dual {
  color: #adb5bd;
  fill: rgba(173, 181, 189, 0.16); }

.icon-dual-primary {
  color: #F26430;
  fill: rgba(242, 100, 48, 0.16); }

.icon-dual-secondary {
  color: #208C3B;
  fill: rgba(32, 140, 59, 0.16); }

.icon-dual-success {
  color: #0ab39c;
  fill: rgba(10, 179, 156, 0.16); }

.icon-dual-info {
  color: #299cdb;
  fill: rgba(41, 156, 219, 0.16); }

.icon-dual-warning {
  color: #3FBF48;
  fill: rgba(63, 191, 72, 0.16); }

.icon-dual-danger {
  color: #f06548;
  fill: rgba(240, 101, 72, 0.16); }

.icon-dual-light {
  color: #f3f6f9;
  fill: rgba(243, 246, 249, 0.16); }

.icon-dual-dark {
  color: #212529;
  fill: rgba(33, 37, 41, 0.16); }

.search-box {
  position: relative; }
  .search-box .form-control {
    padding-left: 40px; }
  .search-box .search-icon {
    font-size: 14px;
    position: absolute;
    left: 13px;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
    color: #878a99; }

.bg-overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
  opacity: 0.1;
  background-color: #000; }

.customizer-setting {
  position: fixed;
  bottom: 40px;
  right: 20px;
  z-index: 1000; }

code {
  -webkit-user-select: all;
          user-select: all; }

.layout-rightside {
  width: 280px;
  margin-right: -1rem;
  margin-top: calc(1px - 1rem * 1.1);
  height: calc(100% + 1rem * 1.1); }

@media (max-width: 1699.98px) {
  .layout-rightside-col {
    display: none;
    position: fixed !important;
    height: 100vh;
    right: 0px;
    top: 0px;
    bottom: 0px;
    z-index: 1004; }
    .layout-rightside-col .overlay {
      position: fixed;
      top: 0;
      right: 0px;
      bottom: 0px;
      left: 0px;
      background-color: rgba(33, 37, 41, 0.2); }
    .layout-rightside-col .layout-rightside {
      margin-top: 0px;
      height: 100%;
      margin-left: auto; }
    .layout-rightside-col .card-body {
      overflow-y: auto;
      padding-bottom: 1rem !important; } }

@media (min-width: 1700px) {
  [data-layout="horizontal"] .layout-rightside, [data-layout-style=detached] .layout-rightside {
    margin-top: calc(28px - 1rem);
    margin-right: 0;
    height: calc(100% - calc(1rem / 5)); } }

.object-cover {
  object-fit: cover; }

.text-truncate-two-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  white-space: normal; }

.favourite-btn {
  border-color: transparent; }
  .favourite-btn .ri-star-fill {
    color: #878a99; }
  .favourite-btn.active {
    border-color: transparent; }
    .favourite-btn.active .ri-star-fill {
      color: #3FBF48; }
      .favourite-btn.active .ri-star-fill:before {
        content: "\\f186"; }

.card-logo-light {
  display: var(--vz-card-logo-light); }

.card-logo-dark {
  display: var(--vz-card-logo-dark); }

[data-layout-mode="dark"] .btn-close {
  filter: invert(1) grayscale(100%) brightness(200%); }

#back-to-top {
  position: fixed;
  bottom: 100px;
  right: 28px;
  transition: all 0.5s ease;
  display: none;
  z-index: 1000; }
  #back-to-top:hover {
    animation: fade-up 1.5s infinite linear; }

@keyframes fade-up {
  0% {
    transform: translateY(0);
    opacity: 1; }
  75% {
    transform: translateY(-20px);
    opacity: 0; } }

.cursor-pointer {
  cursor: pointer; }

#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--vz-card-bg-custom);
  z-index: 9999; }

[data-preloader="disable"] #preloader {
  opacity: 0;
  visibility: hidden; }

#status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px; }

:is([type="tel"], [type="url"], [type="email"], [type="number"])::placeholder {
  text-align: left; }

.main-chart .chart-border-left {
  border-left: 1.4px solid var(--vz-border-color);
  padding: 2px 20px; }
  .main-chart .chart-border-left:last-child {
    margin-right: 0px; }

/* Activity */
.activity-feed {
  list-style: none; }
  .activity-feed .feed-item {
    position: relative;
    padding-bottom: 27px;
    padding-left: 16px;
    border-left: 2px solid #f3f6f9; }
    .activity-feed .feed-item:after {
      content: "";
      display: block;
      position: absolute;
      top: 4px;
      left: -6px;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      border: 2px solid #F26430;
      background-color: #fff; }
    .activity-feed .feed-item:last-child {
      border-color: transparent; }

.mini-stats-wid {
  position: relative; }
  .mini-stats-wid .mini-stat-icon {
    overflow: hidden;
    position: relative; }
    .mini-stats-wid .mini-stat-icon:before, .mini-stats-wid .mini-stat-icon:after {
      content: "";
      position: absolute;
      width: 8px;
      height: 69px;
      background-color: rgba(10, 179, 156, 0.1);
      left: 3px;
      transform: rotate(32deg);
      top: -8px;
      transition: all 0.4s; }
    .mini-stats-wid .mini-stat-icon::after {
      left: 27px;
      width: 8px;
      transition: all 0.2s; }
  .mini-stats-wid:hover .mini-stat-icon::after {
    left: 60px; }
  .mini-stats-wid:hover .mini-stat-icon::before {
    left: 50px; }

.card-wrapper .jp-card .jp-card-back, .card-wrapper .jp-card .jp-card-front {
  background-color: #0ab39c; }

.notification-elem {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: var(--vz-card-bg-custom);
  display: flex;
  align-items: center;
  justify-content: center;
  visibility: hidden;
  opacity: 0; }

.clothes-size li input[type="radio"] {
  display: none; }

.clothes-size li label {
  display: inline-block;
  font-size: 14px;
  border-radius: 5px;
  border: 1px solid var(--vz-border-color);
  text-transform: none;
  letter-spacing: 0;
  color: #F26430; }

.clothes-size li input[type="radio"]:checked + label {
  background-color: #F26430;
  border-color: #F26430;
  color: #fff; }

.button-items {
  margin-left: -8px;
  margin-bottom: -12px; }
  .button-items .btn {
    margin-bottom: 12px;
    margin-left: 8px; }

.bs-example-modal {
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  z-index: 1;
  display: block; }

[dir="rtl"] .modal-open {
  padding-left: 0px !important; }

.icon-demo-content {
  color: var(--vz-gray-500); }
  .icon-demo-content i {
    font-size: 24px;
    margin-right: 10px;
    color: var(--vz-gray-600);
    transition: all 0.4s;
    vertical-align: middle; }
  .icon-demo-content svg {
    margin-right: 10px;
    transition: all 0.4s;
    height: 20px; }
  .icon-demo-content .col-lg-4 {
    margin-top: 24px; }
    .icon-demo-content .col-lg-4:hover i, .icon-demo-content .col-lg-4:hover svg {
      color: #F26430;
      transform: scale(1.5); }

.grid-structure .grid-container {
  background-color: #f3f6f9;
  margin-top: 10px;
  font-size: .8rem;
  font-weight: 500;
  padding: 10px 20px; }

.img-switch .card-radio .form-check-input {
  display: none; }
  .img-switch .card-radio .form-check-input:checked + .form-check-label::before {
    content: "";
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(242, 100, 48, 0.5); }
  .img-switch .card-radio .form-check-input:checked + .form-check-label::after {
    content: '\\eb80';
    font-family: "remixicon";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateY(-50%) translateX(-50%);
    font-size: 18px;
    color: #fff; }

[data-bs-target="#collapseBgGradient"].active {
  border-color: #F26430 !important; }
  [data-bs-target="#collapseBgGradient"].active::before {
    content: "\\eb80";
    font-family: remixicon;
    position: absolute;
    top: 2px;
    right: 6px;
    font-size: 16px;
    color: #F26430; }

[data-layout-mode="dark"] .colorscheme-cardradio .form-check-label {
  background-color: var(--vz-dark); }

[data-layout-mode="dark"] .colorscheme-cardradio .bg-light {
  background-color: rgba(var(--vz-light-rgb), 0.1) !important; }

[data-layout-mode="dark"] .colorscheme-cardradio .bg-soft-light {
  background-color: rgba(var(--vz-dark-rgb), 0.1) !important; }

[data-layout-mode="dark"] .colorscheme-cardradio .dark .bg-dark {
  background-color: var(--vz-card-bg-custom) !important; }

@media print {
  .vertical-menu,
  .right-bar,
  .page-title-box,
  .navbar-header,
  .app-menu,
  .footer,
  #back-to-top {
    display: none !important; }
  .card-body,
  .main-content,
  .right-bar,
  .page-content,
  body {
    padding: 0;
    margin: 0; }
  .card {
    border: 0;
    box-shadow: none !important; }
  .invoice-details .d-sm-flex {
    display: flex !important; }
  .address.col-sm-6 {
    flex: 0 0 auto !important;
    width: 50% !important;
    max-width: 100% !important; } }

.ribbon-box {
  position: relative;
  /* Ribbon two */ }
  .ribbon-box .ribbon {
    padding: 5px 12px;
    box-shadow: 2px 5px 10px rgba(33, 37, 41, 0.15);
    color: #fff;
    font-size: 0.8125rem;
    font-weight: 600;
    position: absolute;
    left: -1px;
    top: 5px; }
    .ribbon-box .ribbon.round-shape {
      border-radius: 0 30px 30px 0; }
    .ribbon-box .ribbon.ribbon-shape {
      display: inline-block; }
      .ribbon-box .ribbon.ribbon-shape::before {
        content: "";
        position: absolute;
        right: -17px;
        top: 0;
        border: 14px solid transparent; }
      .ribbon-box .ribbon.ribbon-shape::after {
        content: "";
        position: absolute;
        right: -17px;
        bottom: 0;
        border: 14px solid transparent; }
  .ribbon-box.ribbon-circle .ribbon {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 20px;
    top: 20px; }
  .ribbon-box.ribbon-fill {
    overflow: hidden; }
    .ribbon-box.ribbon-fill .ribbon {
      transform: rotate(-45deg);
      width: 93px;
      height: 52px;
      left: -36px;
      top: -16px;
      display: flex;
      justify-content: center;
      align-items: flex-end; }
    .ribbon-box.ribbon-fill.ribbon-sm .ribbon {
      padding: 2px 12px;
      width: 78px;
      height: 42px;
      font-size: 12px;
      box-shadow: none; }
  .ribbon-box.right .ribbon {
    position: absolute;
    left: auto;
    right: 0; }
    .ribbon-box.right .ribbon.round-shape {
      border-radius: 30px 0 0 30px; }
    .ribbon-box.right .ribbon.ribbon-shape {
      text-align: right; }
      .ribbon-box.right .ribbon.ribbon-shape::before, .ribbon-box.right .ribbon.ribbon-shape::after {
        right: auto;
        left: -17px;
        border-left-color: transparent; }
  .ribbon-box.right.ribbon-circle .ribbon {
    left: auto;
    right: 20px; }
  .ribbon-box.right .icon-ribbon {
    right: 24px;
    left: auto; }
  .ribbon-box.right.ribbon-fill .ribbon {
    transform: rotate(45deg);
    right: -38px;
    left: auto; }
  .ribbon-box.right.ribbon-box .ribbon-two {
    left: auto;
    right: -5px; }
    .ribbon-box.right.ribbon-box .ribbon-two span {
      left: auto;
      right: -21px;
      transform: rotate(45deg); }
  .ribbon-box .ribbon-content {
    clear: both; }
  .ribbon-box .ribbon-primary {
    background: #F26430; }
    .ribbon-box .ribbon-primary:before {
      border-color: #e1470e transparent transparent; }
    .ribbon-box .ribbon-primary.ribbon-shape::before {
      border-left-color: #F26430;
      border-top-color: #F26430; }
    .ribbon-box .ribbon-primary.ribbon-shape::after {
      border-left-color: #F26430;
      border-bottom-color: #F26430; }
  .ribbon-box.right .ribbon-primary {
    background: #F26430; }
    .ribbon-box.right .ribbon-primary.ribbon-shape::before {
      border-right-color: #F26430;
      border-top-color: #F26430; }
    .ribbon-box.right .ribbon-primary.ribbon-shape::after {
      border-right-color: #F26430;
      border-bottom-color: #F26430; }
  .ribbon-box .ribbon-secondary {
    background: #208C3B; }
    .ribbon-box .ribbon-secondary:before {
      border-color: #17622a transparent transparent; }
    .ribbon-box .ribbon-secondary.ribbon-shape::before {
      border-left-color: #208C3B;
      border-top-color: #208C3B; }
    .ribbon-box .ribbon-secondary.ribbon-shape::after {
      border-left-color: #208C3B;
      border-bottom-color: #208C3B; }
  .ribbon-box.right .ribbon-secondary {
    background: #208C3B; }
    .ribbon-box.right .ribbon-secondary.ribbon-shape::before {
      border-right-color: #208C3B;
      border-top-color: #208C3B; }
    .ribbon-box.right .ribbon-secondary.ribbon-shape::after {
      border-right-color: #208C3B;
      border-bottom-color: #208C3B; }
  .ribbon-box .ribbon-success {
    background: #0ab39c; }
    .ribbon-box .ribbon-success:before {
      border-color: #078372 transparent transparent; }
    .ribbon-box .ribbon-success.ribbon-shape::before {
      border-left-color: #0ab39c;
      border-top-color: #0ab39c; }
    .ribbon-box .ribbon-success.ribbon-shape::after {
      border-left-color: #0ab39c;
      border-bottom-color: #0ab39c; }
  .ribbon-box.right .ribbon-success {
    background: #0ab39c; }
    .ribbon-box.right .ribbon-success.ribbon-shape::before {
      border-right-color: #0ab39c;
      border-top-color: #0ab39c; }
    .ribbon-box.right .ribbon-success.ribbon-shape::after {
      border-right-color: #0ab39c;
      border-bottom-color: #0ab39c; }
  .ribbon-box .ribbon-info {
    background: #299cdb; }
    .ribbon-box .ribbon-info:before {
      border-color: #1e7eb3 transparent transparent; }
    .ribbon-box .ribbon-info.ribbon-shape::before {
      border-left-color: #299cdb;
      border-top-color: #299cdb; }
    .ribbon-box .ribbon-info.ribbon-shape::after {
      border-left-color: #299cdb;
      border-bottom-color: #299cdb; }
  .ribbon-box.right .ribbon-info {
    background: #299cdb; }
    .ribbon-box.right .ribbon-info.ribbon-shape::before {
      border-right-color: #299cdb;
      border-top-color: #299cdb; }
    .ribbon-box.right .ribbon-info.ribbon-shape::after {
      border-right-color: #299cdb;
      border-bottom-color: #299cdb; }
  .ribbon-box .ribbon-warning {
    background: #3FBF48; }
    .ribbon-box .ribbon-warning:before {
      border-color: #32993a transparent transparent; }
    .ribbon-box .ribbon-warning.ribbon-shape::before {
      border-left-color: #3FBF48;
      border-top-color: #3FBF48; }
    .ribbon-box .ribbon-warning.ribbon-shape::after {
      border-left-color: #3FBF48;
      border-bottom-color: #3FBF48; }
  .ribbon-box.right .ribbon-warning {
    background: #3FBF48; }
    .ribbon-box.right .ribbon-warning.ribbon-shape::before {
      border-right-color: #3FBF48;
      border-top-color: #3FBF48; }
    .ribbon-box.right .ribbon-warning.ribbon-shape::after {
      border-right-color: #3FBF48;
      border-bottom-color: #3FBF48; }
  .ribbon-box .ribbon-danger {
    background: #f06548; }
    .ribbon-box .ribbon-danger:before {
      border-color: #ec3d19 transparent transparent; }
    .ribbon-box .ribbon-danger.ribbon-shape::before {
      border-left-color: #f06548;
      border-top-color: #f06548; }
    .ribbon-box .ribbon-danger.ribbon-shape::after {
      border-left-color: #f06548;
      border-bottom-color: #f06548; }
  .ribbon-box.right .ribbon-danger {
    background: #f06548; }
    .ribbon-box.right .ribbon-danger.ribbon-shape::before {
      border-right-color: #f06548;
      border-top-color: #f06548; }
    .ribbon-box.right .ribbon-danger.ribbon-shape::after {
      border-right-color: #f06548;
      border-bottom-color: #f06548; }
  .ribbon-box .ribbon-light {
    background: #f3f6f9; }
    .ribbon-box .ribbon-light:before {
      border-color: #d1dde8 transparent transparent; }
    .ribbon-box .ribbon-light.ribbon-shape::before {
      border-left-color: #f3f6f9;
      border-top-color: #f3f6f9; }
    .ribbon-box .ribbon-light.ribbon-shape::after {
      border-left-color: #f3f6f9;
      border-bottom-color: #f3f6f9; }
  .ribbon-box.right .ribbon-light {
    background: #f3f6f9; }
    .ribbon-box.right .ribbon-light.ribbon-shape::before {
      border-right-color: #f3f6f9;
      border-top-color: #f3f6f9; }
    .ribbon-box.right .ribbon-light.ribbon-shape::after {
      border-right-color: #f3f6f9;
      border-bottom-color: #f3f6f9; }
  .ribbon-box .ribbon-dark {
    background: #212529; }
    .ribbon-box .ribbon-dark:before {
      border-color: #0a0c0d transparent transparent; }
    .ribbon-box .ribbon-dark.ribbon-shape::before {
      border-left-color: #212529;
      border-top-color: #212529; }
    .ribbon-box .ribbon-dark.ribbon-shape::after {
      border-left-color: #212529;
      border-bottom-color: #212529; }
  .ribbon-box.right .ribbon-dark {
    background: #212529; }
    .ribbon-box.right .ribbon-dark.ribbon-shape::before {
      border-right-color: #212529;
      border-top-color: #212529; }
    .ribbon-box.right .ribbon-dark.ribbon-shape::after {
      border-right-color: #212529;
      border-bottom-color: #212529; }
  .ribbon-box .icon-ribbon {
    box-shadow: none;
    left: 24px;
    top: -12px;
    font-size: 40px;
    padding: 0; }
  .ribbon-box .ribbon-two {
    position: absolute;
    left: -5px;
    top: -5px;
    z-index: 1;
    overflow: hidden;
    width: 75px;
    height: 75px;
    text-align: right; }
    .ribbon-box .ribbon-two span {
      font-size: 13px;
      color: #fff;
      text-align: center;
      line-height: 20px;
      transform: rotate(-45deg);
      width: 100px;
      display: block;
      box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);
      position: absolute;
      top: 19px;
      left: -21px;
      font-weight: 600; }
      .ribbon-box .ribbon-two span:before {
        content: "";
        position: absolute;
        left: 0;
        top: 100%;
        z-index: -1;
        border-right: 3px solid transparent;
        border-bottom: 3px solid transparent; }
      .ribbon-box .ribbon-two span:after {
        content: "";
        position: absolute;
        right: 0;
        top: 100%;
        z-index: -1;
        border-left: 3px solid transparent;
        border-bottom: 3px solid transparent; }
  .ribbon-box .ribbon-two-primary span {
    background: #F26430; }
    .ribbon-box .ribbon-two-primary span:before {
      border-left: 3px solid #c93f0d;
      border-top: 3px solid #c93f0d; }
    .ribbon-box .ribbon-two-primary span:after {
      border-right: 3px solid #c93f0d;
      border-top: 3px solid #c93f0d; }
  .ribbon-box .ribbon-two-secondary span {
    background: #208C3B; }
    .ribbon-box .ribbon-two-secondary span:before {
      border-left: 3px solid #124e21;
      border-top: 3px solid #124e21; }
    .ribbon-box .ribbon-two-secondary span:after {
      border-right: 3px solid #124e21;
      border-top: 3px solid #124e21; }
  .ribbon-box .ribbon-two-success span {
    background: #0ab39c; }
    .ribbon-box .ribbon-two-success span:before {
      border-left: 3px solid #066b5d;
      border-top: 3px solid #066b5d; }
    .ribbon-box .ribbon-two-success span:after {
      border-right: 3px solid #066b5d;
      border-top: 3px solid #066b5d; }
  .ribbon-box .ribbon-two-info span {
    background: #299cdb; }
    .ribbon-box .ribbon-two-info span:before {
      border-left: 3px solid #1a6f9d;
      border-top: 3px solid #1a6f9d; }
    .ribbon-box .ribbon-two-info span:after {
      border-right: 3px solid #1a6f9d;
      border-top: 3px solid #1a6f9d; }
  .ribbon-box .ribbon-two-warning span {
    background: #3FBF48; }
    .ribbon-box .ribbon-two-warning span:before {
      border-left: 3px solid #2c8532;
      border-top: 3px solid #2c8532; }
    .ribbon-box .ribbon-two-warning span:after {
      border-right: 3px solid #2c8532;
      border-top: 3px solid #2c8532; }
  .ribbon-box .ribbon-two-danger span {
    background: #f06548; }
    .ribbon-box .ribbon-two-danger span:before {
      border-left: 3px solid #da3412;
      border-top: 3px solid #da3412; }
    .ribbon-box .ribbon-two-danger span:after {
      border-right: 3px solid #da3412;
      border-top: 3px solid #da3412; }
  .ribbon-box .ribbon-two-light span {
    background: #f3f6f9; }
    .ribbon-box .ribbon-two-light span:before {
      border-left: 3px solid #c0d0e0;
      border-top: 3px solid #c0d0e0; }
    .ribbon-box .ribbon-two-light span:after {
      border-right: 3px solid #c0d0e0;
      border-top: 3px solid #c0d0e0; }
  .ribbon-box .ribbon-two-dark span {
    background: #212529; }
    .ribbon-box .ribbon-two-dark span:before {
      border-left: 3px solid black;
      border-top: 3px solid black; }
    .ribbon-box .ribbon-two-dark span:after {
      border-right: 3px solid black;
      border-top: 3px solid black; }

.ribbon-box.right .ribbon-three {
  position: absolute;
  top: -6.1px;
  right: 10px;
  left: auto; }

.ribbon-three {
  position: absolute;
  top: -6.1px;
  left: 10px; }
  .ribbon-three span {
    position: relative;
    display: block;
    text-align: center;
    color: #fff;
    font-size: 14px;
    line-height: 1;
    padding: 12px 8px 10px;
    border-top-right-radius: 8px;
    width: 90px; }
    .ribbon-three span::after, .ribbon-three span::before {
      position: absolute;
      content: ""; }
    .ribbon-three span::before {
      height: 6px;
      width: 6px;
      left: -6px;
      top: 0; }
    .ribbon-three span::after {
      height: 6px;
      width: 8px;
      left: -8px;
      top: 0;
      border-radius: 8px 8px 0 0; }
  .ribbon-three::after {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    border-left: 44px solid transparent;
    border-right: 44px solid transparent;
    border-top: 10px solid; }

.ribbon-three-primary span {
  background: #F26430; }
  .ribbon-three-primary span:before {
    background: #F26430; }
  .ribbon-three-primary span:after {
    background: #e1470e; }

.ribbon-three-primary::after {
  border-top-color: #F26430; }

.ribbon-three-secondary span {
  background: #208C3B; }
  .ribbon-three-secondary span:before {
    background: #208C3B; }
  .ribbon-three-secondary span:after {
    background: #17622a; }

.ribbon-three-secondary::after {
  border-top-color: #208C3B; }

.ribbon-three-success span {
  background: #0ab39c; }
  .ribbon-three-success span:before {
    background: #0ab39c; }
  .ribbon-three-success span:after {
    background: #078372; }

.ribbon-three-success::after {
  border-top-color: #0ab39c; }

.ribbon-three-info span {
  background: #299cdb; }
  .ribbon-three-info span:before {
    background: #299cdb; }
  .ribbon-three-info span:after {
    background: #1e7eb3; }

.ribbon-three-info::after {
  border-top-color: #299cdb; }

.ribbon-three-warning span {
  background: #3FBF48; }
  .ribbon-three-warning span:before {
    background: #3FBF48; }
  .ribbon-three-warning span:after {
    background: #32993a; }

.ribbon-three-warning::after {
  border-top-color: #3FBF48; }

.ribbon-three-danger span {
  background: #f06548; }
  .ribbon-three-danger span:before {
    background: #f06548; }
  .ribbon-three-danger span:after {
    background: #ec3d19; }

.ribbon-three-danger::after {
  border-top-color: #f06548; }

.ribbon-three-light span {
  background: #f3f6f9; }
  .ribbon-three-light span:before {
    background: #f3f6f9; }
  .ribbon-three-light span:after {
    background: #d1dde8; }

.ribbon-three-light::after {
  border-top-color: #f3f6f9; }

.ribbon-three-dark span {
  background: #212529; }
  .ribbon-three-dark span:before {
    background: #212529; }
  .ribbon-three-dark span:after {
    background: #0a0c0d; }

.ribbon-three-dark::after {
  border-top-color: #212529; }

.ribbon-box .trending-ribbon {
  transform: translateX(-50px);
  transition: all 0.5s ease; }
  .ribbon-box .trending-ribbon .trending-ribbon-text {
    transition: all 0.5s ease;
    opacity: 0; }

.ribbon-box:hover .trending-ribbon {
  transform: translateX(0); }
  .ribbon-box:hover .trending-ribbon .trending-ribbon-text {
    opacity: 1; }

.ribbon-box.right .trending-ribbon {
  transform: translateX(50px);
  transition: all 0.5s ease; }
  .ribbon-box.right .trending-ribbon .trending-ribbon-text {
    transition: all 0.5s ease;
    opacity: 0; }

.ribbon-box.right:hover .trending-ribbon {
  transform: translateX(0); }
  .ribbon-box.right:hover .trending-ribbon .trending-ribbon-text {
    opacity: 1; }

.toast:not(:last-child) {
  margin-bottom: 0.75rem; }

.toast-border-primary .toast-body {
  color: #F26430;
  border-bottom: 3px solid #F26430; }

.toast-border-secondary .toast-body {
  color: #208C3B;
  border-bottom: 3px solid #208C3B; }

.toast-border-success .toast-body {
  color: #0ab39c;
  border-bottom: 3px solid #0ab39c; }

.toast-border-info .toast-body {
  color: #299cdb;
  border-bottom: 3px solid #299cdb; }

.toast-border-warning .toast-body {
  color: #3FBF48;
  border-bottom: 3px solid #3FBF48; }

.toast-border-danger .toast-body {
  color: #f06548;
  border-bottom: 3px solid #f06548; }

.toast-border-light .toast-body {
  color: #f3f6f9;
  border-bottom: 3px solid #f3f6f9; }

.toast-border-dark .toast-body {
  color: #212529;
  border-bottom: 3px solid #212529; }

.scrollspy-example {
  position: relative;
  height: 200px;
  margin-top: .5rem;
  overflow: auto; }

.scrollspy-example-2 {
  position: relative;
  height: 370px;
  overflow: auto; }

html {
  position: relative;
  min-height: 100%; }

:is(.h1,
.h2,
.h3,
.h4,
.h5,
.h6, h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6) {
  color: var(--vz-heading-color);
  font-family: "Poppins", sans-serif; }

a {
  text-decoration: none !important; }

label {
  font-weight: 500;
  margin-bottom: 0.5rem; }

b,
strong {
  font-weight: 600; }

.blockquote {
  padding: 10px 20px;
  border-left: 4px solid var(--vz-gray-300); }

.blockquote-reverse {
  border-left: 0;
  border-right: 4px solid var(--vz-gray-300);
  text-align: right; }

@media (min-width: 1200px) {
  :is(.container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl) {
    max-width: 1140px; } }

.row > * {
  position: relative; }

.alert-solid .alert-link {
  color: #fff; }

.alert-outline {
  background-color: var(--vz-card-bg-custom);
  border-width: 2px; }

.alert-borderless {
  border-width: 0; }

.alert-label-icon {
  position: relative;
  padding-left: 60px;
  border: 0; }
  .alert-label-icon .label-icon {
    position: absolute;
    width: 45px;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(255, 255, 255, 0.15);
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center; }
  .alert-label-icon.label-arrow {
    overflow: hidden; }
    .alert-label-icon.label-arrow .label-icon:after {
      content: "";
      position: absolute;
      border: 6px solid transparent;
      border-left-color: #F26430;
      right: -12px; }

.alert-border-left {
  border-left: 3px solid; }

.alert-top-border {
  background-color: var(--vz-card-bg-custom);
  border-color: var(--vz-border-color);
  border-top: 2px solid;
  color: var(--vz-body-color); }

.alert-additional {
  padding: 0; }
  .alert-additional .alert-body {
    padding: 0.8rem 1rem; }
  .alert-additional .alert-content {
    padding: 0.8rem 1rem;
    border-bottom-left-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    margin: 0 -1px -1px -1px; }

.rounded-label .label-icon {
  width: 45px;
  height: 26px;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 0 30px 30px 0; }

.alert-solid.alert-primary {
  background-color: #F26430;
  border-color: #F26430;
  color: #fff; }

.alert-outline.alert-primary {
  color: #F26430; }

.alert-border-left.alert-primary {
  border-left-color: #F26430; }

.alert-top-border.alert-primary {
  border-top-color: #F26430; }

.rounded-label.alert-primary .label-icon {
  background-color: #F26430;
  color: #fff; }

.label-arrow.alert-primary .label-icon {
  color: #fff;
  background-color: #F26430; }
  .label-arrow.alert-primary .label-icon:after {
    border-left-color: #F26430 !important; }

.alert.alert-primary .btn-close::after {
  color: #F26430; }

.alert-additional.alert-primary .alert-content {
  background-color: #F26430;
  color: #fff; }

.alert-solid.alert-secondary {
  background-color: #208C3B;
  border-color: #208C3B;
  color: #fff; }

.alert-outline.alert-secondary {
  color: #208C3B; }

.alert-border-left.alert-secondary {
  border-left-color: #208C3B; }

.alert-top-border.alert-secondary {
  border-top-color: #208C3B; }

.rounded-label.alert-secondary .label-icon {
  background-color: #208C3B;
  color: #fff; }

.label-arrow.alert-secondary .label-icon {
  color: #fff;
  background-color: #208C3B; }
  .label-arrow.alert-secondary .label-icon:after {
    border-left-color: #208C3B !important; }

.alert.alert-secondary .btn-close::after {
  color: #208C3B; }

.alert-additional.alert-secondary .alert-content {
  background-color: #208C3B;
  color: #fff; }

.alert-solid.alert-success {
  background-color: #0ab39c;
  border-color: #0ab39c;
  color: #fff; }

.alert-outline.alert-success {
  color: #0ab39c; }

.alert-border-left.alert-success {
  border-left-color: #0ab39c; }

.alert-top-border.alert-success {
  border-top-color: #0ab39c; }

.rounded-label.alert-success .label-icon {
  background-color: #0ab39c;
  color: #fff; }

.label-arrow.alert-success .label-icon {
  color: #fff;
  background-color: #0ab39c; }
  .label-arrow.alert-success .label-icon:after {
    border-left-color: #0ab39c !important; }

.alert.alert-success .btn-close::after {
  color: #0ab39c; }

.alert-additional.alert-success .alert-content {
  background-color: #0ab39c;
  color: #fff; }

.alert-solid.alert-info {
  background-color: #299cdb;
  border-color: #299cdb;
  color: #fff; }

.alert-outline.alert-info {
  color: #299cdb; }

.alert-border-left.alert-info {
  border-left-color: #299cdb; }

.alert-top-border.alert-info {
  border-top-color: #299cdb; }

.rounded-label.alert-info .label-icon {
  background-color: #299cdb;
  color: #fff; }

.label-arrow.alert-info .label-icon {
  color: #fff;
  background-color: #299cdb; }
  .label-arrow.alert-info .label-icon:after {
    border-left-color: #299cdb !important; }

.alert.alert-info .btn-close::after {
  color: #299cdb; }

.alert-additional.alert-info .alert-content {
  background-color: #299cdb;
  color: #fff; }

.alert-solid.alert-warning {
  background-color: #3FBF48;
  border-color: #3FBF48;
  color: #fff; }

.alert-outline.alert-warning {
  color: #3FBF48; }

.alert-border-left.alert-warning {
  border-left-color: #3FBF48; }

.alert-top-border.alert-warning {
  border-top-color: #3FBF48; }

.rounded-label.alert-warning .label-icon {
  background-color: #3FBF48;
  color: #fff; }

.label-arrow.alert-warning .label-icon {
  color: #fff;
  background-color: #3FBF48; }
  .label-arrow.alert-warning .label-icon:after {
    border-left-color: #3FBF48 !important; }

.alert.alert-warning .btn-close::after {
  color: #3FBF48; }

.alert-additional.alert-warning .alert-content {
  background-color: #3FBF48;
  color: #fff; }

.alert-solid.alert-danger {
  background-color: #f06548;
  border-color: #f06548;
  color: #fff; }

.alert-outline.alert-danger {
  color: #f06548; }

.alert-border-left.alert-danger {
  border-left-color: #f06548; }

.alert-top-border.alert-danger {
  border-top-color: #f06548; }

.rounded-label.alert-danger .label-icon {
  background-color: #f06548;
  color: #fff; }

.label-arrow.alert-danger .label-icon {
  color: #fff;
  background-color: #f06548; }
  .label-arrow.alert-danger .label-icon:after {
    border-left-color: #f06548 !important; }

.alert.alert-danger .btn-close::after {
  color: #f06548; }

.alert-additional.alert-danger .alert-content {
  background-color: #f06548;
  color: #fff; }

.alert-solid.alert-light {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
  color: #000; }

.alert-outline.alert-light {
  color: #f3f6f9; }

.alert-border-left.alert-light {
  border-left-color: #f3f6f9; }

.alert-top-border.alert-light {
  border-top-color: #f3f6f9; }

.rounded-label.alert-light .label-icon {
  background-color: #f3f6f9;
  color: #000; }

.label-arrow.alert-light .label-icon {
  color: #000;
  background-color: #f3f6f9; }
  .label-arrow.alert-light .label-icon:after {
    border-left-color: #f3f6f9 !important; }

.alert.alert-light .btn-close::after {
  color: #f3f6f9; }

.alert-additional.alert-light .alert-content {
  background-color: #f3f6f9;
  color: #000; }

.alert-solid.alert-dark {
  background-color: #212529;
  border-color: #212529;
  color: #fff; }

.alert-outline.alert-dark {
  color: #212529; }

.alert-border-left.alert-dark {
  border-left-color: #212529; }

.alert-top-border.alert-dark {
  border-top-color: #212529; }

.rounded-label.alert-dark .label-icon {
  background-color: #212529;
  color: #fff; }

.label-arrow.alert-dark .label-icon {
  color: #fff;
  background-color: #212529; }
  .label-arrow.alert-dark .label-icon:after {
    border-left-color: #212529 !important; }

.alert.alert-dark .btn-close::after {
  color: #212529; }

.alert-additional.alert-dark .alert-content {
  background-color: #212529;
  color: #fff; }

.alert-dismissible .btn-close {
  background: transparent !important; }
  .alert-dismissible .btn-close::after {
    background: transparent !important;
    content: "\\F0156" !important;
    font-size: 18px;
    line-height: 15px;
    font-family: "Material Design Icons" !important; }

.alert-outline.alert-dark {
  color: var(--vz-dark); }

.bg-soft-primary {
  background-color: rgba(242, 100, 48, 0.18) !important; }

.bg-soft-secondary {
  background-color: rgba(32, 140, 59, 0.18) !important; }

.bg-soft-success {
  background-color: rgba(10, 179, 156, 0.18) !important; }

.bg-soft-info {
  background-color: rgba(41, 156, 219, 0.18) !important; }

.bg-soft-warning {
  background-color: rgba(63, 191, 72, 0.18) !important; }

.bg-soft-danger {
  background-color: rgba(240, 101, 72, 0.18) !important; }

.bg-soft-light {
  background-color: rgba(243, 246, 249, 0.18) !important; }

.bg-soft-dark {
  background-color: rgba(33, 37, 41, 0.18) !important;
  background-color: rgba(var(--vz-dark-rgb), 0.18) !important; }

.bg-soft-light {
  background-color: rgba(var(--vz-light-rgb), 0.18) !important; }

.badge-outline-primary {
  color: #F26430;
  border: 1px solid #F26430;
  background-color: transparent; }

.badge-outline-secondary {
  color: #208C3B;
  border: 1px solid #208C3B;
  background-color: transparent; }

.badge-outline-success {
  color: #0ab39c;
  border: 1px solid #0ab39c;
  background-color: transparent; }

.badge-outline-info {
  color: #299cdb;
  border: 1px solid #299cdb;
  background-color: transparent; }

.badge-outline-warning {
  color: #3FBF48;
  border: 1px solid #3FBF48;
  background-color: transparent; }

.badge-outline-danger {
  color: #f06548;
  border: 1px solid #f06548;
  background-color: transparent; }

.badge-outline-light {
  color: #f3f6f9;
  border: 1px solid #f3f6f9;
  background-color: transparent; }

.badge-outline-dark {
  color: #212529;
  border: 1px solid #212529;
  background-color: transparent; }

.badge-outline {
  background-color: var(--vz-card-bg-custom);
  border: 1px solid; }

.badge-soft-primary {
  color: #F26430;
  background-color: rgba(242, 100, 48, 0.1); }

.badge-outline.badge-primary {
  color: #F26430;
  border: 1px solid #F26430;
  background-color: transparent; }

.badge-label.bg-primary:before {
  border-right-color: #F26430; }

.badge-soft-secondary {
  color: #208C3B;
  background-color: rgba(32, 140, 59, 0.1); }

.badge-outline.badge-secondary {
  color: #208C3B;
  border: 1px solid #208C3B;
  background-color: transparent; }

.badge-label.bg-secondary:before {
  border-right-color: #208C3B; }

.badge-soft-success {
  color: #0ab39c;
  background-color: rgba(10, 179, 156, 0.1); }

.badge-outline.badge-success {
  color: #0ab39c;
  border: 1px solid #0ab39c;
  background-color: transparent; }

.badge-label.bg-success:before {
  border-right-color: #0ab39c; }

.badge-soft-info {
  color: #299cdb;
  background-color: rgba(41, 156, 219, 0.1); }

.badge-outline.badge-info {
  color: #299cdb;
  border: 1px solid #299cdb;
  background-color: transparent; }

.badge-label.bg-info:before {
  border-right-color: #299cdb; }

.badge-soft-warning {
  color: #3FBF48;
  background-color: rgba(63, 191, 72, 0.1); }

.badge-outline.badge-warning {
  color: #3FBF48;
  border: 1px solid #3FBF48;
  background-color: transparent; }

.badge-label.bg-warning:before {
  border-right-color: #3FBF48; }

.badge-soft-danger {
  color: #f06548;
  background-color: rgba(240, 101, 72, 0.1); }

.badge-outline.badge-danger {
  color: #f06548;
  border: 1px solid #f06548;
  background-color: transparent; }

.badge-label.bg-danger:before {
  border-right-color: #f06548; }

.badge-soft-light {
  color: #f3f6f9;
  background-color: rgba(243, 246, 249, 0.1); }

.badge-outline.badge-light {
  color: #f3f6f9;
  border: 1px solid #f3f6f9;
  background-color: transparent; }

.badge-label.bg-light:before {
  border-right-color: #f3f6f9; }

.badge-soft-dark {
  color: #212529;
  background-color: rgba(33, 37, 41, 0.1); }

.badge-outline.badge-dark {
  color: #212529;
  border: 1px solid #212529;
  background-color: transparent; }

.badge-label.bg-dark:before {
  border-right-color: #212529; }

.badge-border {
  border-left: 2px solid; }

.badge-label {
  margin-left: 8px;
  position: relative; }
  .badge-label:before {
    content: "";
    position: absolute;
    border: 8px solid transparent;
    border-right-color: #F26430;
    left: -14px;
    top: 0; }

.badge-gradient-primary {
  background: linear-gradient(135deg, #F26430 0%, #0ab39c 100%); }

.badge-gradient-secondary {
  background: linear-gradient(135deg, #208C3B 0%, #299cdb 100%); }

.badge-gradient-success {
  background: linear-gradient(135deg, #0ab39c 0%, #3FBF48 100%); }

.badge-gradient-danger {
  background: linear-gradient(135deg, #f06548 0%, #208C3B 100%); }

.badge-gradient-warning {
  background: linear-gradient(135deg, #3FBF48 0%, #2c8532 100%); }

.badge-gradient-info {
  background: linear-gradient(135deg, #299cdb 0%, #0ab39c 100%); }

.badge-gradient-dark {
  background: linear-gradient(135deg, #212529 0%, #F26430 100%); }

button,
a {
  outline: none !important;
  position: relative; }

.btn {
  box-shadow: none; }

:is(.btn.show, .btn:first-child:active, :not(.btn-check) + .btn:active) {
  border-color: transparent; }

.btn-rounded {
  border-radius: 30px; }

.btn-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: calc(1rem + 1.5em + 2px);
  width: calc(1rem + 1.5em + 2px);
  padding: 0; }
  .btn-icon :is(i, svg, img) {
    vertical-align: middle; }
  .btn-icon.btn-sm, .btn-group-sm > .btn-icon.btn {
    height: calc(0.5rem + 1.5em + 2px);
    width: calc(0.5rem + 1.5em + 2px); }
  .btn-icon.btn-lg, .btn-group-lg > .btn-icon.btn {
    height: calc(1.4rem + 1.5em + 2px);
    width: calc(1.4rem + 1.5em + 2px); }

.btn-soft-primary {
  --vz-btn-color: #F26430;
  --vz-btn-bg: rgba(242, 100, 48, 0.1);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #da5a2b;
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 242, 100, 48;
  --vz-btn-active-color: var(--vz-btn-hover-color);
  --vz-btn-active-bg: #c25026;
  --vz-btn-active-border-color: transparent; }

.btn-soft-secondary {
  --vz-btn-color: #208C3B;
  --vz-btn-bg: rgba(32, 140, 59, 0.1);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #1d7e35;
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 32, 140, 59;
  --vz-btn-active-color: var(--vz-btn-hover-color);
  --vz-btn-active-bg: #1a702f;
  --vz-btn-active-border-color: transparent; }

.btn-soft-success {
  --vz-btn-color: #0ab39c;
  --vz-btn-bg: rgba(10, 179, 156, 0.1);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #09a18c;
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 10, 179, 156;
  --vz-btn-active-color: var(--vz-btn-hover-color);
  --vz-btn-active-bg: #088f7d;
  --vz-btn-active-border-color: transparent; }

.btn-soft-info {
  --vz-btn-color: #299cdb;
  --vz-btn-bg: rgba(41, 156, 219, 0.1);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #258cc5;
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 41, 156, 219;
  --vz-btn-active-color: var(--vz-btn-hover-color);
  --vz-btn-active-bg: #217daf;
  --vz-btn-active-border-color: transparent; }

.btn-soft-warning {
  --vz-btn-color: #3FBF48;
  --vz-btn-bg: rgba(63, 191, 72, 0.1);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #39ac41;
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 63, 191, 72;
  --vz-btn-active-color: var(--vz-btn-hover-color);
  --vz-btn-active-bg: #32993a;
  --vz-btn-active-border-color: transparent; }

.btn-soft-danger {
  --vz-btn-color: #f06548;
  --vz-btn-bg: rgba(240, 101, 72, 0.1);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #d85b41;
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 240, 101, 72;
  --vz-btn-active-color: var(--vz-btn-hover-color);
  --vz-btn-active-bg: #c0513a;
  --vz-btn-active-border-color: transparent; }

.btn-soft-light {
  --vz-btn-color: #f3f6f9;
  --vz-btn-bg: rgba(243, 246, 249, 0.1);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #dbdde0;
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 243, 246, 249;
  --vz-btn-active-color: var(--vz-btn-hover-color);
  --vz-btn-active-bg: #c2c5c7;
  --vz-btn-active-border-color: transparent; }

.btn-soft-dark {
  --vz-btn-color: #212529;
  --vz-btn-bg: rgba(33, 37, 41, 0.1);
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #fff;
  --vz-btn-hover-bg: #1e2125;
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 33, 37, 41;
  --vz-btn-active-color: var(--vz-btn-hover-color);
  --vz-btn-active-bg: #1a1e21;
  --vz-btn-active-border-color: transparent; }

.btn-ghost-primary {
  --vz-btn-color: #F26430;
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #F26430;
  --vz-btn-hover-bg: rgba(242, 100, 48, 0.1);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 242, 100, 48;
  --vz-btn-active-color: #F26430;
  --vz-btn-active-bg: rgba(242, 100, 48, 0.1);
  --vz-btn-active-border-color: transparent; }

.btn-ghost-secondary {
  --vz-btn-color: #208C3B;
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #208C3B;
  --vz-btn-hover-bg: rgba(32, 140, 59, 0.1);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 32, 140, 59;
  --vz-btn-active-color: #208C3B;
  --vz-btn-active-bg: rgba(32, 140, 59, 0.1);
  --vz-btn-active-border-color: transparent; }

.btn-ghost-success {
  --vz-btn-color: #0ab39c;
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #0ab39c;
  --vz-btn-hover-bg: rgba(10, 179, 156, 0.1);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 10, 179, 156;
  --vz-btn-active-color: #0ab39c;
  --vz-btn-active-bg: rgba(10, 179, 156, 0.1);
  --vz-btn-active-border-color: transparent; }

.btn-ghost-info {
  --vz-btn-color: #299cdb;
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #299cdb;
  --vz-btn-hover-bg: rgba(41, 156, 219, 0.1);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 41, 156, 219;
  --vz-btn-active-color: #299cdb;
  --vz-btn-active-bg: rgba(41, 156, 219, 0.1);
  --vz-btn-active-border-color: transparent; }

.btn-ghost-warning {
  --vz-btn-color: #3FBF48;
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #3FBF48;
  --vz-btn-hover-bg: rgba(63, 191, 72, 0.1);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 63, 191, 72;
  --vz-btn-active-color: #3FBF48;
  --vz-btn-active-bg: rgba(63, 191, 72, 0.1);
  --vz-btn-active-border-color: transparent; }

.btn-ghost-danger {
  --vz-btn-color: #f06548;
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #f06548;
  --vz-btn-hover-bg: rgba(240, 101, 72, 0.1);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 240, 101, 72;
  --vz-btn-active-color: #f06548;
  --vz-btn-active-bg: rgba(240, 101, 72, 0.1);
  --vz-btn-active-border-color: transparent; }

.btn-ghost-light {
  --vz-btn-color: #f3f6f9;
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #f3f6f9;
  --vz-btn-hover-bg: rgba(243, 246, 249, 0.1);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 243, 246, 249;
  --vz-btn-active-color: #f3f6f9;
  --vz-btn-active-bg: rgba(243, 246, 249, 0.1);
  --vz-btn-active-border-color: transparent; }

.btn-ghost-dark {
  --vz-btn-color: #212529;
  --vz-btn-bg: transparent;
  --vz-btn-border-color: transparent;
  --vz-btn-hover-color: #212529;
  --vz-btn-hover-bg: rgba(33, 37, 41, 0.1);
  --vz-btn-hover-border-color: transparent;
  --vz-btn-focus-shadow-rgb: 33, 37, 41;
  --vz-btn-active-color: #212529;
  --vz-btn-active-bg: rgba(33, 37, 41, 0.1);
  --vz-btn-active-border-color: transparent; }

.btn-ghost-secondary {
  color: var(--vz-gray-700); }

.btn-label {
  position: relative;
  padding-left: 44px; }
  .btn-label .label-icon {
    position: absolute;
    width: 35.5px;
    left: -1px;
    top: -1px;
    bottom: -1px;
    background-color: rgba(255, 255, 255, 0.1);
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center; }
  .btn-label.btn-light .label-icon {
    background-color: rgba(33, 37, 41, 0.05); }
  .btn-label.right {
    padding-left: 0.9rem;
    padding-right: 44px; }
    .btn-label.right .label-icon {
      right: -1px;
      left: auto; }

.btn-animation {
  overflow: hidden;
  transition: border-color 0.3s, background-color 0.3s;
  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1); }
  .btn-animation::after {
    content: attr(data-text);
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    transform: translate3d(0, 25%, 0);
    padding: 0.5rem 0.9rem;
    transition: transform 0.3s, opacity 0.3s;
    transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1); }
  .btn-animation > span {
    display: block;
    transition: transform 0.3s, opacity 0.3s;
    transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1); }
  .btn-animation:hover::after {
    opacity: 1;
    transform: translate3d(0, 0, 0); }
  .btn-animation:hover > span {
    opacity: 0;
    transform: translate3d(0, -25%, 0); }

.btn-primary.btn-animation {
  background-color: #F26430;
  border-color: #F26430 !important; }
  .btn-primary.btn-animation:is(:hover, :focus, :active, :focus-visible) {
    color: #F26430;
    background-color: rgba(242, 100, 48, 0.1); }

.btn-secondary.btn-animation {
  background-color: #208C3B;
  border-color: #208C3B !important; }
  .btn-secondary.btn-animation:is(:hover, :focus, :active, :focus-visible) {
    color: #208C3B;
    background-color: rgba(32, 140, 59, 0.1); }

.btn-success.btn-animation {
  background-color: #0ab39c;
  border-color: #0ab39c !important; }
  .btn-success.btn-animation:is(:hover, :focus, :active, :focus-visible) {
    color: #0ab39c;
    background-color: rgba(10, 179, 156, 0.1); }

.btn-info.btn-animation {
  background-color: #299cdb;
  border-color: #299cdb !important; }
  .btn-info.btn-animation:is(:hover, :focus, :active, :focus-visible) {
    color: #299cdb;
    background-color: rgba(41, 156, 219, 0.1); }

.btn-warning.btn-animation {
  background-color: #3FBF48;
  border-color: #3FBF48 !important; }
  .btn-warning.btn-animation:is(:hover, :focus, :active, :focus-visible) {
    color: #3FBF48;
    background-color: rgba(63, 191, 72, 0.1); }

.btn-danger.btn-animation {
  background-color: #f06548;
  border-color: #f06548 !important; }
  .btn-danger.btn-animation:is(:hover, :focus, :active, :focus-visible) {
    color: #f06548;
    background-color: rgba(240, 101, 72, 0.1); }

.btn-light.btn-animation {
  background-color: #f3f6f9;
  border-color: #f3f6f9 !important; }
  .btn-light.btn-animation:is(:hover, :focus, :active, :focus-visible) {
    color: #f3f6f9;
    background-color: rgba(243, 246, 249, 0.1); }

.btn-dark.btn-animation {
  background-color: #212529;
  border-color: #212529 !important; }
  .btn-dark.btn-animation:is(:hover, :focus, :active, :focus-visible) {
    color: #212529;
    background-color: rgba(33, 37, 41, 0.1); }

.btn-group-vertical label {
  margin-bottom: 0; }

.btn-group.radio .btn {
  border: none; }

.btn-group.radio .btn-check:active + .btn-light,
.btn-group.radio .btn-check:checked + .btn-light,
.btn-group.radio .btn-light.active,
.btn-group.radio .btn-light.dropdown-toggle.show,
.btn-group.radio .btn-light:active {
  background-color: rgba(41, 156, 219, 0.2);
  color: #299cdb; }

[data-layout-mode="dark"] .btn-check:focus + .btn-light,
[data-layout-mode="dark"] .btn-check:focus + .btn-outline-light,
[data-layout-mode="dark"] .btn-check:focus + .btn-soft-light,
[data-layout-mode="dark"] .btn-soft-light:focus {
  color: var(--vz-dark);
  background-color: rgba(var(--vz-light-rgb), 0.75);
  border-color: rgba(var(--vz-light-rgb), 0.75); }

[data-layout-mode="dark"] .btn-check:active + .btn-light,
[data-layout-mode="dark"] .btn-check:active + .btn-outline-light,
[data-layout-mode="dark"] .btn-check:active + .btn-soft-light,
[data-layout-mode="dark"] .btn-check:checked + .btn-light,
[data-layout-mode="dark"] .btn-check:checked + .btn-outline-light,
[data-layout-mode="dark"] .btn-check:checked + .btn-soft-light,
[data-layout-mode="dark"] .btn-light.active,
[data-layout-mode="dark"] .btn-light:active,
[data-layout-mode="dark"] .btn-outline-light.active,
[data-layout-mode="dark"] .btn-outline-light:active,
[data-layout-mode="dark"] .btn-soft-light.active,
[data-layout-mode="dark"] .btn-soft-light:active,
[data-layout-mode="dark"] .show > .btn-light.dropdown-toggle,
[data-layout-mode="dark"] .show > .btn-outline-light.dropdown-toggle,
[data-layout-mode="dark"] .show > .btn-soft-light.dropdown-toggle {
  color: var(--vz-dark);
  background-color: rgba(var(--vz-light-rgb), 0.75);
  border-color: rgba(var(--vz-light-rgb), 0.75); }

[data-layout-mode="dark"] .btn-check:focus + .btn-dark,
[data-layout-mode="dark"] .btn-check:focus + .btn-outline-dark,
[data-layout-mode="dark"] .btn-check:focus + .btn-soft-dark,
[data-layout-mode="dark"] .btn-soft-dark:focus {
  color: var(--vz-light);
  background-color: rgba(var(--vz-dark-rgb), 0.75);
  border-color: rgba(var(--vz-dark-rgb), 0.75); }

[data-layout-mode="dark"] .btn-check:active + .btn-dark,
[data-layout-mode="dark"] .btn-check:active + .btn-outline-dark,
[data-layout-mode="dark"] .btn-check:active + .btn-soft-dark,
[data-layout-mode="dark"] .btn-check:checked + .btn-dark,
[data-layout-mode="dark"] .btn-check:checked + .btn-outline-dark,
[data-layout-mode="dark"] .btn-check:checked + .btn-soft-dark,
[data-layout-mode="dark"] .btn-dark.active,
[data-layout-mode="dark"] .btn-dark:active,
[data-layout-mode="dark"] .btn-outline-dark.active,
[data-layout-mode="dark"] .btn-outline-dark:active,
[data-layout-mode="dark"] .btn-soft-dark.active,
[data-layout-mode="dark"] .btn-soft-dark:active,
[data-layout-mode="dark"] .show > .btn-dark.dropdown-toggle,
[data-layout-mode="dark"] .show > .btn-outline-dark.dropdown-toggle,
[data-layout-mode="dark"] .show > .btn-soft-dark.dropdown-toggle {
  color: var(--vz-light);
  background-color: rgba(var(--vz-dark-rgb), 0.75);
  border-color: rgba(var(--vz-dark-rgb), 0.75); }

[data-layout-mode="dark"] .btn-soft-light {
  color: var(--vz-dark);
  background-color: rgba(var(--vz-light-rgb), 0.1); }
  [data-layout-mode="dark"] .btn-soft-light:hover {
    color: var(--vz-dark);
    background-color: var(--vz-light); }

[data-layout-mode="dark"] .btn-soft-dark {
  color: var(--vz-dark);
  background-color: rgba(var(--vz-dark-rgb), 0.1); }
  [data-layout-mode="dark"] .btn-soft-dark:hover {
    color: var(--vz-light);
    background-color: var(--vz-dark); }

[data-layout-mode="dark"] .btn-ghost-light {
  color: var(--vz-dark); }
  [data-layout-mode="dark"] .btn-ghost-light:is(:hover, :focus, :active, :focus-visible) {
    color: var(--vz-dark);
    background-color: rgba(var(--vz-light-rgb), 0.5); }

[data-layout-mode="dark"] .btn-ghost-dark {
  color: var(--vz-dark); }
  [data-layout-mode="dark"] .btn-ghost-dark:is(:hover, :focus, :active, :focus-visible) {
    color: var(--vz-dark);
    background-color: rgba(var(--vz-dark-rgb), 0.1); }

.btn-load .spinner-border,
.btn-load .spinner-grow {
  height: 19px;
  width: 19px; }

:is(.btn-primary, .btn-outline-primary, .btn-soft-primary).btn-border {
  border-bottom: 2px solid #ea4a0f; }

:is(.btn-secondary, .btn-outline-secondary, .btn-soft-secondary).btn-border {
  border-bottom: 2px solid #186b2d; }

:is(.btn-success, .btn-outline-success, .btn-soft-success).btn-border {
  border-bottom: 2px solid #088c7a; }

:is(.btn-info, .btn-outline-info, .btn-soft-info).btn-border {
  border-bottom: 2px solid #2084bc; }

:is(.btn-warning, .btn-outline-warning, .btn-soft-warning).btn-border {
  border-bottom: 2px solid #35a03c; }

:is(.btn-danger, .btn-outline-danger, .btn-soft-danger).btn-border {
  border-bottom: 2px solid #ed4522; }

:is(.btn-light, .btn-outline-light, .btn-soft-light).btn-border {
  border-bottom: 2px solid #d8e2eb; }

:is(.btn-dark, .btn-outline-dark, .btn-soft-dark).btn-border {
  border-bottom: 2px solid #0f1112; }

.custom-toggle .icon-off {
  display: none; }

.custom-toggle.active .icon-on {
  display: none; }

.custom-toggle.active .icon-off {
  display: block; }

.breadcrumb-item > a {
  color: var(--vz-gray-700); }

.breadcrumb-item + .breadcrumb-item::before {
  font-family: "Material Design Icons";
  font-size: 15px;
  line-height: 20px; }

.card {
  margin-bottom: 1rem;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15); }

.card-header {
  border-bottom: 1px solid var(--vz-border-color); }

.card-header-dropdown .dropdown-btn {
  padding: 1rem 0; }

.card-footer {
  border-top: 1px solid var(--vz-border-color); }

.card-drop {
  color: #212529; }

.card-title {
  font-size: 16px;
  margin: 0 0 7px 0; }

.card-title-desc {
  margin-bottom: 24px; }

.card-height-100 {
  height: calc(100% - 1rem); }

.card-animate {
  transition: all 0.4s; }
  .card-animate:hover {
    transform: translateY(calc(-1rem / 5));
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12); }

.card-primary {
  color: #fff;
  background-color: #F26430; }
  .card-primary .card-header, .card-primary .card-footer {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
    border-color: transparent; }
  .card-primary .card-title {
    color: #fff; }

.card-secondary {
  color: #fff;
  background-color: #208C3B; }
  .card-secondary .card-header, .card-secondary .card-footer {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
    border-color: transparent; }
  .card-secondary .card-title {
    color: #fff; }

.card-success {
  color: #fff;
  background-color: #0ab39c; }
  .card-success .card-header, .card-success .card-footer {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
    border-color: transparent; }
  .card-success .card-title {
    color: #fff; }

.card-info {
  color: #fff;
  background-color: #299cdb; }
  .card-info .card-header, .card-info .card-footer {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
    border-color: transparent; }
  .card-info .card-title {
    color: #fff; }

.card-warning {
  color: #fff;
  background-color: #3FBF48; }
  .card-warning .card-header, .card-warning .card-footer {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
    border-color: transparent; }
  .card-warning .card-title {
    color: #fff; }

.card-danger {
  color: #fff;
  background-color: #f06548; }
  .card-danger .card-header, .card-danger .card-footer {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
    border-color: transparent; }
  .card-danger .card-title {
    color: #fff; }

.card-light {
  color: #fff;
  background-color: #f3f6f9; }
  .card-light .card-header, .card-light .card-footer {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
    border-color: transparent; }
  .card-light .card-title {
    color: #fff; }

.card-dark {
  color: #fff;
  background-color: #212529; }
  .card-dark .card-header, .card-dark .card-footer {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
    border-color: transparent; }
  .card-dark .card-title {
    color: #fff; }

.card-border-primary {
  border-color: #F26430 !important; }
  .card-border-primary .card-header, .card-border-primary .card-footer {
    border-color: #F26430; }

.card-border-secondary {
  border-color: #208C3B !important; }
  .card-border-secondary .card-header, .card-border-secondary .card-footer {
    border-color: #208C3B; }

.card-border-success {
  border-color: #0ab39c !important; }
  .card-border-success .card-header, .card-border-success .card-footer {
    border-color: #0ab39c; }

.card-border-info {
  border-color: #299cdb !important; }
  .card-border-info .card-header, .card-border-info .card-footer {
    border-color: #299cdb; }

.card-border-warning {
  border-color: #3FBF48 !important; }
  .card-border-warning .card-header, .card-border-warning .card-footer {
    border-color: #3FBF48; }

.card-border-danger {
  border-color: #f06548 !important; }
  .card-border-danger .card-header, .card-border-danger .card-footer {
    border-color: #f06548; }

.card-border-light {
  border-color: #f3f6f9 !important; }
  .card-border-light .card-header, .card-border-light .card-footer {
    border-color: #f3f6f9; }

.card-border-dark {
  border-color: #212529 !important; }
  .card-border-dark .card-header, .card-border-dark .card-footer {
    border-color: #212529; }

.card-light {
  background-color: var(--vz-light); }
  .card-light .card-header, .card-light .card-footer {
    color: var(--vz-body-color) !important;
    background-color: rgba(var(--vz-dark-rgb), 0.1); }
  .card-light .card-title, .card-light .card-text {
    color: var(--vz-body-color) !important; }

.stretched-link {
  position: static; }

.card-preloader {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(var(--vz-light-rgb), 0.6);
  z-index: 9999; }

.card-status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) !important; }

.custom-loader {
  animation: spin 2s linear infinite; }

@keyframes spin {
  to {
    transform: rotate(360deg); } }

.card-overlay {
  position: relative;
  overflow: hidden; }
  .card-overlay:before {
    content: "";
    background-color: rgba(242, 100, 48, 0.2);
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0; }
  .card-overlay :is(.card-header, .card-footer) {
    border-color: rgba(255, 255, 255, 0.15) !important; }

.card-toolbar-menu {
  line-height: 0.8; }
  .card-toolbar-menu a {
    font-size: 17px; }
  .card-toolbar-menu .minimize-card .plus {
    display: none; }
  .card-toolbar-menu .minimize-card .minus {
    display: block; }
  .card-toolbar-menu .minimize-card.collapsed .plus {
    display: block; }
  .card-toolbar-menu .minimize-card.collapsed .minus {
    display: none; }

.dropdown-toggle::after {
  display: inline-block;
  margin-left: .255em;
  font-size: 15px;
  line-height: 15px;
  content: "\\F0140";
  font-family: "Material Design Icons"; }

.dropdown-menu {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  animation-name: DropDownSlide;
  animation-duration: .3s;
  animation-fill-mode: both;
  position: absolute;
  z-index: 1000; }
  .dropdown-menu.dropdown-megamenu {
    padding: 20px;
    left: 0 !important;
    right: 0 !important; }
  .dropdown-menu[data-popper-placement="top-start"] {
    animation-name: DropDownSlideDown; }

@keyframes DropDownSlide {
  100% {
    margin-top: -1px; }
  0% {
    margin-top: 8px; } }

@keyframes DropDownSlideDown {
  100% {
    margin-bottom: 0; }
  0% {
    margin-bottom: 8px; } }

@media (min-width: 600px) {
  .dropdown-menu-xl {
    width: 420px; }
  .dropdown-menu-lg {
    width: 320px; }
  .dropdown-menu-md {
    width: 240px; } }

.dropdown-toggle-split {
  border-left: none; }
  .dropdown-toggle-split::after {
    margin-left: 0px; }
  .dropdown-toggle-split:before {
    content: "";
    position: absolute;
    background-color: rgba(255, 255, 255, 0.12);
    top: -1px;
    bottom: -1px;
    right: -1px;
    left: 0;
    border-radius: 0 0.25rem 0.25rem 0; }

.dropdown-mega {
  position: static !important; }

.dropdown-mega-menu-xl {
  width: 38rem; }

.dropdown-mega-menu-lg {
  width: 26rem; }

[dir="ltr"] .dropdown-menu-start {
  --bs-position: end; }

[dir="ltr"] .dropdown-menu-end {
  --bs-position: start; }

.dropdown-head .nav-tabs-custom {
  border: 0; }
  .dropdown-head .nav-tabs-custom .nav-link {
    color: rgba(255, 255, 255, 0.6); }
    .dropdown-head .nav-tabs-custom .nav-link.active {
      background-color: var(--vz-dropdown-bg); }
    .dropdown-head .nav-tabs-custom .nav-link:hover {
      color: #fff; }

.dropdownmenu-primary .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(242, 100, 48, 0.07);
  color: #F26430; }

.dropdownmenu-secondary .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(32, 140, 59, 0.07);
  color: #208C3B; }

.dropdownmenu-success .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(10, 179, 156, 0.07);
  color: #0ab39c; }

.dropdownmenu-info .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(41, 156, 219, 0.07);
  color: #299cdb; }

.dropdownmenu-warning .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(63, 191, 72, 0.07);
  color: #3FBF48; }

.dropdownmenu-danger .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(240, 101, 72, 0.07);
  color: #f06548; }

.dropdownmenu-light .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(243, 246, 249, 0.07);
  color: #f3f6f9; }

.dropdownmenu-dark .dropdown-item:is(:focus, :hover, .active) {
  background-color: rgba(33, 37, 41, 0.07);
  color: #212529; }

:is(.nav-tabs, .nav-pills) > li > a {
  color: var(--vz-gray-700);
  font-weight: 500; }

.nav-pills > a {
  color: var(--vz-gray-700);
  font-weight: 500; }

.nav-pills :is(.nav-link.active, .show > .nav-link) {
  box-shadow: none; }

.nav-tabs-custom {
  border-bottom: 1px solid var(--vz-gray-300); }
  .nav-tabs-custom .nav-item {
    position: relative; }
    .nav-tabs-custom .nav-item .nav-link {
      border: none;
      font-weight: 500; }
      .nav-tabs-custom .nav-item .nav-link::after {
        content: "";
        background: #F26430;
        height: 1px;
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 0;
        transition: all 250ms ease 0s;
        transform: scale(0); }
      .nav-tabs-custom .nav-item .nav-link.active {
        color: #F26430; }
        .nav-tabs-custom .nav-item .nav-link.active:after {
          transform: scale(1); }
  .nav-tabs-custom.card-header-tabs {
    margin-top: -1rem; }
    .nav-tabs-custom.card-header-tabs .nav-link {
      padding: 1rem 1rem; }

.vertical-nav .nav .nav-link {
  padding: 24px 16px;
  text-align: center;
  margin-bottom: 8px; }
  .vertical-nav .nav .nav-link .nav-icon {
    font-size: 24px; }

.navtab-bg li > a {
  background-color: #e9ebec;
  margin: 0 5px; }

.arrow-navtabs .nav-item .nav-link {
  position: relative;
  text-align: center; }
  .arrow-navtabs .nav-item .nav-link:before {
    content: "";
    position: absolute;
    border: 6px solid transparent;
    bottom: -12px;
    left: 50%;
    transform: translateX(-50%);
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .arrow-navtabs .nav-item .nav-link:before {
        transition: none; } }
  .arrow-navtabs .nav-item .nav-link.active:before {
    border-top-color: #F26430; }

.custom-hover-nav-tabs .nav-item {
  text-align: center;
  overflow: hidden; }
  .custom-hover-nav-tabs .nav-item .nav-link {
    width: 120px;
    height: 45px;
    position: relative;
    border-radius: 0px; }
    .custom-hover-nav-tabs .nav-item .nav-link .nav-icon {
      font-size: 22px; }
    .custom-hover-nav-tabs .nav-item .nav-link .nav-titl {
      font-size: 14px; }
    .custom-hover-nav-tabs .nav-item .nav-link.active .nav-tab-position {
      color: #fff; }
    .custom-hover-nav-tabs .nav-item .nav-link .nav-tab-position {
      position: absolute;
      left: 0;
      right: 0;
      transition: all 0.4s; }
      .custom-hover-nav-tabs .nav-item .nav-link .nav-tab-position.nav-icon {
        top: 50%;
        transform: translateY(-50%); }
      .custom-hover-nav-tabs .nav-item .nav-link .nav-tab-position.nav-titl {
        bottom: -20px; }
    .custom-hover-nav-tabs .nav-item .nav-link:hover .nav-titl {
      bottom: 50%;
      transform: translateY(50%); }
    .custom-hover-nav-tabs .nav-item .nav-link:hover .nav-icon {
      top: -20px; }

.custom-verti-nav-pills .nav-link {
  background-color: var(--vz-light);
  margin-top: 7px;
  position: relative; }
  @media (min-width: 992px) {
    .custom-verti-nav-pills .nav-link::before {
      content: "";
      position: absolute;
      right: -20px;
      top: 50%;
      transform: translateY(-50%);
      border: 12px solid transparent;
      border-left-color: transparent;
      transition: border-left-color 0.04 ease; }
    .custom-verti-nav-pills .nav-link.active::before {
      border-left-color: #F26430; } }

.animation-nav li {
  position: relative; }
  .animation-nav li a {
    color: var(--vz-body-color);
    border-radius: 4px;
    position: relative;
    overflow: hidden;
    transition: all 0.4s;
    z-index: 1; }
    .animation-nav li a span {
      position: relative; }
    .animation-nav li a::before {
      content: "";
      position: absolute;
      top: 0;
      width: 0;
      right: 0;
      height: 100%;
      transition: width 0.4s cubic-bezier(0.51, 0.18, 0, 0.88) 0.1s;
      background-color: #F26430;
      z-index: -1; }
    .animation-nav li a:hover, .animation-nav li a.active {
      color: #fff;
      background-color: transparent !important; }
      .animation-nav li a:hover::before, .animation-nav li a.active::before {
        width: 100%;
        left: 0; }

.nav-border-top .nav-link {
  border-top: 3px solid transparent; }
  .nav-border-top .nav-link.active {
    border-top-color: #F26430; }

.nav-border-top-primary .nav-link.active {
  color: #F26430;
  border-top-color: #F26430; }

.nav-border-top-secondary .nav-link.active {
  color: #208C3B;
  border-top-color: #208C3B; }

.nav-border-top-success .nav-link.active {
  color: #0ab39c;
  border-top-color: #0ab39c; }

.nav-border-top-info .nav-link.active {
  color: #299cdb;
  border-top-color: #299cdb; }

.nav-border-top-warning .nav-link.active {
  color: #3FBF48;
  border-top-color: #3FBF48; }

.nav-border-top-danger .nav-link.active {
  color: #f06548;
  border-top-color: #f06548; }

.nav-border-top-light .nav-link.active {
  color: #f3f6f9;
  border-top-color: #f3f6f9; }

.nav-border-top-dark .nav-link.active {
  color: #212529;
  border-top-color: #212529; }

.nav-custom {
  background-color: #F26430;
  border-radius: 0.25rem; }
  .nav-custom .nav-item .nav-link {
    color: rgba(255, 255, 255, 0.75); }
    .nav-custom .nav-item .nav-link.active {
      color: #fff;
      background-color: rgba(255, 255, 255, 0.1); }
  .nav-custom.nav-custom-light .nav-item .nav-link {
    color: rgba(var(--vz-dark-rgb), 0.75); }
    .nav-custom.nav-custom-light .nav-item .nav-link.active {
      color: #f3f6f9;
      background-color: #F26430; }

.nav-custom-primary {
  background-color: #F26430; }

.nav-custom-secondary {
  background-color: #208C3B; }

.nav-custom-success {
  background-color: #0ab39c; }

.nav-custom-info {
  background-color: #299cdb; }

.nav-custom-warning {
  background-color: #3FBF48; }

.nav-custom-danger {
  background-color: #f06548; }

.nav-custom-light {
  background-color: #f3f6f9; }

.nav-custom-dark {
  background-color: #212529; }

.nav-custom-light {
  background-color: var(--vz-light); }

.nav-primary .nav-link.active {
  color: #fff;
  background-color: #F26430; }

.nav-primary.nav-tabs .nav-link.active {
  color: #F26430;
  background-color: var(--vz-card-bg-custom); }

.nav-primary.nav-tabs-custom .nav-link.active {
  color: #F26430;
  background-color: var(--vz-card-bg-custom); }
  .nav-primary.nav-tabs-custom .nav-link.active::after {
    background-color: #F26430; }

.nav-primary.arrow-navtabs .nav-link.active::before {
  border-top-color: #F26430; }

.nav-primary.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #F26430; }

.nav-secondary .nav-link.active {
  color: #fff;
  background-color: #208C3B; }

.nav-secondary.nav-tabs .nav-link.active {
  color: #208C3B;
  background-color: var(--vz-card-bg-custom); }

.nav-secondary.nav-tabs-custom .nav-link.active {
  color: #208C3B;
  background-color: var(--vz-card-bg-custom); }
  .nav-secondary.nav-tabs-custom .nav-link.active::after {
    background-color: #208C3B; }

.nav-secondary.arrow-navtabs .nav-link.active::before {
  border-top-color: #208C3B; }

.nav-secondary.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #208C3B; }

.nav-success .nav-link.active {
  color: #fff;
  background-color: #0ab39c; }

.nav-success.nav-tabs .nav-link.active {
  color: #0ab39c;
  background-color: var(--vz-card-bg-custom); }

.nav-success.nav-tabs-custom .nav-link.active {
  color: #0ab39c;
  background-color: var(--vz-card-bg-custom); }
  .nav-success.nav-tabs-custom .nav-link.active::after {
    background-color: #0ab39c; }

.nav-success.arrow-navtabs .nav-link.active::before {
  border-top-color: #0ab39c; }

.nav-success.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #0ab39c; }

.nav-info .nav-link.active {
  color: #fff;
  background-color: #299cdb; }

.nav-info.nav-tabs .nav-link.active {
  color: #299cdb;
  background-color: var(--vz-card-bg-custom); }

.nav-info.nav-tabs-custom .nav-link.active {
  color: #299cdb;
  background-color: var(--vz-card-bg-custom); }
  .nav-info.nav-tabs-custom .nav-link.active::after {
    background-color: #299cdb; }

.nav-info.arrow-navtabs .nav-link.active::before {
  border-top-color: #299cdb; }

.nav-info.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #299cdb; }

.nav-warning .nav-link.active {
  color: #fff;
  background-color: #3FBF48; }

.nav-warning.nav-tabs .nav-link.active {
  color: #3FBF48;
  background-color: var(--vz-card-bg-custom); }

.nav-warning.nav-tabs-custom .nav-link.active {
  color: #3FBF48;
  background-color: var(--vz-card-bg-custom); }
  .nav-warning.nav-tabs-custom .nav-link.active::after {
    background-color: #3FBF48; }

.nav-warning.arrow-navtabs .nav-link.active::before {
  border-top-color: #3FBF48; }

.nav-warning.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #3FBF48; }

.nav-danger .nav-link.active {
  color: #fff;
  background-color: #f06548; }

.nav-danger.nav-tabs .nav-link.active {
  color: #f06548;
  background-color: var(--vz-card-bg-custom); }

.nav-danger.nav-tabs-custom .nav-link.active {
  color: #f06548;
  background-color: var(--vz-card-bg-custom); }
  .nav-danger.nav-tabs-custom .nav-link.active::after {
    background-color: #f06548; }

.nav-danger.arrow-navtabs .nav-link.active::before {
  border-top-color: #f06548; }

.nav-danger.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #f06548; }

.nav-light .nav-link.active {
  color: #fff;
  background-color: #f3f6f9; }

.nav-light.nav-tabs .nav-link.active {
  color: #f3f6f9;
  background-color: var(--vz-card-bg-custom); }

.nav-light.nav-tabs-custom .nav-link.active {
  color: #f3f6f9;
  background-color: var(--vz-card-bg-custom); }
  .nav-light.nav-tabs-custom .nav-link.active::after {
    background-color: #f3f6f9; }

.nav-light.arrow-navtabs .nav-link.active::before {
  border-top-color: #f3f6f9; }

.nav-light.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #f3f6f9; }

.nav-dark .nav-link.active {
  color: #fff;
  background-color: #212529; }

.nav-dark.nav-tabs .nav-link.active {
  color: #212529;
  background-color: var(--vz-card-bg-custom); }

.nav-dark.nav-tabs-custom .nav-link.active {
  color: #212529;
  background-color: var(--vz-card-bg-custom); }
  .nav-dark.nav-tabs-custom .nav-link.active::after {
    background-color: #212529; }

.nav-dark.arrow-navtabs .nav-link.active::before {
  border-top-color: #212529; }

.nav-dark.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #212529; }

.progress-nav {
  position: relative;
  margin-right: 1rem;
  margin-left: 1rem; }
  .progress-nav .progress {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 100%; }
  .progress-nav .nav {
    margin-right: -1rem;
    margin-left: -1rem;
    justify-content: space-between; }
    .progress-nav .nav .nav-link {
      width: 2rem;
      height: 2rem;
      background-color: var(--vz-light);
      padding: 0;
      color: var(--vz-dark);
      font-weight: 500; }
      .progress-nav .nav .nav-link.active, .progress-nav .nav .nav-link.done {
        background-color: #F26430;
        color: #fff; }

.step-arrow-nav .nav {
  background-color: var(--vz-light); }
  .step-arrow-nav .nav .nav-link {
    border-radius: 0;
    position: relative;
    font-weight: 500;
    color: var(--vz-dark); }
    .step-arrow-nav .nav .nav-link::before {
      content: "";
      position: absolute;
      border: 7px solid transparent;
      right: -14px;
      top: 50%;
      transform: translateY(-50%); }
    .step-arrow-nav .nav .nav-link.done {
      background-color: rgba(242, 100, 48, 0.05);
      color: #F26430; }
      .step-arrow-nav .nav .nav-link.done::before {
        border-left-color: transparent; }
    .step-arrow-nav .nav .nav-link.active {
      background-color: rgba(242, 100, 48, 0.1);
      color: #F26430;
      box-shadow: none; }
      .step-arrow-nav .nav .nav-link.active::before {
        border-left-color: rgba(242, 100, 48, 0.1); }
  .step-arrow-nav .nav .nav-item:last-child .nav-link:before {
    display: none; }

.vertical-navs-step .nav {
  gap: 16px; }
  .vertical-navs-step .nav .nav-link {
    text-align: left;
    background-color: rgba(var(--vz-light-rgb), 0.4);
    border: 1px solid var(--vz-border-color);
    color: var(--vz-dark); }
    .vertical-navs-step .nav .nav-link .step-title {
      font-weight: 600; }
    .vertical-navs-step .nav .nav-link .step-icon {
      color: #f06548;
      vertical-align: middle;
      font-weight: 500;
      float: left; }
    .vertical-navs-step .nav .nav-link.active .step-icon, .vertical-navs-step .nav .nav-link.done .step-icon {
      color: #0ab39c; }
      .vertical-navs-step .nav .nav-link.active .step-icon:before, .vertical-navs-step .nav .nav-link.done .step-icon:before {
        content: "\\eb80"; }
    .vertical-navs-step .nav .nav-link.active {
      border-color: #F26430; }
    .vertical-navs-step .nav .nav-link.done {
      border-color: #0ab39c; }

.nav-custom-outline.nav .nav-link {
  border: 1px solid transparent;
  border-bottom: 2px solid transparent; }
  .nav-custom-outline.nav .nav-link.active {
    border-color: #F26430;
    background-color: transparent;
    color: #F26430; }

.nav-primary.nav-custom-outline .nav-link.active {
  color: #F26430;
  border-color: #F26430; }

.nav-secondary.nav-custom-outline .nav-link.active {
  color: #208C3B;
  border-color: #208C3B; }

.nav-success.nav-custom-outline .nav-link.active {
  color: #0ab39c;
  border-color: #0ab39c; }

.nav-info.nav-custom-outline .nav-link.active {
  color: #299cdb;
  border-color: #299cdb; }

.nav-warning.nav-custom-outline .nav-link.active {
  color: #3FBF48;
  border-color: #3FBF48; }

.nav-danger.nav-custom-outline .nav-link.active {
  color: #f06548;
  border-color: #f06548; }

.nav-light.nav-custom-outline .nav-link.active {
  color: #f3f6f9;
  border-color: #f3f6f9; }

.nav-dark.nav-custom-outline .nav-link.active {
  color: #212529;
  border-color: #212529; }

.nav-customs.nav {
  padding-left: 34px;
  overflow: hidden; }
  .nav-customs.nav .nav-link {
    position: relative;
    display: block;
    float: right;
    background-color: var(--vz-body-bg);
    margin-right: 46px;
    transition: all 0.5s ease; }
    .nav-customs.nav .nav-link::before, .nav-customs.nav .nav-link::after {
      display: block;
      content: " ";
      position: absolute;
      top: -1px;
      bottom: -1px;
      width: 37px;
      background-color: var(--vz-body-bg);
      transition: all 0.5s ease; }
    .nav-customs.nav .nav-link::before {
      border-radius: 0 8px 0 0;
      right: -24px;
      transform: skew(30deg, 0deg); }
    .nav-customs.nav .nav-link::after {
      border-radius: 8px 0 0 0;
      left: -24px;
      transform: skew(-30deg, 0deg); }
    .nav-customs.nav .nav-link.active, .nav-customs.nav .nav-link.active:before, .nav-customs.nav .nav-link.active:after {
      background-color: #F26430;
      color: #fff; }
    .nav-customs.nav .nav-link.active {
      z-index: 1; }

.table th {
  font-weight: 600; }

.table > thead {
  border-color: var(--vz-border-color); }

.table > :not(:first-child) {
  border-top-width: 1px; }

.table-nowrap th,
.table-nowrap td {
  white-space: nowrap; }

.table-card {
  margin: -1rem -1rem; }
  .table-card th:first-child,
  .table-card td:first-child {
    padding-left: 16px; }
  .table-card th:last-child,
  .table-card td:last-child {
    padding-right: 16px; }
  .table-card .table > :not(:first-child) {
    border-top-width: 1px; }

.border-primary.table > thead {
  border-color: #F26430 !important; }

.table-primary.table > thead {
  border-bottom-color: #f58860 !important; }

.border-secondary.table > thead {
  border-color: #208C3B !important; }

.table-secondary.table > thead {
  border-bottom-color: #29b64c !important; }

.border-success.table > thead {
  border-color: #0ab39c !important; }

.table-success.table > thead {
  border-bottom-color: #0de3c6 !important; }

.border-info.table > thead {
  border-color: #299cdb !important; }

.table-info.table > thead {
  border-bottom-color: #55b0e2 !important; }

.border-warning.table > thead {
  border-color: #3FBF48 !important; }

.table-warning.table > thead {
  border-bottom-color: #65cc6c !important; }

.border-danger.table > thead {
  border-color: #f06548 !important; }

.table-danger.table > thead {
  border-bottom-color: #f48d77 !important; }

.border-light.table > thead {
  border-color: #f3f6f9 !important; }

.table-light.table > thead {
  border-bottom-color: white !important; }

.border-dark.table > thead {
  border-color: #212529 !important; }

.table-dark.table > thead {
  border-bottom-color: #383f45 !important; }

.table .form-check {
  padding-left: 0px;
  margin-bottom: 0px; }
  .table .form-check .form-check-input {
    margin-left: 0px;
    margin-top: 0px;
    float: none;
    vertical-align: middle; }

.table .sort {
  position: relative; }
  .table .sort::before {
    content: "\\f035d";
    position: absolute;
    right: 0.5rem;
    top: 18px;
    font-size: 0.8rem;
    font-family: "Material Design Icons"; }
  .table .sort::after {
    position: absolute;
    right: 0.5rem;
    content: "\\f0360";
    font-family: "Material Design Icons";
    font-size: 0.8rem;
    top: 12px; }

[data-layout-mode="dark"] .table-light {
  background-color: var(--vz-light);
  color: var(--vz-body-color); }
  [data-layout-mode="dark"] .table-light th, [data-layout-mode="dark"] .table-light td {
    background-color: var(--vz-light); }

.rdt_Table.eSTlnH {
  background-color: var(--vz-card-bg) !important;
  color: var(--vz-body-color); }

.rdt_Table .gZWIKX,
.rdt_Table .jVeafb {
  color: var(--vz-body-color);
  background-color: var(--vz-card-bg); }

.rdt_Table .jVeafb:not(:last-of-type),
.rdt_Table .gZWIKX {
  border-bottom-color: var(--vz-border-color); }

.rdt_Pagination.jxflYm {
  background-color: var(--vz-card-bg);
  color: var(--vz-body-color);
  border-top-color: var(--vz-border-color); }

.rdt_Pagination .bvxQGL {
  fill: var(--vz-dark); }

.rdt_Pagination .bvxQGL:disabled {
  fill: rgba(var(--vz-dark-rgb), 0.25); }

.modal-title {
  font-weight: 600; }

.modal-dialog:not(.modal-dialog-scrollable) .modal-header {
  padding-bottom: 0; }
  .modal-dialog:not(.modal-dialog-scrollable) .modal-header .btn-close {
    margin-top: -1.25rem 1.25rem; }

.modal-dialog:not(.modal-dialog-scrollable) .modal-footer {
  padding-top: 0; }

.modal.fadeInRight .modal-dialog {
  opacity: 0;
  transform: translateX(20%);
  transition: all .3s ease-in-out; }

.modal.fadeInRight.show .modal-dialog {
  opacity: 1;
  transform: translateX(0); }

.modal.fadeInLeft .modal-dialog {
  animation: fadeInLeft 0.3s ease-in-out;
  transform: translate(-50%, 0); }

.modal.fadeInLeft.show .modal-dialog {
  transform: none; }

.modal.fadeInUp .modal-dialog {
  animation: fadeInUp 0.3s ease-in-out;
  transform: translate(0, 30%); }

.modal.fadeInUp.show .modal-dialog {
  transform: none; }

.modal.flip {
  perspective: 1300px; }
  .modal.flip .modal-dialog {
    opacity: 0;
    transform: rotateY(-70deg);
    transition: all .3s; }
  .modal.flip.show .modal-dialog {
    opacity: 1;
    transform: rotateY(0deg); }

.modal.zoomIn .modal-dialog {
  opacity: 0;
  transform: scale(0.7);
  transition: all .3s ease; }

.modal.zoomIn.show .modal-dialog {
  opacity: 1;
  transform: scale(1); }

.modal-dialog-right {
  margin-right: 1.75rem; }

.modal-dialog-bottom {
  display: flex;
  align-items: flex-end;
  min-height: calc(100% - 1.75rem); }
  @media (min-width: 576px) {
    .modal-dialog-bottom {
      min-height: calc(100% - 3.5rem); } }

.modal-dialog-bottom-right {
  display: flex;
  align-items: flex-end;
  min-height: calc(100% - 1.75rem);
  margin-right: 1.75rem; }
  @media (min-width: 576px) {
    .modal-dialog-bottom-right {
      min-height: calc(100% - 3.5rem); } }

@keyframes fadeInLeft {
  0% {
    opacity: 0;
    transform: translate3d(-30%, 0, 0); }
  to {
    opacity: 1;
    transform: translateZ(0); } }

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translate3d(0, 30%, 0); }
  to {
    opacity: 1;
    transform: translateZ(0); } }

@keyframes zoomIn {
  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3); }
  50% {
    opacity: 1; } }

.login-modal {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
  background-size: cover;
  background-position: center; }

.pagination-separated .page-item .page-link {
  margin-left: 0.35rem;
  border-radius: 0.25rem; }

.pagination-rounded .page-link {
  border-radius: 30px !important;
  margin: 0 3px !important;
  border: none;
  min-width: 32px;
  min-height: 32px;
  text-align: center; }

.pagination-rounded.pagination-sm .page-link {
  min-width: 25px;
  min-height: 25px; }

.page-item.active .page-link {
  box-shadow: none; }

.progress-sm {
  height: 5px; }

.progress-lg {
  height: 12px; }

.progress-xl {
  height: 16px; }

.custom-progess {
  position: relative; }
  .custom-progess .progress-icon {
    position: absolute;
    top: -12px; }
    .custom-progess .progress-icon .avatar-title {
      background: var(--vz-card-bg-custom); }

.animated-progress {
  position: relative; }
  .animated-progress .progress-bar {
    position: relative;
    border-radius: 6px;
    animation: animate-positive 2s; }

@keyframes animate-positive {
  0% {
    width: 0; } }

.custom-progress {
  height: 15px;
  padding: 4px;
  border-radius: 30px; }
  .custom-progress .progress-bar {
    position: relative;
    border-radius: 30px; }
    .custom-progress .progress-bar::before {
      content: "";
      position: absolute;
      width: 4px;
      height: 4px;
      background-color: #fff;
      border-radius: 7px;
      right: 2px;
      top: 50%;
      transform: translateY(-50%); }

.progress-label {
  overflow: visible; }
  .progress-label .progress-bar {
    position: relative;
    overflow: visible; }
    .progress-label .progress-bar .label {
      position: absolute;
      top: -25px;
      right: -9px;
      background-color: #F26430;
      color: #fff;
      display: inline-block;
      line-height: 18px;
      padding: 0 4px;
      border-radius: 4px; }
      .progress-label .progress-bar .label:after {
        content: "";
        position: absolute;
        border: 4px solid transparent;
        border-top-color: #F26430;
        bottom: -7px;
        left: 50%;
        transform: translateX(-50%); }

.progress-step-arrow {
  height: 3.25rem; }
  .progress-step-arrow .progress-bar {
    position: relative;
    overflow: initial;
    font-size: .875rem;
    color: #fff; }
    .progress-step-arrow .progress-bar::after {
      content: "";
      position: absolute;
      border: 10px solid transparent;
      bottom: 15px;
      right: -20px;
      z-index: 1; }

.progress-primary .progress-bar {
  background-color: #F26430; }
  .progress-primary .progress-bar::after {
    border-left-color: #F26430; }
  .progress-primary .progress-bar:nth-child(2) {
    background-color: rgba(242, 100, 48, 0.1) !important;
    color: #F26430 !important; }
    .progress-primary .progress-bar:nth-child(2)::after {
      border-left-color: rgba(242, 100, 48, 0.1); }

.progress-secondary .progress-bar {
  background-color: #208C3B; }
  .progress-secondary .progress-bar::after {
    border-left-color: #208C3B; }
  .progress-secondary .progress-bar:nth-child(2) {
    background-color: rgba(32, 140, 59, 0.1) !important;
    color: #208C3B !important; }
    .progress-secondary .progress-bar:nth-child(2)::after {
      border-left-color: rgba(32, 140, 59, 0.1); }

.progress-success .progress-bar {
  background-color: #0ab39c; }
  .progress-success .progress-bar::after {
    border-left-color: #0ab39c; }
  .progress-success .progress-bar:nth-child(2) {
    background-color: rgba(10, 179, 156, 0.1) !important;
    color: #0ab39c !important; }
    .progress-success .progress-bar:nth-child(2)::after {
      border-left-color: rgba(10, 179, 156, 0.1); }

.progress-info .progress-bar {
  background-color: #299cdb; }
  .progress-info .progress-bar::after {
    border-left-color: #299cdb; }
  .progress-info .progress-bar:nth-child(2) {
    background-color: rgba(41, 156, 219, 0.1) !important;
    color: #299cdb !important; }
    .progress-info .progress-bar:nth-child(2)::after {
      border-left-color: rgba(41, 156, 219, 0.1); }

.progress-warning .progress-bar {
  background-color: #3FBF48; }
  .progress-warning .progress-bar::after {
    border-left-color: #3FBF48; }
  .progress-warning .progress-bar:nth-child(2) {
    background-color: rgba(63, 191, 72, 0.1) !important;
    color: #3FBF48 !important; }
    .progress-warning .progress-bar:nth-child(2)::after {
      border-left-color: rgba(63, 191, 72, 0.1); }

.progress-danger .progress-bar {
  background-color: #f06548; }
  .progress-danger .progress-bar::after {
    border-left-color: #f06548; }
  .progress-danger .progress-bar:nth-child(2) {
    background-color: rgba(240, 101, 72, 0.1) !important;
    color: #f06548 !important; }
    .progress-danger .progress-bar:nth-child(2)::after {
      border-left-color: rgba(240, 101, 72, 0.1); }

.progress-light .progress-bar {
  background-color: #f3f6f9; }
  .progress-light .progress-bar::after {
    border-left-color: #f3f6f9; }
  .progress-light .progress-bar:nth-child(2) {
    background-color: rgba(243, 246, 249, 0.1) !important;
    color: #f3f6f9 !important; }
    .progress-light .progress-bar:nth-child(2)::after {
      border-left-color: rgba(243, 246, 249, 0.1); }

.progress-dark .progress-bar {
  background-color: #212529; }
  .progress-dark .progress-bar::after {
    border-left-color: #212529; }
  .progress-dark .progress-bar:nth-child(2) {
    background-color: rgba(33, 37, 41, 0.1) !important;
    color: #212529 !important; }
    .progress-dark .progress-bar:nth-child(2)::after {
      border-left-color: rgba(33, 37, 41, 0.1); }

.popover {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12); }

.text-white-75 {
  color: rgba(255, 255, 255, 0.75) !important; }

.custom-blockquote.blockquote {
  padding: 16px;
  border-left: 3px solid; }
  .custom-blockquote.blockquote.blockquote-outline {
    background-color: var(--vz-card-bg-custom) !important;
    border: 1px solid;
    border-left: 3px solid; }

.custom-blockquote.blockquote.blockquote-primary {
  color: #F26430;
  border-color: #F26430;
  background-color: rgba(242, 100, 48, 0.15); }
  .custom-blockquote.blockquote.blockquote-primary .blockquote-footer {
    color: #F26430; }

.custom-blockquote.blockquote.blockquote-outline.blockquote-primary {
  border-color: #F26430; }
  .custom-blockquote.blockquote.blockquote-outline.blockquote-primary .blockquote-footer {
    color: #F26430; }

.custom-blockquote.blockquote.blockquote-secondary {
  color: #208C3B;
  border-color: #208C3B;
  background-color: rgba(32, 140, 59, 0.15); }
  .custom-blockquote.blockquote.blockquote-secondary .blockquote-footer {
    color: #208C3B; }

.custom-blockquote.blockquote.blockquote-outline.blockquote-secondary {
  border-color: #208C3B; }
  .custom-blockquote.blockquote.blockquote-outline.blockquote-secondary .blockquote-footer {
    color: #208C3B; }

.custom-blockquote.blockquote.blockquote-success {
  color: #0ab39c;
  border-color: #0ab39c;
  background-color: rgba(10, 179, 156, 0.15); }
  .custom-blockquote.blockquote.blockquote-success .blockquote-footer {
    color: #0ab39c; }

.custom-blockquote.blockquote.blockquote-outline.blockquote-success {
  border-color: #0ab39c; }
  .custom-blockquote.blockquote.blockquote-outline.blockquote-success .blockquote-footer {
    color: #0ab39c; }

.custom-blockquote.blockquote.blockquote-info {
  color: #299cdb;
  border-color: #299cdb;
  background-color: rgba(41, 156, 219, 0.15); }
  .custom-blockquote.blockquote.blockquote-info .blockquote-footer {
    color: #299cdb; }

.custom-blockquote.blockquote.blockquote-outline.blockquote-info {
  border-color: #299cdb; }
  .custom-blockquote.blockquote.blockquote-outline.blockquote-info .blockquote-footer {
    color: #299cdb; }

.custom-blockquote.blockquote.blockquote-warning {
  color: #3FBF48;
  border-color: #3FBF48;
  background-color: rgba(63, 191, 72, 0.15); }
  .custom-blockquote.blockquote.blockquote-warning .blockquote-footer {
    color: #3FBF48; }

.custom-blockquote.blockquote.blockquote-outline.blockquote-warning {
  border-color: #3FBF48; }
  .custom-blockquote.blockquote.blockquote-outline.blockquote-warning .blockquote-footer {
    color: #3FBF48; }

.custom-blockquote.blockquote.blockquote-danger {
  color: #f06548;
  border-color: #f06548;
  background-color: rgba(240, 101, 72, 0.15); }
  .custom-blockquote.blockquote.blockquote-danger .blockquote-footer {
    color: #f06548; }

.custom-blockquote.blockquote.blockquote-outline.blockquote-danger {
  border-color: #f06548; }
  .custom-blockquote.blockquote.blockquote-outline.blockquote-danger .blockquote-footer {
    color: #f06548; }

.custom-blockquote.blockquote.blockquote-light {
  color: #f3f6f9;
  border-color: #f3f6f9;
  background-color: rgba(243, 246, 249, 0.15); }
  .custom-blockquote.blockquote.blockquote-light .blockquote-footer {
    color: #f3f6f9; }

.custom-blockquote.blockquote.blockquote-outline.blockquote-light {
  border-color: #f3f6f9; }
  .custom-blockquote.blockquote.blockquote-outline.blockquote-light .blockquote-footer {
    color: #f3f6f9; }

.custom-blockquote.blockquote.blockquote-dark {
  color: #212529;
  border-color: #212529;
  background-color: rgba(33, 37, 41, 0.15); }
  .custom-blockquote.blockquote.blockquote-dark .blockquote-footer {
    color: #212529; }

.custom-blockquote.blockquote.blockquote-outline.blockquote-dark {
  border-color: #212529; }
  .custom-blockquote.blockquote.blockquote-outline.blockquote-dark .blockquote-footer {
    color: #212529; }

.custom-blockquote.blockquote.blockquote-dark {
  color: var(--vz-dark);
  border-color: var(--vz-dark);
  background-color: rgba(var(--vz-dark-rgb), 0.15); }
  .custom-blockquote.blockquote.blockquote-dark .blockquote-footer {
    color: var(--vz-dark); }

.custom-blockquote.blockquote.blockquote-outline.blockquote-dark {
  border-color: var(--vz-dark); }
  .custom-blockquote.blockquote.blockquote-outline.blockquote-dark .blockquote-footer {
    color: var(--vz-dark); }

.form-check {
  position: relative;
  text-align: left; }
  .form-check .form-check-input {
    cursor: pointer; }
  .form-check label {
    cursor: pointer; }

.form-check-primary .form-check-input:checked {
  background-color: #F26430;
  border-color: #F26430; }

.form-radio-primary .form-check-input:checked {
  border-color: #F26430;
  background-color: #F26430; }
  .form-radio-primary .form-check-input:checked:after {
    background-color: #F26430; }

.form-check-secondary .form-check-input:checked {
  background-color: #208C3B;
  border-color: #208C3B; }

.form-radio-secondary .form-check-input:checked {
  border-color: #208C3B;
  background-color: #208C3B; }
  .form-radio-secondary .form-check-input:checked:after {
    background-color: #208C3B; }

.form-check-success .form-check-input:checked {
  background-color: #0ab39c;
  border-color: #0ab39c; }

.form-radio-success .form-check-input:checked {
  border-color: #0ab39c;
  background-color: #0ab39c; }
  .form-radio-success .form-check-input:checked:after {
    background-color: #0ab39c; }

.form-check-info .form-check-input:checked {
  background-color: #299cdb;
  border-color: #299cdb; }

.form-radio-info .form-check-input:checked {
  border-color: #299cdb;
  background-color: #299cdb; }
  .form-radio-info .form-check-input:checked:after {
    background-color: #299cdb; }

.form-check-warning .form-check-input:checked {
  background-color: #3FBF48;
  border-color: #3FBF48; }

.form-radio-warning .form-check-input:checked {
  border-color: #3FBF48;
  background-color: #3FBF48; }
  .form-radio-warning .form-check-input:checked:after {
    background-color: #3FBF48; }

.form-check-danger .form-check-input:checked {
  background-color: #f06548;
  border-color: #f06548; }

.form-radio-danger .form-check-input:checked {
  border-color: #f06548;
  background-color: #f06548; }
  .form-radio-danger .form-check-input:checked:after {
    background-color: #f06548; }

.form-check-light .form-check-input:checked {
  background-color: #f3f6f9;
  border-color: #f3f6f9; }

.form-radio-light .form-check-input:checked {
  border-color: #f3f6f9;
  background-color: #f3f6f9; }
  .form-radio-light .form-check-input:checked:after {
    background-color: #f3f6f9; }

.form-check-dark .form-check-input:checked {
  background-color: #212529;
  border-color: #212529; }

.form-radio-dark .form-check-input:checked {
  border-color: #212529;
  background-color: #212529; }
  .form-radio-dark .form-check-input:checked:after {
    background-color: #212529; }

.form-check-label {
  cursor: pointer;
  margin-bottom: 0; }

.form-check-right {
  padding-left: 0;
  display: inline-block; }
  .form-check-right .form-check-input {
    float: right;
    margin-left: 0;
    margin-right: -1.6em; }
  .form-check-right .form-check-label {
    display: block; }
  .form-check-right.form-switch .form-check-input {
    margin-right: -2.56em; }

.form-check-outline.form-check-primary .form-check-input:checked[type=checkbox] {
  color: #F26430;
  background-color: transparent;
  border-color: #F26430; }

.form-check-outline.form-check-secondary .form-check-input:checked[type=checkbox] {
  color: #208C3B;
  background-color: transparent;
  border-color: #208C3B; }

.form-check-outline.form-check-success .form-check-input:checked[type=checkbox] {
  color: #0ab39c;
  background-color: transparent;
  border-color: #0ab39c; }

.form-check-outline.form-check-info .form-check-input:checked[type=checkbox] {
  color: #299cdb;
  background-color: transparent;
  border-color: #299cdb; }

.form-check-outline.form-check-warning .form-check-input:checked[type=checkbox] {
  color: #3FBF48;
  background-color: transparent;
  border-color: #3FBF48; }

.form-check-outline.form-check-danger .form-check-input:checked[type=checkbox] {
  color: #f06548;
  background-color: transparent;
  border-color: #f06548; }

.form-check-outline.form-check-light .form-check-input:checked[type=checkbox] {
  color: #f3f6f9;
  background-color: transparent;
  border-color: #f3f6f9; }

.form-check-outline.form-check-dark .form-check-input:checked[type=checkbox] {
  color: #212529;
  background-color: transparent;
  border-color: #212529; }

.form-check-outline .form-check-input {
  position: relative; }
  .form-check-outline .form-check-input:checked[type=checkbox] {
    background-image: none; }
    .form-check-outline .form-check-input:checked[type=checkbox]::before {
      content: "\\F012C";
      font-family: "Material Design Icons";
      top: -2px;
      position: absolute;
      font-weight: 700;
      font-size: 11px;
      left: 1px; }

.form-radio-outline.form-radio-primary .form-check-input:checked[type=radio] {
  color: #F26430;
  background-color: transparent;
  border-color: #F26430; }

.form-radio-outline.form-radio-secondary .form-check-input:checked[type=radio] {
  color: #208C3B;
  background-color: transparent;
  border-color: #208C3B; }

.form-radio-outline.form-radio-success .form-check-input:checked[type=radio] {
  color: #0ab39c;
  background-color: transparent;
  border-color: #0ab39c; }

.form-radio-outline.form-radio-info .form-check-input:checked[type=radio] {
  color: #299cdb;
  background-color: transparent;
  border-color: #299cdb; }

.form-radio-outline.form-radio-warning .form-check-input:checked[type=radio] {
  color: #3FBF48;
  background-color: transparent;
  border-color: #3FBF48; }

.form-radio-outline.form-radio-danger .form-check-input:checked[type=radio] {
  color: #f06548;
  background-color: transparent;
  border-color: #f06548; }

.form-radio-outline.form-radio-light .form-check-input:checked[type=radio] {
  color: #f3f6f9;
  background-color: transparent;
  border-color: #f3f6f9; }

.form-radio-outline.form-radio-dark .form-check-input:checked[type=radio] {
  color: #212529;
  background-color: transparent;
  border-color: #212529; }

.form-radio-outline .form-check-input {
  position: relative; }
  .form-radio-outline .form-check-input:checked[type=radio] {
    background-image: none; }
    .form-radio-outline .form-check-input:checked[type=radio]::before {
      content: "\\F0765";
      font-family: "Material Design Icons";
      top: 0px;
      position: absolute;
      font-size: 8px;
      left: 2.2px; }

.form-switch-md {
  padding-left: 2.5rem;
  min-height: 22px;
  line-height: 22px; }
  .form-switch-md .form-check-input {
    width: 40px;
    height: 20px;
    left: -0.5rem;
    position: relative; }
  .form-switch-md .form-check-label {
    vertical-align: middle; }

.form-switch-lg {
  padding-left: 2.75rem;
  min-height: 28px;
  line-height: 28px; }
  .form-switch-lg .form-check-input {
    width: 48px;
    height: 24px;
    left: -0.75rem;
    position: relative; }

.input-group-text {
  margin-bottom: 0px; }

.form-switch-primary .form-check-input:checked {
  background-color: #F26430;
  border-color: #F26430; }

.form-switch-custom.form-switch-primary .form-check-input:checked::before {
  color: #F26430; }

.form-switch-secondary .form-check-input:checked {
  background-color: #208C3B;
  border-color: #208C3B; }

.form-switch-custom.form-switch-secondary .form-check-input:checked::before {
  color: #208C3B; }

.form-switch-success .form-check-input:checked {
  background-color: #0ab39c;
  border-color: #0ab39c; }

.form-switch-custom.form-switch-success .form-check-input:checked::before {
  color: #0ab39c; }

.form-switch-info .form-check-input:checked {
  background-color: #299cdb;
  border-color: #299cdb; }

.form-switch-custom.form-switch-info .form-check-input:checked::before {
  color: #299cdb; }

.form-switch-warning .form-check-input:checked {
  background-color: #3FBF48;
  border-color: #3FBF48; }

.form-switch-custom.form-switch-warning .form-check-input:checked::before {
  color: #3FBF48; }

.form-switch-danger .form-check-input:checked {
  background-color: #f06548;
  border-color: #f06548; }

.form-switch-custom.form-switch-danger .form-check-input:checked::before {
  color: #f06548; }

.form-switch-light .form-check-input:checked {
  background-color: #f3f6f9;
  border-color: #f3f6f9; }

.form-switch-custom.form-switch-light .form-check-input:checked::before {
  color: #f3f6f9; }

.form-switch-dark .form-check-input:checked {
  background-color: #212529;
  border-color: #212529; }

.form-switch-custom.form-switch-dark .form-check-input:checked::before {
  color: #212529; }

.form-switch-custom .form-check-input {
  position: relative;
  background-image: none; }
  .form-switch-custom .form-check-input::before {
    content: "\\F0765";
    font-family: "Material Design Icons";
    top: -9px;
    position: absolute;
    font-size: 20px;
    left: -3px;
    color: #878a99;
    transition: background-position 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-switch-custom .form-check-input::before {
        transition: none; } }
  .form-switch-custom .form-check-input:checked {
    background-image: none;
    background-color: var(--vz-input-bg);
    transition: background-position 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-switch-custom .form-check-input:checked {
        transition: none; } }
    .form-switch-custom .form-check-input:checked::before {
      right: -3px;
      left: auto; }
  .form-switch-custom .form-check-input:focus {
    background-image: none; }

.form-switch-right {
  display: inline-block;
  padding-right: 0.8em;
  margin-bottom: 0;
  padding-left: 0 !important; }
  .form-switch-right .form-check-input {
    float: right;
    margin-left: 0;
    margin-right: -1.6em;
    margin-top: .1em !important; }
  .form-switch-right label {
    margin-bottom: 0;
    margin-right: 1rem; }

.card-radio {
  padding: 0; }
  .card-radio .form-check-label {
    background-color: var(--vz-card-bg-custom);
    border: 1px solid var(--vz-input-check-border);
    border-radius: 0.25rem;
    padding: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    position: relative;
    padding-right: 32px; }
    .card-radio .form-check-label:hover {
      cursor: pointer; }
  .card-radio .form-check-input {
    display: none; }
    .card-radio .form-check-input:checked + .form-check-label {
      border-color: #F26430 !important; }
      .card-radio .form-check-input:checked + .form-check-label:before {
        content: '\\eb80';
        font-family: "remixicon";
        position: absolute;
        top: 2px;
        right: 6px;
        font-size: 16px;
        color: #F26430; }
  .card-radio.dark .form-check-input:checked + .form-check-label:before {
    color: #fff; }

[data-layout-mode="dark"] .form-switch .form-check-input, [data-layout-mode="dark"] .form-switch .form-check-input:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___}); }

.form-icon {
  position: relative; }
  .form-icon .form-control-icon {
    padding-left: 2.7rem;
    position: relative; }
  .form-icon i {
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 18px;
    display: flex;
    align-items: center; }
  .form-icon.right .form-control-icon {
    padding-right: 2.7rem;
    padding-left: 0.9rem;
    position: relative; }
  .form-icon.right i {
    left: auto;
    right: 18px; }

[data-layout-mode="dark"] .form-select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
  background-color: var(--vz-gray-200) !important;
  border-color: var(--vz-border-color) !important; }

[data-layout-mode="dark"] .form-control {
  background-color: var(--vz-gray-200) !important;
  border-color: var(--vz-border-color) !important; }

.list-group-fill-primary .list-group-item.active {
  background-color: #F26430 !important;
  border-color: #F26430; }

.list-group-fill-secondary .list-group-item.active {
  background-color: #208C3B !important;
  border-color: #208C3B; }

.list-group-fill-success .list-group-item.active {
  background-color: #0ab39c !important;
  border-color: #0ab39c; }

.list-group-fill-info .list-group-item.active {
  background-color: #299cdb !important;
  border-color: #299cdb; }

.list-group-fill-warning .list-group-item.active {
  background-color: #3FBF48 !important;
  border-color: #3FBF48; }

.list-group-fill-danger .list-group-item.active {
  background-color: #f06548 !important;
  border-color: #f06548; }

.list-group-fill-light .list-group-item.active {
  background-color: #f3f6f9 !important;
  border-color: #f3f6f9; }

.list-group-fill-dark .list-group-item.active {
  background-color: #212529 !important;
  border-color: #212529; }

.list-group-fill-light {
  color: #212529 !important; }

.list-group-item {
  margin-bottom: 0px; }
  .list-group-item .list-text {
    color: #878a99; }
  .list-group-item.active {
    box-shadow: none; }
    .list-group-item.active .list-title {
      color: #fff; }
    .list-group-item.active .list-text {
      color: rgba(255, 255, 255, 0.5); }

[data-simplebar] {
  position: relative;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start; }

.simplebar-wrapper {
  overflow: hidden;
  width: inherit;
  height: inherit;
  max-width: inherit;
  max-height: inherit; }

.simplebar-mask {
  direction: inherit;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: auto !important;
  height: auto !important;
  z-index: 0; }

.simplebar-offset {
  direction: inherit !important;
  box-sizing: inherit !important;
  resize: none !important;
  position: absolute;
  top: 0;
  left: 0 !important;
  bottom: 0;
  right: 0 !important;
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch; }

.simplebar-content-wrapper {
  direction: inherit;
  box-sizing: border-box !important;
  position: relative;
  display: block;
  height: 100%;
  /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */
  width: auto;
  visibility: visible;
  overflow: auto;
  /* Scroll on this element otherwise element can't have a padding applied properly */
  max-width: 100%;
  /* Not required for horizontal scroll to trigger */
  max-height: 100%;
  /* Needed for vertical scroll to trigger */
  scrollbar-width: none;
  padding: 0px !important; }

.simplebar-content-wrapper::-webkit-scrollbar,
.simplebar-hide-scrollbar::-webkit-scrollbar {
  display: none; }

.simplebar-content:before,
.simplebar-content:after {
  content: ' ';
  display: table; }

.simplebar-placeholder {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  pointer-events: none; }

.simplebar-height-auto-observer-wrapper {
  box-sizing: inherit !important;
  height: 100%;
  width: 100%;
  max-width: 1px;
  position: relative;
  float: left;
  max-height: 1px;
  overflow: hidden;
  z-index: -1;
  padding: 0;
  margin: 0;
  pointer-events: none;
  flex-grow: inherit;
  flex-shrink: 0;
  flex-basis: 0; }

.simplebar-height-auto-observer {
  box-sizing: inherit;
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 1000%;
  width: 1000%;
  min-height: 1px;
  min-width: 1px;
  overflow: hidden;
  pointer-events: none;
  z-index: -1; }

.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden; }

[data-simplebar].simplebar-dragging .simplebar-content {
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none; }

[data-simplebar].simplebar-dragging .simplebar-track {
  pointer-events: all; }

.simplebar-scrollbar {
  position: absolute;
  right: 2px;
  width: 6px;
  min-height: 10px; }

.simplebar-scrollbar:before {
  position: absolute;
  content: '';
  background: #a2adb7;
  border-radius: 7px;
  left: 0;
  right: 0;
  opacity: 0;
  transition: opacity 0.2s linear; }

.simplebar-scrollbar.simplebar-visible:before {
  /* When hovered, remove all transitions from drag handle */
  opacity: 0.5;
  transition: opacity 0s linear; }

.simplebar-track.simplebar-vertical {
  top: 0;
  width: 11px; }

.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
  top: 2px;
  bottom: 2px; }

.simplebar-track.simplebar-horizontal {
  left: 0;
  height: 11px; }

.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {
  height: 100%;
  left: 2px;
  right: 2px; }

.simplebar-track.simplebar-horizontal .simplebar-scrollbar {
  right: auto;
  left: 0;
  top: 2px;
  height: 7px;
  min-height: 0;
  min-width: 10px;
  width: auto; }

/* Rtl support */
[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {
  right: auto;
  left: 0; }

.hs-dummy-scrollbar-size {
  direction: rtl;
  position: fixed;
  opacity: 0;
  visibility: hidden;
  height: 500px;
  width: 500px;
  overflow-y: hidden;
  overflow-x: scroll; }

.simplebar-hide-scrollbar {
  position: fixed;
  left: 0;
  visibility: hidden;
  overflow-y: scroll;
  scrollbar-width: none; }

.custom-scroll {
  height: 100%; }

[data-simplebar-track="primary"] .simplebar-scrollbar:before {
  background: #F26430; }

[data-simplebar-track="secondary"] .simplebar-scrollbar:before {
  background: #208C3B; }

[data-simplebar-track="success"] .simplebar-scrollbar:before {
  background: #0ab39c; }

[data-simplebar-track="info"] .simplebar-scrollbar:before {
  background: #299cdb; }

[data-simplebar-track="warning"] .simplebar-scrollbar:before {
  background: #3FBF48; }

[data-simplebar-track="danger"] .simplebar-scrollbar:before {
  background: #f06548; }

[data-simplebar-track="light"] .simplebar-scrollbar:before {
  background: #f3f6f9; }

[data-simplebar-track="dark"] .simplebar-scrollbar:before {
  background: #212529; }

/**
 * prism.js default theme for JavaScript, CSS and HTML
 * Based on dabblet (http://dabblet.com)
 * @author Lea Verou
 */
code[class*="language-"],
pre[class*="language-"] {
  color: black;
  background: none;
  text-shadow: 0 1px white;
  font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
  font-size: 1em;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  line-height: 1.5;
  tab-size: 4;
  hyphens: none; }

pre[class*="language-"]::selection,
pre[class*="language-"] ::selection,
code[class*="language-"]::selection,
code[class*="language-"] ::selection {
  text-shadow: none;
  background: #b3d4fc; }

@media print {
  code[class*="language-"],
  pre[class*="language-"] {
    text-shadow: none; } }

/* Code blocks */
pre[class*="language-"] {
  padding: 1em;
  margin: 0;
  overflow: auto; }

:not(pre) > code[class*="language-"],
pre[class*="language-"] {
  background: var(--vz-light) !important; }

/* Inline code */
:not(pre) > code[class*="language-"] {
  padding: 0.1em;
  border-radius: 0.3em;
  white-space: normal; }

.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
  color: slategray; }

.token.punctuation {
  color: #999; }

.token.namespace {
  opacity: 0.7; }

.token.property,
.token.tag,
.token.boolean,
.token.number,
.token.constant,
.token.symbol,
.token.deleted {
  color: #f06548; }

.token.selector,
.token.attr-name,
.token.string,
.token.char,
.token.builtin,
.token.inserted {
  color: #690; }

.token.operator,
.token.entity,
.token.url,
.language-css .token.string,
.style .token.string {
  color: #9a6e3a;
  /* This background color was intended by the author of this theme. */
  background: rgba(255, 255, 255, 0.5); }

.token.atrule,
.token.attr-value,
.token.keyword {
  color: #07a; }

.token.function,
.token.class-name {
  color: #dd4a68; }

.token.regex,
.token.important,
.token.variable {
  color: #e90; }

.token.important,
.token.bold {
  font-weight: bold; }

.token.italic {
  font-style: italic; }

.token.entity {
  cursor: help; }

/* Prism editor */
:not(pre) > code[class*="language-"],
pre[class*="language-"] {
  background: #eff2f7; }

code[class*="language-"],
pre[class*="language-"] {
  color: #878a99;
  text-shadow: none; }

.language-markup::-webkit-scrollbar {
  -webkit-appearance: none; }

.language-markup::-webkit-scrollbar:vertical {
  width: 10px; }

.language-markup::-webkit-scrollbar:horizontal {
  height: 10px; }

.language-markup::-webkit-scrollbar-thumb {
  background-color: rgba(var(--vz-dark-rgb), 0.1);
  border-radius: 10px;
  border: 2px solid var(--vz-light); }

.language-markup::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: var(--vz-light); }

#scroll-top {
  width: 30px;
  height: 30px;
  position: fixed;
  bottom: 65px;
  right: 30px;
  background: #343a40;
  border-color: transparent;
  border-radius: 3px;
  color: #ffffff;
  transition: all 0.5s ease; }

.btn-clipboard {
  position: absolute !important;
  right: 15px !important;
  z-index: 1 !important; }

div.code-toolbar > .toolbar {
  opacity: 1 !important; }
  div.code-toolbar > .toolbar button {
    display: inline-block !important;
    margin: 0.375rem 0.5rem !important;
    padding: 0.25rem 0.75rem !important;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
    border-radius: 0.2rem !important;
    border: 1px solid rgba(242, 100, 48, 0.35) !important;
    background-color: transparent;
    color: #F26430 !important;
    box-shadow: none !important; }
    div.code-toolbar > .toolbar button:focus {
      outline: none !important;
      box-shadow: none !important; }
    div.code-toolbar > .toolbar button:hover {
      background-color: #F26430 !important;
      color: #fff !important; }

.swal2-container .swal2-title {
  padding: 24px 24px 0;
  font-size: 20px;
  font-weight: 500; }

.swal2-popup {
  padding-bottom: 24px;
  border-radius: 0.3rem;
  background-color: var(--vz-card-bg-custom);
  color: var(--vz-body-color); }
  .swal2-popup .swal2-title {
    color: var(--vz-heading-color); }
  .swal2-popup .swal2-html-container {
    color: var(--vz-body-color); }

.swal2-footer {
  border-top: 1px solid var(--vz-border-color);
  color: var(--vz-body-color); }

.swal2-html-container {
  font-size: 16px; }

.swal2-icon.swal2-question {
  border-color: #299cdb;
  color: #299cdb; }

.swal2-icon.swal2-success [class^=swal2-success-line] {
  background-color: #0ab39c; }

.swal2-icon.swal2-success .swal2-success-ring {
  border-color: rgba(10, 179, 156, 0.3); }

.swal2-icon.swal2-warning {
  border-color: #3FBF48;
  color: #3FBF48; }

.swal2-styled:focus {
  box-shadow: none; }

.swal2-loader {
  border-color: #F26430 transparent #F26430 transparent; }

.swal2-timer-progress-bar {
  background-color: rgba(10, 179, 156, 0.4); }

.swal2-progress-steps .swal2-progress-step {
  background: #F26430; }
  .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {
    background: #F26430; }
    .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step, .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step-line {
      background: rgba(242, 100, 48, 0.3); }

.swal2-progress-steps .swal2-progress-step-line {
  background: #F26430; }

.swal2-actions.swal2-loading .swal2-styled.swal2-confirm {
  border-left-color: #F26430 !important;
  border-right-color: #F26430 !important; }

.swal2-file, .swal2-input, .swal2-textarea {
  border: 1px solid var(--vz-input-border); }
  .swal2-file:focus, .swal2-input:focus, .swal2-textarea:focus {
    box-shadow: none;
    border-color: var(--vz-input-focus-border); }

.swal2-input {
  height: auto;
  display: block;
  padding: 0.5rem 0.9rem;
  font-size: 0.8125rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  background-color: var(--vz-input-bg);
  background-clip: padding-box;
  border: 1px solid var(--vz-input-border); }

.swal2-close {
  font-family: var(--vz-font-sans-serif);
  font-weight: 300;
  font-size: 28px; }
  .swal2-close:focus {
    box-shadow: none; }
  .swal2-close:hover {
    color: #F26430; }

.swal2-validation-message {
  background-color: transparent; }

.dropzone {
  min-height: 230px;
  border: 2px dashed var(--vz-border-color);
  background: var(--vz-card-bg-custom);
  border-radius: 6px; }
  .dropzone .dz-message {
    font-size: 24px;
    width: 100%;
    margin: 1em 0; }

.noUi-connect {
  background: #0ab39c; }

.noUi-handle {
  background: #0ab39c;
  border: 2px solid var(--vz-card-bg);
  box-shadow: none; }

.noUi-horizontal {
  height: 4px; }
  .noUi-horizontal .noUi-handle {
    height: 16px;
    width: 16px;
    border-radius: 50%;
    right: -10px !important;
    top: -7px; }
    .noUi-horizontal .noUi-handle::before, .noUi-horizontal .noUi-handle::after {
      display: none; }
    .noUi-horizontal .noUi-handle:focus {
      outline: 0; }

.noUi-pips-horizontal {
  height: 50px; }

.noUi-tooltip {
  padding: 0.4rem 0.7rem;
  border-color: var(--vz-border-color);
  border-radius: 0.2rem;
  background-color: var(--vz-card-bg-custom);
  color: var(--vz-body-color); }

.noUi-vertical {
  width: 4px; }
  .noUi-vertical .noUi-handle {
    height: 16px;
    width: 16px;
    right: -8px;
    top: -12px;
    left: auto;
    border-radius: 50%; }
    .noUi-vertical .noUi-handle::before, .noUi-vertical .noUi-handle::after {
      display: none; }
    .noUi-vertical .noUi-handle:focus {
      outline: 0; }
  .noUi-vertical .noUi-origin {
    top: 0; }

.noUi-value {
  font-size: 12px; }

.noUi-marker-horizontal.noUi-marker-large {
  height: 12px; }

.noUi-value-horizontal {
  padding-top: 4px; }

.noUi-target {
  box-shadow: none;
  background-color: var(--vz-light);
  border-color: var(--vz-light); }

.noUi-touch-area:focus {
  outline: 0; }

#red, #green, #blue {
  margin: 10px;
  display: inline-block;
  height: 200px; }

#colorpicker {
  height: 240px;
  width: 310px;
  margin: 0 auto;
  padding: 10px;
  border: 1px solid var(--vz-border-color); }

#result {
  margin: 60px 26px;
  height: 100px;
  width: 100px;
  display: inline-block;
  vertical-align: top;
  border: 1px solid var(--vz-border-color);
  box-shadow: 0 0 3px;
  border-radius: 7px; }

#red .noUi-connect {
  background: #f06548; }

#green .noUi-connect {
  background: #0ab39c; }

#blue .noUi-connect {
  background: #F26430; }

.form-control.keyboard {
  max-width: 340px !important; }

.example-val {
  font-size: 12px;
  color: #878a99;
  display: block;
  margin: 15px 0; }
  .example-val:before {
    content: "Value: ";
    font-size: 12px;
    font-weight: 600; }

.noUi-tooltip {
  display: none; }

.noUi-active .noUi-tooltip {
  display: block; }

.c-1-color {
  background: #f06548; }

.c-2-color {
  background: #3FBF48; }

.c-3-color {
  background: #0ab39c; }

.c-4-color {
  background: #F26430; }

.c-5-color {
  background: #F28322; }

#slider-toggle {
  height: 50px; }
  #slider-toggle.off .noUi-handle {
    border-color: #f06548; }

[data-slider-color="primary"] .noUi-connect {
  background: #F26430; }

[data-slider-color="primary"] .noUi-handle {
  background: #F26430; }

[data-slider-color="primary"][data-slider-style="border"] .noUi-handle, [data-slider-color="primary"][data-slider-style="square"] .noUi-handle {
  border-color: #F26430; }

[data-slider-color="secondary"] .noUi-connect {
  background: #208C3B; }

[data-slider-color="secondary"] .noUi-handle {
  background: #208C3B; }

[data-slider-color="secondary"][data-slider-style="border"] .noUi-handle, [data-slider-color="secondary"][data-slider-style="square"] .noUi-handle {
  border-color: #208C3B; }

[data-slider-color="success"] .noUi-connect {
  background: #0ab39c; }

[data-slider-color="success"] .noUi-handle {
  background: #0ab39c; }

[data-slider-color="success"][data-slider-style="border"] .noUi-handle, [data-slider-color="success"][data-slider-style="square"] .noUi-handle {
  border-color: #0ab39c; }

[data-slider-color="info"] .noUi-connect {
  background: #299cdb; }

[data-slider-color="info"] .noUi-handle {
  background: #299cdb; }

[data-slider-color="info"][data-slider-style="border"] .noUi-handle, [data-slider-color="info"][data-slider-style="square"] .noUi-handle {
  border-color: #299cdb; }

[data-slider-color="warning"] .noUi-connect {
  background: #3FBF48; }

[data-slider-color="warning"] .noUi-handle {
  background: #3FBF48; }

[data-slider-color="warning"][data-slider-style="border"] .noUi-handle, [data-slider-color="warning"][data-slider-style="square"] .noUi-handle {
  border-color: #3FBF48; }

[data-slider-color="danger"] .noUi-connect {
  background: #f06548; }

[data-slider-color="danger"] .noUi-handle {
  background: #f06548; }

[data-slider-color="danger"][data-slider-style="border"] .noUi-handle, [data-slider-color="danger"][data-slider-style="square"] .noUi-handle {
  border-color: #f06548; }

[data-slider-color="light"] .noUi-connect {
  background: #f3f6f9; }

[data-slider-color="light"] .noUi-handle {
  background: #f3f6f9; }

[data-slider-color="light"][data-slider-style="border"] .noUi-handle, [data-slider-color="light"][data-slider-style="square"] .noUi-handle {
  border-color: #f3f6f9; }

[data-slider-color="dark"] .noUi-connect {
  background: #212529; }

[data-slider-color="dark"] .noUi-handle {
  background: #212529; }

[data-slider-color="dark"][data-slider-style="border"] .noUi-handle, [data-slider-color="dark"][data-slider-style="square"] .noUi-handle {
  border-color: #212529; }

[data-slider-size="lg"].noUi-horizontal {
  height: 12px; }
  [data-slider-size="lg"].noUi-horizontal .noUi-handle {
    width: 24px;
    height: 24px; }

[data-slider-size="md"].noUi-horizontal {
  height: 8px; }
  [data-slider-size="md"].noUi-horizontal .noUi-handle {
    width: 20px;
    height: 20px; }

[data-slider-size="sm"].noUi-horizontal {
  height: 4px; }
  [data-slider-size="sm"].noUi-horizontal .noUi-handle {
    width: 16px;
    height: 16px; }

[data-slider-style="line"].noUi-horizontal .noUi-handle {
  width: 8px;
  border-radius: 4px;
  right: -8px; }

[data-slider-style="line"].noUi-vertical .noUi-handle {
  height: 8px;
  border-radius: 4px;
  top: -3px; }

[data-slider-style="border"] .noUi-handle {
  border-color: #0ab39c;
  background-color: #fff; }

[data-slider-style="square"] .noUi-handle {
  border-radius: 0px;
  transform: rotate(45deg);
  height: 10px;
  width: 10px;
  top: -4px;
  border-color: #0ab39c;
  background-color: #fff; }

.nested-list .list-group-item {
  background-color: rgba(242, 100, 48, 0.05);
  border-color: rgba(242, 100, 48, 0.05); }

.nested-list, .nested-1, .nested-2, .nested-3 {
  margin-top: 5px; }

.nested-sortable-handle .handle {
  position: absolute;
  left: 0;
  top: 0;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab; }

.nested-sortable-handle .list-group-item {
  padding-left: 42px; }

.shepherd-element {
  background: var(--vz-card-bg-custom);
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15); }

.shepherd-has-title .shepherd-content .shepherd-header {
  background-color: var(--vz-light);
  padding: 0.5rem 0.75rem; }

.shepherd-has-title .shepherd-content .shepherd-cancel-icon {
  color: rgba(var(--vz-dark-rgb), 0.75); }
  .shepherd-has-title .shepherd-content .shepherd-cancel-icon:hover {
    color: rgba(var(--vz-dark-rgb), 0.75); }

.shepherd-element.shepherd-has-title[data-popper-placement^=bottom] > .shepherd-arrow:before {
  background-color: var(--vz-light); }

.shepherd-title {
  font-size: 15px;
  font-weight: 500;
  color: var(--vz-body-color); }

.shepherd-text {
  padding: 0.75rem;
  font-size: 0.8125rem;
  color: var(--vz-body-color); }

.shepherd-button.btn-success:not(:disabled):hover {
  background: #09a791;
  color: #fff; }

.shepherd-button.btn-light:not(:disabled):hover {
  background: rgba(var(--vz-light-rgb), 0.75);
  color: var(--vz-dark); }

.shepherd-button.btn-primary:not(:disabled):hover {
  background: #f15b24;
  color: #fff; }

.shepherd-footer {
  padding: 0 0.75rem 0.75rem; }

.shepherd-arrow,
.shepherd-arrow:before {
  content: "\\ea75";
  font-family: 'remixicon';
  font-size: 24px;
  z-index: 1;
  background-color: transparent !important;
  transform: rotate(0deg);
  color: #F26430; }

.shepherd-element[data-popper-placement^=bottom] > .shepherd-arrow {
  top: -18px; }

.shepherd-button {
  margin-right: 0.5rem; }

.swiper-button-next, .swiper-button-prev {
  height: 32px !important;
  width: 32px !important;
  background-color: rgba(242, 100, 48, 0.2);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  border-radius: 8px; }
  .swiper-button-next::after, .swiper-button-prev::after {
    font-family: remixicon !important;
    font-size: 28px !important;
    color: #f26430;
    transition: all 0.3s ease; }

.swiper-button-prev::after {
  content: "\\ea64" !important; }

.swiper-button-next::after {
  content: "\\ea6e" !important; }

.swiper-pagination-bullet {
  width: 22px !important;
  height: 5px !important;
  background-color: #fff !important;
  border-radius: 50px !important;
  box-shadow: none; }
  .swiper-pagination-bullet .swiper-pagination-bullet-active {
    opacity: 1; }

.dynamic-pagination .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  background-color: #fff;
  opacity: 0.5;
  transition: all 0.5s ease; }
  .dynamic-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
    opacity: 1;
    width: 20px; }

.swiper-pagination-fraction {
  color: #fff;
  font-size: 16px;
  background-color: rgba(0, 0, 0, 0.3);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px); }

.pagination-custom .swiper-pagination-bullet {
  height: 25px !important;
  width: 25px !important;
  line-height: 25px !important;
  border-radius: 8px !important;
  background-color: #fff !important;
  opacity: 0.5 !important;
  transition: all 0.5s ease; }
  .pagination-custom .swiper-pagination-bullet.swiper-pagination-bullet-active {
    color: #208C3B !important;
    opacity: 1 !important; }

.swiper-pagination-progressbar {
  height: 6px !important;
  background-color: rgba(10, 179, 156, 0.25) !important; }
  .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
    background-color: #0ab39c !important; }

.swiper-scrollbar {
  background-color: rgba(255, 255, 255, 0.35);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  padding: 1.2px;
  height: 6px !important; }
  .swiper-scrollbar .swiper-scrollbar-drag {
    background-color: #fff; }

.swiper-pagination-dark .swiper-pagination-bullet {
  background-color: #208C3B !important; }

.swiper-pagination-dark .dynamic-pagination .swiper-pagination-bullet {
  background-color: #208C3B !important; }

.swiper-pagination-dark.pagination-custom .swiper-pagination-bullet {
  color: #fff; }
  .swiper-pagination-dark.pagination-custom .swiper-pagination-bullet.swiper-pagination-bullet-active {
    opacity: 1; }

.swiper-pagination-dark.swiper-scrollbar {
  background-color: rgba(33, 37, 41, 0.35); }

.multi-wrapper {
  border: none;
  position: relative; }
  .multi-wrapper::before {
    content: "\\ea61";
    position: absolute;
    font-family: "remixicon";
    left: 50%;
    transform: translateX(-50%);
    bottom: 86px;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    border-radius: 50%;
    color: #878a99;
    background-color: var(--vz-light);
    z-index: 1; }
  .multi-wrapper .non-selected-wrapper {
    border: 1px solid var(--vz-input-border);
    background-color: var(--vz-input-bg);
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem; }
  .multi-wrapper .selected-wrapper::-webkit-scrollbar, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar {
    -webkit-appearance: none; }
  .multi-wrapper .selected-wrapper::-webkit-scrollbar:vertical, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar:vertical {
    width: 10px; }
  .multi-wrapper .selected-wrapper::-webkit-scrollbar:horizontal, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar:horizontal {
    height: 9px; }
  .multi-wrapper .selected-wrapper::-webkit-scrollbar-thumb, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar-thumb {
    background-color: rgba(var(--vz-dark-rgb), 0.2);
    border-radius: 10px;
    border: 2px solid var(--vz-input-bg); }
  .multi-wrapper .selected-wrapper::-webkit-scrollbar-track, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: var(--vz-input-bg); }
  .multi-wrapper .item-group .group-label {
    font-size: 12px; }
  .multi-wrapper .item {
    color: var(--vz-body-color); }
    .multi-wrapper .item:hover {
      background-color: rgba(242, 100, 48, 0.1); }
  .multi-wrapper .selected-wrapper {
    border: 1px solid var(--vz-input-border);
    background: var(--vz-input-bg);
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem; }
  .multi-wrapper .search-input {
    flex: 0 0 auto;
    padding: 0.5rem 0.9rem;
    font-size: 0.8125rem;
    color: var(--vz-body-color);
    background-color: var(--vz-input-bg);
    border: 1px solid var(--vz-input-border);
    border-radius: 0.25rem;
    margin-bottom: 16px; }
    .multi-wrapper .search-input::placeholder {
      color: #878a99; }
  .multi-wrapper .header {
    font-weight: 600;
    color: var(--vz-gray-600); }

.pcr-app {
  background: var(--vz-card-bg-custom);
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  border-radius: 4px;
  border: 1px solid var(--vz-border-color); }

.pickr .pcr-button {
  border: 4px solid var(--vz-card-bg-custom);
  box-shadow: 0px 0px 0 2px var(--vz-border-color);
  border-radius: 50%;
  box-shadow: none; }
  .pickr .pcr-button::after, .pickr .pcr-button::before {
    border-radius: 50%; }

.pcr-app[data-theme=classic] .pcr-selection .pcr-color-preview {
  margin-right: .75em;
  margin-left: 0; }

.pcr-app[data-theme=classic] .pcr-selection .pcr-color-chooser, .pcr-app[data-theme=classic] .pcr-selection .pcr-color-opacity {
  margin-left: .75em;
  margin-right: 0; }

.pcr-app[data-theme="monolith"] .pcr-result {
  min-width: 100%; }

.pcr-app .pcr-interaction .pcr-type.active {
  background: #F26430; }

.pcr-app .pcr-interaction .pcr-result {
  background-color: var(--vz-input-bg);
  color: var(--vz-body-color);
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem; }

.pcr-app .pcr-interaction input {
  border-radius: 0.25rem !important; }
  .pcr-app .pcr-interaction input:focus {
    box-shadow: none;
    background-color: var(--vz-input-bg);
    border-color: var(--vz-input-focus-border); }

.pcr-app .pcr-interaction .pcr-save {
  background: #0ab39c !important; }

.pcr-app .pcr-interaction .pcr-clear, .pcr-app .pcr-interaction .pcr-cancel {
  background: #f06548 !important; }

.filepond--root {
  margin-bottom: 0; }
  .filepond--root[data-style-panel-layout~=circle] .filepond--drop-label label {
    font-size: 14px; }

.filepond--panel-root {
  border: 2px dashed var(--vz-border-color);
  background: var(--vz-card-bg-custom); }

.filepond--drop-label {
  color: var(--vz-body-color); }
  .filepond--drop-label label {
    font-weight: 500; }

.filepond--credits {
  display: none; }

.filepond--item-panel {
  background-color: #F26430 !important; }

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  height: auto; }

.input-step {
  border: 1px solid var(--vz-input-border);
  display: inline-flex;
  overflow: visible;
  height: 37.5px;
  border-radius: 0.25rem;
  background: var(--vz-input-bg);
  padding: 4px; }
  .input-step input {
    width: 4em;
    height: 100%;
    text-align: center;
    border: 0;
    background: transparent;
    color: var(--vz-body-color);
    border-radius: 0.25rem; }
    .input-step input:focus-visible {
      outline: 0; }
  .input-step button {
    width: 1.4em;
    font-weight: 300;
    height: 100%;
    line-height: 0.1em;
    font-size: 1.4em;
    padding: 0.2em !important;
    background: var(--vz-light);
    color: var(--vz-body-color);
    border: none;
    border-radius: 0.25rem; }
  .input-step.light {
    background: var(--vz-light); }
    .input-step.light button {
      background-color: var(--vz-input-bg); }
  .input-step.light-input {
    background: var(--vz-light); }
    .input-step.light-input input {
      background-color: var(--vz-input-bg); }
  .input-step.full-width {
    display: flex;
    width: 100%; }
    .input-step.full-width button {
      flex-shrink: 0; }
    .input-step.full-width input {
      flex-grow: 1; }

.input-step.step-primary button {
  background-color: #F26430;
  color: #fff; }

.input-step.step-secondary button {
  background-color: #208C3B;
  color: #fff; }

.input-step.step-success button {
  background-color: #0ab39c;
  color: #fff; }

.input-step.step-info button {
  background-color: #299cdb;
  color: #fff; }

.input-step.step-warning button {
  background-color: #3FBF48;
  color: #fff; }

.input-step.step-danger button {
  background-color: #f06548;
  color: #fff; }

.input-step.step-light button {
  background-color: #f3f6f9;
  color: #fff; }

.input-step.step-dark button {
  background-color: #212529;
  color: #fff; }

.ck {
  font-family: var(--vz-font-sans-serif) !important; }
  .ck.ck-reset_all, .ck.ck-reset_all * {
    color: var(--vz-body-color) !important; }
  .ck.ck-toolbar {
    background: rgba(var(--vz-light-rgb), 0.75) !important; }
  .ck p {
    margin-bottom: 0; }
  .ck.ck-toolbar {
    border: 1px solid var(--vz-input-border) !important; }
    .ck.ck-toolbar.ck-toolbar_grouping > .ck-toolbar__items {
      flex-wrap: wrap !important; }
    .ck.ck-toolbar .ck.ck-toolbar__separator {
      background: transparent !important; }
  .ck.ck-editor__main > .ck-editor__editable {
    border-top: 0 !important;
    background-color: var(--vz-card-bg-custom) !important;
    border-color: var(--vz-input-border) !important;
    box-shadow: none !important; }
  .ck.ck-dropdown__panel {
    background: var(--vz-choices-bg) !important;
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    animation-name: DropDownSlide;
    animation-duration: .3s;
    animation-fill-mode: both;
    border-radius: 0.3rem; }
  .ck.ck-list {
    background: var(--vz-choices-bg) !important; }
  .ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne, .ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se {
    left: 0;
    right: auto !important; }
  .ck.ck-editor__editable_inline[dir=ltr] {
    text-align: left !important; }
  .ck.ck-dropdown__panel {
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12) !important;
    border-radius: 0.3rem !important;
    border: 1px solid var(--vz-border-color) !important; }

.ck.ck-button:focus, .ck.ck-button:active,
a.ck.ck-button:focus,
a.ck.ck-button:active {
  box-shadow: none !important;
  border: 1px solid var(--vz-light) !important; }

.ck.ck-button:not(.ck-disabled):hover,
a.ck.ck-button:not(.ck-disabled):hover {
  background: var(--vz-light) !important; }

.ck.ck-button.ck-on,
a.ck.ck-button.ck-on {
  background: var(--vz-light) !important; }

.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important; }

.ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important; }

.ck-editor__editable {
  min-height: 245px !important; }

.ck[class*=ck-heading_heading] {
  font-weight: 500 !important; }

.ck.ck-button.ck-on:not(.ck-disabled):hover, .ck.ck-button.ck-on:not(.ck-disabled):active,
a.ck.ck-button.ck-on:not(.ck-disabled):hover,
a.ck.ck-button.ck-on:not(.ck-disabled):active {
  box-shadow: none !important; }

.ck.ck-tooltip .ck-tooltip__text {
  background: #212529 !important;
  color: #f3f6f9 !important; }

.ck.ck-input-text {
  background: var(--vz-input-bg) !important;
  border: 1px solid var(--vz-input-border) !important; }
  .ck.ck-input-text:focus {
    border: 1px solid var(--vz-input-focus-border) !important;
    box-shadow: none !important; }

.ck.ck-balloon-panel {
  background: #fff !important;
  border: 1px solid var(--vz-border-color) !important; }
  .ck.ck-balloon-panel[class*=arrow_n]:after {
    border-bottom-color: #fff !important; }
  .ck.ck-balloon-panel[class*=arrow_n]::before {
    border-bottom-color: var(--vz-border-color) !important; }

.ck.ck-labeled-field-view > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {
  background: #fff !important; }

.ck-editor-reverse .ck-editor {
  display: flex;
  flex-direction: column-reverse; }

.ck-editor-reverse .ck.ck-editor__main > .ck-editor__editable {
  border: 1px solid var(--vz-input-border) !important;
  border-bottom: 0 !important; }

.ck-editor-reverse .ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck-editor-reverse .ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important; }

.ck-editor-reverse .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck-editor-reverse .ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important; }

[dir="rtl"] .ck.ck-toolbar > .ck-toolbar__items {
  flex-direction: row-reverse; }

.ql-editor {
  text-align: left; }
  .ql-editor ol,
  .ql-editor ul {
    padding-left: 1.5em;
    padding-right: 0; }
  .ql-editor li:not(.ql-direction-rtl)::before {
    margin-left: -1.5em;
    margin-right: 0.3em;
    text-align: right; }

.ql-container {
  font-family: var(--vz-font-sans-serif); }
  .ql-container.ql-snow {
    border-color: var(--vz-input-border);
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px; }

.ql-bubble {
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem; }

.ql-toolbar {
  font-family: var(--vz-font-sans-serif) !important; }
  .ql-toolbar span {
    outline: none !important;
    color: var(--vz-choices-link-color); }
    .ql-toolbar span:hover {
      color: #F26430 !important; }
  .ql-toolbar.ql-snow {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-color: var(--vz-input-border); }
    .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
      border-color: transparent; }
    .ql-toolbar.ql-snow .ql-picker-options {
      box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
      border-radius: 0.3rem; }

.ql-snow .ql-stroke,
.ql-snow .ql-script,
.ql-snow .ql-strike svg {
  stroke: var(--vz-choices-link-color); }

.ql-snow .ql-fill {
  fill: var(--vz-choices-link-color); }

.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
  right: 0;
  left: auto; }

.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  color: var(--vz-choices-link-color); }

.ql-snow .ql-picker-options {
  background-color: var(--vz-choices-bg);
  border-color: var(--vz-border-color) !important; }

.gridjs-container {
  color: var(--vz-body-color);
  padding: 0;
  display: block; }

.gridjs-wrapper {
  box-shadow: none;
  border: 1px solid var(--vz-border-color);
  border-radius: 0px; }
  .gridjs-wrapper::-webkit-scrollbar {
    -webkit-appearance: none; }
  .gridjs-wrapper::-webkit-scrollbar:vertical {
    width: 12px; }
  .gridjs-wrapper::-webkit-scrollbar:horizontal {
    height: 12px; }
  .gridjs-wrapper::-webkit-scrollbar-thumb {
    background-color: rgba(var(--vz-dark-rgb), 0.075);
    border-radius: 10px;
    border: 2px solid var(--vz-card-bg-custom); }
  .gridjs-wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: var(--vz-card-bg-custom); }

.gridjs-footer {
  border: none !important;
  padding: 12px 0 0; }

.gridjs-table {
  width: 100%; }

.gridjs-tbody, td.gridjs-td {
  background-color: transparent; }

th.gridjs-th,
td.gridjs-td {
  border: 1px solid var(--vz-border-color);
  padding: 0.75rem 0.6rem; }

th.gridjs-th {
  border-top: 0;
  color: var(--vz-body-color);
  background-color: rgba(var(--vz-light-rgb), 0.75); }

th.gridjs-th-sort:focus, th.gridjs-th-sort:hover {
  background-color: rgba(var(--vz-light-rgb), 0.85); }

.gridjs-head {
  padding-top: 0; }

.gridjs-footer {
  box-shadow: none;
  border: 1px solid var(--vz-border-color);
  border-top: 0;
  background-color: transparent; }

.gridjs-summary {
  color: #878a99;
  margin-top: 8px !important; }

.gridjs-pagination .gridjs-pages button {
  margin-left: 0.3rem;
  border-radius: 0.25rem !important;
  border: 1px solid var(--vz-border-color);
  background-color: var(--vz-card-bg-custom);
  color: var(--vz-link-color); }
  .gridjs-pagination .gridjs-pages button:last-child {
    border-right: 1px solid var(--vz-border-color); }
  .gridjs-pagination .gridjs-pages button:disabled, .gridjs-pagination .gridjs-pages button:hover:disabled, .gridjs-pagination .gridjs-pages button[disabled] {
    color: #878a99;
    background-color: var(--vz-card-bg-custom); }
  .gridjs-pagination .gridjs-pages button:hover {
    background-color: #eff2f7;
    color: var(--vz-link-hover-color); }
  .gridjs-pagination .gridjs-pages button:focus {
    box-shadow: none; }
  .gridjs-pagination .gridjs-pages button:last-child:hover, .gridjs-pagination .gridjs-pages button:first-child:hover {
    background-color: transparent; }
  .gridjs-pagination .gridjs-pages button.gridjs-currentPage {
    background-color: #F26430;
    color: #fff;
    border-color: #F26430;
    font-weight: 500; }

.gridjs-search {
  position: relative;
  float: left; }
  .gridjs-search::before {
    content: "\\f0d1";
    font-family: "remixicon";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 10px;
    font-size: 14px;
    color: #878a99; }

input.gridjs-input {
  border-color: var(--vz-input-border);
  background-color: var(--vz-input-bg);
  color: var(--vz-body-color);
  line-height: 1.5;
  padding: 0.5rem 0.9rem 0.5rem 2.025rem;
  border-radius: 0.25rem;
  font-size: 0.8125rem; }
  input.gridjs-input:focus {
    box-shadow: none;
    border-color: var(--vz-input-focus-border);
    background-color: var(--vz-input-bg); }
  input.gridjs-input::placeholder {
    color: #878a99; }

th.gridjs-th .gridjs-th-content {
  float: none;
  display: inline-block;
  vertical-align: middle;
  font-weight: 600; }

button.gridjs-sort {
  float: none;
  display: inline-block;
  vertical-align: middle;
  width: 10px;
  height: 20px; }

th.gridjs-th-sort .gridjs-th-content {
  width: calc(100% - 10px); }

button.gridjs-sort-asc, button.gridjs-sort-desc {
  background-size: 7px; }

.table-card .gridjs-head {
  padding: 16px 16px 5px; }

.table-card .gridjs-wrapper {
  border-top: 0;
  border-radius: 0;
  border-width: 1px 0; }

.table-card .gridjs-footer {
  padding: 8px 16px; }

.gridjs-tr-selected td {
  background-color: rgba(var(--vz-light-rgb), 1); }

.gridjs-tr-selected .gridjs-td .gridjs-checkbox[type=checkbox] {
  background-color: #F26430;
  border-color: #F26430;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___}); }

.gridjs-td .gridjs-checkbox {
  width: 1.1em;
  height: 1.1em;
  vertical-align: top;
  background-color: var(--vz-input-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid var(--vz-input-check-border);
  appearance: none;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact; }
  .gridjs-td .gridjs-checkbox[type="checkbox"] {
    border-radius: 0.25em; }

.gridjs-border-none td.gridjs-td, .gridjs-border-none th.gridjs-th {
  border-right-width: 0;
  border-left-width: 0; }

.gridjs-loading-bar {
  background-color: var(--vz-card-bg-custom); }

[data-layout-mode="dark"] button.gridjs-sort-neutral, [data-layout-mode="dark"] button.gridjs-sort-asc, [data-layout-mode="dark"] button.gridjs-sort-desc {
  filter: invert(1) grayscale(100%) brightness(200%); }

.listjs-pagination {
  margin-bottom: 0;
  justify-content: flex-end;
  gap: 8px; }
  .listjs-pagination li .page {
    display: block;
    padding: 0.375rem 0.75rem;
    color: var(--vz-link-color);
    background-color: var(--vz-card-bg-custom);
    border: 1px solid var(--vz-border-color);
    border-radius: 0.25rem; }
  .listjs-pagination li.active .page {
    color: #fff;
    background-color: #F26430;
    border-color: #F26430; }

.pagination-wrap {
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  align-items: center; }
  .pagination-wrap a {
    text-decoration: none;
    display: inline-block; }

.pagination-next,
.pagination-prev {
  color: #F26430;
  font-weight: 500;
  padding: 0.375rem 0.75rem;
  background-color: var(--vz-card-bg-custom);
  border: 1px solid var(--vz-border-color);
  border-radius: 0.25rem; }
  .pagination-next:hover,
  .pagination-prev:hover {
    color: #f8ac90; }
  .pagination-next.disabled,
  .pagination-prev.disabled {
    color: #878a99;
    cursor: default; }
    .pagination-next.disabled:hover,
    .pagination-prev.disabled:hover {
      color: #878a99; }

.apex-charts {
  min-height: 10px !important; }
  .apex-charts text {
    font-family: var(--vz-font-sans-serif) !important; }
  .apex-charts .apexcharts-canvas {
    margin: 0 auto; }

.apexcharts-tooltip-title,
.apexcharts-tooltip-text {
  font-family: var(--vz-font-sans-serif) !important; }

.apexcharts-tooltip {
  border: 1px solid var(--vz-border-color) !important;
  background-color: var(--vz-card-bg-custom) !important;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15) !important; }
  .apexcharts-tooltip * {
    font-family: var(--vz-font-sans-serif) !important;
    color: #878a99 !important; }
  .apexcharts-tooltip .apexcharts-tooltip-title {
    background-color: rgba(var(--vz-light-rgb), 0.75) !important;
    border-bottom: 1px solid var(--vz-border-color) !important; }

.apexcharts-tooltip.apexcharts-theme-dark * {
  color: #fff !important; }

.apexcharts-legend-series {
  font-weight: 500; }

.apexcharts-gridline {
  pointer-events: none;
  stroke: rgba(var(--vz-light-rgb), 0.75); }

.apexcharts-legend-text {
  color: #878a99 !important;
  font-family: var(--vz-font-sans-serif) !important;
  font-size: 13px !important; }

.apexcharts-pie-label {
  fill: #fff !important; }

.apexcharts-title-text, .apexcharts-subtitle-text {
  fill: #adb5bd; }

.apexcharts-yaxis text,
.apexcharts-xaxis text {
  font-family: var(--vz-font-sans-serif) !important;
  fill: #adb5bd; }

.apexcharts-yaxis-title {
  font-weight: 500; }

#dynamicloadedchart-wrap {
  margin: 0px auto;
  max-width: 800px;
  position: relative; }

.chart-box {
  padding-left: 0; }

#chart-year,
#chart-quarter {
  width: 96%;
  max-width: 48%;
  box-shadow: none;
  padding-left: 0;
  padding-top: 20px;
  background: var(--vz-card-bg-custom);
  border: 1px solid var(--vz-border-color); }

#chart-year {
  float: left;
  position: relative;
  transition: 1s ease transform;
  z-index: 3; }
  #chart-year.chart-quarter-activated {
    transform: translateX(0);
    transition: 1s ease transform; }

#chart-quarter {
  float: left;
  position: relative;
  z-index: -2;
  transition: 1s ease transform; }
  #chart-quarter.active {
    transition: 1.1s ease-in-out transform;
    transform: translateX(0);
    z-index: 1; }

@media screen and (min-width: 480px) {
  #chart-year {
    transform: translateX(50%); }
  #chart-quarter {
    transform: translateX(-50%); } }

.apexcharts-radar-series polygon, .apexcharts-radar-series line {
  stroke: var(--vz-border-color); }

.apexcharts-pie circle, .apexcharts-pie line {
  stroke: var(--vz-border-color); }

.apexcharts-pie text {
  fill: var(--vz-body-color); }

.apex-charts .apexcharts-xaxis line,
.apex-charts .apexcharts-yaxis line {
  stroke: var(--vz-border-color); }

.apex-charts .apexcharts-xaxis-tick {
  stroke: var(--vz-border-color); }

.apex-charts .apexcharts-pie-series path,
.apex-charts .apexcharts-bar-series path {
  stroke: var(--vz-card-bg-custom); }

.apex-charts .apexcharts-radialbar-track path {
  stroke: var(--vz-light); }

.apex-charts .apexcharts-marker {
  stroke: var(--vz-card-bg-custom); }

.apex-charts .apexcharts-boxPlot-series path {
  stroke: var(--vz-border-color); }

.apex-charts .apexcharts-treemap rect,
.apex-charts .apexcharts-heatmap-series rect {
  stroke: var(--vz-card-bg-custom); }

.chartjs-chart {
  max-height: 320px; }

.e-charts {
  height: 350px; }

.e-charts-height {
  height: 300px; }

.gmaps, .gmaps-panaroma {
  height: 300px;
  background: #f3f6f9;
  border-radius: 3px; }

.gmaps-overlay {
  display: block;
  text-align: center;
  color: #fff;
  font-size: 16px;
  line-height: 40px;
  background: #F26430;
  border-radius: 4px;
  padding: 10px 20px; }

.gmaps-overlay_arrow {
  left: 50%;
  margin-left: -16px;
  width: 0;
  height: 0;
  position: absolute; }
  .gmaps-overlay_arrow.above {
    bottom: -15px;
    border-left: 16px solid transparent;
    border-right: 16px solid transparent;
    border-top: 16px solid #F26430; }
  .gmaps-overlay_arrow.below {
    top: -15px;
    border-left: 16px solid transparent;
    border-right: 16px solid transparent;
    border-bottom: 16px solid #F26430; }

.autoComplete_wrapper {
  display: block; }
  .autoComplete_wrapper > input {
    display: block;
    width: 100%;
    height: auto;
    padding: 0.5rem 0.9rem;
    font-size: 0.8125rem;
    font-weight: 400;
    line-height: 1.5;
    color: var(--vz-body-color);
    background-color: var(--vz-input-bg);
    background-clip: padding-box;
    border: 1px solid var(--vz-input-border);
    border-radius: 0.25rem;
    background-image: none; }
    .autoComplete_wrapper > input::placeholder {
      padding: 0 !important;
      color: #878a99 !important;
      font-size: 0.8125rem !important; }
    .autoComplete_wrapper > input:focus {
      border: 1px solid var(--vz-input-focus-border);
      color: var(--vz-body-color); }
    .autoComplete_wrapper > input:hover {
      color: var(--vz-body-color); }
  .autoComplete_wrapper > ul {
    border-radius: 0.25rem;
    border-color: var(--vz-border-color);
    background-color: #fff;
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    padding: 0;
    overflow: auto;
    max-height: 160px;
    margin: 0;
    animation-name: DropDownSlide;
    animation-duration: .3s;
    animation-fill-mode: both; }
    .autoComplete_wrapper > ul > li {
      font-size: 0.8125rem;
      margin: 0;
      padding: 0.35rem 1.2rem;
      border-radius: 0;
      background-color: #fff;
      color: var(--vz-body-color); }
      .autoComplete_wrapper > ul > li mark, .autoComplete_wrapper > ul > li .mark {
        color: #f06548;
        font-weight: 600;
        padding: 1px; }
      .autoComplete_wrapper > ul > li[aria-selected=true], .autoComplete_wrapper > ul > li:hover {
        color: #1e2125;
        background-color: #f3f6f9; }
    .autoComplete_wrapper > ul .no_result {
      padding: 0.7rem 1.2rem;
      font-style: italic;
      font-weight: 500; }

.jvm-tooltip {
  border-radius: 3px;
  background-color: #F26430;
  font-family: var(--vz-font-sans-serif);
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  padding: 5px 9px; }

.jvm-container text {
  font-family: var(--vz-font-sans-serif);
  font-size: 0.8125rem;
  fill: var(--vz-gray-700); }

.jvm-zoom-btn {
  background-color: #F26430; }

.leaflet-map {
  height: 300px; }
  .leaflet-map.leaflet-container {
    z-index: 0;
    font-family: "Poppins", sans-serif; }

.fc td,
.fc th {
  border: 1px solid var(--vz-border-color); }

.fc .fc-toolbar h2, .fc .fc-toolbar .h2 {
  font-size: 16px;
  line-height: 30px;
  text-transform: uppercase; }

@media (max-width: 767.98px) {
  .fc .fc-toolbar .fc-left,
  .fc .fc-toolbar .fc-right,
  .fc .fc-toolbar .fc-center {
    float: none;
    display: block;
    text-align: center;
    clear: both;
    margin: 10px 0; }
  .fc .fc-toolbar > * > * {
    float: none; }
  .fc .fc-toolbar .fc-today-button {
    display: none; } }

.fc .fc-toolbar .btn {
  text-transform: capitalize; }

.fc .fc-col-header-cell {
  background-color: var(--vz-light); }

.fc .fc-col-header-cell-cushion {
  display: block;
  padding: 8px 4px; }

.fc .fc-daygrid-day-number {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  margin: 2px; }

.fc .fc-daygrid-day.fc-day-today {
  background-color: rgba(242, 100, 48, 0.1); }
  .fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-number {
    background-color: #F26430;
    color: #fff; }

.fc .fc-daygrid-day.fc-day-today {
  background-color: rgba(242, 100, 48, 0.1); }

.fc .fc-timegrid-col.fc-day-today {
  background-color: rgba(242, 100, 48, 0.1); }

.fc .fc-list-event:hover td {
  background: transparent; }

.fc .fc-list-event-title a {
  color: #fff !important; }

.fc .fc-col-header,
.fc .fc-daygrid-body,
.fc .fc-scrollgrid-sync-table {
  width: 100% !important; }

.fc .fc-scrollgrid-section > * {
  border-left: 1px solid var(--vz-border-color);
  border-top: 1px solid var(--vz-border-color); }

.fc .fc-scrollgrid-section-liquid > td {
  border-top: 0; }

.fc-theme-bootstrap a:not([href]) {
  color: var(--vz-body-color); }

.fc-event {
  color: #fff; }

.fc th.fc-widget-header {
  background: #e9ebec;
  line-height: 20px;
  padding: 10px 0;
  text-transform: uppercase;
  font-weight: 700; }

.fc-unthemed .fc-content,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-list-heading td,
.fc-unthemed .fc-list-view,
.fc-unthemed .fc-popover,
.fc-unthemed .fc-row,
.fc-unthemed tbody,
.fc-unthemed td,
.fc-unthemed th,
.fc-unthemed thead {
  border-color: #e9ebec; }

.fc-unthemed td.fc-today {
  background: #f6f8fa; }

.fc-button {
  background: var(--vz-card-bg-custom);
  border-color: var(--vz-border-color);
  color: #495057;
  text-transform: capitalize;
  box-shadow: none;
  padding: 6px 12px !important;
  height: auto !important; }

.fc-state-down,
.fc-state-active,
.fc-state-disabled {
  background-color: #F26430;
  color: #fff;
  text-shadow: none; }

.fc-event {
  border-radius: 2px;
  border: none;
  cursor: move;
  font-size: 0.8125rem;
  margin: 5px 7px;
  padding: 5px 5px;
  text-align: center; }

.fc-event,
.fc-event-dot {
  background-color: #F26430; }

.fc-daygrid-dot-event.fc-event-mirror,
.fc-daygrid-dot-event:hover {
  background-color: #F26430; }

.fc-event-title,
.fc-sticky {
  font-weight: 600 !important;
  text-overflow: ellipsis;
  white-space: nowrap; }

.fc-daygrid-event-dot {
  border-color: #fff !important;
  display: none; }

.fc-event-time {
  display: none; }

.fc-event .fc-content {
  color: #fff; }

#external-events .external-event {
  text-align: left;
  padding: 8px 16px;
  margin: 6px 0; }

.fc-day-grid-event.fc-h-event.fc-event.fc-start.fc-end.bg-dark .fc-content {
  color: #f3f6f9; }

.fc-prev-button,
.fc-next-button {
  position: relative;
  height: 37.5px;
  width: 37.5px; }
  .fc-prev-button::before,
  .fc-next-button::before {
    position: absolute;
    font-family: remixicon !important;
    font-size: 20px;
    top: 0;
    bottom: 0px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center; }

.fc-prev-button::before {
  content: "\\ea64"; }

.fc-next-button::before {
  content: "\\ea6e"; }

.fc-toolbar-chunk .btn-group {
  box-shadow: none; }
  .fc-toolbar-chunk .btn-group .btn {
    color: #208C3B;
    background-color: rgba(32, 140, 59, 0.15);
    border: none;
    box-shadow: none; }
    .fc-toolbar-chunk .btn-group .btn:hover, .fc-toolbar-chunk .btn-group .btn.active {
      color: #fff;
      background-color: #208C3B; }

.fc-toolbar-chunk .fc-today-button {
  background-color: #208C3B !important;
  border: #208C3B; }

@media (max-width: 575.98px) {
  .fc-toolbar {
    flex-direction: column;
    gap: 16px; } }

#upcoming-event-list .card:last-child {
  margin-bottom: 6px !important; }

#event-modal .event-details {
  display: none; }

#event-modal .view-event .event-form {
  display: none; }

#event-modal .view-event #event-category-tag {
  display: none; }

#event-modal .view-event .event-details {
  display: block; }

.fc-daygrid-event-harness .fc-daygrid-event {
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px); }

.fc-timegrid-event-harness .fc-timegrid-event {
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px); }

.fc-timegrid-slots table tr {
  border-color: var(--vz-border-color) !important; }

.fc-list-table {
  border-color: var(--vz-border-color); }

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-primary .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-primary .fc-event-main {
  color: #F26430 !important; }

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-primary .fc-event-title {
  color: #F26430 !important; }

.fc-list-table .fc-list-event.bg-soft-primary {
  color: #F26430 !important; }
  .fc-list-table .fc-list-event.bg-soft-primary .fc-list-event-title > a {
    color: #F26430 !important; }
  .fc-list-table .fc-list-event.bg-soft-primary .fc-list-event-dot {
    border-color: #F26430; }

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-secondary .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-secondary .fc-event-main {
  color: #208C3B !important; }

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-secondary .fc-event-title {
  color: #208C3B !important; }

.fc-list-table .fc-list-event.bg-soft-secondary {
  color: #208C3B !important; }
  .fc-list-table .fc-list-event.bg-soft-secondary .fc-list-event-title > a {
    color: #208C3B !important; }
  .fc-list-table .fc-list-event.bg-soft-secondary .fc-list-event-dot {
    border-color: #208C3B; }

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-success .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-success .fc-event-main {
  color: #0ab39c !important; }

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-success .fc-event-title {
  color: #0ab39c !important; }

.fc-list-table .fc-list-event.bg-soft-success {
  color: #0ab39c !important; }
  .fc-list-table .fc-list-event.bg-soft-success .fc-list-event-title > a {
    color: #0ab39c !important; }
  .fc-list-table .fc-list-event.bg-soft-success .fc-list-event-dot {
    border-color: #0ab39c; }

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-info .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-info .fc-event-main {
  color: #299cdb !important; }

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-info .fc-event-title {
  color: #299cdb !important; }

.fc-list-table .fc-list-event.bg-soft-info {
  color: #299cdb !important; }
  .fc-list-table .fc-list-event.bg-soft-info .fc-list-event-title > a {
    color: #299cdb !important; }
  .fc-list-table .fc-list-event.bg-soft-info .fc-list-event-dot {
    border-color: #299cdb; }

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-warning .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-warning .fc-event-main {
  color: #3FBF48 !important; }

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-warning .fc-event-title {
  color: #3FBF48 !important; }

.fc-list-table .fc-list-event.bg-soft-warning {
  color: #3FBF48 !important; }
  .fc-list-table .fc-list-event.bg-soft-warning .fc-list-event-title > a {
    color: #3FBF48 !important; }
  .fc-list-table .fc-list-event.bg-soft-warning .fc-list-event-dot {
    border-color: #3FBF48; }

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-danger .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-danger .fc-event-main {
  color: #f06548 !important; }

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-danger .fc-event-title {
  color: #f06548 !important; }

.fc-list-table .fc-list-event.bg-soft-danger {
  color: #f06548 !important; }
  .fc-list-table .fc-list-event.bg-soft-danger .fc-list-event-title > a {
    color: #f06548 !important; }
  .fc-list-table .fc-list-event.bg-soft-danger .fc-list-event-dot {
    border-color: #f06548; }

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-light .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-light .fc-event-main {
  color: #f3f6f9 !important; }

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-light .fc-event-title {
  color: #f3f6f9 !important; }

.fc-list-table .fc-list-event.bg-soft-light {
  color: #f3f6f9 !important; }
  .fc-list-table .fc-list-event.bg-soft-light .fc-list-event-title > a {
    color: #f3f6f9 !important; }
  .fc-list-table .fc-list-event.bg-soft-light .fc-list-event-dot {
    border-color: #f3f6f9; }

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-main {
  color: #212529 !important; }

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-dark .fc-event-title {
  color: #212529 !important; }

.fc-list-table .fc-list-event.bg-soft-dark {
  color: #212529 !important; }
  .fc-list-table .fc-list-event.bg-soft-dark .fc-list-event-title > a {
    color: #212529 !important; }
  .fc-list-table .fc-list-event.bg-soft-dark .fc-list-event-dot {
    border-color: #212529; }

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-main, .fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-title {
  color: var(--vz-dark) !important; }

.fc-direction-ltr {
  direction: ltr; }
  .fc-direction-ltr .fc-toolbar > * > :not(:first-child) {
    margin-left: 0.75em; }

.fg-emoji-picker {
  width: 250px !important;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15) !important;
  top: auto !important;
  bottom: 130px; }
  .fg-emoji-picker * {
    font-family: var(--vz-font-sans-serif) !important;
    color: var(--vz-body-color) !important; }
  @media (max-width: 991.98px) {
    .fg-emoji-picker {
      left: 14px !important;
      top: auto !important;
      bottom: 118px; } }
  .fg-emoji-picker .fg-emoji-picker-container-title {
    color: #212529 !important; }
  .fg-emoji-picker .fg-emoji-picker-search {
    height: 40px !important; }
    .fg-emoji-picker .fg-emoji-picker-search input {
      background-color: var(--vz-input-bg) !important;
      color: var(--vz-body-color) !important;
      padding: 0.5rem 0.9rem !important;
      font-size: 0.8125rem !important; }
      .fg-emoji-picker .fg-emoji-picker-search input::placeholder {
        color: #878a99 !important; }
    .fg-emoji-picker .fg-emoji-picker-search svg {
      fill: var(--vz-body-color) !important;
      right: 11px;
      top: 12px; }
  .fg-emoji-picker .fg-emoji-picker-categories {
    background-color: #f3f6f9 !important; }
    .fg-emoji-picker .fg-emoji-picker-categories li.active {
      background-color: rgba(var(--bs-primary-rgb), 0.2); }
    .fg-emoji-picker .fg-emoji-picker-categories a:hover {
      background-color: rgba(var(--bs-primary-rgb), 0.2); }

.fg-emoji-picker-grid > li:hover {
  background-color: rgba(var(--bs-primary-rgb), 0.2) !important; }

a.fg-emoji-picker-close-button {
  background-color: #e5ecf2 !important; }

table.dataTable td.dataTables_empty,
table.dataTable th.dataTables_empty {
  text-align: center;
  padding: 50px;
  font-weight: 600;
  --vz-table-accent-bg: var(--vz-card-bg-custom); }

table.dataTable > thead .sorting:before,
table.dataTable > thead .sorting_asc:before,
table.dataTable > thead .sorting_desc:before,
table.dataTable > thead .sorting_asc_disabled:before,
table.dataTable > thead .sorting_desc_disabled:before {
  content: "\\f0360";
  position: absolute;
  right: 0.5rem;
  top: 12px;
  font-size: .8rem;
  font-family: "Material Design Icons"; }

table.dataTable > thead .sorting:after,
table.dataTable > thead .sorting_asc:after,
table.dataTable > thead .sorting_desc:after,
table.dataTable > thead .sorting_asc_disabled:after,
table.dataTable > thead .sorting_desc_disabled:after {
  content: "\\f035d";
  position: absolute;
  right: 0.5rem;
  top: 18px;
  font-size: .8rem;
  font-family: "Material Design Icons"; }

table.dataTable > tbody > tr.child span.dtr-title {
  font-weight: 600;
  min-width: 150px; }

table.dataTable.dtr-inline.collapsed > tbody > tr > th.dtr-control::before,
table.dataTable.dtr-inline.collapsed > tbody > tr > td.dtr-control::before {
  background-color: #F26430;
  border-color: var(--vz-card-bg-custom); }

table.dataTable.dtr-inline.collapsed > tbody > tr.parent.parent > th.dtr-control::before {
  background-color: #f06548; }

table.dataTable.dtr-inline.collapsed > tbody > tr.parent > td.dtr-control::before {
  background-color: #f06548; }

table.dataTable > tbody > tr.child span.dtr-title {
  min-width: 135px; }

.table-card .dataTables_length,
.table-card .dataTables_filter {
  padding: 1rem 1rem;
  padding-bottom: 0px; }

.table-card .dataTables_info,
.table-card .dataTables_paginate {
  padding: 1rem 1rem; }

.table-card div.dataTables_wrapper .col-md-6 {
  width: 100%; }

.table-card div.dataTables_wrapper div.dataTables_filter input {
  width: calc(100% - 52px); }

.table-card div.dataTables_wrapper div.dataTables_filter label {
  display: block; }

div.dtr-modal div.dtr-modal-display {
  background-color: #fff;
  border-color: var(--vz-border-color);
  box-shadow: none;
  height: 70%; }

div.dtr-modal div.dtr-modal-content {
  padding: 1.25rem; }
  div.dtr-modal div.dtr-modal-content h2, div.dtr-modal div.dtr-modal-content .h2 {
    font-size: 1.01562rem;
    font-weight: 600;
    margin-bottom: 15px; }
  div.dtr-modal div.dtr-modal-content .dtr-details tr td {
    padding: 0.75rem 0.6rem; }

div.dtr-modal div.dtr-modal-close {
  font-size: 24px;
  top: 9px;
  right: 11px;
  width: 30px;
  height: 30px;
  line-height: 30px;
  background-color: var(--vz-card-bg-custom);
  border-color: var(--vz-border-color); }
  div.dtr-modal div.dtr-modal-close:hover {
    background-color: var(--vz-light); }

.dt-buttons button.dt-button,
.dt-buttons div.dt-button,
.dt-buttons a.dt-button,
.dt-buttons input.dt-button {
  border-color: var(--vz-border-color);
  background: var(--vz-light);
  color: var(--vz-gray-800); }

.rdt_Table .rdt_TableBody .rdt_TableRow {
  background-color: transparent;
  color: var(--vz-body-color);
  border-bottom-color: var(--vz-border-color);
  outline-color: var(--vz-border-color); }

.select2.select2-container {
  width: 100% !important; }

.select2-container .select2-selection--single {
  border: 1px solid var(--vz-input-border);
  height: calc(1.5em + 1rem + 2px);
  background-color: var(--vz-input-bg);
  outline: none; }
  .select2-container .select2-selection--single .select2-selection__rendered {
    line-height: 36px;
    padding-left: 12px;
    color: var(--vz-body-color); }
  .select2-container .select2-selection--single .select2-selection__arrow {
    height: 34px;
    width: 34px;
    /*rtl:ignore*/
    right: 3px; }
    .select2-container .select2-selection--single .select2-selection__arrow b {
      border-color: var(--vz-input-border) transparent transparent transparent;
      border-width: 6px 6px 0 6px; }

.select2-container--open .select2-selection--single .select2-selection__arrow b {
  border-color: transparent transparent var(--vz-input-border) transparent !important;
  border-width: 0 6px 6px 6px !important; }

.select2-results__option {
  padding: 6px 12px; }

.select2-dropdown {
  border: 0 solid var(--vz-border-color);
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  background-color: var(--vz-choices-bg);
  z-index: 1056; }

.select2-container--default .select2-results__option--selected {
  background-color: var(--vz-input-disabled-bg); }

.select2-container--default .select2-search--dropdown {
  padding: 10px;
  background-color: var(--vz-choices-bg); }
  .select2-container--default .select2-search--dropdown .select2-search__field {
    outline: none;
    border: 1px solid var(--vz-input-border);
    background-color: var(--vz-input-bg);
    color: var(--vz-body-color);
    border-radius: 0.25rem; }

.select2-container--default .select2-results__option--highlighted[aria-selected] {
  background-color: #F26430; }

.select2-container--default .select2-results__option[aria-selected=true] {
  background-color: var(--vz-choices-bg);
  color: var(--vz-choices-link-active-color); }
  .select2-container--default .select2-results__option[aria-selected=true]:hover {
    background-color: #F26430;
    color: #fff; }

.select2-container--default .select2-selection--multiple .select2-selection__choice__display {
  padding-left: 36px;
  padding-right: 5px; }

.select2-container--default .select2-selection--single .select2-selection__arrow {
  /*rtl:ignore*/
  right: 1px;
  /*rtl:ignore*/
  left: auto; }

.select2-container .select2-selection--multiple {
  min-height: calc(1.5em + 1rem + 2px);
  border: 1px solid var(--vz-input-border) !important;
  background-color: var(--vz-input-bg); }
  .select2-container .select2-selection--multiple .select2-selection__rendered {
    padding: 1px 4px; }
  .select2-container .select2-selection--multiple .select2-search__field {
    border: 0;
    color: var(--vz-body-color); }
  .select2-container .select2-selection--multiple .select2-selection__choice {
    background-color: #F26430;
    border: none;
    color: #fff;
    border-radius: 3px;
    padding: 3px;
    margin-top: 6px; }
  .select2-container .select2-selection--multiple .select2-selection__choice__remove {
    color: #fff;
    margin-right: 7px;
    border-color: #f37445;
    padding: 0 8px;
    top: 3px; }
    .select2-container .select2-selection--multiple .select2-selection__choice__remove:hover {
      color: #fff;
      background-color: #F26430; }

.select2-container .select2-search--inline .select2-search__field {
  margin-top: 7px;
  font-family: var(--vz-font-sans-serif); }

.select2-container .select2-search textarea::placeholder {
  color: #878a99; }

.select2-container--default.select2-container--disabled .select2-selection--single, .select2-container--default.select2-container--disabled .select2-selection--multiple {
  background-color: var(--vz-input-disabled-bg);
  cursor: default; }

.toastify {
  padding: 12px 16px;
  color: #fff;
  display: inline-block;
  box-shadow: 0 3px 6px -1px rgba(0, 0, 0, 0.12), 0 10px 36px -4px rgba(77, 96, 232, 0.3);
  background: #0ab39c;
  position: fixed;
  opacity: 0;
  transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
  border-radius: 2px;
  cursor: pointer;
  text-decoration: none;
  max-width: calc(50% - 20px);
  z-index: 2147483647; }
  .toastify.on {
    opacity: 1; }

.toast-close {
  opacity: 0.4;
  padding: 0 5px;
  position: relative;
  left: 4px;
  margin-left: 4px;
  border: none;
  background: none; }

.toastify-right {
  right: 15px; }

.toastify-left {
  left: 15px; }
  .toastify-left .toast-close {
    left: -4px;
    margin-left: 0;
    margin-right: 4px; }

.toastify-top {
  top: -150px; }

.toastify-bottom {
  bottom: -150px; }

.toastify-rounded {
  border-radius: 25px; }

.toastify-avatar {
  width: 1.5em;
  height: 1.5em;
  margin: -7px 5px;
  border-radius: 2px; }

.toastify-center {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  max-width: fit-content;
  max-width: -moz-fit-content; }

@media only screen and (max-width: 360px) {
  .toastify-right, .toastify-left {
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    max-width: -moz-fit-content;
    max-width: fit-content; } }

.choices {
  position: relative;
  margin-bottom: 24px;
  font-size: 16px; }
  .choices:focus {
    outline: none; }
  .choices:last-child {
    margin-bottom: 0; }
  .choices.is-disabled .choices__inner,
  .choices.is-disabled .choices__input {
    background-color: rgba(var(--vz-light-rgb), 0.75);
    cursor: not-allowed;
    -webkit-user-select: none;
            user-select: none; }
  .choices.is-disabled .choices__item {
    cursor: not-allowed; }
  .choices [hidden] {
    display: none !important; }
  .choices[data-type*='select-one'] {
    cursor: pointer; }
    .choices[data-type*='select-one'] .choices__inner {
      padding-bottom: 0.25rem; }
    .choices[data-type*='select-one'] .choices__input {
      display: block;
      width: 100%;
      padding: 0.5rem 0.9rem;
      background-color: var(--vz-input-bg);
      border: 1px solid var(--vz-input-border);
      font-size: 0.8125rem;
      border-radius: 0.25rem;
      color: var(--vz-body-color);
      margin-bottom: 10px; }
    .choices[data-type*='select-one'] .choices__button {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_69___});
      padding: 0;
      background-size: 8px;
      position: absolute;
      top: 50%;
      right: 0;
      left: auto;
      margin-top: -10px;
      margin-right: 25px;
      margin-left: 0;
      height: 20px;
      width: 20px;
      border-radius: 10em;
      opacity: 0.5; }
      .choices[data-type*='select-one'] .choices__button:hover, .choices[data-type*='select-one'] .choices__button:focus {
        opacity: 1; }
      .choices[data-type*='select-one'] .choices__button:focus {
        box-shadow: 0px 0px 0px 2px #00bcd4; }
    .choices[data-type*='select-one'] .choices__item[data-value=''] .choices__button {
      display: none; }
    .choices[data-type*='select-one']:after {
      content: "\\F0140";
      position: absolute;
      border: 0;
      border-color: #212529 transparent transparent;
      right: 11.5px;
      left: auto;
      font-family: 'Material Design Icons';
      width: auto;
      height: auto;
      margin-top: 0;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none; }
    .choices[data-type*='select-one'].is-open:after {
      margin-top: 0;
      transform: translateY(-50%) rotate(-180deg); }
  .choices[data-type*='select-multiple'] .choices__inner, .choices[data-type*='text'] .choices__inner {
    cursor: text;
    padding-right: 0.9rem; }
  .choices[data-type*='select-multiple'] .choices__button, .choices[data-type*='text'] .choices__button {
    position: relative;
    display: inline-block;
    margin-top: 0;
    margin-right: -4px;
    margin-bottom: 0;
    margin-left: 8px;
    padding-left: 16px;
    border-left: 1px solid rgba(255, 255, 255, 0.5);
    border-right: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_70___});
    background-size: 8px;
    width: 8px;
    line-height: 1;
    opacity: 0.75;
    border-radius: 0; }
    .choices[data-type*='select-multiple'] .choices__button:hover, .choices[data-type*='select-multiple'] .choices__button:focus, .choices[data-type*='text'] .choices__button:hover, .choices[data-type*='text'] .choices__button:focus {
      opacity: 1; }
  .choices[data-type*='select-multiple'] .choices__list--dropdown, .choices[data-type*='text'] .choices__list--dropdown {
    padding-bottom: 10px; }
    .choices[data-type*='select-multiple'] .choices__list--dropdown .choices__list, .choices[data-type*='text'] .choices__list--dropdown .choices__list {
      margin-bottom: 0; }
  .choices[data-type*=select-multiple] .choices__input {
    padding-top: 3px; }

.input-light .choices__inner {
  background-color: var(--vz-light);
  border: none; }

.choices__inner {
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  background-color: var(--vz-input-bg);
  padding: 0.25rem 3.6rem 0.1rem 0.5rem;
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem !important;
  font-size: 0.8125rem;
  min-height: 37.5px;
  overflow: hidden; }

.is-focused .choices__inner,
.is-open .choices__inner {
  border-color: var(--vz-input-focus-border); }

.choices__list {
  margin: 0;
  padding-left: 0;
  list-style: none; }

.choices__list--single {
  display: inline-block;
  padding: 4px 16px 4px 4px;
  width: 100%; }
  .choices__list--single .choices__item {
    width: 100%; }

.choices__list--multiple {
  display: inline; }
  .choices__list--multiple .choices__item {
    display: inline-block;
    vertical-align: initial;
    border-radius: 7px;
    padding: 2px 7px;
    font-size: 11px;
    font-weight: 400;
    margin-right: 3.75px;
    margin-bottom: 3.75px;
    margin-top: 2px;
    background-color: #F26430;
    border: 1px solid #F26430;
    word-break: break-all;
    box-sizing: border-box;
    color: #fff;
    box-shadow: none; }
    .choices__list--multiple .choices__item[data-deletable] {
      padding-right: 5px; }
    .choices__list--multiple .choices__item.is-highlighted {
      background-color: #F26430;
      border: 1px solid #F26430; }

.is-disabled .choices__list--multiple .choices__item {
  background-color: #208C3B;
  border: 1px solid #208C3B; }

.choices__list--dropdown {
  visibility: hidden;
  z-index: 1;
  position: absolute;
  width: 100%;
  background-color: var(--vz-choices-bg);
  border: 1px solid var(--vz-border-color);
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  top: 100%;
  margin-top: 0;
  padding: 10px 10px 20px 10px;
  border-bottom-left-radius: 2.5px;
  border-bottom-right-radius: 2.5px;
  overflow: hidden;
  word-break: break-all;
  will-change: visibility;
  animation-duration: .3s;
  animation-fill-mode: both;
  transform: translateY(1px); }
  .choices__list--dropdown.is-active {
    visibility: visible;
    animation-name: DropDownSlide; }
  .choices__list--dropdown .choices__item--selectable.is-highlighted {
    background-color: var(--vz-choices-link-hover-bg); }
  .choices__list--dropdown .choices__list {
    margin: 0 -16px -16px; }
  .choices__list--dropdown .has-no-results {
    font-style: italic;
    font-weight: 500; }
  .choices__list--dropdown .choices__item--selectable:after {
    display: none; }

.is-open .choices__list--dropdown {
  border-color: var(--vz-border-color); }

.is-flipped .choices__list--dropdown {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: -1px;
  border-radius: 0.25rem 0.25rem 0 0; }
  .is-flipped .choices__list--dropdown.is-active {
    animation-name: DropDownSlideDown;
    transform: translateY(-1px); }

.choices__list--dropdown .choices__list {
  position: relative;
  max-height: 300px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  will-change: scroll-position; }

.choices__list--dropdown .choices__item {
  position: relative;
  font-size: 0.8125rem;
  padding: 0.35rem 1.2rem 0.35rem 16px; }

@media (min-width: 640px) {
  .choices__list--dropdown .choices__item--selectable:after {
    content: attr(data-select-text);
    font-size: 12px;
    opacity: 0;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%); }
  .choices__list--dropdown .choices__item--selectable.is-highlighted:after {
    opacity: 0.5; } }

.choices__item {
  cursor: default; }

.choices__item--selectable {
  cursor: pointer; }

.choices__item--disabled {
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
  opacity: 0.5; }

.choices__heading {
  font-weight: 600;
  font-size: 12px;
  padding: 10px 16px;
  border-bottom: 1px solid var(--vz-border-color);
  color: #878a99; }

.choices__button {
  text-indent: -9999px;
  appearance: none;
  border: 0;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer; }
  .choices__button:focus {
    outline: none; }

.choices__input {
  display: inline-block;
  vertical-align: baseline;
  background-color: var(--vz-input-bg);
  color: var(--vz-body-color);
  font-size: 0.8125rem;
  margin-bottom: 0;
  border: 0;
  border-radius: 0;
  max-width: 100%;
  padding: 2px 0 2px 2px; }
  .choices__input:focus {
    outline: 0; }
  .choices__input::placeholder {
    color: #878a99; }

.choices__placeholder {
  color: #878a99;
  opacity: 1; }

[data-layout-mode="dark"] .choices[data-type*=select-one] .choices__button {
  filter: invert(1) grayscale(100%) brightness(200%); }

.flatpickr-calendar {
  background: transparent;
  opacity: 0;
  display: none;
  text-align: center;
  visibility: hidden;
  padding: 0;
  animation: none;
  direction: ltr;
  border: 0;
  font-size: 14px;
  line-height: 24px;
  border-radius: 5px;
  position: absolute;
  width: 307.875px;
  box-sizing: border-box;
  touch-action: manipulation;
  background: var(--vz-choices-bg);
  box-shadow: 1px 0 0 var(--vz-border-color), -1px 0 0 var(--vz-border-color), 0 1px 0 var(--vz-border-color), 0 -1px 0 var(--vz-border-color), 0 3px 13px rgba(0, 0, 0, 0.08); }
  .flatpickr-calendar.open, .flatpickr-calendar.inline {
    opacity: 1;
    max-height: 640px;
    visibility: visible; }
  .flatpickr-calendar.open {
    display: inline-block;
    z-index: 1056; }
  .flatpickr-calendar.animate.open {
    animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1); }
  .flatpickr-calendar.inline {
    display: block;
    position: relative;
    top: 2px;
    width: 100%;
    box-shadow: none; }
    .flatpickr-calendar.inline .flatpickr-rContainer {
      display: block;
      width: 100%; }
      .flatpickr-calendar.inline .flatpickr-rContainer .flatpickr-days {
        width: 100%;
        border: 1px solid var(--vz-input-border);
        border-top: none;
        border-radius: 0 0 5px 5px; }
        .flatpickr-calendar.inline .flatpickr-rContainer .flatpickr-days .dayContainer {
          width: 100%;
          min-width: 100%;
          max-width: 100%; }
          .flatpickr-calendar.inline .flatpickr-rContainer .flatpickr-days .dayContainer .flatpickr-day {
            max-width: 100%;
            border-radius: 4px; }
    .flatpickr-calendar.inline .flatpickr-time {
      border: 1px solid var(--vz-input-border) !important;
      border-radius: 0.25rem; }
  .flatpickr-calendar.static {
    position: absolute;
    top: calc(100% + 2px); }
    .flatpickr-calendar.static.open {
      z-index: 999;
      display: block; }
  .flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7) {
    box-shadow: none !important; }
  .flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1) {
    box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6; }
  .flatpickr-calendar .hasWeeks .dayContainer,
  .flatpickr-calendar .hasTime .dayContainer {
    border-bottom: 0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0; }
  .flatpickr-calendar .hasWeeks .dayContainer {
    border-left: 0; }
  .flatpickr-calendar.hasTime .flatpickr-time {
    height: 40px;
    border-top: 1px solid var(--vz-border-color); }
  .flatpickr-calendar.noCalendar.hasTime .flatpickr-time {
    height: auto; }
  .flatpickr-calendar::before, .flatpickr-calendar::after {
    position: absolute;
    display: block;
    pointer-events: none;
    border: solid transparent;
    content: '';
    height: 0;
    width: 0;
    left: 22px; }
  .flatpickr-calendar.rightMost::before, .flatpickr-calendar.arrowRight::before, .flatpickr-calendar.rightMost::after, .flatpickr-calendar.arrowRight::after {
    left: auto;
    right: 22px; }
  .flatpickr-calendar.arrowCenter::before, .flatpickr-calendar.arrowCenter::after {
    left: 50%;
    right: 50%; }
  .flatpickr-calendar::before {
    border-width: 5px;
    margin: 0 -5px; }
  .flatpickr-calendar::after {
    border-width: 4px;
    margin: 0 -4px; }
  .flatpickr-calendar.arrowTop::before, .flatpickr-calendar.arrowTop::after {
    bottom: 100%; }
  .flatpickr-calendar.arrowTop::before {
    border-bottom-color: #F26430; }
  .flatpickr-calendar.arrowTop::after {
    border-bottom-color: #F26430; }
  .flatpickr-calendar.arrowBottom::before, .flatpickr-calendar.arrowBottom::after {
    top: 100%; }
  .flatpickr-calendar.arrowBottom::before {
    border-top-color: #F26430; }
  .flatpickr-calendar.arrowBottom::after {
    border-top-color: #F26430; }
  .flatpickr-calendar:focus {
    outline: 0; }

.flatpickr-wrapper {
  position: relative;
  display: inline-block; }

.flatpickr-months {
  display: flex;
  background-color: #F26430;
  border-radius: 5px 5px 0px 0px; }
  .flatpickr-months .flatpickr-month {
    background: transparent;
    color: rgba(255, 255, 255, 0.9);
    fill: rgba(255, 255, 255, 0.9);
    height: 34px;
    line-height: 1;
    text-align: center;
    position: relative;
    -webkit-user-select: none;
            user-select: none;
    overflow: hidden;
    flex: 1 1; }
  .flatpickr-months .flatpickr-prev-month,
  .flatpickr-months .flatpickr-next-month {
    text-decoration: none;
    cursor: pointer;
    position: absolute;
    top: 0;
    height: 34px;
    padding: 10px;
    z-index: 3;
    color: rgba(255, 255, 255, 0.9);
    fill: rgba(255, 255, 255, 0.9);
    /*
        /*rtl:begin:ignore*/
    /*
        /*rtl:end:ignore*/
    /*
        /*rtl:begin:ignore*/
    /*
        /*rtl:end:ignore*/ }
    .flatpickr-months .flatpickr-prev-month.flatpickr-disabled,
    .flatpickr-months .flatpickr-next-month.flatpickr-disabled {
      display: none; }
    .flatpickr-months .flatpickr-prev-month i,
    .flatpickr-months .flatpickr-next-month i {
      position: relative; }
    .flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,
    .flatpickr-months .flatpickr-next-month.flatpickr-prev-month {
      /*
                  /*rtl:begin:ignore*/
      /*
                  */
      left: 0;
      /*
                  /*rtl:end:ignore*/
      /*
                  */ }
    .flatpickr-months .flatpickr-prev-month.flatpickr-next-month,
    .flatpickr-months .flatpickr-next-month.flatpickr-next-month {
      /*
                  /*rtl:begin:ignore*/
      /*
                  */
      right: 0;
      /*
                  /*rtl:end:ignore*/
      /*
                  */ }
    .flatpickr-months .flatpickr-prev-month:hover,
    .flatpickr-months .flatpickr-next-month:hover {
      color: #959ea9; }
      .flatpickr-months .flatpickr-prev-month:hover svg,
      .flatpickr-months .flatpickr-next-month:hover svg {
        fill: rgba(255, 255, 255, 0.9); }
    .flatpickr-months .flatpickr-prev-month svg,
    .flatpickr-months .flatpickr-next-month svg {
      width: 14px;
      height: 14px; }
      .flatpickr-months .flatpickr-prev-month svg path,
      .flatpickr-months .flatpickr-next-month svg path {
        transition: fill 0.1s;
        fill: inherit; }

.numInputWrapper {
  position: relative;
  height: auto; }
  .numInputWrapper input,
  .numInputWrapper span {
    display: inline-block; }
  .numInputWrapper input {
    width: 100%; }
    .numInputWrapper input::-ms-clear {
      display: none; }
    .numInputWrapper input::-webkit-outer-spin-button, .numInputWrapper input::-webkit-inner-spin-button {
      margin: 0;
      -webkit-appearance: none; }
  .numInputWrapper span {
    position: absolute;
    right: 0;
    width: 14px;
    padding: 0 4px 0 2px;
    height: 50%;
    line-height: 50%;
    opacity: 0;
    cursor: pointer;
    border: 1px solid rgba(var(--vz-dark-rgb), 0.15);
    box-sizing: border-box; }
    .numInputWrapper span:hover {
      background: rgba(0, 0, 0, 0.1); }
    .numInputWrapper span:active {
      background: rgba(0, 0, 0, 0.2); }
    .numInputWrapper span:after {
      display: block;
      content: "";
      position: absolute; }
    .numInputWrapper span.arrowUp {
      top: 0;
      border-bottom: 0; }
      .numInputWrapper span.arrowUp:after {
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-bottom: 4px solid rgba(57, 57, 57, 0.6);
        top: 26%; }
    .numInputWrapper span.arrowDown {
      top: 50%; }
      .numInputWrapper span.arrowDown:after {
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 4px solid rgba(57, 57, 57, 0.6);
        top: 40%; }
    .numInputWrapper span svg {
      width: inherit;
      height: auto; }
      .numInputWrapper span svg path {
        fill: rgba(0, 0, 0, 0.5); }
  .numInputWrapper:hover {
    background: rgba(0, 0, 0, 0.05); }
    .numInputWrapper:hover span {
      opacity: 1; }

.flatpickr-current-month {
  font-size: 100%;
  line-height: inherit;
  font-weight: 300;
  color: inherit;
  position: absolute;
  width: 75%;
  left: 12.5%;
  padding: 7.48px 0 0 0;
  line-height: 1;
  height: 34px;
  display: inline-block;
  text-align: center;
  transform: translate3d(0px, 0px, 0px); }
  .flatpickr-current-month span.cur-month {
    font-family: inherit;
    font-weight: 700;
    color: inherit;
    display: inline-block;
    margin-left: 0.5ch;
    padding: 0; }
    .flatpickr-current-month span.cur-month:hover {
      background: rgba(0, 0, 0, 0.05); }
  .flatpickr-current-month .numInputWrapper {
    width: 6ch;
    width: 7ch\\0;
    display: inline-block; }
  .flatpickr-current-month span.arrowUp::after {
    border-bottom-color: rgba(0, 0, 0, 0.9); }
  .flatpickr-current-month span.arrowDown:after {
    border-top-color: rgba(0, 0, 0, 0.9); }
  .flatpickr-current-month input.cur-year {
    background: transparent;
    box-sizing: border-box;
    color: inherit;
    cursor: text;
    padding: 0 0 0 0.5ch;
    margin: 0;
    display: inline-block;
    font-size: inherit;
    font-family: inherit;
    font-weight: 600;
    line-height: inherit;
    height: auto;
    border: 0;
    border-radius: 0;
    vertical-align: initial;
    appearance: textfield; }
    .flatpickr-current-month input.cur-year:focus {
      outline: 0; }
    .flatpickr-current-month input.cur-year[disabled], .flatpickr-current-month input.cur-year[disabled]:hover {
      font-size: 100%;
      color: rgba(255, 255, 255, 0.9);
      background: transparent;
      pointer-events: none; }
  .flatpickr-current-month .flatpickr-monthDropdown-months {
    appearance: menulist;
    background: transparent;
    border: none;
    border-radius: 0;
    box-sizing: border-box;
    color: inherit;
    cursor: pointer;
    font-size: inherit;
    font-family: inherit;
    font-weight: 600;
    height: auto;
    line-height: inherit;
    margin: -1px 0 0 0;
    outline: none;
    padding: 0 0 0 0.5ch;
    position: relative;
    vertical-align: initial;
    width: auto; }
    .flatpickr-current-month .flatpickr-monthDropdown-months:focus, .flatpickr-current-month .flatpickr-monthDropdown-months:active {
      outline: none; }
    .flatpickr-current-month .flatpickr-monthDropdown-months:hover {
      background-color: transparent; }
    .flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {
      background-color: transparent;
      outline: none;
      padding: 0;
      color: rgba(0, 0, 0, 0.8); }

.flatpickr-weekdays {
  background-color: #F26430;
  text-align: center;
  overflow: hidden;
  width: 100%;
  display: flex;
  align-items: center;
  height: 36px;
  border-bottom: 1px solid var(--vz-border-color); }
  .flatpickr-weekdays .flatpickr-weekdaycontainer {
    display: flex;
    flex: 1 1; }

span.flatpickr-weekday {
  cursor: default;
  font-size: 90%;
  background: #F26430;
  color: #fff;
  line-height: 1;
  margin: 0;
  text-align: center;
  display: block;
  flex: 1 1;
  font-weight: 500; }

.dayContainer,
.flatpickr-weeks {
  padding: 1px 0 0 0; }

.flatpickr-days {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  width: 307.875px; }
  .flatpickr-days:focus {
    outline: 0; }

.dayContainer {
  padding: 0;
  outline: 0;
  text-align: left;
  width: 307.875px;
  min-width: 307.875px;
  max-width: 307.875px;
  box-sizing: border-box;
  display: inline-block;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  transform: translate3d(0px, 0px, 0px);
  opacity: 1; }
  .dayContainer + .dayContainer {
    box-shadow: -1px 0 0 #e6e6e6; }

.flatpickr-day {
  background: none;
  border: 1px solid transparent;
  border-radius: 150px;
  box-sizing: border-box;
  color: var(--vz-body-color);
  cursor: pointer;
  font-weight: 400;
  width: 14.2857143%;
  flex-basis: 14.2857143%;
  max-width: 39px;
  height: 39px;
  line-height: 39px;
  margin: 0;
  display: inline-block;
  position: relative;
  justify-content: center;
  text-align: center; }
  .flatpickr-day:hover, .flatpickr-day:focus {
    background-color: rgba(var(--vz-light-rgb), 0.7); }
  .flatpickr-day.inRange, .flatpickr-day.prevMonthDay.inRange, .flatpickr-day.nextMonthDay.inRange, .flatpickr-day.today.inRange, .flatpickr-day.prevMonthDay.today.inRange, .flatpickr-day.nextMonthDay.today.inRange, .flatpickr-day:hover, .flatpickr-day.prevMonthDay:hover, .flatpickr-day.nextMonthDay:hover, .flatpickr-day:focus, .flatpickr-day.prevMonthDay:focus, .flatpickr-day.nextMonthDay:focus {
    cursor: pointer;
    outline: 0;
    background-color: var(--vz-light);
    border-color: var(--vz-light); }
  .flatpickr-day.today {
    border-color: #F26430;
    background-color: rgba(242, 100, 48, 0.1);
    box-shadow: none; }
    .flatpickr-day.today:hover, .flatpickr-day.today:focus {
      border-color: #F26430;
      background-color: rgba(242, 100, 48, 0.15);
      color: var(--vz-dark); }
  .flatpickr-day.selected, .flatpickr-day.startRange, .flatpickr-day.endRange, .flatpickr-day.selected.inRange, .flatpickr-day.startRange.inRange, .flatpickr-day.endRange.inRange, .flatpickr-day.selected:focus, .flatpickr-day.startRange:focus, .flatpickr-day.endRange:focus, .flatpickr-day.selected:hover, .flatpickr-day.startRange:hover, .flatpickr-day.endRange:hover, .flatpickr-day.selected.prevMonthDay, .flatpickr-day.startRange.prevMonthDay, .flatpickr-day.endRange.prevMonthDay, .flatpickr-day.selected.nextMonthDay, .flatpickr-day.startRange.nextMonthDay, .flatpickr-day.endRange.nextMonthDay {
    background: #F26430;
    box-shadow: none;
    color: #fff;
    border-color: #F26430; }
  .flatpickr-day.selected.startRange, .flatpickr-day.startRange.startRange, .flatpickr-day.endRange.startRange {
    border-radius: 50px 0 0 50px; }
    .flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
      box-shadow: -10px 0 0 #F26430; }
    .flatpickr-day.selected.startRange .endRange, .flatpickr-day.startRange.startRange .endRange, .flatpickr-day.endRange.startRange .endRange {
      border-radius: 50px; }
  .flatpickr-day.selected.endRange, .flatpickr-day.startRange.endRange, .flatpickr-day.endRange.endRange {
    border-radius: 0 50px 50px 0; }
  .flatpickr-day.inRange {
    border-radius: 0;
    box-shadow: -5px 0 0 var(--vz-light), 5px 0 0 var(--vz-light); }
  .flatpickr-day.flatpickr-disabled, .flatpickr-day.flatpickr-disabled:hover, .flatpickr-day.prevMonthDay, .flatpickr-day.nextMonthDay, .flatpickr-day.notAllowed, .flatpickr-day.notAllowed.prevMonthDay, .flatpickr-day.notAllowed.nextMonthDay {
    color: rgba(var(--vz-body-color-rgb), 0.3);
    background: transparent;
    border-color: transparent;
    cursor: default; }
  .flatpickr-day.flatpickr-disabled, .flatpickr-day.flatpickr-disabled:hover {
    cursor: not-allowed;
    color: rgba(var(--vz-body-color-rgb), 0.3); }
  .flatpickr-day.week.selected {
    border-radius: 0;
    box-shadow: -5px 0 0 #F26430, 5px 0 0 #F26430; }
  .flatpickr-day.hidden {
    visibility: hidden; }

.rangeMode .flatpickr-day {
  margin-top: 1px; }

.flatpickr-weekwrapper {
  float: left; }
  .flatpickr-weekwrapper .flatpickr-weeks {
    padding: 0 12px;
    box-shadow: 1px 0 0 #e6e6e6; }
  .flatpickr-weekwrapper .flatpickr-weekday {
    float: none;
    width: 100%;
    line-height: 35px; }
  .flatpickr-weekwrapper span.flatpickr-day, .flatpickr-weekwrapper span.flatpickr-day:hover {
    display: block;
    width: 100%;
    max-width: none;
    color: rgba(var(--vz-dark-rgb), 0.3);
    background: transparent;
    cursor: default;
    border: none; }

.flatpickr-innerContainer {
  display: block;
  display: flex;
  box-sizing: border-box;
  overflow: hidden; }

.flatpickr-rContainer {
  display: inline-block;
  padding: 0;
  box-sizing: border-box; }

.flatpickr-time {
  text-align: center;
  outline: 0;
  display: block;
  height: 0;
  line-height: 40px;
  max-height: 40px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex; }
  .flatpickr-time:after {
    content: "";
    display: table;
    clear: both; }
  .flatpickr-time .numInputWrapper {
    flex: 1 1;
    width: 40%;
    height: 40px;
    float: left; }
    .flatpickr-time .numInputWrapper span.arrowUp:after, .flatpickr-time .numInputWrapper span.arrowDown:after {
      border-bottom-color: var(--vz-border-color); }
  .flatpickr-time.hasSeconds .numInputWrapper {
    width: 26%; }
  .flatpickr-time.time24hr .numInputWrapper {
    width: 49%; }
  .flatpickr-time input {
    background: transparent;
    box-shadow: none;
    border: 0;
    border-radius: 0;
    text-align: center;
    margin: 0;
    padding: 0;
    height: inherit;
    line-height: inherit;
    color: var(--vz-body-color);
    font-size: 14px;
    position: relative;
    box-sizing: border-box;
    appearance: textfield; }
    .flatpickr-time input.flatpickr-hour {
      font-weight: bold; }
    .flatpickr-time input.flatpickr-minute, .flatpickr-time input.flatpickr-second {
      font-weight: 400; }
    .flatpickr-time input:focus {
      outline: 0;
      border: 0; }
  .flatpickr-time .flatpickr-time-separator,
  .flatpickr-time .flatpickr-am-pm {
    height: inherit;
    float: left;
    line-height: inherit;
    color: var(--vz-body-color);
    font-weight: bold;
    width: 2%;
    -webkit-user-select: none;
            user-select: none;
    align-self: center; }
  .flatpickr-time .flatpickr-am-pm {
    outline: 0;
    width: 18%;
    cursor: pointer;
    text-align: center;
    font-weight: 400; }
  .flatpickr-time input:hover, .flatpickr-time input:focus, .flatpickr-time .flatpickr-am-pm:hover, .flatpickr-time .flatpickr-am-pm:focus {
    background: rgba(242, 100, 48, 0.04); }

.flatpickr-am-pm:focus, .flatpickr-am-pm:hover,
.numInput:focus,
.numInput:hover,
.numInputWrapper:focus,
.numInputWrapper:hover {
  background-color: transparent; }

.flatpickr-input[readonly] {
  cursor: pointer;
  background-color: var(--vz-input-bg); }

[data-inline-date="true"], [data-time-inline] {
  display: none; }

@keyframes fpFadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -20px, 0); }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0); } }

[datepicker-inline],
[timepicker-inline] {
  display: none; }

[data-input-flag] {
  position: relative; }
  [data-input-flag] .dropdown-menu .dropdown-menu-list {
    max-height: 158px;
    overflow-y: auto; }
    [data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar {
      -webkit-appearance: none; }
    [data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar:vertical {
      width: 8px; }
    [data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar:horizontal {
      height: 10px; }
    [data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar-thumb {
      background-color: rgba(var(--vz-dark-rgb), 0.075);
      border-radius: 8px; }
    [data-input-flag] .dropdown-menu .dropdown-menu-list::-webkit-scrollbar-track {
      border-radius: 8px; }

[data-option-flag-img-name] .flag-input {
  padding-left: 45px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_71___});
  background-repeat: no-repeat;
  background-position: 14px 8px;
  background-size: 18px; }

[data-option-flag-name]::before,
[data-option-flag-img-name]::before {
  content: "\\f0140";
  font-family: "Material Design Icons";
  position: absolute;
  right: 0.9rem;
  top: 0.5rem;
  font-size: 16px; }

[data-option-countrycode="false"] .country-codeno {
  display: none; }

[data-search-input="false"] .searchlist-input {
  display: none; }

.auth-page-wrapper .auth-page-content {
  padding-bottom: 60px;
  position: relative;
  z-index: 2;
  width: 100%; }

.auth-page-wrapper .footer {
  left: 0;
  background-color: transparent;
  color: var(--vz-body-color); }

.auth-one-bg-position {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 580px; }
  @media (max-width: 575.98px) {
    .auth-one-bg-position {
      height: 280px; } }

.auth-one-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_72___});
  background-size: cover; }
  .auth-one-bg .bg-overlay {
    background: linear-gradient(to right, #f04e13, #F26430);
    opacity: 0.1; }

.shape {
  position: absolute;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 1;
  pointer-events: none; }
  .shape > svg {
    width: 100%;
    height: auto;
    fill: var(--vz-body-bg); }

.auth-pass-inputgroup input[type="text"] + .btn .ri-eye-fill:before {
  content: "\\ecb6"; }

.particles-js-canvas-el {
  position: relative; }

.signin-other-title {
  position: relative; }
  .signin-other-title:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    left: 0;
    right: 0;
    border-top: 1px dashed var(--vz-border-color);
    top: 10px; }
  .signin-other-title .title {
    display: inline-block;
    position: relative;
    z-index: 9;
    background-color: var(--vz-card-bg-custom);
    padding: 2px 16px; }

.auth-bg-cover {
  background: linear-gradient(126deg, #088f7d 0%, #00395c 100%); }
  .auth-bg-cover > .bg-overlay {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_73___});
    background-position: center;
    background-size: cover;
    opacity: 1;
    background-color: transparent; }
  .auth-bg-cover .footer {
    color: rgba(255, 255, 255, 0.5); }

#password-contain {
  display: none; }
  #password-contain p {
    padding-left: 13px; }
    #password-contain p.valid {
      color: #0ab39c; }
      #password-contain p.valid::before {
        position: relative;
        left: -8px;
        content: "✔"; }
    #password-contain p.invalid {
      color: #f06548; }
      #password-contain p.invalid::before {
        position: relative;
        left: -8px;
        content: "✖"; }

.dash-filter-picker {
  min-width: 210px !important; }

.upcoming-scheduled {
  position: relative; }
  @media (max-width: 575.98px) {
    .upcoming-scheduled {
      top: 35px !important; } }
  .upcoming-scheduled .flatpickr-months {
    position: absolute !important;
    top: -45px !important;
    left: auto !important;
    right: 0px !important;
    width: 200px;
    background-color: transparent; }
    .upcoming-scheduled .flatpickr-months .flatpickr-month {
      color: #878a99 !important;
      fill: #878a99 !important; }
    .upcoming-scheduled .flatpickr-months .flatpickr-prev-month,
    .upcoming-scheduled .flatpickr-months .flatpickr-next-month {
      display: none; }
  .upcoming-scheduled .flatpickr-calendar {
    box-shadow: none !important; }
    .upcoming-scheduled .flatpickr-calendar .flatpickr-current-month {
      font-size: 13px;
      width: 100%;
      left: 0; }
    .upcoming-scheduled .flatpickr-calendar .flatpickr-monthDropdown-months {
      border: 1px solid var(--vz-border-color);
      border-radius: 4px;
      height: 26px; }
    .upcoming-scheduled .flatpickr-calendar .flatpickr-weekdays {
      background-color: var(--vz-light);
      border: none; }
      .upcoming-scheduled .flatpickr-calendar .flatpickr-weekdays span.flatpickr-weekday {
        color: var(--vz-dark);
        background-color: var(--vz-light); }
    .upcoming-scheduled .flatpickr-calendar .flatpickr-day.today {
      color: #fff !important;
      background-color: #0ab39c;
      border-color: #0ab39c !important; }
      .upcoming-scheduled .flatpickr-calendar .flatpickr-day.today:hover {
        color: #0ab39c !important;
        background-color: rgba(10, 179, 156, 0.2) !important; }
    .upcoming-scheduled .flatpickr-calendar .flatpickr-day.selected {
      background-color: #0ab39c !important;
      border-color: #0ab39c !important;
      color: #fff; }
    .upcoming-scheduled .flatpickr-calendar .numInputWrapper {
      width: 7.5ch;
      margin-left: 10px; }
  .upcoming-scheduled .flatpickr-days {
    border: none !important; }

.crm-widget .col {
  border-right: 1px solid var(--vz-border-color); }
  .crm-widget .col:last-child {
    border: 0px; }
  @media (min-width: 768px) and (max-width: 1399.98px) {
    .crm-widget .col:nth-child(3) {
      border-right: 0px; }
    .crm-widget .col:last-child {
      border-right: 1px solid var(--vz-border-color); } }
  @media (max-width: 767.98px) {
    .crm-widget .col {
      border-right: 0px;
      border-bottom: 1px solid var(--vz-border-color); } }

@media (min-width: 1400px) and (max-width: 1599.98px) {
  .project-wrapper > .col-xxl-8,
  .project-wrapper .col-xxl-4 {
    width: 100%; } }

.crypto-widget {
  max-width: 130px !important; }

.bg-marketplace {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_74___});
  background-size: cover; }

.dash-countdown .countdownlist .count-num {
  background-color: var(--vz-card-bg-custom);
  padding: 16px 8px;
  font-size: 22px; }
  @media (max-width: 575.98px) {
    .dash-countdown .countdownlist .count-num {
      font-size: 16px;
      padding: 8px 6px; }
  .dash-countdown .countdownlist .count-title {
    font-size: 10px; } }

.marketplace-icon {
  position: absolute;
  float: right;
  top: 30px;
  left: 30px; }

.marketplace-swiper .swiper-button-next,
.marketplace-swiper .swiper-button-prev {
  top: 34px;
  width: 28px;
  height: 28px;
  background-color: rgba(242, 100, 48, 0.1);
  color: #F26430;
  border-radius: 0.3rem;
  right: 16px !important; }

.marketplace-swiper .swiper-button-prev {
  right: 58px !important;
  left: auto !important; }

.dash-collection .content {
  background-color: rgba(255, 255, 255, 0.25);
  -webkit-backdrop-filter: blur(5px);
          backdrop-filter: blur(5px); }

@media (max-width: 1441.98px) {
  .dash-nft .col-xxl-9,
  .dash-nft .col-xxl-3 {
    width: 100% !important;
    max-width: 100% !important; } }

.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {
  width: 32px;
  height: 32px;
  display: inline-block;
  vertical-align: middle; }

.timeline {
  position: relative;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto; }
  .timeline::after {
    content: "";
    position: absolute;
    width: 2px;
    background: var(--vz-card-bg-custom);
    top: 57px;
    bottom: 166px;
    left: 50%;
    margin-left: -1.5px; }

.timeline-item {
  padding: 30px 60px;
  position: relative;
  background: inherit;
  width: 50%; }
  .timeline-item .icon {
    position: absolute;
    display: inline-flex;
    width: 60px;
    height: 60px;
    align-items: center;
    justify-content: center;
    font-size: 25px;
    top: 30px;
    right: -30px;
    padding: 9px 0;
    background: var(--vz-card-bg-custom);
    border: 1px solid var(--vz-border-color);
    border-radius: 50px;
    color: #0ab39c;
    z-index: 1; }
  .timeline-item .date {
    position: absolute;
    display: inline-block;
    width: calc(100% - 48px);
    top: 50px;
    font-size: 14px;
    font-weight: 500;
    font-style: italic; }
  .timeline-item .content {
    padding: 20px;
    background: var(--vz-card-bg-custom);
    position: relative;
    border: 1px solid var(--vz-border-color);
    border-radius: 0.25rem;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); }
  .timeline-item.left {
    left: 0; }
    .timeline-item.left .date {
      left: calc(100% + 48px);
      text-align: start; }
  .timeline-item.right {
    left: 50%; }
    .timeline-item.right .icon {
      left: -30px; }
    .timeline-item.right .date {
      right: calc(100% + 48px);
      text-align: end; }
    .timeline-item.right::before {
      left: 28px;
      border-color: transparent transparent transparent #fff; }

@media (max-width: 991.98px) {
  .timeline::after {
    left: 24px;
    bottom: 180px; }
  .timeline-item {
    width: 100%;
    padding-left: 48px;
    padding-right: 0px; }
    .timeline-item.right, .timeline-item.left {
      left: 0%; }
      .timeline-item.right .icon, .timeline-item.left .icon {
        width: 45px;
        height: 45px;
        top: 0;
        font-size: 18px;
        left: 0; }
      .timeline-item.right::before, .timeline-item.left::before {
        left: 110px;
        border-color: transparent transparent transparent var(--vz-border-color); }
      .timeline-item.right .date, .timeline-item.left .date {
        right: auto;
        left: 48px;
        width: 79px;
        top: 8px;
        text-align: left; } }

.timeline-2 {
  position: relative; }
  .timeline-2::after {
    position: absolute;
    content: "";
    width: 2px;
    height: 83%;
    top: 50px;
    left: 40px;
    margin-left: -1px;
    background: var(--vz-card-bg-custom); }
  .timeline-2 .timeline-year {
    position: relative;
    width: 100%;
    text-align: left;
    z-index: 1; }
    .timeline-2 .timeline-year p {
      display: inline-flex;
      width: 80px;
      height: 80px;
      margin: 0;
      padding: 23px 10px;
      background: var(--vz-card-bg-custom);
      border-radius: 50px;
      text-transform: uppercase;
      align-items: center;
      justify-content: center;
      text-align: center; }
      .timeline-2 .timeline-year p span {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis; }
  .timeline-2 .timeline-date {
    font-size: 14px;
    font-weight: 500;
    margin: 24px 0 0 0;
    margin-left: 55px; }
    .timeline-2 .timeline-date::after {
      content: "";
      display: block;
      position: absolute;
      width: 14px;
      height: 14px;
      top: 26px;
      left: 45px;
      align-items: left;
      background: #0ab39c;
      border: 3px solid var(--vz-card-bg-custom);
      border-radius: 50px;
      z-index: 1; }
  .timeline-2 .timeline-box {
    position: relative;
    display: inline-block;
    margin: 23px 62px;
    padding: 20px;
    border: 1px solid var(--vz-border-color);
    border-radius: 6px;
    background: var(--vz-card-bg-custom);
    max-width: 695px; }
    @media (max-width: 991.98px) {
      .timeline-2 .timeline-box {
        margin-right: 0; } }
    .timeline-2 .timeline-box::after {
      content: "";
      display: block;
      position: absolute;
      width: 0;
      height: 0;
      border-style: solid;
      top: 26px;
      right: 100%;
      border-color: transparent var(--vz-card-bg-custom) transparent transparent;
      border-width: 10px; }
    .timeline-2 .timeline-box::before {
      content: "";
      display: block;
      position: absolute;
      width: 0;
      height: 0;
      border-style: solid;
      right: 100%;
      top: 24px;
      border-color: transparent var(--vz-border-color) transparent transparent;
      border-width: 12px; }
    .timeline-2 .timeline-box .timeline-text {
      position: relative;
      float: left; }
  .timeline-2 .timeline-launch {
    position: relative;
    display: inline-block;
    border: 1px solid var(--vz-border-color);
    border-radius: 6px;
    background: #fff;
    width: 100%;
    margin-top: 15px;
    padding: 0;
    border: none;
    text-align: left;
    background: transparent; }
    .timeline-2 .timeline-launch .timeline-box {
      margin-left: 0; }
      .timeline-2 .timeline-launch .timeline-box::after {
        left: 30px;
        margin-left: 0px;
        top: -20px;
        border-color: transparent transparent var(--vz-border-color) transparent; }
      .timeline-2 .timeline-launch .timeline-box::before {
        left: 30px;
        margin-left: 0px;
        top: -19px;
        border-color: transparent transparent var(--vz-card-bg-custom) transparent;
        border-width: 10px;
        z-index: 1; }

.horizontal-timeline {
  position: relative;
  width: 100%;
  margin: 0 auto; }
  .horizontal-timeline::before {
    content: "";
    position: absolute;
    width: 100%;
    top: 174px;
    left: 0;
    height: 2px;
    background-color: var(--vz-card-bg-custom); }
  .horizontal-timeline .swiper-slide .item-box {
    margin: 227px 0px 0px;
    background-color: transparent;
    box-shadow: none; }
    .horizontal-timeline .swiper-slide .item-box::after {
      content: "";
      position: absolute;
      left: 0px;
      right: 0px;
      margin: 0px auto;
      background: #F26430;
      width: 13px;
      height: 13px;
      top: -59px;
      border-radius: 50px;
      border: 3px solid var(--vz-card-bg-custom); }
  .horizontal-timeline .swiper-slide .timeline-content {
    min-height: 110px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background-color: var(--vz-card-bg-custom); }
    .horizontal-timeline .swiper-slide .timeline-content::before {
      content: "";
      display: block;
      position: absolute;
      width: 0;
      height: 0;
      border-style: solid;
      left: 0px;
      top: -23px;
      border-color: transparent transparent var(--vz-card-bg-custom) transparent;
      border-width: 12px;
      right: 0;
      margin: 0 auto; }
  .horizontal-timeline .swiper-slide .time {
    position: absolute;
    top: -86px;
    right: 0px;
    left: 0px;
    margin: 0px auto; }
  .horizontal-timeline .swiper-slide:nth-child(even) {
    margin-top: 5px;
    transform: rotate(-180deg); }
    .horizontal-timeline .swiper-slide:nth-child(even) .timeline-content {
      transform: rotate(180deg); }
      .horizontal-timeline .swiper-slide:nth-child(even) .timeline-content::before {
        bottom: -23px;
        top: auto;
        border-color: var(--vz-card-bg-custom) transparent transparent transparent; }
    .horizontal-timeline .swiper-slide:nth-child(even) .time {
      transform: rotate(180deg); }
  .horizontal-timeline .swiper-button-next,
  .horizontal-timeline .swiper-button-prev {
    height: 40px;
    width: 40px;
    line-height: 40px;
    border-radius: 50%;
    background-color: #f36d3c; }
    .horizontal-timeline .swiper-button-next::after,
    .horizontal-timeline .swiper-button-prev::after {
      font-size: 24px;
      color: #fff; }
    .horizontal-timeline .swiper-button-next.swiper-button-disabled,
    .horizontal-timeline .swiper-button-prev.swiper-button-disabled {
      background-color: rgba(242, 100, 48, 0.5);
      opacity: 1;
      cursor: auto;
      -webkit-backdrop-filter: blur(25px);
              backdrop-filter: blur(25px);
      pointer-events: none; }
  .horizontal-timeline .swiper-button-next {
    right: 0; }
    .horizontal-timeline .swiper-button-next::after {
      content: "\\EA6E";
      font-family: remixicon; }
  .horizontal-timeline .swiper-button-prev {
    left: 0; }
    .horizontal-timeline .swiper-button-prev::after {
      content: "\\EA64";
      font-family: remixicon; }

.acitivity-timeline {
  position: relative;
  overflow: hidden; }
  .acitivity-timeline .acitivity-item {
    position: relative; }
    .acitivity-timeline .acitivity-item .flex-shrink-0 {
      z-index: 2; }
    .acitivity-timeline .acitivity-item .acitivity-avatar {
      background-color: var(--vz-card-bg-custom);
      border: 3px solid var(--vz-card-bg-custom);
      height: 32px;
      width: 32px; }
    .acitivity-timeline .acitivity-item:before {
      content: "";
      position: absolute;
      border-left: 1px dashed var(--vz-border-color);
      left: 16px;
      height: 100%;
      top: 5px;
      z-index: 0; }
    .acitivity-timeline .acitivity-item:last-child::before {
      border-color: transparent; }

.categories-filter .list-inline-item {
  position: relative;
  margin-right: 0; }
  .categories-filter .list-inline-item a {
    display: block;
    color: var(--vz-body-color);
    font-weight: 600;
    padding: 8px 15px;
    margin: 5px;
    cursor: pointer; }

.gallery-box {
  position: relative;
  overflow: hidden;
  border: 1px solid transparent;
  margin-bottom: 10px;
  box-shadow: none;
  background-color: transparent;
  padding: 8px; }
  .gallery-box::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    width: 100%;
    height: 0;
    background-color: var(--vz-card-bg-custom);
    transition: all 0.4s; }
  .gallery-box .gallery-container {
    position: relative;
    overflow: hidden;
    border-radius: 4px; }
    .gallery-box .gallery-container a {
      display: block; }
    .gallery-box .gallery-container .gallery-overlay {
      position: absolute;
      top: 0px;
      left: 0px;
      bottom: 0px;
      right: 0px;
      opacity: 0;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 10%, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.5) 100%);
      visibility: hidden;
      overflow: hidden;
      transition: all 0.4s ease-in-out 0s;
      display: flex;
      width: 100%;
      align-items: flex-end;
      padding: 16px; }
      .gallery-box .gallery-container .gallery-overlay .overlay-caption {
        color: #fff;
        margin: 0;
        font-size: 16px; }
  .gallery-box .gallery-img {
    transition: all 0.2s ease-in-out; }
  .gallery-box .box-content {
    position: relative; }
    .gallery-box .box-content .title {
      font-size: 14px;
      margin-bottom: 4px;
      display: none; }
    .gallery-box .box-content .post {
      margin: 0;
      transition: all 0.2s;
      color: #878a99; }
  .gallery-box:hover::before {
    height: 100%; }
  .gallery-box:hover .box-content {
    bottom: 0; }
    .gallery-box:hover .box-content .post {
      opacity: 1; }
  .gallery-box:hover .gallery-overlay {
    opacity: 1;
    visibility: visible; }

.gallery-light .gallery-box::before {
  background-color: var(--vz-light); }

.error-basic-img {
  max-width: 450px; }

.error-500 .title {
  font-size: 250px; }

.error-500 .error-500-img {
  position: absolute;
  top: 57px;
  left: 0;
  right: 0;
  margin: 0 auto; }

@media (min-width: 768px) and (max-width: 991.98px) {
  .error-500 .title {
    font-size: 150px; }
  .error-500 .error-500-img {
    width: 20% !important;
    top: 43px; } }

@media (max-width: 767.98px) {
  .error-500 .title {
    font-size: 68px;
    margin-top: 35px; }
  .error-500 .error-500-img {
    position: relative;
    top: 0px; } }

@keyframes errorAnimation {
  0% {
    transform: translateX(0%); }
  15% {
    transform: translateX(-25%) rotate(-5deg); }
  30% {
    transform: translateX(20%) rotate(3deg); }
  45% {
    transform: translateX(-15%) rotate(-3deg); }
  60% {
    transform: translateX(10%) rotate(2deg); }
  75% {
    transform: translateX(-5%) rotate(-1deg); }
  100% {
    transform: translateX(0%); } }

.error-img {
  animation: errorAnimation 20s infinite; }

.error-text {
  text-shadow: 4px 4px rgba(10, 179, 156, 0.4); }
  @media (min-width: 1200px) {
    .error-text {
      font-size: 10rem; } }

.profile-wid-bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 320px; }
  @media (max-width: 575.98px) {
    .profile-wid-bg {
      height: 445px; } }
  .profile-wid-bg::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    opacity: 0.9;
    background: #F26430;
    background: linear-gradient(to top, #99300a, #F26430); }
  .profile-wid-bg .profile-wid-img {
    width: 100%;
    height: 100%;
    object-fit: cover; }

.profile-nav.nav-pills .nav-link {
  color: rgba(255, 255, 255, 0.8); }
  .profile-nav.nav-pills .nav-link::before {
    background-color: rgba(255, 255, 255, 0.1); }

.profile-project-card {
  border: 1px solid var(--vz-border-color);
  border-left: 3px solid var(--vz-border-color); }

.profile-project-card.profile-project-primary {
  border-left-color: #F26430; }

.profile-project-card.profile-project-secondary {
  border-left-color: #208C3B; }

.profile-project-card.profile-project-success {
  border-left-color: #0ab39c; }

.profile-project-card.profile-project-info {
  border-left-color: #299cdb; }

.profile-project-card.profile-project-warning {
  border-left-color: #3FBF48; }

.profile-project-card.profile-project-danger {
  border-left-color: #f06548; }

.profile-project-card.profile-project-light {
  border-left-color: #f3f6f9; }

.profile-project-card.profile-project-dark {
  border-left-color: #212529; }

.user-profile-img {
  position: relative; }
  .user-profile-img .profile-img {
    width: 100%;
    height: 250px;
    object-fit: cover; }
    @media (max-width: 991px) {
      .user-profile-img .profile-img {
        height: 160px; } }
  .user-profile-img .profile-foreground-img-file-input {
    display: none; }
  .user-profile-img .profile-photo-edit {
    cursor: pointer; }

.profile-user {
  position: relative;
  display: inline-block; }
  .profile-user .profile-photo-edit {
    position: absolute;
    right: 0;
    left: auto;
    bottom: 0;
    cursor: pointer; }
  .profile-user .user-profile-image {
    object-fit: cover; }
  .profile-user .profile-img-file-input {
    display: none; }

.profile-timeline .accordion-item {
  position: relative; }
  .profile-timeline .accordion-item .accordion-button {
    background-color: transparent; }
    .profile-timeline .accordion-item .accordion-button::after {
      background: none; }
  .profile-timeline .accordion-item::before {
    content: "";
    border-left: 2px dashed var(--vz-border-color);
    position: absolute;
    height: 100%;
    left: 23px; }
  .profile-timeline .accordion-item:first-child::before {
    top: 8px; }
  .profile-timeline .accordion-item:last-child::before {
    height: 20px;
    top: 3px; }

.profile-setting-img {
  position: relative;
  height: 260px; }
  .profile-setting-img .overlay-content {
    content: "";
    position: absolute;
    top: 0;
    right: 0; }
  .profile-setting-img .profile-img {
    width: 100%;
    height: 250px;
    object-fit: cover; }
    @media (max-width: 991.98px) {
      .profile-setting-img .profile-img {
        height: 160px; } }
  .profile-setting-img .profile-foreground-img-file-input {
    display: none; }
  .profile-setting-img .profile-photo-edit {
    cursor: pointer; }

@media (max-width: 575.98px) {
  [data-layout="horizontal"] .profile-foreground {
    margin-top: 0 !important; } }

[data-layout="semibox"] .profile-wrapper {
  padding: 0 1rem; }

.sitemap-content {
  width: 100%;
  max-width: 1142px;
  margin: 0 auto;
  padding: 0 20px; }
  .sitemap-content * {
    position: relative; }

.sitemap-horizontal {
  position: relative; }
  .sitemap-horizontal ul {
    padding: 0;
    margin: 0;
    list-style: none; }
    .sitemap-horizontal ul a {
      display: block;
      background: var(--vz-light);
      border: 2px solid var(--vz-card-bg-custom);
      box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
      font-size: 0.8125rem;
      height: 60px;
      padding: 8px;
      display: flex;
      justify-content: center;
      align-items: center; }
      .sitemap-horizontal ul a span {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis; }

.administration .director > li > a {
  width: 50%;
  margin: 0 auto 0px auto;
  border-radius: 4px; }

.administration .subdirector {
  position: absolute;
  width: 100%; }
  .administration .subdirector::after {
    content: "";
    display: block;
    width: 0;
    height: 130px;
    border-left: 2px dashed var(--vz-border-color);
    left: 45.45%;
    position: relative; }
  .administration .subdirector > li:first-child {
    width: 18.59%;
    height: 64px;
    margin: 0 auto 92px auto;
    padding-top: 25px;
    border-bottom: 2px dashed var(--vz-border-color);
    z-index: 1;
    float: right;
    right: 27.2%;
    border-left: 2px dashed var(--vz-border-color); }
    .administration .subdirector > li:first-child a {
      width: 100%;
      left: 25px; }

@media screen and (max-width: 767px) {
  .administration .subdirector > li:first-child {
    width: 40%;
    right: 10%;
    margin-right: 2px; }
  .administration .subdirector::after {
    left: 49.8%; } }

.departments {
  width: 100%; }
  .departments > li:first-child {
    width: 18.59%;
    height: 64px;
    margin: 0 auto 92px auto;
    padding-top: 25px;
    border-bottom: 2px dashed var(--vz-border-color);
    z-index: 1;
    float: left;
    left: 27%; }
    .departments > li:first-child a {
      width: 100%;
      right: 25px; }
  .departments > li:nth-child(2) {
    margin-left: 0;
    clear: left; }
    .departments > li:nth-child(2).department:before {
      border: none; }
  .departments::after {
    content: "";
    display: block;
    position: absolute;
    width: 81.1%;
    height: 22px;
    border-top: 2px dashed var(--vz-border-color);
    border-right: 2px dashed var(--vz-border-color);
    border-left: 2px dashed var(--vz-border-color);
    margin: 0 auto;
    top: 130px;
    left: 9.1%; }
  @media screen and (max-width: 767px) {
    .departments > li:first-child {
      width: 40%;
      left: 10%;
      margin-left: 2px; }
    .departments::after {
      border-right: none;
      left: 0;
      width: 50%; } }

.department {
  border-left: 2px dashed var(--vz-border-color);
  float: left;
  margin-left: 1.75%;
  margin-bottom: 60px;
  width: 18.25%; }
  .department::before {
    content: "";
    display: block;
    position: absolute;
    width: 0;
    height: 22px;
    border-left: 2px dashed var(--vz-border-color);
    z-index: 1;
    top: -22px;
    left: 50%;
    margin-left: -4px; }
  .department > a {
    margin: 0 0 -26px -4px;
    z-index: 1; }
  .department ul {
    margin-top: 0px;
    margin-bottom: 0px; }
    .department ul li {
      padding-left: 25px;
      border-bottom: 2px dashed var(--vz-border-color);
      height: 80px; }
      .department ul li a {
        background: var(--vz-card-bg-custom);
        margin-top: 48px;
        position: absolute;
        z-index: 1;
        width: 90%;
        height: 60px;
        vertical-align: middle;
        right: -1px;
        text-align: center; }
  .department:first-child {
    margin-left: 0;
    clear: left; }
  @media screen and (min-width: 768px) {
    .department:last-child:before {
      border: none; } }
  @media screen and (max-width: 767px) {
    .department {
      float: none;
      width: 100%;
      margin-left: 0; }
      .department::before {
        content: "";
        display: block;
        position: absolute;
        width: 0;
        height: 60px;
        border-left: 2px dashed #fff;
        z-index: 1;
        top: -60px;
        left: 0%;
        margin-left: -4px; }
      .department:nth-child(2)::before {
        display: none; } }

.hori-sitemap ul {
  padding: 0;
  padding-top: 10px;
  text-align: center; }
  .hori-sitemap ul li {
    position: relative; }
  @media (max-width: 575.98px) {
    .hori-sitemap ul {
      text-align: left; }
      .hori-sitemap ul .parent-title a {
        padding-left: 0; }
        .hori-sitemap ul .parent-title a:after {
          display: none; }
      .hori-sitemap ul .parent-title:before {
        display: none; }
  .hori-sitemap > ul {
    position: relative; }
    .hori-sitemap > ul li {
      padding-top: 10px; }
      .hori-sitemap > ul li .second-list,
      .hori-sitemap > ul li .sub-list {
        position: relative; }
        .hori-sitemap > ul li .second-list:before,
        .hori-sitemap > ul li .sub-list:before {
          content: "";
          height: calc(100% - 14px);
          border-right: 2px dashed var(--vz-border-color);
          position: absolute;
          top: 0px;
          left: 0px; }
      .hori-sitemap > ul li .sub-list:before {
        height: 38%; }
      .hori-sitemap > ul li a {
        position: relative;
        padding: 4px 16px 4px 36px; }
        .hori-sitemap > ul li a:after {
          content: "";
          width: 24px;
          border-top: 2px dashed var(--vz-border-color);
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 0; }
      .hori-sitemap > ul li ul {
        margin-left: 36px; } }

@media (min-width: 576px) {
  .hori-sitemap ul {
    padding-top: 20px; }
    .hori-sitemap ul li {
      padding-top: 30px; }
      .hori-sitemap ul li:before {
        content: "";
        height: 24px;
        width: 0;
        border-right: 2px dashed var(--vz-border-color);
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin: 0px auto; }
      .hori-sitemap ul li:after {
        content: "";
        width: 100%;
        border-top: 2px dashed var(--vz-border-color);
        position: absolute;
        top: 0;
        left: 50%; }
      .hori-sitemap ul li:last-of-type:after {
        display: none; }
      .hori-sitemap ul li.parent-title::before {
        content: "";
        height: 23px;
        border-right: 2px dashed var(--vz-border-color);
        position: absolute;
        top: 28px;
        left: 0; }
      .hori-sitemap ul li.parent-title::after {
        border: none; }
      .hori-sitemap ul li .sub-title {
        position: relative; }
        .hori-sitemap ul li .sub-title::before {
          content: "";
          height: 21px;
          border-right: 2px dashed var(--vz-border-color);
          position: absolute;
          top: 27px;
          left: 49%;
          margin: 0 auto; } }

.hori-sitemap a {
  color: var(--vz-body-color);
  padding: 4px 0px;
  display: block; }

.verti-sitemap a {
  color: var(--vz-body-color);
  display: block; }

.verti-sitemap .parent-title a {
  padding-left: 0; }
  .verti-sitemap .parent-title a:before {
    display: none; }

.verti-sitemap .parent-title:before {
  display: none; }

.verti-sitemap .first-list {
  position: relative;
  padding-top: 10px; }
  .verti-sitemap .first-list:before {
    content: "";
    border-left: 2px dashed var(--vz-border-color);
    position: absolute;
    top: 0;
    height: 100%;
    bottom: 0;
    left: 0; }
  .verti-sitemap .first-list .list-wrap a, .verti-sitemap .first-list li a {
    position: relative;
    padding: 10px 16px 4px 36px; }
    .verti-sitemap .first-list .list-wrap a::before, .verti-sitemap .first-list li a::before {
      content: "";
      width: 24px;
      border-top: 2px dashed var(--vz-border-color);
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0; }
  .verti-sitemap .first-list .second-list, .verti-sitemap .first-list .third-list {
    margin-left: 42px; }
  .verti-sitemap .first-list .third-list, .verti-sitemap .first-list .second-list {
    position: relative; }
    .verti-sitemap .first-list .third-list li, .verti-sitemap .first-list .second-list li {
      position: relative; }
      .verti-sitemap .first-list .third-list li:before, .verti-sitemap .first-list .second-list li:before {
        content: "";
        height: 100%;
        border-left: 2px dashed var(--vz-border-color);
        position: absolute;
        top: 0;
        left: 0;
        margin: 0px auto; }
      .verti-sitemap .first-list .third-list li:last-child::before, .verti-sitemap .first-list .second-list li:last-child::before {
        height: 13px; }
  .verti-sitemap .first-list:last-child::before {
    height: 25px; }

.team-box .team-cover, .profile-offcanvas .team-cover, .modal-team-cover {
  display: none;
  position: relative;
  margin-bottom: -140px; }
  .team-box .team-cover img, .profile-offcanvas .team-cover img, .modal-team-cover img {
    height: 140px;
    width: 100%;
    object-fit: cover; }
  .team-box .team-cover::before, .profile-offcanvas .team-cover::before, .modal-team-cover::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background: linear-gradient(to top, #99300a, #F26430);
    opacity: 0.6; }

.team-list.grid-view-filter {
  flex-flow: row wrap; }
  .team-list.grid-view-filter .col {
    flex: 0 0 auto;
    width: 25%; }
  .team-list.grid-view-filter .team-box {
    overflow: hidden; }
    .team-list.grid-view-filter .team-box .team-row {
      align-items: start; }
      .team-list.grid-view-filter .team-box .team-row .col {
        width: 100%; }
    .team-list.grid-view-filter .team-box .team-cover {
      display: block; }
    .team-list.grid-view-filter .team-box .team-settings .col {
      width: 50% !important;
      flex: 0 0 auto; }
    .team-list.grid-view-filter .team-box .team-settings .btn-star {
      color: #fff; }
    .team-list.grid-view-filter .team-box .team-settings .dropdown > a {
      color: #fff; }
    .team-list.grid-view-filter .team-box .team-profile-img {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 25px;
      margin-top: 36px; }
      .team-list.grid-view-filter .team-box .team-profile-img .avatar-lg {
        font-size: 22px; }
      .team-list.grid-view-filter .team-box .team-profile-img .team-content {
        margin-left: 0px;
        margin-top: 25px;
        text-align: center; }
    .team-list.grid-view-filter .team-box .view-btn {
      width: 100%;
      margin-top: 25px; }
  @media (min-width: 1200px) and (max-width: 1399.98px) {
    .team-list.grid-view-filter .col {
      flex: 0 0 auto;
      width: 33.33%; } }
  @media (max-width: 1199.98px) {
    .team-list.grid-view-filter .col {
      flex: 0 0 auto;
      width: 50%; } }
  @media (max-width: 767.98px) {
    .team-list.grid-view-filter .col {
      flex: 0 0 auto;
      width: 100%; } }

.team-list.list-view-filter {
  flex-direction: column; }
  .team-list.list-view-filter .team-box {
    margin-bottom: 10px; }
    .team-list.list-view-filter .team-box .team-row {
      align-items: center;
      justify-content: space-between; }
    .team-list.list-view-filter .team-box .team-profile-img {
      display: flex;
      align-items: center; }
      .team-list.list-view-filter .team-box .team-profile-img .avatar-lg {
        height: 4rem;
        width: 4rem;
        font-size: 16px; }
      .team-list.list-view-filter .team-box .team-profile-img .team-content {
        margin-left: 15px; }
    .team-list.list-view-filter .team-box .team-settings {
      width: auto;
      flex: 0 0 auto;
      order: 6; }
    .team-list.list-view-filter .team-box .btn-star {
      color: #F26430; }
  @media (max-width: 767.98px) {
    .team-list.list-view-filter {
      flex-direction: row; }
      .team-list.list-view-filter .col {
        flex: 0 0 auto;
        width: 100%; }
      .team-list.list-view-filter .team-box .team-settings {
        width: 100%;
        flex: 0 0 auto;
        order: -1;
        margin-bottom: 10px; }
        .team-list.list-view-filter .team-box .team-settings .col {
          width: 50%; }
      .team-list.list-view-filter .team-box .team-profile-img {
        margin-bottom: 25px; }
      .team-list.list-view-filter .team-box .view-btn {
        width: 100%;
        margin-top: 25px; } }

.modal-team-cover {
  display: block; }

.list-grid-nav .nav-link.active {
  background-color: #299cdb;
  color: #fff; }

.profile-offcanvas .team-cover {
  margin-bottom: -132px;
  display: block;
  z-index: -1; }

.profile-offcanvas .btn-star {
  color: #fff; }

.profile-offcanvas .dropdown > a {
  color: #fff; }

.countdownlist {
  text-align: center;
  display: flex;
  gap: 24px; }
  .countdownlist .countdownlist-item {
    width: 25%; }
    .countdownlist .countdownlist-item:last-of-type .count-num::after {
      display: none; }
  .countdownlist .count-title {
    font-size: 13px;
    font-weight: 500;
    display: block;
    margin-bottom: 8px;
    color: rgba(var(--vz-dark-rgb), 0.5);
    text-transform: uppercase; }
  .countdownlist .count-num {
    background-color: var(--vz-card-bg-custom);
    padding: 16px 8px;
    position: relative;
    border-radius: 0.25rem;
    box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
    font-weight: 600;
    font-size: 32px; }
    @media (max-width: 575.98px) {
      .countdownlist .count-num {
        font-size: 18px; } }
    .countdownlist .count-num::after {
      content: ":";
      font-size: 20px;
      position: absolute;
      right: -16px;
      top: 50%;
      transform: translateY(-50%);
      color: var(--vz-dark); }

.move-animation {
  animation: mover 1s infinite  alternate; }

@keyframes mover {
  0% {
    transform: translateY(0); }
  100% {
    transform: translateY(-16px); } }

.coming-soon-text {
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  text-shadow: 3px 4px #0ab39c; }

.countdown-input-group {
  max-width: 400px; }

.search-more-results {
  position: relative;
  overflow: hidden; }
  .search-more-results .nav-icon {
    font-size: 14px;
    color: #fff;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    text-align: center;
    left: 0;
    right: 0; }
    .search-more-results .nav-icon i {
      font-size: 20px; }
    @media (max-width: 767.98px) {
      .search-more-results .nav-icon {
        font-size: 14px; }
        .search-more-results .nav-icon i {
          font-size: 18px; } }

.video-list .list-element {
  display: none; }
  .video-list .list-element:nth-child(1) {
    display: block; }
  .video-list .list-element:nth-child(2) {
    display: block; }
  .video-list .list-element:nth-child(3) {
    display: block; }

.search-voice {
  height: 120px;
  width: 120px;
  line-height: 120px;
  margin: 0px auto;
  text-align: center;
  border-radius: 50%;
  z-index: 1;
  position: relative; }
  .search-voice i {
    line-height: 56px;
    font-size: 30px; }
  .search-voice .voice-wave {
    position: absolute;
    width: 120px;
    height: 120px;
    z-index: -1;
    left: 0px;
    right: 0px;
    margin: 0px auto;
    opacity: 0;
    border-radius: 100px;
    animation: voice-wave 1.8s infinite;
    background-color: var(--vz-light); }
    .search-voice .voice-wave:nth-child(2) {
      animation-delay: 0.3s; }
    .search-voice .voice-wave:nth-child(3) {
      animation-delay: 0.6s; }

@keyframes voice-wave {
  0% {
    opacity: 1;
    transform: scale(0); }
  100% {
    opacity: 0;
    transform: scale(1); } }

.images-menu .swiper-slide {
  width: auto;
  display: inline-block; }

#selection-element {
  display: none; }

.filter-choices-input .choices__inner {
  padding: 0;
  border: none;
  background-color: var(--vz-card-bg-custom); }

.filter-choices-input .choices__input {
  background-color: var(--vz-card-bg-custom); }

@media (min-width: 992px) {
  .sticky-side-div {
    position: sticky;
    top: calc(70px + 1rem); } }

.product-img-slider .product-nav-slider .nav-slide-item {
  border: 1px solid var(--vz-border-color);
  border-radius: 0.25rem;
  padding: 0.5rem;
  cursor: pointer; }

.product-img-slider .product-nav-slider .swiper-slide-thumb-active .nav-slide-item {
  background-color: var(--vz-light); }

.filter-list a.active .listname {
  color: #0ab39c; }

.invoice-table tbody:last-child {
  border: none; }

.currency-select .choices__inner {
  padding: 0px;
  padding-right: 15px;
  min-height: 0px; }

.currency-select .choices__list--single {
  padding: 0px 16px 0 4px; }

.currency-select .choices[data-type*=select-one] {
  bottom: 0px; }
  .currency-select .choices[data-type*=select-one] :after {
    top: 4px; }
  .currency-select .choices[data-type*=select-one] .choices__inner {
    padding-bottom: 0px; }

.chat-wrapper {
  position: relative;
  overflow-x: hidden; }

.chat-leftsidebar {
  height: calc(100vh - 137px);
  position: relative;
  background-color: var(--vz-card-bg-custom); }
  @media (min-width: 992px) {
    .chat-leftsidebar {
      min-width: 300px;
      max-width: 300px;
      height: calc(100vh - 70px - 60px - 8px); } }

.chat-list {
  margin: 0; }
  .chat-list > li.active a {
    background-color: rgba(var(--vz-success-rgb), 0.15);
    color: var(--vz-success); }
    .chat-list > li.active a .badge {
      background-color: rgba(var(--vz-success-rgb), 0.15) !important;
      color: #0ab39c !important; }
  .chat-list > li a {
    display: block;
    padding: 7px 24px;
    color: var(--vz-body-color);
    transition: all 0.4s;
    font-family: "hkgrotesk", sans-serif;
    font-weight: 500;
    font-size: 0.8125rem; }
  .chat-list > li .chat-user-message {
    font-size: 14px; }
  .chat-list > li .unread-msg-user {
    font-weight: 600; }
  .chat-list > li .unread-message {
    position: absolute;
    display: inline-block;
    right: 24px;
    left: auto;
    top: 33px; }
    .chat-list > li .unread-message .badge {
      line-height: 16px;
      font-weight: 600;
      font-size: 10px; }

.chat-user-img {
  position: relative; }
  .chat-user-img .user-status {
    width: 10px;
    height: 10px;
    background-color: #adb5bd;
    border-radius: 50%;
    border: 2px solid var(--vz-card-bg-custom);
    position: absolute;
    right: 0;
    left: auto;
    bottom: 0; }
  .chat-user-img.online .user-status {
    background-color: #0ab39c; }
  .chat-user-img.away .user-status {
    background-color: #3FBF48; }

.chat-room-list {
  max-height: calc(100vh - 296px); }
  @media (max-width: 991.98px) {
    .chat-room-list {
      height: calc(100vh - 296px); } }

.contact-list li {
  cursor: pointer;
  padding: 8px 24px;
  transition: all 0.4s;
  color: var(--vz-body-color);
  font-family: "hkgrotesk", sans-serif;
  font-weight: 500;
  font-size: 0.8125rem; }

.contact-list-title {
  padding: 6px 24px;
  color: #F26430;
  font-weight: 500;
  position: relative;
  font-size: 12px; }
  .contact-list-title:after {
    content: "";
    height: 1px;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 50px;
    right: 0;
    background-color: var(--vz-light); }

.user-chat {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_75___});
  transition: all 0.4s;
  position: relative;
  background-color: var(--vz-body-bg); }
  @media (max-width: 991.98px) {
    .user-chat {
      position: absolute;
      left: 0;
      top: 3px;
      width: 100%;
      height: calc(100% - 3px);
      visibility: hidden;
      transform: translateX(100%);
      z-index: 99;
      padding-top: 70px; }
      .user-chat.user-chat-show {
        visibility: visible;
        transform: translateX(0); } }
  .user-chat .chat-content {
    position: relative; }
  .user-chat.user-chat-show .chat-welcome-section {
    display: none; }
  @media (min-width: 992px) {
    .user-chat.user-chat-show .chat-content {
      display: flex !important; } }

.user-chat-topbar {
  border-bottom: 1px solid transparent;
  background-color: var(--vz-card-bg-custom); }
  @media (max-width: 991.98px) {
    .user-chat-topbar {
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      z-index: 1; } }

.user-chat-nav .nav-btn {
  height: 40px;
  width: 40px;
  line-height: 40px;
  box-shadow: none;
  padding: 0;
  font-size: 20px;
  color: #343a40; }

@media (max-width: 575.98px) {
  .user-chat-nav {
    display: flex;
    justify-content: flex-end; } }

.chat-conversation {
  height: calc(100vh - 299px) !important; }
  @media (max-width: 991.98px) {
    .chat-conversation {
      height: calc(100vh - 275px) !important; } }
  .chat-conversation .simplebar-content-wrapper {
    display: flex;
    flex-direction: column; }
    .chat-conversation .simplebar-content-wrapper .simplebar-content {
      margin-top: auto; }
  .chat-conversation .chat-conversation-list {
    padding-top: 10px;
    margin-bottom: 0; }
    .chat-conversation .chat-conversation-list > li {
      display: flex; }
  .chat-conversation li:last-of-type .conversation-list {
    margin-bottom: 0; }
  .chat-conversation .chat-list.left .check-message-icon {
    display: none; }
  .chat-conversation .chat-list .message-box-drop {
    visibility: hidden; }
  .chat-conversation .chat-list:hover .message-box-drop {
    visibility: visible; }
  .chat-conversation .chat-avatar {
    margin: 0 16px 0 0; }
    .chat-conversation .chat-avatar img {
      width: 28px;
      height: 28px;
      border-radius: 50%; }
  .chat-conversation .chat-day-title {
    position: relative;
    text-align: center;
    margin-bottom: 24px;
    margin-top: 12px;
    width: 100%; }
    .chat-conversation .chat-day-title .title {
      background-color: #fff;
      position: relative;
      font-size: 13px;
      z-index: 1;
      padding: 6px 12px;
      border-radius: 5px; }
    .chat-conversation .chat-day-title:before {
      content: "";
      position: absolute;
      width: 100%;
      height: 1px;
      left: 0;
      right: 0;
      background-color: rgba(242, 100, 48, 0.2);
      top: 10px; }
    .chat-conversation .chat-day-title .badge {
      font-size: 12px; }
  .chat-conversation .conversation-list {
    margin-bottom: 24px;
    display: inline-flex;
    position: relative;
    align-items: flex-end;
    max-width: 80%; }
    @media (max-width: 575.98px) {
      .chat-conversation .conversation-list {
        max-width: 90%; } }
    .chat-conversation .conversation-list .ctext-wrap {
      display: flex;
      margin-bottom: 10px; }
    .chat-conversation .conversation-list .ctext-content {
      word-wrap: break-word;
      word-break: break-word; }
    .chat-conversation .conversation-list .ctext-wrap-content {
      padding: 12px 20px;
      background-color: var(--vz-light);
      position: relative;
      border-radius: 3px;
      box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12); }
      @media (max-width: 575.98px) {
        .chat-conversation .conversation-list .ctext-wrap-content .attached-file .attached-file-avatar {
          display: none; }
        .chat-conversation .conversation-list .ctext-wrap-content .attached-file .dropdown .dropdown-toggle {
          display: block; } }
    .chat-conversation .conversation-list .conversation-name {
      font-weight: 500;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px; }
    .chat-conversation .conversation-list .dropdown .dropdown-toggle {
      font-size: 18px;
      padding: 4px;
      color: #878a99; }
      .chat-conversation .conversation-list .dropdown .dropdown-toggle::after {
        display: none; }
      @media (max-width: 575.98px) {
        .chat-conversation .conversation-list .dropdown .dropdown-toggle {
          display: none; } }
    .chat-conversation .conversation-list .chat-time {
      font-size: 12px;
      margin-top: 4px;
      text-align: right; }
    .chat-conversation .conversation-list .message-img {
      border-radius: 0.2rem;
      position: relative;
      display: flex;
      flex-wrap: wrap;
      gap: 8px; }
      .chat-conversation .conversation-list .message-img .message-img-list {
        position: relative; }
      .chat-conversation .conversation-list .message-img img {
        max-width: 150px; }
      .chat-conversation .conversation-list .message-img .message-img-link {
        position: absolute;
        right: 10px;
        left: auto;
        bottom: 10px; }
        .chat-conversation .conversation-list .message-img .message-img-link li > a {
          font-size: 18px;
          color: #fff;
          display: inline-block;
          line-height: 20px;
          width: 26px;
          height: 24px;
          border-radius: 3px;
          background-color: rgba(33, 37, 41, 0.7);
          text-align: center; }
  .chat-conversation .right {
    justify-content: flex-end; }
    .chat-conversation .right .chat-avatar {
      order: 3;
      margin-right: 0px;
      margin-left: 16px; }
    .chat-conversation .right .chat-time {
      text-align: left;
      color: #878a99; }
    .chat-conversation .right .conversation-list {
      text-align: right; }
      .chat-conversation .right .conversation-list .ctext-wrap {
        justify-content: flex-end; }
        .chat-conversation .right .conversation-list .ctext-wrap .ctext-wrap-content {
          order: 2;
          background-color: rgba(var(--vz-success-rgb), 0.15);
          color: var(--vz-success);
          text-align: right;
          box-shadow: none; }
          .chat-conversation .right .conversation-list .ctext-wrap .ctext-wrap-content .replymessage-block {
            background-color: rgba(255, 255, 255, 0.5);
            border-color: rgba(var(--vz-success-rgb), 1);
            color: #212529; }
            .chat-conversation .right .conversation-list .ctext-wrap .ctext-wrap-content .replymessage-block .conversation-name {
              color: rgba(var(--vz-success-rgb), 1); }
      .chat-conversation .right .conversation-list .conversation-name {
        justify-content: flex-end; }
        .chat-conversation .right .conversation-list .conversation-name .check-message-icon {
          order: 1; }
        .chat-conversation .right .conversation-list .conversation-name .time {
          order: 2; }
        .chat-conversation .right .conversation-list .conversation-name .name {
          order: 3; }
      .chat-conversation .right .conversation-list .dropdown {
        order: 1; }
    .chat-conversation .right .dot {
      background-color: #212529; }

.chat-input-section {
  border-top: 1px solid transparent;
  background-color: var(--vz-card-bg-custom);
  position: relative;
  z-index: 1; }
  .chat-input-section .chat-input-feedback {
    display: none;
    position: absolute;
    top: -20px;
    left: 4px;
    font-size: 12px;
    color: #f06548; }
  .chat-input-section .show {
    display: block; }

.chat-input-links {
  display: flex; }
  .chat-input-links .links-list-item > .btn {
    box-shadow: none;
    padding: 0;
    font-size: 20px;
    width: 37.5px;
    height: 37.5px; }
    .chat-input-links .links-list-item > .btn.btn-link {
      color: #878a99; }

.copyclipboard-alert {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: none; }

.replyCard {
  position: absolute;
  left: 0;
  right: 0;
  border-top: 1px solid var(--vz-border-color);
  overflow: hidden;
  opacity: 0;
  bottom: 0;
  border-radius: 0;
  transition: all 0.4s; }
  @media (max-width: 991.98px) {
    .replyCard {
      bottom: -12px; } }
  .replyCard.show {
    transform: translateY(-88px);
    opacity: 1; }
    @media (max-width: 991.98px) {
      .replyCard.show {
        transform: translateY(-83px); } }

.replymessage-block {
  padding: 12px 20px;
  margin-bottom: 8px;
  text-align: left;
  border-radius: 4px;
  background-color: rgba(var(--vz-success-rgb), 0.1);
  border-left: 2px solid rgba(var(--vz-success-rgb), 1); }
  .replymessage-block .conversation-name {
    color: rgba(var(--vz-success-rgb), 1);
    font-size: 14px; }

.chat-sm .ctext-wrap-content {
  box-shadow: none !important; }

.chat-sm .message-img img {
  max-width: 90px !important; }

.chat-sm .message-img-link {
  bottom: 0 !important;
  right: 5px !important; }

@media (min-width: 1025px) {
  [data-layout="horizontal"] .chat-wrapper {
    margin-left: 0 !important;
    margin-right: 0 !important; } }

@media (max-width: 991.98px) {
  [data-layout="horizontal"] .chat-wrapper {
    margin-top: 0 !important; } }

[data-layout="horizontal"] .chat-leftsidebar {
  height: calc(100vh - 70px - 60px - 54px); }
  @media (max-width: 991.98px) {
    [data-layout="horizontal"] .chat-leftsidebar {
      height: calc(100vh - 70px - 60px - 8px); } }

[data-layout="horizontal"] .chat-room-list {
  height: calc(100vh - 352px); }
  @media (max-width: 991.98px) {
    [data-layout="horizontal"] .chat-room-list {
      height: calc(100vh - 265px); } }

[data-layout="horizontal"] .chat-conversation {
  height: calc(100vh - 343px) !important; }
  @media (max-width: 991.98px) {
    [data-layout="horizontal"] .chat-conversation {
      height: calc(100vh - 275px) !important; } }

.email-wrapper {
  position: relative;
  overflow-x: hidden; }

.email-menu-sidebar {
  height: calc(100vh - 137px);
  position: relative;
  background-color: var(--vz-card-bg-custom);
  transition: all 0.2s; }
  @media (min-width: 992px) {
    .email-menu-sidebar {
      min-width: 250px;
      max-width: 250px;
      height: calc(100vh - 70px - 60px - 8px); } }
  @media (max-width: 991.98px) {
    .email-menu-sidebar {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      width: 200px;
      max-width: 100%;
      z-index: 1003;
      box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
      transform: translateX(-100%);
      visibility: hidden;
      height: 100vh; }
      .email-menu-sidebar.menubar-show {
        visibility: visible;
        transform: none; } }
  .email-menu-sidebar .email-menu-sidebar-scroll {
    height: calc(100vh - 295px); }
    @media (max-width: 991.98px) {
      .email-menu-sidebar .email-menu-sidebar-scroll {
        height: calc(100vh - 150px); } }

.mail-list a {
  display: flex;
  align-items: center;
  color: #878a99;
  padding: 5px 0;
  font-weight: 500; }
  .mail-list a:hover {
    color: #F26430; }
  .mail-list a i {
    font-size: 14px; }
  .mail-list a.active {
    color: #0ab39c;
    font-weight: 600; }
    .mail-list a.active i {
      color: #0ab39c; }

.email-chat-list a {
  padding: 6px 24px; }
  .email-chat-list a.active {
    background-color: rgba(var(--vz-light-rgb), 0.7); }

.email-topbar-link .btn-ghost-secondary {
  color: #878a99; }
  .email-topbar-link .btn-ghost-secondary:hover {
    color: #208C3B; }

.email-content {
  width: 100%;
  background-color: var(--vz-card-bg-custom);
  transition: all 0.2s; }

.unreadConversations-alert {
  position: fixed;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1; }

.email-detail-content {
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 68%;
  width: 32%;
  background-color: var(--vz-card-bg-custom);
  transform: translateX(200%);
  transition: all 0.2s;
  visibility: hidden;
  border-left: 2px solid var(--vz-body-bg); }

.email-detail-show .email-detail-content {
  transform: none;
  visibility: visible; }

.email-detail-show .email-content {
  margin-right: 32%; }
  @media (max-width: 1349.98px) {
    .email-detail-show .email-content {
      margin-right: 0; } }

.email-detail-content-scroll {
  height: calc(100vh - 390px); }
  @media (max-width: 1349.98px) {
    .email-detail-content-scroll {
      height: calc(100vh - 252px); } }

.message-list-content {
  height: calc(100vh - 242px); }
  @media (max-width: 575.98px) {
    .message-list-content {
      height: calc(100vh - 230px); } }

.message-list {
  display: block;
  padding-left: 0;
  margin: 0; }
  .message-list li {
    position: relative;
    display: block;
    height: 50px;
    line-height: 50px;
    cursor: default;
    transition-duration: 0.3s;
    clear: both; }
    .message-list li a {
      color: var(--vz-gray-700); }
    .message-list li:hover {
      background: var(--vz-light);
      transition-duration: 0.05s; }
    .message-list li .col-mail {
      float: left;
      position: relative; }
    .message-list li .col-mail-1 {
      width: 280px; }
      .message-list li .col-mail-1 .star-toggle,
      .message-list li .col-mail-1 .checkbox-wrapper-mail,
      .message-list li .col-mail-1 .dot {
        display: block;
        float: left; }
      .message-list li .col-mail-1 .dot {
        border: 4px solid transparent;
        border-radius: 100px;
        margin: 22px 26px 0;
        height: 0;
        width: 0;
        line-height: 0;
        font-size: 0; }
      .message-list li .col-mail-1 .checkbox-wrapper-mail {
        margin: 15px 0 0 20px;
        line-height: normal; }
      .message-list li .col-mail-1 .star-toggle {
        margin-top: 18px;
        margin-left: 5px; }
      .message-list li .col-mail-1 .title {
        position: absolute;
        top: 0;
        left: 95px;
        right: 0;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-bottom: 0; }
        @media (max-width: 575.98px) {
          .message-list li .col-mail-1 .title {
            left: 95px; } }
    .message-list li .col-mail-2 {
      position: absolute;
      top: 0;
      left: 280px;
      right: 0;
      bottom: 0; }
      .message-list li .col-mail-2 .subject,
      .message-list li .col-mail-2 .date {
        position: absolute;
        top: 0; }
      .message-list li .col-mail-2 .subject {
        left: 0;
        right: 110px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap; }
        .message-list li .col-mail-2 .subject .teaser {
          color: var(--vz-gray-600); }
      .message-list li .col-mail-2 .date {
        right: 0;
        width: 100px;
        padding-left: 20px; }
    .message-list li.active, .message-list li.active:hover {
      box-shadow: inset 3px 0 0 #F26430;
      background-color: var(--vz-light); }
    .message-list li.unread {
      color: var(--vz-gray-800); }
      .message-list li.unread a {
        color: var(--vz-gray-800);
        font-weight: 600; }

#unreadConversations,
#email-topbar-actions {
  display: none; }

#elmLoader {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0; }

.email-compose-input {
  padding-right: 80px; }

@media (max-width: 1349.98px) {
  .email-detail-content {
    position: fixed;
    top: 0;
    bottom: 0;
    left: auto;
    right: 0;
    width: 400px;
    max-width: 100%;
    z-index: 1003;
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    transform: translateX(100%); }
  .email-detail-show .email-detail-content {
    transform: none; } }

@media (max-width: 575.98px) {
  .message-list li .col-mail-1 {
    width: 180px; } }

.email-editor .ck-editor__editable_inline {
  min-height: 200px !important; }

.email-chat-detail {
  width: 350px;
  position: fixed;
  max-width: 100%;
  bottom: 60px;
  right: 60px;
  z-index: 9;
  display: none; }
  .email-chat-detail .card {
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12); }
  @media (max-width: 515.98px) {
    .email-chat-detail {
      left: 16px;
      right: 16px; } }

@media (min-width: 1025px) {
  [data-layout="horizontal"] .email-wrapper {
    margin-left: 0 !important;
    margin-right: 0 !important; } }

@media (max-width: 991.98px) {
  [data-layout="horizontal"] .email-wrapper {
    margin-top: 0 !important; } }

[data-layout="horizontal"] .email-menu-sidebar {
  height: calc(100vh - 70px - 60px - 54px); }
  @media (max-width: 991.98px) {
    [data-layout="horizontal"] .email-menu-sidebar {
      height: 100vh; } }
  [data-layout="horizontal"] .email-menu-sidebar .email-menu-sidebar-scroll {
    height: calc(100vh - 330px); }
    @media (max-width: 991.98px) {
      [data-layout="horizontal"] .email-menu-sidebar .email-menu-sidebar-scroll {
        height: calc(100vh - 150px); } }

[data-layout="horizontal"] .message-list-content {
  height: calc(100vh - 289px); }

[data-layout="horizontal"] .email-detail-content-scroll {
  height: calc(100vh - 435px); }
  @media (max-width: 1349.98px) {
    [data-layout="horizontal"] .email-detail-content-scroll {
      height: calc(100vh - 252px); } }

.email-chat-element .chat-conversation1 {
  height: 250px !important; }

.tasks-board {
  display: flex;
  overflow-x: auto;
  align-items: stretch; }
  .tasks-board .tasks-list {
    min-width: 300px;
    margin-right: 24px; }
  .tasks-board::-webkit-scrollbar {
    -webkit-appearance: none; }
  .tasks-board::-webkit-scrollbar:vertical {
    width: 10px; }
  .tasks-board::-webkit-scrollbar:horizontal {
    height: 8px; }
  .tasks-board::-webkit-scrollbar-thumb {
    background-color: rgba(var(--vz-dark-rgb), 0.075);
    border-radius: 8px; }
  .tasks-board::-webkit-scrollbar-track {
    border-radius: 8px; }

.tasks-box .progress {
  border-radius: 0px 0px 0.25rem 0.25rem; }

.tasks-box .tasks-img {
  height: 135px;
  width: 100%;
  object-fit: cover;
  object-position: center;
  margin: 12px 0px; }

.tasks-box:last-child {
  margin-bottom: 0px; }

.tasks-wrapper {
  max-height: calc(100vh - 418px); }

.tasks {
  min-height: 180px;
  position: relative; }
  .tasks.noTask::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 180px;
    width: 270px;
    margin: 0 auto;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_76___});
    background-size: cover;
    background-position: center; }

#tasksList tr .tasks-list-menu {
  opacity: 0; }

#tasksList tr:hover .tasks-list-menu {
  opacity: 1; }

.layout-wrapper.landing {
  background-color: var(--vz-card-bg-custom);
  font-size: 15px; }

.section {
  padding: 90px 0;
  position: relative; }
  @media (max-width: 767.98px) {
    .section {
      padding: 50px 0; } }

.icon-effect {
  position: relative; }
  .icon-effect::before {
    content: "";
    position: absolute;
    width: 24px;
    height: 24px;
    background-color: rgba(10, 179, 156, 0.2);
    border-radius: 50%;
    bottom: 0;
    left: 0; }

.navbar-landing {
  padding: 10px 0px;
  transition: all 0.5s ease; }
  @media (max-width: 991.98px) {
    .navbar-landing {
      background-color: var(--vz-card-bg-custom);
      box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);
      padding: 10px 8px; } }
  .navbar-landing .navbar-nav .nav-item .nav-link {
    font-size: 16px;
    font-weight: 500;
    transition: all 0.4s;
    font-family: "hkgrotesk", sans-serif;
    color: var(--vz-dark);
    padding: 14px; }
    @media (max-width: 991.98px) {
      .navbar-landing .navbar-nav .nav-item .nav-link {
        padding: 8px 0px; } }
    .navbar-landing .navbar-nav .nav-item .nav-link:hover, .navbar-landing .navbar-nav .nav-item .nav-link.active, .navbar-landing .navbar-nav .nav-item .nav-link:focus {
      color: #0ab39c !important; }
  .navbar-landing .navbar-nav .nav-item.active .nav-link {
    color: #0ab39c !important; }
  .navbar-landing.is-sticky {
    background-color: var(--vz-card-bg-custom);
    box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15); }

.navbar-light .navbar-brand .card-logo-dark {
  display: none; }

.navbar-light .navbar-brand .card-logo-light {
  display: block; }

.navbar-light .navbar-nav .nav-item .nav-link {
  color: rgba(var(--vz-white-rgb), 0.75); }

.navbar-light.is-sticky .navbar-nav .nav-item .nav-link {
  color: var(--vz-dark); }

.navbar-light.is-sticky .navbar-brand .card-logo-dark {
  display: block; }

.navbar-light.is-sticky .navbar-brand .card-logo-light {
  display: none; }

.hero-section {
  background-color: rgba(var(--vz-light-rgb), 0.5); }
  .hero-section .hero-shape-svg svg path {
    fill: var(--vz-card-bg-custom); }

.bg-overlay-pattern {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_77___});
  background-color: transparent;
  background-position: center;
  background-size: cover;
  opacity: 0.2; }

.demo-carousel {
  position: relative;
  z-index: 1; }
  .demo-carousel .carousel-item .demo-item {
    background-color: var(--vz-card-bg-custom);
    padding: 8px;
    border-radius: 7px; }
  .demo-carousel .demo-img-patten-top {
    position: absolute;
    right: -50px;
    top: -16px;
    max-width: 230px; }
  .demo-carousel .demo-img-patten-bottom {
    position: absolute;
    left: -70px;
    bottom: -50px;
    max-width: 230px; }

.client-images img {
  max-height: 45px;
  width: auto;
  margin: 12px auto;
  transition: all .4s; }

.plan-box {
  max-width: 356px;
  margin-left: auto;
  margin-right: auto; }

.process-card {
  position: relative; }
  .process-card .process-arrow-img {
    position: absolute;
    left: 75%;
    top: 7%;
    width: 50%;
    opacity: .1; }

.custom-footer {
  color: #9ba7b3; }

.footer-list li a {
  color: #9ba7b3;
  padding: 7px 0;
  display: block;
  transition: all 0.3s ease-in-out; }
  .footer-list li a:hover {
    color: rgba(255, 255, 255, 0.9); }

.footer-social-link .avatar-title {
  color: #778089;
  background-color: rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease; }
  .footer-social-link .avatar-title:hover {
    color: #fff;
    background-color: #F26430; }

#back-to-top.landing-back-top {
  bottom: 35px; }

[data-layout-mode="dark"] .layout-wrapper.landing .demo-img-patten-top,
[data-layout-mode="dark"] .layout-wrapper.landing .demo-img-patten-bottom {
  opacity: .2; }

[data-layout-mode="dark"] .layout-wrapper.landing footer.bg-dark {
  background-color: var(--vz-card-bg-custom) !important; }

[data-layout-mode="dark"] .navbar-light.is-sticky .navbar-brand .card-logo-dark {
  display: none; }

[data-layout-mode="dark"] .navbar-light.is-sticky .navbar-brand .card-logo-light {
  display: block; }

.bookmark-icon .btn {
  color: #878a99;
  background-color: var(--vz-light);
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  font-size: 0.8125rem; }
  .bookmark-icon .btn:hover, .bookmark-icon .btn.active {
    border-color: transparent;
    color: #f06548; }

.explore-box {
  border-radius: 9px;
  overflow: hidden; }
  .explore-box .explore-img {
    height: 280px;
    object-fit: cover; }
  .explore-box .explore-place-bid-img {
    position: relative;
    overflow: hidden;
    z-index: 0; }
    .explore-box .explore-place-bid-img .bg-overlay {
      position: absolute;
      right: 0;
      left: 0;
      top: 0;
      bottom: 0;
      background-color: rgba(33, 37, 41, 0.4);
      opacity: 0;
      transition: all 0.5s ease; }
    .explore-box .explore-place-bid-img .place-bid-btn {
      top: 50%;
      position: absolute;
      left: 50%;
      transform: translate(-50%, -50%); }
      .explore-box .explore-place-bid-img .place-bid-btn .btn {
        opacity: 0;
        bottom: -25px;
        transition: 0.5s ease; }
  .explore-box:hover .explore-place-bid-img .place-bid-btn .btn {
    opacity: 1;
    bottom: 0; }
  .explore-box:hover .explore-place-bid-img .bg-overlay {
    opacity: 1; }
  .explore-box .discount-time {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    text-align: center;
    background-color: rgba(255, 255, 255, 0.4);
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
    padding: 8px; }

.nft-hero {
  background-size: cover;
  background-position: bottom;
  padding: 222px 0 150px 0; }
  .nft-hero .bg-overlay {
    background-color: #05175f;
    opacity: 0.85; }

#explorecard-list .list-element {
  display: none; }
  #explorecard-list .list-element:nth-child(-n+10) {
    display: block; }

.file-manager-menu {
  max-height: calc(100vh - 296px); }
  @media (max-width: 991.98px) {
    .file-manager-menu {
      height: calc(100vh - 296px); } }
  .file-manager-menu li {
    padding: 5px 0px; }
    .file-manager-menu li a {
      color: var(--vz-dark);
      font-weight: 500;
      transition: all 0.5s ease; }
      .file-manager-menu li a.active, .file-manager-menu li a:hover, .file-manager-menu li a[aria-expanded="true"] {
        color: #0ab39c; }
    .file-manager-menu li .sub-menu li {
      padding-left: 25px;
      position: relative; }
      .file-manager-menu li .sub-menu li::before {
        content: "\\f0374";
        position: absolute;
        left: 0px;
        font-family: Material Design Icons;
        color: rgba(var(--vz-dark-rgb), 0.4); }

.file-manager-sidebar {
  position: relative;
  background-color: var(--vz-card-bg-custom); }
  @media (min-width: 992px) {
    .file-manager-sidebar {
      min-width: 300px;
      max-width: 300px;
      height: calc(100vh - 70px - 60px - 8px); } }
  @media (max-width: 991.98px) {
    .file-manager-sidebar {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      width: 200px;
      max-width: 100%;
      z-index: 1003;
      box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
      transform: translateX(-100%);
      visibility: hidden;
      height: 100vh; }
      .file-manager-sidebar.menubar-show {
        visibility: visible;
        transform: none; } }

.file-menu-sidebar-scroll {
  height: calc(100vh - 375px); }
  @media (max-width: 991.98px) {
    .file-menu-sidebar-scroll {
      height: calc(100vh - 190px); } }

.file-manager-content {
  background-color: var(--vz-card-bg-custom); }

.file-manager-content-scroll {
  height: calc(100vh - 185px);
  overflow-y: auto; }
  .file-manager-content-scroll::-webkit-scrollbar {
    -webkit-appearance: none; }
  .file-manager-content-scroll::-webkit-scrollbar:vertical {
    width: 12px; }
  .file-manager-content-scroll::-webkit-scrollbar:horizontal {
    height: 12px; }
  .file-manager-content-scroll::-webkit-scrollbar-thumb {
    background-color: rgba(var(--vz-dark-rgb), 0.075);
    border-radius: 10px;
    border: 2px solid var(--vz-card-bg-custom); }
  .file-manager-content-scroll::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: var(--vz-card-bg-custom); }
  @media (max-width: 991.98px) {
    .file-manager-content-scroll {
      height: calc(100vh - 144px); } }
  .file-manager-content-scroll .simplebar-content {
    height: 100%; }

.file-detail-content-scroll {
  height: calc(100vh - 180px); }
  @media (max-width: 991.98px) {
    .file-detail-content-scroll {
      height: 100vh; } }
  .file-detail-content-scroll .simplebar-content {
    height: 100%; }

.file-manager-detail-content {
  width: 32%;
  max-width: 100%;
  background-color: var(--vz-card-bg-custom);
  display: none; }

.file-detail-show .file-manager-detail-content {
  display: block; }

#file-overview {
  display: none; }

@media (max-width: 1399.98px) {
  .file-manager-detail-content {
    position: fixed;
    top: 0;
    bottom: 0;
    left: auto;
    right: 0;
    width: 400px;
    max-width: 100%;
    z-index: 1003;
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    transform: translateX(100%); }
  .file-detail-show .file-manager-detail-content {
    transform: none; } }

.file-details-box {
  height: 195px;
  display: flex;
  justify-content: center;
  align-items: center; }

.to-do-menu li .nav-link {
  color: var(--vz-body-color);
  padding-left: 0;
  font-weight: 500;
  background-color: var(--vz-light);
  padding: 10px 12px;
  border-radius: 4px;
  display: block;
  margin-bottom: 8px; }
  .to-do-menu li .nav-link:hover, .to-do-menu li .nav-link.active {
    color: #0ab39c; }

.todo-content {
  height: calc(100vh - 362px);
  overflow-y: auto; }
  .todo-content::-webkit-scrollbar {
    -webkit-appearance: none; }
  .todo-content::-webkit-scrollbar:vertical {
    width: 8px; }
  .todo-content::-webkit-scrollbar:horizontal {
    height: 10px; }
  .todo-content::-webkit-scrollbar-thumb {
    background-color: rgba(var(--vz-dark-rgb), 0.075);
    border-radius: 8px; }
  .todo-content::-webkit-scrollbar-track {
    border-radius: 8px; }

.todo-task table .form-check .form-check-input:checked + .form-check-label {
  text-decoration: line-through; }

.task-handle {
  cursor: move; }

#task-error-msg {
  display: none; }

.bg-job {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_78___});
  background-size: cover;
  background-position: center; }

.job-list-view-card .background {
  height: 130px; }

@media (min-width: 1400px) and (max-width: 1499.98px) {
  .job-list-row.row .col-xxl-3 {
    width: 33%; } }

.custom-container {
  width: 90%; }

.job-navbar .dropdown-menu .dropdown-item .avatar-sm {
  height: 2.5rem;
  width: 2.5rem; }

@media (max-width: 991.98px) {
  .job-navbar {
    background-color: var(--vz-card-bg-custom);
    padding: 16px 0; } }

.job-hero-section {
  position: relative;
  padding: 165px 0;
  overflow-x: hidden; }

.job-panel-filter {
  background-color: var(--vz-card-bg-custom);
  border-radius: 0.25rem;
  overflow: hidden; }
  .job-panel-filter .form-control {
    height: 45px;
    border: none;
    border-radius: 0;
    background-color: transparent; }
  .job-panel-filter .btn {
    border-radius: 0; }
  .job-panel-filter input.form-control {
    border-right: 1px solid var(--vz-border-color); }
  @media (max-width: 767.98px) {
    .job-panel-filter {
      background-color: transparent; }
      .job-panel-filter .form-control {
        background-color: #fff;
        border-radius: 0.25rem; }
      .job-panel-filter input.form-control {
        border: 0; }
      .job-panel-filter .btn {
        border-radius: 0.25rem; } }

.circle-effect {
  position: absolute;
  top: 0;
  z-index: 0;
  right: -55px;
  margin: 0 auto; }
  .circle-effect .circle {
    border: 1px solid var(--vz-border-color);
    height: 240px;
    width: 240px;
    margin: 0 auto;
    border-radius: 50%; }
  .circle-effect .circle2 {
    position: absolute;
    top: -20px;
    right: -20px;
    border: 1px solid var(--vz-border-color);
    height: 280px;
    width: 280px;
    margin: 0 auto;
    border-radius: 50%; }
  .circle-effect .circle3 {
    position: absolute;
    top: -40px;
    right: -40px;
    border: 1px solid var(--vz-border-color);
    height: 320px;
    width: 320px;
    margin: 0 auto;
    border-radius: 50%; }
  .circle-effect .circle4 {
    position: absolute;
    top: -60px;
    right: -60px;
    border: 1px solid var(--vz-border-color);
    height: 360px;
    width: 360px;
    margin: 0 auto;
    border-radius: 50%; }
  @media (max-width: 991.98px) {
    .circle-effect {
      display: none; } }

.home-img .user-img {
  position: relative;
  z-index: 1; }

.application-box,
.feedback-box,
.inquiry-box {
  max-width: 240px;
  position: absolute;
  z-index: 2;
  transition: all 0.5s ease; }
  .application-box:hover,
  .feedback-box:hover,
  .inquiry-box:hover {
    transform: translateY(-5px); }

.inquiry-box {
  left: -134px;
  top: 90px; }
  @media (max-width: 991.98px) {
    .inquiry-box {
      left: 0; } }

.application-box {
  bottom: 50px;
  right: -160px; }
  @media (max-width: 991.98px) {
    .application-box {
      right: 0; } }

.feedback-box {
  right: -50px;
  bottom: -54px; }
  @media (max-width: 576.98px) {
    .feedback-box {
      right: 0;
      bottom: 0; } }

.job-icon-effect {
  height: 30px;
  width: 30px;
  position: absolute;
  top: 0px;
  left: -2%;
  border-radius: 50%;
  background: repeating-linear-gradient(-55deg, rgba(255, 255, 255, 0) 0.8px, #0ab39c 1.6px, #0ab39c 2px, rgba(255, 255, 255, 0) 3.8px, rgba(255, 255, 255, 0) 5px);
  z-index: 0;
  opacity: 0.20; }
  .job-icon-effect span {
    position: relative;
    z-index: 1; }

.about-img-section {
  position: relative; }
  .about-img-section::before {
    content: "";
    position: absolute;
    left: 20px;
    right: -20px;
    top: -20px;
    bottom: 20px;
    border: 1px solid #299cdb;
    z-index: 0;
    border-radius: 0.25rem; }
    @media (max-width: 576.98px) {
      .about-img-section::before {
        right: 20px;
        top: 20px; } }

.features-company-widgets {
  position: absolute;
  bottom: -18px;
  right: -35px; }

/*
Template Name: Velzon - Admin & Dashboard Template
Author: Themesbrand
Website: https://themesbrand.com/
Contact: support@themesbrand.com
File: Custom Css File
*/
.css-b62m3t-container .css-13cymwt-control {
  background-color: #fff;
  /* input bg */
  border-color: var(--vz-border-color); }
  .css-b62m3t-container .css-13cymwt-control:hover {
    border-color: var(--vz-border-color); }

.css-b62m3t-container .css-t3ipsp-control {
  background-color: var(--vz-gray-200);
  border-color: var(--vz-border-color);
  box-shadow: none; }
  .css-b62m3t-container .css-t3ipsp-control:hover {
    border-color: var(--vz-border-color) !important; }

.css-b62m3t-container .css-1nmdiq5-menu {
  background-color: var(--vz-gray-200); }
  .css-b62m3t-container .css-1nmdiq5-menu .css-10wo9uf-option {
    cursor: pointer;
    background-color: var(--vz-gray-200); }
    .css-b62m3t-container .css-1nmdiq5-menu .css-10wo9uf-option:active {
      background-color: var(--vz-gray-200); }
  .css-b62m3t-container .css-1nmdiq5-menu .css-d7l1ni-option {
    cursor: pointer;
    background-color: var(--vz-gray-100); }

.css-b62m3t-container .css-1p3m7a8-multiValue {
  background-color: var(--vz-light); }

.css-b62m3t-container .css-wsp0cs-MultiValueGeneric {
  color: var(--vz-heading-color); }

.css-b62m3t-container .css-12jo7m5 {
  color: var(--vz-heading-color); }

.css-b62m3t-container .css-6j8wv5-Input,
.css-b62m3t-container .css-qc6sy-singleValue {
  color: var(--vz-heading-color); }

.css-b62m3t-container .css-1dimb5e-singleValue {
  color: var(--vz-body-color); }

.marketplace-swiper .swiper-button-next,
.marketplace-swiper .swiper-button-prev {
  top: 24px; }

.marquee {
  width: 100%;
  overflow: hidden;
  position: relative;
  height: 22px;
  line-height: 2; }

.marquee div {
  display: block;
  width: 200%;
  height: 30px;
  position: absolute;
  overflow: hidden;
  animation: marquee 35s linear infinite; }

.marquee span {
  float: left;
  width: 50%; }

@keyframes marquee {
  0% {
    left: 0; }
  100% {
    left: -100%; } }

.kVrXuC,
.dwPlXY,
.gKbhqU,
.iSAVrt {
  background-color: transparent !important;
  color: var(--vz-body-color) !important; }

.fyrdjl {
  color: rgba(var(--vz-body-color-rgb), 0.54) !important;
  fill: rgba(var(--vz-body-color-rgb), 0.54) !important; }

.fyrdjl:disabled {
  color: rgba(var(--vz-body-color-rgb), 0.18) !important;
  fill: rgba(var(--vz-body-color-rgb), 0.18) !important; }

.iSAVrt {
  background-color: var(--vz-card-bg-custom) !important;
  border-bottom-color: var(--vz-border-color) !important; }

.dwPlXY:not(:last-of-type) {
  border-bottom-color: var(--vz-border-color) !important; }

* {
  font-family: "Inter", sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
  font-variation-settings: "slnt" 0; }

.offcanvas-header-dark .btn-close {
  filter: invert(1) grayscale(100%) brightness(200%); }

body * {
  outline: none;
  margin: 0; }

.noUi-horizontal .noUi-handle {
  height: 16px !important;
  width: 16px !important;
  border-radius: 50% !important;
  right: -10px !important;
  top: -7px !important; }

.noUi-connect,
.noUi-horizontal {
  height: 2px !important; }

.noUi-handle {
  background: #0ab39c !important;
  border: 2px solid var(--vz-card-bg) !important;
  box-shadow: none !important; }

.noUi-target {
  background: #fafafa !important;
  border-radius: 4px !important;
  border: 1px solid #d3d3d3 !important;
  background-color: var(--vz-light) !important;
  border-color: var(--vz-light) !important;
  box-shadow: none !important;
  height: 4px !important; }

.dropzone .dz-message {
  text-align: center; }

.fc-direction-ltr .fc-daygrid-event.fc-event-end,
.fc-direction-rtl .fc-daygrid-event.fc-event-start {
  padding: 5px !important;
  font-size: 12px !important;
  margin-right: 2px; }

.fc-event {
  border: none !important; }

@media (max-width: 575.98px) {
  .fc-toolbar {
    display: block !important;
    text-align: center; }
    .fc-toolbar .fc-left,
    .fc-toolbar .fc-right,
    .fc-toolbar .fc-center {
      float: none;
      display: block;
      clear: both;
      margin: 10px 0; }
  .fc .fc-toolbar > * > * {
    float: none; }
  .fc-today-button {
    display: none; } }

.flatpickr-calendar.open {
  z-index: 1090 !important; }

.upcoming-scheduled .flatpickr-input[readonly] {
  display: none; }

.ql-container.ql-snow {
  height: 250px; }

.rangeslider-horizontal .rangeslider__fill {
  background-color: #405189 !important; }

.simplebar-track-primary .simplebar-scrollbar:before {
  background: #F26430 !important; }

.simplebar-track-secondary .simplebar-scrollbar:before {
  background: #208C3B !important; }

.simplebar-track-success .simplebar-scrollbar:before {
  background: #0ab39c !important; }

.simplebar-track-info .simplebar-scrollbar:before {
  background: #299cdb !important; }

.simplebar-track-warning .simplebar-scrollbar:before {
  background: #3FBF48 !important; }

.simplebar-track-danger .simplebar-scrollbar:before {
  background: #f06548 !important; }

.simplebar-track-light .simplebar-scrollbar:before {
  background: #f3f6f9 !important; }

.simplebar-track-dark .simplebar-scrollbar:before {
  background: #212529 !important; }

.chat-conversation .chat-list .message-box-drop .nav-btn {
  font-size: 18px;
  padding: 4px;
  color: #878a99; }

.chatwidgets {
  height: 250px !important; }

[data-layout="horizontal"] .chat-conversation.chatwidgets {
  height: 250px !important; }

#tsparticles canvas {
  position: absolute !important; }

.alert-msg-show {
  right: 24px;
  top: 40px;
  z-index: 1005; }

.pickerEmoji {
  position: absolute;
  bottom: -50px;
  left: 10%;
  transform: translateX(-50%); }

.Toastify .Toastify__toast {
  min-height: 43px; }

.Toastify .Toastify__close-button {
  top: 6px; }

.Toastify .Toastify__close-button--light {
  color: #f3f6f9; }

.rdl-filter,
.rdl-control {
  background-color: var(--vz-input-bg);
  border: 1px solid var(--vz-input-border) !important;
  color: var(--vz-body-color) !important; }

.rdl-move {
  background: var(--vz-light) !important;
  border: 1px solid var(--vz-light) !important;
  color: var(--vz-body-color) !important; }

.react-dual-listbox input:disabled,
.react-dual-listbox select:disabled {
  background-color: var(--vz-input-disabled-bg) !important;
  border: 1px solid var(--vz-input-border) !important; }

.css-26l3qy-menu {
  background-color: var(--vz-gray-200) !important;
  border-color: var(--vz-border-color) !important; }

.css-1n7v3ny-option {
  background-color: var(--vz-gray-300) !important;
  border-color: var(--vz-border-color) !important; }

/* 
.ant-picker-dropdown .ant-picker-panel-container .ant-picker-panels {
  display: inline-flex;
  animation: none;
  flex-wrap: nowrap;
  direction: ltr;

  @media (max-width: 768px) {
    display: inline-grid;
  }
} */
/* .ant-picker-dropdown {
  @media (max-width: 768px) {
    inset: 51.9333px auto auto 0px !important;
  }
}
 */
@media (max-width: 768px) {
  .ant-picker-dropdown .ant-picker-panel-container {
    max-width: 90vw !important;
    overflow: auto !important;
    /*   inset: 51.9333px auto auto 0px !important; */ } }

.card-footer {
  background-color: transparent !important; }

.gm-style iframe + div {
  border: none !important; }
`, "",{"version":3,"sources":["webpack://./src/assets/scss/themes.scss","webpack://./src/assets/scss/icons.scss","webpack://./src/assets/scss/plugins/icons/_materialdesignicons.scss","webpack://./src/assets/scss/plugins/icons/_boxicons.scss","webpack://./src/assets/scss/plugins/icons/_line-awesome.scss","webpack://./src/assets/scss/plugins/icons/_remixicon.scss","webpack://./src/assets/scss/config/default/bootstrap.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./src/assets/scss/config/default/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/_functions.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/assets/scss/config/default/app.scss","webpack://./src/assets/scss/fonts/_fonts.scss","webpack://./src/assets/scss/config/default/_theme-light.scss","webpack://./src/assets/scss/config/default/_theme-dark.scss","webpack://./src/assets/scss/structure/_topbar.scss","webpack://./src/assets/scss/structure/_page-head.scss","webpack://./src/assets/scss/structure/_footer.scss","webpack://./src/assets/scss/structure/_vertical.scss","webpack://./src/assets/scss/structure/_horizontal.scss","webpack://./src/assets/scss/structure/_two-column.scss","webpack://./src/assets/scss/structure/_layouts.scss","webpack://./src/assets/scss/components/_waves.scss","webpack://./src/assets/scss/components/_avatar.scss","webpack://./src/assets/scss/components/_accordion.scss","webpack://./src/assets/scss/components/_helper.scss","webpack://./src/assets/scss/components/_preloader.scss","webpack://./src/assets/scss/components/_forms.scss","webpack://./src/assets/scss/components/_widgets.scss","webpack://./src/assets/scss/components/_demos.scss","webpack://./src/assets/scss/components/_print.scss","webpack://./src/assets/scss/components/_ribbons.scss","webpack://./src/assets/scss/components/_toast.scss","webpack://./src/assets/scss/components/_scrollspy.scss","webpack://./src/assets/scss/components/_reboot.scss","webpack://./src/assets/scss/components/_alerts.scss","webpack://./src/assets/scss/components/_backgrounds.scss","webpack://./src/assets/scss/components/_badge.scss","webpack://./src/assets/scss/components/_buttons.scss","webpack://./src/assets/scss/components/_breadcrumb.scss","webpack://./src/assets/scss/components/_card.scss","webpack://./src/assets/scss/components/_dropdown.scss","webpack://./src/assets/scss/components/_nav.scss","webpack://./src/assets/scss/components/_table.scss","webpack://./src/assets/scss/components/_modal.scss","webpack://./src/assets/scss/components/_pagination.scss","webpack://./src/assets/scss/components/_progress.scss","webpack://./src/assets/scss/components/_popover.scss","webpack://./src/assets/scss/components/_type.scss","webpack://./src/assets/scss/components/_form-check.scss","webpack://./src/assets/scss/components/_form-control.scss","webpack://./src/assets/scss/components/_list-group.scss","webpack://./src/assets/scss/plugins/_custom-scrollbar.scss","webpack://./src/assets/scss/plugins/_prismjs.scss","webpack://./src/assets/scss/plugins/_sweetalert2.scss","webpack://./src/assets/scss/plugins/_dropzone.scss","webpack://./src/assets/scss/plugins/_range-slider.scss","webpack://./src/assets/scss/plugins/_sortablejs.scss","webpack://./src/assets/scss/plugins/_tour.scss","webpack://./src/assets/scss/plugins/_swiper.scss","webpack://./src/assets/scss/plugins/_multijs.scss","webpack://./src/assets/scss/plugins/_colorpicker.scss","webpack://./src/assets/scss/plugins/_filepond.scss","webpack://./src/assets/scss/plugins/_form-input-spin.scss","webpack://./src/assets/scss/plugins/_ckeditor.scss","webpack://./src/assets/scss/plugins/_quilljs.scss","webpack://./src/assets/scss/plugins/_gridjs.scss","webpack://./src/assets/scss/plugins/_listjs.scss","webpack://./src/assets/scss/plugins/_apexcharts.scss","webpack://./src/assets/scss/plugins/_chartjs.scss","webpack://./src/assets/scss/plugins/_echarts.scss","webpack://./src/assets/scss/plugins/_google-map.scss","webpack://./src/assets/scss/plugins/_autocomplete.scss","webpack://./src/assets/scss/plugins/_vector-maps.scss","webpack://./src/assets/scss/plugins/_leaflet-maps.scss","webpack://./src/assets/scss/plugins/_fullcalendar.scss","webpack://./src/assets/scss/plugins/_emoji-picker.scss","webpack://./src/assets/scss/plugins/_datatables.scss","webpack://./src/assets/scss/plugins/_select2.scss","webpack://./src/assets/scss/plugins/_toastify.scss","webpack://./src/assets/scss/plugins/_choices.scss","webpack://./src/assets/scss/plugins/_flatpicker.scss","webpack://./src/assets/scss/plugins/_flag-input.scss","webpack://./src/assets/scss/pages/_authentication.scss","webpack://./src/assets/scss/pages/_dashboard.scss","webpack://./src/assets/scss/pages/_timeline.scss","webpack://./src/assets/scss/pages/_gallery.scss","webpack://./src/assets/scss/pages/_errors.scss","webpack://./src/assets/scss/pages/_profile.scss","webpack://./src/assets/scss/pages/_sitemap.scss","webpack://./src/assets/scss/pages/_team.scss","webpack://./src/assets/scss/pages/_coming-soon.scss","webpack://./src/assets/scss/pages/_search-results.scss","webpack://./src/assets/scss/pages/_ecommerce.scss","webpack://./src/assets/scss/pages/_invoice.scss","webpack://./src/assets/scss/pages/_chat.scss","webpack://./src/assets/scss/pages/_email.scss","webpack://./src/assets/scss/pages/_kanban.scss","webpack://./src/assets/scss/pages/_landing.scss","webpack://./src/assets/scss/pages/_nft-landing.scss","webpack://./src/assets/scss/pages/_file-manager.scss","webpack://./src/assets/scss/pages/_to-do.scss","webpack://./src/assets/scss/pages/_jobs.scss","webpack://./src/assets/scss/pages/_job-landing.scss","webpack://./src/assets/scss/config/default/custom.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;;;CDQC;AERD,4BAAA;AACA;EACE,oCAAoC;EACpC,4CAAmE;EACnE,qPAA2V;EAC3V,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;;EAEE,qBAAqB;EACrB,yDAAyD;EACzD,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC,EAAA;;AAGpC;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,eAAe,EAAA;;AAGjB;EACE,eAAe,EAAA;;AAGjB;EACE,eAAe,EAAA;;AAGjB;EACE,eAAe,EAAA;;AAGjB;EACE,0BAA0B,EAAA;;AAG5B;EACE,0BAA0B,EAAA;;AAG5B;EACE,YAAY,EAAA;;AAGd;EACE,+BAA+B,EAAA;;AAGjC;EACE;;;;;;;;;;;;;;;SFl7MO,EEi8MC;;AAGV;EAGE,wBAAwB,EAAA;;AAG1B;EACE;;;;;;;;;;;;;;;SFp7MO,EEm8MC;;AAGV;EAGE,wBAAwB,EAAA;;AAG1B;EACE;;;;;;;;;;;;;;;SFt7MO,EEq8MC;;AAGV;EAGE,yBAAyB,EAAA;;AAG3B;EACE;;;;;;;;;;;;;;;SFx7MO,EEu8MC;;AAGV;EAGE,yBAAyB,EAAA;;AAG3B;EACE;;;;;;;;;;;;;;;SF17MO,EEy8MC;;AAGV;EAGE,yBAAyB,EAAA;;AAG3B;EACE;;;;;;;;;;;;;;;SF57MO,EE28MC;;AAGV;EAGE,yBAAyB,EAAA;;AAG3B;EACE;;;;;;;;;;;;;;;SF97MO,EE68MC;;AAGV;EAGE,yBAAyB,EAAA;;AAG3B;EAEE,qBAAqB;EACrB,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EAEE,qBAAqB;EACrB,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EAEE,sCAAsC,EAAA;;AAcxC;EACE;IAEE,uBAAuB,EAAA;EAEzB;IAEE,yBAAyB,EAAA,EAAA;;AAI7B,kDAAA;AC3h0BA;EAEI,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAElB,4CAAuC;EACvC,4SAI0D,EAAA;;AAE9D;EAEI,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EAErB,oBAAoB;EAEpB,WAAW;EACX,mCAAmC;EACnC,kCAAkC,EAAA;;AAEtC;EAEI,gBAAgB;EAChB,eAAe;EAEf,gBAAgB,EAAA;;AAEpB;EAEI,kBAAkB,EAAA;;AAEtB;EAEI,kBAAkB;EAClB,oBAAoB;EAEpB,kBAAkB;EAClB,UAAU;EAEV,UAAU;EAEV,kBAAkB,EAAA;;AAetB;EAEI;IAGY,oBAAoB,EAAA;EAEhC;IAGY,yBAAyB,EAAA,EAAA;;AAoBzC;EAEI;IAGY,mBAAmB;IAE3B,UAAU,EAAA;EAEd;IAGY,qBAAqB;IAE7B,UAAU,EAAA,EAAA;;AAkBlB;EAEI;IAEI,UAAU,EAAA;EAEd;IAEI,UAAU,EAAA;EAEd;IAEI,UAAU,EAAA,EAAA;;AAoBlB;EAEI;IAGY,wBAAwB;IAEhC,UAAU,EAAA;EAEd;IAGY,4BAA4B;IAEpC,UAAU,EAAA,EAAA;;AAoBlB;EAEI;IAGY,wBAAwB;IAEhC,UAAU,EAAA;EAEd;IAGY,2BAA2B;IAEnC,UAAU,EAAA,EAAA;;AAoBlB;EAEI;IAGY,wBAAwB;IAEhC,UAAU,EAAA;EAEd;IAGY,4BAA4B;IAEpC,UAAU,EAAA,EAAA;;AAoBlB;EAEI;IAGY,wBAAwB;IAEhC,UAAU,EAAA;EAEd;IAGY,2BAA2B;IAEnC,UAAU,EAAA,EAAA;;AA0ClB;EAEI;IAGY,2BAA2B,EAAA;EAGvC;;IAIY,8DAA2D,EAAA;EAGvE;;;;IAMY,oDAAoD,EAAA;EAGhE;;;IAKY,oCAAoC,EAAA;EAGhD;IAGY,2BAA2B,EAAA,EAAA;;AAG3C;EAGY,kCAAkC,EAAA;;AAE9C;EAGY,kCAAkC,EAAA;;AAG9C;EAGY,kCAAkC,EAAA;;AAE9C;EAGY,kCAAkC,EAAA;;AAG9C;EAGY,wCAAwC,EAAA;;AAEpD;EAGY,wCAAwC,EAAA;;AAGpD;EAGY,qCAAqC,EAAA;;AAEjD;EAGY,qCAAqC,EAAA;;AAEjD;EAGY,uCAAuC,EAAA;;AAEnD;EAGY,uCAAuC,EAAA;;AAEnD;EAGY,yCAAyC,EAAA;;AAErD;EAGY,yCAAyC,EAAA;;AAErD;EAGY,yCAAyC,EAAA;;AAErD;EAGY,yCAAyC,EAAA;;AAErD;EAGY,0CAA0C,EAAA;;AAEtD;EAGY,0CAA0C,EAAA;;AAEtD;EAEI,0BAAyB,EAAA;;AAE7B;EAEI,6BAA4B,EAAA;;AAEhC;EAEI,6BAA4B,EAAA;;AAEhC;EAEI,0BAA2B,EAAA;;AAE/B;EAEI,yBAAyB;EACzB,iBAAiB;EAEjB,qBAAqB;EACrB,YAAY;EACZ,6BAA2B;EAE3B,sBAAsB,EAAA;;AAE1B;EAEI,WAAW;EAEX,8BAA4B,EAAA;;AAEhC;EAEI,YAAY;EAEZ,6BAA2B,EAAA;;AAE/B;EAEI,wBAAwB;EAExB,sEAAsE,EAAA;;AAE1E;EAEI,yBAAyB;EAEzB,sEAAsE,EAAA;;AAE1E;EAEI,yBAAyB;EAEzB,sEAAsE,EAAA;;AAE1E;EAEI,qBAAqB;EAErB,gFAAgF,EAAA;;AAEpF;EAEI,qBAAqB;EAErB,gFAAgF,EAAA;;AAEpF;EAEI,cAAc;EAEd,uCAAkC;EAClC,oBAAoB,EAAA;;AAExB;EAEI,cAAc;EAEd,uCAAkC;EAClC,kBAAkB,EAAA;;AAIpB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;ACzoKpB;;;;;;EAME,kCAAkC;EAClC,mCAAmC;EACnC,qBAAqB;EACrB,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc,EAAA;;AAEhB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB,EAAA;;AAE1B;EACE,gBAAgB,EAAA;;AAElB;EACE,iBAAiB,EAAA;;AAEnB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,eAAe,EAAA;;AAEjB;EACE,kBAAkB;EAClB,aAAa,EAAA;;AAEf;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe,EAAA;;AACf;EACE,kBAAkB,EAAA;;AAEtB;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,oBAAoB,EAAA;;AAEtB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB,EAAA;;AAE3B;EACE,WAAW,EAAA;;AAEb;EACE,YAAY,EAAA;;AAEd;;;;;EAKE,kBAAkB,EAAA;;AAEpB;;;;;EAKE,iBAAiB,EAAA;;AAEnB;EAEU,qCAAqC,EAAA;;AAE/C;EAEU,uCAAuC,EAAA;;AAUjD;EACE;IAEU,uBAAuB,EAAA;EACjC;IAEU,yBAAyB,EAAA,EAAA;;AAErC;EACE,sEAAsE;EAE9D,wBAAwB,EAAA;;AAElC;EACE,sEAAsE;EAE9D,yBAAyB,EAAA;;AAEnC;EACE,sEAAsE;EAE9D,yBAAyB,EAAA;;AAEnC;EACE,gFAAgF;EAExE,uBAAuB,EAAA;;AAEjC;EACE,gFAAgF;EAExE,uBAAuB,EAAA;;AAEjC;EACE,gFAAgF;EAExE,wBAAwB,EAAA;;AAElC;;;;;;EAOU,YAAY,EAAA;;AAEtB;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY,EAAA;;AAEd;;EAEE,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,WAAW,EAAA;;AAEb;EACE,oBAAoB,EAAA;;AAEtB;EACE,cAAc,EAAA;;AAEhB;EACE,WAAW,EAAA;;AAEb;gEJshxBgE;AIphxBhE;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,UAAU,EAAA;;AAEZ;EACE,UAAU;EACV,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,WAAW,EAAA;;AACb;EACE,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,6CAA4C;EAC5C,iTAAkU,EAAA;;AAEpU;EACE,kCAAkC,EAAA;;AACpC;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,iTAAuU,EAAA;;AAEzU;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAClB;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6CAA2C;EAC3C,iTAA6T,EAAA;;AAE/T;;EAEE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;ACr7MlB;;;;;;;;;CLw99BC;AK989BD;EACE,wBAAwB;EACxB,6CAAwD;EAAE,OAAA;EAC1D,iTAI2E;EAAE,aAAA;EAC7E,kBAAkB,EAAA;;AL+89BpB;EK389BE,mCAAmC;EACnC,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC,EAAA;;AAGpC;EAAS,mBAAmB;EAAE,mBAAmB;EAAE,wBAAwB,EAAA;;AAC3E;EAAS,gBAAgB;EAAE,qBAAqB;EAAE,uBAAuB,EAAA;;AACzE;EAAU,eAAe,EAAA;;AACzB;EAAS,gBAAgB,EAAA;;AACzB;EAAS,iBAAkB,EAAA;;AAC3B;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAU,eAAe,EAAA;;AACzB;EAAS,kBAAkB;EAAE,aAAa,EAAA;;AAE1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAAiB,gBAAgB,EAAA;;AACjC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAqC,gBAAgB,EAAA;;AACrD;EAAqC,gBAAgB,EAAA;;AACrD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAqC,gBAAgB,EAAA;;AACrD;EAAqC,gBAAgB,EAAA;;AACrD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAsB,gBAAgB,EAAA;;AACtC;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAuC,gBAAgB,EAAA;;AACvD;EAAuC,gBAAgB,EAAA;;AACvD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAkB,gBAAgB,EAAA;;AAClC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAwC,gBAAgB,EAAA;;AACxD;EAAwC,gBAAgB,EAAA;;AACxD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwC,gBAAgB,EAAA;;AACxD;EAAwC,gBAAgB,EAAA;;AACxD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyC,gBAAgB,EAAA;;AACzD;EAAyC,gBAAgB,EAAA;;AACzD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA0C,gBAAgB,EAAA;;AAC1D;EAA0C,gBAAgB,EAAA;;AAC1D;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAuC,gBAAgB,EAAA;;AACvD;EAAuC,gBAAgB,EAAA;;AACvD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAAwC,gBAAgB,EAAA;;AACxD;EAAwC,gBAAgB,EAAA;;AACxD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAqC,gBAAgB,EAAA;;AACrD;EAAqC,gBAAgB,EAAA;;AACrD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA0B,gBAAgB,EAAA;;AAC1C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAyB,gBAAgB,EAAA;;AACzC;EAAsB,gBAAgB,EAAA;;AACtC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA2B,gBAAgB,EAAA;;AAC3C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA2B,gBAAgB,EAAA;;AAC3C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAuB,gBAAgB,EAAA;;AACvC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAyB,gBAAgB,EAAA;;AACzC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAyC,gBAAgB,EAAA;;AACzD;EAAyC,gBAAgB,EAAA;;AACzD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAyC,gBAAgB,EAAA;;AACzD;EAAyC,gBAAgB,EAAA;;AACzD;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAiB,gBAAgB,EAAA;;AACjC;EAAiB,gBAAgB,EAAA;;AACjC;EAAiB,gBAAgB,EAAA;;AACjC;EAAiB,gBAAgB,EAAA;;AACjC;EAAiB,gBAAgB,EAAA;;AACjC;EAAiB,gBAAgB,EAAA;;AACjC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAqB,gBAAgB,EAAA;;AACrC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuC,gBAAgB,EAAA;;AACvD;EAAuC,gBAAgB,EAAA;;AACvD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuC,gBAAgB,EAAA;;AACvD;EAAuC,gBAAgB,EAAA;;AACvD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAgC,gBAAgB,EAAA;;AAChD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAoB,gBAAgB,EAAA;;AACpC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAoB,gBAAgB,EAAA;;AACpC;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAkB,gBAAgB,EAAA;;AAClC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAuB,gBAAgB,EAAA;;AACvC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAuB,gBAAgB,EAAA;;AACvC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAoC,gBAAgB,EAAA;;AACpD;EAAkC,gBAAgB,EAAA;;AAClD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAsB,gBAAgB,EAAA;;AACtC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAqC,gBAAgB,EAAA;;AACrD;EAAqC,gBAAgB,EAAA;;AACrD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAuB,gBAAgB,EAAA;;AACvC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAqC,gBAAgB,EAAA;;AACrD;EAAqC,gBAAgB,EAAA;;AACrD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAmB,gBAAgB,EAAA;;AACnC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAgC,gBAAgB,EAAA;;AAChD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuC,gBAAgB,EAAA;;AACvD;EAAuC,gBAAgB,EAAA;;AACvD;EAA0C,gBAAgB,EAAA;;AAC1D;EAA0C,gBAAgB,EAAA;;AAC1D;EAAqC,gBAAgB,EAAA;;AACrD;EAAqC,gBAAgB,EAAA;;AACrD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAwB,gBAAgB,EAAA;;AACxC;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAwB,gBAAgB,EAAA;;AACxC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAyB,gBAAgB,EAAA;;AACzC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAuB,gBAAgB,EAAA;;AACvC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAmB,gBAAgB,EAAA;;AACnC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAoC,gBAAgB,EAAA;;AACpD;EAAkC,gBAAgB,EAAA;;AAClD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAsB,gBAAgB,EAAA;;AACtC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAsB,gBAAgB,EAAA;;AACtC;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAqB,gBAAgB,EAAA;;AACrC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAuB,gBAAgB,EAAA;;AACvC;EAAkB,gBAAgB,EAAA;;AAClC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAwB,gBAAgB,EAAA;;AACxC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAqC,gBAAgB,EAAA;;AACrD;EAAqC,gBAAgB,EAAA;;AACrD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AC3wEtC;;;;;;;CNgsrCC;AO/rrCC;;;;;IPqsrCE;AQtsrCJ;EAQI,kBAAwB;EAAxB,oBAAwB;EAAxB,oBAAwB;EAAxB,kBAAwB;EAAxB,iBAAwB;EAAxB,oBAAwB;EAAxB,oBAAwB;EAAxB,mBAAwB;EAAxB,kBAAwB;EAAxB,kBAAwB;EAAxB,gBAAwB;EAAxB,kBAAwB;EAAxB,uBAAwB;EAIxB,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAIlC,qBAAwB;EAAxB,uBAAwB;EAAxB,qBAAwB;EAAxB,kBAAwB;EAAxB,qBAAwB;EAAxB,oBAAwB;EAAxB,mBAAwB;EAAxB,kBAAwB;EAIxB,8BAAgC;EAAhC,+BAAgC;EAAhC,8BAAgC;EAAhC,2BAAgC;EAAhC,6BAAgC;EAAhC,6BAAgC;EAAhC,6BAAgC;EAAhC,yBAAgC;EAGlC,6BAAiC;EACjC,uBAAiC;EACjC,+BAA2C;EAC3C,+BAAqC;EAMrC,2CAA6C;EAC7C,yGAA2C;EAC3C,yFAA+B;EAO/B,gDAA+C;EC4P3C,8BAvE+B;EDnLnC,0BAA+C;EAC/C,0BAA+C;EAC/C,wBAAmC;EAInC,qBAA6B;EAI7B,sBAAuC;EACvC,wBAAuC;EACvC,yCAAuC;EACvC,mDAA+D;EAE/D,2BAAyC;EACzC,6BAA+C;EAC/C,6BAA+C;EAC/C,2BAA+C;EAC/C,4BAAiD;EACjD,8BAAmD;EAGnD,qCAAmC;EACnC,iDAA+C;EAE/C,wBAAmC;EAEnC,0BAAuC,EAAA;;AExDzC;;;EAGE,sBAAsB,EAAA;;AAepB;EFjCJ;IEkCM,uBAAuB,EAAA,EAG5B;;AAWD;EACE,SAAS;EACT,uCAAgE;EDmP5D,mCAvE+B;EC1KnC,uCAAgE;EAChE,uCAAgE;EAChE,2BAA8C;EAC9C,qCAA6D;EAC7D,mCAAmD;EACnD,8BAA8B;EAC9B,6CC0Ga,EAAA;;ADjGf;EACE,cAAsB;EACtB,cCksBmC;EDjsBnC,SAAS;EACT,qBAAkC;EAClC,aCssB+B,EAAA;;AD5rBjC;EACE,aAAa;EACb,qBCyoBwC;EDtoBxC,gBCyoB+B;EDxoB/B,gBCyoB+B,EAAA;;ADroBjC;ED6MQ,sCAf6B,EAAA;EAnJjC;IC3CJ;MDoNQ,qBAlF6B,EAAA,EC/HpC;;AAED;EDwMQ,mCAf6B,EAAA;EAnJjC;ICtCJ;MD+MQ,mBAlF6B,EAAA,EC1HpC;;AAED;EDmMQ,uCAf6B,EAAA;EAnJjC;ICjCJ;MD0MQ,qBAlF6B,EAAA,ECrHpC;;AAED;ED0LM,qBAvE+B,EAAA;;AC9GrC;EDyLQ,qBAf6B,EAAA;EAnJjC;ICvBJ;MDgMQ,qBAlF6B,EAAA,EC3GpC;;AAED;EDgLM,oBAvE+B,EAAA;;AC9FrC;EACE,aAAa;EACb,mBCmb8B,EAAA;;ADzahC;EACE,yCAAiC;UAAjC,iCAAiC;EACjC,YAAY;EACZ,8BAA8B,EAAA;;AAMhC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB,EAAA;;AAMtB;;EAEE,kBAAkB,EAAA;;AAGpB;;;EAGE,aAAa;EACb,mBAAmB,EAAA;;AAGrB;;;;EAIE,gBAAgB,EAAA;;AAGlB;EACE,gBC6gB+B,EAAA;;ADxgBjC;EACE,oBAAoB;EACpB,cAAc,EAAA;;AAMhB;EACE,gBAAgB,EAAA;;AAQlB;;EAEE,mBCufkC,EAAA;;AD/epC;EDmFM,kBAvE+B,EAAA;;ACLrC;EACE,cC0jBgC;EDzjBhC,wCAA6D,EAAA;;AAS/D;;EAEE,kBAAkB;ED+Dd,iBAvE+B;ECUnC,cAAc;EACd,wBAAwB,EAAA;;AAG1B;EAAM,cAAc,EAAA;;AACpB;EAAM,UAAU,EAAA;;AAKhB;EACE,2BAA8C;EAC9C,0BCqTiD,EAAA;EDvTnD;IAKI,iCAA0D,EAAA;;AAU9D;EAGI,cAAc;EACd,qBAAqB,EAAA;;AAOzB;;;;EAIE,qCCma2E;EF9YvE,cAvE+B,EAAA;;AC0DrC;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,cAAc;EDSV,kBAvE+B,EAAA;EC0DrC;IDaM,kBAvE+B;ICqEjC,cAAc;IACd,kBAAkB,EAAA;;AAItB;EDHM,kBAvE+B;EC4EnC,2BAA8C;EAC9C,qBAAqB,EAAA;EAGrB;IACE,cAAc,EAAA;;AAIlB;EACE,sBC66CuC;EF57CnC,kBAvE+B;ECwFnC,WC5Ja;ED6Jb,yBCpJgB;EChJd,qBD4mB+B,EAAA;ED5UnC;IAQI,UAAU;IDtBR,cAvE+B;IC+FjC,gBCmY6B,EAAA;;AD1XjC;EACE,gBAAgB,EAAA;;AAMlB;;EAEE,sBAAsB,EAAA;;AAQxB;EACE,oBAAoB;EACpB,yBAAyB,EAAA;;AAG3B;EACE,oBCsckC;EDrclC,uBCqckC;EDpclC,cC/LgB;EDgMhB,gBAAgB,EAAA;;AAOlB;EAEE,mBAAmB;EACnB,gCAAgC,EAAA;;AAGlC;;;;;;EAME,qBAAqB;EACrB,mBAAmB;EACnB,eAAe,EAAA;;AAQjB;EACE,qBAAqB,EAAA;;AAMvB;EAEE,gBAAgB,EAAA;;AAQlB;EACE,UAAU,EAAA;;AAKZ;;;;;EAKE,SAAS;EACT,oBAAoB;EDrHhB,kBAvE+B;EC8LnC,oBAAoB,EAAA;;AAItB;;EAEE,oBAAoB,EAAA;;AV4krCtB;EUtkrCE,eAAe,EAAA;;AAGjB;EAGE,iBAAiB,EAAA;EAHnB;IAOI,UAAU,EAAA;;AVokrCd;EU5jrCE,wBAAwB,EAAA;;AAQ1B;;;;EAIE,0BAA0B,EAAA;EAJ5B;;;;IAQM,eAAe,EAAA;;AAOrB;EACE,UAAU;EACV,kBAAkB,EAAA;;AAKpB;EACE,gBAAgB,EAAA;;AAUlB;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,SAAS,EAAA;;AAQX;EACE,WAAW;EACX,WAAW;EACX,UAAU;EACV,qBC6RiC;EFve3B,iCAf6B;EC4NnC,oBAAoB,EAAA;ED/WlB;ICwWJ;MD/LQ,iBAlF6B,EAAA,EC6RpC;EAZD;IAUI,WAAW,EAAA;;AAOf;;;;;;;EAOE,UAAU,EAAA;;AAGZ;EACE,YAAY,EAAA;;AV+hrCd;EUrhrCE,oBAAoB;EACpB,6BAA6B,EAAA;;AAQ/B;;;;;;;CVuhrCC;AU5grCD;EACE,wBAAwB,EAAA;;AAK1B;EACE,UAAU,EAAA;;AAOZ;EACE,aAAa;EACb,0BAA0B,EAAA;;AAK5B;EACE,qBAAqB,EAAA;;AAKvB;EACE,SAAS,EAAA;;AAOX;EACE,kBAAkB;EAClB,eAAe,EAAA;;AAQjB;EACE,wBAAwB,EAAA;;AVs/qC1B;EU7+qCE,wBAAwB,EAAA;;AGpkB1B;EJ6QQ,qBAf6B;EI5PnC,gBFytB+B,EAAA;EFhnB7B;II3GJ;MJoRQ,qBAlF6B,EAAA,EI/LpC;;AAIC;EJsQM,iCAf6B;EInPjC,gBF0sBqB;EEzsBrB,gBFyrB6B,EAAA;EF1lB7B;IIpGF;MJ6QM,eAlF6B,EAAA,EIrLlC;;AAND;EJsQM,iCAf6B;EInPjC,gBF0sBqB;EEzsBrB,gBFyrB6B,EAAA;EF1lB7B;IIpGF;MJ6QM,iBAlF6B,EAAA,EIrLlC;;AAND;EJsQM,iCAf6B;EInPjC,gBF0sBqB;EEzsBrB,gBFyrB6B,EAAA;EF1lB7B;IIpGF;MJ6QM,eAlF6B,EAAA,EIrLlC;;AAND;EJsQM,iCAf6B;EInPjC,gBF0sBqB;EEzsBrB,gBFyrB6B,EAAA;EF1lB7B;IIpGF;MJ6QM,iBAlF6B,EAAA,EIrLlC;;AAND;EJsQM,iCAf6B;EInPjC,gBF0sBqB;EEzsBrB,gBFyrB6B,EAAA;EF1lB7B;IIpGF;MJ6QM,eAlF6B,EAAA,EIrLlC;;AAND;EJsQM,iCAf6B;EInPjC,gBF0sBqB;EEzsBrB,gBFyrB6B,EAAA;EF1lB7B;IIpGF;MJ6QM,iBAlF6B,EAAA,EIrLlC;;AAkBH;ECvDE,eAAe;EACf,gBAAgB,EAAA;;AD2DlB;EC5DE,eAAe;EACf,gBAAgB,EAAA;;AD8DlB;EACE,qBAAqB,EAAA;EADvB;IAII,oBFitB+B,EAAA;;AEvsBnC;EJoNM,kBAvE+B;EI3InC,yBAAyB,EAAA;;AAI3B;EACE,mBF2aW;EF9NP,qBAvE+B,EAAA;EIvIrC;IAKI,gBAAgB,EAAA;;AAIpB;EACE,iBFkaW;EEjaX,mBFiaW;EF9NP,kBAvE+B;EI1HnC,cF4DgB,EAAA;EEhElB;IAOI,qBAAqB,EAAA;;AEhGzB;ECIE,eAAe;EAGf,YAAY,EAAA;;ADDd;EACE,gBJolDwC;EInlDxC,mCJolDmE;EInlDnE,wCJqlD6E;ECllD3E,sBD2mBgC;EKnnBlC,eAAe;EAGf,YAAY,EAAA;;ADcd;EAEE,qBAAqB,EAAA;;AAGvB;EACE,qBAA2B;EAC3B,cAAc,EAAA;;AAGhB;EN+PM,kBAvE+B;EMtLnC,cJwHgB,EAAA;;AM1JhB;;;;;;;ECHA,mBAA+B;EAC/B,gBAA+B;EAC/B,WAAW;EACX,4CAA6D;EAC7D,2CAA4D;EAC5D,kBAAkB;EAClB,iBAAiB,EAAA;;ACsDf;EF5CE;IACE,gBN8jBG,EAAA,EM7jBJ;;AE0CH;EF5CE;IACE,gBN+jBG,EAAA,EM9jBJ;;AE0CH;EF5CE;IACE,gBNgkBG,EAAA,EM/jBJ;;AE0CH;EF5CE;IACE,iBNikBI,EAAA,EMhkBL;;AE0CH;EF5CE;IACE,iBNkkBK,EAAA,EMjkBN;;AGhBL;ECAA,mBAA+B;EAC/B,gBAA+B;EAC/B,aAAa;EACb,eAAe;EAEf,yCAA0D;EAC1D,4CAA6D;EAC7D,2CAA4D,EAAA;EDP5D;ICgBA,cAAc;IACd,WAAW;IACX,eAAe;IACf,4CAA6D;IAC7D,2CAA4D;IAC5D,8BAA+C,EAAA;;AA+C3C;EACE,SAAY,EAAA;;AAGd;EApCJ,cAAc;EACd,WAAW,EAAA;;AAcX;EACE,cAAc;EACd,WZiCqD,EAAA;;AYnCvD;EACE,cAAc;EACd,UZiCqD,EAAA;;AYnCvD;EACE,cAAc;EACd,gBZiCqD,EAAA;;AYnCvD;EACE,cAAc;EACd,UZiCqD,EAAA;;AYnCvD;EACE,cAAc;EACd,UZiCqD,EAAA;;AYnCvD;EACE,cAAc;EACd,gBZiCqD,EAAA;;AYFnD;EAhDJ,cAAc;EACd,WAAW,EAAA;;AAqDH;EAhEN,cAAc;EACd,eAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,UAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,UAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,UAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,WAA0C,EAAA;;AAuElC;EAxDV,qBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,gBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,gBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,gBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAmExC;;EAEE,gBAA+B,EAAA;;AAGjC;;EAEE,gBAA+B,EAAA;;AAPjC;;EAEE,sBAA+B,EAAA;;AAGjC;;EAEE,sBAA+B,EAAA;;AAPjC;;EAEE,qBAA+B,EAAA;;AAGjC;;EAEE,qBAA+B,EAAA;;AAPjC;;EAEE,mBAA+B,EAAA;;AAGjC;;EAEE,mBAA+B,EAAA;;AAPjC;;EAEE,qBAA+B,EAAA;;AAGjC;;EAEE,qBAA+B,EAAA;;AAPjC;;EAEE,mBAA+B,EAAA;;AAGjC;;EAEE,mBAA+B,EAAA;;AF1DrC;EEUE;IACE,SAAY,EAAA;EAGd;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYFnD;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAY,EAAA;EAGd;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYFnD;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAY,EAAA;EAGd;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYFnD;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAY,EAAA;EAGd;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYFnD;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAY,EAAA;EAGd;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYFnD;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;ACtHT;EACE,sCAAqC;EACrC,0BAA+B;EAC/B,+CAAmD;EACnD,iCAA6C;EAC7C,8CAAqD;EACrD,qDAA+C;EAC/C,6CAAmD;EACnD,kDAA6C;EAC7C,4CAAiD;EACjD,iDAA2C;EAE3C,WAAW;EACX,mBXkfW;EWjfX,4BAAgD;EAChD,mBXqxB+B;EWpxB/B,0CAAqE,EAAA;EAhBvE;IAwBI,uBXwwB+B;IWvwB/B,oCAAqD;IACrD,wBXilB6B;IWhlB7B,wDAAgF,EAAA;EA3BpF;IA+BI,uBAAuB,EAAA;EA/B3B;IAmCI,sBAAsB,EAAA;;AAI1B;EACE,4CX8kBuE,EAAA;;AWvkBzE;EACE,iBAAiB,EAAA;;AAQnB;EAGI,uBXuuBgC,EAAA;;AWztBpC;EAEI,mBAAmC,EAAA;EAFvC;IAMM,mBX4hB2B,EAAA;;AWvhBjC;EAGI,sBAAsB,EAAA;;AAH1B;EAOI,mBAAmB,EAAA;;AASvB;EAEI,gDAA6C;EAC7C,oCAAgE,EAAA;;AAKpE;EAEI,gDAA6C;EAC7C,oCAAgE,EAAA;;AAQpE;EACE,+CAA6C;EAC7C,mCAA8D,EAAA;;AAOhE;EAEI,8CAA6C;EAC7C,kCAA4D,EAAA;;ACrI9D;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AD0IrE;EACE,gBAAgB;EAChB,iCAAiC,EAAA;;AHpFnC;EGkFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AHrFD;EGkFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AHrFD;EGkFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AHrFD;EGkFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AHrFD;EGkFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AE7JL;EACE,qBb86B2C,EAAA;;Aar6B7C;EACE,+BC2N8D;ED1N9D,kCC0N8D;EDzN9D,gBAAgB;EfoRZ,kBAvE+B;EezMnC,gBbgrB+B,EAAA;;Aa5qBjC;EACE,+BCgN8D;ED/M9D,kCC+M8D;EhB+DxD,qBAf6B,EAAA;EAnJjC;Ie9GJ;MfuRQ,qBAlF6B,EAAA,EejMpC;;AAED;EACE,gCC0M8D;EDzM9D,mCCyM8D;EhB2D1D,qBAvE+B,EAAA;;AiB1NrC;EACE,mBfs6B4C;EFtoBxC,kBAvE+B;EiBrNnC,cfuJgB,EAAA;;AgB5JlB;EACE,cAAc;EACd,WAAW;EACX,sBhBu1BiC;EFzjB7B,oBAvE+B;EkBpNnC,gBhBorB+B;EgBnrB/B,gBhB0rB+B;EgBzrB/B,2BhBm8B6E;EgBl8B7E,oChB67ByE;EgB57BzE,4BAA4B;EAC5B,wChBi8BiF;EgBh8BjF,gBAAgB;EfGd,sBD2mBgC;EiB9mB9B,wEjB29B4F,EAAA;EiBv9B5F;IDhBN;MCiBQ,gBAAgB,EAAA,EDwEvB;EAzFD;IAqBI,gBAAgB,EAAA;IArBpB;MAwBM,eAAe,EAAA;EAxBrB;IA8BI,2BhB66B2E;IgB56B3E,oChBu6BuE;IgBt6BvE,0ChBq7B2F;IgBp7B3F,UAAU;IAKR,4ChB8Ic,EAAA;EgBpLpB;IA+CI,aAAmE,EAAA;EA/CvE;IAoDI,chBwGc;IgBtGd,UAAU,EAAA;EAtDd;IAgEI,6ChBw4ByF;IgBr4BzF,UAAU,EAAA;EAnEd;IAwEI,sBhBkxB+B;IgBjxB/B,uBhBixB+B;IgBhxB/B,yBhBgxB+B;IgB/wB/B,2BhBg4B2E;IkB38B7E,gDlBoiCiG;IgBv9B/F,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,4BhB0hB6B;IgBzhB7B,gBAAgB;ICtEd,qIjB24B6I,EAAA;IiBv4B7I;MDhBN;QCiBQ,gBAAgB,EAAA,EDmErB;EApFH;IAuFI,gDhB68B+F,EAAA;;AgBp8BnG;EACE,cAAc;EACd,WAAW;EACX,iBAA2B;EAC3B,gBAAgB;EAChB,gBhB4lB+B;EgB3lB/B,2BhBq3B6E;EgBp3B7E,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmC,EAAA;EATrC;IAYI,UAAU,EAAA;EAZd;IAiBI,gBAAgB;IAChB,eAAe,EAAA;;AAWnB;EACE,sCFwG8D;EEvG9D,uBhBuuBiC;EFrkB7B,qBAvE+B;EG3MjC,qBD4mB+B,EAAA;EgB9fnC;IAOI,uBhBkuB+B;IgBjuB/B,wBhBiuB+B;IgBhuB/B,yBhBguB+B,EAAA;;AgB5tBnC;EACE,sCF2F8D;EE1F9D,sBhB8tBkC;EFrkB5B,qBAf6B;EGvQjC,qBD6mB+B,EAAA;EFzf/B;IkBOJ;MlBkKQ,qBAlF6B,EAAA,EkBrEpC;EAXD;IAOI,sBhBytBgC;IgBxtBhC,uBhBwtBgC;IgBvtBhC,yBhButBgC,EAAA;;AgBhtBpC;EAEI,oCF0E4D,EAAA;;AE5EhE;EAMI,sCFsE4D,EAAA;;AE5EhE;EAUI,sCFkE4D,EAAA;;AE7DhE;EACE,WhB8zB0C;EgB7zB1C,gCF2D8D;EE1D9D,ehB6qBiC,EAAA;EgBhrBnC;IAMI,eAAe,EAAA;EANnB;IAUI,oBAAoB;IfpKpB,sBD2mBgC,EAAA;EgBjdpC;If1JI,sBD2mBgC,EAAA;EgBjdpC;IAkBsB,kCF2C0C,EAAA;EE7DhE;IAmBsB,kCF0C0C,EAAA;;AKrOhE;EACE,cAAc;EACd,WAAW;EACX,oCnBs1BiC;EmBr1BjC,sCLyP8D;EhBmC1D,oBAvE+B;EqBlNnC,gBnBkrB+B;EmBjrB/B,gBnBwrB+B;EmBvrB/B,2BnBi8B6E;EmBh8B7E,oCnB27ByE;EmB17BzE,0DLuHgF;EKtHhF,4BAA4B;EAC5B,wCnBuiCqE;EmBtiCrE,0BnBuiC2C;EmBtiC3C,wCnB47BiF;EC77B/E,sBD2mBgC;EiB9mB9B,wEjB29B4F;EmBn9BhG,gBAAgB,EAAA;EFJZ;IEfN;MFgBQ,gBAAgB,EAAA,EEiCvB;EAjDD;IAsBI,0CnB87B2F;ImB77B3F,UAAU;IAKR,4CnBuJc,EAAA;EmBnLpB;IAkCI,qBnBuzB+B;ImBtzB/B,sBAAsB,EAAA;EAnC1B;IAwCI,6CnB+5ByF,EAAA;EmBv8B7F;IA8CI,kBAAkB;IAClB,uCnB25B2E,EAAA;;AmBv5B/E;EACE,oBnBgzBkC;EmB/yBlC,uBnB+yBkC;EmB9yBlC,oBnB+yBiC;EFrkB7B,qBAvE+B;EG3MjC,qBD4mB+B,EAAA;;AmB/jBnC;EACE,mBnB4yBiC;EmB3yBjC,sBnB2yBiC;EmB1yBjC,oBnB2yBkC;EFrkB5B,qBAf6B;EGvQjC,qBD6mB+B,EAAA;EFzf/B;IqBvEJ;MrBgPQ,qBAlF6B,EAAA,EqBxJpC;;AClED;EACE,cAAc;EACd,sBpB2+B2E;EoB1+B3E,mBpB2+BsE;EoB1+BtE,uBpB2+B+C,EAAA;EoB/+BjD;IAOI,WAAW;IACX,mBAA2C,EAAA;;AAI/C;EACE,oBpBi+BsE;EoBh+BtE,eAAe;EACf,iBAAiB,EAAA;EAHnB;IAMI,YAAY;IACZ,oBAA4C;IAC5C,cAAc,EAAA;;AAIlB;EACE,YpBm9B6C;EoBl9B7C,apBk9B6C;EoBj9B7C,iBAA8D;EAC9D,mBAAmB;EACnB,oCpBy6ByE;EoBx6BzE,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,8CpBs9ByG;EoBr9BzG,gBAAgB;EAChB,iCAAyB;UAAzB,yBAAyB,EAAA;EAX3B;InBTI,qBDy+B2C,EAAA;EoBh+B/C;IAoBI,kBpB68ByC,EAAA;EoBj+B7C;IAwBI,uBpBo8BqD,EAAA;EoB59BzD;IA4BI,0CpBi6B2F;IoBh6B3F,UAAU;IACV,4CpB8HgB,EAAA;EoB5JpB;IAkCI,yBpB0HgB;IoBzHhB,qBpByHgB,EAAA;IoB5JpB;MAyCQ,0DNkE0E,EAAA;IM3GlF;MAiDQ,0DN0D0E,EAAA;EM3GlF;IAuDI,yBpBqGgB;IoBpGhB,qBpBoGgB;IoB/Fd,0DN8C4E,EAAA;EM3GlF;IAkEI,oBAAoB;IACpB,YAAY;IACZ,YpB46ByC,EAAA;EoBh/B7C;IA4EM,eAAe;IACf,YpBm6BuC,EAAA;;AoBr5B7C;EACE,mBpB85ByD,EAAA;EoB/5B3D;IAII,UpB05BiC;IoBz5BjC,mBAA4C;IAC5C,0DNU8E;IMT9E,gCAAgC;InB3GhC,kBDkgCiC;IiBrgC/B,iDjBygCgE,EAAA;IiBrgChE;MGmGN;QHlGQ,gBAAgB,EAAA,EG0HrB;IAxBH;MAYM,0DNI4E,EAAA;IMhBlF;MAgBM,iCpBy5BwC;MoBp5BtC,0DNL0E,EAAA;EMhBlF;IA2BI,oBpBo4BuD;IoBn4BvD,eAAe,EAAA;IA5BnB;MA+BM,oBAA6C;MAC7C,cAAc,EAAA;;AAKpB;EACE,qBAAqB;EACrB,kBpBk3BoC,EAAA;;AoB/2BtC;EACE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB,EAAA;EAHtB;IAQM,oBAAoB;IACpB,YAAY;IACZ,apBouB2B,EAAA;;AqBz4BjC;EACE,WAAW;EACX,YP+N2B;EO9N3B,UAAU;EACV,6BAA6B;EAC7B,gBAAgB,EAAA;EALlB;IAQI,UAAU,EAAA;IARd;MAY8B,+DrBsKV,EAAA;IqBlLpB;MAa8B,+DrBqKV,EAAA;EqBlLpB;IAiBI,SAAS,EAAA;EAjBb;IAqBI,WrBqkC2C;IqBpkC3C,YrBokC2C;IqBnkC3C,oBAAsE;IHzBxE,yBlBoLkB;IqBzJhB,SrBokCwC;IChlCxC,mBDilC2C;IiBplCzC,oHjB0lCkI;IiB1lClI,4GjB0lCkI;IqBvkCpI,gBAAgB,EAAA;IJfd;MIdN;QJeQ,wBAAgB;QAAhB,gBAAgB,EAAA,EImBrB;IAlCH;MHFE,yBJ0MmC,EAAA;EOxMrC;IAqCI,WrB8iCkC;IqB7iClC,crB8iCmC;IqB7iCnC,kBAAkB;IAClB,erB6iCqC;IqB5iCrC,oCrB6iCiE;IqB5iCjE,yBAAyB;IpB7BzB,mBD0kCkC,EAAA;EqBvlCtC;IAgDI,WrB0iC2C;IqBziC3C,YrByiC2C;IkB5lC7C,yBlBoLkB;IqB/HhB,SrB0iCwC;IChlCxC,mBDilC2C;IiBplCzC,iHjB0lCkI;IiB1lClI,4GjB0lCkI;IqB7iCpI,gBAAgB,EAAA;IJzCd;MIdN;QJeQ,qBAAgB;QAAhB,gBAAgB,EAAA,EI6CrB;IA5DH;MHFE,yBJ0MmC,EAAA;EOxMrC;IA+DI,WrBohCkC;IqBnhClC,crBohCmC;IqBnhCnC,kBAAkB;IAClB,erBmhCqC;IqBlhCrC,oCrBmhCiE;IqBlhCjE,yBAAyB;IpBvDzB,mBD0kCkC,EAAA;EqBvlCtC;IA0EI,oBAAoB,EAAA;IA1ExB;MA6EM,yBrB4EY,EAAA;IqBzJlB;MAiFM,yBrBwEY,EAAA;;AsB/JlB;EACE,kBAAkB,EAAA;EADpB;;;IAMI,0BRoO4D;IQnO5D,iBtB8mCkC,EAAA;EsBrnCtC;IAWI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oBtB80B+B;IsB70B/B,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6C;IAC7C,qBAAqB;ILPnB,gEjB4mC8E,EAAA;IiBxmC9E;MKpBN;QLqBQ,gBAAgB,EAAA,EKIrB;EAzBH;;IA6BI,oBtBi0B+B,EAAA;IsB91BnC;;MAgCM,kBAAkB,EAAA;IAhCxB;;;MAqCM,qBtBmlCoC;MsBllCpC,wBtBmlCmC,EAAA;IsBznCzC;;MA0CM,qBtB8kCoC;MsB7kCpC,wBtB8kCmC,EAAA;EsBznCzC;IAgDI,qBtBwkCsC;IsBvkCtC,wBtBwkCqC,EAAA;EsBznCzC;;;;IAyDM,atBikC+B;IsBhkC/B,8DtBikC4E,EAAA;EsB3nClF;IAgEM,atB0jC+B;IsBzjC/B,8DtB0jC4E,EAAA;EsB3nClF;IAuEM,mBAAmC,EAAA;;ACnEzC;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,WAAW,EAAA;EALb;;;IAUI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,YAAY,EAAA;EAbhB;;;IAoBI,UAAU,EAAA;EApBd;IA2BI,kBAAkB;IAClB,UAAU,EAAA;IA5Bd;MA+BM,UAAU,EAAA;;AAWhB;EACE,aAAa;EACb,mBAAmB;EACnB,sBvB6yBiC;EFzjB7B,oBAvE+B;EyB3KnC,gBvB2oB+B;EuB1oB/B,gBvBipB+B;EuBhpB/B,2BvB05B6E;EuBz5B7E,kBAAkB;EAClB,mBAAmB;EACnB,gDvBg/BiG;EuB/+BjG,wCvBu5BiF;EC77B/E,sBD2mBgC,EAAA;;AuB3jBpC;;;;EAIE,sBvBuyBkC;EFrkB5B,qBAf6B;EGvQjC,qBD6mB+B,EAAA;EFzf/B;IyBpEJ;;;;MzB6OQ,qBAlF6B,EAAA,EyBpJpC;;AAED;;;;EAIE,uBvB0xBiC;EFrkB7B,qBAvE+B;EG3MjC,qBD4mB+B,EAAA;;AuB1iBnC;;EAEE,qBAAsE,EAAA;;AAWxE;;;;EtB/DI,0BsBqE8B;EtBpE9B,6BsBoE8B,EAAA;;AANlC;;;;EtB/DI,0BsB8E8B;EtB7E9B,6BsB6E8B,EAAA;;AAflC;EAyBI,iBvBof6B;EC9jB7B,yBsB2E8B;EtB1E9B,4BsB0E8B,EAAA;;AA1BlC;;EtBjDI,yBsBgF8B;EtB/E9B,4BsB+E8B,EAAA;;AAP4B;EChG1D,aAAa;EACb,WAAW;EACX,mBxB+4B0C;EFtoBxC,kBAvE+B;E0B/LjC,cxB+JgB,EAAA;;AuBpEsB;ECvFtC,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,sBxBy3C4C;EwBx3C5C,iBAAiB;E1B4Pf,qBAvE+B;E0BlLjC,WxB8GW;EwB7GX,yCxBiJgB;EC3KhB,qBD4mB+B,EAAA;;AwBznB/B;;;;EA8CE,cAAc,EAAA;;AA9ChB;EAoDE,qBxBoIc;EwBjIZ,iCV6KwD;EU5KxD,0DVyE0E;EUxE1E,4BAA4B;EAC5B,yDAA6D;EAC7D,4DVyKwD,EAAA;EUpO5D;IA+DI,qBxByHY;IwBxHZ,4CxBwHY,EAAA;;AwBxLhB;EAyEI,iCV2JwD;EU1JxD,8EV0JwD,EAAA;;AUpO5D;EAiFE,qBxBuGc,EAAA;EwBxLhB;IAsFM,sBxBk+B2F;IwBj+B3F,oGV0CwE;IUzCxE,6DxBm9BoD;IwBl9BpD,uEV2IsD,EAAA;EUpO5D;IA8FI,qBxB0FY;IwBzFZ,4CxByFY,EAAA;;AwBxLhB;EAuGI,sCV6HwD,EAAA;;AUpO5D;EA8GE,qBxB0Ec,EAAA;EwBxLhB;IAiHI,yBxBuEY,EAAA;EwBxLhB;IAqHI,4CxBmEY,EAAA;EwBxLhB;IAyHI,cxB+DY,EAAA;;AwB3DlB;EAEI,iBAAiB,EAAA;;AA/HnB;;;;;EAyIM,UAAU,EAAA;;ADrBqF;EChGrG,aAAa;EACb,WAAW;EACX,mBxB+4B0C;EFtoBxC,kBAvE+B;E0B/LjC,cxB4JgB,EAAA;;AuBjE+D;ECvF/E,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,sBxBy3C4C;EwBx3C5C,iBAAiB;E1B4Pf,qBAvE+B;E0BlLjC,WxB8GW;EwB7GX,yCxB8IgB;ECxKhB,qBD4mB+B,EAAA;;AwBznB/B;;;;EA8CE,cAAc,EAAA;;AA9ChB;EAoDE,qBxBiIc;EwB9HZ,iCV6KwD;EU5KxD,0DVyE0E;EUxE1E,4BAA4B;EAC5B,yDAA6D;EAC7D,4DVyKwD,EAAA;EUpO5D;IA+DI,qBxBsHY;IwBrHZ,4CxBqHY,EAAA;;AwBrLhB;EAyEI,iCV2JwD;EU1JxD,8EV0JwD,EAAA;;AUpO5D;EAiFE,qBxBoGc,EAAA;EwBrLhB;IAsFM,sBxBk+B2F;IwBj+B3F,oGV0CwE;IUzCxE,6DxBm9BoD;IwBl9BpD,uEV2IsD,EAAA;EUpO5D;IA8FI,qBxBuFY;IwBtFZ,4CxBsFY,EAAA;;AwBrLhB;EAuGI,sCV6HwD,EAAA;;AUpO5D;EA8GE,qBxBuEc,EAAA;EwBrLhB;IAiHI,yBxBoEY,EAAA;EwBrLhB;IAqHI,4CxBgEY,EAAA;EwBrLhB;IAyHI,cxB4DY,EAAA;;AwBxDlB;EAEI,iBAAiB,EAAA;;AA/HnB;;;;;EA2IM,UAAU,EAAA;;AC7IpB;EAEE,0BAAyC;EACzC,0BAAyC;EACzC,sBAA6C;E3B6RzC,6BAvE+B;E2BpNnC,yBAA6C;EAC7C,yBAA6C;EAC7C,uBAAiC;EACjC,wBAA2B;EAC3B,0BAA+C;EAC/C,kCAA+C;EAC/C,+BAAiD;EACjD,wCAA2D;EAC3D,4FAA2C;EAC3C,+BAAuD;EACvD,2EAAuD;EAGvD,qBAAqB;EACrB,wDAAoG;EACpG,sCAA8D;E3B4Q1D,kCAvE+B;E2BnMnC,sCAA8D;EAC9D,sCAA8D;EAC9D,0BAA4C;EAC5C,kBAAkB;EAClB,qBAAwD;EAExD,sBAAsB;EACtB,eAA2C;EAC3C,yBAAiB;UAAjB,iBAAiB;EACjB,mEAAqH;ExBjBnH,0CwBkB0E;EPjC5E,kCOkCoD;ERtBhD,qIjB24B6I,EAAA;EiBv4B7I;IQhBN;MRiBQ,gBAAgB,EAAA,EQ4FvB;EA7GD;IAuCI,gCAAwD;IAExD,wCAA6D;IAC7D,8CAA6E,EAAA;EAG/E;IAEE,0BAA4C;IAC5C,kCAAiD;IACjD,wCAAiE,EAAA;EAjDrE;IAqDI,gCAAwD;IPrD1D,wCOsDkE;IAChE,8CAA6E;IAC7E,UAAU;IAKR,0CAAuE,EAAA;EAI3E;IACE,8CAA6E;IAC7E,UAAU;IAKR,0CAAuE,EAAA;EAI3E;;IAKE,iCAA0D;IAC1D,yCAA+D;IAG/D,+CAA+E,EAAA;IATjF;;MAiBM,0CAAuE,EAAA;EA7F/E;;IAqGI,mCAA8D;IAC9D,oBAAoB;IACpB,2CAAmE;IAEnE,iDAAmF;IACnF,uCAAoE,EAAA;;AAYtE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADyFjE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADyFjE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADyFjE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADyFjE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADyFjE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADyFjE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADyFjE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,qCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADmHjE;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD0F/B;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD0F/B;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD0F/B;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD0F/B;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD0F/B;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD0F/B;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD0F/B;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,qCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADsGjC;EACE,yBAA6C;EAC7C,oCAAiC;EACjC,wBAA2B;EAC3B,kCAA+C;EAC/C,gDAA6C;EAC7C,wCAA2D;EAC3D,iDAA+C;EAC/C,yCAA6D;EAC7D,gCAAmD;EACnD,2CAAiE;EACjE,yBAA2C;EAC3C,uCAAuD;EAEvD,0BzB2XiD,EAAA;EyBzYnD;IAyBI,0BAA4C,EAAA;EAzBhD;IA6BI,gCAAwD,EAAA;;AAW5D;ECxIE,0BAAyC;EACzC,0BAAyC;E5BwOnC,8BAf6B;E4BvNnC,8BAAiD,EAAA;E5BoE/C;I2BiEJ;M3BwGQ,8BAlF6B,EAAA,E2BpBpC;;AAED;EC5IE,2BAAyC;EACzC,0BAAyC;E5BoOrC,8BAvE+B;E4B3JnC,8BAAiD,EAAA;;ACnEnD;EVgBM,gCjBwoB2C,EAAA;EiBpoB3C;IUpBN;MVqBQ,gBAAgB,EAAA,EUfvB;EAND;IAII,UAAU,EAAA;;AAKd;EAEI,aAAa,EAAA;;AAIjB;EACE,SAAS;EACT,gBAAgB;EVDZ,6BjB0oBwC,EAAA;EiBtoBxC;IULN;MVMQ,gBAAgB,EAAA,EUIvB;EAVD;IAMI,QAAQ;IACR,YAAY;IVNV,4BjB2oBuC,EAAA;IiBvoBvC;MULN;QVMQ,gBAAgB,EAAA,EUGrB;;ACvBH;;;;;;EAME,kBAAkB,EAAA;;AL6FG;EKzFrB,mBAAmB,EAAA;;ALyFwB;EKhF3C,0BAA6C;EAC7C,8BAAmD;EACnD,0BAAmD;EACnD,+BAAmD;EACnD,8BAA6C;E9B6QzC,kCAvE+B;E8BpMnC,yCAA2C;EAC3C,sBAAqC;EACrC,kDAAyD;EACzD,mCAA2D;EAC3D,6BAAyD;EACzD,yCAAuE;EACvE,gDAAqD;EACrD,sCAAiE;EACjE,2DAAqD;EACrD,iCAAqD;EACrD,uCAAiE;EACjE,oCAA2D;EAC3D,wCAAmE;EACnE,qCAA6D;EAC7D,0CAAuE;EACvE,oCAA6D;EAC7D,qCAA6D;EAC7D,mCAAyD;EACzD,sCAAiE;EACjE,sCAAiE;EAGjE,kBAAkB;EAClB,kCAA0D;EAC1D,aAAa;EACb,uCAAkE;EAClE,kEAAwH;EACxH,SAAS;E9BgPL,uCAvE+B;E8BvKnC,+BAAsD;EACtD,gBAAgB;EAChB,gBAAgB;EAChB,uCAA2D;EAC3D,4BAA4B;EAC5B,6EAAyI;E3BzCvI,+C2B0CoF,EAAA;EA3CxF;IA+CI,SAAS;IACT,OAAO;IACP,qCAA6D,EAAA;;AAwB7D;EACE,oBAAc,EAAA;EADhB;IAII,WAAW;IACX,OAAO,EAAA;;AAIX;EACE,kBAAc,EAAA;EADhB;IAII,QAAQ;IACR,UAAU,EAAA;;ApB1Cd;EoB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;ApB3CH;EoB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;ApB3CH;EoB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;ApB3CH;EoB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;ApB3CH;EoB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;AAQP;EAEI,SAAS;EACT,YAAY;EACZ,aAAa;EACb,wCAAgE,EAAA;;AAQpE;EAEI,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,sCAA8D,EAAA;;AANlE;EAYM,iBAAiB,EAAA;;AAKvB;EAEI,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,uCAA+D,EAAA;;AANnE;EAYM,iBAAiB,EAAA;;AAOvB;EACE,SAAS;EACT,6CAA+E;EAC/E,gBAAgB;EAChB,mDAA+E;EAC/E,UAAU,EAAA;;AAMZ;EACE,cAAc;EACd,WAAW;EACX,4EAA4I;EAC5I,WAAW;EACX,gB5B2gB+B;E4B1gB/B,oCAAgE;EAChE,mBAAmB;EACnB,qBAAwD;EACxD,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS,EAAA;EAXX;IAeI,0CAA4E;IVzL9E,kDU2LsF,EAAA;EAjBxF;IAsBI,2CAA8E;IAC9E,qBAAqB;IVjMvB,mDUkMwF,EAAA;EAxB1F;IA6BI,6CAAkF;IAClF,oBAAoB;IACpB,6BAA6B,EAAA;;AAMjC;EACE,cAAc,EAAA;;AAIhB;EACE,cAAc;EACd,gFAAoJ;EACpJ,gBAAgB;E9B0EZ,qBAvE+B;E8BDnC,sCAAoE;EACpE,mBAAmB,EAAA;;AAIrB;EACE,cAAc;EACd,4EAA4I;EAC5I,oCAAgE,EAAA;;AAIlE;EAEE,4BAA2C;EAC3C,yBAAqC;EACrC,kDAAyD;EACzD,0BAAqD;EACrD,iCAAqD;EACrD,oCAAiE;EACjE,gDAAqD;EACrD,sDAA2D;EAC3D,qCAAmE;EACnE,qCAA6D;EAC7D,0CAAuE;EACvE,mCAAyD,EAAA;;ACrP3D;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB,EAAA;EAJxB;;IAOI,kBAAkB;IAClB,cAAc,EAAA;EARlB;;;;;;;;;;;;IAmBI,UAAU,EAAA;;AAKd;EACE,aAAa;EACb,eAAe;EACf,2BAA2B,EAAA;EAH7B;IAMI,WAAW,EAAA;;AAIf;E5BhBI,sBD2mBgC,EAAA;E6B3lBpC;;IAMI,iB7BskB6B,EAAA;E6B5kBjC;;;I5BAI,0B4Ba4B;I5BZ5B,6B4BY4B,EAAA;EAbhC;;;I5BcI,yB4BS8B;I5BR9B,4B4BQ8B,EAAA;;AAgBlC;EACE,uBAAmC;EACnC,sBAAkC,EAAA;EAFpC;;;IAOI,cAAc,EAAA;EAGhB;IACE,eAAe,EAAA;;AAInB;EACE,uBAAsC;EACtC,sBAAqC,EAAA;;AAGvC;EACE,qBAAsC;EACtC,oBAAqC,EAAA;;AAoBvC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB,EAAA;EAHzB;;IAOI,WAAW,EAAA;EAPf;;IAYI,gB7B+e6B,EAAA;E6B3fjC;;I5B1EI,6B4B4F+B;I5B3F/B,4B4B2F+B,EAAA;EAlBnC;;I5BxFI,yB4B+G4B;I5B9G5B,0B4B8G4B,EAAA;;ACtIhC;EAEE,6BAAmD;EACnD,+BAAmD;EAEnD,2BAAuD;EACvD,yCAA2C;EAC3C,qDAAuD;EACvD,qCAA6D;EAG7D,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,kEAAwH;EhC4QpH,uCAvE+B;EgCnMnC,2CAAwE;EACxE,+BAAsD;EACtD,qBAAwD;EbbpD,uGjBuqCsH,EAAA;EiBnqCtH;IaGN;MbFQ,gBAAgB,EAAA,EauBvB;EArBD;IAWI,qCAAkE,EAAA;EAXtE;IAiBI,wCAAwE;IACxE,oBAAoB;IACpB,eAAe,EAAA;;AAQnB;EAEE,+BAAyD;EACzD,8CAAyD;EACzD,oCAA2D;EAC3D,+FAA+E;EAC/E,wCAAmE;EACnE,+DAA6D;EAC7D,+GAAiF;EAGjF,oFAAgJ,EAAA;EAXlJ;IAcI,yDAAuF;IACvF,gBAAgB;IAChB,yDAAuF;I7BtCvF,wD6BuC0F;I7BtC1F,yD6BsC0F,EAAA;IAjB9F;MAsBM,kBAAkB;MAClB,wDAAiG,EAAA;IAvBvG;MA4BM,wCAAwE;MACxE,6BAA6B;MAC7B,yBAAyB,EAAA;EA9B/B;;IAoCI,2CAA8E;IAC9E,mDAAmF;IACnF,yDAAmG,EAAA;EAtCvG;IA2CI,sDAAoF;I7BjEpF,yB6BmE4B;I7BlE5B,0B6BkE4B,EAAA;;AAShC;EAEE,qCAA6D;EAC7D,sCAAqE;EACrE,sCAA+D,EAAA;EAJjE;IAQI,gBAAgB;IAChB,SAAS;I7B9FT,gD6B+FwF,EAAA;IAV5F;MAaM,wCAAwE;MACxE,6BAA6B;MAC7B,yBAAyB,EAAA;EAf/B;;IAqBI,4CAAgF;IZzHlF,oDY0H0F,EAAA;;AAS5F;;EAGI,cAAc;EACd,kBAAkB,EAAA;;AAItB;;EAGI,aAAa;EACb,YAAY;EACZ,kBAAkB,EAAA;;AAItB;;EAGI,WAAW,EAAA;;AASf;EAEI,aAAa,EAAA;;AAFjB;EAKI,cAAc,EAAA;;ACpKlB;EAEE,wBAA+C;EAC/C,6BAA+C;EAC/C,sCAAuC;EACvC,2CAAmD;EACnD,8CAAyD;EACzD,4CAAqD;EACrD,uCAA2D;EAC3D,kCAA6D;EAC7D,uCAA2D;EAC3D,2CAAmD;EACnD,iDAA+D;EAC/D,sCAAiE;EACjE,sCAA+D;EAC/D,sCAA+D;EAC/D,yCAA+D;EAC/D,qEAA2D;EAC3D,oDAAqE;EACrE,0CAAuE;EACvE,kCAAmE;EACnE,4DAAiE;EAGjE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,8DAAgH,EAAA;EA7BlH;;IAoCI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B,EAAA;;AAoBlC;EACE,6CAA4E;EAC5E,gDAA+E;EAC/E,+CAA+E;EjCkO3E,2CAvE+B;EiCzJnC,mCAA8D;EAC9D,qBAAwD;EACxD,mBAAmB,EAAA;EAPrB;IAWI,yCAA0E,EAAA;;AAU9E;EAEE,0BAAmD;EACnD,+BAAmD;EAEnD,2BAAuD;EACvD,2CAA2C;EAC3C,uDAAuD;EACvD,6DAA6D;EAG7D,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAA;EAflB;;IAmBI,oCAAgE,EAAA;EAnBpE;IAuBI,gBAAgB,EAAA;;AASpB;EACE,mB/B2jCuC;E+B1jCvC,sB/B0jCuC;E+BzjCvC,6BAAkD,EAAA;EAHpD;;;IAQI,oCAAgE,EAAA;;AAapE;EACE,gBAAgB;EAChB,YAAY;EAGZ,mBAAmB,EAAA;;AAIrB;EACE,8EAAgJ;EjCiJ5I,6CAvE+B;EiCxEnC,cAAc;EACd,6BAAkD;EAClD,6BAA6B;EAC7B,0EAAmI;E9BtIjI,qD8BuIgG;Ed1I9F,+Cc2IqF,EAAA;EdvIrF;Ic+HN;Md9HQ,gBAAgB,EAAA,EciJvB;EAnBD;IAWI,qBAAqB,EAAA;EAXzB;IAeI,qBAAqB;IACrB,UAAU;IACV,sDAAyF,EAAA;;AAM7F;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kDAAiF;EACjF,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB,EAAA;;AAGvB;EACE,yCAA+D;EAC/D,gBAAgB,EAAA;;AvBxHd;EuBoIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Md5N9B,gBc8N4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AvB3LP;EuBoIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Md5N9B,gBc8N4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AvB3LP;EuBoIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Md5N9B,gBc8N4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AvB3LP;EuBoIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Md5N9B,gBc8N4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AvB3LP;EuBoIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Md5N9B,gBc8N4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AA7DX;EAQQ,iBAAiB;EACjB,2BAA2B,EAAA;EATnC;IAYU,mBAAmB,EAAA;IAZ7B;MAeY,kBAAkB,EAAA;IAf9B;MAmBY,kDAAoF;MACpF,iDAAmF,EAAA;EApB/F;IAyBU,iBAAiB,EAAA;EAzB3B;IA6BU,wBAAwB;IACxB,gBAAgB,EAAA;EA9B1B;IAkCU,aAAa,EAAA;EAlCvB;IAuCU,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,wCAAwC;IACxC,oBAAoB;IACpB,0BAA0B;Id5N9B,gBc8N4B,EAAA;IAjDlC;MAqDY,aAAa,EAAA;IArDzB;MAyDY,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB,EAAA;;AAiB/B;EAEE,4CAAuC;EACvC,kDAAmD;EACnD,qDAAyD;EACzD,8BAAqD;EACrD,6BAAmD;EACnD,mCAA+D;EAC/D,0DAAqE;EACrE,qEAA2D,EAAA;;AC/Q7D;EAEE,wBAAyC;EACzC,wBAAyC;EACzC,gCAAqD;EACrD,yBAAiD;EACjD,4CAAiD;EACjD,gCAAmD;EACnD,sDAA6C;EAC7C,sCAA+D;EAC/D,6BAAmD;EACnD,6BAAmD;EACnD,sBAAqC;EACrC,qBAA2C;EAC3C,kBAAqC;EACrC,iBAAmC;EACnC,kBAA6B;EAC7B,mCAA+D;EAC/D,8BAAiD;EAGjD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,6BAAiD;EACjD,qBAAqB;EACrB,mCAAmD;EACnD,2BAA2B;EAC3B,qEAAyH;E/BdvH,2C+Be4E,EAAA;EA9BhF;IAkCI,eAAe;IACf,cAAc,EAAA;EAnClB;IAuCI,mBAAmB;IACnB,sBAAsB,EAAA;IAxC1B;MA2CM,mBAAmB;M/BnBrB,0D+BoBgG;M/BnBhG,2D+BmBgG,EAAA;IA5CpG;MAgDM,sBAAsB;M/BVxB,8D+BWmG;M/BVnG,6D+BUmG,EAAA;EAjDvG;;IAyDI,aAAa,EAAA;;AAIjB;EAGE,cAAc;EACd,wDAAoG;EACpG,2BAA8C,EAAA;;AAGhD;EACE,4CAAwE,EAAA;;AAG1E;EACE,qDAAiF;EACjF,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB,EAAA;;AAGlB;EAMI,oCAA0D,EAAA;;AAQ9D;EACE,kEAAwH;EACxH,gBAAgB;EAChB,+BAAsD;EACtD,uCAA2D;EAC3D,4EAAgI,EAAA;EALlI;I/BjFI,wF+ByFkK,EAAA;;AAItK;EACE,kEAAwH;EACxH,+BAAsD;EACtD,uCAA2D;EAC3D,yEAA6H,EAAA;EAJ/H;I/B7FI,wF+BoGkK,EAAA;;AAStK;EACE,sDAAiF;EACjF,sDAAiF;EACjF,qDAAgF;EAChF,gBAAgB,EAAA;EAJlB;IAOI,mCAAmD;IACnD,sCAAsD,EAAA;;AAI1D;EACE,sDAAiF;EACjF,qDAAgF,EAAA;;AAIlF;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,2CAA4E;E/BrI1E,iD+BsIwF,EAAA;;AAG5F;;;EAGE,WAAW,EAAA;;AAGb;;E/BtII,0D+BwI4F;E/BvI5F,2D+BuI4F,EAAA;;AAGhG;;E/B7HI,8D+B+H+F;E/B9H/F,6D+B8H+F,EAAA;;AAQnG;EAII,0CAAoE,EAAA;;AxBtHpE;EwBkHJ;IAQI,aAAa;IACb,mBAAmB,EAAA;IATvB;MAcM,SAAY;MACZ,gBAAgB,EAAA;MAftB;QAkBQ,cAAc;QACd,cAAc,EAAA;MAnBtB;Q/B9II,0B+BuKkC;Q/BtKlC,6B+BsKkC,EAAA;QAzBtC;;UA8BY,0BAA0B,EAAA;QA9BtC;;UAmCY,6BAA6B,EAAA;MAnCzC;Q/BhII,yB+BwKoC;Q/BvKpC,4B+BuKoC,EAAA;QAxCxC;;UA6CY,yBAAyB,EAAA;QA7CrC;;UAkDY,4BAA4B,EAAA,EAC7B;;AChOX;EAEE,0CAA6C;EAC7C,uBAAuC;EACvC,8KAAuD;EACvD,mDAA2D;EAC3D,gCAA2D;EAC3D,qCAA6D;EAC7D,uDAAyE;EACzE,qCAA6D;EAC7D,kCAA6D;EAC7D,8CAAqD;EACrD,2BAA+C;EAC/C,iEAAmD;EACnD,sCAA+D;EAC/D,kDAAuE;EACvE,8DAAyE;EACzE,wEAAiE;EACjE,mEAA+E;EAC/E,0EAA2E;EAC3E,sCAA+D;EAC/D,mCAA+D;EAC/D,oCAA2D;EAC3D,kDAAqD,EAAA;;AAIvD;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,4EAA4I;EnCiQxI,oBAvE+B;EmCxLnC,oCAAgE;EAChE,gBAAgB;EAChB,4CAAqE;EACrE,SAAS;EhCtBP,gBgCuBsB;EACxB,qBAAqB;EhB3BjB,0CgB4B2E,EAAA;EhBxB3E;IgBWN;MhBVQ,gBAAgB,EAAA,EgB2DvB;EAjDD;IAgBI,uCAAsE;IACtE,+CAA2E;IAC3E,kGAAgK,EAAA;IAlBpK;MAqBM,qDAAuF;MACvF,iDAAsF,EAAA;EAtB5F;IA4BI,cAAc;IACd,yCAA0E;IAC1E,0CAA2E;IAC3E,iBAAiB;IACjB,WAAW;IACX,8CAAyE;IACzE,4BAA4B;IAC5B,mDAAoF;IhBlDlF,mDgBmD+F,EAAA;IhB/C/F;MgBWN;QhBVQ,gBAAgB,EAAA,EgB+CrB;EArCH;IAwCI,UAAU,EAAA;EAxCd;IA4CI,UAAU;IACV,wDAAiG;IACjG,UAAU;IACV,oDAA2F,EAAA;;AAI/F;EACE,gBAAgB,EAAA;;AAGlB;EACE,gCAAwD;EACxD,wCAA6D;EAC7D,+EAA6I,EAAA;EAH/I;IhC1DI,yDgCgE4F;IhC/D5F,0DgC+D4F,EAAA;IANhG;MhC1DI,+DgCmE0G;MhClE1G,gEgCkE0G,EAAA;EAT9G;IAcI,aAAa,EAAA;EAdjB;IhC5CI,6DgC+D+F;IhC9D/F,4DgC8D+F,EAAA;IAnBnG;MhC5CI,mEgCmE+G;MhClE/G,kEgCkE+G,EAAA;IAvBnH;MhC5CI,6DgCwEiG;MhCvEjG,4DgCuEiG,EAAA;;AAKrG;EACE,8EAAgJ,EAAA;;AAQlJ;EAEI,eAAe,EAAA;;AAFnB;EAMI,eAAe;EACf,cAAc;EhCpHd,gBgCqHwB,EAAA;EAR5B;IAUoB,aAAa,EAAA;EAVjC;IAWmB,gBAAgB,EAAA;EAXnC;IhC7GI,gBgC6H4B,EAAA;;AChJhC;EAEE,4BAAuD;EACvD,4BAAuD;EACvD,mCAA+D;EAE/D,oBAAyC;EACzC,+BAA+D;EAC/D,sCAA+D;EAC/D,sCAAiE;EACjE,0CAAuE;EAGvE,aAAa;EACb,eAAe;EACf,sEAAgI;EAChI,iDAAkF;EpCqR9E,yCAvE+B;EoC5MnC,gBAAgB;EAChB,yCAA+D;EjCA7D,iDiCCwF,EAAA;;AAG5F;EAGI,iDAAmF,EAAA;EAHvF;IAMM,WAAW;IACX,kDAAoF;IACpF,yCAA0E;IAC1E,yFAAgN,EAAO;;AAT7N;EAcI,6CAAkF,EAAA;;ACrCtF;EAEE,kCAAuD;EACvD,mCAAuD;ErCkSnD,oCAvE+B;EqCzNnC,2CAA+C;EAC/C,4CAAyC;EACzC,iCAA6D;EAC7D,oDAA6D;EAC7D,sCAA+D;EAC/D,uDAA2D;EAC3D,iCAAqD;EACrD,0DAAyE;EACzE,uDAA2D;EAC3D,iCAAqD;EACrD,kEAAqE;EACrE,kCAA6D;EAC7D,kCAAuD;EACvD,4CAA2E;EAC3E,uCAAiE;EACjE,qDAA2D;EAC3D,6DAA+E;EAG/E,aAAa;EhCpBb,eAAe;EACf,gBAAgB,EAAA;;AgCuBlB;EACE,kBAAkB;EAClB,cAAc;EACd,sEAAgI;ErCsQ5H,yCAvE+B;EqC7LnC,iCAA0D;EAC1D,qBAAwD;EACxD,yCAA+D;EAC/D,iFAAiJ;ElBpB7I,qIjB+zCoJ,EAAA;EiB3zCpJ;IkBQN;MlBPQ,gBAAgB,EAAA,EkBiDvB;EA1CD;IAYI,UAAU;IACV,uCAAsE;IAEtE,+CAA2E;IAC3E,qDAA2F,EAAA;EAhB/F;IAoBI,UAAU;IACV,uCAAsE;IACtE,+CAA2E;IAC3E,UnC8wCiC;ImC7wCjC,iDAAqF,EAAA;EAxBzF;;IA6BI,UAAU;IACV,wCAAwE;IjBtD1E,gDiBuDkF;IAChF,sDAA6F,EAAA;EAhCjG;;IAqCI,0CAA4E;IAC5E,oBAAoB;IACpB,kDAAiF;IACjF,wDAAiG,EAAA;;AAIrG;EAEI,iBnCqiB6B,EAAA;;AmCviBjC;ElCvBI,0DkC+BoG;ElC9BpG,6DkC8BoG,EAAA;;AARxG;ElCrCI,2DkCmDkG;ElClDlG,8DkCkDkG,EAAA;;AAgBtG;EClGE,iCAAuD;EACvD,iCAAuD;EtCoSjD,qCAf6B;EsCnRnC,qCAA+D,EAAA;EtCgI7D;IqCjCJ;MrC0MQ,qCAlF6B,EAAA,EqCtHpC;;AAED;ECtGE,iCAAuD;EACvD,kCAAuD;EtCgSnD,qCAvE+B;EsCvNnC,qCAA+D,EAAA;;ACFjE;EAEE,4BAA6C;EAC7C,4BAA6C;EvC6RzC,4BAvE+B;EuCpNnC,2BAAiD;EACjD,sBAAqC;EACrC,iCAAqD;EAGrD,qBAAqB;EACrB,4DAA4G;EvCqRxG,oCAvE+B;EuC5MnC,wCAAkE;EAClE,cAAc;EACd,4BAAgD;EAChD,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EpCJtB,4CoCK8E,EAAA;EAnBlF;IAwBI,aAAa,EAAA;;AAKjB;EACE,kBAAkB;EAClB,SAAS,EAAA;;AChCX;EAEE,0BAA+B;EAC/B,0BAA6C;EAC7C,4BAA6C;EAC7C,8BAAqD;EACrD,yBAAqC;EACrC,oCAAmD;EACnD,yDAAuC;EACvC,iCAAqD;EAGrD,kBAAkB;EAClB,4DAA4G;EAC5G,4CAAwE;EACxE,4BAAgD;EAChD,oCAAqD;EACrD,8BAAmD;ErCFjD,4CqCG8E,EAAA;;AAIlF;EAEE,cAAc,EAAA;;AAIhB;EACE,gBtC8pB+B,EAAA;;AsCtpBjC;EACE,mBtCogDkD,EAAA;EsCrgDpD;IAKI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UtC8fuC;IsC7fvC,kBtCidS,EAAA;;AsCjcX;EChEA,yBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD,EAAA;EAMnD;IACE,czBwMiC,EAAA;;AwBjJnC;EChEA,yBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD,EAAA;EAMnD;IACE,czBwMiC,EAAA;;AwBjJnC;EChEA,yBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD,EAAA;EAMnD;IACE,czBwMiC,EAAA;;AwBjJnC;EChEA,yBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD,EAAA;EAMnD;IACE,czBwMiC,EAAA;;AwBjJnC;EChEA,yBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD,EAAA;EAMnD;IACE,czBwMiC,EAAA;;AwBjJnC;EChEA,yBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD,EAAA;EAMnD;IACE,czBwMiC,EAAA;;AwBjJnC;EChEA,yBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD,EAAA;EAMnD;IACE,czBwMiC,EAAA;;AwBjJnC;EChEA,yBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD,EAAA;EAMnD;IACE,czBwMiC,EAAA;;A0B/MnC;EACE;IAAK,+BxCgjDmC,EAAA,EAAA;;AwC3iD5C;EAEE,8BAA6C;E1CyRzC,mCAvE+B;E0ChNnC,yBAAqC;EACrC,oCAA2D;EAC3D,8DAAqD;EACrD,6BAAmD;EACnD,6BAA6C;EAC7C,6CAA6D;EAG7D,aAAa;EACb,iCAAyD;EACzD,gBAAgB;E1C6QZ,uCAvE+B;E0CpMnC,uCAA2D;EvCPzD,+CuCQoF,EAAA;;AAIxF;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,mCAA8D;EAC9D,kBAAkB;EAClB,mBAAmB;EACnB,2CAAmE;EvBvB/D,6CuBwBiF,EAAA;EvBpBjF;IuBWN;MvBVQ,gBAAgB,EAAA,EuBoBvB;;AAED;EtBCE,qMAA6I;EsBC7I,oEAAoH,EAAA;;AAIpH;EACE,kDAA8D,EAAA;EAG5D;IAJJ;MAKM,eAAe,EAAA,EAGpB;;ACrDH;EAEE,2CAA+C;EAC/C,4CAAyC;EACzC,oDAA6D;EAC7D,iCAA6D;EAC7D,sCAA+D;EAC/D,oCAAiE;EACjE,sCAAiE;EACjE,kDAA6D;EAC7D,wDAAyE;EACzE,8DAAmE;EACnE,yDAA2E;EAC3E,+DAAqE;EACrE,uCAAiE;EACjE,qDAA2D;EAC3D,kCAA6D;EAC7D,kCAAuD;EACvD,4CAA2E;EAG3E,aAAa;EACb,sBAAsB;EAGtB,eAAe;EACf,gBAAgB;ExCXd,iDwCYwF,EAAA;;AAG5F;EACE,qBAAqB;EACrB,sBAAsB,EAAA;EAFxB;IAMI,oCAAoC;IACpC,0BAA0B,EAAA;;AAS9B;EACE,WAAW;EACX,wCAAwE;EACxE,mBAAmB,EAAA;EAHrB;IAQI,UAAU;IACV,8CAAoF;IACpF,qBAAqB;IACrB,sDAAyF,EAAA;EAX7F;IAeI,+CAAsF;IACtF,uDAA2F,EAAA;;AAQ/F;EACE,kBAAkB;EAClB,cAAc;EACd,gFAAoJ;EACpJ,iCAA0D;EAC1D,qBAAwD;EACxD,yCAA+D;EAC/D,iFAAiJ,EAAA;EAPnJ;IxC9CI,+BwCwDkC;IxCvDlC,gCwCuDkC,EAAA;EAVtC;IxChCI,mCwC8CqC;IxC7CrC,kCwC6CqC,EAAA;EAdzC;IAmBI,0CAA4E;IAC5E,oBAAoB;IACpB,kDAAiF,EAAA;EArBrF;IA0BI,UAAU;IACV,wCAAwE;IACxE,gDAA6E;IAC7E,sDAA6F,EAAA;EA7BjG;IAkCI,mBAAmB,EAAA;IAlCvB;MAqCM,wDAAwF;MACxF,mDAAmF,EAAA;;AAarF;EACE,mBAAmB,EAAA;EADrB;IxCnDA,6DwCwD6G;IxCpE7G,0BwCqEsC,EAAA;EANtC;IxC/DA,2DwCyEwG;IxC7DxG,4BwC8D2C,EAAA;EAX3C;IAeM,aAAa,EAAA;EAfnB;IAmBM,mDAAmF;IACnF,oBAAoB,EAAA;IApB1B;MAuBQ,yDAAyF;MACzF,oDAAoF,EAAA;;AjCtF5F;EiC8DA;IACE,mBAAmB,EAAA;IADrB;MxCnDA,6DwCwD6G;MxCpE7G,0BwCqEsC,EAAA;IANtC;MxC/DA,2DwCyEwG;MxC7DxG,4BwC8D2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AjCvFP;EiC8DA;IACE,mBAAmB,EAAA;IADrB;MxCnDA,6DwCwD6G;MxCpE7G,0BwCqEsC,EAAA;IANtC;MxC/DA,2DwCyEwG;MxC7DxG,4BwC8D2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AjCvFP;EiC8DA;IACE,mBAAmB,EAAA;IADrB;MxCnDA,6DwCwD6G;MxCpE7G,0BwCqEsC,EAAA;IANtC;MxC/DA,2DwCyEwG;MxC7DxG,4BwC8D2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AjCvFP;EiC8DA;IACE,mBAAmB,EAAA;IADrB;MxCnDA,6DwCwD6G;MxCpE7G,0BwCqEsC,EAAA;IANtC;MxC/DA,2DwCyEwG;MxC7DxG,4BwC8D2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AjCvFP;EiC8DA;IACE,mBAAmB,EAAA;IADrB;MxCnDA,6DwCwD6G;MxCpE7G,0BwCqEsC,EAAA;IANtC;MxC/DA,2DwCyEwG;MxC7DxG,4BwC8D2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AAaX;ExChJI,gBwCiJsB,EAAA;EAD1B;IAII,mDAAmF,EAAA;IAJvF;MAOM,sBAAsB,EAAA;;ACtK1B;EACE,c5B8MiC;E4B7MjC,yB5BwMiC,EAAA;E4B1MnC;IAOM,c5BwM6B;I4BvM7B,yB5BuM6B,EAAA;E4B/MnC;IAYM,W1C0IO;I0CzIP,yB5BkM6B;I4BjM7B,qB5BiM6B,EAAA;;A4B/MnC;EACE,c5B8MiC;E4B7MjC,yB5BwMiC,EAAA;E4B1MnC;IAOM,c5BwM6B;I4BvM7B,yB5BuM6B,EAAA;E4B/MnC;IAYM,W1C0IO;I0CzIP,yB5BkM6B;I4BjM7B,qB5BiM6B,EAAA;;A4B/MnC;EACE,c5B8MiC;E4B7MjC,yB5BwMiC,EAAA;E4B1MnC;IAOM,c5BwM6B;I4BvM7B,yB5BuM6B,EAAA;E4B/MnC;IAYM,W1C0IO;I0CzIP,yB5BkM6B;I4BjM7B,qB5BiM6B,EAAA;;A4B/MnC;EACE,c5B8MiC;E4B7MjC,yB5BwMiC,EAAA;E4B1MnC;IAOM,c5BwM6B;I4BvM7B,yB5BuM6B,EAAA;E4B/MnC;IAYM,W1C0IO;I0CzIP,yB5BkM6B;I4BjM7B,qB5BiM6B,EAAA;;A4B/MnC;EACE,c5B8MiC;E4B7MjC,yB5BwMiC,EAAA;E4B1MnC;IAOM,c5BwM6B;I4BvM7B,yB5BuM6B,EAAA;E4B/MnC;IAYM,W1C0IO;I0CzIP,yB5BkM6B;I4BjM7B,qB5BiM6B,EAAA;;A4B/MnC;EACE,c5B8MiC;E4B7MjC,yB5BwMiC,EAAA;E4B1MnC;IAOM,c5BwM6B;I4BvM7B,yB5BuM6B,EAAA;E4B/MnC;IAYM,W1C0IO;I0CzIP,yB5BkM6B;I4BjM7B,qB5BiM6B,EAAA;;A4B/MnC;EACE,c5B8MiC;E4B7MjC,yB5BwMiC,EAAA;E4B1MnC;IAOM,c5BwM6B;I4BvM7B,yB5BuM6B,EAAA;E4B/MnC;IAYM,W1C0IO;I0CzIP,yB5BkM6B;I4BjM7B,qB5BiM6B,EAAA;;A4B/MnC;EACE,c5B8MiC;E4B7MjC,yB5BwMiC,EAAA;E4B1MnC;IAOM,c5BwM6B;I4BvM7B,yB5BuM6B,EAAA;E4B/MnC;IAYM,W1C0IO;I0CzIP,yB5BkM6B;I4BjM7B,qB5BiM6B,EAAA;;A6B9MrC;EACE,uBAAuB;EACvB,U3CmrD8B;E2ClrD9B,W3CkrD8B;E2CjrD9B,sB3CmrDgC;E2ClrDhC,W3C0Ja;E2CzJb,0FAA0F;EAC1F,SAAS;E1COP,sBD2mBgC;E2ChnBlC,Y3CmrD6B,EAAA;E2C5rD/B;IAaI,W3CkJW;I2CjJX,qBAAqB;IACrB,a3C8qD4B,EAAA;E2C7rDhC;IAmBI,UAAU;IACV,4C3C+JgB;I2C9JhB,U3CyqD0B,EAAA;E2C9rD9B;IA0BI,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;IACjB,a3CmqD4B,EAAA;;A2C/pDhC;EACE,kD3C+pDqE,EAAA;;A4CrsDvE;EAEE,uBAAuC;EACvC,6BAA6C;EAC7C,4BAA6C;EAC7C,wBAAyC;EACzC,2BAA6C;E9C+RzC,8BAvE+B;E8CtNnC,kBAAqC;EACrC,wCAA+B;EAC/B,4BAAmD;EACnD,2CAAmD;EACnD,iCAAqD;EACrD,uDAA+C;EAC/C,gCAAmD;EACnD,+CAA6C;EAC7C,mDAAiE;EAGjE,gCAAwD;EACxD,eAAe;E9CiRX,oCAvE+B;E8CxMnC,4BAAgD;EAChD,oBAAoB;EACpB,oCAAqD;EACrD,4BAA4B;EAC5B,uEAA6H;EAC7H,sCAA+D;E3CR7D,4C2CS8E,EAAA;EA5BlF;IA+BI,UAAU,EAAA;EA/Bd;IAmCI,aAAa,EAAA;;AAIjB;EACE,uBAAuC;EAEvC,kBAAkB;EAClB,+BAAoD;EACpD,kBAAkB;EAClB,eAAe;EACf,oBAAoB,EAAA;EAPtB;IAUI,sCAA4D,EAAA;;AAIhE;EACE,aAAa;EACb,mBAAmB;EACnB,4DAA4G;EAC5G,mCAA8D;EAC9D,2CAAmE;EACnE,4BAA4B;EAC5B,qFAAkJ;E3ChChJ,0F2CiCkJ;E3ChClJ,2F2CgCkJ,EAAA;EARtJ;IAWI,mDAA2E;IAC3E,sCAA8D,EAAA;;AAIlE;EACE,kCAA0D;EAC1D,qBAAqB,EAAA;;AC9DvB;EAEE,uBAAuC;EACvC,uBAAqC;EACrC,2BAAyC;EACzC,yBAAuC;EACvC,kBAAqC;EACrC,mBAA+B;EAC/B,+CAAmD;EACnD,4BAAmD;EACnD,gCAAqD;EACrD,8DAA+C;EAC/C,kDAAiE;EACjE,oCAA2D;EAC3D,oCAA2D;EAC3D,0CAAuD;EACvD,sDAAiE;EACjE,iCAAiE;EACjE,iCAA6D;EAC7D,6BAA+C;EAC/C,sBAA6C;EAC7C,sDAAiE;EACjE,iCAAiE;EAGjE,eAAe;EACf,MAAM;EACN,OAAO;EACP,+BAAoD;EACpD,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAGhB,UAAU,EAAA;;AAOZ;EACE,kBAAkB;EAClB,WAAW;EACX,8BAAmD;EAEnD,oBAAoB,EAAA;EAGpB;I5B5CI,mCjB2gDoD;I6C79CtD,8B7C29CmD,EAAA;IiBrgDjD;M4BwCJ;Q5BvCM,gBAAgB,EAAA,E4B0CrB;EACD;IACE,e7Cy9CoC,EAAA;E6Cr9CtC;IACE,sB7Cs9C2C,EAAA;;A6Cl9C/C;EACE,+CAAoE,EAAA;EADtE;IAII,gBAAgB;IAChB,gBAAgB,EAAA;EALpB;IASI,gBAAgB,EAAA;;AAIpB;EACE,aAAa;EACb,mBAAmB;EACnB,mDAAwE,EAAA;;AAI1E;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EAEX,4BAAgD;EAChD,oBAAoB;EACpB,oCAAqD;EACrD,4BAA4B;EAC5B,uEAA6H;E5CrF3H,4C4CsF8E;EAGhF,UAAU,EAAA;;AAIZ;EAEE,0BAA6C;EAC7C,sBAAqC;EACrC,0BAA+C;EClH/C,eAAe;EACf,MAAM;EACN,OAAO;EACP,kCDkH2E;ECjH3E,YAAY;EACZ,aAAa;EACb,uCD+GsH,EAAA;EC5GtH;IAAS,UAAU,EAAA;EACnB;IAAS,mCD2GkK,EAAA;;AAK7K;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,uCAAoE;EACpE,4FAAgK;E5CtG9J,2D4CuG8F;E5CtG9F,4D4CsG8F,EAAA;EAPlG;IAUI,gGAA8J;IAC9J,mJAAgP,EAAA;;AAKpP;EACE,gBAAgB;EAChB,8CAA8E,EAAA;;AAKhF;EACE,kBAAkB;EAGlB,cAAc;EACd,gCAAsD,EAAA;;AAIxD;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,wEAAuH;EACvH,2CAAmE;EACnE,yFAA6J;E5C1H3J,+D4C2HiG;E5C1HjG,8D4C0HiG,EAAA;EATrG;IAeI,6CAAsE,EAAA;;ArC5GtE;EqCtDJ;IAyKI,0BAAuC;IACvC,uDAA+C,EAAA;EA/HnD;IAoII,gCAAoD;IACpD,kBAAkB;IAClB,iBAAiB,EAAA;EAGnB;IACE,uBAAqC,EAAA,EACtC;;ArChIC;EqCoIF;;IAEE,uBAAqC,EAAA,EACtC;;ArCvIC;EqC2IF;IACE,wBAAqC,EAAA,EACtC;;AASC;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,SAAS,EAAA;EAJX;IAOI,YAAY;IACZ,SAAS;I5C1Mb,gB4C2M4B,EAAA;EAT5B;;I5ClMA,gB4CgN4B,EAAA;EAd5B;IAkBI,gBAAgB,EAAA;;ArC3JpB;EqCyIA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M5C1Mb,gB4C2M4B,EAAA;IAT5B;;M5ClMA,gB4CgN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;ArC5JH;EqCyIA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M5C1Mb,gB4C2M4B,EAAA;IAT5B;;M5ClMA,gB4CgN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;ArC5JH;EqCyIA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M5C1Mb,gB4C2M4B,EAAA;IAT5B;;M5ClMA,gB4CgN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;ArC5JH;EqCyIA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M5C1Mb,gB4C2M4B,EAAA;IAT5B;;M5ClMA,gB4CgN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;ArC5JH;EqCyIA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M5C1Mb,gB4C2M4B,EAAA;IAT5B;;M5ClMA,gB4CgN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;AEvOP;EAEE,yBAA2C;EAC3C,6BAAiD;EACjD,8BAAiD;EACjD,8BAAiD;EACjD,sBAA2C;EjD8RvC,kCAvE+B;EiDrNnC,wBAAyC;EACzC,qBAAmC;EACnC,kCAAyD;EACzD,yBAA6C;EAC7C,gCAAqD;EACrD,iCAAuD;EAGvD,iCAAwD;EACxD,cAAc;EACd,uCAAoE;EACpE,gCAAuD;ECnBvD,sChDirB6E;EgD/qB7E,kBAAkB;EAClB,gBhD0rB+B;EgDzrB/B,gBhDgsB+B;EgD/rB/B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;ElDsRZ,sCAvE+B;EiDnMnC,qBAAqB;EACrB,UAAU,EAAA;EA3BZ;IA6BW,kCAA0D,EAAA;EA7BrE;IAgCI,cAAc;IACd,oCAAgE;IAChE,sCAAmE,EAAA;IAlCvE;MAqCM,kBAAkB;MAClB,WAAW;MACX,yBAAyB;MACzB,mBAAmB,EAAA;;AAKzB;EACE,SAAS,EAAA;EADX;IAII,SAAS;IACT,uFAAgJ;IAChJ,sCAAyD,EAAA;;AAI7D,qBAAA;AACA;EACE,OAAO;EACP,qCAAkE;EAClE,qCAAiE,EAAA;EAHnE;IAMI,WAAW;IACX,gIAAqN;IACrN,wCAA2D,EAAA;;AAI/D,mBAAA;AAEA;EACE,MAAM,EAAA;EADR;IAII,YAAY;IACZ,uFAAgJ;IAChJ,yCAA4D,EAAA;;AAIhE,qBAAA;AACA;EACE,QAAQ;EACR,qCAAkE;EAClE,qCAAiE,EAAA;EAHnE;IAMI,UAAU;IACV,gIAAqN;IACrN,uCAA0D,EAAA;;AAI9D,mBAAA;AAkBA;EACE,sCAAgE;EAChE,gEAAoH;EACpH,8BAAoD;EACpD,kBAAkB;EAClB,sCAAyD;E9ClGvD,8C8CmGkF,EAAA;;AEtHtF;EAEE,yBAA2C;EAC3C,6BAAiD;EnDkS7C,iCAvE+B;EmDzNnC,qBAAmC;EACnC,8BAAuD;EACvD,iDAAuD;EACvD,mCAAyD;EACzD,qDAAqE;EACrE,0DAAmD;EACnD,mCAA+D;EAC/D,qCAA+D;EnDyR3D,wCAvE+B;EmDhNnC,2BAAuD;EACvD,4CAAiD;EACjD,iCAA2D;EAC3D,iCAA2D;EAC3D,6CAAmD;EACnD,8BAAqD;EACrD,iCAAuD;EACvD,yDAAuD;EAGvD,iCAAwD;EACxD,cAAc;EACd,sCAAgE;EDzBhE,sChDirB6E;EgD/qB7E,kBAAkB;EAClB,gBhD0rB+B;EgDzrB/B,gBhDgsB+B;EgD/rB/B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;ElDsRZ,sCAvE+B;EmD9LnC,qBAAqB;EACrB,sCAAyD;EACzD,4BAA4B;EAC5B,2EAAqI;EhDhBnI,8CgDiBkF,EAAA;EApCtF;IAwCI,cAAc;IACd,oCAAgE;IAChE,sCAAmE,EAAA;IA1CvE;MA8CM,kBAAkB;MAClB,cAAc;MACd,WAAW;MACX,yBAAyB;MACzB,mBAAmB;MACnB,eAAe,EAAA;;AAKrB;EAEI,oFAA8I,EAAA;EAFlJ;IAMM,uFAAgJ,EAAA;EANtJ;IAUM,SAAS;IACT,gDAA6E,EAAA;EAXnF;IAeM,sCAAmE;IACnE,sCAAyD,EAAA;;AAK/D,qBAAA;AACA;EAEI,kFAA4I;EAC5I,qCAAkE;EAClE,qCAAiE,EAAA;EAJrE;IAQM,gIAAqN,EAAA;EAR3N;IAYM,OAAO;IACP,kDAA+E,EAAA;EAbrF;IAiBM,oCAAiE;IACjE,wCAA2D,EAAA;;AAKjE,mBAAA;AAEA;EAEI,iFAA2I,EAAA;EAF/I;IAMM,uFAAgJ,EAAA;EANtJ;IAUM,MAAM;IACN,mDAAgF,EAAA;EAXtF;IAeM,mCAAgE;IAChE,yCAA4D,EAAA;;AAhBlE;EAsBI,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,cAAc;EACd,oCAAgE;EAChE,sDAAkF;EAClF,WAAW;EACX,+EAAsI,EAAA;;AAI1I,qBAAA;AACA;EAEI,mFAA6I;EAC7I,qCAAkE;EAClE,qCAAiE,EAAA;EAJrE;IAQM,gIAAqN,EAAA;EAR3N;IAYM,QAAQ;IACR,iDAA8E,EAAA;EAbpF;IAiBM,qCAAkE;IAClE,uCAA0D,EAAA;;AAKhE,mBAAA;AAkBA;EACE,8EAAgJ;EAChJ,gBAAgB;EnDiHZ,6CAvE+B;EmDxCnC,qCAAkE;EAClE,6CAAuE;EACvE,kFAA4I;EhD5J1I,6DgD6JkG;EhD5JlG,8DgD4JkG,EAAA;EAPtG;IAUI,aAAa,EAAA;;AAIjB;EACE,0EAAwI;EACxI,mCAA8D,EAAA;;ACrLhE;EACE,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB,EAAA;ECtBhB;IACE,cAAc;IACd,WAAW;IACX,WAAW,EAAA;;ADuBf;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,2BAA2B;EjClBvB,sCjBgpDkF,EAAA;EiB5oDlF;IiCQN;MjCPQ,gBAAgB,EAAA,EiCevB;;AAED;;;EAGE,cAAc,EAAA;;AAGhB;;EAEE,2BAA2B,EAAA;;AAG7B;;EAEE,4BAA4B,EAAA;;AAQ9B;EAEI,UAAU;EACV,4BAA4B;EAC5B,eAAe,EAAA;;AAJnB;;;EAUI,UAAU;EACV,UAAU,EAAA;;AAXd;;EAgBI,UAAU;EACV,UAAU;EjC5DR,2BjB+oDkC,EAAA;EiB3oDlC;IiCuCN;;MjCtCQ,gBAAgB,EAAA,EiCyDrB;;AAQH;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EAEV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UlDuiDsC;EkDtiDtC,UAAU;EACV,WlDwDa;EkDvDb,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,YlDkiDqC;EiBxnDjC,8BjB0nDgD,EAAA;EiBtnDhD;IiCkEN;;MjCjEQ,gBAAgB,EAAA,EiC4FvB;EA3BD;;;IAsBI,WlD8CW;IkD7CX,qBAAqB;IACrB,UAAU;IACV,YlD0hDmC,EAAA;;AkDvhDvC;EACE,OAAO,EAAA;;AAGT;EACE,QAAQ,EAAA;;AAKV;;EAEE,qBAAqB;EACrB,WlD2hDuC;EkD1hDvC,YlD0hDuC;EkDzhDvC,4BAA4B;EAC5B,wBAAwB;EACxB,0BAA0B,EAAA;;AAG5B;;;;;;;G7D0u0CG;A6Dlu0CH;EACE,0DpCRgF,EAAA;;AoCUlF;EACE,0DpCXgF,EAAA;;AoCmBlF;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,UAAU;EAEV,iBlDm+CsC;EkDl+CtC,mBAAmB;EACnB,gBlDi+CsC;EkDh+CtC,gBAAgB,EAAA;EAblB;IAgBI,uBAAuB;IACvB,cAAc;IACd,WlDg+CqC;IkD/9CrC,WlDg+CoC;IkD/9CpC,UAAU;IACV,iBlDg+CoC;IkD/9CpC,gBlD+9CoC;IkD99CpC,mBAAmB;IACnB,eAAe;IACf,sBlDzBW;IkD0BX,4BAA4B;IAC5B,SAAS;IAET,kCAAiE;IACjE,qCAAoE;IACpE,YlDu9CmC;IiBhoDjC,6BjBmoD+C,EAAA;IiB/nD/C;MiCsIN;QjCrIQ,gBAAgB,EAAA,EiCsKrB;EAjCH;IAoCI,UlDo9CkC,EAAA;;AkD38CtC;EACE,kBAAkB;EAClB,UAA4C;EAC5C,elD88C0C;EkD78C1C,SAA2C;EAC3C,oBlD28C0C;EkD18C1C,uBlD08C0C;EkDz8C1C,WlDpDa;EkDqDb,kBAAkB,EAAA;;AAKpB;;EAGI,gClD68CyD,EAAA;;AkDh9C7D;EAOI,sBlDvDW,EAAA;;AkDgDf;EAWI,WlD3DW,EAAA;;AoDhKf;;EAEE,qBAAqB;EACrB,8BAAoD;EACpD,gCAAuD;EACvD,gDAA+E;EAE/E,kBAAkB;EAClB,6FAA4J,EAAA;;AAI9J;EACE;IAAK,0CAA+C,EAAA,EAAA;;AAItD;EAEE,wBAAyC;EACzC,yBAA2C;EAC3C,qCAA2D;EAC3D,iCAAuD;EACvD,mCAA6D;EAC7D,2CAA2D;EAG3D,yDAAsF;EACtF,+BAA+B,EAAA;;AAGjC;EAEE,wBAAyC;EACzC,yBAA2C;EAC3C,gCAAuD,EAAA;;AASzD;EACE;IACE,mBAAmB,EAAA;EAErB;IACE,UAAU;IACV,eAAe,EAAA,EAAA;;AAKnB;EAEE,wBAAyC;EACzC,yBAA2C;EAC3C,qCAA2D;EAC3D,mCAA6D;EAC7D,yCAA2D;EAG3D,8BAA8B;EAC9B,UAAU,EAAA;;AAGZ;EACE,wBAAyC;EACzC,yBAA2C,EAAA;;AAI3C;EACE;;IAEE,kCAA6D,EAAA,EAC9D;;AChFL;EAEE,2BAA+C;EAC/C,2BAA6C;EAC7C,2BAA+C;EAC/C,iCAAqD;EACrD,iCAAqD;EACrD,sBAA6C;EAC7C,uBAAuC;EACvC,gCAA2D;EAC3D,mDAA2D;EAC3D,kEAAuD,EAAA;;A7C+DrD;E6C9CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IpC1BV,sCoC4BwE,EAAA,EAqE3E;EpC7FG;IoCUJ;MpCTM,gBAAgB,EAAA,EoC4FrB;;A7CrCC;I6C9CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A7C3BH;E6CjCF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A7ClCL;E6C9CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IpC1BV,sCoC4BwE,EAAA,EAqE3E;EpC7FG;IoCUJ;MpCTM,gBAAgB,EAAA,EoC4FrB;;A7CrCC;I6C9CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A7C3BH;E6CjCF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A7ClCL;E6C9CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IpC1BV,sCoC4BwE,EAAA,EAqE3E;EpC7FG;IoCUJ;MpCTM,gBAAgB,EAAA,EoC4FrB;;A7CrCC;I6C9CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A7C3BH;E6CjCF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A7ClCL;E6C9CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IpC1BV,sCoC4BwE,EAAA,EAqE3E;EpC7FG;IoCUJ;MpCTM,gBAAgB,EAAA,EoC4FrB;;A7CrCC;I6C9CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A7C3BH;E6CjCF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A7ClCL;E6C9CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IpC1BV,sCoC4BwE,EAAA,EAqE3E;EpC7FG;IoCUJ;MpCTM,gBAAgB,EAAA,EoC4FrB;;A7CrCC;I6C9CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A7C3BH;E6CjCF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;AAhFP;EAEI,eAAe;EACf,SAAS;EACT,mCAA4D;EAC5D,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gCAAwD;EACxD,kBAAkB;EAClB,wCAA6D;EAC7D,4BAA4B;EAC5B,UAAU;EpC1BV,sCoC4BwE,EAAA;EpCxBxE;IoCUJ;MpCTM,gBAAgB,EAAA,EoC4FrB;EAnFD;IAiBM,MAAM;IACN,OAAO;IACP,gCAAwD;IACxD,qFAAmJ;IACnJ,4BAA4B,EAAA;EArBlC;IAyBM,MAAM;IACN,QAAQ;IACR,gCAAwD;IACxD,oFAAkJ;IAClJ,2BAA2B,EAAA;EA7BjC;IAiCM,MAAM;IACN,QAAQ;IACR,OAAO;IACP,kCAA2D;IAC3D,gBAAgB;IAChB,sFAAoJ;IACpJ,4BAA4B,EAAA;EAvClC;IA2CM,QAAQ;IACR,OAAO;IACP,kCAA2D;IAC3D,gBAAgB;IAChB,mFAAiJ;IACjJ,2BAA2B,EAAA;EAhDjC;IAqDM,eAAe,EAAA;EArDrB;IA2DM,mBAAmB,EAAA;;AA2B3B;EPlHE,eAAe;EACf,MAAM;EACN,OAAO;EACP,a9C+pCsC;E8C9pCtC,YAAY;EACZ,aAAa;EACb,sB9C4Ja,EAAA;E8CzJb;IAAS,UAAU,EAAA;EACnB;IAAS,Y9C8/C2B,EAAA;;AqDl5CtC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oEAA4H,EAAA;EAJ9H;IAOI,0FAAkJ;IAClJ,qDAAiF;IACjF,uDAAmF;IACnF,wDAAoF,EAAA;;AAIxF;EACE,gBAAgB;EAChB,gBrD6jB+B,EAAA;;AqD1jBjC;EACE,YAAY;EACZ,oEAA4H;EAC5H,gBAAgB,EAAA;;AC9IlB;EACE,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAC9B,YtDm1CoC,EAAA;EsDz1CtC;IASI,qBAAqB;IACrB,WAAW,EAAA;;AAKf;EACE,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB,EAAA;;AAGlB;EACE,iBAAiB,EAAA;;AAInB;EAEI,mDAAmD,EAAA;;AAIvD;EACE;IACE,YtDszCkC,EAAA,EAAA;;AsDlzCtC;EACE,+EAA8G;EAC9G,oBAAoB;EACpB,8CAA8C,EAAA;;AAGhD;EACE;IACE,uBAAuB,EAAA,EAAA;;AH9CzB;EACE,cAAc;EACd,WAAW;EACX,WAAW,EAAA;;AIAb;EACE,sBAAwE;EACxE,wEAAyH,EAAA;;AAF3H;EACE,sBAAwE;EACxE,uEAAyH,EAAA;;AAF3H;EACE,sBAAwE;EACxE,wEAAyH,EAAA;;AAF3H;EACE,sBAAwE;EACxE,wEAAyH,EAAA;;AAF3H;EACE,sBAAwE;EACxE,uEAAyH,EAAA;;AAF3H;EACE,sBAAwE;EACxE,wEAAyH,EAAA;;AAF3H;EACE,sBAAwE;EACxE,yEAAyH,EAAA;;AAF3H;EACE,sBAAwE;EACxE,sEAAyH,EAAA;;ACN3H;EACE,yBAAwB,EAAA;EAD1B;IAMM,yBAA8J,EAAA;;AANpK;EACE,yBAAwB,EAAA;EAD1B;IAMM,yBAA8J,EAAA;;AANpK;EACE,yBAAwB,EAAA;EAD1B;IAMM,yBAA8J,EAAA;;AANpK;EACE,yBAAwB,EAAA;EAD1B;IAMM,yBAA8J,EAAA;;AANpK;EACE,yBAAwB,EAAA;EAD1B;IAMM,yBAA8J,EAAA;;AANpK;EACE,yBAAwB,EAAA;EAD1B;IAMM,yBAA8J,EAAA;;AANpK;EACE,yBAAwB,EAAA;EAD1B;IAMM,yBAA8J,EAAA;;AANpK;EACE,yBAAwB,EAAA;EAD1B;IAMM,yBAA8J,EAAA;;ACLtK;EACE,kBAAkB;EAClB,WAAW,EAAA;EAFb;IAKI,cAAc;IACd,mCAAwD;IACxD,WAAW,EAAA;EAPf;IAWI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY,EAAA;;AAKd;EACE,uBAAuC,EAAA;;AADzC;EACE,qCAAuC,EAAA;;AADzC;EACE,sCAAuC,EAAA;;AADzC;EACE,sCAAuC,EAAA;;ACrB3C;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,a1D4pCsC,EAAA;;A0DzpCxC;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,OAAO;EACP,a1DopCsC,EAAA;;A0D5oCpC;EACE,gBAAgB;EAChB,MAAM;EACN,a1DwoCkC,EAAA;;A0DroCpC;EACE,gBAAgB;EAChB,SAAS;EACT,a1DkoCkC,EAAA;;AQnmCpC;EkDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a1DwoCkC,EAAA;E0DroCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a1DkoCkC,EAAA,E0DjoCnC;;AlD8BD;EkDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a1DwoCkC,EAAA;E0DroCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a1DkoCkC,EAAA,E0DjoCnC;;AlD8BD;EkDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a1DwoCkC,EAAA;E0DroCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a1DkoCkC,EAAA,E0DjoCnC;;AlD8BD;EkDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a1DwoCkC,EAAA;E0DroCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a1DkoCkC,EAAA,E0DjoCnC;;AlD8BD;EkDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a1DwoCkC,EAAA;E0DroCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a1DkoCkC,EAAA,E0DjoCnC;;AChCL;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,mBAAmB,EAAA;;ACRrB;;ECIE,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;EAC9B,oBAAoB,EAAA;;ACZtB;EAEI,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,U9DoiBuC;E8DniBvC,WAAW,EAAA;;ACRf;ECAE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;ACNrB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,8BAA8B;EAC9B,ajEwwB+B,EAAA;;AkE5sBzB;EAOI,mCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,mCAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,uDAA+D,EAAA;;AAPnE;EAOI,8DAA+D,EAAA;;AAPnE;EAOI,wDAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,kBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,2CAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,uFAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,2FAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,6FAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,8FAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,4FAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,gFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,6EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,4EAA+D,EAAA;;AAjBnE;EACE,sBAAoC,EAAA;;AADtC;EACE,sBAAoC,EAAA;;AADtC;EACE,sBAAoC,EAAA;;AADtC;EACE,sBAAoC,EAAA;;AADtC;EACE,sBAAoC,EAAA;;AADtC;EACE,wBAAoC,EAAA;;AADtC;EACE,yBAAoC,EAAA;;AADtC;EACE,wBAAoC,EAAA;;AADtC;EACE,yBAAoC,EAAA;;AADtC;EACE,sBAAoC,EAAA;;AAStC;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,yCAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,oCAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,yCAA+D,EAAA;;AAPnE;EAOI,wCAA+D,EAAA;;AAPnE;EAOI,wCAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,oCAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,uCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,0BAA+D;EAA/D,yBAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,+BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,4BAA+D,EAAA;;AAPnE;EAOI,+BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,4BAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,4BAA+D,EAAA;;AAPnE;EAOI,wBAA+D;EAA/D,2BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,gCAA+D,EAAA;;AAPnE;EAOI,2BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,gCAA+D,EAAA;;AAPnE;EAOI,2BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,2BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,iCAA+D;EAA/D,gCAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,6BAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D;EAA/D,kCAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,4BAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,4BAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,2BAA+D;EAA/D,0BAA+D,EAAA;;AAPnE;EAOI,iCAA+D;EAA/D,gCAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,6BAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,6BAA+D,EAAA;;AAPnE;EAOI,yBAA+D;EAA/D,4BAA+D,EAAA;;AAPnE;EAOI,+BAA+D;EAA/D,kCAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,4BAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,4BAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,iBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,gDAA+D,EAAA;;AAPnE;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,8CAA+D,EAAA;;AAPnE;EAOI,kDAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,qCAA+D,EAAA;;AAPnE;EAOI,wCAA+D,EAAA;;AAPnE;EAOI,oCAA+D,EAAA;;AAPnE;EAOI,oCAA+D,EAAA;;AAPnE;EAOI,qCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AArBnE,qBAAA;AAcA;EAOI,gCAA+D;EAA/D,iCAA+D,EAAA;;AAmBnE,mBAAA;AA1BA;EAIQ,oBAA4B;EAGhC,qEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,uEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,qEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,kEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,qEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,oEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,mEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,kEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,mEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,mEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,wEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,yBAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,oCAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0CAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,yBAA+D,EAAA;;AAjBnE;EACE,uBAAoC,EAAA;;AADtC;EACE,sBAAoC,EAAA;;AADtC;EACE,uBAAoC,EAAA;;AADtC;EACE,oBAAoC,EAAA;;AAStC;EAIQ,kBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,gFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,6EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,wCAA+D,EAAA;;AAjBnE;EACE,oBAAoC,EAAA;;AADtC;EACE,qBAAoC,EAAA;;AADtC;EACE,oBAAoC,EAAA;;AADtC;EACE,qBAAoC,EAAA;;AADtC;EACE,kBAAoC,EAAA;;AAStC;EAOI,+CAA+D,EAAA;;AAPnE;EAOI,mCAA+D;UAA/D,2BAA+D,EAAA;;AAPnE;EAOI,oCAA+D;UAA/D,4BAA+D,EAAA;;AAPnE;EAOI,oCAA+D;UAA/D,4BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,oDAA+D,EAAA;;AAPnE;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,oDAA+D,EAAA;;AAPnE;EAOI,oDAA+D,EAAA;;AAPnE;EAOI,qDAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,sDAA+D,EAAA;;AAPnE;EAOI,0DAA+D;EAA/D,2DAA+D,EAAA;;AAPnE;EAOI,2DAA+D;EAA/D,8DAA+D,EAAA;;AAPnE;EAOI,8DAA+D;EAA/D,6DAA+D,EAAA;;AAPnE;EAOI,6DAA+D;EAA/D,0DAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;A1DVvE;E0DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;A1DZL;E0DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;A1DZL;E0DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;A1DZL;E0DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;A1DZL;E0DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;ACxDT;ED+CQ;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA,EAElE;;ACrCT;ED4BQ;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA,EAElE;;AE3ET;;;;;;;C/E228CC;AgFj28CD;EACI,wBAAwB;EACxB,6CAA2C;EAC3C,sFAAqF;EACrF,gBAAgB,EAAA;;AAGpB;EACI,wBAAwB;EACxB,6CAA6C;EAC7C,wFAAyF;EACzF,gBAAgB,EAAA;;AAEpB;EACI,wBAAwB;EACxB,6CAA4C;EAC5C,uFAAuF;EACvF,gBAAgB,EAAA;;AAEpB;EACI,wBAAwB;EACxB,6CAA8C;EAC9C,yFAA2F;EAC3F,gBAAgB,EAAA;;AAEpB;EACI,wBAAwB;EAExB,qFAAmF;EACnF,gBAAgB,EAAA;;AxEvCpB;EyEKE,gDAA+C;EAC/C,mDAA+D;EAC/D,mDAA2E;EAC3E,mDAA6E;EAC7E,mDAAuE;EACvE,mDAAmF;EACnF,mDAAqF;EACrF,mDAAiE;EAGjE,mDAAyD;EACzD,mDAAyE;EACzE,gDAAqF;EACrF,gDAAuF;EACvF,mDAAiF;EACjF,kDAA6F;EAC7F,mDAA+F;EAC/F,oDAA2E;EAG3E,qBAAiC;EACjC,gCAAiD;EAEjD,6BAA2C;EAC3C,qCAA2D;EAG3D,8BAA+C;EAE/C,4BAA2C;EAC3C,iCAAqD;EAGrD,oBAAiC;EACjC,0BAAuC;EAGvC,oBAAiC;EACjC,+BAAiD;EACjD,sCAA+D;EAG/D,qCAAmE;EACnE,6BAAiD;EAEjD,qEAA6E;EAC7E,qCAA2D;EAC3D,4EAA2E;EAC3E,iDAAyF;EACzF,mEAAmF;EAGnF,2BAAyC;EAGzC,2BAAyC;EAIzC,wBAAmC;EACnC,8BAA+C;EAG/C,2BAAuC;EAGvC,yBAA2C;EAC3C,0BAA2C;EAC3C,0BAA6C;EAgB7C,iCAAqD;EAGrD,mBAA+B;EAC/B,0BAAuC;EACvC,gCAAmD;EACnD,+BAAiD;EAGjD,kCAAuD;EAGvD,+CAAmD,EAAA;EAnGrD;IA2EI,+CAA6D,EAAA;EA3EjE;IAgFI,4CAAmC;IACnC,+CAAmD;IACnD,+CAAyD;IACzD,+CAAiE,EAAA;;AjF+28CrE;EkFt68CI,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAIpC,sBAA8B;EAC9B,6BAAsC;EACtC,wBAAmC;EACnC,kCAA2C;EAG3C,mDAA+C;EAC/C,mDAA+D;EAC/D,mDAA2E;EAC3E,mDAA6E;EAC7E,mDAAuE;EACvE,mDAAmF;EACnF,mDAAqF;EACrF,mDAAiE;EAGjE,mDAAyD;EACzD,mDAAyE;EACzE,gDAAqF;EACrF,gDAAuF;EACvF,mDAAiF;EACjF,kDAA6F;EAC7F,mDAA+F;EAC/F,oDAA2E;EAG3E,wBAAiC;EACjC,gCAAiD;EAEjD,6BAA2C;EAC3C,qCAA2D;EAG3D,8BAA+C;EAE/C,4BAA2C;EAC3C,iCAAqD;EAGrD,uBAAiC;EACjC,0BAAuC;EAGvC,uBAAiC;EACjC,+BAAiD;EACjD,mCAA+D;EAG/D,qCAAmE;EACnE,6BAAiD;EAGjD,qEAA6E;EAC7E,qCAA2D;EAC3D,4EAA2E;EAC3E,iDAAyF;EACzF,mEAAmF;EAGnF,2BAAyC;EAGzC,2BAAyC;EAGzC,mBAAyB;EACzB,0BAAiC;EACjC,kBAAuB;EACvB,4BAA+B;EAG/B,wBAAmC;EACnC,8BAA+C;EAG/C,2BAAuC;EAgEvC,mDAA2C;EAC3C,gDAA2C;EAC3C,iDAA6C;EAuD7C,mDAAqD;EAcrD,mDAA+B;EAC/B,mDAAuC;EACvC,mDAAmD;EACnD,mDAAiD;EAGjD,mDAAuD;EAGvD,mDAAmD,EAAA;ElF2w8CnD;IkFv58CE,iDAAqC;IACrC,iDAAqD;IACrD,iDAAiE;IACjE,iDAA2D;IAC3D,6CAAyD;IACzD,iDAAmE;IACnE,iDAA6D,EAAA;ElFy58C/D;IkFp58CE,iDAAmC;IACnC,iDAAmD;IACnD,iDAAyD;IACzD,iDAAiE,EAAA;ElFs58CnE;IkFj58CE,wDAAiC;IACjC,yDAA2B;IAC3B,yDAA+C,EAAA;ElFm58CjD;IkF/48CE,wDAAiC;IACjC,qDAA2B;IAC3B,yDAA+C,EAAA;ElFi58CjD;IkF748CE,wDAA6C;IAC7C,yEAAuC;IACvC,yEAA2D,EAAA;ElF+48C7D;IkF348CE,yDAAiC;IACjC,wDAA2B;IAC3B,wDAA+C,EAAA;ElF648CjD;IkFz48CE,wDAAiC;IACjC,qDAA2B;IAC3B,wDAA+C,EAAA;ElF248CjD;IkFv48CE,yDAA6C;IAC7C,wEAAuC;IACvC,wEAA2D,EAAA;ElFy48C7D;IkFp48CE,iDAA6B;IAC7B,iDAAqC,EAAA;ElFs48CvC;IkF738CE,iDAA+B,EAAA;ElF+38CjC;IkF138CE,iDAAmE;IACnE,iDAA6D,EAAA;ElF438C/D;IkFv38CE,8CAAyE;IACzE,iDAAuC;IACvC,iDAA+C,EAAA;ElFy38CjD;IkFp38CE,iDAAuC,EAAA;ElFs38CzC;IkFh38CE,iDAAqC,EAAA;ElFk38CvC;IkF728CE,yEAAsB;IACtB,wEAAqB;IACrB,uEAAoB,EAAA;ElF+28CtB;IkF328CE,qDAAiB;IACjB,0EAAc;IACd,uEAAwB;IACxB,0EAAsB;IACtB,qDAAyB,EAAA;ElF628C3B;IkFx28CE,gEAA+B;IAC/B,gEAA6C;IAC7C,kEAAmD;IACnD,mEAAiE,EAAA;ElF028CnE;IkFl28CE,iDAAmC,EAAA;ElFo28CrC;IkF/18CE,mDAAqD;IACrD,mDAAqD,EAAA;;AlFk28CzD;EkFh18CE,2GAAiE;EACjE,6DAAyE;EACzE,6DAA2D,EAAA;;AlFm18C7D;EkF/08CE,0GAAiE;EACjE,+DAAyE;EACzE,+DAA2D,EAAA;;AlFk18C7D;EkF908CE,wGAAiE;EACjE,6DAAyE;EACzE,6DAA2D,EAAA;;AlFi18C7D;EkF708CE,iGAAiE;EACjE,6DAAyE;EACzE,6DAA2D,EAAA;;AClR7D;EACI,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,aAAa;EACb,qCxEuFmF;EwEtFnF,6BAA6B;EAC7B,sBxE+FkD,EAAA;EwEvGtD;IAWQ,4CxEwnBmD,EAAA;EwErnBvD;IAdJ;MAeQ,WxED+C,EAAA,EwEGtD;;AAED;EACI,aAAa;EAEb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,YxEmEmD;EwElEnD,gCAA+D,EAAA;EAI/D;IAXJ;MAYQ,0CAA4E,EAAA,EAsBnF;EAlCD;IAiBY,oBAAoB,EAAA;EAjBhC;IAsBQ,YAAY;IACZ,WAAW,EAAA;IAEX;MAzBR;QA0BY,YAAY;QACZ,WAAW,EAAA,EAElB;EA7BL;IAgCQ,yBAA0C,EAAA;;AAIlD,WAAA;AAEA;EACI,yBAA6C,EAAA;EADjD;IAIQ,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,4CxEoC6F;IwEnC7F,gBAAgB,EAAA;EATxB;IAaQ,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,MAAM;IACN,cxEgFU,EAAA;EwEnGlB;IAuBQ,UAAU;IACV,qBAAqB,EAAA;EAGzB;IA3BJ;MA4BQ,4BAA6C,EAAA,EAEpD;;AAID;EAEQ,kBAAkB;EAClB,gBAAgB,EAAA;EAHxB;IAMY,2BxE0pC+D,EAAA;;AwErpC3E;EACI;IAEQ,aAAa,EAAA;EAFrB;IAMQ,qBAAqB,EAAA,EACxB;;AAIT;EACI,YxEvBmD;EwEwBnD,aAAa;EACb,mBAAmB,EAAA;;AAGvB;EACI,YAAY;EACZ,WAAW;EACX,iBAAiB,EAAA;;AAGrB;EACI,QAAQ;EACR,mBAAmB,EAAA;;AAGvB;EACI,WAAW;EACX,mBAAmB,EAAA;;AAInB;EADJ;IAEQ,6BACJ,EAAA,EAKH;;AARD;EAMQ,mBAAmB,EAAA;;AAI3B;EACI,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB,EAAA;EAHtB;IAMQ,kBAAkB;IAClB,UAAU,EAAA;;AAKlB;EACI,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,oCAAgE,EAAA;EAPpE;IAUQ,YAAY,EAAA;EAVpB;IAcQ,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAA;EAjB3B;IAqBQ,kDAAiF,EAAA;;AAKzF;EAGY,gBAAgB,EAAA;;AnFwi9C5B;EmF/h9CY,gBAAgB,EAAA;;AnFki9C5B;EmF3h9CQ,0CxE1GwF;EwE2GxF,sCxE3GwF,EAAA;;AXyo9ChG;EmFzh9CY,uCxE/GoG,EAAA;EX0o9C9G;ImFvh9Cc,2CxE/DD;IwEgEC,WxEhED,EAAA;;AwEsEP;EnFqh9CN;ImFph9CU,+CxElHmE,EAAA,EwE4H1E;;AnF6g9CL;EmFnh9CY,2CAAoC,EAAA;;AnFsh9ChD;EmFlh9CY,kDAAyC,EAAA;;AnFqh9CrD;EmFhh9CQ,aAAa,EAAA;;AnFmh9CrB;EmF/g9CQ,qBAAqB,EAAA;;AnFkh9C7B;EmF7g9CY,2CxE7FG;EwE8FH,WxE9FG,EAAA;;AX8m9Cf;;EmF3g9CY,+BxEnGG,EAAA;;AXkn9Cf;EmFzg9CY,yBxEtGM,EAAA;;AwE2GlB;EACI;IAEQ,gBAAgB,EAAA;IAFxB;MAKY,WAAW,EAAA,EACd;;AAKb;EACI;IACI,oBAAoB,EAAA,EACvB;;AAKG;EnF8/8CN;ImF5/8Cc,kBAAkB;IAClB,4CxEwW2C,EAAA;EXsp8CzD;ImF1/8Cc,qBAAqB;IACrB,eAAe,EAAA;EnF4/8C7B;ImFx/8Cc,kBAAkB,EAAA;EnF0/8ChC;ImFt/8Cc,cAAc;IACd,cAAc,EAAA;EnFw/8C5B;ImFn/8CkB,wCAAwC;IACxC,kBAAkB;IAClB,WAAW;IACX,gBAAgB,EAAA;InFq/8ChC;MmFl/8CoB,aAAa,EAAA;InFo/8CjC;MmFh/8CoB,cAAc,EAAA,EACjB;;AnFk/8CrB;EmF1+8CoB,aAAa,EAAA;;AnF6+8CjC;EmFz+8CoB,cAAc,EAAA;;AnF4+8ClC;EmFn+8CQ,OAAO;EACP,2CAA4D,EAAA;EAE5D;InFo+8CJ;MmFl+8CY,gBAAgB,EAAA,EACnB;;AnFo+8Cb;EmFv98CQ,6DAA0H,EAAA;EAR1H;InFk+8CJ;MmFj+8CQ,gBxE9P2C,EAAA,EwEsQlD;EALG;InFi+8CJ;MmFh+8CQ,mEAAgI,EAAA,EAIvI;;AAIO;EnF498CV;ImF398Cc,+BAA4D,EAAA,EAEnE;;AAQG;EnFq98CV;ImFp98Cc,UxElWsC,EAAA;EX0z9CpD;ImFh98Cc,WxE3WuC,EAAA;EX+z9CrD;ImF388CU,wBAAwE,EAAA,EAf3E;;AnF698CT;EmFz88CQ,aAAa,EAAA;;ACxYrB;EACI,kBzE6lB8B;EyE5lB9B,0CAAiE;EACjE,4CzEmG2E;EyElG3E,6BzEmGkD;EyElGlD,8BAAoF,EAAA;EALxF;IAQQ,6BAA6B;IAC7B,UAAU,EAAA;EATlB;IAaQ,gBAAgB;IAChB,0BAAyB;IACzB,yBAAyB,EAAA;;ApFm19CjC;EoF709CQ,iBAAiB;EACjB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS,EAAA;EAET;IpF809CJ;MoF709CQ,mBAAmB,EAAA,EAE1B;;ApF809CL;EoFx09CY,iBAAiB;EACjB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS,EAAA;EAET;IpFy09CR;MoFx09CY,mBAAmB,EAAA,EAE1B;;AC/CT;EACI,SAAS;EACT,8BAA+C;EAC/C,kBAAkB;EAClB,QAAQ;EACR,6B1E2GsD;E0E1GtD,W1EQmD;E0EPnD,Y1EuGgB;E0EtGhB,qC1EuG6C,EAAA;E0ErG7C;IAVJ;MAWQ,OAAO,EAAA,EAEd;;ArFw39CD;EqFl39CY,U1EH0C,EAAA;E0EK1C;IrFm39CR;MqFl39CY,OAAO,EAAA,EAEd;;ArFm39CT;EqF/29CY,W1Eb2C,EAAA;E0Ee3C;IrFg39CR;MqF/29CY,OAAO,EAAA,EAEd;;ArFg39CT;EqFz29CQ,kBAAkB,EAAA;;AAMtB;ErFu29CF;IqFr29CU,kBAAkB;IAClB,6BAA6B,EAAA,EAChC;;AAMD;ErFk29CN;IqFj29CU,wBAAwE,EAAA,EAE/E;;AC3DL;EACC,kB3EasD;E2EZtD,gBAAgB,EAAA;EAFjB;IAKE,yBAAyB;IACzB,gB3EsFqD,EAAA;;A2ElFvD;EACC,6BAA6B,EAAA;EAE7B;IAHD;MAIE,kB3EAqD,EAAA,E2EEtD;;AAED;EACC,wCAAqG,EAAA;;AAGtG;EACC,Y3ETsD;E2EUtD,a3EFqD;E2EGrD,sC3ENoG;E2EOpG,4B3E4Hc;E2E3Hd,SAAS;EACT,aAAa;EACb,eAAe;EACf,MAAM;EACN,4C3EX8E;E2EY9E,gCAA6C;EAC7C,6BAA6B,EAAA;EAX9B;IAeG,aAAa;IACb,mBAAmB;IACnB,wB3EXqD;I2EYrD,yC3EfkH;I2EgBlH,e3ElBmD;I2EmBnD,oC3EjCsE,EAAA;I2EazE;MAuBI,gD3ElB+H,EAAA;I2ELnI;MA2BI,+C3EvB6H,EAAA;I2EJjI;MA+BI,qBAAqB;MACrB,kB3EfqD;M2EgBrD,eAAe;MACf,oBAAoB,EAAA;IAlCxB;MAsCI,WAAW;MACX,sBAAsB;MACtB,yC3ErCiH,EAAA;I2EHrH;MA4CI,iBAAiB;MACjB,kBAAkB;MAClB,UAAU,EAAA;IA9Cd;MAkDI,+C3E9C6H,EAAA;M2EJjI;QAqDK,+C3EjD4H;Q2EkD5H,8B3EwGe,EAAA;I2E9JpB;MA4DK,cAAc;MACd,iBAAiB;MACjB,oCAAoC;MACpC,iBAAiB;MACjB,0BAA0B;MAC1B,kBAAkB;MAClB,kBAAkB;MAClB,WAAW;MACX,0C3EpDkH,EAAA;I2EhBvH;MAwEK,gD3EnE8H,EAAA;M2ELnI;QA2EM,+C3EvE2H;Q2EwE3H,8B3EkFc,EAAA;M2E9JpB;QAgFM,wBAAwB;QACxB,gD3E5E6H,EAAA;M2ELnI;QAqFM,UAAU;QACV,2D3EjF6H,EAAA;I2ELnI;MA8FM,wBAAwB,EAAA;EA9F9B;IAqGG,qB3EpFsD,EAAA;I2EjBzD;MAwGI,kCAAuF;MACvF,6C3E/FyH;M2EgGzH,iBAAiB;MACjB,kBAAkB;MAClB,mB3EpGsD;M2EqGtD,kC3E3HmE,EAAA;M2EcvE;QAgHK,WAAW;QACX,UAAU;QACV,aAAa;QACb,wD3EzGwH;Q2E0GxH,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,gCAAgC;QAChC,YAAY,EAAA;MAxHjB;QA4HK,mD3EjHoI,EAAA;Q2EXzI;UA+HM,yEAAgE;UAChE,UAAU,EAAA;MAhIhB;QAqIK,gD3EhI8H,EAAA;Q2ELnI;UAwIM,2D3EnI6H,EAAA;I2ELnI;MA8II,kBAAkB,EAAA;MA9ItB;QAkJM,WAAW;QACX,UAAU;QACV,SAAS;QACT,kBAAkB;QAClB,6BAA6B;QAC7B,iBAAiB;QACjB,SAAS,EAAA;EAxJf;IAgKE,c3E1BgB;I2E2BhB,aAAa,EAAA;;AAIf;EACC,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B,EAAA;EAE7B;IALD;MAME,aAAa,EAAA,EAEd;;AAED;EACC,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qBAAqB,EAAA;EALtB;IAQE,yB3EjDgB;I2EkDhB,kBAAkB;IAClB,kBAAkB;IAClB,iDAAiD;IACjD,WAAW;IACX,WAAW;IACX,cAAc;IACd,SAAS,EAAA;IAfX;MAkBG,MAAM;MACN,UAAU,EAAA;IAnBb;MAuBG,QAAQ,EAAA;IAvBX;MA2BG,SAAS;MACT,UAAU,EAAA;EAIZ;IAGG,SAAS,EAAA;EAHZ;IAOG,YAAY,EAAA;EAvChB;IA6CE,yBAAyB,EAAA;IA7C3B;MAiDI,SAAS;MACT,QAAQ;MACR,WAAW;MACX,wBAAwB;MACxB,uBAAuB,EAAA;IArD3B;MAyDI,SAAS;MACT,SAAS;MACT,WAAW;MACX,wBAAwB;MACxB,sBAAsB,EAAA;IA7D1B;MAiEI,SAAS;MACT,SAAS;MACT,WAAW;MACX,yBAAyB;MACzB,uBAAuB,EAAA;;AAM3B;EACC,iB3ErLsD,EAAA;E2EoLvD;IAIE,aAAa,EAAA;;AAIf;EACC,aAAa,EAAA;;AAGd;EAGG,SAAS,EAAA;EAHZ;IAMI,WAAW;IACX,UAAU,EAAA;;AAIZ;EAXF;IAYG,kBAAkB;IAClB,sBAAsB,EAAA,EAEvB;;AAfF;EAmBG,UAAU,EAAA;;AAKX;EAxBF;IAyBG,aAAa,EAAA,EAEd;;AA3BF;EA8BE,aAAa,EAAA;;AA9Bf;EAmCG,iB3E/SmD,EAAA;E2EiTnD;IArCH;MAsCI,cAAc,EAAA,EAEf;;AAxCH;EA4CI,aAAa,EAAA;;AA5CjB;EAgDI,qBAAqB,EAAA;;AAhDzB;EAqDG,qBAAqB,EAAA;;AAGtB;EAxDF;IA0DI,aAAa,EAAA,EACb;;AA3DJ;EAgEG,W3E5UmD,EAAA;E2E4QtD;IAmEI,aAAa,EAAA;IAnEjB;MAuEM,gBAAgB,EAAA;EAvEtB;IA+EK,aAAa,EAAA;EA/ElB;IAmFK,kBAAkB,EAAA;IAnFvB;MAsFM,aAAa,EAAA;IAtFnB;MA0FM,cAAc;MACd,iBAAiB;MACjB,eAAe,EAAA;EA5FrB;IAkGM,aAAa,EAAA;EAlGnB;IAsGM,eAAe,EAAA;IAtGrB;MA2GO,eAAe,EAAA;EA3GtB;IAgHM,iBAAiB,EAAA;EAhHvB;IAqHM,aAAa,EAAA;EArHnB;IA0HK,aAAa,EAAA;EA1HlB;IA+HI,uBAAsC,EAAA;IAEtC;MAjIJ;QAmIM,qBAAqB,EAAA;MAnI3B;QAuIM,gBAAgB,EAAA,EAChB;IAxIN;MA6IM,cAAc,EAAA;IA7IpB;MAmJM,eAAe,EAAA;MAnJrB;QAwJO,eAAe,EAAA;IAxJtB;MA6JM,sBAAsB,EAAA;IA7J5B;MAmKM,qBAAqB,EAAA;IAnK3B;MAyKM,qBAAqB,EAAA;IAzK3B;MA6KM,aAAa,EAAA;IA7KnB;MAkLK,gBAAgB,EAAA;MAlLrB;QAqLM,qBAAqB,EAAA;MArL3B;QAyLM,aAAa,EAAA;;AAzLnB;EAqMG,yCAAyC,EAAA;EAHzC;IAlMH;MAmMI,kB3E+H8B,EAAA,E2E5H/B;;AAtMH;EA2MG,gBAAgB,EAAA;;AA3MnB;EA+MG,aAAa,EAAA;;AA/MhB;EAmNG,qBAAqB,EAAA;;AAKtB;EAxNF;IAyNG,kBAAkB,EAAA;IAzNrB;MA4NI,iB3ExekD,EAAA,E2EyelD;;AA7NJ;EAiOG,8BAAA,EAAoD;;AAjOvD;EAqOG,eAAe;EACf,UAAU;EACV,W3EnfmD;E2EofnD,UAAU;EACV,MAAM;EACN,sC3EnfkG,EAAA;;A2EyQrG;EA+OI,aAAa,EAAA;;AA/OjB;EAmPI,qBAAqB,EAAA;;AAnPzB;EAyPG,kBAAkB;EAClB,sBAAyC;EACzC,iB3E3boD,EAAA;E2EgMvD;;IA+PI,4BAA4B,EAAA;EA/PhC;;IAoQI,wBAAwB,EAAA;EApQ5B;IAwQI,oBAAoB,EAAA;EAxQxB;IA8QK,wBAAwB,EAAA;EA9Q7B;IAkRK,kBAAkB;IAClB,eAAe,EAAA;IAnRpB;MAsRM,aAAa,EAAA;IAtRnB;MA0RM,cAAc;MACd,iBAAiB,EAAA;EA3RvB;IAiSM,aAAa,EAAA;EAjSnB;IAqSM,eAAe,EAAA;EArSrB;IAySM,iBAAiB,EAAA;EAzSvB;IA8SM,aAAa,EAAA;EA9SnB;IAmTK,aAAa;IACb,uBAAuB,EAAA;EApT5B;IAwTK,kBAAkB,EAAA;IAxTvB;MA4TO,kBAAkB;MAClB,yBAA+C;MAC/C,W3EpcQ;M2EqcR,iD3EjjBsG;M2EkjBtG,gBAAgB,EAAA;MAhUvB;QAmUQ,oD3EljBiI;Q2EmjBjI,+B3E1cO,EAAA;M2EsIf;QAwUQ,qBAAqB;QACrB,kBAAkB,EAAA;MAzU1B;QA6UQ,cAAc;QACd,wBAAwB;QACxB,W3ErdO,EAAA;I2EsIf;MAqVQ,qBAAqB,EAAA;IArV7B;MA0VO,cAAc;MACd,U3EvmB+C;M2EwmB/C,kBAAkB;MAClB,YAAY;MACZ,sC3EvmB8F;M2EwmB9F,uBAAuB;MACvB,iBAAiB;MACjB,0BAA0B;MAC1B,4C3EzlBwE,EAAA;E2EuP/E;IAwWK,UAAU,EAAA;IAxWf;MA6WQ,+C3E/mByH,EAAA;M2EkQjI;QAgXS,cAAc,EAAA;IAhXvB;MAwXO,yBAAyB;MACzB,kCAAkC,EAAA;IAzXzC;MA8XM,qBAAqB;MACrB,MAAM;MACN,6BAA6B,EAAA;;AAQjC;EAxYF;IA0YI,kB3EvpBmD,EAAA,E2EwpBnD;;AA3YJ;EA+YG,Y3E5pBoD,EAAA;;A2E6QvD;EAoZG,uBAAyC,EAAA;EApZ5C;IAyZK,cAAc;IACd,kBAAkB;IAClB,yBACyC,EAAA;IA5Z9C;MA+ZM,cAAc,EAAA;IA/ZpB;MAmaM,cAAc;MACd,iBAAiB;MACjB,kBAAkB,EAAA;IAraxB;MAyaM,wBAAwB,EAAA;IAza9B;MA6aM,kBAAkB;MAClB,qBAAqB;MACrB,QAAQ;MACR,QAAQ,EAAA;IAhbd;MAqbO,aAAa,EAAA;EArbpB;IA2bK,wBAAwB,EAAA;EA3b7B;IA+bK,eAAe,EAAA;EA/bpB;IAocI,kBAAkB,EAAA;IApctB;MAucK,0BAA0B,EAAA;;AAvc/B;EA+cG,2C3EjsB0G;E2EksB1G,uD3EjsB0G,EAAA;E2EiP7G;IAodK,yD3EpsBwH,EAAA;E2EgP7H;IAydI,8C3EzsByH,EAAA;;A2EgP7H;EA+dI,8C3E/sByH,EAAA;E2EgP7H;IAkeK,qD3EhtBsI,EAAA;E2E8O3I;IAueM,cAAc,EAAA;EAvepB;IA2eM,qD3EztBqI,EAAA;I2E8O3I;MA8eO,cAAc,EAAA;IA9erB;MAkfO,qD3EhuBoI;M2EiuBpI,8B3EznBQ,EAAA;E2EsIf;IAyfK,8C3EzuBwH;I2E0uBxH,8B3EhoBU,EAAA;E2EsIf;IA8fK,oD3E7uBoI,EAAA;I2E+OzI;MAigBM,oD3EhvBmI;M2EivBnI,+B3ExoBS,EAAA;;A2EsIf;EAygBK,qD3EvvBsI,EAAA;E2E8O3I;IA4gBM,oD3E3vBmI;I2E4vBnI,+B3EnpBS,EAAA;;A2EsIf;EAohBK,kD3EjwBgI,EAAA;E2E6OrI;IAuhBM,wEAA+D,EAAA;EAvhBrE;IA2hBM,oD3E1wBmI,EAAA;I2E+OzI;MA8hBO,0EAAiE,EAAA;EA9hBxE;IAmiBM,qD3EjxBqI,EAAA;;A2E8O3I;EA0iBO,wCAAwC,EAAA;;AA1iB/C;EA+iBQ,0EAAiE,EAAA;;AA/iBzE;EAojBO,qD3ElyBoI,EAAA;E2E8O3I;IAujBQ,2EAAkE,EAAA;;AAvjB1E;EAikBI,2C3EnzByG,EAAA;;A2EkP7G;EA0kBQ,2C3E5zBqG,EAAA;;A2EkP7G;EAglBM,UAAU,EAAA;EAhlBhB;IAolBQ,yBAAyB;IACzB,kCAAkC,EAAA;EArlB1C;IA4lBS,qD3E10BkI,EAAA;I2E8O3I;MA+lBU,cAAc,EAAA;EA/lBxB;IAsmBO,qBAAqB;IACrB,MAAM;IACN,6BAA6B,EAAA;;AAxmBpC;EAgnBG,+C3E11B4H,EAAA;;A2E0O/H;EAonBG,aAAa,EAAA;;AApnBhB;EAwnBG,qBAAqB,EAAA;;AAxnBxB;EA8nBG,qBAAqB,EAAA;;AA9nBxB;EAkoBG,aAAa,EAAA;;AAloBhB;;EAyoBG,iBAAiB,EAAA;;AAGlB;EA5oBF;IA8oBI,kBAAkB,EAAA;EA9oBtB;IAkpBI,eAAe;IACf,cAAc;IACd,sCAAA;IAAwC,2CAAA,EAA4C;EAppBxF;IAwpBI,kB3EtV8B,EAAA;E2ElUlC;IA8pBI,UAAU;IACV,wC3Ex6BiG;I2Ey6BjG,4BAA2B;IAC3B,eAAe;IACf,UAAU,EAAA;IAlqBd;MAqqBK,aAAa,EAAA;EArqBlB;;;;;;IAirBK,qBAAqB,EAAA;EAjrB1B;;;;;;IAqrBK,aAAa,EAAA,EACb;;AAtrBL;EA2rBG,6C3EjWsE,EAAA;;A2E1VzE;EAgsBI,gBAAgB,EAAA;;AAKjB;EArsBH;;IAwsBK,kBAAkB,EAAA,EAClB;;AAzsBL;;;;;EAqtBG,aAAa,EAAA;;AArtBhB;;;;;EAytBG,qBAAqB,EAAA;;AAKxB;EACC,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,0C3Ez9BsH;E2E09BtH,gB3ErUgC,EAAA;E2E+TjC;IASE,kBAAkB;IAClB,qBAAqB,EAAA;EAVvB;IAcE,aAAa,EAAA;;AAIf;EACC,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,wC3En3BiB;E2Eo3BjB,aAAa;EACb,aAAa,EAAA;;AAId;EAEE,cAAc,EAAA;;AAFhB;EAME,yBAAyB;EACzB,aAAa,EAAA;;AtFy+8Cf;EsF/98CK,yBAAyB,EAAA;;AtFk+8C9B;EsF998CK,yBAAyB,EAAA;;AAQ9B;;;;;EAOE,+C3EvgCuH;E2EwgCvH,+D3EvgC+H,EAAA;E2E+/BjI;;;;;IAYI,0C3E36BW,EAAA;E2E+5Bf;;;;;IAiBG,+B3Eh7BY,EAAA;;A2E+5Bf;;;;;EAuBG,+B3Et7BY,EAAA;E2E+5Bf;;;;;IA0BI,qD3EjiCuI,EAAA;E2EugC3I;;;;;IA+BK,cAAc,EAAA;EA/BnB;;;;;IAmCK,qD3E1iCsI,EAAA;I2EugC3I;;;;;MAsCM,cAAc,EAAA;IAtCpB;;;;;MA0CM,qD3EjjCqI;M2EkjCrI,8B3E18BS,EAAA;E2E+5Bf;;;;;IAiDI,+B3Eh9BW;I2Ei9BX,8B3Ej9BW,EAAA;E2E+5Bf;;;;;IAsDI,oD3E9jCqI,EAAA;I2EwgCzI;;;;;MAyDK,oD3EjkCoI;M2EkkCpI,+B3Ez9BU,EAAA;;A2E+5Bf;;;;;EAiEI,qD3ExkCuI,EAAA;E2EugC3I;;;;;IAoEK,oD3E5kCoI;I2E6kCpI,+B3Ep+BU,EAAA;;A2E+5Bf;;;;;EA4EI,+B3E3+BW,EAAA;E2E+5Bf;;;;;IA+EK,qDAAmE,EAAA;EA/ExE;;;;;IAmFK,oD3E3lCoI,EAAA;I2EwgCzI;;;;;MAsFM,0EAAiE,EAAA;EAtFvE;;;;;IA2FK,qD3ElmCsI,EAAA;;A2EugC3I;;;;;EAkGM,wCAAwC,EAAA;;AAlG9C;;;;;EAuGO,0EAAiE,EAAA;;AAvGxE;;;;;EA4GM,qD3EnnCqI,EAAA;E2EugC3I;;;;;IA+GO,2EAAkE,EAAA;;AA/GzE;;;;;EAyHG,+C3EznCsH,EAAA;;A2EggCzH;;;;;EAkIO,2C3E7oCsG,EAAA;;A2E2gC7G;;;;;EAwIK,UAAU,EAAA;EAxIf;;;;;IA4IO,yBAAyB;IACzB,kCAAkC,EAAA;EA7IzC;;;;;IAoJQ,qD3E3pCmI,EAAA;I2EugC3I;;;;;MAuJS,cAAc,EAAA;EAvJvB;;;;;IA8JM,qBAAqB;IACrB,MAAM;IACN,6BAA6B,EAAA;;AAhKnC;;;;;EA4KQ,+C3E5qCiH,EAAA;;A2EggCzH;;;;;EAsLE,+B3ErlCa,EAAA;;A2EylCf;EACC,2EAIC,EAAA;;AAGF;EACC,0EAIC,EAAA;;AAGF;EACC,wEAIC,EAAA;;AAGF;EACC,wEAIC,EAAA;;AAIF;EACC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,cAAc;EACd,MAAM;EACN,OAAO;EACP,sBAAsB;EACtB,wBAAwB;EACxB,aAAa,EAAA;;AtFg+8Cd;EsF398CE,0DAAuD,EAAA;;AtF898CzD;EsFx98CE,0DAAuD,EAAA;;AtF298CzD;EsFr98CE,0DAAuD,EAAA;;AtFw98CzD;EsFl98CE,0DAAuD,EAAA;;AtFq98CzD;EsF/88CE,eAAe;EACf,6BAA6B;EAC7B,gBAAgB;EAChB,wBAAwB,EAAA;;AAGzB;EtFg98CC;IsF588CE,iB3EjzCkD,EAAA;EX+v/CpD;IsF188CE,U3ErzCkD,EAAA;EXiw/CpD;IsFx88CE,U3EzzCkD,EAAA;EXmw/CpD;IsFp88CE,W3Eh0CmD,EAAA;EXsw/CrD;IsFl88CE,W3Ep0CmD,EAAA,E2Eq0CnD;;AAIH;EtFi88CC;IsF/78CC,qEAEkC,EAAA;EtF+78CnC;IsF378CC,YAAY;IACZ,sB3EvuBiC,EAAA;EXoq+ClC;IsFz78CC,+BAAiD;IACjD,gB3E7wCoD,EAAA;EXws/CrD;IsFv78CC,wCAEC;IACD,yBAAsD,EAAA;EtFu78CvD;IsFn78CC,wCAEC;IACD,yBAAsD;IACtD,SAAS;IACT,sB3E5vBiC;I2E6vBjC,yBAAyB,EAAA;ItFm78CxB;MsFh78CA,QAAQ,EAAA;EtFk78CV;IsF568CE,+BAAoD,EAAA;EtF868CtD;IsF168CE,wCAEC,EAAA;EtF068CH;IsFt68CE,wCAEC,EAAA;EtFs68CH;IsFh68CE,8BAAoD,EAAA;EtFk68CtD;IsF958CE,SAAS,EAAA;EtFg68CX;IsF558CE,uCAEC,EAAA;EtF458CH;IsFx58CE,uCAEC,EAAA;EtFw58CH;IsFl58CE,8BAAoD,EAAA;EtFo58CtD;IsFh58CE,uCAEC,EAAA;EtFg58CH;IsF548CE,uCAEC,EAAA,EACD;;AtF448CJ;EsFv48CE,2BAA2B;EAC3B,4BAA4B,EAAA;EtFy48C5B;IsFt48CC,4BAA4B;IAC5B,6BAA6B,EAAA;;AtFy48ChC;EuFr0/CQ,cAAc,EAAA;;AAGlB;EvFs0/CF;;;;;;;IuFl0/CU,cAAc;IACd,cAAc,EAAA;EvF00/CxB;IuFt0/CU,kBAAkB,EAAA,EACrB;;AvFw0/CT;EuFp0/CQ,4BAA6C,EAAA;EAE7C;IvFq0/CJ;MuFp0/CQ,kB5EukBsB,EAAA,E4ErkB7B;;AvFq0/CL;EuFl0/CQ,+B5EuF2C;E4EtF3C,+BAA+B;EAC/B,yBAA0C;EAC1C,4C5E+BwE;E4E9BxE,gB5E4D+C;E4E3D/C,eAAe;EACf,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,YAAY,EAAA;EAEZ;IvFm0/CJ;MuFj0/CY,UAAU,EAAA,EACb;EvFk0/CX;IuF9z/CU,mBAAmB,EAAA;IvFg0/C3B;MuF7z/CY,eAAe,EAAA;MvF+z/CzB;QuF3z/CkB,qBAAqB,EAAA;MvF6z/CvC;QuFxz/CkB,yC5E0DwE,EAAA;IXgw/C5F;MuFpz/CY,kC5EmD2D;M4ElD3D,uB5EDyC,EAAA;MXuz/CnD;QuFnz/Cc,cAAc,EAAA;MvFqz/C5B;QuFjz/Cc,yC5E4C4E,EAAA;QXuw/CxF;UuFjz/CgB,yC5E0CwE,EAAA;QXyw/CxF;UuFhz/CgB,yC5EuCwE;U4EtCxE,6B5EqGJ,EAAA;MX6s/Cd;QuF7y/Cc,yC5EiC4E,EAAA;QX8w/CxF;UuF5y/CgB,yC5E8BwE;U4E7BxE,6B5E4FJ,EAAA;QXkt/CZ;UuF1y/CgB,yC5EyBwE,EAAA;MXmx/C1F;QuFty/CkB,yC5EmBwE;Q4ElBxE,6B5EiFJ,EAAA;IXut/ChB;MuFjy/CgB,UAAU;MACV,mCAAmC,EAAA;IvFmy/CnD;MuF7x/CgB,eAAe,EAAA;EvF+x/CjC;IuFzx/CU,aAAa,EAAA;;AvF4x/CzB;EuFtx/CY,kBAAkB,EAAA;EvFwx/C5B;IuFrx/Cc,WAAW;IACX,kCAAkC,EAAA;EvFux/ChD;IuFlx/CkB,aAAa,EAAA;EvFox/C/B;IuF9w/CkB,yC5EvB4E,EAAA;IXuy/C5F;MuF7w/CoB,yC5E1BwE;M4E2BxE,6B5EoCJ,EAAA;IX2u/ChB;MuF3w/CoB,yC5E/BwE,EAAA;E4EmChF;IvF0w/CZ;MuFxw/CoB,cAAc;MACd,uBAAuB,EAAA,EAC1B;EvFyw/CnB;IuFpw/Cc,yC5E5CgF,EAAA;;AXmz/ChG;EuFjw/CQ,kBAAkB;EAClB,gB5ExGgD;E4EyGhD,iB5E8kC6B;E4E7kC7B,4C5E3GwE;E4E4GxE,6BAA6B;EAC7B,uBAAuB;EACvB,yBAAyB;EACzB,SAAS;EACT,a5E8+BgC;E4E7+BhC,sCAAyD;EACzD,4BAA4B;EAC5B,sC5E2kCuE;E4E1kCvE,qB5Eyc2B;E4Exc3B,aAAa,EAAA;EvFmw/CnB;IuFhw/CU,MAAM;IACN,UAAU,EAAA;;AvFmw/CtB;EuF9v/CQ,YAAY,EAAA;;AvFiw/CpB;EuF7v/CQ,aAAa,EAAA;;AvFgw/CrB;EuF5v/CQ,sBAAsB;EACtB,WAAW,EAAA;;AAGf;EvF6v/CF;IuF3v/CU,aAAa,EAAA;EvF+v/CvB;IuFtv/Cc,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,eAAe,EAAA;IvFwv/C3B;MuFrv/CgB,sBAAsB,EAAA;MvFuv/CpC;QuFpv/CkB,oB5EjMgC,EAAA;MXu7/ClD;QuFlv/CkB,qBAAqB,EAAA;EvFov/C3C;IuF9u/Cc,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,eAAe;IACf,cAAc,EAAA;IvFgv/C1B;MuF7u/CgB,cAAc,EAAA;EvF+u/ChC;IuF1u/Cc,kBAAkB,EAAA;EvF4u/ChC;IuFxu/Cc,UAAU,EAAA;EvF0u/CxB;IuFtu/Cc,WAAW,EAAA,EAjDlB;;AvF0x/CT;EuF7t/CoB,aAAa,EAAA;;AvFgu/CjC;EuF5t/CoB,cAAc,EAAA;;AvF+t/ClC;EuFlt/CoB,oCAAoC,EAAA;;AvFqt/CxD;EuF5s/CwB,qCAAoC,EAAA;;AvF+s/C5D;EwFh//CQ,iBAAiB;EACjB,Y7EuEgD;E6EtEhD,U7EqE+C,EAAA;EX66/CrD;IwF/+/CU,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,qDAA4C;IAC5C,gB7E+qBqB,EAAA;IXk0+C7B;MwF9+/CY,wBAAwB,EAAA;IxFg//CpC;MwF5+/CY,aAAa,EAAA;ExF8+/C3B;IwFz+/CU,0BAAuC,EAAA;IAEvC;MxF0+/CN;QwFz+/CU,iBAAiB,EAAA,EA2CxB;IxFg8/CL;MwFv+/CY,aAAa,EAAA;IxFy+/CzB;MwFp+/CgB,yBAAyB;MACzB,uBAAuB,EAAA;IxFs+/CvC;MwFh+/CgB,yBAAyB;MACzB,uBAAuB,EAAA;IxFk+/CvC;MwF39/CoB,SAAS,EAAA;MxF69/C3B;QwF19/CsB,WAAW;QACX,UAAU,EAAA;IxF49/ClC;MwFp9/CgB,yC7EtCiG,EAAA;MX4//C/G;QwFn9/CkB,gD7EvC2G,EAAA;EX4//CjI;IwF98/CU,UAAU,EAAA;;AxFi9/CtB;EwF58/CQ,+BAA+E,EAAA;EAE/E;IxF68/CJ;MwF58/CQ,iB7ER2C,EAAA,E6EUlD;;AxF68/CL;EwF18/CQ,W7Eb+C;E6Ec/C,sD7EhBkH;E6EiBlH,YAAY;EACZ,W7EhB+C;E6EiB/C,4C7EfwE;E6EgBxE,MAAM;EACN,kBAAkB;EAClB,UAAU;EACV,kBAAkB,EAAA;ExF48/CxB;IwFz8/CU,kBAAkB;IAClB,gBAAgB,EAAA;IxF28/CxB;MwFv8/CgB,WAAW;MACX,kBAAkB;MAClB,MAAM;MACN,QAAQ;MACR,SAAS;MACT,OAAO,EAAA;ExFy8/CzB;IwFn8/CU,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yC7E3FyG;I6E4FzG,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB,EAAA;IxFq8/C3B;MwFl8/CY,WAAW;MACX,yC7EvGqG,EAAA;IX2igDjH;MwFh8/CY,0C7EgDI;M6E/CJ,c7E+CI,EAAA;MXm5/Cd;QwF/7/Cc,c7E4CA;Q6E3CA,6B7E2CA,EAAA;;AXu5/CpB;EwF37/CQ,aAAa,EAAA;;AAGjB;ExF47/CF;IwFx7/Cc,cAAc,EAAA;ExF07/C5B;IwFt7/Cc,aAAa,EAAA,EAChB;;AxFw7/Cb;EwFh7/CoB,aAAa,EAAA;;AxFm7/CjC;EwF/6/CoB,cAAc,EAAA;;AxFk7/ClC;EwF16/CY,2D7ElGuH,EAAA;EX8ggDjI;IwFz6/Cc,+C7ElGiH,EAAA;IX6ggD7H;MwFx6/CgB,sD7EpG2H;M6EqG3H,8D7EpGqH,EAAA;;AX+ggDzI;EwFr6/CY,kD7E9GqG;E6E+GrG,oD7E9GqG,EAAA;EXqhgD/G;IwFn6/CkB,cAAc,EAAA;ExFq6/ChC;IwFj6/CkB,aAAa,EAAA;ExFm6/C/B;IwF55/CsB,+C7E5HyG,EAAA;;AX2hgDjI;EwFl5/C4B,sD7ExImH,EAAA;EX4hgD7I;IwFj5/C8B,4EAAmE,EAAA;;AxFo5/CnG;EwF54/CwB,sD7EnJuH,EAAA;EXiigD7I;IwF34/C0B,iE7EtJmH,EAAA;EXmigD7I;IwFz4/C0B,iEAAwD,EAAA;;AxF44/CpF;;;;;EwFl4/CY,2D7ExKuH,EAAA;EXgjgDjI;;;;;IwFr4/Cc,+B7EnGD,EAAA;IX8+/CX;;;;;MwFx4/CgB,sD7E1K2H;M6E2K3H,8D7E1KqH,EAAA;;AXyjgDzI;;;;;EwFz4/CY,kD7EpLqG;E6EqLrG,oD7EpLqG,EAAA;EXmkgD/G;;;;;IwF34/CkB,cAAc,EAAA;ExFi5/ChC;;;;;IwF74/CkB,aAAa,EAAA;ExFm5/C/B;;;;;IwF54/CsB,+B7E7HT,EAAA;;AXghgDf;;;;;;;;;EwFt4/C4B,sD7E9MmH,EAAA;EX8lgD7I;;;;;;;;;IwF74/C8B,4EAAmE,EAAA;;AxFw5/CnG;;;;;EwFh5/CwB,sD7EzNuH,EAAA;EX+mgD7I;;;;;IwFn5/C0B,iE7E5NmH,EAAA;EXqngD7I;;;;;IwFr5/C0B,iEAAwD,EAAA;;AxF45/CpF;;;;;EwFn5/CgB,2B7E9JE,EAAA;;AXwjgDlB;EwFn5/CY,QAAQ;EACR,eAAe,EAAA;EAEf;IxFo5/CR;MwFn5/CY,aAAa,EAAA,EAEpB;;AxFo5/CT;;EwFh5/CY,aAAa,EAAA;;AxFo5/CzB;EwFh5/CY,iB7EvQ2C,EAAA;;AX0pgDvD;;EwF94/CY,U7E5Q2C,EAAA;;A6E+Q/C;ExFg5/CN;IwF94/Cc,cAAc,EAAA;ExFg5/C5B;;IwF34/Cc,OAAO,EAAA,EACV;;AAOL;ExFw4/CN;;IwFv4/CU,U7E/R2C,EAAA,E6EiSlD;;AAED;ExFw4/CF;IwFt4/CU,cAAc,EAAA;ExFw4/CxB;;IwFn4/CU,OAAO,EAAA,EACV;;AxFs4/CT;EyFxvgDE,yC9E0HmE,EAAA;;AXiogDrE;EyFvvgDE,iB9EqH4B;E8EpH5B,cAAc;EACd,4C9E2nByD;E8E1nBzD,mCAAmD,EAAA;;AzF0vgDrD;EyFrvgDG,iBAAiB,EAAA;;AzFwvgDpB;;EyFlvgDE,iB9EuG4B;E8EtG5B,cAAc;EACd,kBAAkB,EAAA;;AAMjB;EzFivgDD;IyF/ugDG,kBAAkB,EAAA,EAClB;;AAID;EzF8ugDF;IyF7ugDG,cAAc,EAAA,EAEf;;AzF8ugDJ;;;EyFzugDG,kBAAkB;EAClB,8BAAoE,EAAA;EAEpE;IzF4ugDC;;;MyF3ugDA,qBAAwC,EAAA,EAEzC;;AzF8ugDH;;;EyFvugDG,+BAAiE,EAAA;EAEjE;IzF0ugDC;;;MyFzugDA,sBAAqC,EAAA,EAEtC;;AzF4ugDH;;EyFtugDG,+BAAoE,EAAA;EAEpE;IzFwugDC;;MyFvugDA,sBAAwC,EAAA,EAEzC;;AzFyugDH;EyFlugDG,mCAAmD,EAAA;;AAGpD;EzFmugDA;IyFjugDE,iBAAiB;IACjB,gBAAgB,EAAA;EzFmugDlB;IyF/tgDE,iBAAiB,EAAA,EACjB;;AzFiugDJ;;;;;EyFxtgDI,eAAe;EACf,kBAAkB,EAAA;;AzF+tgDtB;;;EyFntgDE,eAAe,EAAA;;AzFwtgDjB;;EyFntgDE,iB9EM4B,EAAA;;AXitgD9B;EyFntgDE,6BAA8C,EAAA;;AzFstgDhD;;;;;EyF9sgDG,kBAAkB,EAAA;;AAQpB;EzF8sgDC;;IyF3sgDC,kBAAkB,EAAA;EzFgtgDnB;;IyFxsgDE,kBAAkB,EAAA,EAPnB;;AAgBF;EzFosgDC;IyFlsgDC,aAAa,EAAA;EzFosgDd;IyFhsgDC,qBAAqB;IACrB,WAAW,EAAA;EzFksgDZ;IyF9rgDC,OAAO,EAAA;EzFgsgDR;IyF5rgDC,OAAO,EAAA;EzF8rgDR;IyF1rgDC,gBAAgB,EAAA;EzF4rgDjB;IyFtrgDE,gBAAgB;IAChB,iBAAiB,EAAA;EzFwrgDnB;IyFnrgDG,qBAAqB,EAAA;EzFqrgDxB;IyFjrgDG,aAAa,EAAA,EACb;;AzFmrgDL;;;;;;EyFtqgDG,qBAAqB,EAAA;;AzF8qgDxB;;;;;;EyF1qgDG,aAAa,EAAA;;AzFkrgDhB;;;;;;;EyFrqgDG,aAAa,EAAA;;AzF8qgDhB;;;;;;;EyF1qgDG,cAAc,EAAA;;AAIhB;EzFgrgDC;IyF9qgDC,aAAa,EAAA;EzFgrgDd;IyF5qgDC,qBAAqB;IACrB,WAAW,EAAA;EzF8qgDZ;IyF1qgDC,wBAAqD,EAAA;EzF4qgDtD;IyFxqgDC,wBAAqD,EAAA;EzF0qgDtD;IyFtqgDC,gBAAgB,EAAA;EzFwqgDjB;IyFlqgDE,gBAAgB;IAChB,iBAAiB,EAAA;EzFoqgDnB;IyF/pgDG,qBAAqB,EAAA;EzFiqgDxB;IyF7pgDG,aAAa,EAAA,EACb;;AC9QL;;;;;;uD1Fm7gDuD;A0F56gDtD;EACG,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EAGzB,iBAAiB;EACjB,wCAAwC,EAAA;;AAE1C;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,8BAA8B;EAI9B,qJAAqJ;EAIrJ,6BAA6B;EAI7B,uCAAuC;EAKvC,mCAAmC;EACnC,oBAAoB,EAAA;;AAEtB;EACE,oCAAoC;EAIpC,6KAA6K,EAAA;;AAE/K;EACE,8BAA8B,EAAA;;AAEhC;EACE,oCAAoC,EAAA;;AAEtC;EAIE,2BAA2B,EAAA;;AAE7B;;EAME,wBAAwB;EACxB,2EAA2E,EAAA;;AAE7E;;;;EAIE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,UAAU,EAAA;;AAEZ;EACE,qBAAqB;EACrB,oBAAoB,EAAA;;AAEtB;EACE,SAAS;EACT,qBAAqB,EAAA;;AAEvB;EACE,oBAAoB;EACpB,sBAAsB,EAAA;;AAExB;EACE,UAAU,EAAA;;AAEZ;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU,EAAA;;AAEZ;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB,EAAA;;AAEpB;EACE,wBAAwB;EAExB,iDAAiD;EAIjD,qBAAqB,EAAA;;AAEvB;EAEE,+CAA+C,EAAA;;AAEjD;EACE,cAAc,EAAA;;AAvFhB;EA4FM,0C/EeO,EAAA;;A+EXf;EAEQ,yC/EuCY,EAAA;;A+EpCpB;EAEQ,yC/EwCY,EAAA;;A+ErCpB;EAEQ,yC/EqCY,EAAA;;A+ElCpB;EAEQ,wC/E6BY,EAAA;;A+E1BpB;EAEQ,yC/EsBY,EAAA;;AgFvLpB;EACI,cAAc;EACd,aAAa,EAAA;;AAGjB;EACI,YAAY;EACZ,WAAW,EAAA;;AAGf;EACI,YAAY;EACZ,WAAW,EAAA;;AAGf;EACI,cAAc;EACd,aAAa,EAAA;;AAGjB;EACI,YAAY;EACZ,WAAW,EAAA;;AAGf;EACI,cAAc;EACd,aAAa,EAAA;;AAGjB;EACI,mBAAmB;EACnB,yBhFoJgB;EgFnJhB,WhFqHW;EgFpHX,aAAa;EACb,gBhF4FoB;EgF3FpB,YAAY;EACZ,uBAAuB;EACvB,WAAW,EAAA;;AAIf;EACI,kBAAkB;EAClB,aAAa;EACb,eAAe,EAAA;EAHnB;IAMQ,kBAAkB;IAClB,0CAAiE;IACjE,kBAAkB;IAClB,oBAAoB,EAAA;IAT5B;MAYY,kBAAkB;MAClB,2BAA2B;MAC3B,UAAU,EAAA;;ACxDtB;EAEQ,gBjF6HgB,EAAA;;AiF/HxB;EAMQ,cjFsJU,EAAA;;AiF5JlB;EAYgB,WAAW;EACX,iCAAiC,EAAA;;AAbjD;EAkBoB,WAAW,EAAA;;AAS/B;EAGY,iCAAiC;EACjC,oCAAoC;EACpC,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB,EAAA;;AAR5B;EAagB,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB,EAAA;;AAQlC;EAGY,iCAAiC;EACjC,oCAAoC;EACpC,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB,EAAA;;AAR5B;EAagB,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB,EAAA;;AASlC;EAEQ,qBAAqB,EAAA;EAF7B;IAKY,kBAAkB;IAClB,ajFmyCqC;IiFlyCrC,SAAS,EAAA;EAPrB;IAYgB,SAAS,EAAA;;AAQzB;EAEQ,4CjFuxC6E;EiFtxC7E,sBjFyhB4B,EAAA;EiF5hBpC;IAMY,eAAe,EAAA;EAN3B;IAUY,sBjFkhBwB,EAAA;IiF5hBpC;MAagB,4BAA4B;MAC5B,6BAA6B,EAAA;;AAM7C;EAEQ,6CjFmwC6E,EAAA;;AiF3vCjF;EAEQ,qCjFsDQ,EAAA;EiFxDhB;IAKY,gBAAgB,EAAA;IAL5B;MAQgB,cjFgDA;MiF/CA,oDAA8C,EAAA;IAT9D;MAagB,cjF2CA,EAAA;;AiFrChB;EAGY,gBAAgB,EAAA;EAH5B;IAMgB,WjFCL;IiFAK,oCAAmC,EAAA;;AA1BnD;EAEQ,oCjF0DQ,EAAA;EiF5DhB;IAKY,gBAAgB,EAAA;IAL5B;MAQgB,cjFoDA;MiFnDA,mDAA8C,EAAA;IAT9D;MAagB,cjF+CA,EAAA;;AiFzChB;EAGY,gBAAgB,EAAA;EAH5B;IAMgB,WjFCL;IiFAK,oCAAmC,EAAA;;AA1BnD;EAEQ,qCjF4DQ,EAAA;EiF9DhB;IAKY,gBAAgB,EAAA;IAL5B;MAQgB,cjFsDA;MiFrDA,oDAA8C,EAAA;IAT9D;MAagB,cjFiDA,EAAA;;AiF3ChB;EAGY,gBAAgB,EAAA;EAH5B;IAMgB,WjFCL;IiFAK,oCAAmC,EAAA;;AA1BnD;EAEQ,qCjF8DQ,EAAA;EiFhEhB;IAKY,gBAAgB,EAAA;IAL5B;MAQgB,cjFwDA;MiFvDA,oDAA8C,EAAA;IAT9D;MAagB,cjFmDA,EAAA;;AiF7ChB;EAGY,gBAAgB,EAAA;EAH5B;IAMgB,WjFCL;IiFAK,oCAAmC,EAAA;;AA1BnD;EAEQ,oCjF2DQ,EAAA;EiF7DhB;IAKY,gBAAgB,EAAA;IAL5B;MAQgB,cjFqDA;MiFpDA,mDAA8C,EAAA;IAT9D;MAagB,cjFgDA,EAAA;;AiF1ChB;EAGY,gBAAgB,EAAA;EAH5B;IAMgB,WjFCL;IiFAK,oCAAmC,EAAA;;AA1BnD;EAEQ,qCjFyDQ,EAAA;EiF3DhB;IAKY,gBAAgB,EAAA;IAL5B;MAQgB,cjFmDA;MiFlDA,oDAA8C,EAAA;IAT9D;MAagB,cjF8CA,EAAA;;AiFxChB;EAGY,gBAAgB,EAAA;EAH5B;IAMgB,WjFCL;IiFAK,oCAAmC,EAAA;;AA1BnD;EAEQ,sCjFyBM,EAAA;EiF3Bd;IAKY,gBAAgB,EAAA;IAL5B;MAQgB,cjFmBF;MiFlBE,qDAA8C,EAAA;IAT9D;MAagB,cjFcF,EAAA;;AiFRd;EAGY,gBAAgB,EAAA;EAH5B;IAMgB,WjFCL;IiFAK,oCAAmC,EAAA;;AA1BnD;EAEQ,mCjFiCM,EAAA;EiFnCd;IAKY,gBAAgB,EAAA;IAL5B;MAQgB,cjF2BF;MiF1BE,kDAA8C,EAAA;IAT9D;MAagB,cjFsBF,EAAA;;AiFhBd;EAGY,gBAAgB,EAAA;EAH5B;IAMgB,WjFCL;IiFAK,oCAAmC,EAAA;;A5F2phDvD;E4F9ohDY,8CAAoF,EAAA;E5FgphD9F;I4F9ohDc,0DnElCkE,EAAA;;AzBmrhDlF;E4F5ohDY,0DnEvCsE,EAAA;;AzBsrhDlF;E4FtohDY,yBAAyB,EAAA;;AChLnC;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AhB0D1C;EgBpDJ,uCAAmD,EAAA;;AhBoD/C;EgBjDJ,wCAAqD,EAAA;;AAMrD;EACI,+BAAgD,EAAA;;AAEpD;EACI,mCAAoD,EAAA;;AAExD;EACI,sCAAuD,EAAA;;AAE3D;EACI,qCAAsD,EAAA;;AAE1D;EACI,oCAAqD,EAAA;;AAIzD;EAEQ,uBAAuB,EAAA;EAF/B;IAIY,+BAAgD,EAAA;;AArB5D;EACI,+BAAgD,EAAA;;AAEpD;EACI,mCAAoD,EAAA;;AAExD;EACI,sCAAuD,EAAA;;AAE3D;EACI,qCAAsD,EAAA;;AAE1D;EACI,oCAAqD,EAAA;;AAIzD;EAEQ,uBAAuB,EAAA;EAF/B;IAIY,+BAAgD,EAAA;;AArB5D;EACI,+BAAgD,EAAA;;AAEpD;EACI,mCAAoD,EAAA;;AAExD;EACI,sCAAuD,EAAA;;AAE3D;EACI,qCAAsD,EAAA;;AAE1D;EACI,oCAAqD,EAAA;;AAIzD;EAEQ,uBAAuB,EAAA;EAF/B;IAIY,+BAAgD,EAAA;;AArB5D;EACI,+BAAgD,EAAA;;AAEpD;EACI,mCAAoD,EAAA;;AAExD;EACI,sCAAuD,EAAA;;AAE3D;EACI,qCAAsD,EAAA;;AAE1D;EACI,oCAAqD,EAAA;;AAIzD;EAEQ,uBAAuB,EAAA;EAF/B;IAIY,+BAAgD,EAAA;;AArB5D;EACI,8BAAgD,EAAA;;AAEpD;EACI,kCAAoD,EAAA;;AAExD;EACI,qCAAuD,EAAA;;AAE3D;EACI,oCAAsD,EAAA;;AAE1D;EACI,mCAAqD,EAAA;;AAIzD;EAEQ,uBAAuB,EAAA;EAF/B;IAIY,8BAAgD,EAAA;;AArB5D;EACI,+BAAgD,EAAA;;AAEpD;EACI,mCAAoD,EAAA;;AAExD;EACI,sCAAuD,EAAA;;AAE3D;EACI,qCAAsD,EAAA;;AAE1D;EACI,oCAAqD,EAAA;;AAIzD;EAEQ,uBAAuB,EAAA;EAF/B;IAIY,+BAAgD,EAAA;;AArB5D;EACI,8BAAgD,EAAA;;AAEpD;EACI,kCAAoD,EAAA;;AAExD;EACI,qCAAuD,EAAA;;AAE3D;EACI,oCAAsD,EAAA;;AAE1D;EACI,mCAAqD,EAAA;;AAIzD;EAEQ,uBAAuB,EAAA;EAF/B;IAIY,8BAAgD,EAAA;;A7Fy9hDhE;E6Fh9hDQ,gCAA6C,EAAA;E7Fk9hDnD;I6Fh9hDU,gDAAiE,EAAA;;AAQ7E;EACI,sClFknB2E,EAAA;;AkF/mB/E;EACI,oClFvDqE,EAAA;;AkF4DzE;EACI,gBlFyDoB,EAAA;;AkFpDxB;EACI,SAAO,EAAA;;AAKX;EACI,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,cAAc;EACd,yBlFqEc;EkFpEd,kBAAkB;EAClB,clFmEc;EkFlEd,kBAAkB;EAClB,oBAAoB,EAAA;EATxB;IAYQ,clF+DU;IkF9DV,yBlF0DU,EAAA;;AkFpDlB;EACI,yDlFiDW,EAAA;;AkF7Cf;EACI,eAAe,EAAA;;AAGnB;EACI,eAAe,EAAA;;AAGnB;EACI,gBAAgB,EAAA;;AAGpB;EACI,gBAAgB,EAAA;;AAGpB;EACI,gBAAgB,EAAA;;AAIpB;EACI,YAAY;EACZ,WAAW,EAAA;;AAGf;EACI,YAAY;EACZ,WAAW,EAAA;;AAGf;EACI,YAAY;EACZ,WAAW,EAAA;;AAGf;EACI,YAAY;EACZ,WAAW,EAAA;;AAGf;EACI,YAAY;EACZ,WAAW,EAAA;;AAGf;EACI,YAAY;EACZ,WAAW,EAAA;;AAIf;EACI,clFHc;EkFId,+BlFJc,EAAA;;AkFSd;EACI,clFeY;EkFdZ,8BlFcY,EAAA;;AkFhBhB;EACI,clFmBY;EkFlBZ,6BlFkBY,EAAA;;AkFpBhB;EACI,clFqBY;EkFpBZ,8BlFoBY,EAAA;;AkFtBhB;EACI,clFuBY;EkFtBZ,8BlFsBY,EAAA;;AkFxBhB;EACI,clFoBY;EkFnBZ,6BlFmBY,EAAA;;AkFrBhB;EACI,clFkBY;EkFjBZ,8BlFiBY,EAAA;;AkFnBhB;EACI,clFdU;EkFeV,+BlFfU,EAAA;;AkFad;EACI,clFNU;EkFOV,4BlFPU,EAAA;;AkFYlB;EACI,kBAAkB,EAAA;EADtB;IAGQ,kBAAkB,EAAA;EAH1B;IAMQ,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,clF5BU,EAAA;;AkFmClB;EACI,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,SAAS;EACT,OAAO;EACP,MAAM;EACN,YAAY;EACZ,sBlFxCW,EAAA;;AkF6Cf;EACI,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa,EAAA;;AnFmFjB;EmF9EI,wBAAgB;UAAhB,gBAAgB,EAAA;;AAGpB;EACI,YAAY;EACZ,mBAAqC;EACrC,kCAAmD;EACnD,+BAAgD,EAAA;;AAKhD;EAFJ;IAGQ,aAAa;IACb,0BAA0B;IAC1B,aAAa;IACb,UAAU;IACV,QAAQ;IACR,WAAW;IACX,aAAa,EAAA;IATrB;MAWY,eAAe;MACf,MAAM;MACN,UAAU;MACV,WAAW;MACX,SAAS;MACT,uClFjFM,EAAA;IkFiElB;MAoBY,eAAe;MACf,YAAY;MACZ,iBAAiB,EAAA;IAtB7B;MAyBY,gBAAgB;MAChB,+BAA+B,EAAA,EAClC;;AAKL;E7F+6hDF;I6F76hDU,6BAA8C;IAC9C,eAAe;IACf,mCAAoD,EAAA,EACvD;;AAKT;EACI,iBAAiB,EAAA;;AAIrB;EACI,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;EAC5B,mBAAmB,EAAA;;AAIvB;EACI,yBAAyB,EAAA;EAD7B;IAGQ,clFhIU,EAAA;EkF6HlB;IAMQ,yBAAyB,EAAA;IANjC;MAQY,clFxGQ,EAAA;MkFgGpB;QAWgB,gBAAgB,EAAA;;AAMhC;EACI,kCAA0D,EAAA;;AAG9D;EACI,iCAAwD,EAAA;;A7Fi6hD5D;E6F55hDQ,kDAAkD,EAAA;;AAK1D;EACI,eAAe;EACf,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,aAAa,EAAA;EANjB;IAQQ,uCAAuC,EAAA;;AAI/C;EACE;IACE,wBAAwB;IACxB,UAAU,EAAA;EAGZ;IACE,4BAA4B;IAC5B,UAAU,EAAA,EAAA;;AAId;EACI,eAAe,EAAA;;AClVnB;EACI,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,0CAAiE;EACjE,aAAa,EAAA;;A9F0uiDjB;E8FtuiDI,UAAU;EACV,kBAAkB,EAAA;;AAGtB;EACI,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,uBAAuB,EAAA;;ACrB3B;EAEQ,gBAAgB,EAAA;;ACFxB;EAEQ,+CrFonBiE;EqFnnBjE,iBAAiB,EAAA;EAHzB;IAMY,iBAAiB,EAAA;;AAO7B,aAAA;AAEA;EACI,gBAAgB,EAAA;EADpB;IAIQ,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,8BrFiIU,EAAA;IqFxIlB;MAUY,WAAW;MACX,cAAc;MACd,kBAAkB;MAClB,QAAQ;MACR,UAAU;MACV,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,yBrFmJQ;MqFlJR,sBrFoHG,EAAA;IqFvIf;MAuBY,yBAAyB,EAAA;;AAMrC;EACI,kBAAkB,EAAA;EADtB;IAIQ,gBAAgB;IAChB,kBAAkB,EAAA;IAL1B;MASY,WAAW;MACX,kBAAkB;MAClB,UAAU;MACV,YAAY;MACZ,yCrFiIQ;MqFhIR,SAAS;MACT,wBAAwB;MACxB,SAAS;MACT,oBAAoB,EAAA;IAjBhC;MAqBY,UAAU;MACV,UAAU;MACV,oBAAoB,EAAA;EAvBhC;IA8BgB,UAAU,EAAA;EA9B1B;IAkCgB,UAAU,EAAA;;AAO1B;EAGY,yBrFkGQ,EAAA;;AqF7FpB;EACI,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,0CAAiE;EACjE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU,EAAA;;AAId;EAGY,aAAa,EAAA;;AAHzB;EAOY,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,wCrFggB6D;EqF/f7D,oBAAoB;EACpB,iBAAiB;EACjB,crF2DQ,EAAA;;AqFxEpB;EAiBY,yBrFuDQ;EqFtDR,qBrFsDQ;EqFrDR,WrFuBG,EAAA;;AsFrJf;EACI,iBAAiB;EACjB,oBAAoB,EAAA;EAFxB;IAKQ,mBAAmB;IACnB,gBAAgB,EAAA;;AAKxB;EACI,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,cAAc,EAAA;;AjGk1iDlB;EiG70iDQ,4BAA4B,EAAA;;AAKpC;EACI,yBAA0C,EAAA;EAD9C;IAIQ,eAAe;IACf,kBAAkB;IAClB,yBAA0C;IAC1C,oBAAoB;IACpB,sBAAsB,EAAA;EAR9B;IAYQ,kBAAkB;IAClB,oBAAoB;IACpB,YAAY,EAAA;EAdpB;IAkBQ,gBAAgB,EAAA;IAlBxB;MAsBgB,ctFiII;MsFhIJ,qBAAqB,EAAA;;AAQrC;EAEQ,yBtFyFU;EsFxFV,gBAAgB;EAChB,gBAAgB;EAChB,gBtF8DgB;EsF7DhB,kBAAkB,EAAA;;AAM1B;EAGY,aAAa,EAAA;EAHzB;IAOoB,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;IACP,yCtF+FA,EAAA;EsF5GpB;IAgBoB,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,4CAA4C;IAC5C,eAAe;IACf,WtFuDL,EAAA;;AX+viDf;EiG7yiDQ,gCAAiC,EAAA;EjG+yiDvC;IiG7yiDU,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,eAAe;IACf,ctFoEQ,EAAA;;AX4uiDpB;EiGxyiDY,gCAA6C,EAAA;;AjG2yiDzD;EiGxyiDY,2DAA4E,EAAA;;AjG2yiDxF;EiGvyiDY,0DAAwE,EAAA;;AjG0yiDpF;EiGryiDgB,qDAA2E,EAAA;;ACnI3F;EACI;;;;;;;IAOI,wBAAwB,EAAA;EAE5B;;;;;IAKI,UAAU;IACV,SAAS,EAAA;EvDjBjB;IuDqBQ,SAAS;IACT,2BAA2B,EAAA;EAG/B;IAEQ,wBAAwB,EAAA;EAGhC;IAEQ,yBAAyB;IACzB,qBAAqB;IACrB,0BAA0B,EAAA,EAC7B;;ACnCT;EACI,kBAAkB;EAkMlB,eAAA,EAAgB;EAnMpB;IAIQ,iBAAiB;IACjB,+CxF0JU;IwFzJV,WxFgJO;IwF/IP,oBxF6qB+B;IwF5qB/B,gBxFmrByB;IwFlrBzB,kBAAkB;IAClB,UAAU;IACV,QAAQ,EAAA;IAXhB;MAcY,4BAA4B,EAAA;IAdxC;MAkBY,qBAAqB,EAAA;MAlBjC;QAqBgB,WAAW;QACX,kBAAkB;QAClB,YAAY;QACZ,MAAM;QACN,8BAA8B,EAAA;MAzB9C;QA6BgB,WAAW;QACX,kBAAkB;QAClB,YAAY;QACZ,SAAS;QACT,8BAA8B,EAAA;EAjC9C;IA0CY,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,SAAS,EAAA;EAlDrB;IAyDQ,gBAAgB,EAAA;IAzDxB;MA4DY,yBAAyB;MACzB,WAAW;MACX,YAAY;MACZ,WAAW;MACX,UAAU;MACV,aAAa;MACb,uBAAuB;MACvB,qBAAqB,EAAA;IAnEjC;MAuEgB,iBAAiB;MACjB,WAAW;MACX,YAAY;MACZ,eAAe;MACf,gBAAgB,EAAA;EA3EhC;IAmFY,kBAAkB;IAClB,UAAU;IACV,QAAQ,EAAA;IArFpB;MAwFgB,4BAA4B,EAAA;IAxF5C;MA4FgB,iBAAiB,EAAA;MA5FjC;QAgGoB,WAAW;QACX,WAAW;QACX,8BAA8B,EAAA;EAlGlD;IAyGgB,UAAU;IACV,WAAW,EAAA;EA1G3B;IA+GY,WAAW;IACX,UAAU,EAAA;EAhHtB;IAqHgB,wBAAwB;IACxB,YAAY;IACZ,UAAU,EAAA;EAvH1B;IA6HgB,UAAU;IACV,WAAW,EAAA;IA9H3B;MAiIoB,UAAU;MACV,YAAY;MACZ,wBAAwB,EAAA;EAnI5C;IA2IQ,WAAW,EAAA;EA3InB;IAiJY,mBxFmCQ,EAAA;IwFpLpB;MAoJgB,6CAA2D,EAAA;IApJ3E;MAyJoB,0BxF2BA;MwF1BA,yBxF0BA,EAAA;IwFpLpB;MA8JoB,0BxFsBA;MwFrBA,4BxFqBA,EAAA;EwFpLpB;IAsKgB,mBxFcI,EAAA;IwFpLpB;MA0KwB,2BxFUJ;MwFTI,yBxFSJ,EAAA;IwFpLpB;MA+KwB,2BxFKJ;MwFJI,4BxFIJ,EAAA;EwFpLpB;IAiJY,mBxFuCQ,EAAA;IwFxLpB;MAoJgB,6CAA2D,EAAA;IApJ3E;MAyJoB,0BxF+BA;MwF9BA,yBxF8BA,EAAA;IwFxLpB;MA8JoB,0BxF0BA;MwFzBA,4BxFyBA,EAAA;EwFxLpB;IAsKgB,mBxFkBI,EAAA;IwFxLpB;MA0KwB,2BxFcJ;MwFbI,yBxFaJ,EAAA;IwFxLpB;MA+KwB,2BxFSJ;MwFRI,4BxFQJ,EAAA;EwFxLpB;IAiJY,mBxFyCQ,EAAA;IwF1LpB;MAoJgB,6CAA2D,EAAA;IApJ3E;MAyJoB,0BxFiCA;MwFhCA,yBxFgCA,EAAA;IwF1LpB;MA8JoB,0BxF4BA;MwF3BA,4BxF2BA,EAAA;EwF1LpB;IAsKgB,mBxFoBI,EAAA;IwF1LpB;MA0KwB,2BxFgBJ;MwFfI,yBxFeJ,EAAA;IwF1LpB;MA+KwB,2BxFWJ;MwFVI,4BxFUJ,EAAA;EwF1LpB;IAiJY,mBxF2CQ,EAAA;IwF5LpB;MAoJgB,6CAA2D,EAAA;IApJ3E;MAyJoB,0BxFmCA;MwFlCA,yBxFkCA,EAAA;IwF5LpB;MA8JoB,0BxF8BA;MwF7BA,4BxF6BA,EAAA;EwF5LpB;IAsKgB,mBxFsBI,EAAA;IwF5LpB;MA0KwB,2BxFkBJ;MwFjBI,yBxFiBJ,EAAA;IwF5LpB;MA+KwB,2BxFaJ;MwFZI,4BxFYJ,EAAA;EwF5LpB;IAiJY,mBxFwCQ,EAAA;IwFzLpB;MAoJgB,6CAA2D,EAAA;IApJ3E;MAyJoB,0BxFgCA;MwF/BA,yBxF+BA,EAAA;IwFzLpB;MA8JoB,0BxF2BA;MwF1BA,4BxF0BA,EAAA;EwFzLpB;IAsKgB,mBxFmBI,EAAA;IwFzLpB;MA0KwB,2BxFeJ;MwFdI,yBxFcJ,EAAA;IwFzLpB;MA+KwB,2BxFUJ;MwFTI,4BxFSJ,EAAA;EwFzLpB;IAiJY,mBxFsCQ,EAAA;IwFvLpB;MAoJgB,6CAA2D,EAAA;IApJ3E;MAyJoB,0BxF8BA;MwF7BA,yBxF6BA,EAAA;IwFvLpB;MA8JoB,0BxFyBA;MwFxBA,4BxFwBA,EAAA;EwFvLpB;IAsKgB,mBxFiBI,EAAA;IwFvLpB;MA0KwB,2BxFaJ;MwFZI,yBxFYJ,EAAA;IwFvLpB;MA+KwB,2BxFQJ;MwFPI,4BxFOJ,EAAA;EwFvLpB;IAiJY,mBxFMM,EAAA;IwFvJlB;MAoJgB,6CAA2D,EAAA;IApJ3E;MAyJoB,0BxFFF;MwFGE,yBxFHF,EAAA;IwFvJlB;MA8JoB,0BxFPF;MwFQE,4BxFRF,EAAA;EwFvJlB;IAsKgB,mBxFfE,EAAA;IwFvJlB;MA0KwB,2BxFnBN;MwFoBM,yBxFpBN,EAAA;IwFvJlB;MA+KwB,2BxFxBN;MwFyBM,4BxFzBN,EAAA;EwFvJlB;IAiJY,mBxFcM,EAAA;IwF/JlB;MAoJgB,6CAA2D,EAAA;IApJ3E;MAyJoB,0BxFMF;MwFLE,yBxFKF,EAAA;IwF/JlB;MA8JoB,0BxFCF;MwFAE,4BxFAF,EAAA;EwF/JlB;IAsKgB,mBxFPE,EAAA;IwF/JlB;MA0KwB,2BxFXN;MwFYM,yBxFZN,EAAA;IwF/JlB;MA+KwB,2BxFhBN;MwFiBM,4BxFjBN,EAAA;EwF/JlB;IA2LQ,gBAAgB;IAChB,UAAU;IACV,UAAU;IACV,eAAe;IACf,UAAU,EAAA;EA/LlB;IAqMQ,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAA;IA5MzB;MA+MY,eAAe;MACf,WxF1DG;MwF2DH,kBAAkB;MAClB,iBAAiB;MACjB,yBAAyB;MACzB,YAAY;MACZ,cAAc;MACd,wEAAwE;MACxE,kBAAkB;MAClB,SAAS;MACT,WAAW;MACX,gBxFieqB,EAAA;MwF3rBjC;QA6NgB,WAAW;QACX,kBAAkB;QAClB,OAAO;QACP,SAAS;QACT,WAAW;QACX,mCAAmC;QACnC,oCAAoC,EAAA;MAnOpD;QAuOgB,WAAW;QACX,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,WAAW;QACX,kCAAkC;QAClC,oCAAoC,EAAA;EA7OpD;IAuPgB,mBxFnEI,EAAA;IwFpLpB;MA0PoB,8BAA4C;MAC5C,6BAA2C,EAAA;IA3P/D;MA+PoB,+BAA6C;MAC7C,6BAA2C,EAAA;EAhQ/D;IAuPgB,mBxF/DI,EAAA;IwFxLpB;MA0PoB,8BAA4C;MAC5C,6BAA2C,EAAA;IA3P/D;MA+PoB,+BAA6C;MAC7C,6BAA2C,EAAA;EAhQ/D;IAuPgB,mBxF7DI,EAAA;IwF1LpB;MA0PoB,8BAA4C;MAC5C,6BAA2C,EAAA;IA3P/D;MA+PoB,+BAA6C;MAC7C,6BAA2C,EAAA;EAhQ/D;IAuPgB,mBxF3DI,EAAA;IwF5LpB;MA0PoB,8BAA4C;MAC5C,6BAA2C,EAAA;IA3P/D;MA+PoB,+BAA6C;MAC7C,6BAA2C,EAAA;EAhQ/D;IAuPgB,mBxF9DI,EAAA;IwFzLpB;MA0PoB,8BAA4C;MAC5C,6BAA2C,EAAA;IA3P/D;MA+PoB,+BAA6C;MAC7C,6BAA2C,EAAA;EAhQ/D;IAuPgB,mBxFhEI,EAAA;IwFvLpB;MA0PoB,8BAA4C;MAC5C,6BAA2C,EAAA;IA3P/D;MA+PoB,+BAA6C;MAC7C,6BAA2C,EAAA;EAhQ/D;IAuPgB,mBxFhGE,EAAA;IwFvJlB;MA0PoB,8BAA4C;MAC5C,6BAA2C,EAAA;IA3P/D;MA+PoB,+BAA6C;MAC7C,6BAA2C,EAAA;EAhQ/D;IAuPgB,mBxFxFE,EAAA;IwF/JlB;MA0PoB,4BAA4C;MAC5C,2BAA2C,EAAA;IA3P/D;MA+PoB,6BAA6C;MAC7C,2BAA2C,EAAA;;AAS/D;EAGY,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,UAAU,EAAA;;AAKtB;EACI,kBAAkB;EAClB,WAAW;EACX,UAAU,EAAA;EAHd;IAMQ,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,WxFvIO;IwFwIP,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,WAAW,EAAA;IAdnB;MAkBY,kBAAkB;MAClB,WAAW,EAAA;IAnBvB;MAuBY,WAAW;MACX,UAAU;MACV,UAAU;MACV,MAAM,EAAA;IA1BlB;MA8BY,WAAW;MACX,UAAU;MACV,UAAU;MACV,MAAM;MACN,0BAA0B,EAAA;EAlCtC;IAuCQ,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,SAAS;IACT,mCAAmC;IACnC,oCAAoC;IACpC,sBAAsB,EAAA;;AAM1B;EAGQ,mBxFtJQ,EAAA;EwFmJhB;IAMY,mBxFzJI,EAAA;EwFmJhB;IAUY,mBAA+B,EAAA;;AAV3C;EAeQ,yBxFlKQ,EAAA;;AwFmJhB;EAGQ,mBxFlJQ,EAAA;EwF+IhB;IAMY,mBxFrJI,EAAA;EwF+IhB;IAUY,mBAA+B,EAAA;;AAV3C;EAeQ,yBxF9JQ,EAAA;;AwF+IhB;EAGQ,mBxFhJQ,EAAA;EwF6IhB;IAMY,mBxFnJI,EAAA;EwF6IhB;IAUY,mBAA+B,EAAA;;AAV3C;EAeQ,yBxF5JQ,EAAA;;AwF6IhB;EAGQ,mBxF9IQ,EAAA;EwF2IhB;IAMY,mBxFjJI,EAAA;EwF2IhB;IAUY,mBAA+B,EAAA;;AAV3C;EAeQ,yBxF1JQ,EAAA;;AwF2IhB;EAGQ,mBxFjJQ,EAAA;EwF8IhB;IAMY,mBxFpJI,EAAA;EwF8IhB;IAUY,mBAA+B,EAAA;;AAV3C;EAeQ,yBxF7JQ,EAAA;;AwF8IhB;EAGQ,mBxFnJQ,EAAA;EwFgJhB;IAMY,mBxFtJI,EAAA;EwFgJhB;IAUY,mBAA+B,EAAA;;AAV3C;EAeQ,yBxF/JQ,EAAA;;AwFgJhB;EAGQ,mBxFnLM,EAAA;EwFgLd;IAMY,mBxFtLE,EAAA;EwFgLd;IAUY,mBAA+B,EAAA;;AAV3C;EAeQ,yBxF/LM,EAAA;;AwFgLd;EAGQ,mBxF3KM,EAAA;EwFwKd;IAMY,mBxF9KE,EAAA;EwFwKd;IAUY,mBAA+B,EAAA;;AAV3C;EAeQ,yBxFvLM,EAAA;;AwF6LlB;EAEQ,4BAA4B;EAC5B,yBAAyB,EAAA;EAHjC;IAMY,yBAAyB;IACzB,UAAU,EAAA;;AAPtB;EAaY,wBAAwB,EAAA;EAbpC;IAgBgB,UAAU,EAAA;;AAhB1B;EAsBY,2BAA2B;EAC3B,yBAAyB,EAAA;EAvBrC;IA0BgB,yBAAyB;IACzB,UAAU,EAAA;;AA3B1B;EAiCgB,wBAAwB,EAAA;EAjCxC;IAoCoB,UAAU,EAAA;;AC9X9B;EAEM,sBzF88CoC,EAAA;;AyFz8CtC;EACI,czF0KY;EyFzKZ,gCzFyKY,EAAA;;AyF3KhB;EACI,czF8KY;EyF7KZ,gCzF6KY,EAAA;;AyF/KhB;EACI,czFgLY;EyF/KZ,gCzF+KY,EAAA;;AyFjLhB;EACI,czFkLY;EyFjLZ,gCzFiLY,EAAA;;AyFnLhB;EACI,czF+KY;EyF9KZ,gCzF8KY,EAAA;;AyFhLhB;EACI,czF6KY;EyF5KZ,gCzF4KY,EAAA;;AyF9KhB;EACI,czF6IU;EyF5IV,gCzF4IU,EAAA;;AyF9Id;EACI,czFqJU;EyFpJV,gCzFoJU,EAAA;;A0F9JlB;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc,EAAA;;ACXhB;EACI,kBAAkB;EAClB,gBAAgB,EAAA;;AAGpB;;;;;;EAYI,8B3FiHyD;E2FhHzD,kC3FVmE,EAAA;;ADsOvE;E4FxNI,gCAAgC,EAAA;;A5FmWpC;E4F/VI,gB3FqGoB;E2FpGpB,qB3Fo5ByC,EAAA;;AD3uB7C;;E4FrKE,gB3F4pB+B,EAAA;;AExmBjC;EyF9CI,kBAAkB;EAClB,yCAA0D,EAAA;;AAG9D;EACI,cAAc;EACd,0CAA2D;EAC3D,iBAAiB,EAAA;;AAWjB;EANJ;;;;;;IAOQ,iBAAiB,EAAA,EAExB;;AlFzDC;EkF6DE,kBAAkB,EAAA;;AC5DtB;EAEQ,W5FkJO,EAAA;;A4F5If;EACI,0CAAiE;EACjE,iBAAiB,EAAA;;AAKrB;EACI,eAAe,EAAA;;AAKnB;EACI,kBAAkB;EAClB,kBAAkB;EAClB,SAAS,EAAA;EAHb;IAMQ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,OAAO;IACP,MAAM;IACN,2C5FoHO;I4FnHP,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB,EAAA;EAf/B;IAoBQ,gBAAgB,EAAA;IApBxB;MAuBgB,WAAW;MACX,kBAAkB;MAClB,6BAA6B;MAC7B,0B5FmII;M4FlIJ,YAAY,EAAA;;AAS5B;EACI,sBAAsB,EAAA;;AAK1B;EACI,0CAAiE;EACjE,oC5FmjBqE;E4FljBrE,qBAAqB;EACrB,2BAA8C,EAAA;;AAKlD;EACI,UAAU,EAAA;EADd;IAIQ,oB5FibK,EAAA;E4Frbb;IAOQ,oB5F8aK;I4F7aL,kC5FwiB4B;I4FviB5B,mC5FuiB4B;I4FtiB5B,wB5FuhByB,EAAA;;A4FjhBjC;EAEQ,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,4BAA4B,EAAA;;AAQhC;EAEQ,yB5FyEQ;E4FxER,qB5FwEQ;E4FvER,W5FyCG,EAAA;;A4FpCX;EAEQ,c5FgEQ,EAAA;;A4F3DhB;EAEQ,0B5FyDQ,EAAA;;A4FpDhB;EAEQ,yB5FkDQ,EAAA;;A4F3ChB;EAGY,yB5FwCI;E4FvCJ,W5FSD,EAAA;;A4FFX;EAGY,W5FDD;E4FEC,yB5F4BI,EAAA;E4FhChB;IAMgB,qCAAoC,EAAA;;AAMpD;EAGY,c5FiBI,EAAA;;A4FVhB;EAGY,yB5FOI;E4FNJ,W5FxBD,EAAA;;A4F7CX;EAEQ,yB5F6EQ;E4F5ER,qB5F4EQ;E4F3ER,W5FyCG,EAAA;;A4FpCX;EAEQ,c5FoEQ,EAAA;;A4F/DhB;EAEQ,0B5F6DQ,EAAA;;A4FxDhB;EAEQ,yB5FsDQ,EAAA;;A4F/ChB;EAGY,yB5F4CI;E4F3CJ,W5FSD,EAAA;;A4FFX;EAGY,W5FDD;E4FEC,yB5FgCI,EAAA;E4FpChB;IAMgB,qCAAoC,EAAA;;AAMpD;EAGY,c5FqBI,EAAA;;A4FdhB;EAGY,yB5FWI;E4FVJ,W5FxBD,EAAA;;A4F7CX;EAEQ,yB5F+EQ;E4F9ER,qB5F8EQ;E4F7ER,W5FyCG,EAAA;;A4FpCX;EAEQ,c5FsEQ,EAAA;;A4FjEhB;EAEQ,0B5F+DQ,EAAA;;A4F1DhB;EAEQ,yB5FwDQ,EAAA;;A4FjDhB;EAGY,yB5F8CI;E4F7CJ,W5FSD,EAAA;;A4FFX;EAGY,W5FDD;E4FEC,yB5FkCI,EAAA;E4FtChB;IAMgB,qCAAoC,EAAA;;AAMpD;EAGY,c5FuBI,EAAA;;A4FhBhB;EAGY,yB5FaI;E4FZJ,W5FxBD,EAAA;;A4F7CX;EAEQ,yB5FiFQ;E4FhFR,qB5FgFQ;E4F/ER,W5FyCG,EAAA;;A4FpCX;EAEQ,c5FwEQ,EAAA;;A4FnEhB;EAEQ,0B5FiEQ,EAAA;;A4F5DhB;EAEQ,yB5F0DQ,EAAA;;A4FnDhB;EAGY,yB5FgDI;E4F/CJ,W5FSD,EAAA;;A4FFX;EAGY,W5FDD;E4FEC,yB5FoCI,EAAA;E4FxChB;IAMgB,qCAAoC,EAAA;;AAMpD;EAGY,c5FyBI,EAAA;;A4FlBhB;EAGY,yB5FeI;E4FdJ,W5FxBD,EAAA;;A4F7CX;EAEQ,yB5F8EQ;E4F7ER,qB5F6EQ;E4F5ER,W5FyCG,EAAA;;A4FpCX;EAEQ,c5FqEQ,EAAA;;A4FhEhB;EAEQ,0B5F8DQ,EAAA;;A4FzDhB;EAEQ,yB5FuDQ,EAAA;;A4FhDhB;EAGY,yB5F6CI;E4F5CJ,W5FSD,EAAA;;A4FFX;EAGY,W5FDD;E4FEC,yB5FiCI,EAAA;E4FrChB;IAMgB,qCAAoC,EAAA;;AAMpD;EAGY,c5FsBI,EAAA;;A4FfhB;EAGY,yB5FYI;E4FXJ,W5FxBD,EAAA;;A4F7CX;EAEQ,yB5F4EQ;E4F3ER,qB5F2EQ;E4F1ER,W5FyCG,EAAA;;A4FpCX;EAEQ,c5FmEQ,EAAA;;A4F9DhB;EAEQ,0B5F4DQ,EAAA;;A4FvDhB;EAEQ,yB5FqDQ,EAAA;;A4F9ChB;EAGY,yB5F2CI;E4F1CJ,W5FSD,EAAA;;A4FFX;EAGY,W5FDD;E4FEC,yB5F+BI,EAAA;E4FnChB;IAMgB,qCAAoC,EAAA;;AAMpD;EAGY,c5FoBI,EAAA;;A4FbhB;EAGY,yB5FUI;E4FTJ,W5FxBD,EAAA;;A4F7CX;EAEQ,yB5F4CM;E4F3CN,qB5F2CM;E4F1CN,W5FmDG,EAAA;;A4F9CX;EAEQ,c5FmCM,EAAA;;A4F9Bd;EAEQ,0B5F4BM,EAAA;;A4FvBd;EAEQ,yB5FqBM,EAAA;;A4Fdd;EAGY,yB5FWE;E4FVF,W5FmBD,EAAA;;A4FZX;EAGY,W5FSD;E4FRC,yB5FDE,EAAA;E4FHd;IAMgB,qCAAoC,EAAA;;AAMpD;EAGY,c5FZE,EAAA;;A4FmBd;EAGY,yB5FtBE;E4FuBF,W5FdD,EAAA;;A4FvDX;EAEQ,yB5FoDM;E4FnDN,qB5FmDM;E4FlDN,W5FyCG,EAAA;;A4FpCX;EAEQ,c5F2CM,EAAA;;A4FtCd;EAEQ,0B5FoCM,EAAA;;A4F/Bd;EAEQ,yB5F6BM,EAAA;;A4FtBd;EAGY,yB5FmBE;E4FlBF,W5FSD,EAAA;;A4FFX;EAGY,W5FDD;E4FEC,yB5FOE,EAAA;E4FXd;IAMgB,qCAAoC,EAAA;;AAMpD;EAGY,c5FJE,EAAA;;A4FWd;EAGY,yB5FdE;E4FeF,W5FxBD,EAAA;;AsCjHf;EsDgJQ,kCAAkC,EAAA;EAF1C;IAIY,kCAAkC;IAClC,4BAA4B;IAC5B,eAAe;IACf,iBAAgB;IAChB,+CAA+C,EAAA;;AAzEvD;EA+EA,qBAAkC,EAAA;;AC9LlC;EACI,qDAAiD,EAAA;;AADrD;EACI,oDAAiD,EAAA;;AADrD;EACI,qDAAiD,EAAA;;AADrD;EACI,qDAAiD,EAAA;;AADrD;EACI,oDAAiD,EAAA;;AADrD;EACI,qDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,mDAAiD;EAKrD,2DAAyE,EALpB;;AADrD;EAUA,4DAA2E,EAAA;;ACE3E;EANA,c9F2KgB;E8F1KhB,yB9F0KgB;E8FzKhB,6BAA6B,EAAA;;AAI7B;EANA,c9F+KgB;E8F9KhB,yB9F8KgB;E8F7KhB,6BAA6B,EAAA;;AAI7B;EANA,c9FiLgB;E8FhLhB,yB9FgLgB;E8F/KhB,6BAA6B,EAAA;;AAI7B;EANA,c9FmLgB;E8FlLhB,yB9FkLgB;E8FjLhB,6BAA6B,EAAA;;AAI7B;EANA,c9FgLgB;E8F/KhB,yB9F+KgB;E8F9KhB,6BAA6B,EAAA;;AAI7B;EANA,c9F8KgB;E8F7KhB,yB9F6KgB;E8F5KhB,6BAA6B,EAAA;;AAI7B;EANA,c9F8Ic;E8F7Id,yB9F6Ic;E8F5Id,6BAA6B,EAAA;;AAI7B;EANA,c9FsJc;E8FrJd,yB9FqJc;E8FpJd,6BAA6B,EAAA;;AAWjC;EACI,0CAAiE;EACjE,iBAAiB,EAAA;;AAIjB;EA1BA,c9FkLgB;E8FjLhB,yC9FiLgB,EAAA;;A8FpJhB;EAvBA,c9F2KgB;E8F1KhB,yB9F0KgB;E8FzKhB,6BAA6B,EAAA;;AA2B7B;EAGY,2B9F2II,EAAA;;A8FxJhB;EA1BA,c9FsLgB;E8FrLhB,wC9FqLgB,EAAA;;A8FxJhB;EAvBA,c9F+KgB;E8F9KhB,yB9F8KgB;E8F7KhB,6BAA6B,EAAA;;AA2B7B;EAGY,2B9F+II,EAAA;;A8F5JhB;EA1BA,c9FwLgB;E8FvLhB,yC9FuLgB,EAAA;;A8F1JhB;EAvBA,c9FiLgB;E8FhLhB,yB9FgLgB;E8F/KhB,6BAA6B,EAAA;;AA2B7B;EAGY,2B9FiJI,EAAA;;A8F9JhB;EA1BA,c9F0LgB;E8FzLhB,yC9FyLgB,EAAA;;A8F5JhB;EAvBA,c9FmLgB;E8FlLhB,yB9FkLgB;E8FjLhB,6BAA6B,EAAA;;AA2B7B;EAGY,2B9FmJI,EAAA;;A8FhKhB;EA1BA,c9FuLgB;E8FtLhB,wC9FsLgB,EAAA;;A8FzJhB;EAvBA,c9FgLgB;E8F/KhB,yB9F+KgB;E8F9KhB,6BAA6B,EAAA;;AA2B7B;EAGY,2B9FgJI,EAAA;;A8F7JhB;EA1BA,c9FqLgB;E8FpLhB,yC9FoLgB,EAAA;;A8FvJhB;EAvBA,c9F8KgB;E8F7KhB,yB9F6KgB;E8F5KhB,6BAA6B,EAAA;;AA2B7B;EAGY,2B9F8II,EAAA;;A8F3JhB;EA1BA,c9FqJc;E8FpJd,0C9FoJc,EAAA;;A8FvHd;EAvBA,c9F8Ic;E8F7Id,yB9F6Ic;E8F5Id,6BAA6B,EAAA;;AA2B7B;EAGY,2B9F8GE,EAAA;;A8F3Hd;EA1BA,c9F6Jc;E8F5Jd,uC9F4Jc,EAAA;;A8F/Hd;EAvBA,c9FsJc;E8FrJd,yB9FqJc;E8FpJd,6BAA6B,EAAA;;AA2B7B;EAGY,2B9FsHE,EAAA;;A8F9GlB;EACI,sBAAsB,EAAA;;AAK1B;EACI,gBAAgB;EAChB,kBAAkB,EAAA;EAFtB;IAIQ,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,2B9FsHY;I8FrHZ,WAAW;IACX,MAAM,EAAA;;AA6BV;EACI,6DAX2E,EAAA;;AAU/E;EACI,6DAV6D,EAAA;;AASjE;EACI,6DAT4D,EAAA;;AAQhE;EACI,6DAR4D,EAAA;;AAOhE;EACI,6DAPyE,EAAA;;AAM7E;EACI,6DANsD,EAAA;;AAK1D;EACI,6DALsD,EAAA;;ACzF9D;;EAEI,wBAAwB;EACxB,kBAAkB,EAAA;;AtEHtB;EsEOI,gB/FgoB8B,EAAA;;A+F7nBlC;EACI,yBAAyB,EAAA;;AAI7B;EACI,mBAAmB,EAAA;;AAIvB;EACI,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gCAAwF;EACxF,+BAAuF;EACvF,UAAU,EAAA;EANd;IASQ,sBAAsB,EAAA;EAT9B;IAaQ,kCAA2F;IAC3F,iCAA0F,EAAA;EAdlG;IAkBQ,kCAA2F;IAC3F,iCAA0F,EAAA;;AAU9F;EACI,uBAAiC;EACjC,oCAA2B;EAC3B,kCAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,wCAA2D;EAC3D,uCAAuD;EACvD,gDAA+C;EAC/C,2BAAyC;EACzC,yCAA6D,EAAA;;AAVjE;EACI,uBAAiC;EACjC,mCAA2B;EAC3B,kCAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,wCAA2D;EAC3D,sCAAuD;EACvD,gDAA+C;EAC/C,2BAAyC;EACzC,yCAA6D,EAAA;;AAVjE;EACI,uBAAiC;EACjC,oCAA2B;EAC3B,kCAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,wCAA2D;EAC3D,uCAAuD;EACvD,gDAA+C;EAC/C,2BAAyC;EACzC,yCAA6D,EAAA;;AAVjE;EACI,uBAAiC;EACjC,oCAA2B;EAC3B,kCAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,wCAA2D;EAC3D,uCAAuD;EACvD,gDAA+C;EAC/C,2BAAyC;EACzC,yCAA6D,EAAA;;AAVjE;EACI,uBAAiC;EACjC,mCAA2B;EAC3B,kCAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,wCAA2D;EAC3D,sCAAuD;EACvD,gDAA+C;EAC/C,2BAAyC;EACzC,yCAA6D,EAAA;;AAVjE;EACI,uBAAiC;EACjC,oCAA2B;EAC3B,kCAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,wCAA2D;EAC3D,uCAAuD;EACvD,gDAA+C;EAC/C,2BAAyC;EACzC,yCAA6D,EAAA;;AAVjE;EACI,uBAAiC;EACjC,qCAA2B;EAC3B,kCAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,wCAA2D;EAC3D,wCAAuD;EACvD,gDAA+C;EAC/C,2BAAyC;EACzC,yCAA6D,EAAA;;AAVjE;EACI,uBAAiC;EACjC,kCAA2B;EAC3B,kCAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,wCAA2D;EAC3D,qCAAuD;EACvD,gDAA+C;EAC/C,2BAAyC;EACzC,yCAA6D,EAAA;;AAUjE;EACI,uBAAiC;EACjC,wBAA2B;EAC3B,kCAA+C;EAC/C,6BAA6C;EAC7C,0CAAuC;EACvC,wCAA2D;EAC3D,uCAAuD;EACvD,8BAA+C;EAC/C,2CAAyC;EACzC,yCAA6D,EAAA;;AAVjE;EACI,uBAAiC;EACjC,wBAA2B;EAC3B,kCAA+C;EAC/C,6BAA6C;EAC7C,yCAAuC;EACvC,wCAA2D;EAC3D,sCAAuD;EACvD,8BAA+C;EAC/C,0CAAyC;EACzC,yCAA6D,EAAA;;AAVjE;EACI,uBAAiC;EACjC,wBAA2B;EAC3B,kCAA+C;EAC/C,6BAA6C;EAC7C,0CAAuC;EACvC,wCAA2D;EAC3D,uCAAuD;EACvD,8BAA+C;EAC/C,2CAAyC;EACzC,yCAA6D,EAAA;;AAVjE;EACI,uBAAiC;EACjC,wBAA2B;EAC3B,kCAA+C;EAC/C,6BAA6C;EAC7C,0CAAuC;EACvC,wCAA2D;EAC3D,uCAAuD;EACvD,8BAA+C;EAC/C,2CAAyC;EACzC,yCAA6D,EAAA;;AAVjE;EACI,uBAAiC;EACjC,wBAA2B;EAC3B,kCAA+C;EAC/C,6BAA6C;EAC7C,yCAAuC;EACvC,wCAA2D;EAC3D,sCAAuD;EACvD,8BAA+C;EAC/C,0CAAyC;EACzC,yCAA6D,EAAA;;AAVjE;EACI,uBAAiC;EACjC,wBAA2B;EAC3B,kCAA+C;EAC/C,6BAA6C;EAC7C,0CAAuC;EACvC,wCAA2D;EAC3D,uCAAuD;EACvD,8BAA+C;EAC/C,2CAAyC;EACzC,yCAA6D,EAAA;;AAVjE;EACI,uBAAiC;EACjC,wBAA2B;EAC3B,kCAA+C;EAC/C,6BAA6C;EAC7C,2CAAuC;EACvC,wCAA2D;EAC3D,wCAAuD;EACvD,8BAA+C;EAC/C,4CAAyC;EACzC,yCAA6D,EAAA;;AAVjE;EACI,uBAAiC;EACjC,wBAA2B;EAC3B,kCAA+C;EAC/C,6BAA6C;EAC7C,wCAAuC;EACvC,wCAA2D;EAC3D,qCAAuD;EACvD,8BAA+C;EAC/C,yCAAyC;EACzC,yCAA6D,EAAA;;AAVjE;EAeA,yBAA0C,EAAA;;AAI9C;EACI,kBAAkB;EAClB,kBAAkB,EAAA;EAFtB;IAKQ,kBAAkB;IAClB,aAAa;IACb,U/F4gByB;I+F3gBzB,S/F2gByB;I+F1gBzB,Y/F0gByB;I+FzgBzB,0C/FoDO;I+FnDP,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB,EAAA;EAd/B;IAmBY,wC/FoDM,EAAA;E+FvElB;IAwBQ,oB/F0uB2B;I+FzuB3B,mBAAmB,EAAA;IAzB3B;MA4BY,W/FufqB;M+FtfrB,UAAU,EAAA;;AAOtB;EACI,gBAAgB;EAChB,oDAAoD;EACpD,wDAAwD,EAAA;EAH5D;IAMQ,wBAAwB;IACxB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,UAAU;IACV,iCAAiC;IACjC,sB/FgtB2B;I+F/sB3B,wCAAwC;IACxC,wDAAwD,EAAA;EAhBhE;IAoBQ,cAAc;IACd,wCAAwC;IACxC,wDAAwD,EAAA;EAtBhE;IA2BY,UAAU;IACV,+BAA+B,EAAA;EA5B3C;IAgCY,UAAU;IACV,kCAAkC,EAAA;;AAO1C;EACI,yB/FeY;E+FdZ,gCAA4B,EAAA;EAE5B;IACI,c/FWQ;I+FVR,yC/FUQ,EAAA;;A+FhBhB;EACI,yB/FmBY;E+FlBZ,gCAA4B,EAAA;EAE5B;IACI,c/FeQ;I+FdR,wC/FcQ,EAAA;;A+FpBhB;EACI,yB/FqBY;E+FpBZ,gCAA4B,EAAA;EAE5B;IACI,c/FiBQ;I+FhBR,yC/FgBQ,EAAA;;A+FtBhB;EACI,yB/FuBY;E+FtBZ,gCAA4B,EAAA;EAE5B;IACI,c/FmBQ;I+FlBR,yC/FkBQ,EAAA;;A+FxBhB;EACI,yB/FoBY;E+FnBZ,gCAA4B,EAAA;EAE5B;IACI,c/FgBQ;I+FfR,wC/FeQ,EAAA;;A+FrBhB;EACI,yB/FkBY;E+FjBZ,gCAA4B,EAAA;EAE5B;IACI,c/FcQ;I+FbR,yC/FaQ,EAAA;;A+FnBhB;EACI,yB/FdU;E+FeV,gCAA4B,EAAA;EAE5B;IACI,c/FlBM;I+FmBN,0C/FnBM,EAAA;;A+Fad;EACI,yB/FNU;E+FOV,gCAA4B,EAAA;EAE5B;IACI,c/FVM;I+FWN,uC/FXM,EAAA;;A+FwBlB;EAEQ,gBAAgB,EAAA;;AAKxB;EAEQ,YAAY,EAAA;;AAFpB;;;;;EAUQ,yC/FZY;E+FaZ,c/FbY,EAAA;;AXkrlDpB;;;;E0G1plDQ,qBAAkC;EAClC,iDAAmE;EACnE,6CAA+D,EAAA;;A1GgqlDvE;;;;;;;;;;;;;;;E0G9olDQ,qBAAkC;EAClC,iDAAmE;EACnE,6CAA+D,EAAA;;A1G+plDvE;;;;E0GxplDQ,sBAAoC;EACpC,gDAAiE;EACjE,4CAA6D,EAAA;;A1G8plDrE;;;;;;;;;;;;;;;E0G5olDQ,sBAAoC;EACpC,gDAAiE;EACjE,4CAA6D,EAAA;;A1G6plDrE;E0GvplDQ,qBAAkC;EAClC,gDAAkE,EAAA;E1GyplDxE;I0GtplDU,qBAAkC;IAClC,iCAA+C,EAAA;;A1GyplD3D;E0GpplDQ,qBAAkC;EAClC,+CAAgE,EAAA;E1GsplDtE;I0GnplDU,sBAAoC;IACpC,gCAA6C,EAAA;;A1GsplDzD;E0GhplDQ,qBAAkC,EAAA;E1GkplDxC;I0G/olDU,qBAAkC;IAClC,gDAAkE,EAAA;;A1GkplD9E;E0G7olDQ,qBAAkC,EAAA;E1G+olDxC;I0G5olDU,qBAAkC;IAClC,+CAAgE,EAAA;;AAK5E;;EAIQ,YAAY;EACZ,WAAW,EAAA;;AAQf;EAEQ,gCAA2C,EAAA;;AAFnD;EAEQ,gCAA2C,EAAA;;AAFnD;EAEQ,gCAA2C,EAAA;;AAFnD;EAEQ,gCAA2C,EAAA;;AAFnD;EAEQ,gCAA2C,EAAA;;AAFnD;EAEQ,gCAA2C,EAAA;;AAFnD;EAEQ,gCAA2C,EAAA;;AAFnD;EAEQ,gCAA2C,EAAA;;AAMvD;EAEQ,aAAa,EAAA;;AAFrB;EAOY,aAAa,EAAA;;AAPzB;EAWY,cAAc,EAAA;;AClV1B;EAEQ,yBAA0C,EAAA;;A9DelD;E8DXY,oCAAoC;EACpC,eAAe;EACf,iBAAiB,EAAA;;AhEV7B;EiECI,mBjG6lB8B;EiG5lB9B,4CjGioBuD,EAAA;;AgCniB3D;EiE1FI,+CjGgnBqE,EAAA;;AiG5mBzE;EAEQ,eAA8B,EAAA;;AjEgGtC;EiE3FI,4CjGqmBqE,EAAA;;AiGlmBzE;EACI,cjG0Ic,EAAA;;AgC1FlB;EiE5CI,eAAe;EACf,iBAAiB,EAAA;;AAGrB;EACI,mBAAmB,EAAA;;AAGvB;EACI,yBAA0C,EAAA;;AAG9C;EACI,oBAAoB,EAAA;EADxB;IAIQ,sCAAuD;IACvD,6CjG2lBuD,EAAA;;AiG7kB3D;EANA,WjGoGW;EiGnGX,yBjGiIgB,EAAA;EiG5HhB;IAIQ,0CjG0FG;IiGzFH,WjGyFG;IiGxFH,yBAAyB,EAAA;EANjC;IAUQ,WjGoFG,EAAA;;AiG9FX;EANA,WjGoGW;EiGnGX,yBjGqIgB,EAAA;EiGhIhB;IAIQ,0CjG0FG;IiGzFH,WjGyFG;IiGxFH,yBAAyB,EAAA;EANjC;IAUQ,WjGoFG,EAAA;;AiG9FX;EANA,WjGoGW;EiGnGX,yBjGuIgB,EAAA;EiGlIhB;IAIQ,0CjG0FG;IiGzFH,WjGyFG;IiGxFH,yBAAyB,EAAA;EANjC;IAUQ,WjGoFG,EAAA;;AiG9FX;EANA,WjGoGW;EiGnGX,yBjGyIgB,EAAA;EiGpIhB;IAIQ,0CjG0FG;IiGzFH,WjGyFG;IiGxFH,yBAAyB,EAAA;EANjC;IAUQ,WjGoFG,EAAA;;AiG9FX;EANA,WjGoGW;EiGnGX,yBjGsIgB,EAAA;EiGjIhB;IAIQ,0CjG0FG;IiGzFH,WjGyFG;IiGxFH,yBAAyB,EAAA;EANjC;IAUQ,WjGoFG,EAAA;;AiG9FX;EANA,WjGoGW;EiGnGX,yBjGoIgB,EAAA;EiG/HhB;IAIQ,0CjG0FG;IiGzFH,WjGyFG;IiGxFH,yBAAyB,EAAA;EANjC;IAUQ,WjGoFG,EAAA;;AiG9FX;EANA,WjGoGW;EiGnGX,yBjGoGc,EAAA;EiG/Fd;IAIQ,0CjG0FG;IiGzFH,WjGyFG;IiGxFH,yBAAyB,EAAA;EANjC;IAUQ,WjGoFG,EAAA;;AiG9FX;EANA,WjGoGW;EiGnGX,yBjG4Gc,EAAA;EiGvGd;IAIQ,0CjG0FG;IiGzFH,WjGyFG;IiGxFH,yBAAyB,EAAA;EANjC;IAUQ,WjGoFG,EAAA;;AiG7EX;EACI,gCAA+B,EAAA;EADnC;IAGQ,qBjGwGQ,EAAA;;AiG3GhB;EACI,gCAA+B,EAAA;EADnC;IAGQ,qBjG4GQ,EAAA;;AiG/GhB;EACI,gCAA+B,EAAA;EADnC;IAGQ,qBjG8GQ,EAAA;;AiGjHhB;EACI,gCAA+B,EAAA;EADnC;IAGQ,qBjGgHQ,EAAA;;AiGnHhB;EACI,gCAA+B,EAAA;EADnC;IAGQ,qBjG6GQ,EAAA;;AiGhHhB;EACI,gCAA+B,EAAA;EADnC;IAGQ,qBjG2GQ,EAAA;;AiG9GhB;EACI,gCAA+B,EAAA;EADnC;IAGQ,qBjG2EM,EAAA;;AiG9Ed;EACI,gCAA+B,EAAA;EADnC;IAGQ,qBjGmFM,EAAA;;AiGvGd;EA2BA,iCAA+C,EAAA;EA3B/C;IA6BI,sCAAyD;IACzD,+CAAgE,EAAA;EAJxE;IAOQ,sCAAyD,EAAA;;AAIjE;EACI,gBAAgB,EAAA;;AAMpB;EACI,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gDAAkE;EAClE,aAAa,EAAA;;AAGjB;EACI,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2CAAyC,EAAA;;AAG7C;EACI,kCAAkC,EAAA;;AAGtC;EACC;IAAK,yBAAyB,EAAA,EAAA;;AAG/B;EACI,kBAAkB;EAClB,gBAAgB,EAAA;EAFpB;IAIQ,WAAW;IACX,yCjGgDY;IiG/CZ,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,OAAO;IACP,SAAS,EAAA;EAVjB;IAaQ,kDAA2C,EAAA;;AAInD;EACI,gBAAgB,EAAA;EADpB;IAGQ,eAAe,EAAA;EAHvB;IAOY,aAAa,EAAA;EAPzB;IAUY,cAAc,EAAA;EAV1B;IAcgB,cAAc,EAAA;EAd9B;IAiBgB,aAAa,EAAA;;ACjK7B;EACI,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,oCAAoC,EAAA;;A3E0FK;E2EtFzC,6ClG2nB2D;EkG1nB3D,6BAA6B;EAC7B,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa,EAAA;EANjB;IASQ,aAAa;IACb,kBAAkB;IAClB,mBAAmB,EAAA;EAX3B;IAeQ,iCAAiC,EAAA;;AAIzC;EACI;IACI,gBAAgB,EAAA;EAGpB;IACI,eAAe,EAAA,EAAA;;AAIvB;EACI;IACI,gBAAgB,EAAA;EAGpB;IACI,kBAAkB,EAAA,EAAA;;AAI1B;EACI;IACI,YAAY,EAAA;EAGhB;IACI,YAAY,EAAA;EAGhB;IACI,YAAY,EAAA,EACf;;ArEWL;EqEPI,iBAAiB,EAAA;EADrB;IAGQ,gBAAgB,EAAA;EAHxB;IAOQ,WAAW;IACX,kBAAkB;IAClB,2ClG+EO;IkG9EP,SlGmiByB;IkGliBzB,YlGkiByB;IkGjiBzB,WlGiiByB;IkGhiBzB,OAAO;IACP,kCAAwD,EAAA;;AAMhE;EACI,2BAA2B,EAAA;;AAO/B;EACI,YAAY,EAAA;;AAGhB;EACI,YAAY,EAAA;;A7GoqmDhB;E6G/pmDQ,kBAAc,EAAA;;A7GkqmDtB;E6G9pmDQ,oBAAc,EAAA;;AAItB;EAEQ,SAAS,EAAA;EAFjB;IAIY,+BlGsCG,EAAA;IkG1Cf;MAMgB,uCAA2D,EAAA;IAN3E;MASgB,WlGiCD,EAAA;;AkGzBX;EAGM,0ClGoDU;EkGnDV,clGmDU,EAAA;;AkGvDhB;EAGM,yClGwDU;EkGvDV,clGuDU,EAAA;;AkG3DhB;EAGM,0ClG0DU;EkGzDV,clGyDU,EAAA;;AkG7DhB;EAGM,0ClG4DU;EkG3DV,clG2DU,EAAA;;AkG/DhB;EAGM,yClGyDU;EkGxDV,clGwDU,EAAA;;AkG5DhB;EAGM,0ClGuDU;EkGtDV,clGsDU,EAAA;;AkG1DhB;EAGM,2ClGuBQ;EkGtBR,clGsBQ,EAAA;;AkG1Bd;EAGM,wClG+BQ;EkG9BR,clG8BQ,EAAA;;AmG/JlB;EAGY,yBAA0C;EAC1C,gBnG2HY,EAAA;;AmGtHxB;EAEQ,yBAA0C;EAC1C,gBnGmHgB,EAAA;;AmG/GxB;EAGQ,gBnGonB0B,EAAA;;AmGhnBlC;EACI,2CAA4D,EAAA;EADhE;IAIQ,kBAAkB,EAAA;IAJ1B;MAOY,YAAY;MACZ,gBnGgGY,EAAA;MmGxGxB;QAWgB,WAAW;QACX,mBnGiJI;QmGhJJ,WAAW;QACX,kBAAkB;QAClB,WAAW;QACX,OAAO;QACP,SAAS;QACT,6BAA6B;QAC7B,mBAAmB,EAAA;MAnBnC;QAuBgB,cnGsII,EAAA;QmG7JpB;UA0BoB,mBAAmB,EAAA;EA1BvC;IAiCQ,iBAAiB,EAAA;IAjCzB;MAoCY,kBnGocC,EAAA;;AmG7bb;EAGY,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB,EAAA;EAL9B;IAQgB,eAAe,EAAA;;AAO/B;EAGY,yBnGqEM;EmGpEN,aAAa,EAAA;;AAOzB;EAGY,kBAAkB;EAClB,kBAAkB,EAAA;EAJ9B;IAOgB,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,SAAS;IACT,2BAA2B;IlF5FrC,uGjBuqCsH,EAAA;IiBnqCtH;MkF4EN;QlF3EQ,gBAAgB,EAAA,EkFyFX;EAdb;IAkBoB,yBnGsEA,EAAA;;AmG9DpB;EAEQ,kBAAkB;EAClB,gBAAgB,EAAA;EAHxB;IAMY,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB,EAAA;IAT9B;MAYgB,eAAe,EAAA;IAZ/B;MAgBgB,eAAe,EAAA;IAhB/B;MAqBoB,WnGWL,EAAA;ImGhCf;MA0BgB,kBAAkB;MAClB,OAAO;MACP,QAAQ;MACR,oBAAoB,EAAA;MA7BpC;QAgCoB,QAAQ;QACR,2BAA2B,EAAA;MAjC/C;QAqCoB,aAAa,EAAA;IArCjC;MA2CoB,WAAW;MACX,0BAA0B,EAAA;IA5C9C;MAgDoB,UAAU,EAAA;;AAS9B;EAEQ,iCAA+C;EAC/C,eAAe;EACf,kBAAkB,EAAA;EAElB;IANR;MAQgB,WAAW;MACX,kBAAkB;MAClB,YAAY;MACZ,QAAQ;MACR,2BAA2B;MAC3B,8BAA8B;MAC9B,8BAA8B;MAC9B,uCAAuC,EAAA;IAfvD;MAoBoB,0BnGfA,EAAA,EmGgBH;;AAOjB;EAEQ,kBAAkB,EAAA;EAF1B;IAKY,2BAA8C;IAC9C,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,UAAU,EAAA;IAVtB;MAagB,kBAAkB,EAAA;IAblC;MAiBgB,WAAW;MACX,kBAAkB;MAClB,MAAM;MACN,QAAQ;MACR,QAAQ;MACR,YAAY;MACZ,6DAA6D;MAC7D,yBnG/CI;MmGgDJ,WAAW,EAAA;IAzB3B;MA8BgB,WnGnFD;MmGoFC,wCAAwC,EAAA;MA/BxD;QAkCoB,WAAW;QACX,OAAO,EAAA;;AAO3B;EAEQ,iCAAiC,EAAA;EAFzC;IAKY,yBnGtEQ,EAAA;;AmG6EhB;EAGY,cnGhFI;EmGiFJ,yBnGjFI,EAAA;;AmG6EhB;EAGY,cnG5EI;EmG6EJ,yBnG7EI,EAAA;;AmGyEhB;EAGY,cnG1EI;EmG2EJ,yBnG3EI,EAAA;;AmGuEhB;EAGY,cnGxEI;EmGyEJ,yBnGzEI,EAAA;;AmGqEhB;EAGY,cnG3EI;EmG4EJ,yBnG5EI,EAAA;;AmGwEhB;EAGY,cnG7EI;EmG8EJ,yBnG9EI,EAAA;;AmG0EhB;EAGY,cnG7GE;EmG8GF,yBnG9GE,EAAA;;AmG0Gd;EAGY,cnGrGE;EmGsGF,yBnGtGE,EAAA;;AmG4GlB;EACI,yBnGxFgB;EmGyFhB,sBnG6WgC,EAAA;EmG/WpC;IAMY,gCnG3HG,EAAA;ImGqHf;MASgB,WnG9HD;MmG+HC,0CnG/HD,EAAA;EmGqHf;IAkBgB,qCAAsD,EAAA;IAlBtE;MAqBoB,cnGzIF;MmG0IE,yBnG7GA,EAAA;;AmGsHhB;EACI,yBnGvHY,EAAA;;AmGsHhB;EACI,yBnGnHY,EAAA;;AmGkHhB;EACI,yBnGjHY,EAAA;;AmGgHhB;EACI,yBnG/GY,EAAA;;AmG8GhB;EACI,yBnGlHY,EAAA;;AmGiHhB;EACI,yBnGpHY,EAAA;;AmGmHhB;EACI,yBnGpJU,EAAA;;AmGmJd;EACI,yBnG5IU,EAAA;;AmG2Id;EAMA,iCAA+C,EAAA;;AAK/C;EAGY,WnGlKD;EmGmKC,yBnGrII,EAAA;;AmGiIhB;EAWgB,cnG5IA;EmG6IA,0CAAiE,EAAA;;AAZjF;EAoBgB,cnGrJA;EmGsJA,0CAAiE,EAAA;EArBjF;IAwBoB,yBnGzJJ,EAAA;;AmGiIhB;EAkCoB,yBnGnKJ,EAAA;;AmGiIhB;EA4CoB,0BnG7KJ,EAAA;;AmGiIhB;EAGY,WnGlKD;EmGmKC,yBnGjII,EAAA;;AmG6HhB;EAWgB,cnGxIA;EmGyIA,0CAAiE,EAAA;;AAZjF;EAoBgB,cnGjJA;EmGkJA,0CAAiE,EAAA;EArBjF;IAwBoB,yBnGrJJ,EAAA;;AmG6HhB;EAkCoB,yBnG/JJ,EAAA;;AmG6HhB;EA4CoB,0BnGzKJ,EAAA;;AmG6HhB;EAGY,WnGlKD;EmGmKC,yBnG/HI,EAAA;;AmG2HhB;EAWgB,cnGtIA;EmGuIA,0CAAiE,EAAA;;AAZjF;EAoBgB,cnG/IA;EmGgJA,0CAAiE,EAAA;EArBjF;IAwBoB,yBnGnJJ,EAAA;;AmG2HhB;EAkCoB,yBnG7JJ,EAAA;;AmG2HhB;EA4CoB,0BnGvKJ,EAAA;;AmG2HhB;EAGY,WnGlKD;EmGmKC,yBnG7HI,EAAA;;AmGyHhB;EAWgB,cnGpIA;EmGqIA,0CAAiE,EAAA;;AAZjF;EAoBgB,cnG7IA;EmG8IA,0CAAiE,EAAA;EArBjF;IAwBoB,yBnGjJJ,EAAA;;AmGyHhB;EAkCoB,yBnG3JJ,EAAA;;AmGyHhB;EA4CoB,0BnGrKJ,EAAA;;AmGyHhB;EAGY,WnGlKD;EmGmKC,yBnGhII,EAAA;;AmG4HhB;EAWgB,cnGvIA;EmGwIA,0CAAiE,EAAA;;AAZjF;EAoBgB,cnGhJA;EmGiJA,0CAAiE,EAAA;EArBjF;IAwBoB,yBnGpJJ,EAAA;;AmG4HhB;EAkCoB,yBnG9JJ,EAAA;;AmG4HhB;EA4CoB,0BnGxKJ,EAAA;;AmG4HhB;EAGY,WnGlKD;EmGmKC,yBnGlII,EAAA;;AmG8HhB;EAWgB,cnGzIA;EmG0IA,0CAAiE,EAAA;;AAZjF;EAoBgB,cnGlJA;EmGmJA,0CAAiE,EAAA;EArBjF;IAwBoB,yBnGtJJ,EAAA;;AmG8HhB;EAkCoB,yBnGhKJ,EAAA;;AmG8HhB;EA4CoB,0BnG1KJ,EAAA;;AmG8HhB;EAGY,WnGlKD;EmGmKC,yBnGlKE,EAAA;;AmG8Jd;EAWgB,cnGzKF;EmG0KE,0CAAiE,EAAA;;AAZjF;EAoBgB,cnGlLF;EmGmLE,0CAAiE,EAAA;EArBjF;IAwBoB,yBnGtLN,EAAA;;AmG8Jd;EAkCoB,yBnGhMN,EAAA;;AmG8Jd;EA4CoB,0BnG1MN,EAAA;;AmG8Jd;EAGY,WnGlKD;EmGmKC,yBnG1JE,EAAA;;AmGsJd;EAWgB,cnGjKF;EmGkKE,0CAAiE,EAAA;;AAZjF;EAoBgB,cnG1KF;EmG2KE,0CAAiE,EAAA;EArBjF;IAwBoB,yBnG9KN,EAAA;;AmGsJd;EAkCoB,yBnGxLN,EAAA;;AmGsJd;EA4CoB,0BnGlMN,EAAA;;AmG2MlB;EACI,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB,EAAA;EAHrB;IAMQ,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,2BAA2B;IAC3B,WAAW,EAAA;EAVnB;IAcQ,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B,EAAA;IAhBtC;MAmBY,WAAW;MACX,YAAY;MACZ,iCAA+C;MAC/C,UAAU;MACV,qBAAkC;MAClC,gBnGnQY,EAAA;MmG2OxB;QA4BgB,yBnGlNI;QmGmNJ,WnGjPD,EAAA;;AmGwPf;EAEQ,iCAA+C,EAAA;EAFvD;IAKY,gBAAgB;IAChB,kBAAkB;IAClB,gBnGtRY;ImGuRZ,qBAAkC,EAAA;IAR9C;MAWgB,WAAW;MACX,kBAAkB;MAClB,6BAA6B;MAC7B,YAAY;MACZ,QAAQ;MACR,2BAA2B,EAAA;IAhB3C;MAoBgB,0CnG9OI;MmG+OJ,cnG/OI,EAAA;MmG0NpB;QAwBoB,8BAA8B,EAAA;IAxBlD;MA6BgB,yCnGvPI;MmGwPJ,cnGxPI;MmGyPJ,gBAAgB,EAAA;MA/BhC;QAkCoB,0CnG5PA,EAAA;EmG0NpB;IA2CwB,aAAa,EAAA;;AASrC;EAEQ,SAAS,EAAA;EAFjB;IAKY,gBAAgB;IAChB,gDAAkE;IAClE,wCAA6D;IAC7D,qBAAkC,EAAA;IAR9C;MAWgB,gBnG8OiB,EAAA;ImGzPjC;MAegB,cnG1RI;MmG2RJ,sBAAsB;MACtB,gBnGpVQ;MmGqVR,WAAW,EAAA;IAlB3B;MAwBoB,cnGhSA,EAAA;MmGwQpB;QA2BwB,gBAAgB,EAAA;IA3BxC;MAiCgB,qBnG/SI,EAAA;ImG8QpB;MAqCgB,qBnG7SI,EAAA;;AmGoTpB;EAGY,6BAA6B;EAC7B,oCAAoC,EAAA;EAJhD;IAOgB,qBnGjUI;ImGkUJ,6BAA6B;IAC7B,cnGnUI,EAAA;;AmG2UhB;EAIgB,cnG/UA;EmGgVA,qBnGhVA,EAAA;;AmG2UhB;EAIgB,cnG3UA;EmG4UA,qBnG5UA,EAAA;;AmGuUhB;EAIgB,cnGzUA;EmG0UA,qBnG1UA,EAAA;;AmGqUhB;EAIgB,cnGvUA;EmGwUA,qBnGxUA,EAAA;;AmGmUhB;EAIgB,cnG1UA;EmG2UA,qBnG3UA,EAAA;;AmGsUhB;EAIgB,cnG5UA;EmG6UA,qBnG7UA,EAAA;;AmGwUhB;EAIgB,cnG5WF;EmG6WE,qBnG7WF,EAAA;;AmGwWd;EAIgB,cnGpWF;EmGqWE,qBnGrWF,EAAA;;AmG6WlB;EAEQ,kBAAkB;EAClB,gBAAgB,EAAA;EAHxB;IAMY,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,mCAAmD;IACnD,kBAAkB;IAClB,yBAAyB,EAAA;IAXrC;MAegB,cAAc;MACd,YAAY;MACZ,kBAAkB;MAClB,SAAS;MACT,YAAY;MACZ,WAAW;MACX,mCAAmD;MACnD,yBAAyB,EAAA;IAtBzC;MA0BgB,wBAAwB;MACxB,YAAY;MACZ,4BAA4B,EAAA;IA5B5C;MAgCgB,wBAAwB;MACxB,WAAW;MACX,6BAA6B,EAAA;IAlC7C;MAwCgB,yBnGhYI;MmGiYJ,WnG/ZD,EAAA;ImGsXf;MA6CgB,UAAU,EAAA;;ACzjB1B;EAEQ,gBpGyrByB,EAAA;;AW3rBjC;EyFMQ,oCpGgnBiE,EAAA;;AoGtnBzE;EASQ,qBpGkmByB,EAAA;;AoG7lBjC;;EAIQ,mBAAmB,EAAA;;AAM3B;EACI,mBpGseS,EAAA;EoGveb;;IAOY,kBAAkB,EAAA;EAP9B;;IAWY,mBAAmB,EAAA;EAX/B;IAgBQ,qBpGmkByB,EAAA;;AoG7jB7B;EAGY,gCAA+B,EAAA;;AAI3C;EAGY,uCAAmD,EAAA;;AAV/D;EAGY,gCAA+B,EAAA;;AAI3C;EAGY,uCAAmD,EAAA;;AAV/D;EAGY,gCAA+B,EAAA;;AAI3C;EAGY,uCAAmD,EAAA;;AAV/D;EAGY,gCAA+B,EAAA;;AAI3C;EAGY,uCAAmD,EAAA;;AAV/D;EAGY,gCAA+B,EAAA;;AAI3C;EAGY,uCAAmD,EAAA;;AAV/D;EAGY,gCAA+B,EAAA;;AAI3C;EAGY,uCAAmD,EAAA;;AAV/D;EAGY,gCAA+B,EAAA;;AAI3C;EAGY,qCAAmD,EAAA;;AAV/D;EAGY,gCAA+B,EAAA;;AAI3C;EAGY,uCAAmD,EAAA;;AAMnE;EAEQ,iBAAiB;EACjB,kBAAkB,EAAA;EAH1B;IAKY,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,sBAAsB,EAAA;;AARlC;EAYQ,kBAAkB,EAAA;EAZ1B;IAcY,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,oCAAoC,EAAA;EAnBhD;IAsBY,kBAAiB;IACjB,aAAa;IACb,iBAAiB;IACjB,oCAAoC;IACpC,iBAAiB;IACjB,SAAS,EAAA;;A/G00nDrB;E+Gn0nDQ,iCAAwD;EACxD,2BAAuD,EAAA;E/Gq0nD7D;I+Gn0nDU,iCAAwD,EAAA;;AAKpE;EAEQ,8CAAuE;EACvE,2BAAuD,EAAA;;AAH/D;;EAQQ,2BAAuD;EACvD,mCAA4D,EAAA;;AATpE;;EAcQ,2CAAyE,EAAA;;AAIjF;EAEQ,mCAA4D;EAC5D,2BAAuD;EACvD,wCAAsE,EAAA;;AAJ9E;EAQQ,oBAA0C,EAAA;;AARlD;EAYQ,oCAA8D,EAAA;;AvDEtE;EwDvII,gBrG0rB6B,EAAA;;AqGvrBjC;EAEQ,iBAAiB,EAAA;EAFzB;IAKY,4BAAkC,EAAA;;AAL9C;EAUQ,cAAc,EAAA;;AAItB;EAGG,UAAU;EACV,0BAA0B;EAC1B,+BAA+B,EAAA;;AALlC;EAUI,UAAU;EACV,wBAAwB,EAAA;;AAX5B;EAkBG,sCAAsC;EACtC,6BAA6B,EAAA;;AAnBhC;EAwBI,eAAe,EAAA;;AAxBnB;EA+BG,oCAAoC;EACpC,4BAA4B,EAAA;;AAhC/B;EAqCI,eAAe,EAAA;;AArCnB;EA2CE,mBAAmB,EAAA;EA3CrB;IA8CG,UAAU;IACV,0BAA0B;IAC1B,mBAAmB,EAAA;EAhDtB;IAqDI,UAAU;IACV,wBAAwB,EAAA;;AAtD5B;EA6DG,UAAU;EACV,qBAAoB;EACpB,wBAAwB,EAAA;;AA/D3B;EAoEI,UAAU;EACV,mBAAmB,EAAA;;AAOvB;EACC,qBrGy5C0C,EAAA;;AqGr5C3C;EACC,aAAa;EACb,qBAAqB;EACrB,gCAAwD,EAAA;EAExD;IALD;MAME,+BAA2D,EAAA,EAE5D;;AAED;EACC,aAAa;EACb,qBAAqB;EACrB,gCAAwD;EACxD,qBrGu4C0C,EAAA;EqGr4C1C;IAND;MAOE,+BAA2D,EAAA,EAE5D;;AAED;EACC;IACC,UAAU;IACV,kCAAkC,EAAA;EAGnC;IACC,UAAU;IACV,wBAAwB,EAAA,EAAA;;AAK1B;EACC;IACC,UAAU;IACV,iCAAiC,EAAA;EAGlC;IACC,UAAU;IACV,wBAAwB,EAAA,EAAA;;AAI1B;EACC;IACC,UAAU;IACV,iCAA8B,EAAA;EAG/B;IACC,UACD,EAAA,EAAA;;AAGD;EACC,0DAAg8D;EACh8D,sBAAsB;EACtB,2BAA2B,EAAA;;AC9J5B;EAGY,oBAAoB;EACpB,sBtGqnBwB,EAAA;;AsG/mBpC;EAEQ,8BAA8B;EAC9B,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAA;;AAP1B;EAYY,eAAe;EACf,gBAAgB,EAAA;;AAK5B;EAEQ,gBtGwmB0B,EAAA;;AuGtoBlC;EACI,WAAW,EAAA;;AAIf;EACI,YAAY,EAAA;;AAIhB;EACI,YAAY,EAAA;;AAGhB;EACI,kBAAkB,EAAA;EADtB;IAIQ,kBAAkB;IAClB,UAAU,EAAA;IALlB;MAQY,oCAA2D,EAAA;;AAOvE;EACI,kBAAkB,EAAA;EADtB;IAIQ,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B,EAAA;;AAItC;EACI;IACI,QAAQ,EAAA,EAAA;;AAMhB;EACI,YAAY;EACZ,YAAY;EACZ,mBAAmB,EAAA;EAHvB;IAMQ,kBAAkB;IAClB,mBAAmB,EAAA;IAP3B;MAUY,WAAW;MACX,kBAAkB;MAClB,UAAU;MACV,WAAW;MACX,sBvGwFG;MuGvFH,kBAAkB;MAClB,UAAU;MACV,QAAQ;MACR,2BAA2B,EAAA;;AAOvC;EACI,iBAAiB,EAAA;EADrB;IAIQ,kBAAkB;IAClB,iBAAiB,EAAA;IALzB;MAQY,kBAAkB;MAClB,UAAU;MACV,WAAW;MACX,yBvGgGQ;MuG/FR,WvGiEG;MuGhEH,qBAAqB;MACrB,iBAAiB;MACjB,cAAc;MACd,kBAAkB,EAAA;MAhB9B;QAmBgB,WAAW;QACX,kBAAkB;QAClB,6BAA6B;QAC7B,yBvGqFI;QuGpFJ,YAAY;QACZ,SAAS;QACT,2BAA2B,EAAA;;AAO3C;EACI,eAAe,EAAA;EADnB;IAIQ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,WvGsCO,EAAA;IuG7Cf;MASY,WAAW;MACX,kBAAkB;MAClB,8BAA8B;MAC9B,YAAY;MACZ,YAAY;MACZ,UAAU,EAAA;;AAOlB;EACI,yBvGqDY,EAAA;EuGpDZ;IACI,0BvGmDQ,EAAA;EuGjDZ;IACI,oDAA2C;IAC3C,yBAAqB,EAAA;IACrB;MACI,0CvG6CI,EAAA;;AuGtDhB;EACI,yBvGyDY,EAAA;EuGxDZ;IACI,0BvGuDQ,EAAA;EuGrDZ;IACI,mDAA2C;IAC3C,yBAAqB,EAAA;IACrB;MACI,yCvGiDI,EAAA;;AuG1DhB;EACI,yBvG2DY,EAAA;EuG1DZ;IACI,0BvGyDQ,EAAA;EuGvDZ;IACI,oDAA2C;IAC3C,yBAAqB,EAAA;IACrB;MACI,0CvGmDI,EAAA;;AuG5DhB;EACI,yBvG6DY,EAAA;EuG5DZ;IACI,0BvG2DQ,EAAA;EuGzDZ;IACI,oDAA2C;IAC3C,yBAAqB,EAAA;IACrB;MACI,0CvGqDI,EAAA;;AuG9DhB;EACI,yBvG0DY,EAAA;EuGzDZ;IACI,0BvGwDQ,EAAA;EuGtDZ;IACI,mDAA2C;IAC3C,yBAAqB,EAAA;IACrB;MACI,yCvGkDI,EAAA;;AuG3DhB;EACI,yBvGwDY,EAAA;EuGvDZ;IACI,0BvGsDQ,EAAA;EuGpDZ;IACI,oDAA2C;IAC3C,yBAAqB,EAAA;IACrB;MACI,0CvGgDI,EAAA;;AuGzDhB;EACI,yBvGwBU,EAAA;EuGvBV;IACI,0BvGsBM,EAAA;EuGpBV;IACI,qDAA2C;IAC3C,yBAAqB,EAAA;IACrB;MACI,2CvGgBE,EAAA;;AuGzBd;EACI,yBvGgCU,EAAA;EuG/BV;IACI,0BvG8BM,EAAA;EuG5BV;IACI,kDAA2C;IAC3C,yBAAqB,EAAA;IACrB;MACI,wCvGwBE,EAAA;;AiDnKlB;EuDKI,6CxGooB2D,EAAA;;AyGpoB/D;EACI,2CAAoC,EAAA;;AAIxC;EAEQ,aAAa;EACb,sBAAsB,EAAA;EAH9B;IAMY,qDAA4E;IAC5E,iBAAiB;IACjB,sBAAsB,EAAA;;AAO9B;EAGY,cAAO;EACP,qBAAc;EACd,0CzG0JI,EAAA;EyG/JhB;IAQgB,cAAO,EAAA;;AARvB;EAcgB,qBAAc,EAAA;EAd9B;IAiBoB,cAAO,EAAA;;AAjB3B;EAGY,cAAO;EACP,qBAAc;EACd,yCzG8JI,EAAA;EyGnKhB;IAQgB,cAAO,EAAA;;AARvB;EAcgB,qBAAc,EAAA;EAd9B;IAiBoB,cAAO,EAAA;;AAjB3B;EAGY,cAAO;EACP,qBAAc;EACd,0CzGgKI,EAAA;EyGrKhB;IAQgB,cAAO,EAAA;;AARvB;EAcgB,qBAAc,EAAA;EAd9B;IAiBoB,cAAO,EAAA;;AAjB3B;EAGY,cAAO;EACP,qBAAc;EACd,0CzGkKI,EAAA;EyGvKhB;IAQgB,cAAO,EAAA;;AARvB;EAcgB,qBAAc,EAAA;EAd9B;IAiBoB,cAAO,EAAA;;AAjB3B;EAGY,cAAO;EACP,qBAAc;EACd,yCzG+JI,EAAA;EyGpKhB;IAQgB,cAAO,EAAA;;AARvB;EAcgB,qBAAc,EAAA;EAd9B;IAiBoB,cAAO,EAAA;;AAjB3B;EAGY,cAAO;EACP,qBAAc;EACd,0CzG6JI,EAAA;EyGlKhB;IAQgB,cAAO,EAAA;;AARvB;EAcgB,qBAAc,EAAA;EAd9B;IAiBoB,cAAO,EAAA;;AAjB3B;EAGY,cAAO;EACP,qBAAc;EACd,2CzG6HE,EAAA;EyGlId;IAQgB,cAAO,EAAA;;AARvB;EAcgB,qBAAc,EAAA;EAd9B;IAiBoB,cAAO,EAAA;;AAjB3B;EAGY,cAAO;EACP,qBAAc;EACd,wCzGqIE,EAAA;EyG1Id;IAQgB,cAAO,EAAA;;AARvB;EAcgB,qBAAc,EAAA;EAd9B;IAiBoB,cAAO,EAAA;;AAjB3B;EA4BQ,qBAAkC;EAClC,4BAAyC;EACzC,gDAAiE,EAAA;EA9BzE;IAgCY,qBAAkC,EAAA;;AAhC9C;EAqCY,4BAAyC,EAAA;EArCrD;IAuCgB,qBAAkC,EAAA;;ArF5DtD;EsFCI,kBAAkB;EAClB,gBAAgB,EAAA;EtFFpB;IsFMQ,eAAe,EAAA;EANvB;IAUQ,eAAe,EAAA;;AASnB;EAGY,yB1G8JI;E0G7JJ,qB1G6JI,EAAA;;A0GxJhB;EAGY,qB1GqJI;E0GpJJ,yB1GoJI,EAAA;E0GxJhB;IAOgB,yB1GiJA,EAAA;;A0GjKhB;EAGY,yB1GkKI;E0GjKJ,qB1GiKI,EAAA;;A0G5JhB;EAGY,qB1GyJI;E0GxJJ,yB1GwJI,EAAA;E0G5JhB;IAOgB,yB1GqJA,EAAA;;A0GrKhB;EAGY,yB1GoKI;E0GnKJ,qB1GmKI,EAAA;;A0G9JhB;EAGY,qB1G2JI;E0G1JJ,yB1G0JI,EAAA;E0G9JhB;IAOgB,yB1GuJA,EAAA;;A0GvKhB;EAGY,yB1GsKI;E0GrKJ,qB1GqKI,EAAA;;A0GhKhB;EAGY,qB1G6JI;E0G5JJ,yB1G4JI,EAAA;E0GhKhB;IAOgB,yB1GyJA,EAAA;;A0GzKhB;EAGY,yB1GmKI;E0GlKJ,qB1GkKI,EAAA;;A0G7JhB;EAGY,qB1G0JI;E0GzJJ,yB1GyJI,EAAA;E0G7JhB;IAOgB,yB1GsJA,EAAA;;A0GtKhB;EAGY,yB1GiKI;E0GhKJ,qB1GgKI,EAAA;;A0G3JhB;EAGY,qB1GwJI;E0GvJJ,yB1GuJI,EAAA;E0G3JhB;IAOgB,yB1GoJA,EAAA;;A0GpKhB;EAGY,yB1GiIE;E0GhIF,qB1GgIE,EAAA;;A0G3Hd;EAGY,qB1GwHE;E0GvHF,yB1GuHE,EAAA;E0G3Hd;IAOgB,yB1GoHF,EAAA;;A0GpId;EAGY,yB1GyIE;E0GxIF,qB1GwIE,EAAA;;A0GnId;EAGY,qB1GgIE;E0G/HF,yB1G+HE,EAAA;E0GnId;IAOgB,yB1G4HF,EAAA;;A0GrHlB;EACI,eAAe;EACf,gBAAgB,EAAA;;AAIpB;EACI,eAAe;EACf,qBAAqB,EAAA;EAFzB;IAKQ,YAAY;IACZ,cAAc;IACd,oBAA4C,EAAA;EAPpD;IAWQ,cAAc,EAAA;EAXtB;IAgBY,qBAA8C,EAAA;;AAUtD;EAIgB,c1GsGA;E0GrGA,6BAA6B;EAC7B,qB1GoGA,EAAA;;A0G1GhB;EAIgB,c1G0GA;E0GzGA,6BAA6B;EAC7B,qB1GwGA,EAAA;;A0G9GhB;EAIgB,c1G4GA;E0G3GA,6BAA6B;EAC7B,qB1G0GA,EAAA;;A0GhHhB;EAIgB,c1G8GA;E0G7GA,6BAA6B;EAC7B,qB1G4GA,EAAA;;A0GlHhB;EAIgB,c1G2GA;E0G1GA,6BAA6B;EAC7B,qB1GyGA,EAAA;;A0G/GhB;EAIgB,c1GyGA;E0GxGA,6BAA6B;EAC7B,qB1GuGA,EAAA;;A0G7GhB;EAIgB,c1GyEF;E0GxEE,6BAA6B;EAC7B,qB1GuEF,EAAA;;A0G7Ed;EAIgB,c1GiFF;E0GhFE,6BAA6B;EAC7B,qB1G+EF,EAAA;;A0GxElB;EAEQ,kBAAkB,EAAA;EAF1B;IAKY,sBAAsB,EAAA;IALlC;MAQgB,iBAAiB;MACjB,oCAAoC;MACpC,SAAS;MACT,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,SAAS,EAAA;;AAWrB;EAIgB,c1GgEA;E0G/DA,6BAA6B;EAC7B,qB1G8DA,EAAA;;A0GpEhB;EAIgB,c1GoEA;E0GnEA,6BAA6B;EAC7B,qB1GkEA,EAAA;;A0GxEhB;EAIgB,c1GsEA;E0GrEA,6BAA6B;EAC7B,qB1GoEA,EAAA;;A0G1EhB;EAIgB,c1GwEA;E0GvEA,6BAA6B;EAC7B,qB1GsEA,EAAA;;A0G5EhB;EAIgB,c1GqEA;E0GpEA,6BAA6B;EAC7B,qB1GmEA,EAAA;;A0GzEhB;EAIgB,c1GmEA;E0GlEA,6BAA6B;EAC7B,qB1GiEA,EAAA;;A0GvEhB;EAIgB,c1GmCF;E0GlCE,6BAA6B;EAC7B,qB1GiCF,EAAA;;A0GvCd;EAIgB,c1G2CF;E0G1CE,6BAA6B;EAC7B,qB1GyCF,EAAA;;A0GlClB;EAEQ,kBAAkB,EAAA;EAF1B;IAKY,sBAAsB,EAAA;IALlC;MAQgB,iBAAiB;MACjB,oCAAoC;MACpC,QAAQ;MACR,kBAAkB;MAClB,cAAc;MACd,WAAW,EAAA;;AAS3B;EACI,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB,EAAA;EAHrB;IAMQ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB,EAAA;EAT1B;IAaQ,sBAAsB,EAAA;;AAI9B;EACI,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB,EAAA;EAHrB;IAMQ,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB,EAAA;;AnFnI1B;EmFwII,kBAAkB,EAAA;;AAMlB;EAIY,yB1GRI;E0GSJ,qB1GTI,EAAA;;A0GchB;EAKoB,c1GnBJ,EAAA;;A0GIhB;EAIY,yB1GJI;E0GKJ,qB1GLI,EAAA;;A0GUhB;EAKoB,c1GfJ,EAAA;;A0GAhB;EAIY,yB1GFI;E0GGJ,qB1GHI,EAAA;;A0GQhB;EAKoB,c1GbJ,EAAA;;A0GFhB;EAIY,yB1GAI;E0GCJ,qB1GDI,EAAA;;A0GMhB;EAKoB,c1GXJ,EAAA;;A0GJhB;EAIY,yB1GHI;E0GIJ,qB1GJI,EAAA;;A0GShB;EAKoB,c1GdJ,EAAA;;A0GDhB;EAIY,yB1GLI;E0GMJ,qB1GNI,EAAA;;A0GWhB;EAKoB,c1GhBJ,EAAA;;A0GChB;EAIY,yB1GrCE;E0GsCF,qB1GtCE,EAAA;;A0G2Cd;EAKoB,c1GhDN,EAAA;;A0GiCd;EAIY,yB1G7BE;E0G8BF,qB1G9BE,EAAA;;A0GmCd;EAKoB,c1GxCN,EAAA;;A0GmDlB;EAEQ,kBAAkB;EAClB,sBAAsB,EAAA;EAH9B;IAMY,iBAAiB;IACjB,oCAAoC;IACpC,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,c1GlEM;IiBhJZ,iDjBygCgE,EAAA;IiBrgChE;MyFkMN;QzFjMQ,gBAAgB,EAAA,EyF+Mf;EAdT;IAiBY,sBAAsB;IACtB,oC1GkuB+D;IiB17BrE,iDjBygCgE,EAAA;IiBrgChE;MyFkMN;QzFjMQ,gBAAgB,EAAA,EyF0Nf;IAzBT;MAsBgB,WAAW;MACX,UAAU,EAAA;EAvB1B;IA4BY,sBAAsB,EAAA;;AAOlC;EACI,qBAAqB;EACrB,oBAA6C;EAC7C,gBAAgB;EAChB,0BAA0B,EAAA;EAJ9B;IAOQ,YAAY;IACZ,cAAc;IACd,oBAA4C;IAC5C,2BAA2B,EAAA;EAVnC;IAcQ,gBAAgB;IAChB,kBAAkB,EAAA;;AAK1B;EACI,UAAU,EAAA;EADd;IAIQ,0CAAiE;IACjE,8CAAyE;IACzE,sB1G2W4B;I0G1W5B,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,mBAAmB,EAAA;IAb3B;MAgBY,eAAe,EAAA;EAhB3B;IAqBQ,aAAa,EAAA;IArBrB;MAwBY,gCAAiC,EAAA;MAxB7C;QA2BgB,gBAAgB;QAChB,wBAAwB;QACxB,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,eAAe;QACf,c1GtHI,EAAA;E0GqFpB;IA0CoB,W1G7JL,EAAA;;AX4ipDf;EqHr4oDY,0D5F1LsE,EAAA;;A6FlIlF;EACI,kBAAkB,EAAA;EADtB;IAGQ,oBAAgC;IAChC,kBAAkB,EAAA;EAJ1B;IAOQ,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB,EAAA;EAZ3B;IAgBY,qBAAiC;IACjC,oB3Gw0BuB;I2Gv0BvB,kBAAkB,EAAA;EAlB9B;IAqBY,UAAU;IACV,WAAW,EAAA;;AtHkspDvB;EsH3rpDQ,0D7FqG0E;E6FpG1E,+CAAgE;EAChE,+CAAoE,EAAA;;AtH8rpD5E;EsH1rpDQ,+CAAgE;EAChE,+CAAoE,EAAA;;AClCxE;EAGY,oCAAmC;EACnC,qB5G6KI,EAAA;;A4GjLhB;EAGY,oCAAmC;EACnC,qB5GiLI,EAAA;;A4GrLhB;EAGY,oCAAmC;EACnC,qB5GmLI,EAAA;;A4GvLhB;EAGY,oCAAmC;EACnC,qB5GqLI,EAAA;;A4GzLhB;EAGY,oCAAmC;EACnC,qB5GkLI,EAAA;;A4GtLhB;EAGY,oCAAmC;EACnC,qB5GgLI,EAAA;;A4GpLhB;EAGY,oCAAmC;EACnC,qB5GgJE,EAAA;;A4GpJd;EAGY,oCAAmC;EACnC,qB5GwJE,EAAA;;A4GlJlB;EACI,yBAAuB,EAAA;;AnEwD3B;EmEpDI,kBAAkB,EAAA;EADtB;IAGQ,c5GwIU,EAAA;EyCtFlB;ImE/CQ,gB5GgnB0B,EAAA;I4GtnBlC;MAQY,W5G6HG,EAAA;I4GrIf;MAWY,+B5G0HG,EAAA;;AX0npDf;EwH/wpDE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB,EAAA;;AAGzB;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,OAAO;EACP,MAAM;EACN,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,UAAU,EAAA;;AAGZ;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,iCAAiC,EAAA;;AAGnC;EACE,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,YAAY;EAAE,mGAAA;EACd,WAAW;EACX,mBAAmB;EACnB,cAAc;EAAE,mFAAA;EAChB,eAAe;EAAE,kDAAA;EACjB,gBAAgB;EAAE,0CAAA;EAClB,qBAAqB;EACrB,uBAAuB,EAAA;;AAGzB;;EAEE,aAAa,EAAA;;AAGf;;EAEE,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,oBAAoB,EAAA;;AAGtB;EACE,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,aAAa,EAAA;;AAGf;EACE,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,WAAW,EAAA;;AAGb;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,gBAAgB,EAAA;;AxH4wpDlB;EwHxwpDE,oBAAoB;EACpB,iBAAiB;EACjB,yBAAyB,EAAA;;AxH2wpD3B;EwHvwpDE,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,+BAA+B,EAAA;;AAGjC;EACE,0DAAA;EACA,YAAY;EACZ,6BAA6B,EAAA;;AAG/B;EACE,MAAM;EACN,WAAW,EAAA;;AAGb;EACE,QAAQ;EACR,WAAW,EAAA;;AAGb;EACE,OAAO;EACP,YAAY,EAAA;;AAGd;EACE,YAAY;EACZ,SAAS;EACT,UAAU,EAAA;;AAGZ;EACE,WAAW;EACX,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,eAAe;EACf,WAAW,EAAA;;AAGb,gBAAA;AxHgwpDA;EwH9vpDE,WAAW;EACX,OAAO,EAAA;;AAGT;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB,EAAA;;AAGvB;EACE,YAAY,EAAA;;AxH8vpDd;EwHxvpDM,mB7GvCc,EAAA;;AXkypDpB;EwH3vpDM,mB7GnCc,EAAA;;AXiypDpB;EwH9vpDM,mB7GjCc,EAAA;;AXkypDpB;EwHjwpDM,mB7G/Bc,EAAA;;AXmypDpB;EwHpwpDM,mB7GlCc,EAAA;;AXyypDpB;EwHvwpDM,mB7GpCc,EAAA;;AX8ypDpB;EwH1wpDM,mB7GpEY,EAAA;;AXi1pDlB;EwH7wpDM,mB7G5DY,EAAA;;A8GnKlB;;;;EzHm/pDE;AyH7+pDF;;EAEI,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,sEAAsE;EACtE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAIhB,WAAW;EAKX,aAAa,EAAA;;AAWjB;;;;EAII,iBAAiB;EACjB,mBAAmB,EAAA;;AAGvB;EAxCA;;IA2CQ,iBAAiB,EAAA,EACpB;;AAGL,gBAAA;AACA;EACI,YAAY;EACZ,SAAS;EACT,cAAc,EAAA;;AAGlB;;EAEI,sCAAoD,EAAA;;AAGxD,gBAAA;AACA;EACI,cAAc;EACd,oBAAoB;EACpB,mBAAmB,EAAA;;AAGvB;;;;EAII,gBAAgB,EAAA;;AAGpB;EACI,WAAW,EAAA;;AAGf;EACI,YAAY,EAAA;;AAGhB;;;;;;;EAOI,c9G6FgB,EAAA;;A8G1FpB;;;;;;EAMI,WAAW,EAAA;;AAGf;;;;;EAKI,cAAc;EACd,oEAAA;EACA,oCAAkC,EAAA;;AAGtC;;;EAGI,WAAW,EAAA;;AAGf;;EAEI,cAAc,EAAA;;AAGlB;;;EAGI,WAAW,EAAA;;AAGf;;EAEI,iBAAiB,EAAA;;AAErB;EACI,kBAAkB,EAAA;;AAGtB;EACI,YAAY,EAAA;;AAGhB,iBAAA;AArFA;;EAwFI,mB9GQc,EAAA;;A8GtJlB;;EAmJI,c9GOc;E8GNd,iBAAiB,EAAA;;AAOrB;EAEQ,wBAAwB,EAAA;;AAFhC;EAMQ,WAAW,EAAA;;AANnB;EAUQ,YAAY,EAAA;;AAVpB;EAcQ,+CAA+D;EAC/D,mBAAmB;EACnB,iCAA+C,EAAA;;AAhBvD;EAoBQ,mBAAmB;EACnB,iCAA+C,EAAA;;AAOvD;EACI,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,yBAAyB,EAAA;;AAK7B;EACI,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB,EAAA;;AAGzB;EACI,qBAAqB,EAAA;EADzB;IAGQ,gCAAgC;IAChC,kCAAkC;IAClC,mCAAmC;IACnC,gJAAsC;IACtC,gCAA2C;IAC3C,qDAA2D;IAC3D,6BAA6B;IAC7B,yBAA0B;IAC1B,2BAA2B,EAAA;IAXnC;MAaY,wBAAwB;MACxB,2BAA2B,EAAA;IAdvC;MAiBY,oCAAqC;MACrC,sBAAwB,EAAA;;AC/NpC;EAEI,oBAAoB;EACpB,eAAe;EACf,gB/G0HoB,EAAA;;A+GtHxB;EACE,oBAAoB;EACpB,qB/GinBiC;E+GhnBjC,0CAAiE;EACjE,2BAA8C,EAAA;EAJhD;IAOI,8BAAoD,EAAA;EAPxD;IAWI,2BAA8C,EAAA;;AAIlD;EACE,4CAAiE;EACjE,2BAA8C,EAAA;;AAGhD;EACE,eAAe,EAAA;;AAGjB;EAEI,qB/GyJgB;E+GxJhB,c/GwJgB,EAAA;;A+G3JpB;EAOM,yB/GkJc,EAAA;;A+GzJpB;EAWM,qC/G8Ic,EAAA;;A+GzJpB;EAeI,qB/GyIgB;E+GxIhB,c/GwIgB,EAAA;;A+GpIpB;EAEI,gBAAgB,EAAA;;AAIpB;EACE,qDAAuD,EAAA;;AAGzD;EACE,yC/G0HkB,EAAA;;A+GvHpB;EAEI,mB/G+GgB,EAAA;E+GjHpB;IAIM,mB/G6Gc,EAAA;I+GjHpB;MAMQ,mC/G2GY,EAAA;;A+GjHpB;EAWI,mB/GsGgB,EAAA;;A+GlGpB;EAEI,qCAAsC;EACtC,sCAAuC,EAAA;;AAI3C;EACE,wC/Gk3BiF,EAAA;E+Gn3BnF;IAGI,gBAAgB;IAChB,0C/Gw3B2F,EAAA;;A+Gp3B/F;EACE,YAAY;EACZ,cAAc;EACd,sB/GsvBiC;EFzjB7B,oBAvE+B;EiHnHnC,gB/GmlB+B;E+GllB/B,gB/GylB+B;E+GxlB/B,2B/Gk2B6E;E+Gj2B7E,oC/G41ByE;E+G31BzE,4BAA4B;EAC5B,wC/Gg2BiF,EAAA;;A+G71BnF;EACE,sC/G8jB6E;E+G7jB7E,gB/GwkB+B;E+GvkB/B,eAAe,EAAA;EAHjB;IAKI,gBAAgB,EAAA;EALpB;IASI,c/G4DgB,EAAA;;A+GxDpB;EACE,6BAA6B,EAAA;;AC5H/B;EACE,iBAAiB;EACjB,yCAA8D;EAC9D,oCAA2D;EAC3D,kBAAkB,EAAA;EAJpB;IAOI,eAAe;IACf,WAAW;IACX,aAAa,EAAA;;ACTjB;EACE,mBjHwLkB,EAAA;;AiHrLpB;EACE,mBjHoLkB;EiHnLlB,mCAAmD;EACnD,gBAAgB,EAAA;;AAGlB;EACE,WAAW,EAAA;EADb;IAGI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,SAAS,EAAA;IAPb;MAUM,aAAa,EAAA;IAVnB;MAaM,UAAU,EAAA;;AAKhB;EACE,YAAY,EAAA;;AAKd;EACE,sBjHy3C8C;EiHx3C9C,oCjHilBuE;EiHhlBvE,qBjHqlBiC;EiHplBjC,0CAAiE;EACjE,2BAA8C,EAAA;;AAKhD;EACE,UAAU,EAAA;EADZ;IAGI,YAAY;IACZ,WAAW;IACX,WAAW;IACX,UAAU;IACV,UAAU;IACV,kBAAkB,EAAA;IARtB;MAUM,aAAa,EAAA;IAVnB;MAaM,UAAU,EAAA;EAbhB;IAkBI,MAAM,EAAA;;AAIV;EACE,eAAe,EAAA;;AAGjB;EAEI,YAAY,EAAA;;AAIhB;EACE,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB;EAChB,iCAA+C;EAC/C,6BAA2C,EAAA;;AAG7C;EAEI,UAAU,EAAA;;AAMd;EACC,YAAY;EACZ,qBAAqB;EACrB,aAAa,EAAA;;AAGd;EACC,aAAa;EACb,YAAY;EACZ,cAAc;EACd,aAAa;EACb,wCjH4gBwE,EAAA;;AiHzgBzE;EACC,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,wCjHmgBwE;EiHlgBrE,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EAEQ,mBjH6DY,EAAA;;AiHzDpB;EAEQ,mBjH0DY,EAAA;;AiHtDpB;EAEQ,mBjH8CY,EAAA;;AiHxCpB;EAEQ,2BAA2B,EAAA;;AAOnC;EACI,eAAe;EACf,cjHKc;EiHJd,cAAc;EACd,cAAc,EAAA;EAJlB;IAMQ,kBAAkB;IAClB,eAAe;IACf,gBAAgB,EAAA;;AA1HxB;EAiII,aAAa,EAAA;;AAEjB;EACI,cAAc,EAAA;;AAKlB;EAAa,mBjHWO,EAAA;;AiHVpB;EAAa,mBjHYO,EAAA;;AiHXpB;EAAa,mBjHYO,EAAA;;AiHXpB;EAAa,mBjHKO,EAAA;;AiHJpB;EAAa,mBjHKO,EAAA;;AiHDpB;EACI,YAAY,EAAA;EADhB;IAIY,qBjHDQ,EAAA;;AXwtqDpB;E4H7sqDM,mBjHdc,EAAA;;AX8tqDpB;E4H5sqDM,mBjHlBc,EAAA;;AXiuqDpB;E4H1sqDQ,qBjHvBY,EAAA;;AXouqDpB;E4HttqDM,mBjHVc,EAAA;;AXmuqDpB;E4HrtqDM,mBjHdc,EAAA;;AXsuqDpB;E4HntqDQ,qBjHnBY,EAAA;;AXyuqDpB;E4H/tqDM,mBjHRc,EAAA;;AX0uqDpB;E4H9tqDM,mBjHZc,EAAA;;AX6uqDpB;E4H5tqDQ,qBjHjBY,EAAA;;AXgvqDpB;E4HxuqDM,mBjHNc,EAAA;;AXivqDpB;E4HvuqDM,mBjHVc,EAAA;;AXovqDpB;E4HruqDQ,qBjHfY,EAAA;;AXuvqDpB;E4HjvqDM,mBjHTc,EAAA;;AX6vqDpB;E4HhvqDM,mBjHbc,EAAA;;AXgwqDpB;E4H9uqDQ,qBjHlBY,EAAA;;AXmwqDpB;E4H1vqDM,mBjHXc,EAAA;;AXwwqDpB;E4HzvqDM,mBjHfc,EAAA;;AX2wqDpB;E4HvvqDQ,qBjHpBY,EAAA;;AX8wqDpB;E4HnwqDM,mBjH3CY,EAAA;;AXizqDlB;E4HlwqDM,mBjH/CY,EAAA;;AXozqDlB;E4HhwqDQ,qBjHpDU,EAAA;;AXuzqDlB;E4H5wqDM,mBjHnCY,EAAA;;AXkzqDlB;E4H3wqDM,mBjHvCY,EAAA;;AXqzqDlB;E4HzwqDQ,qBjH5CU,EAAA;;AXwzqDlB;E4HlwqDI,YAAY,EAAA;E5HowqDd;I4HjwqDI,WAAW;IACX,YAAY,EAAA;;A5HowqDlB;E4H7vqDI,WAAW,EAAA;E5H+vqDb;I4H5vqDI,WAAW;IACX,YAAY,EAAA;;A5H+vqDlB;E4HxvqDI,WAAW,EAAA;E5H0vqDb;I4HvvqDI,WAAW;IACX,YAAY,EAAA;;A5H0vqDlB;E4HjvqDI,UAAU;EACV,kBAAkB;EAClB,WAAW,EAAA;;A5HovqDf;E4HjvqDI,WAAW;EACX,kBAAkB;EAClB,SAAS,EAAA;;A5HovqDb;E4H9uqDI,qBjH3EgB;EiH4EhB,sBjHhHW,EAAA;;AXi2qDf;E4H3uqDI,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,qBjHvFgB;EiHwFhB,sBjH5HW,EAAA;;AkHrJf;EAEQ,0ClHiLY;EkHhLZ,sClHgLY,EAAA;;AkH5KpB;EACI,eAAe,EAAA;;AAInB;EAEQ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY,EAAA;;AAVpB;EAaQ,kBAAkB,EAAA;;AC1B1B;EACI,oCAA2D;EAC3D,4CnHioBuD,EAAA;;AmH9nB3D;EAGY,iCAA+C;EAC/C,uBnHy8C8B,EAAA;;AmH78C1C;EAQY,qCAAqD,EAAA;EARjE;IAUgB,qCAAqD,EAAA;;AAMrE;EACI,iCAA+C,EAAA;;AAGnD;EACI,eAAe;EACf,gBnHoGoB;EmHnGpB,2BAA8C,EAAA;;AAGlD;EACI,gBnHk7CsC;EmHj7CtC,oBnHmpBmC;EmHlpBnC,2BAA8C,EAAA;;AAGlD;EAEQ,mBAAkC;EAClC,WnH8GO,EAAA;;AmHjHf;EAOQ,2CAA4D;EAC5D,qBAAkC,EAAA;;AAR1C;EAYQ,mBAAkC;EAClC,WnHoGO,EAAA;;AmHhGf;EACI,0BnH25CsC,EAAA;;AmHz5C1C;;EAEI,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,UAAU;EACV,wCAAwC;EACxC,uBAAuB;EACvB,cnHmHgB,EAAA;;AmHhHpB;EACI,UAAU,EAAA;;AAGd;EACI,oBAAoB,EAAA;;ACzExB;EACI,uBAAuB;EACvB,sBAAsB;EACtB,yCpHiLgB;EoHhLhB,kCAA0B;UAA1B,0BAA0B;EAC1B,kBAAkB,EAAA;EALtB;IAOQ,iCAAiC;IACjC,0BAA0B;IAC1B,cpH2KY;IoH1KZ,yBAAyB,EAAA;;AAIjC;EAEQ,2BAA2B,EAAA;;AAGnC;EAEQ,2BAA2B,EAAA;;AAInC;EACI,sBAAsB;EACtB,sBAAsB;EACtB,iCAAmC;EACnC,8BAA8B;EAC9B,gBpHymB8B,EAAA;EoH9mBlC;IAOQ,UAAU,EAAA;;AAIlB;EAEQ,UAAU;EACV,WAAW;EACX,sBpH8GO;EoH7GP,YAAY;EACZ,yBAAyB,EAAA;EANjC;IAQY,UAAU;IACV,WAAW,EAAA;;AAKvB;EACI,WpHmGW;EoHlGX,eAAe;EACf,oCpH2GW;EoH1GX,kCAA0B;UAA1B,0BAA0B,EAAA;;AAI9B;EAEQ,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;EAC7B,iCAAmC;EACnC,uBAAuB;EACvB,yBAAyB,EAAA;EARjC;IAUY,yBAA4B;IAC5B,qBAAqB,EAAA;;AAKjC;EACI,sBAAsB;EACtB,qDAAiD,EAAA;EAFrD;IAIQ,oCAAqC,EAAA;;AAK7C;EACI,2CpHkEW;EoHjEX,kCAA0B;UAA1B,0BAA0B;EAC1B,cAAc;EACd,sBAAsB,EAAA;EAJ1B;IAMQ,sBpH6DO,EAAA;;AoHzDf;EAEQ,oCAAuC,EAAA;;AAF/C;EAMY,oCAAuC,EAAA;;AANnD;EAWY,WpH8CG,EAAA;EoHzDf;IAagB,UAAU,EAAA;;AAb1B;EAkBQ,wCpHgDU,EAAA;;AqH9JlB;EACE,YAAY;EACZ,kBAAkB,EAAA;EAFpB;IAKI,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,crHyIc;IqHxId,iCAA+C;IAC/C,UAAU,EAAA;EApBd;IAwBI,wCrHm7B+E;IqHl7B/E,oCrH46BuE;IqH36BvE,+BrH+lBgC;IqH9lBhC,kCrH8lBgC,EAAA;EqHznBpC;IAgCM,wBAAwB,EAAA;EAhC9B;IAoCM,WAAW,EAAA;EApCjB;IAwCM,WAAW,EAAA;EAxCjB;IA4CM,+CAA+D;IAC/D,mBAAmB;IACnB,oCrHu5BqE,EAAA;EqHr8B3E;IAkDM,mBAAmB;IACnB,oCrHk5BqE,EAAA;EqHr8B3E;IAwDI,eAAe,EAAA;EAxDnB;IA4DI,2BrH84B2E,EAAA;IqH18B/E;MA8DM,yCrHqHc,EAAA;EqHnLpB;IAmEI,wCrHw4B+E;IqHv4B/E,8BrHi4BuE;IqHh4BvE,gCrHojBgC;IqHnjBhC,mCrHmjBgC,EAAA;EqHznBpC;IA0EI,cAAc;IACd,sBrH8wB+B;IqH5wB/B,oBrHsmBmC;IqHrmBnC,2BrH43B2E;IqH33B3E,oCrHs3BuE;IqHr3BvE,wCrH23B+E;IqH13B/E,sBrHwiBgC;IqHviBhC,mBAAmB,EAAA;IAlFvB;MAoFM,crHuEY,EAAA;EqH3JlB;IAyFI,gBrHimB6B;IqHhmB7B,yBAA0C,EAAA;;AC3F9C;EACE,oCAA2D;EAC3D,6CtHmoB6D;EsHloB7D,kBAAkB;EAClB,wCtHknBuE,EAAA;;AsH/mBzE;EAEI,0CAAiE;EACjE,gDtH4mBqE;EsH3mBrE,kBAAkB;EAClB,gBtH2nB8B,EAAA;EsHhoBlC;IAOM,kBAAkB,EAAA;;AAKxB;EAIQ,mBAAmB;EACnB,cAAc,EAAA;;AALtB;EASQ,kBAAkB;EAClB,eAAe,EAAA;;AAVvB;EAiBM,eAAe,EAAA;;AAjBrB;EAuBM,mBtH0Ic,EAAA;;AsHjKpB;EA2BM,oCtHw5BqE;EsHv5BrE,2BtH45ByE;EsH35BzE,wCtH45B6E;EsH35B7E,sBtHykB8B,EAAA;;AsHvmBpC;EAkCM,iCAA8C,EAAA;EAlCpD;IAoCQ,gBAAgB;IAChB,oCtH84BmE;IsH74BnE,0CtH45BuF,EAAA;;AsHl8B/F;EA2CM,8BAA+B,EAAA;;AA3CrC;EA+CM,8BAA8B,EAAA;;AClEpC;EACE,gBAAgB,EAAA;EADlB;IAKM,eAAe,EAAA;;AAKrB;EACE,yCAA8D;EAC9D,oCAA2D,EAAA;;AAG7D;EACE,2BAA8C,EAAA;EADhD;IAGI,gBvH6GoB,EAAA;;AuHzGxB;EACE,aAAa,EAAA;;AAGf;EACE,oCAAqC,EAAA;;AlIywrDvC;;EmIjyrDI,wBAAwB;EACxB,YAAY,EAAA;;AAGhB;EACI,wCxHo8B+E;EwHn8B/E,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EvHId,sBD2mBgC;EwH7mBhC,8BxHy7BuE;EwHx7BvE,YAAY,EAAA;EAPhB;IAUQ,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,uBAAuB;IACvB,2BxHq7BuE;IwHp7BvE,sBxHmmB4B,EAAA;IwHnnBpC;MAmBY,UAAU,EAAA;EAnBtB;IAwBQ,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,2BAAyC;IACzC,2BAA8C;IAC9C,YAAY;IACZ,sBxHklB4B,EAAA;EwHnnBpC;IAqCQ,2BAAyC,EAAA;IArCjD;MAwCY,oCxHu5B+D,EAAA;EwH/7B3E;IA6CQ,2BAAyC,EAAA;IA7CjD;MAgDY,oCxH+4B+D,EAAA;EwH/7B3E;IAqDQ,aAAa;IACb,WAAW,EAAA;IAtDnB;MAyDY,cAAc,EAAA;IAzD1B;MA6DY,YAAY,EAAA;;AAOpB;EAGY,yBxHsGI;EwHrGJ,WxHuED,EAAA;;AwH3EX;EAGY,yBxH0GI;EwHzGJ,WxHuED,EAAA;;AwH3EX;EAGY,yBxH4GI;EwH3GJ,WxHuED,EAAA;;AwH3EX;EAGY,yBxH8GI;EwH7GJ,WxHuED,EAAA;;AwH3EX;EAGY,yBxH2GI;EwH1GJ,WxHuED,EAAA;;AwH3EX;EAGY,yBxHyGI;EwHxGJ,WxHuED,EAAA;;AwH3EX;EAGY,yBxHyEE;EwHxEF,WxHuED,EAAA;;AwH3EX;EAGY,yBxHiFE;EwHhFF,WxHuED,EAAA;;AyHtJf;EACI,iDAAyC,EAAA;EAD7C;IAIQ,sCAAyD,EAAA;EAJjE;IAOQ,sDAA+D,EAAA;EAPvE;IAWQ,gBAAgB,EAAA;EAXxB;IAeQ,mDAAgD,EAAA;IAfxD;MAkBY,0BAA0B,EAAA;IAlBtC;MAsBY,kCAAkC,EAAA;EAtB9C;IA2BQ,wBAAwB;IACxB,qDAA4E;IAC5E,+CAA4C;IAC5C,2BAA2B,EAAA;EA9BnC;IAkCQ,2CAA8D;IAC9D,6CzHkmBuD;IyHjmBvD,6BAA6B;IAC7B,uBAAuB;IACvB,yBAAyB;IACzB,qBzHqlB2B,EAAA;EyH5nBnC;IA2CQ,2CAA8D,EAAA;EA3CtE;IAkDgB,OAAO;IACP,sBAAsB,EAAA;EAnDtC;IA0DY,2BAA2B,EAAA;EA1DvC;IA+DQ,wDAA2C;IAC3C,gCAAiD;IACjD,mDAAmD,EAAA;;AAI3D;;;EAIQ,2BAA2B;EAC3B,4CAA0D,EAAA;;AALlE;;EAUY,sCAAoD,EAAA;;AAVhE;;EAeQ,sCAAoD,EAAA;;AAI5D;;EAEI,iCAAwC;EACxC,uCAAuC;EACvC,wCAAwC,EAAA;;AAG5C;;EAEI,iCAAwC;EACxC,oCAAoC;EACpC,qCAAqC,EAAA;;AAGzC;EACI,4BAA4B,EAAA;;AAGhC;EACI,2BAA2C,EAAA;;AAG/C;;;EAMgB,2BAA2B,EAAA;;AAM3C;EAGY,8BAA4B;EAC5B,yBAAwB,EAAA;;AAJpC;EASQ,yCAAgC;EAChC,mDAAgD,EAAA;EAVxD;IAYY,yDAAsD;IACtD,2BAA2B,EAAA;;AAbvC;EAkBQ,2BAAmC;EACnC,mDAAmD,EAAA;EAnB3D;IAuBgB,oCAA4C,EAAA;EAvB5D;IA2BgB,sDAAsD,EAAA;;AAQtE;EACI,2BAAmC,EAAA;;AAKvC;EAEM,aAAa;EACb,8BAA8B,EAAA;;AAHpC;EAQQ,mDAAgD;EAChD,2BAA2B,EAAA;;AATnC;;EAeM,iCAAwC;EACxC,uCAAuC;EACvC,wCAAwC,EAAA;;AAjB9C;;EAsBM,iCAAwC;EACxC,oCAAoC;EACpC,qCAAqC,EAAA;;ApIgzrD3C;EoI1yrDQ,2BAA2B,EAAA;;ACjMnC;EACI,gBAAgB,EAAA;EADpB;;IAKQ,mBAAmB;IACnB,gBAAgB,EAAA;EANxB;IAUQ,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB,EAAA;;AAIzB;EACI,sC1H6pB2E,EAAA;E0H9pB/E;IAIQ,oC1Hw7B2E;I0Hv7B3E,8BAA8B;IAC9B,+BAA+B,EAAA;;AAIvC;EACI,wC1Hi7B+E;E0Hh7B/E,sB1H8lBgC,EAAA;;A0H3lBpC;EACI,iDAAyC,EAAA;EAD7C;IAIQ,wBAAwB;IACxB,mCAA8D,EAAA;IALtE;MAQY,yBAA0B,EAAA;EARtC;IAaQ,2BAA2B;IAC3B,4BAA4B;IAC5B,oC1H85B2E,EAAA;I0H76BnF;MAmBgB,yBAAyB,EAAA;IAnBzC;MAwBY,6C1H8kBmD;M0H7kBnD,qB1HokBuB,EAAA;;A0H/jBnC;;;EAKQ,oCAA+D,EAAA;;AALvE;EASQ,kCAA6D,EAAA;;AATrE;EAcY,QAAQ;EACR,UAAU,EAAA;;AAftB;EAqBY,mCAA8D,EAAA;;AAK1E;EAEQ,sCAAyD;EACzD,+CAA+C,EAAA;;AC1FvD;EACI,2B3HqyBiE;E2HpyBjE,UAAU;EACV,cAAc,EAAA;;AAGlB;EACI,gBAAgB;EAChB,wC3H8mBqE;E2H7mBrE,kBAAkB,EAAA;EAHtB;IAMQ,wBAAwB,EAAA;EANhC;IAUQ,WAAW,EAAA;EAVnB;IAcQ,YAAY,EAAA;EAdpB;IAkBQ,iDAAiE;IACjE,mBAAmB;IACnB,0CAAiE,EAAA;EApBzE;IAwBQ,mBAAmB;IACnB,0CAAiE,EAAA;;AAIzE;EACI,uBAAuB;EACvB,iBAAiB,EAAA;;AAGrB;EACI,WAAW,EAAA;;AAGf;EACI,6B3H0vBqC,EAAA;;A2HvvBzC;;EAEI,wC3HokBqE;E2HnkBrE,uB3H6uB+B,EAAA;;A2H1uBnC;EAEQ,aAAa;EACb,2B3H6uB6D;E2H5uB7D,iDAAkE,EAAA;;AAJ1E;EAYY,iDAAkE,EAAA;;AAK9E;EACI,cAAc,EAAA;;AArClB;EAyCI,gBAAgB;EAChB,wC3HyiBqE;E2HxiBrE,aAAa;EACb,6B3HwtBqC,EAAA;;A2HrtBzC;EACI,c3HyEc;E2HxEd,0BAA0B,EAAA;;AAG9B;EAGQ,mBAAmB;EACnB,iCAAwC;EACxC,wC3H4tCuE;E2H3tCvE,0C3HutC2E;E2HttC3E,2B3HscyE,EAAA;E2H7cjF;IAUY,8C3HutCmE,EAAA;E2HjuC/E;IAgBY,c3HqDM;I2HpDN,0C3H4sCuE,EAAA;E2H7tCnF;IAqBY,yB3H4CM;I2H3CN,iC3H0biF,EAAA;E2Hhd7F;IA0BY,gBAAgB,EAAA;EA1B5B;IAgCgB,6BAA6B,EAAA;EAhC7C;IAqCY,yB3HwDQ;I2HvDR,W3HyBG;I2HxBH,qB3HsDQ;I2HrDR,gB3HAY,EAAA;;A2HKxB;EACI,kBAAkB;EAClB,WAAW,EAAA;EAFf;IAKQ,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,eAAe;IACf,c3HYU,EAAA;;A2HRlB;EACI,oC3HuzB+E;E2HtzB/E,oC3HgzBuE;E2H/yBvE,2B3HozB2E;E2HnzB3E,gB3HyiB6B;E2HxiB7B,sCAAiF;EACjF,sB3HgegC;EFzV9B,oBAvE+B,EAAA;E6HtErC;IAUQ,gBAAgB;IAChB,0C3HszBuF;I2HrzBvF,oC3HsyBmE,EAAA;E2HlzB3E;IAgBQ,c3HRU,EAAA;;A2HYlB;EAEQ,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,gB3H8gByB,EAAA;;A2H1gBjC;EACI,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,YAAY,EAAA;;AAGhB;EACI,wBAAwB,EAAA;;AAG5B;EAEQ,oBAAoB,EAAA;;AAO5B;EAGQ,sBAAsB,EAAA;;AAH9B;EAOQ,aAAa;EACb,gBAAgB;EAChB,mBAAmB,EAAA;;AAT3B;EAaQ,iBAAiB,EAAA;;AAKzB;EAEQ,8C3HwlB0F,EAAA;;A2H1lBlG;EAKQ,yB3HzCY;E2H0CZ,qB3H1CY;E2H8CR,0D7G/FsE,EAAA;;A6GmGlF;EAEQ,Y3HowBuC;E2HnwBvC,a3HmwBuC;E2HlwBvC,mBAAmB;EACnB,oC3H2tBmE;E2H1tBnE,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,8C3HwwBmG;E2HvwBnG,gBAAgB;EAChB,iCAAyB;UAAzB,yBAAyB,EAAA;EAXjC;I1HvNI,qBDy+B2C,EAAA;;A2H/vB/C;EAEQ,qBAAqB;EACrB,oBAAoB,EAAA;;AAI5B;EACI,0CAAiE,EAAA;;AtIi9rDrE;EsI38rDY,kD3H07C2D,EAAA;;A4HjsDvE;EACI,gBAAgB;EAChB,yBAAyB;EACzB,QAAQ,EAAA;EAHZ;IAMY,cAAc;IACd,yB5HqyC8B;I4HpyC9B,2B5H4hBqE;I4H3hBrE,0C5H2yCuE;I4H1yCvE,wC5H8yCmE;I4H7yCnE,sB5H+mBwB,EAAA;E4H1nBpC;IAgBgB,W5HsID;IkBtJb,yBlBoLkB;I4HlKJ,qB5HkKI,EAAA;;A4H5JpB;EACI,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB,EAAA;EAHvB;IAKQ,qBAAqB;IACrB,qBAAqB,EAAA;;AAI7B;;EAEI,c5HgJgB;E4H/IhB,gB5H0FoB;E4HzFpB,yB5HswCsC;E4HrwCtC,0C5H6wC+E;E4H5wC/E,wC5HgxC2E;E4H/wC3E,sB5HilBgC,EAAA;E4HxlBpC;;IASQ,cAA6B,EAAA;EATrC;;IAaQ,c5H6GU;I4H5GV,eAAe,EAAA;IAdvB;;MAiBY,c5HyGM,EAAA;;A6H5JlB;EACI,2BAA2B,EAAA;EAD/B;IAGQ,iDAAyC,EAAA;EAHjD;IAMQ,cAAc,EAAA;;AAItB;;EAEI,iDAAyC,EAAA;;AAG7C;EACI,mDAA0C;EAC1C,qDAA4E;EAC5E,uDAAkC,EAAA;EAHtC;IAKQ,iDAAyC;IACzC,yBAA2B,EAAA;EANnC;IAUQ,4DAA6E;IAC7E,0DAAiD,EAAA;;AAIzD;EAEQ,sBAAwB,EAAA;;AAIhC;EACI,gB7H0FoB,EAAA;;A6HvFxB;EACI,oBAAoB;EACpB,uCAAwD,EAAA;;AAG5D;EACI,yBAA2B;EAC3B,iDAAyC;EACzC,0BAA0B,EAAA;;AAG9B;EACI,qBAAuB,EAAA;;AAG3B;EACI,a7HmGc,EAAA;;A6HhGlB;;EAGQ,iDAAyC;EACzC,a7H4FU,EAAA;;A6HxFlB;EACI,gBAAgB,EAAA;;AAKpB;EACI,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB,EAAA;;AAGtB;EACI,eAAe,EAAA;;AAGnB;;EAEI,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,oCAA2D;EAC3D,wC7H2hBqE,EAAA;;A6HxhBzE;EACI,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,UAAU,EAAA;EAJd;IAMQ,wBAAwB;IACxB,6BAA6B,EAAA;;AAIrC;EACI,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,6BAA6B,EAAA;EAJjC;IAMQ,sCAAsC;IACtC,wBAAwB;IACxB,UAAU,EAAA;;AAIlB;EAvBA;IAyBQ,0BAA0B,EAAA;EAdlC;IAiBQ,2BAA2B,EAAA,EAC9B;;AAKL;EAEQ,8B7HofiE,EAAA;;A6HhfzE;EAEQ,8B7H8eiE,EAAA;;A6HhfzE;EAKQ,0BAA6C,EAAA;;AAIrD;;EAKY,8BAAmD,EAAA;;AAL/D;EAUQ,8BAAmD,EAAA;;AAV3D;;EAgBY,gCAAuD,EAAA;;AAhBnE;EAsBY,uBAAqC,EAAA;;AAtBjD;EA2BQ,gCAAuD,EAAA;;AA3B/D;EAgCY,8BAAmD,EAAA;;AAhC/D;;EAuCY,gCAAuD,EAAA;;ACrLnE;EACE,iBAAiB,EAAA;;ACFnB;EACI,aAAa,EAAA;;AAGjB;EACI,aAAa,EAAA;;ACJjB;EACE,aAAa;EACb,mBhIoJgB;EgInJhB,kBAAkB,EAAA;;AAGpB;EACE,cAAc;EACd,kBAAkB;EAClB,WhI4Ia;EgI3Ib,eAAe;EACf,iBAAiB;EACjB,mBhIuKkB;EgItKlB,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EACE,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB,EAAA;EALpB;IAOI,aAAa;IACb,mCAAmC;IACnC,oCAAoC;IACpC,8BhIwJgB,EAAA;EgIlKpB;IAaI,UAAU;IACV,mCAAmC;IACnC,oCAAoC;IACpC,iChIkJgB,EAAA;;AiIpLpB;EACI,cAAc,EAAA;EADlB;IAIQ,cAAc;IACd,WAAW;IACX,YAAY;IACZ,sBjIm1B2B;IiIj1B3B,oBjI2qB+B;IiI1qB/B,gBjIgrByB;IiI/qBzB,gBjIsrByB;IiIrrBzB,2BjI+7BuE;IiI97BvE,oCjIy7BmE;IiIx7BnE,4BAA4B;IAC5B,wCjI67B2E;IiI57B3E,sBjI0mB4B;IiIzmB5B,sBAAsB,EAAA;IAjB9B;MAoBY,qBAAqB;MACrB,yBAA0C;MAC1C,+BAAsC,EAAA;IAtBlD;MA0BY,8CjI27BmF;MiI17BnF,2BjIg7BmE,EAAA;IiI38B/E;MA+BY,2BjI46BmE,EAAA;EiI38B/E;IAoCQ,sBjIslB4B;IiIrlB5B,oCjIwtCuE;IiIvtCvE,sBjIgHO;IiI/GP,6CjI8lBuD;IiI7lBvD,UAAU;IACV,cAAc;IACd,iBAAiB;IACjB,SAAS;IACT,6BAA6B;IAC7B,uBAAuB;IACvB,yBAAyB,EAAA;IA9CjC;MAiDY,oBjImoB2B;MiIloB3B,SAAS;MACT,uBjI4tC8B;MiI3tC9B,gBAAgB;MAChB,sBjIiGG;MiIhGH,2BjIqsC+D,EAAA;MiI3vC3E;QAyDgB,cjI8HI;QiI7HJ,gBjIioBiB;QiIhoBjB,YAAY,EAAA;MA3D5B;QAgEgB,cjIssCW;QkBtwCzB,yBlBuJgB,EAAA;IiIvJlB;MAsEY,sBjIysC8B;MiIxsC9B,kBAAkB;MAClB,gBjIuDY,EAAA;;AkI/HxB;EACI,kBAAkB;EAClB,yBlIkLgB;EkIjLhB,sClI2qB2E;EkI1qB3E,6ClIioB2D;EkIhoB3D,gBAAgB,EAAA;;AAGpB;EAEQ,sClIoqBuE;EkInqBvE,oBlIyqB+B;EkIxqB/B,wBAAyC,EAAA;;AAIjD;EACI,yBlImKgB,EAAA;;AmIpLpB;EACI,aAAa,EAAA;EADjB;IAGQ,UAAU;IACV,kCnII+D,EAAA;;AoIPvE;;EAEI,wCpImnBqE,EAAA;;AoIhnBzE;EAGY,eAAe;EACf,iBAAiB;EACjB,yBAAyB,EAAA;;AAG7B;EARR;;;IAagB,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,cAAc,EAAA;EAjB9B;IAqBgB,WAAW,EAAA;EArB3B;IAyBgB,aAAa,EAAA,EAChB;;AA1Bb;EA8BY,0BAA0B,EAAA;;AA9BtC;EAmCQ,iCAA+C,EAAA;;AAnCvD;EAuCQ,cAAc;EACd,gBAAgB,EAAA;;AAxCxB;EA4CQ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBpIqEgB;EoIpEhB,WAAW,EAAA;;AArDnB;EA0DY,yCpIoHQ,EAAA;EoI9KpB;IA6DgB,yBpIiHI;IoIhHJ,WpIkFD,EAAA;;AoIhJf;EAqEY,yCpIyGQ,EAAA;;AoI9KpB;EA2EY,yCpImGQ,EAAA;;AoI9KpB;EAgFQ,uBAAuB,EAAA;;AAhF/B;EAqFY,sBAAwB,EAAA;;AArFpC;;;EA4FQ,sBAAsB,EAAA;;AA5F9B;EAgGQ,6CpIghBiE;EoI/gBjE,4CpI+gBiE,EAAA;;AoIhnBzE;EAqGQ,aAAa,EAAA;;AAIrB;EACI,2BAA8C,EAAA;;AAGlD;EACI,WpIkCW,EAAA;;AoI/Bf;EAEQ,mBpIgCU;EoI/BV,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,gBpI+jByB,EAAA;;AoI3jBjC;;;;;;;;;;EAYQ,qBpIYU,EAAA;;AoIxBlB;EAgBQ,mBAAkC,EAAA;;AAI1C;EACI,oCAA2D;EAC3D,oCpI+dqE;EoI9drE,cpIKc;EoIJd,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB,EAAA;;AAG3B;;;EAGI,yBpIkBgB;EoIjBhB,WpIbW;EoIcX,iBAAiB,EAAA;;AAjDrB;EAqDI,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAA;;AAGtB;;EAEI,yBpICgB,EAAA;;AoIEpB;;EAEI,yBpIJgB,EAAA;;AoIWpB;;EAEI,2BAA6C;EAC7C,uBAAuB;EACvB,mBAAmB,EAAA;;AAGvB;EACI,6BAA+B;EAC/B,aAAa,EAAA;;AAGjB;EACI,aAAa,EAAA;;AAGjB;EACI,WpI1DW,EAAA;;AoI6Df;EAEQ,gBAAgB;EAChB,iBAAiB;EACjB,aAAa,EAAA;;AAKrB;EAEQ,cpIvEU,EAAA;;AoI2ElB;;EAEI,kBAAkB;EAClB,cAAc;EACd,aAAa,EAAA;EAJjB;;IAOQ,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,MAAM;IACN,WAAW;IACX,OAAO;IACP,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,uBAAuB,EAAA;;AAI/B;EAEQ,gBAAgB,EAAA;;AAIxB;EAEQ,gBAAgB,EAAA;;AAIxB;EAEQ,gBpImY0B,EAAA;EoIrYlC;IAIY,cpI9EQ;IoI+ER,yCpI/EQ;IoIgFR,YAAY;IACZ,gBAAgB,EAAA;IAP5B;MAWgB,WpIvHD;MoIwHC,yBpItFI,EAAA;;AoI0EpB;EAkBQ,oCAAuC;EACvC,epI7FY,EAAA;;AoIkGhB;EADJ;IAEQ,sBAAsB;IACtB,SAAS,EAAA,EAEhB;;AAED;EAGY,6BAA6B,EAAA;;AAKzC;EAEQ,aAAa,EAAA;;AAFrB;EAOY,aAAa,EAAA;;AAPzB;EAWY,aAAa,EAAA;;AAXzB;EAeY,cAAc,EAAA;;AAK1B;EAEQ,kCAA0B;UAA1B,0BAA0B,EAAA;;AAIlC;EAEQ,kCAA0B;UAA1B,0BAA0B,EAAA;;AAKlC;EAGY,+CAAsC,EAAA;;AAKlD;EACI,oCpIoSqE,EAAA;;AoI/RrE;;EAMgB,yBAAwB,EAAA;;AAMxC;EAIgB,yBAAwB,EAAA;;AAMxC;EAGY,yBAAwB,EAAA;EAHpC;IAOoB,yBAAwB,EAAA;EAP5C;IAYgB,qBpIrMA,EAAA;;AoImKhB;;EAMgB,yBAAwB,EAAA;;AAMxC;EAIgB,yBAAwB,EAAA;;AAMxC;EAGY,yBAAwB,EAAA;EAHpC;IAOoB,yBAAwB,EAAA;EAP5C;IAYgB,qBpIjMA,EAAA;;AoI+JhB;;EAMgB,yBAAwB,EAAA;;AAMxC;EAIgB,yBAAwB,EAAA;;AAMxC;EAGY,yBAAwB,EAAA;EAHpC;IAOoB,yBAAwB,EAAA;EAP5C;IAYgB,qBpI/LA,EAAA;;AoI6JhB;;EAMgB,yBAAwB,EAAA;;AAMxC;EAIgB,yBAAwB,EAAA;;AAMxC;EAGY,yBAAwB,EAAA;EAHpC;IAOoB,yBAAwB,EAAA;EAP5C;IAYgB,qBpI7LA,EAAA;;AoI2JhB;;EAMgB,yBAAwB,EAAA;;AAMxC;EAIgB,yBAAwB,EAAA;;AAMxC;EAGY,yBAAwB,EAAA;EAHpC;IAOoB,yBAAwB,EAAA;EAP5C;IAYgB,qBpIhMA,EAAA;;AoI8JhB;;EAMgB,yBAAwB,EAAA;;AAMxC;EAIgB,yBAAwB,EAAA;;AAMxC;EAGY,yBAAwB,EAAA;EAHpC;IAOoB,yBAAwB,EAAA;EAP5C;IAYgB,qBpIlMA,EAAA;;AoIgKhB;;EAMgB,yBAAwB,EAAA;;AAMxC;EAIgB,yBAAwB,EAAA;;AAMxC;EAGY,yBAAwB,EAAA;EAHpC;IAOoB,yBAAwB,EAAA;EAP5C;IAYgB,qBpIlOF,EAAA;;AoIgMd;;EAMgB,yBAAwB,EAAA;;AAMxC;EAIgB,yBAAwB,EAAA;;AAMxC;EAGY,yBAAwB,EAAA;EAHpC;IAOoB,yBAAwB,EAAA;EAP5C;IAYgB,qBpI1NF,EAAA;;AoIiOlB;EAEQ,gCAA8C,EAAA;;AAItD;EACI,cAAc,EAAA;EADlB;IAGQ,mBAAmB,EAAA;;ACzY3B;EACI,uBAAuB;EACvB,uDAAkC;EAClC,oBAAoB;EACpB,aAAa,EAAA;EAJjB;IAOQ,iDAAyC;IACzC,sCAAyD,EAAA;EAE7D;IAVJ;MAWQ,qBAAqB;MACrB,oBAAoB;MACpB,aAAa,EAAA,EAsCpB;EAnDD;IAiBQ,yBAAuB,EAAA;EAjB/B;IAqBQ,uBAAuB,EAAA;IArB/B;MAuBY,+CAAsC;MACtC,sCAA8B;MAC9B,iCAA6D;MAC7D,+BAAqC,EAAA;MA1BjD;QA4BgB,yBAA0C,EAAA;IA5B1D;MAiCY,qCAAwD;MACxD,WAAW;MACX,SAAS,EAAA;EAnCrB;IAwCQ,oCAAmC,EAAA;IAxC3C;MA0CY,kDAAkD,EAAA;IA1C9D;MA8CgB,kDAAkD,EAAA;;AAOlE;EACI,6DAA6D,EAAA;;AAGjE;EACI,oCAA+C,EAAA;;AC1DnD;;EAEI,kBAAkB;EAClB,aAAa;EACb,gBtIurB6B;EsItrB7B,8CAAqB,EAAA;;AAGzB;;;;;EAKI,iBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,oCAAoC,EAAA;;AAGxC;;;;;EAKI,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,oCAAoC,EAAA;;AAGxC;EACI,gBtIwpB6B;EsIvpB7B,gBAAgB,EAAA;;AAKpB;;EAWoC,yBtIgIhB;EsI/HgB,sCAA6D,EAAA;;AAZjG;EAsB4C,yBtIwHxB,EAAA;;AsI9IpB;EA+BwC,yBtI+GpB,EAAA;;AsIrJpB;EAqD4B,gBAAgB,EAAA;;AAU5C;;EAIQ,kBtI0ZK;EsIzZL,mBAAmB,EAAA;;AAL3B;;EAUQ,kBtIoZK,EAAA;;AsI9Zb;EAeY,WAAW,EAAA;;AAfvB;EAqBoB,wBAAwB,EAAA;;AArB5C;EAyBoB,cAAc,EAAA;;AAQlC;EAIgB,sBtIgBD;EsIfC,oCtI+eyD;EsI9ezD,gBAAgB;EAChB,WAAW,EAAA;;AAP3B;EAUgB,gBtIs2CkC,EAAA;EsIh3ClD;IAYoB,qBtIwiBgC;IsIviBhC,gBtI4iBa;IsI3iBb,mBAAmB,EAAA;EAdvC;IAmB4B,uBtI2oBO,EAAA;;AsI9pBnC;EAyBgB,eAAe;EACf,QAAQ;EACR,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,0CAAiE;EACjE,oCtIodyD,EAAA;EsIpfzE;IAkCoB,iCAA+C,EAAA;;AAOnE;;;;EAKQ,oCtIsciE;EsIrcjE,2BAAyC;EACzC,yBAA0C,EAAA;;AAIlD;EAGQ,6BtI8mBiC;EsI7mBjC,2BtI4mB6D;EsI3mB7D,2CtI2biE;EsI1bjE,qCtI0biE,EAAA;;AuItnBzE;EACI,sBAAsB,EAAA;;AAE1B;EAEQ,wCvIu8B2E;EuIt8B3E,gCzHgOwD;EyH/NxD,oCvI+7BmE;EuI97BnE,aAAa,EAAA;EALrB;IAOY,iBAAiB;IACjB,kBAAkB;IAClB,2BvI+7BmE,EAAA;EuIx8B/E;IAYY,YAAY;IACZ,WAAW;IACX,aAAA;IACA,UAAU,EAAA;IAftB;MAiBgB,wEAAqE;MACrE,2BAA2B,EAAA;;AAM3C;EAIgB,mFAAgF;EAChF,sCAAsC,EAAA;;AAMtD;EACI,iBAAiB,EAAA;;AAGrB;EACI,sCvIktC2E;EuIjtC3E,4CvIulBuD;EuItlBvD,sCAAyD;EACzD,avIqnCoC,EAAA;;AuIlnCxC;EAEQ,6CvIq5BqF,EAAA;;AuIv5B7F;EAKQ,aAAa;EACb,sCAAyD,EAAA;EANjE;IAQY,aAAa;IACb,wCvIk5BuE;IuIj5BvE,oCvI24B+D;IuI14B/D,2BvI+4BmE;IuI94BnE,sBvI6jBwB,EAAA;;AuIzkBpC;EAgBQ,yBvImHY,EAAA;;AuInIpB;EAmBQ,sCAAyD;EACzD,0CAA4E,EAAA;EApBpF;IAsBY,yBvI6GQ;IuI5GR,WvI8EG,EAAA;;AuIrGf;EA4BY,kBAAkB;EAClB,kBAAkB,EAAA;;AA7B9B;EAkCY,aAAA;EACA,UAAU;EACV,aAAA;EACA,UAAU,EAAA;;AAMtB;EAEQ,oCzHwIwD;EyHvIxD,mDAAgE;EAChE,oCvIs2BmE,EAAA;EuI12B3E;IAOY,gBAAgB,EAAA;EAP5B;IAUY,SAAS;IACT,2BvIo2BmE,EAAA;EuI/2B/E;IAcY,yBvI0EQ;IuIzER,YAAY;IACZ,WvI0CG;IuIzCH,kBAAkB;IAClB,YAAY;IACZ,eAAe,EAAA;EAnB3B;IAsBY,WvIoCG;IuInCH,iBAAiB;IACjB,qBzHsFyB;IyHrFzB,cAAc;IACd,QAAQ,EAAA;IA1BpB;MA4BgB,WvI8BD;MuI7BC,yBvI2DI,EAAA;;AuIxFpB;EAmCY,eAAe;EACf,sCvI8iBmE,EAAA;;AuIllB/E;EA0CgB,cvIsBE,EAAA;;AuIhBlB;EAGY,6CvIyzBiF;EuIxzBjF,eAAe,EAAA;;AC/I3B;EACI,kBAAkB;EAClB,WxImJW;EwIlJX,qBAAqB;EACrB,uFAAuF;EACvF,mBxIoLgB;EwInLhB,eAAe;EACf,UAAU;EACV,wDAAwD;EACxD,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB,EAAA;EAbvB;IAeQ,UAAU,EAAA;;AAKlB;EACI,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,gBAAgB,EAAA;;AAGpB;EACI,WAAW,EAAA;;AAGf;EACI,UAAU,EAAA;EADd;IAGQ,UAAU;IACV,cAAc;IACd,iBAAiB,EAAA;;AAIzB;EACI,WAAW,EAAA;;AAGf;EACI,cAAc,EAAA;;AAGlB;EACI,mBAAmB,EAAA;;AAGvB;EACI,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB,EAAA;;AAGtB;EACI,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,sBAAsB;EACtB,2BAA2B,EAAA;;AAG/B;EACI;IACI,iBAAiB;IACjB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,2BAAsB;IAAtB,sBAAsB,EAAA,EACzB;;AC/EL;EACI,kBAAkB;EAClB,mBAAmB;EACnB,eAAe,EAAA;EAHnB;IAMQ,aAAa,EAAA;EANrB;IAUQ,gBAAgB,EAAA;EAVxB;;IAgBY,iDAAmE;IACnE,mBAAmB;IACnB,yBAAiB;YAAjB,iBAAiB,EAAA;EAlB7B;IAsBY,mBAAmB,EAAA;EAtB/B;IA2BQ,wBAAwB,EAAA;EA3BhC;IAgCQ,eAAe,EAAA;IAhCvB;MAkCY,uBAAuB,EAAA;IAlCnC;MAsCY,cAAc;MACd,WAAW;MACX,sBzIkzBuB;MyIjzBvB,oCzI65B+D;MyI55B/D,wCzIk6BuE;MyIj6BvE,oBzIyoB2B;MyIxoB3B,sBzI8kBwB;MyI7kBxB,2BzI85BmE;MyI75BnE,mBAAmB,EAAA;IA9C/B;MAkDY,0DAAyX;MACzX,UAAU;MACV,oBAAoB;MACpB,kBAAkB;MAClB,QAAQ;MACR,QAAQ;MACR,UAAU;MACV,iBAAiB;MACjB,kBAAkB;MAClB,cAAc;MACd,YAAY;MACZ,WAAW;MACX,mBAAmB;MACnB,YAAY,EAAA;MA/DxB;QAkEgB,UAAU,EAAA;MAlE1B;QAsEgB,mCAAmC,EAAA;IAtEnD;MA2EY,aAAa,EAAA;IA3EzB;MA+EY,iBAAiB;MACjB,kBAAkB;MAClB,SAAS;MACT,6CAA2C;MAC3C,aAAa;MACb,UAAU;MACV,oCAAoC;MACpC,WAAW;MACX,YAAY;MACZ,aAAa;MACb,QAAQ;MACR,2BAA2B;MAC3B,oBAAoB,EAAA;IA3FhC;MA+FY,aAAa;MACb,2CAA2C,EAAA;EAhGvD;IA2GY,YAAY;IACZ,qBzI8uBuB,EAAA;EyI11BnC;IAgHY,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,+CzI+BG;IyI9BH,eAAe;IACf,0DAAyX;IACzX,oBAAoB;IACpB,UAAU;IACV,cAAc;IACd,aAAa;IACb,gBAAgB,EAAA;IA9H5B;MAgIgB,UAAU,EAAA;EAhI1B;IAoIY,oBAAoB,EAAA;IApIhC;MAsIgB,gBAAgB,EAAA;EAtIhC;IA6IY,gBAAgB,EAAA;;AAM5B;EAEQ,iCAA+C;EAC/C,YAAY,EAAA;;AAIpB;EACI,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,oCzIwyBuE;EyIvyBvE,qCAAwF;EACxF,wCzI4yB+E;EyI3yB/E,iCAAoD;EACpD,oBzIkhBmC;EyIjhBnC,kBAAkB;EAClB,gBAAgB,EAAA;;AAIpB;;EAGQ,0CzI0yBuF,EAAA;;AyItyB/F;EACI,SAAS;EACT,eAAe;EACf,gBAAgB,EAAA;;AAGpB;EACI,qBAAqB;EACrB,yBAAyB;EACzB,WAAW,EAAA;EAHf;IAMQ,WAAW,EAAA;;AAInB;EACI,eAAe,EAAA;EADnB;IAGQ,qBAAqB;IACrB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBzImfyB;IyIlfzB,oBAAoB;IACpB,qBAAqB;IACrB,eAAe;IACf,yBzIvBY;IyIwBZ,yBzIxBY;IyIyBZ,qBAAqB;IACrB,sBAAsB;IACtB,WzIzDO;IyI0DP,gBzIub0B,EAAA;IyIxclC;MAmBY,kBAAkB,EAAA;IAnB9B;MAuBY,yBzIlCQ;MyImCR,yBzInCQ,EAAA;;AyIyCpB;EAGY,yBzIxCQ;EyIyCR,yBzIzCQ,EAAA;;AyI8CpB;EACI,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,sCAAyD;EACzD,wCAA6D;EAC7D,6CzIwZ2D;EyIvZ3D,SAAS;EACT,aAAa;EACb,4BAA4B;EAC5B,gCAAgC;EAChC,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B,EAAA;EAlB9B;IAoBQ,mBAAmB;IACnB,6BAA6B,EAAA;EArBrC;IAyBQ,iDAA+E,EAAA;EAzBvF;IA6BQ,qBAAqB,EAAA;EA7B7B;IAiCQ,kBAAkB;IAClB,gBzIzIgB,EAAA;EyIuGxB;IAsCQ,aAAa,EAAA;;AAIrB;EAEQ,oCzI2+BuE,EAAA;;AyIv+B/E;EAEQ,SAAS;EACT,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kCAAkC,EAAA;EAN1C;IAQY,iCAAiC;IACjC,2BAA2B,EAAA;;AAzDvC;EAgEQ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iCAAiC;EACjC,4BAA4B,EAAA;;AANpC;EAUQ,kBAAkB;EAClB,oBzIqY+B;EyIpY/B,oCAAwF,EAAA;;AAMhG;EAhFA;IAqFgB,+BAA+B;IAC/B,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B,EAAA;EAVvC;IAegB,YAAY,EAAA,EACf;;AAQjB;EACI,eAAe,EAAA;;AAGnB;EACI,eAAe,EAAA;;AAGnB;EACI,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,YAAY,EAAA;;AAGhB;EACI,gBzI6V6B;EyI5V7B,eAAe;EACf,kBAAkB;EAClB,+CzIqRqE;EyIpRrE,czItMc,EAAA;;AyIyMlB;EACI,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,eAAe,EAAA;EAPnB;IASQ,aAAa,EAAA;;AAIrB;EACI,qBAAqB;EACrB,wBAAwB;EACxB,oCzIilBuE;EyIhlBvE,2BzIqlB2E;EyIplB3E,oBzI6TmC;EyI5TnC,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,sBAAsB,EAAA;EAV1B;IAYQ,UAAU,EAAA;EAZlB;IAeQ,czIrOU,EAAA;;AyIyOlB;EACI,czI1Oc;EyI2Od,UAAU,EAAA;;ApJgiuDd;EoJzhuDY,kDzImzC2D,EAAA;;A0IjsDvE;EACI,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,cAAc;EACd,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,gCAAmD;EACnD,4KAAwI,EAAA;EAlB5I;IAsBQ,UAAU;IACV,iBAAiB;IACjB,mBAAmB,EAAA;EAxB3B;IA4BQ,qBAAqB;IACrB,aAAa,EAAA;EA7BrB;IAiCY,4DAA4D,EAAA;EAjCxE;IAqCQ,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,gBAAgB,EAAA;IAzCxB;MA4CY,cAAc;MACd,WAAW,EAAA;MA7CvB;QAgDgB,WAAW;QACX,wC1I25BmE;Q0I15BnE,gBAAgB;QAChB,0BAA0B,EAAA;QAnD1C;UAuDoB,WAAW;UACX,eAAe;UACf,eAAe,EAAA;UAzDnC;YA4DwB,eAAe;YACf,kBAAkB,EAAA;IA7D1C;MAoEY,mDAAgE;MAChE,sB1IqjBwB,EAAA;E0I1nBpC;IA0EQ,kBAAkB;IAClB,qBAAqB,EAAA;IA3E7B;MA6EY,YAAY;MACZ,cAAc,EAAA;EA9E1B;IAmFQ,2BAA2B,EAAA;EAnFnC;IAuFQ,6CAA6C,EAAA;EAvFrD;;IA4FQ,gBAAgB;IAChB,6BAA6B;IAC7B,4BAA4B,EAAA;EA9FpC;IAkGQ,cAAc,EAAA;EAlGtB;IAsGQ,YAAY;IACZ,4C1I+gBiE,EAAA;E0ItnBzE;IA2GQ,YAAY,EAAA;EA3GpB;IAgHQ,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,yBAAyB;IACzB,WAAW;IACX,SAAS;IACT,QAAQ;IACR,UAAU,EAAA;EAvHlB;IA8HM,UAAU;IACV,WAAW,EAAA;EA/HjB;IAoIM,SAAS;IACT,UAAU,EAAA;EArIhB;IAyIQ,iBAAiB;IACjB,cAAc,EAAA;EA1ItB;IA6IQ,iBAAiB;IACjB,cAAc,EAAA;EA9ItB;IAmJQ,YAAY,EAAA;EAnJpB;IAsJQ,4B1I8BY,EAAA;E0IpLpB;IAyJQ,4B1I2BY,EAAA;E0IpLpB;IA8JQ,SAAS,EAAA;EA9JjB;IAiKQ,yB1ImBY,EAAA;E0IpLpB;IAoKQ,yB1IgBY,EAAA;E0IpLpB;IAuKQ,UAAU,EAAA;;AAIlB;EACI,kBAAkB;EAClB,qBAAqB,EAAA;;AAGzB;EACI,aAAa;EACb,yB1IEgB;E0IDhB,8BAA8B,EAAA;EAHlC;IAMQ,uBAAuB;IACvB,+B1IjCO;I0IkCP,8B1IlCO;I0ImCP,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;IACjB,gBAAgB;IAChB,SAAO,EAAA;EAff;;IAoBQ,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,aAAa;IACb,UAAU;IACV,+B1IrDO;I0IsDP,8B1ItDO;I0I2EL;2BrJs1uDiB;IqJp1uDnB;yBrJs1uDiB;IqJx0uDf;2BrJ00uDiB;IqJx0uDnB;yBrJ00uDiB,EqJz0uDC;IApE1B;;MA+BU,aAAa,EAAA;IA/BvB;;MAmCY,kBAAkB,EAAA;IAnC9B;;MAuCY;qCrJg3uDyB;MqJ92uDzB;mBrJg3uDO;MqJ92uDL,OAAO;MACT;mCrJg3uDuB;MqJ92uDvB;mBrJg3uDO,EqJ/2uDC;IA/CpB;;MAuDY;qCrJ22uDyB;MqJz2uDzB;mBrJ22uDO;MqJz2uDL,QAAQ;MACV;mCrJ22uDuB;MqJz2uDvB;mBrJ22uDO,EqJ12uDC;IA/DpB;;MAuEY,cAAc,EAAA;MAvE1B;;QA0EgB,8B1IpGD,EAAA;I0I0Bf;;MA+EY,WAAW;MACX,YAAY,EAAA;MAhFxB;;QAmFgB,qBAAqB;QACrB,aAAa,EAAA;;AAM7B;EACI,kBAAkB;EAClB,YAAY,EAAA;EAFhB;;IAMQ,qBAAqB,EAAA;EAN7B;IAUQ,WAAW,EAAA;IAVnB;MAaY,aAAa,EAAA;IAbzB;MAkBY,SAAS;MACT,wBAAwB,EAAA;EAnBpC;IAwBQ,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,oBAAoB;IACpB,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,gDAAgE;IAChE,sBAAsB,EAAA;IAjC9B;MAoCY,8BAA2B,EAAA;IApCvC;MAwCY,8BAA2B,EAAA;IAxCvC;MA4CY,cAAc;MACd,WAAW;MACX,kBAAkB,EAAA;IA9C9B;MAkDY,MAAM;MACN,gBAAgB,EAAA;MAnD5B;QAsDgB,kCAAkC;QAClC,mCAAmC;QACnC,8CAA2C;QAC3C,QAAQ,EAAA;IAzDxB;MA8DY,QAAQ,EAAA;MA9DpB;QAiEgB,kCAAkC;QAClC,mCAAmC;QACnC,2CAAwC;QACxC,QAAQ,EAAA;IApExB;MAyEY,cAAc;MACd,YAAY,EAAA;MA1ExB;QA6EgB,wBAAqB,EAAA;EA7ErC;IAoFQ,+BAA4B,EAAA;IApFpC;MAsFY,UAAU,EAAA;;AAKtB;EACI,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,qCAAqC,EAAA;EAbzC;IAgBQ,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,UAAU,EAAA;IArBlB;MAwBY,+BAA4B,EAAA;EAxBxC;IA6BQ,UAAU;IACV,YAAY;IACZ,qBAAqB,EAAA;EA/B7B;IAoCY,uCAAoC,EAAA;EApChD;IAuCY,oCAAiC,EAAA;EAvC7C;IA4CQ,uBAAuB;IACvB,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,oBAAoB;IACpB,SAAS;IACT,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,gB1IiSyB;I0IhSzB,oBAAoB;IACpB,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB,EAAA;IA3D7B;MA8DY,UAAU,EAAA;IA9DtB;MAmEY,eAAe;MACf,+B1InRG;M0IoRH,uBAAuB;MACvB,oBAAoB,EAAA;EAtEhC;IA2EQ,oBAAoB;IACpB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,gB1IkQyB;I0IjQzB,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;IACvB,WAAW,EAAA;IA5FnB;MAgGY,aAAa,EAAA;IAhGzB;MAoGY,6BAA6B,EAAA;IApGzC;MAwGY,6BAA6B;MAC7B,aAAa;MACb,UAAU;MACV,yB1IhTG,EAAA;;A0IsTf;EACI,yB1InSgB;E0IoShB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,+C1IwJqE,EAAA;E0IhKzE;IAUQ,aAAa;IACb,SAAO,EAAA;;AAIf;EACI,eAAe;EACf,cAAc;EACd,mB1IpTgB;E0IqThB,W1InVW;E0IoVX,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,SAAO;EACP,gB1IhXoB,EAAA;;A0ImXxB;;EAEI,kBAAkB,EAAA;;AAEtB;EACI,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,gBAAgB,EAAA;EALpB;IAOQ,UAAU,EAAA;;AAIlB;EACI,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,qCAAqC;EACrC,UAAU,EAAA;EAbd;IAeQ,4BAA4B,EAAA;;AAIpC;EACI,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,2BAA8C;EAC9C,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB,EAAA;EAjBtB;IAqBQ,gDAAkE,EAAA;EArB1E;IAoCQ,eAAe;IACf,UAAU;IACV,iCAA+C;IAC/C,6BAA2C,EAAA;EAvCnD;IA2CQ,qB1I3YY;I0I4YZ,yC1I5YY;I0I6YZ,gB1IsE0B,EAAA;I0InHlC;MAiDY,qB1IjZQ;M0IkZR,0C1IlZQ;M0ImZR,qBAAkC,EAAA;EAnD9C;IAyEQ,mB1IzaY;I0I0aZ,gB1IyC0B;I0IxC1B,W1IzcO;I0I0cP,qB1I5aY,EAAA;E0IgWpB;IAmFY,4BAA4B,EAAA;IAnFxC;MAqFgB,6B1IrbI,EAAA;I0IgWpB;MAyFgB,mBAAmB,EAAA;EAzFnC;IAkGY,4BAA4B,EAAA;EAlGxC;IAuGQ,gBAAgB;IAChB,6DAAyF,EAAA;EAxGjG;IAkHQ,0CAAgE;IAChE,uBAAuB;IACvB,yBAAyB;IACzB,eAAe,EAAA;EArHvB;IA0HQ,mBAAmB;IACnB,0CAAgE,EAAA;EA3HxE;IA+HQ,gBAAgB;IAChB,6C1IheY,EAAA;E0IgWpB;IAoIQ,kBAAkB,EAAA;;AAI1B;EACI,eAAe,EAAA;;AAGnB;EACI,WAAW,EAAA;EADf;IAGQ,eAAe;IACf,2BAA2B,EAAA;EAJnC;IAQQ,WAAW;IACX,WAAW;IACX,iBAAiB,EAAA;EAVzB;IAgBY,cAAc;IACd,WAAW;IACX,eAAe;IACf,oCAAoD;IACpD,uBAAuB;IACvB,eAAe;IACf,YAAY,EAAA;;AAMxB;EACI,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB,EAAA;;AAGpB;EACI,qBAAqB;EACrB,UAAU;EACV,sBAAsB,EAAA;;AAG1B;EACI,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa,EAAA;EATjB;IAYQ,WAAW;IACX,cAAc;IACd,WAAW,EAAA;EAdnB;IAiBQ,SAAO;IACP,UAAU;IACV,YAAY;IACZ,WAAW,EAAA;IApBnB;MAwBoB,2C1I3GqD,EAAA;E0ImFzE;IA+BQ,UAAU,EAAA;EA/BlB;IAmCQ,UAAU,EAAA;EAnClB;IAwCQ,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,oBAAoB;IACpB,2BAA8C;IAC9C,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,qBAAqB,EAAA;IArD7B;MAwDY,iBAAiB,EAAA;IAxD7B;MA6DU,gBAAgB,EAAA;IA7D1B;MAiEY,UAAU;MACV,SAAS,EAAA;EAlErB;;IAyEQ,eAAe;IACf,WAAW;IACX,oBAAoB;IACpB,2BAA8C;IAC9C,iBAAiB;IACjB,SAAS;IACT,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB,EAAA;EAhF1B;IAoFQ,UAAU;IACV,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,gBAAgB,EAAA;EAxFxB;IA6FY,oC1IlnBQ,EAAA;;A0IunBpB;;;;;EAKQ,6BAA6B,EAAA;;AAIrC;EACI,eAAe;EACf,oC1IgJuE,EAAA;;AXmhuD3E;EqJ/puDI,aAAa,EAAA;;AAGjB;EACI;IACI,UAAU;IACV,mCAAmC,EAAA;EAEvC;IACI,UAAU;IACV,+BAA+B,EAAA,EAAA;;ArJgquDvC;;EqJ1puDI,aAAa,EAAA;;ArJ8puDjB;EsJz+vDI,kBAAkB,EAAA;EtJ2+vDpB;IsJv+vDU,iBAAiB;IACjB,gBAAgB,EAAA;ItJy+vDxB;MsJt+vDY,wBAAwB,EAAA;ItJw+vDpC;MsJp+vDY,UAAU,EAAA;ItJs+vDtB;MsJl+vDY,YAAY,EAAA;ItJo+vDxB;MsJh+vDY,iDAAiE;MACjE,kBAAkB,EAAA;ItJk+vD9B;MsJ99vDY,kBAAkB,EAAA;;AtJi+vDlC;EsJz9vDQ,kBAAkB;EAClB,0DAAkD;EAClD,4BAA4B;EAC5B,6BAA6B;EAC7B,qBAAqB,EAAA;;AtJ49vD7B;;EsJr9vDQ,iBAAiB;EACjB,oCAAoC;EACpC,kBAAkB;EAClB,a3I4yB2B;E2I3yB3B,W3I0yB2B;E2IzyB3B,eAAe,EAAA;;AtJy9vDvB;EsJn9vDQ,aAAa,EAAA;;AtJs9vDrB;EsJh9vDQ,aAAa,EAAA;;AC3DrB;EAEQ,oB5I2GY;E4I1GZ,kBAAkB;EAClB,UAAU;EACV,WAAW,EAAA;;AALnB;EAQQ,OAAO;EACP,6BAA6B;EAC7B,2BAA8C,EAAA;;AAItD;EACI,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa,EAAA;EAEb;IARJ;MASQ,aAAa,EAAA,EAEpB;;AAED;EACI,0DAAmD;EACnD,sBAAsB,EAAA;EAF1B;IAKQ,uDAAqE;IACrE,YAAY,EAAA;;AAIpB;EACI,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,OAAO;EACP,UAAU;EACV,oBAAoB,EAAA;EANxB;IAQQ,WAAW;IACX,YAAY;IACZ,uBAAuC,EAAA;;AAM/C;EAGY,gBAAgB,EAAA;;AAK5B;EACI,kBAAkB,EAAA;;AAKtB;EACI,kBAAkB,EAAA;EADtB;IAGQ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,OAAO;IACP,QAAQ;IACR,6CAAkE;IAClE,SAAS,EAAA;EAVjB;IAcQ,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,0CAAiE;IACjE,iBAAiB,EAAA;;AAMzB;EACI,6D5IiDqF,EAAA;E4IlDzF;IAIQ,0DAAuD;IACvD,2BAA2B;IAC3B,sBAAsB;IACtB,UAAU;IACV,6BAA6B,EAAA;EARrC;IAYQ,+B5I8CO,EAAA;;A4IzCf;EACI,aAAa,EAAA;EADjB;IAIQ,kBAAkB,EAAA;IAJ1B;MAOY,c5IsEQ,EAAA;M4I7EpB;QAUgB,kBAAkB;QAClB,UAAU;QACV,YAAS,EAAI;IAZ7B;MAiBY,c5IyDQ,EAAA;M4I1EpB;QAoBgB,kBAAkB;QAClB,UAAU;QACV,YAAS,EAAI;;ACnI7B;EACE,2BAA2B,EAAA;;AAK7B;EACE,kBAAkB,EAAA;EAClB;IAFF;MAGI,oBAAoB,EAAA,EAgEvB;EAnED;IAMI,6BAA6B;IAC7B,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,YAAY;IACZ,6BAA6B,EAAA;IAXjC;MAcM,yBAA2B;MAC3B,wBAA0B,EAAA;IAfhC;;MAmBM,aAAa,EAAA;EAnBnB;IAuBI,2BAA2B,EAAA;IAvB/B;MAyBM,eAAe;MACf,WAAW;MACX,OAAO,EAAA;IA3Bb;MA8BM,wC7IklBmE;M6IjlBnE,kBAAkB;MAClB,YAAY,EAAA;IAhClB;MAmCM,iCAA+C;MAC/C,YAAY,EAAA;MApClB;QAsCQ,qBAAkC;QAClC,iCAA+C,EAAA;IAvCvD;MA4CQ,sBAAwB;MACxB,yB7IuIY;M6ItIZ,gCAAiC,EAAA;MA9CzC;QAgDU,yBAA0B;QAC1B,oDAAgD,EAAA;IAjD1D;MAqDQ,oCAAqC;MACrC,gCAAiC;MACjC,W7IyFO,EAAA;I6IhJf;MA2DM,YAAY;MACZ,iBAAiB,EAAA;EA5DvB;IAiEI,uBAAuB,EAAA;;AAI3B;EAEI,8C7IyiBqE,EAAA;E6I3iBzE;IAIM,WAAW,EAAA;EAEb;IANJ;MAQQ,iBAAiB,EAAA;IARzB;MAWQ,8C7IgiBiE,EAAA,E6I/hBlE;EAEH;IAdJ;MAeM,iBAAiB;MACjB,+C7I2hBmE,EAAA,E6IzhBtE;;AAGH;EACE;;IAGI,WAAW,EAAA,EACZ;;AAIL;EACE,2BAA2B,EAAA;;AAK7B;EACE,0DAAuD;EACvD,sBAAsB,EAAA;;AAGxB;EAGM,0CAAiE;EACjE,iBAAiB;EACjB,eAAe,EAAA;EAEf;IAPN;MAQQ,eAAe;MACf,gBAAgB,EAAA;EATxB;IAeQ,eAAe,EAAA,EAJlB;;AAUL;EACE,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,UAAU,EAAA;;AAGZ;;EAGI,SAAS;EACT,WAAW;EACX,YAAY;EACZ,yC7I8BgB;E6I7BhB,c7I6BgB;E6I5BhB,qBAAqB;EACrB,sBAAsB,EAAA;;AAT1B;EAYI,sBAAsB;EACtB,qBAAqB,EAAA;;AAIzB;EAEI,2C7IbW;E6IcX,kCAA0B;UAA1B,0BAA0B,EAAA;;AAK5B;EADF;;IAIM,sBAAsB;IACtB,0BAA0B,EAAA,EAC3B;;AAIL;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,sBAAsB,EAAA;;ACtLxB;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,cAAc,EAAA;EAJhB;IAOI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,oC9IiI8D;I8IhI9D,SAAS;IACT,aAAa;IACb,SAAS;IACT,mBAAmB,EAAA;;AAIvB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU,EAAA;EAJZ;IAOI,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,SAAS;IACT,YAAY;IACZ,cAAc;IACd,oCAA2D;IAC3D,wC9IklBqE;I8IjlBrE,mBAAmB;IACnB,c9IoJgB;I8InJhB,UAAU,EAAA;EArBd;IAyBI,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;IACxB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,kBAAkB,EAAA;EA/BtB;IAmCI,aAAa;IACb,oCAA2D;IAC3D,kBAAkB;IAClB,wC9I8jBqE;I8I7jBrE,sB9IikBgC;I8IhkBhC,mD9IsGW,EAAA;E8I9If;IA4CI,OAAO,EAAA;IA5CX;MA+CM,uBAAuB;MACvB,iBAAiB,EAAA;EAhDvB;IAqDI,SAAS,EAAA;IArDb;MAwDM,WAAW,EAAA;IAxDjB;MA4DM,wBAAwB;MACxB,eAAe,EAAA;IA7DrB;MAiEM,UAAU;MACV,sD9IkES,EAAA;;A8I7Df;EAzFA;IA4FM,UAAU;IACV,aAAa,EAAA;EA3EnB;IAgFI,WAAW;IACX,kBAAkB;IAClB,kBAAkB,EAAA;IAHpB;MAOI,QAAQ,EAAA;MAPZ;QAUM,WAAW;QACX,YAAY;QACZ,MAAM;QACN,eAAe;QACf,OAAO,EAAA;MAdb;QAkBM,WAAW;QACX,wE9IkgBiE,EAAA;M8IrhBvE;QAuBM,WAAW;QACX,UAAU;QACV,WAAW;QACX,QAAQ;QACR,gBAAgB,EAAA,EACjB;;AAKP;EACE,kBAAkB,EAAA;EADpB;IAII,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,oC9IF8D,EAAA;E8ITlE;IAeI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,UAAU,EAAA;IAlBd;MAqBM,oBAAoB;MACpB,WAAW;MACX,YAAY;MACZ,SAAS;MACT,kBAAkB;MAClB,oC9IjB4D;M8IkB5D,mBAAmB;MACnB,yBAAyB;MACzB,mBAAmB;MACnB,uBAAuB;MACvB,kBAAkB,EAAA;MA/BxB;QAiCQ,oBAAoB;QACpB,qBAAqB;QACrB,4BAA4B;QAC5B,gBAAgB;QAChB,uBAAuB,EAAA;EArC/B;IA2CI,eAAe;IACf,gB9I/CoB;I8IgDpB,kBAAkB;IAClB,iBAAiB,EAAA;IA9CrB;MAiDM,WAAW;MACX,cAAc;MACd,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,SAAS;MACT,UAAU;MACV,iBAAiB;MACjB,mB9IDc;M8IEd,0C9IjD4D;M8IkD5D,mBAAmB;MACnB,UAAU,EAAA;EA5DhB;IAiEI,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,wC9I+aqE;I8I9arE,kBAAkB;IAClB,oCAA2D;IAC3D,gBAAgB,EAAA;IAChB;MAzEJ;QA0EM,eAAe,EAAA,EAkClB;IA5GH;MA8EM,WAAW;MACX,cAAc;MACd,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,mBAAmB;MACnB,SAAS;MACT,WAAW;MACX,0EACa;MACb,kBAAkB,EAAA;IAxFxB;MA4FM,WAAW;MACX,cAAc;MACd,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,mBAAmB;MACnB,WAAW;MACX,SAAS;MACT,wEAA+D;MAC/D,kBAAkB,EAAA;IArGxB;MAyGM,kBAAkB;MAClB,WAAW,EAAA;EA1GjB;IA+GI,kBAAkB;IAClB,qBAAqB;IACrB,wC9ImYqE;I8IlYrE,kBAAkB;IAClB,gB9I/FW;I8IgGX,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,uBAAuB,EAAA;IAzH3B;MA4HM,cAAc,EAAA;MA5HpB;QA+HQ,UAAU;QACV,gBAAgB;QAChB,UAAU;QACV,wEAA+D,EAAA;MAlIvE;QAsIQ,UAAU;QACV,gBAAgB;QAChB,UAAU;QACV,0EACa;QACb,kBAAkB;QAClB,UAAU,EAAA;;AAOlB;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc,EAAA;EAHhB;IAMI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,OAAO;IACP,WAAW;IACX,0C9ItJ8D,EAAA;E8I0IlE;IAiBM,qBAAqB;IACrB,6BAA6B;IAC7B,gBAAgB,EAAA;IAnBtB;MAsBQ,WAAW;MACX,kBAAkB;MAClB,SAAS;MACT,UAAU;MACV,gBAAgB;MAChB,mB9I5HY;M8I6HZ,WAAW;MACX,YAAY;MACZ,UAAU;MACV,mBAAmB;MACnB,0C9I1K0D,EAAA;E8I0IlE;IAqCM,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,0C9IpL4D,EAAA;I8I0IlE;MA6CQ,WAAW;MACX,cAAc;MACd,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,mBAAmB;MACnB,SAAS;MACT,UAAU;MACV,0EAAiE;MACjE,kBAAkB;MAClB,QAAQ;MACR,cAAc,EAAA;EAxDtB;IA6DM,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,SAAS;IACT,gBAAgB,EAAA;EAjEtB;IAqEM,eAAe;IACf,0BAA0B,EAAA;IAtEhC;MAyEQ,yBAAyB,EAAA;MAzEjC;QA4EU,aAAa;QACb,SAAS;QACT,0EAAiE,EAAA;IA9E3E;MAmFQ,yBAAyB,EAAA;EAnFjC;;IA0FI,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyC,EAAA;IA9F7C;;MAiGM,eAAe;MACf,W9IjOS,EAAA;I8I+Hf;;MAqGM,yC9ItMc;M8IuMd,UAAU;MACV,YAAY;MACZ,mCAA2B;cAA3B,2BAA2B;MAC3B,oBAAoB,EAAA;EAzG1B;IA8GI,QAAQ,EAAA;IA9GZ;MAiHM,gBAAgB;MAChB,sBAAsB,EAAA;EAlH5B;IAuHI,OAAO,EAAA;IAvHX;MA0HM,gBAAgB;MAChB,sBAAsB,EAAA;;AAO5B;EACE,kBAAkB;EAClB,gBAAgB,EAAA;EAFlB;IAKI,kBAAkB,EAAA;IALtB;MAQM,UAAU,EAAA;IARhB;MAYM,0CAAiE;MACjE,0CAAiE;MACjE,YAAY;MACZ,WAAW,EAAA;IAfjB;MAmBM,WAAW;MACX,kBAAkB;MAClB,8C9I0MmE;M8IzMnE,UAAU;MACV,YAAY;MACZ,QAAQ;MACR,UAAU,EAAA;IAzBhB;MA6BQ,yBAAyB,EAAA;;ACpbjC;EAEQ,kBAAkB;EAClB,eAAe,EAAA;EAHvB;IAMY,cAAc;IACd,2BAA8C;IAC9C,gB/ImrBqB;I+IlrBrB,iBAAiB;IACjB,WAAW;IACX,eAAe,EAAA;;AAK3B;EACI,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY,EAAA;EAPhB;IAUQ,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,WAAW;IACX,SAAS;IACT,0CAAiE;IACjE,oBAAoB,EAAA;EAlB5B;IAsBQ,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB,EAAA;IAxB1B;MA2BY,cAAc,EAAA;IA3B1B;MA+BY,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,WAAW;MACX,UAAU;MACV,UAAU;MACV,wGAAuG;MACvG,kBAAkB;MAClB,gBAAgB;MAChB,mCAAmC;MACnC,aAAa;MACb,WAAW;MACX,qBAAqB;MACrB,aAAa,EAAA;MA5CzB;QA+CgB,W/IuFD;Q+ItFC,SAAS;QACT,eAAe,EAAA;EAjD/B;IAuDQ,gCAAgC,EAAA;EAvDxC;IA2DQ,kBAAkB,EAAA;IA3D1B;MA8DY,eAAe;MACf,kBAAkB;MAClB,aAAa,EAAA;IAhEzB;MAoEY,SAAS;MACT,oBAAoB;MACpB,c/IsEM,EAAA;E+I5IlB;IA4EY,YAAY,EAAA;EA5ExB;IAgFY,SAAS,EAAA;IAhFrB;MAmFgB,UAAU,EAAA;EAnF1B;IAwFY,UAAU;IACV,mBAAmB,EAAA;;AAK/B;EAGY,iCAA+C,EAAA;;ACjH3D;EACI,gBAAgB,EAAA;;AAGpB;EAEQ,gBAAgB,EAAA;;AAFxB;EAMQ,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,cAAc,EAAA;;AAGlB;EAbJ;IAeY,gBAAgB,EAAA;EAf5B;IAmBY,qBAAqB;IACrB,SAAS,EAAA,EACZ;;AAGL;EAxBJ;IA0BY,eAAe;IACf,gBAAgB,EAAA;EA3B5B;IA+BY,kBAAkB;IAClB,QAAQ,EAAA,EACX;;AAKT;EACI;IACI,yBAAyB,EAAA;EAG7B;IACI,yCAAyC,EAAA;EAG7C;IACI,uCAAuC,EAAA;EAG3C;IACI,yCAAyC,EAAA;EAG7C;IACI,uCAAuC,EAAA;EAG3C;IACI,wCAAwC,EAAA;EAG5C;IACI,yBAAyB,EAAA,EAAA;;AAIjC;EACI,sCAAsC,EAAA;;ACzE1C;EACI,4CjJyLgB,EAAA;EiJvLhB;IAHJ;MAIQ,gBAAgB,EAAA,EAEvB;;AAKD;EACI,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,aAAa,EAAA;EACb;IANJ;MAOQ,aAAa,EAAA,EAqBpB;EA5BD;IAWQ,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,mBjJuJY;IiJtJZ,qDAAoE,EAAA;EAnB5E;IAwBQ,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAA;;AAIzB;EAGY,+BjJ0GG,EAAA;EiJ7Gf;IAMgB,0CjJuGD,EAAA;;AiJjGf;EACI,wCjJgkBqE;EiJ/jBrE,6CjJ+jBqE,EAAA;;AiJ1jBrE;EAEQ,0BjJsHQ,EAAA;;AiJxHhB;EAEQ,0BjJ0HQ,EAAA;;AiJ5HhB;EAEQ,0BjJ4HQ,EAAA;;AiJ9HhB;EAEQ,0BjJ8HQ,EAAA;;AiJhIhB;EAEQ,0BjJ2HQ,EAAA;;AiJ7HhB;EAEQ,0BjJyHQ,EAAA;;AiJ3HhB;EAEQ,0BjJyFM,EAAA;;AiJ3Fd;EAEQ,0BjJiGM,EAAA;;AiJ5FlB;EACI,kBAAkB,EAAA;EADtB;IAIQ,WAAW;IACX,aAAa;IACb,iBAAiB,EAAA;IAEjB;MARR;QASY,aAAa,EAAA,EAEpB;EAXL;IAcQ,aAAa,EAAA;EAdrB;IAkBQ,eAAe,EAAA;;AAIvB;EACI,kBAAkB;EAClB,qBAAqB,EAAA;EAFzB;IAKQ,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,SAAS;IACT,eAAe,EAAA;EATvB;IAaQ,iBAAiB,EAAA;EAbzB;IAiBQ,aAAa,EAAA;;AAIrB;EAEQ,kBAAkB,EAAA;EAF1B;IAKY,6BAA6B,EAAA;IALzC;MAQgB,gBAAgB,EAAA;EARhC;IAaY,WAAW;IACX,8CjJ0f6D;IiJzf7D,kBAAkB;IAClB,YAAY;IACZ,UAAU,EAAA;EAjBtB;IAsBgB,QAAQ,EAAA;EAtBxB;IA4BgB,YAAY;IACZ,QAAQ,EAAA;;AAMxB;EACI,kBAAkB;EAClB,aAAa,EAAA;EAFjB;IAKQ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ,EAAA;EARhB;IAYQ,WAAW;IACX,aAAa;IACb,iBAAiB,EAAA;IAEjB;MAhBR;QAiBY,aAAa,EAAA,EAEpB;EAnBL;IAsBQ,aAAa,EAAA;EAtBrB;IA0BQ,eAAe,EAAA;;AAIvB;E5JooxDE;I4JhoxDU,wBAAwB,EAAA,EAC3B;;A5JkoxDT;E4J5nxDQ,ejJqUK,EAAA;;AkJ/fb;EACI,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe,EAAA;EAJnB;IAOQ,kBAAkB,EAAA;;AAI1B;EACI,kBAAkB,EAAA;EADtB;IAIQ,UAAU;IACV,SAAS;IACT,gBAAgB,EAAA;IANxB;MASY,cAAc;MACd,2BAAyC;MACzC,0CAAiE;MACjE,4ClJ4mB+C;MkJ3mB/C,oBlJ4pB2B;MkJ3pB3B,YAAY;MACZ,YAAY;MACZ,aAAa;MACb,uBAAuB;MACvB,mBAAmB,EAAA;MAlB/B;QAqBgB,oBAAoB;QACpB,qBAAqB;QACrB,4BAA4B;QAC5B,gBAAgB;QAChB,uBAAuB,EAAA;;AAMvC;EAIgB,UAAU;EACV,uBAAuB;EACvB,kBAAkB,EAAA;;AANlC;EAYQ,kBAAkB;EAClB,WAAW,EAAA;EAbnB;IAgBY,WAAW;IACX,cAAc;IACd,QAAQ;IACR,aAAa;IACb,8ClJwjB6D;IkJvjB7D,YAAY;IACZ,kBAAkB,EAAA;EAtB9B;IA2BgB,aAAa;IACb,YAAY;IACZ,wBAAwB;IACxB,iBAAiB;IACjB,gDlJ6iByD;IkJ5iBzD,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,8ClJyiByD,EAAA;IkJ5kBzE;MAsCoB,WAAW;MACX,UAAU,EAAA;;AAM1B;EA7CJ;IAiDoB,UAAU;IACV,UAAU;IACV,iBAAiB,EAAA;EAnDrC;IAwDgB,WAAW,EAAA,EACd;;AAKb;EACI,WAAW,EAAA;EADf;IAKY,aAAa;IACb,YAAY;IACZ,wBAAwB;IACxB,iBAAiB;IACjB,gDlJqgB6D;IkJpgB7D,UAAU;IACV,WAAW;IACX,SAAS,EAAA;IAZrB;MAegB,WAAW;MACX,WAAW,EAAA;EAhB3B;IAqBY,cAAc;IACd,WAAW,EAAA;IAtBvB;MA0BoB,YAAY,EAAA;EA1BhC;IAiCQ,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,6ClJweiE;IkJvejE,+ClJueiE;IkJtejE,8ClJseiE;IkJrejE,cAAc;IACd,UAAU;IACV,UACJ,EAAA;EAEA;IA9CJ;MAiDgB,UAAU;MACV,SAAS;MACT,gBAAgB,EAAA;IAnDhC;MAwDY,kBAAkB;MAClB,OAAO;MACP,UAAU,EAAA,EACb;;AAIT;EACI,8ClJ8cqE;EkJ7crE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa,EAAA;EALjB;IAQQ,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,8ClJkciE;IkJjcjE,UAAU;IACV,UAAU;IACV,SAAS;IACT,iBAAiB,EAAA;EAjBzB;IAqBQ,sBAAsB;IACtB,UAAU,EAAA;EAtBlB;IA0BQ,eAAe;IACf,kBAAkB,EAAA;IA3B1B;MA8BY,kBAAkB;MAClB,gDlJgb6D;MkJ/a7D,YAAY,EAAA;MAhCxB;QAmCgB,oCAA2D;QAC3D,gBAAgB;QAChB,kBAAkB;QAClB,UAAU;QACV,UAAU;QACV,YAAY;QACZ,sBAAsB;QACtB,WAAW;QACX,kBAAkB,EAAA;EA3ClC;IAiDQ,cAAc;IACd,WAAW,EAAA;EAGf;IArDJ;MAuDY,YAAY,EAAA,EACf;EAGL;IA3DJ;MA4DQ,WAAW;MACX,WAAW;MACX,cAAc,EAAA;MA9DtB;QAiEY,WAAW;QACX,cAAc;QACd,kBAAkB;QAClB,QAAQ;QACR,YAAY;QACZ,4BlJvFG;QkJwFH,UAAU;QACV,UAAU;QACV,QAAQ;QACR,iBAAiB,EAAA;MA1E7B;QA+EgB,aAAa,EAAA,EAChB;;AASb;EAEQ,UAAU;EACV,iBAAiB;EACjB,kBAAkB,EAAA;EAJ1B;IAMY,kBAAkB,EAAA;EAEtB;IARR;MASY,gBAAgB,EAAA;MAT5B;QAYoB,eAAe,EAAA;QAZnC;UAcwB,aAAa,EAAA;MAdrC;QAmBoB,aAAa,EAAA;EAnBjC;IA2BY,kBAAkB,EAAA;IA3B9B;MA6BgB,iBAAiB,EAAA;MA7BjC;;QAgCoB,kBAAkB,EAAA;QAhCtC;;UAmCwB,WAAW;UACX,yBAAyB;UACzB,+ClJiViD;UkJhVjD,kBAAkB;UAClB,QAAQ;UACR,SAAS,EAAA;MAxCjC;QA6CwB,WAAW,EAAA;MA7CnC;QAiDoB,kBAAkB;QAClB,0BAA0B,EAAA;QAlD9C;UAqDwB,WAAW;UACX,WAAW;UACX,6ClJ+TiD;UkJ9TjD,kBAAkB;UAClB,QAAQ;UACR,2BAA2B;UAC3B,OAAO,EAAA;MA3D/B;QAgEoB,iBAAiB,EAAA,EA5CpB;;AAiDb;EArEJ;IAuEY,iBAAiB,EAAA;IAvE7B;MAyEgB,iBAAiB,EAAA;MAzEjC;QA4EoB,WAAW;QACX,YAAY;QACZ,QAAQ;QACR,+ClJuSqD;QkJtSrD,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,QAAQ;QACR,gBAAgB,EAAA;MApFpC;QAwFoB,WAAW;QACX,WAAW;QACX,6ClJ4RqD;QkJ3RrD,kBAAkB;QAClB,MAAM;QACN,SAAS,EAAA;MA7F7B;QAkGwB,aAAa,EAAA;MAlGrC;QAwGwB,WAAW;QACX,YAAY;QACZ,+ClJ4QiD;QkJ3QjD,kBAAkB;QAClB,SAAS;QACT,OAAO,EAAA;MA7G/B;QAgHwB,YAAY,EAAA;MAhHpC;QAqHoB,kBAAkB,EAAA;QArHtC;UAwHwB,WAAW;UACX,YAAY;UACZ,+ClJ4PiD;UkJ3PjD,kBAAkB;UAClB,SAAS;UACT,SAAS;UACT,cAAc,EAAA,EACjB;;AA/HrB;EAsIQ,2BAA8C;EAC9C,gBAAgB;EAChB,cAAc,EAAA;;AAOtB;EAEQ,2BAA8C;EAC9C,cAAc,EAAA;;AAHtB;EAOY,eAAe,EAAA;EAP3B;IAUgB,aAAa,EAAA;;AAV7B;EAeY,aAAa,EAAA;;AAfzB;EAmBQ,kBAAkB;EAClB,iBAAiB,EAAA;EApBzB;IAsBY,WAAW;IACX,8ClJgN6D;IkJ/M7D,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,SAAS;IACT,OAAO,EAAA;EA5BnB;IAgCgB,kBAAkB;IAClB,2BAA2B,EAAA;IAjC3C;MAmCoB,WAAW;MACX,WAAW;MACX,6ClJkMqD;MkJjMrD,kBAAkB;MAClB,QAAQ;MACR,2BAA2B;MAC3B,OAAO,EAAA;EAzC3B;IA8CY,iBAAiB,EAAA;EA9C7B;IAmDY,kBAAkB,EAAA;IAnD9B;MAqDgB,kBAAkB,EAAA;MArDlC;QAuDoB,WAAW;QACX,YAAY;QACZ,8ClJ8KqD;QkJ7KrD,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,gBAAgB,EAAA;MA7DpC;QAiEwB,YAAY,EAAA;EAjEpC;IAyEgB,YAAY,EAAA;;ACxd5B;EACI,aAAa;EACb,kBAAkB;EAClB,qBAAqB,EAAA;EAHzB;IAMQ,aAAa;IACb,WAAW;IACX,iBAAiB,EAAA;EARzB;IAYQ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qDAAoE;IACpE,YAAY,EAAA;;AAIpB;EAEQ,mBAAmB,EAAA;EAF3B;IAKY,cAAc;IACd,UAAU,EAAA;EANtB;IAUY,gBAAgB,EAAA;IAV5B;MAagB,kBAAkB,EAAA;MAblC;QAgBoB,WAAW,EAAA;IAhB/B;MAqBgB,cAAc,EAAA;IArB9B;MA0BoB,qBAAqB;MACrB,cAAc,EAAA;IA3BlC;MA+BoB,WnJkGL,EAAA;ImJjIf;MAoCwB,WnJ6FT,EAAA;ImJjIf;MA0CgB,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,mBAAmB;MACnB,gBAAgB,EAAA;MA9ChC;QAiDoB,eAAe,EAAA;MAjDnC;QAqDoB,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB,EAAA;IAvDtC;MA4DgB,WAAW;MACX,gBAAgB,EAAA;EAIxB;IAjER;MAmEgB,cAAc;MACd,aAAa,EAAA,EAChB;EAGL;IAxER;MA0EgB,cAAc;MACd,UAAU,EAAA,EACb;EAGL;IA/ER;MAiFgB,cAAc;MACd,WAAW,EAAA,EACd;;AAnFb;EAwFQ,sBAAsB,EAAA;EAxF9B;IA2FY,mBAAmB,EAAA;IA3F/B;MA8FgB,mBAAmB;MACnB,8BAA8B,EAAA;IA/F9C;MAmGgB,aAAa;MACb,mBAAmB,EAAA;MApGnC;QAuGoB,YAAY;QACZ,WAAW;QACX,eAAe,EAAA;MAzGnC;QA6GoB,iBAAiB,EAAA;IA7GrC;MAkHgB,WAAW;MACX,cAAc;MAEd,QAAQ,EAAA;IArHxB;MAyHgB,cnJsCI,EAAA;EmJlCZ;IA7HR;MA8HY,mBAAmB,EAAA;MA9H/B;QAkIgB,cAAc;QACd,WAAW,EAAA;MAnI3B;QAwIoB,WAAW;QACX,cAAc;QACd,SAAS;QACT,mBAAmB,EAAA;QA3IvC;UA8IwB,UAAU,EAAA;MA9IlC;QAmJoB,mBAAmB,EAAA;MAnJvC;QAuJoB,WAAW;QACX,gBAAgB,EAAA,EACnB;;AAMjB;EACI,cAAc,EAAA;;AAGlB;EAGY,yBnJCQ;EmJAR,WnJtCG,EAAA;;AmJ2Cf;EAEQ,qBAAqB;EACrB,cAAc;EACd,WAAW,EAAA;;AAJnB;EAOQ,WnJlDO,EAAA;;AmJ2Cf;EAYY,WnJvDG,EAAA;;AoJpJf;EACI,kBAAkB;EAClB,aAAa;EACb,SAAS,EAAA;EAHb;IAOQ,UAAU,EAAA;IAPlB;MAWoB,aAAa,EAAA;EAXjC;IAiBQ,eAAe;IACf,gBpJ2GgB;IoJ1GhB,cAAc;IACd,kBAAkB;IAClB,oCAAqD;IACrD,yBAAyB,EAAA;EAtBjC;IA0BQ,0CAAiE;IACjE,iBAAiB;IACjB,kBAAkB;IAClB,sBpJ2lB4B;IoJ1lB5B,4CpJmmBmD;IoJlmBnD,gBpJ0pByB;IoJzpBzB,eAAe,EAAA;IACf;MAjCR;QAkCY,eAAe,EAAA,EAYtB;IA9CL;MAsCY,YAAY;MACZ,eAAe;MACf,kBAAkB;MAClB,YAAY;MACZ,QAAQ;MACR,2BAA2B;MAC3B,qBAAkC,EAAA;;AAM9C;EACI,uCAAuC,EAAA;;AAG3C;EACI;IAAK,wBAAwB,EAAA;EAC7B;IAAO,4BAA4B,EAAA,EAAA;;AAGvC;EACI,gBpJ6nB6B;EoJ5nB7B,yBAAyB;EACzB,WpJsFW;EoJrFX,4BpJyHgB,EAAA;;AoJtHpB;EACI,gBAAgB,EAAA;;ACrEpB;EACI,kBAAkB;EAClB,gBAAgB,EAAA;EAFpB;IAKQ,eAAe;IACf,WrJgJO;IqJ/IP,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,kBAAkB;IAClB,OAAO;IACP,QAAQ,EAAA;IAZhB;MAeY,eAAe,EAAA;IAGnB;MAlBR;QAmBY,eAAe,EAAA;QAnB3B;UAsBgB,eAAe,EAAA,EAClB;;AAKb;EAEQ,aAAa,EAAA;EAFrB;IAIY,cAAc,EAAA;EAJ1B;IAOY,cAAc,EAAA;EAP1B;IAUY,cAAc,EAAA;;AAK1B;EACI,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,kBAAkB,EAAA;EARtB;IAWQ,iBAAiB;IACjB,eAAe,EAAA;EAZvB;IAgBQ,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,UAAU;IACV,oBAAoB;IACpB,mCAAmC;IACnC,iCAA+C,EAAA;IA1BvD;MA6BY,qBAAqB,EAAA;IA7BjC;MAiCY,qBAAqB,EAAA;;AAKjC;EACI;IACI,UAAU;IACV,mBAAmB,EAAA;EAGvB;IACI,UAAU;IACV,mBAAmB,EAAA,EAAA;;AAI3B;EAEQ,WAAW;EACX,qBAAqB,EAAA;;AC9F7B;EACI,aAAa,EAAA;;AAGjB;EAEQ,UAAU;EACV,YAAY;EACZ,0CAAiE,EAAA;;AAJzE;EAQQ,0CAAiE,EAAA;;AAOrE;EADJ;IAEQ,gBAAgB;IAChB,sBAAoD,EAAA,EAE3D;;AAED;EAGY,wCtJwlB6D;EsJvlB7D,sBtJ2lBwB;EsJ1lBxB,eAAe;EACf,eAAe,EAAA;;AAN3B;EAWgB,iCAA+C,EAAA;;AAM/D;EAIgB,ctJ0II,EAAA;;AuJ1LpB;EAGY,YAAY,EAAA;;AAKxB;EAEQ,YAAW;EACX,mBAAmB;EACnB,eAAe,EAAA;;AAJvB;EAOQ,uBAAuB,EAAA;;AAP/B;EAUQ,WAAW,EAAA;EAVnB;IAYY,QAAQ,EAAA;EAZpB;IAeY,mBAAmB,EAAA;;ACvB/B;EACE,kBAAkB;EAClB,kBAAkB,EAAA;;AAKpB;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,0CAAiE,EAAA;EAEjE;IALF;MAMI,gBAAgB;MAChB,gBAAgB;MAChB,uCAAiE,EAAA,EAEpE;;AAED;EACE,SAAS,EAAA;EADX;IAMQ,mDxJ8GoE;IwJ7GpE,wBxJ8GiD,EAAA;IwJrHzD;MAUU,8DAAkF;MAClF,yBAA0B,EAAA;EAXpC;IAiBM,cAAc;IACd,iBAAiB;IACjB,2BAA8C;IAC9C,oBAAoB;IACpB,oCxJ/BmE;IwJgCnE,gBxJsFkB;IwJrFlB,oBxJ0oBiC,EAAA;EwJjqBvC;IA2BM,eAAe,EAAA;EA3BrB;IA+BM,gBxJyoB2B,EAAA;EwJxqBjC;IAmCM,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,UAAU;IACV,SAAS,EAAA;IAvCf;MA0CQ,iBAAiB;MACjB,gBxJ6nByB;MwJ5nBzB,eAAe,EAAA;;AAMvB;EACE,kBAAkB,EAAA;EADpB;IAII,WAAW;IACX,YAAY;IACZ,yBxJgFc;IwJ/Ed,kBAAkB;IAClB,0CAAiE;IACjE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,SAAS,EAAA;EAZb;IAiBM,yBxJoGc,EAAA;EwJrHpB;IAuBM,yBxJ6Fc,EAAA;;AwJxFpB;EACE,+BAA+B,EAAA;EAE/B;IAHF;MAII,2BAA2B,EAAA,EAE9B;;AAID;EAEI,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,2BAA8C;EAC9C,oCxJxGqE;EwJyGrE,gBxJaoB;EwJZpB,oBxJikBmC,EAAA;;AwJ7jBvC;EACE,iBAAiB;EACjB,cxJ2DkB;EwJ1DlB,gBxJKsB;EwJJtB,kBAAkB;EAClB,eAAe,EAAA;EALjB;IAOI,WAAW;IACX,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,QAAQ;IACR,iCAA+C,EAAA;;AAMnD;EACE,oDAAmD;EACnD,oBAAoB;EACpB,kBAAkB;EAClB,mCAAmD,EAAA;EAEnD;IANF;MAOI,kBAAkB;MAClB,OAAO;MACP,QAAQ;MACR,WAAW;MACX,wBAAwB;MACxB,kBAAkB;MAClB,2BAA2B;MAC3B,WAAW;MACX,iBAAiB,EAAA;MAfrB;QAkBM,mBAAmB;QACnB,wBAAwB,EAAA,EACzB;EApBL;IAwBI,kBAAkB,EAAA;EAxBtB;IA6BM,aAAa,EAAA;EAGb;IAhCN;MAiCQ,wBAAwB,EAAA,EAE3B;;AAIL;EACE,oCAAoC;EACpC,0CAAiE,EAAA;EACjE;IAHF;MAII,eAAe;MACf,OAAO;MACP,QAAQ;MACR,MAAM;MACN,UAAU,EAAA,EAEb;;AAED;EAEI,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,cxJxCc,EAAA;;AwJ0ChB;EAVF;IAWI,aAAa;IACb,yBAAyB,EAAA,EAE5B;;AAED;EACE,sCAAsC,EAAA;EACtC;IAFF;MAGI,sCAAsC,EAAA,EAmQzC;EAtQD;IAOI,aAAa;IACb,sBAAsB,EAAA;IAR1B;MAWM,gBAAgB,EAAA;EAXtB;IAgBI,iBAAiB;IACjB,gBAAgB,EAAA;IAjBpB;MAmBM,aAAa,EAAA;EAnBnB;IA0BQ,gBAAgB,EAAA;EA1BxB;IAkCQ,aAAa,EAAA;EAlCrB;IAsCM,kBAAkB,EAAA;EAtCxB;IA2CQ,mBAAmB,EAAA;EA3C3B;IAiDI,kBAAkB,EAAA;IAjDtB;MAoDM,WAAW;MACX,YAAY;MACZ,kBAAkB,EAAA;EAtDxB;IA2DI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW,EAAA;IA/Df;MAkEM,sBxJ1HS;MwJ2HT,kBAAkB;MAClB,eAAe;MACf,UAAU;MACV,iBAAiB;MACjB,kBAAkB,EAAA;IAvExB;MA2EM,WAAW;MACX,kBAAkB;MAClB,WAAW;MACX,WAAW;MACX,OAAO;MACP,QAAQ;MACR,yCxJ3Gc;MwJ4Gd,SAAS,EAAA;IAlFf;MAsFM,eAAe,EAAA;EAtFrB;IA2FI,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,qBAAqB;IACrB,cAAc,EAAA;IAEd;MAjGJ;QAkGM,cAAc,EAAA,EAkGjB;IApMH;MAsGM,aAAa;MACb,mBAAmB,EAAA;IAvGzB;MA2GM,qBAAqB;MACrB,sBAAsB,EAAA;IA5G5B;MAgHM,kBAAkB;MAClB,iCxJzL+C;MwJ0L/C,kBAAkB;MAClB,kBAAkB;MAClB,6CxJmUyD,EAAA;MwJhUvD;QAvHR;UAyHY,aAAa,EAAA;QAzHzB;UA6HY,cAAc,EAAA,EACf;IA9HX;MAoIM,gBxJnNkB;MwJoNlB,aAAa;MACb,eAAe;MACf,mBAAmB;MACnB,QAAQ,EAAA;IAxId;MA6IQ,eAAe;MACf,YAAY;MACZ,cxJjMU,EAAA;MwJkDlB;QAiJU,aAAa,EAAA;MAGf;QApJR;UAqJU,aAAa,EAAA,EAEhB;IAvJP;MA2JM,eAAe;MACf,eAAe;MACf,iBAAiB,EAAA;IA7JvB;MAiKM,qBAAqB;MACrB,kBAAkB;MAClB,aAAa;MACb,eAAe;MACf,QAAQ,EAAA;MArKd;QAwKQ,kBAAkB,EAAA;MAxK1B;QA4KQ,gBAAgB,EAAA;MA5KxB;QAgLQ,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY,EAAA;QAnLpB;UAuLY,eAAe;UACf,WxJhPG;UwJiPH,qBAAqB;UACrB,iBAAiB;UACjB,WAAW;UACX,YAAY;UACZ,kBAAkB;UAClB,uCxJ7OM;UwJ8ON,kBAAkB,EAAA;EA/L9B;IAuMI,yBAAyB,EAAA;IAvM7B;MA0MM,QAAQ;MACR,iBAAiB;MACjB,iBAAiB,EAAA;IA5MvB;MAgNM,gBAAgB;MAChB,cxJnQY,EAAA;IwJkDlB;MAqNM,iBAAiB,EAAA;MArNvB;QAwNQ,yBAAyB,EAAA;QAxNjC;UA2NU,QAAQ;UACR,mDxJnSkE;UwJoSlE,wBxJnS+C;UwJoS/C,iBAAiB;UACjB,gBxJ0NwB,EAAA;UwJzblC;YAkOY,0CxJ1RG;YwJ2RH,4CAA4C;YAC5C,cxJnRM,EAAA;YwJ+ClB;cAuOc,qCAAqC,EAAA;MAvOnD;QA8OQ,yBAAyB,EAAA;QA9OjC;UAiPU,QAAQ,EAAA;QAjPlB;UAqPU,QAAQ,EAAA;QArPlB;UAyPU,QAAQ,EAAA;MAzPlB;QA8PQ,QAAQ,EAAA;IA9PhB;MAmQM,yBxJlTY,EAAA;;AwJuTlB;EACE,iCAAiC;EACjC,0CAAiE;EACjE,kBAAkB;EAClB,UAAU,EAAA;EAJZ;IAOI,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,eAAe;IACf,cxJ3SgB,EAAA;EwJ+RpB;IAeI,cAAc,EAAA;;AAIlB;EACE,aAAa,EAAA;EADf;IAIM,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,aAAa;IACb,cAAc,EAAA;IARpB;MAUQ,cxJvVU,EAAA;;AwJ8VlB;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,aAAa,EAAA;;AAGf;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,4CxJgHuE;EwJ/GvE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,oBAAoB,EAAA;EAEpB;IAXF;MAYI,aAAa,EAAA,EAWhB;EAvBD;IAgBI,4BAA4B;IAC5B,UAAU,EAAA;IAEV;MAnBJ;QAoBM,4BAA4B,EAAA,EAE/B;;AAGH;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kDAAkD;EAClD,qDAAqD,EAAA;EANvD;IASI,qCAAqC;IACrC,eAAe,EAAA;;AAKnB;EAEI,2BAA2B,EAAA;;AAF/B;EAOM,0BAA0B,EAAA;;AAPhC;EAYI,oBAAoB;EACpB,qBAAqB,EAAA;;AAOrB;EnKkuyDF;ImKjuyDI,yBAAyB;IACzB,0BAA0B,EAAA,EAK7B;;AAHC;EnKmuyDF;ImKluyDI,wBAAwB,EAAA,EAE3B;;AnKmuyDH;EmKhuyDI,wCAAkE,EAAA;EAClE;InKkuyDA;MmKjuyDE,uCAAiE,EAAA,EAEpE;;AnKkuyDH;EmK/tyDI,2BAA2B,EAAA;EAC3B;InKiuyDA;MmKhuyDE,2BAA2B,EAAA,EAE9B;;AnKiuyDH;EmK9tyDI,sCAAsC,EAAA;EACtC;InKguyDA;MmK/tyDE,sCAAsC,EAAA,EAEzC;;AC1lBH;EACE,kBAAkB;EAClB,kBAAkB,EAAA;;AAKpB;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,0CAAiE;EACjE,oBAAoB,EAAA;EAEpB;IANF;MAOI,gBAAgB;MAChB,gBAAgB;MAChB,uCAAiE,EAAA,EA6BpE;EA1BC;IAZF;MAaI,eAAe;MACf,MAAM;MACN,SAAS;MACT,OAAO;MACP,YAAY;MACZ,eAAe;MACf,aAAa;MACb,6CzJ0mB2D;MyJzmB3D,4BAA4B;MAC5B,kBAAkB;MAClB,aAAa,EAAA;MAvBjB;QA0BM,mBAAmB;QACnB,eAAe,EAAA,EAChB;EA5BL;IAgCI,2BAA2B,EAAA;IAE3B;MAlCJ;QAmCM,2BAA2B,EAAA,EAE9B;;AAGH;EAEI,aAAa;EACb,mBAAmB;EACnB,czJyGc;EyJxGd,cAAc;EACd,gBzJ0EoB,EAAA;EyJhFxB;IASM,czJ4Hc,EAAA;EyJrIpB;IAaM,eAAe,EAAA;EAbrB;IAiBM,czJ0Hc;IyJzHd,gBzJ0nB2B,EAAA;IyJ5oBjC;MAqBQ,czJsHY,EAAA;;AyJhHpB;EAEI,iBAAiB,EAAA;EAFrB;IAIM,gDAAkE,EAAA;;AAIxE;EAEI,czJwEc,EAAA;EyJ1ElB;IAKM,czJiGc,EAAA;;AyJ5FpB;EACE,WAAW;EACX,0CAAiE;EACjE,oBAAoB,EAAA;;AAGtB;EACE,eAAe;EACf,YzJUkB;EyJTlB,SAAS;EACT,2BAA2B;EAC3B,UAAU,EAAA;;AAGZ;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,UAAU;EACV,0CAAiE;EACjE,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,wCAAwD,EAAA;;AAG1D;EAEI,eAAe;EACf,mBAAmB,EAAA;;AAHvB;EAOI,iBAAiB,EAAA;EAEjB;IATJ;MAUM,eAAe,EAAA,EAElB;;AAGH;EACE,2BAA2B,EAAA;EAE3B;IAHF;MAII,2BAA2B,EAAA,EAE9B;;AAED;EACE,2BAA2B,EAAA;EAE3B;IAHF;MAII,2BAA2B,EAAA,EAE9B;;AAED;EACE,cAAc;EACd,eAAe;EACf,SAAS,EAAA;EAHX;IAMI,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,yBAAyB;IACzB,WAAW,EAAA;IAZf;MAeM,yBAA0C,EAAA;IAfhD;MAmBM,2BAAyC;MACzC,0BAA0B,EAAA;IApBhC;MAwBM,WAAW;MACX,kBAAkB,EAAA;IAzBxB;MA6BM,YAAY,EAAA;MA7BlB;;;QAkCQ,cAAc;QACd,WAAW,EAAA;MAnCnB;QAuCQ,6BAA6B;QAC7B,oBAAoB;QACpB,mBAAmB;QACnB,SAAS;QACT,QAAQ;QACR,cAAc;QACd,YAAY,EAAA;MA7CpB;QAiDQ,qBAAqB;QACrB,mBAAmB,EAAA;MAlD3B;QAsDQ,gBAAgB;QAChB,gBAAgB,EAAA;MAvDxB;QA2DQ,kBAAkB;QAClB,MAAM;QACN,UAAU;QACV,QAAQ;QACR,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB;QACnB,gBAAgB,EAAA;QAEhB;UApER;YAqEU,UAAU,EAAA,EAEb;IAvEP;MA2EM,kBAAkB;MAClB,MAAM;MACN,WAAW;MACX,QAAQ;MACR,SAAS,EAAA;MA/Ef;;QAmFQ,kBAAkB;QAClB,MAAM,EAAA;MApFd;QAwFQ,OAAO;QACP,YAAY;QACZ,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB,EAAA;QA5F3B;UA+FU,yBAA0C,EAAA;MA/FpD;QAoGQ,QAAQ;QACR,YAAY;QACZ,kBAAkB,EAAA;IAtG1B;MA4GM,iCzJ9Ec;MyJ+Ed,iCAA+C,EAAA;IA7GrD;MAiHM,yBAA0C,EAAA;MAjHhD;QAoHQ,yBAA0C;QAC1C,gBzJgbyB,EAAA;;AyJ1ajC;;EAEE,aAAa,EAAA;;AAGf;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS,EAAA;;AAGX;EACE,mBAAmB,EAAA;;AAGrB;EA3LA;IA6LI,eAAe;IACf,MAAM;IACN,SAAS;IACT,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,aAAa;IACb,6CzJsV2D;IyJrV3D,2BAA2B,EAAA;EAzL/B;IA8LM,eAAe,EAAA,EAChB;;AAIL;EApKA;IAsKI,YAAY,EAAA,EACb;;AAGH;EAEI,4BAA4B,EAAA;;AAIhC;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YzJ5NkB;EyJ6NlB,WzJ7NkB;EyJ8NlB,UAAU;EACV,aAAa,EAAA;EAPf;IASI,6CzJsT2D,EAAA;EyJnT7D;IAZF;MAaI,UAAU;MACV,WAAW,EAAA,EAEd;;AAKG;EpKstzDF;IoKrtzDI,yBAAyB;IACzB,0BAA0B,EAAA,EAK7B;;AAHC;EpKutzDF;IoKttzDI,wBAAwB,EAAA,EAE3B;;ApKutzDH;EoKptzDI,wCAAkE,EAAA;EAClE;IpKstzDA;MoKrtzDE,aAAa,EAAA,EAQhB;EpK+szDD;IoKptzDI,2BAA2B,EAAA;IAC3B;MpKstzDA;QoKrtzDE,2BAA2B,EAAA,EAE9B;;ApKstzDL;EoKltzDI,2BAA2B,EAAA;;ApKqtzD/B;EoKjtzDI,2BAA2B,EAAA;EAC3B;IpKmtzDA;MoKltzDE,2BAA2B,EAAA,EAE9B;;AAGH;EAEI,wBAAwB,EAAA;;AC/X5B;EACI,aAAa;EACb,gBAAgB;EAChB,oBAAoB,EAAA;EAHxB;IAMQ,gBAAgB;IAChB,kBAAkB,EAAA;EAP1B;IAWQ,wBAAwB,EAAA;EAXhC;IAeQ,WAAW,EAAA;EAfnB;IAmBQ,WAAW,EAAA;EAnBnB;IAuBQ,iDAAiE;IACjE,kBAAkB,EAAA;EAxB1B;IA4BQ,kBAAkB,EAAA;;AAI1B;EAEQ,sC1JwlB4B,EAAA;;A0J1lBpC;EAMQ,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB,EAAA;;AAVxB;EAcQ,kBAAkB,EAAA;;AAI1B;EACI,+BAA+B,EAAA;;AAInC;EACI,iBAAiB;EACjB,kBAAkB,EAAA;EAFtB;IAMQ,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,aAAa;IACb,YAAY;IACZ,cAAc;IACd,0DAA8C;IAC9C,sBAAsB;IACtB,2BAA2B,EAAA;;AAKnC;EAGY,UAAU,EAAA;;AAHtB;EAQgB,UAAU,EAAA;;ACrF1B;EAEQ,0CAAiE;EACjE,eAAe,EAAA;;AAMvB;EACI,eAAe;EACf,kBAAkB,EAAA;EAElB;IAJJ;MAKQ,eAAe,EAAA,EAEtB;;AAED;EACI,kBAAkB,EAAA;EADtB;IAIQ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yC3JgKY;I2J/JZ,kBAAkB;IAClB,SAAS;IACT,OAAO,EAAA;;AAMf;EACI,iBAAiB;EACjB,yBAAyB,EAAA;EACzB;IAHJ;MAIQ,0CAAiE;MACjE,kDAAkD;MAClD,iBAAiB,EAAA,EAmCxB;EAzCD;IAYgB,eAAe;IACf,gB3J+EQ;I2J9ER,oBAAoB;IACpB,oC3JzCyD;I2J0CzD,qBAAkC;IAClC,aAAa,EAAA;IAEb;MAnBhB;QAoBoB,gBAAgB,EAAA,EAQvB;IA5Bb;MA0BoB,yBAA0B,EAAA;EA1B9C;IA+BoB,yBAA0B,EAAA;EA/B9C;IAsCQ,0CAAiE;IACjE,kDAAkD,EAAA;;AAK1D;EAGY,aAAa,EAAA;;AAHzB;EAOY,cAAc,EAAA;;AAP1B;EAagB,sCAAwD,EAAA;;AAbxE;EAqBoB,qBAAkC,EAAA;;AArBtD;EA2BgB,cAAc,EAAA;;AA3B9B;EA+BgB,aAAa,EAAA;;AAQ7B;EACI,gDAAkE,EAAA;EADtE;IAMgB,8BAAqD,EAAA;;AAMrE;EACI,0DAA4D;EAC5D,6BAA6B;EAC7B,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY,EAAA;;AAGhB;EACI,kBAAkB;EAClB,UAAU,EAAA;EAFd;IAMY,0CAAiE;IACjE,YAAY;IACZ,kBAAkB,EAAA;EAR9B;IAaQ,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,gBAAgB,EAAA;EAhBxB;IAoBQ,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB,EAAA;;AAKxB;EACI,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB,EAAA;;AAKvB;EACI,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB,EAAA;;AAItB;EACI,kBAAkB,EAAA;EADtB;IAIQ,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,UAAU;IACV,WAAW,EAAA;;AAInB;EACI,cAAc,EAAA;;AAGlB;EAGY,cAAc;EACd,cAAc;EACd,cAAc;EACd,gCAAgC,EAAA;EAN5C;IASgB,+B3JzDD,EAAA;;A2J+Df;EAEQ,cAAc;EACd,2C3JlEO;E2JmEP,yBAAyB,EAAA;EAJjC;IAOY,W3JtEG;I2JuEH,yB3JzCQ,EAAA;;A2J8CpB;EAEQ,YAAY,EAAA;;AtKij0DpB;;EsKti0DY,WAAW,EAAA;;AtK0i0DvB;EsKti0DY,qDAA4E,EAAA;;AtKyi0DxF;EsKhi0DoB,aAAa,EAAA;;AtKmi0DjC;EsK/h0DoB,cAAc,EAAA;;AChQlC;EAEQ,c5J0JU;E4JzJV,iCAA+C;EAC/C,4C5J+nBmD;E4J9nBnD,oB5J+qB+B,EAAA;E4JprBvC;IAQY,yBAAyB;IACzB,c5J8KQ,EAAA;;A4JzKpB;EACI,kBAAkB;EAClB,gBAAgB,EAAA;EAFpB;IAIQ,aAAa;IACb,iBAAiB,EAAA;EALzB;IAQQ,kBAAkB;IAClB,gBAAgB;IAChB,UAAU,EAAA;IAVlB;MAYY,kBAAkB;MAClB,QAAQ;MACR,OAAO;MACP,MAAM;MACN,SAAS;MACT,uC5JgIM;M4J/HN,UAAU;MACV,yBAAyB,EAAA;IAnBrC;MAuBY,QAAQ;MACR,kBAAkB;MAClB,SAAS;MACT,gCAAgC,EAAA;MA1B5C;QA6BgB,UAAU;QACV,aAAa;QACb,qBAAqB,EAAA;EA/BrC;IAwCoB,UAAU;IACV,SAAS,EAAA;EAzC7B;IA8CgB,UAAU,EAAA;EA9C1B;IAmDQ,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,kBAAkB;IAClB,0C5JgFO;I4J/EP,kCAA0B;YAA1B,0BAA0B;IAC1B,YAAY,EAAA;;AAKpB;EAEI,sBAAsB;EACtB,2BAA2B;EAC3B,wBAAwB,EAAA;EAJ5B;IAMQ,yBAAyB;IACzB,aAAa,EAAA;;AAIrB;EAEQ,aAAa,EAAA;EAFrB;IAKY,cAAc,EAAA;;AC7F1B;EACI,+BAA+B,EAAA;EAE/B;IAHJ;MAIQ,2BAA2B,EAAA,EAiClC;EArCD;IAQQ,gBAAgB,EAAA;IARxB;MAWY,qBAAkC;MAClC,gB7JmHY;M6JlHZ,yBAAyB,EAAA;MAbrC;QAkBgB,c7JwKI,EAAA;I6J1LpB;MAwBgB,kBAAkB;MAClB,kBAAkB,EAAA;MAzBlC;QA4BoB,iBAAiB;QACjB,kBAAkB;QAClB,SAAS;QACT,kCAAkC;QAClC,oCAAqD,EAAA;;AAOzE;EACI,kBAAkB;EAClB,0CAAiE,EAAA;EAEjE;IAJJ;MAKQ,gBAAgB;MAChB,gBAAgB;MAChB,uCAAiE,EAAA,EAqBxE;EAlBG;IAVJ;MAWQ,eAAe;MACf,MAAM;MACN,SAAS;MACT,OAAO;MACP,YAAY;MACZ,eAAe;MACf,aAAa;MACb,6C7J4kBuD;M6J3kBvD,4BAA4B;MAC5B,kBAAkB;MAClB,aAAa,EAAA;MArBrB;QAwBY,mBAAmB;QACnB,eAAe,EAAA,EAClB;;AAIT;EACI,2BAA2B,EAAA;EAC3B;IAFJ;MAGQ,2BAA2B,EAAA,EAElC;;AAED;EACI,0CAAiE,EAAA;;AAGrE;EACI,2BAA2B;EAC3B,gBAAgB,EAAA;EAFpB;IAKY,wBAAwB,EAAA;EALpC;IASY,WAAW,EAAA;EATvB;IAaY,YAAY,EAAA;EAbxB;IAiBY,iDAAiE;IACjE,mBAAmB;IACnB,0CAAiE,EAAA;EAnB7E;IAuBY,mBAAmB;IACnB,0CAAiE,EAAA;EAEzE;IA1BJ;MA2BQ,2BAA2B,EAAA,EAMlC;EAjCD;IA+BQ,YAAY,EAAA;;AAIpB;EACI,2BAA2B,EAAA;EAC3B;IAFJ;MAGQ,aAAa,EAAA,EAMpB;EATD;IAOQ,YAAY,EAAA;;AAIpB;EACI,UAAU;EACV,eAAe;EACf,0CAAiE;EACjE,aAAa,EAAA;;AAGjB;EAEQ,cAAc,EAAA;;AAItB;EACI,aAAa,EAAA;;AAGjB;EAjBA;IAmBQ,eAAe;IACf,MAAM;IACN,SAAS;IACT,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,aAAa;IACb,6C7J4euD;I6J3evD,2BAA2B,EAAA;EArBnC;IA0BY,eAAe,EAAA,EAClB;;AAIT;EACI,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB,EAAA;;ACxKvB;EAGY,2BAA8C;EAC9C,eAAe;EACf,gB9J0HY;E8JzHZ,iCAA+C;EAC/C,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB,EAAA;EAV9B;IAYgB,c9J8KI,EAAA;;A8JxKpB;EACI,2BAA2B;EAC3B,gBAAgB,EAAA;EAFpB;IAIQ,wBAAwB,EAAA;EAJhC;IAQQ,UAAU,EAAA;EARlB;IAYQ,YAAY,EAAA;EAZpB;IAgBQ,iDAAiE;IACjE,kBAAkB,EAAA;EAjB1B;IAqBQ,kBAAkB,EAAA;;AAI1B;EAKoB,6BAA6B,EAAA;;AAOjD;EACI,YAAY,EAAA;;AAGhB;EACI,aAAa,EAAA;;AC5DjB;EACI,0DAA2C;EAC3C,sBAAsB;EACtB,2BAA2B,EAAA;;AAG/B;EAEQ,aAAa,EAAA;;AAOT;EAHZ;IAIgB,UAAU,EAAA,EAEjB;;ACtBT;EACI,UAAU,EAAA;;AAId;EAIgB,cAAc;EACd,aAAa,EAAA;;AAKzB;EAVJ;IAWQ,0CAAiE;IACjE,eAAe,EAAA,EAEtB;;AAGD;EACI,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB,EAAA;;AAGtB;EACI,0CAAiE;EACjE,sBhKgmBgC;EgK/lBhC,gBAAgB,EAAA;EAHpB;IAMQ,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,6BAA6B,EAAA;EATrC;IAaQ,gBAAgB,EAAA;EAbxB;IAiBQ,8ChK6kBiE,EAAA;EgK1kBrE;IApBJ;MAqBQ,6BAA6B,EAAA;MArBrC;QAwBY,sBhKsGG;QgKrGH,sBhKykBwB,EAAA;MgKlmBpC;QA6BY,SAAS,EAAA;MA7BrB;QAiCY,sBhKikBwB,EAAA,EgKhkB3B;;AAIT;EACI,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,YAAY;EACZ,cAAc,EAAA;EALlB;IAQQ,wChKgjBiE;IgK/iBjE,aAAa;IACb,YAAY;IACZ,cAAc;IACd,kBAAkB,EAAA;EAZ1B;IAgBQ,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,wChKqiBiE;IgKpiBjE,aAAa;IACb,YAAY;IACZ,cAAc;IACd,kBAAkB,EAAA;EAvB1B;IA2BQ,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,wChK0hBiE;IgKzhBjE,aAAa;IACb,YAAY;IACZ,cAAc;IACd,kBAAkB,EAAA;EAlC1B;IAsCQ,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,wChK+gBiE;IgK9gBjE,aAAa;IACb,YAAY;IACZ,cAAc;IACd,kBAAkB,EAAA;EAGtB;IAhDJ;MAiDQ,aAAa,EAAA,EAEpB;;AAED;EAEQ,kBAAkB;EAClB,UAAU,EAAA;;AAKlB;;;EAGI,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,yBAAyB,EAAA;EAN7B;;;IASQ,2BAA2B,EAAA;;AAInC;EACI,YAAY;EACZ,SAAS,EAAA;EAET;IAJJ;MAKQ,OAAO,EAAA,EAEd;;AAED;EACI,YAAY;EACZ,aAAa,EAAA;EAEb;IAJJ;MAKQ,QAAQ,EAAA,EAEf;;AAED;EACI,YAAY;EACZ,aAAa,EAAA;EAEb;IAJJ;MAKQ,QAAQ;MACR,SAAS,EAAA,EAEhB;;AAED;EACI,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,iKAA8I;EAC9I,UAAU;EACV,aAAa,EAAA;EATjB;IAYQ,kBAAkB;IAClB,UAAU,EAAA;;AAIlB;EACI,kBAAkB,EAAA;EADtB;IAIQ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,yBhKHY;IgKIZ,UAAU;IACV,sBhKyb4B,EAAA;IgKvb5B;MAdR;QAeY,WAAW;QACX,SAAS,EAAA,EAEhB;;AAIL;EACI,kBAAkB;EAClB,aAAa;EACb,YAAY,EAAA;;AClNhB;;;;;;C5Kmr1DC;A4K3q1DD;EAEI,sBAAsB;EAAE,aAAA;EACxB,oCAAyD,EAAA;EAH7D;IAKM,oCAAyD,EAAA;;AAL/D;EASI,oCAAqD;EACrD,oCAAyD;EACzD,gBAAgB,EAAA;EAXpB;IAaM,+CAAoE,EAAA;;AAb1E;EAiBI,oCAAqD,EAAA;EAjBzD;IAmBM,eAAe;IACf,oCAAqD,EAAA;IApB3D;MAsBQ,oCAAqD,EAAA;EAtB7D;IA0BM,eAAe;IACf,oCAAqD,EAAA;;AA3B3D;EA+BI,iCAAwD,EAAA;;AA/B5D;EAkCI,8BjK4FyD,EAAA;;AiK9H7D;EAqCI,8BjKyFyD,EAAA;;AiK9H7D;;EAyCI,8BjKqFyD,EAAA;;AiK9H7D;EA6CI,2BAA2B,EAAA;;ApB+F/B;;EoBzFE,SAAS,EAAA;;AAGX;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC,EAAA;;AAGxC;EACE,WAAW;EACX,UAAU,EAAA;;AAGZ;EACE;IACE,OAAO,EAAA;EAGT;IACE,WAAW,EAAA,EAAA;;AAMf;;;;EAIE,wCAAsC;EACtC,sCAA8B,EAAA;;AAGhC;EACE,sDAA6E;EAC7E,qDAA4E,EAAA;;AAG9E;EACE,sDAA6E;EAC7E,qDAA4E,EAAA;;AAG9E;EACE,qDAA4E;EAC5E,sDAAmD,EAAA;;AAGrD;EACE,sDAAmD,EAAA;;A5K9GrD;EACE,gCAAgC;EAChC,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iCACU,EAAA;;AAYZ;EAEI,kDAAkD,EAAA;;AAItD;EAEI,aAAa;EACb,SAAS,EAAA;;A4HtBb;E5H2BE,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;EACvB,oBAAoB,EAAA;;AAGtB;;EAEE,sBAAsB,EAAA;;A4H1CxB;E5H8CE,8BAA8B;EAC9B,8CAA8C;EAE9C,2BAA2B,EAAA;;A4H2B7B;E5HvBE,8BAA8B;EAC9B,6BAA6B;EAC7B,oCAAoC;EACpC,4CAA4C;EAC5C,wCAAwC;EACxC,2BAA2B;EAC3B,sBAAsB,EAAA;;A2H/DxB;E3HmEE,kBAAkB,EAAA;;AAIpB;;EAEE,uBAAuB;EACvB,0BAA0B;EAC1B,iBAAiB,EAAA;;A+IuCnB;E/InCE,uBAAuB,EAAA;;AmBRrB;E4HiNJ;I/IpMI,yBAAyB;IACzB,kBAAkB,EAAA;IAFpB;;;MAOI,WAAW;MACX,cAAc;MACd,WAAW;MACX,cAAc,EAAA;E+IxFpB;I/IgGU,WAAW,EAAA;EAMnB;IACE,aAAa,EAAA,EACd;;AqJ9GH;ErJkHE,wBAAwB,EAAA;;AAG1B;EACE,aAAa,EAAA;;AqItGf;ErI0GE,aAAa,EAAA;;AAGf;EACE,oCAAoC,EAAA;;AAUpC;EAEI,8BAA6B,EAAA;;AAFjC;EAEI,8BAA6B,EAAA;;AAFjC;EAEI,8BAA6B,EAAA;;AAFjC;EAEI,8BAA6B,EAAA;;AAFjC;EAEI,8BAA6B,EAAA;;AAFjC;EAEI,8BAA6B,EAAA;;AAFjC;EAEI,8BAA6B,EAAA;;AAFjC;EAEI,8BAA6B,EAAA;;AAMnC;EAEI,eAAe;EACf,YAAY;EACZ,cWQc,EAAA;;AXJlB;EACE,wBAAwB,EAAA;;AAmu1D1B;EA9t1DI,wBAAwB,EAAA;;AAM5B;EAEI,6BAA6B,EAAA;;AAIjC;EACE,WAAW;EACX,SAAS;EACT,aAAa,EAAA;;AAKf;EACE,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B,EAAA;;AAG7B;EAEI,gBAAgB,EAAA;;AAFpB;EAMI,QAAQ,EAAA;;AANZ;EAUI,cW5Cc,EAAA;;AXkDlB;;EAEE,oCW2vByE;EX1vBzE,mDAAgD;EAChD,sCAA8B,EAAA;;AAGhC;EACE,sCAAoD;EACpD,4CAA0D;EAC1D,sCAAyD,EAAA;;AAG3D;;EAII,wDAA+C;EAC/C,mDAAgD,EAAA;;AAIpD;EACE,+CAAgE;EAChE,+CAAoE,EAAA;;AAGtE;EACE,+CAAgE;EAChE,+CAAoE,EAAA;;AAGtE;;;;;;;;;;GA+s1DG;AAns1DH;;;;;EAys1DE;AAls1DA;EADF;IAEI,0BAA0B;IAC1B,yBAAyB;IACzB,iDAAA,EAAkD,EAErD;;A2CrJD;E3CuJE,wCAAwC,EAAA;;AAG1C;EAAyB,uBAAqB,EAAA","sourcesContent":["@import \"../scss/icons.scss\";\n@import \"../scss/config/default/bootstrap.scss\";\n@import \"../scss/config/default/app.scss\";\n@import \"../scss/config/default/custom.scss\";\n@import\"./shepherd.css\";\n@import \"./mermaid.min.css\";\n\n@import url(\"https://fonts.googleapis.com/css2?family=Dancing+Script:wght@400..700&family=Inter:wght@100..900&display=swap\");\n\n\n* {\n  font-family: \"Inter\", sans-serif;\n  font-optical-sizing: auto;\n  font-weight: 500;\n  font-style: normal;\n  font-variation-settings:\n    \"slnt\" 0;\n\n}\n\n//RTL \n// @import \"../scss/rtl/components-rtl\";\n// @import \"../scss/rtl/layouts-rtl\";\n// @import \"../scss/rtl/plugins-rtl\";\n// @import \"../scss/rtl/pages-rtl\";\n\n\n//Rigthsidebar offcanvas\n.offcanvas-header-dark {\n  .btn-close {\n    filter: invert(1) grayscale(100%) brightness(200%);\n  }\n}\n\nbody {\n  * {\n    outline: none;\n    margin: 0;\n  }\n}\n\n.noUi-horizontal .noUi-handle {\n  height: 16px !important;\n  width: 16px !important;\n  border-radius: 50% !important;\n  right: -10px !important;\n  top: -7px !important;\n}\n\n.noUi-connect,\n.noUi-horizontal {\n  height: 2px !important;\n}\n\n.noUi-handle {\n  background: #0ab39c !important;\n  border: 2px solid var(--vz-card-bg) !important;\n  -webkit-box-shadow: none !important;\n  box-shadow: none !important;\n}\n\n.noUi-target {\n  background: #fafafa !important;\n  border-radius: 4px !important;\n  border: 1px solid #d3d3d3 !important;\n  background-color: var(--vz-light) !important;\n  border-color: var(--vz-light) !important;\n  box-shadow: none !important;\n  height: 4px !important;\n}\n\n.dropzone .dz-message {\n  text-align: center;\n}\n\n// //Calendar\n.fc-direction-ltr .fc-daygrid-event.fc-event-end,\n.fc-direction-rtl .fc-daygrid-event.fc-event-start {\n  padding: 5px !important;\n  font-size: 12px !important;\n  margin-right: 2px;\n}\n\n.fc-event {\n  border: none !important;\n}\n\n@include media-breakpoint-down(sm) {\n  .fc-toolbar {\n    display: block !important;\n    text-align: center;\n\n    .fc-left,\n    .fc-right,\n    .fc-center {\n      float: none;\n      display: block;\n      clear: both;\n      margin: 10px 0;\n    }\n  }\n\n  .fc {\n    .fc-toolbar {\n      >* {\n        >* {\n          float: none;\n        }\n      }\n    }\n  }\n\n  .fc-today-button {\n    display: none;\n  }\n}\n\n.flatpickr-calendar.open {\n  z-index: 1090 !important;\n}\n\n.upcoming-scheduled .flatpickr-input[readonly] {\n  display: none;\n}\n\n.ql-container.ql-snow {\n  height: 250px;\n}\n\n.rangeslider-horizontal .rangeslider__fill {\n  background-color: #405189 !important;\n}\n\n// .Toastify__toast {\n//   min-height: 43px !important;\n//   max-height: 43px !important;\n// }\n\n@each $color,\n$value in $theme-colors {\n  .simplebar-track-#{$color} {\n    .simplebar-scrollbar:before {\n      background: $value !important;\n    }\n  }\n}\n\n// chat\n.chat-conversation .chat-list .message-box-drop {\n  .nav-btn {\n    font-size: 18px;\n    padding: 4px;\n    color: $gray-600;\n  }\n}\n\n.chatwidgets {\n  height: 250px !important;\n}\n\n[data-layout=\"horizontal\"] .chat-conversation {\n  &.chatwidgets {\n    height: 250px !important;\n  }\n}\n\n// authentication\n\n#tsparticles {\n  canvas {\n    position: absolute !important;\n  }\n}\n\n.alert-msg-show {\n  right: 24px;\n  top: 40px;\n  z-index: 1005;\n}\n\n// Emoji Picker\n\n.pickerEmoji {\n  position: absolute;\n  bottom: -50px;\n  left: 10%;\n  transform: translateX(-50%);\n}\n\n.Toastify {\n  .Toastify__toast {\n    min-height: 43px;\n  }\n\n  .Toastify__close-button {\n    top: 6px;\n  }\n\n  .Toastify__close-button--light {\n    color: $light;\n  }\n}\n\n// Tranfer List\n\n.rdl-filter,\n.rdl-control {\n  background-color: $input-bg;\n  border: 1px solid $input-border-color !important;\n  color: $input-color !important;\n}\n\n.rdl-move {\n  background: var(--#{$prefix}light) !important;\n  border: 1px solid var(--#{$prefix}light) !important;\n  color: var(--#{$prefix}body-color) !important;\n}\n\n.react-dual-listbox {\n\n  input:disabled,\n  select:disabled {\n    background-color: $input-disabled-bg !important;\n    border: 1px solid $input-border-color !important;\n  }\n}\n\n.css-26l3qy-menu {\n  background-color: var(--#{$prefix}gray-200) !important;\n  border-color: var(--#{$prefix}border-color) !important;\n}\n\n.css-1n7v3ny-option {\n  background-color: var(--#{$prefix}gray-300) !important;\n  border-color: var(--#{$prefix}border-color) !important;\n}\n\n/* \n.ant-picker-dropdown .ant-picker-panel-container .ant-picker-panels {\n  display: inline-flex;\n  animation: none;\n  flex-wrap: nowrap;\n  direction: ltr;\n\n  @media (max-width: 768px) {\n    display: inline-grid;\n  }\n} */\n\n/* .ant-picker-dropdown {\n  @media (max-width: 768px) {\n    inset: 51.9333px auto auto 0px !important;\n  }\n}\n */\n.ant-picker-dropdown .ant-picker-panel-container {\n  @media (max-width: 768px) {\n    max-width: 90vw !important;\n    overflow: auto !important;\n    /*   inset: 51.9333px auto auto 0px !important; */\n  }\n}\n.card-footer{\n  background-color: transparent !important;\n}\n\n.gm-style iframe + div { border:none!important; }","/*\nTemplate Name: Velzon - Admin & Dashboard Template\nAuthor: Themesbrand\nVersion: 2.4.0\nWebsite: https://Themesbrand.com/\nContact: Themesbrand@gmail.com\nFile: Icons Css File\n*/\n\n// Icons Scss\n@import \"plugins/icons/materialdesignicons\";\n@import \"plugins/icons/boxicons\";\n@import \"plugins/icons/line-awesome\";\n@import \"plugins/icons/remixicon\";","/* MaterialDesignIcons.com */\n@font-face {\n  font-family: \"Material Design Icons\";\n  src: url(\"../../../fonts/materialdesignicons-webfont.eot?v=6.5.95\");\n  src: url(\"../../../fonts/materialdesignicons-webfont.eot?#iefix&v=6.5.95\") format(\"embedded-opentype\"), url(\"../../../fonts/materialdesignicons-webfont.woff2?v=6.5.95\") format(\"woff2\"), url(\"../../../fonts/materialdesignicons-webfont.woff?v=6.5.95\") format(\"woff\"), url(\"../../../fonts/materialdesignicons-webfont.ttf?v=6.5.95\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n.mdi:before,\n.mdi-set {\n  display: inline-block;\n  font: normal normal normal 24px/1 \"Material Design Icons\";\n  font-size: inherit;\n  text-rendering: auto;\n  line-height: inherit;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.mdi-ab-testing::before {\n  content: \"\\F01C9\";\n}\n\n.mdi-abacus::before {\n  content: \"\\F16E0\";\n}\n\n.mdi-abjad-arabic::before {\n  content: \"\\F1328\";\n}\n\n.mdi-abjad-hebrew::before {\n  content: \"\\F1329\";\n}\n\n.mdi-abugida-devanagari::before {\n  content: \"\\F132A\";\n}\n\n.mdi-abugida-thai::before {\n  content: \"\\F132B\";\n}\n\n.mdi-access-point::before {\n  content: \"\\F0003\";\n}\n\n.mdi-access-point-check::before {\n  content: \"\\F1538\";\n}\n\n.mdi-access-point-minus::before {\n  content: \"\\F1539\";\n}\n\n.mdi-access-point-network::before {\n  content: \"\\F0002\";\n}\n\n.mdi-access-point-network-off::before {\n  content: \"\\F0BE1\";\n}\n\n.mdi-access-point-off::before {\n  content: \"\\F1511\";\n}\n\n.mdi-access-point-plus::before {\n  content: \"\\F153A\";\n}\n\n.mdi-access-point-remove::before {\n  content: \"\\F153B\";\n}\n\n.mdi-account::before {\n  content: \"\\F0004\";\n}\n\n.mdi-account-alert::before {\n  content: \"\\F0005\";\n}\n\n.mdi-account-alert-outline::before {\n  content: \"\\F0B50\";\n}\n\n.mdi-account-arrow-down::before {\n  content: \"\\F1868\";\n}\n\n.mdi-account-arrow-down-outline::before {\n  content: \"\\F1869\";\n}\n\n.mdi-account-arrow-left::before {\n  content: \"\\F0B51\";\n}\n\n.mdi-account-arrow-left-outline::before {\n  content: \"\\F0B52\";\n}\n\n.mdi-account-arrow-right::before {\n  content: \"\\F0B53\";\n}\n\n.mdi-account-arrow-right-outline::before {\n  content: \"\\F0B54\";\n}\n\n.mdi-account-arrow-up::before {\n  content: \"\\F1867\";\n}\n\n.mdi-account-arrow-up-outline::before {\n  content: \"\\F186A\";\n}\n\n.mdi-account-box::before {\n  content: \"\\F0006\";\n}\n\n.mdi-account-box-multiple::before {\n  content: \"\\F0934\";\n}\n\n.mdi-account-box-multiple-outline::before {\n  content: \"\\F100A\";\n}\n\n.mdi-account-box-outline::before {\n  content: \"\\F0007\";\n}\n\n.mdi-account-cancel::before {\n  content: \"\\F12DF\";\n}\n\n.mdi-account-cancel-outline::before {\n  content: \"\\F12E0\";\n}\n\n.mdi-account-cash::before {\n  content: \"\\F1097\";\n}\n\n.mdi-account-cash-outline::before {\n  content: \"\\F1098\";\n}\n\n.mdi-account-check::before {\n  content: \"\\F0008\";\n}\n\n.mdi-account-check-outline::before {\n  content: \"\\F0BE2\";\n}\n\n.mdi-account-child::before {\n  content: \"\\F0A89\";\n}\n\n.mdi-account-child-circle::before {\n  content: \"\\F0A8A\";\n}\n\n.mdi-account-child-outline::before {\n  content: \"\\F10C8\";\n}\n\n.mdi-account-circle::before {\n  content: \"\\F0009\";\n}\n\n.mdi-account-circle-outline::before {\n  content: \"\\F0B55\";\n}\n\n.mdi-account-clock::before {\n  content: \"\\F0B56\";\n}\n\n.mdi-account-clock-outline::before {\n  content: \"\\F0B57\";\n}\n\n.mdi-account-cog::before {\n  content: \"\\F1370\";\n}\n\n.mdi-account-cog-outline::before {\n  content: \"\\F1371\";\n}\n\n.mdi-account-convert::before {\n  content: \"\\F000A\";\n}\n\n.mdi-account-convert-outline::before {\n  content: \"\\F1301\";\n}\n\n.mdi-account-cowboy-hat::before {\n  content: \"\\F0E9B\";\n}\n\n.mdi-account-cowboy-hat-outline::before {\n  content: \"\\F17F3\";\n}\n\n.mdi-account-details::before {\n  content: \"\\F0631\";\n}\n\n.mdi-account-details-outline::before {\n  content: \"\\F1372\";\n}\n\n.mdi-account-edit::before {\n  content: \"\\F06BC\";\n}\n\n.mdi-account-edit-outline::before {\n  content: \"\\F0FFB\";\n}\n\n.mdi-account-eye::before {\n  content: \"\\F0420\";\n}\n\n.mdi-account-eye-outline::before {\n  content: \"\\F127B\";\n}\n\n.mdi-account-filter::before {\n  content: \"\\F0936\";\n}\n\n.mdi-account-filter-outline::before {\n  content: \"\\F0F9D\";\n}\n\n.mdi-account-group::before {\n  content: \"\\F0849\";\n}\n\n.mdi-account-group-outline::before {\n  content: \"\\F0B58\";\n}\n\n.mdi-account-hard-hat::before {\n  content: \"\\F05B5\";\n}\n\n.mdi-account-heart::before {\n  content: \"\\F0899\";\n}\n\n.mdi-account-heart-outline::before {\n  content: \"\\F0BE3\";\n}\n\n.mdi-account-injury::before {\n  content: \"\\F1815\";\n}\n\n.mdi-account-injury-outline::before {\n  content: \"\\F1816\";\n}\n\n.mdi-account-key::before {\n  content: \"\\F000B\";\n}\n\n.mdi-account-key-outline::before {\n  content: \"\\F0BE4\";\n}\n\n.mdi-account-lock::before {\n  content: \"\\F115E\";\n}\n\n.mdi-account-lock-open::before {\n  content: \"\\F1960\";\n}\n\n.mdi-account-lock-open-outline::before {\n  content: \"\\F1961\";\n}\n\n.mdi-account-lock-outline::before {\n  content: \"\\F115F\";\n}\n\n.mdi-account-minus::before {\n  content: \"\\F000D\";\n}\n\n.mdi-account-minus-outline::before {\n  content: \"\\F0AEC\";\n}\n\n.mdi-account-multiple::before {\n  content: \"\\F000E\";\n}\n\n.mdi-account-multiple-check::before {\n  content: \"\\F08C5\";\n}\n\n.mdi-account-multiple-check-outline::before {\n  content: \"\\F11FE\";\n}\n\n.mdi-account-multiple-minus::before {\n  content: \"\\F05D3\";\n}\n\n.mdi-account-multiple-minus-outline::before {\n  content: \"\\F0BE5\";\n}\n\n.mdi-account-multiple-outline::before {\n  content: \"\\F000F\";\n}\n\n.mdi-account-multiple-plus::before {\n  content: \"\\F0010\";\n}\n\n.mdi-account-multiple-plus-outline::before {\n  content: \"\\F0800\";\n}\n\n.mdi-account-multiple-remove::before {\n  content: \"\\F120A\";\n}\n\n.mdi-account-multiple-remove-outline::before {\n  content: \"\\F120B\";\n}\n\n.mdi-account-music::before {\n  content: \"\\F0803\";\n}\n\n.mdi-account-music-outline::before {\n  content: \"\\F0CE9\";\n}\n\n.mdi-account-network::before {\n  content: \"\\F0011\";\n}\n\n.mdi-account-network-outline::before {\n  content: \"\\F0BE6\";\n}\n\n.mdi-account-off::before {\n  content: \"\\F0012\";\n}\n\n.mdi-account-off-outline::before {\n  content: \"\\F0BE7\";\n}\n\n.mdi-account-outline::before {\n  content: \"\\F0013\";\n}\n\n.mdi-account-plus::before {\n  content: \"\\F0014\";\n}\n\n.mdi-account-plus-outline::before {\n  content: \"\\F0801\";\n}\n\n.mdi-account-question::before {\n  content: \"\\F0B59\";\n}\n\n.mdi-account-question-outline::before {\n  content: \"\\F0B5A\";\n}\n\n.mdi-account-reactivate::before {\n  content: \"\\F152B\";\n}\n\n.mdi-account-reactivate-outline::before {\n  content: \"\\F152C\";\n}\n\n.mdi-account-remove::before {\n  content: \"\\F0015\";\n}\n\n.mdi-account-remove-outline::before {\n  content: \"\\F0AED\";\n}\n\n.mdi-account-search::before {\n  content: \"\\F0016\";\n}\n\n.mdi-account-search-outline::before {\n  content: \"\\F0935\";\n}\n\n.mdi-account-settings::before {\n  content: \"\\F0630\";\n}\n\n.mdi-account-settings-outline::before {\n  content: \"\\F10C9\";\n}\n\n.mdi-account-star::before {\n  content: \"\\F0017\";\n}\n\n.mdi-account-star-outline::before {\n  content: \"\\F0BE8\";\n}\n\n.mdi-account-supervisor::before {\n  content: \"\\F0A8B\";\n}\n\n.mdi-account-supervisor-circle::before {\n  content: \"\\F0A8C\";\n}\n\n.mdi-account-supervisor-circle-outline::before {\n  content: \"\\F14EC\";\n}\n\n.mdi-account-supervisor-outline::before {\n  content: \"\\F112D\";\n}\n\n.mdi-account-switch::before {\n  content: \"\\F0019\";\n}\n\n.mdi-account-switch-outline::before {\n  content: \"\\F04CB\";\n}\n\n.mdi-account-sync::before {\n  content: \"\\F191B\";\n}\n\n.mdi-account-sync-outline::before {\n  content: \"\\F191C\";\n}\n\n.mdi-account-tie::before {\n  content: \"\\F0CE3\";\n}\n\n.mdi-account-tie-hat::before {\n  content: \"\\F1898\";\n}\n\n.mdi-account-tie-hat-outline::before {\n  content: \"\\F1899\";\n}\n\n.mdi-account-tie-outline::before {\n  content: \"\\F10CA\";\n}\n\n.mdi-account-tie-voice::before {\n  content: \"\\F1308\";\n}\n\n.mdi-account-tie-voice-off::before {\n  content: \"\\F130A\";\n}\n\n.mdi-account-tie-voice-off-outline::before {\n  content: \"\\F130B\";\n}\n\n.mdi-account-tie-voice-outline::before {\n  content: \"\\F1309\";\n}\n\n.mdi-account-voice::before {\n  content: \"\\F05CB\";\n}\n\n.mdi-account-voice-off::before {\n  content: \"\\F0ED4\";\n}\n\n.mdi-account-wrench::before {\n  content: \"\\F189A\";\n}\n\n.mdi-account-wrench-outline::before {\n  content: \"\\F189B\";\n}\n\n.mdi-adjust::before {\n  content: \"\\F001A\";\n}\n\n.mdi-advertisements::before {\n  content: \"\\F192A\";\n}\n\n.mdi-advertisements-off::before {\n  content: \"\\F192B\";\n}\n\n.mdi-air-conditioner::before {\n  content: \"\\F001B\";\n}\n\n.mdi-air-filter::before {\n  content: \"\\F0D43\";\n}\n\n.mdi-air-horn::before {\n  content: \"\\F0DAC\";\n}\n\n.mdi-air-humidifier::before {\n  content: \"\\F1099\";\n}\n\n.mdi-air-humidifier-off::before {\n  content: \"\\F1466\";\n}\n\n.mdi-air-purifier::before {\n  content: \"\\F0D44\";\n}\n\n.mdi-airbag::before {\n  content: \"\\F0BE9\";\n}\n\n.mdi-airballoon::before {\n  content: \"\\F001C\";\n}\n\n.mdi-airballoon-outline::before {\n  content: \"\\F100B\";\n}\n\n.mdi-airplane::before {\n  content: \"\\F001D\";\n}\n\n.mdi-airplane-alert::before {\n  content: \"\\F187A\";\n}\n\n.mdi-airplane-check::before {\n  content: \"\\F187B\";\n}\n\n.mdi-airplane-clock::before {\n  content: \"\\F187C\";\n}\n\n.mdi-airplane-cog::before {\n  content: \"\\F187D\";\n}\n\n.mdi-airplane-edit::before {\n  content: \"\\F187E\";\n}\n\n.mdi-airplane-landing::before {\n  content: \"\\F05D4\";\n}\n\n.mdi-airplane-marker::before {\n  content: \"\\F187F\";\n}\n\n.mdi-airplane-minus::before {\n  content: \"\\F1880\";\n}\n\n.mdi-airplane-off::before {\n  content: \"\\F001E\";\n}\n\n.mdi-airplane-plus::before {\n  content: \"\\F1881\";\n}\n\n.mdi-airplane-remove::before {\n  content: \"\\F1882\";\n}\n\n.mdi-airplane-search::before {\n  content: \"\\F1883\";\n}\n\n.mdi-airplane-settings::before {\n  content: \"\\F1884\";\n}\n\n.mdi-airplane-takeoff::before {\n  content: \"\\F05D5\";\n}\n\n.mdi-airport::before {\n  content: \"\\F084B\";\n}\n\n.mdi-alarm::before {\n  content: \"\\F0020\";\n}\n\n.mdi-alarm-bell::before {\n  content: \"\\F078E\";\n}\n\n.mdi-alarm-check::before {\n  content: \"\\F0021\";\n}\n\n.mdi-alarm-light::before {\n  content: \"\\F078F\";\n}\n\n.mdi-alarm-light-off::before {\n  content: \"\\F171E\";\n}\n\n.mdi-alarm-light-off-outline::before {\n  content: \"\\F171F\";\n}\n\n.mdi-alarm-light-outline::before {\n  content: \"\\F0BEA\";\n}\n\n.mdi-alarm-multiple::before {\n  content: \"\\F0022\";\n}\n\n.mdi-alarm-note::before {\n  content: \"\\F0E71\";\n}\n\n.mdi-alarm-note-off::before {\n  content: \"\\F0E72\";\n}\n\n.mdi-alarm-off::before {\n  content: \"\\F0023\";\n}\n\n.mdi-alarm-panel::before {\n  content: \"\\F15C4\";\n}\n\n.mdi-alarm-panel-outline::before {\n  content: \"\\F15C5\";\n}\n\n.mdi-alarm-plus::before {\n  content: \"\\F0024\";\n}\n\n.mdi-alarm-snooze::before {\n  content: \"\\F068E\";\n}\n\n.mdi-album::before {\n  content: \"\\F0025\";\n}\n\n.mdi-alert::before {\n  content: \"\\F0026\";\n}\n\n.mdi-alert-box::before {\n  content: \"\\F0027\";\n}\n\n.mdi-alert-box-outline::before {\n  content: \"\\F0CE4\";\n}\n\n.mdi-alert-circle::before {\n  content: \"\\F0028\";\n}\n\n.mdi-alert-circle-check::before {\n  content: \"\\F11ED\";\n}\n\n.mdi-alert-circle-check-outline::before {\n  content: \"\\F11EE\";\n}\n\n.mdi-alert-circle-outline::before {\n  content: \"\\F05D6\";\n}\n\n.mdi-alert-decagram::before {\n  content: \"\\F06BD\";\n}\n\n.mdi-alert-decagram-outline::before {\n  content: \"\\F0CE5\";\n}\n\n.mdi-alert-minus::before {\n  content: \"\\F14BB\";\n}\n\n.mdi-alert-minus-outline::before {\n  content: \"\\F14BE\";\n}\n\n.mdi-alert-octagon::before {\n  content: \"\\F0029\";\n}\n\n.mdi-alert-octagon-outline::before {\n  content: \"\\F0CE6\";\n}\n\n.mdi-alert-octagram::before {\n  content: \"\\F0767\";\n}\n\n.mdi-alert-octagram-outline::before {\n  content: \"\\F0CE7\";\n}\n\n.mdi-alert-outline::before {\n  content: \"\\F002A\";\n}\n\n.mdi-alert-plus::before {\n  content: \"\\F14BA\";\n}\n\n.mdi-alert-plus-outline::before {\n  content: \"\\F14BD\";\n}\n\n.mdi-alert-remove::before {\n  content: \"\\F14BC\";\n}\n\n.mdi-alert-remove-outline::before {\n  content: \"\\F14BF\";\n}\n\n.mdi-alert-rhombus::before {\n  content: \"\\F11CE\";\n}\n\n.mdi-alert-rhombus-outline::before {\n  content: \"\\F11CF\";\n}\n\n.mdi-alien::before {\n  content: \"\\F089A\";\n}\n\n.mdi-alien-outline::before {\n  content: \"\\F10CB\";\n}\n\n.mdi-align-horizontal-center::before {\n  content: \"\\F11C3\";\n}\n\n.mdi-align-horizontal-distribute::before {\n  content: \"\\F1962\";\n}\n\n.mdi-align-horizontal-left::before {\n  content: \"\\F11C2\";\n}\n\n.mdi-align-horizontal-right::before {\n  content: \"\\F11C4\";\n}\n\n.mdi-align-vertical-bottom::before {\n  content: \"\\F11C5\";\n}\n\n.mdi-align-vertical-center::before {\n  content: \"\\F11C6\";\n}\n\n.mdi-align-vertical-distribute::before {\n  content: \"\\F1963\";\n}\n\n.mdi-align-vertical-top::before {\n  content: \"\\F11C7\";\n}\n\n.mdi-all-inclusive::before {\n  content: \"\\F06BE\";\n}\n\n.mdi-all-inclusive-box::before {\n  content: \"\\F188D\";\n}\n\n.mdi-all-inclusive-box-outline::before {\n  content: \"\\F188E\";\n}\n\n.mdi-allergy::before {\n  content: \"\\F1258\";\n}\n\n.mdi-alpha::before {\n  content: \"\\F002B\";\n}\n\n.mdi-alpha-a::before {\n  content: \"\\F0AEE\";\n}\n\n.mdi-alpha-a-box::before {\n  content: \"\\F0B08\";\n}\n\n.mdi-alpha-a-box-outline::before {\n  content: \"\\F0BEB\";\n}\n\n.mdi-alpha-a-circle::before {\n  content: \"\\F0BEC\";\n}\n\n.mdi-alpha-a-circle-outline::before {\n  content: \"\\F0BED\";\n}\n\n.mdi-alpha-b::before {\n  content: \"\\F0AEF\";\n}\n\n.mdi-alpha-b-box::before {\n  content: \"\\F0B09\";\n}\n\n.mdi-alpha-b-box-outline::before {\n  content: \"\\F0BEE\";\n}\n\n.mdi-alpha-b-circle::before {\n  content: \"\\F0BEF\";\n}\n\n.mdi-alpha-b-circle-outline::before {\n  content: \"\\F0BF0\";\n}\n\n.mdi-alpha-c::before {\n  content: \"\\F0AF0\";\n}\n\n.mdi-alpha-c-box::before {\n  content: \"\\F0B0A\";\n}\n\n.mdi-alpha-c-box-outline::before {\n  content: \"\\F0BF1\";\n}\n\n.mdi-alpha-c-circle::before {\n  content: \"\\F0BF2\";\n}\n\n.mdi-alpha-c-circle-outline::before {\n  content: \"\\F0BF3\";\n}\n\n.mdi-alpha-d::before {\n  content: \"\\F0AF1\";\n}\n\n.mdi-alpha-d-box::before {\n  content: \"\\F0B0B\";\n}\n\n.mdi-alpha-d-box-outline::before {\n  content: \"\\F0BF4\";\n}\n\n.mdi-alpha-d-circle::before {\n  content: \"\\F0BF5\";\n}\n\n.mdi-alpha-d-circle-outline::before {\n  content: \"\\F0BF6\";\n}\n\n.mdi-alpha-e::before {\n  content: \"\\F0AF2\";\n}\n\n.mdi-alpha-e-box::before {\n  content: \"\\F0B0C\";\n}\n\n.mdi-alpha-e-box-outline::before {\n  content: \"\\F0BF7\";\n}\n\n.mdi-alpha-e-circle::before {\n  content: \"\\F0BF8\";\n}\n\n.mdi-alpha-e-circle-outline::before {\n  content: \"\\F0BF9\";\n}\n\n.mdi-alpha-f::before {\n  content: \"\\F0AF3\";\n}\n\n.mdi-alpha-f-box::before {\n  content: \"\\F0B0D\";\n}\n\n.mdi-alpha-f-box-outline::before {\n  content: \"\\F0BFA\";\n}\n\n.mdi-alpha-f-circle::before {\n  content: \"\\F0BFB\";\n}\n\n.mdi-alpha-f-circle-outline::before {\n  content: \"\\F0BFC\";\n}\n\n.mdi-alpha-g::before {\n  content: \"\\F0AF4\";\n}\n\n.mdi-alpha-g-box::before {\n  content: \"\\F0B0E\";\n}\n\n.mdi-alpha-g-box-outline::before {\n  content: \"\\F0BFD\";\n}\n\n.mdi-alpha-g-circle::before {\n  content: \"\\F0BFE\";\n}\n\n.mdi-alpha-g-circle-outline::before {\n  content: \"\\F0BFF\";\n}\n\n.mdi-alpha-h::before {\n  content: \"\\F0AF5\";\n}\n\n.mdi-alpha-h-box::before {\n  content: \"\\F0B0F\";\n}\n\n.mdi-alpha-h-box-outline::before {\n  content: \"\\F0C00\";\n}\n\n.mdi-alpha-h-circle::before {\n  content: \"\\F0C01\";\n}\n\n.mdi-alpha-h-circle-outline::before {\n  content: \"\\F0C02\";\n}\n\n.mdi-alpha-i::before {\n  content: \"\\F0AF6\";\n}\n\n.mdi-alpha-i-box::before {\n  content: \"\\F0B10\";\n}\n\n.mdi-alpha-i-box-outline::before {\n  content: \"\\F0C03\";\n}\n\n.mdi-alpha-i-circle::before {\n  content: \"\\F0C04\";\n}\n\n.mdi-alpha-i-circle-outline::before {\n  content: \"\\F0C05\";\n}\n\n.mdi-alpha-j::before {\n  content: \"\\F0AF7\";\n}\n\n.mdi-alpha-j-box::before {\n  content: \"\\F0B11\";\n}\n\n.mdi-alpha-j-box-outline::before {\n  content: \"\\F0C06\";\n}\n\n.mdi-alpha-j-circle::before {\n  content: \"\\F0C07\";\n}\n\n.mdi-alpha-j-circle-outline::before {\n  content: \"\\F0C08\";\n}\n\n.mdi-alpha-k::before {\n  content: \"\\F0AF8\";\n}\n\n.mdi-alpha-k-box::before {\n  content: \"\\F0B12\";\n}\n\n.mdi-alpha-k-box-outline::before {\n  content: \"\\F0C09\";\n}\n\n.mdi-alpha-k-circle::before {\n  content: \"\\F0C0A\";\n}\n\n.mdi-alpha-k-circle-outline::before {\n  content: \"\\F0C0B\";\n}\n\n.mdi-alpha-l::before {\n  content: \"\\F0AF9\";\n}\n\n.mdi-alpha-l-box::before {\n  content: \"\\F0B13\";\n}\n\n.mdi-alpha-l-box-outline::before {\n  content: \"\\F0C0C\";\n}\n\n.mdi-alpha-l-circle::before {\n  content: \"\\F0C0D\";\n}\n\n.mdi-alpha-l-circle-outline::before {\n  content: \"\\F0C0E\";\n}\n\n.mdi-alpha-m::before {\n  content: \"\\F0AFA\";\n}\n\n.mdi-alpha-m-box::before {\n  content: \"\\F0B14\";\n}\n\n.mdi-alpha-m-box-outline::before {\n  content: \"\\F0C0F\";\n}\n\n.mdi-alpha-m-circle::before {\n  content: \"\\F0C10\";\n}\n\n.mdi-alpha-m-circle-outline::before {\n  content: \"\\F0C11\";\n}\n\n.mdi-alpha-n::before {\n  content: \"\\F0AFB\";\n}\n\n.mdi-alpha-n-box::before {\n  content: \"\\F0B15\";\n}\n\n.mdi-alpha-n-box-outline::before {\n  content: \"\\F0C12\";\n}\n\n.mdi-alpha-n-circle::before {\n  content: \"\\F0C13\";\n}\n\n.mdi-alpha-n-circle-outline::before {\n  content: \"\\F0C14\";\n}\n\n.mdi-alpha-o::before {\n  content: \"\\F0AFC\";\n}\n\n.mdi-alpha-o-box::before {\n  content: \"\\F0B16\";\n}\n\n.mdi-alpha-o-box-outline::before {\n  content: \"\\F0C15\";\n}\n\n.mdi-alpha-o-circle::before {\n  content: \"\\F0C16\";\n}\n\n.mdi-alpha-o-circle-outline::before {\n  content: \"\\F0C17\";\n}\n\n.mdi-alpha-p::before {\n  content: \"\\F0AFD\";\n}\n\n.mdi-alpha-p-box::before {\n  content: \"\\F0B17\";\n}\n\n.mdi-alpha-p-box-outline::before {\n  content: \"\\F0C18\";\n}\n\n.mdi-alpha-p-circle::before {\n  content: \"\\F0C19\";\n}\n\n.mdi-alpha-p-circle-outline::before {\n  content: \"\\F0C1A\";\n}\n\n.mdi-alpha-q::before {\n  content: \"\\F0AFE\";\n}\n\n.mdi-alpha-q-box::before {\n  content: \"\\F0B18\";\n}\n\n.mdi-alpha-q-box-outline::before {\n  content: \"\\F0C1B\";\n}\n\n.mdi-alpha-q-circle::before {\n  content: \"\\F0C1C\";\n}\n\n.mdi-alpha-q-circle-outline::before {\n  content: \"\\F0C1D\";\n}\n\n.mdi-alpha-r::before {\n  content: \"\\F0AFF\";\n}\n\n.mdi-alpha-r-box::before {\n  content: \"\\F0B19\";\n}\n\n.mdi-alpha-r-box-outline::before {\n  content: \"\\F0C1E\";\n}\n\n.mdi-alpha-r-circle::before {\n  content: \"\\F0C1F\";\n}\n\n.mdi-alpha-r-circle-outline::before {\n  content: \"\\F0C20\";\n}\n\n.mdi-alpha-s::before {\n  content: \"\\F0B00\";\n}\n\n.mdi-alpha-s-box::before {\n  content: \"\\F0B1A\";\n}\n\n.mdi-alpha-s-box-outline::before {\n  content: \"\\F0C21\";\n}\n\n.mdi-alpha-s-circle::before {\n  content: \"\\F0C22\";\n}\n\n.mdi-alpha-s-circle-outline::before {\n  content: \"\\F0C23\";\n}\n\n.mdi-alpha-t::before {\n  content: \"\\F0B01\";\n}\n\n.mdi-alpha-t-box::before {\n  content: \"\\F0B1B\";\n}\n\n.mdi-alpha-t-box-outline::before {\n  content: \"\\F0C24\";\n}\n\n.mdi-alpha-t-circle::before {\n  content: \"\\F0C25\";\n}\n\n.mdi-alpha-t-circle-outline::before {\n  content: \"\\F0C26\";\n}\n\n.mdi-alpha-u::before {\n  content: \"\\F0B02\";\n}\n\n.mdi-alpha-u-box::before {\n  content: \"\\F0B1C\";\n}\n\n.mdi-alpha-u-box-outline::before {\n  content: \"\\F0C27\";\n}\n\n.mdi-alpha-u-circle::before {\n  content: \"\\F0C28\";\n}\n\n.mdi-alpha-u-circle-outline::before {\n  content: \"\\F0C29\";\n}\n\n.mdi-alpha-v::before {\n  content: \"\\F0B03\";\n}\n\n.mdi-alpha-v-box::before {\n  content: \"\\F0B1D\";\n}\n\n.mdi-alpha-v-box-outline::before {\n  content: \"\\F0C2A\";\n}\n\n.mdi-alpha-v-circle::before {\n  content: \"\\F0C2B\";\n}\n\n.mdi-alpha-v-circle-outline::before {\n  content: \"\\F0C2C\";\n}\n\n.mdi-alpha-w::before {\n  content: \"\\F0B04\";\n}\n\n.mdi-alpha-w-box::before {\n  content: \"\\F0B1E\";\n}\n\n.mdi-alpha-w-box-outline::before {\n  content: \"\\F0C2D\";\n}\n\n.mdi-alpha-w-circle::before {\n  content: \"\\F0C2E\";\n}\n\n.mdi-alpha-w-circle-outline::before {\n  content: \"\\F0C2F\";\n}\n\n.mdi-alpha-x::before {\n  content: \"\\F0B05\";\n}\n\n.mdi-alpha-x-box::before {\n  content: \"\\F0B1F\";\n}\n\n.mdi-alpha-x-box-outline::before {\n  content: \"\\F0C30\";\n}\n\n.mdi-alpha-x-circle::before {\n  content: \"\\F0C31\";\n}\n\n.mdi-alpha-x-circle-outline::before {\n  content: \"\\F0C32\";\n}\n\n.mdi-alpha-y::before {\n  content: \"\\F0B06\";\n}\n\n.mdi-alpha-y-box::before {\n  content: \"\\F0B20\";\n}\n\n.mdi-alpha-y-box-outline::before {\n  content: \"\\F0C33\";\n}\n\n.mdi-alpha-y-circle::before {\n  content: \"\\F0C34\";\n}\n\n.mdi-alpha-y-circle-outline::before {\n  content: \"\\F0C35\";\n}\n\n.mdi-alpha-z::before {\n  content: \"\\F0B07\";\n}\n\n.mdi-alpha-z-box::before {\n  content: \"\\F0B21\";\n}\n\n.mdi-alpha-z-box-outline::before {\n  content: \"\\F0C36\";\n}\n\n.mdi-alpha-z-circle::before {\n  content: \"\\F0C37\";\n}\n\n.mdi-alpha-z-circle-outline::before {\n  content: \"\\F0C38\";\n}\n\n.mdi-alphabet-aurebesh::before {\n  content: \"\\F132C\";\n}\n\n.mdi-alphabet-cyrillic::before {\n  content: \"\\F132D\";\n}\n\n.mdi-alphabet-greek::before {\n  content: \"\\F132E\";\n}\n\n.mdi-alphabet-latin::before {\n  content: \"\\F132F\";\n}\n\n.mdi-alphabet-piqad::before {\n  content: \"\\F1330\";\n}\n\n.mdi-alphabet-tengwar::before {\n  content: \"\\F1337\";\n}\n\n.mdi-alphabetical::before {\n  content: \"\\F002C\";\n}\n\n.mdi-alphabetical-off::before {\n  content: \"\\F100C\";\n}\n\n.mdi-alphabetical-variant::before {\n  content: \"\\F100D\";\n}\n\n.mdi-alphabetical-variant-off::before {\n  content: \"\\F100E\";\n}\n\n.mdi-altimeter::before {\n  content: \"\\F05D7\";\n}\n\n.mdi-ambulance::before {\n  content: \"\\F002F\";\n}\n\n.mdi-ammunition::before {\n  content: \"\\F0CE8\";\n}\n\n.mdi-ampersand::before {\n  content: \"\\F0A8D\";\n}\n\n.mdi-amplifier::before {\n  content: \"\\F0030\";\n}\n\n.mdi-amplifier-off::before {\n  content: \"\\F11B5\";\n}\n\n.mdi-anchor::before {\n  content: \"\\F0031\";\n}\n\n.mdi-android::before {\n  content: \"\\F0032\";\n}\n\n.mdi-android-messages::before {\n  content: \"\\F0D45\";\n}\n\n.mdi-android-studio::before {\n  content: \"\\F0034\";\n}\n\n.mdi-angle-acute::before {\n  content: \"\\F0937\";\n}\n\n.mdi-angle-obtuse::before {\n  content: \"\\F0938\";\n}\n\n.mdi-angle-right::before {\n  content: \"\\F0939\";\n}\n\n.mdi-angular::before {\n  content: \"\\F06B2\";\n}\n\n.mdi-angularjs::before {\n  content: \"\\F06BF\";\n}\n\n.mdi-animation::before {\n  content: \"\\F05D8\";\n}\n\n.mdi-animation-outline::before {\n  content: \"\\F0A8F\";\n}\n\n.mdi-animation-play::before {\n  content: \"\\F093A\";\n}\n\n.mdi-animation-play-outline::before {\n  content: \"\\F0A90\";\n}\n\n.mdi-ansible::before {\n  content: \"\\F109A\";\n}\n\n.mdi-antenna::before {\n  content: \"\\F1119\";\n}\n\n.mdi-anvil::before {\n  content: \"\\F089B\";\n}\n\n.mdi-apache-kafka::before {\n  content: \"\\F100F\";\n}\n\n.mdi-api::before {\n  content: \"\\F109B\";\n}\n\n.mdi-api-off::before {\n  content: \"\\F1257\";\n}\n\n.mdi-apple::before {\n  content: \"\\F0035\";\n}\n\n.mdi-apple-finder::before {\n  content: \"\\F0036\";\n}\n\n.mdi-apple-icloud::before {\n  content: \"\\F0038\";\n}\n\n.mdi-apple-ios::before {\n  content: \"\\F0037\";\n}\n\n.mdi-apple-keyboard-caps::before {\n  content: \"\\F0632\";\n}\n\n.mdi-apple-keyboard-command::before {\n  content: \"\\F0633\";\n}\n\n.mdi-apple-keyboard-control::before {\n  content: \"\\F0634\";\n}\n\n.mdi-apple-keyboard-option::before {\n  content: \"\\F0635\";\n}\n\n.mdi-apple-keyboard-shift::before {\n  content: \"\\F0636\";\n}\n\n.mdi-apple-safari::before {\n  content: \"\\F0039\";\n}\n\n.mdi-application::before {\n  content: \"\\F08C6\";\n}\n\n.mdi-application-array::before {\n  content: \"\\F10F5\";\n}\n\n.mdi-application-array-outline::before {\n  content: \"\\F10F6\";\n}\n\n.mdi-application-braces::before {\n  content: \"\\F10F7\";\n}\n\n.mdi-application-braces-outline::before {\n  content: \"\\F10F8\";\n}\n\n.mdi-application-brackets::before {\n  content: \"\\F0C8B\";\n}\n\n.mdi-application-brackets-outline::before {\n  content: \"\\F0C8C\";\n}\n\n.mdi-application-cog::before {\n  content: \"\\F0675\";\n}\n\n.mdi-application-cog-outline::before {\n  content: \"\\F1577\";\n}\n\n.mdi-application-edit::before {\n  content: \"\\F00AE\";\n}\n\n.mdi-application-edit-outline::before {\n  content: \"\\F0619\";\n}\n\n.mdi-application-export::before {\n  content: \"\\F0DAD\";\n}\n\n.mdi-application-import::before {\n  content: \"\\F0DAE\";\n}\n\n.mdi-application-outline::before {\n  content: \"\\F0614\";\n}\n\n.mdi-application-parentheses::before {\n  content: \"\\F10F9\";\n}\n\n.mdi-application-parentheses-outline::before {\n  content: \"\\F10FA\";\n}\n\n.mdi-application-settings::before {\n  content: \"\\F0B60\";\n}\n\n.mdi-application-settings-outline::before {\n  content: \"\\F1555\";\n}\n\n.mdi-application-variable::before {\n  content: \"\\F10FB\";\n}\n\n.mdi-application-variable-outline::before {\n  content: \"\\F10FC\";\n}\n\n.mdi-approximately-equal::before {\n  content: \"\\F0F9E\";\n}\n\n.mdi-approximately-equal-box::before {\n  content: \"\\F0F9F\";\n}\n\n.mdi-apps::before {\n  content: \"\\F003B\";\n}\n\n.mdi-apps-box::before {\n  content: \"\\F0D46\";\n}\n\n.mdi-arch::before {\n  content: \"\\F08C7\";\n}\n\n.mdi-archive::before {\n  content: \"\\F003C\";\n}\n\n.mdi-archive-alert::before {\n  content: \"\\F14FD\";\n}\n\n.mdi-archive-alert-outline::before {\n  content: \"\\F14FE\";\n}\n\n.mdi-archive-arrow-down::before {\n  content: \"\\F1259\";\n}\n\n.mdi-archive-arrow-down-outline::before {\n  content: \"\\F125A\";\n}\n\n.mdi-archive-arrow-up::before {\n  content: \"\\F125B\";\n}\n\n.mdi-archive-arrow-up-outline::before {\n  content: \"\\F125C\";\n}\n\n.mdi-archive-cancel::before {\n  content: \"\\F174B\";\n}\n\n.mdi-archive-cancel-outline::before {\n  content: \"\\F174C\";\n}\n\n.mdi-archive-check::before {\n  content: \"\\F174D\";\n}\n\n.mdi-archive-check-outline::before {\n  content: \"\\F174E\";\n}\n\n.mdi-archive-clock::before {\n  content: \"\\F174F\";\n}\n\n.mdi-archive-clock-outline::before {\n  content: \"\\F1750\";\n}\n\n.mdi-archive-cog::before {\n  content: \"\\F1751\";\n}\n\n.mdi-archive-cog-outline::before {\n  content: \"\\F1752\";\n}\n\n.mdi-archive-edit::before {\n  content: \"\\F1753\";\n}\n\n.mdi-archive-edit-outline::before {\n  content: \"\\F1754\";\n}\n\n.mdi-archive-eye::before {\n  content: \"\\F1755\";\n}\n\n.mdi-archive-eye-outline::before {\n  content: \"\\F1756\";\n}\n\n.mdi-archive-lock::before {\n  content: \"\\F1757\";\n}\n\n.mdi-archive-lock-open::before {\n  content: \"\\F1758\";\n}\n\n.mdi-archive-lock-open-outline::before {\n  content: \"\\F1759\";\n}\n\n.mdi-archive-lock-outline::before {\n  content: \"\\F175A\";\n}\n\n.mdi-archive-marker::before {\n  content: \"\\F175B\";\n}\n\n.mdi-archive-marker-outline::before {\n  content: \"\\F175C\";\n}\n\n.mdi-archive-minus::before {\n  content: \"\\F175D\";\n}\n\n.mdi-archive-minus-outline::before {\n  content: \"\\F175E\";\n}\n\n.mdi-archive-music::before {\n  content: \"\\F175F\";\n}\n\n.mdi-archive-music-outline::before {\n  content: \"\\F1760\";\n}\n\n.mdi-archive-off::before {\n  content: \"\\F1761\";\n}\n\n.mdi-archive-off-outline::before {\n  content: \"\\F1762\";\n}\n\n.mdi-archive-outline::before {\n  content: \"\\F120E\";\n}\n\n.mdi-archive-plus::before {\n  content: \"\\F1763\";\n}\n\n.mdi-archive-plus-outline::before {\n  content: \"\\F1764\";\n}\n\n.mdi-archive-refresh::before {\n  content: \"\\F1765\";\n}\n\n.mdi-archive-refresh-outline::before {\n  content: \"\\F1766\";\n}\n\n.mdi-archive-remove::before {\n  content: \"\\F1767\";\n}\n\n.mdi-archive-remove-outline::before {\n  content: \"\\F1768\";\n}\n\n.mdi-archive-search::before {\n  content: \"\\F1769\";\n}\n\n.mdi-archive-search-outline::before {\n  content: \"\\F176A\";\n}\n\n.mdi-archive-settings::before {\n  content: \"\\F176B\";\n}\n\n.mdi-archive-settings-outline::before {\n  content: \"\\F176C\";\n}\n\n.mdi-archive-star::before {\n  content: \"\\F176D\";\n}\n\n.mdi-archive-star-outline::before {\n  content: \"\\F176E\";\n}\n\n.mdi-archive-sync::before {\n  content: \"\\F176F\";\n}\n\n.mdi-archive-sync-outline::before {\n  content: \"\\F1770\";\n}\n\n.mdi-arm-flex::before {\n  content: \"\\F0FD7\";\n}\n\n.mdi-arm-flex-outline::before {\n  content: \"\\F0FD6\";\n}\n\n.mdi-arrange-bring-forward::before {\n  content: \"\\F003D\";\n}\n\n.mdi-arrange-bring-to-front::before {\n  content: \"\\F003E\";\n}\n\n.mdi-arrange-send-backward::before {\n  content: \"\\F003F\";\n}\n\n.mdi-arrange-send-to-back::before {\n  content: \"\\F0040\";\n}\n\n.mdi-arrow-all::before {\n  content: \"\\F0041\";\n}\n\n.mdi-arrow-bottom-left::before {\n  content: \"\\F0042\";\n}\n\n.mdi-arrow-bottom-left-bold-box::before {\n  content: \"\\F1964\";\n}\n\n.mdi-arrow-bottom-left-bold-box-outline::before {\n  content: \"\\F1965\";\n}\n\n.mdi-arrow-bottom-left-bold-outline::before {\n  content: \"\\F09B7\";\n}\n\n.mdi-arrow-bottom-left-thick::before {\n  content: \"\\F09B8\";\n}\n\n.mdi-arrow-bottom-left-thin::before {\n  content: \"\\F19B6\";\n}\n\n.mdi-arrow-bottom-left-thin-circle-outline::before {\n  content: \"\\F1596\";\n}\n\n.mdi-arrow-bottom-right::before {\n  content: \"\\F0043\";\n}\n\n.mdi-arrow-bottom-right-bold-box::before {\n  content: \"\\F1966\";\n}\n\n.mdi-arrow-bottom-right-bold-box-outline::before {\n  content: \"\\F1967\";\n}\n\n.mdi-arrow-bottom-right-bold-outline::before {\n  content: \"\\F09B9\";\n}\n\n.mdi-arrow-bottom-right-thick::before {\n  content: \"\\F09BA\";\n}\n\n.mdi-arrow-bottom-right-thin::before {\n  content: \"\\F19B7\";\n}\n\n.mdi-arrow-bottom-right-thin-circle-outline::before {\n  content: \"\\F1595\";\n}\n\n.mdi-arrow-collapse::before {\n  content: \"\\F0615\";\n}\n\n.mdi-arrow-collapse-all::before {\n  content: \"\\F0044\";\n}\n\n.mdi-arrow-collapse-down::before {\n  content: \"\\F0792\";\n}\n\n.mdi-arrow-collapse-horizontal::before {\n  content: \"\\F084C\";\n}\n\n.mdi-arrow-collapse-left::before {\n  content: \"\\F0793\";\n}\n\n.mdi-arrow-collapse-right::before {\n  content: \"\\F0794\";\n}\n\n.mdi-arrow-collapse-up::before {\n  content: \"\\F0795\";\n}\n\n.mdi-arrow-collapse-vertical::before {\n  content: \"\\F084D\";\n}\n\n.mdi-arrow-decision::before {\n  content: \"\\F09BB\";\n}\n\n.mdi-arrow-decision-auto::before {\n  content: \"\\F09BC\";\n}\n\n.mdi-arrow-decision-auto-outline::before {\n  content: \"\\F09BD\";\n}\n\n.mdi-arrow-decision-outline::before {\n  content: \"\\F09BE\";\n}\n\n.mdi-arrow-down::before {\n  content: \"\\F0045\";\n}\n\n.mdi-arrow-down-bold::before {\n  content: \"\\F072E\";\n}\n\n.mdi-arrow-down-bold-box::before {\n  content: \"\\F072F\";\n}\n\n.mdi-arrow-down-bold-box-outline::before {\n  content: \"\\F0730\";\n}\n\n.mdi-arrow-down-bold-circle::before {\n  content: \"\\F0047\";\n}\n\n.mdi-arrow-down-bold-circle-outline::before {\n  content: \"\\F0048\";\n}\n\n.mdi-arrow-down-bold-hexagon-outline::before {\n  content: \"\\F0049\";\n}\n\n.mdi-arrow-down-bold-outline::before {\n  content: \"\\F09BF\";\n}\n\n.mdi-arrow-down-box::before {\n  content: \"\\F06C0\";\n}\n\n.mdi-arrow-down-circle::before {\n  content: \"\\F0CDB\";\n}\n\n.mdi-arrow-down-circle-outline::before {\n  content: \"\\F0CDC\";\n}\n\n.mdi-arrow-down-drop-circle::before {\n  content: \"\\F004A\";\n}\n\n.mdi-arrow-down-drop-circle-outline::before {\n  content: \"\\F004B\";\n}\n\n.mdi-arrow-down-left::before {\n  content: \"\\F17A1\";\n}\n\n.mdi-arrow-down-left-bold::before {\n  content: \"\\F17A2\";\n}\n\n.mdi-arrow-down-right::before {\n  content: \"\\F17A3\";\n}\n\n.mdi-arrow-down-right-bold::before {\n  content: \"\\F17A4\";\n}\n\n.mdi-arrow-down-thick::before {\n  content: \"\\F0046\";\n}\n\n.mdi-arrow-down-thin::before {\n  content: \"\\F19B3\";\n}\n\n.mdi-arrow-down-thin-circle-outline::before {\n  content: \"\\F1599\";\n}\n\n.mdi-arrow-expand::before {\n  content: \"\\F0616\";\n}\n\n.mdi-arrow-expand-all::before {\n  content: \"\\F004C\";\n}\n\n.mdi-arrow-expand-down::before {\n  content: \"\\F0796\";\n}\n\n.mdi-arrow-expand-horizontal::before {\n  content: \"\\F084E\";\n}\n\n.mdi-arrow-expand-left::before {\n  content: \"\\F0797\";\n}\n\n.mdi-arrow-expand-right::before {\n  content: \"\\F0798\";\n}\n\n.mdi-arrow-expand-up::before {\n  content: \"\\F0799\";\n}\n\n.mdi-arrow-expand-vertical::before {\n  content: \"\\F084F\";\n}\n\n.mdi-arrow-horizontal-lock::before {\n  content: \"\\F115B\";\n}\n\n.mdi-arrow-left::before {\n  content: \"\\F004D\";\n}\n\n.mdi-arrow-left-bold::before {\n  content: \"\\F0731\";\n}\n\n.mdi-arrow-left-bold-box::before {\n  content: \"\\F0732\";\n}\n\n.mdi-arrow-left-bold-box-outline::before {\n  content: \"\\F0733\";\n}\n\n.mdi-arrow-left-bold-circle::before {\n  content: \"\\F004F\";\n}\n\n.mdi-arrow-left-bold-circle-outline::before {\n  content: \"\\F0050\";\n}\n\n.mdi-arrow-left-bold-hexagon-outline::before {\n  content: \"\\F0051\";\n}\n\n.mdi-arrow-left-bold-outline::before {\n  content: \"\\F09C0\";\n}\n\n.mdi-arrow-left-bottom::before {\n  content: \"\\F17A5\";\n}\n\n.mdi-arrow-left-bottom-bold::before {\n  content: \"\\F17A6\";\n}\n\n.mdi-arrow-left-box::before {\n  content: \"\\F06C1\";\n}\n\n.mdi-arrow-left-circle::before {\n  content: \"\\F0CDD\";\n}\n\n.mdi-arrow-left-circle-outline::before {\n  content: \"\\F0CDE\";\n}\n\n.mdi-arrow-left-drop-circle::before {\n  content: \"\\F0052\";\n}\n\n.mdi-arrow-left-drop-circle-outline::before {\n  content: \"\\F0053\";\n}\n\n.mdi-arrow-left-right::before {\n  content: \"\\F0E73\";\n}\n\n.mdi-arrow-left-right-bold::before {\n  content: \"\\F0E74\";\n}\n\n.mdi-arrow-left-right-bold-outline::before {\n  content: \"\\F09C1\";\n}\n\n.mdi-arrow-left-thick::before {\n  content: \"\\F004E\";\n}\n\n.mdi-arrow-left-thin::before {\n  content: \"\\F19B1\";\n}\n\n.mdi-arrow-left-thin-circle-outline::before {\n  content: \"\\F159A\";\n}\n\n.mdi-arrow-left-top::before {\n  content: \"\\F17A7\";\n}\n\n.mdi-arrow-left-top-bold::before {\n  content: \"\\F17A8\";\n}\n\n.mdi-arrow-projectile::before {\n  content: \"\\F1840\";\n}\n\n.mdi-arrow-projectile-multiple::before {\n  content: \"\\F183F\";\n}\n\n.mdi-arrow-right::before {\n  content: \"\\F0054\";\n}\n\n.mdi-arrow-right-bold::before {\n  content: \"\\F0734\";\n}\n\n.mdi-arrow-right-bold-box::before {\n  content: \"\\F0735\";\n}\n\n.mdi-arrow-right-bold-box-outline::before {\n  content: \"\\F0736\";\n}\n\n.mdi-arrow-right-bold-circle::before {\n  content: \"\\F0056\";\n}\n\n.mdi-arrow-right-bold-circle-outline::before {\n  content: \"\\F0057\";\n}\n\n.mdi-arrow-right-bold-hexagon-outline::before {\n  content: \"\\F0058\";\n}\n\n.mdi-arrow-right-bold-outline::before {\n  content: \"\\F09C2\";\n}\n\n.mdi-arrow-right-bottom::before {\n  content: \"\\F17A9\";\n}\n\n.mdi-arrow-right-bottom-bold::before {\n  content: \"\\F17AA\";\n}\n\n.mdi-arrow-right-box::before {\n  content: \"\\F06C2\";\n}\n\n.mdi-arrow-right-circle::before {\n  content: \"\\F0CDF\";\n}\n\n.mdi-arrow-right-circle-outline::before {\n  content: \"\\F0CE0\";\n}\n\n.mdi-arrow-right-drop-circle::before {\n  content: \"\\F0059\";\n}\n\n.mdi-arrow-right-drop-circle-outline::before {\n  content: \"\\F005A\";\n}\n\n.mdi-arrow-right-thick::before {\n  content: \"\\F0055\";\n}\n\n.mdi-arrow-right-thin::before {\n  content: \"\\F19B0\";\n}\n\n.mdi-arrow-right-thin-circle-outline::before {\n  content: \"\\F1598\";\n}\n\n.mdi-arrow-right-top::before {\n  content: \"\\F17AB\";\n}\n\n.mdi-arrow-right-top-bold::before {\n  content: \"\\F17AC\";\n}\n\n.mdi-arrow-split-horizontal::before {\n  content: \"\\F093B\";\n}\n\n.mdi-arrow-split-vertical::before {\n  content: \"\\F093C\";\n}\n\n.mdi-arrow-top-left::before {\n  content: \"\\F005B\";\n}\n\n.mdi-arrow-top-left-bold-box::before {\n  content: \"\\F1968\";\n}\n\n.mdi-arrow-top-left-bold-box-outline::before {\n  content: \"\\F1969\";\n}\n\n.mdi-arrow-top-left-bold-outline::before {\n  content: \"\\F09C3\";\n}\n\n.mdi-arrow-top-left-bottom-right::before {\n  content: \"\\F0E75\";\n}\n\n.mdi-arrow-top-left-bottom-right-bold::before {\n  content: \"\\F0E76\";\n}\n\n.mdi-arrow-top-left-thick::before {\n  content: \"\\F09C4\";\n}\n\n.mdi-arrow-top-left-thin::before {\n  content: \"\\F19B5\";\n}\n\n.mdi-arrow-top-left-thin-circle-outline::before {\n  content: \"\\F1593\";\n}\n\n.mdi-arrow-top-right::before {\n  content: \"\\F005C\";\n}\n\n.mdi-arrow-top-right-bold-box::before {\n  content: \"\\F196A\";\n}\n\n.mdi-arrow-top-right-bold-box-outline::before {\n  content: \"\\F196B\";\n}\n\n.mdi-arrow-top-right-bold-outline::before {\n  content: \"\\F09C5\";\n}\n\n.mdi-arrow-top-right-bottom-left::before {\n  content: \"\\F0E77\";\n}\n\n.mdi-arrow-top-right-bottom-left-bold::before {\n  content: \"\\F0E78\";\n}\n\n.mdi-arrow-top-right-thick::before {\n  content: \"\\F09C6\";\n}\n\n.mdi-arrow-top-right-thin::before {\n  content: \"\\F19B4\";\n}\n\n.mdi-arrow-top-right-thin-circle-outline::before {\n  content: \"\\F1594\";\n}\n\n.mdi-arrow-u-down-left::before {\n  content: \"\\F17AD\";\n}\n\n.mdi-arrow-u-down-left-bold::before {\n  content: \"\\F17AE\";\n}\n\n.mdi-arrow-u-down-right::before {\n  content: \"\\F17AF\";\n}\n\n.mdi-arrow-u-down-right-bold::before {\n  content: \"\\F17B0\";\n}\n\n.mdi-arrow-u-left-bottom::before {\n  content: \"\\F17B1\";\n}\n\n.mdi-arrow-u-left-bottom-bold::before {\n  content: \"\\F17B2\";\n}\n\n.mdi-arrow-u-left-top::before {\n  content: \"\\F17B3\";\n}\n\n.mdi-arrow-u-left-top-bold::before {\n  content: \"\\F17B4\";\n}\n\n.mdi-arrow-u-right-bottom::before {\n  content: \"\\F17B5\";\n}\n\n.mdi-arrow-u-right-bottom-bold::before {\n  content: \"\\F17B6\";\n}\n\n.mdi-arrow-u-right-top::before {\n  content: \"\\F17B7\";\n}\n\n.mdi-arrow-u-right-top-bold::before {\n  content: \"\\F17B8\";\n}\n\n.mdi-arrow-u-up-left::before {\n  content: \"\\F17B9\";\n}\n\n.mdi-arrow-u-up-left-bold::before {\n  content: \"\\F17BA\";\n}\n\n.mdi-arrow-u-up-right::before {\n  content: \"\\F17BB\";\n}\n\n.mdi-arrow-u-up-right-bold::before {\n  content: \"\\F17BC\";\n}\n\n.mdi-arrow-up::before {\n  content: \"\\F005D\";\n}\n\n.mdi-arrow-up-bold::before {\n  content: \"\\F0737\";\n}\n\n.mdi-arrow-up-bold-box::before {\n  content: \"\\F0738\";\n}\n\n.mdi-arrow-up-bold-box-outline::before {\n  content: \"\\F0739\";\n}\n\n.mdi-arrow-up-bold-circle::before {\n  content: \"\\F005F\";\n}\n\n.mdi-arrow-up-bold-circle-outline::before {\n  content: \"\\F0060\";\n}\n\n.mdi-arrow-up-bold-hexagon-outline::before {\n  content: \"\\F0061\";\n}\n\n.mdi-arrow-up-bold-outline::before {\n  content: \"\\F09C7\";\n}\n\n.mdi-arrow-up-box::before {\n  content: \"\\F06C3\";\n}\n\n.mdi-arrow-up-circle::before {\n  content: \"\\F0CE1\";\n}\n\n.mdi-arrow-up-circle-outline::before {\n  content: \"\\F0CE2\";\n}\n\n.mdi-arrow-up-down::before {\n  content: \"\\F0E79\";\n}\n\n.mdi-arrow-up-down-bold::before {\n  content: \"\\F0E7A\";\n}\n\n.mdi-arrow-up-down-bold-outline::before {\n  content: \"\\F09C8\";\n}\n\n.mdi-arrow-up-drop-circle::before {\n  content: \"\\F0062\";\n}\n\n.mdi-arrow-up-drop-circle-outline::before {\n  content: \"\\F0063\";\n}\n\n.mdi-arrow-up-left::before {\n  content: \"\\F17BD\";\n}\n\n.mdi-arrow-up-left-bold::before {\n  content: \"\\F17BE\";\n}\n\n.mdi-arrow-up-right::before {\n  content: \"\\F17BF\";\n}\n\n.mdi-arrow-up-right-bold::before {\n  content: \"\\F17C0\";\n}\n\n.mdi-arrow-up-thick::before {\n  content: \"\\F005E\";\n}\n\n.mdi-arrow-up-thin::before {\n  content: \"\\F19B2\";\n}\n\n.mdi-arrow-up-thin-circle-outline::before {\n  content: \"\\F1597\";\n}\n\n.mdi-arrow-vertical-lock::before {\n  content: \"\\F115C\";\n}\n\n.mdi-artstation::before {\n  content: \"\\F0B5B\";\n}\n\n.mdi-aspect-ratio::before {\n  content: \"\\F0A24\";\n}\n\n.mdi-assistant::before {\n  content: \"\\F0064\";\n}\n\n.mdi-asterisk::before {\n  content: \"\\F06C4\";\n}\n\n.mdi-at::before {\n  content: \"\\F0065\";\n}\n\n.mdi-atlassian::before {\n  content: \"\\F0804\";\n}\n\n.mdi-atm::before {\n  content: \"\\F0D47\";\n}\n\n.mdi-atom::before {\n  content: \"\\F0768\";\n}\n\n.mdi-atom-variant::before {\n  content: \"\\F0E7B\";\n}\n\n.mdi-attachment::before {\n  content: \"\\F0066\";\n}\n\n.mdi-audio-input-rca::before {\n  content: \"\\F186B\";\n}\n\n.mdi-audio-input-stereo-minijack::before {\n  content: \"\\F186C\";\n}\n\n.mdi-audio-input-xlr::before {\n  content: \"\\F186D\";\n}\n\n.mdi-audio-video::before {\n  content: \"\\F093D\";\n}\n\n.mdi-audio-video-off::before {\n  content: \"\\F11B6\";\n}\n\n.mdi-augmented-reality::before {\n  content: \"\\F0850\";\n}\n\n.mdi-auto-download::before {\n  content: \"\\F137E\";\n}\n\n.mdi-auto-fix::before {\n  content: \"\\F0068\";\n}\n\n.mdi-auto-upload::before {\n  content: \"\\F0069\";\n}\n\n.mdi-autorenew::before {\n  content: \"\\F006A\";\n}\n\n.mdi-av-timer::before {\n  content: \"\\F006B\";\n}\n\n.mdi-aws::before {\n  content: \"\\F0E0F\";\n}\n\n.mdi-axe::before {\n  content: \"\\F08C8\";\n}\n\n.mdi-axe-battle::before {\n  content: \"\\F1842\";\n}\n\n.mdi-axis::before {\n  content: \"\\F0D48\";\n}\n\n.mdi-axis-arrow::before {\n  content: \"\\F0D49\";\n}\n\n.mdi-axis-arrow-info::before {\n  content: \"\\F140E\";\n}\n\n.mdi-axis-arrow-lock::before {\n  content: \"\\F0D4A\";\n}\n\n.mdi-axis-lock::before {\n  content: \"\\F0D4B\";\n}\n\n.mdi-axis-x-arrow::before {\n  content: \"\\F0D4C\";\n}\n\n.mdi-axis-x-arrow-lock::before {\n  content: \"\\F0D4D\";\n}\n\n.mdi-axis-x-rotate-clockwise::before {\n  content: \"\\F0D4E\";\n}\n\n.mdi-axis-x-rotate-counterclockwise::before {\n  content: \"\\F0D4F\";\n}\n\n.mdi-axis-x-y-arrow-lock::before {\n  content: \"\\F0D50\";\n}\n\n.mdi-axis-y-arrow::before {\n  content: \"\\F0D51\";\n}\n\n.mdi-axis-y-arrow-lock::before {\n  content: \"\\F0D52\";\n}\n\n.mdi-axis-y-rotate-clockwise::before {\n  content: \"\\F0D53\";\n}\n\n.mdi-axis-y-rotate-counterclockwise::before {\n  content: \"\\F0D54\";\n}\n\n.mdi-axis-z-arrow::before {\n  content: \"\\F0D55\";\n}\n\n.mdi-axis-z-arrow-lock::before {\n  content: \"\\F0D56\";\n}\n\n.mdi-axis-z-rotate-clockwise::before {\n  content: \"\\F0D57\";\n}\n\n.mdi-axis-z-rotate-counterclockwise::before {\n  content: \"\\F0D58\";\n}\n\n.mdi-babel::before {\n  content: \"\\F0A25\";\n}\n\n.mdi-baby::before {\n  content: \"\\F006C\";\n}\n\n.mdi-baby-bottle::before {\n  content: \"\\F0F39\";\n}\n\n.mdi-baby-bottle-outline::before {\n  content: \"\\F0F3A\";\n}\n\n.mdi-baby-buggy::before {\n  content: \"\\F13E0\";\n}\n\n.mdi-baby-carriage::before {\n  content: \"\\F068F\";\n}\n\n.mdi-baby-carriage-off::before {\n  content: \"\\F0FA0\";\n}\n\n.mdi-baby-face::before {\n  content: \"\\F0E7C\";\n}\n\n.mdi-baby-face-outline::before {\n  content: \"\\F0E7D\";\n}\n\n.mdi-backburger::before {\n  content: \"\\F006D\";\n}\n\n.mdi-backspace::before {\n  content: \"\\F006E\";\n}\n\n.mdi-backspace-outline::before {\n  content: \"\\F0B5C\";\n}\n\n.mdi-backspace-reverse::before {\n  content: \"\\F0E7E\";\n}\n\n.mdi-backspace-reverse-outline::before {\n  content: \"\\F0E7F\";\n}\n\n.mdi-backup-restore::before {\n  content: \"\\F006F\";\n}\n\n.mdi-bacteria::before {\n  content: \"\\F0ED5\";\n}\n\n.mdi-bacteria-outline::before {\n  content: \"\\F0ED6\";\n}\n\n.mdi-badge-account::before {\n  content: \"\\F0DA7\";\n}\n\n.mdi-badge-account-alert::before {\n  content: \"\\F0DA8\";\n}\n\n.mdi-badge-account-alert-outline::before {\n  content: \"\\F0DA9\";\n}\n\n.mdi-badge-account-horizontal::before {\n  content: \"\\F0E0D\";\n}\n\n.mdi-badge-account-horizontal-outline::before {\n  content: \"\\F0E0E\";\n}\n\n.mdi-badge-account-outline::before {\n  content: \"\\F0DAA\";\n}\n\n.mdi-badminton::before {\n  content: \"\\F0851\";\n}\n\n.mdi-bag-carry-on::before {\n  content: \"\\F0F3B\";\n}\n\n.mdi-bag-carry-on-check::before {\n  content: \"\\F0D65\";\n}\n\n.mdi-bag-carry-on-off::before {\n  content: \"\\F0F3C\";\n}\n\n.mdi-bag-checked::before {\n  content: \"\\F0F3D\";\n}\n\n.mdi-bag-personal::before {\n  content: \"\\F0E10\";\n}\n\n.mdi-bag-personal-off::before {\n  content: \"\\F0E11\";\n}\n\n.mdi-bag-personal-off-outline::before {\n  content: \"\\F0E12\";\n}\n\n.mdi-bag-personal-outline::before {\n  content: \"\\F0E13\";\n}\n\n.mdi-bag-suitcase::before {\n  content: \"\\F158B\";\n}\n\n.mdi-bag-suitcase-off::before {\n  content: \"\\F158D\";\n}\n\n.mdi-bag-suitcase-off-outline::before {\n  content: \"\\F158E\";\n}\n\n.mdi-bag-suitcase-outline::before {\n  content: \"\\F158C\";\n}\n\n.mdi-baguette::before {\n  content: \"\\F0F3E\";\n}\n\n.mdi-balcony::before {\n  content: \"\\F1817\";\n}\n\n.mdi-balloon::before {\n  content: \"\\F0A26\";\n}\n\n.mdi-ballot::before {\n  content: \"\\F09C9\";\n}\n\n.mdi-ballot-outline::before {\n  content: \"\\F09CA\";\n}\n\n.mdi-ballot-recount::before {\n  content: \"\\F0C39\";\n}\n\n.mdi-ballot-recount-outline::before {\n  content: \"\\F0C3A\";\n}\n\n.mdi-bandage::before {\n  content: \"\\F0DAF\";\n}\n\n.mdi-bank::before {\n  content: \"\\F0070\";\n}\n\n.mdi-bank-check::before {\n  content: \"\\F1655\";\n}\n\n.mdi-bank-minus::before {\n  content: \"\\F0DB0\";\n}\n\n.mdi-bank-off::before {\n  content: \"\\F1656\";\n}\n\n.mdi-bank-off-outline::before {\n  content: \"\\F1657\";\n}\n\n.mdi-bank-outline::before {\n  content: \"\\F0E80\";\n}\n\n.mdi-bank-plus::before {\n  content: \"\\F0DB1\";\n}\n\n.mdi-bank-remove::before {\n  content: \"\\F0DB2\";\n}\n\n.mdi-bank-transfer::before {\n  content: \"\\F0A27\";\n}\n\n.mdi-bank-transfer-in::before {\n  content: \"\\F0A28\";\n}\n\n.mdi-bank-transfer-out::before {\n  content: \"\\F0A29\";\n}\n\n.mdi-barcode::before {\n  content: \"\\F0071\";\n}\n\n.mdi-barcode-off::before {\n  content: \"\\F1236\";\n}\n\n.mdi-barcode-scan::before {\n  content: \"\\F0072\";\n}\n\n.mdi-barley::before {\n  content: \"\\F0073\";\n}\n\n.mdi-barley-off::before {\n  content: \"\\F0B5D\";\n}\n\n.mdi-barn::before {\n  content: \"\\F0B5E\";\n}\n\n.mdi-barrel::before {\n  content: \"\\F0074\";\n}\n\n.mdi-baseball::before {\n  content: \"\\F0852\";\n}\n\n.mdi-baseball-bat::before {\n  content: \"\\F0853\";\n}\n\n.mdi-baseball-diamond::before {\n  content: \"\\F15EC\";\n}\n\n.mdi-baseball-diamond-outline::before {\n  content: \"\\F15ED\";\n}\n\n.mdi-bash::before {\n  content: \"\\F1183\";\n}\n\n.mdi-basket::before {\n  content: \"\\F0076\";\n}\n\n.mdi-basket-check::before {\n  content: \"\\F18E5\";\n}\n\n.mdi-basket-check-outline::before {\n  content: \"\\F18E6\";\n}\n\n.mdi-basket-fill::before {\n  content: \"\\F0077\";\n}\n\n.mdi-basket-minus::before {\n  content: \"\\F1523\";\n}\n\n.mdi-basket-minus-outline::before {\n  content: \"\\F1524\";\n}\n\n.mdi-basket-off::before {\n  content: \"\\F1525\";\n}\n\n.mdi-basket-off-outline::before {\n  content: \"\\F1526\";\n}\n\n.mdi-basket-outline::before {\n  content: \"\\F1181\";\n}\n\n.mdi-basket-plus::before {\n  content: \"\\F1527\";\n}\n\n.mdi-basket-plus-outline::before {\n  content: \"\\F1528\";\n}\n\n.mdi-basket-remove::before {\n  content: \"\\F1529\";\n}\n\n.mdi-basket-remove-outline::before {\n  content: \"\\F152A\";\n}\n\n.mdi-basket-unfill::before {\n  content: \"\\F0078\";\n}\n\n.mdi-basketball::before {\n  content: \"\\F0806\";\n}\n\n.mdi-basketball-hoop::before {\n  content: \"\\F0C3B\";\n}\n\n.mdi-basketball-hoop-outline::before {\n  content: \"\\F0C3C\";\n}\n\n.mdi-bat::before {\n  content: \"\\F0B5F\";\n}\n\n.mdi-bathtub::before {\n  content: \"\\F1818\";\n}\n\n.mdi-bathtub-outline::before {\n  content: \"\\F1819\";\n}\n\n.mdi-battery::before {\n  content: \"\\F0079\";\n}\n\n.mdi-battery-10::before {\n  content: \"\\F007A\";\n}\n\n.mdi-battery-10-bluetooth::before {\n  content: \"\\F093E\";\n}\n\n.mdi-battery-20::before {\n  content: \"\\F007B\";\n}\n\n.mdi-battery-20-bluetooth::before {\n  content: \"\\F093F\";\n}\n\n.mdi-battery-30::before {\n  content: \"\\F007C\";\n}\n\n.mdi-battery-30-bluetooth::before {\n  content: \"\\F0940\";\n}\n\n.mdi-battery-40::before {\n  content: \"\\F007D\";\n}\n\n.mdi-battery-40-bluetooth::before {\n  content: \"\\F0941\";\n}\n\n.mdi-battery-50::before {\n  content: \"\\F007E\";\n}\n\n.mdi-battery-50-bluetooth::before {\n  content: \"\\F0942\";\n}\n\n.mdi-battery-60::before {\n  content: \"\\F007F\";\n}\n\n.mdi-battery-60-bluetooth::before {\n  content: \"\\F0943\";\n}\n\n.mdi-battery-70::before {\n  content: \"\\F0080\";\n}\n\n.mdi-battery-70-bluetooth::before {\n  content: \"\\F0944\";\n}\n\n.mdi-battery-80::before {\n  content: \"\\F0081\";\n}\n\n.mdi-battery-80-bluetooth::before {\n  content: \"\\F0945\";\n}\n\n.mdi-battery-90::before {\n  content: \"\\F0082\";\n}\n\n.mdi-battery-90-bluetooth::before {\n  content: \"\\F0946\";\n}\n\n.mdi-battery-alert::before {\n  content: \"\\F0083\";\n}\n\n.mdi-battery-alert-bluetooth::before {\n  content: \"\\F0947\";\n}\n\n.mdi-battery-alert-variant::before {\n  content: \"\\F10CC\";\n}\n\n.mdi-battery-alert-variant-outline::before {\n  content: \"\\F10CD\";\n}\n\n.mdi-battery-arrow-down::before {\n  content: \"\\F17DE\";\n}\n\n.mdi-battery-arrow-down-outline::before {\n  content: \"\\F17DF\";\n}\n\n.mdi-battery-arrow-up::before {\n  content: \"\\F17E0\";\n}\n\n.mdi-battery-arrow-up-outline::before {\n  content: \"\\F17E1\";\n}\n\n.mdi-battery-bluetooth::before {\n  content: \"\\F0948\";\n}\n\n.mdi-battery-bluetooth-variant::before {\n  content: \"\\F0949\";\n}\n\n.mdi-battery-charging::before {\n  content: \"\\F0084\";\n}\n\n.mdi-battery-charging-10::before {\n  content: \"\\F089C\";\n}\n\n.mdi-battery-charging-100::before {\n  content: \"\\F0085\";\n}\n\n.mdi-battery-charging-20::before {\n  content: \"\\F0086\";\n}\n\n.mdi-battery-charging-30::before {\n  content: \"\\F0087\";\n}\n\n.mdi-battery-charging-40::before {\n  content: \"\\F0088\";\n}\n\n.mdi-battery-charging-50::before {\n  content: \"\\F089D\";\n}\n\n.mdi-battery-charging-60::before {\n  content: \"\\F0089\";\n}\n\n.mdi-battery-charging-70::before {\n  content: \"\\F089E\";\n}\n\n.mdi-battery-charging-80::before {\n  content: \"\\F008A\";\n}\n\n.mdi-battery-charging-90::before {\n  content: \"\\F008B\";\n}\n\n.mdi-battery-charging-high::before {\n  content: \"\\F12A6\";\n}\n\n.mdi-battery-charging-low::before {\n  content: \"\\F12A4\";\n}\n\n.mdi-battery-charging-medium::before {\n  content: \"\\F12A5\";\n}\n\n.mdi-battery-charging-outline::before {\n  content: \"\\F089F\";\n}\n\n.mdi-battery-charging-wireless::before {\n  content: \"\\F0807\";\n}\n\n.mdi-battery-charging-wireless-10::before {\n  content: \"\\F0808\";\n}\n\n.mdi-battery-charging-wireless-20::before {\n  content: \"\\F0809\";\n}\n\n.mdi-battery-charging-wireless-30::before {\n  content: \"\\F080A\";\n}\n\n.mdi-battery-charging-wireless-40::before {\n  content: \"\\F080B\";\n}\n\n.mdi-battery-charging-wireless-50::before {\n  content: \"\\F080C\";\n}\n\n.mdi-battery-charging-wireless-60::before {\n  content: \"\\F080D\";\n}\n\n.mdi-battery-charging-wireless-70::before {\n  content: \"\\F080E\";\n}\n\n.mdi-battery-charging-wireless-80::before {\n  content: \"\\F080F\";\n}\n\n.mdi-battery-charging-wireless-90::before {\n  content: \"\\F0810\";\n}\n\n.mdi-battery-charging-wireless-alert::before {\n  content: \"\\F0811\";\n}\n\n.mdi-battery-charging-wireless-outline::before {\n  content: \"\\F0812\";\n}\n\n.mdi-battery-check::before {\n  content: \"\\F17E2\";\n}\n\n.mdi-battery-check-outline::before {\n  content: \"\\F17E3\";\n}\n\n.mdi-battery-heart::before {\n  content: \"\\F120F\";\n}\n\n.mdi-battery-heart-outline::before {\n  content: \"\\F1210\";\n}\n\n.mdi-battery-heart-variant::before {\n  content: \"\\F1211\";\n}\n\n.mdi-battery-high::before {\n  content: \"\\F12A3\";\n}\n\n.mdi-battery-lock::before {\n  content: \"\\F179C\";\n}\n\n.mdi-battery-lock-open::before {\n  content: \"\\F179D\";\n}\n\n.mdi-battery-low::before {\n  content: \"\\F12A1\";\n}\n\n.mdi-battery-medium::before {\n  content: \"\\F12A2\";\n}\n\n.mdi-battery-minus::before {\n  content: \"\\F17E4\";\n}\n\n.mdi-battery-minus-outline::before {\n  content: \"\\F17E5\";\n}\n\n.mdi-battery-minus-variant::before {\n  content: \"\\F008C\";\n}\n\n.mdi-battery-negative::before {\n  content: \"\\F008D\";\n}\n\n.mdi-battery-off::before {\n  content: \"\\F125D\";\n}\n\n.mdi-battery-off-outline::before {\n  content: \"\\F125E\";\n}\n\n.mdi-battery-outline::before {\n  content: \"\\F008E\";\n}\n\n.mdi-battery-plus::before {\n  content: \"\\F17E6\";\n}\n\n.mdi-battery-plus-outline::before {\n  content: \"\\F17E7\";\n}\n\n.mdi-battery-plus-variant::before {\n  content: \"\\F008F\";\n}\n\n.mdi-battery-positive::before {\n  content: \"\\F0090\";\n}\n\n.mdi-battery-remove::before {\n  content: \"\\F17E8\";\n}\n\n.mdi-battery-remove-outline::before {\n  content: \"\\F17E9\";\n}\n\n.mdi-battery-sync::before {\n  content: \"\\F1834\";\n}\n\n.mdi-battery-sync-outline::before {\n  content: \"\\F1835\";\n}\n\n.mdi-battery-unknown::before {\n  content: \"\\F0091\";\n}\n\n.mdi-battery-unknown-bluetooth::before {\n  content: \"\\F094A\";\n}\n\n.mdi-beach::before {\n  content: \"\\F0092\";\n}\n\n.mdi-beaker::before {\n  content: \"\\F0CEA\";\n}\n\n.mdi-beaker-alert::before {\n  content: \"\\F1229\";\n}\n\n.mdi-beaker-alert-outline::before {\n  content: \"\\F122A\";\n}\n\n.mdi-beaker-check::before {\n  content: \"\\F122B\";\n}\n\n.mdi-beaker-check-outline::before {\n  content: \"\\F122C\";\n}\n\n.mdi-beaker-minus::before {\n  content: \"\\F122D\";\n}\n\n.mdi-beaker-minus-outline::before {\n  content: \"\\F122E\";\n}\n\n.mdi-beaker-outline::before {\n  content: \"\\F0690\";\n}\n\n.mdi-beaker-plus::before {\n  content: \"\\F122F\";\n}\n\n.mdi-beaker-plus-outline::before {\n  content: \"\\F1230\";\n}\n\n.mdi-beaker-question::before {\n  content: \"\\F1231\";\n}\n\n.mdi-beaker-question-outline::before {\n  content: \"\\F1232\";\n}\n\n.mdi-beaker-remove::before {\n  content: \"\\F1233\";\n}\n\n.mdi-beaker-remove-outline::before {\n  content: \"\\F1234\";\n}\n\n.mdi-bed::before {\n  content: \"\\F02E3\";\n}\n\n.mdi-bed-double::before {\n  content: \"\\F0FD4\";\n}\n\n.mdi-bed-double-outline::before {\n  content: \"\\F0FD3\";\n}\n\n.mdi-bed-empty::before {\n  content: \"\\F08A0\";\n}\n\n.mdi-bed-king::before {\n  content: \"\\F0FD2\";\n}\n\n.mdi-bed-king-outline::before {\n  content: \"\\F0FD1\";\n}\n\n.mdi-bed-outline::before {\n  content: \"\\F0099\";\n}\n\n.mdi-bed-queen::before {\n  content: \"\\F0FD0\";\n}\n\n.mdi-bed-queen-outline::before {\n  content: \"\\F0FDB\";\n}\n\n.mdi-bed-single::before {\n  content: \"\\F106D\";\n}\n\n.mdi-bed-single-outline::before {\n  content: \"\\F106E\";\n}\n\n.mdi-bee::before {\n  content: \"\\F0FA1\";\n}\n\n.mdi-bee-flower::before {\n  content: \"\\F0FA2\";\n}\n\n.mdi-beehive-off-outline::before {\n  content: \"\\F13ED\";\n}\n\n.mdi-beehive-outline::before {\n  content: \"\\F10CE\";\n}\n\n.mdi-beekeeper::before {\n  content: \"\\F14E2\";\n}\n\n.mdi-beer::before {\n  content: \"\\F0098\";\n}\n\n.mdi-beer-outline::before {\n  content: \"\\F130C\";\n}\n\n.mdi-bell::before {\n  content: \"\\F009A\";\n}\n\n.mdi-bell-alert::before {\n  content: \"\\F0D59\";\n}\n\n.mdi-bell-alert-outline::before {\n  content: \"\\F0E81\";\n}\n\n.mdi-bell-badge::before {\n  content: \"\\F116B\";\n}\n\n.mdi-bell-badge-outline::before {\n  content: \"\\F0178\";\n}\n\n.mdi-bell-cancel::before {\n  content: \"\\F13E7\";\n}\n\n.mdi-bell-cancel-outline::before {\n  content: \"\\F13E8\";\n}\n\n.mdi-bell-check::before {\n  content: \"\\F11E5\";\n}\n\n.mdi-bell-check-outline::before {\n  content: \"\\F11E6\";\n}\n\n.mdi-bell-circle::before {\n  content: \"\\F0D5A\";\n}\n\n.mdi-bell-circle-outline::before {\n  content: \"\\F0D5B\";\n}\n\n.mdi-bell-minus::before {\n  content: \"\\F13E9\";\n}\n\n.mdi-bell-minus-outline::before {\n  content: \"\\F13EA\";\n}\n\n.mdi-bell-off::before {\n  content: \"\\F009B\";\n}\n\n.mdi-bell-off-outline::before {\n  content: \"\\F0A91\";\n}\n\n.mdi-bell-outline::before {\n  content: \"\\F009C\";\n}\n\n.mdi-bell-plus::before {\n  content: \"\\F009D\";\n}\n\n.mdi-bell-plus-outline::before {\n  content: \"\\F0A92\";\n}\n\n.mdi-bell-remove::before {\n  content: \"\\F13EB\";\n}\n\n.mdi-bell-remove-outline::before {\n  content: \"\\F13EC\";\n}\n\n.mdi-bell-ring::before {\n  content: \"\\F009E\";\n}\n\n.mdi-bell-ring-outline::before {\n  content: \"\\F009F\";\n}\n\n.mdi-bell-sleep::before {\n  content: \"\\F00A0\";\n}\n\n.mdi-bell-sleep-outline::before {\n  content: \"\\F0A93\";\n}\n\n.mdi-beta::before {\n  content: \"\\F00A1\";\n}\n\n.mdi-betamax::before {\n  content: \"\\F09CB\";\n}\n\n.mdi-biathlon::before {\n  content: \"\\F0E14\";\n}\n\n.mdi-bicycle::before {\n  content: \"\\F109C\";\n}\n\n.mdi-bicycle-basket::before {\n  content: \"\\F1235\";\n}\n\n.mdi-bicycle-cargo::before {\n  content: \"\\F189C\";\n}\n\n.mdi-bicycle-electric::before {\n  content: \"\\F15B4\";\n}\n\n.mdi-bicycle-penny-farthing::before {\n  content: \"\\F15E9\";\n}\n\n.mdi-bike::before {\n  content: \"\\F00A3\";\n}\n\n.mdi-bike-fast::before {\n  content: \"\\F111F\";\n}\n\n.mdi-billboard::before {\n  content: \"\\F1010\";\n}\n\n.mdi-billiards::before {\n  content: \"\\F0B61\";\n}\n\n.mdi-billiards-rack::before {\n  content: \"\\F0B62\";\n}\n\n.mdi-binoculars::before {\n  content: \"\\F00A5\";\n}\n\n.mdi-bio::before {\n  content: \"\\F00A6\";\n}\n\n.mdi-biohazard::before {\n  content: \"\\F00A7\";\n}\n\n.mdi-bird::before {\n  content: \"\\F15C6\";\n}\n\n.mdi-bitbucket::before {\n  content: \"\\F00A8\";\n}\n\n.mdi-bitcoin::before {\n  content: \"\\F0813\";\n}\n\n.mdi-black-mesa::before {\n  content: \"\\F00A9\";\n}\n\n.mdi-blender::before {\n  content: \"\\F0CEB\";\n}\n\n.mdi-blender-outline::before {\n  content: \"\\F181A\";\n}\n\n.mdi-blender-software::before {\n  content: \"\\F00AB\";\n}\n\n.mdi-blinds::before {\n  content: \"\\F00AC\";\n}\n\n.mdi-blinds-open::before {\n  content: \"\\F1011\";\n}\n\n.mdi-block-helper::before {\n  content: \"\\F00AD\";\n}\n\n.mdi-blood-bag::before {\n  content: \"\\F0CEC\";\n}\n\n.mdi-bluetooth::before {\n  content: \"\\F00AF\";\n}\n\n.mdi-bluetooth-audio::before {\n  content: \"\\F00B0\";\n}\n\n.mdi-bluetooth-connect::before {\n  content: \"\\F00B1\";\n}\n\n.mdi-bluetooth-off::before {\n  content: \"\\F00B2\";\n}\n\n.mdi-bluetooth-settings::before {\n  content: \"\\F00B3\";\n}\n\n.mdi-bluetooth-transfer::before {\n  content: \"\\F00B4\";\n}\n\n.mdi-blur::before {\n  content: \"\\F00B5\";\n}\n\n.mdi-blur-linear::before {\n  content: \"\\F00B6\";\n}\n\n.mdi-blur-off::before {\n  content: \"\\F00B7\";\n}\n\n.mdi-blur-radial::before {\n  content: \"\\F00B8\";\n}\n\n.mdi-bolt::before {\n  content: \"\\F0DB3\";\n}\n\n.mdi-bomb::before {\n  content: \"\\F0691\";\n}\n\n.mdi-bomb-off::before {\n  content: \"\\F06C5\";\n}\n\n.mdi-bone::before {\n  content: \"\\F00B9\";\n}\n\n.mdi-book::before {\n  content: \"\\F00BA\";\n}\n\n.mdi-book-account::before {\n  content: \"\\F13AD\";\n}\n\n.mdi-book-account-outline::before {\n  content: \"\\F13AE\";\n}\n\n.mdi-book-alert::before {\n  content: \"\\F167C\";\n}\n\n.mdi-book-alert-outline::before {\n  content: \"\\F167D\";\n}\n\n.mdi-book-alphabet::before {\n  content: \"\\F061D\";\n}\n\n.mdi-book-arrow-down::before {\n  content: \"\\F167E\";\n}\n\n.mdi-book-arrow-down-outline::before {\n  content: \"\\F167F\";\n}\n\n.mdi-book-arrow-left::before {\n  content: \"\\F1680\";\n}\n\n.mdi-book-arrow-left-outline::before {\n  content: \"\\F1681\";\n}\n\n.mdi-book-arrow-right::before {\n  content: \"\\F1682\";\n}\n\n.mdi-book-arrow-right-outline::before {\n  content: \"\\F1683\";\n}\n\n.mdi-book-arrow-up::before {\n  content: \"\\F1684\";\n}\n\n.mdi-book-arrow-up-outline::before {\n  content: \"\\F1685\";\n}\n\n.mdi-book-cancel::before {\n  content: \"\\F1686\";\n}\n\n.mdi-book-cancel-outline::before {\n  content: \"\\F1687\";\n}\n\n.mdi-book-check::before {\n  content: \"\\F14F3\";\n}\n\n.mdi-book-check-outline::before {\n  content: \"\\F14F4\";\n}\n\n.mdi-book-clock::before {\n  content: \"\\F1688\";\n}\n\n.mdi-book-clock-outline::before {\n  content: \"\\F1689\";\n}\n\n.mdi-book-cog::before {\n  content: \"\\F168A\";\n}\n\n.mdi-book-cog-outline::before {\n  content: \"\\F168B\";\n}\n\n.mdi-book-cross::before {\n  content: \"\\F00A2\";\n}\n\n.mdi-book-edit::before {\n  content: \"\\F168C\";\n}\n\n.mdi-book-edit-outline::before {\n  content: \"\\F168D\";\n}\n\n.mdi-book-education::before {\n  content: \"\\F16C9\";\n}\n\n.mdi-book-education-outline::before {\n  content: \"\\F16CA\";\n}\n\n.mdi-book-information-variant::before {\n  content: \"\\F106F\";\n}\n\n.mdi-book-lock::before {\n  content: \"\\F079A\";\n}\n\n.mdi-book-lock-open::before {\n  content: \"\\F079B\";\n}\n\n.mdi-book-lock-open-outline::before {\n  content: \"\\F168E\";\n}\n\n.mdi-book-lock-outline::before {\n  content: \"\\F168F\";\n}\n\n.mdi-book-marker::before {\n  content: \"\\F1690\";\n}\n\n.mdi-book-marker-outline::before {\n  content: \"\\F1691\";\n}\n\n.mdi-book-minus::before {\n  content: \"\\F05D9\";\n}\n\n.mdi-book-minus-multiple::before {\n  content: \"\\F0A94\";\n}\n\n.mdi-book-minus-multiple-outline::before {\n  content: \"\\F090B\";\n}\n\n.mdi-book-minus-outline::before {\n  content: \"\\F1692\";\n}\n\n.mdi-book-multiple::before {\n  content: \"\\F00BB\";\n}\n\n.mdi-book-multiple-outline::before {\n  content: \"\\F0436\";\n}\n\n.mdi-book-music::before {\n  content: \"\\F0067\";\n}\n\n.mdi-book-music-outline::before {\n  content: \"\\F1693\";\n}\n\n.mdi-book-off::before {\n  content: \"\\F1694\";\n}\n\n.mdi-book-off-outline::before {\n  content: \"\\F1695\";\n}\n\n.mdi-book-open::before {\n  content: \"\\F00BD\";\n}\n\n.mdi-book-open-blank-variant::before {\n  content: \"\\F00BE\";\n}\n\n.mdi-book-open-outline::before {\n  content: \"\\F0B63\";\n}\n\n.mdi-book-open-page-variant::before {\n  content: \"\\F05DA\";\n}\n\n.mdi-book-open-page-variant-outline::before {\n  content: \"\\F15D6\";\n}\n\n.mdi-book-open-variant::before {\n  content: \"\\F14F7\";\n}\n\n.mdi-book-outline::before {\n  content: \"\\F0B64\";\n}\n\n.mdi-book-play::before {\n  content: \"\\F0E82\";\n}\n\n.mdi-book-play-outline::before {\n  content: \"\\F0E83\";\n}\n\n.mdi-book-plus::before {\n  content: \"\\F05DB\";\n}\n\n.mdi-book-plus-multiple::before {\n  content: \"\\F0A95\";\n}\n\n.mdi-book-plus-multiple-outline::before {\n  content: \"\\F0ADE\";\n}\n\n.mdi-book-plus-outline::before {\n  content: \"\\F1696\";\n}\n\n.mdi-book-refresh::before {\n  content: \"\\F1697\";\n}\n\n.mdi-book-refresh-outline::before {\n  content: \"\\F1698\";\n}\n\n.mdi-book-remove::before {\n  content: \"\\F0A97\";\n}\n\n.mdi-book-remove-multiple::before {\n  content: \"\\F0A96\";\n}\n\n.mdi-book-remove-multiple-outline::before {\n  content: \"\\F04CA\";\n}\n\n.mdi-book-remove-outline::before {\n  content: \"\\F1699\";\n}\n\n.mdi-book-search::before {\n  content: \"\\F0E84\";\n}\n\n.mdi-book-search-outline::before {\n  content: \"\\F0E85\";\n}\n\n.mdi-book-settings::before {\n  content: \"\\F169A\";\n}\n\n.mdi-book-settings-outline::before {\n  content: \"\\F169B\";\n}\n\n.mdi-book-sync::before {\n  content: \"\\F169C\";\n}\n\n.mdi-book-sync-outline::before {\n  content: \"\\F16C8\";\n}\n\n.mdi-book-variant::before {\n  content: \"\\F00BF\";\n}\n\n.mdi-book-variant-multiple::before {\n  content: \"\\F00BC\";\n}\n\n.mdi-bookmark::before {\n  content: \"\\F00C0\";\n}\n\n.mdi-bookmark-box-multiple::before {\n  content: \"\\F196C\";\n}\n\n.mdi-bookmark-box-multiple-outline::before {\n  content: \"\\F196D\";\n}\n\n.mdi-bookmark-check::before {\n  content: \"\\F00C1\";\n}\n\n.mdi-bookmark-check-outline::before {\n  content: \"\\F137B\";\n}\n\n.mdi-bookmark-minus::before {\n  content: \"\\F09CC\";\n}\n\n.mdi-bookmark-minus-outline::before {\n  content: \"\\F09CD\";\n}\n\n.mdi-bookmark-multiple::before {\n  content: \"\\F0E15\";\n}\n\n.mdi-bookmark-multiple-outline::before {\n  content: \"\\F0E16\";\n}\n\n.mdi-bookmark-music::before {\n  content: \"\\F00C2\";\n}\n\n.mdi-bookmark-music-outline::before {\n  content: \"\\F1379\";\n}\n\n.mdi-bookmark-off::before {\n  content: \"\\F09CE\";\n}\n\n.mdi-bookmark-off-outline::before {\n  content: \"\\F09CF\";\n}\n\n.mdi-bookmark-outline::before {\n  content: \"\\F00C3\";\n}\n\n.mdi-bookmark-plus::before {\n  content: \"\\F00C5\";\n}\n\n.mdi-bookmark-plus-outline::before {\n  content: \"\\F00C4\";\n}\n\n.mdi-bookmark-remove::before {\n  content: \"\\F00C6\";\n}\n\n.mdi-bookmark-remove-outline::before {\n  content: \"\\F137A\";\n}\n\n.mdi-bookshelf::before {\n  content: \"\\F125F\";\n}\n\n.mdi-boom-gate::before {\n  content: \"\\F0E86\";\n}\n\n.mdi-boom-gate-alert::before {\n  content: \"\\F0E87\";\n}\n\n.mdi-boom-gate-alert-outline::before {\n  content: \"\\F0E88\";\n}\n\n.mdi-boom-gate-arrow-down::before {\n  content: \"\\F0E89\";\n}\n\n.mdi-boom-gate-arrow-down-outline::before {\n  content: \"\\F0E8A\";\n}\n\n.mdi-boom-gate-arrow-up::before {\n  content: \"\\F0E8C\";\n}\n\n.mdi-boom-gate-arrow-up-outline::before {\n  content: \"\\F0E8D\";\n}\n\n.mdi-boom-gate-outline::before {\n  content: \"\\F0E8B\";\n}\n\n.mdi-boom-gate-up::before {\n  content: \"\\F17F9\";\n}\n\n.mdi-boom-gate-up-outline::before {\n  content: \"\\F17FA\";\n}\n\n.mdi-boombox::before {\n  content: \"\\F05DC\";\n}\n\n.mdi-boomerang::before {\n  content: \"\\F10CF\";\n}\n\n.mdi-bootstrap::before {\n  content: \"\\F06C6\";\n}\n\n.mdi-border-all::before {\n  content: \"\\F00C7\";\n}\n\n.mdi-border-all-variant::before {\n  content: \"\\F08A1\";\n}\n\n.mdi-border-bottom::before {\n  content: \"\\F00C8\";\n}\n\n.mdi-border-bottom-variant::before {\n  content: \"\\F08A2\";\n}\n\n.mdi-border-color::before {\n  content: \"\\F00C9\";\n}\n\n.mdi-border-horizontal::before {\n  content: \"\\F00CA\";\n}\n\n.mdi-border-inside::before {\n  content: \"\\F00CB\";\n}\n\n.mdi-border-left::before {\n  content: \"\\F00CC\";\n}\n\n.mdi-border-left-variant::before {\n  content: \"\\F08A3\";\n}\n\n.mdi-border-none::before {\n  content: \"\\F00CD\";\n}\n\n.mdi-border-none-variant::before {\n  content: \"\\F08A4\";\n}\n\n.mdi-border-outside::before {\n  content: \"\\F00CE\";\n}\n\n.mdi-border-right::before {\n  content: \"\\F00CF\";\n}\n\n.mdi-border-right-variant::before {\n  content: \"\\F08A5\";\n}\n\n.mdi-border-style::before {\n  content: \"\\F00D0\";\n}\n\n.mdi-border-top::before {\n  content: \"\\F00D1\";\n}\n\n.mdi-border-top-variant::before {\n  content: \"\\F08A6\";\n}\n\n.mdi-border-vertical::before {\n  content: \"\\F00D2\";\n}\n\n.mdi-bottle-soda::before {\n  content: \"\\F1070\";\n}\n\n.mdi-bottle-soda-classic::before {\n  content: \"\\F1071\";\n}\n\n.mdi-bottle-soda-classic-outline::before {\n  content: \"\\F1363\";\n}\n\n.mdi-bottle-soda-outline::before {\n  content: \"\\F1072\";\n}\n\n.mdi-bottle-tonic::before {\n  content: \"\\F112E\";\n}\n\n.mdi-bottle-tonic-outline::before {\n  content: \"\\F112F\";\n}\n\n.mdi-bottle-tonic-plus::before {\n  content: \"\\F1130\";\n}\n\n.mdi-bottle-tonic-plus-outline::before {\n  content: \"\\F1131\";\n}\n\n.mdi-bottle-tonic-skull::before {\n  content: \"\\F1132\";\n}\n\n.mdi-bottle-tonic-skull-outline::before {\n  content: \"\\F1133\";\n}\n\n.mdi-bottle-wine::before {\n  content: \"\\F0854\";\n}\n\n.mdi-bottle-wine-outline::before {\n  content: \"\\F1310\";\n}\n\n.mdi-bow-arrow::before {\n  content: \"\\F1841\";\n}\n\n.mdi-bow-tie::before {\n  content: \"\\F0678\";\n}\n\n.mdi-bowl::before {\n  content: \"\\F028E\";\n}\n\n.mdi-bowl-mix::before {\n  content: \"\\F0617\";\n}\n\n.mdi-bowl-mix-outline::before {\n  content: \"\\F02E4\";\n}\n\n.mdi-bowl-outline::before {\n  content: \"\\F02A9\";\n}\n\n.mdi-bowling::before {\n  content: \"\\F00D3\";\n}\n\n.mdi-box::before {\n  content: \"\\F00D4\";\n}\n\n.mdi-box-cutter::before {\n  content: \"\\F00D5\";\n}\n\n.mdi-box-cutter-off::before {\n  content: \"\\F0B4A\";\n}\n\n.mdi-box-shadow::before {\n  content: \"\\F0637\";\n}\n\n.mdi-boxing-glove::before {\n  content: \"\\F0B65\";\n}\n\n.mdi-braille::before {\n  content: \"\\F09D0\";\n}\n\n.mdi-brain::before {\n  content: \"\\F09D1\";\n}\n\n.mdi-bread-slice::before {\n  content: \"\\F0CEE\";\n}\n\n.mdi-bread-slice-outline::before {\n  content: \"\\F0CEF\";\n}\n\n.mdi-bridge::before {\n  content: \"\\F0618\";\n}\n\n.mdi-briefcase::before {\n  content: \"\\F00D6\";\n}\n\n.mdi-briefcase-account::before {\n  content: \"\\F0CF0\";\n}\n\n.mdi-briefcase-account-outline::before {\n  content: \"\\F0CF1\";\n}\n\n.mdi-briefcase-check::before {\n  content: \"\\F00D7\";\n}\n\n.mdi-briefcase-check-outline::before {\n  content: \"\\F131E\";\n}\n\n.mdi-briefcase-clock::before {\n  content: \"\\F10D0\";\n}\n\n.mdi-briefcase-clock-outline::before {\n  content: \"\\F10D1\";\n}\n\n.mdi-briefcase-download::before {\n  content: \"\\F00D8\";\n}\n\n.mdi-briefcase-download-outline::before {\n  content: \"\\F0C3D\";\n}\n\n.mdi-briefcase-edit::before {\n  content: \"\\F0A98\";\n}\n\n.mdi-briefcase-edit-outline::before {\n  content: \"\\F0C3E\";\n}\n\n.mdi-briefcase-eye::before {\n  content: \"\\F17D9\";\n}\n\n.mdi-briefcase-eye-outline::before {\n  content: \"\\F17DA\";\n}\n\n.mdi-briefcase-minus::before {\n  content: \"\\F0A2A\";\n}\n\n.mdi-briefcase-minus-outline::before {\n  content: \"\\F0C3F\";\n}\n\n.mdi-briefcase-off::before {\n  content: \"\\F1658\";\n}\n\n.mdi-briefcase-off-outline::before {\n  content: \"\\F1659\";\n}\n\n.mdi-briefcase-outline::before {\n  content: \"\\F0814\";\n}\n\n.mdi-briefcase-plus::before {\n  content: \"\\F0A2B\";\n}\n\n.mdi-briefcase-plus-outline::before {\n  content: \"\\F0C40\";\n}\n\n.mdi-briefcase-remove::before {\n  content: \"\\F0A2C\";\n}\n\n.mdi-briefcase-remove-outline::before {\n  content: \"\\F0C41\";\n}\n\n.mdi-briefcase-search::before {\n  content: \"\\F0A2D\";\n}\n\n.mdi-briefcase-search-outline::before {\n  content: \"\\F0C42\";\n}\n\n.mdi-briefcase-upload::before {\n  content: \"\\F00D9\";\n}\n\n.mdi-briefcase-upload-outline::before {\n  content: \"\\F0C43\";\n}\n\n.mdi-briefcase-variant::before {\n  content: \"\\F1494\";\n}\n\n.mdi-briefcase-variant-off::before {\n  content: \"\\F165A\";\n}\n\n.mdi-briefcase-variant-off-outline::before {\n  content: \"\\F165B\";\n}\n\n.mdi-briefcase-variant-outline::before {\n  content: \"\\F1495\";\n}\n\n.mdi-brightness-1::before {\n  content: \"\\F00DA\";\n}\n\n.mdi-brightness-2::before {\n  content: \"\\F00DB\";\n}\n\n.mdi-brightness-3::before {\n  content: \"\\F00DC\";\n}\n\n.mdi-brightness-4::before {\n  content: \"\\F00DD\";\n}\n\n.mdi-brightness-5::before {\n  content: \"\\F00DE\";\n}\n\n.mdi-brightness-6::before {\n  content: \"\\F00DF\";\n}\n\n.mdi-brightness-7::before {\n  content: \"\\F00E0\";\n}\n\n.mdi-brightness-auto::before {\n  content: \"\\F00E1\";\n}\n\n.mdi-brightness-percent::before {\n  content: \"\\F0CF2\";\n}\n\n.mdi-broadcast::before {\n  content: \"\\F1720\";\n}\n\n.mdi-broadcast-off::before {\n  content: \"\\F1721\";\n}\n\n.mdi-broom::before {\n  content: \"\\F00E2\";\n}\n\n.mdi-brush::before {\n  content: \"\\F00E3\";\n}\n\n.mdi-brush-off::before {\n  content: \"\\F1771\";\n}\n\n.mdi-brush-variant::before {\n  content: \"\\F1813\";\n}\n\n.mdi-bucket::before {\n  content: \"\\F1415\";\n}\n\n.mdi-bucket-outline::before {\n  content: \"\\F1416\";\n}\n\n.mdi-buffet::before {\n  content: \"\\F0578\";\n}\n\n.mdi-bug::before {\n  content: \"\\F00E4\";\n}\n\n.mdi-bug-check::before {\n  content: \"\\F0A2E\";\n}\n\n.mdi-bug-check-outline::before {\n  content: \"\\F0A2F\";\n}\n\n.mdi-bug-outline::before {\n  content: \"\\F0A30\";\n}\n\n.mdi-bugle::before {\n  content: \"\\F0DB4\";\n}\n\n.mdi-bulldozer::before {\n  content: \"\\F0B22\";\n}\n\n.mdi-bullet::before {\n  content: \"\\F0CF3\";\n}\n\n.mdi-bulletin-board::before {\n  content: \"\\F00E5\";\n}\n\n.mdi-bullhorn::before {\n  content: \"\\F00E6\";\n}\n\n.mdi-bullhorn-outline::before {\n  content: \"\\F0B23\";\n}\n\n.mdi-bullhorn-variant::before {\n  content: \"\\F196E\";\n}\n\n.mdi-bullhorn-variant-outline::before {\n  content: \"\\F196F\";\n}\n\n.mdi-bullseye::before {\n  content: \"\\F05DD\";\n}\n\n.mdi-bullseye-arrow::before {\n  content: \"\\F08C9\";\n}\n\n.mdi-bulma::before {\n  content: \"\\F12E7\";\n}\n\n.mdi-bunk-bed::before {\n  content: \"\\F1302\";\n}\n\n.mdi-bunk-bed-outline::before {\n  content: \"\\F0097\";\n}\n\n.mdi-bus::before {\n  content: \"\\F00E7\";\n}\n\n.mdi-bus-alert::before {\n  content: \"\\F0A99\";\n}\n\n.mdi-bus-articulated-end::before {\n  content: \"\\F079C\";\n}\n\n.mdi-bus-articulated-front::before {\n  content: \"\\F079D\";\n}\n\n.mdi-bus-clock::before {\n  content: \"\\F08CA\";\n}\n\n.mdi-bus-double-decker::before {\n  content: \"\\F079E\";\n}\n\n.mdi-bus-electric::before {\n  content: \"\\F191D\";\n}\n\n.mdi-bus-marker::before {\n  content: \"\\F1212\";\n}\n\n.mdi-bus-multiple::before {\n  content: \"\\F0F3F\";\n}\n\n.mdi-bus-school::before {\n  content: \"\\F079F\";\n}\n\n.mdi-bus-side::before {\n  content: \"\\F07A0\";\n}\n\n.mdi-bus-stop::before {\n  content: \"\\F1012\";\n}\n\n.mdi-bus-stop-covered::before {\n  content: \"\\F1013\";\n}\n\n.mdi-bus-stop-uncovered::before {\n  content: \"\\F1014\";\n}\n\n.mdi-butterfly::before {\n  content: \"\\F1589\";\n}\n\n.mdi-butterfly-outline::before {\n  content: \"\\F158A\";\n}\n\n.mdi-cabin-a-frame::before {\n  content: \"\\F188C\";\n}\n\n.mdi-cable-data::before {\n  content: \"\\F1394\";\n}\n\n.mdi-cached::before {\n  content: \"\\F00E8\";\n}\n\n.mdi-cactus::before {\n  content: \"\\F0DB5\";\n}\n\n.mdi-cake::before {\n  content: \"\\F00E9\";\n}\n\n.mdi-cake-layered::before {\n  content: \"\\F00EA\";\n}\n\n.mdi-cake-variant::before {\n  content: \"\\F00EB\";\n}\n\n.mdi-cake-variant-outline::before {\n  content: \"\\F17F0\";\n}\n\n.mdi-calculator::before {\n  content: \"\\F00EC\";\n}\n\n.mdi-calculator-variant::before {\n  content: \"\\F0A9A\";\n}\n\n.mdi-calculator-variant-outline::before {\n  content: \"\\F15A6\";\n}\n\n.mdi-calendar::before {\n  content: \"\\F00ED\";\n}\n\n.mdi-calendar-account::before {\n  content: \"\\F0ED7\";\n}\n\n.mdi-calendar-account-outline::before {\n  content: \"\\F0ED8\";\n}\n\n.mdi-calendar-alert::before {\n  content: \"\\F0A31\";\n}\n\n.mdi-calendar-arrow-left::before {\n  content: \"\\F1134\";\n}\n\n.mdi-calendar-arrow-right::before {\n  content: \"\\F1135\";\n}\n\n.mdi-calendar-blank::before {\n  content: \"\\F00EE\";\n}\n\n.mdi-calendar-blank-multiple::before {\n  content: \"\\F1073\";\n}\n\n.mdi-calendar-blank-outline::before {\n  content: \"\\F0B66\";\n}\n\n.mdi-calendar-check::before {\n  content: \"\\F00EF\";\n}\n\n.mdi-calendar-check-outline::before {\n  content: \"\\F0C44\";\n}\n\n.mdi-calendar-clock::before {\n  content: \"\\F00F0\";\n}\n\n.mdi-calendar-clock-outline::before {\n  content: \"\\F16E1\";\n}\n\n.mdi-calendar-collapse-horizontal::before {\n  content: \"\\F189D\";\n}\n\n.mdi-calendar-cursor::before {\n  content: \"\\F157B\";\n}\n\n.mdi-calendar-edit::before {\n  content: \"\\F08A7\";\n}\n\n.mdi-calendar-end::before {\n  content: \"\\F166C\";\n}\n\n.mdi-calendar-expand-horizontal::before {\n  content: \"\\F189E\";\n}\n\n.mdi-calendar-export::before {\n  content: \"\\F0B24\";\n}\n\n.mdi-calendar-heart::before {\n  content: \"\\F09D2\";\n}\n\n.mdi-calendar-import::before {\n  content: \"\\F0B25\";\n}\n\n.mdi-calendar-lock::before {\n  content: \"\\F1641\";\n}\n\n.mdi-calendar-lock-outline::before {\n  content: \"\\F1642\";\n}\n\n.mdi-calendar-minus::before {\n  content: \"\\F0D5C\";\n}\n\n.mdi-calendar-month::before {\n  content: \"\\F0E17\";\n}\n\n.mdi-calendar-month-outline::before {\n  content: \"\\F0E18\";\n}\n\n.mdi-calendar-multiple::before {\n  content: \"\\F00F1\";\n}\n\n.mdi-calendar-multiple-check::before {\n  content: \"\\F00F2\";\n}\n\n.mdi-calendar-multiselect::before {\n  content: \"\\F0A32\";\n}\n\n.mdi-calendar-outline::before {\n  content: \"\\F0B67\";\n}\n\n.mdi-calendar-plus::before {\n  content: \"\\F00F3\";\n}\n\n.mdi-calendar-question::before {\n  content: \"\\F0692\";\n}\n\n.mdi-calendar-range::before {\n  content: \"\\F0679\";\n}\n\n.mdi-calendar-range-outline::before {\n  content: \"\\F0B68\";\n}\n\n.mdi-calendar-refresh::before {\n  content: \"\\F01E1\";\n}\n\n.mdi-calendar-refresh-outline::before {\n  content: \"\\F0203\";\n}\n\n.mdi-calendar-remove::before {\n  content: \"\\F00F4\";\n}\n\n.mdi-calendar-remove-outline::before {\n  content: \"\\F0C45\";\n}\n\n.mdi-calendar-search::before {\n  content: \"\\F094C\";\n}\n\n.mdi-calendar-star::before {\n  content: \"\\F09D3\";\n}\n\n.mdi-calendar-start::before {\n  content: \"\\F166D\";\n}\n\n.mdi-calendar-sync::before {\n  content: \"\\F0E8E\";\n}\n\n.mdi-calendar-sync-outline::before {\n  content: \"\\F0E8F\";\n}\n\n.mdi-calendar-text::before {\n  content: \"\\F00F5\";\n}\n\n.mdi-calendar-text-outline::before {\n  content: \"\\F0C46\";\n}\n\n.mdi-calendar-today::before {\n  content: \"\\F00F6\";\n}\n\n.mdi-calendar-week::before {\n  content: \"\\F0A33\";\n}\n\n.mdi-calendar-week-begin::before {\n  content: \"\\F0A34\";\n}\n\n.mdi-calendar-weekend::before {\n  content: \"\\F0ED9\";\n}\n\n.mdi-calendar-weekend-outline::before {\n  content: \"\\F0EDA\";\n}\n\n.mdi-call-made::before {\n  content: \"\\F00F7\";\n}\n\n.mdi-call-merge::before {\n  content: \"\\F00F8\";\n}\n\n.mdi-call-missed::before {\n  content: \"\\F00F9\";\n}\n\n.mdi-call-received::before {\n  content: \"\\F00FA\";\n}\n\n.mdi-call-split::before {\n  content: \"\\F00FB\";\n}\n\n.mdi-camcorder::before {\n  content: \"\\F00FC\";\n}\n\n.mdi-camcorder-off::before {\n  content: \"\\F00FF\";\n}\n\n.mdi-camera::before {\n  content: \"\\F0100\";\n}\n\n.mdi-camera-account::before {\n  content: \"\\F08CB\";\n}\n\n.mdi-camera-burst::before {\n  content: \"\\F0693\";\n}\n\n.mdi-camera-control::before {\n  content: \"\\F0B69\";\n}\n\n.mdi-camera-document::before {\n  content: \"\\F1871\";\n}\n\n.mdi-camera-document-off::before {\n  content: \"\\F1872\";\n}\n\n.mdi-camera-enhance::before {\n  content: \"\\F0101\";\n}\n\n.mdi-camera-enhance-outline::before {\n  content: \"\\F0B6A\";\n}\n\n.mdi-camera-flip::before {\n  content: \"\\F15D9\";\n}\n\n.mdi-camera-flip-outline::before {\n  content: \"\\F15DA\";\n}\n\n.mdi-camera-front::before {\n  content: \"\\F0102\";\n}\n\n.mdi-camera-front-variant::before {\n  content: \"\\F0103\";\n}\n\n.mdi-camera-gopro::before {\n  content: \"\\F07A1\";\n}\n\n.mdi-camera-image::before {\n  content: \"\\F08CC\";\n}\n\n.mdi-camera-iris::before {\n  content: \"\\F0104\";\n}\n\n.mdi-camera-marker::before {\n  content: \"\\F19A7\";\n}\n\n.mdi-camera-marker-outline::before {\n  content: \"\\F19A8\";\n}\n\n.mdi-camera-metering-center::before {\n  content: \"\\F07A2\";\n}\n\n.mdi-camera-metering-matrix::before {\n  content: \"\\F07A3\";\n}\n\n.mdi-camera-metering-partial::before {\n  content: \"\\F07A4\";\n}\n\n.mdi-camera-metering-spot::before {\n  content: \"\\F07A5\";\n}\n\n.mdi-camera-off::before {\n  content: \"\\F05DF\";\n}\n\n.mdi-camera-off-outline::before {\n  content: \"\\F19BF\";\n}\n\n.mdi-camera-outline::before {\n  content: \"\\F0D5D\";\n}\n\n.mdi-camera-party-mode::before {\n  content: \"\\F0105\";\n}\n\n.mdi-camera-plus::before {\n  content: \"\\F0EDB\";\n}\n\n.mdi-camera-plus-outline::before {\n  content: \"\\F0EDC\";\n}\n\n.mdi-camera-rear::before {\n  content: \"\\F0106\";\n}\n\n.mdi-camera-rear-variant::before {\n  content: \"\\F0107\";\n}\n\n.mdi-camera-retake::before {\n  content: \"\\F0E19\";\n}\n\n.mdi-camera-retake-outline::before {\n  content: \"\\F0E1A\";\n}\n\n.mdi-camera-switch::before {\n  content: \"\\F0108\";\n}\n\n.mdi-camera-switch-outline::before {\n  content: \"\\F084A\";\n}\n\n.mdi-camera-timer::before {\n  content: \"\\F0109\";\n}\n\n.mdi-camera-wireless::before {\n  content: \"\\F0DB6\";\n}\n\n.mdi-camera-wireless-outline::before {\n  content: \"\\F0DB7\";\n}\n\n.mdi-campfire::before {\n  content: \"\\F0EDD\";\n}\n\n.mdi-cancel::before {\n  content: \"\\F073A\";\n}\n\n.mdi-candelabra::before {\n  content: \"\\F17D2\";\n}\n\n.mdi-candelabra-fire::before {\n  content: \"\\F17D3\";\n}\n\n.mdi-candle::before {\n  content: \"\\F05E2\";\n}\n\n.mdi-candy::before {\n  content: \"\\F1970\";\n}\n\n.mdi-candy-off::before {\n  content: \"\\F1971\";\n}\n\n.mdi-candy-off-outline::before {\n  content: \"\\F1972\";\n}\n\n.mdi-candy-outline::before {\n  content: \"\\F1973\";\n}\n\n.mdi-candycane::before {\n  content: \"\\F010A\";\n}\n\n.mdi-cannabis::before {\n  content: \"\\F07A6\";\n}\n\n.mdi-cannabis-off::before {\n  content: \"\\F166E\";\n}\n\n.mdi-caps-lock::before {\n  content: \"\\F0A9B\";\n}\n\n.mdi-car::before {\n  content: \"\\F010B\";\n}\n\n.mdi-car-2-plus::before {\n  content: \"\\F1015\";\n}\n\n.mdi-car-3-plus::before {\n  content: \"\\F1016\";\n}\n\n.mdi-car-arrow-left::before {\n  content: \"\\F13B2\";\n}\n\n.mdi-car-arrow-right::before {\n  content: \"\\F13B3\";\n}\n\n.mdi-car-back::before {\n  content: \"\\F0E1B\";\n}\n\n.mdi-car-battery::before {\n  content: \"\\F010C\";\n}\n\n.mdi-car-brake-abs::before {\n  content: \"\\F0C47\";\n}\n\n.mdi-car-brake-alert::before {\n  content: \"\\F0C48\";\n}\n\n.mdi-car-brake-fluid-level::before {\n  content: \"\\F1909\";\n}\n\n.mdi-car-brake-hold::before {\n  content: \"\\F0D5E\";\n}\n\n.mdi-car-brake-low-pressure::before {\n  content: \"\\F190A\";\n}\n\n.mdi-car-brake-parking::before {\n  content: \"\\F0D5F\";\n}\n\n.mdi-car-brake-retarder::before {\n  content: \"\\F1017\";\n}\n\n.mdi-car-brake-temperature::before {\n  content: \"\\F190B\";\n}\n\n.mdi-car-brake-worn-linings::before {\n  content: \"\\F190C\";\n}\n\n.mdi-car-child-seat::before {\n  content: \"\\F0FA3\";\n}\n\n.mdi-car-clock::before {\n  content: \"\\F1974\";\n}\n\n.mdi-car-clutch::before {\n  content: \"\\F1018\";\n}\n\n.mdi-car-cog::before {\n  content: \"\\F13CC\";\n}\n\n.mdi-car-connected::before {\n  content: \"\\F010D\";\n}\n\n.mdi-car-convertible::before {\n  content: \"\\F07A7\";\n}\n\n.mdi-car-coolant-level::before {\n  content: \"\\F1019\";\n}\n\n.mdi-car-cruise-control::before {\n  content: \"\\F0D60\";\n}\n\n.mdi-car-defrost-front::before {\n  content: \"\\F0D61\";\n}\n\n.mdi-car-defrost-rear::before {\n  content: \"\\F0D62\";\n}\n\n.mdi-car-door::before {\n  content: \"\\F0B6B\";\n}\n\n.mdi-car-door-lock::before {\n  content: \"\\F109D\";\n}\n\n.mdi-car-electric::before {\n  content: \"\\F0B6C\";\n}\n\n.mdi-car-electric-outline::before {\n  content: \"\\F15B5\";\n}\n\n.mdi-car-emergency::before {\n  content: \"\\F160F\";\n}\n\n.mdi-car-esp::before {\n  content: \"\\F0C49\";\n}\n\n.mdi-car-estate::before {\n  content: \"\\F07A8\";\n}\n\n.mdi-car-hatchback::before {\n  content: \"\\F07A9\";\n}\n\n.mdi-car-info::before {\n  content: \"\\F11BE\";\n}\n\n.mdi-car-key::before {\n  content: \"\\F0B6D\";\n}\n\n.mdi-car-lifted-pickup::before {\n  content: \"\\F152D\";\n}\n\n.mdi-car-light-alert::before {\n  content: \"\\F190D\";\n}\n\n.mdi-car-light-dimmed::before {\n  content: \"\\F0C4A\";\n}\n\n.mdi-car-light-fog::before {\n  content: \"\\F0C4B\";\n}\n\n.mdi-car-light-high::before {\n  content: \"\\F0C4C\";\n}\n\n.mdi-car-limousine::before {\n  content: \"\\F08CD\";\n}\n\n.mdi-car-multiple::before {\n  content: \"\\F0B6E\";\n}\n\n.mdi-car-off::before {\n  content: \"\\F0E1C\";\n}\n\n.mdi-car-outline::before {\n  content: \"\\F14ED\";\n}\n\n.mdi-car-parking-lights::before {\n  content: \"\\F0D63\";\n}\n\n.mdi-car-pickup::before {\n  content: \"\\F07AA\";\n}\n\n.mdi-car-seat::before {\n  content: \"\\F0FA4\";\n}\n\n.mdi-car-seat-cooler::before {\n  content: \"\\F0FA5\";\n}\n\n.mdi-car-seat-heater::before {\n  content: \"\\F0FA6\";\n}\n\n.mdi-car-select::before {\n  content: \"\\F1879\";\n}\n\n.mdi-car-settings::before {\n  content: \"\\F13CD\";\n}\n\n.mdi-car-shift-pattern::before {\n  content: \"\\F0F40\";\n}\n\n.mdi-car-side::before {\n  content: \"\\F07AB\";\n}\n\n.mdi-car-speed-limiter::before {\n  content: \"\\F190E\";\n}\n\n.mdi-car-sports::before {\n  content: \"\\F07AC\";\n}\n\n.mdi-car-tire-alert::before {\n  content: \"\\F0C4D\";\n}\n\n.mdi-car-traction-control::before {\n  content: \"\\F0D64\";\n}\n\n.mdi-car-turbocharger::before {\n  content: \"\\F101A\";\n}\n\n.mdi-car-wash::before {\n  content: \"\\F010E\";\n}\n\n.mdi-car-windshield::before {\n  content: \"\\F101B\";\n}\n\n.mdi-car-windshield-outline::before {\n  content: \"\\F101C\";\n}\n\n.mdi-car-wireless::before {\n  content: \"\\F1878\";\n}\n\n.mdi-car-wrench::before {\n  content: \"\\F1814\";\n}\n\n.mdi-carabiner::before {\n  content: \"\\F14C0\";\n}\n\n.mdi-caravan::before {\n  content: \"\\F07AD\";\n}\n\n.mdi-card::before {\n  content: \"\\F0B6F\";\n}\n\n.mdi-card-account-details::before {\n  content: \"\\F05D2\";\n}\n\n.mdi-card-account-details-outline::before {\n  content: \"\\F0DAB\";\n}\n\n.mdi-card-account-details-star::before {\n  content: \"\\F02A3\";\n}\n\n.mdi-card-account-details-star-outline::before {\n  content: \"\\F06DB\";\n}\n\n.mdi-card-account-mail::before {\n  content: \"\\F018E\";\n}\n\n.mdi-card-account-mail-outline::before {\n  content: \"\\F0E98\";\n}\n\n.mdi-card-account-phone::before {\n  content: \"\\F0E99\";\n}\n\n.mdi-card-account-phone-outline::before {\n  content: \"\\F0E9A\";\n}\n\n.mdi-card-bulleted::before {\n  content: \"\\F0B70\";\n}\n\n.mdi-card-bulleted-off::before {\n  content: \"\\F0B71\";\n}\n\n.mdi-card-bulleted-off-outline::before {\n  content: \"\\F0B72\";\n}\n\n.mdi-card-bulleted-outline::before {\n  content: \"\\F0B73\";\n}\n\n.mdi-card-bulleted-settings::before {\n  content: \"\\F0B74\";\n}\n\n.mdi-card-bulleted-settings-outline::before {\n  content: \"\\F0B75\";\n}\n\n.mdi-card-minus::before {\n  content: \"\\F1600\";\n}\n\n.mdi-card-minus-outline::before {\n  content: \"\\F1601\";\n}\n\n.mdi-card-multiple::before {\n  content: \"\\F17F1\";\n}\n\n.mdi-card-multiple-outline::before {\n  content: \"\\F17F2\";\n}\n\n.mdi-card-off::before {\n  content: \"\\F1602\";\n}\n\n.mdi-card-off-outline::before {\n  content: \"\\F1603\";\n}\n\n.mdi-card-outline::before {\n  content: \"\\F0B76\";\n}\n\n.mdi-card-plus::before {\n  content: \"\\F11FF\";\n}\n\n.mdi-card-plus-outline::before {\n  content: \"\\F1200\";\n}\n\n.mdi-card-remove::before {\n  content: \"\\F1604\";\n}\n\n.mdi-card-remove-outline::before {\n  content: \"\\F1605\";\n}\n\n.mdi-card-search::before {\n  content: \"\\F1074\";\n}\n\n.mdi-card-search-outline::before {\n  content: \"\\F1075\";\n}\n\n.mdi-card-text::before {\n  content: \"\\F0B77\";\n}\n\n.mdi-card-text-outline::before {\n  content: \"\\F0B78\";\n}\n\n.mdi-cards::before {\n  content: \"\\F0638\";\n}\n\n.mdi-cards-club::before {\n  content: \"\\F08CE\";\n}\n\n.mdi-cards-club-outline::before {\n  content: \"\\F189F\";\n}\n\n.mdi-cards-diamond::before {\n  content: \"\\F08CF\";\n}\n\n.mdi-cards-diamond-outline::before {\n  content: \"\\F101D\";\n}\n\n.mdi-cards-heart::before {\n  content: \"\\F08D0\";\n}\n\n.mdi-cards-heart-outline::before {\n  content: \"\\F18A0\";\n}\n\n.mdi-cards-outline::before {\n  content: \"\\F0639\";\n}\n\n.mdi-cards-playing::before {\n  content: \"\\F18A1\";\n}\n\n.mdi-cards-playing-club::before {\n  content: \"\\F18A2\";\n}\n\n.mdi-cards-playing-club-multiple::before {\n  content: \"\\F18A3\";\n}\n\n.mdi-cards-playing-club-multiple-outline::before {\n  content: \"\\F18A4\";\n}\n\n.mdi-cards-playing-club-outline::before {\n  content: \"\\F18A5\";\n}\n\n.mdi-cards-playing-diamond::before {\n  content: \"\\F18A6\";\n}\n\n.mdi-cards-playing-diamond-multiple::before {\n  content: \"\\F18A7\";\n}\n\n.mdi-cards-playing-diamond-multiple-outline::before {\n  content: \"\\F18A8\";\n}\n\n.mdi-cards-playing-diamond-outline::before {\n  content: \"\\F18A9\";\n}\n\n.mdi-cards-playing-heart::before {\n  content: \"\\F18AA\";\n}\n\n.mdi-cards-playing-heart-multiple::before {\n  content: \"\\F18AB\";\n}\n\n.mdi-cards-playing-heart-multiple-outline::before {\n  content: \"\\F18AC\";\n}\n\n.mdi-cards-playing-heart-outline::before {\n  content: \"\\F18AD\";\n}\n\n.mdi-cards-playing-outline::before {\n  content: \"\\F063A\";\n}\n\n.mdi-cards-playing-spade::before {\n  content: \"\\F18AE\";\n}\n\n.mdi-cards-playing-spade-multiple::before {\n  content: \"\\F18AF\";\n}\n\n.mdi-cards-playing-spade-multiple-outline::before {\n  content: \"\\F18B0\";\n}\n\n.mdi-cards-playing-spade-outline::before {\n  content: \"\\F18B1\";\n}\n\n.mdi-cards-spade::before {\n  content: \"\\F08D1\";\n}\n\n.mdi-cards-spade-outline::before {\n  content: \"\\F18B2\";\n}\n\n.mdi-cards-variant::before {\n  content: \"\\F06C7\";\n}\n\n.mdi-carrot::before {\n  content: \"\\F010F\";\n}\n\n.mdi-cart::before {\n  content: \"\\F0110\";\n}\n\n.mdi-cart-arrow-down::before {\n  content: \"\\F0D66\";\n}\n\n.mdi-cart-arrow-right::before {\n  content: \"\\F0C4E\";\n}\n\n.mdi-cart-arrow-up::before {\n  content: \"\\F0D67\";\n}\n\n.mdi-cart-check::before {\n  content: \"\\F15EA\";\n}\n\n.mdi-cart-heart::before {\n  content: \"\\F18E0\";\n}\n\n.mdi-cart-minus::before {\n  content: \"\\F0D68\";\n}\n\n.mdi-cart-off::before {\n  content: \"\\F066B\";\n}\n\n.mdi-cart-outline::before {\n  content: \"\\F0111\";\n}\n\n.mdi-cart-plus::before {\n  content: \"\\F0112\";\n}\n\n.mdi-cart-remove::before {\n  content: \"\\F0D69\";\n}\n\n.mdi-cart-variant::before {\n  content: \"\\F15EB\";\n}\n\n.mdi-case-sensitive-alt::before {\n  content: \"\\F0113\";\n}\n\n.mdi-cash::before {\n  content: \"\\F0114\";\n}\n\n.mdi-cash-100::before {\n  content: \"\\F0115\";\n}\n\n.mdi-cash-check::before {\n  content: \"\\F14EE\";\n}\n\n.mdi-cash-fast::before {\n  content: \"\\F185C\";\n}\n\n.mdi-cash-lock::before {\n  content: \"\\F14EA\";\n}\n\n.mdi-cash-lock-open::before {\n  content: \"\\F14EB\";\n}\n\n.mdi-cash-marker::before {\n  content: \"\\F0DB8\";\n}\n\n.mdi-cash-minus::before {\n  content: \"\\F1260\";\n}\n\n.mdi-cash-multiple::before {\n  content: \"\\F0116\";\n}\n\n.mdi-cash-plus::before {\n  content: \"\\F1261\";\n}\n\n.mdi-cash-refund::before {\n  content: \"\\F0A9C\";\n}\n\n.mdi-cash-register::before {\n  content: \"\\F0CF4\";\n}\n\n.mdi-cash-remove::before {\n  content: \"\\F1262\";\n}\n\n.mdi-cassette::before {\n  content: \"\\F09D4\";\n}\n\n.mdi-cast::before {\n  content: \"\\F0118\";\n}\n\n.mdi-cast-audio::before {\n  content: \"\\F101E\";\n}\n\n.mdi-cast-audio-variant::before {\n  content: \"\\F1749\";\n}\n\n.mdi-cast-connected::before {\n  content: \"\\F0119\";\n}\n\n.mdi-cast-education::before {\n  content: \"\\F0E1D\";\n}\n\n.mdi-cast-off::before {\n  content: \"\\F078A\";\n}\n\n.mdi-cast-variant::before {\n  content: \"\\F001F\";\n}\n\n.mdi-castle::before {\n  content: \"\\F011A\";\n}\n\n.mdi-cat::before {\n  content: \"\\F011B\";\n}\n\n.mdi-cctv::before {\n  content: \"\\F07AE\";\n}\n\n.mdi-cctv-off::before {\n  content: \"\\F185F\";\n}\n\n.mdi-ceiling-fan::before {\n  content: \"\\F1797\";\n}\n\n.mdi-ceiling-fan-light::before {\n  content: \"\\F1798\";\n}\n\n.mdi-ceiling-light::before {\n  content: \"\\F0769\";\n}\n\n.mdi-ceiling-light-multiple::before {\n  content: \"\\F18DD\";\n}\n\n.mdi-ceiling-light-multiple-outline::before {\n  content: \"\\F18DE\";\n}\n\n.mdi-ceiling-light-outline::before {\n  content: \"\\F17C7\";\n}\n\n.mdi-cellphone::before {\n  content: \"\\F011C\";\n}\n\n.mdi-cellphone-arrow-down::before {\n  content: \"\\F09D5\";\n}\n\n.mdi-cellphone-basic::before {\n  content: \"\\F011E\";\n}\n\n.mdi-cellphone-charging::before {\n  content: \"\\F1397\";\n}\n\n.mdi-cellphone-check::before {\n  content: \"\\F17FD\";\n}\n\n.mdi-cellphone-cog::before {\n  content: \"\\F0951\";\n}\n\n.mdi-cellphone-dock::before {\n  content: \"\\F011F\";\n}\n\n.mdi-cellphone-information::before {\n  content: \"\\F0F41\";\n}\n\n.mdi-cellphone-key::before {\n  content: \"\\F094E\";\n}\n\n.mdi-cellphone-link::before {\n  content: \"\\F0121\";\n}\n\n.mdi-cellphone-link-off::before {\n  content: \"\\F0122\";\n}\n\n.mdi-cellphone-lock::before {\n  content: \"\\F094F\";\n}\n\n.mdi-cellphone-marker::before {\n  content: \"\\F183A\";\n}\n\n.mdi-cellphone-message::before {\n  content: \"\\F08D3\";\n}\n\n.mdi-cellphone-message-off::before {\n  content: \"\\F10D2\";\n}\n\n.mdi-cellphone-nfc::before {\n  content: \"\\F0E90\";\n}\n\n.mdi-cellphone-nfc-off::before {\n  content: \"\\F12D8\";\n}\n\n.mdi-cellphone-off::before {\n  content: \"\\F0950\";\n}\n\n.mdi-cellphone-play::before {\n  content: \"\\F101F\";\n}\n\n.mdi-cellphone-remove::before {\n  content: \"\\F094D\";\n}\n\n.mdi-cellphone-screenshot::before {\n  content: \"\\F0A35\";\n}\n\n.mdi-cellphone-settings::before {\n  content: \"\\F0123\";\n}\n\n.mdi-cellphone-sound::before {\n  content: \"\\F0952\";\n}\n\n.mdi-cellphone-text::before {\n  content: \"\\F08D2\";\n}\n\n.mdi-cellphone-wireless::before {\n  content: \"\\F0815\";\n}\n\n.mdi-centos::before {\n  content: \"\\F111A\";\n}\n\n.mdi-certificate::before {\n  content: \"\\F0124\";\n}\n\n.mdi-certificate-outline::before {\n  content: \"\\F1188\";\n}\n\n.mdi-chair-rolling::before {\n  content: \"\\F0F48\";\n}\n\n.mdi-chair-school::before {\n  content: \"\\F0125\";\n}\n\n.mdi-chandelier::before {\n  content: \"\\F1793\";\n}\n\n.mdi-charity::before {\n  content: \"\\F0C4F\";\n}\n\n.mdi-chart-arc::before {\n  content: \"\\F0126\";\n}\n\n.mdi-chart-areaspline::before {\n  content: \"\\F0127\";\n}\n\n.mdi-chart-areaspline-variant::before {\n  content: \"\\F0E91\";\n}\n\n.mdi-chart-bar::before {\n  content: \"\\F0128\";\n}\n\n.mdi-chart-bar-stacked::before {\n  content: \"\\F076A\";\n}\n\n.mdi-chart-bell-curve::before {\n  content: \"\\F0C50\";\n}\n\n.mdi-chart-bell-curve-cumulative::before {\n  content: \"\\F0FA7\";\n}\n\n.mdi-chart-box::before {\n  content: \"\\F154D\";\n}\n\n.mdi-chart-box-outline::before {\n  content: \"\\F154E\";\n}\n\n.mdi-chart-box-plus-outline::before {\n  content: \"\\F154F\";\n}\n\n.mdi-chart-bubble::before {\n  content: \"\\F05E3\";\n}\n\n.mdi-chart-donut::before {\n  content: \"\\F07AF\";\n}\n\n.mdi-chart-donut-variant::before {\n  content: \"\\F07B0\";\n}\n\n.mdi-chart-gantt::before {\n  content: \"\\F066C\";\n}\n\n.mdi-chart-histogram::before {\n  content: \"\\F0129\";\n}\n\n.mdi-chart-line::before {\n  content: \"\\F012A\";\n}\n\n.mdi-chart-line-stacked::before {\n  content: \"\\F076B\";\n}\n\n.mdi-chart-line-variant::before {\n  content: \"\\F07B1\";\n}\n\n.mdi-chart-multiline::before {\n  content: \"\\F08D4\";\n}\n\n.mdi-chart-multiple::before {\n  content: \"\\F1213\";\n}\n\n.mdi-chart-pie::before {\n  content: \"\\F012B\";\n}\n\n.mdi-chart-ppf::before {\n  content: \"\\F1380\";\n}\n\n.mdi-chart-sankey::before {\n  content: \"\\F11DF\";\n}\n\n.mdi-chart-sankey-variant::before {\n  content: \"\\F11E0\";\n}\n\n.mdi-chart-scatter-plot::before {\n  content: \"\\F0E92\";\n}\n\n.mdi-chart-scatter-plot-hexbin::before {\n  content: \"\\F066D\";\n}\n\n.mdi-chart-timeline::before {\n  content: \"\\F066E\";\n}\n\n.mdi-chart-timeline-variant::before {\n  content: \"\\F0E93\";\n}\n\n.mdi-chart-timeline-variant-shimmer::before {\n  content: \"\\F15B6\";\n}\n\n.mdi-chart-tree::before {\n  content: \"\\F0E94\";\n}\n\n.mdi-chart-waterfall::before {\n  content: \"\\F1918\";\n}\n\n.mdi-chat::before {\n  content: \"\\F0B79\";\n}\n\n.mdi-chat-alert::before {\n  content: \"\\F0B7A\";\n}\n\n.mdi-chat-alert-outline::before {\n  content: \"\\F12C9\";\n}\n\n.mdi-chat-minus::before {\n  content: \"\\F1410\";\n}\n\n.mdi-chat-minus-outline::before {\n  content: \"\\F1413\";\n}\n\n.mdi-chat-outline::before {\n  content: \"\\F0EDE\";\n}\n\n.mdi-chat-plus::before {\n  content: \"\\F140F\";\n}\n\n.mdi-chat-plus-outline::before {\n  content: \"\\F1412\";\n}\n\n.mdi-chat-processing::before {\n  content: \"\\F0B7B\";\n}\n\n.mdi-chat-processing-outline::before {\n  content: \"\\F12CA\";\n}\n\n.mdi-chat-question::before {\n  content: \"\\F1738\";\n}\n\n.mdi-chat-question-outline::before {\n  content: \"\\F1739\";\n}\n\n.mdi-chat-remove::before {\n  content: \"\\F1411\";\n}\n\n.mdi-chat-remove-outline::before {\n  content: \"\\F1414\";\n}\n\n.mdi-chat-sleep::before {\n  content: \"\\F12D1\";\n}\n\n.mdi-chat-sleep-outline::before {\n  content: \"\\F12D2\";\n}\n\n.mdi-check::before {\n  content: \"\\F012C\";\n}\n\n.mdi-check-all::before {\n  content: \"\\F012D\";\n}\n\n.mdi-check-bold::before {\n  content: \"\\F0E1E\";\n}\n\n.mdi-check-circle::before {\n  content: \"\\F05E0\";\n}\n\n.mdi-check-circle-outline::before {\n  content: \"\\F05E1\";\n}\n\n.mdi-check-decagram::before {\n  content: \"\\F0791\";\n}\n\n.mdi-check-decagram-outline::before {\n  content: \"\\F1740\";\n}\n\n.mdi-check-network::before {\n  content: \"\\F0C53\";\n}\n\n.mdi-check-network-outline::before {\n  content: \"\\F0C54\";\n}\n\n.mdi-check-outline::before {\n  content: \"\\F0855\";\n}\n\n.mdi-check-underline::before {\n  content: \"\\F0E1F\";\n}\n\n.mdi-check-underline-circle::before {\n  content: \"\\F0E20\";\n}\n\n.mdi-check-underline-circle-outline::before {\n  content: \"\\F0E21\";\n}\n\n.mdi-checkbook::before {\n  content: \"\\F0A9D\";\n}\n\n.mdi-checkbox-blank::before {\n  content: \"\\F012E\";\n}\n\n.mdi-checkbox-blank-badge::before {\n  content: \"\\F1176\";\n}\n\n.mdi-checkbox-blank-badge-outline::before {\n  content: \"\\F0117\";\n}\n\n.mdi-checkbox-blank-circle::before {\n  content: \"\\F012F\";\n}\n\n.mdi-checkbox-blank-circle-outline::before {\n  content: \"\\F0130\";\n}\n\n.mdi-checkbox-blank-off::before {\n  content: \"\\F12EC\";\n}\n\n.mdi-checkbox-blank-off-outline::before {\n  content: \"\\F12ED\";\n}\n\n.mdi-checkbox-blank-outline::before {\n  content: \"\\F0131\";\n}\n\n.mdi-checkbox-intermediate::before {\n  content: \"\\F0856\";\n}\n\n.mdi-checkbox-marked::before {\n  content: \"\\F0132\";\n}\n\n.mdi-checkbox-marked-circle::before {\n  content: \"\\F0133\";\n}\n\n.mdi-checkbox-marked-circle-outline::before {\n  content: \"\\F0134\";\n}\n\n.mdi-checkbox-marked-circle-plus-outline::before {\n  content: \"\\F1927\";\n}\n\n.mdi-checkbox-marked-outline::before {\n  content: \"\\F0135\";\n}\n\n.mdi-checkbox-multiple-blank::before {\n  content: \"\\F0136\";\n}\n\n.mdi-checkbox-multiple-blank-circle::before {\n  content: \"\\F063B\";\n}\n\n.mdi-checkbox-multiple-blank-circle-outline::before {\n  content: \"\\F063C\";\n}\n\n.mdi-checkbox-multiple-blank-outline::before {\n  content: \"\\F0137\";\n}\n\n.mdi-checkbox-multiple-marked::before {\n  content: \"\\F0138\";\n}\n\n.mdi-checkbox-multiple-marked-circle::before {\n  content: \"\\F063D\";\n}\n\n.mdi-checkbox-multiple-marked-circle-outline::before {\n  content: \"\\F063E\";\n}\n\n.mdi-checkbox-multiple-marked-outline::before {\n  content: \"\\F0139\";\n}\n\n.mdi-checkbox-multiple-outline::before {\n  content: \"\\F0C51\";\n}\n\n.mdi-checkbox-outline::before {\n  content: \"\\F0C52\";\n}\n\n.mdi-checkerboard::before {\n  content: \"\\F013A\";\n}\n\n.mdi-checkerboard-minus::before {\n  content: \"\\F1202\";\n}\n\n.mdi-checkerboard-plus::before {\n  content: \"\\F1201\";\n}\n\n.mdi-checkerboard-remove::before {\n  content: \"\\F1203\";\n}\n\n.mdi-cheese::before {\n  content: \"\\F12B9\";\n}\n\n.mdi-cheese-off::before {\n  content: \"\\F13EE\";\n}\n\n.mdi-chef-hat::before {\n  content: \"\\F0B7C\";\n}\n\n.mdi-chemical-weapon::before {\n  content: \"\\F013B\";\n}\n\n.mdi-chess-bishop::before {\n  content: \"\\F085C\";\n}\n\n.mdi-chess-king::before {\n  content: \"\\F0857\";\n}\n\n.mdi-chess-knight::before {\n  content: \"\\F0858\";\n}\n\n.mdi-chess-pawn::before {\n  content: \"\\F0859\";\n}\n\n.mdi-chess-queen::before {\n  content: \"\\F085A\";\n}\n\n.mdi-chess-rook::before {\n  content: \"\\F085B\";\n}\n\n.mdi-chevron-double-down::before {\n  content: \"\\F013C\";\n}\n\n.mdi-chevron-double-left::before {\n  content: \"\\F013D\";\n}\n\n.mdi-chevron-double-right::before {\n  content: \"\\F013E\";\n}\n\n.mdi-chevron-double-up::before {\n  content: \"\\F013F\";\n}\n\n.mdi-chevron-down::before {\n  content: \"\\F0140\";\n}\n\n.mdi-chevron-down-box::before {\n  content: \"\\F09D6\";\n}\n\n.mdi-chevron-down-box-outline::before {\n  content: \"\\F09D7\";\n}\n\n.mdi-chevron-down-circle::before {\n  content: \"\\F0B26\";\n}\n\n.mdi-chevron-down-circle-outline::before {\n  content: \"\\F0B27\";\n}\n\n.mdi-chevron-left::before {\n  content: \"\\F0141\";\n}\n\n.mdi-chevron-left-box::before {\n  content: \"\\F09D8\";\n}\n\n.mdi-chevron-left-box-outline::before {\n  content: \"\\F09D9\";\n}\n\n.mdi-chevron-left-circle::before {\n  content: \"\\F0B28\";\n}\n\n.mdi-chevron-left-circle-outline::before {\n  content: \"\\F0B29\";\n}\n\n.mdi-chevron-right::before {\n  content: \"\\F0142\";\n}\n\n.mdi-chevron-right-box::before {\n  content: \"\\F09DA\";\n}\n\n.mdi-chevron-right-box-outline::before {\n  content: \"\\F09DB\";\n}\n\n.mdi-chevron-right-circle::before {\n  content: \"\\F0B2A\";\n}\n\n.mdi-chevron-right-circle-outline::before {\n  content: \"\\F0B2B\";\n}\n\n.mdi-chevron-triple-down::before {\n  content: \"\\F0DB9\";\n}\n\n.mdi-chevron-triple-left::before {\n  content: \"\\F0DBA\";\n}\n\n.mdi-chevron-triple-right::before {\n  content: \"\\F0DBB\";\n}\n\n.mdi-chevron-triple-up::before {\n  content: \"\\F0DBC\";\n}\n\n.mdi-chevron-up::before {\n  content: \"\\F0143\";\n}\n\n.mdi-chevron-up-box::before {\n  content: \"\\F09DC\";\n}\n\n.mdi-chevron-up-box-outline::before {\n  content: \"\\F09DD\";\n}\n\n.mdi-chevron-up-circle::before {\n  content: \"\\F0B2C\";\n}\n\n.mdi-chevron-up-circle-outline::before {\n  content: \"\\F0B2D\";\n}\n\n.mdi-chili-alert::before {\n  content: \"\\F17EA\";\n}\n\n.mdi-chili-alert-outline::before {\n  content: \"\\F17EB\";\n}\n\n.mdi-chili-hot::before {\n  content: \"\\F07B2\";\n}\n\n.mdi-chili-hot-outline::before {\n  content: \"\\F17EC\";\n}\n\n.mdi-chili-medium::before {\n  content: \"\\F07B3\";\n}\n\n.mdi-chili-medium-outline::before {\n  content: \"\\F17ED\";\n}\n\n.mdi-chili-mild::before {\n  content: \"\\F07B4\";\n}\n\n.mdi-chili-mild-outline::before {\n  content: \"\\F17EE\";\n}\n\n.mdi-chili-off::before {\n  content: \"\\F1467\";\n}\n\n.mdi-chili-off-outline::before {\n  content: \"\\F17EF\";\n}\n\n.mdi-chip::before {\n  content: \"\\F061A\";\n}\n\n.mdi-church::before {\n  content: \"\\F0144\";\n}\n\n.mdi-cigar::before {\n  content: \"\\F1189\";\n}\n\n.mdi-cigar-off::before {\n  content: \"\\F141B\";\n}\n\n.mdi-circle::before {\n  content: \"\\F0765\";\n}\n\n.mdi-circle-box::before {\n  content: \"\\F15DC\";\n}\n\n.mdi-circle-box-outline::before {\n  content: \"\\F15DD\";\n}\n\n.mdi-circle-double::before {\n  content: \"\\F0E95\";\n}\n\n.mdi-circle-edit-outline::before {\n  content: \"\\F08D5\";\n}\n\n.mdi-circle-expand::before {\n  content: \"\\F0E96\";\n}\n\n.mdi-circle-half::before {\n  content: \"\\F1395\";\n}\n\n.mdi-circle-half-full::before {\n  content: \"\\F1396\";\n}\n\n.mdi-circle-medium::before {\n  content: \"\\F09DE\";\n}\n\n.mdi-circle-multiple::before {\n  content: \"\\F0B38\";\n}\n\n.mdi-circle-multiple-outline::before {\n  content: \"\\F0695\";\n}\n\n.mdi-circle-off-outline::before {\n  content: \"\\F10D3\";\n}\n\n.mdi-circle-opacity::before {\n  content: \"\\F1853\";\n}\n\n.mdi-circle-outline::before {\n  content: \"\\F0766\";\n}\n\n.mdi-circle-slice-1::before {\n  content: \"\\F0A9E\";\n}\n\n.mdi-circle-slice-2::before {\n  content: \"\\F0A9F\";\n}\n\n.mdi-circle-slice-3::before {\n  content: \"\\F0AA0\";\n}\n\n.mdi-circle-slice-4::before {\n  content: \"\\F0AA1\";\n}\n\n.mdi-circle-slice-5::before {\n  content: \"\\F0AA2\";\n}\n\n.mdi-circle-slice-6::before {\n  content: \"\\F0AA3\";\n}\n\n.mdi-circle-slice-7::before {\n  content: \"\\F0AA4\";\n}\n\n.mdi-circle-slice-8::before {\n  content: \"\\F0AA5\";\n}\n\n.mdi-circle-small::before {\n  content: \"\\F09DF\";\n}\n\n.mdi-circular-saw::before {\n  content: \"\\F0E22\";\n}\n\n.mdi-city::before {\n  content: \"\\F0146\";\n}\n\n.mdi-city-variant::before {\n  content: \"\\F0A36\";\n}\n\n.mdi-city-variant-outline::before {\n  content: \"\\F0A37\";\n}\n\n.mdi-clipboard::before {\n  content: \"\\F0147\";\n}\n\n.mdi-clipboard-account::before {\n  content: \"\\F0148\";\n}\n\n.mdi-clipboard-account-outline::before {\n  content: \"\\F0C55\";\n}\n\n.mdi-clipboard-alert::before {\n  content: \"\\F0149\";\n}\n\n.mdi-clipboard-alert-outline::before {\n  content: \"\\F0CF7\";\n}\n\n.mdi-clipboard-arrow-down::before {\n  content: \"\\F014A\";\n}\n\n.mdi-clipboard-arrow-down-outline::before {\n  content: \"\\F0C56\";\n}\n\n.mdi-clipboard-arrow-left::before {\n  content: \"\\F014B\";\n}\n\n.mdi-clipboard-arrow-left-outline::before {\n  content: \"\\F0CF8\";\n}\n\n.mdi-clipboard-arrow-right::before {\n  content: \"\\F0CF9\";\n}\n\n.mdi-clipboard-arrow-right-outline::before {\n  content: \"\\F0CFA\";\n}\n\n.mdi-clipboard-arrow-up::before {\n  content: \"\\F0C57\";\n}\n\n.mdi-clipboard-arrow-up-outline::before {\n  content: \"\\F0C58\";\n}\n\n.mdi-clipboard-check::before {\n  content: \"\\F014E\";\n}\n\n.mdi-clipboard-check-multiple::before {\n  content: \"\\F1263\";\n}\n\n.mdi-clipboard-check-multiple-outline::before {\n  content: \"\\F1264\";\n}\n\n.mdi-clipboard-check-outline::before {\n  content: \"\\F08A8\";\n}\n\n.mdi-clipboard-clock::before {\n  content: \"\\F16E2\";\n}\n\n.mdi-clipboard-clock-outline::before {\n  content: \"\\F16E3\";\n}\n\n.mdi-clipboard-edit::before {\n  content: \"\\F14E5\";\n}\n\n.mdi-clipboard-edit-outline::before {\n  content: \"\\F14E6\";\n}\n\n.mdi-clipboard-file::before {\n  content: \"\\F1265\";\n}\n\n.mdi-clipboard-file-outline::before {\n  content: \"\\F1266\";\n}\n\n.mdi-clipboard-flow::before {\n  content: \"\\F06C8\";\n}\n\n.mdi-clipboard-flow-outline::before {\n  content: \"\\F1117\";\n}\n\n.mdi-clipboard-list::before {\n  content: \"\\F10D4\";\n}\n\n.mdi-clipboard-list-outline::before {\n  content: \"\\F10D5\";\n}\n\n.mdi-clipboard-minus::before {\n  content: \"\\F1618\";\n}\n\n.mdi-clipboard-minus-outline::before {\n  content: \"\\F1619\";\n}\n\n.mdi-clipboard-multiple::before {\n  content: \"\\F1267\";\n}\n\n.mdi-clipboard-multiple-outline::before {\n  content: \"\\F1268\";\n}\n\n.mdi-clipboard-off::before {\n  content: \"\\F161A\";\n}\n\n.mdi-clipboard-off-outline::before {\n  content: \"\\F161B\";\n}\n\n.mdi-clipboard-outline::before {\n  content: \"\\F014C\";\n}\n\n.mdi-clipboard-play::before {\n  content: \"\\F0C59\";\n}\n\n.mdi-clipboard-play-multiple::before {\n  content: \"\\F1269\";\n}\n\n.mdi-clipboard-play-multiple-outline::before {\n  content: \"\\F126A\";\n}\n\n.mdi-clipboard-play-outline::before {\n  content: \"\\F0C5A\";\n}\n\n.mdi-clipboard-plus::before {\n  content: \"\\F0751\";\n}\n\n.mdi-clipboard-plus-outline::before {\n  content: \"\\F131F\";\n}\n\n.mdi-clipboard-pulse::before {\n  content: \"\\F085D\";\n}\n\n.mdi-clipboard-pulse-outline::before {\n  content: \"\\F085E\";\n}\n\n.mdi-clipboard-remove::before {\n  content: \"\\F161C\";\n}\n\n.mdi-clipboard-remove-outline::before {\n  content: \"\\F161D\";\n}\n\n.mdi-clipboard-search::before {\n  content: \"\\F161E\";\n}\n\n.mdi-clipboard-search-outline::before {\n  content: \"\\F161F\";\n}\n\n.mdi-clipboard-text::before {\n  content: \"\\F014D\";\n}\n\n.mdi-clipboard-text-clock::before {\n  content: \"\\F18F9\";\n}\n\n.mdi-clipboard-text-clock-outline::before {\n  content: \"\\F18FA\";\n}\n\n.mdi-clipboard-text-multiple::before {\n  content: \"\\F126B\";\n}\n\n.mdi-clipboard-text-multiple-outline::before {\n  content: \"\\F126C\";\n}\n\n.mdi-clipboard-text-off::before {\n  content: \"\\F1620\";\n}\n\n.mdi-clipboard-text-off-outline::before {\n  content: \"\\F1621\";\n}\n\n.mdi-clipboard-text-outline::before {\n  content: \"\\F0A38\";\n}\n\n.mdi-clipboard-text-play::before {\n  content: \"\\F0C5B\";\n}\n\n.mdi-clipboard-text-play-outline::before {\n  content: \"\\F0C5C\";\n}\n\n.mdi-clipboard-text-search::before {\n  content: \"\\F1622\";\n}\n\n.mdi-clipboard-text-search-outline::before {\n  content: \"\\F1623\";\n}\n\n.mdi-clippy::before {\n  content: \"\\F014F\";\n}\n\n.mdi-clock::before {\n  content: \"\\F0954\";\n}\n\n.mdi-clock-alert::before {\n  content: \"\\F0955\";\n}\n\n.mdi-clock-alert-outline::before {\n  content: \"\\F05CE\";\n}\n\n.mdi-clock-check::before {\n  content: \"\\F0FA8\";\n}\n\n.mdi-clock-check-outline::before {\n  content: \"\\F0FA9\";\n}\n\n.mdi-clock-digital::before {\n  content: \"\\F0E97\";\n}\n\n.mdi-clock-edit::before {\n  content: \"\\F19BA\";\n}\n\n.mdi-clock-edit-outline::before {\n  content: \"\\F19BB\";\n}\n\n.mdi-clock-end::before {\n  content: \"\\F0151\";\n}\n\n.mdi-clock-fast::before {\n  content: \"\\F0152\";\n}\n\n.mdi-clock-in::before {\n  content: \"\\F0153\";\n}\n\n.mdi-clock-minus::before {\n  content: \"\\F1863\";\n}\n\n.mdi-clock-minus-outline::before {\n  content: \"\\F1864\";\n}\n\n.mdi-clock-out::before {\n  content: \"\\F0154\";\n}\n\n.mdi-clock-outline::before {\n  content: \"\\F0150\";\n}\n\n.mdi-clock-plus::before {\n  content: \"\\F1861\";\n}\n\n.mdi-clock-plus-outline::before {\n  content: \"\\F1862\";\n}\n\n.mdi-clock-remove::before {\n  content: \"\\F1865\";\n}\n\n.mdi-clock-remove-outline::before {\n  content: \"\\F1866\";\n}\n\n.mdi-clock-start::before {\n  content: \"\\F0155\";\n}\n\n.mdi-clock-time-eight::before {\n  content: \"\\F1446\";\n}\n\n.mdi-clock-time-eight-outline::before {\n  content: \"\\F1452\";\n}\n\n.mdi-clock-time-eleven::before {\n  content: \"\\F1449\";\n}\n\n.mdi-clock-time-eleven-outline::before {\n  content: \"\\F1455\";\n}\n\n.mdi-clock-time-five::before {\n  content: \"\\F1443\";\n}\n\n.mdi-clock-time-five-outline::before {\n  content: \"\\F144F\";\n}\n\n.mdi-clock-time-four::before {\n  content: \"\\F1442\";\n}\n\n.mdi-clock-time-four-outline::before {\n  content: \"\\F144E\";\n}\n\n.mdi-clock-time-nine::before {\n  content: \"\\F1447\";\n}\n\n.mdi-clock-time-nine-outline::before {\n  content: \"\\F1453\";\n}\n\n.mdi-clock-time-one::before {\n  content: \"\\F143F\";\n}\n\n.mdi-clock-time-one-outline::before {\n  content: \"\\F144B\";\n}\n\n.mdi-clock-time-seven::before {\n  content: \"\\F1445\";\n}\n\n.mdi-clock-time-seven-outline::before {\n  content: \"\\F1451\";\n}\n\n.mdi-clock-time-six::before {\n  content: \"\\F1444\";\n}\n\n.mdi-clock-time-six-outline::before {\n  content: \"\\F1450\";\n}\n\n.mdi-clock-time-ten::before {\n  content: \"\\F1448\";\n}\n\n.mdi-clock-time-ten-outline::before {\n  content: \"\\F1454\";\n}\n\n.mdi-clock-time-three::before {\n  content: \"\\F1441\";\n}\n\n.mdi-clock-time-three-outline::before {\n  content: \"\\F144D\";\n}\n\n.mdi-clock-time-twelve::before {\n  content: \"\\F144A\";\n}\n\n.mdi-clock-time-twelve-outline::before {\n  content: \"\\F1456\";\n}\n\n.mdi-clock-time-two::before {\n  content: \"\\F1440\";\n}\n\n.mdi-clock-time-two-outline::before {\n  content: \"\\F144C\";\n}\n\n.mdi-close::before {\n  content: \"\\F0156\";\n}\n\n.mdi-close-box::before {\n  content: \"\\F0157\";\n}\n\n.mdi-close-box-multiple::before {\n  content: \"\\F0C5D\";\n}\n\n.mdi-close-box-multiple-outline::before {\n  content: \"\\F0C5E\";\n}\n\n.mdi-close-box-outline::before {\n  content: \"\\F0158\";\n}\n\n.mdi-close-circle::before {\n  content: \"\\F0159\";\n}\n\n.mdi-close-circle-multiple::before {\n  content: \"\\F062A\";\n}\n\n.mdi-close-circle-multiple-outline::before {\n  content: \"\\F0883\";\n}\n\n.mdi-close-circle-outline::before {\n  content: \"\\F015A\";\n}\n\n.mdi-close-network::before {\n  content: \"\\F015B\";\n}\n\n.mdi-close-network-outline::before {\n  content: \"\\F0C5F\";\n}\n\n.mdi-close-octagon::before {\n  content: \"\\F015C\";\n}\n\n.mdi-close-octagon-outline::before {\n  content: \"\\F015D\";\n}\n\n.mdi-close-outline::before {\n  content: \"\\F06C9\";\n}\n\n.mdi-close-thick::before {\n  content: \"\\F1398\";\n}\n\n.mdi-closed-caption::before {\n  content: \"\\F015E\";\n}\n\n.mdi-closed-caption-outline::before {\n  content: \"\\F0DBD\";\n}\n\n.mdi-cloud::before {\n  content: \"\\F015F\";\n}\n\n.mdi-cloud-alert::before {\n  content: \"\\F09E0\";\n}\n\n.mdi-cloud-braces::before {\n  content: \"\\F07B5\";\n}\n\n.mdi-cloud-check::before {\n  content: \"\\F0160\";\n}\n\n.mdi-cloud-check-outline::before {\n  content: \"\\F12CC\";\n}\n\n.mdi-cloud-circle::before {\n  content: \"\\F0161\";\n}\n\n.mdi-cloud-download::before {\n  content: \"\\F0162\";\n}\n\n.mdi-cloud-download-outline::before {\n  content: \"\\F0B7D\";\n}\n\n.mdi-cloud-lock::before {\n  content: \"\\F11F1\";\n}\n\n.mdi-cloud-lock-outline::before {\n  content: \"\\F11F2\";\n}\n\n.mdi-cloud-off-outline::before {\n  content: \"\\F0164\";\n}\n\n.mdi-cloud-outline::before {\n  content: \"\\F0163\";\n}\n\n.mdi-cloud-print::before {\n  content: \"\\F0165\";\n}\n\n.mdi-cloud-print-outline::before {\n  content: \"\\F0166\";\n}\n\n.mdi-cloud-question::before {\n  content: \"\\F0A39\";\n}\n\n.mdi-cloud-refresh::before {\n  content: \"\\F052A\";\n}\n\n.mdi-cloud-search::before {\n  content: \"\\F0956\";\n}\n\n.mdi-cloud-search-outline::before {\n  content: \"\\F0957\";\n}\n\n.mdi-cloud-sync::before {\n  content: \"\\F063F\";\n}\n\n.mdi-cloud-sync-outline::before {\n  content: \"\\F12D6\";\n}\n\n.mdi-cloud-tags::before {\n  content: \"\\F07B6\";\n}\n\n.mdi-cloud-upload::before {\n  content: \"\\F0167\";\n}\n\n.mdi-cloud-upload-outline::before {\n  content: \"\\F0B7E\";\n}\n\n.mdi-clover::before {\n  content: \"\\F0816\";\n}\n\n.mdi-coach-lamp::before {\n  content: \"\\F1020\";\n}\n\n.mdi-coat-rack::before {\n  content: \"\\F109E\";\n}\n\n.mdi-code-array::before {\n  content: \"\\F0168\";\n}\n\n.mdi-code-braces::before {\n  content: \"\\F0169\";\n}\n\n.mdi-code-braces-box::before {\n  content: \"\\F10D6\";\n}\n\n.mdi-code-brackets::before {\n  content: \"\\F016A\";\n}\n\n.mdi-code-equal::before {\n  content: \"\\F016B\";\n}\n\n.mdi-code-greater-than::before {\n  content: \"\\F016C\";\n}\n\n.mdi-code-greater-than-or-equal::before {\n  content: \"\\F016D\";\n}\n\n.mdi-code-json::before {\n  content: \"\\F0626\";\n}\n\n.mdi-code-less-than::before {\n  content: \"\\F016E\";\n}\n\n.mdi-code-less-than-or-equal::before {\n  content: \"\\F016F\";\n}\n\n.mdi-code-not-equal::before {\n  content: \"\\F0170\";\n}\n\n.mdi-code-not-equal-variant::before {\n  content: \"\\F0171\";\n}\n\n.mdi-code-parentheses::before {\n  content: \"\\F0172\";\n}\n\n.mdi-code-parentheses-box::before {\n  content: \"\\F10D7\";\n}\n\n.mdi-code-string::before {\n  content: \"\\F0173\";\n}\n\n.mdi-code-tags::before {\n  content: \"\\F0174\";\n}\n\n.mdi-code-tags-check::before {\n  content: \"\\F0694\";\n}\n\n.mdi-codepen::before {\n  content: \"\\F0175\";\n}\n\n.mdi-coffee::before {\n  content: \"\\F0176\";\n}\n\n.mdi-coffee-maker::before {\n  content: \"\\F109F\";\n}\n\n.mdi-coffee-maker-check::before {\n  content: \"\\F1931\";\n}\n\n.mdi-coffee-maker-check-outline::before {\n  content: \"\\F1932\";\n}\n\n.mdi-coffee-maker-outline::before {\n  content: \"\\F181B\";\n}\n\n.mdi-coffee-off::before {\n  content: \"\\F0FAA\";\n}\n\n.mdi-coffee-off-outline::before {\n  content: \"\\F0FAB\";\n}\n\n.mdi-coffee-outline::before {\n  content: \"\\F06CA\";\n}\n\n.mdi-coffee-to-go::before {\n  content: \"\\F0177\";\n}\n\n.mdi-coffee-to-go-outline::before {\n  content: \"\\F130E\";\n}\n\n.mdi-coffin::before {\n  content: \"\\F0B7F\";\n}\n\n.mdi-cog::before {\n  content: \"\\F0493\";\n}\n\n.mdi-cog-box::before {\n  content: \"\\F0494\";\n}\n\n.mdi-cog-clockwise::before {\n  content: \"\\F11DD\";\n}\n\n.mdi-cog-counterclockwise::before {\n  content: \"\\F11DE\";\n}\n\n.mdi-cog-off::before {\n  content: \"\\F13CE\";\n}\n\n.mdi-cog-off-outline::before {\n  content: \"\\F13CF\";\n}\n\n.mdi-cog-outline::before {\n  content: \"\\F08BB\";\n}\n\n.mdi-cog-pause::before {\n  content: \"\\F1933\";\n}\n\n.mdi-cog-pause-outline::before {\n  content: \"\\F1934\";\n}\n\n.mdi-cog-play::before {\n  content: \"\\F1935\";\n}\n\n.mdi-cog-play-outline::before {\n  content: \"\\F1936\";\n}\n\n.mdi-cog-refresh::before {\n  content: \"\\F145E\";\n}\n\n.mdi-cog-refresh-outline::before {\n  content: \"\\F145F\";\n}\n\n.mdi-cog-stop::before {\n  content: \"\\F1937\";\n}\n\n.mdi-cog-stop-outline::before {\n  content: \"\\F1938\";\n}\n\n.mdi-cog-sync::before {\n  content: \"\\F1460\";\n}\n\n.mdi-cog-sync-outline::before {\n  content: \"\\F1461\";\n}\n\n.mdi-cog-transfer::before {\n  content: \"\\F105B\";\n}\n\n.mdi-cog-transfer-outline::before {\n  content: \"\\F105C\";\n}\n\n.mdi-cogs::before {\n  content: \"\\F08D6\";\n}\n\n.mdi-collage::before {\n  content: \"\\F0640\";\n}\n\n.mdi-collapse-all::before {\n  content: \"\\F0AA6\";\n}\n\n.mdi-collapse-all-outline::before {\n  content: \"\\F0AA7\";\n}\n\n.mdi-color-helper::before {\n  content: \"\\F0179\";\n}\n\n.mdi-comma::before {\n  content: \"\\F0E23\";\n}\n\n.mdi-comma-box::before {\n  content: \"\\F0E2B\";\n}\n\n.mdi-comma-box-outline::before {\n  content: \"\\F0E24\";\n}\n\n.mdi-comma-circle::before {\n  content: \"\\F0E25\";\n}\n\n.mdi-comma-circle-outline::before {\n  content: \"\\F0E26\";\n}\n\n.mdi-comment::before {\n  content: \"\\F017A\";\n}\n\n.mdi-comment-account::before {\n  content: \"\\F017B\";\n}\n\n.mdi-comment-account-outline::before {\n  content: \"\\F017C\";\n}\n\n.mdi-comment-alert::before {\n  content: \"\\F017D\";\n}\n\n.mdi-comment-alert-outline::before {\n  content: \"\\F017E\";\n}\n\n.mdi-comment-arrow-left::before {\n  content: \"\\F09E1\";\n}\n\n.mdi-comment-arrow-left-outline::before {\n  content: \"\\F09E2\";\n}\n\n.mdi-comment-arrow-right::before {\n  content: \"\\F09E3\";\n}\n\n.mdi-comment-arrow-right-outline::before {\n  content: \"\\F09E4\";\n}\n\n.mdi-comment-bookmark::before {\n  content: \"\\F15AE\";\n}\n\n.mdi-comment-bookmark-outline::before {\n  content: \"\\F15AF\";\n}\n\n.mdi-comment-check::before {\n  content: \"\\F017F\";\n}\n\n.mdi-comment-check-outline::before {\n  content: \"\\F0180\";\n}\n\n.mdi-comment-edit::before {\n  content: \"\\F11BF\";\n}\n\n.mdi-comment-edit-outline::before {\n  content: \"\\F12C4\";\n}\n\n.mdi-comment-eye::before {\n  content: \"\\F0A3A\";\n}\n\n.mdi-comment-eye-outline::before {\n  content: \"\\F0A3B\";\n}\n\n.mdi-comment-flash::before {\n  content: \"\\F15B0\";\n}\n\n.mdi-comment-flash-outline::before {\n  content: \"\\F15B1\";\n}\n\n.mdi-comment-minus::before {\n  content: \"\\F15DF\";\n}\n\n.mdi-comment-minus-outline::before {\n  content: \"\\F15E0\";\n}\n\n.mdi-comment-multiple::before {\n  content: \"\\F085F\";\n}\n\n.mdi-comment-multiple-outline::before {\n  content: \"\\F0181\";\n}\n\n.mdi-comment-off::before {\n  content: \"\\F15E1\";\n}\n\n.mdi-comment-off-outline::before {\n  content: \"\\F15E2\";\n}\n\n.mdi-comment-outline::before {\n  content: \"\\F0182\";\n}\n\n.mdi-comment-plus::before {\n  content: \"\\F09E5\";\n}\n\n.mdi-comment-plus-outline::before {\n  content: \"\\F0183\";\n}\n\n.mdi-comment-processing::before {\n  content: \"\\F0184\";\n}\n\n.mdi-comment-processing-outline::before {\n  content: \"\\F0185\";\n}\n\n.mdi-comment-question::before {\n  content: \"\\F0817\";\n}\n\n.mdi-comment-question-outline::before {\n  content: \"\\F0186\";\n}\n\n.mdi-comment-quote::before {\n  content: \"\\F1021\";\n}\n\n.mdi-comment-quote-outline::before {\n  content: \"\\F1022\";\n}\n\n.mdi-comment-remove::before {\n  content: \"\\F05DE\";\n}\n\n.mdi-comment-remove-outline::before {\n  content: \"\\F0187\";\n}\n\n.mdi-comment-search::before {\n  content: \"\\F0A3C\";\n}\n\n.mdi-comment-search-outline::before {\n  content: \"\\F0A3D\";\n}\n\n.mdi-comment-text::before {\n  content: \"\\F0188\";\n}\n\n.mdi-comment-text-multiple::before {\n  content: \"\\F0860\";\n}\n\n.mdi-comment-text-multiple-outline::before {\n  content: \"\\F0861\";\n}\n\n.mdi-comment-text-outline::before {\n  content: \"\\F0189\";\n}\n\n.mdi-compare::before {\n  content: \"\\F018A\";\n}\n\n.mdi-compare-horizontal::before {\n  content: \"\\F1492\";\n}\n\n.mdi-compare-remove::before {\n  content: \"\\F18B3\";\n}\n\n.mdi-compare-vertical::before {\n  content: \"\\F1493\";\n}\n\n.mdi-compass::before {\n  content: \"\\F018B\";\n}\n\n.mdi-compass-off::before {\n  content: \"\\F0B80\";\n}\n\n.mdi-compass-off-outline::before {\n  content: \"\\F0B81\";\n}\n\n.mdi-compass-outline::before {\n  content: \"\\F018C\";\n}\n\n.mdi-compass-rose::before {\n  content: \"\\F1382\";\n}\n\n.mdi-cone::before {\n  content: \"\\F194C\";\n}\n\n.mdi-cone-off::before {\n  content: \"\\F194D\";\n}\n\n.mdi-connection::before {\n  content: \"\\F1616\";\n}\n\n.mdi-console::before {\n  content: \"\\F018D\";\n}\n\n.mdi-console-line::before {\n  content: \"\\F07B7\";\n}\n\n.mdi-console-network::before {\n  content: \"\\F08A9\";\n}\n\n.mdi-console-network-outline::before {\n  content: \"\\F0C60\";\n}\n\n.mdi-consolidate::before {\n  content: \"\\F10D8\";\n}\n\n.mdi-contactless-payment::before {\n  content: \"\\F0D6A\";\n}\n\n.mdi-contactless-payment-circle::before {\n  content: \"\\F0321\";\n}\n\n.mdi-contactless-payment-circle-outline::before {\n  content: \"\\F0408\";\n}\n\n.mdi-contacts::before {\n  content: \"\\F06CB\";\n}\n\n.mdi-contacts-outline::before {\n  content: \"\\F05B8\";\n}\n\n.mdi-contain::before {\n  content: \"\\F0A3E\";\n}\n\n.mdi-contain-end::before {\n  content: \"\\F0A3F\";\n}\n\n.mdi-contain-start::before {\n  content: \"\\F0A40\";\n}\n\n.mdi-content-copy::before {\n  content: \"\\F018F\";\n}\n\n.mdi-content-cut::before {\n  content: \"\\F0190\";\n}\n\n.mdi-content-duplicate::before {\n  content: \"\\F0191\";\n}\n\n.mdi-content-paste::before {\n  content: \"\\F0192\";\n}\n\n.mdi-content-save::before {\n  content: \"\\F0193\";\n}\n\n.mdi-content-save-alert::before {\n  content: \"\\F0F42\";\n}\n\n.mdi-content-save-alert-outline::before {\n  content: \"\\F0F43\";\n}\n\n.mdi-content-save-all::before {\n  content: \"\\F0194\";\n}\n\n.mdi-content-save-all-outline::before {\n  content: \"\\F0F44\";\n}\n\n.mdi-content-save-check::before {\n  content: \"\\F18EA\";\n}\n\n.mdi-content-save-check-outline::before {\n  content: \"\\F18EB\";\n}\n\n.mdi-content-save-cog::before {\n  content: \"\\F145B\";\n}\n\n.mdi-content-save-cog-outline::before {\n  content: \"\\F145C\";\n}\n\n.mdi-content-save-edit::before {\n  content: \"\\F0CFB\";\n}\n\n.mdi-content-save-edit-outline::before {\n  content: \"\\F0CFC\";\n}\n\n.mdi-content-save-move::before {\n  content: \"\\F0E27\";\n}\n\n.mdi-content-save-move-outline::before {\n  content: \"\\F0E28\";\n}\n\n.mdi-content-save-off::before {\n  content: \"\\F1643\";\n}\n\n.mdi-content-save-off-outline::before {\n  content: \"\\F1644\";\n}\n\n.mdi-content-save-outline::before {\n  content: \"\\F0818\";\n}\n\n.mdi-content-save-settings::before {\n  content: \"\\F061B\";\n}\n\n.mdi-content-save-settings-outline::before {\n  content: \"\\F0B2E\";\n}\n\n.mdi-contrast::before {\n  content: \"\\F0195\";\n}\n\n.mdi-contrast-box::before {\n  content: \"\\F0196\";\n}\n\n.mdi-contrast-circle::before {\n  content: \"\\F0197\";\n}\n\n.mdi-controller-classic::before {\n  content: \"\\F0B82\";\n}\n\n.mdi-controller-classic-outline::before {\n  content: \"\\F0B83\";\n}\n\n.mdi-cookie::before {\n  content: \"\\F0198\";\n}\n\n.mdi-cookie-alert::before {\n  content: \"\\F16D0\";\n}\n\n.mdi-cookie-alert-outline::before {\n  content: \"\\F16D1\";\n}\n\n.mdi-cookie-check::before {\n  content: \"\\F16D2\";\n}\n\n.mdi-cookie-check-outline::before {\n  content: \"\\F16D3\";\n}\n\n.mdi-cookie-clock::before {\n  content: \"\\F16E4\";\n}\n\n.mdi-cookie-clock-outline::before {\n  content: \"\\F16E5\";\n}\n\n.mdi-cookie-cog::before {\n  content: \"\\F16D4\";\n}\n\n.mdi-cookie-cog-outline::before {\n  content: \"\\F16D5\";\n}\n\n.mdi-cookie-edit::before {\n  content: \"\\F16E6\";\n}\n\n.mdi-cookie-edit-outline::before {\n  content: \"\\F16E7\";\n}\n\n.mdi-cookie-lock::before {\n  content: \"\\F16E8\";\n}\n\n.mdi-cookie-lock-outline::before {\n  content: \"\\F16E9\";\n}\n\n.mdi-cookie-minus::before {\n  content: \"\\F16DA\";\n}\n\n.mdi-cookie-minus-outline::before {\n  content: \"\\F16DB\";\n}\n\n.mdi-cookie-off::before {\n  content: \"\\F16EA\";\n}\n\n.mdi-cookie-off-outline::before {\n  content: \"\\F16EB\";\n}\n\n.mdi-cookie-outline::before {\n  content: \"\\F16DE\";\n}\n\n.mdi-cookie-plus::before {\n  content: \"\\F16D6\";\n}\n\n.mdi-cookie-plus-outline::before {\n  content: \"\\F16D7\";\n}\n\n.mdi-cookie-refresh::before {\n  content: \"\\F16EC\";\n}\n\n.mdi-cookie-refresh-outline::before {\n  content: \"\\F16ED\";\n}\n\n.mdi-cookie-remove::before {\n  content: \"\\F16D8\";\n}\n\n.mdi-cookie-remove-outline::before {\n  content: \"\\F16D9\";\n}\n\n.mdi-cookie-settings::before {\n  content: \"\\F16DC\";\n}\n\n.mdi-cookie-settings-outline::before {\n  content: \"\\F16DD\";\n}\n\n.mdi-coolant-temperature::before {\n  content: \"\\F03C8\";\n}\n\n.mdi-copyleft::before {\n  content: \"\\F1939\";\n}\n\n.mdi-copyright::before {\n  content: \"\\F05E6\";\n}\n\n.mdi-cordova::before {\n  content: \"\\F0958\";\n}\n\n.mdi-corn::before {\n  content: \"\\F07B8\";\n}\n\n.mdi-corn-off::before {\n  content: \"\\F13EF\";\n}\n\n.mdi-cosine-wave::before {\n  content: \"\\F1479\";\n}\n\n.mdi-counter::before {\n  content: \"\\F0199\";\n}\n\n.mdi-countertop::before {\n  content: \"\\F181C\";\n}\n\n.mdi-countertop-outline::before {\n  content: \"\\F181D\";\n}\n\n.mdi-cow::before {\n  content: \"\\F019A\";\n}\n\n.mdi-cow-off::before {\n  content: \"\\F18FC\";\n}\n\n.mdi-cpu-32-bit::before {\n  content: \"\\F0EDF\";\n}\n\n.mdi-cpu-64-bit::before {\n  content: \"\\F0EE0\";\n}\n\n.mdi-cradle::before {\n  content: \"\\F198B\";\n}\n\n.mdi-cradle-outline::before {\n  content: \"\\F1991\";\n}\n\n.mdi-crane::before {\n  content: \"\\F0862\";\n}\n\n.mdi-creation::before {\n  content: \"\\F0674\";\n}\n\n.mdi-creative-commons::before {\n  content: \"\\F0D6B\";\n}\n\n.mdi-credit-card::before {\n  content: \"\\F0FEF\";\n}\n\n.mdi-credit-card-check::before {\n  content: \"\\F13D0\";\n}\n\n.mdi-credit-card-check-outline::before {\n  content: \"\\F13D1\";\n}\n\n.mdi-credit-card-chip::before {\n  content: \"\\F190F\";\n}\n\n.mdi-credit-card-chip-outline::before {\n  content: \"\\F1910\";\n}\n\n.mdi-credit-card-clock::before {\n  content: \"\\F0EE1\";\n}\n\n.mdi-credit-card-clock-outline::before {\n  content: \"\\F0EE2\";\n}\n\n.mdi-credit-card-edit::before {\n  content: \"\\F17D7\";\n}\n\n.mdi-credit-card-edit-outline::before {\n  content: \"\\F17D8\";\n}\n\n.mdi-credit-card-fast::before {\n  content: \"\\F1911\";\n}\n\n.mdi-credit-card-fast-outline::before {\n  content: \"\\F1912\";\n}\n\n.mdi-credit-card-lock::before {\n  content: \"\\F18E7\";\n}\n\n.mdi-credit-card-lock-outline::before {\n  content: \"\\F18E8\";\n}\n\n.mdi-credit-card-marker::before {\n  content: \"\\F06A8\";\n}\n\n.mdi-credit-card-marker-outline::before {\n  content: \"\\F0DBE\";\n}\n\n.mdi-credit-card-minus::before {\n  content: \"\\F0FAC\";\n}\n\n.mdi-credit-card-minus-outline::before {\n  content: \"\\F0FAD\";\n}\n\n.mdi-credit-card-multiple::before {\n  content: \"\\F0FF0\";\n}\n\n.mdi-credit-card-multiple-outline::before {\n  content: \"\\F019C\";\n}\n\n.mdi-credit-card-off::before {\n  content: \"\\F0FF1\";\n}\n\n.mdi-credit-card-off-outline::before {\n  content: \"\\F05E4\";\n}\n\n.mdi-credit-card-outline::before {\n  content: \"\\F019B\";\n}\n\n.mdi-credit-card-plus::before {\n  content: \"\\F0FF2\";\n}\n\n.mdi-credit-card-plus-outline::before {\n  content: \"\\F0676\";\n}\n\n.mdi-credit-card-refresh::before {\n  content: \"\\F1645\";\n}\n\n.mdi-credit-card-refresh-outline::before {\n  content: \"\\F1646\";\n}\n\n.mdi-credit-card-refund::before {\n  content: \"\\F0FF3\";\n}\n\n.mdi-credit-card-refund-outline::before {\n  content: \"\\F0AA8\";\n}\n\n.mdi-credit-card-remove::before {\n  content: \"\\F0FAE\";\n}\n\n.mdi-credit-card-remove-outline::before {\n  content: \"\\F0FAF\";\n}\n\n.mdi-credit-card-scan::before {\n  content: \"\\F0FF4\";\n}\n\n.mdi-credit-card-scan-outline::before {\n  content: \"\\F019D\";\n}\n\n.mdi-credit-card-search::before {\n  content: \"\\F1647\";\n}\n\n.mdi-credit-card-search-outline::before {\n  content: \"\\F1648\";\n}\n\n.mdi-credit-card-settings::before {\n  content: \"\\F0FF5\";\n}\n\n.mdi-credit-card-settings-outline::before {\n  content: \"\\F08D7\";\n}\n\n.mdi-credit-card-sync::before {\n  content: \"\\F1649\";\n}\n\n.mdi-credit-card-sync-outline::before {\n  content: \"\\F164A\";\n}\n\n.mdi-credit-card-wireless::before {\n  content: \"\\F0802\";\n}\n\n.mdi-credit-card-wireless-off::before {\n  content: \"\\F057A\";\n}\n\n.mdi-credit-card-wireless-off-outline::before {\n  content: \"\\F057B\";\n}\n\n.mdi-credit-card-wireless-outline::before {\n  content: \"\\F0D6C\";\n}\n\n.mdi-cricket::before {\n  content: \"\\F0D6D\";\n}\n\n.mdi-crop::before {\n  content: \"\\F019E\";\n}\n\n.mdi-crop-free::before {\n  content: \"\\F019F\";\n}\n\n.mdi-crop-landscape::before {\n  content: \"\\F01A0\";\n}\n\n.mdi-crop-portrait::before {\n  content: \"\\F01A1\";\n}\n\n.mdi-crop-rotate::before {\n  content: \"\\F0696\";\n}\n\n.mdi-crop-square::before {\n  content: \"\\F01A2\";\n}\n\n.mdi-cross::before {\n  content: \"\\F0953\";\n}\n\n.mdi-cross-bolnisi::before {\n  content: \"\\F0CED\";\n}\n\n.mdi-cross-celtic::before {\n  content: \"\\F0CF5\";\n}\n\n.mdi-cross-outline::before {\n  content: \"\\F0CF6\";\n}\n\n.mdi-crosshairs::before {\n  content: \"\\F01A3\";\n}\n\n.mdi-crosshairs-gps::before {\n  content: \"\\F01A4\";\n}\n\n.mdi-crosshairs-off::before {\n  content: \"\\F0F45\";\n}\n\n.mdi-crosshairs-question::before {\n  content: \"\\F1136\";\n}\n\n.mdi-crowd::before {\n  content: \"\\F1975\";\n}\n\n.mdi-crown::before {\n  content: \"\\F01A5\";\n}\n\n.mdi-crown-circle::before {\n  content: \"\\F17DC\";\n}\n\n.mdi-crown-circle-outline::before {\n  content: \"\\F17DD\";\n}\n\n.mdi-crown-outline::before {\n  content: \"\\F11D0\";\n}\n\n.mdi-cryengine::before {\n  content: \"\\F0959\";\n}\n\n.mdi-crystal-ball::before {\n  content: \"\\F0B2F\";\n}\n\n.mdi-cube::before {\n  content: \"\\F01A6\";\n}\n\n.mdi-cube-off::before {\n  content: \"\\F141C\";\n}\n\n.mdi-cube-off-outline::before {\n  content: \"\\F141D\";\n}\n\n.mdi-cube-outline::before {\n  content: \"\\F01A7\";\n}\n\n.mdi-cube-scan::before {\n  content: \"\\F0B84\";\n}\n\n.mdi-cube-send::before {\n  content: \"\\F01A8\";\n}\n\n.mdi-cube-unfolded::before {\n  content: \"\\F01A9\";\n}\n\n.mdi-cup::before {\n  content: \"\\F01AA\";\n}\n\n.mdi-cup-off::before {\n  content: \"\\F05E5\";\n}\n\n.mdi-cup-off-outline::before {\n  content: \"\\F137D\";\n}\n\n.mdi-cup-outline::before {\n  content: \"\\F130F\";\n}\n\n.mdi-cup-water::before {\n  content: \"\\F01AB\";\n}\n\n.mdi-cupboard::before {\n  content: \"\\F0F46\";\n}\n\n.mdi-cupboard-outline::before {\n  content: \"\\F0F47\";\n}\n\n.mdi-cupcake::before {\n  content: \"\\F095A\";\n}\n\n.mdi-curling::before {\n  content: \"\\F0863\";\n}\n\n.mdi-currency-bdt::before {\n  content: \"\\F0864\";\n}\n\n.mdi-currency-brl::before {\n  content: \"\\F0B85\";\n}\n\n.mdi-currency-btc::before {\n  content: \"\\F01AC\";\n}\n\n.mdi-currency-cny::before {\n  content: \"\\F07BA\";\n}\n\n.mdi-currency-eth::before {\n  content: \"\\F07BB\";\n}\n\n.mdi-currency-eur::before {\n  content: \"\\F01AD\";\n}\n\n.mdi-currency-eur-off::before {\n  content: \"\\F1315\";\n}\n\n.mdi-currency-gbp::before {\n  content: \"\\F01AE\";\n}\n\n.mdi-currency-ils::before {\n  content: \"\\F0C61\";\n}\n\n.mdi-currency-inr::before {\n  content: \"\\F01AF\";\n}\n\n.mdi-currency-jpy::before {\n  content: \"\\F07BC\";\n}\n\n.mdi-currency-krw::before {\n  content: \"\\F07BD\";\n}\n\n.mdi-currency-kzt::before {\n  content: \"\\F0865\";\n}\n\n.mdi-currency-mnt::before {\n  content: \"\\F1512\";\n}\n\n.mdi-currency-ngn::before {\n  content: \"\\F01B0\";\n}\n\n.mdi-currency-php::before {\n  content: \"\\F09E6\";\n}\n\n.mdi-currency-rial::before {\n  content: \"\\F0E9C\";\n}\n\n.mdi-currency-rub::before {\n  content: \"\\F01B1\";\n}\n\n.mdi-currency-rupee::before {\n  content: \"\\F1976\";\n}\n\n.mdi-currency-sign::before {\n  content: \"\\F07BE\";\n}\n\n.mdi-currency-try::before {\n  content: \"\\F01B2\";\n}\n\n.mdi-currency-twd::before {\n  content: \"\\F07BF\";\n}\n\n.mdi-currency-usd::before {\n  content: \"\\F01C1\";\n}\n\n.mdi-currency-usd-off::before {\n  content: \"\\F067A\";\n}\n\n.mdi-current-ac::before {\n  content: \"\\F1480\";\n}\n\n.mdi-current-dc::before {\n  content: \"\\F095C\";\n}\n\n.mdi-cursor-default::before {\n  content: \"\\F01C0\";\n}\n\n.mdi-cursor-default-click::before {\n  content: \"\\F0CFD\";\n}\n\n.mdi-cursor-default-click-outline::before {\n  content: \"\\F0CFE\";\n}\n\n.mdi-cursor-default-gesture::before {\n  content: \"\\F1127\";\n}\n\n.mdi-cursor-default-gesture-outline::before {\n  content: \"\\F1128\";\n}\n\n.mdi-cursor-default-outline::before {\n  content: \"\\F01BF\";\n}\n\n.mdi-cursor-move::before {\n  content: \"\\F01BE\";\n}\n\n.mdi-cursor-pointer::before {\n  content: \"\\F01BD\";\n}\n\n.mdi-cursor-text::before {\n  content: \"\\F05E7\";\n}\n\n.mdi-curtains::before {\n  content: \"\\F1846\";\n}\n\n.mdi-curtains-closed::before {\n  content: \"\\F1847\";\n}\n\n.mdi-cylinder::before {\n  content: \"\\F194E\";\n}\n\n.mdi-cylinder-off::before {\n  content: \"\\F194F\";\n}\n\n.mdi-dance-ballroom::before {\n  content: \"\\F15FB\";\n}\n\n.mdi-dance-pole::before {\n  content: \"\\F1578\";\n}\n\n.mdi-data-matrix::before {\n  content: \"\\F153C\";\n}\n\n.mdi-data-matrix-edit::before {\n  content: \"\\F153D\";\n}\n\n.mdi-data-matrix-minus::before {\n  content: \"\\F153E\";\n}\n\n.mdi-data-matrix-plus::before {\n  content: \"\\F153F\";\n}\n\n.mdi-data-matrix-remove::before {\n  content: \"\\F1540\";\n}\n\n.mdi-data-matrix-scan::before {\n  content: \"\\F1541\";\n}\n\n.mdi-database::before {\n  content: \"\\F01BC\";\n}\n\n.mdi-database-alert::before {\n  content: \"\\F163A\";\n}\n\n.mdi-database-alert-outline::before {\n  content: \"\\F1624\";\n}\n\n.mdi-database-arrow-down::before {\n  content: \"\\F163B\";\n}\n\n.mdi-database-arrow-down-outline::before {\n  content: \"\\F1625\";\n}\n\n.mdi-database-arrow-left::before {\n  content: \"\\F163C\";\n}\n\n.mdi-database-arrow-left-outline::before {\n  content: \"\\F1626\";\n}\n\n.mdi-database-arrow-right::before {\n  content: \"\\F163D\";\n}\n\n.mdi-database-arrow-right-outline::before {\n  content: \"\\F1627\";\n}\n\n.mdi-database-arrow-up::before {\n  content: \"\\F163E\";\n}\n\n.mdi-database-arrow-up-outline::before {\n  content: \"\\F1628\";\n}\n\n.mdi-database-check::before {\n  content: \"\\F0AA9\";\n}\n\n.mdi-database-check-outline::before {\n  content: \"\\F1629\";\n}\n\n.mdi-database-clock::before {\n  content: \"\\F163F\";\n}\n\n.mdi-database-clock-outline::before {\n  content: \"\\F162A\";\n}\n\n.mdi-database-cog::before {\n  content: \"\\F164B\";\n}\n\n.mdi-database-cog-outline::before {\n  content: \"\\F164C\";\n}\n\n.mdi-database-edit::before {\n  content: \"\\F0B86\";\n}\n\n.mdi-database-edit-outline::before {\n  content: \"\\F162B\";\n}\n\n.mdi-database-export::before {\n  content: \"\\F095E\";\n}\n\n.mdi-database-export-outline::before {\n  content: \"\\F162C\";\n}\n\n.mdi-database-eye::before {\n  content: \"\\F191F\";\n}\n\n.mdi-database-eye-off::before {\n  content: \"\\F1920\";\n}\n\n.mdi-database-eye-off-outline::before {\n  content: \"\\F1921\";\n}\n\n.mdi-database-eye-outline::before {\n  content: \"\\F1922\";\n}\n\n.mdi-database-import::before {\n  content: \"\\F095D\";\n}\n\n.mdi-database-import-outline::before {\n  content: \"\\F162D\";\n}\n\n.mdi-database-lock::before {\n  content: \"\\F0AAA\";\n}\n\n.mdi-database-lock-outline::before {\n  content: \"\\F162E\";\n}\n\n.mdi-database-marker::before {\n  content: \"\\F12F6\";\n}\n\n.mdi-database-marker-outline::before {\n  content: \"\\F162F\";\n}\n\n.mdi-database-minus::before {\n  content: \"\\F01BB\";\n}\n\n.mdi-database-minus-outline::before {\n  content: \"\\F1630\";\n}\n\n.mdi-database-off::before {\n  content: \"\\F1640\";\n}\n\n.mdi-database-off-outline::before {\n  content: \"\\F1631\";\n}\n\n.mdi-database-outline::before {\n  content: \"\\F1632\";\n}\n\n.mdi-database-plus::before {\n  content: \"\\F01BA\";\n}\n\n.mdi-database-plus-outline::before {\n  content: \"\\F1633\";\n}\n\n.mdi-database-refresh::before {\n  content: \"\\F05C2\";\n}\n\n.mdi-database-refresh-outline::before {\n  content: \"\\F1634\";\n}\n\n.mdi-database-remove::before {\n  content: \"\\F0D00\";\n}\n\n.mdi-database-remove-outline::before {\n  content: \"\\F1635\";\n}\n\n.mdi-database-search::before {\n  content: \"\\F0866\";\n}\n\n.mdi-database-search-outline::before {\n  content: \"\\F1636\";\n}\n\n.mdi-database-settings::before {\n  content: \"\\F0D01\";\n}\n\n.mdi-database-settings-outline::before {\n  content: \"\\F1637\";\n}\n\n.mdi-database-sync::before {\n  content: \"\\F0CFF\";\n}\n\n.mdi-database-sync-outline::before {\n  content: \"\\F1638\";\n}\n\n.mdi-death-star::before {\n  content: \"\\F08D8\";\n}\n\n.mdi-death-star-variant::before {\n  content: \"\\F08D9\";\n}\n\n.mdi-deathly-hallows::before {\n  content: \"\\F0B87\";\n}\n\n.mdi-debian::before {\n  content: \"\\F08DA\";\n}\n\n.mdi-debug-step-into::before {\n  content: \"\\F01B9\";\n}\n\n.mdi-debug-step-out::before {\n  content: \"\\F01B8\";\n}\n\n.mdi-debug-step-over::before {\n  content: \"\\F01B7\";\n}\n\n.mdi-decagram::before {\n  content: \"\\F076C\";\n}\n\n.mdi-decagram-outline::before {\n  content: \"\\F076D\";\n}\n\n.mdi-decimal::before {\n  content: \"\\F10A1\";\n}\n\n.mdi-decimal-comma::before {\n  content: \"\\F10A2\";\n}\n\n.mdi-decimal-comma-decrease::before {\n  content: \"\\F10A3\";\n}\n\n.mdi-decimal-comma-increase::before {\n  content: \"\\F10A4\";\n}\n\n.mdi-decimal-decrease::before {\n  content: \"\\F01B6\";\n}\n\n.mdi-decimal-increase::before {\n  content: \"\\F01B5\";\n}\n\n.mdi-delete::before {\n  content: \"\\F01B4\";\n}\n\n.mdi-delete-alert::before {\n  content: \"\\F10A5\";\n}\n\n.mdi-delete-alert-outline::before {\n  content: \"\\F10A6\";\n}\n\n.mdi-delete-circle::before {\n  content: \"\\F0683\";\n}\n\n.mdi-delete-circle-outline::before {\n  content: \"\\F0B88\";\n}\n\n.mdi-delete-clock::before {\n  content: \"\\F1556\";\n}\n\n.mdi-delete-clock-outline::before {\n  content: \"\\F1557\";\n}\n\n.mdi-delete-empty::before {\n  content: \"\\F06CC\";\n}\n\n.mdi-delete-empty-outline::before {\n  content: \"\\F0E9D\";\n}\n\n.mdi-delete-forever::before {\n  content: \"\\F05E8\";\n}\n\n.mdi-delete-forever-outline::before {\n  content: \"\\F0B89\";\n}\n\n.mdi-delete-off::before {\n  content: \"\\F10A7\";\n}\n\n.mdi-delete-off-outline::before {\n  content: \"\\F10A8\";\n}\n\n.mdi-delete-outline::before {\n  content: \"\\F09E7\";\n}\n\n.mdi-delete-restore::before {\n  content: \"\\F0819\";\n}\n\n.mdi-delete-sweep::before {\n  content: \"\\F05E9\";\n}\n\n.mdi-delete-sweep-outline::before {\n  content: \"\\F0C62\";\n}\n\n.mdi-delete-variant::before {\n  content: \"\\F01B3\";\n}\n\n.mdi-delta::before {\n  content: \"\\F01C2\";\n}\n\n.mdi-desk::before {\n  content: \"\\F1239\";\n}\n\n.mdi-desk-lamp::before {\n  content: \"\\F095F\";\n}\n\n.mdi-deskphone::before {\n  content: \"\\F01C3\";\n}\n\n.mdi-desktop-classic::before {\n  content: \"\\F07C0\";\n}\n\n.mdi-desktop-mac::before {\n  content: \"\\F01C4\";\n}\n\n.mdi-desktop-mac-dashboard::before {\n  content: \"\\F09E8\";\n}\n\n.mdi-desktop-tower::before {\n  content: \"\\F01C5\";\n}\n\n.mdi-desktop-tower-monitor::before {\n  content: \"\\F0AAB\";\n}\n\n.mdi-details::before {\n  content: \"\\F01C6\";\n}\n\n.mdi-dev-to::before {\n  content: \"\\F0D6E\";\n}\n\n.mdi-developer-board::before {\n  content: \"\\F0697\";\n}\n\n.mdi-deviantart::before {\n  content: \"\\F01C7\";\n}\n\n.mdi-devices::before {\n  content: \"\\F0FB0\";\n}\n\n.mdi-dharmachakra::before {\n  content: \"\\F094B\";\n}\n\n.mdi-diabetes::before {\n  content: \"\\F1126\";\n}\n\n.mdi-dialpad::before {\n  content: \"\\F061C\";\n}\n\n.mdi-diameter::before {\n  content: \"\\F0C63\";\n}\n\n.mdi-diameter-outline::before {\n  content: \"\\F0C64\";\n}\n\n.mdi-diameter-variant::before {\n  content: \"\\F0C65\";\n}\n\n.mdi-diamond::before {\n  content: \"\\F0B8A\";\n}\n\n.mdi-diamond-outline::before {\n  content: \"\\F0B8B\";\n}\n\n.mdi-diamond-stone::before {\n  content: \"\\F01C8\";\n}\n\n.mdi-dice-1::before {\n  content: \"\\F01CA\";\n}\n\n.mdi-dice-1-outline::before {\n  content: \"\\F114A\";\n}\n\n.mdi-dice-2::before {\n  content: \"\\F01CB\";\n}\n\n.mdi-dice-2-outline::before {\n  content: \"\\F114B\";\n}\n\n.mdi-dice-3::before {\n  content: \"\\F01CC\";\n}\n\n.mdi-dice-3-outline::before {\n  content: \"\\F114C\";\n}\n\n.mdi-dice-4::before {\n  content: \"\\F01CD\";\n}\n\n.mdi-dice-4-outline::before {\n  content: \"\\F114D\";\n}\n\n.mdi-dice-5::before {\n  content: \"\\F01CE\";\n}\n\n.mdi-dice-5-outline::before {\n  content: \"\\F114E\";\n}\n\n.mdi-dice-6::before {\n  content: \"\\F01CF\";\n}\n\n.mdi-dice-6-outline::before {\n  content: \"\\F114F\";\n}\n\n.mdi-dice-d10::before {\n  content: \"\\F1153\";\n}\n\n.mdi-dice-d10-outline::before {\n  content: \"\\F076F\";\n}\n\n.mdi-dice-d12::before {\n  content: \"\\F1154\";\n}\n\n.mdi-dice-d12-outline::before {\n  content: \"\\F0867\";\n}\n\n.mdi-dice-d20::before {\n  content: \"\\F1155\";\n}\n\n.mdi-dice-d20-outline::before {\n  content: \"\\F05EA\";\n}\n\n.mdi-dice-d4::before {\n  content: \"\\F1150\";\n}\n\n.mdi-dice-d4-outline::before {\n  content: \"\\F05EB\";\n}\n\n.mdi-dice-d6::before {\n  content: \"\\F1151\";\n}\n\n.mdi-dice-d6-outline::before {\n  content: \"\\F05ED\";\n}\n\n.mdi-dice-d8::before {\n  content: \"\\F1152\";\n}\n\n.mdi-dice-d8-outline::before {\n  content: \"\\F05EC\";\n}\n\n.mdi-dice-multiple::before {\n  content: \"\\F076E\";\n}\n\n.mdi-dice-multiple-outline::before {\n  content: \"\\F1156\";\n}\n\n.mdi-digital-ocean::before {\n  content: \"\\F1237\";\n}\n\n.mdi-dip-switch::before {\n  content: \"\\F07C1\";\n}\n\n.mdi-directions::before {\n  content: \"\\F01D0\";\n}\n\n.mdi-directions-fork::before {\n  content: \"\\F0641\";\n}\n\n.mdi-disc::before {\n  content: \"\\F05EE\";\n}\n\n.mdi-disc-alert::before {\n  content: \"\\F01D1\";\n}\n\n.mdi-disc-player::before {\n  content: \"\\F0960\";\n}\n\n.mdi-discord::before {\n  content: \"\\F066F\";\n}\n\n.mdi-dishwasher::before {\n  content: \"\\F0AAC\";\n}\n\n.mdi-dishwasher-alert::before {\n  content: \"\\F11B8\";\n}\n\n.mdi-dishwasher-off::before {\n  content: \"\\F11B9\";\n}\n\n.mdi-disqus::before {\n  content: \"\\F01D2\";\n}\n\n.mdi-distribute-horizontal-center::before {\n  content: \"\\F11C9\";\n}\n\n.mdi-distribute-horizontal-left::before {\n  content: \"\\F11C8\";\n}\n\n.mdi-distribute-horizontal-right::before {\n  content: \"\\F11CA\";\n}\n\n.mdi-distribute-vertical-bottom::before {\n  content: \"\\F11CB\";\n}\n\n.mdi-distribute-vertical-center::before {\n  content: \"\\F11CC\";\n}\n\n.mdi-distribute-vertical-top::before {\n  content: \"\\F11CD\";\n}\n\n.mdi-diversify::before {\n  content: \"\\F1877\";\n}\n\n.mdi-diving::before {\n  content: \"\\F1977\";\n}\n\n.mdi-diving-flippers::before {\n  content: \"\\F0DBF\";\n}\n\n.mdi-diving-helmet::before {\n  content: \"\\F0DC0\";\n}\n\n.mdi-diving-scuba::before {\n  content: \"\\F0DC1\";\n}\n\n.mdi-diving-scuba-flag::before {\n  content: \"\\F0DC2\";\n}\n\n.mdi-diving-scuba-tank::before {\n  content: \"\\F0DC3\";\n}\n\n.mdi-diving-scuba-tank-multiple::before {\n  content: \"\\F0DC4\";\n}\n\n.mdi-diving-snorkel::before {\n  content: \"\\F0DC5\";\n}\n\n.mdi-division::before {\n  content: \"\\F01D4\";\n}\n\n.mdi-division-box::before {\n  content: \"\\F01D5\";\n}\n\n.mdi-dlna::before {\n  content: \"\\F0A41\";\n}\n\n.mdi-dna::before {\n  content: \"\\F0684\";\n}\n\n.mdi-dns::before {\n  content: \"\\F01D6\";\n}\n\n.mdi-dns-outline::before {\n  content: \"\\F0B8C\";\n}\n\n.mdi-dock-bottom::before {\n  content: \"\\F10A9\";\n}\n\n.mdi-dock-left::before {\n  content: \"\\F10AA\";\n}\n\n.mdi-dock-right::before {\n  content: \"\\F10AB\";\n}\n\n.mdi-dock-top::before {\n  content: \"\\F1513\";\n}\n\n.mdi-dock-window::before {\n  content: \"\\F10AC\";\n}\n\n.mdi-docker::before {\n  content: \"\\F0868\";\n}\n\n.mdi-doctor::before {\n  content: \"\\F0A42\";\n}\n\n.mdi-dog::before {\n  content: \"\\F0A43\";\n}\n\n.mdi-dog-service::before {\n  content: \"\\F0AAD\";\n}\n\n.mdi-dog-side::before {\n  content: \"\\F0A44\";\n}\n\n.mdi-dog-side-off::before {\n  content: \"\\F16EE\";\n}\n\n.mdi-dolby::before {\n  content: \"\\F06B3\";\n}\n\n.mdi-dolly::before {\n  content: \"\\F0E9E\";\n}\n\n.mdi-dolphin::before {\n  content: \"\\F18B4\";\n}\n\n.mdi-domain::before {\n  content: \"\\F01D7\";\n}\n\n.mdi-domain-off::before {\n  content: \"\\F0D6F\";\n}\n\n.mdi-domain-plus::before {\n  content: \"\\F10AD\";\n}\n\n.mdi-domain-remove::before {\n  content: \"\\F10AE\";\n}\n\n.mdi-dome-light::before {\n  content: \"\\F141E\";\n}\n\n.mdi-domino-mask::before {\n  content: \"\\F1023\";\n}\n\n.mdi-donkey::before {\n  content: \"\\F07C2\";\n}\n\n.mdi-door::before {\n  content: \"\\F081A\";\n}\n\n.mdi-door-closed::before {\n  content: \"\\F081B\";\n}\n\n.mdi-door-closed-lock::before {\n  content: \"\\F10AF\";\n}\n\n.mdi-door-open::before {\n  content: \"\\F081C\";\n}\n\n.mdi-door-sliding::before {\n  content: \"\\F181E\";\n}\n\n.mdi-door-sliding-lock::before {\n  content: \"\\F181F\";\n}\n\n.mdi-door-sliding-open::before {\n  content: \"\\F1820\";\n}\n\n.mdi-doorbell::before {\n  content: \"\\F12E6\";\n}\n\n.mdi-doorbell-video::before {\n  content: \"\\F0869\";\n}\n\n.mdi-dot-net::before {\n  content: \"\\F0AAE\";\n}\n\n.mdi-dots-circle::before {\n  content: \"\\F1978\";\n}\n\n.mdi-dots-grid::before {\n  content: \"\\F15FC\";\n}\n\n.mdi-dots-hexagon::before {\n  content: \"\\F15FF\";\n}\n\n.mdi-dots-horizontal::before {\n  content: \"\\F01D8\";\n}\n\n.mdi-dots-horizontal-circle::before {\n  content: \"\\F07C3\";\n}\n\n.mdi-dots-horizontal-circle-outline::before {\n  content: \"\\F0B8D\";\n}\n\n.mdi-dots-square::before {\n  content: \"\\F15FD\";\n}\n\n.mdi-dots-triangle::before {\n  content: \"\\F15FE\";\n}\n\n.mdi-dots-vertical::before {\n  content: \"\\F01D9\";\n}\n\n.mdi-dots-vertical-circle::before {\n  content: \"\\F07C4\";\n}\n\n.mdi-dots-vertical-circle-outline::before {\n  content: \"\\F0B8E\";\n}\n\n.mdi-download::before {\n  content: \"\\F01DA\";\n}\n\n.mdi-download-box::before {\n  content: \"\\F1462\";\n}\n\n.mdi-download-box-outline::before {\n  content: \"\\F1463\";\n}\n\n.mdi-download-circle::before {\n  content: \"\\F1464\";\n}\n\n.mdi-download-circle-outline::before {\n  content: \"\\F1465\";\n}\n\n.mdi-download-lock::before {\n  content: \"\\F1320\";\n}\n\n.mdi-download-lock-outline::before {\n  content: \"\\F1321\";\n}\n\n.mdi-download-multiple::before {\n  content: \"\\F09E9\";\n}\n\n.mdi-download-network::before {\n  content: \"\\F06F4\";\n}\n\n.mdi-download-network-outline::before {\n  content: \"\\F0C66\";\n}\n\n.mdi-download-off::before {\n  content: \"\\F10B0\";\n}\n\n.mdi-download-off-outline::before {\n  content: \"\\F10B1\";\n}\n\n.mdi-download-outline::before {\n  content: \"\\F0B8F\";\n}\n\n.mdi-drag::before {\n  content: \"\\F01DB\";\n}\n\n.mdi-drag-horizontal::before {\n  content: \"\\F01DC\";\n}\n\n.mdi-drag-horizontal-variant::before {\n  content: \"\\F12F0\";\n}\n\n.mdi-drag-variant::before {\n  content: \"\\F0B90\";\n}\n\n.mdi-drag-vertical::before {\n  content: \"\\F01DD\";\n}\n\n.mdi-drag-vertical-variant::before {\n  content: \"\\F12F1\";\n}\n\n.mdi-drama-masks::before {\n  content: \"\\F0D02\";\n}\n\n.mdi-draw::before {\n  content: \"\\F0F49\";\n}\n\n.mdi-draw-pen::before {\n  content: \"\\F19B9\";\n}\n\n.mdi-drawing::before {\n  content: \"\\F01DE\";\n}\n\n.mdi-drawing-box::before {\n  content: \"\\F01DF\";\n}\n\n.mdi-dresser::before {\n  content: \"\\F0F4A\";\n}\n\n.mdi-dresser-outline::before {\n  content: \"\\F0F4B\";\n}\n\n.mdi-drone::before {\n  content: \"\\F01E2\";\n}\n\n.mdi-dropbox::before {\n  content: \"\\F01E3\";\n}\n\n.mdi-drupal::before {\n  content: \"\\F01E4\";\n}\n\n.mdi-duck::before {\n  content: \"\\F01E5\";\n}\n\n.mdi-dumbbell::before {\n  content: \"\\F01E6\";\n}\n\n.mdi-dump-truck::before {\n  content: \"\\F0C67\";\n}\n\n.mdi-ear-hearing::before {\n  content: \"\\F07C5\";\n}\n\n.mdi-ear-hearing-off::before {\n  content: \"\\F0A45\";\n}\n\n.mdi-earbuds::before {\n  content: \"\\F184F\";\n}\n\n.mdi-earbuds-off::before {\n  content: \"\\F1850\";\n}\n\n.mdi-earbuds-off-outline::before {\n  content: \"\\F1851\";\n}\n\n.mdi-earbuds-outline::before {\n  content: \"\\F1852\";\n}\n\n.mdi-earth::before {\n  content: \"\\F01E7\";\n}\n\n.mdi-earth-arrow-right::before {\n  content: \"\\F1311\";\n}\n\n.mdi-earth-box::before {\n  content: \"\\F06CD\";\n}\n\n.mdi-earth-box-minus::before {\n  content: \"\\F1407\";\n}\n\n.mdi-earth-box-off::before {\n  content: \"\\F06CE\";\n}\n\n.mdi-earth-box-plus::before {\n  content: \"\\F1406\";\n}\n\n.mdi-earth-box-remove::before {\n  content: \"\\F1408\";\n}\n\n.mdi-earth-minus::before {\n  content: \"\\F1404\";\n}\n\n.mdi-earth-off::before {\n  content: \"\\F01E8\";\n}\n\n.mdi-earth-plus::before {\n  content: \"\\F1403\";\n}\n\n.mdi-earth-remove::before {\n  content: \"\\F1405\";\n}\n\n.mdi-egg::before {\n  content: \"\\F0AAF\";\n}\n\n.mdi-egg-easter::before {\n  content: \"\\F0AB0\";\n}\n\n.mdi-egg-fried::before {\n  content: \"\\F184A\";\n}\n\n.mdi-egg-off::before {\n  content: \"\\F13F0\";\n}\n\n.mdi-egg-off-outline::before {\n  content: \"\\F13F1\";\n}\n\n.mdi-egg-outline::before {\n  content: \"\\F13F2\";\n}\n\n.mdi-eiffel-tower::before {\n  content: \"\\F156B\";\n}\n\n.mdi-eight-track::before {\n  content: \"\\F09EA\";\n}\n\n.mdi-eject::before {\n  content: \"\\F01EA\";\n}\n\n.mdi-eject-outline::before {\n  content: \"\\F0B91\";\n}\n\n.mdi-electric-switch::before {\n  content: \"\\F0E9F\";\n}\n\n.mdi-electric-switch-closed::before {\n  content: \"\\F10D9\";\n}\n\n.mdi-electron-framework::before {\n  content: \"\\F1024\";\n}\n\n.mdi-elephant::before {\n  content: \"\\F07C6\";\n}\n\n.mdi-elevation-decline::before {\n  content: \"\\F01EB\";\n}\n\n.mdi-elevation-rise::before {\n  content: \"\\F01EC\";\n}\n\n.mdi-elevator::before {\n  content: \"\\F01ED\";\n}\n\n.mdi-elevator-down::before {\n  content: \"\\F12C2\";\n}\n\n.mdi-elevator-passenger::before {\n  content: \"\\F1381\";\n}\n\n.mdi-elevator-passenger-off::before {\n  content: \"\\F1979\";\n}\n\n.mdi-elevator-passenger-off-outline::before {\n  content: \"\\F197A\";\n}\n\n.mdi-elevator-passenger-outline::before {\n  content: \"\\F197B\";\n}\n\n.mdi-elevator-up::before {\n  content: \"\\F12C1\";\n}\n\n.mdi-ellipse::before {\n  content: \"\\F0EA0\";\n}\n\n.mdi-ellipse-outline::before {\n  content: \"\\F0EA1\";\n}\n\n.mdi-email::before {\n  content: \"\\F01EE\";\n}\n\n.mdi-email-alert::before {\n  content: \"\\F06CF\";\n}\n\n.mdi-email-alert-outline::before {\n  content: \"\\F0D42\";\n}\n\n.mdi-email-box::before {\n  content: \"\\F0D03\";\n}\n\n.mdi-email-check::before {\n  content: \"\\F0AB1\";\n}\n\n.mdi-email-check-outline::before {\n  content: \"\\F0AB2\";\n}\n\n.mdi-email-edit::before {\n  content: \"\\F0EE3\";\n}\n\n.mdi-email-edit-outline::before {\n  content: \"\\F0EE4\";\n}\n\n.mdi-email-fast::before {\n  content: \"\\F186F\";\n}\n\n.mdi-email-fast-outline::before {\n  content: \"\\F1870\";\n}\n\n.mdi-email-lock::before {\n  content: \"\\F01F1\";\n}\n\n.mdi-email-mark-as-unread::before {\n  content: \"\\F0B92\";\n}\n\n.mdi-email-minus::before {\n  content: \"\\F0EE5\";\n}\n\n.mdi-email-minus-outline::before {\n  content: \"\\F0EE6\";\n}\n\n.mdi-email-multiple::before {\n  content: \"\\F0EE7\";\n}\n\n.mdi-email-multiple-outline::before {\n  content: \"\\F0EE8\";\n}\n\n.mdi-email-newsletter::before {\n  content: \"\\F0FB1\";\n}\n\n.mdi-email-off::before {\n  content: \"\\F13E3\";\n}\n\n.mdi-email-off-outline::before {\n  content: \"\\F13E4\";\n}\n\n.mdi-email-open::before {\n  content: \"\\F01EF\";\n}\n\n.mdi-email-open-multiple::before {\n  content: \"\\F0EE9\";\n}\n\n.mdi-email-open-multiple-outline::before {\n  content: \"\\F0EEA\";\n}\n\n.mdi-email-open-outline::before {\n  content: \"\\F05EF\";\n}\n\n.mdi-email-outline::before {\n  content: \"\\F01F0\";\n}\n\n.mdi-email-plus::before {\n  content: \"\\F09EB\";\n}\n\n.mdi-email-plus-outline::before {\n  content: \"\\F09EC\";\n}\n\n.mdi-email-receive::before {\n  content: \"\\F10DA\";\n}\n\n.mdi-email-receive-outline::before {\n  content: \"\\F10DB\";\n}\n\n.mdi-email-remove::before {\n  content: \"\\F1661\";\n}\n\n.mdi-email-remove-outline::before {\n  content: \"\\F1662\";\n}\n\n.mdi-email-seal::before {\n  content: \"\\F195B\";\n}\n\n.mdi-email-seal-outline::before {\n  content: \"\\F195C\";\n}\n\n.mdi-email-search::before {\n  content: \"\\F0961\";\n}\n\n.mdi-email-search-outline::before {\n  content: \"\\F0962\";\n}\n\n.mdi-email-send::before {\n  content: \"\\F10DC\";\n}\n\n.mdi-email-send-outline::before {\n  content: \"\\F10DD\";\n}\n\n.mdi-email-sync::before {\n  content: \"\\F12C7\";\n}\n\n.mdi-email-sync-outline::before {\n  content: \"\\F12C8\";\n}\n\n.mdi-email-variant::before {\n  content: \"\\F05F0\";\n}\n\n.mdi-ember::before {\n  content: \"\\F0B30\";\n}\n\n.mdi-emby::before {\n  content: \"\\F06B4\";\n}\n\n.mdi-emoticon::before {\n  content: \"\\F0C68\";\n}\n\n.mdi-emoticon-angry::before {\n  content: \"\\F0C69\";\n}\n\n.mdi-emoticon-angry-outline::before {\n  content: \"\\F0C6A\";\n}\n\n.mdi-emoticon-confused::before {\n  content: \"\\F10DE\";\n}\n\n.mdi-emoticon-confused-outline::before {\n  content: \"\\F10DF\";\n}\n\n.mdi-emoticon-cool::before {\n  content: \"\\F0C6B\";\n}\n\n.mdi-emoticon-cool-outline::before {\n  content: \"\\F01F3\";\n}\n\n.mdi-emoticon-cry::before {\n  content: \"\\F0C6C\";\n}\n\n.mdi-emoticon-cry-outline::before {\n  content: \"\\F0C6D\";\n}\n\n.mdi-emoticon-dead::before {\n  content: \"\\F0C6E\";\n}\n\n.mdi-emoticon-dead-outline::before {\n  content: \"\\F069B\";\n}\n\n.mdi-emoticon-devil::before {\n  content: \"\\F0C6F\";\n}\n\n.mdi-emoticon-devil-outline::before {\n  content: \"\\F01F4\";\n}\n\n.mdi-emoticon-excited::before {\n  content: \"\\F0C70\";\n}\n\n.mdi-emoticon-excited-outline::before {\n  content: \"\\F069C\";\n}\n\n.mdi-emoticon-frown::before {\n  content: \"\\F0F4C\";\n}\n\n.mdi-emoticon-frown-outline::before {\n  content: \"\\F0F4D\";\n}\n\n.mdi-emoticon-happy::before {\n  content: \"\\F0C71\";\n}\n\n.mdi-emoticon-happy-outline::before {\n  content: \"\\F01F5\";\n}\n\n.mdi-emoticon-kiss::before {\n  content: \"\\F0C72\";\n}\n\n.mdi-emoticon-kiss-outline::before {\n  content: \"\\F0C73\";\n}\n\n.mdi-emoticon-lol::before {\n  content: \"\\F1214\";\n}\n\n.mdi-emoticon-lol-outline::before {\n  content: \"\\F1215\";\n}\n\n.mdi-emoticon-neutral::before {\n  content: \"\\F0C74\";\n}\n\n.mdi-emoticon-neutral-outline::before {\n  content: \"\\F01F6\";\n}\n\n.mdi-emoticon-outline::before {\n  content: \"\\F01F2\";\n}\n\n.mdi-emoticon-poop::before {\n  content: \"\\F01F7\";\n}\n\n.mdi-emoticon-poop-outline::before {\n  content: \"\\F0C75\";\n}\n\n.mdi-emoticon-sad::before {\n  content: \"\\F0C76\";\n}\n\n.mdi-emoticon-sad-outline::before {\n  content: \"\\F01F8\";\n}\n\n.mdi-emoticon-sick::before {\n  content: \"\\F157C\";\n}\n\n.mdi-emoticon-sick-outline::before {\n  content: \"\\F157D\";\n}\n\n.mdi-emoticon-tongue::before {\n  content: \"\\F01F9\";\n}\n\n.mdi-emoticon-tongue-outline::before {\n  content: \"\\F0C77\";\n}\n\n.mdi-emoticon-wink::before {\n  content: \"\\F0C78\";\n}\n\n.mdi-emoticon-wink-outline::before {\n  content: \"\\F0C79\";\n}\n\n.mdi-engine::before {\n  content: \"\\F01FA\";\n}\n\n.mdi-engine-off::before {\n  content: \"\\F0A46\";\n}\n\n.mdi-engine-off-outline::before {\n  content: \"\\F0A47\";\n}\n\n.mdi-engine-outline::before {\n  content: \"\\F01FB\";\n}\n\n.mdi-epsilon::before {\n  content: \"\\F10E0\";\n}\n\n.mdi-equal::before {\n  content: \"\\F01FC\";\n}\n\n.mdi-equal-box::before {\n  content: \"\\F01FD\";\n}\n\n.mdi-equalizer::before {\n  content: \"\\F0EA2\";\n}\n\n.mdi-equalizer-outline::before {\n  content: \"\\F0EA3\";\n}\n\n.mdi-eraser::before {\n  content: \"\\F01FE\";\n}\n\n.mdi-eraser-variant::before {\n  content: \"\\F0642\";\n}\n\n.mdi-escalator::before {\n  content: \"\\F01FF\";\n}\n\n.mdi-escalator-box::before {\n  content: \"\\F1399\";\n}\n\n.mdi-escalator-down::before {\n  content: \"\\F12C0\";\n}\n\n.mdi-escalator-up::before {\n  content: \"\\F12BF\";\n}\n\n.mdi-eslint::before {\n  content: \"\\F0C7A\";\n}\n\n.mdi-et::before {\n  content: \"\\F0AB3\";\n}\n\n.mdi-ethereum::before {\n  content: \"\\F086A\";\n}\n\n.mdi-ethernet::before {\n  content: \"\\F0200\";\n}\n\n.mdi-ethernet-cable::before {\n  content: \"\\F0201\";\n}\n\n.mdi-ethernet-cable-off::before {\n  content: \"\\F0202\";\n}\n\n.mdi-ev-plug-ccs1::before {\n  content: \"\\F1519\";\n}\n\n.mdi-ev-plug-ccs2::before {\n  content: \"\\F151A\";\n}\n\n.mdi-ev-plug-chademo::before {\n  content: \"\\F151B\";\n}\n\n.mdi-ev-plug-tesla::before {\n  content: \"\\F151C\";\n}\n\n.mdi-ev-plug-type1::before {\n  content: \"\\F151D\";\n}\n\n.mdi-ev-plug-type2::before {\n  content: \"\\F151E\";\n}\n\n.mdi-ev-station::before {\n  content: \"\\F05F1\";\n}\n\n.mdi-evernote::before {\n  content: \"\\F0204\";\n}\n\n.mdi-excavator::before {\n  content: \"\\F1025\";\n}\n\n.mdi-exclamation::before {\n  content: \"\\F0205\";\n}\n\n.mdi-exclamation-thick::before {\n  content: \"\\F1238\";\n}\n\n.mdi-exit-run::before {\n  content: \"\\F0A48\";\n}\n\n.mdi-exit-to-app::before {\n  content: \"\\F0206\";\n}\n\n.mdi-expand-all::before {\n  content: \"\\F0AB4\";\n}\n\n.mdi-expand-all-outline::before {\n  content: \"\\F0AB5\";\n}\n\n.mdi-expansion-card::before {\n  content: \"\\F08AE\";\n}\n\n.mdi-expansion-card-variant::before {\n  content: \"\\F0FB2\";\n}\n\n.mdi-exponent::before {\n  content: \"\\F0963\";\n}\n\n.mdi-exponent-box::before {\n  content: \"\\F0964\";\n}\n\n.mdi-export::before {\n  content: \"\\F0207\";\n}\n\n.mdi-export-variant::before {\n  content: \"\\F0B93\";\n}\n\n.mdi-eye::before {\n  content: \"\\F0208\";\n}\n\n.mdi-eye-arrow-left::before {\n  content: \"\\F18FD\";\n}\n\n.mdi-eye-arrow-left-outline::before {\n  content: \"\\F18FE\";\n}\n\n.mdi-eye-arrow-right::before {\n  content: \"\\F18FF\";\n}\n\n.mdi-eye-arrow-right-outline::before {\n  content: \"\\F1900\";\n}\n\n.mdi-eye-check::before {\n  content: \"\\F0D04\";\n}\n\n.mdi-eye-check-outline::before {\n  content: \"\\F0D05\";\n}\n\n.mdi-eye-circle::before {\n  content: \"\\F0B94\";\n}\n\n.mdi-eye-circle-outline::before {\n  content: \"\\F0B95\";\n}\n\n.mdi-eye-minus::before {\n  content: \"\\F1026\";\n}\n\n.mdi-eye-minus-outline::before {\n  content: \"\\F1027\";\n}\n\n.mdi-eye-off::before {\n  content: \"\\F0209\";\n}\n\n.mdi-eye-off-outline::before {\n  content: \"\\F06D1\";\n}\n\n.mdi-eye-outline::before {\n  content: \"\\F06D0\";\n}\n\n.mdi-eye-plus::before {\n  content: \"\\F086B\";\n}\n\n.mdi-eye-plus-outline::before {\n  content: \"\\F086C\";\n}\n\n.mdi-eye-refresh::before {\n  content: \"\\F197C\";\n}\n\n.mdi-eye-refresh-outline::before {\n  content: \"\\F197D\";\n}\n\n.mdi-eye-remove::before {\n  content: \"\\F15E3\";\n}\n\n.mdi-eye-remove-outline::before {\n  content: \"\\F15E4\";\n}\n\n.mdi-eye-settings::before {\n  content: \"\\F086D\";\n}\n\n.mdi-eye-settings-outline::before {\n  content: \"\\F086E\";\n}\n\n.mdi-eyedropper::before {\n  content: \"\\F020A\";\n}\n\n.mdi-eyedropper-minus::before {\n  content: \"\\F13DD\";\n}\n\n.mdi-eyedropper-off::before {\n  content: \"\\F13DF\";\n}\n\n.mdi-eyedropper-plus::before {\n  content: \"\\F13DC\";\n}\n\n.mdi-eyedropper-remove::before {\n  content: \"\\F13DE\";\n}\n\n.mdi-eyedropper-variant::before {\n  content: \"\\F020B\";\n}\n\n.mdi-face-agent::before {\n  content: \"\\F0D70\";\n}\n\n.mdi-face-man::before {\n  content: \"\\F0643\";\n}\n\n.mdi-face-man-outline::before {\n  content: \"\\F0B96\";\n}\n\n.mdi-face-man-profile::before {\n  content: \"\\F0644\";\n}\n\n.mdi-face-man-shimmer::before {\n  content: \"\\F15CC\";\n}\n\n.mdi-face-man-shimmer-outline::before {\n  content: \"\\F15CD\";\n}\n\n.mdi-face-mask::before {\n  content: \"\\F1586\";\n}\n\n.mdi-face-mask-outline::before {\n  content: \"\\F1587\";\n}\n\n.mdi-face-recognition::before {\n  content: \"\\F0C7B\";\n}\n\n.mdi-face-woman::before {\n  content: \"\\F1077\";\n}\n\n.mdi-face-woman-outline::before {\n  content: \"\\F1078\";\n}\n\n.mdi-face-woman-profile::before {\n  content: \"\\F1076\";\n}\n\n.mdi-face-woman-shimmer::before {\n  content: \"\\F15CE\";\n}\n\n.mdi-face-woman-shimmer-outline::before {\n  content: \"\\F15CF\";\n}\n\n.mdi-facebook::before {\n  content: \"\\F020C\";\n}\n\n.mdi-facebook-gaming::before {\n  content: \"\\F07DD\";\n}\n\n.mdi-facebook-messenger::before {\n  content: \"\\F020E\";\n}\n\n.mdi-facebook-workplace::before {\n  content: \"\\F0B31\";\n}\n\n.mdi-factory::before {\n  content: \"\\F020F\";\n}\n\n.mdi-family-tree::before {\n  content: \"\\F160E\";\n}\n\n.mdi-fan::before {\n  content: \"\\F0210\";\n}\n\n.mdi-fan-alert::before {\n  content: \"\\F146C\";\n}\n\n.mdi-fan-auto::before {\n  content: \"\\F171D\";\n}\n\n.mdi-fan-chevron-down::before {\n  content: \"\\F146D\";\n}\n\n.mdi-fan-chevron-up::before {\n  content: \"\\F146E\";\n}\n\n.mdi-fan-minus::before {\n  content: \"\\F1470\";\n}\n\n.mdi-fan-off::before {\n  content: \"\\F081D\";\n}\n\n.mdi-fan-plus::before {\n  content: \"\\F146F\";\n}\n\n.mdi-fan-remove::before {\n  content: \"\\F1471\";\n}\n\n.mdi-fan-speed-1::before {\n  content: \"\\F1472\";\n}\n\n.mdi-fan-speed-2::before {\n  content: \"\\F1473\";\n}\n\n.mdi-fan-speed-3::before {\n  content: \"\\F1474\";\n}\n\n.mdi-fast-forward::before {\n  content: \"\\F0211\";\n}\n\n.mdi-fast-forward-10::before {\n  content: \"\\F0D71\";\n}\n\n.mdi-fast-forward-15::before {\n  content: \"\\F193A\";\n}\n\n.mdi-fast-forward-30::before {\n  content: \"\\F0D06\";\n}\n\n.mdi-fast-forward-5::before {\n  content: \"\\F11F8\";\n}\n\n.mdi-fast-forward-60::before {\n  content: \"\\F160B\";\n}\n\n.mdi-fast-forward-outline::before {\n  content: \"\\F06D2\";\n}\n\n.mdi-fax::before {\n  content: \"\\F0212\";\n}\n\n.mdi-feather::before {\n  content: \"\\F06D3\";\n}\n\n.mdi-feature-search::before {\n  content: \"\\F0A49\";\n}\n\n.mdi-feature-search-outline::before {\n  content: \"\\F0A4A\";\n}\n\n.mdi-fedora::before {\n  content: \"\\F08DB\";\n}\n\n.mdi-fence::before {\n  content: \"\\F179A\";\n}\n\n.mdi-fence-electric::before {\n  content: \"\\F17F6\";\n}\n\n.mdi-fencing::before {\n  content: \"\\F14C1\";\n}\n\n.mdi-ferris-wheel::before {\n  content: \"\\F0EA4\";\n}\n\n.mdi-ferry::before {\n  content: \"\\F0213\";\n}\n\n.mdi-file::before {\n  content: \"\\F0214\";\n}\n\n.mdi-file-account::before {\n  content: \"\\F073B\";\n}\n\n.mdi-file-account-outline::before {\n  content: \"\\F1028\";\n}\n\n.mdi-file-alert::before {\n  content: \"\\F0A4B\";\n}\n\n.mdi-file-alert-outline::before {\n  content: \"\\F0A4C\";\n}\n\n.mdi-file-cabinet::before {\n  content: \"\\F0AB6\";\n}\n\n.mdi-file-cad::before {\n  content: \"\\F0EEB\";\n}\n\n.mdi-file-cad-box::before {\n  content: \"\\F0EEC\";\n}\n\n.mdi-file-cancel::before {\n  content: \"\\F0DC6\";\n}\n\n.mdi-file-cancel-outline::before {\n  content: \"\\F0DC7\";\n}\n\n.mdi-file-certificate::before {\n  content: \"\\F1186\";\n}\n\n.mdi-file-certificate-outline::before {\n  content: \"\\F1187\";\n}\n\n.mdi-file-chart::before {\n  content: \"\\F0215\";\n}\n\n.mdi-file-chart-outline::before {\n  content: \"\\F1029\";\n}\n\n.mdi-file-check::before {\n  content: \"\\F0216\";\n}\n\n.mdi-file-check-outline::before {\n  content: \"\\F0E29\";\n}\n\n.mdi-file-clock::before {\n  content: \"\\F12E1\";\n}\n\n.mdi-file-clock-outline::before {\n  content: \"\\F12E2\";\n}\n\n.mdi-file-cloud::before {\n  content: \"\\F0217\";\n}\n\n.mdi-file-cloud-outline::before {\n  content: \"\\F102A\";\n}\n\n.mdi-file-code::before {\n  content: \"\\F022E\";\n}\n\n.mdi-file-code-outline::before {\n  content: \"\\F102B\";\n}\n\n.mdi-file-cog::before {\n  content: \"\\F107B\";\n}\n\n.mdi-file-cog-outline::before {\n  content: \"\\F107C\";\n}\n\n.mdi-file-compare::before {\n  content: \"\\F08AA\";\n}\n\n.mdi-file-delimited::before {\n  content: \"\\F0218\";\n}\n\n.mdi-file-delimited-outline::before {\n  content: \"\\F0EA5\";\n}\n\n.mdi-file-document::before {\n  content: \"\\F0219\";\n}\n\n.mdi-file-document-edit::before {\n  content: \"\\F0DC8\";\n}\n\n.mdi-file-document-edit-outline::before {\n  content: \"\\F0DC9\";\n}\n\n.mdi-file-document-multiple::before {\n  content: \"\\F1517\";\n}\n\n.mdi-file-document-multiple-outline::before {\n  content: \"\\F1518\";\n}\n\n.mdi-file-document-outline::before {\n  content: \"\\F09EE\";\n}\n\n.mdi-file-download::before {\n  content: \"\\F0965\";\n}\n\n.mdi-file-download-outline::before {\n  content: \"\\F0966\";\n}\n\n.mdi-file-edit::before {\n  content: \"\\F11E7\";\n}\n\n.mdi-file-edit-outline::before {\n  content: \"\\F11E8\";\n}\n\n.mdi-file-excel::before {\n  content: \"\\F021B\";\n}\n\n.mdi-file-excel-box::before {\n  content: \"\\F021C\";\n}\n\n.mdi-file-excel-box-outline::before {\n  content: \"\\F102C\";\n}\n\n.mdi-file-excel-outline::before {\n  content: \"\\F102D\";\n}\n\n.mdi-file-export::before {\n  content: \"\\F021D\";\n}\n\n.mdi-file-export-outline::before {\n  content: \"\\F102E\";\n}\n\n.mdi-file-eye::before {\n  content: \"\\F0DCA\";\n}\n\n.mdi-file-eye-outline::before {\n  content: \"\\F0DCB\";\n}\n\n.mdi-file-find::before {\n  content: \"\\F021E\";\n}\n\n.mdi-file-find-outline::before {\n  content: \"\\F0B97\";\n}\n\n.mdi-file-gif-box::before {\n  content: \"\\F0D78\";\n}\n\n.mdi-file-hidden::before {\n  content: \"\\F0613\";\n}\n\n.mdi-file-image::before {\n  content: \"\\F021F\";\n}\n\n.mdi-file-image-marker::before {\n  content: \"\\F1772\";\n}\n\n.mdi-file-image-marker-outline::before {\n  content: \"\\F1773\";\n}\n\n.mdi-file-image-minus::before {\n  content: \"\\F193B\";\n}\n\n.mdi-file-image-minus-outline::before {\n  content: \"\\F193C\";\n}\n\n.mdi-file-image-outline::before {\n  content: \"\\F0EB0\";\n}\n\n.mdi-file-image-plus::before {\n  content: \"\\F193D\";\n}\n\n.mdi-file-image-plus-outline::before {\n  content: \"\\F193E\";\n}\n\n.mdi-file-image-remove::before {\n  content: \"\\F193F\";\n}\n\n.mdi-file-image-remove-outline::before {\n  content: \"\\F1940\";\n}\n\n.mdi-file-import::before {\n  content: \"\\F0220\";\n}\n\n.mdi-file-import-outline::before {\n  content: \"\\F102F\";\n}\n\n.mdi-file-jpg-box::before {\n  content: \"\\F0225\";\n}\n\n.mdi-file-key::before {\n  content: \"\\F1184\";\n}\n\n.mdi-file-key-outline::before {\n  content: \"\\F1185\";\n}\n\n.mdi-file-link::before {\n  content: \"\\F1177\";\n}\n\n.mdi-file-link-outline::before {\n  content: \"\\F1178\";\n}\n\n.mdi-file-lock::before {\n  content: \"\\F0221\";\n}\n\n.mdi-file-lock-outline::before {\n  content: \"\\F1030\";\n}\n\n.mdi-file-marker::before {\n  content: \"\\F1774\";\n}\n\n.mdi-file-marker-outline::before {\n  content: \"\\F1775\";\n}\n\n.mdi-file-move::before {\n  content: \"\\F0AB9\";\n}\n\n.mdi-file-move-outline::before {\n  content: \"\\F1031\";\n}\n\n.mdi-file-multiple::before {\n  content: \"\\F0222\";\n}\n\n.mdi-file-multiple-outline::before {\n  content: \"\\F1032\";\n}\n\n.mdi-file-music::before {\n  content: \"\\F0223\";\n}\n\n.mdi-file-music-outline::before {\n  content: \"\\F0E2A\";\n}\n\n.mdi-file-outline::before {\n  content: \"\\F0224\";\n}\n\n.mdi-file-pdf-box::before {\n  content: \"\\F0226\";\n}\n\n.mdi-file-percent::before {\n  content: \"\\F081E\";\n}\n\n.mdi-file-percent-outline::before {\n  content: \"\\F1033\";\n}\n\n.mdi-file-phone::before {\n  content: \"\\F1179\";\n}\n\n.mdi-file-phone-outline::before {\n  content: \"\\F117A\";\n}\n\n.mdi-file-plus::before {\n  content: \"\\F0752\";\n}\n\n.mdi-file-plus-outline::before {\n  content: \"\\F0EED\";\n}\n\n.mdi-file-png-box::before {\n  content: \"\\F0E2D\";\n}\n\n.mdi-file-powerpoint::before {\n  content: \"\\F0227\";\n}\n\n.mdi-file-powerpoint-box::before {\n  content: \"\\F0228\";\n}\n\n.mdi-file-powerpoint-box-outline::before {\n  content: \"\\F1034\";\n}\n\n.mdi-file-powerpoint-outline::before {\n  content: \"\\F1035\";\n}\n\n.mdi-file-presentation-box::before {\n  content: \"\\F0229\";\n}\n\n.mdi-file-question::before {\n  content: \"\\F086F\";\n}\n\n.mdi-file-question-outline::before {\n  content: \"\\F1036\";\n}\n\n.mdi-file-refresh::before {\n  content: \"\\F0918\";\n}\n\n.mdi-file-refresh-outline::before {\n  content: \"\\F0541\";\n}\n\n.mdi-file-remove::before {\n  content: \"\\F0B98\";\n}\n\n.mdi-file-remove-outline::before {\n  content: \"\\F1037\";\n}\n\n.mdi-file-replace::before {\n  content: \"\\F0B32\";\n}\n\n.mdi-file-replace-outline::before {\n  content: \"\\F0B33\";\n}\n\n.mdi-file-restore::before {\n  content: \"\\F0670\";\n}\n\n.mdi-file-restore-outline::before {\n  content: \"\\F1038\";\n}\n\n.mdi-file-search::before {\n  content: \"\\F0C7C\";\n}\n\n.mdi-file-search-outline::before {\n  content: \"\\F0C7D\";\n}\n\n.mdi-file-send::before {\n  content: \"\\F022A\";\n}\n\n.mdi-file-send-outline::before {\n  content: \"\\F1039\";\n}\n\n.mdi-file-settings::before {\n  content: \"\\F1079\";\n}\n\n.mdi-file-settings-outline::before {\n  content: \"\\F107A\";\n}\n\n.mdi-file-sign::before {\n  content: \"\\F19C3\";\n}\n\n.mdi-file-star::before {\n  content: \"\\F103A\";\n}\n\n.mdi-file-star-outline::before {\n  content: \"\\F103B\";\n}\n\n.mdi-file-swap::before {\n  content: \"\\F0FB4\";\n}\n\n.mdi-file-swap-outline::before {\n  content: \"\\F0FB5\";\n}\n\n.mdi-file-sync::before {\n  content: \"\\F1216\";\n}\n\n.mdi-file-sync-outline::before {\n  content: \"\\F1217\";\n}\n\n.mdi-file-table::before {\n  content: \"\\F0C7E\";\n}\n\n.mdi-file-table-box::before {\n  content: \"\\F10E1\";\n}\n\n.mdi-file-table-box-multiple::before {\n  content: \"\\F10E2\";\n}\n\n.mdi-file-table-box-multiple-outline::before {\n  content: \"\\F10E3\";\n}\n\n.mdi-file-table-box-outline::before {\n  content: \"\\F10E4\";\n}\n\n.mdi-file-table-outline::before {\n  content: \"\\F0C7F\";\n}\n\n.mdi-file-tree::before {\n  content: \"\\F0645\";\n}\n\n.mdi-file-tree-outline::before {\n  content: \"\\F13D2\";\n}\n\n.mdi-file-undo::before {\n  content: \"\\F08DC\";\n}\n\n.mdi-file-undo-outline::before {\n  content: \"\\F103C\";\n}\n\n.mdi-file-upload::before {\n  content: \"\\F0A4D\";\n}\n\n.mdi-file-upload-outline::before {\n  content: \"\\F0A4E\";\n}\n\n.mdi-file-video::before {\n  content: \"\\F022B\";\n}\n\n.mdi-file-video-outline::before {\n  content: \"\\F0E2C\";\n}\n\n.mdi-file-word::before {\n  content: \"\\F022C\";\n}\n\n.mdi-file-word-box::before {\n  content: \"\\F022D\";\n}\n\n.mdi-file-word-box-outline::before {\n  content: \"\\F103D\";\n}\n\n.mdi-file-word-outline::before {\n  content: \"\\F103E\";\n}\n\n.mdi-film::before {\n  content: \"\\F022F\";\n}\n\n.mdi-filmstrip::before {\n  content: \"\\F0230\";\n}\n\n.mdi-filmstrip-box::before {\n  content: \"\\F0332\";\n}\n\n.mdi-filmstrip-box-multiple::before {\n  content: \"\\F0D18\";\n}\n\n.mdi-filmstrip-off::before {\n  content: \"\\F0231\";\n}\n\n.mdi-filter::before {\n  content: \"\\F0232\";\n}\n\n.mdi-filter-check::before {\n  content: \"\\F18EC\";\n}\n\n.mdi-filter-check-outline::before {\n  content: \"\\F18ED\";\n}\n\n.mdi-filter-menu::before {\n  content: \"\\F10E5\";\n}\n\n.mdi-filter-menu-outline::before {\n  content: \"\\F10E6\";\n}\n\n.mdi-filter-minus::before {\n  content: \"\\F0EEE\";\n}\n\n.mdi-filter-minus-outline::before {\n  content: \"\\F0EEF\";\n}\n\n.mdi-filter-off::before {\n  content: \"\\F14EF\";\n}\n\n.mdi-filter-off-outline::before {\n  content: \"\\F14F0\";\n}\n\n.mdi-filter-outline::before {\n  content: \"\\F0233\";\n}\n\n.mdi-filter-plus::before {\n  content: \"\\F0EF0\";\n}\n\n.mdi-filter-plus-outline::before {\n  content: \"\\F0EF1\";\n}\n\n.mdi-filter-remove::before {\n  content: \"\\F0234\";\n}\n\n.mdi-filter-remove-outline::before {\n  content: \"\\F0235\";\n}\n\n.mdi-filter-variant::before {\n  content: \"\\F0236\";\n}\n\n.mdi-filter-variant-minus::before {\n  content: \"\\F1112\";\n}\n\n.mdi-filter-variant-plus::before {\n  content: \"\\F1113\";\n}\n\n.mdi-filter-variant-remove::before {\n  content: \"\\F103F\";\n}\n\n.mdi-finance::before {\n  content: \"\\F081F\";\n}\n\n.mdi-find-replace::before {\n  content: \"\\F06D4\";\n}\n\n.mdi-fingerprint::before {\n  content: \"\\F0237\";\n}\n\n.mdi-fingerprint-off::before {\n  content: \"\\F0EB1\";\n}\n\n.mdi-fire::before {\n  content: \"\\F0238\";\n}\n\n.mdi-fire-alert::before {\n  content: \"\\F15D7\";\n}\n\n.mdi-fire-circle::before {\n  content: \"\\F1807\";\n}\n\n.mdi-fire-extinguisher::before {\n  content: \"\\F0EF2\";\n}\n\n.mdi-fire-hydrant::before {\n  content: \"\\F1137\";\n}\n\n.mdi-fire-hydrant-alert::before {\n  content: \"\\F1138\";\n}\n\n.mdi-fire-hydrant-off::before {\n  content: \"\\F1139\";\n}\n\n.mdi-fire-off::before {\n  content: \"\\F1722\";\n}\n\n.mdi-fire-truck::before {\n  content: \"\\F08AB\";\n}\n\n.mdi-firebase::before {\n  content: \"\\F0967\";\n}\n\n.mdi-firefox::before {\n  content: \"\\F0239\";\n}\n\n.mdi-fireplace::before {\n  content: \"\\F0E2E\";\n}\n\n.mdi-fireplace-off::before {\n  content: \"\\F0E2F\";\n}\n\n.mdi-firewire::before {\n  content: \"\\F05BE\";\n}\n\n.mdi-firework::before {\n  content: \"\\F0E30\";\n}\n\n.mdi-firework-off::before {\n  content: \"\\F1723\";\n}\n\n.mdi-fish::before {\n  content: \"\\F023A\";\n}\n\n.mdi-fish-off::before {\n  content: \"\\F13F3\";\n}\n\n.mdi-fishbowl::before {\n  content: \"\\F0EF3\";\n}\n\n.mdi-fishbowl-outline::before {\n  content: \"\\F0EF4\";\n}\n\n.mdi-fit-to-page::before {\n  content: \"\\F0EF5\";\n}\n\n.mdi-fit-to-page-outline::before {\n  content: \"\\F0EF6\";\n}\n\n.mdi-fit-to-screen::before {\n  content: \"\\F18F4\";\n}\n\n.mdi-fit-to-screen-outline::before {\n  content: \"\\F18F5\";\n}\n\n.mdi-flag::before {\n  content: \"\\F023B\";\n}\n\n.mdi-flag-checkered::before {\n  content: \"\\F023C\";\n}\n\n.mdi-flag-minus::before {\n  content: \"\\F0B99\";\n}\n\n.mdi-flag-minus-outline::before {\n  content: \"\\F10B2\";\n}\n\n.mdi-flag-off::before {\n  content: \"\\F18EE\";\n}\n\n.mdi-flag-off-outline::before {\n  content: \"\\F18EF\";\n}\n\n.mdi-flag-outline::before {\n  content: \"\\F023D\";\n}\n\n.mdi-flag-plus::before {\n  content: \"\\F0B9A\";\n}\n\n.mdi-flag-plus-outline::before {\n  content: \"\\F10B3\";\n}\n\n.mdi-flag-remove::before {\n  content: \"\\F0B9B\";\n}\n\n.mdi-flag-remove-outline::before {\n  content: \"\\F10B4\";\n}\n\n.mdi-flag-triangle::before {\n  content: \"\\F023F\";\n}\n\n.mdi-flag-variant::before {\n  content: \"\\F0240\";\n}\n\n.mdi-flag-variant-outline::before {\n  content: \"\\F023E\";\n}\n\n.mdi-flare::before {\n  content: \"\\F0D72\";\n}\n\n.mdi-flash::before {\n  content: \"\\F0241\";\n}\n\n.mdi-flash-alert::before {\n  content: \"\\F0EF7\";\n}\n\n.mdi-flash-alert-outline::before {\n  content: \"\\F0EF8\";\n}\n\n.mdi-flash-auto::before {\n  content: \"\\F0242\";\n}\n\n.mdi-flash-off::before {\n  content: \"\\F0243\";\n}\n\n.mdi-flash-outline::before {\n  content: \"\\F06D5\";\n}\n\n.mdi-flash-red-eye::before {\n  content: \"\\F067B\";\n}\n\n.mdi-flashlight::before {\n  content: \"\\F0244\";\n}\n\n.mdi-flashlight-off::before {\n  content: \"\\F0245\";\n}\n\n.mdi-flask::before {\n  content: \"\\F0093\";\n}\n\n.mdi-flask-empty::before {\n  content: \"\\F0094\";\n}\n\n.mdi-flask-empty-minus::before {\n  content: \"\\F123A\";\n}\n\n.mdi-flask-empty-minus-outline::before {\n  content: \"\\F123B\";\n}\n\n.mdi-flask-empty-off::before {\n  content: \"\\F13F4\";\n}\n\n.mdi-flask-empty-off-outline::before {\n  content: \"\\F13F5\";\n}\n\n.mdi-flask-empty-outline::before {\n  content: \"\\F0095\";\n}\n\n.mdi-flask-empty-plus::before {\n  content: \"\\F123C\";\n}\n\n.mdi-flask-empty-plus-outline::before {\n  content: \"\\F123D\";\n}\n\n.mdi-flask-empty-remove::before {\n  content: \"\\F123E\";\n}\n\n.mdi-flask-empty-remove-outline::before {\n  content: \"\\F123F\";\n}\n\n.mdi-flask-minus::before {\n  content: \"\\F1240\";\n}\n\n.mdi-flask-minus-outline::before {\n  content: \"\\F1241\";\n}\n\n.mdi-flask-off::before {\n  content: \"\\F13F6\";\n}\n\n.mdi-flask-off-outline::before {\n  content: \"\\F13F7\";\n}\n\n.mdi-flask-outline::before {\n  content: \"\\F0096\";\n}\n\n.mdi-flask-plus::before {\n  content: \"\\F1242\";\n}\n\n.mdi-flask-plus-outline::before {\n  content: \"\\F1243\";\n}\n\n.mdi-flask-remove::before {\n  content: \"\\F1244\";\n}\n\n.mdi-flask-remove-outline::before {\n  content: \"\\F1245\";\n}\n\n.mdi-flask-round-bottom::before {\n  content: \"\\F124B\";\n}\n\n.mdi-flask-round-bottom-empty::before {\n  content: \"\\F124C\";\n}\n\n.mdi-flask-round-bottom-empty-outline::before {\n  content: \"\\F124D\";\n}\n\n.mdi-flask-round-bottom-outline::before {\n  content: \"\\F124E\";\n}\n\n.mdi-fleur-de-lis::before {\n  content: \"\\F1303\";\n}\n\n.mdi-flip-horizontal::before {\n  content: \"\\F10E7\";\n}\n\n.mdi-flip-to-back::before {\n  content: \"\\F0247\";\n}\n\n.mdi-flip-to-front::before {\n  content: \"\\F0248\";\n}\n\n.mdi-flip-vertical::before {\n  content: \"\\F10E8\";\n}\n\n.mdi-floor-lamp::before {\n  content: \"\\F08DD\";\n}\n\n.mdi-floor-lamp-dual::before {\n  content: \"\\F1040\";\n}\n\n.mdi-floor-lamp-dual-outline::before {\n  content: \"\\F17CE\";\n}\n\n.mdi-floor-lamp-outline::before {\n  content: \"\\F17C8\";\n}\n\n.mdi-floor-lamp-torchiere::before {\n  content: \"\\F1747\";\n}\n\n.mdi-floor-lamp-torchiere-outline::before {\n  content: \"\\F17D6\";\n}\n\n.mdi-floor-lamp-torchiere-variant::before {\n  content: \"\\F1041\";\n}\n\n.mdi-floor-lamp-torchiere-variant-outline::before {\n  content: \"\\F17CF\";\n}\n\n.mdi-floor-plan::before {\n  content: \"\\F0821\";\n}\n\n.mdi-floppy::before {\n  content: \"\\F0249\";\n}\n\n.mdi-floppy-variant::before {\n  content: \"\\F09EF\";\n}\n\n.mdi-flower::before {\n  content: \"\\F024A\";\n}\n\n.mdi-flower-outline::before {\n  content: \"\\F09F0\";\n}\n\n.mdi-flower-pollen::before {\n  content: \"\\F1885\";\n}\n\n.mdi-flower-pollen-outline::before {\n  content: \"\\F1886\";\n}\n\n.mdi-flower-poppy::before {\n  content: \"\\F0D08\";\n}\n\n.mdi-flower-tulip::before {\n  content: \"\\F09F1\";\n}\n\n.mdi-flower-tulip-outline::before {\n  content: \"\\F09F2\";\n}\n\n.mdi-focus-auto::before {\n  content: \"\\F0F4E\";\n}\n\n.mdi-focus-field::before {\n  content: \"\\F0F4F\";\n}\n\n.mdi-focus-field-horizontal::before {\n  content: \"\\F0F50\";\n}\n\n.mdi-focus-field-vertical::before {\n  content: \"\\F0F51\";\n}\n\n.mdi-folder::before {\n  content: \"\\F024B\";\n}\n\n.mdi-folder-account::before {\n  content: \"\\F024C\";\n}\n\n.mdi-folder-account-outline::before {\n  content: \"\\F0B9C\";\n}\n\n.mdi-folder-alert::before {\n  content: \"\\F0DCC\";\n}\n\n.mdi-folder-alert-outline::before {\n  content: \"\\F0DCD\";\n}\n\n.mdi-folder-check::before {\n  content: \"\\F197E\";\n}\n\n.mdi-folder-check-outline::before {\n  content: \"\\F197F\";\n}\n\n.mdi-folder-clock::before {\n  content: \"\\F0ABA\";\n}\n\n.mdi-folder-clock-outline::before {\n  content: \"\\F0ABB\";\n}\n\n.mdi-folder-cog::before {\n  content: \"\\F107F\";\n}\n\n.mdi-folder-cog-outline::before {\n  content: \"\\F1080\";\n}\n\n.mdi-folder-download::before {\n  content: \"\\F024D\";\n}\n\n.mdi-folder-download-outline::before {\n  content: \"\\F10E9\";\n}\n\n.mdi-folder-edit::before {\n  content: \"\\F08DE\";\n}\n\n.mdi-folder-edit-outline::before {\n  content: \"\\F0DCE\";\n}\n\n.mdi-folder-eye::before {\n  content: \"\\F178A\";\n}\n\n.mdi-folder-eye-outline::before {\n  content: \"\\F178B\";\n}\n\n.mdi-folder-google-drive::before {\n  content: \"\\F024E\";\n}\n\n.mdi-folder-heart::before {\n  content: \"\\F10EA\";\n}\n\n.mdi-folder-heart-outline::before {\n  content: \"\\F10EB\";\n}\n\n.mdi-folder-hidden::before {\n  content: \"\\F179E\";\n}\n\n.mdi-folder-home::before {\n  content: \"\\F10B5\";\n}\n\n.mdi-folder-home-outline::before {\n  content: \"\\F10B6\";\n}\n\n.mdi-folder-image::before {\n  content: \"\\F024F\";\n}\n\n.mdi-folder-information::before {\n  content: \"\\F10B7\";\n}\n\n.mdi-folder-information-outline::before {\n  content: \"\\F10B8\";\n}\n\n.mdi-folder-key::before {\n  content: \"\\F08AC\";\n}\n\n.mdi-folder-key-network::before {\n  content: \"\\F08AD\";\n}\n\n.mdi-folder-key-network-outline::before {\n  content: \"\\F0C80\";\n}\n\n.mdi-folder-key-outline::before {\n  content: \"\\F10EC\";\n}\n\n.mdi-folder-lock::before {\n  content: \"\\F0250\";\n}\n\n.mdi-folder-lock-open::before {\n  content: \"\\F0251\";\n}\n\n.mdi-folder-marker::before {\n  content: \"\\F126D\";\n}\n\n.mdi-folder-marker-outline::before {\n  content: \"\\F126E\";\n}\n\n.mdi-folder-move::before {\n  content: \"\\F0252\";\n}\n\n.mdi-folder-move-outline::before {\n  content: \"\\F1246\";\n}\n\n.mdi-folder-multiple::before {\n  content: \"\\F0253\";\n}\n\n.mdi-folder-multiple-image::before {\n  content: \"\\F0254\";\n}\n\n.mdi-folder-multiple-outline::before {\n  content: \"\\F0255\";\n}\n\n.mdi-folder-multiple-plus::before {\n  content: \"\\F147E\";\n}\n\n.mdi-folder-multiple-plus-outline::before {\n  content: \"\\F147F\";\n}\n\n.mdi-folder-music::before {\n  content: \"\\F1359\";\n}\n\n.mdi-folder-music-outline::before {\n  content: \"\\F135A\";\n}\n\n.mdi-folder-network::before {\n  content: \"\\F0870\";\n}\n\n.mdi-folder-network-outline::before {\n  content: \"\\F0C81\";\n}\n\n.mdi-folder-open::before {\n  content: \"\\F0770\";\n}\n\n.mdi-folder-open-outline::before {\n  content: \"\\F0DCF\";\n}\n\n.mdi-folder-outline::before {\n  content: \"\\F0256\";\n}\n\n.mdi-folder-plus::before {\n  content: \"\\F0257\";\n}\n\n.mdi-folder-plus-outline::before {\n  content: \"\\F0B9D\";\n}\n\n.mdi-folder-pound::before {\n  content: \"\\F0D09\";\n}\n\n.mdi-folder-pound-outline::before {\n  content: \"\\F0D0A\";\n}\n\n.mdi-folder-refresh::before {\n  content: \"\\F0749\";\n}\n\n.mdi-folder-refresh-outline::before {\n  content: \"\\F0542\";\n}\n\n.mdi-folder-remove::before {\n  content: \"\\F0258\";\n}\n\n.mdi-folder-remove-outline::before {\n  content: \"\\F0B9E\";\n}\n\n.mdi-folder-search::before {\n  content: \"\\F0968\";\n}\n\n.mdi-folder-search-outline::before {\n  content: \"\\F0969\";\n}\n\n.mdi-folder-settings::before {\n  content: \"\\F107D\";\n}\n\n.mdi-folder-settings-outline::before {\n  content: \"\\F107E\";\n}\n\n.mdi-folder-star::before {\n  content: \"\\F069D\";\n}\n\n.mdi-folder-star-multiple::before {\n  content: \"\\F13D3\";\n}\n\n.mdi-folder-star-multiple-outline::before {\n  content: \"\\F13D4\";\n}\n\n.mdi-folder-star-outline::before {\n  content: \"\\F0B9F\";\n}\n\n.mdi-folder-swap::before {\n  content: \"\\F0FB6\";\n}\n\n.mdi-folder-swap-outline::before {\n  content: \"\\F0FB7\";\n}\n\n.mdi-folder-sync::before {\n  content: \"\\F0D0B\";\n}\n\n.mdi-folder-sync-outline::before {\n  content: \"\\F0D0C\";\n}\n\n.mdi-folder-table::before {\n  content: \"\\F12E3\";\n}\n\n.mdi-folder-table-outline::before {\n  content: \"\\F12E4\";\n}\n\n.mdi-folder-text::before {\n  content: \"\\F0C82\";\n}\n\n.mdi-folder-text-outline::before {\n  content: \"\\F0C83\";\n}\n\n.mdi-folder-upload::before {\n  content: \"\\F0259\";\n}\n\n.mdi-folder-upload-outline::before {\n  content: \"\\F10ED\";\n}\n\n.mdi-folder-zip::before {\n  content: \"\\F06EB\";\n}\n\n.mdi-folder-zip-outline::before {\n  content: \"\\F07B9\";\n}\n\n.mdi-font-awesome::before {\n  content: \"\\F003A\";\n}\n\n.mdi-food::before {\n  content: \"\\F025A\";\n}\n\n.mdi-food-apple::before {\n  content: \"\\F025B\";\n}\n\n.mdi-food-apple-outline::before {\n  content: \"\\F0C84\";\n}\n\n.mdi-food-croissant::before {\n  content: \"\\F07C8\";\n}\n\n.mdi-food-drumstick::before {\n  content: \"\\F141F\";\n}\n\n.mdi-food-drumstick-off::before {\n  content: \"\\F1468\";\n}\n\n.mdi-food-drumstick-off-outline::before {\n  content: \"\\F1469\";\n}\n\n.mdi-food-drumstick-outline::before {\n  content: \"\\F1420\";\n}\n\n.mdi-food-fork-drink::before {\n  content: \"\\F05F2\";\n}\n\n.mdi-food-halal::before {\n  content: \"\\F1572\";\n}\n\n.mdi-food-hot-dog::before {\n  content: \"\\F184B\";\n}\n\n.mdi-food-kosher::before {\n  content: \"\\F1573\";\n}\n\n.mdi-food-off::before {\n  content: \"\\F05F3\";\n}\n\n.mdi-food-off-outline::before {\n  content: \"\\F1915\";\n}\n\n.mdi-food-outline::before {\n  content: \"\\F1916\";\n}\n\n.mdi-food-steak::before {\n  content: \"\\F146A\";\n}\n\n.mdi-food-steak-off::before {\n  content: \"\\F146B\";\n}\n\n.mdi-food-takeout-box::before {\n  content: \"\\F1836\";\n}\n\n.mdi-food-takeout-box-outline::before {\n  content: \"\\F1837\";\n}\n\n.mdi-food-turkey::before {\n  content: \"\\F171C\";\n}\n\n.mdi-food-variant::before {\n  content: \"\\F025C\";\n}\n\n.mdi-food-variant-off::before {\n  content: \"\\F13E5\";\n}\n\n.mdi-foot-print::before {\n  content: \"\\F0F52\";\n}\n\n.mdi-football::before {\n  content: \"\\F025D\";\n}\n\n.mdi-football-australian::before {\n  content: \"\\F025E\";\n}\n\n.mdi-football-helmet::before {\n  content: \"\\F025F\";\n}\n\n.mdi-forest::before {\n  content: \"\\F1897\";\n}\n\n.mdi-forklift::before {\n  content: \"\\F07C9\";\n}\n\n.mdi-form-dropdown::before {\n  content: \"\\F1400\";\n}\n\n.mdi-form-select::before {\n  content: \"\\F1401\";\n}\n\n.mdi-form-textarea::before {\n  content: \"\\F1095\";\n}\n\n.mdi-form-textbox::before {\n  content: \"\\F060E\";\n}\n\n.mdi-form-textbox-lock::before {\n  content: \"\\F135D\";\n}\n\n.mdi-form-textbox-password::before {\n  content: \"\\F07F5\";\n}\n\n.mdi-format-align-bottom::before {\n  content: \"\\F0753\";\n}\n\n.mdi-format-align-center::before {\n  content: \"\\F0260\";\n}\n\n.mdi-format-align-justify::before {\n  content: \"\\F0261\";\n}\n\n.mdi-format-align-left::before {\n  content: \"\\F0262\";\n}\n\n.mdi-format-align-middle::before {\n  content: \"\\F0754\";\n}\n\n.mdi-format-align-right::before {\n  content: \"\\F0263\";\n}\n\n.mdi-format-align-top::before {\n  content: \"\\F0755\";\n}\n\n.mdi-format-annotation-minus::before {\n  content: \"\\F0ABC\";\n}\n\n.mdi-format-annotation-plus::before {\n  content: \"\\F0646\";\n}\n\n.mdi-format-bold::before {\n  content: \"\\F0264\";\n}\n\n.mdi-format-clear::before {\n  content: \"\\F0265\";\n}\n\n.mdi-format-color-fill::before {\n  content: \"\\F0266\";\n}\n\n.mdi-format-color-highlight::before {\n  content: \"\\F0E31\";\n}\n\n.mdi-format-color-marker-cancel::before {\n  content: \"\\F1313\";\n}\n\n.mdi-format-color-text::before {\n  content: \"\\F069E\";\n}\n\n.mdi-format-columns::before {\n  content: \"\\F08DF\";\n}\n\n.mdi-format-float-center::before {\n  content: \"\\F0267\";\n}\n\n.mdi-format-float-left::before {\n  content: \"\\F0268\";\n}\n\n.mdi-format-float-none::before {\n  content: \"\\F0269\";\n}\n\n.mdi-format-float-right::before {\n  content: \"\\F026A\";\n}\n\n.mdi-format-font::before {\n  content: \"\\F06D6\";\n}\n\n.mdi-format-font-size-decrease::before {\n  content: \"\\F09F3\";\n}\n\n.mdi-format-font-size-increase::before {\n  content: \"\\F09F4\";\n}\n\n.mdi-format-header-1::before {\n  content: \"\\F026B\";\n}\n\n.mdi-format-header-2::before {\n  content: \"\\F026C\";\n}\n\n.mdi-format-header-3::before {\n  content: \"\\F026D\";\n}\n\n.mdi-format-header-4::before {\n  content: \"\\F026E\";\n}\n\n.mdi-format-header-5::before {\n  content: \"\\F026F\";\n}\n\n.mdi-format-header-6::before {\n  content: \"\\F0270\";\n}\n\n.mdi-format-header-decrease::before {\n  content: \"\\F0271\";\n}\n\n.mdi-format-header-equal::before {\n  content: \"\\F0272\";\n}\n\n.mdi-format-header-increase::before {\n  content: \"\\F0273\";\n}\n\n.mdi-format-header-pound::before {\n  content: \"\\F0274\";\n}\n\n.mdi-format-horizontal-align-center::before {\n  content: \"\\F061E\";\n}\n\n.mdi-format-horizontal-align-left::before {\n  content: \"\\F061F\";\n}\n\n.mdi-format-horizontal-align-right::before {\n  content: \"\\F0620\";\n}\n\n.mdi-format-indent-decrease::before {\n  content: \"\\F0275\";\n}\n\n.mdi-format-indent-increase::before {\n  content: \"\\F0276\";\n}\n\n.mdi-format-italic::before {\n  content: \"\\F0277\";\n}\n\n.mdi-format-letter-case::before {\n  content: \"\\F0B34\";\n}\n\n.mdi-format-letter-case-lower::before {\n  content: \"\\F0B35\";\n}\n\n.mdi-format-letter-case-upper::before {\n  content: \"\\F0B36\";\n}\n\n.mdi-format-letter-ends-with::before {\n  content: \"\\F0FB8\";\n}\n\n.mdi-format-letter-matches::before {\n  content: \"\\F0FB9\";\n}\n\n.mdi-format-letter-spacing::before {\n  content: \"\\F1956\";\n}\n\n.mdi-format-letter-starts-with::before {\n  content: \"\\F0FBA\";\n}\n\n.mdi-format-line-spacing::before {\n  content: \"\\F0278\";\n}\n\n.mdi-format-line-style::before {\n  content: \"\\F05C8\";\n}\n\n.mdi-format-line-weight::before {\n  content: \"\\F05C9\";\n}\n\n.mdi-format-list-bulleted::before {\n  content: \"\\F0279\";\n}\n\n.mdi-format-list-bulleted-square::before {\n  content: \"\\F0DD0\";\n}\n\n.mdi-format-list-bulleted-triangle::before {\n  content: \"\\F0EB2\";\n}\n\n.mdi-format-list-bulleted-type::before {\n  content: \"\\F027A\";\n}\n\n.mdi-format-list-checkbox::before {\n  content: \"\\F096A\";\n}\n\n.mdi-format-list-checks::before {\n  content: \"\\F0756\";\n}\n\n.mdi-format-list-group::before {\n  content: \"\\F1860\";\n}\n\n.mdi-format-list-numbered::before {\n  content: \"\\F027B\";\n}\n\n.mdi-format-list-numbered-rtl::before {\n  content: \"\\F0D0D\";\n}\n\n.mdi-format-list-text::before {\n  content: \"\\F126F\";\n}\n\n.mdi-format-overline::before {\n  content: \"\\F0EB3\";\n}\n\n.mdi-format-page-break::before {\n  content: \"\\F06D7\";\n}\n\n.mdi-format-page-split::before {\n  content: \"\\F1917\";\n}\n\n.mdi-format-paint::before {\n  content: \"\\F027C\";\n}\n\n.mdi-format-paragraph::before {\n  content: \"\\F027D\";\n}\n\n.mdi-format-pilcrow::before {\n  content: \"\\F06D8\";\n}\n\n.mdi-format-quote-close::before {\n  content: \"\\F027E\";\n}\n\n.mdi-format-quote-close-outline::before {\n  content: \"\\F11A8\";\n}\n\n.mdi-format-quote-open::before {\n  content: \"\\F0757\";\n}\n\n.mdi-format-quote-open-outline::before {\n  content: \"\\F11A7\";\n}\n\n.mdi-format-rotate-90::before {\n  content: \"\\F06AA\";\n}\n\n.mdi-format-section::before {\n  content: \"\\F069F\";\n}\n\n.mdi-format-size::before {\n  content: \"\\F027F\";\n}\n\n.mdi-format-strikethrough::before {\n  content: \"\\F0280\";\n}\n\n.mdi-format-strikethrough-variant::before {\n  content: \"\\F0281\";\n}\n\n.mdi-format-subscript::before {\n  content: \"\\F0282\";\n}\n\n.mdi-format-superscript::before {\n  content: \"\\F0283\";\n}\n\n.mdi-format-text::before {\n  content: \"\\F0284\";\n}\n\n.mdi-format-text-rotation-angle-down::before {\n  content: \"\\F0FBB\";\n}\n\n.mdi-format-text-rotation-angle-up::before {\n  content: \"\\F0FBC\";\n}\n\n.mdi-format-text-rotation-down::before {\n  content: \"\\F0D73\";\n}\n\n.mdi-format-text-rotation-down-vertical::before {\n  content: \"\\F0FBD\";\n}\n\n.mdi-format-text-rotation-none::before {\n  content: \"\\F0D74\";\n}\n\n.mdi-format-text-rotation-up::before {\n  content: \"\\F0FBE\";\n}\n\n.mdi-format-text-rotation-vertical::before {\n  content: \"\\F0FBF\";\n}\n\n.mdi-format-text-variant::before {\n  content: \"\\F0E32\";\n}\n\n.mdi-format-text-variant-outline::before {\n  content: \"\\F150F\";\n}\n\n.mdi-format-text-wrapping-clip::before {\n  content: \"\\F0D0E\";\n}\n\n.mdi-format-text-wrapping-overflow::before {\n  content: \"\\F0D0F\";\n}\n\n.mdi-format-text-wrapping-wrap::before {\n  content: \"\\F0D10\";\n}\n\n.mdi-format-textbox::before {\n  content: \"\\F0D11\";\n}\n\n.mdi-format-textdirection-l-to-r::before {\n  content: \"\\F0285\";\n}\n\n.mdi-format-textdirection-r-to-l::before {\n  content: \"\\F0286\";\n}\n\n.mdi-format-title::before {\n  content: \"\\F05F4\";\n}\n\n.mdi-format-underline::before {\n  content: \"\\F0287\";\n}\n\n.mdi-format-underline-wavy::before {\n  content: \"\\F18E9\";\n}\n\n.mdi-format-vertical-align-bottom::before {\n  content: \"\\F0621\";\n}\n\n.mdi-format-vertical-align-center::before {\n  content: \"\\F0622\";\n}\n\n.mdi-format-vertical-align-top::before {\n  content: \"\\F0623\";\n}\n\n.mdi-format-wrap-inline::before {\n  content: \"\\F0288\";\n}\n\n.mdi-format-wrap-square::before {\n  content: \"\\F0289\";\n}\n\n.mdi-format-wrap-tight::before {\n  content: \"\\F028A\";\n}\n\n.mdi-format-wrap-top-bottom::before {\n  content: \"\\F028B\";\n}\n\n.mdi-forum::before {\n  content: \"\\F028C\";\n}\n\n.mdi-forum-outline::before {\n  content: \"\\F0822\";\n}\n\n.mdi-forward::before {\n  content: \"\\F028D\";\n}\n\n.mdi-forwardburger::before {\n  content: \"\\F0D75\";\n}\n\n.mdi-fountain::before {\n  content: \"\\F096B\";\n}\n\n.mdi-fountain-pen::before {\n  content: \"\\F0D12\";\n}\n\n.mdi-fountain-pen-tip::before {\n  content: \"\\F0D13\";\n}\n\n.mdi-fraction-one-half::before {\n  content: \"\\F1992\";\n}\n\n.mdi-freebsd::before {\n  content: \"\\F08E0\";\n}\n\n.mdi-french-fries::before {\n  content: \"\\F1957\";\n}\n\n.mdi-frequently-asked-questions::before {\n  content: \"\\F0EB4\";\n}\n\n.mdi-fridge::before {\n  content: \"\\F0290\";\n}\n\n.mdi-fridge-alert::before {\n  content: \"\\F11B1\";\n}\n\n.mdi-fridge-alert-outline::before {\n  content: \"\\F11B2\";\n}\n\n.mdi-fridge-bottom::before {\n  content: \"\\F0292\";\n}\n\n.mdi-fridge-industrial::before {\n  content: \"\\F15EE\";\n}\n\n.mdi-fridge-industrial-alert::before {\n  content: \"\\F15EF\";\n}\n\n.mdi-fridge-industrial-alert-outline::before {\n  content: \"\\F15F0\";\n}\n\n.mdi-fridge-industrial-off::before {\n  content: \"\\F15F1\";\n}\n\n.mdi-fridge-industrial-off-outline::before {\n  content: \"\\F15F2\";\n}\n\n.mdi-fridge-industrial-outline::before {\n  content: \"\\F15F3\";\n}\n\n.mdi-fridge-off::before {\n  content: \"\\F11AF\";\n}\n\n.mdi-fridge-off-outline::before {\n  content: \"\\F11B0\";\n}\n\n.mdi-fridge-outline::before {\n  content: \"\\F028F\";\n}\n\n.mdi-fridge-top::before {\n  content: \"\\F0291\";\n}\n\n.mdi-fridge-variant::before {\n  content: \"\\F15F4\";\n}\n\n.mdi-fridge-variant-alert::before {\n  content: \"\\F15F5\";\n}\n\n.mdi-fridge-variant-alert-outline::before {\n  content: \"\\F15F6\";\n}\n\n.mdi-fridge-variant-off::before {\n  content: \"\\F15F7\";\n}\n\n.mdi-fridge-variant-off-outline::before {\n  content: \"\\F15F8\";\n}\n\n.mdi-fridge-variant-outline::before {\n  content: \"\\F15F9\";\n}\n\n.mdi-fruit-cherries::before {\n  content: \"\\F1042\";\n}\n\n.mdi-fruit-cherries-off::before {\n  content: \"\\F13F8\";\n}\n\n.mdi-fruit-citrus::before {\n  content: \"\\F1043\";\n}\n\n.mdi-fruit-citrus-off::before {\n  content: \"\\F13F9\";\n}\n\n.mdi-fruit-grapes::before {\n  content: \"\\F1044\";\n}\n\n.mdi-fruit-grapes-outline::before {\n  content: \"\\F1045\";\n}\n\n.mdi-fruit-pineapple::before {\n  content: \"\\F1046\";\n}\n\n.mdi-fruit-watermelon::before {\n  content: \"\\F1047\";\n}\n\n.mdi-fuel::before {\n  content: \"\\F07CA\";\n}\n\n.mdi-fuel-cell::before {\n  content: \"\\F18B5\";\n}\n\n.mdi-fullscreen::before {\n  content: \"\\F0293\";\n}\n\n.mdi-fullscreen-exit::before {\n  content: \"\\F0294\";\n}\n\n.mdi-function::before {\n  content: \"\\F0295\";\n}\n\n.mdi-function-variant::before {\n  content: \"\\F0871\";\n}\n\n.mdi-furigana-horizontal::before {\n  content: \"\\F1081\";\n}\n\n.mdi-furigana-vertical::before {\n  content: \"\\F1082\";\n}\n\n.mdi-fuse::before {\n  content: \"\\F0C85\";\n}\n\n.mdi-fuse-alert::before {\n  content: \"\\F142D\";\n}\n\n.mdi-fuse-blade::before {\n  content: \"\\F0C86\";\n}\n\n.mdi-fuse-off::before {\n  content: \"\\F142C\";\n}\n\n.mdi-gamepad::before {\n  content: \"\\F0296\";\n}\n\n.mdi-gamepad-circle::before {\n  content: \"\\F0E33\";\n}\n\n.mdi-gamepad-circle-down::before {\n  content: \"\\F0E34\";\n}\n\n.mdi-gamepad-circle-left::before {\n  content: \"\\F0E35\";\n}\n\n.mdi-gamepad-circle-outline::before {\n  content: \"\\F0E36\";\n}\n\n.mdi-gamepad-circle-right::before {\n  content: \"\\F0E37\";\n}\n\n.mdi-gamepad-circle-up::before {\n  content: \"\\F0E38\";\n}\n\n.mdi-gamepad-down::before {\n  content: \"\\F0E39\";\n}\n\n.mdi-gamepad-left::before {\n  content: \"\\F0E3A\";\n}\n\n.mdi-gamepad-outline::before {\n  content: \"\\F1919\";\n}\n\n.mdi-gamepad-right::before {\n  content: \"\\F0E3B\";\n}\n\n.mdi-gamepad-round::before {\n  content: \"\\F0E3C\";\n}\n\n.mdi-gamepad-round-down::before {\n  content: \"\\F0E3D\";\n}\n\n.mdi-gamepad-round-left::before {\n  content: \"\\F0E3E\";\n}\n\n.mdi-gamepad-round-outline::before {\n  content: \"\\F0E3F\";\n}\n\n.mdi-gamepad-round-right::before {\n  content: \"\\F0E40\";\n}\n\n.mdi-gamepad-round-up::before {\n  content: \"\\F0E41\";\n}\n\n.mdi-gamepad-square::before {\n  content: \"\\F0EB5\";\n}\n\n.mdi-gamepad-square-outline::before {\n  content: \"\\F0EB6\";\n}\n\n.mdi-gamepad-up::before {\n  content: \"\\F0E42\";\n}\n\n.mdi-gamepad-variant::before {\n  content: \"\\F0297\";\n}\n\n.mdi-gamepad-variant-outline::before {\n  content: \"\\F0EB7\";\n}\n\n.mdi-gamma::before {\n  content: \"\\F10EE\";\n}\n\n.mdi-gantry-crane::before {\n  content: \"\\F0DD1\";\n}\n\n.mdi-garage::before {\n  content: \"\\F06D9\";\n}\n\n.mdi-garage-alert::before {\n  content: \"\\F0872\";\n}\n\n.mdi-garage-alert-variant::before {\n  content: \"\\F12D5\";\n}\n\n.mdi-garage-lock::before {\n  content: \"\\F17FB\";\n}\n\n.mdi-garage-open::before {\n  content: \"\\F06DA\";\n}\n\n.mdi-garage-open-variant::before {\n  content: \"\\F12D4\";\n}\n\n.mdi-garage-variant::before {\n  content: \"\\F12D3\";\n}\n\n.mdi-garage-variant-lock::before {\n  content: \"\\F17FC\";\n}\n\n.mdi-gas-cylinder::before {\n  content: \"\\F0647\";\n}\n\n.mdi-gas-station::before {\n  content: \"\\F0298\";\n}\n\n.mdi-gas-station-off::before {\n  content: \"\\F1409\";\n}\n\n.mdi-gas-station-off-outline::before {\n  content: \"\\F140A\";\n}\n\n.mdi-gas-station-outline::before {\n  content: \"\\F0EB8\";\n}\n\n.mdi-gate::before {\n  content: \"\\F0299\";\n}\n\n.mdi-gate-alert::before {\n  content: \"\\F17F8\";\n}\n\n.mdi-gate-and::before {\n  content: \"\\F08E1\";\n}\n\n.mdi-gate-arrow-left::before {\n  content: \"\\F17F7\";\n}\n\n.mdi-gate-arrow-right::before {\n  content: \"\\F1169\";\n}\n\n.mdi-gate-nand::before {\n  content: \"\\F08E2\";\n}\n\n.mdi-gate-nor::before {\n  content: \"\\F08E3\";\n}\n\n.mdi-gate-not::before {\n  content: \"\\F08E4\";\n}\n\n.mdi-gate-open::before {\n  content: \"\\F116A\";\n}\n\n.mdi-gate-or::before {\n  content: \"\\F08E5\";\n}\n\n.mdi-gate-xnor::before {\n  content: \"\\F08E6\";\n}\n\n.mdi-gate-xor::before {\n  content: \"\\F08E7\";\n}\n\n.mdi-gatsby::before {\n  content: \"\\F0E43\";\n}\n\n.mdi-gauge::before {\n  content: \"\\F029A\";\n}\n\n.mdi-gauge-empty::before {\n  content: \"\\F0873\";\n}\n\n.mdi-gauge-full::before {\n  content: \"\\F0874\";\n}\n\n.mdi-gauge-low::before {\n  content: \"\\F0875\";\n}\n\n.mdi-gavel::before {\n  content: \"\\F029B\";\n}\n\n.mdi-gender-female::before {\n  content: \"\\F029C\";\n}\n\n.mdi-gender-male::before {\n  content: \"\\F029D\";\n}\n\n.mdi-gender-male-female::before {\n  content: \"\\F029E\";\n}\n\n.mdi-gender-male-female-variant::before {\n  content: \"\\F113F\";\n}\n\n.mdi-gender-non-binary::before {\n  content: \"\\F1140\";\n}\n\n.mdi-gender-transgender::before {\n  content: \"\\F029F\";\n}\n\n.mdi-gentoo::before {\n  content: \"\\F08E8\";\n}\n\n.mdi-gesture::before {\n  content: \"\\F07CB\";\n}\n\n.mdi-gesture-double-tap::before {\n  content: \"\\F073C\";\n}\n\n.mdi-gesture-pinch::before {\n  content: \"\\F0ABD\";\n}\n\n.mdi-gesture-spread::before {\n  content: \"\\F0ABE\";\n}\n\n.mdi-gesture-swipe::before {\n  content: \"\\F0D76\";\n}\n\n.mdi-gesture-swipe-down::before {\n  content: \"\\F073D\";\n}\n\n.mdi-gesture-swipe-horizontal::before {\n  content: \"\\F0ABF\";\n}\n\n.mdi-gesture-swipe-left::before {\n  content: \"\\F073E\";\n}\n\n.mdi-gesture-swipe-right::before {\n  content: \"\\F073F\";\n}\n\n.mdi-gesture-swipe-up::before {\n  content: \"\\F0740\";\n}\n\n.mdi-gesture-swipe-vertical::before {\n  content: \"\\F0AC0\";\n}\n\n.mdi-gesture-tap::before {\n  content: \"\\F0741\";\n}\n\n.mdi-gesture-tap-box::before {\n  content: \"\\F12A9\";\n}\n\n.mdi-gesture-tap-button::before {\n  content: \"\\F12A8\";\n}\n\n.mdi-gesture-tap-hold::before {\n  content: \"\\F0D77\";\n}\n\n.mdi-gesture-two-double-tap::before {\n  content: \"\\F0742\";\n}\n\n.mdi-gesture-two-tap::before {\n  content: \"\\F0743\";\n}\n\n.mdi-ghost::before {\n  content: \"\\F02A0\";\n}\n\n.mdi-ghost-off::before {\n  content: \"\\F09F5\";\n}\n\n.mdi-ghost-off-outline::before {\n  content: \"\\F165C\";\n}\n\n.mdi-ghost-outline::before {\n  content: \"\\F165D\";\n}\n\n.mdi-gift::before {\n  content: \"\\F0E44\";\n}\n\n.mdi-gift-off::before {\n  content: \"\\F16EF\";\n}\n\n.mdi-gift-off-outline::before {\n  content: \"\\F16F0\";\n}\n\n.mdi-gift-open::before {\n  content: \"\\F16F1\";\n}\n\n.mdi-gift-open-outline::before {\n  content: \"\\F16F2\";\n}\n\n.mdi-gift-outline::before {\n  content: \"\\F02A1\";\n}\n\n.mdi-git::before {\n  content: \"\\F02A2\";\n}\n\n.mdi-github::before {\n  content: \"\\F02A4\";\n}\n\n.mdi-gitlab::before {\n  content: \"\\F0BA0\";\n}\n\n.mdi-glass-cocktail::before {\n  content: \"\\F0356\";\n}\n\n.mdi-glass-cocktail-off::before {\n  content: \"\\F15E6\";\n}\n\n.mdi-glass-flute::before {\n  content: \"\\F02A5\";\n}\n\n.mdi-glass-fragile::before {\n  content: \"\\F1873\";\n}\n\n.mdi-glass-mug::before {\n  content: \"\\F02A6\";\n}\n\n.mdi-glass-mug-off::before {\n  content: \"\\F15E7\";\n}\n\n.mdi-glass-mug-variant::before {\n  content: \"\\F1116\";\n}\n\n.mdi-glass-mug-variant-off::before {\n  content: \"\\F15E8\";\n}\n\n.mdi-glass-pint-outline::before {\n  content: \"\\F130D\";\n}\n\n.mdi-glass-stange::before {\n  content: \"\\F02A7\";\n}\n\n.mdi-glass-tulip::before {\n  content: \"\\F02A8\";\n}\n\n.mdi-glass-wine::before {\n  content: \"\\F0876\";\n}\n\n.mdi-glasses::before {\n  content: \"\\F02AA\";\n}\n\n.mdi-globe-light::before {\n  content: \"\\F12D7\";\n}\n\n.mdi-globe-model::before {\n  content: \"\\F08E9\";\n}\n\n.mdi-gmail::before {\n  content: \"\\F02AB\";\n}\n\n.mdi-gnome::before {\n  content: \"\\F02AC\";\n}\n\n.mdi-go-kart::before {\n  content: \"\\F0D79\";\n}\n\n.mdi-go-kart-track::before {\n  content: \"\\F0D7A\";\n}\n\n.mdi-gog::before {\n  content: \"\\F0BA1\";\n}\n\n.mdi-gold::before {\n  content: \"\\F124F\";\n}\n\n.mdi-golf::before {\n  content: \"\\F0823\";\n}\n\n.mdi-golf-cart::before {\n  content: \"\\F11A4\";\n}\n\n.mdi-golf-tee::before {\n  content: \"\\F1083\";\n}\n\n.mdi-gondola::before {\n  content: \"\\F0686\";\n}\n\n.mdi-goodreads::before {\n  content: \"\\F0D7B\";\n}\n\n.mdi-google::before {\n  content: \"\\F02AD\";\n}\n\n.mdi-google-ads::before {\n  content: \"\\F0C87\";\n}\n\n.mdi-google-analytics::before {\n  content: \"\\F07CC\";\n}\n\n.mdi-google-assistant::before {\n  content: \"\\F07CD\";\n}\n\n.mdi-google-cardboard::before {\n  content: \"\\F02AE\";\n}\n\n.mdi-google-chrome::before {\n  content: \"\\F02AF\";\n}\n\n.mdi-google-circles::before {\n  content: \"\\F02B0\";\n}\n\n.mdi-google-circles-communities::before {\n  content: \"\\F02B1\";\n}\n\n.mdi-google-circles-extended::before {\n  content: \"\\F02B2\";\n}\n\n.mdi-google-circles-group::before {\n  content: \"\\F02B3\";\n}\n\n.mdi-google-classroom::before {\n  content: \"\\F02C0\";\n}\n\n.mdi-google-cloud::before {\n  content: \"\\F11F6\";\n}\n\n.mdi-google-controller::before {\n  content: \"\\F02B4\";\n}\n\n.mdi-google-controller-off::before {\n  content: \"\\F02B5\";\n}\n\n.mdi-google-downasaur::before {\n  content: \"\\F1362\";\n}\n\n.mdi-google-drive::before {\n  content: \"\\F02B6\";\n}\n\n.mdi-google-earth::before {\n  content: \"\\F02B7\";\n}\n\n.mdi-google-fit::before {\n  content: \"\\F096C\";\n}\n\n.mdi-google-glass::before {\n  content: \"\\F02B8\";\n}\n\n.mdi-google-hangouts::before {\n  content: \"\\F02C9\";\n}\n\n.mdi-google-home::before {\n  content: \"\\F0824\";\n}\n\n.mdi-google-keep::before {\n  content: \"\\F06DC\";\n}\n\n.mdi-google-lens::before {\n  content: \"\\F09F6\";\n}\n\n.mdi-google-maps::before {\n  content: \"\\F05F5\";\n}\n\n.mdi-google-my-business::before {\n  content: \"\\F1048\";\n}\n\n.mdi-google-nearby::before {\n  content: \"\\F02B9\";\n}\n\n.mdi-google-play::before {\n  content: \"\\F02BC\";\n}\n\n.mdi-google-plus::before {\n  content: \"\\F02BD\";\n}\n\n.mdi-google-podcast::before {\n  content: \"\\F0EB9\";\n}\n\n.mdi-google-spreadsheet::before {\n  content: \"\\F09F7\";\n}\n\n.mdi-google-street-view::before {\n  content: \"\\F0C88\";\n}\n\n.mdi-google-translate::before {\n  content: \"\\F02BF\";\n}\n\n.mdi-gradient-horizontal::before {\n  content: \"\\F174A\";\n}\n\n.mdi-gradient-vertical::before {\n  content: \"\\F06A0\";\n}\n\n.mdi-grain::before {\n  content: \"\\F0D7C\";\n}\n\n.mdi-graph::before {\n  content: \"\\F1049\";\n}\n\n.mdi-graph-outline::before {\n  content: \"\\F104A\";\n}\n\n.mdi-graphql::before {\n  content: \"\\F0877\";\n}\n\n.mdi-grass::before {\n  content: \"\\F1510\";\n}\n\n.mdi-grave-stone::before {\n  content: \"\\F0BA2\";\n}\n\n.mdi-grease-pencil::before {\n  content: \"\\F0648\";\n}\n\n.mdi-greater-than::before {\n  content: \"\\F096D\";\n}\n\n.mdi-greater-than-or-equal::before {\n  content: \"\\F096E\";\n}\n\n.mdi-greenhouse::before {\n  content: \"\\F002D\";\n}\n\n.mdi-grid::before {\n  content: \"\\F02C1\";\n}\n\n.mdi-grid-large::before {\n  content: \"\\F0758\";\n}\n\n.mdi-grid-off::before {\n  content: \"\\F02C2\";\n}\n\n.mdi-grill::before {\n  content: \"\\F0E45\";\n}\n\n.mdi-grill-outline::before {\n  content: \"\\F118A\";\n}\n\n.mdi-group::before {\n  content: \"\\F02C3\";\n}\n\n.mdi-guitar-acoustic::before {\n  content: \"\\F0771\";\n}\n\n.mdi-guitar-electric::before {\n  content: \"\\F02C4\";\n}\n\n.mdi-guitar-pick::before {\n  content: \"\\F02C5\";\n}\n\n.mdi-guitar-pick-outline::before {\n  content: \"\\F02C6\";\n}\n\n.mdi-guy-fawkes-mask::before {\n  content: \"\\F0825\";\n}\n\n.mdi-hail::before {\n  content: \"\\F0AC1\";\n}\n\n.mdi-hair-dryer::before {\n  content: \"\\F10EF\";\n}\n\n.mdi-hair-dryer-outline::before {\n  content: \"\\F10F0\";\n}\n\n.mdi-halloween::before {\n  content: \"\\F0BA3\";\n}\n\n.mdi-hamburger::before {\n  content: \"\\F0685\";\n}\n\n.mdi-hamburger-check::before {\n  content: \"\\F1776\";\n}\n\n.mdi-hamburger-minus::before {\n  content: \"\\F1777\";\n}\n\n.mdi-hamburger-off::before {\n  content: \"\\F1778\";\n}\n\n.mdi-hamburger-plus::before {\n  content: \"\\F1779\";\n}\n\n.mdi-hamburger-remove::before {\n  content: \"\\F177A\";\n}\n\n.mdi-hammer::before {\n  content: \"\\F08EA\";\n}\n\n.mdi-hammer-screwdriver::before {\n  content: \"\\F1322\";\n}\n\n.mdi-hammer-sickle::before {\n  content: \"\\F1887\";\n}\n\n.mdi-hammer-wrench::before {\n  content: \"\\F1323\";\n}\n\n.mdi-hand-back-left::before {\n  content: \"\\F0E46\";\n}\n\n.mdi-hand-back-left-off::before {\n  content: \"\\F1830\";\n}\n\n.mdi-hand-back-left-off-outline::before {\n  content: \"\\F1832\";\n}\n\n.mdi-hand-back-left-outline::before {\n  content: \"\\F182C\";\n}\n\n.mdi-hand-back-right::before {\n  content: \"\\F0E47\";\n}\n\n.mdi-hand-back-right-off::before {\n  content: \"\\F1831\";\n}\n\n.mdi-hand-back-right-off-outline::before {\n  content: \"\\F1833\";\n}\n\n.mdi-hand-back-right-outline::before {\n  content: \"\\F182D\";\n}\n\n.mdi-hand-clap::before {\n  content: \"\\F194B\";\n}\n\n.mdi-hand-coin::before {\n  content: \"\\F188F\";\n}\n\n.mdi-hand-coin-outline::before {\n  content: \"\\F1890\";\n}\n\n.mdi-hand-extended::before {\n  content: \"\\F18B6\";\n}\n\n.mdi-hand-extended-outline::before {\n  content: \"\\F18B7\";\n}\n\n.mdi-hand-front-left::before {\n  content: \"\\F182B\";\n}\n\n.mdi-hand-front-left-outline::before {\n  content: \"\\F182E\";\n}\n\n.mdi-hand-front-right::before {\n  content: \"\\F0A4F\";\n}\n\n.mdi-hand-front-right-outline::before {\n  content: \"\\F182F\";\n}\n\n.mdi-hand-heart::before {\n  content: \"\\F10F1\";\n}\n\n.mdi-hand-heart-outline::before {\n  content: \"\\F157E\";\n}\n\n.mdi-hand-okay::before {\n  content: \"\\F0A50\";\n}\n\n.mdi-hand-peace::before {\n  content: \"\\F0A51\";\n}\n\n.mdi-hand-peace-variant::before {\n  content: \"\\F0A52\";\n}\n\n.mdi-hand-pointing-down::before {\n  content: \"\\F0A53\";\n}\n\n.mdi-hand-pointing-left::before {\n  content: \"\\F0A54\";\n}\n\n.mdi-hand-pointing-right::before {\n  content: \"\\F02C7\";\n}\n\n.mdi-hand-pointing-up::before {\n  content: \"\\F0A55\";\n}\n\n.mdi-hand-saw::before {\n  content: \"\\F0E48\";\n}\n\n.mdi-hand-wash::before {\n  content: \"\\F157F\";\n}\n\n.mdi-hand-wash-outline::before {\n  content: \"\\F1580\";\n}\n\n.mdi-hand-water::before {\n  content: \"\\F139F\";\n}\n\n.mdi-hand-wave::before {\n  content: \"\\F1821\";\n}\n\n.mdi-hand-wave-outline::before {\n  content: \"\\F1822\";\n}\n\n.mdi-handball::before {\n  content: \"\\F0F53\";\n}\n\n.mdi-handcuffs::before {\n  content: \"\\F113E\";\n}\n\n.mdi-hands-pray::before {\n  content: \"\\F0579\";\n}\n\n.mdi-handshake::before {\n  content: \"\\F1218\";\n}\n\n.mdi-handshake-outline::before {\n  content: \"\\F15A1\";\n}\n\n.mdi-hanger::before {\n  content: \"\\F02C8\";\n}\n\n.mdi-hard-hat::before {\n  content: \"\\F096F\";\n}\n\n.mdi-harddisk::before {\n  content: \"\\F02CA\";\n}\n\n.mdi-harddisk-plus::before {\n  content: \"\\F104B\";\n}\n\n.mdi-harddisk-remove::before {\n  content: \"\\F104C\";\n}\n\n.mdi-hat-fedora::before {\n  content: \"\\F0BA4\";\n}\n\n.mdi-hazard-lights::before {\n  content: \"\\F0C89\";\n}\n\n.mdi-hdr::before {\n  content: \"\\F0D7D\";\n}\n\n.mdi-hdr-off::before {\n  content: \"\\F0D7E\";\n}\n\n.mdi-head::before {\n  content: \"\\F135E\";\n}\n\n.mdi-head-alert::before {\n  content: \"\\F1338\";\n}\n\n.mdi-head-alert-outline::before {\n  content: \"\\F1339\";\n}\n\n.mdi-head-check::before {\n  content: \"\\F133A\";\n}\n\n.mdi-head-check-outline::before {\n  content: \"\\F133B\";\n}\n\n.mdi-head-cog::before {\n  content: \"\\F133C\";\n}\n\n.mdi-head-cog-outline::before {\n  content: \"\\F133D\";\n}\n\n.mdi-head-dots-horizontal::before {\n  content: \"\\F133E\";\n}\n\n.mdi-head-dots-horizontal-outline::before {\n  content: \"\\F133F\";\n}\n\n.mdi-head-flash::before {\n  content: \"\\F1340\";\n}\n\n.mdi-head-flash-outline::before {\n  content: \"\\F1341\";\n}\n\n.mdi-head-heart::before {\n  content: \"\\F1342\";\n}\n\n.mdi-head-heart-outline::before {\n  content: \"\\F1343\";\n}\n\n.mdi-head-lightbulb::before {\n  content: \"\\F1344\";\n}\n\n.mdi-head-lightbulb-outline::before {\n  content: \"\\F1345\";\n}\n\n.mdi-head-minus::before {\n  content: \"\\F1346\";\n}\n\n.mdi-head-minus-outline::before {\n  content: \"\\F1347\";\n}\n\n.mdi-head-outline::before {\n  content: \"\\F135F\";\n}\n\n.mdi-head-plus::before {\n  content: \"\\F1348\";\n}\n\n.mdi-head-plus-outline::before {\n  content: \"\\F1349\";\n}\n\n.mdi-head-question::before {\n  content: \"\\F134A\";\n}\n\n.mdi-head-question-outline::before {\n  content: \"\\F134B\";\n}\n\n.mdi-head-remove::before {\n  content: \"\\F134C\";\n}\n\n.mdi-head-remove-outline::before {\n  content: \"\\F134D\";\n}\n\n.mdi-head-snowflake::before {\n  content: \"\\F134E\";\n}\n\n.mdi-head-snowflake-outline::before {\n  content: \"\\F134F\";\n}\n\n.mdi-head-sync::before {\n  content: \"\\F1350\";\n}\n\n.mdi-head-sync-outline::before {\n  content: \"\\F1351\";\n}\n\n.mdi-headphones::before {\n  content: \"\\F02CB\";\n}\n\n.mdi-headphones-bluetooth::before {\n  content: \"\\F0970\";\n}\n\n.mdi-headphones-box::before {\n  content: \"\\F02CC\";\n}\n\n.mdi-headphones-off::before {\n  content: \"\\F07CE\";\n}\n\n.mdi-headphones-settings::before {\n  content: \"\\F02CD\";\n}\n\n.mdi-headset::before {\n  content: \"\\F02CE\";\n}\n\n.mdi-headset-dock::before {\n  content: \"\\F02CF\";\n}\n\n.mdi-headset-off::before {\n  content: \"\\F02D0\";\n}\n\n.mdi-heart::before {\n  content: \"\\F02D1\";\n}\n\n.mdi-heart-box::before {\n  content: \"\\F02D2\";\n}\n\n.mdi-heart-box-outline::before {\n  content: \"\\F02D3\";\n}\n\n.mdi-heart-broken::before {\n  content: \"\\F02D4\";\n}\n\n.mdi-heart-broken-outline::before {\n  content: \"\\F0D14\";\n}\n\n.mdi-heart-circle::before {\n  content: \"\\F0971\";\n}\n\n.mdi-heart-circle-outline::before {\n  content: \"\\F0972\";\n}\n\n.mdi-heart-cog::before {\n  content: \"\\F1663\";\n}\n\n.mdi-heart-cog-outline::before {\n  content: \"\\F1664\";\n}\n\n.mdi-heart-flash::before {\n  content: \"\\F0EF9\";\n}\n\n.mdi-heart-half::before {\n  content: \"\\F06DF\";\n}\n\n.mdi-heart-half-full::before {\n  content: \"\\F06DE\";\n}\n\n.mdi-heart-half-outline::before {\n  content: \"\\F06E0\";\n}\n\n.mdi-heart-minus::before {\n  content: \"\\F142F\";\n}\n\n.mdi-heart-minus-outline::before {\n  content: \"\\F1432\";\n}\n\n.mdi-heart-multiple::before {\n  content: \"\\F0A56\";\n}\n\n.mdi-heart-multiple-outline::before {\n  content: \"\\F0A57\";\n}\n\n.mdi-heart-off::before {\n  content: \"\\F0759\";\n}\n\n.mdi-heart-off-outline::before {\n  content: \"\\F1434\";\n}\n\n.mdi-heart-outline::before {\n  content: \"\\F02D5\";\n}\n\n.mdi-heart-plus::before {\n  content: \"\\F142E\";\n}\n\n.mdi-heart-plus-outline::before {\n  content: \"\\F1431\";\n}\n\n.mdi-heart-pulse::before {\n  content: \"\\F05F6\";\n}\n\n.mdi-heart-remove::before {\n  content: \"\\F1430\";\n}\n\n.mdi-heart-remove-outline::before {\n  content: \"\\F1433\";\n}\n\n.mdi-heart-settings::before {\n  content: \"\\F1665\";\n}\n\n.mdi-heart-settings-outline::before {\n  content: \"\\F1666\";\n}\n\n.mdi-helicopter::before {\n  content: \"\\F0AC2\";\n}\n\n.mdi-help::before {\n  content: \"\\F02D6\";\n}\n\n.mdi-help-box::before {\n  content: \"\\F078B\";\n}\n\n.mdi-help-circle::before {\n  content: \"\\F02D7\";\n}\n\n.mdi-help-circle-outline::before {\n  content: \"\\F0625\";\n}\n\n.mdi-help-network::before {\n  content: \"\\F06F5\";\n}\n\n.mdi-help-network-outline::before {\n  content: \"\\F0C8A\";\n}\n\n.mdi-help-rhombus::before {\n  content: \"\\F0BA5\";\n}\n\n.mdi-help-rhombus-outline::before {\n  content: \"\\F0BA6\";\n}\n\n.mdi-hexadecimal::before {\n  content: \"\\F12A7\";\n}\n\n.mdi-hexagon::before {\n  content: \"\\F02D8\";\n}\n\n.mdi-hexagon-multiple::before {\n  content: \"\\F06E1\";\n}\n\n.mdi-hexagon-multiple-outline::before {\n  content: \"\\F10F2\";\n}\n\n.mdi-hexagon-outline::before {\n  content: \"\\F02D9\";\n}\n\n.mdi-hexagon-slice-1::before {\n  content: \"\\F0AC3\";\n}\n\n.mdi-hexagon-slice-2::before {\n  content: \"\\F0AC4\";\n}\n\n.mdi-hexagon-slice-3::before {\n  content: \"\\F0AC5\";\n}\n\n.mdi-hexagon-slice-4::before {\n  content: \"\\F0AC6\";\n}\n\n.mdi-hexagon-slice-5::before {\n  content: \"\\F0AC7\";\n}\n\n.mdi-hexagon-slice-6::before {\n  content: \"\\F0AC8\";\n}\n\n.mdi-hexagram::before {\n  content: \"\\F0AC9\";\n}\n\n.mdi-hexagram-outline::before {\n  content: \"\\F0ACA\";\n}\n\n.mdi-high-definition::before {\n  content: \"\\F07CF\";\n}\n\n.mdi-high-definition-box::before {\n  content: \"\\F0878\";\n}\n\n.mdi-highway::before {\n  content: \"\\F05F7\";\n}\n\n.mdi-hiking::before {\n  content: \"\\F0D7F\";\n}\n\n.mdi-history::before {\n  content: \"\\F02DA\";\n}\n\n.mdi-hockey-puck::before {\n  content: \"\\F0879\";\n}\n\n.mdi-hockey-sticks::before {\n  content: \"\\F087A\";\n}\n\n.mdi-hololens::before {\n  content: \"\\F02DB\";\n}\n\n.mdi-home::before {\n  content: \"\\F02DC\";\n}\n\n.mdi-home-account::before {\n  content: \"\\F0826\";\n}\n\n.mdi-home-alert::before {\n  content: \"\\F087B\";\n}\n\n.mdi-home-alert-outline::before {\n  content: \"\\F15D0\";\n}\n\n.mdi-home-analytics::before {\n  content: \"\\F0EBA\";\n}\n\n.mdi-home-assistant::before {\n  content: \"\\F07D0\";\n}\n\n.mdi-home-automation::before {\n  content: \"\\F07D1\";\n}\n\n.mdi-home-battery::before {\n  content: \"\\F1901\";\n}\n\n.mdi-home-battery-outline::before {\n  content: \"\\F1902\";\n}\n\n.mdi-home-circle::before {\n  content: \"\\F07D2\";\n}\n\n.mdi-home-circle-outline::before {\n  content: \"\\F104D\";\n}\n\n.mdi-home-city::before {\n  content: \"\\F0D15\";\n}\n\n.mdi-home-city-outline::before {\n  content: \"\\F0D16\";\n}\n\n.mdi-home-edit::before {\n  content: \"\\F1159\";\n}\n\n.mdi-home-edit-outline::before {\n  content: \"\\F115A\";\n}\n\n.mdi-home-export-outline::before {\n  content: \"\\F0F9B\";\n}\n\n.mdi-home-flood::before {\n  content: \"\\F0EFA\";\n}\n\n.mdi-home-floor-0::before {\n  content: \"\\F0DD2\";\n}\n\n.mdi-home-floor-1::before {\n  content: \"\\F0D80\";\n}\n\n.mdi-home-floor-2::before {\n  content: \"\\F0D81\";\n}\n\n.mdi-home-floor-3::before {\n  content: \"\\F0D82\";\n}\n\n.mdi-home-floor-a::before {\n  content: \"\\F0D83\";\n}\n\n.mdi-home-floor-b::before {\n  content: \"\\F0D84\";\n}\n\n.mdi-home-floor-g::before {\n  content: \"\\F0D85\";\n}\n\n.mdi-home-floor-l::before {\n  content: \"\\F0D86\";\n}\n\n.mdi-home-floor-negative-1::before {\n  content: \"\\F0DD3\";\n}\n\n.mdi-home-group::before {\n  content: \"\\F0DD4\";\n}\n\n.mdi-home-group-minus::before {\n  content: \"\\F19C1\";\n}\n\n.mdi-home-group-plus::before {\n  content: \"\\F19C0\";\n}\n\n.mdi-home-group-remove::before {\n  content: \"\\F19C2\";\n}\n\n.mdi-home-heart::before {\n  content: \"\\F0827\";\n}\n\n.mdi-home-import-outline::before {\n  content: \"\\F0F9C\";\n}\n\n.mdi-home-lightbulb::before {\n  content: \"\\F1251\";\n}\n\n.mdi-home-lightbulb-outline::before {\n  content: \"\\F1252\";\n}\n\n.mdi-home-lightning-bolt::before {\n  content: \"\\F1903\";\n}\n\n.mdi-home-lightning-bolt-outline::before {\n  content: \"\\F1904\";\n}\n\n.mdi-home-lock::before {\n  content: \"\\F08EB\";\n}\n\n.mdi-home-lock-open::before {\n  content: \"\\F08EC\";\n}\n\n.mdi-home-map-marker::before {\n  content: \"\\F05F8\";\n}\n\n.mdi-home-minus::before {\n  content: \"\\F0974\";\n}\n\n.mdi-home-minus-outline::before {\n  content: \"\\F13D5\";\n}\n\n.mdi-home-modern::before {\n  content: \"\\F02DD\";\n}\n\n.mdi-home-outline::before {\n  content: \"\\F06A1\";\n}\n\n.mdi-home-plus::before {\n  content: \"\\F0975\";\n}\n\n.mdi-home-plus-outline::before {\n  content: \"\\F13D6\";\n}\n\n.mdi-home-remove::before {\n  content: \"\\F1247\";\n}\n\n.mdi-home-remove-outline::before {\n  content: \"\\F13D7\";\n}\n\n.mdi-home-roof::before {\n  content: \"\\F112B\";\n}\n\n.mdi-home-search::before {\n  content: \"\\F13B0\";\n}\n\n.mdi-home-search-outline::before {\n  content: \"\\F13B1\";\n}\n\n.mdi-home-switch::before {\n  content: \"\\F1794\";\n}\n\n.mdi-home-switch-outline::before {\n  content: \"\\F1795\";\n}\n\n.mdi-home-thermometer::before {\n  content: \"\\F0F54\";\n}\n\n.mdi-home-thermometer-outline::before {\n  content: \"\\F0F55\";\n}\n\n.mdi-home-variant::before {\n  content: \"\\F02DE\";\n}\n\n.mdi-home-variant-outline::before {\n  content: \"\\F0BA7\";\n}\n\n.mdi-hook::before {\n  content: \"\\F06E2\";\n}\n\n.mdi-hook-off::before {\n  content: \"\\F06E3\";\n}\n\n.mdi-hoop-house::before {\n  content: \"\\F0E56\";\n}\n\n.mdi-hops::before {\n  content: \"\\F02DF\";\n}\n\n.mdi-horizontal-rotate-clockwise::before {\n  content: \"\\F10F3\";\n}\n\n.mdi-horizontal-rotate-counterclockwise::before {\n  content: \"\\F10F4\";\n}\n\n.mdi-horse::before {\n  content: \"\\F15BF\";\n}\n\n.mdi-horse-human::before {\n  content: \"\\F15C0\";\n}\n\n.mdi-horse-variant::before {\n  content: \"\\F15C1\";\n}\n\n.mdi-horse-variant-fast::before {\n  content: \"\\F186E\";\n}\n\n.mdi-horseshoe::before {\n  content: \"\\F0A58\";\n}\n\n.mdi-hospital::before {\n  content: \"\\F0FF6\";\n}\n\n.mdi-hospital-box::before {\n  content: \"\\F02E0\";\n}\n\n.mdi-hospital-box-outline::before {\n  content: \"\\F0FF7\";\n}\n\n.mdi-hospital-building::before {\n  content: \"\\F02E1\";\n}\n\n.mdi-hospital-marker::before {\n  content: \"\\F02E2\";\n}\n\n.mdi-hot-tub::before {\n  content: \"\\F0828\";\n}\n\n.mdi-hours-24::before {\n  content: \"\\F1478\";\n}\n\n.mdi-hubspot::before {\n  content: \"\\F0D17\";\n}\n\n.mdi-hulu::before {\n  content: \"\\F0829\";\n}\n\n.mdi-human::before {\n  content: \"\\F02E6\";\n}\n\n.mdi-human-baby-changing-table::before {\n  content: \"\\F138B\";\n}\n\n.mdi-human-cane::before {\n  content: \"\\F1581\";\n}\n\n.mdi-human-capacity-decrease::before {\n  content: \"\\F159B\";\n}\n\n.mdi-human-capacity-increase::before {\n  content: \"\\F159C\";\n}\n\n.mdi-human-child::before {\n  content: \"\\F02E7\";\n}\n\n.mdi-human-dolly::before {\n  content: \"\\F1980\";\n}\n\n.mdi-human-edit::before {\n  content: \"\\F14E8\";\n}\n\n.mdi-human-female::before {\n  content: \"\\F0649\";\n}\n\n.mdi-human-female-boy::before {\n  content: \"\\F0A59\";\n}\n\n.mdi-human-female-dance::before {\n  content: \"\\F15C9\";\n}\n\n.mdi-human-female-female::before {\n  content: \"\\F0A5A\";\n}\n\n.mdi-human-female-girl::before {\n  content: \"\\F0A5B\";\n}\n\n.mdi-human-greeting::before {\n  content: \"\\F17C4\";\n}\n\n.mdi-human-greeting-proximity::before {\n  content: \"\\F159D\";\n}\n\n.mdi-human-greeting-variant::before {\n  content: \"\\F064A\";\n}\n\n.mdi-human-handsdown::before {\n  content: \"\\F064B\";\n}\n\n.mdi-human-handsup::before {\n  content: \"\\F064C\";\n}\n\n.mdi-human-male::before {\n  content: \"\\F064D\";\n}\n\n.mdi-human-male-board::before {\n  content: \"\\F0890\";\n}\n\n.mdi-human-male-board-poll::before {\n  content: \"\\F0846\";\n}\n\n.mdi-human-male-boy::before {\n  content: \"\\F0A5C\";\n}\n\n.mdi-human-male-child::before {\n  content: \"\\F138C\";\n}\n\n.mdi-human-male-female::before {\n  content: \"\\F02E8\";\n}\n\n.mdi-human-male-female-child::before {\n  content: \"\\F1823\";\n}\n\n.mdi-human-male-girl::before {\n  content: \"\\F0A5D\";\n}\n\n.mdi-human-male-height::before {\n  content: \"\\F0EFB\";\n}\n\n.mdi-human-male-height-variant::before {\n  content: \"\\F0EFC\";\n}\n\n.mdi-human-male-male::before {\n  content: \"\\F0A5E\";\n}\n\n.mdi-human-non-binary::before {\n  content: \"\\F1848\";\n}\n\n.mdi-human-pregnant::before {\n  content: \"\\F05CF\";\n}\n\n.mdi-human-queue::before {\n  content: \"\\F1571\";\n}\n\n.mdi-human-scooter::before {\n  content: \"\\F11E9\";\n}\n\n.mdi-human-wheelchair::before {\n  content: \"\\F138D\";\n}\n\n.mdi-human-white-cane::before {\n  content: \"\\F1981\";\n}\n\n.mdi-humble-bundle::before {\n  content: \"\\F0744\";\n}\n\n.mdi-hvac::before {\n  content: \"\\F1352\";\n}\n\n.mdi-hvac-off::before {\n  content: \"\\F159E\";\n}\n\n.mdi-hydraulic-oil-level::before {\n  content: \"\\F1324\";\n}\n\n.mdi-hydraulic-oil-temperature::before {\n  content: \"\\F1325\";\n}\n\n.mdi-hydro-power::before {\n  content: \"\\F12E5\";\n}\n\n.mdi-hydrogen-station::before {\n  content: \"\\F1894\";\n}\n\n.mdi-ice-cream::before {\n  content: \"\\F082A\";\n}\n\n.mdi-ice-cream-off::before {\n  content: \"\\F0E52\";\n}\n\n.mdi-ice-pop::before {\n  content: \"\\F0EFD\";\n}\n\n.mdi-id-card::before {\n  content: \"\\F0FC0\";\n}\n\n.mdi-identifier::before {\n  content: \"\\F0EFE\";\n}\n\n.mdi-ideogram-cjk::before {\n  content: \"\\F1331\";\n}\n\n.mdi-ideogram-cjk-variant::before {\n  content: \"\\F1332\";\n}\n\n.mdi-image::before {\n  content: \"\\F02E9\";\n}\n\n.mdi-image-album::before {\n  content: \"\\F02EA\";\n}\n\n.mdi-image-area::before {\n  content: \"\\F02EB\";\n}\n\n.mdi-image-area-close::before {\n  content: \"\\F02EC\";\n}\n\n.mdi-image-auto-adjust::before {\n  content: \"\\F0FC1\";\n}\n\n.mdi-image-broken::before {\n  content: \"\\F02ED\";\n}\n\n.mdi-image-broken-variant::before {\n  content: \"\\F02EE\";\n}\n\n.mdi-image-edit::before {\n  content: \"\\F11E3\";\n}\n\n.mdi-image-edit-outline::before {\n  content: \"\\F11E4\";\n}\n\n.mdi-image-filter-black-white::before {\n  content: \"\\F02F0\";\n}\n\n.mdi-image-filter-center-focus::before {\n  content: \"\\F02F1\";\n}\n\n.mdi-image-filter-center-focus-strong::before {\n  content: \"\\F0EFF\";\n}\n\n.mdi-image-filter-center-focus-strong-outline::before {\n  content: \"\\F0F00\";\n}\n\n.mdi-image-filter-center-focus-weak::before {\n  content: \"\\F02F2\";\n}\n\n.mdi-image-filter-drama::before {\n  content: \"\\F02F3\";\n}\n\n.mdi-image-filter-frames::before {\n  content: \"\\F02F4\";\n}\n\n.mdi-image-filter-hdr::before {\n  content: \"\\F02F5\";\n}\n\n.mdi-image-filter-none::before {\n  content: \"\\F02F6\";\n}\n\n.mdi-image-filter-tilt-shift::before {\n  content: \"\\F02F7\";\n}\n\n.mdi-image-filter-vintage::before {\n  content: \"\\F02F8\";\n}\n\n.mdi-image-frame::before {\n  content: \"\\F0E49\";\n}\n\n.mdi-image-marker::before {\n  content: \"\\F177B\";\n}\n\n.mdi-image-marker-outline::before {\n  content: \"\\F177C\";\n}\n\n.mdi-image-minus::before {\n  content: \"\\F1419\";\n}\n\n.mdi-image-move::before {\n  content: \"\\F09F8\";\n}\n\n.mdi-image-multiple::before {\n  content: \"\\F02F9\";\n}\n\n.mdi-image-multiple-outline::before {\n  content: \"\\F02EF\";\n}\n\n.mdi-image-off::before {\n  content: \"\\F082B\";\n}\n\n.mdi-image-off-outline::before {\n  content: \"\\F11D1\";\n}\n\n.mdi-image-outline::before {\n  content: \"\\F0976\";\n}\n\n.mdi-image-plus::before {\n  content: \"\\F087C\";\n}\n\n.mdi-image-remove::before {\n  content: \"\\F1418\";\n}\n\n.mdi-image-search::before {\n  content: \"\\F0977\";\n}\n\n.mdi-image-search-outline::before {\n  content: \"\\F0978\";\n}\n\n.mdi-image-size-select-actual::before {\n  content: \"\\F0C8D\";\n}\n\n.mdi-image-size-select-large::before {\n  content: \"\\F0C8E\";\n}\n\n.mdi-image-size-select-small::before {\n  content: \"\\F0C8F\";\n}\n\n.mdi-image-text::before {\n  content: \"\\F160D\";\n}\n\n.mdi-import::before {\n  content: \"\\F02FA\";\n}\n\n.mdi-inbox::before {\n  content: \"\\F0687\";\n}\n\n.mdi-inbox-arrow-down::before {\n  content: \"\\F02FB\";\n}\n\n.mdi-inbox-arrow-down-outline::before {\n  content: \"\\F1270\";\n}\n\n.mdi-inbox-arrow-up::before {\n  content: \"\\F03D1\";\n}\n\n.mdi-inbox-arrow-up-outline::before {\n  content: \"\\F1271\";\n}\n\n.mdi-inbox-full::before {\n  content: \"\\F1272\";\n}\n\n.mdi-inbox-full-outline::before {\n  content: \"\\F1273\";\n}\n\n.mdi-inbox-multiple::before {\n  content: \"\\F08B0\";\n}\n\n.mdi-inbox-multiple-outline::before {\n  content: \"\\F0BA8\";\n}\n\n.mdi-inbox-outline::before {\n  content: \"\\F1274\";\n}\n\n.mdi-inbox-remove::before {\n  content: \"\\F159F\";\n}\n\n.mdi-inbox-remove-outline::before {\n  content: \"\\F15A0\";\n}\n\n.mdi-incognito::before {\n  content: \"\\F05F9\";\n}\n\n.mdi-incognito-circle::before {\n  content: \"\\F1421\";\n}\n\n.mdi-incognito-circle-off::before {\n  content: \"\\F1422\";\n}\n\n.mdi-incognito-off::before {\n  content: \"\\F0075\";\n}\n\n.mdi-induction::before {\n  content: \"\\F184C\";\n}\n\n.mdi-infinity::before {\n  content: \"\\F06E4\";\n}\n\n.mdi-information::before {\n  content: \"\\F02FC\";\n}\n\n.mdi-information-off::before {\n  content: \"\\F178C\";\n}\n\n.mdi-information-off-outline::before {\n  content: \"\\F178D\";\n}\n\n.mdi-information-outline::before {\n  content: \"\\F02FD\";\n}\n\n.mdi-information-variant::before {\n  content: \"\\F064E\";\n}\n\n.mdi-instagram::before {\n  content: \"\\F02FE\";\n}\n\n.mdi-instrument-triangle::before {\n  content: \"\\F104E\";\n}\n\n.mdi-integrated-circuit-chip::before {\n  content: \"\\F1913\";\n}\n\n.mdi-invert-colors::before {\n  content: \"\\F0301\";\n}\n\n.mdi-invert-colors-off::before {\n  content: \"\\F0E4A\";\n}\n\n.mdi-iobroker::before {\n  content: \"\\F12E8\";\n}\n\n.mdi-ip::before {\n  content: \"\\F0A5F\";\n}\n\n.mdi-ip-network::before {\n  content: \"\\F0A60\";\n}\n\n.mdi-ip-network-outline::before {\n  content: \"\\F0C90\";\n}\n\n.mdi-ip-outline::before {\n  content: \"\\F1982\";\n}\n\n.mdi-ipod::before {\n  content: \"\\F0C91\";\n}\n\n.mdi-iron::before {\n  content: \"\\F1824\";\n}\n\n.mdi-iron-board::before {\n  content: \"\\F1838\";\n}\n\n.mdi-iron-outline::before {\n  content: \"\\F1825\";\n}\n\n.mdi-island::before {\n  content: \"\\F104F\";\n}\n\n.mdi-iv-bag::before {\n  content: \"\\F10B9\";\n}\n\n.mdi-jabber::before {\n  content: \"\\F0DD5\";\n}\n\n.mdi-jeepney::before {\n  content: \"\\F0302\";\n}\n\n.mdi-jellyfish::before {\n  content: \"\\F0F01\";\n}\n\n.mdi-jellyfish-outline::before {\n  content: \"\\F0F02\";\n}\n\n.mdi-jira::before {\n  content: \"\\F0303\";\n}\n\n.mdi-jquery::before {\n  content: \"\\F087D\";\n}\n\n.mdi-jsfiddle::before {\n  content: \"\\F0304\";\n}\n\n.mdi-jump-rope::before {\n  content: \"\\F12FF\";\n}\n\n.mdi-kabaddi::before {\n  content: \"\\F0D87\";\n}\n\n.mdi-kangaroo::before {\n  content: \"\\F1558\";\n}\n\n.mdi-karate::before {\n  content: \"\\F082C\";\n}\n\n.mdi-kayaking::before {\n  content: \"\\F08AF\";\n}\n\n.mdi-keg::before {\n  content: \"\\F0305\";\n}\n\n.mdi-kettle::before {\n  content: \"\\F05FA\";\n}\n\n.mdi-kettle-alert::before {\n  content: \"\\F1317\";\n}\n\n.mdi-kettle-alert-outline::before {\n  content: \"\\F1318\";\n}\n\n.mdi-kettle-off::before {\n  content: \"\\F131B\";\n}\n\n.mdi-kettle-off-outline::before {\n  content: \"\\F131C\";\n}\n\n.mdi-kettle-outline::before {\n  content: \"\\F0F56\";\n}\n\n.mdi-kettle-pour-over::before {\n  content: \"\\F173C\";\n}\n\n.mdi-kettle-steam::before {\n  content: \"\\F1319\";\n}\n\n.mdi-kettle-steam-outline::before {\n  content: \"\\F131A\";\n}\n\n.mdi-kettlebell::before {\n  content: \"\\F1300\";\n}\n\n.mdi-key::before {\n  content: \"\\F0306\";\n}\n\n.mdi-key-alert::before {\n  content: \"\\F1983\";\n}\n\n.mdi-key-alert-outline::before {\n  content: \"\\F1984\";\n}\n\n.mdi-key-arrow-right::before {\n  content: \"\\F1312\";\n}\n\n.mdi-key-chain::before {\n  content: \"\\F1574\";\n}\n\n.mdi-key-chain-variant::before {\n  content: \"\\F1575\";\n}\n\n.mdi-key-change::before {\n  content: \"\\F0307\";\n}\n\n.mdi-key-link::before {\n  content: \"\\F119F\";\n}\n\n.mdi-key-minus::before {\n  content: \"\\F0308\";\n}\n\n.mdi-key-outline::before {\n  content: \"\\F0DD6\";\n}\n\n.mdi-key-plus::before {\n  content: \"\\F0309\";\n}\n\n.mdi-key-remove::before {\n  content: \"\\F030A\";\n}\n\n.mdi-key-star::before {\n  content: \"\\F119E\";\n}\n\n.mdi-key-variant::before {\n  content: \"\\F030B\";\n}\n\n.mdi-key-wireless::before {\n  content: \"\\F0FC2\";\n}\n\n.mdi-keyboard::before {\n  content: \"\\F030C\";\n}\n\n.mdi-keyboard-backspace::before {\n  content: \"\\F030D\";\n}\n\n.mdi-keyboard-caps::before {\n  content: \"\\F030E\";\n}\n\n.mdi-keyboard-close::before {\n  content: \"\\F030F\";\n}\n\n.mdi-keyboard-esc::before {\n  content: \"\\F12B7\";\n}\n\n.mdi-keyboard-f1::before {\n  content: \"\\F12AB\";\n}\n\n.mdi-keyboard-f10::before {\n  content: \"\\F12B4\";\n}\n\n.mdi-keyboard-f11::before {\n  content: \"\\F12B5\";\n}\n\n.mdi-keyboard-f12::before {\n  content: \"\\F12B6\";\n}\n\n.mdi-keyboard-f2::before {\n  content: \"\\F12AC\";\n}\n\n.mdi-keyboard-f3::before {\n  content: \"\\F12AD\";\n}\n\n.mdi-keyboard-f4::before {\n  content: \"\\F12AE\";\n}\n\n.mdi-keyboard-f5::before {\n  content: \"\\F12AF\";\n}\n\n.mdi-keyboard-f6::before {\n  content: \"\\F12B0\";\n}\n\n.mdi-keyboard-f7::before {\n  content: \"\\F12B1\";\n}\n\n.mdi-keyboard-f8::before {\n  content: \"\\F12B2\";\n}\n\n.mdi-keyboard-f9::before {\n  content: \"\\F12B3\";\n}\n\n.mdi-keyboard-off::before {\n  content: \"\\F0310\";\n}\n\n.mdi-keyboard-off-outline::before {\n  content: \"\\F0E4B\";\n}\n\n.mdi-keyboard-outline::before {\n  content: \"\\F097B\";\n}\n\n.mdi-keyboard-return::before {\n  content: \"\\F0311\";\n}\n\n.mdi-keyboard-settings::before {\n  content: \"\\F09F9\";\n}\n\n.mdi-keyboard-settings-outline::before {\n  content: \"\\F09FA\";\n}\n\n.mdi-keyboard-space::before {\n  content: \"\\F1050\";\n}\n\n.mdi-keyboard-tab::before {\n  content: \"\\F0312\";\n}\n\n.mdi-keyboard-tab-reverse::before {\n  content: \"\\F0325\";\n}\n\n.mdi-keyboard-variant::before {\n  content: \"\\F0313\";\n}\n\n.mdi-khanda::before {\n  content: \"\\F10FD\";\n}\n\n.mdi-kickstarter::before {\n  content: \"\\F0745\";\n}\n\n.mdi-kite::before {\n  content: \"\\F1985\";\n}\n\n.mdi-kite-outline::before {\n  content: \"\\F1986\";\n}\n\n.mdi-kitesurfing::before {\n  content: \"\\F1744\";\n}\n\n.mdi-klingon::before {\n  content: \"\\F135B\";\n}\n\n.mdi-knife::before {\n  content: \"\\F09FB\";\n}\n\n.mdi-knife-military::before {\n  content: \"\\F09FC\";\n}\n\n.mdi-koala::before {\n  content: \"\\F173F\";\n}\n\n.mdi-kodi::before {\n  content: \"\\F0314\";\n}\n\n.mdi-kubernetes::before {\n  content: \"\\F10FE\";\n}\n\n.mdi-label::before {\n  content: \"\\F0315\";\n}\n\n.mdi-label-multiple::before {\n  content: \"\\F1375\";\n}\n\n.mdi-label-multiple-outline::before {\n  content: \"\\F1376\";\n}\n\n.mdi-label-off::before {\n  content: \"\\F0ACB\";\n}\n\n.mdi-label-off-outline::before {\n  content: \"\\F0ACC\";\n}\n\n.mdi-label-outline::before {\n  content: \"\\F0316\";\n}\n\n.mdi-label-percent::before {\n  content: \"\\F12EA\";\n}\n\n.mdi-label-percent-outline::before {\n  content: \"\\F12EB\";\n}\n\n.mdi-label-variant::before {\n  content: \"\\F0ACD\";\n}\n\n.mdi-label-variant-outline::before {\n  content: \"\\F0ACE\";\n}\n\n.mdi-ladder::before {\n  content: \"\\F15A2\";\n}\n\n.mdi-ladybug::before {\n  content: \"\\F082D\";\n}\n\n.mdi-lambda::before {\n  content: \"\\F0627\";\n}\n\n.mdi-lamp::before {\n  content: \"\\F06B5\";\n}\n\n.mdi-lamp-outline::before {\n  content: \"\\F17D0\";\n}\n\n.mdi-lamps::before {\n  content: \"\\F1576\";\n}\n\n.mdi-lamps-outline::before {\n  content: \"\\F17D1\";\n}\n\n.mdi-lan::before {\n  content: \"\\F0317\";\n}\n\n.mdi-lan-check::before {\n  content: \"\\F12AA\";\n}\n\n.mdi-lan-connect::before {\n  content: \"\\F0318\";\n}\n\n.mdi-lan-disconnect::before {\n  content: \"\\F0319\";\n}\n\n.mdi-lan-pending::before {\n  content: \"\\F031A\";\n}\n\n.mdi-language-c::before {\n  content: \"\\F0671\";\n}\n\n.mdi-language-cpp::before {\n  content: \"\\F0672\";\n}\n\n.mdi-language-csharp::before {\n  content: \"\\F031B\";\n}\n\n.mdi-language-css3::before {\n  content: \"\\F031C\";\n}\n\n.mdi-language-fortran::before {\n  content: \"\\F121A\";\n}\n\n.mdi-language-go::before {\n  content: \"\\F07D3\";\n}\n\n.mdi-language-haskell::before {\n  content: \"\\F0C92\";\n}\n\n.mdi-language-html5::before {\n  content: \"\\F031D\";\n}\n\n.mdi-language-java::before {\n  content: \"\\F0B37\";\n}\n\n.mdi-language-javascript::before {\n  content: \"\\F031E\";\n}\n\n.mdi-language-kotlin::before {\n  content: \"\\F1219\";\n}\n\n.mdi-language-lua::before {\n  content: \"\\F08B1\";\n}\n\n.mdi-language-markdown::before {\n  content: \"\\F0354\";\n}\n\n.mdi-language-markdown-outline::before {\n  content: \"\\F0F5B\";\n}\n\n.mdi-language-php::before {\n  content: \"\\F031F\";\n}\n\n.mdi-language-python::before {\n  content: \"\\F0320\";\n}\n\n.mdi-language-r::before {\n  content: \"\\F07D4\";\n}\n\n.mdi-language-ruby::before {\n  content: \"\\F0D2D\";\n}\n\n.mdi-language-ruby-on-rails::before {\n  content: \"\\F0ACF\";\n}\n\n.mdi-language-rust::before {\n  content: \"\\F1617\";\n}\n\n.mdi-language-swift::before {\n  content: \"\\F06E5\";\n}\n\n.mdi-language-typescript::before {\n  content: \"\\F06E6\";\n}\n\n.mdi-language-xaml::before {\n  content: \"\\F0673\";\n}\n\n.mdi-laptop::before {\n  content: \"\\F0322\";\n}\n\n.mdi-laptop-off::before {\n  content: \"\\F06E7\";\n}\n\n.mdi-laravel::before {\n  content: \"\\F0AD0\";\n}\n\n.mdi-laser-pointer::before {\n  content: \"\\F1484\";\n}\n\n.mdi-lasso::before {\n  content: \"\\F0F03\";\n}\n\n.mdi-lastpass::before {\n  content: \"\\F0446\";\n}\n\n.mdi-latitude::before {\n  content: \"\\F0F57\";\n}\n\n.mdi-launch::before {\n  content: \"\\F0327\";\n}\n\n.mdi-lava-lamp::before {\n  content: \"\\F07D5\";\n}\n\n.mdi-layers::before {\n  content: \"\\F0328\";\n}\n\n.mdi-layers-edit::before {\n  content: \"\\F1892\";\n}\n\n.mdi-layers-minus::before {\n  content: \"\\F0E4C\";\n}\n\n.mdi-layers-off::before {\n  content: \"\\F0329\";\n}\n\n.mdi-layers-off-outline::before {\n  content: \"\\F09FD\";\n}\n\n.mdi-layers-outline::before {\n  content: \"\\F09FE\";\n}\n\n.mdi-layers-plus::before {\n  content: \"\\F0E4D\";\n}\n\n.mdi-layers-remove::before {\n  content: \"\\F0E4E\";\n}\n\n.mdi-layers-search::before {\n  content: \"\\F1206\";\n}\n\n.mdi-layers-search-outline::before {\n  content: \"\\F1207\";\n}\n\n.mdi-layers-triple::before {\n  content: \"\\F0F58\";\n}\n\n.mdi-layers-triple-outline::before {\n  content: \"\\F0F59\";\n}\n\n.mdi-lead-pencil::before {\n  content: \"\\F064F\";\n}\n\n.mdi-leaf::before {\n  content: \"\\F032A\";\n}\n\n.mdi-leaf-circle::before {\n  content: \"\\F1905\";\n}\n\n.mdi-leaf-circle-outline::before {\n  content: \"\\F1906\";\n}\n\n.mdi-leaf-maple::before {\n  content: \"\\F0C93\";\n}\n\n.mdi-leaf-maple-off::before {\n  content: \"\\F12DA\";\n}\n\n.mdi-leaf-off::before {\n  content: \"\\F12D9\";\n}\n\n.mdi-leak::before {\n  content: \"\\F0DD7\";\n}\n\n.mdi-leak-off::before {\n  content: \"\\F0DD8\";\n}\n\n.mdi-led-off::before {\n  content: \"\\F032B\";\n}\n\n.mdi-led-on::before {\n  content: \"\\F032C\";\n}\n\n.mdi-led-outline::before {\n  content: \"\\F032D\";\n}\n\n.mdi-led-strip::before {\n  content: \"\\F07D6\";\n}\n\n.mdi-led-strip-variant::before {\n  content: \"\\F1051\";\n}\n\n.mdi-led-variant-off::before {\n  content: \"\\F032E\";\n}\n\n.mdi-led-variant-on::before {\n  content: \"\\F032F\";\n}\n\n.mdi-led-variant-outline::before {\n  content: \"\\F0330\";\n}\n\n.mdi-leek::before {\n  content: \"\\F117D\";\n}\n\n.mdi-less-than::before {\n  content: \"\\F097C\";\n}\n\n.mdi-less-than-or-equal::before {\n  content: \"\\F097D\";\n}\n\n.mdi-library::before {\n  content: \"\\F0331\";\n}\n\n.mdi-library-shelves::before {\n  content: \"\\F0BA9\";\n}\n\n.mdi-license::before {\n  content: \"\\F0FC3\";\n}\n\n.mdi-lifebuoy::before {\n  content: \"\\F087E\";\n}\n\n.mdi-light-flood-down::before {\n  content: \"\\F1987\";\n}\n\n.mdi-light-flood-up::before {\n  content: \"\\F1988\";\n}\n\n.mdi-light-recessed::before {\n  content: \"\\F179B\";\n}\n\n.mdi-light-switch::before {\n  content: \"\\F097E\";\n}\n\n.mdi-lightbulb::before {\n  content: \"\\F0335\";\n}\n\n.mdi-lightbulb-auto::before {\n  content: \"\\F1800\";\n}\n\n.mdi-lightbulb-auto-outline::before {\n  content: \"\\F1801\";\n}\n\n.mdi-lightbulb-cfl::before {\n  content: \"\\F1208\";\n}\n\n.mdi-lightbulb-cfl-off::before {\n  content: \"\\F1209\";\n}\n\n.mdi-lightbulb-cfl-spiral::before {\n  content: \"\\F1275\";\n}\n\n.mdi-lightbulb-cfl-spiral-off::before {\n  content: \"\\F12C3\";\n}\n\n.mdi-lightbulb-fluorescent-tube::before {\n  content: \"\\F1804\";\n}\n\n.mdi-lightbulb-fluorescent-tube-outline::before {\n  content: \"\\F1805\";\n}\n\n.mdi-lightbulb-group::before {\n  content: \"\\F1253\";\n}\n\n.mdi-lightbulb-group-off::before {\n  content: \"\\F12CD\";\n}\n\n.mdi-lightbulb-group-off-outline::before {\n  content: \"\\F12CE\";\n}\n\n.mdi-lightbulb-group-outline::before {\n  content: \"\\F1254\";\n}\n\n.mdi-lightbulb-multiple::before {\n  content: \"\\F1255\";\n}\n\n.mdi-lightbulb-multiple-off::before {\n  content: \"\\F12CF\";\n}\n\n.mdi-lightbulb-multiple-off-outline::before {\n  content: \"\\F12D0\";\n}\n\n.mdi-lightbulb-multiple-outline::before {\n  content: \"\\F1256\";\n}\n\n.mdi-lightbulb-off::before {\n  content: \"\\F0E4F\";\n}\n\n.mdi-lightbulb-off-outline::before {\n  content: \"\\F0E50\";\n}\n\n.mdi-lightbulb-on::before {\n  content: \"\\F06E8\";\n}\n\n.mdi-lightbulb-on-outline::before {\n  content: \"\\F06E9\";\n}\n\n.mdi-lightbulb-outline::before {\n  content: \"\\F0336\";\n}\n\n.mdi-lightbulb-spot::before {\n  content: \"\\F17F4\";\n}\n\n.mdi-lightbulb-spot-off::before {\n  content: \"\\F17F5\";\n}\n\n.mdi-lightbulb-variant::before {\n  content: \"\\F1802\";\n}\n\n.mdi-lightbulb-variant-outline::before {\n  content: \"\\F1803\";\n}\n\n.mdi-lighthouse::before {\n  content: \"\\F09FF\";\n}\n\n.mdi-lighthouse-on::before {\n  content: \"\\F0A00\";\n}\n\n.mdi-lightning-bolt::before {\n  content: \"\\F140B\";\n}\n\n.mdi-lightning-bolt-circle::before {\n  content: \"\\F0820\";\n}\n\n.mdi-lightning-bolt-outline::before {\n  content: \"\\F140C\";\n}\n\n.mdi-line-scan::before {\n  content: \"\\F0624\";\n}\n\n.mdi-lingerie::before {\n  content: \"\\F1476\";\n}\n\n.mdi-link::before {\n  content: \"\\F0337\";\n}\n\n.mdi-link-box::before {\n  content: \"\\F0D1A\";\n}\n\n.mdi-link-box-outline::before {\n  content: \"\\F0D1B\";\n}\n\n.mdi-link-box-variant::before {\n  content: \"\\F0D1C\";\n}\n\n.mdi-link-box-variant-outline::before {\n  content: \"\\F0D1D\";\n}\n\n.mdi-link-lock::before {\n  content: \"\\F10BA\";\n}\n\n.mdi-link-off::before {\n  content: \"\\F0338\";\n}\n\n.mdi-link-plus::before {\n  content: \"\\F0C94\";\n}\n\n.mdi-link-variant::before {\n  content: \"\\F0339\";\n}\n\n.mdi-link-variant-minus::before {\n  content: \"\\F10FF\";\n}\n\n.mdi-link-variant-off::before {\n  content: \"\\F033A\";\n}\n\n.mdi-link-variant-plus::before {\n  content: \"\\F1100\";\n}\n\n.mdi-link-variant-remove::before {\n  content: \"\\F1101\";\n}\n\n.mdi-linkedin::before {\n  content: \"\\F033B\";\n}\n\n.mdi-linux::before {\n  content: \"\\F033D\";\n}\n\n.mdi-linux-mint::before {\n  content: \"\\F08ED\";\n}\n\n.mdi-lipstick::before {\n  content: \"\\F13B5\";\n}\n\n.mdi-liquid-spot::before {\n  content: \"\\F1826\";\n}\n\n.mdi-liquor::before {\n  content: \"\\F191E\";\n}\n\n.mdi-list-status::before {\n  content: \"\\F15AB\";\n}\n\n.mdi-litecoin::before {\n  content: \"\\F0A61\";\n}\n\n.mdi-loading::before {\n  content: \"\\F0772\";\n}\n\n.mdi-location-enter::before {\n  content: \"\\F0FC4\";\n}\n\n.mdi-location-exit::before {\n  content: \"\\F0FC5\";\n}\n\n.mdi-lock::before {\n  content: \"\\F033E\";\n}\n\n.mdi-lock-alert::before {\n  content: \"\\F08EE\";\n}\n\n.mdi-lock-alert-outline::before {\n  content: \"\\F15D1\";\n}\n\n.mdi-lock-check::before {\n  content: \"\\F139A\";\n}\n\n.mdi-lock-check-outline::before {\n  content: \"\\F16A8\";\n}\n\n.mdi-lock-clock::before {\n  content: \"\\F097F\";\n}\n\n.mdi-lock-minus::before {\n  content: \"\\F16A9\";\n}\n\n.mdi-lock-minus-outline::before {\n  content: \"\\F16AA\";\n}\n\n.mdi-lock-off::before {\n  content: \"\\F1671\";\n}\n\n.mdi-lock-off-outline::before {\n  content: \"\\F1672\";\n}\n\n.mdi-lock-open::before {\n  content: \"\\F033F\";\n}\n\n.mdi-lock-open-alert::before {\n  content: \"\\F139B\";\n}\n\n.mdi-lock-open-alert-outline::before {\n  content: \"\\F15D2\";\n}\n\n.mdi-lock-open-check::before {\n  content: \"\\F139C\";\n}\n\n.mdi-lock-open-check-outline::before {\n  content: \"\\F16AB\";\n}\n\n.mdi-lock-open-minus::before {\n  content: \"\\F16AC\";\n}\n\n.mdi-lock-open-minus-outline::before {\n  content: \"\\F16AD\";\n}\n\n.mdi-lock-open-outline::before {\n  content: \"\\F0340\";\n}\n\n.mdi-lock-open-plus::before {\n  content: \"\\F16AE\";\n}\n\n.mdi-lock-open-plus-outline::before {\n  content: \"\\F16AF\";\n}\n\n.mdi-lock-open-remove::before {\n  content: \"\\F16B0\";\n}\n\n.mdi-lock-open-remove-outline::before {\n  content: \"\\F16B1\";\n}\n\n.mdi-lock-open-variant::before {\n  content: \"\\F0FC6\";\n}\n\n.mdi-lock-open-variant-outline::before {\n  content: \"\\F0FC7\";\n}\n\n.mdi-lock-outline::before {\n  content: \"\\F0341\";\n}\n\n.mdi-lock-pattern::before {\n  content: \"\\F06EA\";\n}\n\n.mdi-lock-plus::before {\n  content: \"\\F05FB\";\n}\n\n.mdi-lock-plus-outline::before {\n  content: \"\\F16B2\";\n}\n\n.mdi-lock-question::before {\n  content: \"\\F08EF\";\n}\n\n.mdi-lock-remove::before {\n  content: \"\\F16B3\";\n}\n\n.mdi-lock-remove-outline::before {\n  content: \"\\F16B4\";\n}\n\n.mdi-lock-reset::before {\n  content: \"\\F0773\";\n}\n\n.mdi-lock-smart::before {\n  content: \"\\F08B2\";\n}\n\n.mdi-locker::before {\n  content: \"\\F07D7\";\n}\n\n.mdi-locker-multiple::before {\n  content: \"\\F07D8\";\n}\n\n.mdi-login::before {\n  content: \"\\F0342\";\n}\n\n.mdi-login-variant::before {\n  content: \"\\F05FC\";\n}\n\n.mdi-logout::before {\n  content: \"\\F0343\";\n}\n\n.mdi-logout-variant::before {\n  content: \"\\F05FD\";\n}\n\n.mdi-longitude::before {\n  content: \"\\F0F5A\";\n}\n\n.mdi-looks::before {\n  content: \"\\F0344\";\n}\n\n.mdi-lotion::before {\n  content: \"\\F1582\";\n}\n\n.mdi-lotion-outline::before {\n  content: \"\\F1583\";\n}\n\n.mdi-lotion-plus::before {\n  content: \"\\F1584\";\n}\n\n.mdi-lotion-plus-outline::before {\n  content: \"\\F1585\";\n}\n\n.mdi-loupe::before {\n  content: \"\\F0345\";\n}\n\n.mdi-lumx::before {\n  content: \"\\F0346\";\n}\n\n.mdi-lungs::before {\n  content: \"\\F1084\";\n}\n\n.mdi-mace::before {\n  content: \"\\F1843\";\n}\n\n.mdi-magazine-pistol::before {\n  content: \"\\F0324\";\n}\n\n.mdi-magazine-rifle::before {\n  content: \"\\F0323\";\n}\n\n.mdi-magic-staff::before {\n  content: \"\\F1844\";\n}\n\n.mdi-magnet::before {\n  content: \"\\F0347\";\n}\n\n.mdi-magnet-on::before {\n  content: \"\\F0348\";\n}\n\n.mdi-magnify::before {\n  content: \"\\F0349\";\n}\n\n.mdi-magnify-close::before {\n  content: \"\\F0980\";\n}\n\n.mdi-magnify-expand::before {\n  content: \"\\F1874\";\n}\n\n.mdi-magnify-minus::before {\n  content: \"\\F034A\";\n}\n\n.mdi-magnify-minus-cursor::before {\n  content: \"\\F0A62\";\n}\n\n.mdi-magnify-minus-outline::before {\n  content: \"\\F06EC\";\n}\n\n.mdi-magnify-plus::before {\n  content: \"\\F034B\";\n}\n\n.mdi-magnify-plus-cursor::before {\n  content: \"\\F0A63\";\n}\n\n.mdi-magnify-plus-outline::before {\n  content: \"\\F06ED\";\n}\n\n.mdi-magnify-remove-cursor::before {\n  content: \"\\F120C\";\n}\n\n.mdi-magnify-remove-outline::before {\n  content: \"\\F120D\";\n}\n\n.mdi-magnify-scan::before {\n  content: \"\\F1276\";\n}\n\n.mdi-mail::before {\n  content: \"\\F0EBB\";\n}\n\n.mdi-mailbox::before {\n  content: \"\\F06EE\";\n}\n\n.mdi-mailbox-open::before {\n  content: \"\\F0D88\";\n}\n\n.mdi-mailbox-open-outline::before {\n  content: \"\\F0D89\";\n}\n\n.mdi-mailbox-open-up::before {\n  content: \"\\F0D8A\";\n}\n\n.mdi-mailbox-open-up-outline::before {\n  content: \"\\F0D8B\";\n}\n\n.mdi-mailbox-outline::before {\n  content: \"\\F0D8C\";\n}\n\n.mdi-mailbox-up::before {\n  content: \"\\F0D8D\";\n}\n\n.mdi-mailbox-up-outline::before {\n  content: \"\\F0D8E\";\n}\n\n.mdi-manjaro::before {\n  content: \"\\F160A\";\n}\n\n.mdi-map::before {\n  content: \"\\F034D\";\n}\n\n.mdi-map-check::before {\n  content: \"\\F0EBC\";\n}\n\n.mdi-map-check-outline::before {\n  content: \"\\F0EBD\";\n}\n\n.mdi-map-clock::before {\n  content: \"\\F0D1E\";\n}\n\n.mdi-map-clock-outline::before {\n  content: \"\\F0D1F\";\n}\n\n.mdi-map-legend::before {\n  content: \"\\F0A01\";\n}\n\n.mdi-map-marker::before {\n  content: \"\\F034E\";\n}\n\n.mdi-map-marker-account::before {\n  content: \"\\F18E3\";\n}\n\n.mdi-map-marker-account-outline::before {\n  content: \"\\F18E4\";\n}\n\n.mdi-map-marker-alert::before {\n  content: \"\\F0F05\";\n}\n\n.mdi-map-marker-alert-outline::before {\n  content: \"\\F0F06\";\n}\n\n.mdi-map-marker-check::before {\n  content: \"\\F0C95\";\n}\n\n.mdi-map-marker-check-outline::before {\n  content: \"\\F12FB\";\n}\n\n.mdi-map-marker-circle::before {\n  content: \"\\F034F\";\n}\n\n.mdi-map-marker-distance::before {\n  content: \"\\F08F0\";\n}\n\n.mdi-map-marker-down::before {\n  content: \"\\F1102\";\n}\n\n.mdi-map-marker-left::before {\n  content: \"\\F12DB\";\n}\n\n.mdi-map-marker-left-outline::before {\n  content: \"\\F12DD\";\n}\n\n.mdi-map-marker-minus::before {\n  content: \"\\F0650\";\n}\n\n.mdi-map-marker-minus-outline::before {\n  content: \"\\F12F9\";\n}\n\n.mdi-map-marker-multiple::before {\n  content: \"\\F0350\";\n}\n\n.mdi-map-marker-multiple-outline::before {\n  content: \"\\F1277\";\n}\n\n.mdi-map-marker-off::before {\n  content: \"\\F0351\";\n}\n\n.mdi-map-marker-off-outline::before {\n  content: \"\\F12FD\";\n}\n\n.mdi-map-marker-outline::before {\n  content: \"\\F07D9\";\n}\n\n.mdi-map-marker-path::before {\n  content: \"\\F0D20\";\n}\n\n.mdi-map-marker-plus::before {\n  content: \"\\F0651\";\n}\n\n.mdi-map-marker-plus-outline::before {\n  content: \"\\F12F8\";\n}\n\n.mdi-map-marker-question::before {\n  content: \"\\F0F07\";\n}\n\n.mdi-map-marker-question-outline::before {\n  content: \"\\F0F08\";\n}\n\n.mdi-map-marker-radius::before {\n  content: \"\\F0352\";\n}\n\n.mdi-map-marker-radius-outline::before {\n  content: \"\\F12FC\";\n}\n\n.mdi-map-marker-remove::before {\n  content: \"\\F0F09\";\n}\n\n.mdi-map-marker-remove-outline::before {\n  content: \"\\F12FA\";\n}\n\n.mdi-map-marker-remove-variant::before {\n  content: \"\\F0F0A\";\n}\n\n.mdi-map-marker-right::before {\n  content: \"\\F12DC\";\n}\n\n.mdi-map-marker-right-outline::before {\n  content: \"\\F12DE\";\n}\n\n.mdi-map-marker-star::before {\n  content: \"\\F1608\";\n}\n\n.mdi-map-marker-star-outline::before {\n  content: \"\\F1609\";\n}\n\n.mdi-map-marker-up::before {\n  content: \"\\F1103\";\n}\n\n.mdi-map-minus::before {\n  content: \"\\F0981\";\n}\n\n.mdi-map-outline::before {\n  content: \"\\F0982\";\n}\n\n.mdi-map-plus::before {\n  content: \"\\F0983\";\n}\n\n.mdi-map-search::before {\n  content: \"\\F0984\";\n}\n\n.mdi-map-search-outline::before {\n  content: \"\\F0985\";\n}\n\n.mdi-mapbox::before {\n  content: \"\\F0BAA\";\n}\n\n.mdi-margin::before {\n  content: \"\\F0353\";\n}\n\n.mdi-marker::before {\n  content: \"\\F0652\";\n}\n\n.mdi-marker-cancel::before {\n  content: \"\\F0DD9\";\n}\n\n.mdi-marker-check::before {\n  content: \"\\F0355\";\n}\n\n.mdi-mastodon::before {\n  content: \"\\F0AD1\";\n}\n\n.mdi-material-design::before {\n  content: \"\\F0986\";\n}\n\n.mdi-material-ui::before {\n  content: \"\\F0357\";\n}\n\n.mdi-math-compass::before {\n  content: \"\\F0358\";\n}\n\n.mdi-math-cos::before {\n  content: \"\\F0C96\";\n}\n\n.mdi-math-integral::before {\n  content: \"\\F0FC8\";\n}\n\n.mdi-math-integral-box::before {\n  content: \"\\F0FC9\";\n}\n\n.mdi-math-log::before {\n  content: \"\\F1085\";\n}\n\n.mdi-math-norm::before {\n  content: \"\\F0FCA\";\n}\n\n.mdi-math-norm-box::before {\n  content: \"\\F0FCB\";\n}\n\n.mdi-math-sin::before {\n  content: \"\\F0C97\";\n}\n\n.mdi-math-tan::before {\n  content: \"\\F0C98\";\n}\n\n.mdi-matrix::before {\n  content: \"\\F0628\";\n}\n\n.mdi-medal::before {\n  content: \"\\F0987\";\n}\n\n.mdi-medal-outline::before {\n  content: \"\\F1326\";\n}\n\n.mdi-medical-bag::before {\n  content: \"\\F06EF\";\n}\n\n.mdi-meditation::before {\n  content: \"\\F117B\";\n}\n\n.mdi-memory::before {\n  content: \"\\F035B\";\n}\n\n.mdi-menorah::before {\n  content: \"\\F17D4\";\n}\n\n.mdi-menorah-fire::before {\n  content: \"\\F17D5\";\n}\n\n.mdi-menu::before {\n  content: \"\\F035C\";\n}\n\n.mdi-menu-down::before {\n  content: \"\\F035D\";\n}\n\n.mdi-menu-down-outline::before {\n  content: \"\\F06B6\";\n}\n\n.mdi-menu-left::before {\n  content: \"\\F035E\";\n}\n\n.mdi-menu-left-outline::before {\n  content: \"\\F0A02\";\n}\n\n.mdi-menu-open::before {\n  content: \"\\F0BAB\";\n}\n\n.mdi-menu-right::before {\n  content: \"\\F035F\";\n}\n\n.mdi-menu-right-outline::before {\n  content: \"\\F0A03\";\n}\n\n.mdi-menu-swap::before {\n  content: \"\\F0A64\";\n}\n\n.mdi-menu-swap-outline::before {\n  content: \"\\F0A65\";\n}\n\n.mdi-menu-up::before {\n  content: \"\\F0360\";\n}\n\n.mdi-menu-up-outline::before {\n  content: \"\\F06B7\";\n}\n\n.mdi-merge::before {\n  content: \"\\F0F5C\";\n}\n\n.mdi-message::before {\n  content: \"\\F0361\";\n}\n\n.mdi-message-alert::before {\n  content: \"\\F0362\";\n}\n\n.mdi-message-alert-outline::before {\n  content: \"\\F0A04\";\n}\n\n.mdi-message-arrow-left::before {\n  content: \"\\F12F2\";\n}\n\n.mdi-message-arrow-left-outline::before {\n  content: \"\\F12F3\";\n}\n\n.mdi-message-arrow-right::before {\n  content: \"\\F12F4\";\n}\n\n.mdi-message-arrow-right-outline::before {\n  content: \"\\F12F5\";\n}\n\n.mdi-message-badge::before {\n  content: \"\\F1941\";\n}\n\n.mdi-message-badge-outline::before {\n  content: \"\\F1942\";\n}\n\n.mdi-message-bookmark::before {\n  content: \"\\F15AC\";\n}\n\n.mdi-message-bookmark-outline::before {\n  content: \"\\F15AD\";\n}\n\n.mdi-message-bulleted::before {\n  content: \"\\F06A2\";\n}\n\n.mdi-message-bulleted-off::before {\n  content: \"\\F06A3\";\n}\n\n.mdi-message-cog::before {\n  content: \"\\F06F1\";\n}\n\n.mdi-message-cog-outline::before {\n  content: \"\\F1172\";\n}\n\n.mdi-message-draw::before {\n  content: \"\\F0363\";\n}\n\n.mdi-message-flash::before {\n  content: \"\\F15A9\";\n}\n\n.mdi-message-flash-outline::before {\n  content: \"\\F15AA\";\n}\n\n.mdi-message-image::before {\n  content: \"\\F0364\";\n}\n\n.mdi-message-image-outline::before {\n  content: \"\\F116C\";\n}\n\n.mdi-message-lock::before {\n  content: \"\\F0FCC\";\n}\n\n.mdi-message-lock-outline::before {\n  content: \"\\F116D\";\n}\n\n.mdi-message-minus::before {\n  content: \"\\F116E\";\n}\n\n.mdi-message-minus-outline::before {\n  content: \"\\F116F\";\n}\n\n.mdi-message-off::before {\n  content: \"\\F164D\";\n}\n\n.mdi-message-off-outline::before {\n  content: \"\\F164E\";\n}\n\n.mdi-message-outline::before {\n  content: \"\\F0365\";\n}\n\n.mdi-message-plus::before {\n  content: \"\\F0653\";\n}\n\n.mdi-message-plus-outline::before {\n  content: \"\\F10BB\";\n}\n\n.mdi-message-processing::before {\n  content: \"\\F0366\";\n}\n\n.mdi-message-processing-outline::before {\n  content: \"\\F1170\";\n}\n\n.mdi-message-question::before {\n  content: \"\\F173A\";\n}\n\n.mdi-message-question-outline::before {\n  content: \"\\F173B\";\n}\n\n.mdi-message-reply::before {\n  content: \"\\F0367\";\n}\n\n.mdi-message-reply-outline::before {\n  content: \"\\F173D\";\n}\n\n.mdi-message-reply-text::before {\n  content: \"\\F0368\";\n}\n\n.mdi-message-reply-text-outline::before {\n  content: \"\\F173E\";\n}\n\n.mdi-message-settings::before {\n  content: \"\\F06F0\";\n}\n\n.mdi-message-settings-outline::before {\n  content: \"\\F1171\";\n}\n\n.mdi-message-star::before {\n  content: \"\\F069A\";\n}\n\n.mdi-message-star-outline::before {\n  content: \"\\F1250\";\n}\n\n.mdi-message-text::before {\n  content: \"\\F0369\";\n}\n\n.mdi-message-text-clock::before {\n  content: \"\\F1173\";\n}\n\n.mdi-message-text-clock-outline::before {\n  content: \"\\F1174\";\n}\n\n.mdi-message-text-lock::before {\n  content: \"\\F0FCD\";\n}\n\n.mdi-message-text-lock-outline::before {\n  content: \"\\F1175\";\n}\n\n.mdi-message-text-outline::before {\n  content: \"\\F036A\";\n}\n\n.mdi-message-video::before {\n  content: \"\\F036B\";\n}\n\n.mdi-meteor::before {\n  content: \"\\F0629\";\n}\n\n.mdi-metronome::before {\n  content: \"\\F07DA\";\n}\n\n.mdi-metronome-tick::before {\n  content: \"\\F07DB\";\n}\n\n.mdi-micro-sd::before {\n  content: \"\\F07DC\";\n}\n\n.mdi-microphone::before {\n  content: \"\\F036C\";\n}\n\n.mdi-microphone-minus::before {\n  content: \"\\F08B3\";\n}\n\n.mdi-microphone-off::before {\n  content: \"\\F036D\";\n}\n\n.mdi-microphone-outline::before {\n  content: \"\\F036E\";\n}\n\n.mdi-microphone-plus::before {\n  content: \"\\F08B4\";\n}\n\n.mdi-microphone-question::before {\n  content: \"\\F1989\";\n}\n\n.mdi-microphone-question-outline::before {\n  content: \"\\F198A\";\n}\n\n.mdi-microphone-settings::before {\n  content: \"\\F036F\";\n}\n\n.mdi-microphone-variant::before {\n  content: \"\\F0370\";\n}\n\n.mdi-microphone-variant-off::before {\n  content: \"\\F0371\";\n}\n\n.mdi-microscope::before {\n  content: \"\\F0654\";\n}\n\n.mdi-microsoft::before {\n  content: \"\\F0372\";\n}\n\n.mdi-microsoft-access::before {\n  content: \"\\F138E\";\n}\n\n.mdi-microsoft-azure::before {\n  content: \"\\F0805\";\n}\n\n.mdi-microsoft-azure-devops::before {\n  content: \"\\F0FD5\";\n}\n\n.mdi-microsoft-bing::before {\n  content: \"\\F00A4\";\n}\n\n.mdi-microsoft-dynamics-365::before {\n  content: \"\\F0988\";\n}\n\n.mdi-microsoft-edge::before {\n  content: \"\\F01E9\";\n}\n\n.mdi-microsoft-excel::before {\n  content: \"\\F138F\";\n}\n\n.mdi-microsoft-internet-explorer::before {\n  content: \"\\F0300\";\n}\n\n.mdi-microsoft-office::before {\n  content: \"\\F03C6\";\n}\n\n.mdi-microsoft-onedrive::before {\n  content: \"\\F03CA\";\n}\n\n.mdi-microsoft-onenote::before {\n  content: \"\\F0747\";\n}\n\n.mdi-microsoft-outlook::before {\n  content: \"\\F0D22\";\n}\n\n.mdi-microsoft-powerpoint::before {\n  content: \"\\F1390\";\n}\n\n.mdi-microsoft-sharepoint::before {\n  content: \"\\F1391\";\n}\n\n.mdi-microsoft-teams::before {\n  content: \"\\F02BB\";\n}\n\n.mdi-microsoft-visual-studio::before {\n  content: \"\\F0610\";\n}\n\n.mdi-microsoft-visual-studio-code::before {\n  content: \"\\F0A1E\";\n}\n\n.mdi-microsoft-windows::before {\n  content: \"\\F05B3\";\n}\n\n.mdi-microsoft-windows-classic::before {\n  content: \"\\F0A21\";\n}\n\n.mdi-microsoft-word::before {\n  content: \"\\F1392\";\n}\n\n.mdi-microsoft-xbox::before {\n  content: \"\\F05B9\";\n}\n\n.mdi-microsoft-xbox-controller::before {\n  content: \"\\F05BA\";\n}\n\n.mdi-microsoft-xbox-controller-battery-alert::before {\n  content: \"\\F074B\";\n}\n\n.mdi-microsoft-xbox-controller-battery-charging::before {\n  content: \"\\F0A22\";\n}\n\n.mdi-microsoft-xbox-controller-battery-empty::before {\n  content: \"\\F074C\";\n}\n\n.mdi-microsoft-xbox-controller-battery-full::before {\n  content: \"\\F074D\";\n}\n\n.mdi-microsoft-xbox-controller-battery-low::before {\n  content: \"\\F074E\";\n}\n\n.mdi-microsoft-xbox-controller-battery-medium::before {\n  content: \"\\F074F\";\n}\n\n.mdi-microsoft-xbox-controller-battery-unknown::before {\n  content: \"\\F0750\";\n}\n\n.mdi-microsoft-xbox-controller-menu::before {\n  content: \"\\F0E6F\";\n}\n\n.mdi-microsoft-xbox-controller-off::before {\n  content: \"\\F05BB\";\n}\n\n.mdi-microsoft-xbox-controller-view::before {\n  content: \"\\F0E70\";\n}\n\n.mdi-microwave::before {\n  content: \"\\F0C99\";\n}\n\n.mdi-microwave-off::before {\n  content: \"\\F1423\";\n}\n\n.mdi-middleware::before {\n  content: \"\\F0F5D\";\n}\n\n.mdi-middleware-outline::before {\n  content: \"\\F0F5E\";\n}\n\n.mdi-midi::before {\n  content: \"\\F08F1\";\n}\n\n.mdi-midi-port::before {\n  content: \"\\F08F2\";\n}\n\n.mdi-mine::before {\n  content: \"\\F0DDA\";\n}\n\n.mdi-minecraft::before {\n  content: \"\\F0373\";\n}\n\n.mdi-mini-sd::before {\n  content: \"\\F0A05\";\n}\n\n.mdi-minidisc::before {\n  content: \"\\F0A06\";\n}\n\n.mdi-minus::before {\n  content: \"\\F0374\";\n}\n\n.mdi-minus-box::before {\n  content: \"\\F0375\";\n}\n\n.mdi-minus-box-multiple::before {\n  content: \"\\F1141\";\n}\n\n.mdi-minus-box-multiple-outline::before {\n  content: \"\\F1142\";\n}\n\n.mdi-minus-box-outline::before {\n  content: \"\\F06F2\";\n}\n\n.mdi-minus-circle::before {\n  content: \"\\F0376\";\n}\n\n.mdi-minus-circle-multiple::before {\n  content: \"\\F035A\";\n}\n\n.mdi-minus-circle-multiple-outline::before {\n  content: \"\\F0AD3\";\n}\n\n.mdi-minus-circle-off::before {\n  content: \"\\F1459\";\n}\n\n.mdi-minus-circle-off-outline::before {\n  content: \"\\F145A\";\n}\n\n.mdi-minus-circle-outline::before {\n  content: \"\\F0377\";\n}\n\n.mdi-minus-network::before {\n  content: \"\\F0378\";\n}\n\n.mdi-minus-network-outline::before {\n  content: \"\\F0C9A\";\n}\n\n.mdi-minus-thick::before {\n  content: \"\\F1639\";\n}\n\n.mdi-mirror::before {\n  content: \"\\F11FD\";\n}\n\n.mdi-mirror-rectangle::before {\n  content: \"\\F179F\";\n}\n\n.mdi-mirror-variant::before {\n  content: \"\\F17A0\";\n}\n\n.mdi-mixed-martial-arts::before {\n  content: \"\\F0D8F\";\n}\n\n.mdi-mixed-reality::before {\n  content: \"\\F087F\";\n}\n\n.mdi-molecule::before {\n  content: \"\\F0BAC\";\n}\n\n.mdi-molecule-co::before {\n  content: \"\\F12FE\";\n}\n\n.mdi-molecule-co2::before {\n  content: \"\\F07E4\";\n}\n\n.mdi-monitor::before {\n  content: \"\\F0379\";\n}\n\n.mdi-monitor-cellphone::before {\n  content: \"\\F0989\";\n}\n\n.mdi-monitor-cellphone-star::before {\n  content: \"\\F098A\";\n}\n\n.mdi-monitor-dashboard::before {\n  content: \"\\F0A07\";\n}\n\n.mdi-monitor-edit::before {\n  content: \"\\F12C6\";\n}\n\n.mdi-monitor-eye::before {\n  content: \"\\F13B4\";\n}\n\n.mdi-monitor-lock::before {\n  content: \"\\F0DDB\";\n}\n\n.mdi-monitor-multiple::before {\n  content: \"\\F037A\";\n}\n\n.mdi-monitor-off::before {\n  content: \"\\F0D90\";\n}\n\n.mdi-monitor-screenshot::before {\n  content: \"\\F0E51\";\n}\n\n.mdi-monitor-share::before {\n  content: \"\\F1483\";\n}\n\n.mdi-monitor-shimmer::before {\n  content: \"\\F1104\";\n}\n\n.mdi-monitor-small::before {\n  content: \"\\F1876\";\n}\n\n.mdi-monitor-speaker::before {\n  content: \"\\F0F5F\";\n}\n\n.mdi-monitor-speaker-off::before {\n  content: \"\\F0F60\";\n}\n\n.mdi-monitor-star::before {\n  content: \"\\F0DDC\";\n}\n\n.mdi-moon-first-quarter::before {\n  content: \"\\F0F61\";\n}\n\n.mdi-moon-full::before {\n  content: \"\\F0F62\";\n}\n\n.mdi-moon-last-quarter::before {\n  content: \"\\F0F63\";\n}\n\n.mdi-moon-new::before {\n  content: \"\\F0F64\";\n}\n\n.mdi-moon-waning-crescent::before {\n  content: \"\\F0F65\";\n}\n\n.mdi-moon-waning-gibbous::before {\n  content: \"\\F0F66\";\n}\n\n.mdi-moon-waxing-crescent::before {\n  content: \"\\F0F67\";\n}\n\n.mdi-moon-waxing-gibbous::before {\n  content: \"\\F0F68\";\n}\n\n.mdi-moped::before {\n  content: \"\\F1086\";\n}\n\n.mdi-moped-electric::before {\n  content: \"\\F15B7\";\n}\n\n.mdi-moped-electric-outline::before {\n  content: \"\\F15B8\";\n}\n\n.mdi-moped-outline::before {\n  content: \"\\F15B9\";\n}\n\n.mdi-more::before {\n  content: \"\\F037B\";\n}\n\n.mdi-mortar-pestle::before {\n  content: \"\\F1748\";\n}\n\n.mdi-mortar-pestle-plus::before {\n  content: \"\\F03F1\";\n}\n\n.mdi-mosque::before {\n  content: \"\\F1827\";\n}\n\n.mdi-mother-heart::before {\n  content: \"\\F1314\";\n}\n\n.mdi-mother-nurse::before {\n  content: \"\\F0D21\";\n}\n\n.mdi-motion::before {\n  content: \"\\F15B2\";\n}\n\n.mdi-motion-outline::before {\n  content: \"\\F15B3\";\n}\n\n.mdi-motion-pause::before {\n  content: \"\\F1590\";\n}\n\n.mdi-motion-pause-outline::before {\n  content: \"\\F1592\";\n}\n\n.mdi-motion-play::before {\n  content: \"\\F158F\";\n}\n\n.mdi-motion-play-outline::before {\n  content: \"\\F1591\";\n}\n\n.mdi-motion-sensor::before {\n  content: \"\\F0D91\";\n}\n\n.mdi-motion-sensor-off::before {\n  content: \"\\F1435\";\n}\n\n.mdi-motorbike::before {\n  content: \"\\F037C\";\n}\n\n.mdi-motorbike-electric::before {\n  content: \"\\F15BA\";\n}\n\n.mdi-mouse::before {\n  content: \"\\F037D\";\n}\n\n.mdi-mouse-bluetooth::before {\n  content: \"\\F098B\";\n}\n\n.mdi-mouse-move-down::before {\n  content: \"\\F1550\";\n}\n\n.mdi-mouse-move-up::before {\n  content: \"\\F1551\";\n}\n\n.mdi-mouse-move-vertical::before {\n  content: \"\\F1552\";\n}\n\n.mdi-mouse-off::before {\n  content: \"\\F037E\";\n}\n\n.mdi-mouse-variant::before {\n  content: \"\\F037F\";\n}\n\n.mdi-mouse-variant-off::before {\n  content: \"\\F0380\";\n}\n\n.mdi-move-resize::before {\n  content: \"\\F0655\";\n}\n\n.mdi-move-resize-variant::before {\n  content: \"\\F0656\";\n}\n\n.mdi-movie::before {\n  content: \"\\F0381\";\n}\n\n.mdi-movie-check::before {\n  content: \"\\F16F3\";\n}\n\n.mdi-movie-check-outline::before {\n  content: \"\\F16F4\";\n}\n\n.mdi-movie-cog::before {\n  content: \"\\F16F5\";\n}\n\n.mdi-movie-cog-outline::before {\n  content: \"\\F16F6\";\n}\n\n.mdi-movie-edit::before {\n  content: \"\\F1122\";\n}\n\n.mdi-movie-edit-outline::before {\n  content: \"\\F1123\";\n}\n\n.mdi-movie-filter::before {\n  content: \"\\F1124\";\n}\n\n.mdi-movie-filter-outline::before {\n  content: \"\\F1125\";\n}\n\n.mdi-movie-minus::before {\n  content: \"\\F16F7\";\n}\n\n.mdi-movie-minus-outline::before {\n  content: \"\\F16F8\";\n}\n\n.mdi-movie-off::before {\n  content: \"\\F16F9\";\n}\n\n.mdi-movie-off-outline::before {\n  content: \"\\F16FA\";\n}\n\n.mdi-movie-open::before {\n  content: \"\\F0FCE\";\n}\n\n.mdi-movie-open-check::before {\n  content: \"\\F16FB\";\n}\n\n.mdi-movie-open-check-outline::before {\n  content: \"\\F16FC\";\n}\n\n.mdi-movie-open-cog::before {\n  content: \"\\F16FD\";\n}\n\n.mdi-movie-open-cog-outline::before {\n  content: \"\\F16FE\";\n}\n\n.mdi-movie-open-edit::before {\n  content: \"\\F16FF\";\n}\n\n.mdi-movie-open-edit-outline::before {\n  content: \"\\F1700\";\n}\n\n.mdi-movie-open-minus::before {\n  content: \"\\F1701\";\n}\n\n.mdi-movie-open-minus-outline::before {\n  content: \"\\F1702\";\n}\n\n.mdi-movie-open-off::before {\n  content: \"\\F1703\";\n}\n\n.mdi-movie-open-off-outline::before {\n  content: \"\\F1704\";\n}\n\n.mdi-movie-open-outline::before {\n  content: \"\\F0FCF\";\n}\n\n.mdi-movie-open-play::before {\n  content: \"\\F1705\";\n}\n\n.mdi-movie-open-play-outline::before {\n  content: \"\\F1706\";\n}\n\n.mdi-movie-open-plus::before {\n  content: \"\\F1707\";\n}\n\n.mdi-movie-open-plus-outline::before {\n  content: \"\\F1708\";\n}\n\n.mdi-movie-open-remove::before {\n  content: \"\\F1709\";\n}\n\n.mdi-movie-open-remove-outline::before {\n  content: \"\\F170A\";\n}\n\n.mdi-movie-open-settings::before {\n  content: \"\\F170B\";\n}\n\n.mdi-movie-open-settings-outline::before {\n  content: \"\\F170C\";\n}\n\n.mdi-movie-open-star::before {\n  content: \"\\F170D\";\n}\n\n.mdi-movie-open-star-outline::before {\n  content: \"\\F170E\";\n}\n\n.mdi-movie-outline::before {\n  content: \"\\F0DDD\";\n}\n\n.mdi-movie-play::before {\n  content: \"\\F170F\";\n}\n\n.mdi-movie-play-outline::before {\n  content: \"\\F1710\";\n}\n\n.mdi-movie-plus::before {\n  content: \"\\F1711\";\n}\n\n.mdi-movie-plus-outline::before {\n  content: \"\\F1712\";\n}\n\n.mdi-movie-remove::before {\n  content: \"\\F1713\";\n}\n\n.mdi-movie-remove-outline::before {\n  content: \"\\F1714\";\n}\n\n.mdi-movie-roll::before {\n  content: \"\\F07DE\";\n}\n\n.mdi-movie-search::before {\n  content: \"\\F11D2\";\n}\n\n.mdi-movie-search-outline::before {\n  content: \"\\F11D3\";\n}\n\n.mdi-movie-settings::before {\n  content: \"\\F1715\";\n}\n\n.mdi-movie-settings-outline::before {\n  content: \"\\F1716\";\n}\n\n.mdi-movie-star::before {\n  content: \"\\F1717\";\n}\n\n.mdi-movie-star-outline::before {\n  content: \"\\F1718\";\n}\n\n.mdi-mower::before {\n  content: \"\\F166F\";\n}\n\n.mdi-mower-bag::before {\n  content: \"\\F1670\";\n}\n\n.mdi-muffin::before {\n  content: \"\\F098C\";\n}\n\n.mdi-multicast::before {\n  content: \"\\F1893\";\n}\n\n.mdi-multiplication::before {\n  content: \"\\F0382\";\n}\n\n.mdi-multiplication-box::before {\n  content: \"\\F0383\";\n}\n\n.mdi-mushroom::before {\n  content: \"\\F07DF\";\n}\n\n.mdi-mushroom-off::before {\n  content: \"\\F13FA\";\n}\n\n.mdi-mushroom-off-outline::before {\n  content: \"\\F13FB\";\n}\n\n.mdi-mushroom-outline::before {\n  content: \"\\F07E0\";\n}\n\n.mdi-music::before {\n  content: \"\\F075A\";\n}\n\n.mdi-music-accidental-double-flat::before {\n  content: \"\\F0F69\";\n}\n\n.mdi-music-accidental-double-sharp::before {\n  content: \"\\F0F6A\";\n}\n\n.mdi-music-accidental-flat::before {\n  content: \"\\F0F6B\";\n}\n\n.mdi-music-accidental-natural::before {\n  content: \"\\F0F6C\";\n}\n\n.mdi-music-accidental-sharp::before {\n  content: \"\\F0F6D\";\n}\n\n.mdi-music-box::before {\n  content: \"\\F0384\";\n}\n\n.mdi-music-box-multiple::before {\n  content: \"\\F0333\";\n}\n\n.mdi-music-box-multiple-outline::before {\n  content: \"\\F0F04\";\n}\n\n.mdi-music-box-outline::before {\n  content: \"\\F0385\";\n}\n\n.mdi-music-circle::before {\n  content: \"\\F0386\";\n}\n\n.mdi-music-circle-outline::before {\n  content: \"\\F0AD4\";\n}\n\n.mdi-music-clef-alto::before {\n  content: \"\\F0F6E\";\n}\n\n.mdi-music-clef-bass::before {\n  content: \"\\F0F6F\";\n}\n\n.mdi-music-clef-treble::before {\n  content: \"\\F0F70\";\n}\n\n.mdi-music-note::before {\n  content: \"\\F0387\";\n}\n\n.mdi-music-note-bluetooth::before {\n  content: \"\\F05FE\";\n}\n\n.mdi-music-note-bluetooth-off::before {\n  content: \"\\F05FF\";\n}\n\n.mdi-music-note-eighth::before {\n  content: \"\\F0388\";\n}\n\n.mdi-music-note-eighth-dotted::before {\n  content: \"\\F0F71\";\n}\n\n.mdi-music-note-half::before {\n  content: \"\\F0389\";\n}\n\n.mdi-music-note-half-dotted::before {\n  content: \"\\F0F72\";\n}\n\n.mdi-music-note-off::before {\n  content: \"\\F038A\";\n}\n\n.mdi-music-note-off-outline::before {\n  content: \"\\F0F73\";\n}\n\n.mdi-music-note-outline::before {\n  content: \"\\F0F74\";\n}\n\n.mdi-music-note-plus::before {\n  content: \"\\F0DDE\";\n}\n\n.mdi-music-note-quarter::before {\n  content: \"\\F038B\";\n}\n\n.mdi-music-note-quarter-dotted::before {\n  content: \"\\F0F75\";\n}\n\n.mdi-music-note-sixteenth::before {\n  content: \"\\F038C\";\n}\n\n.mdi-music-note-sixteenth-dotted::before {\n  content: \"\\F0F76\";\n}\n\n.mdi-music-note-whole::before {\n  content: \"\\F038D\";\n}\n\n.mdi-music-note-whole-dotted::before {\n  content: \"\\F0F77\";\n}\n\n.mdi-music-off::before {\n  content: \"\\F075B\";\n}\n\n.mdi-music-rest-eighth::before {\n  content: \"\\F0F78\";\n}\n\n.mdi-music-rest-half::before {\n  content: \"\\F0F79\";\n}\n\n.mdi-music-rest-quarter::before {\n  content: \"\\F0F7A\";\n}\n\n.mdi-music-rest-sixteenth::before {\n  content: \"\\F0F7B\";\n}\n\n.mdi-music-rest-whole::before {\n  content: \"\\F0F7C\";\n}\n\n.mdi-mustache::before {\n  content: \"\\F15DE\";\n}\n\n.mdi-nail::before {\n  content: \"\\F0DDF\";\n}\n\n.mdi-nas::before {\n  content: \"\\F08F3\";\n}\n\n.mdi-nativescript::before {\n  content: \"\\F0880\";\n}\n\n.mdi-nature::before {\n  content: \"\\F038E\";\n}\n\n.mdi-nature-people::before {\n  content: \"\\F038F\";\n}\n\n.mdi-navigation::before {\n  content: \"\\F0390\";\n}\n\n.mdi-navigation-outline::before {\n  content: \"\\F1607\";\n}\n\n.mdi-navigation-variant::before {\n  content: \"\\F18F0\";\n}\n\n.mdi-navigation-variant-outline::before {\n  content: \"\\F18F1\";\n}\n\n.mdi-near-me::before {\n  content: \"\\F05CD\";\n}\n\n.mdi-necklace::before {\n  content: \"\\F0F0B\";\n}\n\n.mdi-needle::before {\n  content: \"\\F0391\";\n}\n\n.mdi-netflix::before {\n  content: \"\\F0746\";\n}\n\n.mdi-network::before {\n  content: \"\\F06F3\";\n}\n\n.mdi-network-off::before {\n  content: \"\\F0C9B\";\n}\n\n.mdi-network-off-outline::before {\n  content: \"\\F0C9C\";\n}\n\n.mdi-network-outline::before {\n  content: \"\\F0C9D\";\n}\n\n.mdi-network-strength-1::before {\n  content: \"\\F08F4\";\n}\n\n.mdi-network-strength-1-alert::before {\n  content: \"\\F08F5\";\n}\n\n.mdi-network-strength-2::before {\n  content: \"\\F08F6\";\n}\n\n.mdi-network-strength-2-alert::before {\n  content: \"\\F08F7\";\n}\n\n.mdi-network-strength-3::before {\n  content: \"\\F08F8\";\n}\n\n.mdi-network-strength-3-alert::before {\n  content: \"\\F08F9\";\n}\n\n.mdi-network-strength-4::before {\n  content: \"\\F08FA\";\n}\n\n.mdi-network-strength-4-alert::before {\n  content: \"\\F08FB\";\n}\n\n.mdi-network-strength-4-cog::before {\n  content: \"\\F191A\";\n}\n\n.mdi-network-strength-off::before {\n  content: \"\\F08FC\";\n}\n\n.mdi-network-strength-off-outline::before {\n  content: \"\\F08FD\";\n}\n\n.mdi-network-strength-outline::before {\n  content: \"\\F08FE\";\n}\n\n.mdi-new-box::before {\n  content: \"\\F0394\";\n}\n\n.mdi-newspaper::before {\n  content: \"\\F0395\";\n}\n\n.mdi-newspaper-check::before {\n  content: \"\\F1943\";\n}\n\n.mdi-newspaper-minus::before {\n  content: \"\\F0F0C\";\n}\n\n.mdi-newspaper-plus::before {\n  content: \"\\F0F0D\";\n}\n\n.mdi-newspaper-remove::before {\n  content: \"\\F1944\";\n}\n\n.mdi-newspaper-variant::before {\n  content: \"\\F1001\";\n}\n\n.mdi-newspaper-variant-multiple::before {\n  content: \"\\F1002\";\n}\n\n.mdi-newspaper-variant-multiple-outline::before {\n  content: \"\\F1003\";\n}\n\n.mdi-newspaper-variant-outline::before {\n  content: \"\\F1004\";\n}\n\n.mdi-nfc::before {\n  content: \"\\F0396\";\n}\n\n.mdi-nfc-search-variant::before {\n  content: \"\\F0E53\";\n}\n\n.mdi-nfc-tap::before {\n  content: \"\\F0397\";\n}\n\n.mdi-nfc-variant::before {\n  content: \"\\F0398\";\n}\n\n.mdi-nfc-variant-off::before {\n  content: \"\\F0E54\";\n}\n\n.mdi-ninja::before {\n  content: \"\\F0774\";\n}\n\n.mdi-nintendo-game-boy::before {\n  content: \"\\F1393\";\n}\n\n.mdi-nintendo-switch::before {\n  content: \"\\F07E1\";\n}\n\n.mdi-nintendo-wii::before {\n  content: \"\\F05AB\";\n}\n\n.mdi-nintendo-wiiu::before {\n  content: \"\\F072D\";\n}\n\n.mdi-nix::before {\n  content: \"\\F1105\";\n}\n\n.mdi-nodejs::before {\n  content: \"\\F0399\";\n}\n\n.mdi-noodles::before {\n  content: \"\\F117E\";\n}\n\n.mdi-not-equal::before {\n  content: \"\\F098D\";\n}\n\n.mdi-not-equal-variant::before {\n  content: \"\\F098E\";\n}\n\n.mdi-note::before {\n  content: \"\\F039A\";\n}\n\n.mdi-note-alert::before {\n  content: \"\\F177D\";\n}\n\n.mdi-note-alert-outline::before {\n  content: \"\\F177E\";\n}\n\n.mdi-note-check::before {\n  content: \"\\F177F\";\n}\n\n.mdi-note-check-outline::before {\n  content: \"\\F1780\";\n}\n\n.mdi-note-edit::before {\n  content: \"\\F1781\";\n}\n\n.mdi-note-edit-outline::before {\n  content: \"\\F1782\";\n}\n\n.mdi-note-minus::before {\n  content: \"\\F164F\";\n}\n\n.mdi-note-minus-outline::before {\n  content: \"\\F1650\";\n}\n\n.mdi-note-multiple::before {\n  content: \"\\F06B8\";\n}\n\n.mdi-note-multiple-outline::before {\n  content: \"\\F06B9\";\n}\n\n.mdi-note-off::before {\n  content: \"\\F1783\";\n}\n\n.mdi-note-off-outline::before {\n  content: \"\\F1784\";\n}\n\n.mdi-note-outline::before {\n  content: \"\\F039B\";\n}\n\n.mdi-note-plus::before {\n  content: \"\\F039C\";\n}\n\n.mdi-note-plus-outline::before {\n  content: \"\\F039D\";\n}\n\n.mdi-note-remove::before {\n  content: \"\\F1651\";\n}\n\n.mdi-note-remove-outline::before {\n  content: \"\\F1652\";\n}\n\n.mdi-note-search::before {\n  content: \"\\F1653\";\n}\n\n.mdi-note-search-outline::before {\n  content: \"\\F1654\";\n}\n\n.mdi-note-text::before {\n  content: \"\\F039E\";\n}\n\n.mdi-note-text-outline::before {\n  content: \"\\F11D7\";\n}\n\n.mdi-notebook::before {\n  content: \"\\F082E\";\n}\n\n.mdi-notebook-check::before {\n  content: \"\\F14F5\";\n}\n\n.mdi-notebook-check-outline::before {\n  content: \"\\F14F6\";\n}\n\n.mdi-notebook-edit::before {\n  content: \"\\F14E7\";\n}\n\n.mdi-notebook-edit-outline::before {\n  content: \"\\F14E9\";\n}\n\n.mdi-notebook-minus::before {\n  content: \"\\F1610\";\n}\n\n.mdi-notebook-minus-outline::before {\n  content: \"\\F1611\";\n}\n\n.mdi-notebook-multiple::before {\n  content: \"\\F0E55\";\n}\n\n.mdi-notebook-outline::before {\n  content: \"\\F0EBF\";\n}\n\n.mdi-notebook-plus::before {\n  content: \"\\F1612\";\n}\n\n.mdi-notebook-plus-outline::before {\n  content: \"\\F1613\";\n}\n\n.mdi-notebook-remove::before {\n  content: \"\\F1614\";\n}\n\n.mdi-notebook-remove-outline::before {\n  content: \"\\F1615\";\n}\n\n.mdi-notification-clear-all::before {\n  content: \"\\F039F\";\n}\n\n.mdi-npm::before {\n  content: \"\\F06F7\";\n}\n\n.mdi-nuke::before {\n  content: \"\\F06A4\";\n}\n\n.mdi-null::before {\n  content: \"\\F07E2\";\n}\n\n.mdi-numeric::before {\n  content: \"\\F03A0\";\n}\n\n.mdi-numeric-0::before {\n  content: \"\\F0B39\";\n}\n\n.mdi-numeric-0-box::before {\n  content: \"\\F03A1\";\n}\n\n.mdi-numeric-0-box-multiple::before {\n  content: \"\\F0F0E\";\n}\n\n.mdi-numeric-0-box-multiple-outline::before {\n  content: \"\\F03A2\";\n}\n\n.mdi-numeric-0-box-outline::before {\n  content: \"\\F03A3\";\n}\n\n.mdi-numeric-0-circle::before {\n  content: \"\\F0C9E\";\n}\n\n.mdi-numeric-0-circle-outline::before {\n  content: \"\\F0C9F\";\n}\n\n.mdi-numeric-1::before {\n  content: \"\\F0B3A\";\n}\n\n.mdi-numeric-1-box::before {\n  content: \"\\F03A4\";\n}\n\n.mdi-numeric-1-box-multiple::before {\n  content: \"\\F0F0F\";\n}\n\n.mdi-numeric-1-box-multiple-outline::before {\n  content: \"\\F03A5\";\n}\n\n.mdi-numeric-1-box-outline::before {\n  content: \"\\F03A6\";\n}\n\n.mdi-numeric-1-circle::before {\n  content: \"\\F0CA0\";\n}\n\n.mdi-numeric-1-circle-outline::before {\n  content: \"\\F0CA1\";\n}\n\n.mdi-numeric-10::before {\n  content: \"\\F0FE9\";\n}\n\n.mdi-numeric-10-box::before {\n  content: \"\\F0F7D\";\n}\n\n.mdi-numeric-10-box-multiple::before {\n  content: \"\\F0FEA\";\n}\n\n.mdi-numeric-10-box-multiple-outline::before {\n  content: \"\\F0FEB\";\n}\n\n.mdi-numeric-10-box-outline::before {\n  content: \"\\F0F7E\";\n}\n\n.mdi-numeric-10-circle::before {\n  content: \"\\F0FEC\";\n}\n\n.mdi-numeric-10-circle-outline::before {\n  content: \"\\F0FED\";\n}\n\n.mdi-numeric-2::before {\n  content: \"\\F0B3B\";\n}\n\n.mdi-numeric-2-box::before {\n  content: \"\\F03A7\";\n}\n\n.mdi-numeric-2-box-multiple::before {\n  content: \"\\F0F10\";\n}\n\n.mdi-numeric-2-box-multiple-outline::before {\n  content: \"\\F03A8\";\n}\n\n.mdi-numeric-2-box-outline::before {\n  content: \"\\F03A9\";\n}\n\n.mdi-numeric-2-circle::before {\n  content: \"\\F0CA2\";\n}\n\n.mdi-numeric-2-circle-outline::before {\n  content: \"\\F0CA3\";\n}\n\n.mdi-numeric-3::before {\n  content: \"\\F0B3C\";\n}\n\n.mdi-numeric-3-box::before {\n  content: \"\\F03AA\";\n}\n\n.mdi-numeric-3-box-multiple::before {\n  content: \"\\F0F11\";\n}\n\n.mdi-numeric-3-box-multiple-outline::before {\n  content: \"\\F03AB\";\n}\n\n.mdi-numeric-3-box-outline::before {\n  content: \"\\F03AC\";\n}\n\n.mdi-numeric-3-circle::before {\n  content: \"\\F0CA4\";\n}\n\n.mdi-numeric-3-circle-outline::before {\n  content: \"\\F0CA5\";\n}\n\n.mdi-numeric-4::before {\n  content: \"\\F0B3D\";\n}\n\n.mdi-numeric-4-box::before {\n  content: \"\\F03AD\";\n}\n\n.mdi-numeric-4-box-multiple::before {\n  content: \"\\F0F12\";\n}\n\n.mdi-numeric-4-box-multiple-outline::before {\n  content: \"\\F03B2\";\n}\n\n.mdi-numeric-4-box-outline::before {\n  content: \"\\F03AE\";\n}\n\n.mdi-numeric-4-circle::before {\n  content: \"\\F0CA6\";\n}\n\n.mdi-numeric-4-circle-outline::before {\n  content: \"\\F0CA7\";\n}\n\n.mdi-numeric-5::before {\n  content: \"\\F0B3E\";\n}\n\n.mdi-numeric-5-box::before {\n  content: \"\\F03B1\";\n}\n\n.mdi-numeric-5-box-multiple::before {\n  content: \"\\F0F13\";\n}\n\n.mdi-numeric-5-box-multiple-outline::before {\n  content: \"\\F03AF\";\n}\n\n.mdi-numeric-5-box-outline::before {\n  content: \"\\F03B0\";\n}\n\n.mdi-numeric-5-circle::before {\n  content: \"\\F0CA8\";\n}\n\n.mdi-numeric-5-circle-outline::before {\n  content: \"\\F0CA9\";\n}\n\n.mdi-numeric-6::before {\n  content: \"\\F0B3F\";\n}\n\n.mdi-numeric-6-box::before {\n  content: \"\\F03B3\";\n}\n\n.mdi-numeric-6-box-multiple::before {\n  content: \"\\F0F14\";\n}\n\n.mdi-numeric-6-box-multiple-outline::before {\n  content: \"\\F03B4\";\n}\n\n.mdi-numeric-6-box-outline::before {\n  content: \"\\F03B5\";\n}\n\n.mdi-numeric-6-circle::before {\n  content: \"\\F0CAA\";\n}\n\n.mdi-numeric-6-circle-outline::before {\n  content: \"\\F0CAB\";\n}\n\n.mdi-numeric-7::before {\n  content: \"\\F0B40\";\n}\n\n.mdi-numeric-7-box::before {\n  content: \"\\F03B6\";\n}\n\n.mdi-numeric-7-box-multiple::before {\n  content: \"\\F0F15\";\n}\n\n.mdi-numeric-7-box-multiple-outline::before {\n  content: \"\\F03B7\";\n}\n\n.mdi-numeric-7-box-outline::before {\n  content: \"\\F03B8\";\n}\n\n.mdi-numeric-7-circle::before {\n  content: \"\\F0CAC\";\n}\n\n.mdi-numeric-7-circle-outline::before {\n  content: \"\\F0CAD\";\n}\n\n.mdi-numeric-8::before {\n  content: \"\\F0B41\";\n}\n\n.mdi-numeric-8-box::before {\n  content: \"\\F03B9\";\n}\n\n.mdi-numeric-8-box-multiple::before {\n  content: \"\\F0F16\";\n}\n\n.mdi-numeric-8-box-multiple-outline::before {\n  content: \"\\F03BA\";\n}\n\n.mdi-numeric-8-box-outline::before {\n  content: \"\\F03BB\";\n}\n\n.mdi-numeric-8-circle::before {\n  content: \"\\F0CAE\";\n}\n\n.mdi-numeric-8-circle-outline::before {\n  content: \"\\F0CAF\";\n}\n\n.mdi-numeric-9::before {\n  content: \"\\F0B42\";\n}\n\n.mdi-numeric-9-box::before {\n  content: \"\\F03BC\";\n}\n\n.mdi-numeric-9-box-multiple::before {\n  content: \"\\F0F17\";\n}\n\n.mdi-numeric-9-box-multiple-outline::before {\n  content: \"\\F03BD\";\n}\n\n.mdi-numeric-9-box-outline::before {\n  content: \"\\F03BE\";\n}\n\n.mdi-numeric-9-circle::before {\n  content: \"\\F0CB0\";\n}\n\n.mdi-numeric-9-circle-outline::before {\n  content: \"\\F0CB1\";\n}\n\n.mdi-numeric-9-plus::before {\n  content: \"\\F0FEE\";\n}\n\n.mdi-numeric-9-plus-box::before {\n  content: \"\\F03BF\";\n}\n\n.mdi-numeric-9-plus-box-multiple::before {\n  content: \"\\F0F18\";\n}\n\n.mdi-numeric-9-plus-box-multiple-outline::before {\n  content: \"\\F03C0\";\n}\n\n.mdi-numeric-9-plus-box-outline::before {\n  content: \"\\F03C1\";\n}\n\n.mdi-numeric-9-plus-circle::before {\n  content: \"\\F0CB2\";\n}\n\n.mdi-numeric-9-plus-circle-outline::before {\n  content: \"\\F0CB3\";\n}\n\n.mdi-numeric-negative-1::before {\n  content: \"\\F1052\";\n}\n\n.mdi-numeric-positive-1::before {\n  content: \"\\F15CB\";\n}\n\n.mdi-nut::before {\n  content: \"\\F06F8\";\n}\n\n.mdi-nutrition::before {\n  content: \"\\F03C2\";\n}\n\n.mdi-nuxt::before {\n  content: \"\\F1106\";\n}\n\n.mdi-oar::before {\n  content: \"\\F067C\";\n}\n\n.mdi-ocarina::before {\n  content: \"\\F0DE0\";\n}\n\n.mdi-oci::before {\n  content: \"\\F12E9\";\n}\n\n.mdi-ocr::before {\n  content: \"\\F113A\";\n}\n\n.mdi-octagon::before {\n  content: \"\\F03C3\";\n}\n\n.mdi-octagon-outline::before {\n  content: \"\\F03C4\";\n}\n\n.mdi-octagram::before {\n  content: \"\\F06F9\";\n}\n\n.mdi-octagram-outline::before {\n  content: \"\\F0775\";\n}\n\n.mdi-octahedron::before {\n  content: \"\\F1950\";\n}\n\n.mdi-octahedron-off::before {\n  content: \"\\F1951\";\n}\n\n.mdi-odnoklassniki::before {\n  content: \"\\F03C5\";\n}\n\n.mdi-offer::before {\n  content: \"\\F121B\";\n}\n\n.mdi-office-building::before {\n  content: \"\\F0991\";\n}\n\n.mdi-office-building-cog::before {\n  content: \"\\F1949\";\n}\n\n.mdi-office-building-cog-outline::before {\n  content: \"\\F194A\";\n}\n\n.mdi-office-building-marker::before {\n  content: \"\\F1520\";\n}\n\n.mdi-office-building-marker-outline::before {\n  content: \"\\F1521\";\n}\n\n.mdi-office-building-outline::before {\n  content: \"\\F151F\";\n}\n\n.mdi-oil::before {\n  content: \"\\F03C7\";\n}\n\n.mdi-oil-lamp::before {\n  content: \"\\F0F19\";\n}\n\n.mdi-oil-level::before {\n  content: \"\\F1053\";\n}\n\n.mdi-oil-temperature::before {\n  content: \"\\F0FF8\";\n}\n\n.mdi-om::before {\n  content: \"\\F0973\";\n}\n\n.mdi-omega::before {\n  content: \"\\F03C9\";\n}\n\n.mdi-one-up::before {\n  content: \"\\F0BAD\";\n}\n\n.mdi-onepassword::before {\n  content: \"\\F0881\";\n}\n\n.mdi-opacity::before {\n  content: \"\\F05CC\";\n}\n\n.mdi-open-in-app::before {\n  content: \"\\F03CB\";\n}\n\n.mdi-open-in-new::before {\n  content: \"\\F03CC\";\n}\n\n.mdi-open-source-initiative::before {\n  content: \"\\F0BAE\";\n}\n\n.mdi-openid::before {\n  content: \"\\F03CD\";\n}\n\n.mdi-opera::before {\n  content: \"\\F03CE\";\n}\n\n.mdi-orbit::before {\n  content: \"\\F0018\";\n}\n\n.mdi-orbit-variant::before {\n  content: \"\\F15DB\";\n}\n\n.mdi-order-alphabetical-ascending::before {\n  content: \"\\F020D\";\n}\n\n.mdi-order-alphabetical-descending::before {\n  content: \"\\F0D07\";\n}\n\n.mdi-order-bool-ascending::before {\n  content: \"\\F02BE\";\n}\n\n.mdi-order-bool-ascending-variant::before {\n  content: \"\\F098F\";\n}\n\n.mdi-order-bool-descending::before {\n  content: \"\\F1384\";\n}\n\n.mdi-order-bool-descending-variant::before {\n  content: \"\\F0990\";\n}\n\n.mdi-order-numeric-ascending::before {\n  content: \"\\F0545\";\n}\n\n.mdi-order-numeric-descending::before {\n  content: \"\\F0546\";\n}\n\n.mdi-origin::before {\n  content: \"\\F0B43\";\n}\n\n.mdi-ornament::before {\n  content: \"\\F03CF\";\n}\n\n.mdi-ornament-variant::before {\n  content: \"\\F03D0\";\n}\n\n.mdi-outdoor-lamp::before {\n  content: \"\\F1054\";\n}\n\n.mdi-overscan::before {\n  content: \"\\F1005\";\n}\n\n.mdi-owl::before {\n  content: \"\\F03D2\";\n}\n\n.mdi-pac-man::before {\n  content: \"\\F0BAF\";\n}\n\n.mdi-package::before {\n  content: \"\\F03D3\";\n}\n\n.mdi-package-down::before {\n  content: \"\\F03D4\";\n}\n\n.mdi-package-up::before {\n  content: \"\\F03D5\";\n}\n\n.mdi-package-variant::before {\n  content: \"\\F03D6\";\n}\n\n.mdi-package-variant-closed::before {\n  content: \"\\F03D7\";\n}\n\n.mdi-page-first::before {\n  content: \"\\F0600\";\n}\n\n.mdi-page-last::before {\n  content: \"\\F0601\";\n}\n\n.mdi-page-layout-body::before {\n  content: \"\\F06FA\";\n}\n\n.mdi-page-layout-footer::before {\n  content: \"\\F06FB\";\n}\n\n.mdi-page-layout-header::before {\n  content: \"\\F06FC\";\n}\n\n.mdi-page-layout-header-footer::before {\n  content: \"\\F0F7F\";\n}\n\n.mdi-page-layout-sidebar-left::before {\n  content: \"\\F06FD\";\n}\n\n.mdi-page-layout-sidebar-right::before {\n  content: \"\\F06FE\";\n}\n\n.mdi-page-next::before {\n  content: \"\\F0BB0\";\n}\n\n.mdi-page-next-outline::before {\n  content: \"\\F0BB1\";\n}\n\n.mdi-page-previous::before {\n  content: \"\\F0BB2\";\n}\n\n.mdi-page-previous-outline::before {\n  content: \"\\F0BB3\";\n}\n\n.mdi-pail::before {\n  content: \"\\F1417\";\n}\n\n.mdi-pail-minus::before {\n  content: \"\\F1437\";\n}\n\n.mdi-pail-minus-outline::before {\n  content: \"\\F143C\";\n}\n\n.mdi-pail-off::before {\n  content: \"\\F1439\";\n}\n\n.mdi-pail-off-outline::before {\n  content: \"\\F143E\";\n}\n\n.mdi-pail-outline::before {\n  content: \"\\F143A\";\n}\n\n.mdi-pail-plus::before {\n  content: \"\\F1436\";\n}\n\n.mdi-pail-plus-outline::before {\n  content: \"\\F143B\";\n}\n\n.mdi-pail-remove::before {\n  content: \"\\F1438\";\n}\n\n.mdi-pail-remove-outline::before {\n  content: \"\\F143D\";\n}\n\n.mdi-palette::before {\n  content: \"\\F03D8\";\n}\n\n.mdi-palette-advanced::before {\n  content: \"\\F03D9\";\n}\n\n.mdi-palette-outline::before {\n  content: \"\\F0E0C\";\n}\n\n.mdi-palette-swatch::before {\n  content: \"\\F08B5\";\n}\n\n.mdi-palette-swatch-outline::before {\n  content: \"\\F135C\";\n}\n\n.mdi-palette-swatch-variant::before {\n  content: \"\\F195A\";\n}\n\n.mdi-palm-tree::before {\n  content: \"\\F1055\";\n}\n\n.mdi-pan::before {\n  content: \"\\F0BB4\";\n}\n\n.mdi-pan-bottom-left::before {\n  content: \"\\F0BB5\";\n}\n\n.mdi-pan-bottom-right::before {\n  content: \"\\F0BB6\";\n}\n\n.mdi-pan-down::before {\n  content: \"\\F0BB7\";\n}\n\n.mdi-pan-horizontal::before {\n  content: \"\\F0BB8\";\n}\n\n.mdi-pan-left::before {\n  content: \"\\F0BB9\";\n}\n\n.mdi-pan-right::before {\n  content: \"\\F0BBA\";\n}\n\n.mdi-pan-top-left::before {\n  content: \"\\F0BBB\";\n}\n\n.mdi-pan-top-right::before {\n  content: \"\\F0BBC\";\n}\n\n.mdi-pan-up::before {\n  content: \"\\F0BBD\";\n}\n\n.mdi-pan-vertical::before {\n  content: \"\\F0BBE\";\n}\n\n.mdi-panda::before {\n  content: \"\\F03DA\";\n}\n\n.mdi-pandora::before {\n  content: \"\\F03DB\";\n}\n\n.mdi-panorama::before {\n  content: \"\\F03DC\";\n}\n\n.mdi-panorama-fisheye::before {\n  content: \"\\F03DD\";\n}\n\n.mdi-panorama-horizontal::before {\n  content: \"\\F1928\";\n}\n\n.mdi-panorama-horizontal-outline::before {\n  content: \"\\F03DE\";\n}\n\n.mdi-panorama-outline::before {\n  content: \"\\F198C\";\n}\n\n.mdi-panorama-sphere::before {\n  content: \"\\F198D\";\n}\n\n.mdi-panorama-sphere-outline::before {\n  content: \"\\F198E\";\n}\n\n.mdi-panorama-variant::before {\n  content: \"\\F198F\";\n}\n\n.mdi-panorama-variant-outline::before {\n  content: \"\\F1990\";\n}\n\n.mdi-panorama-vertical::before {\n  content: \"\\F1929\";\n}\n\n.mdi-panorama-vertical-outline::before {\n  content: \"\\F03DF\";\n}\n\n.mdi-panorama-wide-angle::before {\n  content: \"\\F195F\";\n}\n\n.mdi-panorama-wide-angle-outline::before {\n  content: \"\\F03E0\";\n}\n\n.mdi-paper-cut-vertical::before {\n  content: \"\\F03E1\";\n}\n\n.mdi-paper-roll::before {\n  content: \"\\F1157\";\n}\n\n.mdi-paper-roll-outline::before {\n  content: \"\\F1158\";\n}\n\n.mdi-paperclip::before {\n  content: \"\\F03E2\";\n}\n\n.mdi-parachute::before {\n  content: \"\\F0CB4\";\n}\n\n.mdi-parachute-outline::before {\n  content: \"\\F0CB5\";\n}\n\n.mdi-paragliding::before {\n  content: \"\\F1745\";\n}\n\n.mdi-parking::before {\n  content: \"\\F03E3\";\n}\n\n.mdi-party-popper::before {\n  content: \"\\F1056\";\n}\n\n.mdi-passport::before {\n  content: \"\\F07E3\";\n}\n\n.mdi-passport-biometric::before {\n  content: \"\\F0DE1\";\n}\n\n.mdi-pasta::before {\n  content: \"\\F1160\";\n}\n\n.mdi-patio-heater::before {\n  content: \"\\F0F80\";\n}\n\n.mdi-patreon::before {\n  content: \"\\F0882\";\n}\n\n.mdi-pause::before {\n  content: \"\\F03E4\";\n}\n\n.mdi-pause-circle::before {\n  content: \"\\F03E5\";\n}\n\n.mdi-pause-circle-outline::before {\n  content: \"\\F03E6\";\n}\n\n.mdi-pause-octagon::before {\n  content: \"\\F03E7\";\n}\n\n.mdi-pause-octagon-outline::before {\n  content: \"\\F03E8\";\n}\n\n.mdi-paw::before {\n  content: \"\\F03E9\";\n}\n\n.mdi-paw-off::before {\n  content: \"\\F0657\";\n}\n\n.mdi-paw-off-outline::before {\n  content: \"\\F1676\";\n}\n\n.mdi-paw-outline::before {\n  content: \"\\F1675\";\n}\n\n.mdi-peace::before {\n  content: \"\\F0884\";\n}\n\n.mdi-peanut::before {\n  content: \"\\F0FFC\";\n}\n\n.mdi-peanut-off::before {\n  content: \"\\F0FFD\";\n}\n\n.mdi-peanut-off-outline::before {\n  content: \"\\F0FFF\";\n}\n\n.mdi-peanut-outline::before {\n  content: \"\\F0FFE\";\n}\n\n.mdi-pen::before {\n  content: \"\\F03EA\";\n}\n\n.mdi-pen-lock::before {\n  content: \"\\F0DE2\";\n}\n\n.mdi-pen-minus::before {\n  content: \"\\F0DE3\";\n}\n\n.mdi-pen-off::before {\n  content: \"\\F0DE4\";\n}\n\n.mdi-pen-plus::before {\n  content: \"\\F0DE5\";\n}\n\n.mdi-pen-remove::before {\n  content: \"\\F0DE6\";\n}\n\n.mdi-pencil::before {\n  content: \"\\F03EB\";\n}\n\n.mdi-pencil-box::before {\n  content: \"\\F03EC\";\n}\n\n.mdi-pencil-box-multiple::before {\n  content: \"\\F1144\";\n}\n\n.mdi-pencil-box-multiple-outline::before {\n  content: \"\\F1145\";\n}\n\n.mdi-pencil-box-outline::before {\n  content: \"\\F03ED\";\n}\n\n.mdi-pencil-circle::before {\n  content: \"\\F06FF\";\n}\n\n.mdi-pencil-circle-outline::before {\n  content: \"\\F0776\";\n}\n\n.mdi-pencil-lock::before {\n  content: \"\\F03EE\";\n}\n\n.mdi-pencil-lock-outline::before {\n  content: \"\\F0DE7\";\n}\n\n.mdi-pencil-minus::before {\n  content: \"\\F0DE8\";\n}\n\n.mdi-pencil-minus-outline::before {\n  content: \"\\F0DE9\";\n}\n\n.mdi-pencil-off::before {\n  content: \"\\F03EF\";\n}\n\n.mdi-pencil-off-outline::before {\n  content: \"\\F0DEA\";\n}\n\n.mdi-pencil-outline::before {\n  content: \"\\F0CB6\";\n}\n\n.mdi-pencil-plus::before {\n  content: \"\\F0DEB\";\n}\n\n.mdi-pencil-plus-outline::before {\n  content: \"\\F0DEC\";\n}\n\n.mdi-pencil-remove::before {\n  content: \"\\F0DED\";\n}\n\n.mdi-pencil-remove-outline::before {\n  content: \"\\F0DEE\";\n}\n\n.mdi-pencil-ruler::before {\n  content: \"\\F1353\";\n}\n\n.mdi-penguin::before {\n  content: \"\\F0EC0\";\n}\n\n.mdi-pentagon::before {\n  content: \"\\F0701\";\n}\n\n.mdi-pentagon-outline::before {\n  content: \"\\F0700\";\n}\n\n.mdi-pentagram::before {\n  content: \"\\F1667\";\n}\n\n.mdi-percent::before {\n  content: \"\\F03F0\";\n}\n\n.mdi-percent-outline::before {\n  content: \"\\F1278\";\n}\n\n.mdi-periodic-table::before {\n  content: \"\\F08B6\";\n}\n\n.mdi-perspective-less::before {\n  content: \"\\F0D23\";\n}\n\n.mdi-perspective-more::before {\n  content: \"\\F0D24\";\n}\n\n.mdi-ph::before {\n  content: \"\\F17C5\";\n}\n\n.mdi-phone::before {\n  content: \"\\F03F2\";\n}\n\n.mdi-phone-alert::before {\n  content: \"\\F0F1A\";\n}\n\n.mdi-phone-alert-outline::before {\n  content: \"\\F118E\";\n}\n\n.mdi-phone-bluetooth::before {\n  content: \"\\F03F3\";\n}\n\n.mdi-phone-bluetooth-outline::before {\n  content: \"\\F118F\";\n}\n\n.mdi-phone-cancel::before {\n  content: \"\\F10BC\";\n}\n\n.mdi-phone-cancel-outline::before {\n  content: \"\\F1190\";\n}\n\n.mdi-phone-check::before {\n  content: \"\\F11A9\";\n}\n\n.mdi-phone-check-outline::before {\n  content: \"\\F11AA\";\n}\n\n.mdi-phone-classic::before {\n  content: \"\\F0602\";\n}\n\n.mdi-phone-classic-off::before {\n  content: \"\\F1279\";\n}\n\n.mdi-phone-dial::before {\n  content: \"\\F1559\";\n}\n\n.mdi-phone-dial-outline::before {\n  content: \"\\F155A\";\n}\n\n.mdi-phone-forward::before {\n  content: \"\\F03F4\";\n}\n\n.mdi-phone-forward-outline::before {\n  content: \"\\F1191\";\n}\n\n.mdi-phone-hangup::before {\n  content: \"\\F03F5\";\n}\n\n.mdi-phone-hangup-outline::before {\n  content: \"\\F1192\";\n}\n\n.mdi-phone-in-talk::before {\n  content: \"\\F03F6\";\n}\n\n.mdi-phone-in-talk-outline::before {\n  content: \"\\F1182\";\n}\n\n.mdi-phone-incoming::before {\n  content: \"\\F03F7\";\n}\n\n.mdi-phone-incoming-outline::before {\n  content: \"\\F1193\";\n}\n\n.mdi-phone-lock::before {\n  content: \"\\F03F8\";\n}\n\n.mdi-phone-lock-outline::before {\n  content: \"\\F1194\";\n}\n\n.mdi-phone-log::before {\n  content: \"\\F03F9\";\n}\n\n.mdi-phone-log-outline::before {\n  content: \"\\F1195\";\n}\n\n.mdi-phone-message::before {\n  content: \"\\F1196\";\n}\n\n.mdi-phone-message-outline::before {\n  content: \"\\F1197\";\n}\n\n.mdi-phone-minus::before {\n  content: \"\\F0658\";\n}\n\n.mdi-phone-minus-outline::before {\n  content: \"\\F1198\";\n}\n\n.mdi-phone-missed::before {\n  content: \"\\F03FA\";\n}\n\n.mdi-phone-missed-outline::before {\n  content: \"\\F11A5\";\n}\n\n.mdi-phone-off::before {\n  content: \"\\F0DEF\";\n}\n\n.mdi-phone-off-outline::before {\n  content: \"\\F11A6\";\n}\n\n.mdi-phone-outgoing::before {\n  content: \"\\F03FB\";\n}\n\n.mdi-phone-outgoing-outline::before {\n  content: \"\\F1199\";\n}\n\n.mdi-phone-outline::before {\n  content: \"\\F0DF0\";\n}\n\n.mdi-phone-paused::before {\n  content: \"\\F03FC\";\n}\n\n.mdi-phone-paused-outline::before {\n  content: \"\\F119A\";\n}\n\n.mdi-phone-plus::before {\n  content: \"\\F0659\";\n}\n\n.mdi-phone-plus-outline::before {\n  content: \"\\F119B\";\n}\n\n.mdi-phone-refresh::before {\n  content: \"\\F1993\";\n}\n\n.mdi-phone-refresh-outline::before {\n  content: \"\\F1994\";\n}\n\n.mdi-phone-remove::before {\n  content: \"\\F152F\";\n}\n\n.mdi-phone-remove-outline::before {\n  content: \"\\F1530\";\n}\n\n.mdi-phone-return::before {\n  content: \"\\F082F\";\n}\n\n.mdi-phone-return-outline::before {\n  content: \"\\F119C\";\n}\n\n.mdi-phone-ring::before {\n  content: \"\\F11AB\";\n}\n\n.mdi-phone-ring-outline::before {\n  content: \"\\F11AC\";\n}\n\n.mdi-phone-rotate-landscape::before {\n  content: \"\\F0885\";\n}\n\n.mdi-phone-rotate-portrait::before {\n  content: \"\\F0886\";\n}\n\n.mdi-phone-settings::before {\n  content: \"\\F03FD\";\n}\n\n.mdi-phone-settings-outline::before {\n  content: \"\\F119D\";\n}\n\n.mdi-phone-sync::before {\n  content: \"\\F1995\";\n}\n\n.mdi-phone-sync-outline::before {\n  content: \"\\F1996\";\n}\n\n.mdi-phone-voip::before {\n  content: \"\\F03FE\";\n}\n\n.mdi-pi::before {\n  content: \"\\F03FF\";\n}\n\n.mdi-pi-box::before {\n  content: \"\\F0400\";\n}\n\n.mdi-pi-hole::before {\n  content: \"\\F0DF1\";\n}\n\n.mdi-piano::before {\n  content: \"\\F067D\";\n}\n\n.mdi-piano-off::before {\n  content: \"\\F0698\";\n}\n\n.mdi-pickaxe::before {\n  content: \"\\F08B7\";\n}\n\n.mdi-picture-in-picture-bottom-right::before {\n  content: \"\\F0E57\";\n}\n\n.mdi-picture-in-picture-bottom-right-outline::before {\n  content: \"\\F0E58\";\n}\n\n.mdi-picture-in-picture-top-right::before {\n  content: \"\\F0E59\";\n}\n\n.mdi-picture-in-picture-top-right-outline::before {\n  content: \"\\F0E5A\";\n}\n\n.mdi-pier::before {\n  content: \"\\F0887\";\n}\n\n.mdi-pier-crane::before {\n  content: \"\\F0888\";\n}\n\n.mdi-pig::before {\n  content: \"\\F0401\";\n}\n\n.mdi-pig-variant::before {\n  content: \"\\F1006\";\n}\n\n.mdi-pig-variant-outline::before {\n  content: \"\\F1678\";\n}\n\n.mdi-piggy-bank::before {\n  content: \"\\F1007\";\n}\n\n.mdi-piggy-bank-outline::before {\n  content: \"\\F1679\";\n}\n\n.mdi-pill::before {\n  content: \"\\F0402\";\n}\n\n.mdi-pillar::before {\n  content: \"\\F0702\";\n}\n\n.mdi-pin::before {\n  content: \"\\F0403\";\n}\n\n.mdi-pin-off::before {\n  content: \"\\F0404\";\n}\n\n.mdi-pin-off-outline::before {\n  content: \"\\F0930\";\n}\n\n.mdi-pin-outline::before {\n  content: \"\\F0931\";\n}\n\n.mdi-pine-tree::before {\n  content: \"\\F0405\";\n}\n\n.mdi-pine-tree-box::before {\n  content: \"\\F0406\";\n}\n\n.mdi-pine-tree-fire::before {\n  content: \"\\F141A\";\n}\n\n.mdi-pinterest::before {\n  content: \"\\F0407\";\n}\n\n.mdi-pinwheel::before {\n  content: \"\\F0AD5\";\n}\n\n.mdi-pinwheel-outline::before {\n  content: \"\\F0AD6\";\n}\n\n.mdi-pipe::before {\n  content: \"\\F07E5\";\n}\n\n.mdi-pipe-disconnected::before {\n  content: \"\\F07E6\";\n}\n\n.mdi-pipe-leak::before {\n  content: \"\\F0889\";\n}\n\n.mdi-pipe-valve::before {\n  content: \"\\F184D\";\n}\n\n.mdi-pipe-wrench::before {\n  content: \"\\F1354\";\n}\n\n.mdi-pirate::before {\n  content: \"\\F0A08\";\n}\n\n.mdi-pistol::before {\n  content: \"\\F0703\";\n}\n\n.mdi-piston::before {\n  content: \"\\F088A\";\n}\n\n.mdi-pitchfork::before {\n  content: \"\\F1553\";\n}\n\n.mdi-pizza::before {\n  content: \"\\F0409\";\n}\n\n.mdi-play::before {\n  content: \"\\F040A\";\n}\n\n.mdi-play-box::before {\n  content: \"\\F127A\";\n}\n\n.mdi-play-box-multiple::before {\n  content: \"\\F0D19\";\n}\n\n.mdi-play-box-multiple-outline::before {\n  content: \"\\F13E6\";\n}\n\n.mdi-play-box-outline::before {\n  content: \"\\F040B\";\n}\n\n.mdi-play-circle::before {\n  content: \"\\F040C\";\n}\n\n.mdi-play-circle-outline::before {\n  content: \"\\F040D\";\n}\n\n.mdi-play-network::before {\n  content: \"\\F088B\";\n}\n\n.mdi-play-network-outline::before {\n  content: \"\\F0CB7\";\n}\n\n.mdi-play-outline::before {\n  content: \"\\F0F1B\";\n}\n\n.mdi-play-pause::before {\n  content: \"\\F040E\";\n}\n\n.mdi-play-protected-content::before {\n  content: \"\\F040F\";\n}\n\n.mdi-play-speed::before {\n  content: \"\\F08FF\";\n}\n\n.mdi-playlist-check::before {\n  content: \"\\F05C7\";\n}\n\n.mdi-playlist-edit::before {\n  content: \"\\F0900\";\n}\n\n.mdi-playlist-minus::before {\n  content: \"\\F0410\";\n}\n\n.mdi-playlist-music::before {\n  content: \"\\F0CB8\";\n}\n\n.mdi-playlist-music-outline::before {\n  content: \"\\F0CB9\";\n}\n\n.mdi-playlist-play::before {\n  content: \"\\F0411\";\n}\n\n.mdi-playlist-plus::before {\n  content: \"\\F0412\";\n}\n\n.mdi-playlist-remove::before {\n  content: \"\\F0413\";\n}\n\n.mdi-playlist-star::before {\n  content: \"\\F0DF2\";\n}\n\n.mdi-plex::before {\n  content: \"\\F06BA\";\n}\n\n.mdi-pliers::before {\n  content: \"\\F19A4\";\n}\n\n.mdi-plus::before {\n  content: \"\\F0415\";\n}\n\n.mdi-plus-box::before {\n  content: \"\\F0416\";\n}\n\n.mdi-plus-box-multiple::before {\n  content: \"\\F0334\";\n}\n\n.mdi-plus-box-multiple-outline::before {\n  content: \"\\F1143\";\n}\n\n.mdi-plus-box-outline::before {\n  content: \"\\F0704\";\n}\n\n.mdi-plus-circle::before {\n  content: \"\\F0417\";\n}\n\n.mdi-plus-circle-multiple::before {\n  content: \"\\F034C\";\n}\n\n.mdi-plus-circle-multiple-outline::before {\n  content: \"\\F0418\";\n}\n\n.mdi-plus-circle-outline::before {\n  content: \"\\F0419\";\n}\n\n.mdi-plus-minus::before {\n  content: \"\\F0992\";\n}\n\n.mdi-plus-minus-box::before {\n  content: \"\\F0993\";\n}\n\n.mdi-plus-minus-variant::before {\n  content: \"\\F14C9\";\n}\n\n.mdi-plus-network::before {\n  content: \"\\F041A\";\n}\n\n.mdi-plus-network-outline::before {\n  content: \"\\F0CBA\";\n}\n\n.mdi-plus-outline::before {\n  content: \"\\F0705\";\n}\n\n.mdi-plus-thick::before {\n  content: \"\\F11EC\";\n}\n\n.mdi-podcast::before {\n  content: \"\\F0994\";\n}\n\n.mdi-podium::before {\n  content: \"\\F0D25\";\n}\n\n.mdi-podium-bronze::before {\n  content: \"\\F0D26\";\n}\n\n.mdi-podium-gold::before {\n  content: \"\\F0D27\";\n}\n\n.mdi-podium-silver::before {\n  content: \"\\F0D28\";\n}\n\n.mdi-point-of-sale::before {\n  content: \"\\F0D92\";\n}\n\n.mdi-pokeball::before {\n  content: \"\\F041D\";\n}\n\n.mdi-pokemon-go::before {\n  content: \"\\F0A09\";\n}\n\n.mdi-poker-chip::before {\n  content: \"\\F0830\";\n}\n\n.mdi-polaroid::before {\n  content: \"\\F041E\";\n}\n\n.mdi-police-badge::before {\n  content: \"\\F1167\";\n}\n\n.mdi-police-badge-outline::before {\n  content: \"\\F1168\";\n}\n\n.mdi-police-station::before {\n  content: \"\\F1839\";\n}\n\n.mdi-poll::before {\n  content: \"\\F041F\";\n}\n\n.mdi-polo::before {\n  content: \"\\F14C3\";\n}\n\n.mdi-polymer::before {\n  content: \"\\F0421\";\n}\n\n.mdi-pool::before {\n  content: \"\\F0606\";\n}\n\n.mdi-popcorn::before {\n  content: \"\\F0422\";\n}\n\n.mdi-post::before {\n  content: \"\\F1008\";\n}\n\n.mdi-post-outline::before {\n  content: \"\\F1009\";\n}\n\n.mdi-postage-stamp::before {\n  content: \"\\F0CBB\";\n}\n\n.mdi-pot::before {\n  content: \"\\F02E5\";\n}\n\n.mdi-pot-mix::before {\n  content: \"\\F065B\";\n}\n\n.mdi-pot-mix-outline::before {\n  content: \"\\F0677\";\n}\n\n.mdi-pot-outline::before {\n  content: \"\\F02FF\";\n}\n\n.mdi-pot-steam::before {\n  content: \"\\F065A\";\n}\n\n.mdi-pot-steam-outline::before {\n  content: \"\\F0326\";\n}\n\n.mdi-pound::before {\n  content: \"\\F0423\";\n}\n\n.mdi-pound-box::before {\n  content: \"\\F0424\";\n}\n\n.mdi-pound-box-outline::before {\n  content: \"\\F117F\";\n}\n\n.mdi-power::before {\n  content: \"\\F0425\";\n}\n\n.mdi-power-cycle::before {\n  content: \"\\F0901\";\n}\n\n.mdi-power-off::before {\n  content: \"\\F0902\";\n}\n\n.mdi-power-on::before {\n  content: \"\\F0903\";\n}\n\n.mdi-power-plug::before {\n  content: \"\\F06A5\";\n}\n\n.mdi-power-plug-off::before {\n  content: \"\\F06A6\";\n}\n\n.mdi-power-plug-off-outline::before {\n  content: \"\\F1424\";\n}\n\n.mdi-power-plug-outline::before {\n  content: \"\\F1425\";\n}\n\n.mdi-power-settings::before {\n  content: \"\\F0426\";\n}\n\n.mdi-power-sleep::before {\n  content: \"\\F0904\";\n}\n\n.mdi-power-socket::before {\n  content: \"\\F0427\";\n}\n\n.mdi-power-socket-au::before {\n  content: \"\\F0905\";\n}\n\n.mdi-power-socket-ch::before {\n  content: \"\\F0FB3\";\n}\n\n.mdi-power-socket-de::before {\n  content: \"\\F1107\";\n}\n\n.mdi-power-socket-eu::before {\n  content: \"\\F07E7\";\n}\n\n.mdi-power-socket-fr::before {\n  content: \"\\F1108\";\n}\n\n.mdi-power-socket-it::before {\n  content: \"\\F14FF\";\n}\n\n.mdi-power-socket-jp::before {\n  content: \"\\F1109\";\n}\n\n.mdi-power-socket-uk::before {\n  content: \"\\F07E8\";\n}\n\n.mdi-power-socket-us::before {\n  content: \"\\F07E9\";\n}\n\n.mdi-power-standby::before {\n  content: \"\\F0906\";\n}\n\n.mdi-powershell::before {\n  content: \"\\F0A0A\";\n}\n\n.mdi-prescription::before {\n  content: \"\\F0706\";\n}\n\n.mdi-presentation::before {\n  content: \"\\F0428\";\n}\n\n.mdi-presentation-play::before {\n  content: \"\\F0429\";\n}\n\n.mdi-pretzel::before {\n  content: \"\\F1562\";\n}\n\n.mdi-printer::before {\n  content: \"\\F042A\";\n}\n\n.mdi-printer-3d::before {\n  content: \"\\F042B\";\n}\n\n.mdi-printer-3d-nozzle::before {\n  content: \"\\F0E5B\";\n}\n\n.mdi-printer-3d-nozzle-alert::before {\n  content: \"\\F11C0\";\n}\n\n.mdi-printer-3d-nozzle-alert-outline::before {\n  content: \"\\F11C1\";\n}\n\n.mdi-printer-3d-nozzle-heat::before {\n  content: \"\\F18B8\";\n}\n\n.mdi-printer-3d-nozzle-heat-outline::before {\n  content: \"\\F18B9\";\n}\n\n.mdi-printer-3d-nozzle-outline::before {\n  content: \"\\F0E5C\";\n}\n\n.mdi-printer-alert::before {\n  content: \"\\F042C\";\n}\n\n.mdi-printer-check::before {\n  content: \"\\F1146\";\n}\n\n.mdi-printer-eye::before {\n  content: \"\\F1458\";\n}\n\n.mdi-printer-off::before {\n  content: \"\\F0E5D\";\n}\n\n.mdi-printer-off-outline::before {\n  content: \"\\F1785\";\n}\n\n.mdi-printer-outline::before {\n  content: \"\\F1786\";\n}\n\n.mdi-printer-pos::before {\n  content: \"\\F1057\";\n}\n\n.mdi-printer-search::before {\n  content: \"\\F1457\";\n}\n\n.mdi-printer-settings::before {\n  content: \"\\F0707\";\n}\n\n.mdi-printer-wireless::before {\n  content: \"\\F0A0B\";\n}\n\n.mdi-priority-high::before {\n  content: \"\\F0603\";\n}\n\n.mdi-priority-low::before {\n  content: \"\\F0604\";\n}\n\n.mdi-professional-hexagon::before {\n  content: \"\\F042D\";\n}\n\n.mdi-progress-alert::before {\n  content: \"\\F0CBC\";\n}\n\n.mdi-progress-check::before {\n  content: \"\\F0995\";\n}\n\n.mdi-progress-clock::before {\n  content: \"\\F0996\";\n}\n\n.mdi-progress-close::before {\n  content: \"\\F110A\";\n}\n\n.mdi-progress-download::before {\n  content: \"\\F0997\";\n}\n\n.mdi-progress-pencil::before {\n  content: \"\\F1787\";\n}\n\n.mdi-progress-question::before {\n  content: \"\\F1522\";\n}\n\n.mdi-progress-star::before {\n  content: \"\\F1788\";\n}\n\n.mdi-progress-upload::before {\n  content: \"\\F0998\";\n}\n\n.mdi-progress-wrench::before {\n  content: \"\\F0CBD\";\n}\n\n.mdi-projector::before {\n  content: \"\\F042E\";\n}\n\n.mdi-projector-screen::before {\n  content: \"\\F042F\";\n}\n\n.mdi-projector-screen-off::before {\n  content: \"\\F180D\";\n}\n\n.mdi-projector-screen-off-outline::before {\n  content: \"\\F180E\";\n}\n\n.mdi-projector-screen-outline::before {\n  content: \"\\F1724\";\n}\n\n.mdi-projector-screen-variant::before {\n  content: \"\\F180F\";\n}\n\n.mdi-projector-screen-variant-off::before {\n  content: \"\\F1810\";\n}\n\n.mdi-projector-screen-variant-off-outline::before {\n  content: \"\\F1811\";\n}\n\n.mdi-projector-screen-variant-outline::before {\n  content: \"\\F1812\";\n}\n\n.mdi-propane-tank::before {\n  content: \"\\F1357\";\n}\n\n.mdi-propane-tank-outline::before {\n  content: \"\\F1358\";\n}\n\n.mdi-protocol::before {\n  content: \"\\F0FD8\";\n}\n\n.mdi-publish::before {\n  content: \"\\F06A7\";\n}\n\n.mdi-publish-off::before {\n  content: \"\\F1945\";\n}\n\n.mdi-pulse::before {\n  content: \"\\F0430\";\n}\n\n.mdi-pump::before {\n  content: \"\\F1402\";\n}\n\n.mdi-pumpkin::before {\n  content: \"\\F0BBF\";\n}\n\n.mdi-purse::before {\n  content: \"\\F0F1C\";\n}\n\n.mdi-purse-outline::before {\n  content: \"\\F0F1D\";\n}\n\n.mdi-puzzle::before {\n  content: \"\\F0431\";\n}\n\n.mdi-puzzle-check::before {\n  content: \"\\F1426\";\n}\n\n.mdi-puzzle-check-outline::before {\n  content: \"\\F1427\";\n}\n\n.mdi-puzzle-edit::before {\n  content: \"\\F14D3\";\n}\n\n.mdi-puzzle-edit-outline::before {\n  content: \"\\F14D9\";\n}\n\n.mdi-puzzle-heart::before {\n  content: \"\\F14D4\";\n}\n\n.mdi-puzzle-heart-outline::before {\n  content: \"\\F14DA\";\n}\n\n.mdi-puzzle-minus::before {\n  content: \"\\F14D1\";\n}\n\n.mdi-puzzle-minus-outline::before {\n  content: \"\\F14D7\";\n}\n\n.mdi-puzzle-outline::before {\n  content: \"\\F0A66\";\n}\n\n.mdi-puzzle-plus::before {\n  content: \"\\F14D0\";\n}\n\n.mdi-puzzle-plus-outline::before {\n  content: \"\\F14D6\";\n}\n\n.mdi-puzzle-remove::before {\n  content: \"\\F14D2\";\n}\n\n.mdi-puzzle-remove-outline::before {\n  content: \"\\F14D8\";\n}\n\n.mdi-puzzle-star::before {\n  content: \"\\F14D5\";\n}\n\n.mdi-puzzle-star-outline::before {\n  content: \"\\F14DB\";\n}\n\n.mdi-pyramid::before {\n  content: \"\\F1952\";\n}\n\n.mdi-pyramid-off::before {\n  content: \"\\F1953\";\n}\n\n.mdi-qi::before {\n  content: \"\\F0999\";\n}\n\n.mdi-qqchat::before {\n  content: \"\\F0605\";\n}\n\n.mdi-qrcode::before {\n  content: \"\\F0432\";\n}\n\n.mdi-qrcode-edit::before {\n  content: \"\\F08B8\";\n}\n\n.mdi-qrcode-minus::before {\n  content: \"\\F118C\";\n}\n\n.mdi-qrcode-plus::before {\n  content: \"\\F118B\";\n}\n\n.mdi-qrcode-remove::before {\n  content: \"\\F118D\";\n}\n\n.mdi-qrcode-scan::before {\n  content: \"\\F0433\";\n}\n\n.mdi-quadcopter::before {\n  content: \"\\F0434\";\n}\n\n.mdi-quality-high::before {\n  content: \"\\F0435\";\n}\n\n.mdi-quality-low::before {\n  content: \"\\F0A0C\";\n}\n\n.mdi-quality-medium::before {\n  content: \"\\F0A0D\";\n}\n\n.mdi-quora::before {\n  content: \"\\F0D29\";\n}\n\n.mdi-rabbit::before {\n  content: \"\\F0907\";\n}\n\n.mdi-racing-helmet::before {\n  content: \"\\F0D93\";\n}\n\n.mdi-racquetball::before {\n  content: \"\\F0D94\";\n}\n\n.mdi-radar::before {\n  content: \"\\F0437\";\n}\n\n.mdi-radiator::before {\n  content: \"\\F0438\";\n}\n\n.mdi-radiator-disabled::before {\n  content: \"\\F0AD7\";\n}\n\n.mdi-radiator-off::before {\n  content: \"\\F0AD8\";\n}\n\n.mdi-radio::before {\n  content: \"\\F0439\";\n}\n\n.mdi-radio-am::before {\n  content: \"\\F0CBE\";\n}\n\n.mdi-radio-fm::before {\n  content: \"\\F0CBF\";\n}\n\n.mdi-radio-handheld::before {\n  content: \"\\F043A\";\n}\n\n.mdi-radio-off::before {\n  content: \"\\F121C\";\n}\n\n.mdi-radio-tower::before {\n  content: \"\\F043B\";\n}\n\n.mdi-radioactive::before {\n  content: \"\\F043C\";\n}\n\n.mdi-radioactive-circle::before {\n  content: \"\\F185D\";\n}\n\n.mdi-radioactive-circle-outline::before {\n  content: \"\\F185E\";\n}\n\n.mdi-radioactive-off::before {\n  content: \"\\F0EC1\";\n}\n\n.mdi-radiobox-blank::before {\n  content: \"\\F043D\";\n}\n\n.mdi-radiobox-marked::before {\n  content: \"\\F043E\";\n}\n\n.mdi-radiology-box::before {\n  content: \"\\F14C5\";\n}\n\n.mdi-radiology-box-outline::before {\n  content: \"\\F14C6\";\n}\n\n.mdi-radius::before {\n  content: \"\\F0CC0\";\n}\n\n.mdi-radius-outline::before {\n  content: \"\\F0CC1\";\n}\n\n.mdi-railroad-light::before {\n  content: \"\\F0F1E\";\n}\n\n.mdi-rake::before {\n  content: \"\\F1544\";\n}\n\n.mdi-raspberry-pi::before {\n  content: \"\\F043F\";\n}\n\n.mdi-ray-end::before {\n  content: \"\\F0440\";\n}\n\n.mdi-ray-end-arrow::before {\n  content: \"\\F0441\";\n}\n\n.mdi-ray-start::before {\n  content: \"\\F0442\";\n}\n\n.mdi-ray-start-arrow::before {\n  content: \"\\F0443\";\n}\n\n.mdi-ray-start-end::before {\n  content: \"\\F0444\";\n}\n\n.mdi-ray-start-vertex-end::before {\n  content: \"\\F15D8\";\n}\n\n.mdi-ray-vertex::before {\n  content: \"\\F0445\";\n}\n\n.mdi-razor-double-edge::before {\n  content: \"\\F1997\";\n}\n\n.mdi-razor-single-edge::before {\n  content: \"\\F1998\";\n}\n\n.mdi-react::before {\n  content: \"\\F0708\";\n}\n\n.mdi-read::before {\n  content: \"\\F0447\";\n}\n\n.mdi-receipt::before {\n  content: \"\\F0449\";\n}\n\n.mdi-record::before {\n  content: \"\\F044A\";\n}\n\n.mdi-record-circle::before {\n  content: \"\\F0EC2\";\n}\n\n.mdi-record-circle-outline::before {\n  content: \"\\F0EC3\";\n}\n\n.mdi-record-player::before {\n  content: \"\\F099A\";\n}\n\n.mdi-record-rec::before {\n  content: \"\\F044B\";\n}\n\n.mdi-rectangle::before {\n  content: \"\\F0E5E\";\n}\n\n.mdi-rectangle-outline::before {\n  content: \"\\F0E5F\";\n}\n\n.mdi-recycle::before {\n  content: \"\\F044C\";\n}\n\n.mdi-recycle-variant::before {\n  content: \"\\F139D\";\n}\n\n.mdi-reddit::before {\n  content: \"\\F044D\";\n}\n\n.mdi-redhat::before {\n  content: \"\\F111B\";\n}\n\n.mdi-redo::before {\n  content: \"\\F044E\";\n}\n\n.mdi-redo-variant::before {\n  content: \"\\F044F\";\n}\n\n.mdi-reflect-horizontal::before {\n  content: \"\\F0A0E\";\n}\n\n.mdi-reflect-vertical::before {\n  content: \"\\F0A0F\";\n}\n\n.mdi-refresh::before {\n  content: \"\\F0450\";\n}\n\n.mdi-refresh-auto::before {\n  content: \"\\F18F2\";\n}\n\n.mdi-refresh-circle::before {\n  content: \"\\F1377\";\n}\n\n.mdi-regex::before {\n  content: \"\\F0451\";\n}\n\n.mdi-registered-trademark::before {\n  content: \"\\F0A67\";\n}\n\n.mdi-reiterate::before {\n  content: \"\\F1588\";\n}\n\n.mdi-relation-many-to-many::before {\n  content: \"\\F1496\";\n}\n\n.mdi-relation-many-to-one::before {\n  content: \"\\F1497\";\n}\n\n.mdi-relation-many-to-one-or-many::before {\n  content: \"\\F1498\";\n}\n\n.mdi-relation-many-to-only-one::before {\n  content: \"\\F1499\";\n}\n\n.mdi-relation-many-to-zero-or-many::before {\n  content: \"\\F149A\";\n}\n\n.mdi-relation-many-to-zero-or-one::before {\n  content: \"\\F149B\";\n}\n\n.mdi-relation-one-or-many-to-many::before {\n  content: \"\\F149C\";\n}\n\n.mdi-relation-one-or-many-to-one::before {\n  content: \"\\F149D\";\n}\n\n.mdi-relation-one-or-many-to-one-or-many::before {\n  content: \"\\F149E\";\n}\n\n.mdi-relation-one-or-many-to-only-one::before {\n  content: \"\\F149F\";\n}\n\n.mdi-relation-one-or-many-to-zero-or-many::before {\n  content: \"\\F14A0\";\n}\n\n.mdi-relation-one-or-many-to-zero-or-one::before {\n  content: \"\\F14A1\";\n}\n\n.mdi-relation-one-to-many::before {\n  content: \"\\F14A2\";\n}\n\n.mdi-relation-one-to-one::before {\n  content: \"\\F14A3\";\n}\n\n.mdi-relation-one-to-one-or-many::before {\n  content: \"\\F14A4\";\n}\n\n.mdi-relation-one-to-only-one::before {\n  content: \"\\F14A5\";\n}\n\n.mdi-relation-one-to-zero-or-many::before {\n  content: \"\\F14A6\";\n}\n\n.mdi-relation-one-to-zero-or-one::before {\n  content: \"\\F14A7\";\n}\n\n.mdi-relation-only-one-to-many::before {\n  content: \"\\F14A8\";\n}\n\n.mdi-relation-only-one-to-one::before {\n  content: \"\\F14A9\";\n}\n\n.mdi-relation-only-one-to-one-or-many::before {\n  content: \"\\F14AA\";\n}\n\n.mdi-relation-only-one-to-only-one::before {\n  content: \"\\F14AB\";\n}\n\n.mdi-relation-only-one-to-zero-or-many::before {\n  content: \"\\F14AC\";\n}\n\n.mdi-relation-only-one-to-zero-or-one::before {\n  content: \"\\F14AD\";\n}\n\n.mdi-relation-zero-or-many-to-many::before {\n  content: \"\\F14AE\";\n}\n\n.mdi-relation-zero-or-many-to-one::before {\n  content: \"\\F14AF\";\n}\n\n.mdi-relation-zero-or-many-to-one-or-many::before {\n  content: \"\\F14B0\";\n}\n\n.mdi-relation-zero-or-many-to-only-one::before {\n  content: \"\\F14B1\";\n}\n\n.mdi-relation-zero-or-many-to-zero-or-many::before {\n  content: \"\\F14B2\";\n}\n\n.mdi-relation-zero-or-many-to-zero-or-one::before {\n  content: \"\\F14B3\";\n}\n\n.mdi-relation-zero-or-one-to-many::before {\n  content: \"\\F14B4\";\n}\n\n.mdi-relation-zero-or-one-to-one::before {\n  content: \"\\F14B5\";\n}\n\n.mdi-relation-zero-or-one-to-one-or-many::before {\n  content: \"\\F14B6\";\n}\n\n.mdi-relation-zero-or-one-to-only-one::before {\n  content: \"\\F14B7\";\n}\n\n.mdi-relation-zero-or-one-to-zero-or-many::before {\n  content: \"\\F14B8\";\n}\n\n.mdi-relation-zero-or-one-to-zero-or-one::before {\n  content: \"\\F14B9\";\n}\n\n.mdi-relative-scale::before {\n  content: \"\\F0452\";\n}\n\n.mdi-reload::before {\n  content: \"\\F0453\";\n}\n\n.mdi-reload-alert::before {\n  content: \"\\F110B\";\n}\n\n.mdi-reminder::before {\n  content: \"\\F088C\";\n}\n\n.mdi-remote::before {\n  content: \"\\F0454\";\n}\n\n.mdi-remote-desktop::before {\n  content: \"\\F08B9\";\n}\n\n.mdi-remote-off::before {\n  content: \"\\F0EC4\";\n}\n\n.mdi-remote-tv::before {\n  content: \"\\F0EC5\";\n}\n\n.mdi-remote-tv-off::before {\n  content: \"\\F0EC6\";\n}\n\n.mdi-rename-box::before {\n  content: \"\\F0455\";\n}\n\n.mdi-reorder-horizontal::before {\n  content: \"\\F0688\";\n}\n\n.mdi-reorder-vertical::before {\n  content: \"\\F0689\";\n}\n\n.mdi-repeat::before {\n  content: \"\\F0456\";\n}\n\n.mdi-repeat-off::before {\n  content: \"\\F0457\";\n}\n\n.mdi-repeat-once::before {\n  content: \"\\F0458\";\n}\n\n.mdi-repeat-variant::before {\n  content: \"\\F0547\";\n}\n\n.mdi-replay::before {\n  content: \"\\F0459\";\n}\n\n.mdi-reply::before {\n  content: \"\\F045A\";\n}\n\n.mdi-reply-all::before {\n  content: \"\\F045B\";\n}\n\n.mdi-reply-all-outline::before {\n  content: \"\\F0F1F\";\n}\n\n.mdi-reply-circle::before {\n  content: \"\\F11AE\";\n}\n\n.mdi-reply-outline::before {\n  content: \"\\F0F20\";\n}\n\n.mdi-reproduction::before {\n  content: \"\\F045C\";\n}\n\n.mdi-resistor::before {\n  content: \"\\F0B44\";\n}\n\n.mdi-resistor-nodes::before {\n  content: \"\\F0B45\";\n}\n\n.mdi-resize::before {\n  content: \"\\F0A68\";\n}\n\n.mdi-resize-bottom-right::before {\n  content: \"\\F045D\";\n}\n\n.mdi-responsive::before {\n  content: \"\\F045E\";\n}\n\n.mdi-restart::before {\n  content: \"\\F0709\";\n}\n\n.mdi-restart-alert::before {\n  content: \"\\F110C\";\n}\n\n.mdi-restart-off::before {\n  content: \"\\F0D95\";\n}\n\n.mdi-restore::before {\n  content: \"\\F099B\";\n}\n\n.mdi-restore-alert::before {\n  content: \"\\F110D\";\n}\n\n.mdi-rewind::before {\n  content: \"\\F045F\";\n}\n\n.mdi-rewind-10::before {\n  content: \"\\F0D2A\";\n}\n\n.mdi-rewind-15::before {\n  content: \"\\F1946\";\n}\n\n.mdi-rewind-30::before {\n  content: \"\\F0D96\";\n}\n\n.mdi-rewind-5::before {\n  content: \"\\F11F9\";\n}\n\n.mdi-rewind-60::before {\n  content: \"\\F160C\";\n}\n\n.mdi-rewind-outline::before {\n  content: \"\\F070A\";\n}\n\n.mdi-rhombus::before {\n  content: \"\\F070B\";\n}\n\n.mdi-rhombus-medium::before {\n  content: \"\\F0A10\";\n}\n\n.mdi-rhombus-medium-outline::before {\n  content: \"\\F14DC\";\n}\n\n.mdi-rhombus-outline::before {\n  content: \"\\F070C\";\n}\n\n.mdi-rhombus-split::before {\n  content: \"\\F0A11\";\n}\n\n.mdi-rhombus-split-outline::before {\n  content: \"\\F14DD\";\n}\n\n.mdi-ribbon::before {\n  content: \"\\F0460\";\n}\n\n.mdi-rice::before {\n  content: \"\\F07EA\";\n}\n\n.mdi-rickshaw::before {\n  content: \"\\F15BB\";\n}\n\n.mdi-rickshaw-electric::before {\n  content: \"\\F15BC\";\n}\n\n.mdi-ring::before {\n  content: \"\\F07EB\";\n}\n\n.mdi-rivet::before {\n  content: \"\\F0E60\";\n}\n\n.mdi-road::before {\n  content: \"\\F0461\";\n}\n\n.mdi-road-variant::before {\n  content: \"\\F0462\";\n}\n\n.mdi-robber::before {\n  content: \"\\F1058\";\n}\n\n.mdi-robot::before {\n  content: \"\\F06A9\";\n}\n\n.mdi-robot-angry::before {\n  content: \"\\F169D\";\n}\n\n.mdi-robot-angry-outline::before {\n  content: \"\\F169E\";\n}\n\n.mdi-robot-confused::before {\n  content: \"\\F169F\";\n}\n\n.mdi-robot-confused-outline::before {\n  content: \"\\F16A0\";\n}\n\n.mdi-robot-dead::before {\n  content: \"\\F16A1\";\n}\n\n.mdi-robot-dead-outline::before {\n  content: \"\\F16A2\";\n}\n\n.mdi-robot-excited::before {\n  content: \"\\F16A3\";\n}\n\n.mdi-robot-excited-outline::before {\n  content: \"\\F16A4\";\n}\n\n.mdi-robot-happy::before {\n  content: \"\\F1719\";\n}\n\n.mdi-robot-happy-outline::before {\n  content: \"\\F171A\";\n}\n\n.mdi-robot-industrial::before {\n  content: \"\\F0B46\";\n}\n\n.mdi-robot-love::before {\n  content: \"\\F16A5\";\n}\n\n.mdi-robot-love-outline::before {\n  content: \"\\F16A6\";\n}\n\n.mdi-robot-mower::before {\n  content: \"\\F11F7\";\n}\n\n.mdi-robot-mower-outline::before {\n  content: \"\\F11F3\";\n}\n\n.mdi-robot-off::before {\n  content: \"\\F16A7\";\n}\n\n.mdi-robot-off-outline::before {\n  content: \"\\F167B\";\n}\n\n.mdi-robot-outline::before {\n  content: \"\\F167A\";\n}\n\n.mdi-robot-vacuum::before {\n  content: \"\\F070D\";\n}\n\n.mdi-robot-vacuum-variant::before {\n  content: \"\\F0908\";\n}\n\n.mdi-rocket::before {\n  content: \"\\F0463\";\n}\n\n.mdi-rocket-launch::before {\n  content: \"\\F14DE\";\n}\n\n.mdi-rocket-launch-outline::before {\n  content: \"\\F14DF\";\n}\n\n.mdi-rocket-outline::before {\n  content: \"\\F13AF\";\n}\n\n.mdi-rodent::before {\n  content: \"\\F1327\";\n}\n\n.mdi-roller-skate::before {\n  content: \"\\F0D2B\";\n}\n\n.mdi-roller-skate-off::before {\n  content: \"\\F0145\";\n}\n\n.mdi-rollerblade::before {\n  content: \"\\F0D2C\";\n}\n\n.mdi-rollerblade-off::before {\n  content: \"\\F002E\";\n}\n\n.mdi-rollupjs::before {\n  content: \"\\F0BC0\";\n}\n\n.mdi-roman-numeral-1::before {\n  content: \"\\F1088\";\n}\n\n.mdi-roman-numeral-10::before {\n  content: \"\\F1091\";\n}\n\n.mdi-roman-numeral-2::before {\n  content: \"\\F1089\";\n}\n\n.mdi-roman-numeral-3::before {\n  content: \"\\F108A\";\n}\n\n.mdi-roman-numeral-4::before {\n  content: \"\\F108B\";\n}\n\n.mdi-roman-numeral-5::before {\n  content: \"\\F108C\";\n}\n\n.mdi-roman-numeral-6::before {\n  content: \"\\F108D\";\n}\n\n.mdi-roman-numeral-7::before {\n  content: \"\\F108E\";\n}\n\n.mdi-roman-numeral-8::before {\n  content: \"\\F108F\";\n}\n\n.mdi-roman-numeral-9::before {\n  content: \"\\F1090\";\n}\n\n.mdi-room-service::before {\n  content: \"\\F088D\";\n}\n\n.mdi-room-service-outline::before {\n  content: \"\\F0D97\";\n}\n\n.mdi-rotate-360::before {\n  content: \"\\F1999\";\n}\n\n.mdi-rotate-3d::before {\n  content: \"\\F0EC7\";\n}\n\n.mdi-rotate-3d-variant::before {\n  content: \"\\F0464\";\n}\n\n.mdi-rotate-left::before {\n  content: \"\\F0465\";\n}\n\n.mdi-rotate-left-variant::before {\n  content: \"\\F0466\";\n}\n\n.mdi-rotate-orbit::before {\n  content: \"\\F0D98\";\n}\n\n.mdi-rotate-right::before {\n  content: \"\\F0467\";\n}\n\n.mdi-rotate-right-variant::before {\n  content: \"\\F0468\";\n}\n\n.mdi-rounded-corner::before {\n  content: \"\\F0607\";\n}\n\n.mdi-router::before {\n  content: \"\\F11E2\";\n}\n\n.mdi-router-network::before {\n  content: \"\\F1087\";\n}\n\n.mdi-router-wireless::before {\n  content: \"\\F0469\";\n}\n\n.mdi-router-wireless-off::before {\n  content: \"\\F15A3\";\n}\n\n.mdi-router-wireless-settings::before {\n  content: \"\\F0A69\";\n}\n\n.mdi-routes::before {\n  content: \"\\F046A\";\n}\n\n.mdi-routes-clock::before {\n  content: \"\\F1059\";\n}\n\n.mdi-rowing::before {\n  content: \"\\F0608\";\n}\n\n.mdi-rss::before {\n  content: \"\\F046B\";\n}\n\n.mdi-rss-box::before {\n  content: \"\\F046C\";\n}\n\n.mdi-rss-off::before {\n  content: \"\\F0F21\";\n}\n\n.mdi-rug::before {\n  content: \"\\F1475\";\n}\n\n.mdi-rugby::before {\n  content: \"\\F0D99\";\n}\n\n.mdi-ruler::before {\n  content: \"\\F046D\";\n}\n\n.mdi-ruler-square::before {\n  content: \"\\F0CC2\";\n}\n\n.mdi-ruler-square-compass::before {\n  content: \"\\F0EBE\";\n}\n\n.mdi-run::before {\n  content: \"\\F070E\";\n}\n\n.mdi-run-fast::before {\n  content: \"\\F046E\";\n}\n\n.mdi-rv-truck::before {\n  content: \"\\F11D4\";\n}\n\n.mdi-sack::before {\n  content: \"\\F0D2E\";\n}\n\n.mdi-sack-percent::before {\n  content: \"\\F0D2F\";\n}\n\n.mdi-safe::before {\n  content: \"\\F0A6A\";\n}\n\n.mdi-safe-square::before {\n  content: \"\\F127C\";\n}\n\n.mdi-safe-square-outline::before {\n  content: \"\\F127D\";\n}\n\n.mdi-safety-goggles::before {\n  content: \"\\F0D30\";\n}\n\n.mdi-sail-boat::before {\n  content: \"\\F0EC8\";\n}\n\n.mdi-sale::before {\n  content: \"\\F046F\";\n}\n\n.mdi-salesforce::before {\n  content: \"\\F088E\";\n}\n\n.mdi-sass::before {\n  content: \"\\F07EC\";\n}\n\n.mdi-satellite::before {\n  content: \"\\F0470\";\n}\n\n.mdi-satellite-uplink::before {\n  content: \"\\F0909\";\n}\n\n.mdi-satellite-variant::before {\n  content: \"\\F0471\";\n}\n\n.mdi-sausage::before {\n  content: \"\\F08BA\";\n}\n\n.mdi-sausage-off::before {\n  content: \"\\F1789\";\n}\n\n.mdi-saw-blade::before {\n  content: \"\\F0E61\";\n}\n\n.mdi-sawtooth-wave::before {\n  content: \"\\F147A\";\n}\n\n.mdi-saxophone::before {\n  content: \"\\F0609\";\n}\n\n.mdi-scale::before {\n  content: \"\\F0472\";\n}\n\n.mdi-scale-balance::before {\n  content: \"\\F05D1\";\n}\n\n.mdi-scale-bathroom::before {\n  content: \"\\F0473\";\n}\n\n.mdi-scale-off::before {\n  content: \"\\F105A\";\n}\n\n.mdi-scale-unbalanced::before {\n  content: \"\\F19B8\";\n}\n\n.mdi-scan-helper::before {\n  content: \"\\F13D8\";\n}\n\n.mdi-scanner::before {\n  content: \"\\F06AB\";\n}\n\n.mdi-scanner-off::before {\n  content: \"\\F090A\";\n}\n\n.mdi-scatter-plot::before {\n  content: \"\\F0EC9\";\n}\n\n.mdi-scatter-plot-outline::before {\n  content: \"\\F0ECA\";\n}\n\n.mdi-scent::before {\n  content: \"\\F1958\";\n}\n\n.mdi-scent-off::before {\n  content: \"\\F1959\";\n}\n\n.mdi-school::before {\n  content: \"\\F0474\";\n}\n\n.mdi-school-outline::before {\n  content: \"\\F1180\";\n}\n\n.mdi-scissors-cutting::before {\n  content: \"\\F0A6B\";\n}\n\n.mdi-scooter::before {\n  content: \"\\F15BD\";\n}\n\n.mdi-scooter-electric::before {\n  content: \"\\F15BE\";\n}\n\n.mdi-scoreboard::before {\n  content: \"\\F127E\";\n}\n\n.mdi-scoreboard-outline::before {\n  content: \"\\F127F\";\n}\n\n.mdi-screen-rotation::before {\n  content: \"\\F0475\";\n}\n\n.mdi-screen-rotation-lock::before {\n  content: \"\\F0478\";\n}\n\n.mdi-screw-flat-top::before {\n  content: \"\\F0DF3\";\n}\n\n.mdi-screw-lag::before {\n  content: \"\\F0DF4\";\n}\n\n.mdi-screw-machine-flat-top::before {\n  content: \"\\F0DF5\";\n}\n\n.mdi-screw-machine-round-top::before {\n  content: \"\\F0DF6\";\n}\n\n.mdi-screw-round-top::before {\n  content: \"\\F0DF7\";\n}\n\n.mdi-screwdriver::before {\n  content: \"\\F0476\";\n}\n\n.mdi-script::before {\n  content: \"\\F0BC1\";\n}\n\n.mdi-script-outline::before {\n  content: \"\\F0477\";\n}\n\n.mdi-script-text::before {\n  content: \"\\F0BC2\";\n}\n\n.mdi-script-text-key::before {\n  content: \"\\F1725\";\n}\n\n.mdi-script-text-key-outline::before {\n  content: \"\\F1726\";\n}\n\n.mdi-script-text-outline::before {\n  content: \"\\F0BC3\";\n}\n\n.mdi-script-text-play::before {\n  content: \"\\F1727\";\n}\n\n.mdi-script-text-play-outline::before {\n  content: \"\\F1728\";\n}\n\n.mdi-sd::before {\n  content: \"\\F0479\";\n}\n\n.mdi-seal::before {\n  content: \"\\F047A\";\n}\n\n.mdi-seal-variant::before {\n  content: \"\\F0FD9\";\n}\n\n.mdi-search-web::before {\n  content: \"\\F070F\";\n}\n\n.mdi-seat::before {\n  content: \"\\F0CC3\";\n}\n\n.mdi-seat-flat::before {\n  content: \"\\F047B\";\n}\n\n.mdi-seat-flat-angled::before {\n  content: \"\\F047C\";\n}\n\n.mdi-seat-individual-suite::before {\n  content: \"\\F047D\";\n}\n\n.mdi-seat-legroom-extra::before {\n  content: \"\\F047E\";\n}\n\n.mdi-seat-legroom-normal::before {\n  content: \"\\F047F\";\n}\n\n.mdi-seat-legroom-reduced::before {\n  content: \"\\F0480\";\n}\n\n.mdi-seat-outline::before {\n  content: \"\\F0CC4\";\n}\n\n.mdi-seat-passenger::before {\n  content: \"\\F1249\";\n}\n\n.mdi-seat-recline-extra::before {\n  content: \"\\F0481\";\n}\n\n.mdi-seat-recline-normal::before {\n  content: \"\\F0482\";\n}\n\n.mdi-seatbelt::before {\n  content: \"\\F0CC5\";\n}\n\n.mdi-security::before {\n  content: \"\\F0483\";\n}\n\n.mdi-security-network::before {\n  content: \"\\F0484\";\n}\n\n.mdi-seed::before {\n  content: \"\\F0E62\";\n}\n\n.mdi-seed-off::before {\n  content: \"\\F13FD\";\n}\n\n.mdi-seed-off-outline::before {\n  content: \"\\F13FE\";\n}\n\n.mdi-seed-outline::before {\n  content: \"\\F0E63\";\n}\n\n.mdi-seesaw::before {\n  content: \"\\F15A4\";\n}\n\n.mdi-segment::before {\n  content: \"\\F0ECB\";\n}\n\n.mdi-select::before {\n  content: \"\\F0485\";\n}\n\n.mdi-select-all::before {\n  content: \"\\F0486\";\n}\n\n.mdi-select-color::before {\n  content: \"\\F0D31\";\n}\n\n.mdi-select-compare::before {\n  content: \"\\F0AD9\";\n}\n\n.mdi-select-drag::before {\n  content: \"\\F0A6C\";\n}\n\n.mdi-select-group::before {\n  content: \"\\F0F82\";\n}\n\n.mdi-select-inverse::before {\n  content: \"\\F0487\";\n}\n\n.mdi-select-marker::before {\n  content: \"\\F1280\";\n}\n\n.mdi-select-multiple::before {\n  content: \"\\F1281\";\n}\n\n.mdi-select-multiple-marker::before {\n  content: \"\\F1282\";\n}\n\n.mdi-select-off::before {\n  content: \"\\F0488\";\n}\n\n.mdi-select-place::before {\n  content: \"\\F0FDA\";\n}\n\n.mdi-select-remove::before {\n  content: \"\\F17C1\";\n}\n\n.mdi-select-search::before {\n  content: \"\\F1204\";\n}\n\n.mdi-selection::before {\n  content: \"\\F0489\";\n}\n\n.mdi-selection-drag::before {\n  content: \"\\F0A6D\";\n}\n\n.mdi-selection-ellipse::before {\n  content: \"\\F0D32\";\n}\n\n.mdi-selection-ellipse-arrow-inside::before {\n  content: \"\\F0F22\";\n}\n\n.mdi-selection-ellipse-remove::before {\n  content: \"\\F17C2\";\n}\n\n.mdi-selection-marker::before {\n  content: \"\\F1283\";\n}\n\n.mdi-selection-multiple::before {\n  content: \"\\F1285\";\n}\n\n.mdi-selection-multiple-marker::before {\n  content: \"\\F1284\";\n}\n\n.mdi-selection-off::before {\n  content: \"\\F0777\";\n}\n\n.mdi-selection-remove::before {\n  content: \"\\F17C3\";\n}\n\n.mdi-selection-search::before {\n  content: \"\\F1205\";\n}\n\n.mdi-semantic-web::before {\n  content: \"\\F1316\";\n}\n\n.mdi-send::before {\n  content: \"\\F048A\";\n}\n\n.mdi-send-check::before {\n  content: \"\\F1161\";\n}\n\n.mdi-send-check-outline::before {\n  content: \"\\F1162\";\n}\n\n.mdi-send-circle::before {\n  content: \"\\F0DF8\";\n}\n\n.mdi-send-circle-outline::before {\n  content: \"\\F0DF9\";\n}\n\n.mdi-send-clock::before {\n  content: \"\\F1163\";\n}\n\n.mdi-send-clock-outline::before {\n  content: \"\\F1164\";\n}\n\n.mdi-send-lock::before {\n  content: \"\\F07ED\";\n}\n\n.mdi-send-lock-outline::before {\n  content: \"\\F1166\";\n}\n\n.mdi-send-outline::before {\n  content: \"\\F1165\";\n}\n\n.mdi-serial-port::before {\n  content: \"\\F065C\";\n}\n\n.mdi-server::before {\n  content: \"\\F048B\";\n}\n\n.mdi-server-minus::before {\n  content: \"\\F048C\";\n}\n\n.mdi-server-network::before {\n  content: \"\\F048D\";\n}\n\n.mdi-server-network-off::before {\n  content: \"\\F048E\";\n}\n\n.mdi-server-off::before {\n  content: \"\\F048F\";\n}\n\n.mdi-server-plus::before {\n  content: \"\\F0490\";\n}\n\n.mdi-server-remove::before {\n  content: \"\\F0491\";\n}\n\n.mdi-server-security::before {\n  content: \"\\F0492\";\n}\n\n.mdi-set-all::before {\n  content: \"\\F0778\";\n}\n\n.mdi-set-center::before {\n  content: \"\\F0779\";\n}\n\n.mdi-set-center-right::before {\n  content: \"\\F077A\";\n}\n\n.mdi-set-left::before {\n  content: \"\\F077B\";\n}\n\n.mdi-set-left-center::before {\n  content: \"\\F077C\";\n}\n\n.mdi-set-left-right::before {\n  content: \"\\F077D\";\n}\n\n.mdi-set-merge::before {\n  content: \"\\F14E0\";\n}\n\n.mdi-set-none::before {\n  content: \"\\F077E\";\n}\n\n.mdi-set-right::before {\n  content: \"\\F077F\";\n}\n\n.mdi-set-split::before {\n  content: \"\\F14E1\";\n}\n\n.mdi-set-square::before {\n  content: \"\\F145D\";\n}\n\n.mdi-set-top-box::before {\n  content: \"\\F099F\";\n}\n\n.mdi-settings-helper::before {\n  content: \"\\F0A6E\";\n}\n\n.mdi-shaker::before {\n  content: \"\\F110E\";\n}\n\n.mdi-shaker-outline::before {\n  content: \"\\F110F\";\n}\n\n.mdi-shape::before {\n  content: \"\\F0831\";\n}\n\n.mdi-shape-circle-plus::before {\n  content: \"\\F065D\";\n}\n\n.mdi-shape-outline::before {\n  content: \"\\F0832\";\n}\n\n.mdi-shape-oval-plus::before {\n  content: \"\\F11FA\";\n}\n\n.mdi-shape-plus::before {\n  content: \"\\F0495\";\n}\n\n.mdi-shape-polygon-plus::before {\n  content: \"\\F065E\";\n}\n\n.mdi-shape-rectangle-plus::before {\n  content: \"\\F065F\";\n}\n\n.mdi-shape-square-plus::before {\n  content: \"\\F0660\";\n}\n\n.mdi-shape-square-rounded-plus::before {\n  content: \"\\F14FA\";\n}\n\n.mdi-share::before {\n  content: \"\\F0496\";\n}\n\n.mdi-share-all::before {\n  content: \"\\F11F4\";\n}\n\n.mdi-share-all-outline::before {\n  content: \"\\F11F5\";\n}\n\n.mdi-share-circle::before {\n  content: \"\\F11AD\";\n}\n\n.mdi-share-off::before {\n  content: \"\\F0F23\";\n}\n\n.mdi-share-off-outline::before {\n  content: \"\\F0F24\";\n}\n\n.mdi-share-outline::before {\n  content: \"\\F0932\";\n}\n\n.mdi-share-variant::before {\n  content: \"\\F0497\";\n}\n\n.mdi-share-variant-outline::before {\n  content: \"\\F1514\";\n}\n\n.mdi-shark::before {\n  content: \"\\F18BA\";\n}\n\n.mdi-shark-fin::before {\n  content: \"\\F1673\";\n}\n\n.mdi-shark-fin-outline::before {\n  content: \"\\F1674\";\n}\n\n.mdi-shark-off::before {\n  content: \"\\F18BB\";\n}\n\n.mdi-sheep::before {\n  content: \"\\F0CC6\";\n}\n\n.mdi-shield::before {\n  content: \"\\F0498\";\n}\n\n.mdi-shield-account::before {\n  content: \"\\F088F\";\n}\n\n.mdi-shield-account-outline::before {\n  content: \"\\F0A12\";\n}\n\n.mdi-shield-account-variant::before {\n  content: \"\\F15A7\";\n}\n\n.mdi-shield-account-variant-outline::before {\n  content: \"\\F15A8\";\n}\n\n.mdi-shield-airplane::before {\n  content: \"\\F06BB\";\n}\n\n.mdi-shield-airplane-outline::before {\n  content: \"\\F0CC7\";\n}\n\n.mdi-shield-alert::before {\n  content: \"\\F0ECC\";\n}\n\n.mdi-shield-alert-outline::before {\n  content: \"\\F0ECD\";\n}\n\n.mdi-shield-bug::before {\n  content: \"\\F13DA\";\n}\n\n.mdi-shield-bug-outline::before {\n  content: \"\\F13DB\";\n}\n\n.mdi-shield-car::before {\n  content: \"\\F0F83\";\n}\n\n.mdi-shield-check::before {\n  content: \"\\F0565\";\n}\n\n.mdi-shield-check-outline::before {\n  content: \"\\F0CC8\";\n}\n\n.mdi-shield-cross::before {\n  content: \"\\F0CC9\";\n}\n\n.mdi-shield-cross-outline::before {\n  content: \"\\F0CCA\";\n}\n\n.mdi-shield-crown::before {\n  content: \"\\F18BC\";\n}\n\n.mdi-shield-crown-outline::before {\n  content: \"\\F18BD\";\n}\n\n.mdi-shield-edit::before {\n  content: \"\\F11A0\";\n}\n\n.mdi-shield-edit-outline::before {\n  content: \"\\F11A1\";\n}\n\n.mdi-shield-half::before {\n  content: \"\\F1360\";\n}\n\n.mdi-shield-half-full::before {\n  content: \"\\F0780\";\n}\n\n.mdi-shield-home::before {\n  content: \"\\F068A\";\n}\n\n.mdi-shield-home-outline::before {\n  content: \"\\F0CCB\";\n}\n\n.mdi-shield-key::before {\n  content: \"\\F0BC4\";\n}\n\n.mdi-shield-key-outline::before {\n  content: \"\\F0BC5\";\n}\n\n.mdi-shield-link-variant::before {\n  content: \"\\F0D33\";\n}\n\n.mdi-shield-link-variant-outline::before {\n  content: \"\\F0D34\";\n}\n\n.mdi-shield-lock::before {\n  content: \"\\F099D\";\n}\n\n.mdi-shield-lock-open::before {\n  content: \"\\F199A\";\n}\n\n.mdi-shield-lock-open-outline::before {\n  content: \"\\F199B\";\n}\n\n.mdi-shield-lock-outline::before {\n  content: \"\\F0CCC\";\n}\n\n.mdi-shield-moon::before {\n  content: \"\\F1828\";\n}\n\n.mdi-shield-moon-outline::before {\n  content: \"\\F1829\";\n}\n\n.mdi-shield-off::before {\n  content: \"\\F099E\";\n}\n\n.mdi-shield-off-outline::before {\n  content: \"\\F099C\";\n}\n\n.mdi-shield-outline::before {\n  content: \"\\F0499\";\n}\n\n.mdi-shield-plus::before {\n  content: \"\\F0ADA\";\n}\n\n.mdi-shield-plus-outline::before {\n  content: \"\\F0ADB\";\n}\n\n.mdi-shield-refresh::before {\n  content: \"\\F00AA\";\n}\n\n.mdi-shield-refresh-outline::before {\n  content: \"\\F01E0\";\n}\n\n.mdi-shield-remove::before {\n  content: \"\\F0ADC\";\n}\n\n.mdi-shield-remove-outline::before {\n  content: \"\\F0ADD\";\n}\n\n.mdi-shield-search::before {\n  content: \"\\F0D9A\";\n}\n\n.mdi-shield-star::before {\n  content: \"\\F113B\";\n}\n\n.mdi-shield-star-outline::before {\n  content: \"\\F113C\";\n}\n\n.mdi-shield-sun::before {\n  content: \"\\F105D\";\n}\n\n.mdi-shield-sun-outline::before {\n  content: \"\\F105E\";\n}\n\n.mdi-shield-sword::before {\n  content: \"\\F18BE\";\n}\n\n.mdi-shield-sword-outline::before {\n  content: \"\\F18BF\";\n}\n\n.mdi-shield-sync::before {\n  content: \"\\F11A2\";\n}\n\n.mdi-shield-sync-outline::before {\n  content: \"\\F11A3\";\n}\n\n.mdi-shimmer::before {\n  content: \"\\F1545\";\n}\n\n.mdi-ship-wheel::before {\n  content: \"\\F0833\";\n}\n\n.mdi-shipping-pallet::before {\n  content: \"\\F184E\";\n}\n\n.mdi-shoe-ballet::before {\n  content: \"\\F15CA\";\n}\n\n.mdi-shoe-cleat::before {\n  content: \"\\F15C7\";\n}\n\n.mdi-shoe-formal::before {\n  content: \"\\F0B47\";\n}\n\n.mdi-shoe-heel::before {\n  content: \"\\F0B48\";\n}\n\n.mdi-shoe-print::before {\n  content: \"\\F0DFA\";\n}\n\n.mdi-shoe-sneaker::before {\n  content: \"\\F15C8\";\n}\n\n.mdi-shopping::before {\n  content: \"\\F049A\";\n}\n\n.mdi-shopping-music::before {\n  content: \"\\F049B\";\n}\n\n.mdi-shopping-outline::before {\n  content: \"\\F11D5\";\n}\n\n.mdi-shopping-search::before {\n  content: \"\\F0F84\";\n}\n\n.mdi-shore::before {\n  content: \"\\F14F9\";\n}\n\n.mdi-shovel::before {\n  content: \"\\F0710\";\n}\n\n.mdi-shovel-off::before {\n  content: \"\\F0711\";\n}\n\n.mdi-shower::before {\n  content: \"\\F09A0\";\n}\n\n.mdi-shower-head::before {\n  content: \"\\F09A1\";\n}\n\n.mdi-shredder::before {\n  content: \"\\F049C\";\n}\n\n.mdi-shuffle::before {\n  content: \"\\F049D\";\n}\n\n.mdi-shuffle-disabled::before {\n  content: \"\\F049E\";\n}\n\n.mdi-shuffle-variant::before {\n  content: \"\\F049F\";\n}\n\n.mdi-shuriken::before {\n  content: \"\\F137F\";\n}\n\n.mdi-sickle::before {\n  content: \"\\F18C0\";\n}\n\n.mdi-sigma::before {\n  content: \"\\F04A0\";\n}\n\n.mdi-sigma-lower::before {\n  content: \"\\F062B\";\n}\n\n.mdi-sign-caution::before {\n  content: \"\\F04A1\";\n}\n\n.mdi-sign-direction::before {\n  content: \"\\F0781\";\n}\n\n.mdi-sign-direction-minus::before {\n  content: \"\\F1000\";\n}\n\n.mdi-sign-direction-plus::before {\n  content: \"\\F0FDC\";\n}\n\n.mdi-sign-direction-remove::before {\n  content: \"\\F0FDD\";\n}\n\n.mdi-sign-pole::before {\n  content: \"\\F14F8\";\n}\n\n.mdi-sign-real-estate::before {\n  content: \"\\F1118\";\n}\n\n.mdi-sign-text::before {\n  content: \"\\F0782\";\n}\n\n.mdi-signal::before {\n  content: \"\\F04A2\";\n}\n\n.mdi-signal-2g::before {\n  content: \"\\F0712\";\n}\n\n.mdi-signal-3g::before {\n  content: \"\\F0713\";\n}\n\n.mdi-signal-4g::before {\n  content: \"\\F0714\";\n}\n\n.mdi-signal-5g::before {\n  content: \"\\F0A6F\";\n}\n\n.mdi-signal-cellular-1::before {\n  content: \"\\F08BC\";\n}\n\n.mdi-signal-cellular-2::before {\n  content: \"\\F08BD\";\n}\n\n.mdi-signal-cellular-3::before {\n  content: \"\\F08BE\";\n}\n\n.mdi-signal-cellular-outline::before {\n  content: \"\\F08BF\";\n}\n\n.mdi-signal-distance-variant::before {\n  content: \"\\F0E64\";\n}\n\n.mdi-signal-hspa::before {\n  content: \"\\F0715\";\n}\n\n.mdi-signal-hspa-plus::before {\n  content: \"\\F0716\";\n}\n\n.mdi-signal-off::before {\n  content: \"\\F0783\";\n}\n\n.mdi-signal-variant::before {\n  content: \"\\F060A\";\n}\n\n.mdi-signature::before {\n  content: \"\\F0DFB\";\n}\n\n.mdi-signature-freehand::before {\n  content: \"\\F0DFC\";\n}\n\n.mdi-signature-image::before {\n  content: \"\\F0DFD\";\n}\n\n.mdi-signature-text::before {\n  content: \"\\F0DFE\";\n}\n\n.mdi-silo::before {\n  content: \"\\F0B49\";\n}\n\n.mdi-silverware::before {\n  content: \"\\F04A3\";\n}\n\n.mdi-silverware-clean::before {\n  content: \"\\F0FDE\";\n}\n\n.mdi-silverware-fork::before {\n  content: \"\\F04A4\";\n}\n\n.mdi-silverware-fork-knife::before {\n  content: \"\\F0A70\";\n}\n\n.mdi-silverware-spoon::before {\n  content: \"\\F04A5\";\n}\n\n.mdi-silverware-variant::before {\n  content: \"\\F04A6\";\n}\n\n.mdi-sim::before {\n  content: \"\\F04A7\";\n}\n\n.mdi-sim-alert::before {\n  content: \"\\F04A8\";\n}\n\n.mdi-sim-alert-outline::before {\n  content: \"\\F15D3\";\n}\n\n.mdi-sim-off::before {\n  content: \"\\F04A9\";\n}\n\n.mdi-sim-off-outline::before {\n  content: \"\\F15D4\";\n}\n\n.mdi-sim-outline::before {\n  content: \"\\F15D5\";\n}\n\n.mdi-simple-icons::before {\n  content: \"\\F131D\";\n}\n\n.mdi-sina-weibo::before {\n  content: \"\\F0ADF\";\n}\n\n.mdi-sine-wave::before {\n  content: \"\\F095B\";\n}\n\n.mdi-sitemap::before {\n  content: \"\\F04AA\";\n}\n\n.mdi-sitemap-outline::before {\n  content: \"\\F199C\";\n}\n\n.mdi-size-l::before {\n  content: \"\\F13A6\";\n}\n\n.mdi-size-m::before {\n  content: \"\\F13A5\";\n}\n\n.mdi-size-s::before {\n  content: \"\\F13A4\";\n}\n\n.mdi-size-xl::before {\n  content: \"\\F13A7\";\n}\n\n.mdi-size-xs::before {\n  content: \"\\F13A3\";\n}\n\n.mdi-size-xxl::before {\n  content: \"\\F13A8\";\n}\n\n.mdi-size-xxs::before {\n  content: \"\\F13A2\";\n}\n\n.mdi-size-xxxl::before {\n  content: \"\\F13A9\";\n}\n\n.mdi-skate::before {\n  content: \"\\F0D35\";\n}\n\n.mdi-skate-off::before {\n  content: \"\\F0699\";\n}\n\n.mdi-skateboard::before {\n  content: \"\\F14C2\";\n}\n\n.mdi-skateboarding::before {\n  content: \"\\F0501\";\n}\n\n.mdi-skew-less::before {\n  content: \"\\F0D36\";\n}\n\n.mdi-skew-more::before {\n  content: \"\\F0D37\";\n}\n\n.mdi-ski::before {\n  content: \"\\F1304\";\n}\n\n.mdi-ski-cross-country::before {\n  content: \"\\F1305\";\n}\n\n.mdi-ski-water::before {\n  content: \"\\F1306\";\n}\n\n.mdi-skip-backward::before {\n  content: \"\\F04AB\";\n}\n\n.mdi-skip-backward-outline::before {\n  content: \"\\F0F25\";\n}\n\n.mdi-skip-forward::before {\n  content: \"\\F04AC\";\n}\n\n.mdi-skip-forward-outline::before {\n  content: \"\\F0F26\";\n}\n\n.mdi-skip-next::before {\n  content: \"\\F04AD\";\n}\n\n.mdi-skip-next-circle::before {\n  content: \"\\F0661\";\n}\n\n.mdi-skip-next-circle-outline::before {\n  content: \"\\F0662\";\n}\n\n.mdi-skip-next-outline::before {\n  content: \"\\F0F27\";\n}\n\n.mdi-skip-previous::before {\n  content: \"\\F04AE\";\n}\n\n.mdi-skip-previous-circle::before {\n  content: \"\\F0663\";\n}\n\n.mdi-skip-previous-circle-outline::before {\n  content: \"\\F0664\";\n}\n\n.mdi-skip-previous-outline::before {\n  content: \"\\F0F28\";\n}\n\n.mdi-skull::before {\n  content: \"\\F068C\";\n}\n\n.mdi-skull-crossbones::before {\n  content: \"\\F0BC6\";\n}\n\n.mdi-skull-crossbones-outline::before {\n  content: \"\\F0BC7\";\n}\n\n.mdi-skull-outline::before {\n  content: \"\\F0BC8\";\n}\n\n.mdi-skull-scan::before {\n  content: \"\\F14C7\";\n}\n\n.mdi-skull-scan-outline::before {\n  content: \"\\F14C8\";\n}\n\n.mdi-skype::before {\n  content: \"\\F04AF\";\n}\n\n.mdi-skype-business::before {\n  content: \"\\F04B0\";\n}\n\n.mdi-slack::before {\n  content: \"\\F04B1\";\n}\n\n.mdi-slash-forward::before {\n  content: \"\\F0FDF\";\n}\n\n.mdi-slash-forward-box::before {\n  content: \"\\F0FE0\";\n}\n\n.mdi-sledding::before {\n  content: \"\\F041B\";\n}\n\n.mdi-sleep::before {\n  content: \"\\F04B2\";\n}\n\n.mdi-sleep-off::before {\n  content: \"\\F04B3\";\n}\n\n.mdi-slide::before {\n  content: \"\\F15A5\";\n}\n\n.mdi-slope-downhill::before {\n  content: \"\\F0DFF\";\n}\n\n.mdi-slope-uphill::before {\n  content: \"\\F0E00\";\n}\n\n.mdi-slot-machine::before {\n  content: \"\\F1114\";\n}\n\n.mdi-slot-machine-outline::before {\n  content: \"\\F1115\";\n}\n\n.mdi-smart-card::before {\n  content: \"\\F10BD\";\n}\n\n.mdi-smart-card-off::before {\n  content: \"\\F18F7\";\n}\n\n.mdi-smart-card-off-outline::before {\n  content: \"\\F18F8\";\n}\n\n.mdi-smart-card-outline::before {\n  content: \"\\F10BE\";\n}\n\n.mdi-smart-card-reader::before {\n  content: \"\\F10BF\";\n}\n\n.mdi-smart-card-reader-outline::before {\n  content: \"\\F10C0\";\n}\n\n.mdi-smog::before {\n  content: \"\\F0A71\";\n}\n\n.mdi-smoke::before {\n  content: \"\\F1799\";\n}\n\n.mdi-smoke-detector::before {\n  content: \"\\F0392\";\n}\n\n.mdi-smoke-detector-alert::before {\n  content: \"\\F192E\";\n}\n\n.mdi-smoke-detector-alert-outline::before {\n  content: \"\\F192F\";\n}\n\n.mdi-smoke-detector-off::before {\n  content: \"\\F1809\";\n}\n\n.mdi-smoke-detector-off-outline::before {\n  content: \"\\F180A\";\n}\n\n.mdi-smoke-detector-outline::before {\n  content: \"\\F1808\";\n}\n\n.mdi-smoke-detector-variant::before {\n  content: \"\\F180B\";\n}\n\n.mdi-smoke-detector-variant-alert::before {\n  content: \"\\F1930\";\n}\n\n.mdi-smoke-detector-variant-off::before {\n  content: \"\\F180C\";\n}\n\n.mdi-smoking::before {\n  content: \"\\F04B4\";\n}\n\n.mdi-smoking-off::before {\n  content: \"\\F04B5\";\n}\n\n.mdi-smoking-pipe::before {\n  content: \"\\F140D\";\n}\n\n.mdi-smoking-pipe-off::before {\n  content: \"\\F1428\";\n}\n\n.mdi-snail::before {\n  content: \"\\F1677\";\n}\n\n.mdi-snake::before {\n  content: \"\\F150E\";\n}\n\n.mdi-snapchat::before {\n  content: \"\\F04B6\";\n}\n\n.mdi-snowboard::before {\n  content: \"\\F1307\";\n}\n\n.mdi-snowflake::before {\n  content: \"\\F0717\";\n}\n\n.mdi-snowflake-alert::before {\n  content: \"\\F0F29\";\n}\n\n.mdi-snowflake-melt::before {\n  content: \"\\F12CB\";\n}\n\n.mdi-snowflake-off::before {\n  content: \"\\F14E3\";\n}\n\n.mdi-snowflake-variant::before {\n  content: \"\\F0F2A\";\n}\n\n.mdi-snowman::before {\n  content: \"\\F04B7\";\n}\n\n.mdi-snowmobile::before {\n  content: \"\\F06DD\";\n}\n\n.mdi-soccer::before {\n  content: \"\\F04B8\";\n}\n\n.mdi-soccer-field::before {\n  content: \"\\F0834\";\n}\n\n.mdi-social-distance-2-meters::before {\n  content: \"\\F1579\";\n}\n\n.mdi-social-distance-6-feet::before {\n  content: \"\\F157A\";\n}\n\n.mdi-sofa::before {\n  content: \"\\F04B9\";\n}\n\n.mdi-sofa-outline::before {\n  content: \"\\F156D\";\n}\n\n.mdi-sofa-single::before {\n  content: \"\\F156E\";\n}\n\n.mdi-sofa-single-outline::before {\n  content: \"\\F156F\";\n}\n\n.mdi-solar-panel::before {\n  content: \"\\F0D9B\";\n}\n\n.mdi-solar-panel-large::before {\n  content: \"\\F0D9C\";\n}\n\n.mdi-solar-power::before {\n  content: \"\\F0A72\";\n}\n\n.mdi-soldering-iron::before {\n  content: \"\\F1092\";\n}\n\n.mdi-solid::before {\n  content: \"\\F068D\";\n}\n\n.mdi-sony-playstation::before {\n  content: \"\\F0414\";\n}\n\n.mdi-sort::before {\n  content: \"\\F04BA\";\n}\n\n.mdi-sort-alphabetical-ascending::before {\n  content: \"\\F05BD\";\n}\n\n.mdi-sort-alphabetical-ascending-variant::before {\n  content: \"\\F1148\";\n}\n\n.mdi-sort-alphabetical-descending::before {\n  content: \"\\F05BF\";\n}\n\n.mdi-sort-alphabetical-descending-variant::before {\n  content: \"\\F1149\";\n}\n\n.mdi-sort-alphabetical-variant::before {\n  content: \"\\F04BB\";\n}\n\n.mdi-sort-ascending::before {\n  content: \"\\F04BC\";\n}\n\n.mdi-sort-bool-ascending::before {\n  content: \"\\F1385\";\n}\n\n.mdi-sort-bool-ascending-variant::before {\n  content: \"\\F1386\";\n}\n\n.mdi-sort-bool-descending::before {\n  content: \"\\F1387\";\n}\n\n.mdi-sort-bool-descending-variant::before {\n  content: \"\\F1388\";\n}\n\n.mdi-sort-calendar-ascending::before {\n  content: \"\\F1547\";\n}\n\n.mdi-sort-calendar-descending::before {\n  content: \"\\F1548\";\n}\n\n.mdi-sort-clock-ascending::before {\n  content: \"\\F1549\";\n}\n\n.mdi-sort-clock-ascending-outline::before {\n  content: \"\\F154A\";\n}\n\n.mdi-sort-clock-descending::before {\n  content: \"\\F154B\";\n}\n\n.mdi-sort-clock-descending-outline::before {\n  content: \"\\F154C\";\n}\n\n.mdi-sort-descending::before {\n  content: \"\\F04BD\";\n}\n\n.mdi-sort-numeric-ascending::before {\n  content: \"\\F1389\";\n}\n\n.mdi-sort-numeric-ascending-variant::before {\n  content: \"\\F090D\";\n}\n\n.mdi-sort-numeric-descending::before {\n  content: \"\\F138A\";\n}\n\n.mdi-sort-numeric-descending-variant::before {\n  content: \"\\F0AD2\";\n}\n\n.mdi-sort-numeric-variant::before {\n  content: \"\\F04BE\";\n}\n\n.mdi-sort-reverse-variant::before {\n  content: \"\\F033C\";\n}\n\n.mdi-sort-variant::before {\n  content: \"\\F04BF\";\n}\n\n.mdi-sort-variant-lock::before {\n  content: \"\\F0CCD\";\n}\n\n.mdi-sort-variant-lock-open::before {\n  content: \"\\F0CCE\";\n}\n\n.mdi-sort-variant-remove::before {\n  content: \"\\F1147\";\n}\n\n.mdi-soundbar::before {\n  content: \"\\F17DB\";\n}\n\n.mdi-soundcloud::before {\n  content: \"\\F04C0\";\n}\n\n.mdi-source-branch::before {\n  content: \"\\F062C\";\n}\n\n.mdi-source-branch-check::before {\n  content: \"\\F14CF\";\n}\n\n.mdi-source-branch-minus::before {\n  content: \"\\F14CB\";\n}\n\n.mdi-source-branch-plus::before {\n  content: \"\\F14CA\";\n}\n\n.mdi-source-branch-refresh::before {\n  content: \"\\F14CD\";\n}\n\n.mdi-source-branch-remove::before {\n  content: \"\\F14CC\";\n}\n\n.mdi-source-branch-sync::before {\n  content: \"\\F14CE\";\n}\n\n.mdi-source-commit::before {\n  content: \"\\F0718\";\n}\n\n.mdi-source-commit-end::before {\n  content: \"\\F0719\";\n}\n\n.mdi-source-commit-end-local::before {\n  content: \"\\F071A\";\n}\n\n.mdi-source-commit-local::before {\n  content: \"\\F071B\";\n}\n\n.mdi-source-commit-next-local::before {\n  content: \"\\F071C\";\n}\n\n.mdi-source-commit-start::before {\n  content: \"\\F071D\";\n}\n\n.mdi-source-commit-start-next-local::before {\n  content: \"\\F071E\";\n}\n\n.mdi-source-fork::before {\n  content: \"\\F04C1\";\n}\n\n.mdi-source-merge::before {\n  content: \"\\F062D\";\n}\n\n.mdi-source-pull::before {\n  content: \"\\F04C2\";\n}\n\n.mdi-source-repository::before {\n  content: \"\\F0CCF\";\n}\n\n.mdi-source-repository-multiple::before {\n  content: \"\\F0CD0\";\n}\n\n.mdi-soy-sauce::before {\n  content: \"\\F07EE\";\n}\n\n.mdi-soy-sauce-off::before {\n  content: \"\\F13FC\";\n}\n\n.mdi-spa::before {\n  content: \"\\F0CD1\";\n}\n\n.mdi-spa-outline::before {\n  content: \"\\F0CD2\";\n}\n\n.mdi-space-invaders::before {\n  content: \"\\F0BC9\";\n}\n\n.mdi-space-station::before {\n  content: \"\\F1383\";\n}\n\n.mdi-spade::before {\n  content: \"\\F0E65\";\n}\n\n.mdi-speaker::before {\n  content: \"\\F04C3\";\n}\n\n.mdi-speaker-bluetooth::before {\n  content: \"\\F09A2\";\n}\n\n.mdi-speaker-multiple::before {\n  content: \"\\F0D38\";\n}\n\n.mdi-speaker-off::before {\n  content: \"\\F04C4\";\n}\n\n.mdi-speaker-wireless::before {\n  content: \"\\F071F\";\n}\n\n.mdi-spear::before {\n  content: \"\\F1845\";\n}\n\n.mdi-speedometer::before {\n  content: \"\\F04C5\";\n}\n\n.mdi-speedometer-medium::before {\n  content: \"\\F0F85\";\n}\n\n.mdi-speedometer-slow::before {\n  content: \"\\F0F86\";\n}\n\n.mdi-spellcheck::before {\n  content: \"\\F04C6\";\n}\n\n.mdi-sphere::before {\n  content: \"\\F1954\";\n}\n\n.mdi-sphere-off::before {\n  content: \"\\F1955\";\n}\n\n.mdi-spider::before {\n  content: \"\\F11EA\";\n}\n\n.mdi-spider-thread::before {\n  content: \"\\F11EB\";\n}\n\n.mdi-spider-web::before {\n  content: \"\\F0BCA\";\n}\n\n.mdi-spirit-level::before {\n  content: \"\\F14F1\";\n}\n\n.mdi-spoon-sugar::before {\n  content: \"\\F1429\";\n}\n\n.mdi-spotify::before {\n  content: \"\\F04C7\";\n}\n\n.mdi-spotlight::before {\n  content: \"\\F04C8\";\n}\n\n.mdi-spotlight-beam::before {\n  content: \"\\F04C9\";\n}\n\n.mdi-spray::before {\n  content: \"\\F0665\";\n}\n\n.mdi-spray-bottle::before {\n  content: \"\\F0AE0\";\n}\n\n.mdi-sprinkler::before {\n  content: \"\\F105F\";\n}\n\n.mdi-sprinkler-fire::before {\n  content: \"\\F199D\";\n}\n\n.mdi-sprinkler-variant::before {\n  content: \"\\F1060\";\n}\n\n.mdi-sprout::before {\n  content: \"\\F0E66\";\n}\n\n.mdi-sprout-outline::before {\n  content: \"\\F0E67\";\n}\n\n.mdi-square::before {\n  content: \"\\F0764\";\n}\n\n.mdi-square-circle::before {\n  content: \"\\F1500\";\n}\n\n.mdi-square-edit-outline::before {\n  content: \"\\F090C\";\n}\n\n.mdi-square-medium::before {\n  content: \"\\F0A13\";\n}\n\n.mdi-square-medium-outline::before {\n  content: \"\\F0A14\";\n}\n\n.mdi-square-off::before {\n  content: \"\\F12EE\";\n}\n\n.mdi-square-off-outline::before {\n  content: \"\\F12EF\";\n}\n\n.mdi-square-opacity::before {\n  content: \"\\F1854\";\n}\n\n.mdi-square-outline::before {\n  content: \"\\F0763\";\n}\n\n.mdi-square-root::before {\n  content: \"\\F0784\";\n}\n\n.mdi-square-root-box::before {\n  content: \"\\F09A3\";\n}\n\n.mdi-square-rounded::before {\n  content: \"\\F14FB\";\n}\n\n.mdi-square-rounded-outline::before {\n  content: \"\\F14FC\";\n}\n\n.mdi-square-small::before {\n  content: \"\\F0A15\";\n}\n\n.mdi-square-wave::before {\n  content: \"\\F147B\";\n}\n\n.mdi-squeegee::before {\n  content: \"\\F0AE1\";\n}\n\n.mdi-ssh::before {\n  content: \"\\F08C0\";\n}\n\n.mdi-stack-exchange::before {\n  content: \"\\F060B\";\n}\n\n.mdi-stack-overflow::before {\n  content: \"\\F04CC\";\n}\n\n.mdi-stackpath::before {\n  content: \"\\F0359\";\n}\n\n.mdi-stadium::before {\n  content: \"\\F0FF9\";\n}\n\n.mdi-stadium-variant::before {\n  content: \"\\F0720\";\n}\n\n.mdi-stairs::before {\n  content: \"\\F04CD\";\n}\n\n.mdi-stairs-box::before {\n  content: \"\\F139E\";\n}\n\n.mdi-stairs-down::before {\n  content: \"\\F12BE\";\n}\n\n.mdi-stairs-up::before {\n  content: \"\\F12BD\";\n}\n\n.mdi-stamper::before {\n  content: \"\\F0D39\";\n}\n\n.mdi-standard-definition::before {\n  content: \"\\F07EF\";\n}\n\n.mdi-star::before {\n  content: \"\\F04CE\";\n}\n\n.mdi-star-box::before {\n  content: \"\\F0A73\";\n}\n\n.mdi-star-box-multiple::before {\n  content: \"\\F1286\";\n}\n\n.mdi-star-box-multiple-outline::before {\n  content: \"\\F1287\";\n}\n\n.mdi-star-box-outline::before {\n  content: \"\\F0A74\";\n}\n\n.mdi-star-check::before {\n  content: \"\\F1566\";\n}\n\n.mdi-star-check-outline::before {\n  content: \"\\F156A\";\n}\n\n.mdi-star-circle::before {\n  content: \"\\F04CF\";\n}\n\n.mdi-star-circle-outline::before {\n  content: \"\\F09A4\";\n}\n\n.mdi-star-cog::before {\n  content: \"\\F1668\";\n}\n\n.mdi-star-cog-outline::before {\n  content: \"\\F1669\";\n}\n\n.mdi-star-crescent::before {\n  content: \"\\F0979\";\n}\n\n.mdi-star-david::before {\n  content: \"\\F097A\";\n}\n\n.mdi-star-face::before {\n  content: \"\\F09A5\";\n}\n\n.mdi-star-four-points::before {\n  content: \"\\F0AE2\";\n}\n\n.mdi-star-four-points-outline::before {\n  content: \"\\F0AE3\";\n}\n\n.mdi-star-half::before {\n  content: \"\\F0246\";\n}\n\n.mdi-star-half-full::before {\n  content: \"\\F04D0\";\n}\n\n.mdi-star-minus::before {\n  content: \"\\F1564\";\n}\n\n.mdi-star-minus-outline::before {\n  content: \"\\F1568\";\n}\n\n.mdi-star-off::before {\n  content: \"\\F04D1\";\n}\n\n.mdi-star-off-outline::before {\n  content: \"\\F155B\";\n}\n\n.mdi-star-outline::before {\n  content: \"\\F04D2\";\n}\n\n.mdi-star-plus::before {\n  content: \"\\F1563\";\n}\n\n.mdi-star-plus-outline::before {\n  content: \"\\F1567\";\n}\n\n.mdi-star-remove::before {\n  content: \"\\F1565\";\n}\n\n.mdi-star-remove-outline::before {\n  content: \"\\F1569\";\n}\n\n.mdi-star-settings::before {\n  content: \"\\F166A\";\n}\n\n.mdi-star-settings-outline::before {\n  content: \"\\F166B\";\n}\n\n.mdi-star-shooting::before {\n  content: \"\\F1741\";\n}\n\n.mdi-star-shooting-outline::before {\n  content: \"\\F1742\";\n}\n\n.mdi-star-three-points::before {\n  content: \"\\F0AE4\";\n}\n\n.mdi-star-three-points-outline::before {\n  content: \"\\F0AE5\";\n}\n\n.mdi-state-machine::before {\n  content: \"\\F11EF\";\n}\n\n.mdi-steam::before {\n  content: \"\\F04D3\";\n}\n\n.mdi-steering::before {\n  content: \"\\F04D4\";\n}\n\n.mdi-steering-off::before {\n  content: \"\\F090E\";\n}\n\n.mdi-step-backward::before {\n  content: \"\\F04D5\";\n}\n\n.mdi-step-backward-2::before {\n  content: \"\\F04D6\";\n}\n\n.mdi-step-forward::before {\n  content: \"\\F04D7\";\n}\n\n.mdi-step-forward-2::before {\n  content: \"\\F04D8\";\n}\n\n.mdi-stethoscope::before {\n  content: \"\\F04D9\";\n}\n\n.mdi-sticker::before {\n  content: \"\\F1364\";\n}\n\n.mdi-sticker-alert::before {\n  content: \"\\F1365\";\n}\n\n.mdi-sticker-alert-outline::before {\n  content: \"\\F1366\";\n}\n\n.mdi-sticker-check::before {\n  content: \"\\F1367\";\n}\n\n.mdi-sticker-check-outline::before {\n  content: \"\\F1368\";\n}\n\n.mdi-sticker-circle-outline::before {\n  content: \"\\F05D0\";\n}\n\n.mdi-sticker-emoji::before {\n  content: \"\\F0785\";\n}\n\n.mdi-sticker-minus::before {\n  content: \"\\F1369\";\n}\n\n.mdi-sticker-minus-outline::before {\n  content: \"\\F136A\";\n}\n\n.mdi-sticker-outline::before {\n  content: \"\\F136B\";\n}\n\n.mdi-sticker-plus::before {\n  content: \"\\F136C\";\n}\n\n.mdi-sticker-plus-outline::before {\n  content: \"\\F136D\";\n}\n\n.mdi-sticker-remove::before {\n  content: \"\\F136E\";\n}\n\n.mdi-sticker-remove-outline::before {\n  content: \"\\F136F\";\n}\n\n.mdi-sticker-text::before {\n  content: \"\\F178E\";\n}\n\n.mdi-sticker-text-outline::before {\n  content: \"\\F178F\";\n}\n\n.mdi-stocking::before {\n  content: \"\\F04DA\";\n}\n\n.mdi-stomach::before {\n  content: \"\\F1093\";\n}\n\n.mdi-stool::before {\n  content: \"\\F195D\";\n}\n\n.mdi-stool-outline::before {\n  content: \"\\F195E\";\n}\n\n.mdi-stop::before {\n  content: \"\\F04DB\";\n}\n\n.mdi-stop-circle::before {\n  content: \"\\F0666\";\n}\n\n.mdi-stop-circle-outline::before {\n  content: \"\\F0667\";\n}\n\n.mdi-store::before {\n  content: \"\\F04DC\";\n}\n\n.mdi-store-24-hour::before {\n  content: \"\\F04DD\";\n}\n\n.mdi-store-alert::before {\n  content: \"\\F18C1\";\n}\n\n.mdi-store-alert-outline::before {\n  content: \"\\F18C2\";\n}\n\n.mdi-store-check::before {\n  content: \"\\F18C3\";\n}\n\n.mdi-store-check-outline::before {\n  content: \"\\F18C4\";\n}\n\n.mdi-store-clock::before {\n  content: \"\\F18C5\";\n}\n\n.mdi-store-clock-outline::before {\n  content: \"\\F18C6\";\n}\n\n.mdi-store-cog::before {\n  content: \"\\F18C7\";\n}\n\n.mdi-store-cog-outline::before {\n  content: \"\\F18C8\";\n}\n\n.mdi-store-edit::before {\n  content: \"\\F18C9\";\n}\n\n.mdi-store-edit-outline::before {\n  content: \"\\F18CA\";\n}\n\n.mdi-store-marker::before {\n  content: \"\\F18CB\";\n}\n\n.mdi-store-marker-outline::before {\n  content: \"\\F18CC\";\n}\n\n.mdi-store-minus::before {\n  content: \"\\F165E\";\n}\n\n.mdi-store-minus-outline::before {\n  content: \"\\F18CD\";\n}\n\n.mdi-store-off::before {\n  content: \"\\F18CE\";\n}\n\n.mdi-store-off-outline::before {\n  content: \"\\F18CF\";\n}\n\n.mdi-store-outline::before {\n  content: \"\\F1361\";\n}\n\n.mdi-store-plus::before {\n  content: \"\\F165F\";\n}\n\n.mdi-store-plus-outline::before {\n  content: \"\\F18D0\";\n}\n\n.mdi-store-remove::before {\n  content: \"\\F1660\";\n}\n\n.mdi-store-remove-outline::before {\n  content: \"\\F18D1\";\n}\n\n.mdi-store-search::before {\n  content: \"\\F18D2\";\n}\n\n.mdi-store-search-outline::before {\n  content: \"\\F18D3\";\n}\n\n.mdi-store-settings::before {\n  content: \"\\F18D4\";\n}\n\n.mdi-store-settings-outline::before {\n  content: \"\\F18D5\";\n}\n\n.mdi-storefront::before {\n  content: \"\\F07C7\";\n}\n\n.mdi-storefront-outline::before {\n  content: \"\\F10C1\";\n}\n\n.mdi-stove::before {\n  content: \"\\F04DE\";\n}\n\n.mdi-strategy::before {\n  content: \"\\F11D6\";\n}\n\n.mdi-stretch-to-page::before {\n  content: \"\\F0F2B\";\n}\n\n.mdi-stretch-to-page-outline::before {\n  content: \"\\F0F2C\";\n}\n\n.mdi-string-lights::before {\n  content: \"\\F12BA\";\n}\n\n.mdi-string-lights-off::before {\n  content: \"\\F12BB\";\n}\n\n.mdi-subdirectory-arrow-left::before {\n  content: \"\\F060C\";\n}\n\n.mdi-subdirectory-arrow-right::before {\n  content: \"\\F060D\";\n}\n\n.mdi-submarine::before {\n  content: \"\\F156C\";\n}\n\n.mdi-subtitles::before {\n  content: \"\\F0A16\";\n}\n\n.mdi-subtitles-outline::before {\n  content: \"\\F0A17\";\n}\n\n.mdi-subway::before {\n  content: \"\\F06AC\";\n}\n\n.mdi-subway-alert-variant::before {\n  content: \"\\F0D9D\";\n}\n\n.mdi-subway-variant::before {\n  content: \"\\F04DF\";\n}\n\n.mdi-summit::before {\n  content: \"\\F0786\";\n}\n\n.mdi-sun-compass::before {\n  content: \"\\F19A5\";\n}\n\n.mdi-sun-snowflake::before {\n  content: \"\\F1796\";\n}\n\n.mdi-sun-thermometer::before {\n  content: \"\\F18D6\";\n}\n\n.mdi-sun-thermometer-outline::before {\n  content: \"\\F18D7\";\n}\n\n.mdi-sun-wireless::before {\n  content: \"\\F17FE\";\n}\n\n.mdi-sun-wireless-outline::before {\n  content: \"\\F17FF\";\n}\n\n.mdi-sunglasses::before {\n  content: \"\\F04E0\";\n}\n\n.mdi-surfing::before {\n  content: \"\\F1746\";\n}\n\n.mdi-surround-sound::before {\n  content: \"\\F05C5\";\n}\n\n.mdi-surround-sound-2-0::before {\n  content: \"\\F07F0\";\n}\n\n.mdi-surround-sound-2-1::before {\n  content: \"\\F1729\";\n}\n\n.mdi-surround-sound-3-1::before {\n  content: \"\\F07F1\";\n}\n\n.mdi-surround-sound-5-1::before {\n  content: \"\\F07F2\";\n}\n\n.mdi-surround-sound-5-1-2::before {\n  content: \"\\F172A\";\n}\n\n.mdi-surround-sound-7-1::before {\n  content: \"\\F07F3\";\n}\n\n.mdi-svg::before {\n  content: \"\\F0721\";\n}\n\n.mdi-swap-horizontal::before {\n  content: \"\\F04E1\";\n}\n\n.mdi-swap-horizontal-bold::before {\n  content: \"\\F0BCD\";\n}\n\n.mdi-swap-horizontal-circle::before {\n  content: \"\\F0FE1\";\n}\n\n.mdi-swap-horizontal-circle-outline::before {\n  content: \"\\F0FE2\";\n}\n\n.mdi-swap-horizontal-variant::before {\n  content: \"\\F08C1\";\n}\n\n.mdi-swap-vertical::before {\n  content: \"\\F04E2\";\n}\n\n.mdi-swap-vertical-bold::before {\n  content: \"\\F0BCE\";\n}\n\n.mdi-swap-vertical-circle::before {\n  content: \"\\F0FE3\";\n}\n\n.mdi-swap-vertical-circle-outline::before {\n  content: \"\\F0FE4\";\n}\n\n.mdi-swap-vertical-variant::before {\n  content: \"\\F08C2\";\n}\n\n.mdi-swim::before {\n  content: \"\\F04E3\";\n}\n\n.mdi-switch::before {\n  content: \"\\F04E4\";\n}\n\n.mdi-sword::before {\n  content: \"\\F04E5\";\n}\n\n.mdi-sword-cross::before {\n  content: \"\\F0787\";\n}\n\n.mdi-syllabary-hangul::before {\n  content: \"\\F1333\";\n}\n\n.mdi-syllabary-hiragana::before {\n  content: \"\\F1334\";\n}\n\n.mdi-syllabary-katakana::before {\n  content: \"\\F1335\";\n}\n\n.mdi-syllabary-katakana-halfwidth::before {\n  content: \"\\F1336\";\n}\n\n.mdi-symbol::before {\n  content: \"\\F1501\";\n}\n\n.mdi-symfony::before {\n  content: \"\\F0AE6\";\n}\n\n.mdi-sync::before {\n  content: \"\\F04E6\";\n}\n\n.mdi-sync-alert::before {\n  content: \"\\F04E7\";\n}\n\n.mdi-sync-circle::before {\n  content: \"\\F1378\";\n}\n\n.mdi-sync-off::before {\n  content: \"\\F04E8\";\n}\n\n.mdi-tab::before {\n  content: \"\\F04E9\";\n}\n\n.mdi-tab-minus::before {\n  content: \"\\F0B4B\";\n}\n\n.mdi-tab-plus::before {\n  content: \"\\F075C\";\n}\n\n.mdi-tab-remove::before {\n  content: \"\\F0B4C\";\n}\n\n.mdi-tab-search::before {\n  content: \"\\F199E\";\n}\n\n.mdi-tab-unselected::before {\n  content: \"\\F04EA\";\n}\n\n.mdi-table::before {\n  content: \"\\F04EB\";\n}\n\n.mdi-table-account::before {\n  content: \"\\F13B9\";\n}\n\n.mdi-table-alert::before {\n  content: \"\\F13BA\";\n}\n\n.mdi-table-arrow-down::before {\n  content: \"\\F13BB\";\n}\n\n.mdi-table-arrow-left::before {\n  content: \"\\F13BC\";\n}\n\n.mdi-table-arrow-right::before {\n  content: \"\\F13BD\";\n}\n\n.mdi-table-arrow-up::before {\n  content: \"\\F13BE\";\n}\n\n.mdi-table-border::before {\n  content: \"\\F0A18\";\n}\n\n.mdi-table-cancel::before {\n  content: \"\\F13BF\";\n}\n\n.mdi-table-chair::before {\n  content: \"\\F1061\";\n}\n\n.mdi-table-check::before {\n  content: \"\\F13C0\";\n}\n\n.mdi-table-clock::before {\n  content: \"\\F13C1\";\n}\n\n.mdi-table-cog::before {\n  content: \"\\F13C2\";\n}\n\n.mdi-table-column::before {\n  content: \"\\F0835\";\n}\n\n.mdi-table-column-plus-after::before {\n  content: \"\\F04EC\";\n}\n\n.mdi-table-column-plus-before::before {\n  content: \"\\F04ED\";\n}\n\n.mdi-table-column-remove::before {\n  content: \"\\F04EE\";\n}\n\n.mdi-table-column-width::before {\n  content: \"\\F04EF\";\n}\n\n.mdi-table-edit::before {\n  content: \"\\F04F0\";\n}\n\n.mdi-table-eye::before {\n  content: \"\\F1094\";\n}\n\n.mdi-table-eye-off::before {\n  content: \"\\F13C3\";\n}\n\n.mdi-table-furniture::before {\n  content: \"\\F05BC\";\n}\n\n.mdi-table-headers-eye::before {\n  content: \"\\F121D\";\n}\n\n.mdi-table-headers-eye-off::before {\n  content: \"\\F121E\";\n}\n\n.mdi-table-heart::before {\n  content: \"\\F13C4\";\n}\n\n.mdi-table-key::before {\n  content: \"\\F13C5\";\n}\n\n.mdi-table-large::before {\n  content: \"\\F04F1\";\n}\n\n.mdi-table-large-plus::before {\n  content: \"\\F0F87\";\n}\n\n.mdi-table-large-remove::before {\n  content: \"\\F0F88\";\n}\n\n.mdi-table-lock::before {\n  content: \"\\F13C6\";\n}\n\n.mdi-table-merge-cells::before {\n  content: \"\\F09A6\";\n}\n\n.mdi-table-minus::before {\n  content: \"\\F13C7\";\n}\n\n.mdi-table-multiple::before {\n  content: \"\\F13C8\";\n}\n\n.mdi-table-network::before {\n  content: \"\\F13C9\";\n}\n\n.mdi-table-of-contents::before {\n  content: \"\\F0836\";\n}\n\n.mdi-table-off::before {\n  content: \"\\F13CA\";\n}\n\n.mdi-table-picnic::before {\n  content: \"\\F1743\";\n}\n\n.mdi-table-pivot::before {\n  content: \"\\F183C\";\n}\n\n.mdi-table-plus::before {\n  content: \"\\F0A75\";\n}\n\n.mdi-table-refresh::before {\n  content: \"\\F13A0\";\n}\n\n.mdi-table-remove::before {\n  content: \"\\F0A76\";\n}\n\n.mdi-table-row::before {\n  content: \"\\F0837\";\n}\n\n.mdi-table-row-height::before {\n  content: \"\\F04F2\";\n}\n\n.mdi-table-row-plus-after::before {\n  content: \"\\F04F3\";\n}\n\n.mdi-table-row-plus-before::before {\n  content: \"\\F04F4\";\n}\n\n.mdi-table-row-remove::before {\n  content: \"\\F04F5\";\n}\n\n.mdi-table-search::before {\n  content: \"\\F090F\";\n}\n\n.mdi-table-settings::before {\n  content: \"\\F0838\";\n}\n\n.mdi-table-split-cell::before {\n  content: \"\\F142A\";\n}\n\n.mdi-table-star::before {\n  content: \"\\F13CB\";\n}\n\n.mdi-table-sync::before {\n  content: \"\\F13A1\";\n}\n\n.mdi-table-tennis::before {\n  content: \"\\F0E68\";\n}\n\n.mdi-tablet::before {\n  content: \"\\F04F6\";\n}\n\n.mdi-tablet-android::before {\n  content: \"\\F04F7\";\n}\n\n.mdi-tablet-cellphone::before {\n  content: \"\\F09A7\";\n}\n\n.mdi-tablet-dashboard::before {\n  content: \"\\F0ECE\";\n}\n\n.mdi-taco::before {\n  content: \"\\F0762\";\n}\n\n.mdi-tag::before {\n  content: \"\\F04F9\";\n}\n\n.mdi-tag-arrow-down::before {\n  content: \"\\F172B\";\n}\n\n.mdi-tag-arrow-down-outline::before {\n  content: \"\\F172C\";\n}\n\n.mdi-tag-arrow-left::before {\n  content: \"\\F172D\";\n}\n\n.mdi-tag-arrow-left-outline::before {\n  content: \"\\F172E\";\n}\n\n.mdi-tag-arrow-right::before {\n  content: \"\\F172F\";\n}\n\n.mdi-tag-arrow-right-outline::before {\n  content: \"\\F1730\";\n}\n\n.mdi-tag-arrow-up::before {\n  content: \"\\F1731\";\n}\n\n.mdi-tag-arrow-up-outline::before {\n  content: \"\\F1732\";\n}\n\n.mdi-tag-faces::before {\n  content: \"\\F04FA\";\n}\n\n.mdi-tag-heart::before {\n  content: \"\\F068B\";\n}\n\n.mdi-tag-heart-outline::before {\n  content: \"\\F0BCF\";\n}\n\n.mdi-tag-minus::before {\n  content: \"\\F0910\";\n}\n\n.mdi-tag-minus-outline::before {\n  content: \"\\F121F\";\n}\n\n.mdi-tag-multiple::before {\n  content: \"\\F04FB\";\n}\n\n.mdi-tag-multiple-outline::before {\n  content: \"\\F12F7\";\n}\n\n.mdi-tag-off::before {\n  content: \"\\F1220\";\n}\n\n.mdi-tag-off-outline::before {\n  content: \"\\F1221\";\n}\n\n.mdi-tag-outline::before {\n  content: \"\\F04FC\";\n}\n\n.mdi-tag-plus::before {\n  content: \"\\F0722\";\n}\n\n.mdi-tag-plus-outline::before {\n  content: \"\\F1222\";\n}\n\n.mdi-tag-remove::before {\n  content: \"\\F0723\";\n}\n\n.mdi-tag-remove-outline::before {\n  content: \"\\F1223\";\n}\n\n.mdi-tag-search::before {\n  content: \"\\F1907\";\n}\n\n.mdi-tag-search-outline::before {\n  content: \"\\F1908\";\n}\n\n.mdi-tag-text::before {\n  content: \"\\F1224\";\n}\n\n.mdi-tag-text-outline::before {\n  content: \"\\F04FD\";\n}\n\n.mdi-tailwind::before {\n  content: \"\\F13FF\";\n}\n\n.mdi-tangram::before {\n  content: \"\\F04F8\";\n}\n\n.mdi-tank::before {\n  content: \"\\F0D3A\";\n}\n\n.mdi-tanker-truck::before {\n  content: \"\\F0FE5\";\n}\n\n.mdi-tape-drive::before {\n  content: \"\\F16DF\";\n}\n\n.mdi-tape-measure::before {\n  content: \"\\F0B4D\";\n}\n\n.mdi-target::before {\n  content: \"\\F04FE\";\n}\n\n.mdi-target-account::before {\n  content: \"\\F0BD0\";\n}\n\n.mdi-target-variant::before {\n  content: \"\\F0A77\";\n}\n\n.mdi-taxi::before {\n  content: \"\\F04FF\";\n}\n\n.mdi-tea::before {\n  content: \"\\F0D9E\";\n}\n\n.mdi-tea-outline::before {\n  content: \"\\F0D9F\";\n}\n\n.mdi-teamviewer::before {\n  content: \"\\F0500\";\n}\n\n.mdi-teddy-bear::before {\n  content: \"\\F18FB\";\n}\n\n.mdi-telescope::before {\n  content: \"\\F0B4E\";\n}\n\n.mdi-television::before {\n  content: \"\\F0502\";\n}\n\n.mdi-television-ambient-light::before {\n  content: \"\\F1356\";\n}\n\n.mdi-television-box::before {\n  content: \"\\F0839\";\n}\n\n.mdi-television-classic::before {\n  content: \"\\F07F4\";\n}\n\n.mdi-television-classic-off::before {\n  content: \"\\F083A\";\n}\n\n.mdi-television-guide::before {\n  content: \"\\F0503\";\n}\n\n.mdi-television-off::before {\n  content: \"\\F083B\";\n}\n\n.mdi-television-pause::before {\n  content: \"\\F0F89\";\n}\n\n.mdi-television-play::before {\n  content: \"\\F0ECF\";\n}\n\n.mdi-television-shimmer::before {\n  content: \"\\F1110\";\n}\n\n.mdi-television-stop::before {\n  content: \"\\F0F8A\";\n}\n\n.mdi-temperature-celsius::before {\n  content: \"\\F0504\";\n}\n\n.mdi-temperature-fahrenheit::before {\n  content: \"\\F0505\";\n}\n\n.mdi-temperature-kelvin::before {\n  content: \"\\F0506\";\n}\n\n.mdi-tennis::before {\n  content: \"\\F0DA0\";\n}\n\n.mdi-tennis-ball::before {\n  content: \"\\F0507\";\n}\n\n.mdi-tent::before {\n  content: \"\\F0508\";\n}\n\n.mdi-terraform::before {\n  content: \"\\F1062\";\n}\n\n.mdi-terrain::before {\n  content: \"\\F0509\";\n}\n\n.mdi-test-tube::before {\n  content: \"\\F0668\";\n}\n\n.mdi-test-tube-empty::before {\n  content: \"\\F0911\";\n}\n\n.mdi-test-tube-off::before {\n  content: \"\\F0912\";\n}\n\n.mdi-text::before {\n  content: \"\\F09A8\";\n}\n\n.mdi-text-account::before {\n  content: \"\\F1570\";\n}\n\n.mdi-text-box::before {\n  content: \"\\F021A\";\n}\n\n.mdi-text-box-check::before {\n  content: \"\\F0EA6\";\n}\n\n.mdi-text-box-check-outline::before {\n  content: \"\\F0EA7\";\n}\n\n.mdi-text-box-minus::before {\n  content: \"\\F0EA8\";\n}\n\n.mdi-text-box-minus-outline::before {\n  content: \"\\F0EA9\";\n}\n\n.mdi-text-box-multiple::before {\n  content: \"\\F0AB7\";\n}\n\n.mdi-text-box-multiple-outline::before {\n  content: \"\\F0AB8\";\n}\n\n.mdi-text-box-outline::before {\n  content: \"\\F09ED\";\n}\n\n.mdi-text-box-plus::before {\n  content: \"\\F0EAA\";\n}\n\n.mdi-text-box-plus-outline::before {\n  content: \"\\F0EAB\";\n}\n\n.mdi-text-box-remove::before {\n  content: \"\\F0EAC\";\n}\n\n.mdi-text-box-remove-outline::before {\n  content: \"\\F0EAD\";\n}\n\n.mdi-text-box-search::before {\n  content: \"\\F0EAE\";\n}\n\n.mdi-text-box-search-outline::before {\n  content: \"\\F0EAF\";\n}\n\n.mdi-text-long::before {\n  content: \"\\F09AA\";\n}\n\n.mdi-text-recognition::before {\n  content: \"\\F113D\";\n}\n\n.mdi-text-search::before {\n  content: \"\\F13B8\";\n}\n\n.mdi-text-shadow::before {\n  content: \"\\F0669\";\n}\n\n.mdi-text-short::before {\n  content: \"\\F09A9\";\n}\n\n.mdi-text-to-speech::before {\n  content: \"\\F050A\";\n}\n\n.mdi-text-to-speech-off::before {\n  content: \"\\F050B\";\n}\n\n.mdi-texture::before {\n  content: \"\\F050C\";\n}\n\n.mdi-texture-box::before {\n  content: \"\\F0FE6\";\n}\n\n.mdi-theater::before {\n  content: \"\\F050D\";\n}\n\n.mdi-theme-light-dark::before {\n  content: \"\\F050E\";\n}\n\n.mdi-thermometer::before {\n  content: \"\\F050F\";\n}\n\n.mdi-thermometer-alert::before {\n  content: \"\\F0E01\";\n}\n\n.mdi-thermometer-bluetooth::before {\n  content: \"\\F1895\";\n}\n\n.mdi-thermometer-chevron-down::before {\n  content: \"\\F0E02\";\n}\n\n.mdi-thermometer-chevron-up::before {\n  content: \"\\F0E03\";\n}\n\n.mdi-thermometer-high::before {\n  content: \"\\F10C2\";\n}\n\n.mdi-thermometer-lines::before {\n  content: \"\\F0510\";\n}\n\n.mdi-thermometer-low::before {\n  content: \"\\F10C3\";\n}\n\n.mdi-thermometer-minus::before {\n  content: \"\\F0E04\";\n}\n\n.mdi-thermometer-off::before {\n  content: \"\\F1531\";\n}\n\n.mdi-thermometer-plus::before {\n  content: \"\\F0E05\";\n}\n\n.mdi-thermostat::before {\n  content: \"\\F0393\";\n}\n\n.mdi-thermostat-box::before {\n  content: \"\\F0891\";\n}\n\n.mdi-thought-bubble::before {\n  content: \"\\F07F6\";\n}\n\n.mdi-thought-bubble-outline::before {\n  content: \"\\F07F7\";\n}\n\n.mdi-thumb-down::before {\n  content: \"\\F0511\";\n}\n\n.mdi-thumb-down-outline::before {\n  content: \"\\F0512\";\n}\n\n.mdi-thumb-up::before {\n  content: \"\\F0513\";\n}\n\n.mdi-thumb-up-outline::before {\n  content: \"\\F0514\";\n}\n\n.mdi-thumbs-up-down::before {\n  content: \"\\F0515\";\n}\n\n.mdi-thumbs-up-down-outline::before {\n  content: \"\\F1914\";\n}\n\n.mdi-ticket::before {\n  content: \"\\F0516\";\n}\n\n.mdi-ticket-account::before {\n  content: \"\\F0517\";\n}\n\n.mdi-ticket-confirmation::before {\n  content: \"\\F0518\";\n}\n\n.mdi-ticket-confirmation-outline::before {\n  content: \"\\F13AA\";\n}\n\n.mdi-ticket-outline::before {\n  content: \"\\F0913\";\n}\n\n.mdi-ticket-percent::before {\n  content: \"\\F0724\";\n}\n\n.mdi-ticket-percent-outline::before {\n  content: \"\\F142B\";\n}\n\n.mdi-tie::before {\n  content: \"\\F0519\";\n}\n\n.mdi-tilde::before {\n  content: \"\\F0725\";\n}\n\n.mdi-tilde-off::before {\n  content: \"\\F18F3\";\n}\n\n.mdi-timelapse::before {\n  content: \"\\F051A\";\n}\n\n.mdi-timeline::before {\n  content: \"\\F0BD1\";\n}\n\n.mdi-timeline-alert::before {\n  content: \"\\F0F95\";\n}\n\n.mdi-timeline-alert-outline::before {\n  content: \"\\F0F98\";\n}\n\n.mdi-timeline-check::before {\n  content: \"\\F1532\";\n}\n\n.mdi-timeline-check-outline::before {\n  content: \"\\F1533\";\n}\n\n.mdi-timeline-clock::before {\n  content: \"\\F11FB\";\n}\n\n.mdi-timeline-clock-outline::before {\n  content: \"\\F11FC\";\n}\n\n.mdi-timeline-help::before {\n  content: \"\\F0F99\";\n}\n\n.mdi-timeline-help-outline::before {\n  content: \"\\F0F9A\";\n}\n\n.mdi-timeline-minus::before {\n  content: \"\\F1534\";\n}\n\n.mdi-timeline-minus-outline::before {\n  content: \"\\F1535\";\n}\n\n.mdi-timeline-outline::before {\n  content: \"\\F0BD2\";\n}\n\n.mdi-timeline-plus::before {\n  content: \"\\F0F96\";\n}\n\n.mdi-timeline-plus-outline::before {\n  content: \"\\F0F97\";\n}\n\n.mdi-timeline-remove::before {\n  content: \"\\F1536\";\n}\n\n.mdi-timeline-remove-outline::before {\n  content: \"\\F1537\";\n}\n\n.mdi-timeline-text::before {\n  content: \"\\F0BD3\";\n}\n\n.mdi-timeline-text-outline::before {\n  content: \"\\F0BD4\";\n}\n\n.mdi-timer::before {\n  content: \"\\F13AB\";\n}\n\n.mdi-timer-10::before {\n  content: \"\\F051C\";\n}\n\n.mdi-timer-3::before {\n  content: \"\\F051D\";\n}\n\n.mdi-timer-cog::before {\n  content: \"\\F1925\";\n}\n\n.mdi-timer-cog-outline::before {\n  content: \"\\F1926\";\n}\n\n.mdi-timer-off::before {\n  content: \"\\F13AC\";\n}\n\n.mdi-timer-off-outline::before {\n  content: \"\\F051E\";\n}\n\n.mdi-timer-outline::before {\n  content: \"\\F051B\";\n}\n\n.mdi-timer-sand::before {\n  content: \"\\F051F\";\n}\n\n.mdi-timer-sand-complete::before {\n  content: \"\\F199F\";\n}\n\n.mdi-timer-sand-empty::before {\n  content: \"\\F06AD\";\n}\n\n.mdi-timer-sand-full::before {\n  content: \"\\F078C\";\n}\n\n.mdi-timer-sand-paused::before {\n  content: \"\\F19A0\";\n}\n\n.mdi-timer-settings::before {\n  content: \"\\F1923\";\n}\n\n.mdi-timer-settings-outline::before {\n  content: \"\\F1924\";\n}\n\n.mdi-timetable::before {\n  content: \"\\F0520\";\n}\n\n.mdi-tire::before {\n  content: \"\\F1896\";\n}\n\n.mdi-toaster::before {\n  content: \"\\F1063\";\n}\n\n.mdi-toaster-off::before {\n  content: \"\\F11B7\";\n}\n\n.mdi-toaster-oven::before {\n  content: \"\\F0CD3\";\n}\n\n.mdi-toggle-switch::before {\n  content: \"\\F0521\";\n}\n\n.mdi-toggle-switch-off::before {\n  content: \"\\F0522\";\n}\n\n.mdi-toggle-switch-off-outline::before {\n  content: \"\\F0A19\";\n}\n\n.mdi-toggle-switch-outline::before {\n  content: \"\\F0A1A\";\n}\n\n.mdi-toilet::before {\n  content: \"\\F09AB\";\n}\n\n.mdi-toolbox::before {\n  content: \"\\F09AC\";\n}\n\n.mdi-toolbox-outline::before {\n  content: \"\\F09AD\";\n}\n\n.mdi-tools::before {\n  content: \"\\F1064\";\n}\n\n.mdi-tooltip::before {\n  content: \"\\F0523\";\n}\n\n.mdi-tooltip-account::before {\n  content: \"\\F000C\";\n}\n\n.mdi-tooltip-cellphone::before {\n  content: \"\\F183B\";\n}\n\n.mdi-tooltip-check::before {\n  content: \"\\F155C\";\n}\n\n.mdi-tooltip-check-outline::before {\n  content: \"\\F155D\";\n}\n\n.mdi-tooltip-edit::before {\n  content: \"\\F0524\";\n}\n\n.mdi-tooltip-edit-outline::before {\n  content: \"\\F12C5\";\n}\n\n.mdi-tooltip-image::before {\n  content: \"\\F0525\";\n}\n\n.mdi-tooltip-image-outline::before {\n  content: \"\\F0BD5\";\n}\n\n.mdi-tooltip-minus::before {\n  content: \"\\F155E\";\n}\n\n.mdi-tooltip-minus-outline::before {\n  content: \"\\F155F\";\n}\n\n.mdi-tooltip-outline::before {\n  content: \"\\F0526\";\n}\n\n.mdi-tooltip-plus::before {\n  content: \"\\F0BD6\";\n}\n\n.mdi-tooltip-plus-outline::before {\n  content: \"\\F0527\";\n}\n\n.mdi-tooltip-remove::before {\n  content: \"\\F1560\";\n}\n\n.mdi-tooltip-remove-outline::before {\n  content: \"\\F1561\";\n}\n\n.mdi-tooltip-text::before {\n  content: \"\\F0528\";\n}\n\n.mdi-tooltip-text-outline::before {\n  content: \"\\F0BD7\";\n}\n\n.mdi-tooth::before {\n  content: \"\\F08C3\";\n}\n\n.mdi-tooth-outline::before {\n  content: \"\\F0529\";\n}\n\n.mdi-toothbrush::before {\n  content: \"\\F1129\";\n}\n\n.mdi-toothbrush-electric::before {\n  content: \"\\F112C\";\n}\n\n.mdi-toothbrush-paste::before {\n  content: \"\\F112A\";\n}\n\n.mdi-torch::before {\n  content: \"\\F1606\";\n}\n\n.mdi-tortoise::before {\n  content: \"\\F0D3B\";\n}\n\n.mdi-toslink::before {\n  content: \"\\F12B8\";\n}\n\n.mdi-tournament::before {\n  content: \"\\F09AE\";\n}\n\n.mdi-tow-truck::before {\n  content: \"\\F083C\";\n}\n\n.mdi-tower-beach::before {\n  content: \"\\F0681\";\n}\n\n.mdi-tower-fire::before {\n  content: \"\\F0682\";\n}\n\n.mdi-town-hall::before {\n  content: \"\\F1875\";\n}\n\n.mdi-toy-brick::before {\n  content: \"\\F1288\";\n}\n\n.mdi-toy-brick-marker::before {\n  content: \"\\F1289\";\n}\n\n.mdi-toy-brick-marker-outline::before {\n  content: \"\\F128A\";\n}\n\n.mdi-toy-brick-minus::before {\n  content: \"\\F128B\";\n}\n\n.mdi-toy-brick-minus-outline::before {\n  content: \"\\F128C\";\n}\n\n.mdi-toy-brick-outline::before {\n  content: \"\\F128D\";\n}\n\n.mdi-toy-brick-plus::before {\n  content: \"\\F128E\";\n}\n\n.mdi-toy-brick-plus-outline::before {\n  content: \"\\F128F\";\n}\n\n.mdi-toy-brick-remove::before {\n  content: \"\\F1290\";\n}\n\n.mdi-toy-brick-remove-outline::before {\n  content: \"\\F1291\";\n}\n\n.mdi-toy-brick-search::before {\n  content: \"\\F1292\";\n}\n\n.mdi-toy-brick-search-outline::before {\n  content: \"\\F1293\";\n}\n\n.mdi-track-light::before {\n  content: \"\\F0914\";\n}\n\n.mdi-trackpad::before {\n  content: \"\\F07F8\";\n}\n\n.mdi-trackpad-lock::before {\n  content: \"\\F0933\";\n}\n\n.mdi-tractor::before {\n  content: \"\\F0892\";\n}\n\n.mdi-tractor-variant::before {\n  content: \"\\F14C4\";\n}\n\n.mdi-trademark::before {\n  content: \"\\F0A78\";\n}\n\n.mdi-traffic-cone::before {\n  content: \"\\F137C\";\n}\n\n.mdi-traffic-light::before {\n  content: \"\\F052B\";\n}\n\n.mdi-traffic-light-outline::before {\n  content: \"\\F182A\";\n}\n\n.mdi-train::before {\n  content: \"\\F052C\";\n}\n\n.mdi-train-car::before {\n  content: \"\\F0BD8\";\n}\n\n.mdi-train-car-passenger::before {\n  content: \"\\F1733\";\n}\n\n.mdi-train-car-passenger-door::before {\n  content: \"\\F1734\";\n}\n\n.mdi-train-car-passenger-door-open::before {\n  content: \"\\F1735\";\n}\n\n.mdi-train-car-passenger-variant::before {\n  content: \"\\F1736\";\n}\n\n.mdi-train-variant::before {\n  content: \"\\F08C4\";\n}\n\n.mdi-tram::before {\n  content: \"\\F052D\";\n}\n\n.mdi-tram-side::before {\n  content: \"\\F0FE7\";\n}\n\n.mdi-transcribe::before {\n  content: \"\\F052E\";\n}\n\n.mdi-transcribe-close::before {\n  content: \"\\F052F\";\n}\n\n.mdi-transfer::before {\n  content: \"\\F1065\";\n}\n\n.mdi-transfer-down::before {\n  content: \"\\F0DA1\";\n}\n\n.mdi-transfer-left::before {\n  content: \"\\F0DA2\";\n}\n\n.mdi-transfer-right::before {\n  content: \"\\F0530\";\n}\n\n.mdi-transfer-up::before {\n  content: \"\\F0DA3\";\n}\n\n.mdi-transit-connection::before {\n  content: \"\\F0D3C\";\n}\n\n.mdi-transit-connection-horizontal::before {\n  content: \"\\F1546\";\n}\n\n.mdi-transit-connection-variant::before {\n  content: \"\\F0D3D\";\n}\n\n.mdi-transit-detour::before {\n  content: \"\\F0F8B\";\n}\n\n.mdi-transit-skip::before {\n  content: \"\\F1515\";\n}\n\n.mdi-transit-transfer::before {\n  content: \"\\F06AE\";\n}\n\n.mdi-transition::before {\n  content: \"\\F0915\";\n}\n\n.mdi-transition-masked::before {\n  content: \"\\F0916\";\n}\n\n.mdi-translate::before {\n  content: \"\\F05CA\";\n}\n\n.mdi-translate-off::before {\n  content: \"\\F0E06\";\n}\n\n.mdi-transmission-tower::before {\n  content: \"\\F0D3E\";\n}\n\n.mdi-transmission-tower-export::before {\n  content: \"\\F192C\";\n}\n\n.mdi-transmission-tower-import::before {\n  content: \"\\F192D\";\n}\n\n.mdi-trash-can::before {\n  content: \"\\F0A79\";\n}\n\n.mdi-trash-can-outline::before {\n  content: \"\\F0A7A\";\n}\n\n.mdi-tray::before {\n  content: \"\\F1294\";\n}\n\n.mdi-tray-alert::before {\n  content: \"\\F1295\";\n}\n\n.mdi-tray-arrow-down::before {\n  content: \"\\F0120\";\n}\n\n.mdi-tray-arrow-up::before {\n  content: \"\\F011D\";\n}\n\n.mdi-tray-full::before {\n  content: \"\\F1296\";\n}\n\n.mdi-tray-minus::before {\n  content: \"\\F1297\";\n}\n\n.mdi-tray-plus::before {\n  content: \"\\F1298\";\n}\n\n.mdi-tray-remove::before {\n  content: \"\\F1299\";\n}\n\n.mdi-treasure-chest::before {\n  content: \"\\F0726\";\n}\n\n.mdi-tree::before {\n  content: \"\\F0531\";\n}\n\n.mdi-tree-outline::before {\n  content: \"\\F0E69\";\n}\n\n.mdi-trello::before {\n  content: \"\\F0532\";\n}\n\n.mdi-trending-down::before {\n  content: \"\\F0533\";\n}\n\n.mdi-trending-neutral::before {\n  content: \"\\F0534\";\n}\n\n.mdi-trending-up::before {\n  content: \"\\F0535\";\n}\n\n.mdi-triangle::before {\n  content: \"\\F0536\";\n}\n\n.mdi-triangle-outline::before {\n  content: \"\\F0537\";\n}\n\n.mdi-triangle-wave::before {\n  content: \"\\F147C\";\n}\n\n.mdi-triforce::before {\n  content: \"\\F0BD9\";\n}\n\n.mdi-trophy::before {\n  content: \"\\F0538\";\n}\n\n.mdi-trophy-award::before {\n  content: \"\\F0539\";\n}\n\n.mdi-trophy-broken::before {\n  content: \"\\F0DA4\";\n}\n\n.mdi-trophy-outline::before {\n  content: \"\\F053A\";\n}\n\n.mdi-trophy-variant::before {\n  content: \"\\F053B\";\n}\n\n.mdi-trophy-variant-outline::before {\n  content: \"\\F053C\";\n}\n\n.mdi-truck::before {\n  content: \"\\F053D\";\n}\n\n.mdi-truck-cargo-container::before {\n  content: \"\\F18D8\";\n}\n\n.mdi-truck-check::before {\n  content: \"\\F0CD4\";\n}\n\n.mdi-truck-check-outline::before {\n  content: \"\\F129A\";\n}\n\n.mdi-truck-delivery::before {\n  content: \"\\F053E\";\n}\n\n.mdi-truck-delivery-outline::before {\n  content: \"\\F129B\";\n}\n\n.mdi-truck-fast::before {\n  content: \"\\F0788\";\n}\n\n.mdi-truck-fast-outline::before {\n  content: \"\\F129C\";\n}\n\n.mdi-truck-flatbed::before {\n  content: \"\\F1891\";\n}\n\n.mdi-truck-minus::before {\n  content: \"\\F19AE\";\n}\n\n.mdi-truck-minus-outline::before {\n  content: \"\\F19BD\";\n}\n\n.mdi-truck-outline::before {\n  content: \"\\F129D\";\n}\n\n.mdi-truck-plus::before {\n  content: \"\\F19AD\";\n}\n\n.mdi-truck-plus-outline::before {\n  content: \"\\F19BC\";\n}\n\n.mdi-truck-remove::before {\n  content: \"\\F19AF\";\n}\n\n.mdi-truck-remove-outline::before {\n  content: \"\\F19BE\";\n}\n\n.mdi-truck-snowflake::before {\n  content: \"\\F19A6\";\n}\n\n.mdi-truck-trailer::before {\n  content: \"\\F0727\";\n}\n\n.mdi-trumpet::before {\n  content: \"\\F1096\";\n}\n\n.mdi-tshirt-crew::before {\n  content: \"\\F0A7B\";\n}\n\n.mdi-tshirt-crew-outline::before {\n  content: \"\\F053F\";\n}\n\n.mdi-tshirt-v::before {\n  content: \"\\F0A7C\";\n}\n\n.mdi-tshirt-v-outline::before {\n  content: \"\\F0540\";\n}\n\n.mdi-tumble-dryer::before {\n  content: \"\\F0917\";\n}\n\n.mdi-tumble-dryer-alert::before {\n  content: \"\\F11BA\";\n}\n\n.mdi-tumble-dryer-off::before {\n  content: \"\\F11BB\";\n}\n\n.mdi-tune::before {\n  content: \"\\F062E\";\n}\n\n.mdi-tune-variant::before {\n  content: \"\\F1542\";\n}\n\n.mdi-tune-vertical::before {\n  content: \"\\F066A\";\n}\n\n.mdi-tune-vertical-variant::before {\n  content: \"\\F1543\";\n}\n\n.mdi-tunnel::before {\n  content: \"\\F183D\";\n}\n\n.mdi-tunnel-outline::before {\n  content: \"\\F183E\";\n}\n\n.mdi-turkey::before {\n  content: \"\\F171B\";\n}\n\n.mdi-turnstile::before {\n  content: \"\\F0CD5\";\n}\n\n.mdi-turnstile-outline::before {\n  content: \"\\F0CD6\";\n}\n\n.mdi-turtle::before {\n  content: \"\\F0CD7\";\n}\n\n.mdi-twitch::before {\n  content: \"\\F0543\";\n}\n\n.mdi-twitter::before {\n  content: \"\\F0544\";\n}\n\n.mdi-two-factor-authentication::before {\n  content: \"\\F09AF\";\n}\n\n.mdi-typewriter::before {\n  content: \"\\F0F2D\";\n}\n\n.mdi-ubisoft::before {\n  content: \"\\F0BDA\";\n}\n\n.mdi-ubuntu::before {\n  content: \"\\F0548\";\n}\n\n.mdi-ufo::before {\n  content: \"\\F10C4\";\n}\n\n.mdi-ufo-outline::before {\n  content: \"\\F10C5\";\n}\n\n.mdi-ultra-high-definition::before {\n  content: \"\\F07F9\";\n}\n\n.mdi-umbraco::before {\n  content: \"\\F0549\";\n}\n\n.mdi-umbrella::before {\n  content: \"\\F054A\";\n}\n\n.mdi-umbrella-beach::before {\n  content: \"\\F188A\";\n}\n\n.mdi-umbrella-beach-outline::before {\n  content: \"\\F188B\";\n}\n\n.mdi-umbrella-closed::before {\n  content: \"\\F09B0\";\n}\n\n.mdi-umbrella-closed-outline::before {\n  content: \"\\F13E2\";\n}\n\n.mdi-umbrella-closed-variant::before {\n  content: \"\\F13E1\";\n}\n\n.mdi-umbrella-outline::before {\n  content: \"\\F054B\";\n}\n\n.mdi-undo::before {\n  content: \"\\F054C\";\n}\n\n.mdi-undo-variant::before {\n  content: \"\\F054D\";\n}\n\n.mdi-unfold-less-horizontal::before {\n  content: \"\\F054E\";\n}\n\n.mdi-unfold-less-vertical::before {\n  content: \"\\F0760\";\n}\n\n.mdi-unfold-more-horizontal::before {\n  content: \"\\F054F\";\n}\n\n.mdi-unfold-more-vertical::before {\n  content: \"\\F0761\";\n}\n\n.mdi-ungroup::before {\n  content: \"\\F0550\";\n}\n\n.mdi-unicode::before {\n  content: \"\\F0ED0\";\n}\n\n.mdi-unicorn::before {\n  content: \"\\F15C2\";\n}\n\n.mdi-unicorn-variant::before {\n  content: \"\\F15C3\";\n}\n\n.mdi-unicycle::before {\n  content: \"\\F15E5\";\n}\n\n.mdi-unity::before {\n  content: \"\\F06AF\";\n}\n\n.mdi-unreal::before {\n  content: \"\\F09B1\";\n}\n\n.mdi-update::before {\n  content: \"\\F06B0\";\n}\n\n.mdi-upload::before {\n  content: \"\\F0552\";\n}\n\n.mdi-upload-lock::before {\n  content: \"\\F1373\";\n}\n\n.mdi-upload-lock-outline::before {\n  content: \"\\F1374\";\n}\n\n.mdi-upload-multiple::before {\n  content: \"\\F083D\";\n}\n\n.mdi-upload-network::before {\n  content: \"\\F06F6\";\n}\n\n.mdi-upload-network-outline::before {\n  content: \"\\F0CD8\";\n}\n\n.mdi-upload-off::before {\n  content: \"\\F10C6\";\n}\n\n.mdi-upload-off-outline::before {\n  content: \"\\F10C7\";\n}\n\n.mdi-upload-outline::before {\n  content: \"\\F0E07\";\n}\n\n.mdi-usb::before {\n  content: \"\\F0553\";\n}\n\n.mdi-usb-flash-drive::before {\n  content: \"\\F129E\";\n}\n\n.mdi-usb-flash-drive-outline::before {\n  content: \"\\F129F\";\n}\n\n.mdi-usb-port::before {\n  content: \"\\F11F0\";\n}\n\n.mdi-vacuum::before {\n  content: \"\\F19A1\";\n}\n\n.mdi-vacuum-outline::before {\n  content: \"\\F19A2\";\n}\n\n.mdi-valve::before {\n  content: \"\\F1066\";\n}\n\n.mdi-valve-closed::before {\n  content: \"\\F1067\";\n}\n\n.mdi-valve-open::before {\n  content: \"\\F1068\";\n}\n\n.mdi-van-passenger::before {\n  content: \"\\F07FA\";\n}\n\n.mdi-van-utility::before {\n  content: \"\\F07FB\";\n}\n\n.mdi-vanish::before {\n  content: \"\\F07FC\";\n}\n\n.mdi-vanish-quarter::before {\n  content: \"\\F1554\";\n}\n\n.mdi-vanity-light::before {\n  content: \"\\F11E1\";\n}\n\n.mdi-variable::before {\n  content: \"\\F0AE7\";\n}\n\n.mdi-variable-box::before {\n  content: \"\\F1111\";\n}\n\n.mdi-vector-arrange-above::before {\n  content: \"\\F0554\";\n}\n\n.mdi-vector-arrange-below::before {\n  content: \"\\F0555\";\n}\n\n.mdi-vector-bezier::before {\n  content: \"\\F0AE8\";\n}\n\n.mdi-vector-circle::before {\n  content: \"\\F0556\";\n}\n\n.mdi-vector-circle-variant::before {\n  content: \"\\F0557\";\n}\n\n.mdi-vector-combine::before {\n  content: \"\\F0558\";\n}\n\n.mdi-vector-curve::before {\n  content: \"\\F0559\";\n}\n\n.mdi-vector-difference::before {\n  content: \"\\F055A\";\n}\n\n.mdi-vector-difference-ab::before {\n  content: \"\\F055B\";\n}\n\n.mdi-vector-difference-ba::before {\n  content: \"\\F055C\";\n}\n\n.mdi-vector-ellipse::before {\n  content: \"\\F0893\";\n}\n\n.mdi-vector-intersection::before {\n  content: \"\\F055D\";\n}\n\n.mdi-vector-line::before {\n  content: \"\\F055E\";\n}\n\n.mdi-vector-link::before {\n  content: \"\\F0FE8\";\n}\n\n.mdi-vector-point::before {\n  content: \"\\F055F\";\n}\n\n.mdi-vector-polygon::before {\n  content: \"\\F0560\";\n}\n\n.mdi-vector-polygon-variant::before {\n  content: \"\\F1856\";\n}\n\n.mdi-vector-polyline::before {\n  content: \"\\F0561\";\n}\n\n.mdi-vector-polyline-edit::before {\n  content: \"\\F1225\";\n}\n\n.mdi-vector-polyline-minus::before {\n  content: \"\\F1226\";\n}\n\n.mdi-vector-polyline-plus::before {\n  content: \"\\F1227\";\n}\n\n.mdi-vector-polyline-remove::before {\n  content: \"\\F1228\";\n}\n\n.mdi-vector-radius::before {\n  content: \"\\F074A\";\n}\n\n.mdi-vector-rectangle::before {\n  content: \"\\F05C6\";\n}\n\n.mdi-vector-selection::before {\n  content: \"\\F0562\";\n}\n\n.mdi-vector-square::before {\n  content: \"\\F0001\";\n}\n\n.mdi-vector-square-close::before {\n  content: \"\\F1857\";\n}\n\n.mdi-vector-square-edit::before {\n  content: \"\\F18D9\";\n}\n\n.mdi-vector-square-minus::before {\n  content: \"\\F18DA\";\n}\n\n.mdi-vector-square-open::before {\n  content: \"\\F1858\";\n}\n\n.mdi-vector-square-plus::before {\n  content: \"\\F18DB\";\n}\n\n.mdi-vector-square-remove::before {\n  content: \"\\F18DC\";\n}\n\n.mdi-vector-triangle::before {\n  content: \"\\F0563\";\n}\n\n.mdi-vector-union::before {\n  content: \"\\F0564\";\n}\n\n.mdi-vhs::before {\n  content: \"\\F0A1B\";\n}\n\n.mdi-vibrate::before {\n  content: \"\\F0566\";\n}\n\n.mdi-vibrate-off::before {\n  content: \"\\F0CD9\";\n}\n\n.mdi-video::before {\n  content: \"\\F0567\";\n}\n\n.mdi-video-3d::before {\n  content: \"\\F07FD\";\n}\n\n.mdi-video-3d-off::before {\n  content: \"\\F13D9\";\n}\n\n.mdi-video-3d-variant::before {\n  content: \"\\F0ED1\";\n}\n\n.mdi-video-4k-box::before {\n  content: \"\\F083E\";\n}\n\n.mdi-video-account::before {\n  content: \"\\F0919\";\n}\n\n.mdi-video-box::before {\n  content: \"\\F00FD\";\n}\n\n.mdi-video-box-off::before {\n  content: \"\\F00FE\";\n}\n\n.mdi-video-check::before {\n  content: \"\\F1069\";\n}\n\n.mdi-video-check-outline::before {\n  content: \"\\F106A\";\n}\n\n.mdi-video-high-definition::before {\n  content: \"\\F152E\";\n}\n\n.mdi-video-image::before {\n  content: \"\\F091A\";\n}\n\n.mdi-video-input-antenna::before {\n  content: \"\\F083F\";\n}\n\n.mdi-video-input-component::before {\n  content: \"\\F0840\";\n}\n\n.mdi-video-input-hdmi::before {\n  content: \"\\F0841\";\n}\n\n.mdi-video-input-scart::before {\n  content: \"\\F0F8C\";\n}\n\n.mdi-video-input-svideo::before {\n  content: \"\\F0842\";\n}\n\n.mdi-video-marker::before {\n  content: \"\\F19A9\";\n}\n\n.mdi-video-marker-outline::before {\n  content: \"\\F19AA\";\n}\n\n.mdi-video-minus::before {\n  content: \"\\F09B2\";\n}\n\n.mdi-video-minus-outline::before {\n  content: \"\\F02BA\";\n}\n\n.mdi-video-off::before {\n  content: \"\\F0568\";\n}\n\n.mdi-video-off-outline::before {\n  content: \"\\F0BDB\";\n}\n\n.mdi-video-outline::before {\n  content: \"\\F0BDC\";\n}\n\n.mdi-video-plus::before {\n  content: \"\\F09B3\";\n}\n\n.mdi-video-plus-outline::before {\n  content: \"\\F01D3\";\n}\n\n.mdi-video-stabilization::before {\n  content: \"\\F091B\";\n}\n\n.mdi-video-switch::before {\n  content: \"\\F0569\";\n}\n\n.mdi-video-switch-outline::before {\n  content: \"\\F0790\";\n}\n\n.mdi-video-vintage::before {\n  content: \"\\F0A1C\";\n}\n\n.mdi-video-wireless::before {\n  content: \"\\F0ED2\";\n}\n\n.mdi-video-wireless-outline::before {\n  content: \"\\F0ED3\";\n}\n\n.mdi-view-agenda::before {\n  content: \"\\F056A\";\n}\n\n.mdi-view-agenda-outline::before {\n  content: \"\\F11D8\";\n}\n\n.mdi-view-array::before {\n  content: \"\\F056B\";\n}\n\n.mdi-view-array-outline::before {\n  content: \"\\F1485\";\n}\n\n.mdi-view-carousel::before {\n  content: \"\\F056C\";\n}\n\n.mdi-view-carousel-outline::before {\n  content: \"\\F1486\";\n}\n\n.mdi-view-column::before {\n  content: \"\\F056D\";\n}\n\n.mdi-view-column-outline::before {\n  content: \"\\F1487\";\n}\n\n.mdi-view-comfy::before {\n  content: \"\\F0E6A\";\n}\n\n.mdi-view-comfy-outline::before {\n  content: \"\\F1488\";\n}\n\n.mdi-view-compact::before {\n  content: \"\\F0E6B\";\n}\n\n.mdi-view-compact-outline::before {\n  content: \"\\F0E6C\";\n}\n\n.mdi-view-dashboard::before {\n  content: \"\\F056E\";\n}\n\n.mdi-view-dashboard-edit::before {\n  content: \"\\F1947\";\n}\n\n.mdi-view-dashboard-edit-outline::before {\n  content: \"\\F1948\";\n}\n\n.mdi-view-dashboard-outline::before {\n  content: \"\\F0A1D\";\n}\n\n.mdi-view-dashboard-variant::before {\n  content: \"\\F0843\";\n}\n\n.mdi-view-dashboard-variant-outline::before {\n  content: \"\\F1489\";\n}\n\n.mdi-view-day::before {\n  content: \"\\F056F\";\n}\n\n.mdi-view-day-outline::before {\n  content: \"\\F148A\";\n}\n\n.mdi-view-gallery::before {\n  content: \"\\F1888\";\n}\n\n.mdi-view-gallery-outline::before {\n  content: \"\\F1889\";\n}\n\n.mdi-view-grid::before {\n  content: \"\\F0570\";\n}\n\n.mdi-view-grid-outline::before {\n  content: \"\\F11D9\";\n}\n\n.mdi-view-grid-plus::before {\n  content: \"\\F0F8D\";\n}\n\n.mdi-view-grid-plus-outline::before {\n  content: \"\\F11DA\";\n}\n\n.mdi-view-headline::before {\n  content: \"\\F0571\";\n}\n\n.mdi-view-list::before {\n  content: \"\\F0572\";\n}\n\n.mdi-view-list-outline::before {\n  content: \"\\F148B\";\n}\n\n.mdi-view-module::before {\n  content: \"\\F0573\";\n}\n\n.mdi-view-module-outline::before {\n  content: \"\\F148C\";\n}\n\n.mdi-view-parallel::before {\n  content: \"\\F0728\";\n}\n\n.mdi-view-parallel-outline::before {\n  content: \"\\F148D\";\n}\n\n.mdi-view-quilt::before {\n  content: \"\\F0574\";\n}\n\n.mdi-view-quilt-outline::before {\n  content: \"\\F148E\";\n}\n\n.mdi-view-sequential::before {\n  content: \"\\F0729\";\n}\n\n.mdi-view-sequential-outline::before {\n  content: \"\\F148F\";\n}\n\n.mdi-view-split-horizontal::before {\n  content: \"\\F0BCB\";\n}\n\n.mdi-view-split-vertical::before {\n  content: \"\\F0BCC\";\n}\n\n.mdi-view-stream::before {\n  content: \"\\F0575\";\n}\n\n.mdi-view-stream-outline::before {\n  content: \"\\F1490\";\n}\n\n.mdi-view-week::before {\n  content: \"\\F0576\";\n}\n\n.mdi-view-week-outline::before {\n  content: \"\\F1491\";\n}\n\n.mdi-vimeo::before {\n  content: \"\\F0577\";\n}\n\n.mdi-violin::before {\n  content: \"\\F060F\";\n}\n\n.mdi-virtual-reality::before {\n  content: \"\\F0894\";\n}\n\n.mdi-virus::before {\n  content: \"\\F13B6\";\n}\n\n.mdi-virus-off::before {\n  content: \"\\F18E1\";\n}\n\n.mdi-virus-off-outline::before {\n  content: \"\\F18E2\";\n}\n\n.mdi-virus-outline::before {\n  content: \"\\F13B7\";\n}\n\n.mdi-vlc::before {\n  content: \"\\F057C\";\n}\n\n.mdi-voicemail::before {\n  content: \"\\F057D\";\n}\n\n.mdi-volleyball::before {\n  content: \"\\F09B4\";\n}\n\n.mdi-volume-high::before {\n  content: \"\\F057E\";\n}\n\n.mdi-volume-low::before {\n  content: \"\\F057F\";\n}\n\n.mdi-volume-medium::before {\n  content: \"\\F0580\";\n}\n\n.mdi-volume-minus::before {\n  content: \"\\F075E\";\n}\n\n.mdi-volume-mute::before {\n  content: \"\\F075F\";\n}\n\n.mdi-volume-off::before {\n  content: \"\\F0581\";\n}\n\n.mdi-volume-plus::before {\n  content: \"\\F075D\";\n}\n\n.mdi-volume-source::before {\n  content: \"\\F1120\";\n}\n\n.mdi-volume-variant-off::before {\n  content: \"\\F0E08\";\n}\n\n.mdi-volume-vibrate::before {\n  content: \"\\F1121\";\n}\n\n.mdi-vote::before {\n  content: \"\\F0A1F\";\n}\n\n.mdi-vote-outline::before {\n  content: \"\\F0A20\";\n}\n\n.mdi-vpn::before {\n  content: \"\\F0582\";\n}\n\n.mdi-vuejs::before {\n  content: \"\\F0844\";\n}\n\n.mdi-vuetify::before {\n  content: \"\\F0E6D\";\n}\n\n.mdi-walk::before {\n  content: \"\\F0583\";\n}\n\n.mdi-wall::before {\n  content: \"\\F07FE\";\n}\n\n.mdi-wall-sconce::before {\n  content: \"\\F091C\";\n}\n\n.mdi-wall-sconce-flat::before {\n  content: \"\\F091D\";\n}\n\n.mdi-wall-sconce-flat-outline::before {\n  content: \"\\F17C9\";\n}\n\n.mdi-wall-sconce-flat-variant::before {\n  content: \"\\F041C\";\n}\n\n.mdi-wall-sconce-flat-variant-outline::before {\n  content: \"\\F17CA\";\n}\n\n.mdi-wall-sconce-outline::before {\n  content: \"\\F17CB\";\n}\n\n.mdi-wall-sconce-round::before {\n  content: \"\\F0748\";\n}\n\n.mdi-wall-sconce-round-outline::before {\n  content: \"\\F17CC\";\n}\n\n.mdi-wall-sconce-round-variant::before {\n  content: \"\\F091E\";\n}\n\n.mdi-wall-sconce-round-variant-outline::before {\n  content: \"\\F17CD\";\n}\n\n.mdi-wallet::before {\n  content: \"\\F0584\";\n}\n\n.mdi-wallet-giftcard::before {\n  content: \"\\F0585\";\n}\n\n.mdi-wallet-membership::before {\n  content: \"\\F0586\";\n}\n\n.mdi-wallet-outline::before {\n  content: \"\\F0BDD\";\n}\n\n.mdi-wallet-plus::before {\n  content: \"\\F0F8E\";\n}\n\n.mdi-wallet-plus-outline::before {\n  content: \"\\F0F8F\";\n}\n\n.mdi-wallet-travel::before {\n  content: \"\\F0587\";\n}\n\n.mdi-wallpaper::before {\n  content: \"\\F0E09\";\n}\n\n.mdi-wan::before {\n  content: \"\\F0588\";\n}\n\n.mdi-wardrobe::before {\n  content: \"\\F0F90\";\n}\n\n.mdi-wardrobe-outline::before {\n  content: \"\\F0F91\";\n}\n\n.mdi-warehouse::before {\n  content: \"\\F0F81\";\n}\n\n.mdi-washing-machine::before {\n  content: \"\\F072A\";\n}\n\n.mdi-washing-machine-alert::before {\n  content: \"\\F11BC\";\n}\n\n.mdi-washing-machine-off::before {\n  content: \"\\F11BD\";\n}\n\n.mdi-watch::before {\n  content: \"\\F0589\";\n}\n\n.mdi-watch-export::before {\n  content: \"\\F058A\";\n}\n\n.mdi-watch-export-variant::before {\n  content: \"\\F0895\";\n}\n\n.mdi-watch-import::before {\n  content: \"\\F058B\";\n}\n\n.mdi-watch-import-variant::before {\n  content: \"\\F0896\";\n}\n\n.mdi-watch-variant::before {\n  content: \"\\F0897\";\n}\n\n.mdi-watch-vibrate::before {\n  content: \"\\F06B1\";\n}\n\n.mdi-watch-vibrate-off::before {\n  content: \"\\F0CDA\";\n}\n\n.mdi-water::before {\n  content: \"\\F058C\";\n}\n\n.mdi-water-alert::before {\n  content: \"\\F1502\";\n}\n\n.mdi-water-alert-outline::before {\n  content: \"\\F1503\";\n}\n\n.mdi-water-boiler::before {\n  content: \"\\F0F92\";\n}\n\n.mdi-water-boiler-alert::before {\n  content: \"\\F11B3\";\n}\n\n.mdi-water-boiler-off::before {\n  content: \"\\F11B4\";\n}\n\n.mdi-water-check::before {\n  content: \"\\F1504\";\n}\n\n.mdi-water-check-outline::before {\n  content: \"\\F1505\";\n}\n\n.mdi-water-circle::before {\n  content: \"\\F1806\";\n}\n\n.mdi-water-minus::before {\n  content: \"\\F1506\";\n}\n\n.mdi-water-minus-outline::before {\n  content: \"\\F1507\";\n}\n\n.mdi-water-off::before {\n  content: \"\\F058D\";\n}\n\n.mdi-water-off-outline::before {\n  content: \"\\F1508\";\n}\n\n.mdi-water-opacity::before {\n  content: \"\\F1855\";\n}\n\n.mdi-water-outline::before {\n  content: \"\\F0E0A\";\n}\n\n.mdi-water-percent::before {\n  content: \"\\F058E\";\n}\n\n.mdi-water-percent-alert::before {\n  content: \"\\F1509\";\n}\n\n.mdi-water-plus::before {\n  content: \"\\F150A\";\n}\n\n.mdi-water-plus-outline::before {\n  content: \"\\F150B\";\n}\n\n.mdi-water-polo::before {\n  content: \"\\F12A0\";\n}\n\n.mdi-water-pump::before {\n  content: \"\\F058F\";\n}\n\n.mdi-water-pump-off::before {\n  content: \"\\F0F93\";\n}\n\n.mdi-water-remove::before {\n  content: \"\\F150C\";\n}\n\n.mdi-water-remove-outline::before {\n  content: \"\\F150D\";\n}\n\n.mdi-water-sync::before {\n  content: \"\\F17C6\";\n}\n\n.mdi-water-well::before {\n  content: \"\\F106B\";\n}\n\n.mdi-water-well-outline::before {\n  content: \"\\F106C\";\n}\n\n.mdi-waterfall::before {\n  content: \"\\F1849\";\n}\n\n.mdi-watering-can::before {\n  content: \"\\F1481\";\n}\n\n.mdi-watering-can-outline::before {\n  content: \"\\F1482\";\n}\n\n.mdi-watermark::before {\n  content: \"\\F0612\";\n}\n\n.mdi-wave::before {\n  content: \"\\F0F2E\";\n}\n\n.mdi-waveform::before {\n  content: \"\\F147D\";\n}\n\n.mdi-waves::before {\n  content: \"\\F078D\";\n}\n\n.mdi-waves-arrow-left::before {\n  content: \"\\F1859\";\n}\n\n.mdi-waves-arrow-right::before {\n  content: \"\\F185A\";\n}\n\n.mdi-waves-arrow-up::before {\n  content: \"\\F185B\";\n}\n\n.mdi-waze::before {\n  content: \"\\F0BDE\";\n}\n\n.mdi-weather-cloudy::before {\n  content: \"\\F0590\";\n}\n\n.mdi-weather-cloudy-alert::before {\n  content: \"\\F0F2F\";\n}\n\n.mdi-weather-cloudy-arrow-right::before {\n  content: \"\\F0E6E\";\n}\n\n.mdi-weather-cloudy-clock::before {\n  content: \"\\F18F6\";\n}\n\n.mdi-weather-fog::before {\n  content: \"\\F0591\";\n}\n\n.mdi-weather-hail::before {\n  content: \"\\F0592\";\n}\n\n.mdi-weather-hazy::before {\n  content: \"\\F0F30\";\n}\n\n.mdi-weather-hurricane::before {\n  content: \"\\F0898\";\n}\n\n.mdi-weather-lightning::before {\n  content: \"\\F0593\";\n}\n\n.mdi-weather-lightning-rainy::before {\n  content: \"\\F067E\";\n}\n\n.mdi-weather-night::before {\n  content: \"\\F0594\";\n}\n\n.mdi-weather-night-partly-cloudy::before {\n  content: \"\\F0F31\";\n}\n\n.mdi-weather-partly-cloudy::before {\n  content: \"\\F0595\";\n}\n\n.mdi-weather-partly-lightning::before {\n  content: \"\\F0F32\";\n}\n\n.mdi-weather-partly-rainy::before {\n  content: \"\\F0F33\";\n}\n\n.mdi-weather-partly-snowy::before {\n  content: \"\\F0F34\";\n}\n\n.mdi-weather-partly-snowy-rainy::before {\n  content: \"\\F0F35\";\n}\n\n.mdi-weather-pouring::before {\n  content: \"\\F0596\";\n}\n\n.mdi-weather-rainy::before {\n  content: \"\\F0597\";\n}\n\n.mdi-weather-snowy::before {\n  content: \"\\F0598\";\n}\n\n.mdi-weather-snowy-heavy::before {\n  content: \"\\F0F36\";\n}\n\n.mdi-weather-snowy-rainy::before {\n  content: \"\\F067F\";\n}\n\n.mdi-weather-sunny::before {\n  content: \"\\F0599\";\n}\n\n.mdi-weather-sunny-alert::before {\n  content: \"\\F0F37\";\n}\n\n.mdi-weather-sunny-off::before {\n  content: \"\\F14E4\";\n}\n\n.mdi-weather-sunset::before {\n  content: \"\\F059A\";\n}\n\n.mdi-weather-sunset-down::before {\n  content: \"\\F059B\";\n}\n\n.mdi-weather-sunset-up::before {\n  content: \"\\F059C\";\n}\n\n.mdi-weather-tornado::before {\n  content: \"\\F0F38\";\n}\n\n.mdi-weather-windy::before {\n  content: \"\\F059D\";\n}\n\n.mdi-weather-windy-variant::before {\n  content: \"\\F059E\";\n}\n\n.mdi-web::before {\n  content: \"\\F059F\";\n}\n\n.mdi-web-box::before {\n  content: \"\\F0F94\";\n}\n\n.mdi-web-cancel::before {\n  content: \"\\F1790\";\n}\n\n.mdi-web-check::before {\n  content: \"\\F0789\";\n}\n\n.mdi-web-clock::before {\n  content: \"\\F124A\";\n}\n\n.mdi-web-minus::before {\n  content: \"\\F10A0\";\n}\n\n.mdi-web-off::before {\n  content: \"\\F0A8E\";\n}\n\n.mdi-web-plus::before {\n  content: \"\\F0033\";\n}\n\n.mdi-web-refresh::before {\n  content: \"\\F1791\";\n}\n\n.mdi-web-remove::before {\n  content: \"\\F0551\";\n}\n\n.mdi-web-sync::before {\n  content: \"\\F1792\";\n}\n\n.mdi-webcam::before {\n  content: \"\\F05A0\";\n}\n\n.mdi-webcam-off::before {\n  content: \"\\F1737\";\n}\n\n.mdi-webhook::before {\n  content: \"\\F062F\";\n}\n\n.mdi-webpack::before {\n  content: \"\\F072B\";\n}\n\n.mdi-webrtc::before {\n  content: \"\\F1248\";\n}\n\n.mdi-wechat::before {\n  content: \"\\F0611\";\n}\n\n.mdi-weight::before {\n  content: \"\\F05A1\";\n}\n\n.mdi-weight-gram::before {\n  content: \"\\F0D3F\";\n}\n\n.mdi-weight-kilogram::before {\n  content: \"\\F05A2\";\n}\n\n.mdi-weight-lifter::before {\n  content: \"\\F115D\";\n}\n\n.mdi-weight-pound::before {\n  content: \"\\F09B5\";\n}\n\n.mdi-whatsapp::before {\n  content: \"\\F05A3\";\n}\n\n.mdi-wheel-barrow::before {\n  content: \"\\F14F2\";\n}\n\n.mdi-wheelchair-accessibility::before {\n  content: \"\\F05A4\";\n}\n\n.mdi-whistle::before {\n  content: \"\\F09B6\";\n}\n\n.mdi-whistle-outline::before {\n  content: \"\\F12BC\";\n}\n\n.mdi-white-balance-auto::before {\n  content: \"\\F05A5\";\n}\n\n.mdi-white-balance-incandescent::before {\n  content: \"\\F05A6\";\n}\n\n.mdi-white-balance-iridescent::before {\n  content: \"\\F05A7\";\n}\n\n.mdi-white-balance-sunny::before {\n  content: \"\\F05A8\";\n}\n\n.mdi-widgets::before {\n  content: \"\\F072C\";\n}\n\n.mdi-widgets-outline::before {\n  content: \"\\F1355\";\n}\n\n.mdi-wifi::before {\n  content: \"\\F05A9\";\n}\n\n.mdi-wifi-alert::before {\n  content: \"\\F16B5\";\n}\n\n.mdi-wifi-arrow-down::before {\n  content: \"\\F16B6\";\n}\n\n.mdi-wifi-arrow-left::before {\n  content: \"\\F16B7\";\n}\n\n.mdi-wifi-arrow-left-right::before {\n  content: \"\\F16B8\";\n}\n\n.mdi-wifi-arrow-right::before {\n  content: \"\\F16B9\";\n}\n\n.mdi-wifi-arrow-up::before {\n  content: \"\\F16BA\";\n}\n\n.mdi-wifi-arrow-up-down::before {\n  content: \"\\F16BB\";\n}\n\n.mdi-wifi-cancel::before {\n  content: \"\\F16BC\";\n}\n\n.mdi-wifi-check::before {\n  content: \"\\F16BD\";\n}\n\n.mdi-wifi-cog::before {\n  content: \"\\F16BE\";\n}\n\n.mdi-wifi-lock::before {\n  content: \"\\F16BF\";\n}\n\n.mdi-wifi-lock-open::before {\n  content: \"\\F16C0\";\n}\n\n.mdi-wifi-marker::before {\n  content: \"\\F16C1\";\n}\n\n.mdi-wifi-minus::before {\n  content: \"\\F16C2\";\n}\n\n.mdi-wifi-off::before {\n  content: \"\\F05AA\";\n}\n\n.mdi-wifi-plus::before {\n  content: \"\\F16C3\";\n}\n\n.mdi-wifi-refresh::before {\n  content: \"\\F16C4\";\n}\n\n.mdi-wifi-remove::before {\n  content: \"\\F16C5\";\n}\n\n.mdi-wifi-settings::before {\n  content: \"\\F16C6\";\n}\n\n.mdi-wifi-star::before {\n  content: \"\\F0E0B\";\n}\n\n.mdi-wifi-strength-1::before {\n  content: \"\\F091F\";\n}\n\n.mdi-wifi-strength-1-alert::before {\n  content: \"\\F0920\";\n}\n\n.mdi-wifi-strength-1-lock::before {\n  content: \"\\F0921\";\n}\n\n.mdi-wifi-strength-1-lock-open::before {\n  content: \"\\F16CB\";\n}\n\n.mdi-wifi-strength-2::before {\n  content: \"\\F0922\";\n}\n\n.mdi-wifi-strength-2-alert::before {\n  content: \"\\F0923\";\n}\n\n.mdi-wifi-strength-2-lock::before {\n  content: \"\\F0924\";\n}\n\n.mdi-wifi-strength-2-lock-open::before {\n  content: \"\\F16CC\";\n}\n\n.mdi-wifi-strength-3::before {\n  content: \"\\F0925\";\n}\n\n.mdi-wifi-strength-3-alert::before {\n  content: \"\\F0926\";\n}\n\n.mdi-wifi-strength-3-lock::before {\n  content: \"\\F0927\";\n}\n\n.mdi-wifi-strength-3-lock-open::before {\n  content: \"\\F16CD\";\n}\n\n.mdi-wifi-strength-4::before {\n  content: \"\\F0928\";\n}\n\n.mdi-wifi-strength-4-alert::before {\n  content: \"\\F0929\";\n}\n\n.mdi-wifi-strength-4-lock::before {\n  content: \"\\F092A\";\n}\n\n.mdi-wifi-strength-4-lock-open::before {\n  content: \"\\F16CE\";\n}\n\n.mdi-wifi-strength-alert-outline::before {\n  content: \"\\F092B\";\n}\n\n.mdi-wifi-strength-lock-open-outline::before {\n  content: \"\\F16CF\";\n}\n\n.mdi-wifi-strength-lock-outline::before {\n  content: \"\\F092C\";\n}\n\n.mdi-wifi-strength-off::before {\n  content: \"\\F092D\";\n}\n\n.mdi-wifi-strength-off-outline::before {\n  content: \"\\F092E\";\n}\n\n.mdi-wifi-strength-outline::before {\n  content: \"\\F092F\";\n}\n\n.mdi-wifi-sync::before {\n  content: \"\\F16C7\";\n}\n\n.mdi-wikipedia::before {\n  content: \"\\F05AC\";\n}\n\n.mdi-wind-turbine::before {\n  content: \"\\F0DA5\";\n}\n\n.mdi-wind-turbine-alert::before {\n  content: \"\\F19AB\";\n}\n\n.mdi-wind-turbine-check::before {\n  content: \"\\F19AC\";\n}\n\n.mdi-window-close::before {\n  content: \"\\F05AD\";\n}\n\n.mdi-window-closed::before {\n  content: \"\\F05AE\";\n}\n\n.mdi-window-closed-variant::before {\n  content: \"\\F11DB\";\n}\n\n.mdi-window-maximize::before {\n  content: \"\\F05AF\";\n}\n\n.mdi-window-minimize::before {\n  content: \"\\F05B0\";\n}\n\n.mdi-window-open::before {\n  content: \"\\F05B1\";\n}\n\n.mdi-window-open-variant::before {\n  content: \"\\F11DC\";\n}\n\n.mdi-window-restore::before {\n  content: \"\\F05B2\";\n}\n\n.mdi-window-shutter::before {\n  content: \"\\F111C\";\n}\n\n.mdi-window-shutter-alert::before {\n  content: \"\\F111D\";\n}\n\n.mdi-window-shutter-open::before {\n  content: \"\\F111E\";\n}\n\n.mdi-windsock::before {\n  content: \"\\F15FA\";\n}\n\n.mdi-wiper::before {\n  content: \"\\F0AE9\";\n}\n\n.mdi-wiper-wash::before {\n  content: \"\\F0DA6\";\n}\n\n.mdi-wiper-wash-alert::before {\n  content: \"\\F18DF\";\n}\n\n.mdi-wizard-hat::before {\n  content: \"\\F1477\";\n}\n\n.mdi-wordpress::before {\n  content: \"\\F05B4\";\n}\n\n.mdi-wrap::before {\n  content: \"\\F05B6\";\n}\n\n.mdi-wrap-disabled::before {\n  content: \"\\F0BDF\";\n}\n\n.mdi-wrench::before {\n  content: \"\\F05B7\";\n}\n\n.mdi-wrench-clock::before {\n  content: \"\\F19A3\";\n}\n\n.mdi-wrench-outline::before {\n  content: \"\\F0BE0\";\n}\n\n.mdi-xamarin::before {\n  content: \"\\F0845\";\n}\n\n.mdi-xml::before {\n  content: \"\\F05C0\";\n}\n\n.mdi-xmpp::before {\n  content: \"\\F07FF\";\n}\n\n.mdi-yahoo::before {\n  content: \"\\F0B4F\";\n}\n\n.mdi-yeast::before {\n  content: \"\\F05C1\";\n}\n\n.mdi-yin-yang::before {\n  content: \"\\F0680\";\n}\n\n.mdi-yoga::before {\n  content: \"\\F117C\";\n}\n\n.mdi-youtube::before {\n  content: \"\\F05C3\";\n}\n\n.mdi-youtube-gaming::before {\n  content: \"\\F0848\";\n}\n\n.mdi-youtube-studio::before {\n  content: \"\\F0847\";\n}\n\n.mdi-youtube-subscription::before {\n  content: \"\\F0D40\";\n}\n\n.mdi-youtube-tv::before {\n  content: \"\\F0448\";\n}\n\n.mdi-yurt::before {\n  content: \"\\F1516\";\n}\n\n.mdi-z-wave::before {\n  content: \"\\F0AEA\";\n}\n\n.mdi-zend::before {\n  content: \"\\F0AEB\";\n}\n\n.mdi-zigbee::before {\n  content: \"\\F0D41\";\n}\n\n.mdi-zip-box::before {\n  content: \"\\F05C4\";\n}\n\n.mdi-zip-box-outline::before {\n  content: \"\\F0FFA\";\n}\n\n.mdi-zip-disk::before {\n  content: \"\\F0A23\";\n}\n\n.mdi-zodiac-aquarius::before {\n  content: \"\\F0A7D\";\n}\n\n.mdi-zodiac-aries::before {\n  content: \"\\F0A7E\";\n}\n\n.mdi-zodiac-cancer::before {\n  content: \"\\F0A7F\";\n}\n\n.mdi-zodiac-capricorn::before {\n  content: \"\\F0A80\";\n}\n\n.mdi-zodiac-gemini::before {\n  content: \"\\F0A81\";\n}\n\n.mdi-zodiac-leo::before {\n  content: \"\\F0A82\";\n}\n\n.mdi-zodiac-libra::before {\n  content: \"\\F0A83\";\n}\n\n.mdi-zodiac-pisces::before {\n  content: \"\\F0A84\";\n}\n\n.mdi-zodiac-sagittarius::before {\n  content: \"\\F0A85\";\n}\n\n.mdi-zodiac-scorpio::before {\n  content: \"\\F0A86\";\n}\n\n.mdi-zodiac-taurus::before {\n  content: \"\\F0A87\";\n}\n\n.mdi-zodiac-virgo::before {\n  content: \"\\F0A88\";\n}\n\n.mdi-blank::before {\n  content: \"\\F68C\";\n  visibility: hidden;\n}\n\n.mdi-18px.mdi-set, .mdi-18px.mdi:before {\n  font-size: 18px;\n}\n\n.mdi-24px.mdi-set, .mdi-24px.mdi:before {\n  font-size: 24px;\n}\n\n.mdi-36px.mdi-set, .mdi-36px.mdi:before {\n  font-size: 36px;\n}\n\n.mdi-48px.mdi-set, .mdi-48px.mdi:before {\n  font-size: 48px;\n}\n\n.mdi-dark:before {\n  color: rgba(0, 0, 0, 0.54);\n}\n\n.mdi-dark.mdi-inactive:before {\n  color: rgba(0, 0, 0, 0.26);\n}\n\n.mdi-light:before {\n  color: white;\n}\n\n.mdi-light.mdi-inactive:before {\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.mdi-rotate-45 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(45deg);\n            transform: scaleX(-1) rotate(45deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(45deg);\n            -ms-transform: rotate(45deg);\n            transform: scaleY(-1) rotate(45deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-45:before {\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n.mdi-rotate-90 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(90deg);\n            transform: scaleX(-1) rotate(90deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(90deg);\n            -ms-transform: rotate(90deg);\n            transform: scaleY(-1) rotate(90deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-90:before {\n  -webkit-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n\n.mdi-rotate-135 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(135deg);\n            transform: scaleX(-1) rotate(135deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(135deg);\n            -ms-transform: rotate(135deg);\n            transform: scaleY(-1) rotate(135deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-135:before {\n  -webkit-transform: rotate(135deg);\n  -ms-transform: rotate(135deg);\n  transform: rotate(135deg);\n}\n\n.mdi-rotate-180 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(180deg);\n            transform: scaleX(-1) rotate(180deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(180deg);\n            -ms-transform: rotate(180deg);\n            transform: scaleY(-1) rotate(180deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-180:before {\n  -webkit-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n\n.mdi-rotate-225 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(225deg);\n            transform: scaleX(-1) rotate(225deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(225deg);\n            -ms-transform: rotate(225deg);\n            transform: scaleY(-1) rotate(225deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-225:before {\n  -webkit-transform: rotate(225deg);\n  -ms-transform: rotate(225deg);\n  transform: rotate(225deg);\n}\n\n.mdi-rotate-270 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(270deg);\n            transform: scaleX(-1) rotate(270deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(270deg);\n            -ms-transform: rotate(270deg);\n            transform: scaleY(-1) rotate(270deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-270:before {\n  -webkit-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n\n.mdi-rotate-315 {\n  /*\n        // Not included in production\n        &.mdi-flip-h:before {\n            -webkit-transform: scaleX(-1) rotate(315deg);\n            transform: scaleX(-1) rotate(315deg);\n            filter: FlipH;\n            -ms-filter: \"FlipH\";\n        }\n        &.mdi-flip-v:before {\n            -webkit-transform: scaleY(-1) rotate(315deg);\n            -ms-transform: rotate(315deg);\n            transform: scaleY(-1) rotate(315deg);\n            filter: FlipV;\n            -ms-filter: \"FlipV\";\n        }\n        */\n}\n\n.mdi-rotate-315:before {\n  -webkit-transform: rotate(315deg);\n  -ms-transform: rotate(315deg);\n  transform: rotate(315deg);\n}\n\n.mdi-flip-h:before {\n  -webkit-transform: scaleX(-1);\n  transform: scaleX(-1);\n  filter: FlipH;\n  -ms-filter: \"FlipH\";\n}\n\n.mdi-flip-v:before {\n  -webkit-transform: scaleY(-1);\n  transform: scaleY(-1);\n  filter: FlipV;\n  -ms-filter: \"FlipV\";\n}\n\n.mdi-spin:before {\n  -webkit-animation: mdi-spin 2s infinite linear;\n  animation: mdi-spin 2s infinite linear;\n}\n\n@-webkit-keyframes mdi-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n@keyframes mdi-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(359deg);\n    transform: rotate(359deg);\n  }\n}\n\n/*# sourceMappingURL=materialdesignicons.css.map */","// boxicons 2.1.1\n\n@font-face\n{\n    font-family: 'boxicons';\n    font-weight: normal;\n    font-style: normal;\n\n    src: url('../../../fonts/boxicons.eot');\n    src: url('../../../fonts/boxicons.eot') format('embedded-opentype'),\n    url('../../../fonts/boxicons.woff2') format('woff2'),\n    url('../../../fonts/boxicons.woff') format('woff'),\n    url('../../../fonts/boxicons.ttf') format('truetype'),\n    url('../../../fonts/boxicons.svg?#boxicons') format('svg');\n}\n.bx\n{\n    font-family: 'boxicons' !important;\n    font-weight: normal;\n    font-style: normal;\n    font-variant: normal;\n    line-height: 1;\n    text-rendering: auto;\n    display: inline-block;\n\n    text-transform: none;\n\n    speak: none;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n}\n.bx-ul\n{\n    margin-left: 2em;\n    padding-left: 0;\n\n    list-style: none;\n}\n.bx-ul > li\n{\n    position: relative;\n}\n.bx-ul .bx\n{\n    font-size: inherit;\n    line-height: inherit;\n\n    position: absolute;\n    left: -2em;\n\n    width: 2em;\n\n    text-align: center;\n}\n@-webkit-keyframes spin\n{\n    0%\n    {\n        -webkit-transform: rotate(0);\n                transform: rotate(0);\n    }\n    100%\n    {\n        -webkit-transform: rotate(359deg);\n                transform: rotate(359deg);\n    }\n}\n@keyframes spin\n{\n    0%\n    {\n        -webkit-transform: rotate(0);\n                transform: rotate(0);\n    }\n    100%\n    {\n        -webkit-transform: rotate(359deg);\n                transform: rotate(359deg);\n    }\n}\n@-webkit-keyframes burst\n{\n    0%\n    {\n        -webkit-transform: scale(1);\n                transform: scale(1);\n\n        opacity: 1;\n    }\n    90%\n    {\n        -webkit-transform: scale(1.5);\n                transform: scale(1.5);\n\n        opacity: 0;\n    }\n}\n@keyframes burst\n{\n    0%\n    {\n        -webkit-transform: scale(1);\n                transform: scale(1);\n\n        opacity: 1;\n    }\n    90%\n    {\n        -webkit-transform: scale(1.5);\n                transform: scale(1.5);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes flashing\n{\n    0%\n    {\n        opacity: 1;\n    }\n    45%\n    {\n        opacity: 0;\n    }\n    90%\n    {\n        opacity: 1;\n    }\n}\n@keyframes flashing\n{\n    0%\n    {\n        opacity: 1;\n    }\n    45%\n    {\n        opacity: 0;\n    }\n    90%\n    {\n        opacity: 1;\n    }\n}\n@-webkit-keyframes fade-left\n{\n    0%\n    {\n        -webkit-transform: translateX(0);\n                transform: translateX(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateX(-20px);\n                transform: translateX(-20px);\n\n        opacity: 0;\n    }\n}\n@keyframes fade-left\n{\n    0%\n    {\n        -webkit-transform: translateX(0);\n                transform: translateX(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateX(-20px);\n                transform: translateX(-20px);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes fade-right\n{\n    0%\n    {\n        -webkit-transform: translateX(0);\n                transform: translateX(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateX(20px);\n                transform: translateX(20px);\n\n        opacity: 0;\n    }\n}\n@keyframes fade-right\n{\n    0%\n    {\n        -webkit-transform: translateX(0);\n                transform: translateX(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateX(20px);\n                transform: translateX(20px);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes fade-up\n{\n    0%\n    {\n        -webkit-transform: translateY(0);\n                transform: translateY(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateY(-20px);\n                transform: translateY(-20px);\n\n        opacity: 0;\n    }\n}\n@keyframes fade-up\n{\n    0%\n    {\n        -webkit-transform: translateY(0);\n                transform: translateY(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateY(-20px);\n                transform: translateY(-20px);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes fade-down\n{\n    0%\n    {\n        -webkit-transform: translateY(0);\n                transform: translateY(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateY(20px);\n                transform: translateY(20px);\n\n        opacity: 0;\n    }\n}\n@keyframes fade-down\n{\n    0%\n    {\n        -webkit-transform: translateY(0);\n                transform: translateY(0);\n\n        opacity: 1;\n    }\n    75%\n    {\n        -webkit-transform: translateY(20px);\n                transform: translateY(20px);\n\n        opacity: 0;\n    }\n}\n@-webkit-keyframes tada\n{\n    from\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n\n    10%,\n    20%\n    {\n        -webkit-transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\n                transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\n    }\n\n    30%,\n    50%,\n    70%,\n    90%\n    {\n        -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\n                transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\n    }\n\n    40%,\n    60%,\n    80%\n    {\n        -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, -10deg);\n                transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, -10deg);\n    }\n\n    to\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n}\n\n@keyframes tada\n{\n    from\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n\n    10%,\n    20%\n    {\n        -webkit-transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\n                transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\n    }\n\n    30%,\n    50%,\n    70%,\n    90%\n    {\n        -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\n                transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\n    }\n\n    40%,\n    60%,\n    80%\n    {\n        -webkit-transform: rotate3d(0, 0, 1, -10deg);\n                transform: rotate3d(0, 0, 1, -10deg);\n    }\n\n    to\n    {\n        -webkit-transform: scale3d(1, 1, 1);\n                transform: scale3d(1, 1, 1);\n    }\n}\n.bx-spin\n{\n    -webkit-animation: spin 2s linear infinite;\n            animation: spin 2s linear infinite;\n}\n.bx-spin-hover:hover\n{\n    -webkit-animation: spin 2s linear infinite;\n            animation: spin 2s linear infinite;\n}\n\n.bx-tada\n{\n    -webkit-animation: tada 1.5s ease infinite;\n            animation: tada 1.5s ease infinite;\n}\n.bx-tada-hover:hover\n{\n    -webkit-animation: tada 1.5s ease infinite;\n            animation: tada 1.5s ease infinite;\n}\n\n.bx-flashing\n{\n    -webkit-animation: flashing 1.5s infinite linear;\n            animation: flashing 1.5s infinite linear;\n}\n.bx-flashing-hover:hover\n{\n    -webkit-animation: flashing 1.5s infinite linear;\n            animation: flashing 1.5s infinite linear;\n}\n\n.bx-burst\n{\n    -webkit-animation: burst 1.5s infinite linear;\n            animation: burst 1.5s infinite linear;\n}\n.bx-burst-hover:hover\n{\n    -webkit-animation: burst 1.5s infinite linear;\n            animation: burst 1.5s infinite linear;\n}\n.bx-fade-up\n{\n    -webkit-animation: fade-up 1.5s infinite linear;\n            animation: fade-up 1.5s infinite linear;\n}\n.bx-fade-up-hover:hover\n{\n    -webkit-animation: fade-up 1.5s infinite linear;\n            animation: fade-up 1.5s infinite linear;\n}\n.bx-fade-down\n{\n    -webkit-animation: fade-down 1.5s infinite linear;\n            animation: fade-down 1.5s infinite linear;\n}\n.bx-fade-down-hover:hover\n{\n    -webkit-animation: fade-down 1.5s infinite linear;\n            animation: fade-down 1.5s infinite linear;\n}\n.bx-fade-left\n{\n    -webkit-animation: fade-left 1.5s infinite linear;\n            animation: fade-left 1.5s infinite linear;\n}\n.bx-fade-left-hover:hover\n{\n    -webkit-animation: fade-left 1.5s infinite linear;\n            animation: fade-left 1.5s infinite linear;\n}\n.bx-fade-right\n{\n    -webkit-animation: fade-right 1.5s infinite linear;\n            animation: fade-right 1.5s infinite linear;\n}\n.bx-fade-right-hover:hover\n{\n    -webkit-animation: fade-right 1.5s infinite linear;\n            animation: fade-right 1.5s infinite linear;\n}\n.bx-xs\n{\n    font-size: 1rem!important;\n}\n.bx-sm\n{\n    font-size: 1.55rem!important;\n}\n.bx-md\n{\n    font-size: 2.25rem!important;\n}\n.bx-lg\n{\n    font-size: 3.0rem!important;\n}\n.bx-fw\n{\n    font-size: 1.2857142857em;\n    line-height: .8em;\n\n    width: 1.2857142857em;\n    height: .8em;\n    margin-top: -.2em!important;\n\n    vertical-align: middle;\n}\n.bx-pull-left\n{\n    float: left;\n\n    margin-right: .3em!important;\n}\n.bx-pull-right\n{\n    float: right;\n\n    margin-left: .3em!important;\n}\n.bx-rotate-90\n{\n    transform: rotate(90deg);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=1)';\n}\n.bx-rotate-180\n{\n    transform: rotate(180deg);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2)';\n}\n.bx-rotate-270\n{\n    transform: rotate(270deg);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=3)';\n}\n.bx-flip-horizontal\n{\n    transform: scaleX(-1);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)';\n}\n.bx-flip-vertical\n{\n    transform: scaleY(-1);\n\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)';\n}\n.bx-border\n{\n    padding: .25em;\n\n    border: .07em solid rgba(0,0,0,.1);\n    border-radius: .25em;\n}\n.bx-border-circle\n{\n    padding: .25em;\n\n    border: .07em solid rgba(0,0,0,.1);\n    border-radius: 50%;\n}\n\n  \n  .bxl-meta:before {\n    content: \"\\ef27\";\n  }\n  .bx-lemon:before {\n    content: \"\\ef28\";\n  }\n  .bxs-lemon:before {\n    content: \"\\ef29\";\n  }\n  .bx-cricket-ball:before {\n    content: \"\\ef0c\";\n  }\n  .bx-baguette:before {\n    content: \"\\ef0d\";\n  }\n  .bx-bowl-hot:before {\n    content: \"\\ef0e\";\n  }\n  .bx-bowl-rice:before {\n    content: \"\\ef0f\";\n  }\n  .bx-cable-car:before {\n    content: \"\\ef10\";\n  }\n  .bx-candles:before {\n    content: \"\\ef11\";\n  }\n  .bx-circle-half:before {\n    content: \"\\ef12\";\n  }\n  .bx-circle-quarter:before {\n    content: \"\\ef13\";\n  }\n  .bx-circle-three-quarter:before {\n    content: \"\\ef14\";\n  }\n  .bx-cross:before {\n    content: \"\\ef15\";\n  }\n  .bx-fork:before {\n    content: \"\\ef16\";\n  }\n  .bx-knife:before {\n    content: \"\\ef17\";\n  }\n  .bx-money-withdraw:before {\n    content: \"\\ef18\";\n  }\n  .bx-popsicle:before {\n    content: \"\\ef19\";\n  }\n  .bx-scatter-chart:before {\n    content: \"\\ef1a\";\n  }\n  .bxs-baguette:before {\n    content: \"\\ef1b\";\n  }\n  .bxs-bowl-hot:before {\n    content: \"\\ef1c\";\n  }\n  .bxs-bowl-rice:before {\n    content: \"\\ef1d\";\n  }\n  .bxs-cable-car:before {\n    content: \"\\ef1e\";\n  }\n  .bxs-circle-half:before {\n    content: \"\\ef1f\";\n  }\n  .bxs-circle-quarter:before {\n    content: \"\\ef20\";\n  }\n  .bxs-circle-three-quarter:before {\n    content: \"\\ef21\";\n  }\n  .bxs-cricket-ball:before {\n    content: \"\\ef22\";\n  }\n  .bxs-invader:before {\n    content: \"\\ef23\";\n  }\n  .bx-male-female:before {\n    content: \"\\ef24\";\n  }\n  .bxs-popsicle:before {\n    content: \"\\ef25\";\n  }\n  .bxs-tree-alt:before {\n    content: \"\\ef26\";\n  }\n  .bxl-venmo:before {\n    content: \"\\e900\";\n  }\n  .bxl-upwork:before {\n    content: \"\\e901\";\n  }\n  .bxl-netlify:before {\n    content: \"\\e902\";\n  }\n  .bxl-java:before {\n    content: \"\\e903\";\n  }\n  .bxl-heroku:before {\n    content: \"\\e904\";\n  }\n  .bxl-go-lang:before {\n    content: \"\\e905\";\n  }\n  .bxl-gmail:before {\n    content: \"\\e906\";\n  }\n  .bxl-flask:before {\n    content: \"\\e907\";\n  }\n  .bxl-99designs:before {\n    content: \"\\e908\";\n  }\n  .bxl-500px:before {\n    content: \"\\e909\";\n  }\n  .bxl-adobe:before {\n    content: \"\\e90a\";\n  }\n  .bxl-airbnb:before {\n    content: \"\\e90b\";\n  }\n  .bxl-algolia:before {\n    content: \"\\e90c\";\n  }\n  .bxl-amazon:before {\n    content: \"\\e90d\";\n  }\n  .bxl-android:before {\n    content: \"\\e90e\";\n  }\n  .bxl-angular:before {\n    content: \"\\e90f\";\n  }\n  .bxl-apple:before {\n    content: \"\\e910\";\n  }\n  .bxl-audible:before {\n    content: \"\\e911\";\n  }\n  .bxl-aws:before {\n    content: \"\\e912\";\n  }\n  .bxl-baidu:before {\n    content: \"\\e913\";\n  }\n  .bxl-behance:before {\n    content: \"\\e914\";\n  }\n  .bxl-bing:before {\n    content: \"\\e915\";\n  }\n  .bxl-bitcoin:before {\n    content: \"\\e916\";\n  }\n  .bxl-blender:before {\n    content: \"\\e917\";\n  }\n  .bxl-blogger:before {\n    content: \"\\e918\";\n  }\n  .bxl-bootstrap:before {\n    content: \"\\e919\";\n  }\n  .bxl-chrome:before {\n    content: \"\\e91a\";\n  }\n  .bxl-codepen:before {\n    content: \"\\e91b\";\n  }\n  .bxl-c-plus-plus:before {\n    content: \"\\e91c\";\n  }\n  .bxl-creative-commons:before {\n    content: \"\\e91d\";\n  }\n  .bxl-css3:before {\n    content: \"\\e91e\";\n  }\n  .bxl-dailymotion:before {\n    content: \"\\e91f\";\n  }\n  .bxl-deviantart:before {\n    content: \"\\e920\";\n  }\n  .bxl-dev-to:before {\n    content: \"\\e921\";\n  }\n  .bxl-digg:before {\n    content: \"\\e922\";\n  }\n  .bxl-digitalocean:before {\n    content: \"\\e923\";\n  }\n  .bxl-discord:before {\n    content: \"\\e924\";\n  }\n  .bxl-discord-alt:before {\n    content: \"\\e925\";\n  }\n  .bxl-discourse:before {\n    content: \"\\e926\";\n  }\n  .bxl-django:before {\n    content: \"\\e927\";\n  }\n  .bxl-docker:before {\n    content: \"\\e928\";\n  }\n  .bxl-dribbble:before {\n    content: \"\\e929\";\n  }\n  .bxl-dropbox:before {\n    content: \"\\e92a\";\n  }\n  .bxl-drupal:before {\n    content: \"\\e92b\";\n  }\n  .bxl-ebay:before {\n    content: \"\\e92c\";\n  }\n  .bxl-edge:before {\n    content: \"\\e92d\";\n  }\n  .bxl-etsy:before {\n    content: \"\\e92e\";\n  }\n  .bxl-facebook:before {\n    content: \"\\e92f\";\n  }\n  .bxl-facebook-circle:before {\n    content: \"\\e930\";\n  }\n  .bxl-facebook-square:before {\n    content: \"\\e931\";\n  }\n  .bxl-figma:before {\n    content: \"\\e932\";\n  }\n  .bxl-firebase:before {\n    content: \"\\e933\";\n  }\n  .bxl-firefox:before {\n    content: \"\\e934\";\n  }\n  .bxl-flickr:before {\n    content: \"\\e935\";\n  }\n  .bxl-flickr-square:before {\n    content: \"\\e936\";\n  }\n  .bxl-flutter:before {\n    content: \"\\e937\";\n  }\n  .bxl-foursquare:before {\n    content: \"\\e938\";\n  }\n  .bxl-git:before {\n    content: \"\\e939\";\n  }\n  .bxl-github:before {\n    content: \"\\e93a\";\n  }\n  .bxl-gitlab:before {\n    content: \"\\e93b\";\n  }\n  .bxl-google:before {\n    content: \"\\e93c\";\n  }\n  .bxl-google-cloud:before {\n    content: \"\\e93d\";\n  }\n  .bxl-google-plus:before {\n    content: \"\\e93e\";\n  }\n  .bxl-google-plus-circle:before {\n    content: \"\\e93f\";\n  }\n  .bxl-html5:before {\n    content: \"\\e940\";\n  }\n  .bxl-imdb:before {\n    content: \"\\e941\";\n  }\n  .bxl-instagram:before {\n    content: \"\\e942\";\n  }\n  .bxl-instagram-alt:before {\n    content: \"\\e943\";\n  }\n  .bxl-internet-explorer:before {\n    content: \"\\e944\";\n  }\n  .bxl-invision:before {\n    content: \"\\e945\";\n  }\n  .bxl-javascript:before {\n    content: \"\\e946\";\n  }\n  .bxl-joomla:before {\n    content: \"\\e947\";\n  }\n  .bxl-jquery:before {\n    content: \"\\e948\";\n  }\n  .bxl-jsfiddle:before {\n    content: \"\\e949\";\n  }\n  .bxl-kickstarter:before {\n    content: \"\\e94a\";\n  }\n  .bxl-kubernetes:before {\n    content: \"\\e94b\";\n  }\n  .bxl-less:before {\n    content: \"\\e94c\";\n  }\n  .bxl-linkedin:before {\n    content: \"\\e94d\";\n  }\n  .bxl-linkedin-square:before {\n    content: \"\\e94e\";\n  }\n  .bxl-magento:before {\n    content: \"\\e94f\";\n  }\n  .bxl-mailchimp:before {\n    content: \"\\e950\";\n  }\n  .bxl-markdown:before {\n    content: \"\\e951\";\n  }\n  .bxl-mastercard:before {\n    content: \"\\e952\";\n  }\n  .bxl-mastodon:before {\n    content: \"\\e953\";\n  }\n  .bxl-medium:before {\n    content: \"\\e954\";\n  }\n  .bxl-medium-old:before {\n    content: \"\\e955\";\n  }\n  .bxl-medium-square:before {\n    content: \"\\e956\";\n  }\n  .bxl-messenger:before {\n    content: \"\\e957\";\n  }\n  .bxl-microsoft:before {\n    content: \"\\e958\";\n  }\n  .bxl-microsoft-teams:before {\n    content: \"\\e959\";\n  }\n  .bxl-nodejs:before {\n    content: \"\\e95a\";\n  }\n  .bxl-ok-ru:before {\n    content: \"\\e95b\";\n  }\n  .bxl-opera:before {\n    content: \"\\e95c\";\n  }\n  .bxl-patreon:before {\n    content: \"\\e95d\";\n  }\n  .bxl-paypal:before {\n    content: \"\\e95e\";\n  }\n  .bxl-periscope:before {\n    content: \"\\e95f\";\n  }\n  .bxl-php:before {\n    content: \"\\e960\";\n  }\n  .bxl-pinterest:before {\n    content: \"\\e961\";\n  }\n  .bxl-pinterest-alt:before {\n    content: \"\\e962\";\n  }\n  .bxl-play-store:before {\n    content: \"\\e963\";\n  }\n  .bxl-pocket:before {\n    content: \"\\e964\";\n  }\n  .bxl-product-hunt:before {\n    content: \"\\e965\";\n  }\n  .bxl-python:before {\n    content: \"\\e966\";\n  }\n  .bxl-quora:before {\n    content: \"\\e967\";\n  }\n  .bxl-react:before {\n    content: \"\\e968\";\n  }\n  .bxl-redbubble:before {\n    content: \"\\e969\";\n  }\n  .bxl-reddit:before {\n    content: \"\\e96a\";\n  }\n  .bxl-redux:before {\n    content: \"\\e96b\";\n  }\n  .bxl-sass:before {\n    content: \"\\e96c\";\n  }\n  .bxl-shopify:before {\n    content: \"\\e96d\";\n  }\n  .bxl-sketch:before {\n    content: \"\\e96e\";\n  }\n  .bxl-skype:before {\n    content: \"\\e96f\";\n  }\n  .bxl-slack:before {\n    content: \"\\e970\";\n  }\n  .bxl-slack-old:before {\n    content: \"\\e971\";\n  }\n  .bxl-snapchat:before {\n    content: \"\\e972\";\n  }\n  .bxl-soundcloud:before {\n    content: \"\\e973\";\n  }\n  .bxl-spotify:before {\n    content: \"\\e974\";\n  }\n  .bxl-spring-boot:before {\n    content: \"\\e975\";\n  }\n  .bxl-squarespace:before {\n    content: \"\\e976\";\n  }\n  .bxl-stack-overflow:before {\n    content: \"\\e977\";\n  }\n  .bxl-steam:before {\n    content: \"\\e978\";\n  }\n  .bxl-stripe:before {\n    content: \"\\e979\";\n  }\n  .bxl-tailwind-css:before {\n    content: \"\\e97a\";\n  }\n  .bxl-telegram:before {\n    content: \"\\e97b\";\n  }\n  .bxl-tiktok:before {\n    content: \"\\e97c\";\n  }\n  .bxl-trello:before {\n    content: \"\\e97d\";\n  }\n  .bxl-trip-advisor:before {\n    content: \"\\e97e\";\n  }\n  .bxl-tumblr:before {\n    content: \"\\e97f\";\n  }\n  .bxl-tux:before {\n    content: \"\\e980\";\n  }\n  .bxl-twitch:before {\n    content: \"\\e981\";\n  }\n  .bxl-twitter:before {\n    content: \"\\e982\";\n  }\n  .bxl-unity:before {\n    content: \"\\e983\";\n  }\n  .bxl-unsplash:before {\n    content: \"\\e984\";\n  }\n  .bxl-vimeo:before {\n    content: \"\\e985\";\n  }\n  .bxl-visa:before {\n    content: \"\\e986\";\n  }\n  .bxl-visual-studio:before {\n    content: \"\\e987\";\n  }\n  .bxl-vk:before {\n    content: \"\\e988\";\n  }\n  .bxl-vuejs:before {\n    content: \"\\e989\";\n  }\n  .bxl-whatsapp:before {\n    content: \"\\e98a\";\n  }\n  .bxl-whatsapp-square:before {\n    content: \"\\e98b\";\n  }\n  .bxl-wikipedia:before {\n    content: \"\\e98c\";\n  }\n  .bxl-windows:before {\n    content: \"\\e98d\";\n  }\n  .bxl-wix:before {\n    content: \"\\e98e\";\n  }\n  .bxl-wordpress:before {\n    content: \"\\e98f\";\n  }\n  .bxl-yahoo:before {\n    content: \"\\e990\";\n  }\n  .bxl-yelp:before {\n    content: \"\\e991\";\n  }\n  .bxl-youtube:before {\n    content: \"\\e992\";\n  }\n  .bxl-zoom:before {\n    content: \"\\e993\";\n  }\n  .bx-collapse-alt:before {\n    content: \"\\e994\";\n  }\n  .bx-collapse-horizontal:before {\n    content: \"\\e995\";\n  }\n  .bx-collapse-vertical:before {\n    content: \"\\e996\";\n  }\n  .bx-expand-horizontal:before {\n    content: \"\\e997\";\n  }\n  .bx-expand-vertical:before {\n    content: \"\\e998\";\n  }\n  .bx-injection:before {\n    content: \"\\e999\";\n  }\n  .bx-leaf:before {\n    content: \"\\e99a\";\n  }\n  .bx-math:before {\n    content: \"\\e99b\";\n  }\n  .bx-party:before {\n    content: \"\\e99c\";\n  }\n  .bx-abacus:before {\n    content: \"\\e99d\";\n  }\n  .bx-accessibility:before {\n    content: \"\\e99e\";\n  }\n  .bx-add-to-queue:before {\n    content: \"\\e99f\";\n  }\n  .bx-adjust:before {\n    content: \"\\e9a0\";\n  }\n  .bx-alarm:before {\n    content: \"\\e9a1\";\n  }\n  .bx-alarm-add:before {\n    content: \"\\e9a2\";\n  }\n  .bx-alarm-exclamation:before {\n    content: \"\\e9a3\";\n  }\n  .bx-alarm-off:before {\n    content: \"\\e9a4\";\n  }\n  .bx-alarm-snooze:before {\n    content: \"\\e9a5\";\n  }\n  .bx-album:before {\n    content: \"\\e9a6\";\n  }\n  .bx-align-justify:before {\n    content: \"\\e9a7\";\n  }\n  .bx-align-left:before {\n    content: \"\\e9a8\";\n  }\n  .bx-align-middle:before {\n    content: \"\\e9a9\";\n  }\n  .bx-align-right:before {\n    content: \"\\e9aa\";\n  }\n  .bx-analyse:before {\n    content: \"\\e9ab\";\n  }\n  .bx-anchor:before {\n    content: \"\\e9ac\";\n  }\n  .bx-angry:before {\n    content: \"\\e9ad\";\n  }\n  .bx-aperture:before {\n    content: \"\\e9ae\";\n  }\n  .bx-arch:before {\n    content: \"\\e9af\";\n  }\n  .bx-archive:before {\n    content: \"\\e9b0\";\n  }\n  .bx-archive-in:before {\n    content: \"\\e9b1\";\n  }\n  .bx-archive-out:before {\n    content: \"\\e9b2\";\n  }\n  .bx-area:before {\n    content: \"\\e9b3\";\n  }\n  .bx-arrow-back:before {\n    content: \"\\e9b4\";\n  }\n  .bx-arrow-from-bottom:before {\n    content: \"\\e9b5\";\n  }\n  .bx-arrow-from-left:before {\n    content: \"\\e9b6\";\n  }\n  .bx-arrow-from-right:before {\n    content: \"\\e9b7\";\n  }\n  .bx-arrow-from-top:before {\n    content: \"\\e9b8\";\n  }\n  .bx-arrow-to-bottom:before {\n    content: \"\\e9b9\";\n  }\n  .bx-arrow-to-left:before {\n    content: \"\\e9ba\";\n  }\n  .bx-arrow-to-right:before {\n    content: \"\\e9bb\";\n  }\n  .bx-arrow-to-top:before {\n    content: \"\\e9bc\";\n  }\n  .bx-at:before {\n    content: \"\\e9bd\";\n  }\n  .bx-atom:before {\n    content: \"\\e9be\";\n  }\n  .bx-award:before {\n    content: \"\\e9bf\";\n  }\n  .bx-badge:before {\n    content: \"\\e9c0\";\n  }\n  .bx-badge-check:before {\n    content: \"\\e9c1\";\n  }\n  .bx-ball:before {\n    content: \"\\e9c2\";\n  }\n  .bx-band-aid:before {\n    content: \"\\e9c3\";\n  }\n  .bx-bar-chart:before {\n    content: \"\\e9c4\";\n  }\n  .bx-bar-chart-alt:before {\n    content: \"\\e9c5\";\n  }\n  .bx-bar-chart-alt-2:before {\n    content: \"\\e9c6\";\n  }\n  .bx-bar-chart-square:before {\n    content: \"\\e9c7\";\n  }\n  .bx-barcode:before {\n    content: \"\\e9c8\";\n  }\n  .bx-barcode-reader:before {\n    content: \"\\e9c9\";\n  }\n  .bx-baseball:before {\n    content: \"\\e9ca\";\n  }\n  .bx-basket:before {\n    content: \"\\e9cb\";\n  }\n  .bx-basketball:before {\n    content: \"\\e9cc\";\n  }\n  .bx-bath:before {\n    content: \"\\e9cd\";\n  }\n  .bx-battery:before {\n    content: \"\\e9ce\";\n  }\n  .bx-bed:before {\n    content: \"\\e9cf\";\n  }\n  .bx-been-here:before {\n    content: \"\\e9d0\";\n  }\n  .bx-beer:before {\n    content: \"\\e9d1\";\n  }\n  .bx-bell:before {\n    content: \"\\e9d2\";\n  }\n  .bx-bell-minus:before {\n    content: \"\\e9d3\";\n  }\n  .bx-bell-off:before {\n    content: \"\\e9d4\";\n  }\n  .bx-bell-plus:before {\n    content: \"\\e9d5\";\n  }\n  .bx-bible:before {\n    content: \"\\e9d6\";\n  }\n  .bx-bitcoin:before {\n    content: \"\\e9d7\";\n  }\n  .bx-blanket:before {\n    content: \"\\e9d8\";\n  }\n  .bx-block:before {\n    content: \"\\e9d9\";\n  }\n  .bx-bluetooth:before {\n    content: \"\\e9da\";\n  }\n  .bx-body:before {\n    content: \"\\e9db\";\n  }\n  .bx-bold:before {\n    content: \"\\e9dc\";\n  }\n  .bx-bolt-circle:before {\n    content: \"\\e9dd\";\n  }\n  .bx-bomb:before {\n    content: \"\\e9de\";\n  }\n  .bx-bone:before {\n    content: \"\\e9df\";\n  }\n  .bx-bong:before {\n    content: \"\\e9e0\";\n  }\n  .bx-book:before {\n    content: \"\\e9e1\";\n  }\n  .bx-book-add:before {\n    content: \"\\e9e2\";\n  }\n  .bx-book-alt:before {\n    content: \"\\e9e3\";\n  }\n  .bx-book-bookmark:before {\n    content: \"\\e9e4\";\n  }\n  .bx-book-content:before {\n    content: \"\\e9e5\";\n  }\n  .bx-book-heart:before {\n    content: \"\\e9e6\";\n  }\n  .bx-bookmark:before {\n    content: \"\\e9e7\";\n  }\n  .bx-bookmark-alt:before {\n    content: \"\\e9e8\";\n  }\n  .bx-bookmark-alt-minus:before {\n    content: \"\\e9e9\";\n  }\n  .bx-bookmark-alt-plus:before {\n    content: \"\\e9ea\";\n  }\n  .bx-bookmark-heart:before {\n    content: \"\\e9eb\";\n  }\n  .bx-bookmark-minus:before {\n    content: \"\\e9ec\";\n  }\n  .bx-bookmark-plus:before {\n    content: \"\\e9ed\";\n  }\n  .bx-bookmarks:before {\n    content: \"\\e9ee\";\n  }\n  .bx-book-open:before {\n    content: \"\\e9ef\";\n  }\n  .bx-book-reader:before {\n    content: \"\\e9f0\";\n  }\n  .bx-border-all:before {\n    content: \"\\e9f1\";\n  }\n  .bx-border-bottom:before {\n    content: \"\\e9f2\";\n  }\n  .bx-border-inner:before {\n    content: \"\\e9f3\";\n  }\n  .bx-border-left:before {\n    content: \"\\e9f4\";\n  }\n  .bx-border-none:before {\n    content: \"\\e9f5\";\n  }\n  .bx-border-outer:before {\n    content: \"\\e9f6\";\n  }\n  .bx-border-radius:before {\n    content: \"\\e9f7\";\n  }\n  .bx-border-right:before {\n    content: \"\\e9f8\";\n  }\n  .bx-border-top:before {\n    content: \"\\e9f9\";\n  }\n  .bx-bot:before {\n    content: \"\\e9fa\";\n  }\n  .bx-bowling-ball:before {\n    content: \"\\e9fb\";\n  }\n  .bx-box:before {\n    content: \"\\e9fc\";\n  }\n  .bx-bracket:before {\n    content: \"\\e9fd\";\n  }\n  .bx-braille:before {\n    content: \"\\e9fe\";\n  }\n  .bx-brain:before {\n    content: \"\\e9ff\";\n  }\n  .bx-briefcase:before {\n    content: \"\\ea00\";\n  }\n  .bx-briefcase-alt:before {\n    content: \"\\ea01\";\n  }\n  .bx-briefcase-alt-2:before {\n    content: \"\\ea02\";\n  }\n  .bx-brightness:before {\n    content: \"\\ea03\";\n  }\n  .bx-brightness-half:before {\n    content: \"\\ea04\";\n  }\n  .bx-broadcast:before {\n    content: \"\\ea05\";\n  }\n  .bx-brush:before {\n    content: \"\\ea06\";\n  }\n  .bx-brush-alt:before {\n    content: \"\\ea07\";\n  }\n  .bx-bug:before {\n    content: \"\\ea08\";\n  }\n  .bx-bug-alt:before {\n    content: \"\\ea09\";\n  }\n  .bx-building:before {\n    content: \"\\ea0a\";\n  }\n  .bx-building-house:before {\n    content: \"\\ea0b\";\n  }\n  .bx-buildings:before {\n    content: \"\\ea0c\";\n  }\n  .bx-bulb:before {\n    content: \"\\ea0d\";\n  }\n  .bx-bullseye:before {\n    content: \"\\ea0e\";\n  }\n  .bx-buoy:before {\n    content: \"\\ea0f\";\n  }\n  .bx-bus:before {\n    content: \"\\ea10\";\n  }\n  .bx-bus-school:before {\n    content: \"\\ea11\";\n  }\n  .bx-cabinet:before {\n    content: \"\\ea12\";\n  }\n  .bx-cake:before {\n    content: \"\\ea13\";\n  }\n  .bx-calculator:before {\n    content: \"\\ea14\";\n  }\n  .bx-calendar:before {\n    content: \"\\ea15\";\n  }\n  .bx-calendar-alt:before {\n    content: \"\\ea16\";\n  }\n  .bx-calendar-check:before {\n    content: \"\\ea17\";\n  }\n  .bx-calendar-edit:before {\n    content: \"\\ea18\";\n  }\n  .bx-calendar-event:before {\n    content: \"\\ea19\";\n  }\n  .bx-calendar-exclamation:before {\n    content: \"\\ea1a\";\n  }\n  .bx-calendar-heart:before {\n    content: \"\\ea1b\";\n  }\n  .bx-calendar-minus:before {\n    content: \"\\ea1c\";\n  }\n  .bx-calendar-plus:before {\n    content: \"\\ea1d\";\n  }\n  .bx-calendar-star:before {\n    content: \"\\ea1e\";\n  }\n  .bx-calendar-week:before {\n    content: \"\\ea1f\";\n  }\n  .bx-calendar-x:before {\n    content: \"\\ea20\";\n  }\n  .bx-camera:before {\n    content: \"\\ea21\";\n  }\n  .bx-camera-home:before {\n    content: \"\\ea22\";\n  }\n  .bx-camera-movie:before {\n    content: \"\\ea23\";\n  }\n  .bx-camera-off:before {\n    content: \"\\ea24\";\n  }\n  .bx-capsule:before {\n    content: \"\\ea25\";\n  }\n  .bx-captions:before {\n    content: \"\\ea26\";\n  }\n  .bx-car:before {\n    content: \"\\ea27\";\n  }\n  .bx-card:before {\n    content: \"\\ea28\";\n  }\n  .bx-caret-down:before {\n    content: \"\\ea29\";\n  }\n  .bx-caret-down-circle:before {\n    content: \"\\ea2a\";\n  }\n  .bx-caret-down-square:before {\n    content: \"\\ea2b\";\n  }\n  .bx-caret-left:before {\n    content: \"\\ea2c\";\n  }\n  .bx-caret-left-circle:before {\n    content: \"\\ea2d\";\n  }\n  .bx-caret-left-square:before {\n    content: \"\\ea2e\";\n  }\n  .bx-caret-right:before {\n    content: \"\\ea2f\";\n  }\n  .bx-caret-right-circle:before {\n    content: \"\\ea30\";\n  }\n  .bx-caret-right-square:before {\n    content: \"\\ea31\";\n  }\n  .bx-caret-up:before {\n    content: \"\\ea32\";\n  }\n  .bx-caret-up-circle:before {\n    content: \"\\ea33\";\n  }\n  .bx-caret-up-square:before {\n    content: \"\\ea34\";\n  }\n  .bx-carousel:before {\n    content: \"\\ea35\";\n  }\n  .bx-cart:before {\n    content: \"\\ea36\";\n  }\n  .bx-cart-alt:before {\n    content: \"\\ea37\";\n  }\n  .bx-cast:before {\n    content: \"\\ea38\";\n  }\n  .bx-category:before {\n    content: \"\\ea39\";\n  }\n  .bx-category-alt:before {\n    content: \"\\ea3a\";\n  }\n  .bx-cctv:before {\n    content: \"\\ea3b\";\n  }\n  .bx-certification:before {\n    content: \"\\ea3c\";\n  }\n  .bx-chair:before {\n    content: \"\\ea3d\";\n  }\n  .bx-chalkboard:before {\n    content: \"\\ea3e\";\n  }\n  .bx-chart:before {\n    content: \"\\ea3f\";\n  }\n  .bx-chat:before {\n    content: \"\\ea40\";\n  }\n  .bx-check:before {\n    content: \"\\ea41\";\n  }\n  .bx-checkbox:before {\n    content: \"\\ea42\";\n  }\n  .bx-checkbox-checked:before {\n    content: \"\\ea43\";\n  }\n  .bx-checkbox-minus:before {\n    content: \"\\ea44\";\n  }\n  .bx-checkbox-square:before {\n    content: \"\\ea45\";\n  }\n  .bx-check-circle:before {\n    content: \"\\ea46\";\n  }\n  .bx-check-double:before {\n    content: \"\\ea47\";\n  }\n  .bx-check-shield:before {\n    content: \"\\ea48\";\n  }\n  .bx-check-square:before {\n    content: \"\\ea49\";\n  }\n  .bx-chevron-down:before {\n    content: \"\\ea4a\";\n  }\n  .bx-chevron-down-circle:before {\n    content: \"\\ea4b\";\n  }\n  .bx-chevron-down-square:before {\n    content: \"\\ea4c\";\n  }\n  .bx-chevron-left:before {\n    content: \"\\ea4d\";\n  }\n  .bx-chevron-left-circle:before {\n    content: \"\\ea4e\";\n  }\n  .bx-chevron-left-square:before {\n    content: \"\\ea4f\";\n  }\n  .bx-chevron-right:before {\n    content: \"\\ea50\";\n  }\n  .bx-chevron-right-circle:before {\n    content: \"\\ea51\";\n  }\n  .bx-chevron-right-square:before {\n    content: \"\\ea52\";\n  }\n  .bx-chevrons-down:before {\n    content: \"\\ea53\";\n  }\n  .bx-chevrons-left:before {\n    content: \"\\ea54\";\n  }\n  .bx-chevrons-right:before {\n    content: \"\\ea55\";\n  }\n  .bx-chevrons-up:before {\n    content: \"\\ea56\";\n  }\n  .bx-chevron-up:before {\n    content: \"\\ea57\";\n  }\n  .bx-chevron-up-circle:before {\n    content: \"\\ea58\";\n  }\n  .bx-chevron-up-square:before {\n    content: \"\\ea59\";\n  }\n  .bx-chip:before {\n    content: \"\\ea5a\";\n  }\n  .bx-church:before {\n    content: \"\\ea5b\";\n  }\n  .bx-circle:before {\n    content: \"\\ea5c\";\n  }\n  .bx-clinic:before {\n    content: \"\\ea5d\";\n  }\n  .bx-clipboard:before {\n    content: \"\\ea5e\";\n  }\n  .bx-closet:before {\n    content: \"\\ea5f\";\n  }\n  .bx-cloud:before {\n    content: \"\\ea60\";\n  }\n  .bx-cloud-download:before {\n    content: \"\\ea61\";\n  }\n  .bx-cloud-drizzle:before {\n    content: \"\\ea62\";\n  }\n  .bx-cloud-lightning:before {\n    content: \"\\ea63\";\n  }\n  .bx-cloud-light-rain:before {\n    content: \"\\ea64\";\n  }\n  .bx-cloud-rain:before {\n    content: \"\\ea65\";\n  }\n  .bx-cloud-snow:before {\n    content: \"\\ea66\";\n  }\n  .bx-cloud-upload:before {\n    content: \"\\ea67\";\n  }\n  .bx-code:before {\n    content: \"\\ea68\";\n  }\n  .bx-code-alt:before {\n    content: \"\\ea69\";\n  }\n  .bx-code-block:before {\n    content: \"\\ea6a\";\n  }\n  .bx-code-curly:before {\n    content: \"\\ea6b\";\n  }\n  .bx-coffee:before {\n    content: \"\\ea6c\";\n  }\n  .bx-coffee-togo:before {\n    content: \"\\ea6d\";\n  }\n  .bx-cog:before {\n    content: \"\\ea6e\";\n  }\n  .bx-coin:before {\n    content: \"\\ea6f\";\n  }\n  .bx-coin-stack:before {\n    content: \"\\ea70\";\n  }\n  .bx-collapse:before {\n    content: \"\\ea71\";\n  }\n  .bx-collection:before {\n    content: \"\\ea72\";\n  }\n  .bx-color-fill:before {\n    content: \"\\ea73\";\n  }\n  .bx-columns:before {\n    content: \"\\ea74\";\n  }\n  .bx-command:before {\n    content: \"\\ea75\";\n  }\n  .bx-comment:before {\n    content: \"\\ea76\";\n  }\n  .bx-comment-add:before {\n    content: \"\\ea77\";\n  }\n  .bx-comment-check:before {\n    content: \"\\ea78\";\n  }\n  .bx-comment-detail:before {\n    content: \"\\ea79\";\n  }\n  .bx-comment-dots:before {\n    content: \"\\ea7a\";\n  }\n  .bx-comment-edit:before {\n    content: \"\\ea7b\";\n  }\n  .bx-comment-error:before {\n    content: \"\\ea7c\";\n  }\n  .bx-comment-minus:before {\n    content: \"\\ea7d\";\n  }\n  .bx-comment-x:before {\n    content: \"\\ea7e\";\n  }\n  .bx-compass:before {\n    content: \"\\ea7f\";\n  }\n  .bx-confused:before {\n    content: \"\\ea80\";\n  }\n  .bx-conversation:before {\n    content: \"\\ea81\";\n  }\n  .bx-cookie:before {\n    content: \"\\ea82\";\n  }\n  .bx-cool:before {\n    content: \"\\ea83\";\n  }\n  .bx-copy:before {\n    content: \"\\ea84\";\n  }\n  .bx-copy-alt:before {\n    content: \"\\ea85\";\n  }\n  .bx-copyright:before {\n    content: \"\\ea86\";\n  }\n  .bx-credit-card:before {\n    content: \"\\ea87\";\n  }\n  .bx-credit-card-alt:before {\n    content: \"\\ea88\";\n  }\n  .bx-credit-card-front:before {\n    content: \"\\ea89\";\n  }\n  .bx-crop:before {\n    content: \"\\ea8a\";\n  }\n  .bx-crosshair:before {\n    content: \"\\ea8b\";\n  }\n  .bx-crown:before {\n    content: \"\\ea8c\";\n  }\n  .bx-cube:before {\n    content: \"\\ea8d\";\n  }\n  .bx-cube-alt:before {\n    content: \"\\ea8e\";\n  }\n  .bx-cuboid:before {\n    content: \"\\ea8f\";\n  }\n  .bx-current-location:before {\n    content: \"\\ea90\";\n  }\n  .bx-customize:before {\n    content: \"\\ea91\";\n  }\n  .bx-cut:before {\n    content: \"\\ea92\";\n  }\n  .bx-cycling:before {\n    content: \"\\ea93\";\n  }\n  .bx-cylinder:before {\n    content: \"\\ea94\";\n  }\n  .bx-data:before {\n    content: \"\\ea95\";\n  }\n  .bx-desktop:before {\n    content: \"\\ea96\";\n  }\n  .bx-detail:before {\n    content: \"\\ea97\";\n  }\n  .bx-devices:before {\n    content: \"\\ea98\";\n  }\n  .bx-dialpad:before {\n    content: \"\\ea99\";\n  }\n  .bx-dialpad-alt:before {\n    content: \"\\ea9a\";\n  }\n  .bx-diamond:before {\n    content: \"\\ea9b\";\n  }\n  .bx-dice-1:before {\n    content: \"\\ea9c\";\n  }\n  .bx-dice-2:before {\n    content: \"\\ea9d\";\n  }\n  .bx-dice-3:before {\n    content: \"\\ea9e\";\n  }\n  .bx-dice-4:before {\n    content: \"\\ea9f\";\n  }\n  .bx-dice-5:before {\n    content: \"\\eaa0\";\n  }\n  .bx-dice-6:before {\n    content: \"\\eaa1\";\n  }\n  .bx-directions:before {\n    content: \"\\eaa2\";\n  }\n  .bx-disc:before {\n    content: \"\\eaa3\";\n  }\n  .bx-dish:before {\n    content: \"\\eaa4\";\n  }\n  .bx-dislike:before {\n    content: \"\\eaa5\";\n  }\n  .bx-dizzy:before {\n    content: \"\\eaa6\";\n  }\n  .bx-dna:before {\n    content: \"\\eaa7\";\n  }\n  .bx-dock-bottom:before {\n    content: \"\\eaa8\";\n  }\n  .bx-dock-left:before {\n    content: \"\\eaa9\";\n  }\n  .bx-dock-right:before {\n    content: \"\\eaaa\";\n  }\n  .bx-dock-top:before {\n    content: \"\\eaab\";\n  }\n  .bx-dollar:before {\n    content: \"\\eaac\";\n  }\n  .bx-dollar-circle:before {\n    content: \"\\eaad\";\n  }\n  .bx-donate-blood:before {\n    content: \"\\eaae\";\n  }\n  .bx-donate-heart:before {\n    content: \"\\eaaf\";\n  }\n  .bx-door-open:before {\n    content: \"\\eab0\";\n  }\n  .bx-dots-horizontal:before {\n    content: \"\\eab1\";\n  }\n  .bx-dots-horizontal-rounded:before {\n    content: \"\\eab2\";\n  }\n  .bx-dots-vertical:before {\n    content: \"\\eab3\";\n  }\n  .bx-dots-vertical-rounded:before {\n    content: \"\\eab4\";\n  }\n  .bx-doughnut-chart:before {\n    content: \"\\eab5\";\n  }\n  .bx-down-arrow:before {\n    content: \"\\eab6\";\n  }\n  .bx-down-arrow-alt:before {\n    content: \"\\eab7\";\n  }\n  .bx-down-arrow-circle:before {\n    content: \"\\eab8\";\n  }\n  .bx-download:before {\n    content: \"\\eab9\";\n  }\n  .bx-downvote:before {\n    content: \"\\eaba\";\n  }\n  .bx-drink:before {\n    content: \"\\eabb\";\n  }\n  .bx-droplet:before {\n    content: \"\\eabc\";\n  }\n  .bx-dumbbell:before {\n    content: \"\\eabd\";\n  }\n  .bx-duplicate:before {\n    content: \"\\eabe\";\n  }\n  .bx-edit:before {\n    content: \"\\eabf\";\n  }\n  .bx-edit-alt:before {\n    content: \"\\eac0\";\n  }\n  .bx-envelope:before {\n    content: \"\\eac1\";\n  }\n  .bx-envelope-open:before {\n    content: \"\\eac2\";\n  }\n  .bx-equalizer:before {\n    content: \"\\eac3\";\n  }\n  .bx-eraser:before {\n    content: \"\\eac4\";\n  }\n  .bx-error:before {\n    content: \"\\eac5\";\n  }\n  .bx-error-alt:before {\n    content: \"\\eac6\";\n  }\n  .bx-error-circle:before {\n    content: \"\\eac7\";\n  }\n  .bx-euro:before {\n    content: \"\\eac8\";\n  }\n  .bx-exclude:before {\n    content: \"\\eac9\";\n  }\n  .bx-exit:before {\n    content: \"\\eaca\";\n  }\n  .bx-exit-fullscreen:before {\n    content: \"\\eacb\";\n  }\n  .bx-expand:before {\n    content: \"\\eacc\";\n  }\n  .bx-expand-alt:before {\n    content: \"\\eacd\";\n  }\n  .bx-export:before {\n    content: \"\\eace\";\n  }\n  .bx-extension:before {\n    content: \"\\eacf\";\n  }\n  .bx-face:before {\n    content: \"\\ead0\";\n  }\n  .bx-fast-forward:before {\n    content: \"\\ead1\";\n  }\n  .bx-fast-forward-circle:before {\n    content: \"\\ead2\";\n  }\n  .bx-female:before {\n    content: \"\\ead3\";\n  }\n  .bx-female-sign:before {\n    content: \"\\ead4\";\n  }\n  .bx-file:before {\n    content: \"\\ead5\";\n  }\n  .bx-file-blank:before {\n    content: \"\\ead6\";\n  }\n  .bx-file-find:before {\n    content: \"\\ead7\";\n  }\n  .bx-film:before {\n    content: \"\\ead8\";\n  }\n  .bx-filter:before {\n    content: \"\\ead9\";\n  }\n  .bx-filter-alt:before {\n    content: \"\\eada\";\n  }\n  .bx-fingerprint:before {\n    content: \"\\eadb\";\n  }\n  .bx-first-aid:before {\n    content: \"\\eadc\";\n  }\n  .bx-first-page:before {\n    content: \"\\eadd\";\n  }\n  .bx-flag:before {\n    content: \"\\eade\";\n  }\n  .bx-folder:before {\n    content: \"\\eadf\";\n  }\n  .bx-folder-minus:before {\n    content: \"\\eae0\";\n  }\n  .bx-folder-open:before {\n    content: \"\\eae1\";\n  }\n  .bx-folder-plus:before {\n    content: \"\\eae2\";\n  }\n  .bx-font:before {\n    content: \"\\eae3\";\n  }\n  .bx-font-color:before {\n    content: \"\\eae4\";\n  }\n  .bx-font-family:before {\n    content: \"\\eae5\";\n  }\n  .bx-font-size:before {\n    content: \"\\eae6\";\n  }\n  .bx-food-menu:before {\n    content: \"\\eae7\";\n  }\n  .bx-food-tag:before {\n    content: \"\\eae8\";\n  }\n  .bx-football:before {\n    content: \"\\eae9\";\n  }\n  .bx-fridge:before {\n    content: \"\\eaea\";\n  }\n  .bx-fullscreen:before {\n    content: \"\\eaeb\";\n  }\n  .bx-game:before {\n    content: \"\\eaec\";\n  }\n  .bx-gas-pump:before {\n    content: \"\\eaed\";\n  }\n  .bx-ghost:before {\n    content: \"\\eaee\";\n  }\n  .bx-gift:before {\n    content: \"\\eaef\";\n  }\n  .bx-git-branch:before {\n    content: \"\\eaf0\";\n  }\n  .bx-git-commit:before {\n    content: \"\\eaf1\";\n  }\n  .bx-git-compare:before {\n    content: \"\\eaf2\";\n  }\n  .bx-git-merge:before {\n    content: \"\\eaf3\";\n  }\n  .bx-git-pull-request:before {\n    content: \"\\eaf4\";\n  }\n  .bx-git-repo-forked:before {\n    content: \"\\eaf5\";\n  }\n  .bx-glasses:before {\n    content: \"\\eaf6\";\n  }\n  .bx-glasses-alt:before {\n    content: \"\\eaf7\";\n  }\n  .bx-globe:before {\n    content: \"\\eaf8\";\n  }\n  .bx-globe-alt:before {\n    content: \"\\eaf9\";\n  }\n  .bx-grid:before {\n    content: \"\\eafa\";\n  }\n  .bx-grid-alt:before {\n    content: \"\\eafb\";\n  }\n  .bx-grid-horizontal:before {\n    content: \"\\eafc\";\n  }\n  .bx-grid-small:before {\n    content: \"\\eafd\";\n  }\n  .bx-grid-vertical:before {\n    content: \"\\eafe\";\n  }\n  .bx-group:before {\n    content: \"\\eaff\";\n  }\n  .bx-handicap:before {\n    content: \"\\eb00\";\n  }\n  .bx-happy:before {\n    content: \"\\eb01\";\n  }\n  .bx-happy-alt:before {\n    content: \"\\eb02\";\n  }\n  .bx-happy-beaming:before {\n    content: \"\\eb03\";\n  }\n  .bx-happy-heart-eyes:before {\n    content: \"\\eb04\";\n  }\n  .bx-hash:before {\n    content: \"\\eb05\";\n  }\n  .bx-hdd:before {\n    content: \"\\eb06\";\n  }\n  .bx-heading:before {\n    content: \"\\eb07\";\n  }\n  .bx-headphone:before {\n    content: \"\\eb08\";\n  }\n  .bx-health:before {\n    content: \"\\eb09\";\n  }\n  .bx-heart:before {\n    content: \"\\eb0a\";\n  }\n  .bx-heart-circle:before {\n    content: \"\\eb0b\";\n  }\n  .bx-heart-square:before {\n    content: \"\\eb0c\";\n  }\n  .bx-help-circle:before {\n    content: \"\\eb0d\";\n  }\n  .bx-hide:before {\n    content: \"\\eb0e\";\n  }\n  .bx-highlight:before {\n    content: \"\\eb0f\";\n  }\n  .bx-history:before {\n    content: \"\\eb10\";\n  }\n  .bx-hive:before {\n    content: \"\\eb11\";\n  }\n  .bx-home:before {\n    content: \"\\eb12\";\n  }\n  .bx-home-alt:before {\n    content: \"\\eb13\";\n  }\n  .bx-home-circle:before {\n    content: \"\\eb14\";\n  }\n  .bx-home-heart:before {\n    content: \"\\eb15\";\n  }\n  .bx-home-smile:before {\n    content: \"\\eb16\";\n  }\n  .bx-horizontal-center:before {\n    content: \"\\eb17\";\n  }\n  .bx-hotel:before {\n    content: \"\\eb18\";\n  }\n  .bx-hourglass:before {\n    content: \"\\eb19\";\n  }\n  .bx-id-card:before {\n    content: \"\\eb1a\";\n  }\n  .bx-image:before {\n    content: \"\\eb1b\";\n  }\n  .bx-image-add:before {\n    content: \"\\eb1c\";\n  }\n  .bx-image-alt:before {\n    content: \"\\eb1d\";\n  }\n  .bx-images:before {\n    content: \"\\eb1e\";\n  }\n  .bx-import:before {\n    content: \"\\eb1f\";\n  }\n  .bx-infinite:before {\n    content: \"\\eb20\";\n  }\n  .bx-info-circle:before {\n    content: \"\\eb21\";\n  }\n  .bx-info-square:before {\n    content: \"\\eb22\";\n  }\n  .bx-intersect:before {\n    content: \"\\eb23\";\n  }\n  .bx-italic:before {\n    content: \"\\eb24\";\n  }\n  .bx-joystick:before {\n    content: \"\\eb25\";\n  }\n  .bx-joystick-alt:before {\n    content: \"\\eb26\";\n  }\n  .bx-joystick-button:before {\n    content: \"\\eb27\";\n  }\n  .bx-key:before {\n    content: \"\\eb28\";\n  }\n  .bx-label:before {\n    content: \"\\eb29\";\n  }\n  .bx-landscape:before {\n    content: \"\\eb2a\";\n  }\n  .bx-laptop:before {\n    content: \"\\eb2b\";\n  }\n  .bx-last-page:before {\n    content: \"\\eb2c\";\n  }\n  .bx-laugh:before {\n    content: \"\\eb2d\";\n  }\n  .bx-layer:before {\n    content: \"\\eb2e\";\n  }\n  .bx-layer-minus:before {\n    content: \"\\eb2f\";\n  }\n  .bx-layer-plus:before {\n    content: \"\\eb30\";\n  }\n  .bx-layout:before {\n    content: \"\\eb31\";\n  }\n  .bx-left-arrow:before {\n    content: \"\\eb32\";\n  }\n  .bx-left-arrow-alt:before {\n    content: \"\\eb33\";\n  }\n  .bx-left-arrow-circle:before {\n    content: \"\\eb34\";\n  }\n  .bx-left-down-arrow-circle:before {\n    content: \"\\eb35\";\n  }\n  .bx-left-indent:before {\n    content: \"\\eb36\";\n  }\n  .bx-left-top-arrow-circle:before {\n    content: \"\\eb37\";\n  }\n  .bx-library:before {\n    content: \"\\eb38\";\n  }\n  .bx-like:before {\n    content: \"\\eb39\";\n  }\n  .bx-line-chart:before {\n    content: \"\\eb3a\";\n  }\n  .bx-line-chart-down:before {\n    content: \"\\eb3b\";\n  }\n  .bx-link:before {\n    content: \"\\eb3c\";\n  }\n  .bx-link-alt:before {\n    content: \"\\eb3d\";\n  }\n  .bx-link-external:before {\n    content: \"\\eb3e\";\n  }\n  .bx-lira:before {\n    content: \"\\eb3f\";\n  }\n  .bx-list-check:before {\n    content: \"\\eb40\";\n  }\n  .bx-list-minus:before {\n    content: \"\\eb41\";\n  }\n  .bx-list-ol:before {\n    content: \"\\eb42\";\n  }\n  .bx-list-plus:before {\n    content: \"\\eb43\";\n  }\n  .bx-list-ul:before {\n    content: \"\\eb44\";\n  }\n  .bx-loader:before {\n    content: \"\\eb45\";\n  }\n  .bx-loader-alt:before {\n    content: \"\\eb46\";\n  }\n  .bx-loader-circle:before {\n    content: \"\\eb47\";\n  }\n  .bx-location-plus:before {\n    content: \"\\eb48\";\n  }\n  .bx-lock:before {\n    content: \"\\eb49\";\n  }\n  .bx-lock-alt:before {\n    content: \"\\eb4a\";\n  }\n  .bx-lock-open:before {\n    content: \"\\eb4b\";\n  }\n  .bx-lock-open-alt:before {\n    content: \"\\eb4c\";\n  }\n  .bx-log-in:before {\n    content: \"\\eb4d\";\n  }\n  .bx-log-in-circle:before {\n    content: \"\\eb4e\";\n  }\n  .bx-log-out:before {\n    content: \"\\eb4f\";\n  }\n  .bx-log-out-circle:before {\n    content: \"\\eb50\";\n  }\n  .bx-low-vision:before {\n    content: \"\\eb51\";\n  }\n  .bx-magnet:before {\n    content: \"\\eb52\";\n  }\n  .bx-mail-send:before {\n    content: \"\\eb53\";\n  }\n  .bx-male:before {\n    content: \"\\eb54\";\n  }\n  .bx-male-sign:before {\n    content: \"\\eb55\";\n  }\n  .bx-map:before {\n    content: \"\\eb56\";\n  }\n  .bx-map-alt:before {\n    content: \"\\eb57\";\n  }\n  .bx-map-pin:before {\n    content: \"\\eb58\";\n  }\n  .bx-mask:before {\n    content: \"\\eb59\";\n  }\n  .bx-medal:before {\n    content: \"\\eb5a\";\n  }\n  .bx-meh:before {\n    content: \"\\eb5b\";\n  }\n  .bx-meh-alt:before {\n    content: \"\\eb5c\";\n  }\n  .bx-meh-blank:before {\n    content: \"\\eb5d\";\n  }\n  .bx-memory-card:before {\n    content: \"\\eb5e\";\n  }\n  .bx-menu:before {\n    content: \"\\eb5f\";\n  }\n  .bx-menu-alt-left:before {\n    content: \"\\eb60\";\n  }\n  .bx-menu-alt-right:before {\n    content: \"\\eb61\";\n  }\n  .bx-merge:before {\n    content: \"\\eb62\";\n  }\n  .bx-message:before {\n    content: \"\\eb63\";\n  }\n  .bx-message-add:before {\n    content: \"\\eb64\";\n  }\n  .bx-message-alt:before {\n    content: \"\\eb65\";\n  }\n  .bx-message-alt-add:before {\n    content: \"\\eb66\";\n  }\n  .bx-message-alt-check:before {\n    content: \"\\eb67\";\n  }\n  .bx-message-alt-detail:before {\n    content: \"\\eb68\";\n  }\n  .bx-message-alt-dots:before {\n    content: \"\\eb69\";\n  }\n  .bx-message-alt-edit:before {\n    content: \"\\eb6a\";\n  }\n  .bx-message-alt-error:before {\n    content: \"\\eb6b\";\n  }\n  .bx-message-alt-minus:before {\n    content: \"\\eb6c\";\n  }\n  .bx-message-alt-x:before {\n    content: \"\\eb6d\";\n  }\n  .bx-message-check:before {\n    content: \"\\eb6e\";\n  }\n  .bx-message-detail:before {\n    content: \"\\eb6f\";\n  }\n  .bx-message-dots:before {\n    content: \"\\eb70\";\n  }\n  .bx-message-edit:before {\n    content: \"\\eb71\";\n  }\n  .bx-message-error:before {\n    content: \"\\eb72\";\n  }\n  .bx-message-minus:before {\n    content: \"\\eb73\";\n  }\n  .bx-message-rounded:before {\n    content: \"\\eb74\";\n  }\n  .bx-message-rounded-add:before {\n    content: \"\\eb75\";\n  }\n  .bx-message-rounded-check:before {\n    content: \"\\eb76\";\n  }\n  .bx-message-rounded-detail:before {\n    content: \"\\eb77\";\n  }\n  .bx-message-rounded-dots:before {\n    content: \"\\eb78\";\n  }\n  .bx-message-rounded-edit:before {\n    content: \"\\eb79\";\n  }\n  .bx-message-rounded-error:before {\n    content: \"\\eb7a\";\n  }\n  .bx-message-rounded-minus:before {\n    content: \"\\eb7b\";\n  }\n  .bx-message-rounded-x:before {\n    content: \"\\eb7c\";\n  }\n  .bx-message-square:before {\n    content: \"\\eb7d\";\n  }\n  .bx-message-square-add:before {\n    content: \"\\eb7e\";\n  }\n  .bx-message-square-check:before {\n    content: \"\\eb7f\";\n  }\n  .bx-message-square-detail:before {\n    content: \"\\eb80\";\n  }\n  .bx-message-square-dots:before {\n    content: \"\\eb81\";\n  }\n  .bx-message-square-edit:before {\n    content: \"\\eb82\";\n  }\n  .bx-message-square-error:before {\n    content: \"\\eb83\";\n  }\n  .bx-message-square-minus:before {\n    content: \"\\eb84\";\n  }\n  .bx-message-square-x:before {\n    content: \"\\eb85\";\n  }\n  .bx-message-x:before {\n    content: \"\\eb86\";\n  }\n  .bx-meteor:before {\n    content: \"\\eb87\";\n  }\n  .bx-microchip:before {\n    content: \"\\eb88\";\n  }\n  .bx-microphone:before {\n    content: \"\\eb89\";\n  }\n  .bx-microphone-off:before {\n    content: \"\\eb8a\";\n  }\n  .bx-minus:before {\n    content: \"\\eb8b\";\n  }\n  .bx-minus-back:before {\n    content: \"\\eb8c\";\n  }\n  .bx-minus-circle:before {\n    content: \"\\eb8d\";\n  }\n  .bx-minus-front:before {\n    content: \"\\eb8e\";\n  }\n  .bx-mobile:before {\n    content: \"\\eb8f\";\n  }\n  .bx-mobile-alt:before {\n    content: \"\\eb90\";\n  }\n  .bx-mobile-landscape:before {\n    content: \"\\eb91\";\n  }\n  .bx-mobile-vibration:before {\n    content: \"\\eb92\";\n  }\n  .bx-money:before {\n    content: \"\\eb93\";\n  }\n  .bx-moon:before {\n    content: \"\\eb94\";\n  }\n  .bx-mouse:before {\n    content: \"\\eb95\";\n  }\n  .bx-mouse-alt:before {\n    content: \"\\eb96\";\n  }\n  .bx-move:before {\n    content: \"\\eb97\";\n  }\n  .bx-move-horizontal:before {\n    content: \"\\eb98\";\n  }\n  .bx-move-vertical:before {\n    content: \"\\eb99\";\n  }\n  .bx-movie:before {\n    content: \"\\eb9a\";\n  }\n  .bx-movie-play:before {\n    content: \"\\eb9b\";\n  }\n  .bx-music:before {\n    content: \"\\eb9c\";\n  }\n  .bx-navigation:before {\n    content: \"\\eb9d\";\n  }\n  .bx-network-chart:before {\n    content: \"\\eb9e\";\n  }\n  .bx-news:before {\n    content: \"\\eb9f\";\n  }\n  .bx-no-entry:before {\n    content: \"\\eba0\";\n  }\n  .bx-note:before {\n    content: \"\\eba1\";\n  }\n  .bx-notepad:before {\n    content: \"\\eba2\";\n  }\n  .bx-notification:before {\n    content: \"\\eba3\";\n  }\n  .bx-notification-off:before {\n    content: \"\\eba4\";\n  }\n  .bx-outline:before {\n    content: \"\\eba5\";\n  }\n  .bx-package:before {\n    content: \"\\eba6\";\n  }\n  .bx-paint:before {\n    content: \"\\eba7\";\n  }\n  .bx-paint-roll:before {\n    content: \"\\eba8\";\n  }\n  .bx-palette:before {\n    content: \"\\eba9\";\n  }\n  .bx-paperclip:before {\n    content: \"\\ebaa\";\n  }\n  .bx-paper-plane:before {\n    content: \"\\ebab\";\n  }\n  .bx-paragraph:before {\n    content: \"\\ebac\";\n  }\n  .bx-paste:before {\n    content: \"\\ebad\";\n  }\n  .bx-pause:before {\n    content: \"\\ebae\";\n  }\n  .bx-pause-circle:before {\n    content: \"\\ebaf\";\n  }\n  .bx-pen:before {\n    content: \"\\ebb0\";\n  }\n  .bx-pencil:before {\n    content: \"\\ebb1\";\n  }\n  .bx-phone:before {\n    content: \"\\ebb2\";\n  }\n  .bx-phone-call:before {\n    content: \"\\ebb3\";\n  }\n  .bx-phone-incoming:before {\n    content: \"\\ebb4\";\n  }\n  .bx-phone-off:before {\n    content: \"\\ebb5\";\n  }\n  .bx-phone-outgoing:before {\n    content: \"\\ebb6\";\n  }\n  .bx-photo-album:before {\n    content: \"\\ebb7\";\n  }\n  .bx-pie-chart:before {\n    content: \"\\ebb8\";\n  }\n  .bx-pie-chart-alt:before {\n    content: \"\\ebb9\";\n  }\n  .bx-pie-chart-alt-2:before {\n    content: \"\\ebba\";\n  }\n  .bx-pin:before {\n    content: \"\\ebbb\";\n  }\n  .bx-planet:before {\n    content: \"\\ebbc\";\n  }\n  .bx-play:before {\n    content: \"\\ebbd\";\n  }\n  .bx-play-circle:before {\n    content: \"\\ebbe\";\n  }\n  .bx-plug:before {\n    content: \"\\ebbf\";\n  }\n  .bx-plus:before {\n    content: \"\\ebc0\";\n  }\n  .bx-plus-circle:before {\n    content: \"\\ebc1\";\n  }\n  .bx-plus-medical:before {\n    content: \"\\ebc2\";\n  }\n  .bx-podcast:before {\n    content: \"\\ebc3\";\n  }\n  .bx-pointer:before {\n    content: \"\\ebc4\";\n  }\n  .bx-poll:before {\n    content: \"\\ebc5\";\n  }\n  .bx-polygon:before {\n    content: \"\\ebc6\";\n  }\n  .bx-pound:before {\n    content: \"\\ebc7\";\n  }\n  .bx-power-off:before {\n    content: \"\\ebc8\";\n  }\n  .bx-printer:before {\n    content: \"\\ebc9\";\n  }\n  .bx-pulse:before {\n    content: \"\\ebca\";\n  }\n  .bx-purchase-tag:before {\n    content: \"\\ebcb\";\n  }\n  .bx-purchase-tag-alt:before {\n    content: \"\\ebcc\";\n  }\n  .bx-pyramid:before {\n    content: \"\\ebcd\";\n  }\n  .bx-qr:before {\n    content: \"\\ebce\";\n  }\n  .bx-qr-scan:before {\n    content: \"\\ebcf\";\n  }\n  .bx-question-mark:before {\n    content: \"\\ebd0\";\n  }\n  .bx-radar:before {\n    content: \"\\ebd1\";\n  }\n  .bx-radio:before {\n    content: \"\\ebd2\";\n  }\n  .bx-radio-circle:before {\n    content: \"\\ebd3\";\n  }\n  .bx-radio-circle-marked:before {\n    content: \"\\ebd4\";\n  }\n  .bx-receipt:before {\n    content: \"\\ebd5\";\n  }\n  .bx-rectangle:before {\n    content: \"\\ebd6\";\n  }\n  .bx-recycle:before {\n    content: \"\\ebd7\";\n  }\n  .bx-redo:before {\n    content: \"\\ebd8\";\n  }\n  .bx-refresh:before {\n    content: \"\\ebd9\";\n  }\n  .bx-registered:before {\n    content: \"\\ebda\";\n  }\n  .bx-rename:before {\n    content: \"\\ebdb\";\n  }\n  .bx-repeat:before {\n    content: \"\\ebdc\";\n  }\n  .bx-reply:before {\n    content: \"\\ebdd\";\n  }\n  .bx-reply-all:before {\n    content: \"\\ebde\";\n  }\n  .bx-repost:before {\n    content: \"\\ebdf\";\n  }\n  .bx-reset:before {\n    content: \"\\ebe0\";\n  }\n  .bx-restaurant:before {\n    content: \"\\ebe1\";\n  }\n  .bx-revision:before {\n    content: \"\\ebe2\";\n  }\n  .bx-rewind:before {\n    content: \"\\ebe3\";\n  }\n  .bx-rewind-circle:before {\n    content: \"\\ebe4\";\n  }\n  .bx-right-arrow:before {\n    content: \"\\ebe5\";\n  }\n  .bx-right-arrow-alt:before {\n    content: \"\\ebe6\";\n  }\n  .bx-right-arrow-circle:before {\n    content: \"\\ebe7\";\n  }\n  .bx-right-down-arrow-circle:before {\n    content: \"\\ebe8\";\n  }\n  .bx-right-indent:before {\n    content: \"\\ebe9\";\n  }\n  .bx-right-top-arrow-circle:before {\n    content: \"\\ebea\";\n  }\n  .bx-rocket:before {\n    content: \"\\ebeb\";\n  }\n  .bx-rotate-left:before {\n    content: \"\\ebec\";\n  }\n  .bx-rotate-right:before {\n    content: \"\\ebed\";\n  }\n  .bx-rss:before {\n    content: \"\\ebee\";\n  }\n  .bx-ruble:before {\n    content: \"\\ebef\";\n  }\n  .bx-ruler:before {\n    content: \"\\ebf0\";\n  }\n  .bx-run:before {\n    content: \"\\ebf1\";\n  }\n  .bx-rupee:before {\n    content: \"\\ebf2\";\n  }\n  .bx-sad:before {\n    content: \"\\ebf3\";\n  }\n  .bx-save:before {\n    content: \"\\ebf4\";\n  }\n  .bx-scan:before {\n    content: \"\\ebf5\";\n  }\n  .bx-screenshot:before {\n    content: \"\\ebf6\";\n  }\n  .bx-search:before {\n    content: \"\\ebf7\";\n  }\n  .bx-search-alt:before {\n    content: \"\\ebf8\";\n  }\n  .bx-search-alt-2:before {\n    content: \"\\ebf9\";\n  }\n  .bx-selection:before {\n    content: \"\\ebfa\";\n  }\n  .bx-select-multiple:before {\n    content: \"\\ebfb\";\n  }\n  .bx-send:before {\n    content: \"\\ebfc\";\n  }\n  .bx-server:before {\n    content: \"\\ebfd\";\n  }\n  .bx-shape-circle:before {\n    content: \"\\ebfe\";\n  }\n  .bx-shape-polygon:before {\n    content: \"\\ebff\";\n  }\n  .bx-shape-square:before {\n    content: \"\\ec00\";\n  }\n  .bx-shape-triangle:before {\n    content: \"\\ec01\";\n  }\n  .bx-share:before {\n    content: \"\\ec02\";\n  }\n  .bx-share-alt:before {\n    content: \"\\ec03\";\n  }\n  .bx-shekel:before {\n    content: \"\\ec04\";\n  }\n  .bx-shield:before {\n    content: \"\\ec05\";\n  }\n  .bx-shield-alt:before {\n    content: \"\\ec06\";\n  }\n  .bx-shield-alt-2:before {\n    content: \"\\ec07\";\n  }\n  .bx-shield-quarter:before {\n    content: \"\\ec08\";\n  }\n  .bx-shield-x:before {\n    content: \"\\ec09\";\n  }\n  .bx-shocked:before {\n    content: \"\\ec0a\";\n  }\n  .bx-shopping-bag:before {\n    content: \"\\ec0b\";\n  }\n  .bx-show:before {\n    content: \"\\ec0c\";\n  }\n  .bx-show-alt:before {\n    content: \"\\ec0d\";\n  }\n  .bx-shuffle:before {\n    content: \"\\ec0e\";\n  }\n  .bx-sidebar:before {\n    content: \"\\ec0f\";\n  }\n  .bx-sitemap:before {\n    content: \"\\ec10\";\n  }\n  .bx-skip-next:before {\n    content: \"\\ec11\";\n  }\n  .bx-skip-next-circle:before {\n    content: \"\\ec12\";\n  }\n  .bx-skip-previous:before {\n    content: \"\\ec13\";\n  }\n  .bx-skip-previous-circle:before {\n    content: \"\\ec14\";\n  }\n  .bx-sleepy:before {\n    content: \"\\ec15\";\n  }\n  .bx-slider:before {\n    content: \"\\ec16\";\n  }\n  .bx-slider-alt:before {\n    content: \"\\ec17\";\n  }\n  .bx-slideshow:before {\n    content: \"\\ec18\";\n  }\n  .bx-smile:before {\n    content: \"\\ec19\";\n  }\n  .bx-sort:before {\n    content: \"\\ec1a\";\n  }\n  .bx-sort-alt-2:before {\n    content: \"\\ec1b\";\n  }\n  .bx-sort-a-z:before {\n    content: \"\\ec1c\";\n  }\n  .bx-sort-down:before {\n    content: \"\\ec1d\";\n  }\n  .bx-sort-up:before {\n    content: \"\\ec1e\";\n  }\n  .bx-sort-z-a:before {\n    content: \"\\ec1f\";\n  }\n  .bx-spa:before {\n    content: \"\\ec20\";\n  }\n  .bx-space-bar:before {\n    content: \"\\ec21\";\n  }\n  .bx-speaker:before {\n    content: \"\\ec22\";\n  }\n  .bx-spray-can:before {\n    content: \"\\ec23\";\n  }\n  .bx-spreadsheet:before {\n    content: \"\\ec24\";\n  }\n  .bx-square:before {\n    content: \"\\ec25\";\n  }\n  .bx-square-rounded:before {\n    content: \"\\ec26\";\n  }\n  .bx-star:before {\n    content: \"\\ec27\";\n  }\n  .bx-station:before {\n    content: \"\\ec28\";\n  }\n  .bx-stats:before {\n    content: \"\\ec29\";\n  }\n  .bx-sticker:before {\n    content: \"\\ec2a\";\n  }\n  .bx-stop:before {\n    content: \"\\ec2b\";\n  }\n  .bx-stop-circle:before {\n    content: \"\\ec2c\";\n  }\n  .bx-stopwatch:before {\n    content: \"\\ec2d\";\n  }\n  .bx-store:before {\n    content: \"\\ec2e\";\n  }\n  .bx-store-alt:before {\n    content: \"\\ec2f\";\n  }\n  .bx-street-view:before {\n    content: \"\\ec30\";\n  }\n  .bx-strikethrough:before {\n    content: \"\\ec31\";\n  }\n  .bx-subdirectory-left:before {\n    content: \"\\ec32\";\n  }\n  .bx-subdirectory-right:before {\n    content: \"\\ec33\";\n  }\n  .bx-sun:before {\n    content: \"\\ec34\";\n  }\n  .bx-support:before {\n    content: \"\\ec35\";\n  }\n  .bx-swim:before {\n    content: \"\\ec36\";\n  }\n  .bx-sync:before {\n    content: \"\\ec37\";\n  }\n  .bx-tab:before {\n    content: \"\\ec38\";\n  }\n  .bx-table:before {\n    content: \"\\ec39\";\n  }\n  .bx-tachometer:before {\n    content: \"\\ec3a\";\n  }\n  .bx-tag:before {\n    content: \"\\ec3b\";\n  }\n  .bx-tag-alt:before {\n    content: \"\\ec3c\";\n  }\n  .bx-target-lock:before {\n    content: \"\\ec3d\";\n  }\n  .bx-task:before {\n    content: \"\\ec3e\";\n  }\n  .bx-task-x:before {\n    content: \"\\ec3f\";\n  }\n  .bx-taxi:before {\n    content: \"\\ec40\";\n  }\n  .bx-tennis-ball:before {\n    content: \"\\ec41\";\n  }\n  .bx-terminal:before {\n    content: \"\\ec42\";\n  }\n  .bx-test-tube:before {\n    content: \"\\ec43\";\n  }\n  .bx-text:before {\n    content: \"\\ec44\";\n  }\n  .bx-time:before {\n    content: \"\\ec45\";\n  }\n  .bx-time-five:before {\n    content: \"\\ec46\";\n  }\n  .bx-timer:before {\n    content: \"\\ec47\";\n  }\n  .bx-tired:before {\n    content: \"\\ec48\";\n  }\n  .bx-toggle-left:before {\n    content: \"\\ec49\";\n  }\n  .bx-toggle-right:before {\n    content: \"\\ec4a\";\n  }\n  .bx-tone:before {\n    content: \"\\ec4b\";\n  }\n  .bx-traffic-cone:before {\n    content: \"\\ec4c\";\n  }\n  .bx-train:before {\n    content: \"\\ec4d\";\n  }\n  .bx-transfer:before {\n    content: \"\\ec4e\";\n  }\n  .bx-transfer-alt:before {\n    content: \"\\ec4f\";\n  }\n  .bx-trash:before {\n    content: \"\\ec50\";\n  }\n  .bx-trash-alt:before {\n    content: \"\\ec51\";\n  }\n  .bx-trending-down:before {\n    content: \"\\ec52\";\n  }\n  .bx-trending-up:before {\n    content: \"\\ec53\";\n  }\n  .bx-trim:before {\n    content: \"\\ec54\";\n  }\n  .bx-trip:before {\n    content: \"\\ec55\";\n  }\n  .bx-trophy:before {\n    content: \"\\ec56\";\n  }\n  .bx-tv:before {\n    content: \"\\ec57\";\n  }\n  .bx-underline:before {\n    content: \"\\ec58\";\n  }\n  .bx-undo:before {\n    content: \"\\ec59\";\n  }\n  .bx-unite:before {\n    content: \"\\ec5a\";\n  }\n  .bx-unlink:before {\n    content: \"\\ec5b\";\n  }\n  .bx-up-arrow:before {\n    content: \"\\ec5c\";\n  }\n  .bx-up-arrow-alt:before {\n    content: \"\\ec5d\";\n  }\n  .bx-up-arrow-circle:before {\n    content: \"\\ec5e\";\n  }\n  .bx-upload:before {\n    content: \"\\ec5f\";\n  }\n  .bx-upside-down:before {\n    content: \"\\ec60\";\n  }\n  .bx-upvote:before {\n    content: \"\\ec61\";\n  }\n  .bx-usb:before {\n    content: \"\\ec62\";\n  }\n  .bx-user:before {\n    content: \"\\ec63\";\n  }\n  .bx-user-check:before {\n    content: \"\\ec64\";\n  }\n  .bx-user-circle:before {\n    content: \"\\ec65\";\n  }\n  .bx-user-minus:before {\n    content: \"\\ec66\";\n  }\n  .bx-user-pin:before {\n    content: \"\\ec67\";\n  }\n  .bx-user-plus:before {\n    content: \"\\ec68\";\n  }\n  .bx-user-voice:before {\n    content: \"\\ec69\";\n  }\n  .bx-user-x:before {\n    content: \"\\ec6a\";\n  }\n  .bx-vector:before {\n    content: \"\\ec6b\";\n  }\n  .bx-vertical-center:before {\n    content: \"\\ec6c\";\n  }\n  .bx-vial:before {\n    content: \"\\ec6d\";\n  }\n  .bx-video:before {\n    content: \"\\ec6e\";\n  }\n  .bx-video-off:before {\n    content: \"\\ec6f\";\n  }\n  .bx-video-plus:before {\n    content: \"\\ec70\";\n  }\n  .bx-video-recording:before {\n    content: \"\\ec71\";\n  }\n  .bx-voicemail:before {\n    content: \"\\ec72\";\n  }\n  .bx-volume:before {\n    content: \"\\ec73\";\n  }\n  .bx-volume-full:before {\n    content: \"\\ec74\";\n  }\n  .bx-volume-low:before {\n    content: \"\\ec75\";\n  }\n  .bx-volume-mute:before {\n    content: \"\\ec76\";\n  }\n  .bx-walk:before {\n    content: \"\\ec77\";\n  }\n  .bx-wallet:before {\n    content: \"\\ec78\";\n  }\n  .bx-wallet-alt:before {\n    content: \"\\ec79\";\n  }\n  .bx-water:before {\n    content: \"\\ec7a\";\n  }\n  .bx-webcam:before {\n    content: \"\\ec7b\";\n  }\n  .bx-wifi:before {\n    content: \"\\ec7c\";\n  }\n  .bx-wifi-0:before {\n    content: \"\\ec7d\";\n  }\n  .bx-wifi-1:before {\n    content: \"\\ec7e\";\n  }\n  .bx-wifi-2:before {\n    content: \"\\ec7f\";\n  }\n  .bx-wifi-off:before {\n    content: \"\\ec80\";\n  }\n  .bx-wind:before {\n    content: \"\\ec81\";\n  }\n  .bx-window:before {\n    content: \"\\ec82\";\n  }\n  .bx-window-alt:before {\n    content: \"\\ec83\";\n  }\n  .bx-window-close:before {\n    content: \"\\ec84\";\n  }\n  .bx-window-open:before {\n    content: \"\\ec85\";\n  }\n  .bx-windows:before {\n    content: \"\\ec86\";\n  }\n  .bx-wine:before {\n    content: \"\\ec87\";\n  }\n  .bx-wink-smile:before {\n    content: \"\\ec88\";\n  }\n  .bx-wink-tongue:before {\n    content: \"\\ec89\";\n  }\n  .bx-won:before {\n    content: \"\\ec8a\";\n  }\n  .bx-world:before {\n    content: \"\\ec8b\";\n  }\n  .bx-wrench:before {\n    content: \"\\ec8c\";\n  }\n  .bx-x:before {\n    content: \"\\ec8d\";\n  }\n  .bx-x-circle:before {\n    content: \"\\ec8e\";\n  }\n  .bx-yen:before {\n    content: \"\\ec8f\";\n  }\n  .bx-zoom-in:before {\n    content: \"\\ec90\";\n  }\n  .bx-zoom-out:before {\n    content: \"\\ec91\";\n  }\n  .bxs-party:before {\n    content: \"\\ec92\";\n  }\n  .bxs-hot:before {\n    content: \"\\ec93\";\n  }\n  .bxs-droplet:before {\n    content: \"\\ec94\";\n  }\n  .bxs-cat:before {\n    content: \"\\ec95\";\n  }\n  .bxs-dog:before {\n    content: \"\\ec96\";\n  }\n  .bxs-injection:before {\n    content: \"\\ec97\";\n  }\n  .bxs-leaf:before {\n    content: \"\\ec98\";\n  }\n  .bxs-add-to-queue:before {\n    content: \"\\ec99\";\n  }\n  .bxs-adjust:before {\n    content: \"\\ec9a\";\n  }\n  .bxs-adjust-alt:before {\n    content: \"\\ec9b\";\n  }\n  .bxs-alarm:before {\n    content: \"\\ec9c\";\n  }\n  .bxs-alarm-add:before {\n    content: \"\\ec9d\";\n  }\n  .bxs-alarm-exclamation:before {\n    content: \"\\ec9e\";\n  }\n  .bxs-alarm-off:before {\n    content: \"\\ec9f\";\n  }\n  .bxs-alarm-snooze:before {\n    content: \"\\eca0\";\n  }\n  .bxs-album:before {\n    content: \"\\eca1\";\n  }\n  .bxs-ambulance:before {\n    content: \"\\eca2\";\n  }\n  .bxs-analyse:before {\n    content: \"\\eca3\";\n  }\n  .bxs-angry:before {\n    content: \"\\eca4\";\n  }\n  .bxs-arch:before {\n    content: \"\\eca5\";\n  }\n  .bxs-archive:before {\n    content: \"\\eca6\";\n  }\n  .bxs-archive-in:before {\n    content: \"\\eca7\";\n  }\n  .bxs-archive-out:before {\n    content: \"\\eca8\";\n  }\n  .bxs-area:before {\n    content: \"\\eca9\";\n  }\n  .bxs-arrow-from-bottom:before {\n    content: \"\\ecaa\";\n  }\n  .bxs-arrow-from-left:before {\n    content: \"\\ecab\";\n  }\n  .bxs-arrow-from-right:before {\n    content: \"\\ecac\";\n  }\n  .bxs-arrow-from-top:before {\n    content: \"\\ecad\";\n  }\n  .bxs-arrow-to-bottom:before {\n    content: \"\\ecae\";\n  }\n  .bxs-arrow-to-left:before {\n    content: \"\\ecaf\";\n  }\n  .bxs-arrow-to-right:before {\n    content: \"\\ecb0\";\n  }\n  .bxs-arrow-to-top:before {\n    content: \"\\ecb1\";\n  }\n  .bxs-award:before {\n    content: \"\\ecb2\";\n  }\n  .bxs-baby-carriage:before {\n    content: \"\\ecb3\";\n  }\n  .bxs-backpack:before {\n    content: \"\\ecb4\";\n  }\n  .bxs-badge:before {\n    content: \"\\ecb5\";\n  }\n  .bxs-badge-check:before {\n    content: \"\\ecb6\";\n  }\n  .bxs-badge-dollar:before {\n    content: \"\\ecb7\";\n  }\n  .bxs-ball:before {\n    content: \"\\ecb8\";\n  }\n  .bxs-band-aid:before {\n    content: \"\\ecb9\";\n  }\n  .bxs-bank:before {\n    content: \"\\ecba\";\n  }\n  .bxs-bar-chart-alt-2:before {\n    content: \"\\ecbb\";\n  }\n  .bxs-bar-chart-square:before {\n    content: \"\\ecbc\";\n  }\n  .bxs-barcode:before {\n    content: \"\\ecbd\";\n  }\n  .bxs-baseball:before {\n    content: \"\\ecbe\";\n  }\n  .bxs-basket:before {\n    content: \"\\ecbf\";\n  }\n  .bxs-basketball:before {\n    content: \"\\ecc0\";\n  }\n  .bxs-bath:before {\n    content: \"\\ecc1\";\n  }\n  .bxs-battery:before {\n    content: \"\\ecc2\";\n  }\n  .bxs-battery-charging:before {\n    content: \"\\ecc3\";\n  }\n  .bxs-battery-full:before {\n    content: \"\\ecc4\";\n  }\n  .bxs-battery-low:before {\n    content: \"\\ecc5\";\n  }\n  .bxs-bed:before {\n    content: \"\\ecc6\";\n  }\n  .bxs-been-here:before {\n    content: \"\\ecc7\";\n  }\n  .bxs-beer:before {\n    content: \"\\ecc8\";\n  }\n  .bxs-bell:before {\n    content: \"\\ecc9\";\n  }\n  .bxs-bell-minus:before {\n    content: \"\\ecca\";\n  }\n  .bxs-bell-off:before {\n    content: \"\\eccb\";\n  }\n  .bxs-bell-plus:before {\n    content: \"\\eccc\";\n  }\n  .bxs-bell-ring:before {\n    content: \"\\eccd\";\n  }\n  .bxs-bible:before {\n    content: \"\\ecce\";\n  }\n  .bxs-binoculars:before {\n    content: \"\\eccf\";\n  }\n  .bxs-blanket:before {\n    content: \"\\ecd0\";\n  }\n  .bxs-bolt:before {\n    content: \"\\ecd1\";\n  }\n  .bxs-bolt-circle:before {\n    content: \"\\ecd2\";\n  }\n  .bxs-bomb:before {\n    content: \"\\ecd3\";\n  }\n  .bxs-bone:before {\n    content: \"\\ecd4\";\n  }\n  .bxs-bong:before {\n    content: \"\\ecd5\";\n  }\n  .bxs-book:before {\n    content: \"\\ecd6\";\n  }\n  .bxs-book-add:before {\n    content: \"\\ecd7\";\n  }\n  .bxs-book-alt:before {\n    content: \"\\ecd8\";\n  }\n  .bxs-book-bookmark:before {\n    content: \"\\ecd9\";\n  }\n  .bxs-book-content:before {\n    content: \"\\ecda\";\n  }\n  .bxs-book-heart:before {\n    content: \"\\ecdb\";\n  }\n  .bxs-bookmark:before {\n    content: \"\\ecdc\";\n  }\n  .bxs-bookmark-alt:before {\n    content: \"\\ecdd\";\n  }\n  .bxs-bookmark-alt-minus:before {\n    content: \"\\ecde\";\n  }\n  .bxs-bookmark-alt-plus:before {\n    content: \"\\ecdf\";\n  }\n  .bxs-bookmark-heart:before {\n    content: \"\\ece0\";\n  }\n  .bxs-bookmark-minus:before {\n    content: \"\\ece1\";\n  }\n  .bxs-bookmark-plus:before {\n    content: \"\\ece2\";\n  }\n  .bxs-bookmarks:before {\n    content: \"\\ece3\";\n  }\n  .bxs-bookmark-star:before {\n    content: \"\\ece4\";\n  }\n  .bxs-book-open:before {\n    content: \"\\ece5\";\n  }\n  .bxs-book-reader:before {\n    content: \"\\ece6\";\n  }\n  .bxs-bot:before {\n    content: \"\\ece7\";\n  }\n  .bxs-bowling-ball:before {\n    content: \"\\ece8\";\n  }\n  .bxs-box:before {\n    content: \"\\ece9\";\n  }\n  .bxs-brain:before {\n    content: \"\\ecea\";\n  }\n  .bxs-briefcase:before {\n    content: \"\\eceb\";\n  }\n  .bxs-briefcase-alt:before {\n    content: \"\\ecec\";\n  }\n  .bxs-briefcase-alt-2:before {\n    content: \"\\eced\";\n  }\n  .bxs-brightness:before {\n    content: \"\\ecee\";\n  }\n  .bxs-brightness-half:before {\n    content: \"\\ecef\";\n  }\n  .bxs-brush:before {\n    content: \"\\ecf0\";\n  }\n  .bxs-brush-alt:before {\n    content: \"\\ecf1\";\n  }\n  .bxs-bug:before {\n    content: \"\\ecf2\";\n  }\n  .bxs-bug-alt:before {\n    content: \"\\ecf3\";\n  }\n  .bxs-building:before {\n    content: \"\\ecf4\";\n  }\n  .bxs-building-house:before {\n    content: \"\\ecf5\";\n  }\n  .bxs-buildings:before {\n    content: \"\\ecf6\";\n  }\n  .bxs-bulb:before {\n    content: \"\\ecf7\";\n  }\n  .bxs-bullseye:before {\n    content: \"\\ecf8\";\n  }\n  .bxs-buoy:before {\n    content: \"\\ecf9\";\n  }\n  .bxs-bus:before {\n    content: \"\\ecfa\";\n  }\n  .bxs-business:before {\n    content: \"\\ecfb\";\n  }\n  .bxs-bus-school:before {\n    content: \"\\ecfc\";\n  }\n  .bxs-cabinet:before {\n    content: \"\\ecfd\";\n  }\n  .bxs-cake:before {\n    content: \"\\ecfe\";\n  }\n  .bxs-calculator:before {\n    content: \"\\ecff\";\n  }\n  .bxs-calendar:before {\n    content: \"\\ed00\";\n  }\n  .bxs-calendar-alt:before {\n    content: \"\\ed01\";\n  }\n  .bxs-calendar-check:before {\n    content: \"\\ed02\";\n  }\n  .bxs-calendar-edit:before {\n    content: \"\\ed03\";\n  }\n  .bxs-calendar-event:before {\n    content: \"\\ed04\";\n  }\n  .bxs-calendar-exclamation:before {\n    content: \"\\ed05\";\n  }\n  .bxs-calendar-heart:before {\n    content: \"\\ed06\";\n  }\n  .bxs-calendar-minus:before {\n    content: \"\\ed07\";\n  }\n  .bxs-calendar-plus:before {\n    content: \"\\ed08\";\n  }\n  .bxs-calendar-star:before {\n    content: \"\\ed09\";\n  }\n  .bxs-calendar-week:before {\n    content: \"\\ed0a\";\n  }\n  .bxs-calendar-x:before {\n    content: \"\\ed0b\";\n  }\n  .bxs-camera:before {\n    content: \"\\ed0c\";\n  }\n  .bxs-camera-home:before {\n    content: \"\\ed0d\";\n  }\n  .bxs-camera-movie:before {\n    content: \"\\ed0e\";\n  }\n  .bxs-camera-off:before {\n    content: \"\\ed0f\";\n  }\n  .bxs-camera-plus:before {\n    content: \"\\ed10\";\n  }\n  .bxs-capsule:before {\n    content: \"\\ed11\";\n  }\n  .bxs-captions:before {\n    content: \"\\ed12\";\n  }\n  .bxs-car:before {\n    content: \"\\ed13\";\n  }\n  .bxs-car-battery:before {\n    content: \"\\ed14\";\n  }\n  .bxs-car-crash:before {\n    content: \"\\ed15\";\n  }\n  .bxs-card:before {\n    content: \"\\ed16\";\n  }\n  .bxs-caret-down-circle:before {\n    content: \"\\ed17\";\n  }\n  .bxs-caret-down-square:before {\n    content: \"\\ed18\";\n  }\n  .bxs-caret-left-circle:before {\n    content: \"\\ed19\";\n  }\n  .bxs-caret-left-square:before {\n    content: \"\\ed1a\";\n  }\n  .bxs-caret-right-circle:before {\n    content: \"\\ed1b\";\n  }\n  .bxs-caret-right-square:before {\n    content: \"\\ed1c\";\n  }\n  .bxs-caret-up-circle:before {\n    content: \"\\ed1d\";\n  }\n  .bxs-caret-up-square:before {\n    content: \"\\ed1e\";\n  }\n  .bxs-car-garage:before {\n    content: \"\\ed1f\";\n  }\n  .bxs-car-mechanic:before {\n    content: \"\\ed20\";\n  }\n  .bxs-carousel:before {\n    content: \"\\ed21\";\n  }\n  .bxs-cart:before {\n    content: \"\\ed22\";\n  }\n  .bxs-cart-add:before {\n    content: \"\\ed23\";\n  }\n  .bxs-cart-alt:before {\n    content: \"\\ed24\";\n  }\n  .bxs-cart-download:before {\n    content: \"\\ed25\";\n  }\n  .bxs-car-wash:before {\n    content: \"\\ed26\";\n  }\n  .bxs-category:before {\n    content: \"\\ed27\";\n  }\n  .bxs-category-alt:before {\n    content: \"\\ed28\";\n  }\n  .bxs-cctv:before {\n    content: \"\\ed29\";\n  }\n  .bxs-certification:before {\n    content: \"\\ed2a\";\n  }\n  .bxs-chalkboard:before {\n    content: \"\\ed2b\";\n  }\n  .bxs-chart:before {\n    content: \"\\ed2c\";\n  }\n  .bxs-chat:before {\n    content: \"\\ed2d\";\n  }\n  .bxs-checkbox:before {\n    content: \"\\ed2e\";\n  }\n  .bxs-checkbox-checked:before {\n    content: \"\\ed2f\";\n  }\n  .bxs-checkbox-minus:before {\n    content: \"\\ed30\";\n  }\n  .bxs-check-circle:before {\n    content: \"\\ed31\";\n  }\n  .bxs-check-shield:before {\n    content: \"\\ed32\";\n  }\n  .bxs-check-square:before {\n    content: \"\\ed33\";\n  }\n  .bxs-chess:before {\n    content: \"\\ed34\";\n  }\n  .bxs-chevron-down:before {\n    content: \"\\ed35\";\n  }\n  .bxs-chevron-down-circle:before {\n    content: \"\\ed36\";\n  }\n  .bxs-chevron-down-square:before {\n    content: \"\\ed37\";\n  }\n  .bxs-chevron-left:before {\n    content: \"\\ed38\";\n  }\n  .bxs-chevron-left-circle:before {\n    content: \"\\ed39\";\n  }\n  .bxs-chevron-left-square:before {\n    content: \"\\ed3a\";\n  }\n  .bxs-chevron-right:before {\n    content: \"\\ed3b\";\n  }\n  .bxs-chevron-right-circle:before {\n    content: \"\\ed3c\";\n  }\n  .bxs-chevron-right-square:before {\n    content: \"\\ed3d\";\n  }\n  .bxs-chevrons-down:before {\n    content: \"\\ed3e\";\n  }\n  .bxs-chevrons-left:before {\n    content: \"\\ed3f\";\n  }\n  .bxs-chevrons-right:before {\n    content: \"\\ed40\";\n  }\n  .bxs-chevrons-up:before {\n    content: \"\\ed41\";\n  }\n  .bxs-chevron-up:before {\n    content: \"\\ed42\";\n  }\n  .bxs-chevron-up-circle:before {\n    content: \"\\ed43\";\n  }\n  .bxs-chevron-up-square:before {\n    content: \"\\ed44\";\n  }\n  .bxs-chip:before {\n    content: \"\\ed45\";\n  }\n  .bxs-church:before {\n    content: \"\\ed46\";\n  }\n  .bxs-circle:before {\n    content: \"\\ed47\";\n  }\n  .bxs-city:before {\n    content: \"\\ed48\";\n  }\n  .bxs-clinic:before {\n    content: \"\\ed49\";\n  }\n  .bxs-cloud:before {\n    content: \"\\ed4a\";\n  }\n  .bxs-cloud-download:before {\n    content: \"\\ed4b\";\n  }\n  .bxs-cloud-lightning:before {\n    content: \"\\ed4c\";\n  }\n  .bxs-cloud-rain:before {\n    content: \"\\ed4d\";\n  }\n  .bxs-cloud-upload:before {\n    content: \"\\ed4e\";\n  }\n  .bxs-coffee:before {\n    content: \"\\ed4f\";\n  }\n  .bxs-coffee-alt:before {\n    content: \"\\ed50\";\n  }\n  .bxs-coffee-togo:before {\n    content: \"\\ed51\";\n  }\n  .bxs-cog:before {\n    content: \"\\ed52\";\n  }\n  .bxs-coin:before {\n    content: \"\\ed53\";\n  }\n  .bxs-coin-stack:before {\n    content: \"\\ed54\";\n  }\n  .bxs-collection:before {\n    content: \"\\ed55\";\n  }\n  .bxs-color-fill:before {\n    content: \"\\ed56\";\n  }\n  .bxs-comment:before {\n    content: \"\\ed57\";\n  }\n  .bxs-comment-add:before {\n    content: \"\\ed58\";\n  }\n  .bxs-comment-check:before {\n    content: \"\\ed59\";\n  }\n  .bxs-comment-detail:before {\n    content: \"\\ed5a\";\n  }\n  .bxs-comment-dots:before {\n    content: \"\\ed5b\";\n  }\n  .bxs-comment-edit:before {\n    content: \"\\ed5c\";\n  }\n  .bxs-comment-error:before {\n    content: \"\\ed5d\";\n  }\n  .bxs-comment-minus:before {\n    content: \"\\ed5e\";\n  }\n  .bxs-comment-x:before {\n    content: \"\\ed5f\";\n  }\n  .bxs-compass:before {\n    content: \"\\ed60\";\n  }\n  .bxs-component:before {\n    content: \"\\ed61\";\n  }\n  .bxs-confused:before {\n    content: \"\\ed62\";\n  }\n  .bxs-contact:before {\n    content: \"\\ed63\";\n  }\n  .bxs-conversation:before {\n    content: \"\\ed64\";\n  }\n  .bxs-cookie:before {\n    content: \"\\ed65\";\n  }\n  .bxs-cool:before {\n    content: \"\\ed66\";\n  }\n  .bxs-copy:before {\n    content: \"\\ed67\";\n  }\n  .bxs-copy-alt:before {\n    content: \"\\ed68\";\n  }\n  .bxs-copyright:before {\n    content: \"\\ed69\";\n  }\n  .bxs-coupon:before {\n    content: \"\\ed6a\";\n  }\n  .bxs-credit-card:before {\n    content: \"\\ed6b\";\n  }\n  .bxs-credit-card-alt:before {\n    content: \"\\ed6c\";\n  }\n  .bxs-credit-card-front:before {\n    content: \"\\ed6d\";\n  }\n  .bxs-crop:before {\n    content: \"\\ed6e\";\n  }\n  .bxs-crown:before {\n    content: \"\\ed6f\";\n  }\n  .bxs-cube:before {\n    content: \"\\ed70\";\n  }\n  .bxs-cube-alt:before {\n    content: \"\\ed71\";\n  }\n  .bxs-cuboid:before {\n    content: \"\\ed72\";\n  }\n  .bxs-customize:before {\n    content: \"\\ed73\";\n  }\n  .bxs-cylinder:before {\n    content: \"\\ed74\";\n  }\n  .bxs-dashboard:before {\n    content: \"\\ed75\";\n  }\n  .bxs-data:before {\n    content: \"\\ed76\";\n  }\n  .bxs-detail:before {\n    content: \"\\ed77\";\n  }\n  .bxs-devices:before {\n    content: \"\\ed78\";\n  }\n  .bxs-diamond:before {\n    content: \"\\ed79\";\n  }\n  .bxs-dice-1:before {\n    content: \"\\ed7a\";\n  }\n  .bxs-dice-2:before {\n    content: \"\\ed7b\";\n  }\n  .bxs-dice-3:before {\n    content: \"\\ed7c\";\n  }\n  .bxs-dice-4:before {\n    content: \"\\ed7d\";\n  }\n  .bxs-dice-5:before {\n    content: \"\\ed7e\";\n  }\n  .bxs-dice-6:before {\n    content: \"\\ed7f\";\n  }\n  .bxs-direction-left:before {\n    content: \"\\ed80\";\n  }\n  .bxs-direction-right:before {\n    content: \"\\ed81\";\n  }\n  .bxs-directions:before {\n    content: \"\\ed82\";\n  }\n  .bxs-disc:before {\n    content: \"\\ed83\";\n  }\n  .bxs-discount:before {\n    content: \"\\ed84\";\n  }\n  .bxs-dish:before {\n    content: \"\\ed85\";\n  }\n  .bxs-dislike:before {\n    content: \"\\ed86\";\n  }\n  .bxs-dizzy:before {\n    content: \"\\ed87\";\n  }\n  .bxs-dock-bottom:before {\n    content: \"\\ed88\";\n  }\n  .bxs-dock-left:before {\n    content: \"\\ed89\";\n  }\n  .bxs-dock-right:before {\n    content: \"\\ed8a\";\n  }\n  .bxs-dock-top:before {\n    content: \"\\ed8b\";\n  }\n  .bxs-dollar-circle:before {\n    content: \"\\ed8c\";\n  }\n  .bxs-donate-blood:before {\n    content: \"\\ed8d\";\n  }\n  .bxs-donate-heart:before {\n    content: \"\\ed8e\";\n  }\n  .bxs-door-open:before {\n    content: \"\\ed8f\";\n  }\n  .bxs-doughnut-chart:before {\n    content: \"\\ed90\";\n  }\n  .bxs-down-arrow:before {\n    content: \"\\ed91\";\n  }\n  .bxs-down-arrow-alt:before {\n    content: \"\\ed92\";\n  }\n  .bxs-down-arrow-circle:before {\n    content: \"\\ed93\";\n  }\n  .bxs-down-arrow-square:before {\n    content: \"\\ed94\";\n  }\n  .bxs-download:before {\n    content: \"\\ed95\";\n  }\n  .bxs-downvote:before {\n    content: \"\\ed96\";\n  }\n  .bxs-drink:before {\n    content: \"\\ed97\";\n  }\n  .bxs-droplet-half:before {\n    content: \"\\ed98\";\n  }\n  .bxs-dryer:before {\n    content: \"\\ed99\";\n  }\n  .bxs-duplicate:before {\n    content: \"\\ed9a\";\n  }\n  .bxs-edit:before {\n    content: \"\\ed9b\";\n  }\n  .bxs-edit-alt:before {\n    content: \"\\ed9c\";\n  }\n  .bxs-edit-location:before {\n    content: \"\\ed9d\";\n  }\n  .bxs-eject:before {\n    content: \"\\ed9e\";\n  }\n  .bxs-envelope:before {\n    content: \"\\ed9f\";\n  }\n  .bxs-envelope-open:before {\n    content: \"\\eda0\";\n  }\n  .bxs-eraser:before {\n    content: \"\\eda1\";\n  }\n  .bxs-error:before {\n    content: \"\\eda2\";\n  }\n  .bxs-error-alt:before {\n    content: \"\\eda3\";\n  }\n  .bxs-error-circle:before {\n    content: \"\\eda4\";\n  }\n  .bxs-ev-station:before {\n    content: \"\\eda5\";\n  }\n  .bxs-exit:before {\n    content: \"\\eda6\";\n  }\n  .bxs-extension:before {\n    content: \"\\eda7\";\n  }\n  .bxs-eyedropper:before {\n    content: \"\\eda8\";\n  }\n  .bxs-face:before {\n    content: \"\\eda9\";\n  }\n  .bxs-face-mask:before {\n    content: \"\\edaa\";\n  }\n  .bxs-factory:before {\n    content: \"\\edab\";\n  }\n  .bxs-fast-forward-circle:before {\n    content: \"\\edac\";\n  }\n  .bxs-file:before {\n    content: \"\\edad\";\n  }\n  .bxs-file-archive:before {\n    content: \"\\edae\";\n  }\n  .bxs-file-blank:before {\n    content: \"\\edaf\";\n  }\n  .bxs-file-css:before {\n    content: \"\\edb0\";\n  }\n  .bxs-file-doc:before {\n    content: \"\\edb1\";\n  }\n  .bxs-file-export:before {\n    content: \"\\edb2\";\n  }\n  .bxs-file-find:before {\n    content: \"\\edb3\";\n  }\n  .bxs-file-gif:before {\n    content: \"\\edb4\";\n  }\n  .bxs-file-html:before {\n    content: \"\\edb5\";\n  }\n  .bxs-file-image:before {\n    content: \"\\edb6\";\n  }\n  .bxs-file-import:before {\n    content: \"\\edb7\";\n  }\n  .bxs-file-jpg:before {\n    content: \"\\edb8\";\n  }\n  .bxs-file-js:before {\n    content: \"\\edb9\";\n  }\n  .bxs-file-json:before {\n    content: \"\\edba\";\n  }\n  .bxs-file-md:before {\n    content: \"\\edbb\";\n  }\n  .bxs-file-pdf:before {\n    content: \"\\edbc\";\n  }\n  .bxs-file-plus:before {\n    content: \"\\edbd\";\n  }\n  .bxs-file-png:before {\n    content: \"\\edbe\";\n  }\n  .bxs-file-txt:before {\n    content: \"\\edbf\";\n  }\n  .bxs-film:before {\n    content: \"\\edc0\";\n  }\n  .bxs-filter-alt:before {\n    content: \"\\edc1\";\n  }\n  .bxs-first-aid:before {\n    content: \"\\edc2\";\n  }\n  .bxs-flag:before {\n    content: \"\\edc3\";\n  }\n  .bxs-flag-alt:before {\n    content: \"\\edc4\";\n  }\n  .bxs-flag-checkered:before {\n    content: \"\\edc5\";\n  }\n  .bxs-flame:before {\n    content: \"\\edc6\";\n  }\n  .bxs-flask:before {\n    content: \"\\edc7\";\n  }\n  .bxs-florist:before {\n    content: \"\\edc8\";\n  }\n  .bxs-folder:before {\n    content: \"\\edc9\";\n  }\n  .bxs-folder-minus:before {\n    content: \"\\edca\";\n  }\n  .bxs-folder-open:before {\n    content: \"\\edcb\";\n  }\n  .bxs-folder-plus:before {\n    content: \"\\edcc\";\n  }\n  .bxs-food-menu:before {\n    content: \"\\edcd\";\n  }\n  .bxs-fridge:before {\n    content: \"\\edce\";\n  }\n  .bxs-game:before {\n    content: \"\\edcf\";\n  }\n  .bxs-gas-pump:before {\n    content: \"\\edd0\";\n  }\n  .bxs-ghost:before {\n    content: \"\\edd1\";\n  }\n  .bxs-gift:before {\n    content: \"\\edd2\";\n  }\n  .bxs-graduation:before {\n    content: \"\\edd3\";\n  }\n  .bxs-grid:before {\n    content: \"\\edd4\";\n  }\n  .bxs-grid-alt:before {\n    content: \"\\edd5\";\n  }\n  .bxs-group:before {\n    content: \"\\edd6\";\n  }\n  .bxs-guitar-amp:before {\n    content: \"\\edd7\";\n  }\n  .bxs-hand:before {\n    content: \"\\edd8\";\n  }\n  .bxs-hand-down:before {\n    content: \"\\edd9\";\n  }\n  .bxs-hand-left:before {\n    content: \"\\edda\";\n  }\n  .bxs-hand-right:before {\n    content: \"\\eddb\";\n  }\n  .bxs-hand-up:before {\n    content: \"\\eddc\";\n  }\n  .bxs-happy:before {\n    content: \"\\eddd\";\n  }\n  .bxs-happy-alt:before {\n    content: \"\\edde\";\n  }\n  .bxs-happy-beaming:before {\n    content: \"\\eddf\";\n  }\n  .bxs-happy-heart-eyes:before {\n    content: \"\\ede0\";\n  }\n  .bxs-hdd:before {\n    content: \"\\ede1\";\n  }\n  .bxs-heart:before {\n    content: \"\\ede2\";\n  }\n  .bxs-heart-circle:before {\n    content: \"\\ede3\";\n  }\n  .bxs-heart-square:before {\n    content: \"\\ede4\";\n  }\n  .bxs-help-circle:before {\n    content: \"\\ede5\";\n  }\n  .bxs-hide:before {\n    content: \"\\ede6\";\n  }\n  .bxs-home:before {\n    content: \"\\ede7\";\n  }\n  .bxs-home-circle:before {\n    content: \"\\ede8\";\n  }\n  .bxs-home-heart:before {\n    content: \"\\ede9\";\n  }\n  .bxs-home-smile:before {\n    content: \"\\edea\";\n  }\n  .bxs-hotel:before {\n    content: \"\\edeb\";\n  }\n  .bxs-hourglass:before {\n    content: \"\\edec\";\n  }\n  .bxs-hourglass-bottom:before {\n    content: \"\\eded\";\n  }\n  .bxs-hourglass-top:before {\n    content: \"\\edee\";\n  }\n  .bxs-id-card:before {\n    content: \"\\edef\";\n  }\n  .bxs-image:before {\n    content: \"\\edf0\";\n  }\n  .bxs-image-add:before {\n    content: \"\\edf1\";\n  }\n  .bxs-image-alt:before {\n    content: \"\\edf2\";\n  }\n  .bxs-inbox:before {\n    content: \"\\edf3\";\n  }\n  .bxs-info-circle:before {\n    content: \"\\edf4\";\n  }\n  .bxs-info-square:before {\n    content: \"\\edf5\";\n  }\n  .bxs-institution:before {\n    content: \"\\edf6\";\n  }\n  .bxs-joystick:before {\n    content: \"\\edf7\";\n  }\n  .bxs-joystick-alt:before {\n    content: \"\\edf8\";\n  }\n  .bxs-joystick-button:before {\n    content: \"\\edf9\";\n  }\n  .bxs-key:before {\n    content: \"\\edfa\";\n  }\n  .bxs-keyboard:before {\n    content: \"\\edfb\";\n  }\n  .bxs-label:before {\n    content: \"\\edfc\";\n  }\n  .bxs-landmark:before {\n    content: \"\\edfd\";\n  }\n  .bxs-landscape:before {\n    content: \"\\edfe\";\n  }\n  .bxs-laugh:before {\n    content: \"\\edff\";\n  }\n  .bxs-layer:before {\n    content: \"\\ee00\";\n  }\n  .bxs-layer-minus:before {\n    content: \"\\ee01\";\n  }\n  .bxs-layer-plus:before {\n    content: \"\\ee02\";\n  }\n  .bxs-layout:before {\n    content: \"\\ee03\";\n  }\n  .bxs-left-arrow:before {\n    content: \"\\ee04\";\n  }\n  .bxs-left-arrow-alt:before {\n    content: \"\\ee05\";\n  }\n  .bxs-left-arrow-circle:before {\n    content: \"\\ee06\";\n  }\n  .bxs-left-arrow-square:before {\n    content: \"\\ee07\";\n  }\n  .bxs-left-down-arrow-circle:before {\n    content: \"\\ee08\";\n  }\n  .bxs-left-top-arrow-circle:before {\n    content: \"\\ee09\";\n  }\n  .bxs-like:before {\n    content: \"\\ee0a\";\n  }\n  .bxs-location-plus:before {\n    content: \"\\ee0b\";\n  }\n  .bxs-lock:before {\n    content: \"\\ee0c\";\n  }\n  .bxs-lock-alt:before {\n    content: \"\\ee0d\";\n  }\n  .bxs-lock-open:before {\n    content: \"\\ee0e\";\n  }\n  .bxs-lock-open-alt:before {\n    content: \"\\ee0f\";\n  }\n  .bxs-log-in:before {\n    content: \"\\ee10\";\n  }\n  .bxs-log-in-circle:before {\n    content: \"\\ee11\";\n  }\n  .bxs-log-out:before {\n    content: \"\\ee12\";\n  }\n  .bxs-log-out-circle:before {\n    content: \"\\ee13\";\n  }\n  .bxs-low-vision:before {\n    content: \"\\ee14\";\n  }\n  .bxs-magic-wand:before {\n    content: \"\\ee15\";\n  }\n  .bxs-magnet:before {\n    content: \"\\ee16\";\n  }\n  .bxs-map:before {\n    content: \"\\ee17\";\n  }\n  .bxs-map-alt:before {\n    content: \"\\ee18\";\n  }\n  .bxs-map-pin:before {\n    content: \"\\ee19\";\n  }\n  .bxs-mask:before {\n    content: \"\\ee1a\";\n  }\n  .bxs-medal:before {\n    content: \"\\ee1b\";\n  }\n  .bxs-megaphone:before {\n    content: \"\\ee1c\";\n  }\n  .bxs-meh:before {\n    content: \"\\ee1d\";\n  }\n  .bxs-meh-alt:before {\n    content: \"\\ee1e\";\n  }\n  .bxs-meh-blank:before {\n    content: \"\\ee1f\";\n  }\n  .bxs-memory-card:before {\n    content: \"\\ee20\";\n  }\n  .bxs-message:before {\n    content: \"\\ee21\";\n  }\n  .bxs-message-add:before {\n    content: \"\\ee22\";\n  }\n  .bxs-message-alt:before {\n    content: \"\\ee23\";\n  }\n  .bxs-message-alt-add:before {\n    content: \"\\ee24\";\n  }\n  .bxs-message-alt-check:before {\n    content: \"\\ee25\";\n  }\n  .bxs-message-alt-detail:before {\n    content: \"\\ee26\";\n  }\n  .bxs-message-alt-dots:before {\n    content: \"\\ee27\";\n  }\n  .bxs-message-alt-edit:before {\n    content: \"\\ee28\";\n  }\n  .bxs-message-alt-error:before {\n    content: \"\\ee29\";\n  }\n  .bxs-message-alt-minus:before {\n    content: \"\\ee2a\";\n  }\n  .bxs-message-alt-x:before {\n    content: \"\\ee2b\";\n  }\n  .bxs-message-check:before {\n    content: \"\\ee2c\";\n  }\n  .bxs-message-detail:before {\n    content: \"\\ee2d\";\n  }\n  .bxs-message-dots:before {\n    content: \"\\ee2e\";\n  }\n  .bxs-message-edit:before {\n    content: \"\\ee2f\";\n  }\n  .bxs-message-error:before {\n    content: \"\\ee30\";\n  }\n  .bxs-message-minus:before {\n    content: \"\\ee31\";\n  }\n  .bxs-message-rounded:before {\n    content: \"\\ee32\";\n  }\n  .bxs-message-rounded-add:before {\n    content: \"\\ee33\";\n  }\n  .bxs-message-rounded-check:before {\n    content: \"\\ee34\";\n  }\n  .bxs-message-rounded-detail:before {\n    content: \"\\ee35\";\n  }\n  .bxs-message-rounded-dots:before {\n    content: \"\\ee36\";\n  }\n  .bxs-message-rounded-edit:before {\n    content: \"\\ee37\";\n  }\n  .bxs-message-rounded-error:before {\n    content: \"\\ee38\";\n  }\n  .bxs-message-rounded-minus:before {\n    content: \"\\ee39\";\n  }\n  .bxs-message-rounded-x:before {\n    content: \"\\ee3a\";\n  }\n  .bxs-message-square:before {\n    content: \"\\ee3b\";\n  }\n  .bxs-message-square-add:before {\n    content: \"\\ee3c\";\n  }\n  .bxs-message-square-check:before {\n    content: \"\\ee3d\";\n  }\n  .bxs-message-square-detail:before {\n    content: \"\\ee3e\";\n  }\n  .bxs-message-square-dots:before {\n    content: \"\\ee3f\";\n  }\n  .bxs-message-square-edit:before {\n    content: \"\\ee40\";\n  }\n  .bxs-message-square-error:before {\n    content: \"\\ee41\";\n  }\n  .bxs-message-square-minus:before {\n    content: \"\\ee42\";\n  }\n  .bxs-message-square-x:before {\n    content: \"\\ee43\";\n  }\n  .bxs-message-x:before {\n    content: \"\\ee44\";\n  }\n  .bxs-meteor:before {\n    content: \"\\ee45\";\n  }\n  .bxs-microchip:before {\n    content: \"\\ee46\";\n  }\n  .bxs-microphone:before {\n    content: \"\\ee47\";\n  }\n  .bxs-microphone-alt:before {\n    content: \"\\ee48\";\n  }\n  .bxs-microphone-off:before {\n    content: \"\\ee49\";\n  }\n  .bxs-minus-circle:before {\n    content: \"\\ee4a\";\n  }\n  .bxs-minus-square:before {\n    content: \"\\ee4b\";\n  }\n  .bxs-mobile:before {\n    content: \"\\ee4c\";\n  }\n  .bxs-mobile-vibration:before {\n    content: \"\\ee4d\";\n  }\n  .bxs-moon:before {\n    content: \"\\ee4e\";\n  }\n  .bxs-mouse:before {\n    content: \"\\ee4f\";\n  }\n  .bxs-mouse-alt:before {\n    content: \"\\ee50\";\n  }\n  .bxs-movie:before {\n    content: \"\\ee51\";\n  }\n  .bxs-movie-play:before {\n    content: \"\\ee52\";\n  }\n  .bxs-music:before {\n    content: \"\\ee53\";\n  }\n  .bxs-navigation:before {\n    content: \"\\ee54\";\n  }\n  .bxs-network-chart:before {\n    content: \"\\ee55\";\n  }\n  .bxs-news:before {\n    content: \"\\ee56\";\n  }\n  .bxs-no-entry:before {\n    content: \"\\ee57\";\n  }\n  .bxs-note:before {\n    content: \"\\ee58\";\n  }\n  .bxs-notepad:before {\n    content: \"\\ee59\";\n  }\n  .bxs-notification:before {\n    content: \"\\ee5a\";\n  }\n  .bxs-notification-off:before {\n    content: \"\\ee5b\";\n  }\n  .bxs-offer:before {\n    content: \"\\ee5c\";\n  }\n  .bxs-package:before {\n    content: \"\\ee5d\";\n  }\n  .bxs-paint:before {\n    content: \"\\ee5e\";\n  }\n  .bxs-paint-roll:before {\n    content: \"\\ee5f\";\n  }\n  .bxs-palette:before {\n    content: \"\\ee60\";\n  }\n  .bxs-paper-plane:before {\n    content: \"\\ee61\";\n  }\n  .bxs-parking:before {\n    content: \"\\ee62\";\n  }\n  .bxs-paste:before {\n    content: \"\\ee63\";\n  }\n  .bxs-pen:before {\n    content: \"\\ee64\";\n  }\n  .bxs-pencil:before {\n    content: \"\\ee65\";\n  }\n  .bxs-phone:before {\n    content: \"\\ee66\";\n  }\n  .bxs-phone-call:before {\n    content: \"\\ee67\";\n  }\n  .bxs-phone-incoming:before {\n    content: \"\\ee68\";\n  }\n  .bxs-phone-off:before {\n    content: \"\\ee69\";\n  }\n  .bxs-phone-outgoing:before {\n    content: \"\\ee6a\";\n  }\n  .bxs-photo-album:before {\n    content: \"\\ee6b\";\n  }\n  .bxs-piano:before {\n    content: \"\\ee6c\";\n  }\n  .bxs-pie-chart:before {\n    content: \"\\ee6d\";\n  }\n  .bxs-pie-chart-alt:before {\n    content: \"\\ee6e\";\n  }\n  .bxs-pie-chart-alt-2:before {\n    content: \"\\ee6f\";\n  }\n  .bxs-pin:before {\n    content: \"\\ee70\";\n  }\n  .bxs-pizza:before {\n    content: \"\\ee71\";\n  }\n  .bxs-plane:before {\n    content: \"\\ee72\";\n  }\n  .bxs-plane-alt:before {\n    content: \"\\ee73\";\n  }\n  .bxs-plane-land:before {\n    content: \"\\ee74\";\n  }\n  .bxs-planet:before {\n    content: \"\\ee75\";\n  }\n  .bxs-plane-take-off:before {\n    content: \"\\ee76\";\n  }\n  .bxs-playlist:before {\n    content: \"\\ee77\";\n  }\n  .bxs-plug:before {\n    content: \"\\ee78\";\n  }\n  .bxs-plus-circle:before {\n    content: \"\\ee79\";\n  }\n  .bxs-plus-square:before {\n    content: \"\\ee7a\";\n  }\n  .bxs-pointer:before {\n    content: \"\\ee7b\";\n  }\n  .bxs-polygon:before {\n    content: \"\\ee7c\";\n  }\n  .bxs-printer:before {\n    content: \"\\ee7d\";\n  }\n  .bxs-purchase-tag:before {\n    content: \"\\ee7e\";\n  }\n  .bxs-purchase-tag-alt:before {\n    content: \"\\ee7f\";\n  }\n  .bxs-pyramid:before {\n    content: \"\\ee80\";\n  }\n  .bxs-quote-alt-left:before {\n    content: \"\\ee81\";\n  }\n  .bxs-quote-alt-right:before {\n    content: \"\\ee82\";\n  }\n  .bxs-quote-left:before {\n    content: \"\\ee83\";\n  }\n  .bxs-quote-right:before {\n    content: \"\\ee84\";\n  }\n  .bxs-quote-single-left:before {\n    content: \"\\ee85\";\n  }\n  .bxs-quote-single-right:before {\n    content: \"\\ee86\";\n  }\n  .bxs-radiation:before {\n    content: \"\\ee87\";\n  }\n  .bxs-radio:before {\n    content: \"\\ee88\";\n  }\n  .bxs-receipt:before {\n    content: \"\\ee89\";\n  }\n  .bxs-rectangle:before {\n    content: \"\\ee8a\";\n  }\n  .bxs-registered:before {\n    content: \"\\ee8b\";\n  }\n  .bxs-rename:before {\n    content: \"\\ee8c\";\n  }\n  .bxs-report:before {\n    content: \"\\ee8d\";\n  }\n  .bxs-rewind-circle:before {\n    content: \"\\ee8e\";\n  }\n  .bxs-right-arrow:before {\n    content: \"\\ee8f\";\n  }\n  .bxs-right-arrow-alt:before {\n    content: \"\\ee90\";\n  }\n  .bxs-right-arrow-circle:before {\n    content: \"\\ee91\";\n  }\n  .bxs-right-arrow-square:before {\n    content: \"\\ee92\";\n  }\n  .bxs-right-down-arrow-circle:before {\n    content: \"\\ee93\";\n  }\n  .bxs-right-top-arrow-circle:before {\n    content: \"\\ee94\";\n  }\n  .bxs-rocket:before {\n    content: \"\\ee95\";\n  }\n  .bxs-ruler:before {\n    content: \"\\ee96\";\n  }\n  .bxs-sad:before {\n    content: \"\\ee97\";\n  }\n  .bxs-save:before {\n    content: \"\\ee98\";\n  }\n  .bxs-school:before {\n    content: \"\\ee99\";\n  }\n  .bxs-search:before {\n    content: \"\\ee9a\";\n  }\n  .bxs-search-alt-2:before {\n    content: \"\\ee9b\";\n  }\n  .bxs-select-multiple:before {\n    content: \"\\ee9c\";\n  }\n  .bxs-send:before {\n    content: \"\\ee9d\";\n  }\n  .bxs-server:before {\n    content: \"\\ee9e\";\n  }\n  .bxs-shapes:before {\n    content: \"\\ee9f\";\n  }\n  .bxs-share:before {\n    content: \"\\eea0\";\n  }\n  .bxs-share-alt:before {\n    content: \"\\eea1\";\n  }\n  .bxs-shield:before {\n    content: \"\\eea2\";\n  }\n  .bxs-shield-alt-2:before {\n    content: \"\\eea3\";\n  }\n  .bxs-shield-x:before {\n    content: \"\\eea4\";\n  }\n  .bxs-ship:before {\n    content: \"\\eea5\";\n  }\n  .bxs-shocked:before {\n    content: \"\\eea6\";\n  }\n  .bxs-shopping-bag:before {\n    content: \"\\eea7\";\n  }\n  .bxs-shopping-bag-alt:before {\n    content: \"\\eea8\";\n  }\n  .bxs-shopping-bags:before {\n    content: \"\\eea9\";\n  }\n  .bxs-show:before {\n    content: \"\\eeaa\";\n  }\n  .bxs-skip-next-circle:before {\n    content: \"\\eeab\";\n  }\n  .bxs-skip-previous-circle:before {\n    content: \"\\eeac\";\n  }\n  .bxs-skull:before {\n    content: \"\\eead\";\n  }\n  .bxs-sleepy:before {\n    content: \"\\eeae\";\n  }\n  .bxs-slideshow:before {\n    content: \"\\eeaf\";\n  }\n  .bxs-smile:before {\n    content: \"\\eeb0\";\n  }\n  .bxs-sort-alt:before {\n    content: \"\\eeb1\";\n  }\n  .bxs-spa:before {\n    content: \"\\eeb2\";\n  }\n  .bxs-speaker:before {\n    content: \"\\eeb3\";\n  }\n  .bxs-spray-can:before {\n    content: \"\\eeb4\";\n  }\n  .bxs-spreadsheet:before {\n    content: \"\\eeb5\";\n  }\n  .bxs-square:before {\n    content: \"\\eeb6\";\n  }\n  .bxs-square-rounded:before {\n    content: \"\\eeb7\";\n  }\n  .bxs-star:before {\n    content: \"\\eeb8\";\n  }\n  .bxs-star-half:before {\n    content: \"\\eeb9\";\n  }\n  .bxs-sticker:before {\n    content: \"\\eeba\";\n  }\n  .bxs-stopwatch:before {\n    content: \"\\eebb\";\n  }\n  .bxs-store:before {\n    content: \"\\eebc\";\n  }\n  .bxs-store-alt:before {\n    content: \"\\eebd\";\n  }\n  .bxs-sun:before {\n    content: \"\\eebe\";\n  }\n  .bxs-tachometer:before {\n    content: \"\\eebf\";\n  }\n  .bxs-tag:before {\n    content: \"\\eec0\";\n  }\n  .bxs-tag-alt:before {\n    content: \"\\eec1\";\n  }\n  .bxs-tag-x:before {\n    content: \"\\eec2\";\n  }\n  .bxs-taxi:before {\n    content: \"\\eec3\";\n  }\n  .bxs-tennis-ball:before {\n    content: \"\\eec4\";\n  }\n  .bxs-terminal:before {\n    content: \"\\eec5\";\n  }\n  .bxs-thermometer:before {\n    content: \"\\eec6\";\n  }\n  .bxs-time:before {\n    content: \"\\eec7\";\n  }\n  .bxs-time-five:before {\n    content: \"\\eec8\";\n  }\n  .bxs-timer:before {\n    content: \"\\eec9\";\n  }\n  .bxs-tired:before {\n    content: \"\\eeca\";\n  }\n  .bxs-toggle-left:before {\n    content: \"\\eecb\";\n  }\n  .bxs-toggle-right:before {\n    content: \"\\eecc\";\n  }\n  .bxs-tone:before {\n    content: \"\\eecd\";\n  }\n  .bxs-torch:before {\n    content: \"\\eece\";\n  }\n  .bxs-to-top:before {\n    content: \"\\eecf\";\n  }\n  .bxs-traffic:before {\n    content: \"\\eed0\";\n  }\n  .bxs-traffic-barrier:before {\n    content: \"\\eed1\";\n  }\n  .bxs-traffic-cone:before {\n    content: \"\\eed2\";\n  }\n  .bxs-train:before {\n    content: \"\\eed3\";\n  }\n  .bxs-trash:before {\n    content: \"\\eed4\";\n  }\n  .bxs-trash-alt:before {\n    content: \"\\eed5\";\n  }\n  .bxs-tree:before {\n    content: \"\\eed6\";\n  }\n  .bxs-trophy:before {\n    content: \"\\eed7\";\n  }\n  .bxs-truck:before {\n    content: \"\\eed8\";\n  }\n  .bxs-t-shirt:before {\n    content: \"\\eed9\";\n  }\n  .bxs-tv:before {\n    content: \"\\eeda\";\n  }\n  .bxs-up-arrow:before {\n    content: \"\\eedb\";\n  }\n  .bxs-up-arrow-alt:before {\n    content: \"\\eedc\";\n  }\n  .bxs-up-arrow-circle:before {\n    content: \"\\eedd\";\n  }\n  .bxs-up-arrow-square:before {\n    content: \"\\eede\";\n  }\n  .bxs-upside-down:before {\n    content: \"\\eedf\";\n  }\n  .bxs-upvote:before {\n    content: \"\\eee0\";\n  }\n  .bxs-user:before {\n    content: \"\\eee1\";\n  }\n  .bxs-user-account:before {\n    content: \"\\eee2\";\n  }\n  .bxs-user-badge:before {\n    content: \"\\eee3\";\n  }\n  .bxs-user-check:before {\n    content: \"\\eee4\";\n  }\n  .bxs-user-circle:before {\n    content: \"\\eee5\";\n  }\n  .bxs-user-detail:before {\n    content: \"\\eee6\";\n  }\n  .bxs-user-minus:before {\n    content: \"\\eee7\";\n  }\n  .bxs-user-pin:before {\n    content: \"\\eee8\";\n  }\n  .bxs-user-plus:before {\n    content: \"\\eee9\";\n  }\n  .bxs-user-rectangle:before {\n    content: \"\\eeea\";\n  }\n  .bxs-user-voice:before {\n    content: \"\\eeeb\";\n  }\n  .bxs-user-x:before {\n    content: \"\\eeec\";\n  }\n  .bxs-vector:before {\n    content: \"\\eeed\";\n  }\n  .bxs-vial:before {\n    content: \"\\eeee\";\n  }\n  .bxs-video:before {\n    content: \"\\eeef\";\n  }\n  .bxs-video-off:before {\n    content: \"\\eef0\";\n  }\n  .bxs-video-plus:before {\n    content: \"\\eef1\";\n  }\n  .bxs-video-recording:before {\n    content: \"\\eef2\";\n  }\n  .bxs-videos:before {\n    content: \"\\eef3\";\n  }\n  .bxs-virus:before {\n    content: \"\\eef4\";\n  }\n  .bxs-virus-block:before {\n    content: \"\\eef5\";\n  }\n  .bxs-volume:before {\n    content: \"\\eef6\";\n  }\n  .bxs-volume-full:before {\n    content: \"\\eef7\";\n  }\n  .bxs-volume-low:before {\n    content: \"\\eef8\";\n  }\n  .bxs-volume-mute:before {\n    content: \"\\eef9\";\n  }\n  .bxs-wallet:before {\n    content: \"\\eefa\";\n  }\n  .bxs-wallet-alt:before {\n    content: \"\\eefb\";\n  }\n  .bxs-washer:before {\n    content: \"\\eefc\";\n  }\n  .bxs-watch:before {\n    content: \"\\eefd\";\n  }\n  .bxs-watch-alt:before {\n    content: \"\\eefe\";\n  }\n  .bxs-webcam:before {\n    content: \"\\eeff\";\n  }\n  .bxs-widget:before {\n    content: \"\\ef00\";\n  }\n  .bxs-window-alt:before {\n    content: \"\\ef01\";\n  }\n  .bxs-wine:before {\n    content: \"\\ef02\";\n  }\n  .bxs-wink-smile:before {\n    content: \"\\ef03\";\n  }\n  .bxs-wink-tongue:before {\n    content: \"\\ef04\";\n  }\n  .bxs-wrench:before {\n    content: \"\\ef05\";\n  }\n  .bxs-x-circle:before {\n    content: \"\\ef06\";\n  }\n  .bxs-x-square:before {\n    content: \"\\ef07\";\n  }\n  .bxs-yin-yang:before {\n    content: \"\\ef08\";\n  }\n  .bxs-zap:before {\n    content: \"\\ef09\";\n  }\n  .bxs-zoom-in:before {\n    content: \"\\ef0a\";\n  }\n  .bxs-zoom-out:before {\n    content: \"\\ef0b\";\n  }\n  ",".la,\n.las,\n.lar,\n.lal,\n.lad,\n.lab {\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-font-smoothing: antialiased;\n  display: inline-block;\n  font-style: normal;\n  font-variant: normal;\n  text-rendering: auto;\n  line-height: 1; }\n\n.la-lg {\n  font-size: 1.33333em;\n  line-height: 0.75em;\n  vertical-align: -.0667em; }\n\n.la-xs {\n  font-size: .75em; }\n\n.la-sm {\n  font-size: .875em; }\n\n.la-1x {\n  font-size: 1em; }\n\n.la-2x {\n  font-size: 2em; }\n\n.la-3x {\n  font-size: 3em; }\n\n.la-4x {\n  font-size: 4em; }\n\n.la-5x {\n  font-size: 5em; }\n\n.la-6x {\n  font-size: 6em; }\n\n.la-7x {\n  font-size: 7em; }\n\n.la-8x {\n  font-size: 8em; }\n\n.la-9x {\n  font-size: 9em; }\n\n.la-10x {\n  font-size: 10em; }\n\n.la-fw {\n  text-align: center;\n  width: 1.25em; }\n\n.la-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0; }\n  .la-ul > li {\n    position: relative; }\n\n.la-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit; }\n\n.la-border {\n  border: solid 0.08em #eee;\n  border-radius: .1em;\n  padding: .2em .25em .15em; }\n\n.la-pull-left {\n  float: left; }\n\n.la-pull-right {\n  float: right; }\n\n.la.la-pull-left,\n.las.la-pull-left,\n.lar.la-pull-left,\n.lal.la-pull-left,\n.lab.la-pull-left {\n  margin-right: .3em; }\n\n.la.la-pull-right,\n.las.la-pull-right,\n.lar.la-pull-right,\n.lal.la-pull-right,\n.lab.la-pull-right {\n  margin-left: .3em; }\n\n.la-spin {\n  -webkit-animation: la-spin 2s infinite linear;\n          animation: la-spin 2s infinite linear; }\n\n.la-pulse {\n  -webkit-animation: la-spin 1s infinite steps(8);\n          animation: la-spin 1s infinite steps(8); }\n\n@-webkit-keyframes la-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n@keyframes la-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n.la-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg); }\n\n.la-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg); }\n\n.la-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg); }\n\n.la-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1); }\n\n.la-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1); }\n\n.la-flip-both, .la-flip-horizontal.la-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1); }\n\n:root .la-rotate-90,\n:root .la-rotate-180,\n:root .la-rotate-270,\n:root .la-flip-horizontal,\n:root .la-flip-vertical,\n:root .la-flip-both {\n  -webkit-filter: none;\n          filter: none; }\n\n.la-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: middle;\n  width: 2.5em; }\n\n.la-stack-1x,\n.la-stack-2x {\n  left: 0;\n  position: absolute;\n  text-align: center;\n  width: 100%; }\n\n.la-stack-1x {\n  line-height: inherit; }\n\n.la-stack-2x {\n  font-size: 2em; }\n\n.la-inverse {\n  color: #fff; }\n\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\nreaders do not read off random characters that represent icons */\n.la-500px:before {\n  content: \"\\f26e\"; }\n\n.la-accessible-icon:before {\n  content: \"\\f368\"; }\n\n.la-accusoft:before {\n  content: \"\\f369\"; }\n\n.la-acquisitions-incorporated:before {\n  content: \"\\f6af\"; }\n\n.la-ad:before {\n  content: \"\\f641\"; }\n\n.la-address-book:before {\n  content: \"\\f2b9\"; }\n\n.la-address-card:before {\n  content: \"\\f2bb\"; }\n\n.la-adjust:before {\n  content: \"\\f042\"; }\n\n.la-adn:before {\n  content: \"\\f170\"; }\n\n.la-adobe:before {\n  content: \"\\f778\"; }\n\n.la-adversal:before {\n  content: \"\\f36a\"; }\n\n.la-affiliatetheme:before {\n  content: \"\\f36b\"; }\n\n.la-air-freshener:before {\n  content: \"\\f5d0\"; }\n\n.la-airbnb:before {\n  content: \"\\f834\"; }\n\n.la-algolia:before {\n  content: \"\\f36c\"; }\n\n.la-align-center:before {\n  content: \"\\f037\"; }\n\n.la-align-justify:before {\n  content: \"\\f039\"; }\n\n.la-align-left:before {\n  content: \"\\f036\"; }\n\n.la-align-right:before {\n  content: \"\\f038\"; }\n\n.la-alipay:before {\n  content: \"\\f642\"; }\n\n.la-allergies:before {\n  content: \"\\f461\"; }\n\n.la-amazon:before {\n  content: \"\\f270\"; }\n\n.la-amazon-pay:before {\n  content: \"\\f42c\"; }\n\n.la-ambulance:before {\n  content: \"\\f0f9\"; }\n\n.la-american-sign-language-interpreting:before {\n  content: \"\\f2a3\"; }\n\n.la-amilia:before {\n  content: \"\\f36d\"; }\n\n.la-anchor:before {\n  content: \"\\f13d\"; }\n\n.la-android:before {\n  content: \"\\f17b\"; }\n\n.la-angellist:before {\n  content: \"\\f209\"; }\n\n.la-angle-double-down:before {\n  content: \"\\f103\"; }\n\n.la-angle-double-left:before {\n  content: \"\\f100\"; }\n\n.la-angle-double-right:before {\n  content: \"\\f101\"; }\n\n.la-angle-double-up:before {\n  content: \"\\f102\"; }\n\n.la-angle-down:before {\n  content: \"\\f107\"; }\n\n.la-angle-left:before {\n  content: \"\\f104\"; }\n\n.la-angle-right:before {\n  content: \"\\f105\"; }\n\n.la-angle-up:before {\n  content: \"\\f106\"; }\n\n.la-angry:before {\n  content: \"\\f556\"; }\n\n.la-angrycreative:before {\n  content: \"\\f36e\"; }\n\n.la-angular:before {\n  content: \"\\f420\"; }\n\n.la-ankh:before {\n  content: \"\\f644\"; }\n\n.la-app-store:before {\n  content: \"\\f36f\"; }\n\n.la-app-store-ios:before {\n  content: \"\\f370\"; }\n\n.la-apper:before {\n  content: \"\\f371\"; }\n\n.la-apple:before {\n  content: \"\\f179\"; }\n\n.la-apple-alt:before {\n  content: \"\\f5d1\"; }\n\n.la-apple-pay:before {\n  content: \"\\f415\"; }\n\n.la-archive:before {\n  content: \"\\f187\"; }\n\n.la-archway:before {\n  content: \"\\f557\"; }\n\n.la-arrow-alt-circle-down:before {\n  content: \"\\f358\"; }\n\n.la-arrow-alt-circle-left:before {\n  content: \"\\f359\"; }\n\n.la-arrow-alt-circle-right:before {\n  content: \"\\f35a\"; }\n\n.la-arrow-alt-circle-up:before {\n  content: \"\\f35b\"; }\n\n.la-arrow-circle-down:before {\n  content: \"\\f0ab\"; }\n\n.la-arrow-circle-left:before {\n  content: \"\\f0a8\"; }\n\n.la-arrow-circle-right:before {\n  content: \"\\f0a9\"; }\n\n.la-arrow-circle-up:before {\n  content: \"\\f0aa\"; }\n\n.la-arrow-down:before {\n  content: \"\\f063\"; }\n\n.la-arrow-left:before {\n  content: \"\\f060\"; }\n\n.la-arrow-right:before {\n  content: \"\\f061\"; }\n\n.la-arrow-up:before {\n  content: \"\\f062\"; }\n\n.la-arrows-alt:before {\n  content: \"\\f0b2\"; }\n\n.la-arrows-alt-h:before {\n  content: \"\\f337\"; }\n\n.la-arrows-alt-v:before {\n  content: \"\\f338\"; }\n\n.la-artstation:before {\n  content: \"\\f77a\"; }\n\n.la-assistive-listening-systems:before {\n  content: \"\\f2a2\"; }\n\n.la-asterisk:before {\n  content: \"\\f069\"; }\n\n.la-asymmetrik:before {\n  content: \"\\f372\"; }\n\n.la-at:before {\n  content: \"\\f1fa\"; }\n\n.la-atlas:before {\n  content: \"\\f558\"; }\n\n.la-atlassian:before {\n  content: \"\\f77b\"; }\n\n.la-atom:before {\n  content: \"\\f5d2\"; }\n\n.la-audible:before {\n  content: \"\\f373\"; }\n\n.la-audio-description:before {\n  content: \"\\f29e\"; }\n\n.la-autoprefixer:before {\n  content: \"\\f41c\"; }\n\n.la-avianex:before {\n  content: \"\\f374\"; }\n\n.la-aviato:before {\n  content: \"\\f421\"; }\n\n.la-award:before {\n  content: \"\\f559\"; }\n\n.la-aws:before {\n  content: \"\\f375\"; }\n\n.la-baby:before {\n  content: \"\\f77c\"; }\n\n.la-baby-carriage:before {\n  content: \"\\f77d\"; }\n\n.la-backspace:before {\n  content: \"\\f55a\"; }\n\n.la-backward:before {\n  content: \"\\f04a\"; }\n\n.la-bacon:before {\n  content: \"\\f7e5\"; }\n\n.la-balance-scale:before {\n  content: \"\\f24e\"; }\n\n.la-balance-scale-left:before {\n  content: \"\\f515\"; }\n\n.la-balance-scale-right:before {\n  content: \"\\f516\"; }\n\n.la-ban:before {\n  content: \"\\f05e\"; }\n\n.la-band-aid:before {\n  content: \"\\f462\"; }\n\n.la-bandcamp:before {\n  content: \"\\f2d5\"; }\n\n.la-barcode:before {\n  content: \"\\f02a\"; }\n\n.la-bars:before {\n  content: \"\\f0c9\"; }\n\n.la-baseball-ball:before {\n  content: \"\\f433\"; }\n\n.la-basketball-ball:before {\n  content: \"\\f434\"; }\n\n.la-bath:before {\n  content: \"\\f2cd\"; }\n\n.la-battery-empty:before {\n  content: \"\\f244\"; }\n\n.la-battery-full:before {\n  content: \"\\f240\"; }\n\n.la-battery-half:before {\n  content: \"\\f242\"; }\n\n.la-battery-quarter:before {\n  content: \"\\f243\"; }\n\n.la-battery-three-quarters:before {\n  content: \"\\f241\"; }\n\n.la-battle-net:before {\n  content: \"\\f835\"; }\n\n.la-bed:before {\n  content: \"\\f236\"; }\n\n.la-beer:before {\n  content: \"\\f0fc\"; }\n\n.la-behance:before {\n  content: \"\\f1b4\"; }\n\n.la-behance-square:before {\n  content: \"\\f1b5\"; }\n\n.la-bell:before {\n  content: \"\\f0f3\"; }\n\n.la-bell-slash:before {\n  content: \"\\f1f6\"; }\n\n.la-bezier-curve:before {\n  content: \"\\f55b\"; }\n\n.la-bible:before {\n  content: \"\\f647\"; }\n\n.la-bicycle:before {\n  content: \"\\f206\"; }\n\n.la-biking:before {\n  content: \"\\f84a\"; }\n\n.la-bimobject:before {\n  content: \"\\f378\"; }\n\n.la-binoculars:before {\n  content: \"\\f1e5\"; }\n\n.la-biohazard:before {\n  content: \"\\f780\"; }\n\n.la-birthday-cake:before {\n  content: \"\\f1fd\"; }\n\n.la-bitbucket:before {\n  content: \"\\f171\"; }\n\n.la-bitcoin:before {\n  content: \"\\f379\"; }\n\n.la-bity:before {\n  content: \"\\f37a\"; }\n\n.la-black-tie:before {\n  content: \"\\f27e\"; }\n\n.la-blackberry:before {\n  content: \"\\f37b\"; }\n\n.la-blender:before {\n  content: \"\\f517\"; }\n\n.la-blender-phone:before {\n  content: \"\\f6b6\"; }\n\n.la-blind:before {\n  content: \"\\f29d\"; }\n\n.la-blog:before {\n  content: \"\\f781\"; }\n\n.la-blogger:before {\n  content: \"\\f37c\"; }\n\n.la-blogger-b:before {\n  content: \"\\f37d\"; }\n\n.la-bluetooth:before {\n  content: \"\\f293\"; }\n\n.la-bluetooth-b:before {\n  content: \"\\f294\"; }\n\n.la-bold:before {\n  content: \"\\f032\"; }\n\n.la-bolt:before {\n  content: \"\\f0e7\"; }\n\n.la-bomb:before {\n  content: \"\\f1e2\"; }\n\n.la-bone:before {\n  content: \"\\f5d7\"; }\n\n.la-bong:before {\n  content: \"\\f55c\"; }\n\n.la-book:before {\n  content: \"\\f02d\"; }\n\n.la-book-dead:before {\n  content: \"\\f6b7\"; }\n\n.la-book-medical:before {\n  content: \"\\f7e6\"; }\n\n.la-book-open:before {\n  content: \"\\f518\"; }\n\n.la-book-reader:before {\n  content: \"\\f5da\"; }\n\n.la-bookmark:before {\n  content: \"\\f02e\"; }\n\n.la-bootstrap:before {\n  content: \"\\f836\"; }\n\n.la-border-all:before {\n  content: \"\\f84c\"; }\n\n.la-border-none:before {\n  content: \"\\f850\"; }\n\n.la-border-style:before {\n  content: \"\\f853\"; }\n\n.la-bowling-ball:before {\n  content: \"\\f436\"; }\n\n.la-box:before {\n  content: \"\\f466\"; }\n\n.la-box-open:before {\n  content: \"\\f49e\"; }\n\n.la-boxes:before {\n  content: \"\\f468\"; }\n\n.la-braille:before {\n  content: \"\\f2a1\"; }\n\n.la-brain:before {\n  content: \"\\f5dc\"; }\n\n.la-bread-slice:before {\n  content: \"\\f7ec\"; }\n\n.la-briefcase:before {\n  content: \"\\f0b1\"; }\n\n.la-briefcase-medical:before {\n  content: \"\\f469\"; }\n\n.la-broadcast-tower:before {\n  content: \"\\f519\"; }\n\n.la-broom:before {\n  content: \"\\f51a\"; }\n\n.la-brush:before {\n  content: \"\\f55d\"; }\n\n.la-btc:before {\n  content: \"\\f15a\"; }\n\n.la-buffer:before {\n  content: \"\\f837\"; }\n\n.la-bug:before {\n  content: \"\\f188\"; }\n\n.la-building:before {\n  content: \"\\f1ad\"; }\n\n.la-bullhorn:before {\n  content: \"\\f0a1\"; }\n\n.la-bullseye:before {\n  content: \"\\f140\"; }\n\n.la-burn:before {\n  content: \"\\f46a\"; }\n\n.la-buromobelexperte:before {\n  content: \"\\f37f\"; }\n\n.la-bus:before {\n  content: \"\\f207\"; }\n\n.la-bus-alt:before {\n  content: \"\\f55e\"; }\n\n.la-business-time:before {\n  content: \"\\f64a\"; }\n\n.la-buy-n-large:before {\n  content: \"\\f8a6\"; }\n\n.la-buysellads:before {\n  content: \"\\f20d\"; }\n\n.la-calculator:before {\n  content: \"\\f1ec\"; }\n\n.la-calendar:before {\n  content: \"\\f133\"; }\n\n.la-calendar-alt:before {\n  content: \"\\f073\"; }\n\n.la-calendar-check:before {\n  content: \"\\f274\"; }\n\n.la-calendar-day:before {\n  content: \"\\f783\"; }\n\n.la-calendar-minus:before {\n  content: \"\\f272\"; }\n\n.la-calendar-plus:before {\n  content: \"\\f271\"; }\n\n.la-calendar-times:before {\n  content: \"\\f273\"; }\n\n.la-calendar-week:before {\n  content: \"\\f784\"; }\n\n.la-camera:before {\n  content: \"\\f030\"; }\n\n.la-camera-retro:before {\n  content: \"\\f083\"; }\n\n.la-campground:before {\n  content: \"\\f6bb\"; }\n\n.la-canadian-maple-leaf:before {\n  content: \"\\f785\"; }\n\n.la-candy-cane:before {\n  content: \"\\f786\"; }\n\n.la-cannabis:before {\n  content: \"\\f55f\"; }\n\n.la-capsules:before {\n  content: \"\\f46b\"; }\n\n.la-car:before {\n  content: \"\\f1b9\"; }\n\n.la-car-alt:before {\n  content: \"\\f5de\"; }\n\n.la-car-battery:before {\n  content: \"\\f5df\"; }\n\n.la-car-crash:before {\n  content: \"\\f5e1\"; }\n\n.la-car-side:before {\n  content: \"\\f5e4\"; }\n\n.la-caret-down:before {\n  content: \"\\f0d7\"; }\n\n.la-caret-left:before {\n  content: \"\\f0d9\"; }\n\n.la-caret-right:before {\n  content: \"\\f0da\"; }\n\n.la-caret-square-down:before {\n  content: \"\\f150\"; }\n\n.la-caret-square-left:before {\n  content: \"\\f191\"; }\n\n.la-caret-square-right:before {\n  content: \"\\f152\"; }\n\n.la-caret-square-up:before {\n  content: \"\\f151\"; }\n\n.la-caret-up:before {\n  content: \"\\f0d8\"; }\n\n.la-carrot:before {\n  content: \"\\f787\"; }\n\n.la-cart-arrow-down:before {\n  content: \"\\f218\"; }\n\n.la-cart-plus:before {\n  content: \"\\f217\"; }\n\n.la-cash-register:before {\n  content: \"\\f788\"; }\n\n.la-cat:before {\n  content: \"\\f6be\"; }\n\n.la-cc-amazon-pay:before {\n  content: \"\\f42d\"; }\n\n.la-cc-amex:before {\n  content: \"\\f1f3\"; }\n\n.la-cc-apple-pay:before {\n  content: \"\\f416\"; }\n\n.la-cc-diners-club:before {\n  content: \"\\f24c\"; }\n\n.la-cc-discover:before {\n  content: \"\\f1f2\"; }\n\n.la-cc-jcb:before {\n  content: \"\\f24b\"; }\n\n.la-cc-mastercard:before {\n  content: \"\\f1f1\"; }\n\n.la-cc-paypal:before {\n  content: \"\\f1f4\"; }\n\n.la-cc-stripe:before {\n  content: \"\\f1f5\"; }\n\n.la-cc-visa:before {\n  content: \"\\f1f0\"; }\n\n.la-centercode:before {\n  content: \"\\f380\"; }\n\n.la-centos:before {\n  content: \"\\f789\"; }\n\n.la-certificate:before {\n  content: \"\\f0a3\"; }\n\n.la-chair:before {\n  content: \"\\f6c0\"; }\n\n.la-chalkboard:before {\n  content: \"\\f51b\"; }\n\n.la-chalkboard-teacher:before {\n  content: \"\\f51c\"; }\n\n.la-charging-station:before {\n  content: \"\\f5e7\"; }\n\n.la-chart-area:before {\n  content: \"\\f1fe\"; }\n\n.la-chart-bar:before {\n  content: \"\\f080\"; }\n\n.la-chart-line:before {\n  content: \"\\f201\"; }\n\n.la-chart-pie:before {\n  content: \"\\f200\"; }\n\n.la-check:before {\n  content: \"\\f00c\"; }\n\n.la-check-circle:before {\n  content: \"\\f058\"; }\n\n.la-check-double:before {\n  content: \"\\f560\"; }\n\n.la-check-square:before {\n  content: \"\\f14a\"; }\n\n.la-cheese:before {\n  content: \"\\f7ef\"; }\n\n.la-chess:before {\n  content: \"\\f439\"; }\n\n.la-chess-bishop:before {\n  content: \"\\f43a\"; }\n\n.la-chess-board:before {\n  content: \"\\f43c\"; }\n\n.la-chess-king:before {\n  content: \"\\f43f\"; }\n\n.la-chess-knight:before {\n  content: \"\\f441\"; }\n\n.la-chess-pawn:before {\n  content: \"\\f443\"; }\n\n.la-chess-queen:before {\n  content: \"\\f445\"; }\n\n.la-chess-rook:before {\n  content: \"\\f447\"; }\n\n.la-chevron-circle-down:before {\n  content: \"\\f13a\"; }\n\n.la-chevron-circle-left:before {\n  content: \"\\f137\"; }\n\n.la-chevron-circle-right:before {\n  content: \"\\f138\"; }\n\n.la-chevron-circle-up:before {\n  content: \"\\f139\"; }\n\n.la-chevron-down:before {\n  content: \"\\f078\"; }\n\n.la-chevron-left:before {\n  content: \"\\f053\"; }\n\n.la-chevron-right:before {\n  content: \"\\f054\"; }\n\n.la-chevron-up:before {\n  content: \"\\f077\"; }\n\n.la-child:before {\n  content: \"\\f1ae\"; }\n\n.la-chrome:before {\n  content: \"\\f268\"; }\n\n.la-chromecast:before {\n  content: \"\\f838\"; }\n\n.la-church:before {\n  content: \"\\f51d\"; }\n\n.la-circle:before {\n  content: \"\\f111\"; }\n\n.la-circle-notch:before {\n  content: \"\\f1ce\"; }\n\n.la-city:before {\n  content: \"\\f64f\"; }\n\n.la-clinic-medical:before {\n  content: \"\\f7f2\"; }\n\n.la-clipboard:before {\n  content: \"\\f328\"; }\n\n.la-clipboard-check:before {\n  content: \"\\f46c\"; }\n\n.la-clipboard-list:before {\n  content: \"\\f46d\"; }\n\n.la-clock:before {\n  content: \"\\f017\"; }\n\n.la-clone:before {\n  content: \"\\f24d\"; }\n\n.la-closed-captioning:before {\n  content: \"\\f20a\"; }\n\n.la-cloud:before {\n  content: \"\\f0c2\"; }\n\n.la-cloud-download-alt:before {\n  content: \"\\f381\"; }\n\n.la-cloud-meatball:before {\n  content: \"\\f73b\"; }\n\n.la-cloud-moon:before {\n  content: \"\\f6c3\"; }\n\n.la-cloud-moon-rain:before {\n  content: \"\\f73c\"; }\n\n.la-cloud-rain:before {\n  content: \"\\f73d\"; }\n\n.la-cloud-showers-heavy:before {\n  content: \"\\f740\"; }\n\n.la-cloud-sun:before {\n  content: \"\\f6c4\"; }\n\n.la-cloud-sun-rain:before {\n  content: \"\\f743\"; }\n\n.la-cloud-upload-alt:before {\n  content: \"\\f382\"; }\n\n.la-cloudscale:before {\n  content: \"\\f383\"; }\n\n.la-cloudsmith:before {\n  content: \"\\f384\"; }\n\n.la-cloudversify:before {\n  content: \"\\f385\"; }\n\n.la-cocktail:before {\n  content: \"\\f561\"; }\n\n.la-code:before {\n  content: \"\\f121\"; }\n\n.la-code-branch:before {\n  content: \"\\f126\"; }\n\n.la-codepen:before {\n  content: \"\\f1cb\"; }\n\n.la-codiepie:before {\n  content: \"\\f284\"; }\n\n.la-coffee:before {\n  content: \"\\f0f4\"; }\n\n.la-cog:before {\n  content: \"\\f013\"; }\n\n.la-cogs:before {\n  content: \"\\f085\"; }\n\n.la-coins:before {\n  content: \"\\f51e\"; }\n\n.la-columns:before {\n  content: \"\\f0db\"; }\n\n.la-comment:before {\n  content: \"\\f075\"; }\n\n.la-comment-alt:before {\n  content: \"\\f27a\"; }\n\n.la-comment-dollar:before {\n  content: \"\\f651\"; }\n\n.la-comment-dots:before {\n  content: \"\\f4ad\"; }\n\n.la-comment-medical:before {\n  content: \"\\f7f5\"; }\n\n.la-comment-slash:before {\n  content: \"\\f4b3\"; }\n\n.la-comments:before {\n  content: \"\\f086\"; }\n\n.la-comments-dollar:before {\n  content: \"\\f653\"; }\n\n.la-compact-disc:before {\n  content: \"\\f51f\"; }\n\n.la-compass:before {\n  content: \"\\f14e\"; }\n\n.la-compress:before {\n  content: \"\\f066\"; }\n\n.la-compress-arrows-alt:before {\n  content: \"\\f78c\"; }\n\n.la-concierge-bell:before {\n  content: \"\\f562\"; }\n\n.la-confluence:before {\n  content: \"\\f78d\"; }\n\n.la-connectdevelop:before {\n  content: \"\\f20e\"; }\n\n.la-contao:before {\n  content: \"\\f26d\"; }\n\n.la-cookie:before {\n  content: \"\\f563\"; }\n\n.la-cookie-bite:before {\n  content: \"\\f564\"; }\n\n.la-copy:before {\n  content: \"\\f0c5\"; }\n\n.la-copyright:before {\n  content: \"\\f1f9\"; }\n\n.la-cotton-bureau:before {\n  content: \"\\f89e\"; }\n\n.la-couch:before {\n  content: \"\\f4b8\"; }\n\n.la-cpanel:before {\n  content: \"\\f388\"; }\n\n.la-creative-commons:before {\n  content: \"\\f25e\"; }\n\n.la-creative-commons-by:before {\n  content: \"\\f4e7\"; }\n\n.la-creative-commons-nc:before {\n  content: \"\\f4e8\"; }\n\n.la-creative-commons-nc-eu:before {\n  content: \"\\f4e9\"; }\n\n.la-creative-commons-nc-jp:before {\n  content: \"\\f4ea\"; }\n\n.la-creative-commons-nd:before {\n  content: \"\\f4eb\"; }\n\n.la-creative-commons-pd:before {\n  content: \"\\f4ec\"; }\n\n.la-creative-commons-pd-alt:before {\n  content: \"\\f4ed\"; }\n\n.la-creative-commons-remix:before {\n  content: \"\\f4ee\"; }\n\n.la-creative-commons-sa:before {\n  content: \"\\f4ef\"; }\n\n.la-creative-commons-sampling:before {\n  content: \"\\f4f0\"; }\n\n.la-creative-commons-sampling-plus:before {\n  content: \"\\f4f1\"; }\n\n.la-creative-commons-share:before {\n  content: \"\\f4f2\"; }\n\n.la-creative-commons-zero:before {\n  content: \"\\f4f3\"; }\n\n.la-credit-card:before {\n  content: \"\\f09d\"; }\n\n.la-critical-role:before {\n  content: \"\\f6c9\"; }\n\n.la-crop:before {\n  content: \"\\f125\"; }\n\n.la-crop-alt:before {\n  content: \"\\f565\"; }\n\n.la-cross:before {\n  content: \"\\f654\"; }\n\n.la-crosshairs:before {\n  content: \"\\f05b\"; }\n\n.la-crow:before {\n  content: \"\\f520\"; }\n\n.la-crown:before {\n  content: \"\\f521\"; }\n\n.la-crutch:before {\n  content: \"\\f7f7\"; }\n\n.la-css3:before {\n  content: \"\\f13c\"; }\n\n.la-css3-alt:before {\n  content: \"\\f38b\"; }\n\n.la-cube:before {\n  content: \"\\f1b2\"; }\n\n.la-cubes:before {\n  content: \"\\f1b3\"; }\n\n.la-cut:before {\n  content: \"\\f0c4\"; }\n\n.la-cuttlefish:before {\n  content: \"\\f38c\"; }\n\n.la-d-and-d:before {\n  content: \"\\f38d\"; }\n\n.la-d-and-d-beyond:before {\n  content: \"\\f6ca\"; }\n\n.la-dashcube:before {\n  content: \"\\f210\"; }\n\n.la-database:before {\n  content: \"\\f1c0\"; }\n\n.la-deaf:before {\n  content: \"\\f2a4\"; }\n\n.la-delicious:before {\n  content: \"\\f1a5\"; }\n\n.la-democrat:before {\n  content: \"\\f747\"; }\n\n.la-deploydog:before {\n  content: \"\\f38e\"; }\n\n.la-deskpro:before {\n  content: \"\\f38f\"; }\n\n.la-desktop:before {\n  content: \"\\f108\"; }\n\n.la-dev:before {\n  content: \"\\f6cc\"; }\n\n.la-deviantart:before {\n  content: \"\\f1bd\"; }\n\n.la-dharmachakra:before {\n  content: \"\\f655\"; }\n\n.la-dhl:before {\n  content: \"\\f790\"; }\n\n.la-diagnoses:before {\n  content: \"\\f470\"; }\n\n.la-diaspora:before {\n  content: \"\\f791\"; }\n\n.la-dice:before {\n  content: \"\\f522\"; }\n\n.la-dice-d20:before {\n  content: \"\\f6cf\"; }\n\n.la-dice-d6:before {\n  content: \"\\f6d1\"; }\n\n.la-dice-five:before {\n  content: \"\\f523\"; }\n\n.la-dice-four:before {\n  content: \"\\f524\"; }\n\n.la-dice-one:before {\n  content: \"\\f525\"; }\n\n.la-dice-six:before {\n  content: \"\\f526\"; }\n\n.la-dice-three:before {\n  content: \"\\f527\"; }\n\n.la-dice-two:before {\n  content: \"\\f528\"; }\n\n.la-digg:before {\n  content: \"\\f1a6\"; }\n\n.la-digital-ocean:before {\n  content: \"\\f391\"; }\n\n.la-digital-tachograph:before {\n  content: \"\\f566\"; }\n\n.la-directions:before {\n  content: \"\\f5eb\"; }\n\n.la-discord:before {\n  content: \"\\f392\"; }\n\n.la-discourse:before {\n  content: \"\\f393\"; }\n\n.la-divide:before {\n  content: \"\\f529\"; }\n\n.la-dizzy:before {\n  content: \"\\f567\"; }\n\n.la-dna:before {\n  content: \"\\f471\"; }\n\n.la-dochub:before {\n  content: \"\\f394\"; }\n\n.la-docker:before {\n  content: \"\\f395\"; }\n\n.la-dog:before {\n  content: \"\\f6d3\"; }\n\n.la-dollar-sign:before {\n  content: \"\\f155\"; }\n\n.la-dolly:before {\n  content: \"\\f472\"; }\n\n.la-dolly-flatbed:before {\n  content: \"\\f474\"; }\n\n.la-donate:before {\n  content: \"\\f4b9\"; }\n\n.la-door-closed:before {\n  content: \"\\f52a\"; }\n\n.la-door-open:before {\n  content: \"\\f52b\"; }\n\n.la-dot-circle:before {\n  content: \"\\f192\"; }\n\n.la-dove:before {\n  content: \"\\f4ba\"; }\n\n.la-download:before {\n  content: \"\\f019\"; }\n\n.la-draft2digital:before {\n  content: \"\\f396\"; }\n\n.la-drafting-compass:before {\n  content: \"\\f568\"; }\n\n.la-dragon:before {\n  content: \"\\f6d5\"; }\n\n.la-draw-polygon:before {\n  content: \"\\f5ee\"; }\n\n.la-dribbble:before {\n  content: \"\\f17d\"; }\n\n.la-dribbble-square:before {\n  content: \"\\f397\"; }\n\n.la-dropbox:before {\n  content: \"\\f16b\"; }\n\n.la-drum:before {\n  content: \"\\f569\"; }\n\n.la-drum-steelpan:before {\n  content: \"\\f56a\"; }\n\n.la-drumstick-bite:before {\n  content: \"\\f6d7\"; }\n\n.la-drupal:before {\n  content: \"\\f1a9\"; }\n\n.la-dumbbell:before {\n  content: \"\\f44b\"; }\n\n.la-dumpster:before {\n  content: \"\\f793\"; }\n\n.la-dumpster-fire:before {\n  content: \"\\f794\"; }\n\n.la-dungeon:before {\n  content: \"\\f6d9\"; }\n\n.la-dyalog:before {\n  content: \"\\f399\"; }\n\n.la-earlybirds:before {\n  content: \"\\f39a\"; }\n\n.la-ebay:before {\n  content: \"\\f4f4\"; }\n\n.la-edge:before {\n  content: \"\\f282\"; }\n\n.la-edit:before {\n  content: \"\\f044\"; }\n\n.la-egg:before {\n  content: \"\\f7fb\"; }\n\n.la-eject:before {\n  content: \"\\f052\"; }\n\n.la-elementor:before {\n  content: \"\\f430\"; }\n\n.la-ellipsis-h:before {\n  content: \"\\f141\"; }\n\n.la-ellipsis-v:before {\n  content: \"\\f142\"; }\n\n.la-ello:before {\n  content: \"\\f5f1\"; }\n\n.la-ember:before {\n  content: \"\\f423\"; }\n\n.la-empire:before {\n  content: \"\\f1d1\"; }\n\n.la-envelope:before {\n  content: \"\\f0e0\"; }\n\n.la-envelope-open:before {\n  content: \"\\f2b6\"; }\n\n.la-envelope-open-text:before {\n  content: \"\\f658\"; }\n\n.la-envelope-square:before {\n  content: \"\\f199\"; }\n\n.la-envira:before {\n  content: \"\\f299\"; }\n\n.la-equals:before {\n  content: \"\\f52c\"; }\n\n.la-eraser:before {\n  content: \"\\f12d\"; }\n\n.la-erlang:before {\n  content: \"\\f39d\"; }\n\n.la-ethereum:before {\n  content: \"\\f42e\"; }\n\n.la-ethernet:before {\n  content: \"\\f796\"; }\n\n.la-etsy:before {\n  content: \"\\f2d7\"; }\n\n.la-euro-sign:before {\n  content: \"\\f153\"; }\n\n.la-evernote:before {\n  content: \"\\f839\"; }\n\n.la-exchange-alt:before {\n  content: \"\\f362\"; }\n\n.la-exclamation:before {\n  content: \"\\f12a\"; }\n\n.la-exclamation-circle:before {\n  content: \"\\f06a\"; }\n\n.la-exclamation-triangle:before {\n  content: \"\\f071\"; }\n\n.la-expand:before {\n  content: \"\\f065\"; }\n\n.la-expand-arrows-alt:before {\n  content: \"\\f31e\"; }\n\n.la-expeditedssl:before {\n  content: \"\\f23e\"; }\n\n.la-external-link-alt:before {\n  content: \"\\f35d\"; }\n\n.la-external-link-square-alt:before {\n  content: \"\\f360\"; }\n\n.la-eye:before {\n  content: \"\\f06e\"; }\n\n.la-eye-dropper:before {\n  content: \"\\f1fb\"; }\n\n.la-eye-slash:before {\n  content: \"\\f070\"; }\n\n.la-facebook:before {\n  content: \"\\f09a\"; }\n\n.la-facebook-f:before {\n  content: \"\\f39e\"; }\n\n.la-facebook-messenger:before {\n  content: \"\\f39f\"; }\n\n.la-facebook-square:before {\n  content: \"\\f082\"; }\n\n.la-fan:before {\n  content: \"\\f863\"; }\n\n.la-fantasy-flight-games:before {\n  content: \"\\f6dc\"; }\n\n.la-fast-backward:before {\n  content: \"\\f049\"; }\n\n.la-fast-forward:before {\n  content: \"\\f050\"; }\n\n.la-fax:before {\n  content: \"\\f1ac\"; }\n\n.la-feather:before {\n  content: \"\\f52d\"; }\n\n.la-feather-alt:before {\n  content: \"\\f56b\"; }\n\n.la-fedex:before {\n  content: \"\\f797\"; }\n\n.la-fedora:before {\n  content: \"\\f798\"; }\n\n.la-female:before {\n  content: \"\\f182\"; }\n\n.la-fighter-jet:before {\n  content: \"\\f0fb\"; }\n\n.la-figma:before {\n  content: \"\\f799\"; }\n\n.la-file:before {\n  content: \"\\f15b\"; }\n\n.la-file-alt:before {\n  content: \"\\f15c\"; }\n\n.la-file-archive:before {\n  content: \"\\f1c6\"; }\n\n.la-file-audio:before {\n  content: \"\\f1c7\"; }\n\n.la-file-code:before {\n  content: \"\\f1c9\"; }\n\n.la-file-contract:before {\n  content: \"\\f56c\"; }\n\n.la-file-csv:before {\n  content: \"\\f6dd\"; }\n\n.la-file-download:before {\n  content: \"\\f56d\"; }\n\n.la-file-excel:before {\n  content: \"\\f1c3\"; }\n\n.la-file-export:before {\n  content: \"\\f56e\"; }\n\n.la-file-image:before {\n  content: \"\\f1c5\"; }\n\n.la-file-import:before {\n  content: \"\\f56f\"; }\n\n.la-file-invoice:before {\n  content: \"\\f570\"; }\n\n.la-file-invoice-dollar:before {\n  content: \"\\f571\"; }\n\n.la-file-medical:before {\n  content: \"\\f477\"; }\n\n.la-file-medical-alt:before {\n  content: \"\\f478\"; }\n\n.la-file-pdf:before {\n  content: \"\\f1c1\"; }\n\n.la-file-powerpoint:before {\n  content: \"\\f1c4\"; }\n\n.la-file-prescription:before {\n  content: \"\\f572\"; }\n\n.la-file-signature:before {\n  content: \"\\f573\"; }\n\n.la-file-upload:before {\n  content: \"\\f574\"; }\n\n.la-file-video:before {\n  content: \"\\f1c8\"; }\n\n.la-file-word:before {\n  content: \"\\f1c2\"; }\n\n.la-fill:before {\n  content: \"\\f575\"; }\n\n.la-fill-drip:before {\n  content: \"\\f576\"; }\n\n.la-film:before {\n  content: \"\\f008\"; }\n\n.la-filter:before {\n  content: \"\\f0b0\"; }\n\n.la-fingerprint:before {\n  content: \"\\f577\"; }\n\n.la-fire:before {\n  content: \"\\f06d\"; }\n\n.la-fire-alt:before {\n  content: \"\\f7e4\"; }\n\n.la-fire-extinguisher:before {\n  content: \"\\f134\"; }\n\n.la-firefox:before {\n  content: \"\\f269\"; }\n\n.la-first-aid:before {\n  content: \"\\f479\"; }\n\n.la-first-order:before {\n  content: \"\\f2b0\"; }\n\n.la-first-order-alt:before {\n  content: \"\\f50a\"; }\n\n.la-firstdraft:before {\n  content: \"\\f3a1\"; }\n\n.la-fish:before {\n  content: \"\\f578\"; }\n\n.la-fist-raised:before {\n  content: \"\\f6de\"; }\n\n.la-flag:before {\n  content: \"\\f024\"; }\n\n.la-flag-checkered:before {\n  content: \"\\f11e\"; }\n\n.la-flag-usa:before {\n  content: \"\\f74d\"; }\n\n.la-flask:before {\n  content: \"\\f0c3\"; }\n\n.la-flickr:before {\n  content: \"\\f16e\"; }\n\n.la-flipboard:before {\n  content: \"\\f44d\"; }\n\n.la-flushed:before {\n  content: \"\\f579\"; }\n\n.la-fly:before {\n  content: \"\\f417\"; }\n\n.la-folder:before {\n  content: \"\\f07b\"; }\n\n.la-folder-minus:before {\n  content: \"\\f65d\"; }\n\n.la-folder-open:before {\n  content: \"\\f07c\"; }\n\n.la-folder-plus:before {\n  content: \"\\f65e\"; }\n\n.la-font:before {\n  content: \"\\f031\"; }\n\n.la-font-awesome:before {\n  content: \"\\f2b4\"; }\n\n.la-font-awesome-alt:before {\n  content: \"\\f35c\"; }\n\n.la-font-awesome-flag:before {\n  content: \"\\f425\"; }\n\n.la-font-awesome-logo-full:before {\n  content: \"\\f4e6\"; }\n\n.la-fonticons:before {\n  content: \"\\f280\"; }\n\n.la-fonticons-fi:before {\n  content: \"\\f3a2\"; }\n\n.la-football-ball:before {\n  content: \"\\f44e\"; }\n\n.la-fort-awesome:before {\n  content: \"\\f286\"; }\n\n.la-fort-awesome-alt:before {\n  content: \"\\f3a3\"; }\n\n.la-forumbee:before {\n  content: \"\\f211\"; }\n\n.la-forward:before {\n  content: \"\\f04e\"; }\n\n.la-foursquare:before {\n  content: \"\\f180\"; }\n\n.la-free-code-camp:before {\n  content: \"\\f2c5\"; }\n\n.la-freebsd:before {\n  content: \"\\f3a4\"; }\n\n.la-frog:before {\n  content: \"\\f52e\"; }\n\n.la-frown:before {\n  content: \"\\f119\"; }\n\n.la-frown-open:before {\n  content: \"\\f57a\"; }\n\n.la-fulcrum:before {\n  content: \"\\f50b\"; }\n\n.la-funnel-dollar:before {\n  content: \"\\f662\"; }\n\n.la-futbol:before {\n  content: \"\\f1e3\"; }\n\n.la-galactic-republic:before {\n  content: \"\\f50c\"; }\n\n.la-galactic-senate:before {\n  content: \"\\f50d\"; }\n\n.la-gamepad:before {\n  content: \"\\f11b\"; }\n\n.la-gas-pump:before {\n  content: \"\\f52f\"; }\n\n.la-gavel:before {\n  content: \"\\f0e3\"; }\n\n.la-gem:before {\n  content: \"\\f3a5\"; }\n\n.la-genderless:before {\n  content: \"\\f22d\"; }\n\n.la-get-pocket:before {\n  content: \"\\f265\"; }\n\n.la-gg:before {\n  content: \"\\f260\"; }\n\n.la-gg-circle:before {\n  content: \"\\f261\"; }\n\n.la-ghost:before {\n  content: \"\\f6e2\"; }\n\n.la-gift:before {\n  content: \"\\f06b\"; }\n\n.la-gifts:before {\n  content: \"\\f79c\"; }\n\n.la-git:before {\n  content: \"\\f1d3\"; }\n\n.la-git-alt:before {\n  content: \"\\f841\"; }\n\n.la-git-square:before {\n  content: \"\\f1d2\"; }\n\n.la-github:before {\n  content: \"\\f09b\"; }\n\n.la-github-alt:before {\n  content: \"\\f113\"; }\n\n.la-github-square:before {\n  content: \"\\f092\"; }\n\n.la-gitkraken:before {\n  content: \"\\f3a6\"; }\n\n.la-gitlab:before {\n  content: \"\\f296\"; }\n\n.la-gitter:before {\n  content: \"\\f426\"; }\n\n.la-glass-cheers:before {\n  content: \"\\f79f\"; }\n\n.la-glass-martini:before {\n  content: \"\\f000\"; }\n\n.la-glass-martini-alt:before {\n  content: \"\\f57b\"; }\n\n.la-glass-whiskey:before {\n  content: \"\\f7a0\"; }\n\n.la-glasses:before {\n  content: \"\\f530\"; }\n\n.la-glide:before {\n  content: \"\\f2a5\"; }\n\n.la-glide-g:before {\n  content: \"\\f2a6\"; }\n\n.la-globe:before {\n  content: \"\\f0ac\"; }\n\n.la-globe-africa:before {\n  content: \"\\f57c\"; }\n\n.la-globe-americas:before {\n  content: \"\\f57d\"; }\n\n.la-globe-asia:before {\n  content: \"\\f57e\"; }\n\n.la-globe-europe:before {\n  content: \"\\f7a2\"; }\n\n.la-gofore:before {\n  content: \"\\f3a7\"; }\n\n.la-golf-ball:before {\n  content: \"\\f450\"; }\n\n.la-goodreads:before {\n  content: \"\\f3a8\"; }\n\n.la-goodreads-g:before {\n  content: \"\\f3a9\"; }\n\n.la-google:before {\n  content: \"\\f1a0\"; }\n\n.la-google-drive:before {\n  content: \"\\f3aa\"; }\n\n.la-google-play:before {\n  content: \"\\f3ab\"; }\n\n.la-google-plus:before {\n  content: \"\\f2b3\"; }\n\n.la-google-plus-g:before {\n  content: \"\\f0d5\"; }\n\n.la-google-plus-square:before {\n  content: \"\\f0d4\"; }\n\n.la-google-wallet:before {\n  content: \"\\f1ee\"; }\n\n.la-gopuram:before {\n  content: \"\\f664\"; }\n\n.la-graduation-cap:before {\n  content: \"\\f19d\"; }\n\n.la-gratipay:before {\n  content: \"\\f184\"; }\n\n.la-grav:before {\n  content: \"\\f2d6\"; }\n\n.la-greater-than:before {\n  content: \"\\f531\"; }\n\n.la-greater-than-equal:before {\n  content: \"\\f532\"; }\n\n.la-grimace:before {\n  content: \"\\f57f\"; }\n\n.la-grin:before {\n  content: \"\\f580\"; }\n\n.la-grin-alt:before {\n  content: \"\\f581\"; }\n\n.la-grin-beam:before {\n  content: \"\\f582\"; }\n\n.la-grin-beam-sweat:before {\n  content: \"\\f583\"; }\n\n.la-grin-hearts:before {\n  content: \"\\f584\"; }\n\n.la-grin-squint:before {\n  content: \"\\f585\"; }\n\n.la-grin-squint-tears:before {\n  content: \"\\f586\"; }\n\n.la-grin-stars:before {\n  content: \"\\f587\"; }\n\n.la-grin-tears:before {\n  content: \"\\f588\"; }\n\n.la-grin-tongue:before {\n  content: \"\\f589\"; }\n\n.la-grin-tongue-squint:before {\n  content: \"\\f58a\"; }\n\n.la-grin-tongue-wink:before {\n  content: \"\\f58b\"; }\n\n.la-grin-wink:before {\n  content: \"\\f58c\"; }\n\n.la-grip-horizontal:before {\n  content: \"\\f58d\"; }\n\n.la-grip-lines:before {\n  content: \"\\f7a4\"; }\n\n.la-grip-lines-vertical:before {\n  content: \"\\f7a5\"; }\n\n.la-grip-vertical:before {\n  content: \"\\f58e\"; }\n\n.la-gripfire:before {\n  content: \"\\f3ac\"; }\n\n.la-grunt:before {\n  content: \"\\f3ad\"; }\n\n.la-guitar:before {\n  content: \"\\f7a6\"; }\n\n.la-gulp:before {\n  content: \"\\f3ae\"; }\n\n.la-h-square:before {\n  content: \"\\f0fd\"; }\n\n.la-hacker-news:before {\n  content: \"\\f1d4\"; }\n\n.la-hacker-news-square:before {\n  content: \"\\f3af\"; }\n\n.la-hackerrank:before {\n  content: \"\\f5f7\"; }\n\n.la-hamburger:before {\n  content: \"\\f805\"; }\n\n.la-hammer:before {\n  content: \"\\f6e3\"; }\n\n.la-hamsa:before {\n  content: \"\\f665\"; }\n\n.la-hand-holding:before {\n  content: \"\\f4bd\"; }\n\n.la-hand-holding-heart:before {\n  content: \"\\f4be\"; }\n\n.la-hand-holding-usd:before {\n  content: \"\\f4c0\"; }\n\n.la-hand-lizard:before {\n  content: \"\\f258\"; }\n\n.la-hand-middle-finger:before {\n  content: \"\\f806\"; }\n\n.la-hand-paper:before {\n  content: \"\\f256\"; }\n\n.la-hand-peace:before {\n  content: \"\\f25b\"; }\n\n.la-hand-point-down:before {\n  content: \"\\f0a7\"; }\n\n.la-hand-point-left:before {\n  content: \"\\f0a5\"; }\n\n.la-hand-point-right:before {\n  content: \"\\f0a4\"; }\n\n.la-hand-point-up:before {\n  content: \"\\f0a6\"; }\n\n.la-hand-pointer:before {\n  content: \"\\f25a\"; }\n\n.la-hand-rock:before {\n  content: \"\\f255\"; }\n\n.la-hand-scissors:before {\n  content: \"\\f257\"; }\n\n.la-hand-spock:before {\n  content: \"\\f259\"; }\n\n.la-hands:before {\n  content: \"\\f4c2\"; }\n\n.la-hands-helping:before {\n  content: \"\\f4c4\"; }\n\n.la-handshake:before {\n  content: \"\\f2b5\"; }\n\n.la-hanukiah:before {\n  content: \"\\f6e6\"; }\n\n.la-hard-hat:before {\n  content: \"\\f807\"; }\n\n.la-hashtag:before {\n  content: \"\\f292\"; }\n\n.la-hat-cowboy:before {\n  content: \"\\f8c0\"; }\n\n.la-hat-cowboy-side:before {\n  content: \"\\f8c1\"; }\n\n.la-hat-wizard:before {\n  content: \"\\f6e8\"; }\n\n.la-haykal:before {\n  content: \"\\f666\"; }\n\n.la-hdd:before {\n  content: \"\\f0a0\"; }\n\n.la-heading:before {\n  content: \"\\f1dc\"; }\n\n.la-headphones:before {\n  content: \"\\f025\"; }\n\n.la-headphones-alt:before {\n  content: \"\\f58f\"; }\n\n.la-headset:before {\n  content: \"\\f590\"; }\n\n.la-heart:before {\n  content: \"\\f004\"; }\n\n.la-heart-broken:before {\n  content: \"\\f7a9\"; }\n\n.la-heartbeat:before {\n  content: \"\\f21e\"; }\n\n.la-helicopter:before {\n  content: \"\\f533\"; }\n\n.la-highlighter:before {\n  content: \"\\f591\"; }\n\n.la-hiking:before {\n  content: \"\\f6ec\"; }\n\n.la-hippo:before {\n  content: \"\\f6ed\"; }\n\n.la-hips:before {\n  content: \"\\f452\"; }\n\n.la-hire-a-helper:before {\n  content: \"\\f3b0\"; }\n\n.la-history:before {\n  content: \"\\f1da\"; }\n\n.la-hockey-puck:before {\n  content: \"\\f453\"; }\n\n.la-holly-berry:before {\n  content: \"\\f7aa\"; }\n\n.la-home:before {\n  content: \"\\f015\"; }\n\n.la-hooli:before {\n  content: \"\\f427\"; }\n\n.la-hornbill:before {\n  content: \"\\f592\"; }\n\n.la-horse:before {\n  content: \"\\f6f0\"; }\n\n.la-horse-head:before {\n  content: \"\\f7ab\"; }\n\n.la-hospital:before {\n  content: \"\\f0f8\"; }\n\n.la-hospital-alt:before {\n  content: \"\\f47d\"; }\n\n.la-hospital-symbol:before {\n  content: \"\\f47e\"; }\n\n.la-hot-tub:before {\n  content: \"\\f593\"; }\n\n.la-hotdog:before {\n  content: \"\\f80f\"; }\n\n.la-hotel:before {\n  content: \"\\f594\"; }\n\n.la-hotjar:before {\n  content: \"\\f3b1\"; }\n\n.la-hourglass:before {\n  content: \"\\f254\"; }\n\n.la-hourglass-end:before {\n  content: \"\\f253\"; }\n\n.la-hourglass-half:before {\n  content: \"\\f252\"; }\n\n.la-hourglass-start:before {\n  content: \"\\f251\"; }\n\n.la-house-damage:before {\n  content: \"\\f6f1\"; }\n\n.la-houzz:before {\n  content: \"\\f27c\"; }\n\n.la-hryvnia:before {\n  content: \"\\f6f2\"; }\n\n.la-html5:before {\n  content: \"\\f13b\"; }\n\n.la-hubspot:before {\n  content: \"\\f3b2\"; }\n\n.la-i-cursor:before {\n  content: \"\\f246\"; }\n\n.la-ice-cream:before {\n  content: \"\\f810\"; }\n\n.la-icicles:before {\n  content: \"\\f7ad\"; }\n\n.la-icons:before {\n  content: \"\\f86d\"; }\n\n.la-id-badge:before {\n  content: \"\\f2c1\"; }\n\n.la-id-card:before {\n  content: \"\\f2c2\"; }\n\n.la-id-card-alt:before {\n  content: \"\\f47f\"; }\n\n.la-igloo:before {\n  content: \"\\f7ae\"; }\n\n.la-image:before {\n  content: \"\\f03e\"; }\n\n.la-images:before {\n  content: \"\\f302\"; }\n\n.la-imdb:before {\n  content: \"\\f2d8\"; }\n\n.la-inbox:before {\n  content: \"\\f01c\"; }\n\n.la-indent:before {\n  content: \"\\f03c\"; }\n\n.la-industry:before {\n  content: \"\\f275\"; }\n\n.la-infinity:before {\n  content: \"\\f534\"; }\n\n.la-info:before {\n  content: \"\\f129\"; }\n\n.la-info-circle:before {\n  content: \"\\f05a\"; }\n\n.la-instagram:before {\n  content: \"\\f16d\"; }\n\n.la-intercom:before {\n  content: \"\\f7af\"; }\n\n.la-internet-explorer:before {\n  content: \"\\f26b\"; }\n\n.la-invision:before {\n  content: \"\\f7b0\"; }\n\n.la-ioxhost:before {\n  content: \"\\f208\"; }\n\n.la-italic:before {\n  content: \"\\f033\"; }\n\n.la-itch-io:before {\n  content: \"\\f83a\"; }\n\n.la-itunes:before {\n  content: \"\\f3b4\"; }\n\n.la-itunes-note:before {\n  content: \"\\f3b5\"; }\n\n.la-java:before {\n  content: \"\\f4e4\"; }\n\n.la-jedi:before {\n  content: \"\\f669\"; }\n\n.la-jedi-order:before {\n  content: \"\\f50e\"; }\n\n.la-jenkins:before {\n  content: \"\\f3b6\"; }\n\n.la-jira:before {\n  content: \"\\f7b1\"; }\n\n.la-joget:before {\n  content: \"\\f3b7\"; }\n\n.la-joint:before {\n  content: \"\\f595\"; }\n\n.la-joomla:before {\n  content: \"\\f1aa\"; }\n\n.la-journal-whills:before {\n  content: \"\\f66a\"; }\n\n.la-js:before {\n  content: \"\\f3b8\"; }\n\n.la-js-square:before {\n  content: \"\\f3b9\"; }\n\n.la-jsfiddle:before {\n  content: \"\\f1cc\"; }\n\n.la-kaaba:before {\n  content: \"\\f66b\"; }\n\n.la-kaggle:before {\n  content: \"\\f5fa\"; }\n\n.la-key:before {\n  content: \"\\f084\"; }\n\n.la-keybase:before {\n  content: \"\\f4f5\"; }\n\n.la-keyboard:before {\n  content: \"\\f11c\"; }\n\n.la-keycdn:before {\n  content: \"\\f3ba\"; }\n\n.la-khanda:before {\n  content: \"\\f66d\"; }\n\n.la-kickstarter:before {\n  content: \"\\f3bb\"; }\n\n.la-kickstarter-k:before {\n  content: \"\\f3bc\"; }\n\n.la-kiss:before {\n  content: \"\\f596\"; }\n\n.la-kiss-beam:before {\n  content: \"\\f597\"; }\n\n.la-kiss-wink-heart:before {\n  content: \"\\f598\"; }\n\n.la-kiwi-bird:before {\n  content: \"\\f535\"; }\n\n.la-korvue:before {\n  content: \"\\f42f\"; }\n\n.la-landmark:before {\n  content: \"\\f66f\"; }\n\n.la-language:before {\n  content: \"\\f1ab\"; }\n\n.la-laptop:before {\n  content: \"\\f109\"; }\n\n.la-laptop-code:before {\n  content: \"\\f5fc\"; }\n\n.la-laptop-medical:before {\n  content: \"\\f812\"; }\n\n.la-laravel:before {\n  content: \"\\f3bd\"; }\n\n.la-lastfm:before {\n  content: \"\\f202\"; }\n\n.la-lastfm-square:before {\n  content: \"\\f203\"; }\n\n.la-laugh:before {\n  content: \"\\f599\"; }\n\n.la-laugh-beam:before {\n  content: \"\\f59a\"; }\n\n.la-laugh-squint:before {\n  content: \"\\f59b\"; }\n\n.la-laugh-wink:before {\n  content: \"\\f59c\"; }\n\n.la-layer-group:before {\n  content: \"\\f5fd\"; }\n\n.la-leaf:before {\n  content: \"\\f06c\"; }\n\n.la-leanpub:before {\n  content: \"\\f212\"; }\n\n.la-lemon:before {\n  content: \"\\f094\"; }\n\n.la-less:before {\n  content: \"\\f41d\"; }\n\n.la-less-than:before {\n  content: \"\\f536\"; }\n\n.la-less-than-equal:before {\n  content: \"\\f537\"; }\n\n.la-level-down-alt:before {\n  content: \"\\f3be\"; }\n\n.la-level-up-alt:before {\n  content: \"\\f3bf\"; }\n\n.la-life-ring:before {\n  content: \"\\f1cd\"; }\n\n.la-lightbulb:before {\n  content: \"\\f0eb\"; }\n\n.la-line:before {\n  content: \"\\f3c0\"; }\n\n.la-link:before {\n  content: \"\\f0c1\"; }\n\n.la-linkedin:before {\n  content: \"\\f08c\"; }\n\n.la-linkedin-in:before {\n  content: \"\\f0e1\"; }\n\n.la-linode:before {\n  content: \"\\f2b8\"; }\n\n.la-linux:before {\n  content: \"\\f17c\"; }\n\n.la-lira-sign:before {\n  content: \"\\f195\"; }\n\n.la-list:before {\n  content: \"\\f03a\"; }\n\n.la-list-alt:before {\n  content: \"\\f022\"; }\n\n.la-list-ol:before {\n  content: \"\\f0cb\"; }\n\n.la-list-ul:before {\n  content: \"\\f0ca\"; }\n\n.la-location-arrow:before {\n  content: \"\\f124\"; }\n\n.la-lock:before {\n  content: \"\\f023\"; }\n\n.la-lock-open:before {\n  content: \"\\f3c1\"; }\n\n.la-long-arrow-alt-down:before {\n  content: \"\\f309\"; }\n\n.la-long-arrow-alt-left:before {\n  content: \"\\f30a\"; }\n\n.la-long-arrow-alt-right:before {\n  content: \"\\f30b\"; }\n\n.la-long-arrow-alt-up:before {\n  content: \"\\f30c\"; }\n\n.la-low-vision:before {\n  content: \"\\f2a8\"; }\n\n.la-luggage-cart:before {\n  content: \"\\f59d\"; }\n\n.la-lyft:before {\n  content: \"\\f3c3\"; }\n\n.la-magento:before {\n  content: \"\\f3c4\"; }\n\n.la-magic:before {\n  content: \"\\f0d0\"; }\n\n.la-magnet:before {\n  content: \"\\f076\"; }\n\n.la-mail-bulk:before {\n  content: \"\\f674\"; }\n\n.la-mailchimp:before {\n  content: \"\\f59e\"; }\n\n.la-male:before {\n  content: \"\\f183\"; }\n\n.la-mandalorian:before {\n  content: \"\\f50f\"; }\n\n.la-map:before {\n  content: \"\\f279\"; }\n\n.la-map-marked:before {\n  content: \"\\f59f\"; }\n\n.la-map-marked-alt:before {\n  content: \"\\f5a0\"; }\n\n.la-map-marker:before {\n  content: \"\\f041\"; }\n\n.la-map-marker-alt:before {\n  content: \"\\f3c5\"; }\n\n.la-map-pin:before {\n  content: \"\\f276\"; }\n\n.la-map-signs:before {\n  content: \"\\f277\"; }\n\n.la-markdown:before {\n  content: \"\\f60f\"; }\n\n.la-marker:before {\n  content: \"\\f5a1\"; }\n\n.la-mars:before {\n  content: \"\\f222\"; }\n\n.la-mars-double:before {\n  content: \"\\f227\"; }\n\n.la-mars-stroke:before {\n  content: \"\\f229\"; }\n\n.la-mars-stroke-h:before {\n  content: \"\\f22b\"; }\n\n.la-mars-stroke-v:before {\n  content: \"\\f22a\"; }\n\n.la-mask:before {\n  content: \"\\f6fa\"; }\n\n.la-mastodon:before {\n  content: \"\\f4f6\"; }\n\n.la-maxcdn:before {\n  content: \"\\f136\"; }\n\n.la-mdb:before {\n  content: \"\\f8ca\"; }\n\n.la-medal:before {\n  content: \"\\f5a2\"; }\n\n.la-medapps:before {\n  content: \"\\f3c6\"; }\n\n.la-medium:before {\n  content: \"\\f23a\"; }\n\n.la-medium-m:before {\n  content: \"\\f3c7\"; }\n\n.la-medkit:before {\n  content: \"\\f0fa\"; }\n\n.la-medrt:before {\n  content: \"\\f3c8\"; }\n\n.la-meetup:before {\n  content: \"\\f2e0\"; }\n\n.la-megaport:before {\n  content: \"\\f5a3\"; }\n\n.la-meh:before {\n  content: \"\\f11a\"; }\n\n.la-meh-blank:before {\n  content: \"\\f5a4\"; }\n\n.la-meh-rolling-eyes:before {\n  content: \"\\f5a5\"; }\n\n.la-memory:before {\n  content: \"\\f538\"; }\n\n.la-mendeley:before {\n  content: \"\\f7b3\"; }\n\n.la-menorah:before {\n  content: \"\\f676\"; }\n\n.la-mercury:before {\n  content: \"\\f223\"; }\n\n.la-meteor:before {\n  content: \"\\f753\"; }\n\n.la-microchip:before {\n  content: \"\\f2db\"; }\n\n.la-microphone:before {\n  content: \"\\f130\"; }\n\n.la-microphone-alt:before {\n  content: \"\\f3c9\"; }\n\n.la-microphone-alt-slash:before {\n  content: \"\\f539\"; }\n\n.la-microphone-slash:before {\n  content: \"\\f131\"; }\n\n.la-microscope:before {\n  content: \"\\f610\"; }\n\n.la-microsoft:before {\n  content: \"\\f3ca\"; }\n\n.la-minus:before {\n  content: \"\\f068\"; }\n\n.la-minus-circle:before {\n  content: \"\\f056\"; }\n\n.la-minus-square:before {\n  content: \"\\f146\"; }\n\n.la-mitten:before {\n  content: \"\\f7b5\"; }\n\n.la-mix:before {\n  content: \"\\f3cb\"; }\n\n.la-mixcloud:before {\n  content: \"\\f289\"; }\n\n.la-mizuni:before {\n  content: \"\\f3cc\"; }\n\n.la-mobile:before {\n  content: \"\\f10b\"; }\n\n.la-mobile-alt:before {\n  content: \"\\f3cd\"; }\n\n.la-modx:before {\n  content: \"\\f285\"; }\n\n.la-monero:before {\n  content: \"\\f3d0\"; }\n\n.la-money-bill:before {\n  content: \"\\f0d6\"; }\n\n.la-money-bill-alt:before {\n  content: \"\\f3d1\"; }\n\n.la-money-bill-wave:before {\n  content: \"\\f53a\"; }\n\n.la-money-bill-wave-alt:before {\n  content: \"\\f53b\"; }\n\n.la-money-check:before {\n  content: \"\\f53c\"; }\n\n.la-money-check-alt:before {\n  content: \"\\f53d\"; }\n\n.la-monument:before {\n  content: \"\\f5a6\"; }\n\n.la-moon:before {\n  content: \"\\f186\"; }\n\n.la-mortar-pestle:before {\n  content: \"\\f5a7\"; }\n\n.la-mosque:before {\n  content: \"\\f678\"; }\n\n.la-motorcycle:before {\n  content: \"\\f21c\"; }\n\n.la-mountain:before {\n  content: \"\\f6fc\"; }\n\n.la-mouse:before {\n  content: \"\\f8cc\"; }\n\n.la-mouse-pointer:before {\n  content: \"\\f245\"; }\n\n.la-mug-hot:before {\n  content: \"\\f7b6\"; }\n\n.la-music:before {\n  content: \"\\f001\"; }\n\n.la-napster:before {\n  content: \"\\f3d2\"; }\n\n.la-neos:before {\n  content: \"\\f612\"; }\n\n.la-network-wired:before {\n  content: \"\\f6ff\"; }\n\n.la-neuter:before {\n  content: \"\\f22c\"; }\n\n.la-newspaper:before {\n  content: \"\\f1ea\"; }\n\n.la-nimblr:before {\n  content: \"\\f5a8\"; }\n\n.la-node:before {\n  content: \"\\f419\"; }\n\n.la-node-js:before {\n  content: \"\\f3d3\"; }\n\n.la-not-equal:before {\n  content: \"\\f53e\"; }\n\n.la-notes-medical:before {\n  content: \"\\f481\"; }\n\n.la-npm:before {\n  content: \"\\f3d4\"; }\n\n.la-ns8:before {\n  content: \"\\f3d5\"; }\n\n.la-nutritionix:before {\n  content: \"\\f3d6\"; }\n\n.la-object-group:before {\n  content: \"\\f247\"; }\n\n.la-object-ungroup:before {\n  content: \"\\f248\"; }\n\n.la-odnoklassniki:before {\n  content: \"\\f263\"; }\n\n.la-odnoklassniki-square:before {\n  content: \"\\f264\"; }\n\n.la-oil-can:before {\n  content: \"\\f613\"; }\n\n.la-old-republic:before {\n  content: \"\\f510\"; }\n\n.la-om:before {\n  content: \"\\f679\"; }\n\n.la-opencart:before {\n  content: \"\\f23d\"; }\n\n.la-openid:before {\n  content: \"\\f19b\"; }\n\n.la-opera:before {\n  content: \"\\f26a\"; }\n\n.la-optin-monster:before {\n  content: \"\\f23c\"; }\n\n.la-orcid:before {\n  content: \"\\f8d2\"; }\n\n.la-osi:before {\n  content: \"\\f41a\"; }\n\n.la-otter:before {\n  content: \"\\f700\"; }\n\n.la-outdent:before {\n  content: \"\\f03b\"; }\n\n.la-page4:before {\n  content: \"\\f3d7\"; }\n\n.la-pagelines:before {\n  content: \"\\f18c\"; }\n\n.la-pager:before {\n  content: \"\\f815\"; }\n\n.la-paint-brush:before {\n  content: \"\\f1fc\"; }\n\n.la-paint-roller:before {\n  content: \"\\f5aa\"; }\n\n.la-palette:before {\n  content: \"\\f53f\"; }\n\n.la-palfed:before {\n  content: \"\\f3d8\"; }\n\n.la-pallet:before {\n  content: \"\\f482\"; }\n\n.la-paper-plane:before {\n  content: \"\\f1d8\"; }\n\n.la-paperclip:before {\n  content: \"\\f0c6\"; }\n\n.la-parachute-box:before {\n  content: \"\\f4cd\"; }\n\n.la-paragraph:before {\n  content: \"\\f1dd\"; }\n\n.la-parking:before {\n  content: \"\\f540\"; }\n\n.la-passport:before {\n  content: \"\\f5ab\"; }\n\n.la-pastafarianism:before {\n  content: \"\\f67b\"; }\n\n.la-paste:before {\n  content: \"\\f0ea\"; }\n\n.la-patreon:before {\n  content: \"\\f3d9\"; }\n\n.la-pause:before {\n  content: \"\\f04c\"; }\n\n.la-pause-circle:before {\n  content: \"\\f28b\"; }\n\n.la-paw:before {\n  content: \"\\f1b0\"; }\n\n.la-paypal:before {\n  content: \"\\f1ed\"; }\n\n.la-peace:before {\n  content: \"\\f67c\"; }\n\n.la-pen:before {\n  content: \"\\f304\"; }\n\n.la-pen-alt:before {\n  content: \"\\f305\"; }\n\n.la-pen-fancy:before {\n  content: \"\\f5ac\"; }\n\n.la-pen-nib:before {\n  content: \"\\f5ad\"; }\n\n.la-pen-square:before {\n  content: \"\\f14b\"; }\n\n.la-pencil-alt:before {\n  content: \"\\f303\"; }\n\n.la-pencil-ruler:before {\n  content: \"\\f5ae\"; }\n\n.la-penny-arcade:before {\n  content: \"\\f704\"; }\n\n.la-people-carry:before {\n  content: \"\\f4ce\"; }\n\n.la-pepper-hot:before {\n  content: \"\\f816\"; }\n\n.la-percent:before {\n  content: \"\\f295\"; }\n\n.la-percentage:before {\n  content: \"\\f541\"; }\n\n.la-periscope:before {\n  content: \"\\f3da\"; }\n\n.la-person-booth:before {\n  content: \"\\f756\"; }\n\n.la-phabricator:before {\n  content: \"\\f3db\"; }\n\n.la-phoenix-framework:before {\n  content: \"\\f3dc\"; }\n\n.la-phoenix-squadron:before {\n  content: \"\\f511\"; }\n\n.la-phone:before {\n  content: \"\\f095\"; }\n\n.la-phone-alt:before {\n  content: \"\\f879\"; }\n\n.la-phone-slash:before {\n  content: \"\\f3dd\"; }\n\n.la-phone-square:before {\n  content: \"\\f098\"; }\n\n.la-phone-square-alt:before {\n  content: \"\\f87b\"; }\n\n.la-phone-volume:before {\n  content: \"\\f2a0\"; }\n\n.la-photo-video:before {\n  content: \"\\f87c\"; }\n\n.la-php:before {\n  content: \"\\f457\"; }\n\n.la-pied-piper:before {\n  content: \"\\f2ae\"; }\n\n.la-pied-piper-alt:before {\n  content: \"\\f1a8\"; }\n\n.la-pied-piper-hat:before {\n  content: \"\\f4e5\"; }\n\n.la-pied-piper-pp:before {\n  content: \"\\f1a7\"; }\n\n.la-piggy-bank:before {\n  content: \"\\f4d3\"; }\n\n.la-pills:before {\n  content: \"\\f484\"; }\n\n.la-pinterest:before {\n  content: \"\\f0d2\"; }\n\n.la-pinterest-p:before {\n  content: \"\\f231\"; }\n\n.la-pinterest-square:before {\n  content: \"\\f0d3\"; }\n\n.la-pizza-slice:before {\n  content: \"\\f818\"; }\n\n.la-place-of-worship:before {\n  content: \"\\f67f\"; }\n\n.la-plane:before {\n  content: \"\\f072\"; }\n\n.la-plane-arrival:before {\n  content: \"\\f5af\"; }\n\n.la-plane-departure:before {\n  content: \"\\f5b0\"; }\n\n.la-play:before {\n  content: \"\\f04b\"; }\n\n.la-play-circle:before {\n  content: \"\\f144\"; }\n\n.la-playstation:before {\n  content: \"\\f3df\"; }\n\n.la-plug:before {\n  content: \"\\f1e6\"; }\n\n.la-plus:before {\n  content: \"\\f067\"; }\n\n.la-plus-circle:before {\n  content: \"\\f055\"; }\n\n.la-plus-square:before {\n  content: \"\\f0fe\"; }\n\n.la-podcast:before {\n  content: \"\\f2ce\"; }\n\n.la-poll:before {\n  content: \"\\f681\"; }\n\n.la-poll-h:before {\n  content: \"\\f682\"; }\n\n.la-poo:before {\n  content: \"\\f2fe\"; }\n\n.la-poo-storm:before {\n  content: \"\\f75a\"; }\n\n.la-poop:before {\n  content: \"\\f619\"; }\n\n.la-portrait:before {\n  content: \"\\f3e0\"; }\n\n.la-pound-sign:before {\n  content: \"\\f154\"; }\n\n.la-power-off:before {\n  content: \"\\f011\"; }\n\n.la-pray:before {\n  content: \"\\f683\"; }\n\n.la-praying-hands:before {\n  content: \"\\f684\"; }\n\n.la-prescription:before {\n  content: \"\\f5b1\"; }\n\n.la-prescription-bottle:before {\n  content: \"\\f485\"; }\n\n.la-prescription-bottle-alt:before {\n  content: \"\\f486\"; }\n\n.la-print:before {\n  content: \"\\f02f\"; }\n\n.la-procedures:before {\n  content: \"\\f487\"; }\n\n.la-product-hunt:before {\n  content: \"\\f288\"; }\n\n.la-project-diagram:before {\n  content: \"\\f542\"; }\n\n.la-pushed:before {\n  content: \"\\f3e1\"; }\n\n.la-puzzle-piece:before {\n  content: \"\\f12e\"; }\n\n.la-python:before {\n  content: \"\\f3e2\"; }\n\n.la-qq:before {\n  content: \"\\f1d6\"; }\n\n.la-qrcode:before {\n  content: \"\\f029\"; }\n\n.la-question:before {\n  content: \"\\f128\"; }\n\n.la-question-circle:before {\n  content: \"\\f059\"; }\n\n.la-quidditch:before {\n  content: \"\\f458\"; }\n\n.la-quinscape:before {\n  content: \"\\f459\"; }\n\n.la-quora:before {\n  content: \"\\f2c4\"; }\n\n.la-quote-left:before {\n  content: \"\\f10d\"; }\n\n.la-quote-right:before {\n  content: \"\\f10e\"; }\n\n.la-quran:before {\n  content: \"\\f687\"; }\n\n.la-r-project:before {\n  content: \"\\f4f7\"; }\n\n.la-radiation:before {\n  content: \"\\f7b9\"; }\n\n.la-radiation-alt:before {\n  content: \"\\f7ba\"; }\n\n.la-rainbow:before {\n  content: \"\\f75b\"; }\n\n.la-random:before {\n  content: \"\\f074\"; }\n\n.la-raspberry-pi:before {\n  content: \"\\f7bb\"; }\n\n.la-ravelry:before {\n  content: \"\\f2d9\"; }\n\n.la-react:before {\n  content: \"\\f41b\"; }\n\n.la-reacteurope:before {\n  content: \"\\f75d\"; }\n\n.la-readme:before {\n  content: \"\\f4d5\"; }\n\n.la-rebel:before {\n  content: \"\\f1d0\"; }\n\n.la-receipt:before {\n  content: \"\\f543\"; }\n\n.la-record-vinyl:before {\n  content: \"\\f8d9\"; }\n\n.la-recycle:before {\n  content: \"\\f1b8\"; }\n\n.la-red-river:before {\n  content: \"\\f3e3\"; }\n\n.la-reddit:before {\n  content: \"\\f1a1\"; }\n\n.la-reddit-alien:before {\n  content: \"\\f281\"; }\n\n.la-reddit-square:before {\n  content: \"\\f1a2\"; }\n\n.la-redhat:before {\n  content: \"\\f7bc\"; }\n\n.la-redo:before {\n  content: \"\\f01e\"; }\n\n.la-redo-alt:before {\n  content: \"\\f2f9\"; }\n\n.la-registered:before {\n  content: \"\\f25d\"; }\n\n.la-remove-format:before {\n  content: \"\\f87d\"; }\n\n.la-renren:before {\n  content: \"\\f18b\"; }\n\n.la-reply:before {\n  content: \"\\f3e5\"; }\n\n.la-reply-all:before {\n  content: \"\\f122\"; }\n\n.la-replyd:before {\n  content: \"\\f3e6\"; }\n\n.la-republican:before {\n  content: \"\\f75e\"; }\n\n.la-researchgate:before {\n  content: \"\\f4f8\"; }\n\n.la-resolving:before {\n  content: \"\\f3e7\"; }\n\n.la-restroom:before {\n  content: \"\\f7bd\"; }\n\n.la-retweet:before {\n  content: \"\\f079\"; }\n\n.la-rev:before {\n  content: \"\\f5b2\"; }\n\n.la-ribbon:before {\n  content: \"\\f4d6\"; }\n\n.la-ring:before {\n  content: \"\\f70b\"; }\n\n.la-road:before {\n  content: \"\\f018\"; }\n\n.la-robot:before {\n  content: \"\\f544\"; }\n\n.la-rocket:before {\n  content: \"\\f135\"; }\n\n.la-rocketchat:before {\n  content: \"\\f3e8\"; }\n\n.la-rockrms:before {\n  content: \"\\f3e9\"; }\n\n.la-route:before {\n  content: \"\\f4d7\"; }\n\n.la-rss:before {\n  content: \"\\f09e\"; }\n\n.la-rss-square:before {\n  content: \"\\f143\"; }\n\n.la-ruble-sign:before {\n  content: \"\\f158\"; }\n\n.la-ruler:before {\n  content: \"\\f545\"; }\n\n.la-ruler-combined:before {\n  content: \"\\f546\"; }\n\n.la-ruler-horizontal:before {\n  content: \"\\f547\"; }\n\n.la-ruler-vertical:before {\n  content: \"\\f548\"; }\n\n.la-running:before {\n  content: \"\\f70c\"; }\n\n.la-rupee-sign:before {\n  content: \"\\f156\"; }\n\n.la-sad-cry:before {\n  content: \"\\f5b3\"; }\n\n.la-sad-tear:before {\n  content: \"\\f5b4\"; }\n\n.la-safari:before {\n  content: \"\\f267\"; }\n\n.la-salesforce:before {\n  content: \"\\f83b\"; }\n\n.la-sass:before {\n  content: \"\\f41e\"; }\n\n.la-satellite:before {\n  content: \"\\f7bf\"; }\n\n.la-satellite-dish:before {\n  content: \"\\f7c0\"; }\n\n.la-save:before {\n  content: \"\\f0c7\"; }\n\n.la-schlix:before {\n  content: \"\\f3ea\"; }\n\n.la-school:before {\n  content: \"\\f549\"; }\n\n.la-screwdriver:before {\n  content: \"\\f54a\"; }\n\n.la-scribd:before {\n  content: \"\\f28a\"; }\n\n.la-scroll:before {\n  content: \"\\f70e\"; }\n\n.la-sd-card:before {\n  content: \"\\f7c2\"; }\n\n.la-search:before {\n  content: \"\\f002\"; }\n\n.la-search-dollar:before {\n  content: \"\\f688\"; }\n\n.la-search-location:before {\n  content: \"\\f689\"; }\n\n.la-search-minus:before {\n  content: \"\\f010\"; }\n\n.la-search-plus:before {\n  content: \"\\f00e\"; }\n\n.la-searchengin:before {\n  content: \"\\f3eb\"; }\n\n.la-seedling:before {\n  content: \"\\f4d8\"; }\n\n.la-sellcast:before {\n  content: \"\\f2da\"; }\n\n.la-sellsy:before {\n  content: \"\\f213\"; }\n\n.la-server:before {\n  content: \"\\f233\"; }\n\n.la-servicestack:before {\n  content: \"\\f3ec\"; }\n\n.la-shapes:before {\n  content: \"\\f61f\"; }\n\n.la-share:before {\n  content: \"\\f064\"; }\n\n.la-share-alt:before {\n  content: \"\\f1e0\"; }\n\n.la-share-alt-square:before {\n  content: \"\\f1e1\"; }\n\n.la-share-square:before {\n  content: \"\\f14d\"; }\n\n.la-shekel-sign:before {\n  content: \"\\f20b\"; }\n\n.la-shield-alt:before {\n  content: \"\\f3ed\"; }\n\n.la-ship:before {\n  content: \"\\f21a\"; }\n\n.la-shipping-fast:before {\n  content: \"\\f48b\"; }\n\n.la-shirtsinbulk:before {\n  content: \"\\f214\"; }\n\n.la-shoe-prints:before {\n  content: \"\\f54b\"; }\n\n.la-shopping-bag:before {\n  content: \"\\f290\"; }\n\n.la-shopping-basket:before {\n  content: \"\\f291\"; }\n\n.la-shopping-cart:before {\n  content: \"\\f07a\"; }\n\n.la-shopware:before {\n  content: \"\\f5b5\"; }\n\n.la-shower:before {\n  content: \"\\f2cc\"; }\n\n.la-shuttle-van:before {\n  content: \"\\f5b6\"; }\n\n.la-sign:before {\n  content: \"\\f4d9\"; }\n\n.la-sign-in-alt:before {\n  content: \"\\f2f6\"; }\n\n.la-sign-language:before {\n  content: \"\\f2a7\"; }\n\n.la-sign-out-alt:before {\n  content: \"\\f2f5\"; }\n\n.la-signal:before {\n  content: \"\\f012\"; }\n\n.la-signature:before {\n  content: \"\\f5b7\"; }\n\n.la-sim-card:before {\n  content: \"\\f7c4\"; }\n\n.la-simplybuilt:before {\n  content: \"\\f215\"; }\n\n.la-sistrix:before {\n  content: \"\\f3ee\"; }\n\n.la-sitemap:before {\n  content: \"\\f0e8\"; }\n\n.la-sith:before {\n  content: \"\\f512\"; }\n\n.la-skating:before {\n  content: \"\\f7c5\"; }\n\n.la-sketch:before {\n  content: \"\\f7c6\"; }\n\n.la-skiing:before {\n  content: \"\\f7c9\"; }\n\n.la-skiing-nordic:before {\n  content: \"\\f7ca\"; }\n\n.la-skull:before {\n  content: \"\\f54c\"; }\n\n.la-skull-crossbones:before {\n  content: \"\\f714\"; }\n\n.la-skyatlas:before {\n  content: \"\\f216\"; }\n\n.la-skype:before {\n  content: \"\\f17e\"; }\n\n.la-slack:before {\n  content: \"\\f198\"; }\n\n.la-slack-hash:before {\n  content: \"\\f3ef\"; }\n\n.la-slash:before {\n  content: \"\\f715\"; }\n\n.la-sleigh:before {\n  content: \"\\f7cc\"; }\n\n.la-sliders-h:before {\n  content: \"\\f1de\"; }\n\n.la-slideshare:before {\n  content: \"\\f1e7\"; }\n\n.la-smile:before {\n  content: \"\\f118\"; }\n\n.la-smile-beam:before {\n  content: \"\\f5b8\"; }\n\n.la-smile-wink:before {\n  content: \"\\f4da\"; }\n\n.la-smog:before {\n  content: \"\\f75f\"; }\n\n.la-smoking:before {\n  content: \"\\f48d\"; }\n\n.la-smoking-ban:before {\n  content: \"\\f54d\"; }\n\n.la-sms:before {\n  content: \"\\f7cd\"; }\n\n.la-snapchat:before {\n  content: \"\\f2ab\"; }\n\n.la-snapchat-ghost:before {\n  content: \"\\f2ac\"; }\n\n.la-snapchat-square:before {\n  content: \"\\f2ad\"; }\n\n.la-snowboarding:before {\n  content: \"\\f7ce\"; }\n\n.la-snowflake:before {\n  content: \"\\f2dc\"; }\n\n.la-snowman:before {\n  content: \"\\f7d0\"; }\n\n.la-snowplow:before {\n  content: \"\\f7d2\"; }\n\n.la-socks:before {\n  content: \"\\f696\"; }\n\n.la-solar-panel:before {\n  content: \"\\f5ba\"; }\n\n.la-sort:before {\n  content: \"\\f0dc\"; }\n\n.la-sort-alpha-down:before {\n  content: \"\\f15d\"; }\n\n.la-sort-alpha-down-alt:before {\n  content: \"\\f881\"; }\n\n.la-sort-alpha-up:before {\n  content: \"\\f15e\"; }\n\n.la-sort-alpha-up-alt:before {\n  content: \"\\f882\"; }\n\n.la-sort-amount-down:before {\n  content: \"\\f160\"; }\n\n.la-sort-amount-down-alt:before {\n  content: \"\\f884\"; }\n\n.la-sort-amount-up:before {\n  content: \"\\f161\"; }\n\n.la-sort-amount-up-alt:before {\n  content: \"\\f885\"; }\n\n.la-sort-down:before {\n  content: \"\\f0dd\"; }\n\n.la-sort-numeric-down:before {\n  content: \"\\f162\"; }\n\n.la-sort-numeric-down-alt:before {\n  content: \"\\f886\"; }\n\n.la-sort-numeric-up:before {\n  content: \"\\f163\"; }\n\n.la-sort-numeric-up-alt:before {\n  content: \"\\f887\"; }\n\n.la-sort-up:before {\n  content: \"\\f0de\"; }\n\n.la-soundcloud:before {\n  content: \"\\f1be\"; }\n\n.la-sourcetree:before {\n  content: \"\\f7d3\"; }\n\n.la-spa:before {\n  content: \"\\f5bb\"; }\n\n.la-space-shuttle:before {\n  content: \"\\f197\"; }\n\n.la-speakap:before {\n  content: \"\\f3f3\"; }\n\n.la-speaker-deck:before {\n  content: \"\\f83c\"; }\n\n.la-spell-check:before {\n  content: \"\\f891\"; }\n\n.la-spider:before {\n  content: \"\\f717\"; }\n\n.la-spinner:before {\n  content: \"\\f110\"; }\n\n.la-splotch:before {\n  content: \"\\f5bc\"; }\n\n.la-spotify:before {\n  content: \"\\f1bc\"; }\n\n.la-spray-can:before {\n  content: \"\\f5bd\"; }\n\n.la-square:before {\n  content: \"\\f0c8\"; }\n\n.la-square-full:before {\n  content: \"\\f45c\"; }\n\n.la-square-root-alt:before {\n  content: \"\\f698\"; }\n\n.la-squarespace:before {\n  content: \"\\f5be\"; }\n\n.la-stack-exchange:before {\n  content: \"\\f18d\"; }\n\n.la-stack-overflow:before {\n  content: \"\\f16c\"; }\n\n.la-stackpath:before {\n  content: \"\\f842\"; }\n\n.la-stamp:before {\n  content: \"\\f5bf\"; }\n\n.la-star:before {\n  content: \"\\f005\"; }\n\n.la-star-and-crescent:before {\n  content: \"\\f699\"; }\n\n.la-star-half:before {\n  content: \"\\f089\"; }\n\n.la-star-half-alt:before {\n  content: \"\\f5c0\"; }\n\n.la-star-of-david:before {\n  content: \"\\f69a\"; }\n\n.la-star-of-life:before {\n  content: \"\\f621\"; }\n\n.la-staylinked:before {\n  content: \"\\f3f5\"; }\n\n.la-steam:before {\n  content: \"\\f1b6\"; }\n\n.la-steam-square:before {\n  content: \"\\f1b7\"; }\n\n.la-steam-symbol:before {\n  content: \"\\f3f6\"; }\n\n.la-step-backward:before {\n  content: \"\\f048\"; }\n\n.la-step-forward:before {\n  content: \"\\f051\"; }\n\n.la-stethoscope:before {\n  content: \"\\f0f1\"; }\n\n.la-sticker-mule:before {\n  content: \"\\f3f7\"; }\n\n.la-sticky-note:before {\n  content: \"\\f249\"; }\n\n.la-stop:before {\n  content: \"\\f04d\"; }\n\n.la-stop-circle:before {\n  content: \"\\f28d\"; }\n\n.la-stopwatch:before {\n  content: \"\\f2f2\"; }\n\n.la-store:before {\n  content: \"\\f54e\"; }\n\n.la-store-alt:before {\n  content: \"\\f54f\"; }\n\n.la-strava:before {\n  content: \"\\f428\"; }\n\n.la-stream:before {\n  content: \"\\f550\"; }\n\n.la-street-view:before {\n  content: \"\\f21d\"; }\n\n.la-strikethrough:before {\n  content: \"\\f0cc\"; }\n\n.la-stripe:before {\n  content: \"\\f429\"; }\n\n.la-stripe-s:before {\n  content: \"\\f42a\"; }\n\n.la-stroopwafel:before {\n  content: \"\\f551\"; }\n\n.la-studiovinari:before {\n  content: \"\\f3f8\"; }\n\n.la-stumbleupon:before {\n  content: \"\\f1a4\"; }\n\n.la-stumbleupon-circle:before {\n  content: \"\\f1a3\"; }\n\n.la-subscript:before {\n  content: \"\\f12c\"; }\n\n.la-subway:before {\n  content: \"\\f239\"; }\n\n.la-suitcase:before {\n  content: \"\\f0f2\"; }\n\n.la-suitcase-rolling:before {\n  content: \"\\f5c1\"; }\n\n.la-sun:before {\n  content: \"\\f185\"; }\n\n.la-superpowers:before {\n  content: \"\\f2dd\"; }\n\n.la-superscript:before {\n  content: \"\\f12b\"; }\n\n.la-supple:before {\n  content: \"\\f3f9\"; }\n\n.la-surprise:before {\n  content: \"\\f5c2\"; }\n\n.la-suse:before {\n  content: \"\\f7d6\"; }\n\n.la-swatchbook:before {\n  content: \"\\f5c3\"; }\n\n.la-swift:before {\n  content: \"\\f8e1\"; }\n\n.la-swimmer:before {\n  content: \"\\f5c4\"; }\n\n.la-swimming-pool:before {\n  content: \"\\f5c5\"; }\n\n.la-symfony:before {\n  content: \"\\f83d\"; }\n\n.la-synagogue:before {\n  content: \"\\f69b\"; }\n\n.la-sync:before {\n  content: \"\\f021\"; }\n\n.la-sync-alt:before {\n  content: \"\\f2f1\"; }\n\n.la-syringe:before {\n  content: \"\\f48e\"; }\n\n.la-table:before {\n  content: \"\\f0ce\"; }\n\n.la-table-tennis:before {\n  content: \"\\f45d\"; }\n\n.la-tablet:before {\n  content: \"\\f10a\"; }\n\n.la-tablet-alt:before {\n  content: \"\\f3fa\"; }\n\n.la-tablets:before {\n  content: \"\\f490\"; }\n\n.la-tachometer-alt:before {\n  content: \"\\f3fd\"; }\n\n.la-tag:before {\n  content: \"\\f02b\"; }\n\n.la-tags:before {\n  content: \"\\f02c\"; }\n\n.la-tape:before {\n  content: \"\\f4db\"; }\n\n.la-tasks:before {\n  content: \"\\f0ae\"; }\n\n.la-taxi:before {\n  content: \"\\f1ba\"; }\n\n.la-teamspeak:before {\n  content: \"\\f4f9\"; }\n\n.la-teeth:before {\n  content: \"\\f62e\"; }\n\n.la-teeth-open:before {\n  content: \"\\f62f\"; }\n\n.la-telegram:before {\n  content: \"\\f2c6\"; }\n\n.la-telegram-plane:before {\n  content: \"\\f3fe\"; }\n\n.la-temperature-high:before {\n  content: \"\\f769\"; }\n\n.la-temperature-low:before {\n  content: \"\\f76b\"; }\n\n.la-tencent-weibo:before {\n  content: \"\\f1d5\"; }\n\n.la-tenge:before {\n  content: \"\\f7d7\"; }\n\n.la-terminal:before {\n  content: \"\\f120\"; }\n\n.la-text-height:before {\n  content: \"\\f034\"; }\n\n.la-text-width:before {\n  content: \"\\f035\"; }\n\n.la-th:before {\n  content: \"\\f00a\"; }\n\n.la-th-large:before {\n  content: \"\\f009\"; }\n\n.la-th-list:before {\n  content: \"\\f00b\"; }\n\n.la-the-red-yeti:before {\n  content: \"\\f69d\"; }\n\n.la-theater-masks:before {\n  content: \"\\f630\"; }\n\n.la-themeco:before {\n  content: \"\\f5c6\"; }\n\n.la-themeisle:before {\n  content: \"\\f2b2\"; }\n\n.la-thermometer:before {\n  content: \"\\f491\"; }\n\n.la-thermometer-empty:before {\n  content: \"\\f2cb\"; }\n\n.la-thermometer-full:before {\n  content: \"\\f2c7\"; }\n\n.la-thermometer-half:before {\n  content: \"\\f2c9\"; }\n\n.la-thermometer-quarter:before {\n  content: \"\\f2ca\"; }\n\n.la-thermometer-three-quarters:before {\n  content: \"\\f2c8\"; }\n\n.la-think-peaks:before {\n  content: \"\\f731\"; }\n\n.la-thumbs-down:before {\n  content: \"\\f165\"; }\n\n.la-thumbs-up:before {\n  content: \"\\f164\"; }\n\n.la-thumbtack:before {\n  content: \"\\f08d\"; }\n\n.la-ticket-alt:before {\n  content: \"\\f3ff\"; }\n\n.la-times:before {\n  content: \"\\f00d\"; }\n\n.la-times-circle:before {\n  content: \"\\f057\"; }\n\n.la-tint:before {\n  content: \"\\f043\"; }\n\n.la-tint-slash:before {\n  content: \"\\f5c7\"; }\n\n.la-tired:before {\n  content: \"\\f5c8\"; }\n\n.la-toggle-off:before {\n  content: \"\\f204\"; }\n\n.la-toggle-on:before {\n  content: \"\\f205\"; }\n\n.la-toilet:before {\n  content: \"\\f7d8\"; }\n\n.la-toilet-paper:before {\n  content: \"\\f71e\"; }\n\n.la-toolbox:before {\n  content: \"\\f552\"; }\n\n.la-tools:before {\n  content: \"\\f7d9\"; }\n\n.la-tooth:before {\n  content: \"\\f5c9\"; }\n\n.la-torah:before {\n  content: \"\\f6a0\"; }\n\n.la-torii-gate:before {\n  content: \"\\f6a1\"; }\n\n.la-tractor:before {\n  content: \"\\f722\"; }\n\n.la-trade-federation:before {\n  content: \"\\f513\"; }\n\n.la-trademark:before {\n  content: \"\\f25c\"; }\n\n.la-traffic-light:before {\n  content: \"\\f637\"; }\n\n.la-train:before {\n  content: \"\\f238\"; }\n\n.la-tram:before {\n  content: \"\\f7da\"; }\n\n.la-transgender:before {\n  content: \"\\f224\"; }\n\n.la-transgender-alt:before {\n  content: \"\\f225\"; }\n\n.la-trash:before {\n  content: \"\\f1f8\"; }\n\n.la-trash-alt:before {\n  content: \"\\f2ed\"; }\n\n.la-trash-restore:before {\n  content: \"\\f829\"; }\n\n.la-trash-restore-alt:before {\n  content: \"\\f82a\"; }\n\n.la-tree:before {\n  content: \"\\f1bb\"; }\n\n.la-trello:before {\n  content: \"\\f181\"; }\n\n.la-tripadvisor:before {\n  content: \"\\f262\"; }\n\n.la-trophy:before {\n  content: \"\\f091\"; }\n\n.la-truck:before {\n  content: \"\\f0d1\"; }\n\n.la-truck-loading:before {\n  content: \"\\f4de\"; }\n\n.la-truck-monster:before {\n  content: \"\\f63b\"; }\n\n.la-truck-moving:before {\n  content: \"\\f4df\"; }\n\n.la-truck-pickup:before {\n  content: \"\\f63c\"; }\n\n.la-tshirt:before {\n  content: \"\\f553\"; }\n\n.la-tty:before {\n  content: \"\\f1e4\"; }\n\n.la-tumblr:before {\n  content: \"\\f173\"; }\n\n.la-tumblr-square:before {\n  content: \"\\f174\"; }\n\n.la-tv:before {\n  content: \"\\f26c\"; }\n\n.la-twitch:before {\n  content: \"\\f1e8\"; }\n\n.la-twitter:before {\n  content: \"\\f099\"; }\n\n.la-twitter-square:before {\n  content: \"\\f081\"; }\n\n.la-typo3:before {\n  content: \"\\f42b\"; }\n\n.la-uber:before {\n  content: \"\\f402\"; }\n\n.la-ubuntu:before {\n  content: \"\\f7df\"; }\n\n.la-uikit:before {\n  content: \"\\f403\"; }\n\n.la-umbraco:before {\n  content: \"\\f8e8\"; }\n\n.la-umbrella:before {\n  content: \"\\f0e9\"; }\n\n.la-umbrella-beach:before {\n  content: \"\\f5ca\"; }\n\n.la-underline:before {\n  content: \"\\f0cd\"; }\n\n.la-undo:before {\n  content: \"\\f0e2\"; }\n\n.la-undo-alt:before {\n  content: \"\\f2ea\"; }\n\n.la-uniregistry:before {\n  content: \"\\f404\"; }\n\n.la-universal-access:before {\n  content: \"\\f29a\"; }\n\n.la-university:before {\n  content: \"\\f19c\"; }\n\n.la-unlink:before {\n  content: \"\\f127\"; }\n\n.la-unlock:before {\n  content: \"\\f09c\"; }\n\n.la-unlock-alt:before {\n  content: \"\\f13e\"; }\n\n.la-untappd:before {\n  content: \"\\f405\"; }\n\n.la-upload:before {\n  content: \"\\f093\"; }\n\n.la-ups:before {\n  content: \"\\f7e0\"; }\n\n.la-usb:before {\n  content: \"\\f287\"; }\n\n.la-user:before {\n  content: \"\\f007\"; }\n\n.la-user-alt:before {\n  content: \"\\f406\"; }\n\n.la-user-alt-slash:before {\n  content: \"\\f4fa\"; }\n\n.la-user-astronaut:before {\n  content: \"\\f4fb\"; }\n\n.la-user-check:before {\n  content: \"\\f4fc\"; }\n\n.la-user-circle:before {\n  content: \"\\f2bd\"; }\n\n.la-user-clock:before {\n  content: \"\\f4fd\"; }\n\n.la-user-cog:before {\n  content: \"\\f4fe\"; }\n\n.la-user-edit:before {\n  content: \"\\f4ff\"; }\n\n.la-user-friends:before {\n  content: \"\\f500\"; }\n\n.la-user-graduate:before {\n  content: \"\\f501\"; }\n\n.la-user-injured:before {\n  content: \"\\f728\"; }\n\n.la-user-lock:before {\n  content: \"\\f502\"; }\n\n.la-user-md:before {\n  content: \"\\f0f0\"; }\n\n.la-user-minus:before {\n  content: \"\\f503\"; }\n\n.la-user-ninja:before {\n  content: \"\\f504\"; }\n\n.la-user-nurse:before {\n  content: \"\\f82f\"; }\n\n.la-user-plus:before {\n  content: \"\\f234\"; }\n\n.la-user-secret:before {\n  content: \"\\f21b\"; }\n\n.la-user-shield:before {\n  content: \"\\f505\"; }\n\n.la-user-slash:before {\n  content: \"\\f506\"; }\n\n.la-user-tag:before {\n  content: \"\\f507\"; }\n\n.la-user-tie:before {\n  content: \"\\f508\"; }\n\n.la-user-times:before {\n  content: \"\\f235\"; }\n\n.la-users:before {\n  content: \"\\f0c0\"; }\n\n.la-users-cog:before {\n  content: \"\\f509\"; }\n\n.la-usps:before {\n  content: \"\\f7e1\"; }\n\n.la-ussunnah:before {\n  content: \"\\f407\"; }\n\n.la-utensil-spoon:before {\n  content: \"\\f2e5\"; }\n\n.la-utensils:before {\n  content: \"\\f2e7\"; }\n\n.la-vaadin:before {\n  content: \"\\f408\"; }\n\n.la-vector-square:before {\n  content: \"\\f5cb\"; }\n\n.la-venus:before {\n  content: \"\\f221\"; }\n\n.la-venus-double:before {\n  content: \"\\f226\"; }\n\n.la-venus-mars:before {\n  content: \"\\f228\"; }\n\n.la-viacoin:before {\n  content: \"\\f237\"; }\n\n.la-viadeo:before {\n  content: \"\\f2a9\"; }\n\n.la-viadeo-square:before {\n  content: \"\\f2aa\"; }\n\n.la-vial:before {\n  content: \"\\f492\"; }\n\n.la-vials:before {\n  content: \"\\f493\"; }\n\n.la-viber:before {\n  content: \"\\f409\"; }\n\n.la-video:before {\n  content: \"\\f03d\"; }\n\n.la-video-slash:before {\n  content: \"\\f4e2\"; }\n\n.la-vihara:before {\n  content: \"\\f6a7\"; }\n\n.la-vimeo:before {\n  content: \"\\f40a\"; }\n\n.la-vimeo-square:before {\n  content: \"\\f194\"; }\n\n.la-vimeo-v:before {\n  content: \"\\f27d\"; }\n\n.la-vine:before {\n  content: \"\\f1ca\"; }\n\n.la-vk:before {\n  content: \"\\f189\"; }\n\n.la-vnv:before {\n  content: \"\\f40b\"; }\n\n.la-voicemail:before {\n  content: \"\\f897\"; }\n\n.la-volleyball-ball:before {\n  content: \"\\f45f\"; }\n\n.la-volume-down:before {\n  content: \"\\f027\"; }\n\n.la-volume-mute:before {\n  content: \"\\f6a9\"; }\n\n.la-volume-off:before {\n  content: \"\\f026\"; }\n\n.la-volume-up:before {\n  content: \"\\f028\"; }\n\n.la-vote-yea:before {\n  content: \"\\f772\"; }\n\n.la-vr-cardboard:before {\n  content: \"\\f729\"; }\n\n.la-vuejs:before {\n  content: \"\\f41f\"; }\n\n.la-walking:before {\n  content: \"\\f554\"; }\n\n.la-wallet:before {\n  content: \"\\f555\"; }\n\n.la-warehouse:before {\n  content: \"\\f494\"; }\n\n.la-water:before {\n  content: \"\\f773\"; }\n\n.la-wave-square:before {\n  content: \"\\f83e\"; }\n\n.la-waze:before {\n  content: \"\\f83f\"; }\n\n.la-weebly:before {\n  content: \"\\f5cc\"; }\n\n.la-weibo:before {\n  content: \"\\f18a\"; }\n\n.la-weight:before {\n  content: \"\\f496\"; }\n\n.la-weight-hanging:before {\n  content: \"\\f5cd\"; }\n\n.la-weixin:before {\n  content: \"\\f1d7\"; }\n\n.la-whatsapp:before {\n  content: \"\\f232\"; }\n\n.la-whatsapp-square:before {\n  content: \"\\f40c\"; }\n\n.la-wheelchair:before {\n  content: \"\\f193\"; }\n\n.la-whmcs:before {\n  content: \"\\f40d\"; }\n\n.la-wifi:before {\n  content: \"\\f1eb\"; }\n\n.la-wikipedia-w:before {\n  content: \"\\f266\"; }\n\n.la-wind:before {\n  content: \"\\f72e\"; }\n\n.la-window-close:before {\n  content: \"\\f410\"; }\n\n.la-window-maximize:before {\n  content: \"\\f2d0\"; }\n\n.la-window-minimize:before {\n  content: \"\\f2d1\"; }\n\n.la-window-restore:before {\n  content: \"\\f2d2\"; }\n\n.la-windows:before {\n  content: \"\\f17a\"; }\n\n.la-wine-bottle:before {\n  content: \"\\f72f\"; }\n\n.la-wine-glass:before {\n  content: \"\\f4e3\"; }\n\n.la-wine-glass-alt:before {\n  content: \"\\f5ce\"; }\n\n.la-wix:before {\n  content: \"\\f5cf\"; }\n\n.la-wizards-of-the-coast:before {\n  content: \"\\f730\"; }\n\n.la-wolf-pack-battalion:before {\n  content: \"\\f514\"; }\n\n.la-won-sign:before {\n  content: \"\\f159\"; }\n\n.la-wordpress:before {\n  content: \"\\f19a\"; }\n\n.la-wordpress-simple:before {\n  content: \"\\f411\"; }\n\n.la-wpbeginner:before {\n  content: \"\\f297\"; }\n\n.la-wpexplorer:before {\n  content: \"\\f2de\"; }\n\n.la-wpforms:before {\n  content: \"\\f298\"; }\n\n.la-wpressr:before {\n  content: \"\\f3e4\"; }\n\n.la-wrench:before {\n  content: \"\\f0ad\"; }\n\n.la-x-ray:before {\n  content: \"\\f497\"; }\n\n.la-xbox:before {\n  content: \"\\f412\"; }\n\n.la-xing:before {\n  content: \"\\f168\"; }\n\n.la-xing-square:before {\n  content: \"\\f169\"; }\n\n.la-y-combinator:before {\n  content: \"\\f23b\"; }\n\n.la-yahoo:before {\n  content: \"\\f19e\"; }\n\n.la-yammer:before {\n  content: \"\\f840\"; }\n\n.la-yandex:before {\n  content: \"\\f413\"; }\n\n.la-yandex-international:before {\n  content: \"\\f414\"; }\n\n.la-yarn:before {\n  content: \"\\f7e3\"; }\n\n.la-yelp:before {\n  content: \"\\f1e9\"; }\n\n.la-yen-sign:before {\n  content: \"\\f157\"; }\n\n.la-yin-yang:before {\n  content: \"\\f6ad\"; }\n\n.la-yoast:before {\n  content: \"\\f2b1\"; }\n\n.la-youtube:before {\n  content: \"\\f167\"; }\n\n.la-youtube-square:before {\n  content: \"\\f431\"; }\n\n.la-zhihu:before {\n  content: \"\\f63f\"; }\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px; }\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto; }\n@font-face {\n  font-family: 'Line Awesome Brands';\n  font-style: normal;\n  font-weight: normal;\n  font-display: auto;\n  src: url(\"../../../fonts/la-brands-400.eot\");\n  src: url(\"../../../fonts/la-brands-400.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../fonts/la-brands-400.woff2\") format(\"woff2\"), url(\"../../../fonts/la-brands-400.woff\") format(\"woff\"), url(\"../../../fonts/la-brands-400.ttf\") format(\"truetype\"), url(\"../../../fonts/la-brands-400.svg#lineawesome\") format(\"svg\"); }\n\n.lab {\n  font-family: 'Line Awesome Brands'; }\n@font-face {\n  font-family: 'Line Awesome Free';\n  font-style: normal;\n  font-weight: 400;\n  font-display: auto;\n  src: url(\"../../../fonts/la-regular-400.eot\");\n  src: url(\"../../../fonts/la-regular-400.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../fonts/la-regular-400.woff2\") format(\"woff2\"), url(\"../../../fonts/la-regular-400.woff\") format(\"woff\"), url(\"../../../fonts/la-regular-400.ttf\") format(\"truetype\"), url(\"../../../fonts/la-regular-400.svg#lineawesome\") format(\"svg\"); }\n\n.lar {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n@font-face {\n  font-family: 'Line Awesome Free';\n  font-style: normal;\n  font-weight: 900;\n  font-display: auto;\n  src: url(\"../../../fonts/la-solid-900.eot\");\n  src: url(\"../../../fonts/la-solid-900.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../fonts/la-solid-900.woff2\") format(\"woff2\"), url(\"../../../fonts/la-solid-900.woff\") format(\"woff\"), url(\"../../../fonts/la-solid-900.ttf\") format(\"truetype\"), url(\"../../../fonts/la-solid-900.svg#lineawesome\") format(\"svg\"); }\n\n.la,\n.las {\n  font-family: 'Line Awesome Free';\n  font-weight: 900; }\n\n.la.la-glass:before {\n  content: \"\\f000\"; }\n\n.la.la-meetup {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-star-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-star-o:before {\n  content: \"\\f005\"; }\n\n.la.la-remove:before {\n  content: \"\\f00d\"; }\n\n.la.la-close:before {\n  content: \"\\f00d\"; }\n\n.la.la-gear:before {\n  content: \"\\f013\"; }\n\n.la.la-trash-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-trash-o:before {\n  content: \"\\f2ed\"; }\n\n.la.la-file-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-o:before {\n  content: \"\\f15b\"; }\n\n.la.la-clock-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-clock-o:before {\n  content: \"\\f017\"; }\n\n.la.la-arrow-circle-o-down {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-arrow-circle-o-down:before {\n  content: \"\\f358\"; }\n\n.la.la-arrow-circle-o-up {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-arrow-circle-o-up:before {\n  content: \"\\f35b\"; }\n\n.la.la-play-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-play-circle-o:before {\n  content: \"\\f144\"; }\n\n.la.la-repeat:before {\n  content: \"\\f01e\"; }\n\n.la.la-rotate-right:before {\n  content: \"\\f01e\"; }\n\n.la.la-refresh:before {\n  content: \"\\f021\"; }\n\n.la.la-list-alt {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-dedent:before {\n  content: \"\\f03b\"; }\n\n.la.la-video-camera:before {\n  content: \"\\f03d\"; }\n\n.la.la-picture-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-picture-o:before {\n  content: \"\\f03e\"; }\n\n.la.la-photo {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-photo:before {\n  content: \"\\f03e\"; }\n\n.la.la-image {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-image:before {\n  content: \"\\f03e\"; }\n\n.la.la-pencil:before {\n  content: \"\\f303\"; }\n\n.la.la-map-marker:before {\n  content: \"\\f3c5\"; }\n\n.la.la-pencil-square-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-pencil-square-o:before {\n  content: \"\\f044\"; }\n\n.la.la-share-square-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-share-square-o:before {\n  content: \"\\f14d\"; }\n\n.la.la-check-square-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-check-square-o:before {\n  content: \"\\f14a\"; }\n\n.la.la-arrows:before {\n  content: \"\\f0b2\"; }\n\n.la.la-times-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-times-circle-o:before {\n  content: \"\\f057\"; }\n\n.la.la-check-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-check-circle-o:before {\n  content: \"\\f058\"; }\n\n.la.la-mail-forward:before {\n  content: \"\\f064\"; }\n\n.la.la-eye {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-eye-slash {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-warning:before {\n  content: \"\\f071\"; }\n\n.la.la-calendar:before {\n  content: \"\\f073\"; }\n\n.la.la-arrows-v:before {\n  content: \"\\f338\"; }\n\n.la.la-arrows-h:before {\n  content: \"\\f337\"; }\n\n.la.la-bar-chart {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-bar-chart:before {\n  content: \"\\f080\"; }\n\n.la.la-bar-chart-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-bar-chart-o:before {\n  content: \"\\f080\"; }\n\n.la.la-twitter-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-facebook-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-gears:before {\n  content: \"\\f085\"; }\n\n.la.la-thumbs-o-up {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-thumbs-o-up:before {\n  content: \"\\f164\"; }\n\n.la.la-thumbs-o-down {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-thumbs-o-down:before {\n  content: \"\\f165\"; }\n\n.la.la-heart-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-heart-o:before {\n  content: \"\\f004\"; }\n\n.la.la-sign-out:before {\n  content: \"\\f2f5\"; }\n\n.la.la-linkedin-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-linkedin-square:before {\n  content: \"\\f08c\"; }\n\n.la.la-thumb-tack:before {\n  content: \"\\f08d\"; }\n\n.la.la-external-link:before {\n  content: \"\\f35d\"; }\n\n.la.la-sign-in:before {\n  content: \"\\f2f6\"; }\n\n.la.la-github-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-lemon-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-lemon-o:before {\n  content: \"\\f094\"; }\n\n.la.la-square-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-square-o:before {\n  content: \"\\f0c8\"; }\n\n.la.la-bookmark-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-bookmark-o:before {\n  content: \"\\f02e\"; }\n\n.la.la-twitter {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-facebook {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-facebook:before {\n  content: \"\\f39e\"; }\n\n.la.la-facebook-f {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-facebook-f:before {\n  content: \"\\f39e\"; }\n\n.la.la-github {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-credit-card {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-feed:before {\n  content: \"\\f09e\"; }\n\n.la.la-hdd-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hdd-o:before {\n  content: \"\\f0a0\"; }\n\n.la.la-hand-o-right {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-o-right:before {\n  content: \"\\f0a4\"; }\n\n.la.la-hand-o-left {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-o-left:before {\n  content: \"\\f0a5\"; }\n\n.la.la-hand-o-up {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-o-up:before {\n  content: \"\\f0a6\"; }\n\n.la.la-hand-o-down {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-o-down:before {\n  content: \"\\f0a7\"; }\n\n.la.la-arrows-alt:before {\n  content: \"\\f31e\"; }\n\n.la.la-group:before {\n  content: \"\\f0c0\"; }\n\n.la.la-chain:before {\n  content: \"\\f0c1\"; }\n\n.la.la-scissors:before {\n  content: \"\\f0c4\"; }\n\n.la.la-files-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-files-o:before {\n  content: \"\\f0c5\"; }\n\n.la.la-floppy-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-floppy-o:before {\n  content: \"\\f0c7\"; }\n\n.la.la-navicon:before {\n  content: \"\\f0c9\"; }\n\n.la.la-reorder:before {\n  content: \"\\f0c9\"; }\n\n.la.la-pinterest {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-pinterest-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google-plus-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google-plus {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google-plus:before {\n  content: \"\\f0d5\"; }\n\n.la.la-money {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-money:before {\n  content: \"\\f3d1\"; }\n\n.la.la-unsorted:before {\n  content: \"\\f0dc\"; }\n\n.la.la-sort-desc:before {\n  content: \"\\f0dd\"; }\n\n.la.la-sort-asc:before {\n  content: \"\\f0de\"; }\n\n.la.la-linkedin {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-linkedin:before {\n  content: \"\\f0e1\"; }\n\n.la.la-rotate-left:before {\n  content: \"\\f0e2\"; }\n\n.la.la-legal:before {\n  content: \"\\f0e3\"; }\n\n.la.la-tachometer:before {\n  content: \"\\f3fd\"; }\n\n.la.la-dashboard:before {\n  content: \"\\f3fd\"; }\n\n.la.la-comment-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-comment-o:before {\n  content: \"\\f075\"; }\n\n.la.la-comments-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-comments-o:before {\n  content: \"\\f086\"; }\n\n.la.la-flash:before {\n  content: \"\\f0e7\"; }\n\n.la.la-clipboard {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-paste {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-paste:before {\n  content: \"\\f328\"; }\n\n.la.la-lightbulb-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-lightbulb-o:before {\n  content: \"\\f0eb\"; }\n\n.la.la-exchange:before {\n  content: \"\\f362\"; }\n\n.la.la-cloud-download:before {\n  content: \"\\f381\"; }\n\n.la.la-cloud-upload:before {\n  content: \"\\f382\"; }\n\n.la.la-bell-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-bell-o:before {\n  content: \"\\f0f3\"; }\n\n.la.la-cutlery:before {\n  content: \"\\f2e7\"; }\n\n.la.la-file-text-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-text-o:before {\n  content: \"\\f15c\"; }\n\n.la.la-building-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-building-o:before {\n  content: \"\\f1ad\"; }\n\n.la.la-hospital-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hospital-o:before {\n  content: \"\\f0f8\"; }\n\n.la.la-tablet:before {\n  content: \"\\f3fa\"; }\n\n.la.la-mobile:before {\n  content: \"\\f3cd\"; }\n\n.la.la-mobile-phone:before {\n  content: \"\\f3cd\"; }\n\n.la.la-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-circle-o:before {\n  content: \"\\f111\"; }\n\n.la.la-mail-reply:before {\n  content: \"\\f3e5\"; }\n\n.la.la-github-alt {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-folder-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-folder-o:before {\n  content: \"\\f07b\"; }\n\n.la.la-folder-open-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-folder-open-o:before {\n  content: \"\\f07c\"; }\n\n.la.la-smile-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-smile-o:before {\n  content: \"\\f118\"; }\n\n.la.la-frown-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-frown-o:before {\n  content: \"\\f119\"; }\n\n.la.la-meh-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-meh-o:before {\n  content: \"\\f11a\"; }\n\n.la.la-keyboard-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-keyboard-o:before {\n  content: \"\\f11c\"; }\n\n.la.la-flag-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-flag-o:before {\n  content: \"\\f024\"; }\n\n.la.la-mail-reply-all:before {\n  content: \"\\f122\"; }\n\n.la.la-star-half-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-star-half-o:before {\n  content: \"\\f089\"; }\n\n.la.la-star-half-empty {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-star-half-empty:before {\n  content: \"\\f089\"; }\n\n.la.la-star-half-full {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-star-half-full:before {\n  content: \"\\f089\"; }\n\n.la.la-code-fork:before {\n  content: \"\\f126\"; }\n\n.la.la-chain-broken:before {\n  content: \"\\f127\"; }\n\n.la.la-shield:before {\n  content: \"\\f3ed\"; }\n\n.la.la-calendar-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-calendar-o:before {\n  content: \"\\f133\"; }\n\n.la.la-maxcdn {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-html5 {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-css3 {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-ticket:before {\n  content: \"\\f3ff\"; }\n\n.la.la-minus-square-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-minus-square-o:before {\n  content: \"\\f146\"; }\n\n.la.la-level-up:before {\n  content: \"\\f3bf\"; }\n\n.la.la-level-down:before {\n  content: \"\\f3be\"; }\n\n.la.la-pencil-square:before {\n  content: \"\\f14b\"; }\n\n.la.la-external-link-square:before {\n  content: \"\\f360\"; }\n\n.la.la-compass {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-caret-square-o-down {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-caret-square-o-down:before {\n  content: \"\\f150\"; }\n\n.la.la-toggle-down {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-toggle-down:before {\n  content: \"\\f150\"; }\n\n.la.la-caret-square-o-up {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-caret-square-o-up:before {\n  content: \"\\f151\"; }\n\n.la.la-toggle-up {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-toggle-up:before {\n  content: \"\\f151\"; }\n\n.la.la-caret-square-o-right {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-caret-square-o-right:before {\n  content: \"\\f152\"; }\n\n.la.la-toggle-right {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-toggle-right:before {\n  content: \"\\f152\"; }\n\n.la.la-eur:before {\n  content: \"\\f153\"; }\n\n.la.la-euro:before {\n  content: \"\\f153\"; }\n\n.la.la-gbp:before {\n  content: \"\\f154\"; }\n\n.la.la-usd:before {\n  content: \"\\f155\"; }\n\n.la.la-dollar:before {\n  content: \"\\f155\"; }\n\n.la.la-inr:before {\n  content: \"\\f156\"; }\n\n.la.la-rupee:before {\n  content: \"\\f156\"; }\n\n.la.la-jpy:before {\n  content: \"\\f157\"; }\n\n.la.la-cny:before {\n  content: \"\\f157\"; }\n\n.la.la-rmb:before {\n  content: \"\\f157\"; }\n\n.la.la-yen:before {\n  content: \"\\f157\"; }\n\n.la.la-rub:before {\n  content: \"\\f158\"; }\n\n.la.la-ruble:before {\n  content: \"\\f158\"; }\n\n.la.la-rouble:before {\n  content: \"\\f158\"; }\n\n.la.la-krw:before {\n  content: \"\\f159\"; }\n\n.la.la-won:before {\n  content: \"\\f159\"; }\n\n.la.la-btc {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-bitcoin {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-bitcoin:before {\n  content: \"\\f15a\"; }\n\n.la.la-file-text:before {\n  content: \"\\f15c\"; }\n\n.la.la-sort-alpha-asc:before {\n  content: \"\\f15d\"; }\n\n.la.la-sort-alpha-desc:before {\n  content: \"\\f881\"; }\n\n.la.la-sort-amount-asc:before {\n  content: \"\\f160\"; }\n\n.la.la-sort-amount-desc:before {\n  content: \"\\f884\"; }\n\n.la.la-sort-numeric-asc:before {\n  content: \"\\f162\"; }\n\n.la.la-sort-numeric-desc:before {\n  content: \"\\f886\"; }\n\n.la.la-youtube-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-youtube {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-xing {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-xing-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-youtube-play {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-youtube-play:before {\n  content: \"\\f167\"; }\n\n.la.la-dropbox {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-stack-overflow {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-instagram {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-flickr {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-adn {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-bitbucket {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-bitbucket-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-bitbucket-square:before {\n  content: \"\\f171\"; }\n\n.la.la-tumblr {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-tumblr-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-long-arrow-down:before {\n  content: \"\\f309\"; }\n\n.la.la-long-arrow-up:before {\n  content: \"\\f30c\"; }\n\n.la.la-long-arrow-left:before {\n  content: \"\\f30a\"; }\n\n.la.la-long-arrow-right:before {\n  content: \"\\f30b\"; }\n\n.la.la-apple {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-windows {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-android {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-linux {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-dribbble {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-skype {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-foursquare {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-trello {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-gratipay {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-gittip {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-gittip:before {\n  content: \"\\f184\"; }\n\n.la.la-sun-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-sun-o:before {\n  content: \"\\f185\"; }\n\n.la.la-moon-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-moon-o:before {\n  content: \"\\f186\"; }\n\n.la.la-vk {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-weibo {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-renren {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-pagelines {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-stack-exchange {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-arrow-circle-o-right {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-arrow-circle-o-right:before {\n  content: \"\\f35a\"; }\n\n.la.la-arrow-circle-o-left {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-arrow-circle-o-left:before {\n  content: \"\\f359\"; }\n\n.la.la-caret-square-o-left {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-caret-square-o-left:before {\n  content: \"\\f191\"; }\n\n.la.la-toggle-left {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-toggle-left:before {\n  content: \"\\f191\"; }\n\n.la.la-dot-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-dot-circle-o:before {\n  content: \"\\f192\"; }\n\n.la.la-vimeo-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-try:before {\n  content: \"\\f195\"; }\n\n.la.la-turkish-lira:before {\n  content: \"\\f195\"; }\n\n.la.la-plus-square-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-plus-square-o:before {\n  content: \"\\f0fe\"; }\n\n.la.la-slack {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wordpress {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-openid {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-institution:before {\n  content: \"\\f19c\"; }\n\n.la.la-bank:before {\n  content: \"\\f19c\"; }\n\n.la.la-mortar-board:before {\n  content: \"\\f19d\"; }\n\n.la.la-yahoo {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-reddit {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-reddit-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-stumbleupon-circle {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-stumbleupon {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-delicious {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-digg {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-pied-piper-pp {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-pied-piper-alt {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-drupal {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-joomla {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-spoon:before {\n  content: \"\\f2e5\"; }\n\n.la.la-behance {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-behance-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-steam {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-steam-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-automobile:before {\n  content: \"\\f1b9\"; }\n\n.la.la-cab:before {\n  content: \"\\f1ba\"; }\n\n.la.la-envelope-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-envelope-o:before {\n  content: \"\\f0e0\"; }\n\n.la.la-deviantart {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-soundcloud {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-file-pdf-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-pdf-o:before {\n  content: \"\\f1c1\"; }\n\n.la.la-file-word-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-word-o:before {\n  content: \"\\f1c2\"; }\n\n.la.la-file-excel-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-excel-o:before {\n  content: \"\\f1c3\"; }\n\n.la.la-file-powerpoint-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-powerpoint-o:before {\n  content: \"\\f1c4\"; }\n\n.la.la-file-image-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-image-o:before {\n  content: \"\\f1c5\"; }\n\n.la.la-file-photo-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-photo-o:before {\n  content: \"\\f1c5\"; }\n\n.la.la-file-picture-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-picture-o:before {\n  content: \"\\f1c5\"; }\n\n.la.la-file-archive-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-archive-o:before {\n  content: \"\\f1c6\"; }\n\n.la.la-file-zip-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-zip-o:before {\n  content: \"\\f1c6\"; }\n\n.la.la-file-audio-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-audio-o:before {\n  content: \"\\f1c7\"; }\n\n.la.la-file-sound-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-sound-o:before {\n  content: \"\\f1c7\"; }\n\n.la.la-file-video-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-video-o:before {\n  content: \"\\f1c8\"; }\n\n.la.la-file-movie-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-movie-o:before {\n  content: \"\\f1c8\"; }\n\n.la.la-file-code-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-file-code-o:before {\n  content: \"\\f1c9\"; }\n\n.la.la-vine {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-codepen {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-jsfiddle {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-life-ring {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-life-bouy {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-life-bouy:before {\n  content: \"\\f1cd\"; }\n\n.la.la-life-buoy {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-life-buoy:before {\n  content: \"\\f1cd\"; }\n\n.la.la-life-saver {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-life-saver:before {\n  content: \"\\f1cd\"; }\n\n.la.la-support {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-support:before {\n  content: \"\\f1cd\"; }\n\n.la.la-circle-o-notch:before {\n  content: \"\\f1ce\"; }\n\n.la.la-rebel {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-ra {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-ra:before {\n  content: \"\\f1d0\"; }\n\n.la.la-resistance {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-resistance:before {\n  content: \"\\f1d0\"; }\n\n.la.la-empire {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-ge {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-ge:before {\n  content: \"\\f1d1\"; }\n\n.la.la-git-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-git {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-hacker-news {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-y-combinator-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-y-combinator-square:before {\n  content: \"\\f1d4\"; }\n\n.la.la-yc-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-yc-square:before {\n  content: \"\\f1d4\"; }\n\n.la.la-tencent-weibo {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-qq {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-weixin {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wechat {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wechat:before {\n  content: \"\\f1d7\"; }\n\n.la.la-send:before {\n  content: \"\\f1d8\"; }\n\n.la.la-paper-plane-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-paper-plane-o:before {\n  content: \"\\f1d8\"; }\n\n.la.la-send-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-send-o:before {\n  content: \"\\f1d8\"; }\n\n.la.la-circle-thin {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-circle-thin:before {\n  content: \"\\f111\"; }\n\n.la.la-header:before {\n  content: \"\\f1dc\"; }\n\n.la.la-sliders:before {\n  content: \"\\f1de\"; }\n\n.la.la-futbol-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-futbol-o:before {\n  content: \"\\f1e3\"; }\n\n.la.la-soccer-ball-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-soccer-ball-o:before {\n  content: \"\\f1e3\"; }\n\n.la.la-slideshare {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-twitch {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-yelp {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-newspaper-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-newspaper-o:before {\n  content: \"\\f1ea\"; }\n\n.la.la-paypal {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google-wallet {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc-visa {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc-mastercard {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc-discover {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc-amex {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc-paypal {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc-stripe {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-bell-slash-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-bell-slash-o:before {\n  content: \"\\f1f6\"; }\n\n.la.la-trash:before {\n  content: \"\\f2ed\"; }\n\n.la.la-copyright {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-eyedropper:before {\n  content: \"\\f1fb\"; }\n\n.la.la-area-chart:before {\n  content: \"\\f1fe\"; }\n\n.la.la-pie-chart:before {\n  content: \"\\f200\"; }\n\n.la.la-line-chart:before {\n  content: \"\\f201\"; }\n\n.la.la-lastfm {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-lastfm-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-ioxhost {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-angellist {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-cc:before {\n  content: \"\\f20a\"; }\n\n.la.la-ils:before {\n  content: \"\\f20b\"; }\n\n.la.la-shekel:before {\n  content: \"\\f20b\"; }\n\n.la.la-sheqel:before {\n  content: \"\\f20b\"; }\n\n.la.la-meanpath {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-meanpath:before {\n  content: \"\\f2b4\"; }\n\n.la.la-buysellads {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-connectdevelop {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-dashcube {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-forumbee {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-leanpub {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-sellsy {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-shirtsinbulk {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-simplybuilt {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-skyatlas {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-diamond {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-diamond:before {\n  content: \"\\f3a5\"; }\n\n.la.la-intersex:before {\n  content: \"\\f224\"; }\n\n.la.la-facebook-official {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-facebook-official:before {\n  content: \"\\f09a\"; }\n\n.la.la-pinterest-p {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-whatsapp {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-hotel:before {\n  content: \"\\f236\"; }\n\n.la.la-viacoin {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-medium {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-y-combinator {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-yc {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-yc:before {\n  content: \"\\f23b\"; }\n\n.la.la-optin-monster {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-opencart {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-expeditedssl {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-battery-4:before {\n  content: \"\\f240\"; }\n\n.la.la-battery:before {\n  content: \"\\f240\"; }\n\n.la.la-battery-3:before {\n  content: \"\\f241\"; }\n\n.la.la-battery-2:before {\n  content: \"\\f242\"; }\n\n.la.la-battery-1:before {\n  content: \"\\f243\"; }\n\n.la.la-battery-0:before {\n  content: \"\\f244\"; }\n\n.la.la-object-group {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-object-ungroup {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-sticky-note-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-sticky-note-o:before {\n  content: \"\\f249\"; }\n\n.la.la-cc-jcb {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-cc-diners-club {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-clone {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hourglass-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hourglass-o:before {\n  content: \"\\f254\"; }\n\n.la.la-hourglass-1:before {\n  content: \"\\f251\"; }\n\n.la.la-hourglass-2:before {\n  content: \"\\f252\"; }\n\n.la.la-hourglass-3:before {\n  content: \"\\f253\"; }\n\n.la.la-hand-rock-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-rock-o:before {\n  content: \"\\f255\"; }\n\n.la.la-hand-grab-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-grab-o:before {\n  content: \"\\f255\"; }\n\n.la.la-hand-paper-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-paper-o:before {\n  content: \"\\f256\"; }\n\n.la.la-hand-stop-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-stop-o:before {\n  content: \"\\f256\"; }\n\n.la.la-hand-scissors-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-scissors-o:before {\n  content: \"\\f257\"; }\n\n.la.la-hand-lizard-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-lizard-o:before {\n  content: \"\\f258\"; }\n\n.la.la-hand-spock-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-spock-o:before {\n  content: \"\\f259\"; }\n\n.la.la-hand-pointer-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-pointer-o:before {\n  content: \"\\f25a\"; }\n\n.la.la-hand-peace-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-hand-peace-o:before {\n  content: \"\\f25b\"; }\n\n.la.la-registered {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-creative-commons {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-gg {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-gg-circle {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-tripadvisor {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-odnoklassniki {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-odnoklassniki-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-get-pocket {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wikipedia-w {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-safari {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-chrome {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-firefox {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-opera {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-internet-explorer {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-television:before {\n  content: \"\\f26c\"; }\n\n.la.la-contao {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-500px {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-amazon {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-calendar-plus-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-calendar-plus-o:before {\n  content: \"\\f271\"; }\n\n.la.la-calendar-minus-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-calendar-minus-o:before {\n  content: \"\\f272\"; }\n\n.la.la-calendar-times-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-calendar-times-o:before {\n  content: \"\\f273\"; }\n\n.la.la-calendar-check-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-calendar-check-o:before {\n  content: \"\\f274\"; }\n\n.la.la-map-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-map-o:before {\n  content: \"\\f279\"; }\n\n.la.la-commenting:before {\n  content: \"\\f4ad\"; }\n\n.la.la-commenting-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-commenting-o:before {\n  content: \"\\f4ad\"; }\n\n.la.la-houzz {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-vimeo {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-vimeo:before {\n  content: \"\\f27d\"; }\n\n.la.la-black-tie {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-fonticons {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-reddit-alien {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-edge {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-credit-card-alt:before {\n  content: \"\\f09d\"; }\n\n.la.la-codiepie {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-modx {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-fort-awesome {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-usb {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-product-hunt {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-mixcloud {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-scribd {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-pause-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-pause-circle-o:before {\n  content: \"\\f28b\"; }\n\n.la.la-stop-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-stop-circle-o:before {\n  content: \"\\f28d\"; }\n\n.la.la-bluetooth {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-bluetooth-b {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-gitlab {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wpbeginner {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wpforms {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-envira {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wheelchair-alt {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wheelchair-alt:before {\n  content: \"\\f368\"; }\n\n.la.la-question-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-question-circle-o:before {\n  content: \"\\f059\"; }\n\n.la.la-volume-control-phone:before {\n  content: \"\\f2a0\"; }\n\n.la.la-asl-interpreting:before {\n  content: \"\\f2a3\"; }\n\n.la.la-deafness:before {\n  content: \"\\f2a4\"; }\n\n.la.la-hard-of-hearing:before {\n  content: \"\\f2a4\"; }\n\n.la.la-glide {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-glide-g {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-signing:before {\n  content: \"\\f2a7\"; }\n\n.la.la-viadeo {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-viadeo-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-snapchat {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-snapchat-ghost {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-snapchat-square {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-pied-piper {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-first-order {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-yoast {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-themeisle {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google-plus-official {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google-plus-official:before {\n  content: \"\\f2b3\"; }\n\n.la.la-google-plus-circle {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-google-plus-circle:before {\n  content: \"\\f2b3\"; }\n\n.la.la-font-awesome {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-fa {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-fa:before {\n  content: \"\\f2b4\"; }\n\n.la.la-handshake-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-handshake-o:before {\n  content: \"\\f2b5\"; }\n\n.la.la-envelope-open-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-envelope-open-o:before {\n  content: \"\\f2b6\"; }\n\n.la.la-linode {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-address-book-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-address-book-o:before {\n  content: \"\\f2b9\"; }\n\n.la.la-vcard:before {\n  content: \"\\f2bb\"; }\n\n.la.la-address-card-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-address-card-o:before {\n  content: \"\\f2bb\"; }\n\n.la.la-vcard-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-vcard-o:before {\n  content: \"\\f2bb\"; }\n\n.la.la-user-circle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-user-circle-o:before {\n  content: \"\\f2bd\"; }\n\n.la.la-user-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-user-o:before {\n  content: \"\\f007\"; }\n\n.la.la-id-badge {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-drivers-license:before {\n  content: \"\\f2c2\"; }\n\n.la.la-id-card-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-id-card-o:before {\n  content: \"\\f2c2\"; }\n\n.la.la-drivers-license-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-drivers-license-o:before {\n  content: \"\\f2c2\"; }\n\n.la.la-quora {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-free-code-camp {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-telegram {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-thermometer-4:before {\n  content: \"\\f2c7\"; }\n\n.la.la-thermometer:before {\n  content: \"\\f2c7\"; }\n\n.la.la-thermometer-3:before {\n  content: \"\\f2c8\"; }\n\n.la.la-thermometer-2:before {\n  content: \"\\f2c9\"; }\n\n.la.la-thermometer-1:before {\n  content: \"\\f2ca\"; }\n\n.la.la-thermometer-0:before {\n  content: \"\\f2cb\"; }\n\n.la.la-bathtub:before {\n  content: \"\\f2cd\"; }\n\n.la.la-s15:before {\n  content: \"\\f2cd\"; }\n\n.la.la-window-maximize {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-window-restore {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-times-rectangle:before {\n  content: \"\\f410\"; }\n\n.la.la-window-close-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-window-close-o:before {\n  content: \"\\f410\"; }\n\n.la.la-times-rectangle-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-times-rectangle-o:before {\n  content: \"\\f410\"; }\n\n.la.la-bandcamp {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-grav {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-etsy {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-imdb {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-ravelry {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-eercast {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-eercast:before {\n  content: \"\\f2da\"; }\n\n.la.la-snowflake-o {\n  font-family: 'Line Awesome Free';\n  font-weight: 400; }\n\n.la.la-snowflake-o:before {\n  content: \"\\f2dc\"; }\n\n.la.la-superpowers {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-wpexplorer {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n\n.la.la-spotify {\n  font-family: 'Line Awesome Brands';\n  font-weight: 400; }\n","/*\n* Remix Icon v2.5.0\n* https://remixicon.com\n* https://github.com/Remix-Design/RemixIcon\n*\n* Copyright RemixIcon.com\n* Released under the Apache License Version 2.0\n*\n* Date: 2020-05-23\n*/\n@font-face {\n  font-family: \"remixicon\";\n  src: url('../../../fonts/remixicon.eot?t=1590207869815'); /* IE9*/\n  src: url('../../../fonts/remixicon.eot?t=1590207869815#iefix') format('embedded-opentype'), /* IE6-IE8 */\n  url(\"../../../fonts/remixicon.woff2?t=1590207869815\") format(\"woff2\"),\n  url(\"../../../fonts/remixicon.woff?t=1590207869815\") format(\"woff\"),\n  url('../../../fonts/remixicon.ttf?t=1590207869815') format('truetype'), /* chrome, firefox, opera, Safari, Android, iOS 4.2+*/\n  url('../../../fonts/remixicon.svg?t=1590207869815#remixicon') format('svg'); /* iOS 4.1- */\n  font-display: swap;\n}\n\n[class^=\"ri-\"], [class*=\" ri-\"] {\n  font-family: 'remixicon' !important;\n  font-style: normal;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.ri-lg { font-size: 1.3333em; line-height: 0.75em; vertical-align: -.0667em; }\n.ri-xl { font-size: 1.5em; line-height: 0.6666em; vertical-align: -.075em; }\n.ri-xxs { font-size: .5em; }\n.ri-xs { font-size: .75em; }\n.ri-sm { font-size: .875em }\n.ri-1x { font-size: 1em; }\n.ri-2x { font-size: 2em; }\n.ri-3x { font-size: 3em; }\n.ri-4x { font-size: 4em; }\n.ri-5x { font-size: 5em; }\n.ri-6x { font-size: 6em; }\n.ri-7x { font-size: 7em; }\n.ri-8x { font-size: 8em; }\n.ri-9x { font-size: 9em; }\n.ri-10x { font-size: 10em; }\n.ri-fw { text-align: center; width: 1.25em; }\n\n.ri-24-hours-fill:before { content: \"\\ea01\"; }\n.ri-24-hours-line:before { content: \"\\ea02\"; }\n.ri-4k-fill:before { content: \"\\ea03\"; }\n.ri-4k-line:before { content: \"\\ea04\"; }\n.ri-a-b:before { content: \"\\ea05\"; }\n.ri-account-box-fill:before { content: \"\\ea06\"; }\n.ri-account-box-line:before { content: \"\\ea07\"; }\n.ri-account-circle-fill:before { content: \"\\ea08\"; }\n.ri-account-circle-line:before { content: \"\\ea09\"; }\n.ri-account-pin-box-fill:before { content: \"\\ea0a\"; }\n.ri-account-pin-box-line:before { content: \"\\ea0b\"; }\n.ri-account-pin-circle-fill:before { content: \"\\ea0c\"; }\n.ri-account-pin-circle-line:before { content: \"\\ea0d\"; }\n.ri-add-box-fill:before { content: \"\\ea0e\"; }\n.ri-add-box-line:before { content: \"\\ea0f\"; }\n.ri-add-circle-fill:before { content: \"\\ea10\"; }\n.ri-add-circle-line:before { content: \"\\ea11\"; }\n.ri-add-fill:before { content: \"\\ea12\"; }\n.ri-add-line:before { content: \"\\ea13\"; }\n.ri-admin-fill:before { content: \"\\ea14\"; }\n.ri-admin-line:before { content: \"\\ea15\"; }\n.ri-advertisement-fill:before { content: \"\\ea16\"; }\n.ri-advertisement-line:before { content: \"\\ea17\"; }\n.ri-airplay-fill:before { content: \"\\ea18\"; }\n.ri-airplay-line:before { content: \"\\ea19\"; }\n.ri-alarm-fill:before { content: \"\\ea1a\"; }\n.ri-alarm-line:before { content: \"\\ea1b\"; }\n.ri-alarm-warning-fill:before { content: \"\\ea1c\"; }\n.ri-alarm-warning-line:before { content: \"\\ea1d\"; }\n.ri-album-fill:before { content: \"\\ea1e\"; }\n.ri-album-line:before { content: \"\\ea1f\"; }\n.ri-alert-fill:before { content: \"\\ea20\"; }\n.ri-alert-line:before { content: \"\\ea21\"; }\n.ri-aliens-fill:before { content: \"\\ea22\"; }\n.ri-aliens-line:before { content: \"\\ea23\"; }\n.ri-align-bottom:before { content: \"\\ea24\"; }\n.ri-align-center:before { content: \"\\ea25\"; }\n.ri-align-justify:before { content: \"\\ea26\"; }\n.ri-align-left:before { content: \"\\ea27\"; }\n.ri-align-right:before { content: \"\\ea28\"; }\n.ri-align-top:before { content: \"\\ea29\"; }\n.ri-align-vertically:before { content: \"\\ea2a\"; }\n.ri-alipay-fill:before { content: \"\\ea2b\"; }\n.ri-alipay-line:before { content: \"\\ea2c\"; }\n.ri-amazon-fill:before { content: \"\\ea2d\"; }\n.ri-amazon-line:before { content: \"\\ea2e\"; }\n.ri-anchor-fill:before { content: \"\\ea2f\"; }\n.ri-anchor-line:before { content: \"\\ea30\"; }\n.ri-ancient-gate-fill:before { content: \"\\ea31\"; }\n.ri-ancient-gate-line:before { content: \"\\ea32\"; }\n.ri-ancient-pavilion-fill:before { content: \"\\ea33\"; }\n.ri-ancient-pavilion-line:before { content: \"\\ea34\"; }\n.ri-android-fill:before { content: \"\\ea35\"; }\n.ri-android-line:before { content: \"\\ea36\"; }\n.ri-angularjs-fill:before { content: \"\\ea37\"; }\n.ri-angularjs-line:before { content: \"\\ea38\"; }\n.ri-anticlockwise-2-fill:before { content: \"\\ea39\"; }\n.ri-anticlockwise-2-line:before { content: \"\\ea3a\"; }\n.ri-anticlockwise-fill:before { content: \"\\ea3b\"; }\n.ri-anticlockwise-line:before { content: \"\\ea3c\"; }\n.ri-app-store-fill:before { content: \"\\ea3d\"; }\n.ri-app-store-line:before { content: \"\\ea3e\"; }\n.ri-apple-fill:before { content: \"\\ea3f\"; }\n.ri-apple-line:before { content: \"\\ea40\"; }\n.ri-apps-2-fill:before { content: \"\\ea41\"; }\n.ri-apps-2-line:before { content: \"\\ea42\"; }\n.ri-apps-fill:before { content: \"\\ea43\"; }\n.ri-apps-line:before { content: \"\\ea44\"; }\n.ri-archive-drawer-fill:before { content: \"\\ea45\"; }\n.ri-archive-drawer-line:before { content: \"\\ea46\"; }\n.ri-archive-fill:before { content: \"\\ea47\"; }\n.ri-archive-line:before { content: \"\\ea48\"; }\n.ri-arrow-down-circle-fill:before { content: \"\\ea49\"; }\n.ri-arrow-down-circle-line:before { content: \"\\ea4a\"; }\n.ri-arrow-down-fill:before { content: \"\\ea4b\"; }\n.ri-arrow-down-line:before { content: \"\\ea4c\"; }\n.ri-arrow-down-s-fill:before { content: \"\\ea4d\"; }\n.ri-arrow-down-s-line:before { content: \"\\ea4e\"; }\n.ri-arrow-drop-down-fill:before { content: \"\\ea4f\"; }\n.ri-arrow-drop-down-line:before { content: \"\\ea50\"; }\n.ri-arrow-drop-left-fill:before { content: \"\\ea51\"; }\n.ri-arrow-drop-left-line:before { content: \"\\ea52\"; }\n.ri-arrow-drop-right-fill:before { content: \"\\ea53\"; }\n.ri-arrow-drop-right-line:before { content: \"\\ea54\"; }\n.ri-arrow-drop-up-fill:before { content: \"\\ea55\"; }\n.ri-arrow-drop-up-line:before { content: \"\\ea56\"; }\n.ri-arrow-go-back-fill:before { content: \"\\ea57\"; }\n.ri-arrow-go-back-line:before { content: \"\\ea58\"; }\n.ri-arrow-go-forward-fill:before { content: \"\\ea59\"; }\n.ri-arrow-go-forward-line:before { content: \"\\ea5a\"; }\n.ri-arrow-left-circle-fill:before { content: \"\\ea5b\"; }\n.ri-arrow-left-circle-line:before { content: \"\\ea5c\"; }\n.ri-arrow-left-down-fill:before { content: \"\\ea5d\"; }\n.ri-arrow-left-down-line:before { content: \"\\ea5e\"; }\n.ri-arrow-left-fill:before { content: \"\\ea5f\"; }\n.ri-arrow-left-line:before { content: \"\\ea60\"; }\n.ri-arrow-left-right-fill:before { content: \"\\ea61\"; }\n.ri-arrow-left-right-line:before { content: \"\\ea62\"; }\n.ri-arrow-left-s-fill:before { content: \"\\ea63\"; }\n.ri-arrow-left-s-line:before { content: \"\\ea64\"; }\n.ri-arrow-left-up-fill:before { content: \"\\ea65\"; }\n.ri-arrow-left-up-line:before { content: \"\\ea66\"; }\n.ri-arrow-right-circle-fill:before { content: \"\\ea67\"; }\n.ri-arrow-right-circle-line:before { content: \"\\ea68\"; }\n.ri-arrow-right-down-fill:before { content: \"\\ea69\"; }\n.ri-arrow-right-down-line:before { content: \"\\ea6a\"; }\n.ri-arrow-right-fill:before { content: \"\\ea6b\"; }\n.ri-arrow-right-line:before { content: \"\\ea6c\"; }\n.ri-arrow-right-s-fill:before { content: \"\\ea6d\"; }\n.ri-arrow-right-s-line:before { content: \"\\ea6e\"; }\n.ri-arrow-right-up-fill:before { content: \"\\ea6f\"; }\n.ri-arrow-right-up-line:before { content: \"\\ea70\"; }\n.ri-arrow-up-circle-fill:before { content: \"\\ea71\"; }\n.ri-arrow-up-circle-line:before { content: \"\\ea72\"; }\n.ri-arrow-up-down-fill:before { content: \"\\ea73\"; }\n.ri-arrow-up-down-line:before { content: \"\\ea74\"; }\n.ri-arrow-up-fill:before { content: \"\\ea75\"; }\n.ri-arrow-up-line:before { content: \"\\ea76\"; }\n.ri-arrow-up-s-fill:before { content: \"\\ea77\"; }\n.ri-arrow-up-s-line:before { content: \"\\ea78\"; }\n.ri-artboard-2-fill:before { content: \"\\ea79\"; }\n.ri-artboard-2-line:before { content: \"\\ea7a\"; }\n.ri-artboard-fill:before { content: \"\\ea7b\"; }\n.ri-artboard-line:before { content: \"\\ea7c\"; }\n.ri-article-fill:before { content: \"\\ea7d\"; }\n.ri-article-line:before { content: \"\\ea7e\"; }\n.ri-aspect-ratio-fill:before { content: \"\\ea7f\"; }\n.ri-aspect-ratio-line:before { content: \"\\ea80\"; }\n.ri-asterisk:before { content: \"\\ea81\"; }\n.ri-at-fill:before { content: \"\\ea82\"; }\n.ri-at-line:before { content: \"\\ea83\"; }\n.ri-attachment-2:before { content: \"\\ea84\"; }\n.ri-attachment-fill:before { content: \"\\ea85\"; }\n.ri-attachment-line:before { content: \"\\ea86\"; }\n.ri-auction-fill:before { content: \"\\ea87\"; }\n.ri-auction-line:before { content: \"\\ea88\"; }\n.ri-award-fill:before { content: \"\\ea89\"; }\n.ri-award-line:before { content: \"\\ea8a\"; }\n.ri-baidu-fill:before { content: \"\\ea8b\"; }\n.ri-baidu-line:before { content: \"\\ea8c\"; }\n.ri-ball-pen-fill:before { content: \"\\ea8d\"; }\n.ri-ball-pen-line:before { content: \"\\ea8e\"; }\n.ri-bank-card-2-fill:before { content: \"\\ea8f\"; }\n.ri-bank-card-2-line:before { content: \"\\ea90\"; }\n.ri-bank-card-fill:before { content: \"\\ea91\"; }\n.ri-bank-card-line:before { content: \"\\ea92\"; }\n.ri-bank-fill:before { content: \"\\ea93\"; }\n.ri-bank-line:before { content: \"\\ea94\"; }\n.ri-bar-chart-2-fill:before { content: \"\\ea95\"; }\n.ri-bar-chart-2-line:before { content: \"\\ea96\"; }\n.ri-bar-chart-box-fill:before { content: \"\\ea97\"; }\n.ri-bar-chart-box-line:before { content: \"\\ea98\"; }\n.ri-bar-chart-fill:before { content: \"\\ea99\"; }\n.ri-bar-chart-grouped-fill:before { content: \"\\ea9a\"; }\n.ri-bar-chart-grouped-line:before { content: \"\\ea9b\"; }\n.ri-bar-chart-horizontal-fill:before { content: \"\\ea9c\"; }\n.ri-bar-chart-horizontal-line:before { content: \"\\ea9d\"; }\n.ri-bar-chart-line:before { content: \"\\ea9e\"; }\n.ri-barcode-box-fill:before { content: \"\\ea9f\"; }\n.ri-barcode-box-line:before { content: \"\\eaa0\"; }\n.ri-barcode-fill:before { content: \"\\eaa1\"; }\n.ri-barcode-line:before { content: \"\\eaa2\"; }\n.ri-barricade-fill:before { content: \"\\eaa3\"; }\n.ri-barricade-line:before { content: \"\\eaa4\"; }\n.ri-base-station-fill:before { content: \"\\eaa5\"; }\n.ri-base-station-line:before { content: \"\\eaa6\"; }\n.ri-basketball-fill:before { content: \"\\eaa7\"; }\n.ri-basketball-line:before { content: \"\\eaa8\"; }\n.ri-battery-2-charge-fill:before { content: \"\\eaa9\"; }\n.ri-battery-2-charge-line:before { content: \"\\eaaa\"; }\n.ri-battery-2-fill:before { content: \"\\eaab\"; }\n.ri-battery-2-line:before { content: \"\\eaac\"; }\n.ri-battery-charge-fill:before { content: \"\\eaad\"; }\n.ri-battery-charge-line:before { content: \"\\eaae\"; }\n.ri-battery-fill:before { content: \"\\eaaf\"; }\n.ri-battery-line:before { content: \"\\eab0\"; }\n.ri-battery-low-fill:before { content: \"\\eab1\"; }\n.ri-battery-low-line:before { content: \"\\eab2\"; }\n.ri-battery-saver-fill:before { content: \"\\eab3\"; }\n.ri-battery-saver-line:before { content: \"\\eab4\"; }\n.ri-battery-share-fill:before { content: \"\\eab5\"; }\n.ri-battery-share-line:before { content: \"\\eab6\"; }\n.ri-bear-smile-fill:before { content: \"\\eab7\"; }\n.ri-bear-smile-line:before { content: \"\\eab8\"; }\n.ri-behance-fill:before { content: \"\\eab9\"; }\n.ri-behance-line:before { content: \"\\eaba\"; }\n.ri-bell-fill:before { content: \"\\eabb\"; }\n.ri-bell-line:before { content: \"\\eabc\"; }\n.ri-bike-fill:before { content: \"\\eabd\"; }\n.ri-bike-line:before { content: \"\\eabe\"; }\n.ri-bilibili-fill:before { content: \"\\eabf\"; }\n.ri-bilibili-line:before { content: \"\\eac0\"; }\n.ri-bill-fill:before { content: \"\\eac1\"; }\n.ri-bill-line:before { content: \"\\eac2\"; }\n.ri-billiards-fill:before { content: \"\\eac3\"; }\n.ri-billiards-line:before { content: \"\\eac4\"; }\n.ri-bit-coin-fill:before { content: \"\\eac5\"; }\n.ri-bit-coin-line:before { content: \"\\eac6\"; }\n.ri-blaze-fill:before { content: \"\\eac7\"; }\n.ri-blaze-line:before { content: \"\\eac8\"; }\n.ri-bluetooth-connect-fill:before { content: \"\\eac9\"; }\n.ri-bluetooth-connect-line:before { content: \"\\eaca\"; }\n.ri-bluetooth-fill:before { content: \"\\eacb\"; }\n.ri-bluetooth-line:before { content: \"\\eacc\"; }\n.ri-blur-off-fill:before { content: \"\\eacd\"; }\n.ri-blur-off-line:before { content: \"\\eace\"; }\n.ri-body-scan-fill:before { content: \"\\eacf\"; }\n.ri-body-scan-line:before { content: \"\\ead0\"; }\n.ri-bold:before { content: \"\\ead1\"; }\n.ri-book-2-fill:before { content: \"\\ead2\"; }\n.ri-book-2-line:before { content: \"\\ead3\"; }\n.ri-book-3-fill:before { content: \"\\ead4\"; }\n.ri-book-3-line:before { content: \"\\ead5\"; }\n.ri-book-fill:before { content: \"\\ead6\"; }\n.ri-book-line:before { content: \"\\ead7\"; }\n.ri-book-mark-fill:before { content: \"\\ead8\"; }\n.ri-book-mark-line:before { content: \"\\ead9\"; }\n.ri-book-open-fill:before { content: \"\\eada\"; }\n.ri-book-open-line:before { content: \"\\eadb\"; }\n.ri-book-read-fill:before { content: \"\\eadc\"; }\n.ri-book-read-line:before { content: \"\\eadd\"; }\n.ri-booklet-fill:before { content: \"\\eade\"; }\n.ri-booklet-line:before { content: \"\\eadf\"; }\n.ri-bookmark-2-fill:before { content: \"\\eae0\"; }\n.ri-bookmark-2-line:before { content: \"\\eae1\"; }\n.ri-bookmark-3-fill:before { content: \"\\eae2\"; }\n.ri-bookmark-3-line:before { content: \"\\eae3\"; }\n.ri-bookmark-fill:before { content: \"\\eae4\"; }\n.ri-bookmark-line:before { content: \"\\eae5\"; }\n.ri-boxing-fill:before { content: \"\\eae6\"; }\n.ri-boxing-line:before { content: \"\\eae7\"; }\n.ri-braces-fill:before { content: \"\\eae8\"; }\n.ri-braces-line:before { content: \"\\eae9\"; }\n.ri-brackets-fill:before { content: \"\\eaea\"; }\n.ri-brackets-line:before { content: \"\\eaeb\"; }\n.ri-briefcase-2-fill:before { content: \"\\eaec\"; }\n.ri-briefcase-2-line:before { content: \"\\eaed\"; }\n.ri-briefcase-3-fill:before { content: \"\\eaee\"; }\n.ri-briefcase-3-line:before { content: \"\\eaef\"; }\n.ri-briefcase-4-fill:before { content: \"\\eaf0\"; }\n.ri-briefcase-4-line:before { content: \"\\eaf1\"; }\n.ri-briefcase-5-fill:before { content: \"\\eaf2\"; }\n.ri-briefcase-5-line:before { content: \"\\eaf3\"; }\n.ri-briefcase-fill:before { content: \"\\eaf4\"; }\n.ri-briefcase-line:before { content: \"\\eaf5\"; }\n.ri-bring-forward:before { content: \"\\eaf6\"; }\n.ri-bring-to-front:before { content: \"\\eaf7\"; }\n.ri-broadcast-fill:before { content: \"\\eaf8\"; }\n.ri-broadcast-line:before { content: \"\\eaf9\"; }\n.ri-brush-2-fill:before { content: \"\\eafa\"; }\n.ri-brush-2-line:before { content: \"\\eafb\"; }\n.ri-brush-3-fill:before { content: \"\\eafc\"; }\n.ri-brush-3-line:before { content: \"\\eafd\"; }\n.ri-brush-4-fill:before { content: \"\\eafe\"; }\n.ri-brush-4-line:before { content: \"\\eaff\"; }\n.ri-brush-fill:before { content: \"\\eb00\"; }\n.ri-brush-line:before { content: \"\\eb01\"; }\n.ri-bubble-chart-fill:before { content: \"\\eb02\"; }\n.ri-bubble-chart-line:before { content: \"\\eb03\"; }\n.ri-bug-2-fill:before { content: \"\\eb04\"; }\n.ri-bug-2-line:before { content: \"\\eb05\"; }\n.ri-bug-fill:before { content: \"\\eb06\"; }\n.ri-bug-line:before { content: \"\\eb07\"; }\n.ri-building-2-fill:before { content: \"\\eb08\"; }\n.ri-building-2-line:before { content: \"\\eb09\"; }\n.ri-building-3-fill:before { content: \"\\eb0a\"; }\n.ri-building-3-line:before { content: \"\\eb0b\"; }\n.ri-building-4-fill:before { content: \"\\eb0c\"; }\n.ri-building-4-line:before { content: \"\\eb0d\"; }\n.ri-building-fill:before { content: \"\\eb0e\"; }\n.ri-building-line:before { content: \"\\eb0f\"; }\n.ri-bus-2-fill:before { content: \"\\eb10\"; }\n.ri-bus-2-line:before { content: \"\\eb11\"; }\n.ri-bus-fill:before { content: \"\\eb12\"; }\n.ri-bus-line:before { content: \"\\eb13\"; }\n.ri-bus-wifi-fill:before { content: \"\\eb14\"; }\n.ri-bus-wifi-line:before { content: \"\\eb15\"; }\n.ri-cactus-fill:before { content: \"\\eb16\"; }\n.ri-cactus-line:before { content: \"\\eb17\"; }\n.ri-cake-2-fill:before { content: \"\\eb18\"; }\n.ri-cake-2-line:before { content: \"\\eb19\"; }\n.ri-cake-3-fill:before { content: \"\\eb1a\"; }\n.ri-cake-3-line:before { content: \"\\eb1b\"; }\n.ri-cake-fill:before { content: \"\\eb1c\"; }\n.ri-cake-line:before { content: \"\\eb1d\"; }\n.ri-calculator-fill:before { content: \"\\eb1e\"; }\n.ri-calculator-line:before { content: \"\\eb1f\"; }\n.ri-calendar-2-fill:before { content: \"\\eb20\"; }\n.ri-calendar-2-line:before { content: \"\\eb21\"; }\n.ri-calendar-check-fill:before { content: \"\\eb22\"; }\n.ri-calendar-check-line:before { content: \"\\eb23\"; }\n.ri-calendar-event-fill:before { content: \"\\eb24\"; }\n.ri-calendar-event-line:before { content: \"\\eb25\"; }\n.ri-calendar-fill:before { content: \"\\eb26\"; }\n.ri-calendar-line:before { content: \"\\eb27\"; }\n.ri-calendar-todo-fill:before { content: \"\\eb28\"; }\n.ri-calendar-todo-line:before { content: \"\\eb29\"; }\n.ri-camera-2-fill:before { content: \"\\eb2a\"; }\n.ri-camera-2-line:before { content: \"\\eb2b\"; }\n.ri-camera-3-fill:before { content: \"\\eb2c\"; }\n.ri-camera-3-line:before { content: \"\\eb2d\"; }\n.ri-camera-fill:before { content: \"\\eb2e\"; }\n.ri-camera-lens-fill:before { content: \"\\eb2f\"; }\n.ri-camera-lens-line:before { content: \"\\eb30\"; }\n.ri-camera-line:before { content: \"\\eb31\"; }\n.ri-camera-off-fill:before { content: \"\\eb32\"; }\n.ri-camera-off-line:before { content: \"\\eb33\"; }\n.ri-camera-switch-fill:before { content: \"\\eb34\"; }\n.ri-camera-switch-line:before { content: \"\\eb35\"; }\n.ri-capsule-fill:before { content: \"\\eb36\"; }\n.ri-capsule-line:before { content: \"\\eb37\"; }\n.ri-car-fill:before { content: \"\\eb38\"; }\n.ri-car-line:before { content: \"\\eb39\"; }\n.ri-car-washing-fill:before { content: \"\\eb3a\"; }\n.ri-car-washing-line:before { content: \"\\eb3b\"; }\n.ri-caravan-fill:before { content: \"\\eb3c\"; }\n.ri-caravan-line:before { content: \"\\eb3d\"; }\n.ri-cast-fill:before { content: \"\\eb3e\"; }\n.ri-cast-line:before { content: \"\\eb3f\"; }\n.ri-cellphone-fill:before { content: \"\\eb40\"; }\n.ri-cellphone-line:before { content: \"\\eb41\"; }\n.ri-celsius-fill:before { content: \"\\eb42\"; }\n.ri-celsius-line:before { content: \"\\eb43\"; }\n.ri-centos-fill:before { content: \"\\eb44\"; }\n.ri-centos-line:before { content: \"\\eb45\"; }\n.ri-character-recognition-fill:before { content: \"\\eb46\"; }\n.ri-character-recognition-line:before { content: \"\\eb47\"; }\n.ri-charging-pile-2-fill:before { content: \"\\eb48\"; }\n.ri-charging-pile-2-line:before { content: \"\\eb49\"; }\n.ri-charging-pile-fill:before { content: \"\\eb4a\"; }\n.ri-charging-pile-line:before { content: \"\\eb4b\"; }\n.ri-chat-1-fill:before { content: \"\\eb4c\"; }\n.ri-chat-1-line:before { content: \"\\eb4d\"; }\n.ri-chat-2-fill:before { content: \"\\eb4e\"; }\n.ri-chat-2-line:before { content: \"\\eb4f\"; }\n.ri-chat-3-fill:before { content: \"\\eb50\"; }\n.ri-chat-3-line:before { content: \"\\eb51\"; }\n.ri-chat-4-fill:before { content: \"\\eb52\"; }\n.ri-chat-4-line:before { content: \"\\eb53\"; }\n.ri-chat-check-fill:before { content: \"\\eb54\"; }\n.ri-chat-check-line:before { content: \"\\eb55\"; }\n.ri-chat-delete-fill:before { content: \"\\eb56\"; }\n.ri-chat-delete-line:before { content: \"\\eb57\"; }\n.ri-chat-download-fill:before { content: \"\\eb58\"; }\n.ri-chat-download-line:before { content: \"\\eb59\"; }\n.ri-chat-follow-up-fill:before { content: \"\\eb5a\"; }\n.ri-chat-follow-up-line:before { content: \"\\eb5b\"; }\n.ri-chat-forward-fill:before { content: \"\\eb5c\"; }\n.ri-chat-forward-line:before { content: \"\\eb5d\"; }\n.ri-chat-heart-fill:before { content: \"\\eb5e\"; }\n.ri-chat-heart-line:before { content: \"\\eb5f\"; }\n.ri-chat-history-fill:before { content: \"\\eb60\"; }\n.ri-chat-history-line:before { content: \"\\eb61\"; }\n.ri-chat-new-fill:before { content: \"\\eb62\"; }\n.ri-chat-new-line:before { content: \"\\eb63\"; }\n.ri-chat-off-fill:before { content: \"\\eb64\"; }\n.ri-chat-off-line:before { content: \"\\eb65\"; }\n.ri-chat-poll-fill:before { content: \"\\eb66\"; }\n.ri-chat-poll-line:before { content: \"\\eb67\"; }\n.ri-chat-private-fill:before { content: \"\\eb68\"; }\n.ri-chat-private-line:before { content: \"\\eb69\"; }\n.ri-chat-quote-fill:before { content: \"\\eb6a\"; }\n.ri-chat-quote-line:before { content: \"\\eb6b\"; }\n.ri-chat-settings-fill:before { content: \"\\eb6c\"; }\n.ri-chat-settings-line:before { content: \"\\eb6d\"; }\n.ri-chat-smile-2-fill:before { content: \"\\eb6e\"; }\n.ri-chat-smile-2-line:before { content: \"\\eb6f\"; }\n.ri-chat-smile-3-fill:before { content: \"\\eb70\"; }\n.ri-chat-smile-3-line:before { content: \"\\eb71\"; }\n.ri-chat-smile-fill:before { content: \"\\eb72\"; }\n.ri-chat-smile-line:before { content: \"\\eb73\"; }\n.ri-chat-upload-fill:before { content: \"\\eb74\"; }\n.ri-chat-upload-line:before { content: \"\\eb75\"; }\n.ri-chat-voice-fill:before { content: \"\\eb76\"; }\n.ri-chat-voice-line:before { content: \"\\eb77\"; }\n.ri-check-double-fill:before { content: \"\\eb78\"; }\n.ri-check-double-line:before { content: \"\\eb79\"; }\n.ri-check-fill:before { content: \"\\eb7a\"; }\n.ri-check-line:before { content: \"\\eb7b\"; }\n.ri-checkbox-blank-circle-fill:before { content: \"\\eb7c\"; }\n.ri-checkbox-blank-circle-line:before { content: \"\\eb7d\"; }\n.ri-checkbox-blank-fill:before { content: \"\\eb7e\"; }\n.ri-checkbox-blank-line:before { content: \"\\eb7f\"; }\n.ri-checkbox-circle-fill:before { content: \"\\eb80\"; }\n.ri-checkbox-circle-line:before { content: \"\\eb81\"; }\n.ri-checkbox-fill:before { content: \"\\eb82\"; }\n.ri-checkbox-indeterminate-fill:before { content: \"\\eb83\"; }\n.ri-checkbox-indeterminate-line:before { content: \"\\eb84\"; }\n.ri-checkbox-line:before { content: \"\\eb85\"; }\n.ri-checkbox-multiple-blank-fill:before { content: \"\\eb86\"; }\n.ri-checkbox-multiple-blank-line:before { content: \"\\eb87\"; }\n.ri-checkbox-multiple-fill:before { content: \"\\eb88\"; }\n.ri-checkbox-multiple-line:before { content: \"\\eb89\"; }\n.ri-china-railway-fill:before { content: \"\\eb8a\"; }\n.ri-china-railway-line:before { content: \"\\eb8b\"; }\n.ri-chrome-fill:before { content: \"\\eb8c\"; }\n.ri-chrome-line:before { content: \"\\eb8d\"; }\n.ri-clapperboard-fill:before { content: \"\\eb8e\"; }\n.ri-clapperboard-line:before { content: \"\\eb8f\"; }\n.ri-clipboard-fill:before { content: \"\\eb90\"; }\n.ri-clipboard-line:before { content: \"\\eb91\"; }\n.ri-clockwise-2-fill:before { content: \"\\eb92\"; }\n.ri-clockwise-2-line:before { content: \"\\eb93\"; }\n.ri-clockwise-fill:before { content: \"\\eb94\"; }\n.ri-clockwise-line:before { content: \"\\eb95\"; }\n.ri-close-circle-fill:before { content: \"\\eb96\"; }\n.ri-close-circle-line:before { content: \"\\eb97\"; }\n.ri-close-fill:before { content: \"\\eb98\"; }\n.ri-close-line:before { content: \"\\eb99\"; }\n.ri-closed-captioning-fill:before { content: \"\\eb9a\"; }\n.ri-closed-captioning-line:before { content: \"\\eb9b\"; }\n.ri-cloud-fill:before { content: \"\\eb9c\"; }\n.ri-cloud-line:before { content: \"\\eb9d\"; }\n.ri-cloud-off-fill:before { content: \"\\eb9e\"; }\n.ri-cloud-off-line:before { content: \"\\eb9f\"; }\n.ri-cloud-windy-fill:before { content: \"\\eba0\"; }\n.ri-cloud-windy-line:before { content: \"\\eba1\"; }\n.ri-cloudy-2-fill:before { content: \"\\eba2\"; }\n.ri-cloudy-2-line:before { content: \"\\eba3\"; }\n.ri-cloudy-fill:before { content: \"\\eba4\"; }\n.ri-cloudy-line:before { content: \"\\eba5\"; }\n.ri-code-box-fill:before { content: \"\\eba6\"; }\n.ri-code-box-line:before { content: \"\\eba7\"; }\n.ri-code-fill:before { content: \"\\eba8\"; }\n.ri-code-line:before { content: \"\\eba9\"; }\n.ri-code-s-fill:before { content: \"\\ebaa\"; }\n.ri-code-s-line:before { content: \"\\ebab\"; }\n.ri-code-s-slash-fill:before { content: \"\\ebac\"; }\n.ri-code-s-slash-line:before { content: \"\\ebad\"; }\n.ri-code-view:before { content: \"\\ebae\"; }\n.ri-codepen-fill:before { content: \"\\ebaf\"; }\n.ri-codepen-line:before { content: \"\\ebb0\"; }\n.ri-coin-fill:before { content: \"\\ebb1\"; }\n.ri-coin-line:before { content: \"\\ebb2\"; }\n.ri-coins-fill:before { content: \"\\ebb3\"; }\n.ri-coins-line:before { content: \"\\ebb4\"; }\n.ri-collage-fill:before { content: \"\\ebb5\"; }\n.ri-collage-line:before { content: \"\\ebb6\"; }\n.ri-command-fill:before { content: \"\\ebb7\"; }\n.ri-command-line:before { content: \"\\ebb8\"; }\n.ri-community-fill:before { content: \"\\ebb9\"; }\n.ri-community-line:before { content: \"\\ebba\"; }\n.ri-compass-2-fill:before { content: \"\\ebbb\"; }\n.ri-compass-2-line:before { content: \"\\ebbc\"; }\n.ri-compass-3-fill:before { content: \"\\ebbd\"; }\n.ri-compass-3-line:before { content: \"\\ebbe\"; }\n.ri-compass-4-fill:before { content: \"\\ebbf\"; }\n.ri-compass-4-line:before { content: \"\\ebc0\"; }\n.ri-compass-discover-fill:before { content: \"\\ebc1\"; }\n.ri-compass-discover-line:before { content: \"\\ebc2\"; }\n.ri-compass-fill:before { content: \"\\ebc3\"; }\n.ri-compass-line:before { content: \"\\ebc4\"; }\n.ri-compasses-2-fill:before { content: \"\\ebc5\"; }\n.ri-compasses-2-line:before { content: \"\\ebc6\"; }\n.ri-compasses-fill:before { content: \"\\ebc7\"; }\n.ri-compasses-line:before { content: \"\\ebc8\"; }\n.ri-computer-fill:before { content: \"\\ebc9\"; }\n.ri-computer-line:before { content: \"\\ebca\"; }\n.ri-contacts-book-2-fill:before { content: \"\\ebcb\"; }\n.ri-contacts-book-2-line:before { content: \"\\ebcc\"; }\n.ri-contacts-book-fill:before { content: \"\\ebcd\"; }\n.ri-contacts-book-line:before { content: \"\\ebce\"; }\n.ri-contacts-book-upload-fill:before { content: \"\\ebcf\"; }\n.ri-contacts-book-upload-line:before { content: \"\\ebd0\"; }\n.ri-contacts-fill:before { content: \"\\ebd1\"; }\n.ri-contacts-line:before { content: \"\\ebd2\"; }\n.ri-contrast-2-fill:before { content: \"\\ebd3\"; }\n.ri-contrast-2-line:before { content: \"\\ebd4\"; }\n.ri-contrast-drop-2-fill:before { content: \"\\ebd5\"; }\n.ri-contrast-drop-2-line:before { content: \"\\ebd6\"; }\n.ri-contrast-drop-fill:before { content: \"\\ebd7\"; }\n.ri-contrast-drop-line:before { content: \"\\ebd8\"; }\n.ri-contrast-fill:before { content: \"\\ebd9\"; }\n.ri-contrast-line:before { content: \"\\ebda\"; }\n.ri-copper-coin-fill:before { content: \"\\ebdb\"; }\n.ri-copper-coin-line:before { content: \"\\ebdc\"; }\n.ri-copper-diamond-fill:before { content: \"\\ebdd\"; }\n.ri-copper-diamond-line:before { content: \"\\ebde\"; }\n.ri-copyleft-fill:before { content: \"\\ebdf\"; }\n.ri-copyleft-line:before { content: \"\\ebe0\"; }\n.ri-copyright-fill:before { content: \"\\ebe1\"; }\n.ri-copyright-line:before { content: \"\\ebe2\"; }\n.ri-coreos-fill:before { content: \"\\ebe3\"; }\n.ri-coreos-line:before { content: \"\\ebe4\"; }\n.ri-coupon-2-fill:before { content: \"\\ebe5\"; }\n.ri-coupon-2-line:before { content: \"\\ebe6\"; }\n.ri-coupon-3-fill:before { content: \"\\ebe7\"; }\n.ri-coupon-3-line:before { content: \"\\ebe8\"; }\n.ri-coupon-4-fill:before { content: \"\\ebe9\"; }\n.ri-coupon-4-line:before { content: \"\\ebea\"; }\n.ri-coupon-5-fill:before { content: \"\\ebeb\"; }\n.ri-coupon-5-line:before { content: \"\\ebec\"; }\n.ri-coupon-fill:before { content: \"\\ebed\"; }\n.ri-coupon-line:before { content: \"\\ebee\"; }\n.ri-cpu-fill:before { content: \"\\ebef\"; }\n.ri-cpu-line:before { content: \"\\ebf0\"; }\n.ri-creative-commons-by-fill:before { content: \"\\ebf1\"; }\n.ri-creative-commons-by-line:before { content: \"\\ebf2\"; }\n.ri-creative-commons-fill:before { content: \"\\ebf3\"; }\n.ri-creative-commons-line:before { content: \"\\ebf4\"; }\n.ri-creative-commons-nc-fill:before { content: \"\\ebf5\"; }\n.ri-creative-commons-nc-line:before { content: \"\\ebf6\"; }\n.ri-creative-commons-nd-fill:before { content: \"\\ebf7\"; }\n.ri-creative-commons-nd-line:before { content: \"\\ebf8\"; }\n.ri-creative-commons-sa-fill:before { content: \"\\ebf9\"; }\n.ri-creative-commons-sa-line:before { content: \"\\ebfa\"; }\n.ri-creative-commons-zero-fill:before { content: \"\\ebfb\"; }\n.ri-creative-commons-zero-line:before { content: \"\\ebfc\"; }\n.ri-criminal-fill:before { content: \"\\ebfd\"; }\n.ri-criminal-line:before { content: \"\\ebfe\"; }\n.ri-crop-2-fill:before { content: \"\\ebff\"; }\n.ri-crop-2-line:before { content: \"\\ec00\"; }\n.ri-crop-fill:before { content: \"\\ec01\"; }\n.ri-crop-line:before { content: \"\\ec02\"; }\n.ri-css3-fill:before { content: \"\\ec03\"; }\n.ri-css3-line:before { content: \"\\ec04\"; }\n.ri-cup-fill:before { content: \"\\ec05\"; }\n.ri-cup-line:before { content: \"\\ec06\"; }\n.ri-currency-fill:before { content: \"\\ec07\"; }\n.ri-currency-line:before { content: \"\\ec08\"; }\n.ri-cursor-fill:before { content: \"\\ec09\"; }\n.ri-cursor-line:before { content: \"\\ec0a\"; }\n.ri-customer-service-2-fill:before { content: \"\\ec0b\"; }\n.ri-customer-service-2-line:before { content: \"\\ec0c\"; }\n.ri-customer-service-fill:before { content: \"\\ec0d\"; }\n.ri-customer-service-line:before { content: \"\\ec0e\"; }\n.ri-dashboard-2-fill:before { content: \"\\ec0f\"; }\n.ri-dashboard-2-line:before { content: \"\\ec10\"; }\n.ri-dashboard-3-fill:before { content: \"\\ec11\"; }\n.ri-dashboard-3-line:before { content: \"\\ec12\"; }\n.ri-dashboard-fill:before { content: \"\\ec13\"; }\n.ri-dashboard-line:before { content: \"\\ec14\"; }\n.ri-database-2-fill:before { content: \"\\ec15\"; }\n.ri-database-2-line:before { content: \"\\ec16\"; }\n.ri-database-fill:before { content: \"\\ec17\"; }\n.ri-database-line:before { content: \"\\ec18\"; }\n.ri-delete-back-2-fill:before { content: \"\\ec19\"; }\n.ri-delete-back-2-line:before { content: \"\\ec1a\"; }\n.ri-delete-back-fill:before { content: \"\\ec1b\"; }\n.ri-delete-back-line:before { content: \"\\ec1c\"; }\n.ri-delete-bin-2-fill:before { content: \"\\ec1d\"; }\n.ri-delete-bin-2-line:before { content: \"\\ec1e\"; }\n.ri-delete-bin-3-fill:before { content: \"\\ec1f\"; }\n.ri-delete-bin-3-line:before { content: \"\\ec20\"; }\n.ri-delete-bin-4-fill:before { content: \"\\ec21\"; }\n.ri-delete-bin-4-line:before { content: \"\\ec22\"; }\n.ri-delete-bin-5-fill:before { content: \"\\ec23\"; }\n.ri-delete-bin-5-line:before { content: \"\\ec24\"; }\n.ri-delete-bin-6-fill:before { content: \"\\ec25\"; }\n.ri-delete-bin-6-line:before { content: \"\\ec26\"; }\n.ri-delete-bin-7-fill:before { content: \"\\ec27\"; }\n.ri-delete-bin-7-line:before { content: \"\\ec28\"; }\n.ri-delete-bin-fill:before { content: \"\\ec29\"; }\n.ri-delete-bin-line:before { content: \"\\ec2a\"; }\n.ri-delete-column:before { content: \"\\ec2b\"; }\n.ri-delete-row:before { content: \"\\ec2c\"; }\n.ri-device-fill:before { content: \"\\ec2d\"; }\n.ri-device-line:before { content: \"\\ec2e\"; }\n.ri-device-recover-fill:before { content: \"\\ec2f\"; }\n.ri-device-recover-line:before { content: \"\\ec30\"; }\n.ri-dingding-fill:before { content: \"\\ec31\"; }\n.ri-dingding-line:before { content: \"\\ec32\"; }\n.ri-direction-fill:before { content: \"\\ec33\"; }\n.ri-direction-line:before { content: \"\\ec34\"; }\n.ri-disc-fill:before { content: \"\\ec35\"; }\n.ri-disc-line:before { content: \"\\ec36\"; }\n.ri-discord-fill:before { content: \"\\ec37\"; }\n.ri-discord-line:before { content: \"\\ec38\"; }\n.ri-discuss-fill:before { content: \"\\ec39\"; }\n.ri-discuss-line:before { content: \"\\ec3a\"; }\n.ri-dislike-fill:before { content: \"\\ec3b\"; }\n.ri-dislike-line:before { content: \"\\ec3c\"; }\n.ri-disqus-fill:before { content: \"\\ec3d\"; }\n.ri-disqus-line:before { content: \"\\ec3e\"; }\n.ri-divide-fill:before { content: \"\\ec3f\"; }\n.ri-divide-line:before { content: \"\\ec40\"; }\n.ri-donut-chart-fill:before { content: \"\\ec41\"; }\n.ri-donut-chart-line:before { content: \"\\ec42\"; }\n.ri-door-closed-fill:before { content: \"\\ec43\"; }\n.ri-door-closed-line:before { content: \"\\ec44\"; }\n.ri-door-fill:before { content: \"\\ec45\"; }\n.ri-door-line:before { content: \"\\ec46\"; }\n.ri-door-lock-box-fill:before { content: \"\\ec47\"; }\n.ri-door-lock-box-line:before { content: \"\\ec48\"; }\n.ri-door-lock-fill:before { content: \"\\ec49\"; }\n.ri-door-lock-line:before { content: \"\\ec4a\"; }\n.ri-door-open-fill:before { content: \"\\ec4b\"; }\n.ri-door-open-line:before { content: \"\\ec4c\"; }\n.ri-dossier-fill:before { content: \"\\ec4d\"; }\n.ri-dossier-line:before { content: \"\\ec4e\"; }\n.ri-douban-fill:before { content: \"\\ec4f\"; }\n.ri-douban-line:before { content: \"\\ec50\"; }\n.ri-double-quotes-l:before { content: \"\\ec51\"; }\n.ri-double-quotes-r:before { content: \"\\ec52\"; }\n.ri-download-2-fill:before { content: \"\\ec53\"; }\n.ri-download-2-line:before { content: \"\\ec54\"; }\n.ri-download-cloud-2-fill:before { content: \"\\ec55\"; }\n.ri-download-cloud-2-line:before { content: \"\\ec56\"; }\n.ri-download-cloud-fill:before { content: \"\\ec57\"; }\n.ri-download-cloud-line:before { content: \"\\ec58\"; }\n.ri-download-fill:before { content: \"\\ec59\"; }\n.ri-download-line:before { content: \"\\ec5a\"; }\n.ri-draft-fill:before { content: \"\\ec5b\"; }\n.ri-draft-line:before { content: \"\\ec5c\"; }\n.ri-drag-drop-fill:before { content: \"\\ec5d\"; }\n.ri-drag-drop-line:before { content: \"\\ec5e\"; }\n.ri-drag-move-2-fill:before { content: \"\\ec5f\"; }\n.ri-drag-move-2-line:before { content: \"\\ec60\"; }\n.ri-drag-move-fill:before { content: \"\\ec61\"; }\n.ri-drag-move-line:before { content: \"\\ec62\"; }\n.ri-dribbble-fill:before { content: \"\\ec63\"; }\n.ri-dribbble-line:before { content: \"\\ec64\"; }\n.ri-drive-fill:before { content: \"\\ec65\"; }\n.ri-drive-line:before { content: \"\\ec66\"; }\n.ri-drizzle-fill:before { content: \"\\ec67\"; }\n.ri-drizzle-line:before { content: \"\\ec68\"; }\n.ri-drop-fill:before { content: \"\\ec69\"; }\n.ri-drop-line:before { content: \"\\ec6a\"; }\n.ri-dropbox-fill:before { content: \"\\ec6b\"; }\n.ri-dropbox-line:before { content: \"\\ec6c\"; }\n.ri-dual-sim-1-fill:before { content: \"\\ec6d\"; }\n.ri-dual-sim-1-line:before { content: \"\\ec6e\"; }\n.ri-dual-sim-2-fill:before { content: \"\\ec6f\"; }\n.ri-dual-sim-2-line:before { content: \"\\ec70\"; }\n.ri-dv-fill:before { content: \"\\ec71\"; }\n.ri-dv-line:before { content: \"\\ec72\"; }\n.ri-dvd-fill:before { content: \"\\ec73\"; }\n.ri-dvd-line:before { content: \"\\ec74\"; }\n.ri-e-bike-2-fill:before { content: \"\\ec75\"; }\n.ri-e-bike-2-line:before { content: \"\\ec76\"; }\n.ri-e-bike-fill:before { content: \"\\ec77\"; }\n.ri-e-bike-line:before { content: \"\\ec78\"; }\n.ri-earth-fill:before { content: \"\\ec79\"; }\n.ri-earth-line:before { content: \"\\ec7a\"; }\n.ri-earthquake-fill:before { content: \"\\ec7b\"; }\n.ri-earthquake-line:before { content: \"\\ec7c\"; }\n.ri-edge-fill:before { content: \"\\ec7d\"; }\n.ri-edge-line:before { content: \"\\ec7e\"; }\n.ri-edit-2-fill:before { content: \"\\ec7f\"; }\n.ri-edit-2-line:before { content: \"\\ec80\"; }\n.ri-edit-box-fill:before { content: \"\\ec81\"; }\n.ri-edit-box-line:before { content: \"\\ec82\"; }\n.ri-edit-circle-fill:before { content: \"\\ec83\"; }\n.ri-edit-circle-line:before { content: \"\\ec84\"; }\n.ri-edit-fill:before { content: \"\\ec85\"; }\n.ri-edit-line:before { content: \"\\ec86\"; }\n.ri-eject-fill:before { content: \"\\ec87\"; }\n.ri-eject-line:before { content: \"\\ec88\"; }\n.ri-emotion-2-fill:before { content: \"\\ec89\"; }\n.ri-emotion-2-line:before { content: \"\\ec8a\"; }\n.ri-emotion-fill:before { content: \"\\ec8b\"; }\n.ri-emotion-happy-fill:before { content: \"\\ec8c\"; }\n.ri-emotion-happy-line:before { content: \"\\ec8d\"; }\n.ri-emotion-laugh-fill:before { content: \"\\ec8e\"; }\n.ri-emotion-laugh-line:before { content: \"\\ec8f\"; }\n.ri-emotion-line:before { content: \"\\ec90\"; }\n.ri-emotion-normal-fill:before { content: \"\\ec91\"; }\n.ri-emotion-normal-line:before { content: \"\\ec92\"; }\n.ri-emotion-sad-fill:before { content: \"\\ec93\"; }\n.ri-emotion-sad-line:before { content: \"\\ec94\"; }\n.ri-emotion-unhappy-fill:before { content: \"\\ec95\"; }\n.ri-emotion-unhappy-line:before { content: \"\\ec96\"; }\n.ri-empathize-fill:before { content: \"\\ec97\"; }\n.ri-empathize-line:before { content: \"\\ec98\"; }\n.ri-emphasis-cn:before { content: \"\\ec99\"; }\n.ri-emphasis:before { content: \"\\ec9a\"; }\n.ri-english-input:before { content: \"\\ec9b\"; }\n.ri-equalizer-fill:before { content: \"\\ec9c\"; }\n.ri-equalizer-line:before { content: \"\\ec9d\"; }\n.ri-eraser-fill:before { content: \"\\ec9e\"; }\n.ri-eraser-line:before { content: \"\\ec9f\"; }\n.ri-error-warning-fill:before { content: \"\\eca0\"; }\n.ri-error-warning-line:before { content: \"\\eca1\"; }\n.ri-evernote-fill:before { content: \"\\eca2\"; }\n.ri-evernote-line:before { content: \"\\eca3\"; }\n.ri-exchange-box-fill:before { content: \"\\eca4\"; }\n.ri-exchange-box-line:before { content: \"\\eca5\"; }\n.ri-exchange-cny-fill:before { content: \"\\eca6\"; }\n.ri-exchange-cny-line:before { content: \"\\eca7\"; }\n.ri-exchange-dollar-fill:before { content: \"\\eca8\"; }\n.ri-exchange-dollar-line:before { content: \"\\eca9\"; }\n.ri-exchange-fill:before { content: \"\\ecaa\"; }\n.ri-exchange-funds-fill:before { content: \"\\ecab\"; }\n.ri-exchange-funds-line:before { content: \"\\ecac\"; }\n.ri-exchange-line:before { content: \"\\ecad\"; }\n.ri-external-link-fill:before { content: \"\\ecae\"; }\n.ri-external-link-line:before { content: \"\\ecaf\"; }\n.ri-eye-2-fill:before { content: \"\\ecb0\"; }\n.ri-eye-2-line:before { content: \"\\ecb1\"; }\n.ri-eye-close-fill:before { content: \"\\ecb2\"; }\n.ri-eye-close-line:before { content: \"\\ecb3\"; }\n.ri-eye-fill:before { content: \"\\ecb4\"; }\n.ri-eye-line:before { content: \"\\ecb5\"; }\n.ri-eye-off-fill:before { content: \"\\ecb6\"; }\n.ri-eye-off-line:before { content: \"\\ecb7\"; }\n.ri-facebook-box-fill:before { content: \"\\ecb8\"; }\n.ri-facebook-box-line:before { content: \"\\ecb9\"; }\n.ri-facebook-circle-fill:before { content: \"\\ecba\"; }\n.ri-facebook-circle-line:before { content: \"\\ecbb\"; }\n.ri-facebook-fill:before { content: \"\\ecbc\"; }\n.ri-facebook-line:before { content: \"\\ecbd\"; }\n.ri-fahrenheit-fill:before { content: \"\\ecbe\"; }\n.ri-fahrenheit-line:before { content: \"\\ecbf\"; }\n.ri-feedback-fill:before { content: \"\\ecc0\"; }\n.ri-feedback-line:before { content: \"\\ecc1\"; }\n.ri-file-2-fill:before { content: \"\\ecc2\"; }\n.ri-file-2-line:before { content: \"\\ecc3\"; }\n.ri-file-3-fill:before { content: \"\\ecc4\"; }\n.ri-file-3-line:before { content: \"\\ecc5\"; }\n.ri-file-4-fill:before { content: \"\\ecc6\"; }\n.ri-file-4-line:before { content: \"\\ecc7\"; }\n.ri-file-add-fill:before { content: \"\\ecc8\"; }\n.ri-file-add-line:before { content: \"\\ecc9\"; }\n.ri-file-chart-2-fill:before { content: \"\\ecca\"; }\n.ri-file-chart-2-line:before { content: \"\\eccb\"; }\n.ri-file-chart-fill:before { content: \"\\eccc\"; }\n.ri-file-chart-line:before { content: \"\\eccd\"; }\n.ri-file-cloud-fill:before { content: \"\\ecce\"; }\n.ri-file-cloud-line:before { content: \"\\eccf\"; }\n.ri-file-code-fill:before { content: \"\\ecd0\"; }\n.ri-file-code-line:before { content: \"\\ecd1\"; }\n.ri-file-copy-2-fill:before { content: \"\\ecd2\"; }\n.ri-file-copy-2-line:before { content: \"\\ecd3\"; }\n.ri-file-copy-fill:before { content: \"\\ecd4\"; }\n.ri-file-copy-line:before { content: \"\\ecd5\"; }\n.ri-file-damage-fill:before { content: \"\\ecd6\"; }\n.ri-file-damage-line:before { content: \"\\ecd7\"; }\n.ri-file-download-fill:before { content: \"\\ecd8\"; }\n.ri-file-download-line:before { content: \"\\ecd9\"; }\n.ri-file-edit-fill:before { content: \"\\ecda\"; }\n.ri-file-edit-line:before { content: \"\\ecdb\"; }\n.ri-file-excel-2-fill:before { content: \"\\ecdc\"; }\n.ri-file-excel-2-line:before { content: \"\\ecdd\"; }\n.ri-file-excel-fill:before { content: \"\\ecde\"; }\n.ri-file-excel-line:before { content: \"\\ecdf\"; }\n.ri-file-fill:before { content: \"\\ece0\"; }\n.ri-file-forbid-fill:before { content: \"\\ece1\"; }\n.ri-file-forbid-line:before { content: \"\\ece2\"; }\n.ri-file-gif-fill:before { content: \"\\ece3\"; }\n.ri-file-gif-line:before { content: \"\\ece4\"; }\n.ri-file-history-fill:before { content: \"\\ece5\"; }\n.ri-file-history-line:before { content: \"\\ece6\"; }\n.ri-file-hwp-fill:before { content: \"\\ece7\"; }\n.ri-file-hwp-line:before { content: \"\\ece8\"; }\n.ri-file-info-fill:before { content: \"\\ece9\"; }\n.ri-file-info-line:before { content: \"\\ecea\"; }\n.ri-file-line:before { content: \"\\eceb\"; }\n.ri-file-list-2-fill:before { content: \"\\ecec\"; }\n.ri-file-list-2-line:before { content: \"\\eced\"; }\n.ri-file-list-3-fill:before { content: \"\\ecee\"; }\n.ri-file-list-3-line:before { content: \"\\ecef\"; }\n.ri-file-list-fill:before { content: \"\\ecf0\"; }\n.ri-file-list-line:before { content: \"\\ecf1\"; }\n.ri-file-lock-fill:before { content: \"\\ecf2\"; }\n.ri-file-lock-line:before { content: \"\\ecf3\"; }\n.ri-file-mark-fill:before { content: \"\\ecf4\"; }\n.ri-file-mark-line:before { content: \"\\ecf5\"; }\n.ri-file-music-fill:before { content: \"\\ecf6\"; }\n.ri-file-music-line:before { content: \"\\ecf7\"; }\n.ri-file-paper-2-fill:before { content: \"\\ecf8\"; }\n.ri-file-paper-2-line:before { content: \"\\ecf9\"; }\n.ri-file-paper-fill:before { content: \"\\ecfa\"; }\n.ri-file-paper-line:before { content: \"\\ecfb\"; }\n.ri-file-pdf-fill:before { content: \"\\ecfc\"; }\n.ri-file-pdf-line:before { content: \"\\ecfd\"; }\n.ri-file-ppt-2-fill:before { content: \"\\ecfe\"; }\n.ri-file-ppt-2-line:before { content: \"\\ecff\"; }\n.ri-file-ppt-fill:before { content: \"\\ed00\"; }\n.ri-file-ppt-line:before { content: \"\\ed01\"; }\n.ri-file-reduce-fill:before { content: \"\\ed02\"; }\n.ri-file-reduce-line:before { content: \"\\ed03\"; }\n.ri-file-search-fill:before { content: \"\\ed04\"; }\n.ri-file-search-line:before { content: \"\\ed05\"; }\n.ri-file-settings-fill:before { content: \"\\ed06\"; }\n.ri-file-settings-line:before { content: \"\\ed07\"; }\n.ri-file-shield-2-fill:before { content: \"\\ed08\"; }\n.ri-file-shield-2-line:before { content: \"\\ed09\"; }\n.ri-file-shield-fill:before { content: \"\\ed0a\"; }\n.ri-file-shield-line:before { content: \"\\ed0b\"; }\n.ri-file-shred-fill:before { content: \"\\ed0c\"; }\n.ri-file-shred-line:before { content: \"\\ed0d\"; }\n.ri-file-text-fill:before { content: \"\\ed0e\"; }\n.ri-file-text-line:before { content: \"\\ed0f\"; }\n.ri-file-transfer-fill:before { content: \"\\ed10\"; }\n.ri-file-transfer-line:before { content: \"\\ed11\"; }\n.ri-file-unknow-fill:before { content: \"\\ed12\"; }\n.ri-file-unknow-line:before { content: \"\\ed13\"; }\n.ri-file-upload-fill:before { content: \"\\ed14\"; }\n.ri-file-upload-line:before { content: \"\\ed15\"; }\n.ri-file-user-fill:before { content: \"\\ed16\"; }\n.ri-file-user-line:before { content: \"\\ed17\"; }\n.ri-file-warning-fill:before { content: \"\\ed18\"; }\n.ri-file-warning-line:before { content: \"\\ed19\"; }\n.ri-file-word-2-fill:before { content: \"\\ed1a\"; }\n.ri-file-word-2-line:before { content: \"\\ed1b\"; }\n.ri-file-word-fill:before { content: \"\\ed1c\"; }\n.ri-file-word-line:before { content: \"\\ed1d\"; }\n.ri-file-zip-fill:before { content: \"\\ed1e\"; }\n.ri-file-zip-line:before { content: \"\\ed1f\"; }\n.ri-film-fill:before { content: \"\\ed20\"; }\n.ri-film-line:before { content: \"\\ed21\"; }\n.ri-filter-2-fill:before { content: \"\\ed22\"; }\n.ri-filter-2-line:before { content: \"\\ed23\"; }\n.ri-filter-3-fill:before { content: \"\\ed24\"; }\n.ri-filter-3-line:before { content: \"\\ed25\"; }\n.ri-filter-fill:before { content: \"\\ed26\"; }\n.ri-filter-line:before { content: \"\\ed27\"; }\n.ri-filter-off-fill:before { content: \"\\ed28\"; }\n.ri-filter-off-line:before { content: \"\\ed29\"; }\n.ri-find-replace-fill:before { content: \"\\ed2a\"; }\n.ri-find-replace-line:before { content: \"\\ed2b\"; }\n.ri-finder-fill:before { content: \"\\ed2c\"; }\n.ri-finder-line:before { content: \"\\ed2d\"; }\n.ri-fingerprint-2-fill:before { content: \"\\ed2e\"; }\n.ri-fingerprint-2-line:before { content: \"\\ed2f\"; }\n.ri-fingerprint-fill:before { content: \"\\ed30\"; }\n.ri-fingerprint-line:before { content: \"\\ed31\"; }\n.ri-fire-fill:before { content: \"\\ed32\"; }\n.ri-fire-line:before { content: \"\\ed33\"; }\n.ri-firefox-fill:before { content: \"\\ed34\"; }\n.ri-firefox-line:before { content: \"\\ed35\"; }\n.ri-first-aid-kit-fill:before { content: \"\\ed36\"; }\n.ri-first-aid-kit-line:before { content: \"\\ed37\"; }\n.ri-flag-2-fill:before { content: \"\\ed38\"; }\n.ri-flag-2-line:before { content: \"\\ed39\"; }\n.ri-flag-fill:before { content: \"\\ed3a\"; }\n.ri-flag-line:before { content: \"\\ed3b\"; }\n.ri-flashlight-fill:before { content: \"\\ed3c\"; }\n.ri-flashlight-line:before { content: \"\\ed3d\"; }\n.ri-flask-fill:before { content: \"\\ed3e\"; }\n.ri-flask-line:before { content: \"\\ed3f\"; }\n.ri-flight-land-fill:before { content: \"\\ed40\"; }\n.ri-flight-land-line:before { content: \"\\ed41\"; }\n.ri-flight-takeoff-fill:before { content: \"\\ed42\"; }\n.ri-flight-takeoff-line:before { content: \"\\ed43\"; }\n.ri-flood-fill:before { content: \"\\ed44\"; }\n.ri-flood-line:before { content: \"\\ed45\"; }\n.ri-flow-chart:before { content: \"\\ed46\"; }\n.ri-flutter-fill:before { content: \"\\ed47\"; }\n.ri-flutter-line:before { content: \"\\ed48\"; }\n.ri-focus-2-fill:before { content: \"\\ed49\"; }\n.ri-focus-2-line:before { content: \"\\ed4a\"; }\n.ri-focus-3-fill:before { content: \"\\ed4b\"; }\n.ri-focus-3-line:before { content: \"\\ed4c\"; }\n.ri-focus-fill:before { content: \"\\ed4d\"; }\n.ri-focus-line:before { content: \"\\ed4e\"; }\n.ri-foggy-fill:before { content: \"\\ed4f\"; }\n.ri-foggy-line:before { content: \"\\ed50\"; }\n.ri-folder-2-fill:before { content: \"\\ed51\"; }\n.ri-folder-2-line:before { content: \"\\ed52\"; }\n.ri-folder-3-fill:before { content: \"\\ed53\"; }\n.ri-folder-3-line:before { content: \"\\ed54\"; }\n.ri-folder-4-fill:before { content: \"\\ed55\"; }\n.ri-folder-4-line:before { content: \"\\ed56\"; }\n.ri-folder-5-fill:before { content: \"\\ed57\"; }\n.ri-folder-5-line:before { content: \"\\ed58\"; }\n.ri-folder-add-fill:before { content: \"\\ed59\"; }\n.ri-folder-add-line:before { content: \"\\ed5a\"; }\n.ri-folder-chart-2-fill:before { content: \"\\ed5b\"; }\n.ri-folder-chart-2-line:before { content: \"\\ed5c\"; }\n.ri-folder-chart-fill:before { content: \"\\ed5d\"; }\n.ri-folder-chart-line:before { content: \"\\ed5e\"; }\n.ri-folder-download-fill:before { content: \"\\ed5f\"; }\n.ri-folder-download-line:before { content: \"\\ed60\"; }\n.ri-folder-fill:before { content: \"\\ed61\"; }\n.ri-folder-forbid-fill:before { content: \"\\ed62\"; }\n.ri-folder-forbid-line:before { content: \"\\ed63\"; }\n.ri-folder-history-fill:before { content: \"\\ed64\"; }\n.ri-folder-history-line:before { content: \"\\ed65\"; }\n.ri-folder-info-fill:before { content: \"\\ed66\"; }\n.ri-folder-info-line:before { content: \"\\ed67\"; }\n.ri-folder-keyhole-fill:before { content: \"\\ed68\"; }\n.ri-folder-keyhole-line:before { content: \"\\ed69\"; }\n.ri-folder-line:before { content: \"\\ed6a\"; }\n.ri-folder-lock-fill:before { content: \"\\ed6b\"; }\n.ri-folder-lock-line:before { content: \"\\ed6c\"; }\n.ri-folder-music-fill:before { content: \"\\ed6d\"; }\n.ri-folder-music-line:before { content: \"\\ed6e\"; }\n.ri-folder-open-fill:before { content: \"\\ed6f\"; }\n.ri-folder-open-line:before { content: \"\\ed70\"; }\n.ri-folder-received-fill:before { content: \"\\ed71\"; }\n.ri-folder-received-line:before { content: \"\\ed72\"; }\n.ri-folder-reduce-fill:before { content: \"\\ed73\"; }\n.ri-folder-reduce-line:before { content: \"\\ed74\"; }\n.ri-folder-settings-fill:before { content: \"\\ed75\"; }\n.ri-folder-settings-line:before { content: \"\\ed76\"; }\n.ri-folder-shared-fill:before { content: \"\\ed77\"; }\n.ri-folder-shared-line:before { content: \"\\ed78\"; }\n.ri-folder-shield-2-fill:before { content: \"\\ed79\"; }\n.ri-folder-shield-2-line:before { content: \"\\ed7a\"; }\n.ri-folder-shield-fill:before { content: \"\\ed7b\"; }\n.ri-folder-shield-line:before { content: \"\\ed7c\"; }\n.ri-folder-transfer-fill:before { content: \"\\ed7d\"; }\n.ri-folder-transfer-line:before { content: \"\\ed7e\"; }\n.ri-folder-unknow-fill:before { content: \"\\ed7f\"; }\n.ri-folder-unknow-line:before { content: \"\\ed80\"; }\n.ri-folder-upload-fill:before { content: \"\\ed81\"; }\n.ri-folder-upload-line:before { content: \"\\ed82\"; }\n.ri-folder-user-fill:before { content: \"\\ed83\"; }\n.ri-folder-user-line:before { content: \"\\ed84\"; }\n.ri-folder-warning-fill:before { content: \"\\ed85\"; }\n.ri-folder-warning-line:before { content: \"\\ed86\"; }\n.ri-folder-zip-fill:before { content: \"\\ed87\"; }\n.ri-folder-zip-line:before { content: \"\\ed88\"; }\n.ri-folders-fill:before { content: \"\\ed89\"; }\n.ri-folders-line:before { content: \"\\ed8a\"; }\n.ri-font-color:before { content: \"\\ed8b\"; }\n.ri-font-size-2:before { content: \"\\ed8c\"; }\n.ri-font-size:before { content: \"\\ed8d\"; }\n.ri-football-fill:before { content: \"\\ed8e\"; }\n.ri-football-line:before { content: \"\\ed8f\"; }\n.ri-footprint-fill:before { content: \"\\ed90\"; }\n.ri-footprint-line:before { content: \"\\ed91\"; }\n.ri-forbid-2-fill:before { content: \"\\ed92\"; }\n.ri-forbid-2-line:before { content: \"\\ed93\"; }\n.ri-forbid-fill:before { content: \"\\ed94\"; }\n.ri-forbid-line:before { content: \"\\ed95\"; }\n.ri-format-clear:before { content: \"\\ed96\"; }\n.ri-fridge-fill:before { content: \"\\ed97\"; }\n.ri-fridge-line:before { content: \"\\ed98\"; }\n.ri-fullscreen-exit-fill:before { content: \"\\ed99\"; }\n.ri-fullscreen-exit-line:before { content: \"\\ed9a\"; }\n.ri-fullscreen-fill:before { content: \"\\ed9b\"; }\n.ri-fullscreen-line:before { content: \"\\ed9c\"; }\n.ri-function-fill:before { content: \"\\ed9d\"; }\n.ri-function-line:before { content: \"\\ed9e\"; }\n.ri-functions:before { content: \"\\ed9f\"; }\n.ri-funds-box-fill:before { content: \"\\eda0\"; }\n.ri-funds-box-line:before { content: \"\\eda1\"; }\n.ri-funds-fill:before { content: \"\\eda2\"; }\n.ri-funds-line:before { content: \"\\eda3\"; }\n.ri-gallery-fill:before { content: \"\\eda4\"; }\n.ri-gallery-line:before { content: \"\\eda5\"; }\n.ri-gallery-upload-fill:before { content: \"\\eda6\"; }\n.ri-gallery-upload-line:before { content: \"\\eda7\"; }\n.ri-game-fill:before { content: \"\\eda8\"; }\n.ri-game-line:before { content: \"\\eda9\"; }\n.ri-gamepad-fill:before { content: \"\\edaa\"; }\n.ri-gamepad-line:before { content: \"\\edab\"; }\n.ri-gas-station-fill:before { content: \"\\edac\"; }\n.ri-gas-station-line:before { content: \"\\edad\"; }\n.ri-gatsby-fill:before { content: \"\\edae\"; }\n.ri-gatsby-line:before { content: \"\\edaf\"; }\n.ri-genderless-fill:before { content: \"\\edb0\"; }\n.ri-genderless-line:before { content: \"\\edb1\"; }\n.ri-ghost-2-fill:before { content: \"\\edb2\"; }\n.ri-ghost-2-line:before { content: \"\\edb3\"; }\n.ri-ghost-fill:before { content: \"\\edb4\"; }\n.ri-ghost-line:before { content: \"\\edb5\"; }\n.ri-ghost-smile-fill:before { content: \"\\edb6\"; }\n.ri-ghost-smile-line:before { content: \"\\edb7\"; }\n.ri-gift-2-fill:before { content: \"\\edb8\"; }\n.ri-gift-2-line:before { content: \"\\edb9\"; }\n.ri-gift-fill:before { content: \"\\edba\"; }\n.ri-gift-line:before { content: \"\\edbb\"; }\n.ri-git-branch-fill:before { content: \"\\edbc\"; }\n.ri-git-branch-line:before { content: \"\\edbd\"; }\n.ri-git-commit-fill:before { content: \"\\edbe\"; }\n.ri-git-commit-line:before { content: \"\\edbf\"; }\n.ri-git-merge-fill:before { content: \"\\edc0\"; }\n.ri-git-merge-line:before { content: \"\\edc1\"; }\n.ri-git-pull-request-fill:before { content: \"\\edc2\"; }\n.ri-git-pull-request-line:before { content: \"\\edc3\"; }\n.ri-git-repository-commits-fill:before { content: \"\\edc4\"; }\n.ri-git-repository-commits-line:before { content: \"\\edc5\"; }\n.ri-git-repository-fill:before { content: \"\\edc6\"; }\n.ri-git-repository-line:before { content: \"\\edc7\"; }\n.ri-git-repository-private-fill:before { content: \"\\edc8\"; }\n.ri-git-repository-private-line:before { content: \"\\edc9\"; }\n.ri-github-fill:before { content: \"\\edca\"; }\n.ri-github-line:before { content: \"\\edcb\"; }\n.ri-gitlab-fill:before { content: \"\\edcc\"; }\n.ri-gitlab-line:before { content: \"\\edcd\"; }\n.ri-global-fill:before { content: \"\\edce\"; }\n.ri-global-line:before { content: \"\\edcf\"; }\n.ri-globe-fill:before { content: \"\\edd0\"; }\n.ri-globe-line:before { content: \"\\edd1\"; }\n.ri-goblet-fill:before { content: \"\\edd2\"; }\n.ri-goblet-line:before { content: \"\\edd3\"; }\n.ri-google-fill:before { content: \"\\edd4\"; }\n.ri-google-line:before { content: \"\\edd5\"; }\n.ri-google-play-fill:before { content: \"\\edd6\"; }\n.ri-google-play-line:before { content: \"\\edd7\"; }\n.ri-government-fill:before { content: \"\\edd8\"; }\n.ri-government-line:before { content: \"\\edd9\"; }\n.ri-gps-fill:before { content: \"\\edda\"; }\n.ri-gps-line:before { content: \"\\eddb\"; }\n.ri-gradienter-fill:before { content: \"\\eddc\"; }\n.ri-gradienter-line:before { content: \"\\eddd\"; }\n.ri-grid-fill:before { content: \"\\edde\"; }\n.ri-grid-line:before { content: \"\\eddf\"; }\n.ri-group-2-fill:before { content: \"\\ede0\"; }\n.ri-group-2-line:before { content: \"\\ede1\"; }\n.ri-group-fill:before { content: \"\\ede2\"; }\n.ri-group-line:before { content: \"\\ede3\"; }\n.ri-guide-fill:before { content: \"\\ede4\"; }\n.ri-guide-line:before { content: \"\\ede5\"; }\n.ri-h-1:before { content: \"\\ede6\"; }\n.ri-h-2:before { content: \"\\ede7\"; }\n.ri-h-3:before { content: \"\\ede8\"; }\n.ri-h-4:before { content: \"\\ede9\"; }\n.ri-h-5:before { content: \"\\edea\"; }\n.ri-h-6:before { content: \"\\edeb\"; }\n.ri-hail-fill:before { content: \"\\edec\"; }\n.ri-hail-line:before { content: \"\\eded\"; }\n.ri-hammer-fill:before { content: \"\\edee\"; }\n.ri-hammer-line:before { content: \"\\edef\"; }\n.ri-hand-coin-fill:before { content: \"\\edf0\"; }\n.ri-hand-coin-line:before { content: \"\\edf1\"; }\n.ri-hand-heart-fill:before { content: \"\\edf2\"; }\n.ri-hand-heart-line:before { content: \"\\edf3\"; }\n.ri-hand-sanitizer-fill:before { content: \"\\edf4\"; }\n.ri-hand-sanitizer-line:before { content: \"\\edf5\"; }\n.ri-handbag-fill:before { content: \"\\edf6\"; }\n.ri-handbag-line:before { content: \"\\edf7\"; }\n.ri-hard-drive-2-fill:before { content: \"\\edf8\"; }\n.ri-hard-drive-2-line:before { content: \"\\edf9\"; }\n.ri-hard-drive-fill:before { content: \"\\edfa\"; }\n.ri-hard-drive-line:before { content: \"\\edfb\"; }\n.ri-hashtag:before { content: \"\\edfc\"; }\n.ri-haze-2-fill:before { content: \"\\edfd\"; }\n.ri-haze-2-line:before { content: \"\\edfe\"; }\n.ri-haze-fill:before { content: \"\\edff\"; }\n.ri-haze-line:before { content: \"\\ee00\"; }\n.ri-hd-fill:before { content: \"\\ee01\"; }\n.ri-hd-line:before { content: \"\\ee02\"; }\n.ri-heading:before { content: \"\\ee03\"; }\n.ri-headphone-fill:before { content: \"\\ee04\"; }\n.ri-headphone-line:before { content: \"\\ee05\"; }\n.ri-health-book-fill:before { content: \"\\ee06\"; }\n.ri-health-book-line:before { content: \"\\ee07\"; }\n.ri-heart-2-fill:before { content: \"\\ee08\"; }\n.ri-heart-2-line:before { content: \"\\ee09\"; }\n.ri-heart-3-fill:before { content: \"\\ee0a\"; }\n.ri-heart-3-line:before { content: \"\\ee0b\"; }\n.ri-heart-add-fill:before { content: \"\\ee0c\"; }\n.ri-heart-add-line:before { content: \"\\ee0d\"; }\n.ri-heart-fill:before { content: \"\\ee0e\"; }\n.ri-heart-line:before { content: \"\\ee0f\"; }\n.ri-heart-pulse-fill:before { content: \"\\ee10\"; }\n.ri-heart-pulse-line:before { content: \"\\ee11\"; }\n.ri-hearts-fill:before { content: \"\\ee12\"; }\n.ri-hearts-line:before { content: \"\\ee13\"; }\n.ri-heavy-showers-fill:before { content: \"\\ee14\"; }\n.ri-heavy-showers-line:before { content: \"\\ee15\"; }\n.ri-history-fill:before { content: \"\\ee16\"; }\n.ri-history-line:before { content: \"\\ee17\"; }\n.ri-home-2-fill:before { content: \"\\ee18\"; }\n.ri-home-2-line:before { content: \"\\ee19\"; }\n.ri-home-3-fill:before { content: \"\\ee1a\"; }\n.ri-home-3-line:before { content: \"\\ee1b\"; }\n.ri-home-4-fill:before { content: \"\\ee1c\"; }\n.ri-home-4-line:before { content: \"\\ee1d\"; }\n.ri-home-5-fill:before { content: \"\\ee1e\"; }\n.ri-home-5-line:before { content: \"\\ee1f\"; }\n.ri-home-6-fill:before { content: \"\\ee20\"; }\n.ri-home-6-line:before { content: \"\\ee21\"; }\n.ri-home-7-fill:before { content: \"\\ee22\"; }\n.ri-home-7-line:before { content: \"\\ee23\"; }\n.ri-home-8-fill:before { content: \"\\ee24\"; }\n.ri-home-8-line:before { content: \"\\ee25\"; }\n.ri-home-fill:before { content: \"\\ee26\"; }\n.ri-home-gear-fill:before { content: \"\\ee27\"; }\n.ri-home-gear-line:before { content: \"\\ee28\"; }\n.ri-home-heart-fill:before { content: \"\\ee29\"; }\n.ri-home-heart-line:before { content: \"\\ee2a\"; }\n.ri-home-line:before { content: \"\\ee2b\"; }\n.ri-home-smile-2-fill:before { content: \"\\ee2c\"; }\n.ri-home-smile-2-line:before { content: \"\\ee2d\"; }\n.ri-home-smile-fill:before { content: \"\\ee2e\"; }\n.ri-home-smile-line:before { content: \"\\ee2f\"; }\n.ri-home-wifi-fill:before { content: \"\\ee30\"; }\n.ri-home-wifi-line:before { content: \"\\ee31\"; }\n.ri-honor-of-kings-fill:before { content: \"\\ee32\"; }\n.ri-honor-of-kings-line:before { content: \"\\ee33\"; }\n.ri-honour-fill:before { content: \"\\ee34\"; }\n.ri-honour-line:before { content: \"\\ee35\"; }\n.ri-hospital-fill:before { content: \"\\ee36\"; }\n.ri-hospital-line:before { content: \"\\ee37\"; }\n.ri-hotel-bed-fill:before { content: \"\\ee38\"; }\n.ri-hotel-bed-line:before { content: \"\\ee39\"; }\n.ri-hotel-fill:before { content: \"\\ee3a\"; }\n.ri-hotel-line:before { content: \"\\ee3b\"; }\n.ri-hotspot-fill:before { content: \"\\ee3c\"; }\n.ri-hotspot-line:before { content: \"\\ee3d\"; }\n.ri-hq-fill:before { content: \"\\ee3e\"; }\n.ri-hq-line:before { content: \"\\ee3f\"; }\n.ri-html5-fill:before { content: \"\\ee40\"; }\n.ri-html5-line:before { content: \"\\ee41\"; }\n.ri-ie-fill:before { content: \"\\ee42\"; }\n.ri-ie-line:before { content: \"\\ee43\"; }\n.ri-image-2-fill:before { content: \"\\ee44\"; }\n.ri-image-2-line:before { content: \"\\ee45\"; }\n.ri-image-add-fill:before { content: \"\\ee46\"; }\n.ri-image-add-line:before { content: \"\\ee47\"; }\n.ri-image-edit-fill:before { content: \"\\ee48\"; }\n.ri-image-edit-line:before { content: \"\\ee49\"; }\n.ri-image-fill:before { content: \"\\ee4a\"; }\n.ri-image-line:before { content: \"\\ee4b\"; }\n.ri-inbox-archive-fill:before { content: \"\\ee4c\"; }\n.ri-inbox-archive-line:before { content: \"\\ee4d\"; }\n.ri-inbox-fill:before { content: \"\\ee4e\"; }\n.ri-inbox-line:before { content: \"\\ee4f\"; }\n.ri-inbox-unarchive-fill:before { content: \"\\ee50\"; }\n.ri-inbox-unarchive-line:before { content: \"\\ee51\"; }\n.ri-increase-decrease-fill:before { content: \"\\ee52\"; }\n.ri-increase-decrease-line:before { content: \"\\ee53\"; }\n.ri-indent-decrease:before { content: \"\\ee54\"; }\n.ri-indent-increase:before { content: \"\\ee55\"; }\n.ri-indeterminate-circle-fill:before { content: \"\\ee56\"; }\n.ri-indeterminate-circle-line:before { content: \"\\ee57\"; }\n.ri-information-fill:before { content: \"\\ee58\"; }\n.ri-information-line:before { content: \"\\ee59\"; }\n.ri-infrared-thermometer-fill:before { content: \"\\ee5a\"; }\n.ri-infrared-thermometer-line:before { content: \"\\ee5b\"; }\n.ri-ink-bottle-fill:before { content: \"\\ee5c\"; }\n.ri-ink-bottle-line:before { content: \"\\ee5d\"; }\n.ri-input-cursor-move:before { content: \"\\ee5e\"; }\n.ri-input-method-fill:before { content: \"\\ee5f\"; }\n.ri-input-method-line:before { content: \"\\ee60\"; }\n.ri-insert-column-left:before { content: \"\\ee61\"; }\n.ri-insert-column-right:before { content: \"\\ee62\"; }\n.ri-insert-row-bottom:before { content: \"\\ee63\"; }\n.ri-insert-row-top:before { content: \"\\ee64\"; }\n.ri-instagram-fill:before { content: \"\\ee65\"; }\n.ri-instagram-line:before { content: \"\\ee66\"; }\n.ri-install-fill:before { content: \"\\ee67\"; }\n.ri-install-line:before { content: \"\\ee68\"; }\n.ri-invision-fill:before { content: \"\\ee69\"; }\n.ri-invision-line:before { content: \"\\ee6a\"; }\n.ri-italic:before { content: \"\\ee6b\"; }\n.ri-kakao-talk-fill:before { content: \"\\ee6c\"; }\n.ri-kakao-talk-line:before { content: \"\\ee6d\"; }\n.ri-key-2-fill:before { content: \"\\ee6e\"; }\n.ri-key-2-line:before { content: \"\\ee6f\"; }\n.ri-key-fill:before { content: \"\\ee70\"; }\n.ri-key-line:before { content: \"\\ee71\"; }\n.ri-keyboard-box-fill:before { content: \"\\ee72\"; }\n.ri-keyboard-box-line:before { content: \"\\ee73\"; }\n.ri-keyboard-fill:before { content: \"\\ee74\"; }\n.ri-keyboard-line:before { content: \"\\ee75\"; }\n.ri-keynote-fill:before { content: \"\\ee76\"; }\n.ri-keynote-line:before { content: \"\\ee77\"; }\n.ri-knife-blood-fill:before { content: \"\\ee78\"; }\n.ri-knife-blood-line:before { content: \"\\ee79\"; }\n.ri-knife-fill:before { content: \"\\ee7a\"; }\n.ri-knife-line:before { content: \"\\ee7b\"; }\n.ri-landscape-fill:before { content: \"\\ee7c\"; }\n.ri-landscape-line:before { content: \"\\ee7d\"; }\n.ri-layout-2-fill:before { content: \"\\ee7e\"; }\n.ri-layout-2-line:before { content: \"\\ee7f\"; }\n.ri-layout-3-fill:before { content: \"\\ee80\"; }\n.ri-layout-3-line:before { content: \"\\ee81\"; }\n.ri-layout-4-fill:before { content: \"\\ee82\"; }\n.ri-layout-4-line:before { content: \"\\ee83\"; }\n.ri-layout-5-fill:before { content: \"\\ee84\"; }\n.ri-layout-5-line:before { content: \"\\ee85\"; }\n.ri-layout-6-fill:before { content: \"\\ee86\"; }\n.ri-layout-6-line:before { content: \"\\ee87\"; }\n.ri-layout-bottom-2-fill:before { content: \"\\ee88\"; }\n.ri-layout-bottom-2-line:before { content: \"\\ee89\"; }\n.ri-layout-bottom-fill:before { content: \"\\ee8a\"; }\n.ri-layout-bottom-line:before { content: \"\\ee8b\"; }\n.ri-layout-column-fill:before { content: \"\\ee8c\"; }\n.ri-layout-column-line:before { content: \"\\ee8d\"; }\n.ri-layout-fill:before { content: \"\\ee8e\"; }\n.ri-layout-grid-fill:before { content: \"\\ee8f\"; }\n.ri-layout-grid-line:before { content: \"\\ee90\"; }\n.ri-layout-left-2-fill:before { content: \"\\ee91\"; }\n.ri-layout-left-2-line:before { content: \"\\ee92\"; }\n.ri-layout-left-fill:before { content: \"\\ee93\"; }\n.ri-layout-left-line:before { content: \"\\ee94\"; }\n.ri-layout-line:before { content: \"\\ee95\"; }\n.ri-layout-masonry-fill:before { content: \"\\ee96\"; }\n.ri-layout-masonry-line:before { content: \"\\ee97\"; }\n.ri-layout-right-2-fill:before { content: \"\\ee98\"; }\n.ri-layout-right-2-line:before { content: \"\\ee99\"; }\n.ri-layout-right-fill:before { content: \"\\ee9a\"; }\n.ri-layout-right-line:before { content: \"\\ee9b\"; }\n.ri-layout-row-fill:before { content: \"\\ee9c\"; }\n.ri-layout-row-line:before { content: \"\\ee9d\"; }\n.ri-layout-top-2-fill:before { content: \"\\ee9e\"; }\n.ri-layout-top-2-line:before { content: \"\\ee9f\"; }\n.ri-layout-top-fill:before { content: \"\\eea0\"; }\n.ri-layout-top-line:before { content: \"\\eea1\"; }\n.ri-leaf-fill:before { content: \"\\eea2\"; }\n.ri-leaf-line:before { content: \"\\eea3\"; }\n.ri-lifebuoy-fill:before { content: \"\\eea4\"; }\n.ri-lifebuoy-line:before { content: \"\\eea5\"; }\n.ri-lightbulb-fill:before { content: \"\\eea6\"; }\n.ri-lightbulb-flash-fill:before { content: \"\\eea7\"; }\n.ri-lightbulb-flash-line:before { content: \"\\eea8\"; }\n.ri-lightbulb-line:before { content: \"\\eea9\"; }\n.ri-line-chart-fill:before { content: \"\\eeaa\"; }\n.ri-line-chart-line:before { content: \"\\eeab\"; }\n.ri-line-fill:before { content: \"\\eeac\"; }\n.ri-line-height:before { content: \"\\eead\"; }\n.ri-line-line:before { content: \"\\eeae\"; }\n.ri-link-m:before { content: \"\\eeaf\"; }\n.ri-link-unlink-m:before { content: \"\\eeb0\"; }\n.ri-link-unlink:before { content: \"\\eeb1\"; }\n.ri-link:before { content: \"\\eeb2\"; }\n.ri-linkedin-box-fill:before { content: \"\\eeb3\"; }\n.ri-linkedin-box-line:before { content: \"\\eeb4\"; }\n.ri-linkedin-fill:before { content: \"\\eeb5\"; }\n.ri-linkedin-line:before { content: \"\\eeb6\"; }\n.ri-links-fill:before { content: \"\\eeb7\"; }\n.ri-links-line:before { content: \"\\eeb8\"; }\n.ri-list-check-2:before { content: \"\\eeb9\"; }\n.ri-list-check:before { content: \"\\eeba\"; }\n.ri-list-ordered:before { content: \"\\eebb\"; }\n.ri-list-settings-fill:before { content: \"\\eebc\"; }\n.ri-list-settings-line:before { content: \"\\eebd\"; }\n.ri-list-unordered:before { content: \"\\eebe\"; }\n.ri-live-fill:before { content: \"\\eebf\"; }\n.ri-live-line:before { content: \"\\eec0\"; }\n.ri-loader-2-fill:before { content: \"\\eec1\"; }\n.ri-loader-2-line:before { content: \"\\eec2\"; }\n.ri-loader-3-fill:before { content: \"\\eec3\"; }\n.ri-loader-3-line:before { content: \"\\eec4\"; }\n.ri-loader-4-fill:before { content: \"\\eec5\"; }\n.ri-loader-4-line:before { content: \"\\eec6\"; }\n.ri-loader-5-fill:before { content: \"\\eec7\"; }\n.ri-loader-5-line:before { content: \"\\eec8\"; }\n.ri-loader-fill:before { content: \"\\eec9\"; }\n.ri-loader-line:before { content: \"\\eeca\"; }\n.ri-lock-2-fill:before { content: \"\\eecb\"; }\n.ri-lock-2-line:before { content: \"\\eecc\"; }\n.ri-lock-fill:before { content: \"\\eecd\"; }\n.ri-lock-line:before { content: \"\\eece\"; }\n.ri-lock-password-fill:before { content: \"\\eecf\"; }\n.ri-lock-password-line:before { content: \"\\eed0\"; }\n.ri-lock-unlock-fill:before { content: \"\\eed1\"; }\n.ri-lock-unlock-line:before { content: \"\\eed2\"; }\n.ri-login-box-fill:before { content: \"\\eed3\"; }\n.ri-login-box-line:before { content: \"\\eed4\"; }\n.ri-login-circle-fill:before { content: \"\\eed5\"; }\n.ri-login-circle-line:before { content: \"\\eed6\"; }\n.ri-logout-box-fill:before { content: \"\\eed7\"; }\n.ri-logout-box-line:before { content: \"\\eed8\"; }\n.ri-logout-box-r-fill:before { content: \"\\eed9\"; }\n.ri-logout-box-r-line:before { content: \"\\eeda\"; }\n.ri-logout-circle-fill:before { content: \"\\eedb\"; }\n.ri-logout-circle-line:before { content: \"\\eedc\"; }\n.ri-logout-circle-r-fill:before { content: \"\\eedd\"; }\n.ri-logout-circle-r-line:before { content: \"\\eede\"; }\n.ri-luggage-cart-fill:before { content: \"\\eedf\"; }\n.ri-luggage-cart-line:before { content: \"\\eee0\"; }\n.ri-luggage-deposit-fill:before { content: \"\\eee1\"; }\n.ri-luggage-deposit-line:before { content: \"\\eee2\"; }\n.ri-lungs-fill:before { content: \"\\eee3\"; }\n.ri-lungs-line:before { content: \"\\eee4\"; }\n.ri-mac-fill:before { content: \"\\eee5\"; }\n.ri-mac-line:before { content: \"\\eee6\"; }\n.ri-macbook-fill:before { content: \"\\eee7\"; }\n.ri-macbook-line:before { content: \"\\eee8\"; }\n.ri-magic-fill:before { content: \"\\eee9\"; }\n.ri-magic-line:before { content: \"\\eeea\"; }\n.ri-mail-add-fill:before { content: \"\\eeeb\"; }\n.ri-mail-add-line:before { content: \"\\eeec\"; }\n.ri-mail-check-fill:before { content: \"\\eeed\"; }\n.ri-mail-check-line:before { content: \"\\eeee\"; }\n.ri-mail-close-fill:before { content: \"\\eeef\"; }\n.ri-mail-close-line:before { content: \"\\eef0\"; }\n.ri-mail-download-fill:before { content: \"\\eef1\"; }\n.ri-mail-download-line:before { content: \"\\eef2\"; }\n.ri-mail-fill:before { content: \"\\eef3\"; }\n.ri-mail-forbid-fill:before { content: \"\\eef4\"; }\n.ri-mail-forbid-line:before { content: \"\\eef5\"; }\n.ri-mail-line:before { content: \"\\eef6\"; }\n.ri-mail-lock-fill:before { content: \"\\eef7\"; }\n.ri-mail-lock-line:before { content: \"\\eef8\"; }\n.ri-mail-open-fill:before { content: \"\\eef9\"; }\n.ri-mail-open-line:before { content: \"\\eefa\"; }\n.ri-mail-send-fill:before { content: \"\\eefb\"; }\n.ri-mail-send-line:before { content: \"\\eefc\"; }\n.ri-mail-settings-fill:before { content: \"\\eefd\"; }\n.ri-mail-settings-line:before { content: \"\\eefe\"; }\n.ri-mail-star-fill:before { content: \"\\eeff\"; }\n.ri-mail-star-line:before { content: \"\\ef00\"; }\n.ri-mail-unread-fill:before { content: \"\\ef01\"; }\n.ri-mail-unread-line:before { content: \"\\ef02\"; }\n.ri-mail-volume-fill:before { content: \"\\ef03\"; }\n.ri-mail-volume-line:before { content: \"\\ef04\"; }\n.ri-map-2-fill:before { content: \"\\ef05\"; }\n.ri-map-2-line:before { content: \"\\ef06\"; }\n.ri-map-fill:before { content: \"\\ef07\"; }\n.ri-map-line:before { content: \"\\ef08\"; }\n.ri-map-pin-2-fill:before { content: \"\\ef09\"; }\n.ri-map-pin-2-line:before { content: \"\\ef0a\"; }\n.ri-map-pin-3-fill:before { content: \"\\ef0b\"; }\n.ri-map-pin-3-line:before { content: \"\\ef0c\"; }\n.ri-map-pin-4-fill:before { content: \"\\ef0d\"; }\n.ri-map-pin-4-line:before { content: \"\\ef0e\"; }\n.ri-map-pin-5-fill:before { content: \"\\ef0f\"; }\n.ri-map-pin-5-line:before { content: \"\\ef10\"; }\n.ri-map-pin-add-fill:before { content: \"\\ef11\"; }\n.ri-map-pin-add-line:before { content: \"\\ef12\"; }\n.ri-map-pin-fill:before { content: \"\\ef13\"; }\n.ri-map-pin-line:before { content: \"\\ef14\"; }\n.ri-map-pin-range-fill:before { content: \"\\ef15\"; }\n.ri-map-pin-range-line:before { content: \"\\ef16\"; }\n.ri-map-pin-time-fill:before { content: \"\\ef17\"; }\n.ri-map-pin-time-line:before { content: \"\\ef18\"; }\n.ri-map-pin-user-fill:before { content: \"\\ef19\"; }\n.ri-map-pin-user-line:before { content: \"\\ef1a\"; }\n.ri-mark-pen-fill:before { content: \"\\ef1b\"; }\n.ri-mark-pen-line:before { content: \"\\ef1c\"; }\n.ri-markdown-fill:before { content: \"\\ef1d\"; }\n.ri-markdown-line:before { content: \"\\ef1e\"; }\n.ri-markup-fill:before { content: \"\\ef1f\"; }\n.ri-markup-line:before { content: \"\\ef20\"; }\n.ri-mastercard-fill:before { content: \"\\ef21\"; }\n.ri-mastercard-line:before { content: \"\\ef22\"; }\n.ri-mastodon-fill:before { content: \"\\ef23\"; }\n.ri-mastodon-line:before { content: \"\\ef24\"; }\n.ri-medal-2-fill:before { content: \"\\ef25\"; }\n.ri-medal-2-line:before { content: \"\\ef26\"; }\n.ri-medal-fill:before { content: \"\\ef27\"; }\n.ri-medal-line:before { content: \"\\ef28\"; }\n.ri-medicine-bottle-fill:before { content: \"\\ef29\"; }\n.ri-medicine-bottle-line:before { content: \"\\ef2a\"; }\n.ri-medium-fill:before { content: \"\\ef2b\"; }\n.ri-medium-line:before { content: \"\\ef2c\"; }\n.ri-men-fill:before { content: \"\\ef2d\"; }\n.ri-men-line:before { content: \"\\ef2e\"; }\n.ri-mental-health-fill:before { content: \"\\ef2f\"; }\n.ri-mental-health-line:before { content: \"\\ef30\"; }\n.ri-menu-2-fill:before { content: \"\\ef31\"; }\n.ri-menu-2-line:before { content: \"\\ef32\"; }\n.ri-menu-3-fill:before { content: \"\\ef33\"; }\n.ri-menu-3-line:before { content: \"\\ef34\"; }\n.ri-menu-4-fill:before { content: \"\\ef35\"; }\n.ri-menu-4-line:before { content: \"\\ef36\"; }\n.ri-menu-5-fill:before { content: \"\\ef37\"; }\n.ri-menu-5-line:before { content: \"\\ef38\"; }\n.ri-menu-add-fill:before { content: \"\\ef39\"; }\n.ri-menu-add-line:before { content: \"\\ef3a\"; }\n.ri-menu-fill:before { content: \"\\ef3b\"; }\n.ri-menu-fold-fill:before { content: \"\\ef3c\"; }\n.ri-menu-fold-line:before { content: \"\\ef3d\"; }\n.ri-menu-line:before { content: \"\\ef3e\"; }\n.ri-menu-unfold-fill:before { content: \"\\ef3f\"; }\n.ri-menu-unfold-line:before { content: \"\\ef40\"; }\n.ri-merge-cells-horizontal:before { content: \"\\ef41\"; }\n.ri-merge-cells-vertical:before { content: \"\\ef42\"; }\n.ri-message-2-fill:before { content: \"\\ef43\"; }\n.ri-message-2-line:before { content: \"\\ef44\"; }\n.ri-message-3-fill:before { content: \"\\ef45\"; }\n.ri-message-3-line:before { content: \"\\ef46\"; }\n.ri-message-fill:before { content: \"\\ef47\"; }\n.ri-message-line:before { content: \"\\ef48\"; }\n.ri-messenger-fill:before { content: \"\\ef49\"; }\n.ri-messenger-line:before { content: \"\\ef4a\"; }\n.ri-meteor-fill:before { content: \"\\ef4b\"; }\n.ri-meteor-line:before { content: \"\\ef4c\"; }\n.ri-mic-2-fill:before { content: \"\\ef4d\"; }\n.ri-mic-2-line:before { content: \"\\ef4e\"; }\n.ri-mic-fill:before { content: \"\\ef4f\"; }\n.ri-mic-line:before { content: \"\\ef50\"; }\n.ri-mic-off-fill:before { content: \"\\ef51\"; }\n.ri-mic-off-line:before { content: \"\\ef52\"; }\n.ri-mickey-fill:before { content: \"\\ef53\"; }\n.ri-mickey-line:before { content: \"\\ef54\"; }\n.ri-microscope-fill:before { content: \"\\ef55\"; }\n.ri-microscope-line:before { content: \"\\ef56\"; }\n.ri-microsoft-fill:before { content: \"\\ef57\"; }\n.ri-microsoft-line:before { content: \"\\ef58\"; }\n.ri-mind-map:before { content: \"\\ef59\"; }\n.ri-mini-program-fill:before { content: \"\\ef5a\"; }\n.ri-mini-program-line:before { content: \"\\ef5b\"; }\n.ri-mist-fill:before { content: \"\\ef5c\"; }\n.ri-mist-line:before { content: \"\\ef5d\"; }\n.ri-money-cny-box-fill:before { content: \"\\ef5e\"; }\n.ri-money-cny-box-line:before { content: \"\\ef5f\"; }\n.ri-money-cny-circle-fill:before { content: \"\\ef60\"; }\n.ri-money-cny-circle-line:before { content: \"\\ef61\"; }\n.ri-money-dollar-box-fill:before { content: \"\\ef62\"; }\n.ri-money-dollar-box-line:before { content: \"\\ef63\"; }\n.ri-money-dollar-circle-fill:before { content: \"\\ef64\"; }\n.ri-money-dollar-circle-line:before { content: \"\\ef65\"; }\n.ri-money-euro-box-fill:before { content: \"\\ef66\"; }\n.ri-money-euro-box-line:before { content: \"\\ef67\"; }\n.ri-money-euro-circle-fill:before { content: \"\\ef68\"; }\n.ri-money-euro-circle-line:before { content: \"\\ef69\"; }\n.ri-money-pound-box-fill:before { content: \"\\ef6a\"; }\n.ri-money-pound-box-line:before { content: \"\\ef6b\"; }\n.ri-money-pound-circle-fill:before { content: \"\\ef6c\"; }\n.ri-money-pound-circle-line:before { content: \"\\ef6d\"; }\n.ri-moon-clear-fill:before { content: \"\\ef6e\"; }\n.ri-moon-clear-line:before { content: \"\\ef6f\"; }\n.ri-moon-cloudy-fill:before { content: \"\\ef70\"; }\n.ri-moon-cloudy-line:before { content: \"\\ef71\"; }\n.ri-moon-fill:before { content: \"\\ef72\"; }\n.ri-moon-foggy-fill:before { content: \"\\ef73\"; }\n.ri-moon-foggy-line:before { content: \"\\ef74\"; }\n.ri-moon-line:before { content: \"\\ef75\"; }\n.ri-more-2-fill:before { content: \"\\ef76\"; }\n.ri-more-2-line:before { content: \"\\ef77\"; }\n.ri-more-fill:before { content: \"\\ef78\"; }\n.ri-more-line:before { content: \"\\ef79\"; }\n.ri-motorbike-fill:before { content: \"\\ef7a\"; }\n.ri-motorbike-line:before { content: \"\\ef7b\"; }\n.ri-mouse-fill:before { content: \"\\ef7c\"; }\n.ri-mouse-line:before { content: \"\\ef7d\"; }\n.ri-movie-2-fill:before { content: \"\\ef7e\"; }\n.ri-movie-2-line:before { content: \"\\ef7f\"; }\n.ri-movie-fill:before { content: \"\\ef80\"; }\n.ri-movie-line:before { content: \"\\ef81\"; }\n.ri-music-2-fill:before { content: \"\\ef82\"; }\n.ri-music-2-line:before { content: \"\\ef83\"; }\n.ri-music-fill:before { content: \"\\ef84\"; }\n.ri-music-line:before { content: \"\\ef85\"; }\n.ri-mv-fill:before { content: \"\\ef86\"; }\n.ri-mv-line:before { content: \"\\ef87\"; }\n.ri-navigation-fill:before { content: \"\\ef88\"; }\n.ri-navigation-line:before { content: \"\\ef89\"; }\n.ri-netease-cloud-music-fill:before { content: \"\\ef8a\"; }\n.ri-netease-cloud-music-line:before { content: \"\\ef8b\"; }\n.ri-netflix-fill:before { content: \"\\ef8c\"; }\n.ri-netflix-line:before { content: \"\\ef8d\"; }\n.ri-newspaper-fill:before { content: \"\\ef8e\"; }\n.ri-newspaper-line:before { content: \"\\ef8f\"; }\n.ri-node-tree:before { content: \"\\ef90\"; }\n.ri-notification-2-fill:before { content: \"\\ef91\"; }\n.ri-notification-2-line:before { content: \"\\ef92\"; }\n.ri-notification-3-fill:before { content: \"\\ef93\"; }\n.ri-notification-3-line:before { content: \"\\ef94\"; }\n.ri-notification-4-fill:before { content: \"\\ef95\"; }\n.ri-notification-4-line:before { content: \"\\ef96\"; }\n.ri-notification-badge-fill:before { content: \"\\ef97\"; }\n.ri-notification-badge-line:before { content: \"\\ef98\"; }\n.ri-notification-fill:before { content: \"\\ef99\"; }\n.ri-notification-line:before { content: \"\\ef9a\"; }\n.ri-notification-off-fill:before { content: \"\\ef9b\"; }\n.ri-notification-off-line:before { content: \"\\ef9c\"; }\n.ri-npmjs-fill:before { content: \"\\ef9d\"; }\n.ri-npmjs-line:before { content: \"\\ef9e\"; }\n.ri-number-0:before { content: \"\\ef9f\"; }\n.ri-number-1:before { content: \"\\efa0\"; }\n.ri-number-2:before { content: \"\\efa1\"; }\n.ri-number-3:before { content: \"\\efa2\"; }\n.ri-number-4:before { content: \"\\efa3\"; }\n.ri-number-5:before { content: \"\\efa4\"; }\n.ri-number-6:before { content: \"\\efa5\"; }\n.ri-number-7:before { content: \"\\efa6\"; }\n.ri-number-8:before { content: \"\\efa7\"; }\n.ri-number-9:before { content: \"\\efa8\"; }\n.ri-numbers-fill:before { content: \"\\efa9\"; }\n.ri-numbers-line:before { content: \"\\efaa\"; }\n.ri-nurse-fill:before { content: \"\\efab\"; }\n.ri-nurse-line:before { content: \"\\efac\"; }\n.ri-oil-fill:before { content: \"\\efad\"; }\n.ri-oil-line:before { content: \"\\efae\"; }\n.ri-omega:before { content: \"\\efaf\"; }\n.ri-open-arm-fill:before { content: \"\\efb0\"; }\n.ri-open-arm-line:before { content: \"\\efb1\"; }\n.ri-open-source-fill:before { content: \"\\efb2\"; }\n.ri-open-source-line:before { content: \"\\efb3\"; }\n.ri-opera-fill:before { content: \"\\efb4\"; }\n.ri-opera-line:before { content: \"\\efb5\"; }\n.ri-order-play-fill:before { content: \"\\efb6\"; }\n.ri-order-play-line:before { content: \"\\efb7\"; }\n.ri-organization-chart:before { content: \"\\efb8\"; }\n.ri-outlet-2-fill:before { content: \"\\efb9\"; }\n.ri-outlet-2-line:before { content: \"\\efba\"; }\n.ri-outlet-fill:before { content: \"\\efbb\"; }\n.ri-outlet-line:before { content: \"\\efbc\"; }\n.ri-page-separator:before { content: \"\\efbd\"; }\n.ri-pages-fill:before { content: \"\\efbe\"; }\n.ri-pages-line:before { content: \"\\efbf\"; }\n.ri-paint-brush-fill:before { content: \"\\efc0\"; }\n.ri-paint-brush-line:before { content: \"\\efc1\"; }\n.ri-paint-fill:before { content: \"\\efc2\"; }\n.ri-paint-line:before { content: \"\\efc3\"; }\n.ri-palette-fill:before { content: \"\\efc4\"; }\n.ri-palette-line:before { content: \"\\efc5\"; }\n.ri-pantone-fill:before { content: \"\\efc6\"; }\n.ri-pantone-line:before { content: \"\\efc7\"; }\n.ri-paragraph:before { content: \"\\efc8\"; }\n.ri-parent-fill:before { content: \"\\efc9\"; }\n.ri-parent-line:before { content: \"\\efca\"; }\n.ri-parentheses-fill:before { content: \"\\efcb\"; }\n.ri-parentheses-line:before { content: \"\\efcc\"; }\n.ri-parking-box-fill:before { content: \"\\efcd\"; }\n.ri-parking-box-line:before { content: \"\\efce\"; }\n.ri-parking-fill:before { content: \"\\efcf\"; }\n.ri-parking-line:before { content: \"\\efd0\"; }\n.ri-passport-fill:before { content: \"\\efd1\"; }\n.ri-passport-line:before { content: \"\\efd2\"; }\n.ri-patreon-fill:before { content: \"\\efd3\"; }\n.ri-patreon-line:before { content: \"\\efd4\"; }\n.ri-pause-circle-fill:before { content: \"\\efd5\"; }\n.ri-pause-circle-line:before { content: \"\\efd6\"; }\n.ri-pause-fill:before { content: \"\\efd7\"; }\n.ri-pause-line:before { content: \"\\efd8\"; }\n.ri-pause-mini-fill:before { content: \"\\efd9\"; }\n.ri-pause-mini-line:before { content: \"\\efda\"; }\n.ri-paypal-fill:before { content: \"\\efdb\"; }\n.ri-paypal-line:before { content: \"\\efdc\"; }\n.ri-pen-nib-fill:before { content: \"\\efdd\"; }\n.ri-pen-nib-line:before { content: \"\\efde\"; }\n.ri-pencil-fill:before { content: \"\\efdf\"; }\n.ri-pencil-line:before { content: \"\\efe0\"; }\n.ri-pencil-ruler-2-fill:before { content: \"\\efe1\"; }\n.ri-pencil-ruler-2-line:before { content: \"\\efe2\"; }\n.ri-pencil-ruler-fill:before { content: \"\\efe3\"; }\n.ri-pencil-ruler-line:before { content: \"\\efe4\"; }\n.ri-percent-fill:before { content: \"\\efe5\"; }\n.ri-percent-line:before { content: \"\\efe6\"; }\n.ri-phone-camera-fill:before { content: \"\\efe7\"; }\n.ri-phone-camera-line:before { content: \"\\efe8\"; }\n.ri-phone-fill:before { content: \"\\efe9\"; }\n.ri-phone-find-fill:before { content: \"\\efea\"; }\n.ri-phone-find-line:before { content: \"\\efeb\"; }\n.ri-phone-line:before { content: \"\\efec\"; }\n.ri-phone-lock-fill:before { content: \"\\efed\"; }\n.ri-phone-lock-line:before { content: \"\\efee\"; }\n.ri-picture-in-picture-2-fill:before { content: \"\\efef\"; }\n.ri-picture-in-picture-2-line:before { content: \"\\eff0\"; }\n.ri-picture-in-picture-exit-fill:before { content: \"\\eff1\"; }\n.ri-picture-in-picture-exit-line:before { content: \"\\eff2\"; }\n.ri-picture-in-picture-fill:before { content: \"\\eff3\"; }\n.ri-picture-in-picture-line:before { content: \"\\eff4\"; }\n.ri-pie-chart-2-fill:before { content: \"\\eff5\"; }\n.ri-pie-chart-2-line:before { content: \"\\eff6\"; }\n.ri-pie-chart-box-fill:before { content: \"\\eff7\"; }\n.ri-pie-chart-box-line:before { content: \"\\eff8\"; }\n.ri-pie-chart-fill:before { content: \"\\eff9\"; }\n.ri-pie-chart-line:before { content: \"\\effa\"; }\n.ri-pin-distance-fill:before { content: \"\\effb\"; }\n.ri-pin-distance-line:before { content: \"\\effc\"; }\n.ri-ping-pong-fill:before { content: \"\\effd\"; }\n.ri-ping-pong-line:before { content: \"\\effe\"; }\n.ri-pinterest-fill:before { content: \"\\efff\"; }\n.ri-pinterest-line:before { content: \"\\f000\"; }\n.ri-pinyin-input:before { content: \"\\f001\"; }\n.ri-pixelfed-fill:before { content: \"\\f002\"; }\n.ri-pixelfed-line:before { content: \"\\f003\"; }\n.ri-plane-fill:before { content: \"\\f004\"; }\n.ri-plane-line:before { content: \"\\f005\"; }\n.ri-plant-fill:before { content: \"\\f006\"; }\n.ri-plant-line:before { content: \"\\f007\"; }\n.ri-play-circle-fill:before { content: \"\\f008\"; }\n.ri-play-circle-line:before { content: \"\\f009\"; }\n.ri-play-fill:before { content: \"\\f00a\"; }\n.ri-play-line:before { content: \"\\f00b\"; }\n.ri-play-list-2-fill:before { content: \"\\f00c\"; }\n.ri-play-list-2-line:before { content: \"\\f00d\"; }\n.ri-play-list-add-fill:before { content: \"\\f00e\"; }\n.ri-play-list-add-line:before { content: \"\\f00f\"; }\n.ri-play-list-fill:before { content: \"\\f010\"; }\n.ri-play-list-line:before { content: \"\\f011\"; }\n.ri-play-mini-fill:before { content: \"\\f012\"; }\n.ri-play-mini-line:before { content: \"\\f013\"; }\n.ri-playstation-fill:before { content: \"\\f014\"; }\n.ri-playstation-line:before { content: \"\\f015\"; }\n.ri-plug-2-fill:before { content: \"\\f016\"; }\n.ri-plug-2-line:before { content: \"\\f017\"; }\n.ri-plug-fill:before { content: \"\\f018\"; }\n.ri-plug-line:before { content: \"\\f019\"; }\n.ri-polaroid-2-fill:before { content: \"\\f01a\"; }\n.ri-polaroid-2-line:before { content: \"\\f01b\"; }\n.ri-polaroid-fill:before { content: \"\\f01c\"; }\n.ri-polaroid-line:before { content: \"\\f01d\"; }\n.ri-police-car-fill:before { content: \"\\f01e\"; }\n.ri-police-car-line:before { content: \"\\f01f\"; }\n.ri-price-tag-2-fill:before { content: \"\\f020\"; }\n.ri-price-tag-2-line:before { content: \"\\f021\"; }\n.ri-price-tag-3-fill:before { content: \"\\f022\"; }\n.ri-price-tag-3-line:before { content: \"\\f023\"; }\n.ri-price-tag-fill:before { content: \"\\f024\"; }\n.ri-price-tag-line:before { content: \"\\f025\"; }\n.ri-printer-cloud-fill:before { content: \"\\f026\"; }\n.ri-printer-cloud-line:before { content: \"\\f027\"; }\n.ri-printer-fill:before { content: \"\\f028\"; }\n.ri-printer-line:before { content: \"\\f029\"; }\n.ri-product-hunt-fill:before { content: \"\\f02a\"; }\n.ri-product-hunt-line:before { content: \"\\f02b\"; }\n.ri-profile-fill:before { content: \"\\f02c\"; }\n.ri-profile-line:before { content: \"\\f02d\"; }\n.ri-projector-2-fill:before { content: \"\\f02e\"; }\n.ri-projector-2-line:before { content: \"\\f02f\"; }\n.ri-projector-fill:before { content: \"\\f030\"; }\n.ri-projector-line:before { content: \"\\f031\"; }\n.ri-psychotherapy-fill:before { content: \"\\f032\"; }\n.ri-psychotherapy-line:before { content: \"\\f033\"; }\n.ri-pulse-fill:before { content: \"\\f034\"; }\n.ri-pulse-line:before { content: \"\\f035\"; }\n.ri-pushpin-2-fill:before { content: \"\\f036\"; }\n.ri-pushpin-2-line:before { content: \"\\f037\"; }\n.ri-pushpin-fill:before { content: \"\\f038\"; }\n.ri-pushpin-line:before { content: \"\\f039\"; }\n.ri-qq-fill:before { content: \"\\f03a\"; }\n.ri-qq-line:before { content: \"\\f03b\"; }\n.ri-qr-code-fill:before { content: \"\\f03c\"; }\n.ri-qr-code-line:before { content: \"\\f03d\"; }\n.ri-qr-scan-2-fill:before { content: \"\\f03e\"; }\n.ri-qr-scan-2-line:before { content: \"\\f03f\"; }\n.ri-qr-scan-fill:before { content: \"\\f040\"; }\n.ri-qr-scan-line:before { content: \"\\f041\"; }\n.ri-question-answer-fill:before { content: \"\\f042\"; }\n.ri-question-answer-line:before { content: \"\\f043\"; }\n.ri-question-fill:before { content: \"\\f044\"; }\n.ri-question-line:before { content: \"\\f045\"; }\n.ri-question-mark:before { content: \"\\f046\"; }\n.ri-questionnaire-fill:before { content: \"\\f047\"; }\n.ri-questionnaire-line:before { content: \"\\f048\"; }\n.ri-quill-pen-fill:before { content: \"\\f049\"; }\n.ri-quill-pen-line:before { content: \"\\f04a\"; }\n.ri-radar-fill:before { content: \"\\f04b\"; }\n.ri-radar-line:before { content: \"\\f04c\"; }\n.ri-radio-2-fill:before { content: \"\\f04d\"; }\n.ri-radio-2-line:before { content: \"\\f04e\"; }\n.ri-radio-button-fill:before { content: \"\\f04f\"; }\n.ri-radio-button-line:before { content: \"\\f050\"; }\n.ri-radio-fill:before { content: \"\\f051\"; }\n.ri-radio-line:before { content: \"\\f052\"; }\n.ri-rainbow-fill:before { content: \"\\f053\"; }\n.ri-rainbow-line:before { content: \"\\f054\"; }\n.ri-rainy-fill:before { content: \"\\f055\"; }\n.ri-rainy-line:before { content: \"\\f056\"; }\n.ri-reactjs-fill:before { content: \"\\f057\"; }\n.ri-reactjs-line:before { content: \"\\f058\"; }\n.ri-record-circle-fill:before { content: \"\\f059\"; }\n.ri-record-circle-line:before { content: \"\\f05a\"; }\n.ri-record-mail-fill:before { content: \"\\f05b\"; }\n.ri-record-mail-line:before { content: \"\\f05c\"; }\n.ri-recycle-fill:before { content: \"\\f05d\"; }\n.ri-recycle-line:before { content: \"\\f05e\"; }\n.ri-red-packet-fill:before { content: \"\\f05f\"; }\n.ri-red-packet-line:before { content: \"\\f060\"; }\n.ri-reddit-fill:before { content: \"\\f061\"; }\n.ri-reddit-line:before { content: \"\\f062\"; }\n.ri-refresh-fill:before { content: \"\\f063\"; }\n.ri-refresh-line:before { content: \"\\f064\"; }\n.ri-refund-2-fill:before { content: \"\\f065\"; }\n.ri-refund-2-line:before { content: \"\\f066\"; }\n.ri-refund-fill:before { content: \"\\f067\"; }\n.ri-refund-line:before { content: \"\\f068\"; }\n.ri-registered-fill:before { content: \"\\f069\"; }\n.ri-registered-line:before { content: \"\\f06a\"; }\n.ri-remixicon-fill:before { content: \"\\f06b\"; }\n.ri-remixicon-line:before { content: \"\\f06c\"; }\n.ri-remote-control-2-fill:before { content: \"\\f06d\"; }\n.ri-remote-control-2-line:before { content: \"\\f06e\"; }\n.ri-remote-control-fill:before { content: \"\\f06f\"; }\n.ri-remote-control-line:before { content: \"\\f070\"; }\n.ri-repeat-2-fill:before { content: \"\\f071\"; }\n.ri-repeat-2-line:before { content: \"\\f072\"; }\n.ri-repeat-fill:before { content: \"\\f073\"; }\n.ri-repeat-line:before { content: \"\\f074\"; }\n.ri-repeat-one-fill:before { content: \"\\f075\"; }\n.ri-repeat-one-line:before { content: \"\\f076\"; }\n.ri-reply-all-fill:before { content: \"\\f077\"; }\n.ri-reply-all-line:before { content: \"\\f078\"; }\n.ri-reply-fill:before { content: \"\\f079\"; }\n.ri-reply-line:before { content: \"\\f07a\"; }\n.ri-reserved-fill:before { content: \"\\f07b\"; }\n.ri-reserved-line:before { content: \"\\f07c\"; }\n.ri-rest-time-fill:before { content: \"\\f07d\"; }\n.ri-rest-time-line:before { content: \"\\f07e\"; }\n.ri-restart-fill:before { content: \"\\f07f\"; }\n.ri-restart-line:before { content: \"\\f080\"; }\n.ri-restaurant-2-fill:before { content: \"\\f081\"; }\n.ri-restaurant-2-line:before { content: \"\\f082\"; }\n.ri-restaurant-fill:before { content: \"\\f083\"; }\n.ri-restaurant-line:before { content: \"\\f084\"; }\n.ri-rewind-fill:before { content: \"\\f085\"; }\n.ri-rewind-line:before { content: \"\\f086\"; }\n.ri-rewind-mini-fill:before { content: \"\\f087\"; }\n.ri-rewind-mini-line:before { content: \"\\f088\"; }\n.ri-rhythm-fill:before { content: \"\\f089\"; }\n.ri-rhythm-line:before { content: \"\\f08a\"; }\n.ri-riding-fill:before { content: \"\\f08b\"; }\n.ri-riding-line:before { content: \"\\f08c\"; }\n.ri-road-map-fill:before { content: \"\\f08d\"; }\n.ri-road-map-line:before { content: \"\\f08e\"; }\n.ri-roadster-fill:before { content: \"\\f08f\"; }\n.ri-roadster-line:before { content: \"\\f090\"; }\n.ri-robot-fill:before { content: \"\\f091\"; }\n.ri-robot-line:before { content: \"\\f092\"; }\n.ri-rocket-2-fill:before { content: \"\\f093\"; }\n.ri-rocket-2-line:before { content: \"\\f094\"; }\n.ri-rocket-fill:before { content: \"\\f095\"; }\n.ri-rocket-line:before { content: \"\\f096\"; }\n.ri-rotate-lock-fill:before { content: \"\\f097\"; }\n.ri-rotate-lock-line:before { content: \"\\f098\"; }\n.ri-rounded-corner:before { content: \"\\f099\"; }\n.ri-route-fill:before { content: \"\\f09a\"; }\n.ri-route-line:before { content: \"\\f09b\"; }\n.ri-router-fill:before { content: \"\\f09c\"; }\n.ri-router-line:before { content: \"\\f09d\"; }\n.ri-rss-fill:before { content: \"\\f09e\"; }\n.ri-rss-line:before { content: \"\\f09f\"; }\n.ri-ruler-2-fill:before { content: \"\\f0a0\"; }\n.ri-ruler-2-line:before { content: \"\\f0a1\"; }\n.ri-ruler-fill:before { content: \"\\f0a2\"; }\n.ri-ruler-line:before { content: \"\\f0a3\"; }\n.ri-run-fill:before { content: \"\\f0a4\"; }\n.ri-run-line:before { content: \"\\f0a5\"; }\n.ri-safari-fill:before { content: \"\\f0a6\"; }\n.ri-safari-line:before { content: \"\\f0a7\"; }\n.ri-safe-2-fill:before { content: \"\\f0a8\"; }\n.ri-safe-2-line:before { content: \"\\f0a9\"; }\n.ri-safe-fill:before { content: \"\\f0aa\"; }\n.ri-safe-line:before { content: \"\\f0ab\"; }\n.ri-sailboat-fill:before { content: \"\\f0ac\"; }\n.ri-sailboat-line:before { content: \"\\f0ad\"; }\n.ri-save-2-fill:before { content: \"\\f0ae\"; }\n.ri-save-2-line:before { content: \"\\f0af\"; }\n.ri-save-3-fill:before { content: \"\\f0b0\"; }\n.ri-save-3-line:before { content: \"\\f0b1\"; }\n.ri-save-fill:before { content: \"\\f0b2\"; }\n.ri-save-line:before { content: \"\\f0b3\"; }\n.ri-scales-2-fill:before { content: \"\\f0b4\"; }\n.ri-scales-2-line:before { content: \"\\f0b5\"; }\n.ri-scales-3-fill:before { content: \"\\f0b6\"; }\n.ri-scales-3-line:before { content: \"\\f0b7\"; }\n.ri-scales-fill:before { content: \"\\f0b8\"; }\n.ri-scales-line:before { content: \"\\f0b9\"; }\n.ri-scan-2-fill:before { content: \"\\f0ba\"; }\n.ri-scan-2-line:before { content: \"\\f0bb\"; }\n.ri-scan-fill:before { content: \"\\f0bc\"; }\n.ri-scan-line:before { content: \"\\f0bd\"; }\n.ri-scissors-2-fill:before { content: \"\\f0be\"; }\n.ri-scissors-2-line:before { content: \"\\f0bf\"; }\n.ri-scissors-cut-fill:before { content: \"\\f0c0\"; }\n.ri-scissors-cut-line:before { content: \"\\f0c1\"; }\n.ri-scissors-fill:before { content: \"\\f0c2\"; }\n.ri-scissors-line:before { content: \"\\f0c3\"; }\n.ri-screenshot-2-fill:before { content: \"\\f0c4\"; }\n.ri-screenshot-2-line:before { content: \"\\f0c5\"; }\n.ri-screenshot-fill:before { content: \"\\f0c6\"; }\n.ri-screenshot-line:before { content: \"\\f0c7\"; }\n.ri-sd-card-fill:before { content: \"\\f0c8\"; }\n.ri-sd-card-line:before { content: \"\\f0c9\"; }\n.ri-sd-card-mini-fill:before { content: \"\\f0ca\"; }\n.ri-sd-card-mini-line:before { content: \"\\f0cb\"; }\n.ri-search-2-fill:before { content: \"\\f0cc\"; }\n.ri-search-2-line:before { content: \"\\f0cd\"; }\n.ri-search-eye-fill:before { content: \"\\f0ce\"; }\n.ri-search-eye-line:before { content: \"\\f0cf\"; }\n.ri-search-fill:before { content: \"\\f0d0\"; }\n.ri-search-line:before { content: \"\\f0d1\"; }\n.ri-secure-payment-fill:before { content: \"\\f0d2\"; }\n.ri-secure-payment-line:before { content: \"\\f0d3\"; }\n.ri-seedling-fill:before { content: \"\\f0d4\"; }\n.ri-seedling-line:before { content: \"\\f0d5\"; }\n.ri-send-backward:before { content: \"\\f0d6\"; }\n.ri-send-plane-2-fill:before { content: \"\\f0d7\"; }\n.ri-send-plane-2-line:before { content: \"\\f0d8\"; }\n.ri-send-plane-fill:before { content: \"\\f0d9\"; }\n.ri-send-plane-line:before { content: \"\\f0da\"; }\n.ri-send-to-back:before { content: \"\\f0db\"; }\n.ri-sensor-fill:before { content: \"\\f0dc\"; }\n.ri-sensor-line:before { content: \"\\f0dd\"; }\n.ri-separator:before { content: \"\\f0de\"; }\n.ri-server-fill:before { content: \"\\f0df\"; }\n.ri-server-line:before { content: \"\\f0e0\"; }\n.ri-service-fill:before { content: \"\\f0e1\"; }\n.ri-service-line:before { content: \"\\f0e2\"; }\n.ri-settings-2-fill:before { content: \"\\f0e3\"; }\n.ri-settings-2-line:before { content: \"\\f0e4\"; }\n.ri-settings-3-fill:before { content: \"\\f0e5\"; }\n.ri-settings-3-line:before { content: \"\\f0e6\"; }\n.ri-settings-4-fill:before { content: \"\\f0e7\"; }\n.ri-settings-4-line:before { content: \"\\f0e8\"; }\n.ri-settings-5-fill:before { content: \"\\f0e9\"; }\n.ri-settings-5-line:before { content: \"\\f0ea\"; }\n.ri-settings-6-fill:before { content: \"\\f0eb\"; }\n.ri-settings-6-line:before { content: \"\\f0ec\"; }\n.ri-settings-fill:before { content: \"\\f0ed\"; }\n.ri-settings-line:before { content: \"\\f0ee\"; }\n.ri-shape-2-fill:before { content: \"\\f0ef\"; }\n.ri-shape-2-line:before { content: \"\\f0f0\"; }\n.ri-shape-fill:before { content: \"\\f0f1\"; }\n.ri-shape-line:before { content: \"\\f0f2\"; }\n.ri-share-box-fill:before { content: \"\\f0f3\"; }\n.ri-share-box-line:before { content: \"\\f0f4\"; }\n.ri-share-circle-fill:before { content: \"\\f0f5\"; }\n.ri-share-circle-line:before { content: \"\\f0f6\"; }\n.ri-share-fill:before { content: \"\\f0f7\"; }\n.ri-share-forward-2-fill:before { content: \"\\f0f8\"; }\n.ri-share-forward-2-line:before { content: \"\\f0f9\"; }\n.ri-share-forward-box-fill:before { content: \"\\f0fa\"; }\n.ri-share-forward-box-line:before { content: \"\\f0fb\"; }\n.ri-share-forward-fill:before { content: \"\\f0fc\"; }\n.ri-share-forward-line:before { content: \"\\f0fd\"; }\n.ri-share-line:before { content: \"\\f0fe\"; }\n.ri-shield-check-fill:before { content: \"\\f0ff\"; }\n.ri-shield-check-line:before { content: \"\\f100\"; }\n.ri-shield-cross-fill:before { content: \"\\f101\"; }\n.ri-shield-cross-line:before { content: \"\\f102\"; }\n.ri-shield-fill:before { content: \"\\f103\"; }\n.ri-shield-flash-fill:before { content: \"\\f104\"; }\n.ri-shield-flash-line:before { content: \"\\f105\"; }\n.ri-shield-keyhole-fill:before { content: \"\\f106\"; }\n.ri-shield-keyhole-line:before { content: \"\\f107\"; }\n.ri-shield-line:before { content: \"\\f108\"; }\n.ri-shield-star-fill:before { content: \"\\f109\"; }\n.ri-shield-star-line:before { content: \"\\f10a\"; }\n.ri-shield-user-fill:before { content: \"\\f10b\"; }\n.ri-shield-user-line:before { content: \"\\f10c\"; }\n.ri-ship-2-fill:before { content: \"\\f10d\"; }\n.ri-ship-2-line:before { content: \"\\f10e\"; }\n.ri-ship-fill:before { content: \"\\f10f\"; }\n.ri-ship-line:before { content: \"\\f110\"; }\n.ri-shirt-fill:before { content: \"\\f111\"; }\n.ri-shirt-line:before { content: \"\\f112\"; }\n.ri-shopping-bag-2-fill:before { content: \"\\f113\"; }\n.ri-shopping-bag-2-line:before { content: \"\\f114\"; }\n.ri-shopping-bag-3-fill:before { content: \"\\f115\"; }\n.ri-shopping-bag-3-line:before { content: \"\\f116\"; }\n.ri-shopping-bag-fill:before { content: \"\\f117\"; }\n.ri-shopping-bag-line:before { content: \"\\f118\"; }\n.ri-shopping-basket-2-fill:before { content: \"\\f119\"; }\n.ri-shopping-basket-2-line:before { content: \"\\f11a\"; }\n.ri-shopping-basket-fill:before { content: \"\\f11b\"; }\n.ri-shopping-basket-line:before { content: \"\\f11c\"; }\n.ri-shopping-cart-2-fill:before { content: \"\\f11d\"; }\n.ri-shopping-cart-2-line:before { content: \"\\f11e\"; }\n.ri-shopping-cart-fill:before { content: \"\\f11f\"; }\n.ri-shopping-cart-line:before { content: \"\\f120\"; }\n.ri-showers-fill:before { content: \"\\f121\"; }\n.ri-showers-line:before { content: \"\\f122\"; }\n.ri-shuffle-fill:before { content: \"\\f123\"; }\n.ri-shuffle-line:before { content: \"\\f124\"; }\n.ri-shut-down-fill:before { content: \"\\f125\"; }\n.ri-shut-down-line:before { content: \"\\f126\"; }\n.ri-side-bar-fill:before { content: \"\\f127\"; }\n.ri-side-bar-line:before { content: \"\\f128\"; }\n.ri-signal-tower-fill:before { content: \"\\f129\"; }\n.ri-signal-tower-line:before { content: \"\\f12a\"; }\n.ri-signal-wifi-1-fill:before { content: \"\\f12b\"; }\n.ri-signal-wifi-1-line:before { content: \"\\f12c\"; }\n.ri-signal-wifi-2-fill:before { content: \"\\f12d\"; }\n.ri-signal-wifi-2-line:before { content: \"\\f12e\"; }\n.ri-signal-wifi-3-fill:before { content: \"\\f12f\"; }\n.ri-signal-wifi-3-line:before { content: \"\\f130\"; }\n.ri-signal-wifi-error-fill:before { content: \"\\f131\"; }\n.ri-signal-wifi-error-line:before { content: \"\\f132\"; }\n.ri-signal-wifi-fill:before { content: \"\\f133\"; }\n.ri-signal-wifi-line:before { content: \"\\f134\"; }\n.ri-signal-wifi-off-fill:before { content: \"\\f135\"; }\n.ri-signal-wifi-off-line:before { content: \"\\f136\"; }\n.ri-sim-card-2-fill:before { content: \"\\f137\"; }\n.ri-sim-card-2-line:before { content: \"\\f138\"; }\n.ri-sim-card-fill:before { content: \"\\f139\"; }\n.ri-sim-card-line:before { content: \"\\f13a\"; }\n.ri-single-quotes-l:before { content: \"\\f13b\"; }\n.ri-single-quotes-r:before { content: \"\\f13c\"; }\n.ri-sip-fill:before { content: \"\\f13d\"; }\n.ri-sip-line:before { content: \"\\f13e\"; }\n.ri-skip-back-fill:before { content: \"\\f13f\"; }\n.ri-skip-back-line:before { content: \"\\f140\"; }\n.ri-skip-back-mini-fill:before { content: \"\\f141\"; }\n.ri-skip-back-mini-line:before { content: \"\\f142\"; }\n.ri-skip-forward-fill:before { content: \"\\f143\"; }\n.ri-skip-forward-line:before { content: \"\\f144\"; }\n.ri-skip-forward-mini-fill:before { content: \"\\f145\"; }\n.ri-skip-forward-mini-line:before { content: \"\\f146\"; }\n.ri-skull-2-fill:before { content: \"\\f147\"; }\n.ri-skull-2-line:before { content: \"\\f148\"; }\n.ri-skull-fill:before { content: \"\\f149\"; }\n.ri-skull-line:before { content: \"\\f14a\"; }\n.ri-skype-fill:before { content: \"\\f14b\"; }\n.ri-skype-line:before { content: \"\\f14c\"; }\n.ri-slack-fill:before { content: \"\\f14d\"; }\n.ri-slack-line:before { content: \"\\f14e\"; }\n.ri-slice-fill:before { content: \"\\f14f\"; }\n.ri-slice-line:before { content: \"\\f150\"; }\n.ri-slideshow-2-fill:before { content: \"\\f151\"; }\n.ri-slideshow-2-line:before { content: \"\\f152\"; }\n.ri-slideshow-3-fill:before { content: \"\\f153\"; }\n.ri-slideshow-3-line:before { content: \"\\f154\"; }\n.ri-slideshow-4-fill:before { content: \"\\f155\"; }\n.ri-slideshow-4-line:before { content: \"\\f156\"; }\n.ri-slideshow-fill:before { content: \"\\f157\"; }\n.ri-slideshow-line:before { content: \"\\f158\"; }\n.ri-smartphone-fill:before { content: \"\\f159\"; }\n.ri-smartphone-line:before { content: \"\\f15a\"; }\n.ri-snapchat-fill:before { content: \"\\f15b\"; }\n.ri-snapchat-line:before { content: \"\\f15c\"; }\n.ri-snowy-fill:before { content: \"\\f15d\"; }\n.ri-snowy-line:before { content: \"\\f15e\"; }\n.ri-sort-asc:before { content: \"\\f15f\"; }\n.ri-sort-desc:before { content: \"\\f160\"; }\n.ri-sound-module-fill:before { content: \"\\f161\"; }\n.ri-sound-module-line:before { content: \"\\f162\"; }\n.ri-soundcloud-fill:before { content: \"\\f163\"; }\n.ri-soundcloud-line:before { content: \"\\f164\"; }\n.ri-space-ship-fill:before { content: \"\\f165\"; }\n.ri-space-ship-line:before { content: \"\\f166\"; }\n.ri-space:before { content: \"\\f167\"; }\n.ri-spam-2-fill:before { content: \"\\f168\"; }\n.ri-spam-2-line:before { content: \"\\f169\"; }\n.ri-spam-3-fill:before { content: \"\\f16a\"; }\n.ri-spam-3-line:before { content: \"\\f16b\"; }\n.ri-spam-fill:before { content: \"\\f16c\"; }\n.ri-spam-line:before { content: \"\\f16d\"; }\n.ri-speaker-2-fill:before { content: \"\\f16e\"; }\n.ri-speaker-2-line:before { content: \"\\f16f\"; }\n.ri-speaker-3-fill:before { content: \"\\f170\"; }\n.ri-speaker-3-line:before { content: \"\\f171\"; }\n.ri-speaker-fill:before { content: \"\\f172\"; }\n.ri-speaker-line:before { content: \"\\f173\"; }\n.ri-spectrum-fill:before { content: \"\\f174\"; }\n.ri-spectrum-line:before { content: \"\\f175\"; }\n.ri-speed-fill:before { content: \"\\f176\"; }\n.ri-speed-line:before { content: \"\\f177\"; }\n.ri-speed-mini-fill:before { content: \"\\f178\"; }\n.ri-speed-mini-line:before { content: \"\\f179\"; }\n.ri-split-cells-horizontal:before { content: \"\\f17a\"; }\n.ri-split-cells-vertical:before { content: \"\\f17b\"; }\n.ri-spotify-fill:before { content: \"\\f17c\"; }\n.ri-spotify-line:before { content: \"\\f17d\"; }\n.ri-spy-fill:before { content: \"\\f17e\"; }\n.ri-spy-line:before { content: \"\\f17f\"; }\n.ri-stack-fill:before { content: \"\\f180\"; }\n.ri-stack-line:before { content: \"\\f181\"; }\n.ri-stack-overflow-fill:before { content: \"\\f182\"; }\n.ri-stack-overflow-line:before { content: \"\\f183\"; }\n.ri-stackshare-fill:before { content: \"\\f184\"; }\n.ri-stackshare-line:before { content: \"\\f185\"; }\n.ri-star-fill:before { content: \"\\f186\"; }\n.ri-star-half-fill:before { content: \"\\f187\"; }\n.ri-star-half-line:before { content: \"\\f188\"; }\n.ri-star-half-s-fill:before { content: \"\\f189\"; }\n.ri-star-half-s-line:before { content: \"\\f18a\"; }\n.ri-star-line:before { content: \"\\f18b\"; }\n.ri-star-s-fill:before { content: \"\\f18c\"; }\n.ri-star-s-line:before { content: \"\\f18d\"; }\n.ri-star-smile-fill:before { content: \"\\f18e\"; }\n.ri-star-smile-line:before { content: \"\\f18f\"; }\n.ri-steam-fill:before { content: \"\\f190\"; }\n.ri-steam-line:before { content: \"\\f191\"; }\n.ri-steering-2-fill:before { content: \"\\f192\"; }\n.ri-steering-2-line:before { content: \"\\f193\"; }\n.ri-steering-fill:before { content: \"\\f194\"; }\n.ri-steering-line:before { content: \"\\f195\"; }\n.ri-stethoscope-fill:before { content: \"\\f196\"; }\n.ri-stethoscope-line:before { content: \"\\f197\"; }\n.ri-sticky-note-2-fill:before { content: \"\\f198\"; }\n.ri-sticky-note-2-line:before { content: \"\\f199\"; }\n.ri-sticky-note-fill:before { content: \"\\f19a\"; }\n.ri-sticky-note-line:before { content: \"\\f19b\"; }\n.ri-stock-fill:before { content: \"\\f19c\"; }\n.ri-stock-line:before { content: \"\\f19d\"; }\n.ri-stop-circle-fill:before { content: \"\\f19e\"; }\n.ri-stop-circle-line:before { content: \"\\f19f\"; }\n.ri-stop-fill:before { content: \"\\f1a0\"; }\n.ri-stop-line:before { content: \"\\f1a1\"; }\n.ri-stop-mini-fill:before { content: \"\\f1a2\"; }\n.ri-stop-mini-line:before { content: \"\\f1a3\"; }\n.ri-store-2-fill:before { content: \"\\f1a4\"; }\n.ri-store-2-line:before { content: \"\\f1a5\"; }\n.ri-store-3-fill:before { content: \"\\f1a6\"; }\n.ri-store-3-line:before { content: \"\\f1a7\"; }\n.ri-store-fill:before { content: \"\\f1a8\"; }\n.ri-store-line:before { content: \"\\f1a9\"; }\n.ri-strikethrough-2:before { content: \"\\f1aa\"; }\n.ri-strikethrough:before { content: \"\\f1ab\"; }\n.ri-subscript-2:before { content: \"\\f1ac\"; }\n.ri-subscript:before { content: \"\\f1ad\"; }\n.ri-subtract-fill:before { content: \"\\f1ae\"; }\n.ri-subtract-line:before { content: \"\\f1af\"; }\n.ri-subway-fill:before { content: \"\\f1b0\"; }\n.ri-subway-line:before { content: \"\\f1b1\"; }\n.ri-subway-wifi-fill:before { content: \"\\f1b2\"; }\n.ri-subway-wifi-line:before { content: \"\\f1b3\"; }\n.ri-suitcase-2-fill:before { content: \"\\f1b4\"; }\n.ri-suitcase-2-line:before { content: \"\\f1b5\"; }\n.ri-suitcase-3-fill:before { content: \"\\f1b6\"; }\n.ri-suitcase-3-line:before { content: \"\\f1b7\"; }\n.ri-suitcase-fill:before { content: \"\\f1b8\"; }\n.ri-suitcase-line:before { content: \"\\f1b9\"; }\n.ri-sun-cloudy-fill:before { content: \"\\f1ba\"; }\n.ri-sun-cloudy-line:before { content: \"\\f1bb\"; }\n.ri-sun-fill:before { content: \"\\f1bc\"; }\n.ri-sun-foggy-fill:before { content: \"\\f1bd\"; }\n.ri-sun-foggy-line:before { content: \"\\f1be\"; }\n.ri-sun-line:before { content: \"\\f1bf\"; }\n.ri-superscript-2:before { content: \"\\f1c0\"; }\n.ri-superscript:before { content: \"\\f1c1\"; }\n.ri-surgical-mask-fill:before { content: \"\\f1c2\"; }\n.ri-surgical-mask-line:before { content: \"\\f1c3\"; }\n.ri-surround-sound-fill:before { content: \"\\f1c4\"; }\n.ri-surround-sound-line:before { content: \"\\f1c5\"; }\n.ri-survey-fill:before { content: \"\\f1c6\"; }\n.ri-survey-line:before { content: \"\\f1c7\"; }\n.ri-swap-box-fill:before { content: \"\\f1c8\"; }\n.ri-swap-box-line:before { content: \"\\f1c9\"; }\n.ri-swap-fill:before { content: \"\\f1ca\"; }\n.ri-swap-line:before { content: \"\\f1cb\"; }\n.ri-switch-fill:before { content: \"\\f1cc\"; }\n.ri-switch-line:before { content: \"\\f1cd\"; }\n.ri-sword-fill:before { content: \"\\f1ce\"; }\n.ri-sword-line:before { content: \"\\f1cf\"; }\n.ri-syringe-fill:before { content: \"\\f1d0\"; }\n.ri-syringe-line:before { content: \"\\f1d1\"; }\n.ri-t-box-fill:before { content: \"\\f1d2\"; }\n.ri-t-box-line:before { content: \"\\f1d3\"; }\n.ri-t-shirt-2-fill:before { content: \"\\f1d4\"; }\n.ri-t-shirt-2-line:before { content: \"\\f1d5\"; }\n.ri-t-shirt-air-fill:before { content: \"\\f1d6\"; }\n.ri-t-shirt-air-line:before { content: \"\\f1d7\"; }\n.ri-t-shirt-fill:before { content: \"\\f1d8\"; }\n.ri-t-shirt-line:before { content: \"\\f1d9\"; }\n.ri-table-2:before { content: \"\\f1da\"; }\n.ri-table-alt-fill:before { content: \"\\f1db\"; }\n.ri-table-alt-line:before { content: \"\\f1dc\"; }\n.ri-table-fill:before { content: \"\\f1dd\"; }\n.ri-table-line:before { content: \"\\f1de\"; }\n.ri-tablet-fill:before { content: \"\\f1df\"; }\n.ri-tablet-line:before { content: \"\\f1e0\"; }\n.ri-takeaway-fill:before { content: \"\\f1e1\"; }\n.ri-takeaway-line:before { content: \"\\f1e2\"; }\n.ri-taobao-fill:before { content: \"\\f1e3\"; }\n.ri-taobao-line:before { content: \"\\f1e4\"; }\n.ri-tape-fill:before { content: \"\\f1e5\"; }\n.ri-tape-line:before { content: \"\\f1e6\"; }\n.ri-task-fill:before { content: \"\\f1e7\"; }\n.ri-task-line:before { content: \"\\f1e8\"; }\n.ri-taxi-fill:before { content: \"\\f1e9\"; }\n.ri-taxi-line:before { content: \"\\f1ea\"; }\n.ri-taxi-wifi-fill:before { content: \"\\f1eb\"; }\n.ri-taxi-wifi-line:before { content: \"\\f1ec\"; }\n.ri-team-fill:before { content: \"\\f1ed\"; }\n.ri-team-line:before { content: \"\\f1ee\"; }\n.ri-telegram-fill:before { content: \"\\f1ef\"; }\n.ri-telegram-line:before { content: \"\\f1f0\"; }\n.ri-temp-cold-fill:before { content: \"\\f1f1\"; }\n.ri-temp-cold-line:before { content: \"\\f1f2\"; }\n.ri-temp-hot-fill:before { content: \"\\f1f3\"; }\n.ri-temp-hot-line:before { content: \"\\f1f4\"; }\n.ri-terminal-box-fill:before { content: \"\\f1f5\"; }\n.ri-terminal-box-line:before { content: \"\\f1f6\"; }\n.ri-terminal-fill:before { content: \"\\f1f7\"; }\n.ri-terminal-line:before { content: \"\\f1f8\"; }\n.ri-terminal-window-fill:before { content: \"\\f1f9\"; }\n.ri-terminal-window-line:before { content: \"\\f1fa\"; }\n.ri-test-tube-fill:before { content: \"\\f1fb\"; }\n.ri-test-tube-line:before { content: \"\\f1fc\"; }\n.ri-text-direction-l:before { content: \"\\f1fd\"; }\n.ri-text-direction-r:before { content: \"\\f1fe\"; }\n.ri-text-spacing:before { content: \"\\f1ff\"; }\n.ri-text-wrap:before { content: \"\\f200\"; }\n.ri-text:before { content: \"\\f201\"; }\n.ri-thermometer-fill:before { content: \"\\f202\"; }\n.ri-thermometer-line:before { content: \"\\f203\"; }\n.ri-thumb-down-fill:before { content: \"\\f204\"; }\n.ri-thumb-down-line:before { content: \"\\f205\"; }\n.ri-thumb-up-fill:before { content: \"\\f206\"; }\n.ri-thumb-up-line:before { content: \"\\f207\"; }\n.ri-thunderstorms-fill:before { content: \"\\f208\"; }\n.ri-thunderstorms-line:before { content: \"\\f209\"; }\n.ri-ticket-2-fill:before { content: \"\\f20a\"; }\n.ri-ticket-2-line:before { content: \"\\f20b\"; }\n.ri-ticket-fill:before { content: \"\\f20c\"; }\n.ri-ticket-line:before { content: \"\\f20d\"; }\n.ri-time-fill:before { content: \"\\f20e\"; }\n.ri-time-line:before { content: \"\\f20f\"; }\n.ri-timer-2-fill:before { content: \"\\f210\"; }\n.ri-timer-2-line:before { content: \"\\f211\"; }\n.ri-timer-fill:before { content: \"\\f212\"; }\n.ri-timer-flash-fill:before { content: \"\\f213\"; }\n.ri-timer-flash-line:before { content: \"\\f214\"; }\n.ri-timer-line:before { content: \"\\f215\"; }\n.ri-todo-fill:before { content: \"\\f216\"; }\n.ri-todo-line:before { content: \"\\f217\"; }\n.ri-toggle-fill:before { content: \"\\f218\"; }\n.ri-toggle-line:before { content: \"\\f219\"; }\n.ri-tools-fill:before { content: \"\\f21a\"; }\n.ri-tools-line:before { content: \"\\f21b\"; }\n.ri-tornado-fill:before { content: \"\\f21c\"; }\n.ri-tornado-line:before { content: \"\\f21d\"; }\n.ri-trademark-fill:before { content: \"\\f21e\"; }\n.ri-trademark-line:before { content: \"\\f21f\"; }\n.ri-traffic-light-fill:before { content: \"\\f220\"; }\n.ri-traffic-light-line:before { content: \"\\f221\"; }\n.ri-train-fill:before { content: \"\\f222\"; }\n.ri-train-line:before { content: \"\\f223\"; }\n.ri-train-wifi-fill:before { content: \"\\f224\"; }\n.ri-train-wifi-line:before { content: \"\\f225\"; }\n.ri-translate-2:before { content: \"\\f226\"; }\n.ri-translate:before { content: \"\\f227\"; }\n.ri-travesti-fill:before { content: \"\\f228\"; }\n.ri-travesti-line:before { content: \"\\f229\"; }\n.ri-treasure-map-fill:before { content: \"\\f22a\"; }\n.ri-treasure-map-line:before { content: \"\\f22b\"; }\n.ri-trello-fill:before { content: \"\\f22c\"; }\n.ri-trello-line:before { content: \"\\f22d\"; }\n.ri-trophy-fill:before { content: \"\\f22e\"; }\n.ri-trophy-line:before { content: \"\\f22f\"; }\n.ri-truck-fill:before { content: \"\\f230\"; }\n.ri-truck-line:before { content: \"\\f231\"; }\n.ri-tumblr-fill:before { content: \"\\f232\"; }\n.ri-tumblr-line:before { content: \"\\f233\"; }\n.ri-tv-2-fill:before { content: \"\\f234\"; }\n.ri-tv-2-line:before { content: \"\\f235\"; }\n.ri-tv-fill:before { content: \"\\f236\"; }\n.ri-tv-line:before { content: \"\\f237\"; }\n.ri-twitch-fill:before { content: \"\\f238\"; }\n.ri-twitch-line:before { content: \"\\f239\"; }\n.ri-twitter-fill:before { content: \"\\f23a\"; }\n.ri-twitter-line:before { content: \"\\f23b\"; }\n.ri-typhoon-fill:before { content: \"\\f23c\"; }\n.ri-typhoon-line:before { content: \"\\f23d\"; }\n.ri-u-disk-fill:before { content: \"\\f23e\"; }\n.ri-u-disk-line:before { content: \"\\f23f\"; }\n.ri-ubuntu-fill:before { content: \"\\f240\"; }\n.ri-ubuntu-line:before { content: \"\\f241\"; }\n.ri-umbrella-fill:before { content: \"\\f242\"; }\n.ri-umbrella-line:before { content: \"\\f243\"; }\n.ri-underline:before { content: \"\\f244\"; }\n.ri-uninstall-fill:before { content: \"\\f245\"; }\n.ri-uninstall-line:before { content: \"\\f246\"; }\n.ri-unsplash-fill:before { content: \"\\f247\"; }\n.ri-unsplash-line:before { content: \"\\f248\"; }\n.ri-upload-2-fill:before { content: \"\\f249\"; }\n.ri-upload-2-line:before { content: \"\\f24a\"; }\n.ri-upload-cloud-2-fill:before { content: \"\\f24b\"; }\n.ri-upload-cloud-2-line:before { content: \"\\f24c\"; }\n.ri-upload-cloud-fill:before { content: \"\\f24d\"; }\n.ri-upload-cloud-line:before { content: \"\\f24e\"; }\n.ri-upload-fill:before { content: \"\\f24f\"; }\n.ri-upload-line:before { content: \"\\f250\"; }\n.ri-usb-fill:before { content: \"\\f251\"; }\n.ri-usb-line:before { content: \"\\f252\"; }\n.ri-user-2-fill:before { content: \"\\f253\"; }\n.ri-user-2-line:before { content: \"\\f254\"; }\n.ri-user-3-fill:before { content: \"\\f255\"; }\n.ri-user-3-line:before { content: \"\\f256\"; }\n.ri-user-4-fill:before { content: \"\\f257\"; }\n.ri-user-4-line:before { content: \"\\f258\"; }\n.ri-user-5-fill:before { content: \"\\f259\"; }\n.ri-user-5-line:before { content: \"\\f25a\"; }\n.ri-user-6-fill:before { content: \"\\f25b\"; }\n.ri-user-6-line:before { content: \"\\f25c\"; }\n.ri-user-add-fill:before { content: \"\\f25d\"; }\n.ri-user-add-line:before { content: \"\\f25e\"; }\n.ri-user-fill:before { content: \"\\f25f\"; }\n.ri-user-follow-fill:before { content: \"\\f260\"; }\n.ri-user-follow-line:before { content: \"\\f261\"; }\n.ri-user-heart-fill:before { content: \"\\f262\"; }\n.ri-user-heart-line:before { content: \"\\f263\"; }\n.ri-user-line:before { content: \"\\f264\"; }\n.ri-user-location-fill:before { content: \"\\f265\"; }\n.ri-user-location-line:before { content: \"\\f266\"; }\n.ri-user-received-2-fill:before { content: \"\\f267\"; }\n.ri-user-received-2-line:before { content: \"\\f268\"; }\n.ri-user-received-fill:before { content: \"\\f269\"; }\n.ri-user-received-line:before { content: \"\\f26a\"; }\n.ri-user-search-fill:before { content: \"\\f26b\"; }\n.ri-user-search-line:before { content: \"\\f26c\"; }\n.ri-user-settings-fill:before { content: \"\\f26d\"; }\n.ri-user-settings-line:before { content: \"\\f26e\"; }\n.ri-user-shared-2-fill:before { content: \"\\f26f\"; }\n.ri-user-shared-2-line:before { content: \"\\f270\"; }\n.ri-user-shared-fill:before { content: \"\\f271\"; }\n.ri-user-shared-line:before { content: \"\\f272\"; }\n.ri-user-smile-fill:before { content: \"\\f273\"; }\n.ri-user-smile-line:before { content: \"\\f274\"; }\n.ri-user-star-fill:before { content: \"\\f275\"; }\n.ri-user-star-line:before { content: \"\\f276\"; }\n.ri-user-unfollow-fill:before { content: \"\\f277\"; }\n.ri-user-unfollow-line:before { content: \"\\f278\"; }\n.ri-user-voice-fill:before { content: \"\\f279\"; }\n.ri-user-voice-line:before { content: \"\\f27a\"; }\n.ri-video-add-fill:before { content: \"\\f27b\"; }\n.ri-video-add-line:before { content: \"\\f27c\"; }\n.ri-video-chat-fill:before { content: \"\\f27d\"; }\n.ri-video-chat-line:before { content: \"\\f27e\"; }\n.ri-video-download-fill:before { content: \"\\f27f\"; }\n.ri-video-download-line:before { content: \"\\f280\"; }\n.ri-video-fill:before { content: \"\\f281\"; }\n.ri-video-line:before { content: \"\\f282\"; }\n.ri-video-upload-fill:before { content: \"\\f283\"; }\n.ri-video-upload-line:before { content: \"\\f284\"; }\n.ri-vidicon-2-fill:before { content: \"\\f285\"; }\n.ri-vidicon-2-line:before { content: \"\\f286\"; }\n.ri-vidicon-fill:before { content: \"\\f287\"; }\n.ri-vidicon-line:before { content: \"\\f288\"; }\n.ri-vimeo-fill:before { content: \"\\f289\"; }\n.ri-vimeo-line:before { content: \"\\f28a\"; }\n.ri-vip-crown-2-fill:before { content: \"\\f28b\"; }\n.ri-vip-crown-2-line:before { content: \"\\f28c\"; }\n.ri-vip-crown-fill:before { content: \"\\f28d\"; }\n.ri-vip-crown-line:before { content: \"\\f28e\"; }\n.ri-vip-diamond-fill:before { content: \"\\f28f\"; }\n.ri-vip-diamond-line:before { content: \"\\f290\"; }\n.ri-vip-fill:before { content: \"\\f291\"; }\n.ri-vip-line:before { content: \"\\f292\"; }\n.ri-virus-fill:before { content: \"\\f293\"; }\n.ri-virus-line:before { content: \"\\f294\"; }\n.ri-visa-fill:before { content: \"\\f295\"; }\n.ri-visa-line:before { content: \"\\f296\"; }\n.ri-voice-recognition-fill:before { content: \"\\f297\"; }\n.ri-voice-recognition-line:before { content: \"\\f298\"; }\n.ri-voiceprint-fill:before { content: \"\\f299\"; }\n.ri-voiceprint-line:before { content: \"\\f29a\"; }\n.ri-volume-down-fill:before { content: \"\\f29b\"; }\n.ri-volume-down-line:before { content: \"\\f29c\"; }\n.ri-volume-mute-fill:before { content: \"\\f29d\"; }\n.ri-volume-mute-line:before { content: \"\\f29e\"; }\n.ri-volume-off-vibrate-fill:before { content: \"\\f29f\"; }\n.ri-volume-off-vibrate-line:before { content: \"\\f2a0\"; }\n.ri-volume-up-fill:before { content: \"\\f2a1\"; }\n.ri-volume-up-line:before { content: \"\\f2a2\"; }\n.ri-volume-vibrate-fill:before { content: \"\\f2a3\"; }\n.ri-volume-vibrate-line:before { content: \"\\f2a4\"; }\n.ri-vuejs-fill:before { content: \"\\f2a5\"; }\n.ri-vuejs-line:before { content: \"\\f2a6\"; }\n.ri-walk-fill:before { content: \"\\f2a7\"; }\n.ri-walk-line:before { content: \"\\f2a8\"; }\n.ri-wallet-2-fill:before { content: \"\\f2a9\"; }\n.ri-wallet-2-line:before { content: \"\\f2aa\"; }\n.ri-wallet-3-fill:before { content: \"\\f2ab\"; }\n.ri-wallet-3-line:before { content: \"\\f2ac\"; }\n.ri-wallet-fill:before { content: \"\\f2ad\"; }\n.ri-wallet-line:before { content: \"\\f2ae\"; }\n.ri-water-flash-fill:before { content: \"\\f2af\"; }\n.ri-water-flash-line:before { content: \"\\f2b0\"; }\n.ri-webcam-fill:before { content: \"\\f2b1\"; }\n.ri-webcam-line:before { content: \"\\f2b2\"; }\n.ri-wechat-2-fill:before { content: \"\\f2b3\"; }\n.ri-wechat-2-line:before { content: \"\\f2b4\"; }\n.ri-wechat-fill:before { content: \"\\f2b5\"; }\n.ri-wechat-line:before { content: \"\\f2b6\"; }\n.ri-wechat-pay-fill:before { content: \"\\f2b7\"; }\n.ri-wechat-pay-line:before { content: \"\\f2b8\"; }\n.ri-weibo-fill:before { content: \"\\f2b9\"; }\n.ri-weibo-line:before { content: \"\\f2ba\"; }\n.ri-whatsapp-fill:before { content: \"\\f2bb\"; }\n.ri-whatsapp-line:before { content: \"\\f2bc\"; }\n.ri-wheelchair-fill:before { content: \"\\f2bd\"; }\n.ri-wheelchair-line:before { content: \"\\f2be\"; }\n.ri-wifi-fill:before { content: \"\\f2bf\"; }\n.ri-wifi-line:before { content: \"\\f2c0\"; }\n.ri-wifi-off-fill:before { content: \"\\f2c1\"; }\n.ri-wifi-off-line:before { content: \"\\f2c2\"; }\n.ri-window-2-fill:before { content: \"\\f2c3\"; }\n.ri-window-2-line:before { content: \"\\f2c4\"; }\n.ri-window-fill:before { content: \"\\f2c5\"; }\n.ri-window-line:before { content: \"\\f2c6\"; }\n.ri-windows-fill:before { content: \"\\f2c7\"; }\n.ri-windows-line:before { content: \"\\f2c8\"; }\n.ri-windy-fill:before { content: \"\\f2c9\"; }\n.ri-windy-line:before { content: \"\\f2ca\"; }\n.ri-wireless-charging-fill:before { content: \"\\f2cb\"; }\n.ri-wireless-charging-line:before { content: \"\\f2cc\"; }\n.ri-women-fill:before { content: \"\\f2cd\"; }\n.ri-women-line:before { content: \"\\f2ce\"; }\n.ri-wubi-input:before { content: \"\\f2cf\"; }\n.ri-xbox-fill:before { content: \"\\f2d0\"; }\n.ri-xbox-line:before { content: \"\\f2d1\"; }\n.ri-xing-fill:before { content: \"\\f2d2\"; }\n.ri-xing-line:before { content: \"\\f2d3\"; }\n.ri-youtube-fill:before { content: \"\\f2d4\"; }\n.ri-youtube-line:before { content: \"\\f2d5\"; }\n.ri-zcool-fill:before { content: \"\\f2d6\"; }\n.ri-zcool-line:before { content: \"\\f2d7\"; }\n.ri-zhihu-fill:before { content: \"\\f2d8\"; }\n.ri-zhihu-line:before { content: \"\\f2d9\"; }\n.ri-zoom-in-fill:before { content: \"\\f2da\"; }\n.ri-zoom-in-line:before { content: \"\\f2db\"; }\n.ri-zoom-out-fill:before { content: \"\\f2dc\"; }\n.ri-zoom-out-line:before { content: \"\\f2dd\"; }\n.ri-zzz-fill:before { content: \"\\f2de\"; }\n.ri-zzz-line:before { content: \"\\f2df\"; }\n\n","/*\nTemplate Name: Velzon - Admin & Dashboard Template\nAuthor: Themesbrand\nVersion: 2.4.0\nWebsite: https://Themesbrand.com/\nContact: Themesbrand@gmail.com\nFile: Custom Bootstrap Css File\n*/\n\n\n//Core files\n@import \"./node_modules/bootstrap/scss/functions\";\n@import \"./node_modules/bootstrap/scss/variables\";\n@import \"variables\";\n@import \"./node_modules/bootstrap/scss/bootstrap\";","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.2.3 (https://getbootstrap.com/)\n   * Copyright 2011-2022 The Bootstrap Authors\n   * Copyright 2011-2022 Twitter, Inc.\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n\n",":root {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{$font-family-base};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  --#{$prefix}body-color: #{$body-color};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n  --#{$prefix}body-bg: #{$body-bg};\n  // scss-docs-end root-body-variables\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-2xl: #{$border-radius-2xl};\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n\n  --#{$prefix}code-color: #{$code-color};\n\n  --#{$prefix}highlight-bg: #{$mark-bg};\n}\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: '';\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + ' 0';\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + ' ' + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + ' ' + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      }\n      @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + ' ' + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: '';\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + ' 0';\n    }\n\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + ' ' + $value;\n      }\n\n      @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + ' ' +  if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + ' calc(' + $min-width + if($value < 0, ' - ', ' + ') + $variable-width + ')';\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluidVal: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluidVal {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluidVal);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule {\n        #{$property}: if($rfs-mode == max-media-query, $fluidVal, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: var(--#{$prefix}link-color);\n  text-decoration: $link-decoration;\n\n  &:hover {\n    color: var(--#{$prefix}link-hover-color);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. Correct the outline style in Safari.\n// 2. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n\n[type=\"search\"] {\n  outline-offset: -2px; // 1\n  -webkit-appearance: textfield; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\n\n//\n// custom-variables\n//\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             vz-; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix;\n\n// Font Family\n$font-family-primary:                             'Poppins', sans-serif;\n$font-family-secondary:                           'hkgrotesk', sans-serif;\n\n//\n// Vertical Menu\n//\n$vertical-menu-width:                             250px;\n$vertical-menu-width-md:                          180px;\n$vertical-menu-width-sm:                          70px;\n\n// Light Menu\n$vertical-menu-bg:                                var(--#{$prefix}vertical-menu-bg);\n$vertical-menu-box-shadow:                        0 2px 4px rgba(15,34,58,0.12);\n$vertical-menu-border:                            $white;\n$vertical-menu-z-index:                           1002;\n$vertical-menu-item-font-size:                    1rem;\n$vertical-menu-item-font-family:                  $font-family-secondary;\n$vertical-menu-item-color:                        var(--#{$prefix}vertical-menu-item-color);\n$vertical-menu-item-hover-color:                  var(--#{$prefix}vertical-menu-item-hover-color);\n$vertical-menu-item-active-color:                 var(--#{$prefix}vertical-menu-item-active-color);\n$vertical-menu-item-padding-x:                    1.5rem;\n$vertical-menu-item-padding-y:                    0.625rem;\n$vertical-menu-sub-item-font-size:                0.813rem;\n$vertical-menu-sub-item-font-family:              $font-family-primary;\n$vertical-menu-sub-item-color:                    var(--#{$prefix}vertical-menu-sub-item-color);\n$vertical-menu-sub-item-hover-color:              var(--#{$prefix}vertical-menu-sub-item-hover-color);\n$vertical-menu-sub-item-active-color:             var(--#{$prefix}vertical-menu-sub-item-active-color);\n$vertical-menu-sub-item-padding-x:                1.5rem;\n$vertical-menu-sub-item-padding-y:                0.55rem;\n$vertical-menu-dropdown-box-shadow:               0 2px 4px rgba(15,34,58,0.12);\n$vertical-menu-title-color:                       var(--#{$prefix}vertical-menu-title-color);\n$vertical-menu-item-icon-width:                   1.75rem;\n\n// Dark Menu\n$vertical-menu-bg-dark:                         var(--#{$prefix}vertical-menu-bg-dark);\n$vertical-menu-border-dark:                     var(--#{$prefix}vertical-menu-bg-dark);\n$vertical-menu-item-color-dark:                 var(--#{$prefix}vertical-menu-item-color-dark);\n$vertical-menu-item-hover-color-dark:           var(--#{$prefix}vertical-menu-item-hover-color-dark);\n$vertical-menu-item-active-color-dark:          var(--#{$prefix}vertical-menu-item-active-color-dark);\n$vertical-menu-sub-item-color-dark:             var(--#{$prefix}vertical-menu-sub-item-color-dark);\n$vertical-menu-sub-item-hover-color-dark:       var(--#{$prefix}vertical-menu-sub-item-hover-color-dark);\n$vertical-menu-sub-item-active-color-dark:      var(--#{$prefix}vertical-menu-sub-item-active-color-dark);\n$vertical-menu-title-color-dark:                var(--#{$prefix}vertical-menu-title-color-dark);\n\n// vertical gradient Menu\n$vertical-menu-bg-gradient:                         var(--#{$prefix}vertical-menu-bg-gradient);\n$vertical-menu-border-gradient:                     var(--#{$prefix}vertical-menu-border-gradient);\n$vertical-menu-item-color-gradient:                 rgba($white, 0.5);\n$vertical-menu-sub-item-color-gradient:             rgba($white, 0.5);\n$vertical-menu-title-color-gradient:                rgba($white, 0.5);\n\n//\n// Horizontal Menu\n//\n$horizontal-menu-box-shadow:                       0 2px 4px rgba(15,34,58,0.12);\n$horizontal-menu-dropdown-box-shadow:              0 0px 5px rgba(15,34,58,0.15);\n$horizontal-menu-dropdown-min-width:               12rem; \n$horizontal-menu-item-padding-x:                   1.5rem;\n$horizontal-menu-item-padding-y:                   0.75rem;\n\n//\n// Two Column Menu\n//\n$twocolumn-menu-iconview-bg:                       var(--#{$prefix}twocolumn-menu-iconview-bg);\n$twocolumn-menu-bg:                                var(--#{$prefix}twocolumn-menu-bg);\n$twocolumn-menu-iconview-width:                    70px;\n$twocolumn-menu-width:                             220px;\n$twocolumn-menu-box-shadow:                        0 2px 4px rgba(15,34,58,0.12);\n$twocolumn-menu-z-index:                           1002;\n// dark\n$twocolumn-menu-iconview-bg-dark:                 var(--#{$prefix}twocolumn-menu-iconview-bg-dark);\n$twocolumn-menu-bg-dark:                          var(--#{$prefix}twocolumn-menu-bg-dark);\n$twocolumn-menu-border-dark:                      var(--#{$prefix}twocolumn-menu-bg-dark);\n$twocolumn-menu-item-color-dark:                  var(--#{$prefix}twocolumn-menu-item-color-dark);\n$twocolumn-menu-item-active-color-dark:           var(--#{$prefix}twocolumn-menu-item-active-color-dark);\n$twocolumn-menu-item-active-bg-dark:              var(--#{$prefix}twocolumn-menu-item-active-bg-dark);\n\n// gradient Menu\n$twocolumn-menu-item-color-gradient:              rgba($white, 0.6);\n\n//semibox\n$semibox-width:                                   110px;\n\n// Topbar - (Default Light)\n$header-height:                                    70px;\n$header-bg:                                       var(--#{$prefix}header-bg);\n$header-item-color:                               var(--#{$prefix}header-item-color);\n\n// Topbar - Dark\n$header-bg-dark:                                 var(--#{$prefix}header-bg-dark);\n$header-item-color-dark:                         var(--#{$prefix}header-item-color-dark); \n\n// Topbar Search\n$topbar-search-bg:                                var(--#{$prefix}topbar-search-bg);\n$page-title-box-shadow:                           0 1px 2px rgba(56,65,74,0.15);\n$page-title-border:                               none;\n\n// Topbar User\n$topbar-user-bg: var(--#{$prefix}topbar-user-bg);\n$topbar-user-bg-dark: var(--#{$prefix}topbar-user-bg-dark);\n\n// Footer\n$footer-height: 60px;\n$footer-bg: var(--#{$prefix}footer-bg);\n$footer-color: var(--#{$prefix}footer-color);\n\n// Horizontal nav\n$topnav-bg:   var(--#{$prefix}topnav-bg);\n$topnav-item-color:   var(--#{$prefix}topnav-item-color);\n$topnav-item-color-active:   var(--#{$prefix}topnav-item-color-active);\n\n// Brand \n$navbar-brand-box-width: 240px;\n\n// Boxed layout width\n$boxed-layout-width:    1300px;\n$boxed-body-bg:         var(--#{$prefix}boxed-body-bg);\n\n// Font Weight\n$font-weight-medium: 500;\n\n// heading\n$heading-color: var(--#{$prefix}heading-color);\n$heading-font-family:         $font-family-primary;\n\n// Chat\n$chat-primary-bg:       var(--#{$prefix}light);\n$chat-secondary-bg:    rgba(var(--#{$prefix}success-rgb), 0.15);\n$chat-secondary-color:  var(--#{$prefix}success);\n\n// Timeline\n$timeline-color:   var(--#{$prefix}card-bg-custom);     \n\n//auth pages\n$auth-bg-cover: linear-gradient(126deg, rgba(8, 143, 125, 1) 0%, rgba(0, 57, 92, 1) 100%);\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff;\n$gray-100: #f3f6f9;\n$gray-200: #eff2f7;\n$gray-300: #e9ebec;\n$gray-400: #ced4da;\n$gray-500: #adb5bd;\n$gray-600: #878a99;\n$gray-700: #495057;\n$gray-800: #343a40;\n$gray-900: #212529;\n$black:    #000;\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n);\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:       #3577f1;\n$indigo:     #F26430; // Primary\n$purple:     #F28322; // Primary Light\n$pink:       #f672a7;\n$red:        #f06548;\n$orange:     #208C3B; // Secondary\n$yellow:     #3FBF48; // Secondary Light\n$green:      #0ab39c;\n$teal:       #02a8b5;\n$cyan:       #299cdb;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n);\n// scss-docs-end colors-map\n\n// scss-docs-start theme-color-variables\n$primary:       $indigo;    // #F26430\n$secondary:     $orange;    // #208C3B\n$success:       $green;\n$info:          $cyan;\n$warning:       $yellow;    // #3FBF48\n$danger:        $red;\n$light:         $gray-100;\n$dark:          $gray-900;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n);\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-colors-rgb\n$theme-colors-rgb: map-loop($theme-colors, to-rgb, \"$value\");\n// scss-docs-end theme-colors-rgb\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   1.75;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black;\n$color-contrast-light:     $white;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%);\n$blue-200: tint-color($blue, 60%);\n$blue-300: tint-color($blue, 40%);\n$blue-400: tint-color($blue, 20%);\n$blue-500: $blue;\n$blue-600: shade-color($blue, 20%);\n$blue-700: shade-color($blue, 40%);\n$blue-800: shade-color($blue, 60%);\n$blue-900: shade-color($blue, 80%);\n\n$indigo-100: tint-color($indigo, 80%);\n$indigo-200: tint-color($indigo, 60%);\n$indigo-300: tint-color($indigo, 40%);\n$indigo-400: tint-color($indigo, 20%);\n$indigo-500: $indigo;\n$indigo-600: shade-color($indigo, 20%);\n$indigo-700: shade-color($indigo, 40%);\n$indigo-800: shade-color($indigo, 60%);\n$indigo-900: shade-color($indigo, 80%);\n\n$purple-100: tint-color($purple, 80%);\n$purple-200: tint-color($purple, 60%);\n$purple-300: tint-color($purple, 40%);\n$purple-400: tint-color($purple, 20%);\n$purple-500: $purple;\n$purple-600: shade-color($purple, 20%);\n$purple-700: shade-color($purple, 40%);\n$purple-800: shade-color($purple, 60%);\n$purple-900: shade-color($purple, 80%);\n\n$pink-100: tint-color($pink, 80%);\n$pink-200: tint-color($pink, 60%);\n$pink-300: tint-color($pink, 40%);\n$pink-400: tint-color($pink, 20%);\n$pink-500: $pink;\n$pink-600: shade-color($pink, 20%);\n$pink-700: shade-color($pink, 40%);\n$pink-800: shade-color($pink, 60%);\n$pink-900: shade-color($pink, 80%);\n\n$red-100: tint-color($red, 80%);\n$red-200: tint-color($red, 60%);\n$red-300: tint-color($red, 40%);\n$red-400: tint-color($red, 20%);\n$red-500: $red;\n$red-600: shade-color($red, 20%);\n$red-700: shade-color($red, 40%);\n$red-800: shade-color($red, 60%);\n$red-900: shade-color($red, 80%);\n\n$orange-100: tint-color($orange, 80%);\n$orange-200: tint-color($orange, 60%);\n$orange-300: tint-color($orange, 40%);\n$orange-400: tint-color($orange, 20%);\n$orange-500: $orange;\n$orange-600: shade-color($orange, 20%);\n$orange-700: shade-color($orange, 40%);\n$orange-800: shade-color($orange, 60%);\n$orange-900: shade-color($orange, 80%);\n\n$yellow-100: tint-color($yellow, 80%);\n$yellow-200: tint-color($yellow, 60%);\n$yellow-300: tint-color($yellow, 40%);\n$yellow-400: tint-color($yellow, 20%);\n$yellow-500: $yellow;\n$yellow-600: shade-color($yellow, 20%);\n$yellow-700: shade-color($yellow, 40%);\n$yellow-800: shade-color($yellow, 60%);\n$yellow-900: shade-color($yellow, 80%);\n\n$green-100: tint-color($green, 80%);\n$green-200: tint-color($green, 60%);\n$green-300: tint-color($green, 40%);\n$green-400: tint-color($green, 20%);\n$green-500: $green;\n$green-600: shade-color($green, 20%);\n$green-700: shade-color($green, 40%);\n$green-800: shade-color($green, 60%);\n$green-900: shade-color($green, 80%);\n\n$teal-100: tint-color($teal, 80%);\n$teal-200: tint-color($teal, 60%);\n$teal-300: tint-color($teal, 40%);\n$teal-400: tint-color($teal, 20%);\n$teal-500: $teal;\n$teal-600: shade-color($teal, 20%);\n$teal-700: shade-color($teal, 40%);\n$teal-800: shade-color($teal, 60%);\n$teal-900: shade-color($teal, 80%);\n\n$cyan-100: tint-color($cyan, 80%);\n$cyan-200: tint-color($cyan, 60%);\n$cyan-300: tint-color($cyan, 40%);\n$cyan-400: tint-color($cyan, 20%);\n$cyan-500: $cyan;\n$cyan-600: shade-color($cyan, 20%);\n$cyan-700: shade-color($cyan, 40%);\n$cyan-800: shade-color($cyan, 60%);\n$cyan-900: shade-color($cyan, 80%);\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n);\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n);\n\n$purples: (\n  \"purple-100\": $purple-200,\n  \"purple-200\": $purple-100,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n);\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n);\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n);\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n);\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n);\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n);\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n);\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n);\n// fusv-enable\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n);\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                false;\n$enable-rounded:              true;\n$enable-shadows:              false;\n$enable-gradients:            false;\n$enable-transitions:          true;\n$enable-reduced-motion:       true;\n$enable-smooth-scroll:        true;\n$enable-grid-classes:         true;\n$enable-container-classes:    true;\n$enable-cssgrid:              false;\n$enable-button-pointers:      true;\n$enable-rfs:                  true;\n$enable-validation-icons:     true;\n$enable-negative-margins:     true;\n$enable-deprecation-messages: true;\n$enable-important-utilities:  true;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0));\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n);\n\n$negative-spacers: if($enable-negative-margins, negativify-map($spacers), null);\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n);\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   #f3f3f9;\n$body-color:                $gray-900;\n$body-text-align:           null;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              var(--#{$prefix}link-color);\n$link-decoration:                         underline;\n$link-shade-percentage:                   20%;\n$link-hover-color:                        var(--#{$prefix}link-hover-color);\n$link-hover-decoration:                   null;\n\n$stretched-link-pseudo-element:           after;\n$stretched-link-z-index:                  1;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n);\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n);\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12;\n$grid-gutter-width:           1rem;\n$grid-row-columns:            6;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width * 1;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n);\n\n$border-style:                solid;\n$border-color-translucent:    rgba($black, .175);\n$border-color:                var(--#{$prefix}border-color);\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .25rem;\n$border-radius-sm:            .2rem;\n$border-radius-lg:            .3rem;\n$border-radius-xl:            1rem;\n$border-radius-2xl:           2rem;\n$border-radius-pill:          50rem;\n// scss-docs-end border-radius-variables\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 1px 2px rgba(56,65,74,0.15);\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075);\n$box-shadow-lg:               0 5px 10px rgba(30, 32, 37, 0.12);\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075);\n$element-shadow:              none;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white;\n$component-active-bg:         $primary;\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em;\n$caret-vertical-align:        $caret-width * .85;\n$caret-spacing:               $caret-width * .85;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out;\n$transition-fade:             opacity .15s linear;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease;\n$transition-collapse-width:   width .35s ease;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n);\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      $font-family-primary;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif);\n$font-family-code:            var(--#{$prefix}font-monospace);\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null;\n$font-size-base:              0.8125rem; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875;\n$font-size-lg:                $font-size-base * 1.25;\n\n$font-weight-lighter:         lighter;\n$font-weight-light:           300;\n$font-weight-normal:          400;\n$font-weight-semibold:        600;\n$font-weight-bold:            700;\n$font-weight-bolder:          bolder;\n\n$font-weight-base:            $font-weight-normal;\n\n$line-height-base:            1.5;\n$line-height-sm:              1.25;\n$line-height-lg:              2;\n\n$h1-font-size:                $font-size-base * 2.5;\n$h2-font-size:                $font-size-base * 2;\n$h3-font-size:                $font-size-base * 1.75;\n$h4-font-size:                $font-size-base * 1.5;\n$h5-font-size:                $font-size-base * 1.25;\n$h6-font-size:                $font-size-base;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n);\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5;\n$headings-font-family:        null;\n$headings-font-style:         null;\n$headings-font-weight:        500;\n$headings-line-height:        1.2;\n$headings-color:              null;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n);\n\n$display-font-family: null;\n$display-font-style:  null;\n$display-font-weight: 300;\n$display-line-height: $headings-line-height;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25;\n$lead-font-weight:            300;\n\n$small-font-size:             .875em;\n\n$sub-sup-font-size:           .75em;\n\n$text-muted:                  $gray-600;\n\n$initialism-font-size:        $small-font-size;\n\n$blockquote-margin-y:         $spacer;\n$blockquote-font-size:        $font-size-base * 1.1;\n$blockquote-footer-color:     $gray-600;\n$blockquote-footer-font-size: $small-font-size;\n\n$hr-margin-y:                 $spacer;\n$hr-color:                    inherit;\n// fusv-disable\n$hr-bg-color:                 null; // Deprecated in v5.2.0\n$hr-height:                   $border-width;\n// fusv-enable\n$hr-border-color:             null; // Allows for inherited colors\n$hr-border-width:             $border-width;\n$hr-opacity:                  .25;\n\n$legend-margin-bottom:        .5rem;\n$legend-font-size:            1.5rem;\n$legend-font-weight:          null;\n\n$mark-padding:                .2em;\n\n$dt-font-weight:              $font-weight-semibold;\n\n$list-inline-padding:         .5rem;\n\n$mark-bg:                     #fcf8e3;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .75rem;\n$table-cell-padding-x:        .6rem;\n$table-cell-padding-y-sm:     .3rem;\n$table-cell-padding-x-sm:     .25rem;\n\n$table-cell-vertical-align:   top;\n\n$table-color:                 var(--#{$prefix}body-color);\n$table-bg:                    transparent;\n$table-accent-bg:             transparent;\n\n$table-th-font-weight:        null;\n\n$table-striped-color:         $table-color;\n$table-striped-bg-factor:     .02;\n$table-striped-bg:            rgba(var(--#{$prefix}dark-rgb), $table-striped-bg-factor);\n\n$table-active-color:          $table-color;\n$table-active-bg-factor:      1;\n$table-active-bg:             rgba(var(--#{$prefix}light-rgb), $table-active-bg-factor);\n\n$table-hover-color:           $table-color;\n$table-hover-bg-factor:       1;\n$table-hover-bg:              rgba(var(--#{$prefix}light-rgb), $table-hover-bg-factor);\n\n$table-border-factor:         .1;\n$table-border-width:          $border-width;\n$table-border-color:          $border-color;\n\n$table-striped-order:         odd;\n$table-striped-columns-order: even;\n\n$table-group-separator-color: $border-color;\n\n$table-caption-color:         $text-muted;\n\n$table-bg-scale:              -80%;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n);\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .5rem;\n$input-btn-padding-x:         .9rem;\n$input-btn-font-family:       null;\n$input-btn-font-size:         $font-size-base;\n$input-btn-line-height:       $line-height-base;\n\n$input-btn-focus-width:         0;\n$input-btn-focus-color-opacity: .25;\n$input-btn-focus-color:         rgba($component-active-bg, $input-btn-focus-color-opacity);\n$input-btn-focus-blur:          0;\n$input-btn-focus-box-shadow:    0 0 $input-btn-focus-blur $input-btn-focus-width $input-btn-focus-color;\n\n$input-btn-padding-y-sm:      .25rem;\n$input-btn-padding-x-sm:      .5rem;\n$input-btn-font-size-sm:      $font-size-sm;\n\n$input-btn-padding-y-lg:      .7rem;\n$input-btn-padding-x-lg:      1.2rem;\n$input-btn-font-size-lg:      $font-size-lg;\n\n$input-btn-border-width:      $border-width;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-padding-y:               $input-btn-padding-y;\n$btn-padding-x:               $input-btn-padding-x;\n$btn-font-family:             $input-btn-font-family;\n$btn-font-size:               $input-btn-font-size;\n$btn-line-height:             $input-btn-line-height;\n$btn-white-space:             null; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm;\n$btn-padding-x-sm:            $input-btn-padding-x-sm;\n$btn-font-size-sm:            $input-btn-font-size-sm;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg;\n$btn-padding-x-lg:            $input-btn-padding-x-lg;\n$btn-font-size-lg:            $input-btn-font-size-lg;\n\n$btn-border-width:            $input-btn-border-width;\n\n$btn-font-weight:             $font-weight-normal;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075);\n$btn-focus-width:             $input-btn-focus-width;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow;\n$btn-disabled-opacity:        .65;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125);\n\n$btn-link-color:              $link-color;\n$btn-link-hover-color:        $link-hover-color;\n$btn-link-disabled-color:     $gray-600;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius;\n$btn-border-radius-sm:        $border-radius-sm;\n$btn-border-radius-lg:        $border-radius-lg;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$btn-hover-bg-shade-amount:       15%;\n$btn-hover-bg-tint-amount:        15%;\n$btn-hover-border-shade-amount:   20%;\n$btn-hover-border-tint-amount:    10%;\n$btn-active-bg-shade-amount:      20%;\n$btn-active-bg-tint-amount:       20%;\n$btn-active-border-shade-amount:  25%;\n$btn-active-border-tint-amount:   10%;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem;\n$form-text-font-size:                   $small-font-size;\n$form-text-font-style:                  null;\n$form-text-font-weight:                 null;\n$form-text-color:                       $text-muted;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem;\n$form-label-font-size:                  null;\n$form-label-font-style:                 null;\n$form-label-font-weight:                null;\n$form-label-color:                      null;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y;\n$input-padding-x:                       $input-btn-padding-x;\n$input-font-family:                     $input-btn-font-family;\n$input-font-size:                       $input-btn-font-size;\n$input-font-weight:                     $font-weight-base;\n$input-line-height:                     $input-btn-line-height;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm;\n$input-padding-x-sm:                    $input-btn-padding-x-sm;\n$input-font-size-sm:                    $input-btn-font-size-sm;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg;\n$input-padding-x-lg:                    $input-btn-padding-x-lg;\n$input-font-size-lg:                    $input-btn-font-size-lg;\n\n$input-bg:                              var(--#{$prefix}input-bg);\n$input-disabled-color:                  null;\n$input-disabled-bg:                     var(--#{$prefix}input-disabled-bg);\n$input-disabled-border-color:           null;\n\n$input-color:                           var(--#{$prefix}body-color);\n$input-border-color:                    var(--#{$prefix}input-border);\n$input-border-width:                    $input-btn-border-width;\n$input-box-shadow:                      $box-shadow-inset;\n\n$input-border-radius:                   $border-radius;\n$input-border-radius-sm:                $border-radius-sm;\n$input-border-radius-lg:                $border-radius-lg;\n\n$input-focus-bg:                        $input-bg;\n$input-focus-border-color:              var(--#{$prefix}input-focus-border);\n$input-focus-color:                     $input-color;\n$input-focus-width:                     $input-btn-focus-width;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow;\n\n$input-placeholder-color:               $gray-600;\n$input-plaintext-color:                 var(--#{$prefix}body-color);\n\n$input-height-border:                   $input-border-width * 2;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2);\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y);\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5);\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false));\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false));\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false));\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n$form-color-width:                      3rem;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1.1em;\n$form-check-min-height:                   $font-size-base * $line-height-base;\n$form-check-padding-start:                $form-check-input-width + .5em;\n$form-check-margin-bottom:                .125rem;\n$form-check-label-color:                  null;\n$form-check-label-cursor:                 null;\n$form-check-transition:                   null;\n\n$form-check-input-active-filter:          brightness(90%);\n\n$form-check-input-bg:                     $input-bg;\n$form-check-input-border:                 1px solid var(--#{$prefix}input-check-border);\n$form-check-input-border-radius:          .25em;\n$form-check-radio-border-radius:          50%;\n$form-check-input-focus-border:           $input-focus-border-color;\n$form-check-input-focus-box-shadow:       $input-btn-focus-box-shadow;\n\n$form-check-input-checked-color:          $component-active-color;\n$form-check-input-checked-bg-color:       $component-active-bg;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/></svg>\");\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\");\n\n$form-check-input-indeterminate-color:          $component-active-color;\n$form-check-input-indeterminate-bg-color:       $component-active-bg;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\");\n\n$form-check-input-disabled-opacity:        .5;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity;\n\n$form-check-inline-margin-end:    1rem;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba(0, 0, 0, .25);\n$form-switch-width:               2em;\n$form-switch-padding-start:       $form-switch-width + .5em;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\");\n$form-switch-border-radius:       $form-switch-width;\n$form-switch-transition:          background-position .15s ease-in-out;\n\n$form-switch-focus-color:         tint-color($component-active-bg, 50%);\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\");\n\n$form-switch-checked-color:       $component-active-color;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\");\n$form-switch-checked-bg-position: right center;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y;\n$input-group-addon-padding-x:           $input-padding-x;\n$input-group-addon-font-weight:         $input-font-weight;\n$input-group-addon-color:               $input-color;\n$input-group-addon-bg:                  var(--#{$prefix}input-group-addon-bg);\n$input-group-addon-border-color:        $input-border-color;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y;\n$form-select-padding-x:             $input-padding-x;\n$form-select-font-family:           $input-font-family;\n$form-select-font-size:             $input-font-size;\n$form-select-indicator-padding:     $form-select-padding-x * 3; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight;\n$form-select-line-height:           $input-line-height;\n$form-select-color:                 $input-color;\n$form-select-bg:                    $input-bg;\n$form-select-disabled-color:        null;\n$form-select-disabled-bg:           $input-disabled-bg;\n$form-select-disabled-border-color: $input-disabled-border-color;\n$form-select-bg-position:           right $form-select-padding-x center;\n$form-select-bg-size:               16px 12px; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\");\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half;\n\n$form-select-border-width:        $input-border-width;\n$form-select-border-color:        $input-border-color;\n$form-select-border-radius:       $border-radius;\n$form-select-box-shadow:          $box-shadow-inset;\n\n$form-select-focus-border-color:  $input-focus-border-color;\n$form-select-focus-width:         $input-focus-width;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color;\n\n$form-select-padding-y-sm:        $input-padding-y-sm;\n$form-select-padding-x-sm:        $input-padding-x-sm;\n$form-select-font-size-sm:        $input-font-size-sm;\n$form-select-border-radius-sm:    $input-border-radius-sm;\n\n$form-select-padding-y-lg:        $input-padding-y-lg;\n$form-select-padding-x-lg:        $input-padding-x-lg;\n$form-select-font-size-lg:        $input-font-size-lg;\n$form-select-border-radius-lg:    $input-border-radius-lg;\n\n$form-select-transition:          $input-transition;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100%;\n$form-range-track-height:         .5rem;\n$form-range-track-cursor:         pointer;\n$form-range-track-bg:             var(--#{$prefix}gray-300);\n$form-range-track-border-radius:  1rem;\n$form-range-track-box-shadow:     $box-shadow-inset;\n\n$form-range-thumb-width:                   1rem;\n$form-range-thumb-height:                  $form-range-thumb-width;\n$form-range-thumb-bg:                      $component-active-bg;\n$form-range-thumb-border:                  0;\n$form-range-thumb-border-radius:           1rem;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1);\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%);\n$form-range-thumb-disabled-bg:             $gray-500;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color;\n$form-file-button-bg:             $input-group-addon-bg;\n$form-file-button-hover-bg:       $input-group-addon-bg;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:            add(3.5rem, $input-height-border);\n$form-floating-line-height:       1.25;\n$form-floating-padding-x:         $input-padding-x;\n$form-floating-padding-y:         1rem;\n$form-floating-input-padding-t:   1.625rem;\n$form-floating-input-padding-b:   .625rem;\n$form-floating-label-opacity:     .65;\n$form-floating-label-transform:   scale(.85) translateY(-.5rem) translateX(.15rem);\n$form-floating-transition:        opacity .1s ease-in-out, transform .1s ease-in-out;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top;\n$form-feedback-font-size:           $form-text-font-size;\n$form-feedback-font-style:          $form-text-font-style;\n$form-feedback-valid-color:         $success;\n$form-feedback-invalid-color:       $danger;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\");\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\");\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": $form-feedback-valid-color,\n    \"icon\": $form-feedback-icon-valid\n  ),\n  \"invalid\": (\n    \"color\": $form-feedback-invalid-color,\n    \"icon\": $form-feedback-icon-invalid\n  )\n);\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000;\n$zindex-sticky:                     1020;\n$zindex-fixed:                      1030;\n$zindex-offcanvas-backdrop:         1040;\n$zindex-offcanvas:                  1045;\n$zindex-modal-backdrop:             1050;\n$zindex-modal:                      1055;\n$zindex-popover:                    1070;\n$zindex-tooltip:                    1080;\n$zindex-toast:                      1090;\n// scss-docs-end zindex-stack\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem;\n$nav-link-padding-x:                1rem;\n$nav-link-font-size:                null;\n$nav-link-font-weight:              null;\n$nav-link-color:                    $link-color;\n$nav-link-hover-color:              $link-hover-color;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out;\n$nav-link-disabled-color:           $gray-600;\n\n$nav-tabs-border-color:             var(--#{$prefix}gray-300);\n$nav-tabs-border-width:             $border-width;\n$nav-tabs-border-radius:            $border-radius;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}gray-300) var(--#{$prefix}gray-300) $nav-tabs-border-color;\n$nav-tabs-link-active-color:        $gray-700;\n$nav-tabs-link-active-bg:           var(--#{$prefix}nav-tabs-link-active-bg);\n$nav-tabs-link-active-border-color: var(--#{$prefix}gray-300) var(--#{$prefix}gray-300) $nav-tabs-link-active-bg;\n\n$nav-pills-border-radius:           $border-radius;\n$nav-pills-link-active-color:       $component-active-color;\n$nav-pills-link-active-bg:          $component-active-bg;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5;\n$navbar-padding-x:                  null;\n\n$navbar-nav-link-padding-x:         .5rem;\n\n$navbar-brand-font-size:            $font-size-lg;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5;\n$navbar-brand-margin-end:           1rem;\n\n$navbar-toggler-padding-y:          .25rem;\n$navbar-toggler-padding-x:          .75rem;\n$navbar-toggler-font-size:          $font-size-lg;\n$navbar-toggler-border-radius:      $btn-border-radius;\n$navbar-toggler-focus-width:        $btn-focus-width;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-theme-variables\n$navbar-dark-color:                 rgba($white, .55);\n$navbar-dark-hover-color:           rgba($white, .75);\n$navbar-dark-active-color:          $white;\n$navbar-dark-disabled-color:        rgba($white, .25);\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n$navbar-dark-toggler-border-color:  rgba($white, .1);\n\n$navbar-light-color:                rgba($black, .55);\n$navbar-light-hover-color:          rgba($black, .7);\n$navbar-light-active-color:         rgba($black, .9);\n$navbar-light-disabled-color:       rgba($black, .3);\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\n$navbar-light-toggler-border-color: rgba($black, .1);\n\n$navbar-light-brand-color:                $navbar-light-active-color;\n$navbar-light-brand-hover-color:          $navbar-light-active-color;\n$navbar-dark-brand-color:                 $navbar-dark-active-color;\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color;\n// scss-docs-end navbar-theme-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem;\n$dropdown-padding-x:                0;\n$dropdown-padding-y:                .5rem;\n$dropdown-spacer:                   .125rem;\n$dropdown-font-size:                $font-size-base;\n$dropdown-color:                    var(--#{$prefix}body-color);\n$dropdown-bg:                       $white;\n$dropdown-border-color:             var(--#{$prefix}border-color);\n$dropdown-border-radius:            $border-radius-lg;\n$dropdown-border-width:             0;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width);\n$dropdown-divider-bg:               $dropdown-border-color;\n$dropdown-divider-margin-y:         $spacer * .5;\n$dropdown-box-shadow:               $box-shadow-lg;\n\n$dropdown-link-color:               $gray-900;\n$dropdown-link-hover-color:         #{shade-color($gray-900, 10%)};\n$dropdown-link-hover-bg:            $gray-100;\n\n$dropdown-link-active-color:        #{shade-color($gray-900, 10%)};\n$dropdown-link-active-bg:           $gray-100;\n\n$dropdown-link-disabled-color:      $gray-500;\n\n$dropdown-item-padding-y:           0.35rem;\n$dropdown-item-padding-x:           1.2rem;\n\n$dropdown-header-color:             $gray-600;\n$dropdown-header-padding-x:         $dropdown-item-padding-x;\n$dropdown-header-padding-y:         $dropdown-padding-y;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x; // Deprecated in v5.2.0\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300;\n$dropdown-dark-bg:                  $gray-800;\n$dropdown-dark-border-color:        $dropdown-border-color;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg;\n$dropdown-dark-box-shadow:          null;\n$dropdown-dark-link-color:          $dropdown-dark-color;\n$dropdown-dark-link-hover-color:    $white;\n$dropdown-dark-link-hover-bg:       rgba($white, .15);\n$dropdown-dark-link-active-color:   $white;\n$dropdown-dark-link-active-bg:      lighten($dropdown-dark-bg, 5%);\n$dropdown-dark-link-disabled-color: $gray-500;\n$dropdown-dark-header-color:        $gray-500;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem;\n$pagination-padding-x:              .75rem;\n$pagination-padding-y-sm:           .25rem;\n$pagination-padding-x-sm:           .5rem;\n$pagination-padding-y-lg:           .6rem;\n$pagination-padding-x-lg:           1.2rem;\n\n$pagination-font-size:              $font-size-base;\n$pagination-color:                  $link-color;\n$pagination-bg:                     var(--#{$prefix}card-bg-custom);\n$pagination-border-width:           $border-width;\n$pagination-border-radius:          $border-radius;\n$pagination-margin-start:           -$pagination-border-width;\n$pagination-border-color:           var(--#{$prefix}border-color);\n\n$pagination-focus-color:            $link-hover-color;\n$pagination-focus-bg:               $gray-200;\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow;\n$pagination-focus-outline:          0;\n\n$pagination-hover-color:            $link-hover-color;\n$pagination-hover-bg:               $gray-200;\n$pagination-hover-border-color:     var(--#{$prefix}border-color);\n\n$pagination-active-color:           $component-active-color;\n$pagination-active-bg:              $component-active-bg;\n$pagination-active-border-color:    $pagination-active-bg;\n\n$pagination-disabled-color:         $gray-600;\n$pagination-disabled-bg:            $pagination-bg;\n$pagination-disabled-border-color:  $pagination-border-color;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\n\n$pagination-border-radius-sm:       $border-radius-sm;\n$pagination-border-radius-lg:       $border-radius-lg;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5;\n$placeholder-opacity-min:           .2;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer;\n$card-spacer-x:                     $spacer;\n$card-title-spacer-y:               $spacer * .5;\n$card-border-width:                 0;\n$card-border-color:                 rgba($black, .125);\n$card-border-radius:                $border-radius;\n$card-box-shadow:                   $box-shadow;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width);\n$card-cap-padding-y:                $card-spacer-y;\n$card-cap-padding-x:                $card-spacer-x;\n$card-cap-bg:                       $white;\n$card-cap-color:                    null;\n$card-height:                       null;\n$card-color:                        null;\n$card-bg:                           $white;\n$card-img-overlay-padding:          $spacer;\n$card-group-margin:                 $grid-gutter-width * .5;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem;\n$accordion-padding-x:                     1.25rem;\n$accordion-color:                         var(--#{$prefix}body-color);\n$accordion-bg:                            $white;\n$accordion-border-width:                  $border-width;\n$accordion-border-color:                  var(--#{$prefix}border-color);\n$accordion-border-radius:                 $border-radius;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width);\n\n$accordion-body-padding-y:                $accordion-padding-y;\n$accordion-body-padding-x:                $accordion-padding-x;\n\n$accordion-button-padding-y:              $accordion-padding-y;\n$accordion-button-padding-x:              $accordion-padding-x;\n$accordion-button-color:                  $accordion-color;\n$accordion-button-bg:                     $accordion-bg;\n$accordion-transition:                    $btn-transition, border-radius .15s ease;\n$accordion-button-active-bg:              rgba($component-active-bg, 0.05);\n$accordion-button-active-color:           shade-color($primary, 10%);\n\n$accordion-button-focus-border-color:     $input-focus-border-color;\n$accordion-button-focus-box-shadow:       inset 0 ($accordion-border-width * -1) 0 $accordion-border-color;\n\n$accordion-icon-width:                    0.75rem;\n$accordion-icon-color:                    $accordion-color;\n$accordion-icon-active-color:             $accordion-button-active-color;\n$accordion-icon-transition:               transform .2s ease-in-out;\n$accordion-icon-transform:                rotate(-180deg);\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm;\n$tooltip-max-width:                 200px;\n$tooltip-color:                     $white;\n$tooltip-bg:                        $black;\n$tooltip-border-radius:             $border-radius-sm;\n$tooltip-opacity:                   .9;\n$tooltip-padding-y:                 $spacer * .4;\n$tooltip-padding-x:                 $spacer * .7;\n$tooltip-margin:                    0;\n\n$tooltip-arrow-width:               .8rem;\n$tooltip-arrow-height:              .4rem;\n$tooltip-arrow-color:               $tooltip-bg;\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x;\n$form-feedback-tooltip-font-size:     $tooltip-font-size;\n$form-feedback-tooltip-line-height:   null;\n$form-feedback-tooltip-opacity:       $tooltip-opacity;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-base;\n$popover-bg:                        $white;\n$popover-max-width:                 276px;\n$popover-border-width:              $border-width;\n$popover-border-color:              var(--#{$prefix}border-color);\n$popover-border-radius:             $border-radius;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width);\n$popover-box-shadow:                $box-shadow-lg;\n\n$popover-header-font-size:          $font-size-base;\n$popover-header-bg:                 var(--#{$prefix}popover-bg);\n$popover-header-color:              $headings-color;\n$popover-header-padding-y:          .7rem;\n$popover-header-padding-x:          $spacer;\n\n$popover-body-color:                var(--#{$prefix}body-color);\n$popover-body-padding-y:            $spacer;\n$popover-body-padding-x:            $spacer;\n\n$popover-arrow-width:               1rem;\n$popover-arrow-height:              .5rem;\n$popover-arrow-color:               var(--#{$prefix}popover-bg);\n\n$popover-arrow-outer-color:         var(--#{$prefix}border-color);\n// scss-docs-end popover-variables\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px;\n$toast-padding-x:                   .75rem;\n$toast-padding-y:                   .5rem;\n$toast-font-size:                   .875rem;\n$toast-color:                       null;\n$toast-background-color:            rgba($white, .85);\n$toast-border-width:                1px;\n$toast-border-color:                rgba($black, .1);\n$toast-border-radius:               $border-radius;\n$toast-box-shadow:                  $box-shadow;\n$toast-spacing:                     $container-padding-x;\n\n$toast-header-color:                $gray-600;\n$toast-header-background-color:     rgba($white, .85);\n$toast-header-border-color:         rgba($black, .05);\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em;\n$badge-font-weight:                 $font-weight-semibold;\n$badge-color:                       $white;\n$badge-padding-y:                   .35em;\n$badge-padding-x:                   .65em;\n$badge-border-radius:               $border-radius;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer * 1.25;\n\n// Margin between elements in footer, must be lower than or equal to 2 * $modal-inner-padding\n$modal-footer-margin-between:       .5rem;\n\n$modal-dialog-margin:               .5rem;\n$modal-dialog-margin-y-sm-up:       1.75rem;\n\n$modal-title-line-height:           $line-height-base;\n\n$modal-content-color:               null;\n$modal-content-bg:                  $white;\n$modal-content-border-color:        $border-color;\n$modal-content-border-width:        $border-width;\n$modal-content-border-radius:       $border-radius-lg;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width);\n$modal-content-box-shadow-xs:       $box-shadow-sm;\n$modal-content-box-shadow-sm-up:    $box-shadow;\n\n$modal-backdrop-bg:                 $black;\n$modal-backdrop-opacity:            .5;\n$modal-header-border-color:         $border-color;\n$modal-footer-border-color:         $modal-header-border-color;\n$modal-header-border-width:         0;\n$modal-footer-border-width:         $modal-header-border-width;\n$modal-header-padding-y:            $modal-inner-padding;\n$modal-header-padding-x:            $modal-inner-padding;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null;\n$modal-sm:                          300px;\n$modal-md:                          500px;\n$modal-lg:                          800px;\n$modal-xl:                          1140px;\n\n$modal-fade-transform:              translate(0, -50px);\n$modal-show-transform:              none;\n$modal-transition:                  transform .3s ease-out;\n$modal-scale-transform:             scale(1.02);\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer * 0.8;\n$alert-padding-x:               $spacer;\n$alert-margin-bottom:           1rem;\n$alert-border-radius:           $border-radius;\n$alert-link-font-weight:        $font-weight-semibold;\n$alert-border-width:            $border-width;\n$alert-bg-scale:                -85%;\n$alert-border-scale:            -70%;\n$alert-color-scale:             25%;\n$alert-dismissible-padding-r:   $alert-padding-x * 3; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   0.625rem;\n$progress-font-size:                $font-size-base * .75;\n$progress-bg:                       $gray-200;\n$progress-border-radius:            $border-radius;\n$progress-box-shadow:               $box-shadow-inset;\n$progress-bar-color:                $white;\n$progress-bar-bg:                   $primary;\n$progress-bar-animation-timing:     1s linear infinite;\n$progress-bar-transition:           width .6s ease;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color);\n$list-group-bg:                     var(--#{$prefix}card-bg-custom);\n$list-group-border-color:           var(--#{$prefix}border-color);\n$list-group-border-width:           $border-width;\n$list-group-border-radius:          $border-radius;\n\n$list-group-item-padding-y:         $spacer * .7;\n$list-group-item-padding-x:         $spacer;\n$list-group-item-bg-scale:          -80%;\n$list-group-item-color-scale:       40%;\n\n$list-group-hover-bg:               var(--#{$prefix}list-group-hover-bg);\n$list-group-active-color:           $component-active-color;\n$list-group-active-bg:              $component-active-bg;\n$list-group-active-border-color:    $list-group-active-bg;\n\n$list-group-disabled-color:         $gray-600;\n$list-group-disabled-bg:            $list-group-bg;\n\n$list-group-action-color:           var(--#{$prefix}body-color);\n$list-group-action-hover-color:     $list-group-action-color;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color);\n$list-group-action-active-bg:       var(--#{$prefix}list-group-hover-bg);;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem;\n$thumbnail-bg:                      var(--#{$prefix}body-bg);\n$thumbnail-border-width:            $border-width;\n$thumbnail-border-color:            var(--#{$prefix}border-color);\n$thumbnail-border-radius:           $border-radius;\n$thumbnail-box-shadow:              $box-shadow-sm;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size;\n$figure-caption-color:              $gray-600;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null;\n$breadcrumb-padding-y:              0;\n$breadcrumb-padding-x:              0;\n$breadcrumb-item-padding-x:         .5rem;\n$breadcrumb-margin-bottom:          1rem;\n$breadcrumb-bg:                     null;\n$breadcrumb-divider-color:          $gray-600;\n$breadcrumb-active-color:           $gray-600;\n$breadcrumb-divider:                quote(\"\\F0142\");\n$breadcrumb-divider-flipped:        $breadcrumb-divider;\n$breadcrumb-border-radius:          null;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white;\n$carousel-control-width:             15%;\n$carousel-control-opacity:           .5;\n$carousel-control-hover-opacity:     .9;\n$carousel-control-transition:        opacity .15s ease;\n\n$carousel-indicator-width:           30px;\n$carousel-indicator-height:          3px;\n$carousel-indicator-hit-area-height: 10px;\n$carousel-indicator-spacer:          3px;\n$carousel-indicator-opacity:         .5;\n$carousel-indicator-active-bg:       $white;\n$carousel-indicator-active-opacity:  1;\n$carousel-indicator-transition:      opacity .6s ease;\n\n$carousel-caption-width:             70%;\n$carousel-caption-color:             $white;\n$carousel-caption-padding-y:         1.25rem;\n$carousel-caption-spacer:            1.25rem;\n\n$carousel-control-icon-width:        2rem;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\");\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\");\n\n$carousel-transition-duration:       .6s;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n\n$carousel-dark-indicator-active-bg:  $black;\n$carousel-dark-caption-color:        $black;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100);\n// scss-docs-end carousel-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem;\n$spinner-height:          $spinner-width;\n$spinner-vertical-align:  -.125em;\n$spinner-border-width:    .25em;\n$spinner-animation-speed: .75s;\n\n$spinner-width-sm:        1rem;\n$spinner-height-sm:       $spinner-width-sm;\n$spinner-border-width-sm: .2em;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em;\n$btn-close-height:           $btn-close-width;\n$btn-close-padding-x:        .25em;\n$btn-close-padding-y:        $btn-close-padding-x;\n$btn-close-color:            $black;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\");\n$btn-close-focus-shadow:     $input-btn-focus-box-shadow;\n$btn-close-opacity:          .5;\n$btn-close-hover-opacity:    .75;\n$btn-close-focus-opacity:    1;\n$btn-close-disabled-opacity: .25;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%);\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding;\n$offcanvas-padding-x:               $modal-inner-padding;\n$offcanvas-horizontal-width:        400px;\n$offcanvas-vertical-height:         30vh;\n$offcanvas-transition-duration:     .3s;\n$offcanvas-border-color:            $modal-content-border-color;\n$offcanvas-border-width:            $modal-content-border-width;\n$offcanvas-title-line-height:       $modal-title-line-height;\n$offcanvas-bg-color:                $modal-content-bg;\n$offcanvas-color:                   $modal-content-color;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size;\n$code-color:                        $pink;\n\n$kbd-padding-y:                     .2rem;\n$kbd-padding-x:                     .4rem;\n$kbd-font-size:                     $code-font-size;\n$kbd-color:                         $white;\n$kbd-bg:                            $gray-900;\n$nested-kbd-font-weight:            $font-weight-bold;; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null;\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: divide(100%, $count);\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  color: var(--#{$prefix}table-color);\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-accent-bg);\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: ($table-border-width * 2) solid $table-group-separator-color;\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-accent-bg: var(--#{$prefix}table-striped-bg);\n    color: var(--#{$prefix}table-striped-color);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-accent-bg: var(--#{$prefix}table-striped-bg);\n    color: var(--#{$prefix}table-striped-color);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-accent-bg: var(--#{$prefix}table-active-bg);\n  color: var(--#{$prefix}table-active-color);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-accent-bg: var(--#{$prefix}table-hover-bg);\n    color: var(--#{$prefix}table-hover-color);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","// Bootstrap functions\n//\n// Utility mixins and functions for evaluating source code across our variables, maps, and mixins.\n\n// Ascending\n// Used to evaluate Sass maps like our grid breakpoints.\n@mixin _assert-ascending($map, $map-name) {\n  $prev-key: null;\n  $prev-num: null;\n  @each $key, $num in $map {\n    @if $prev-num == null or unit($num) == \"%\" or unit($prev-num) == \"%\" {\n      // Do nothing\n    } @else if not comparable($prev-num, $num) {\n      @warn \"Potentially invalid value for #{$map-name}: This map must be in ascending order, but key '#{$key}' has value #{$num} whose unit makes it incomparable to #{$prev-num}, the value of the previous key '#{$prev-key}' !\";\n    } @else if $prev-num >= $num {\n      @warn \"Invalid value for #{$map-name}: This map must be in ascending order, but key '#{$key}' has value #{$num} which isn't greater than #{$prev-num}, the value of the previous key '#{$prev-key}' !\";\n    }\n    $prev-key: $key;\n    $prev-num: $num;\n  }\n}\n\n// Starts at zero\n// Used to ensure the min-width of the lowest breakpoint starts at 0.\n@mixin _assert-starts-at-zero($map, $map-name: \"$grid-breakpoints\") {\n  @if length($map) > 0 {\n    $values: map-values($map);\n    $first-value: nth($values, 1);\n    @if $first-value != 0 {\n      @warn \"First breakpoint in #{$map-name} must start at 0, but starts at #{$first-value}.\";\n    }\n  }\n}\n\n// Colors\n@function to-rgb($value) {\n  @return red($value), green($value), blue($value);\n}\n\n// stylelint-disable scss/dollar-variable-pattern\n@function rgba-css-var($identifier, $target) {\n  @if $identifier == \"body\" and $target == \"bg\" {\n    @return rgba(var(--#{$prefix}#{$identifier}-bg-rgb), var(--#{$prefix}#{$target}-opacity));\n  } @if $identifier == \"body\" and $target == \"text\" {\n    @return rgba(var(--#{$prefix}#{$identifier}-color-rgb), var(--#{$prefix}#{$target}-opacity));\n  } @else {\n    @return rgba(var(--#{$prefix}#{$identifier}-rgb), var(--#{$prefix}#{$target}-opacity));\n  }\n}\n\n@function map-loop($map, $func, $args...) {\n  $_map: ();\n\n  @each $key, $value in $map {\n    // allow to pass the $key and $value of the map as an function argument\n    $_args: ();\n    @each $arg in $args {\n      $_args: append($_args, if($arg == \"$key\", $key, if($arg == \"$value\", $value, $arg)));\n    }\n\n    $_map: map-merge($_map, ($key: call(get-function($func), $_args...)));\n  }\n\n  @return $_map;\n}\n// stylelint-enable scss/dollar-variable-pattern\n\n@function varify($list) {\n  $result: null;\n  @each $entry in $list {\n    $result: append($result, var(--#{$prefix}#{$entry}), space);\n  }\n  @return $result;\n}\n\n// Internal Bootstrap function to turn maps into its negative variant.\n// It prefixes the keys with `n` and makes the value negative.\n@function negativify-map($map) {\n  $result: ();\n  @each $key, $value in $map {\n    @if $key != 0 {\n      $result: map-merge($result, (\"n\" + $key: (-$value)));\n    }\n  }\n  @return $result;\n}\n\n// Get multiple keys from a sass map\n@function map-get-multiple($map, $values) {\n  $result: ();\n  @each $key, $value in $map {\n    @if (index($values, $key) != null) {\n      $result: map-merge($result, ($key: $value));\n    }\n  }\n  @return $result;\n}\n\n// Merge multiple maps\n@function map-merge-multiple($maps...) {\n  $merged-maps: ();\n\n  @each $map in $maps {\n    $merged-maps: map-merge($merged-maps, $map);\n  }\n  @return $merged-maps;\n}\n\n// Replace `$search` with `$replace` in `$string`\n// Used on our SVG icon backgrounds for custom forms.\n//\n// @author Kitty Giraudel\n// @param {String} $string - Initial string\n// @param {String} $search - Substring to replace\n// @param {String} $replace ('') - New value\n// @return {String} - Updated string\n@function str-replace($string, $search, $replace: \"\") {\n  $index: str-index($string, $search);\n\n  @if $index {\n    @return str-slice($string, 1, $index - 1) + $replace + str-replace(str-slice($string, $index + str-length($search)), $search, $replace);\n  }\n\n  @return $string;\n}\n\n// See https://codepen.io/kevinweber/pen/dXWoRw\n//\n// Requires the use of quotes around data URIs.\n\n@function escape-svg($string) {\n  @if str-index($string, \"data:image/svg+xml\") {\n    @each $char, $encoded in $escaped-characters {\n      // Do not escape the url brackets\n      @if str-index($string, \"url(\") == 1 {\n        $string: url(\"#{str-replace(str-slice($string, 6, -3), $char, $encoded)}\");\n      } @else {\n        $string: str-replace($string, $char, $encoded);\n      }\n    }\n  }\n\n  @return $string;\n}\n\n// Color contrast\n// See https://github.com/twbs/bootstrap/pull/30168\n\n// A list of pre-calculated numbers of pow(divide((divide($value, 255) + .055), 1.055), 2.4). (from 0 to 255)\n// stylelint-disable-next-line scss/dollar-variable-default, scss/dollar-variable-pattern\n$_luminance-list: .0008 .001 .0011 .0013 .0015 .0017 .002 .0022 .0025 .0027 .003 .0033 .0037 .004 .0044 .0048 .0052 .0056 .006 .0065 .007 .0075 .008 .0086 .0091 .0097 .0103 .011 .0116 .0123 .013 .0137 .0144 .0152 .016 .0168 .0176 .0185 .0194 .0203 .0212 .0222 .0232 .0242 .0252 .0262 .0273 .0284 .0296 .0307 .0319 .0331 .0343 .0356 .0369 .0382 .0395 .0409 .0423 .0437 .0452 .0467 .0482 .0497 .0513 .0529 .0545 .0561 .0578 .0595 .0612 .063 .0648 .0666 .0685 .0704 .0723 .0742 .0762 .0782 .0802 .0823 .0844 .0865 .0887 .0908 .0931 .0953 .0976 .0999 .1022 .1046 .107 .1095 .1119 .1144 .117 .1195 .1221 .1248 .1274 .1301 .1329 .1356 .1384 .1413 .1441 .147 .15 .1529 .1559 .159 .162 .1651 .1683 .1714 .1746 .1779 .1812 .1845 .1878 .1912 .1946 .1981 .2016 .2051 .2086 .2122 .2159 .2195 .2232 .227 .2307 .2346 .2384 .2423 .2462 .2502 .2542 .2582 .2623 .2664 .2705 .2747 .2789 .2831 .2874 .2918 .2961 .3005 .305 .3095 .314 .3185 .3231 .3278 .3325 .3372 .3419 .3467 .3515 .3564 .3613 .3663 .3712 .3763 .3813 .3864 .3916 .3968 .402 .4072 .4125 .4179 .4233 .4287 .4342 .4397 .4452 .4508 .4564 .4621 .4678 .4735 .4793 .4851 .491 .4969 .5029 .5089 .5149 .521 .5271 .5333 .5395 .5457 .552 .5583 .5647 .5711 .5776 .5841 .5906 .5972 .6038 .6105 .6172 .624 .6308 .6376 .6445 .6514 .6584 .6654 .6724 .6795 .6867 .6939 .7011 .7084 .7157 .7231 .7305 .7379 .7454 .7529 .7605 .7682 .7758 .7835 .7913 .7991 .807 .8148 .8228 .8308 .8388 .8469 .855 .8632 .8714 .8796 .8879 .8963 .9047 .9131 .9216 .9301 .9387 .9473 .956 .9647 .9734 .9823 .9911 1;\n\n@function color-contrast($background, $color-contrast-dark: $color-contrast-dark, $color-contrast-light: $color-contrast-light, $min-contrast-ratio: $min-contrast-ratio) {\n  $foregrounds: $color-contrast-light, $color-contrast-dark, $white, $black;\n  $max-ratio: 0;\n  $max-ratio-color: null;\n\n  @each $color in $foregrounds {\n    $contrast-ratio: contrast-ratio($background, $color);\n    @if $contrast-ratio > $min-contrast-ratio {\n      @return $color;\n    } @else if $contrast-ratio > $max-ratio {\n      $max-ratio: $contrast-ratio;\n      $max-ratio-color: $color;\n    }\n  }\n\n  @warn \"Found no color leading to #{$min-contrast-ratio}:1 contrast ratio against #{$background}...\";\n\n  @return $max-ratio-color;\n}\n\n@function contrast-ratio($background, $foreground: $color-contrast-light) {\n  $l1: luminance($background);\n  $l2: luminance(opaque($background, $foreground));\n\n  @return if($l1 > $l2, divide($l1 + .05, $l2 + .05), divide($l2 + .05, $l1 + .05));\n}\n\n// Return WCAG2.1 relative luminance\n// See https://www.w3.org/TR/WCAG/#dfn-relative-luminance\n// See https://www.w3.org/TR/WCAG/#dfn-contrast-ratio\n@function luminance($color) {\n  $rgb: (\n    \"r\": red($color),\n    \"g\": green($color),\n    \"b\": blue($color)\n  );\n\n  @each $name, $value in $rgb {\n    $value: if(divide($value, 255) < .03928, divide(divide($value, 255), 12.92), nth($_luminance-list, $value + 1));\n    $rgb: map-merge($rgb, ($name: $value));\n  }\n\n  @return (map-get($rgb, \"r\") * .2126) + (map-get($rgb, \"g\") * .7152) + (map-get($rgb, \"b\") * .0722);\n}\n\n// Return opaque color\n// opaque(#fff, rgba(0, 0, 0, .5)) => #808080\n@function opaque($background, $foreground) {\n  @return mix(rgba($foreground, 1), $background, opacity($foreground) * 100%);\n}\n\n// scss-docs-start color-functions\n// Tint a color: mix a color with white\n@function tint-color($color, $weight) {\n  @return mix(white, $color, $weight);\n}\n\n// Shade a color: mix a color with black\n@function shade-color($color, $weight) {\n  @return mix(black, $color, $weight);\n}\n\n// Shade the color if the weight is positive, else tint it\n@function shift-color($color, $weight) {\n  @return if($weight > 0, shade-color($color, $weight), tint-color($color, -$weight));\n}\n// scss-docs-end color-functions\n\n// Return valid calc\n@function add($value1, $value2, $return-calc: true) {\n  @if $value1 == null {\n    @return $value2;\n  }\n\n  @if $value2 == null {\n    @return $value1;\n  }\n\n  @if type-of($value1) == number and type-of($value2) == number and comparable($value1, $value2) {\n    @return $value1 + $value2;\n  }\n\n  @return if($return-calc == true, calc(#{$value1} + #{$value2}), $value1 + unquote(\" + \") + $value2);\n}\n\n@function subtract($value1, $value2, $return-calc: true) {\n  @if $value1 == null and $value2 == null {\n    @return null;\n  }\n\n  @if $value1 == null {\n    @return -$value2;\n  }\n\n  @if $value2 == null {\n    @return $value1;\n  }\n\n  @if type-of($value1) == number and type-of($value2) == number and comparable($value1, $value2) {\n    @return $value1 - $value2;\n  }\n\n  @if type-of($value2) != number {\n    $value2: unquote(\"(\") + $value2 + unquote(\")\");\n  }\n\n  @return if($return-calc == true, calc(#{$value1} - #{$value2}), $value1 + unquote(\" - \") + $value2);\n}\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  // Add some height to date inputs on iOS\n  // https://github.com/twbs/bootstrap/issues/23307\n  // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n  &::-webkit-date-and-time-value {\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  -moz-padding-start: subtract($form-select-padding-x, 3px); // See https://github.com/twbs/bootstrap/issues/32636\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  background-color: $form-select-bg;\n  background-image: escape-svg($form-select-indicator);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n  appearance: none;\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  background-color: $form-check-input-bg;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  appearance: none;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        background-image: escape-svg($form-check-input-checked-bg-image), var(--#{$prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-check-input-checked-bg-image);\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        background-image: escape-svg($form-check-radio-checked-bg-image), var(--#{$prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-check-radio-checked-bg-image);\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      background-image: escape-svg($form-check-input-indeterminate-bg-image), var(--#{$prefix}gradient);\n    } @else {\n      background-image: escape-svg($form-check-input-indeterminate-bg-image);\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: escape-svg($form-switch-bg-image);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      background-image: escape-svg($form-switch-focus-bg-image);\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        background-image: escape-svg($form-switch-checked-bg-image), var(--#{$prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-switch-checked-bg-image);\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      opacity: $form-floating-label-opacity;\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      opacity: $form-floating-label-opacity;\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: -$input-border-width;\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity)\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-image: escape-svg($form-select-indicator), escape-svg($icon);\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$body-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: none;\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix(color-contrast($primary), $primary, 15%))};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    background: none;\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n\n    &.disabled,\n    &:disabled {\n      color: var(--#{$prefix}nav-link-disabled-color);\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n\n    &:disabled {\n      color: var(--#{$prefix}nav-link-disabled-color);\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .show > .nav-link,\n  .nav-link.active {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-border-color: #{$accordion-button-focus-border-color};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: var(--#{$prefix}accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == ($pagination-border-width * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $state, $value in $theme-colors {\n  $alert-background: shift-color($value, $alert-bg-scale);\n  $alert-border: shift-color($value, $alert-border-scale);\n  $alert-color: shift-color($value, $alert-color-scale);\n\n  @if (contrast-ratio($alert-background, $alert-color) < $min-contrast-ratio) {\n    $alert-color: mix($value, color-contrast($alert-background), abs($alert-color-scale));\n  }\n  .alert-#{$state} {\n    @include alert-variant($alert-background, $alert-border, $alert-color);\n  }\n}\n// scss-docs-end alert-modifiers\n","// scss-docs-start alert-variant-mixin\n@mixin alert-variant($background, $border, $color) {\n  --#{$prefix}alert-color: #{$color};\n  --#{$prefix}alert-bg: #{$background};\n  --#{$prefix}alert-border-color: #{$border};\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n\n  .alert-link {\n    color: shade-color($color, 20%);\n  }\n}\n// scss-docs-end alert-variant-mixin\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state, $value in $theme-colors {\n  $list-group-variant-bg: shift-color($value, $list-group-item-bg-scale);\n  $list-group-variant-color: shift-color($value, $list-group-item-color-scale);\n  @if (contrast-ratio($list-group-variant-bg, $list-group-variant-color) < $min-contrast-ratio) {\n    $list-group-variant-color: mix($value, color-contrast($list-group-variant-bg), abs($list-group-item-color-scale));\n  }\n\n  @include list-group-item-variant($state, $list-group-variant-bg, $list-group-variant-color);\n}\n// scss-docs-end list-group-modifiers\n","// List Groups\n\n// scss-docs-start list-group-mixin\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      &:hover,\n      &:focus {\n        color: $color;\n        background-color: shade-color($background, 10%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n// scss-docs-end list-group-mixin\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: $btn-close-color;\n  background: transparent escape-svg($btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: $btn-close-opacity;\n\n  // Override <a>'s hover style\n  &:hover {\n    color: $btn-close-color;\n    text-decoration: none;\n    opacity: $btn-close-hover-opacity;\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: $btn-close-focus-shadow;\n    opacity: $btn-close-focus-opacity;\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: $btn-close-disabled-opacity;\n  }\n}\n\n.btn-close-white {\n  filter: $btn-close-white-filter;\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  padding: var(--#{$prefix}tooltip-arrow-height);\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: 0;\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: 0;\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: 0;\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: 0;\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n.carousel-dark {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(transform $offcanvas-transition-duration ease-in-out);\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: $offcanvas-title-line-height;\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// stylelint-disable function-name-case\n\n// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  $color-rgb: to-rgb($value);\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA($color-rgb, var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: $value !important; // stylelint-disable-line declaration-no-important\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage)) !important; // stylelint-disable-line declaration-no-important\n      }\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: 1px;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix, $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","/*\nTemplate Name: Velzon - Admin & Dashboard Template\nAuthor: Themesbrand\nVersion: 2.4.0\nWebsite: https://themesbrand.com/\nContact: support@themesbrand.com\nFile: Main Css File\n*/\n\n\n//Fonts\n@import \"../../fonts/fonts\";\n\n//Core files\n@import \"./node_modules/bootstrap/scss/functions\";\n@import \"./node_modules/bootstrap/scss/variables\";\n@import \"variables\";\n@import \"./node_modules/bootstrap/scss/mixins\";\n\n@import \"theme-light\";\n@import \"theme-dark\";\n\n// Structure\n@import \"../../structure/topbar\";\n@import \"../../structure/page-head\";\n@import \"../../structure/footer\";\n@import \"../../structure/vertical\";\n@import \"../../structure/horizontal\";\n@import \"../../structure/two-column\";\n@import \"../../structure/layouts\";\n\n// Components\n@import \"../../components/waves\";\n@import \"../../components/avatar\";\n@import \"../../components/accordion\";\n@import \"../../components/helper\";\n@import \"../../components/preloader\";\n@import \"../../components/forms\";\n@import \"../../components/widgets\";\n@import \"../../components/demos\";\n@import \"../../components/print\";\n@import \"../../components/ribbons\";\n@import \"../../components/toast\";\n@import \"../../components/scrollspy\";\n\n// Bootstrap components\n@import \"../../components/reboot\";\n@import \"../../components/alerts\";\n@import \"../../components/backgrounds\";\n@import \"../../components/badge\";\n@import \"../../components/buttons\";\n@import \"../../components/breadcrumb\";\n@import \"../../components/card\";\n@import \"../../components/dropdown\";\n@import \"../../components/nav\";\n@import \"../../components/table\";\n@import \"../../components/modal\";\n@import \"../../components/pagination\";\n@import \"../../components/progress\";\n@import \"../../components/popover\";\n@import \"../../components/type\";\n@import \"../../components/form-check\";\n@import \"../../components/form-control\";\n@import \"../../components/list-group\";\n\n// Plugins\n@import \"../../plugins/custom-scrollbar\";\n@import \"../../plugins/prismjs\";\n@import \"../../plugins/sweetalert2\";\n@import \"../../plugins/dropzone\";\n@import \"../../plugins/range-slider\";\n@import \"../../plugins/sortablejs\";\n@import \"../../plugins/tour\";\n@import \"../../plugins/swiper\";\n@import \"../../plugins/multijs\";\n@import \"../../plugins/colorpicker\";\n@import \"../../plugins/filepond\";\n@import \"../../plugins/form-input-spin\";\n@import \"../../plugins/ckeditor\";\n@import \"../../plugins/quilljs\";\n@import \"../../plugins/gridjs\";\n@import \"../../plugins/listjs\";\n@import \"../../plugins/apexcharts\";\n@import \"../../plugins/chartjs\";\n@import \"../../plugins/echarts\";\n@import \"../../plugins/google-map\";\n@import \"../../plugins/autocomplete\";\n@import \"../../plugins/vector-maps\";\n@import \"../../plugins/leaflet-maps\";\n@import \"../../plugins/fullcalendar\";\n@import \"../../plugins/emoji-picker\";\n@import \"../../plugins/datatables\";\n@import \"../../plugins/select2\";\n\n// Plugins\n@import \"../../plugins/toastify\";\n@import \"../../plugins/choices\";\n@import \"../../plugins/flatpicker\";\n@import \"../../plugins/flag-input\";\n\n// Pages\n@import \"../../pages/authentication\";\n@import \"../../pages/dashboard\";\n@import \"../../pages/timeline\";\n@import \"../../pages/gallery\";\n@import \"../../pages/errors\";\n@import \"../../pages/profile\";\n@import \"../../pages/sitemap\";\n@import \"../../pages/team\";\n@import \"../../pages/coming-soon\";\n@import \"../../pages/search-results\";\n@import \"../../pages/ecommerce\";\n@import \"../../pages/invoice\";\n@import \"../../pages/chat\";\n@import \"../../pages/email\";\n@import \"../../pages/kanban\";\n@import \"../../pages/landing\";\n@import \"../../pages/nft-landing\";\n@import \"../../pages/file-manager\";\n@import \"../../pages/to-do\";\n@import \"../../pages/jobs\";\n@import \"../../pages/job-landing\";","//\n// Google font - Poppins\n//\n\n@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');\n\n//\n// Premium Font : HKGrotesk\n//\n\n@font-face {\n    font-family: \"hkgrotesk\";\n    src: url(\"../../fonts/hkgrotesk-light.eot\");\n    src: local('hkgrotesk light'), url(\"../../fonts/hkgrotesk-light.woff\") format(\"woff\");\n    font-weight: 300;\n}\n\n@font-face {\n    font-family: \"hkgrotesk\";\n    src: url(\"../../fonts/hkgrotesk-regular.eot\");\n    src: local('hkgrotesk regular'), url(\"../../fonts/hkgrotesk-regular.woff\") format(\"woff\");\n    font-weight: 400;\n}\n@font-face {\n    font-family: \"hkgrotesk\";\n    src: url(\"../../fonts/hkgrotesk-medium.eot\");\n    src: local('hkgrotesk medium'), url(\"../../fonts/hkgrotesk-medium.woff\") format(\"woff\");\n    font-weight: 500;\n}\n@font-face {\n    font-family: \"hkgrotesk\";\n    src: url(\"../../fonts/hkgrotesk-semibold.eot\");\n    src: local('hkgrotesk semibold'), url(\"../../fonts/hkgrotesk-semibold.woff\") format(\"woff\");\n    font-weight: 600;\n}\n@font-face {\n    font-family: \"hkgrotesk\";\n    // src: url(\"../../fonts/hkgrotesk-bold.eot\");\n    src: local('hkgrotesk bold'), url(\"../../fonts/hkgrotesk-bold.woff\") format(\"woff\");\n    font-weight: 700;\n}","// :root CSS variables\n\n:root{\n\n    //vertical light\n  --#{$prefix}vertical-menu-bg:                      #{$white};\n  --#{$prefix}vertical-menu-item-color:              #{darken($gray-600, 10%)};\n  --#{$prefix}vertical-menu-item-hover-color:        #{$primary};\n  --#{$prefix}vertical-menu-item-active-color:       #{$primary};\n  --#{$prefix}vertical-menu-sub-item-color:          #{darken($gray-600, 4%)};\n  --#{$prefix}vertical-menu-sub-item-hover-color:    #{$primary};\n  --#{$prefix}vertical-menu-sub-item-active-color:   #{$primary};\n  --#{$prefix}vertical-menu-title-color:             #919da9;\n  \n  //vertical dark\n  --#{$prefix}vertical-menu-bg-dark:                 #{$primary};\n  --#{$prefix}vertical-menu-item-color-dark:         #e0dcdc;\n  --#{$prefix}vertical-menu-item-hover-color-dark:   #{$white};\n  --#{$prefix}vertical-menu-item-active-color-dark:  #{$white};\n  --#{$prefix}vertical-menu-sub-item-color-dark:     #e0dcdc;\n  --#{$prefix}vertical-menu-sub-item-hover-color-dark: #{$white};\n  --#{$prefix}vertical-menu-sub-item-active-color-dark: #{$white};\n  --#{$prefix}vertical-menu-title-color-dark:         #c1c6cb;\n\n  // Topbar - (Default Light)\n  --#{$prefix}header-bg:  #{$white};\n  --#{$prefix}header-item-color:  #e9ecef;\n  // Topbar - Dark\n  --#{$prefix}header-bg-dark:  #{$primary};\n  --#{$prefix}header-item-color-dark:  #b0c4d9;\n\n  // Topbar Search\n  --#{$prefix}topbar-search-bg: #f3f3f9;\n  // Topbar User\n  --#{$prefix}topbar-user-bg: #f3f3f9;\n  --#{$prefix}topbar-user-bg-dark: #088F7D;\n\n  //footer\n  --#{$prefix}footer-bg: #{$white};\n  --#{$prefix}footer-color: #98a6ad;\n\n  // Horizontal nav\n  --#{$prefix}topnav-bg: #{$white};\n  --#{$prefix}topnav-item-color: #{darken($gray-600, 10%)};\n  --#{$prefix}topnav-item-color-active: #{$primary};\n\n  // twocolumn menu\n  --#{$prefix}twocolumn-menu-iconview-bg: #{$white};\n  --#{$prefix}twocolumn-menu-bg:  #{$white};\n  // two column dark\n  --#{$prefix}twocolumn-menu-iconview-bg-dark: var(--#{$prefix}vertical-menu-bg-dark);\n  --#{$prefix}twocolumn-menu-bg-dark:  #{lighten($primary, 2%)};\n  --#{$prefix}twocolumn-menu-item-color-dark: var(--#{$prefix}vertical-menu-item-color-dark);\n  --#{$prefix}twocolumn-menu-item-active-color-dark:  #{$white};\n  --#{$prefix}twocolumn-menu-item-active-bg-dark:  #{rgba($white, .15)};\n\n  // boxed \n  --#{$prefix}boxed-body-bg: #{darken($body-bg, 4%)};\n\n  // heading-color\n  --#{$prefix}heading-color: #{$gray-700};\n  \n  // component variable\n  // link\n  --#{$prefix}link-color: #{$primary};\n  --#{$prefix}link-hover-color: #{$primary};\n\n  // Border variable\n  --#{$prefix}border-color:  #{$gray-300};\n\n  // card\n  --#{$prefix}card-bg-custom: #{$white};\n  --#{$prefix}card-logo-dark: block;\n  --#{$prefix}card-logo-light: none;\n\n  // nav tabs\n  .nav-tabs {\n    --#{$prefix}nav-tabs-link-active-bg:           #{$body-bg};\n  }\n\n  //choices \n  .choices, .flatpickr-calendar, .ck, .ql-toolbar, .select2-container, .menu-dropdown{\n    --#{$prefix}choices-bg:                        #{$white};\n    --#{$prefix}choices-link-color:                #{$gray-900};\n    --#{$prefix}choices-link-hover-bg:             #{$gray-100};\n    --#{$prefix}choices-link-active-color:         #{shade-color($gray-900, 10%)};\n  }\n\n  //list\n  --#{$prefix}list-group-hover-bg: #{$gray-100};\n\n  // form\n  --#{$prefix}input-bg: #{$white};\n  --#{$prefix}input-border: #{$gray-400};\n  --#{$prefix}input-focus-border: #{tint-color($component-active-bg, 50%)};\n  --#{$prefix}input-disabled-bg: #{$gray-200};\n\n  // input-group-addon\n  --#{$prefix}input-group-addon-bg: #{$gray-200};\n\n  //check\n  --#{$prefix}input-check-border: var(--#{$prefix}input-border);\n}\n","// :root CSS dark variables\n\n\n[data-layout-mode=\"dark\"]{\n\n  // Color system - Dark Mode only\n  $gray-100: #1a1d21;\n  $gray-200: #212529;\n  $gray-300: #2a2f34;\n  $gray-400: #878a99;\n  $gray-500: #adb5bd;\n  $gray-600: #bfc8e2;\n  $gray-700: #ced4da;\n  $gray-800: #eff2f7;\n  $gray-900: #f3f6f9;\n  \n  $grays: (\n      \"100\": $gray-100,\n      \"200\": $gray-200,\n      \"300\": $gray-300,\n      \"400\": $gray-400,\n      \"500\": $gray-500,\n      \"600\": $gray-600,\n      \"700\": $gray-700,\n      \"800\": $gray-800,\n      \"900\": $gray-900\n  );\n\n  // Prefix for :root CSS variables\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  // body\n  --#{$prefix}body-bg :  #{$gray-100};\n  --#{$prefix}body-bg-rgb :  #{to-rgb($gray-100)};\n  --#{$prefix}body-color: #{$gray-700};\n  --#{$prefix}body-color-rgb: #{to-rgb($gray-700)};\n\n  //vertical light\n  --#{$prefix}vertical-menu-bg:                      #{$gray-200};\n  --#{$prefix}vertical-menu-item-color:              #{darken($gray-400, 16%)};\n  --#{$prefix}vertical-menu-item-hover-color:        #{$primary};\n  --#{$prefix}vertical-menu-item-active-color:       #{$primary};\n  --#{$prefix}vertical-menu-sub-item-color:          #{darken($gray-400, 12%)};\n  --#{$prefix}vertical-menu-sub-item-hover-color:    #{$primary};\n  --#{$prefix}vertical-menu-sub-item-active-color:   #{$primary};\n  --#{$prefix}vertical-menu-title-color:             #{$gray-400};\n\n  //vertical dark\n  --#{$prefix}vertical-menu-bg-dark:                 #{$gray-200};\n  --#{$prefix}vertical-menu-item-color-dark:         #{$gray-400};\n  --#{$prefix}vertical-menu-item-hover-color-dark:   #{$white};\n  --#{$prefix}vertical-menu-item-active-color-dark:  #{$white};\n  --#{$prefix}vertical-menu-sub-item-color-dark:     #{darken($gray-400, 4%)};\n  --#{$prefix}vertical-menu-sub-item-hover-color-dark: #{$white};\n  --#{$prefix}vertical-menu-sub-item-active-color-dark: #{$white};\n  --#{$prefix}vertical-menu-title-color-dark:         #{darken($gray-400, 16%)};\n\n  // Topbar - (Default Light)\n  --#{$prefix}header-bg:  #292e32;\n  --#{$prefix}header-item-color:  #e9ecef;\n  // Topbar - Dark\n  --#{$prefix}header-bg-dark:  #{$primary};\n  --#{$prefix}header-item-color-dark:  #b0c4d9;\n\n  // Topbar Search\n  --#{$prefix}topbar-search-bg: #202328;\n  // Topbar User\n  --#{$prefix}topbar-user-bg: #{lighten($gray-300, 3%)};\n  --#{$prefix}topbar-user-bg-dark: #088f7d;\n  \n  //footer\n  --#{$prefix}footer-bg: #{$gray-200};\n  --#{$prefix}footer-color: #{$gray-400};\n  \n  // Horizontal nav\n  --#{$prefix}topnav-bg: #{lighten($gray-200, 2.5%)};\n  --#{$prefix}topnav-item-color: #{$gray-400};\n  --#{$prefix}topnav-item-color-active: #{$white};\n  \n  // twocolumn menu\n  --#{$prefix}twocolumn-menu-iconview-bg: #{$white};\n  --#{$prefix}twocolumn-menu-bg:  #{$white};\n  \n  // two column dark\n  --#{$prefix}twocolumn-menu-iconview-bg-dark: var(--#{$prefix}vertical-menu-bg-dark);\n  --#{$prefix}twocolumn-menu-bg-dark:  #30363a;\n  --#{$prefix}twocolumn-menu-item-color-dark: var(--#{$prefix}vertical-menu-item-color-dark);\n  --#{$prefix}twocolumn-menu-item-active-color-dark:  #{$white};\n  --#{$prefix}twocolumn-menu-item-active-bg-dark:  #{rgba($white, .15)};\n  \n  // boxed \n  --#{$prefix}boxed-body-bg: #{darken($gray-100, 4%)};\n  \n  // heading-color\n  --#{$prefix}heading-color: #{$gray-700};\n  \n  // component variable\n  --#{$prefix}light: #{$gray-300};\n  --#{$prefix}light-rgb: #{to-rgb($gray-300)};\n  --#{$prefix}dark: #{$gray-800};\n  --#{$prefix}dark-rgb: #{to-rgb($gray-800)};\n  \n  // link\n  --#{$prefix}link-color: #{$gray-700};\n  --#{$prefix}link-hover-color: #{$gray-700};\n  \n  // Border variable\n  --#{$prefix}border-color:  #{lighten($gray-300, 3.5%)};\n  \n  // dropdown\n  .dropdown-menu {\n    --#{$prefix}dropdown-bg:                         #{lighten($gray-200, 3.5%)};\n    --#{$prefix}dropdown-link-color:                 #{$gray-500};\n    --#{$prefix}dropdown-link-hover-color:           #{shade-color($gray-700, 10%)};\n    --#{$prefix}dropdown-link-hover-bg:              #{lighten($gray-300, 2%)};\n    --#{$prefix}dropdown-border-width:               1px;\n    --#{$prefix}dropdown-link-active-color:          #{$gray-500};\n    --#{$prefix}dropdown-link-active-bg:             #{lighten($gray-300, 2%)};\n  }\n\n  //choices \n  .choices, .flatpickr-calendar, .ck, .ql-toolbar, .select2-container, .menu-dropdown {\n    --#{$prefix}choices-bg:                          #{lighten($gray-200, 3.5%)};\n    --#{$prefix}choices-link-color:                  #{$gray-500};\n    --#{$prefix}choices-link-hover-bg:               #{lighten($gray-300, 2%)};\n    --#{$prefix}choices-link-active-color:           #{shade-color($gray-900, 10%)};\n  }\n  \n  //buttons\n  .btn-light {\n    --#{$prefix}btn-color:                           var(--#{$prefix}dark);\n    --#{$prefix}btn-bg:                              var(--#{$prefix}light);\n    --#{$prefix}btn-border-color:                    var(--#{$prefix}light);\n  }\n\n  .btn-outline-light {\n    --#{$prefix}btn-color:                           var(--#{$prefix}dark);\n    --#{$prefix}btn-bg:                              transparent;\n    --#{$prefix}btn-border-color:                    var(--#{$prefix}light);\n  }\n  \n  .btn-light, .btn-outline-light {\n    --#{$prefix}btn-hover-color:                     var(--#{$prefix}dark);\n    --#{$prefix}btn-hover-bg:                        rgba(var(--#{$prefix}light-rgb), 0.75);\n    --#{$prefix}btn-hover-border-color:              rgba(var(--#{$prefix}light-rgb), 0.75);\n  }\n\n  .btn-dark {\n    --#{$prefix}btn-color:                           var(--#{$prefix}light);\n    --#{$prefix}btn-bg:                              var(--#{$prefix}dark);\n    --#{$prefix}btn-border-color:                    var(--#{$prefix}dark);\n  }\n\n  .btn-outline-dark {\n    --#{$prefix}btn-color:                           var(--#{$prefix}dark);\n    --#{$prefix}btn-bg:                              transparent;\n    --#{$prefix}btn-border-color:                    var(--#{$prefix}dark);\n  }\n\n  .btn-dark, .btn-outline-dark {\n    --#{$prefix}btn-hover-color:                     var(--#{$prefix}light);\n    --#{$prefix}btn-hover-bg:                        rgba(var(--#{$prefix}dark-rgb), 0.75);\n    --#{$prefix}btn-hover-border-color:              rgba(var(--#{$prefix}dark-rgb), 0.75);\n  }\n\n  // card\n  .card {\n    --#{$prefix}card-bg:                             #{$gray-200};\n    --#{$prefix}card-cap-bg:                         #{$gray-200};\n  }\n  \n  --#{$prefix}card-bg-custom:                        #{$gray-200};\n  --#{$prefix}card-logo-dark:                        none;\n  --#{$prefix}card-logo-light:                       block;\n  \n  // modal\n  .modal {\n    --#{$prefix}modal-bg:                            #{$gray-200};\n  }\n  \n  // nav tabs\n  .nav-tabs {\n    --#{$prefix}nav-tabs-link-active-color:          #{$gray-900};\n    --#{$prefix}nav-tabs-link-active-bg:             #{$gray-300};\n  }\n\n  // accordion\n  .accordion{\n    --#{$prefix}accordion-button-active-color:       #{$white};\n    --#{$prefix}accordion-bg:                        #{$gray-200};\n    --#{$prefix}accordion-btn-bg:                    #{$gray-200};\n  }\n  \n  //offcanvas\n  :is(.offcanvas, .offcanvas-lg, .offcanvas-md, .offcanvas-sm, .offcanvas-xl, .offcanvas-xxl) {\n    --#{$prefix}offcanvas-bg:                        #{$gray-200};\n      \n  }\n\n  // progress\n  .progress{\n    --#{$prefix}progress-bg:                         #{$gray-300};\n  }\n\n  //table\n  .table {\n    --vz-table-striped-bg:                          #{rgba($white, .03)};\n    --vz-table-active-bg:                          #{rgba($white, .07)};\n    --vz-table-hover-bg:                          #{rgba($white, .07)};\n  }\n\n  .table-light{\n    --vz-table-color:                                #{$white};\n    --vz-table-bg:                                   #{rgba($white, .05)};\n    --vz-table-border-color:                         #{$border-color};\n    --vz-table-striped-bg:                           #{rgba($white, .07)};\n    --vz-table-striped-color:                        #{$white};\n  }\n\n  // toast\n  .toast {\n    --#{$prefix}toast-bg:                            #{rgba($gray-300, .85)};\n    --#{$prefix}toast-header-bg:                     #{rgba($gray-300, .85)};\n    --#{$prefix}toast-border-color:                  #{rgba($white, .1)};\n    --#{$prefix}toast-header-border-color:           #{rgba($white, .05)};\n  }\n\n  //list\n  --#{$prefix}list-group-hover-bg:                   #{lighten($gray-200, 2.5%)};\n\n  // popover\n  .popover{\n    --#{$prefix}popover-bg:                          #{lighten($gray-200, 1%)};\n  }\n\n  // pagination\n  .pagination{\n    --#{$prefix}pagination-hover-bg:                   #{lighten($gray-200, 4%)};\n    --#{$prefix}pagination-focus-bg:                   #{lighten($gray-200, 4%)};\n  }\n\n  //form\n  --#{$prefix}input-bg:                              #{lighten($gray-200, 2%)};\n  --#{$prefix}input-border:                          #{$gray-300};\n  --#{$prefix}input-focus-border:                    #{lighten($gray-300, 4%)};\n  --#{$prefix}input-disabled-bg:                     #{$gray-200};\n\n  // input-group-addon\n  --#{$prefix}input-group-addon-bg:                  #{$gray-300};\n\n  //check\n  --#{$prefix}input-check-border:                    #{lighten($gray-300, 4%)};\n}\n\n//sidebar color\n[data-sidebar=\"gradient\"] { \n  --#{$prefix}vertical-menu-bg-gradient:             linear-gradient(to right, var(--#{$prefix}primary), var(--#{$prefix}success));\n  --#{$prefix}vertical-menu-border-gradient:         var(--#{$prefix}success);\n  --#{$prefix}twocolumn-menu-bg-dark:                var(--#{$prefix}success);\n}\n\n[data-sidebar=\"gradient-2\"] { \n  --#{$prefix}vertical-menu-bg-gradient:             linear-gradient(to right, var(--#{$prefix}info), var(--#{$prefix}secondary));\n  --#{$prefix}vertical-menu-border-gradient:         var(--#{$prefix}secondary);\n  --#{$prefix}twocolumn-menu-bg-dark:                var(--#{$prefix}secondary);\n}\n\n[data-sidebar=\"gradient-3\"] { \n  --#{$prefix}vertical-menu-bg-gradient:             linear-gradient(to right, var(--#{$prefix}info), var(--#{$prefix}success));\n  --#{$prefix}vertical-menu-border-gradient:         var(--#{$prefix}success);\n  --#{$prefix}twocolumn-menu-bg-dark:                var(--#{$prefix}success);\n}\n\n[data-sidebar=\"gradient-4\"] { \n  --#{$prefix}vertical-menu-bg-gradient:             linear-gradient(to right, #1a1d21, var(--#{$prefix}primary));\n  --#{$prefix}vertical-menu-border-gradient:         var(--#{$prefix}primary);\n  --#{$prefix}twocolumn-menu-bg-dark:                var(--#{$prefix}primary);\n}","//\n// _topbar.scss\n//\n\n#page-topbar {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 1000;\n    background-color: $header-bg;\n    transition: all 0.1s ease-out;\n    border: 1px solid $page-title-border;\n\n    &.topbar-shadow {\n        box-shadow: $box-shadow;\n    }\n\n    @media (min-width: 768px) {\n        left: $vertical-menu-width;\n    }\n}\n\n.navbar-header {\n    display: flex;\n    -ms-flex-pack: justify;\n    justify-content: space-between;\n    align-items: center;\n    margin: 0 auto;\n    height: $header-height;\n    padding: 0 $grid-gutter-width 0 calc(#{$grid-gutter-width} / 2)\n    /*rtl: 0 0 0 calc(#{$grid-gutter-width} / 2) */\n    ;\n\n    @media (max-width: 767.98px) {\n        padding: 0 calc(#{$grid-gutter-width} / 2) 0 calc(#{$grid-gutter-width} / 2);\n    }\n\n    .topbar-head-dropdown {\n        .dropdown-menu.show {\n            top: 13px !important;\n        }\n    }\n\n    .btn-topbar {\n        height: 42px;\n        width: 42px;\n\n        @media (max-width: 360px) {\n            height: 36px;\n            width: 36px;\n        }\n    }\n\n    .user-name-text {\n        color: var(--#{$prefix}gray-700);\n    }\n}\n\n/* Search */\n\n.app-search {\n    padding: calc(#{$header-height - 38px} / 2) 0;\n\n    .form-control {\n        border: none;\n        height: 38px;\n        padding-left: 40px;\n        padding-right: 30px;\n        background-color: $topbar-search-bg;\n        box-shadow: none;\n    }\n\n    span.search-widget-icon {\n        position: absolute;\n        z-index: 10;\n        font-size: 18px;\n        line-height: 38px;\n        left: 13px;\n        top: 0;\n        color: $gray-600;\n    }\n\n    .search-widget-icon-close {\n        right: 7px;\n        left: auto !important;\n    }\n\n    @media (max-width: 1023.99px) {\n        padding-left: calc(#{$grid-gutter-width} / 2);\n    }\n}\n\n// Mega menu\n\n.megamenu-list {\n    li {\n        position: relative;\n        padding: 5px 0px;\n\n        a {\n            color: $dropdown-color;\n        }\n    }\n}\n\n@media (max-width: 767.98px) {\n    .logo {\n        span.logo-lg {\n            display: none;\n        }\n\n        span.logo-sm {\n            display: inline-block;\n        }\n    }\n}\n\n.header-item {\n    height: $header-height;\n    display: flex;\n    align-items: center;\n}\n\n.header-profile-user {\n    height: 45px;\n    width: 45px;\n    margin-left: 10px;\n}\n\n.topbar-badge-sm {\n    right: 0;\n    top: 7px !important;\n}\n\n.topbar-badge {\n    right: -9px;\n    top: 4px !important;\n}\n\n.topbar-user {\n    @media (min-width: 768px) {\n        background-color: transparent\n    }\n\n    .dropdown-menu {\n        top: 6px !important;\n    }\n}\n\n.notification-item {\n    padding: 0.75rem 1rem;\n    white-space: inherit;\n    position: relative;\n\n    .form-check-input {\n        position: relative;\n        z-index: 2;\n    }\n}\n\n// Dropdown with Icons\n.dropdown-icon-item {\n    display: block;\n    border-radius: 3px;\n    line-height: 34px;\n    text-align: center;\n    padding: 15px 0 9px;\n    border: 1px solid transparent;\n    color: var(--#{$prefix}dropdown-link-color);\n\n    img {\n        height: 24px;\n    }\n\n    span {\n        display: block;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n    }\n\n    &:hover {\n        background-color: var(--#{$prefix}dropdown-link-hover-bg);\n    }\n}\n\n// Full Screen\n.fullscreen-enable {\n    [data-toggle=\"fullscreen\"] {\n        .bx-fullscreen::before {\n            content: \"\\eacb\";\n        }\n    }\n}\n\n// Dark mode enable\n[data-layout-mode=\"dark\"] {\n    .light-dark-mode {\n        .bx-moon::before {\n            content: \"\\ec34\";\n        }\n    }\n}\n\n[data-topbar=\"dark\"] {\n    #page-topbar {\n        background-color: $header-bg-dark;\n        border-color: $header-bg-dark;\n    }\n\n    .navbar-header {\n        .btn-topbar {\n            color: $header-item-color-dark;\n\n            &:hover,\n            &:focus {\n                background-color: rgba($white, 0.07);\n                color: $white;\n            }\n        }\n    }\n\n    .topbar-user {\n        @media (min-width: 767.99px) {\n            background-color: $topbar-user-bg-dark;\n        }\n\n        .user-name-text {\n            color: rgba($white, 0.85) !important;\n        }\n\n        .user-name-sub-text {\n            color: $header-item-color-dark !important;\n        }\n    }\n\n    .logo-dark {\n        display: none;\n    }\n\n    .logo-light {\n        display: inline-block;\n    }\n\n    .app-search {\n        .form-control {\n            background-color: rgba($white, 0.05);\n            color: $white;\n        }\n\n        span.search-widget-icon,\n        input.form-control::-webkit-input-placeholder {\n            color: rgba($white, 0.5);\n        }\n    }\n\n    .hamburger-icon {\n        span {\n            background-color: $gray-300;\n        }\n    }\n}\n\n@media (max-width: 600px) {\n    .navbar-header {\n        .dropdown {\n            position: static;\n\n            .dropdown-menu {\n                width: 100%;\n            }\n        }\n    }\n}\n\n@media (max-width: 767.98px){\n    #search-dropdown-reponsive{\n        top: 54px !important;\n    }\n}\n\n[data-layout=\"vertical\"] {\n    &[data-layout-style=\"detached\"] {\n        @media (min-width: 1024.1px) {\n            #page-topbar {\n                left: 0 !important;\n                box-shadow: $box-shadow;\n            }\n\n            .horizontal-logo {\n                display: inline-block;\n                padding-left: 0;\n            }\n\n            .topnav-hamburger {\n                visibility: hidden;\n            }\n\n            .layout-width {\n                max-width: 95%;\n                margin: 0 auto;\n            }\n\n            &:is([data-sidebar-size=\"sm\"], [data-sidebar-size=\"sm-hover\"]) {\n                .navbar-brand-box {\n                    background-color: transparent !important;\n                    position: relative;\n                    width: auto;\n                    text-align: left;\n\n                    .logo-sm {\n                        display: none;\n                    }\n\n                    .logo-lg {\n                        display: block;\n                    }\n                }\n            }\n        }\n\n        &[data-topbar=\"dark\"] {\n            .horizontal-logo {\n                .logo-dark {\n                    display: none;\n                }\n\n                .logo-light {\n                    display: block;\n                }\n            }\n        }\n    }\n}\n\n[data-layout=\"horizontal\"] {\n    #page-topbar {\n        left: 0;\n        border-bottom: 1px solid var(--#{$prefix}gray-300);\n\n        @media (min-width: 1024.1px) {\n            &.topbar-shadow {\n                box-shadow: none;\n            }\n        }\n    }\n\n    .page-content {\n        @media (min-width: 1024.1px) {\n            margin-top: $header-height;\n        }\n\n        @media (max-width: 1024.1px) {\n            padding: calc(45px + #{$grid-gutter-width} * 1.8) calc(#{$grid-gutter-width} / 2) $footer-height calc(#{$grid-gutter-width} / 2);\n        }\n\n        padding: calc(45px + #{$grid-gutter-width}) calc(#{$grid-gutter-width} / 2) $footer-height calc(#{$grid-gutter-width} / 2);\n    }\n\n    &[data-layout-width=\"boxed\"] {\n        .page-content {\n            @media (min-width: 1024.1px) {\n                min-height: calc(100vh - #{$footer-height + $header-height});\n            }   \n        }\n    }\n}\n\n[data-layout=\"vertical\"] {\n\n    &:is([data-sidebar-size=\"sm\"], [data-sidebar-size=\"sm-hover\"]) {\n        #page-topbar {\n            @media (min-width: 768px) {\n                left: $vertical-menu-width-sm;\n            }\n        }\n    }\n\n    &[data-sidebar-size=\"md\"] {\n        #page-topbar {\n            @media (min-width: 768px) {\n                left: $vertical-menu-width-md;\n            }\n        }\n    }\n}\n\n[data-layout=\"twocolumn\"] {\n    #page-topbar {\n        @media (min-width: 768px) {\n            left: calc(#{$twocolumn-menu-iconview-width} + #{$twocolumn-menu-width});\n        }\n    }\n\n    .horizontal-logo {\n        display: none;\n    }\n}","// \n// _page-head.scss\n// \n\n.page-title-box {\n    padding: 10px $grid-gutter-width;\n    background-color: var(--#{$prefix}card-bg-custom);\n    box-shadow: $page-title-box-shadow;\n    border-bottom: 1px solid $page-title-border;\n    margin: -23px (-$grid-gutter-width * 1) $grid-gutter-width (-$grid-gutter-width * 1);\n\n    .breadcrumb {\n        background-color: transparent;\n        padding: 0;\n    }\n\n    h4 {\n        font-weight: 700;\n        font-size: 15px!important;\n        text-transform: uppercase;\n    }\n}\n\n[data-layout=\"horizontal\"] {\n    .page-title-box {\n        padding: 1.2rem 0;\n        background-color: transparent !important;\n        border-bottom: none;\n        border-top: none;\n        box-shadow: none;\n        margin: 0;\n\n        @media (min-width: 1024.1px) {\n            margin: -19px 0 0 0;\n        }\n    }\n}\n\n[data-layout=\"vertical\"] {\n    &[data-layout-style=\"detached\"]{\n        .page-title-box {\n            padding: 1.2rem 0;\n            background-color: transparent !important;\n            border-bottom: none;\n            border-top: none;\n            box-shadow: none;\n            margin: 0;\n    \n            @media (min-width: 1024.1px) {\n                margin: -19px 0 0 0;\n            }\n        }\n    }\n}","// \n// _footer.scss\n// \n\n.footer {\n    bottom: 0;\n    padding: 20px calc(#{$grid-gutter-width} * 0.5);\n    position: absolute;\n    right: 0;\n    color: $footer-color;\n    left: $vertical-menu-width;\n    height: $footer-height;\n    background-color: $footer-bg;\n\n    @media (max-width: 991.98px) {\n        left: 0;\n    }\n}\n\n[data-layout=\"vertical\"] {\n\n    &:is([data-sidebar-size=\"sm\"], [data-sidebar-size=\"sm-hover\"]) {\n        .footer {\n            left: $vertical-menu-width-sm;\n\n            @media (max-width: 767.98px) {\n                left: 0;\n            }\n        }\n    }\n    &[data-sidebar-size=\"md\"] {\n        .footer {\n            left: $vertical-menu-width-md;\n\n            @media (max-width: 991.98px) {\n                left: 0;\n            }\n        }\n    }\n\n}\n\n[data-layout=\"horizontal\"]{\n    .footer {\n        left: 0 !important;\n    } \n}\n\n[data-layout=\"vertical\"][data-layout-style=\"detached\"] {\n\n    @media (min-width: 1024.1px) {\n        .footer {\n            left: 0 !important;\n            background-color: transparent;\n        } \n    }\n}\n\n[data-layout=\"twocolumn\"] { \n    .footer {\n        @media (min-width: 768.1px) {\n            left: calc(#{$twocolumn-menu-iconview-width} + #{$twocolumn-menu-width});\n        }\n    }\n}","//\n// _vertical.scss\n//\n\n.app-content {\n margin-left: $vertical-menu-width;\n overflow: hidden;\n\n .content {\n  padding: 0 15px 10px 15px;\n  margin-top: $header-height;\n }\n}\n\n.main-content {\n transition: all 0.1s ease-out;\n\n @media (min-width: 768px) {\n  margin-left: $vertical-menu-width;\n }\n}\n\n.page-content {\n padding: #{$grid-gutter-width} calc(#{$grid-gutter-width}) $footer-height calc(#{$grid-gutter-width});\n}\n\n.navbar-menu {\n width: $vertical-menu-width;\n z-index: $vertical-menu-z-index;\n background: $vertical-menu-bg;\n border-right: 1px solid $vertical-menu-border;\n bottom: 0;\n margin-top: 0;\n position: fixed;\n top: 0;\n box-shadow: $vertical-menu-box-shadow;\n padding: 0 0 calc(#{$header-height} + 25px) 0;\n transition: all 0.1s ease-out;\n\n .navbar-nav {\n  .nav-link {\n   display: flex;\n   align-items: center;\n   padding: $vertical-menu-item-padding-y $vertical-menu-item-padding-x;\n   color: $vertical-menu-item-color;\n   font-size: $vertical-menu-item-font-size;\n   font-family: $vertical-menu-item-font-family;\n\n   &.active {\n    color: $vertical-menu-item-active-color;\n   }\n\n   &:hover {\n    color: $vertical-menu-item-hover-color;\n   }\n\n   i {\n    display: inline-block;\n    min-width: $vertical-menu-item-icon-width;\n    font-size: 18px;\n    line-height: inherit;\n   }\n\n   svg {\n    width: 18px;\n    margin-right: 0.665rem;\n    color: $vertical-menu-item-color;\n   }\n\n   .badge {\n    margin-left: auto;\n    margin-right: -2px;\n    z-index: 1;\n   }\n\n   &:hover {\n    color: $vertical-menu-item-hover-color;\n\n    .icon-dual {\n     color: $vertical-menu-item-hover-color;\n     fill: rgba($primary, 0.16);\n    }\n   }\n\n   &[data-bs-toggle=\"collapse\"] {\n    &:after {\n     display: block;\n     content: \"\\F0142\";\n     font-family: \"Material Design Icons\";\n     margin-left: auto;\n     transition: transform 0.2s;\n     font-size: 1.05rem;\n     position: absolute;\n     right: 18px;\n     color: $vertical-menu-title-color;\n    }\n\n    &[aria-expanded=\"true\"] {\n     color: $vertical-menu-item-active-color;\n\n     .icon-dual {\n      color: $vertical-menu-item-hover-color;\n      fill: rgba($primary, 0.16);\n     }\n\n     &:after {\n      transform: rotate(90deg);\n      color: $vertical-menu-item-active-color;\n     }\n\n     &:before {\n      opacity: 1;\n      background-color: $vertical-menu-item-active-color;\n     }\n    }\n   }\n\n   &.collapsed {\n    &.active {\n     &::after {\n      transform: rotate(90deg);\n     }\n    }\n   }\n  }\n\n  .nav-sm {\n   padding-left: $vertical-menu-item-icon-width;\n\n   .nav-link {\n    padding: $vertical-menu-sub-item-padding-y $vertical-menu-sub-item-padding-x !important;\n    color: $vertical-menu-sub-item-color;\n    white-space: none;\n    position: relative;\n    font-size: $vertical-menu-sub-item-font-size;\n    font-family: $vertical-menu-sub-item-font-family;\n\n    &:before {\n     content: \"\";\n     width: 6px;\n     height: 1.5px;\n     background-color: $vertical-menu-sub-item-color;\n     position: absolute;\n     left: 2px;\n     top: 16.5px;\n     transition: all 0.4s ease-in-out;\n     opacity: 0.5;\n    }\n\n    &:hover {\n     color: $vertical-menu-sub-item-hover-color;\n\n     &:before {\n      background-color: $vertical-menu-sub-item-hover-color !important;\n      opacity: 1;\n     }\n    }\n\n    &.active {\n     color: $vertical-menu-item-active-color;\n\n     &:before {\n      background-color: $vertical-menu-item-active-color;\n     }\n    }\n   }\n\n   .nav-sm {\n    padding-left: 15px;\n\n    .nav-link {\n     &:before {\n      height: 5px;\n      width: 5px;\n      left: 5px;\n      border-radius: 50%;\n      background-color: transparent;\n      border: 1px solid;\n      top: 16px;\n     }\n    }\n   }\n  }\n }\n\n .btn-vertical-sm-hover {\n  color: $text-muted;\n  display: none;\n }\n}\n\n.navbar-brand-box {\n padding: 0 1.3rem;\n text-align: center;\n transition: all 0.1s ease-out;\n\n @media (max-width: 767.98px) {\n  display: none;\n }\n}\n\n.hamburger-icon {\n width: 20px;\n height: 14px;\n position: relative;\n cursor: pointer;\n display: inline-block;\n\n span {\n  background-color: $text-muted;\n  position: absolute;\n  border-radius: 2px;\n  transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);\n  width: 100%;\n  height: 2px;\n  display: block;\n  left: 0px;\n\n  &:nth-child(1) {\n   top: 0;\n   width: 80%;\n  }\n\n  &:nth-child(2) {\n   top: 6px;\n  }\n\n  &:nth-child(3) {\n   bottom: 0;\n   width: 60%;\n  }\n }\n\n .vertical-menu-btn:hover &:not(.open) {\n  span {\n   &:nth-child(1) {\n    top: -1px;\n   }\n\n   &:nth-child(3) {\n    bottom: -1px;\n   }\n  }\n }\n\n &.open {\n  transform: rotate(-90deg);\n\n  span {\n   &:nth-child(1) {\n    left: 1px;\n    top: 5px;\n    width: 20px;\n    transform: rotate(90deg);\n    transition-delay: 150ms;\n   }\n\n   &:nth-child(2) {\n    left: 3px;\n    top: 13px;\n    width: 10px;\n    transform: rotate(45deg);\n    transition-delay: 50ms;\n   }\n\n   &:nth-child(3) {\n    left: 9px;\n    top: 13px;\n    width: 10px;\n    transform: rotate(-45deg);\n    transition-delay: 100ms;\n   }\n  }\n }\n}\n\n.logo {\n line-height: $header-height;\n\n .logo-sm {\n  display: none;\n }\n}\n\n.logo-light {\n display: none;\n}\n\n:is([data-layout=\"vertical\"], [data-layout=\"semibox\"]) {\n .app-menu {\n  .row {\n   margin: 0;\n\n   > * {\n    width: 100%;\n    padding: 0;\n   }\n  }\n\n  @media (max-width: 767.98px) {\n   margin-left: -100%;\n   padding: 10px 0 20px 0;\n  }\n }\n\n .navbar-menu {\n  .container-fluid {\n   padding: 0;\n  }\n }\n\n .navbar-brand-box {\n  @media (max-width: 767.98px) {\n   display: none;\n  }\n }\n\n .horizontal-logo {\n  display: none;\n }\n\n &[data-sidebar-size=\"sm-hover\"] {\n  .main-content {\n   margin-left: $vertical-menu-width-sm;\n\n   @media (max-width: 767.98px) {\n    margin-left: 0;\n   }\n  }\n\n  .logo {\n   span.logo-lg {\n    display: none;\n   }\n\n   span.logo-sm {\n    display: inline-block;\n   }\n  }\n\n  .btn-vertical-sm-hover {\n   display: inline-block;\n  }\n\n  @media (min-width: 768px) {\n   .topnav-hamburger {\n    display: none;\n   }\n  }\n\n  // Side menu\n  .navbar-menu {\n   width: $vertical-menu-width-sm;\n\n   .btn-vertical-sm-hover {\n    display: none;\n\n    i {\n     &.ri-record-circle-line:before {\n      content: \"\\EB7D\";\n     }\n    }\n   }\n\n   // Sidebar Menu\n   .navbar-nav {\n    .badge {\n     display: none;\n    }\n\n    .menu-title {\n     text-align: center;\n\n     span {\n      display: none;\n     }\n\n     i {\n      display: block;\n      line-height: 36px;\n      font-size: 1rem;\n     }\n    }\n\n    .nav-link {\n     span {\n      display: none;\n     }\n\n     i {\n      font-size: 22px;\n\n      &.las,\n      &.lar,\n      &.lab {\n       font-size: 24px;\n      }\n     }\n\n     svg {\n      margin-right: 0px;\n     }\n\n     &:after,\n     &:before {\n      display: none;\n     }\n    }\n\n    .menu-dropdown {\n     display: none;\n    }\n   }\n\n   &:hover {\n    width: $vertical-menu-width !important;\n\n    @media (min-width: 1024.99px) {\n     .btn-vertical-sm-hover {\n      display: inline-block;\n     }\n\n     .navbar-brand-box {\n      text-align: left;\n     }\n    }\n\n    .navbar-nav {\n     .menu-dropdown.show {\n      display: block;\n     }\n    }\n\n    .nav-link {\n     i {\n      font-size: 18px;\n\n      &.las,\n      &.lar,\n      &.lab {\n       font-size: 20px;\n      }\n     }\n\n     svg {\n      margin-right: 0.665rem;\n     }\n\n     span,\n     &:after,\n     &:before {\n      display: inline-block;\n     }\n    }\n\n    .logo {\n     span.logo-lg {\n      display: inline-block;\n     }\n\n     span.logo-sm {\n      display: none;\n     }\n    }\n\n    .menu-title {\n     text-align: left;\n\n     span {\n      display: inline-block;\n     }\n\n     i {\n      display: none;\n     }\n    }\n   }\n  }\n }\n\n &:is([data-sidebar-size=\"sm-hover\"], [data-sidebar-size=\"sm-hover-active\"]) {\n  .navbar-header {\n   @media (min-width: 1025px) {\n    padding-left: $grid-gutter-width;\n   }\n   padding-top: calc($grid-gutter-width*0.5);\n  }\n }\n\n &[data-sidebar-size=\"sm-hover-active\"] {\n  .navbar-brand-box {\n   text-align: left;\n  }\n\n  .topnav-hamburger {\n   display: none;\n  }\n\n  .btn-vertical-sm-hover {\n   display: inline-block;\n  }\n }\n\n &[data-sidebar-size=\"sm\"] {\n  @media (min-width: 768px) {\n   min-height: 1400px;\n\n   .main-content {\n    margin-left: $vertical-menu-width-sm;\n   }\n  }\n\n  #page-topbar {\n   /*  z-index: calc(#{$vertical-menu-z-index} + 1); */\n  }\n\n  .navbar-brand-box {\n   position: fixed;\n   padding: 0;\n   width: $vertical-menu-width-sm;\n   z-index: 1;\n   top: 0;\n   background: $vertical-menu-bg;\n  }\n\n  .logo {\n   span.logo-lg {\n    display: none;\n   }\n\n   span.logo-sm {\n    display: inline-block;\n   }\n  }\n\n  // Side menu\n  .navbar-menu {\n   position: absolute;\n   width: $vertical-menu-width-sm !important;\n   padding-top: $header-height;\n\n   .simplebar-mask,\n   .simplebar-content-wrapper {\n    overflow: visible !important;\n   }\n\n   .simplebar-scrollbar,\n   .vertical-menu-btn {\n    display: none !important;\n   }\n\n   .simplebar-offset {\n    bottom: 0 !important;\n   }\n\n   // Sidebar Menu\n   .navbar-nav {\n    .badge {\n     display: none !important;\n    }\n\n    .menu-title {\n     text-align: center;\n     font-size: 1rem;\n\n     span {\n      display: none;\n     }\n\n     i {\n      display: block;\n      line-height: 36px;\n     }\n    }\n\n    .nav-link {\n     span {\n      display: none;\n     }\n\n     i {\n      font-size: 22px;\n     }\n\n     svg {\n      margin-right: 0px;\n     }\n\n     &:after,\n     &:before {\n      display: none;\n     }\n    }\n\n    .menu-dropdown {\n     display: none;\n     height: auto !important;\n    }\n\n    .nav-item {\n     position: relative;\n\n     &:hover {\n      > a.menu-link {\n       position: relative;\n       width: calc(200px + #{$vertical-menu-width-sm});\n       color: $white;\n       background-color: $vertical-menu-bg-dark;\n       transition: none;\n\n       .icon-dual {\n        color: $vertical-menu-item-hover-color-dark;\n        fill: rgba($white, 0.16);\n       }\n\n       span {\n        display: inline-block;\n        padding-left: 25px;\n       }\n\n       &:after {\n        display: block;\n        transform: rotate(90deg);\n        color: $white;\n       }\n      }\n\n      .nav-link {\n       span {\n        display: inline-block;\n       }\n      }\n\n      > .menu-dropdown {\n       display: block;\n       left: $vertical-menu-width-sm;\n       position: absolute;\n       width: 200px;\n       background: $vertical-menu-bg;\n       height: auto !important;\n       padding: 0.5rem 0;\n       border-radius: 0 0 3px 3px;\n       box-shadow: $vertical-menu-dropdown-box-shadow;\n      }\n     }\n    }\n\n    .nav-sm {\n     padding: 0;\n\n     .nav-item {\n      &:hover {\n       > .nav-link {\n        color: $vertical-menu-item-hover-color;\n\n        &:after {\n         color: inherit;\n        }\n       }\n      }\n     }\n\n     .nav-link {\n      &:after {\n       display: block !important;\n       transform: rotate(0deg) !important;\n      }\n     }\n\n     .menu-dropdown {\n      left: 100% !important;\n      top: 0;\n      border-radius: 3px !important;\n     }\n    }\n   }\n  }\n }\n\n &[data-sidebar-size=\"md\"] {\n  @media (min-width: 768px) {\n   .main-content {\n    margin-left: $vertical-menu-width-md;\n   }\n  }\n\n  .navbar-brand-box {\n   width: $vertical-menu-width-md;\n  }\n\n  // Side menu\n  .navbar-menu {\n   width: $vertical-menu-width-md !important;\n\n   // Sidebar Menu\n   .navbar-nav {\n    .nav-link {\n     display: block;\n     text-align: center;\n     padding: $vertical-menu-sub-item-padding-y\n      $vertical-menu-sub-item-padding-x * 0.35;\n\n     i {\n      display: block;\n     }\n\n     svg {\n      display: block;\n      margin-left: auto;\n      margin-right: auto;\n     }\n\n     &:before {\n      display: none !important;\n     }\n\n     &[data-bs-toggle=\"collapse\"]:after {\n      position: relative;\n      display: inline-block;\n      right: 0;\n      top: 3px;\n     }\n\n     &.menu-link {\n      &[data-bs-toggle=\"collapse\"]:after {\n       display: none;\n      }\n     }\n    }\n\n    .badge {\n     display: none !important;\n    }\n\n    .nav-sm {\n     padding-left: 0;\n    }\n   }\n\n   .menu-title {\n    text-align: center;\n\n    span {\n     text-decoration: underline;\n    }\n   }\n  }\n }\n\n &[data-sidebar=\"dark\"] {\n  .navbar-menu {\n   background: $vertical-menu-bg-dark;\n   border-right: 1px solid $vertical-menu-border-dark;\n\n   .hamburger-icon {\n    span {\n     background-color: $vertical-menu-item-color-dark;\n    }\n   }\n\n   .btn-vertical-sm-hover {\n    color: $vertical-menu-item-color-dark;\n   }\n  }\n\n  .navbar-nav {\n   .nav-link {\n    color: $vertical-menu-item-color-dark;\n\n    &.active {\n     color: $vertical-menu-item-active-color-dark;\n    }\n\n    &[data-bs-toggle=\"collapse\"] {\n     &:after {\n      color: inherit;\n     }\n\n     &[aria-expanded=\"true\"] {\n      color: $vertical-menu-item-active-color-dark;\n\n      &:after {\n       color: inherit;\n      }\n\n      .icon-dual {\n       color: $vertical-menu-item-active-color-dark;\n       fill: rgba($white, 0.1);\n      }\n     }\n    }\n\n    svg {\n     color: $vertical-menu-item-color-dark;\n     fill: rgba($white, 0.1);\n    }\n\n    &:hover {\n     color: $vertical-menu-item-hover-color-dark;\n\n     .icon-dual {\n      color: $vertical-menu-item-hover-color-dark;\n      fill: rgba($white, 0.16);\n     }\n    }\n   }\n\n   > .nav-item {\n    .nav-link.active {\n     color: $vertical-menu-item-active-color-dark;\n\n     .icon-dual {\n      color: $vertical-menu-item-hover-color-dark;\n      fill: rgba($white, 0.16);\n     }\n    }\n   }\n\n   .nav-sm {\n    .nav-link {\n     color: $vertical-menu-sub-item-color-dark;\n\n     &:before {\n      background-color: $vertical-menu-sub-item-color-dark !important;\n     }\n\n     &:hover {\n      color: $vertical-menu-item-hover-color-dark;\n\n      &:before {\n       background-color: $vertical-menu-item-hover-color-dark !important;\n      }\n     }\n\n     &.active {\n      color: $vertical-menu-item-active-color-dark;\n     }\n    }\n\n    .nav-sm {\n     .nav-link {\n      &:before {\n       background-color: transparent !important;\n      }\n\n      &:hover {\n       &:before {\n        background-color: $vertical-menu-item-hover-color-dark !important;\n       }\n      }\n\n      &.active {\n       color: $vertical-menu-item-active-color-dark;\n\n       &:before {\n        background-color: $vertical-menu-item-active-color-dark !important;\n       }\n      }\n     }\n    }\n   }\n  }\n\n  &[data-sidebar-size=\"sm\"] {\n   .navbar-brand-box {\n    background: $vertical-menu-bg-dark;\n   }\n\n   // Side menu\n   .navbar-menu {\n    .navbar-nav {\n     .nav-item {\n      &:hover {\n       > .menu-dropdown {\n        background: $vertical-menu-bg-dark;\n       }\n      }\n     }\n\n     .nav-sm {\n      padding: 0;\n\n      .nav-link {\n       &:after {\n        display: block !important;\n        transform: rotate(0deg) !important;\n       }\n      }\n\n      .nav-item {\n       &:hover {\n        > .nav-link {\n         color: $vertical-menu-item-active-color-dark;\n\n         &:after {\n          color: inherit;\n         }\n        }\n       }\n      }\n\n      .menu-dropdown {\n       left: 100% !important;\n       top: 0;\n       border-radius: 3px !important;\n      }\n     }\n    }\n   }\n  }\n\n  .menu-title {\n   color: $vertical-menu-title-color-dark;\n  }\n\n  .logo-dark {\n   display: none;\n  }\n\n  .logo-light {\n   display: inline-block;\n  }\n }\n\n &[data-sidebar=\"light\"] {\n  .logo-dark {\n   display: inline-block;\n  }\n\n  .logo-light {\n   display: none;\n  }\n }\n\n &[data-layout-style=\"detached\"] {\n  #layout-wrapper,\n  .main-content {\n   min-height: 100vh;\n  }\n\n  @media (min-width: 1024.1px) {\n   .main-content {\n    position: relative;\n   }\n\n   #layout-wrapper {\n    max-width: 100%;\n    margin: 0 auto;\n    /* padding-left: $grid-gutter-width; */ /* templatletin default ayarını kaldırdım */\n   }\n\n   .navbar-header {\n    padding-left: $grid-gutter-width;\n   }\n\n   .navbar-menu {\n    // top: calc(#{$grid-gutter-width});\n    // bottom: $grid-gutter-width;\n    padding: 0;\n    border-right: $vertical-menu-bg;\n    border-radius:0 38px 38px 0;\n    padding: 10px 0;\n    z-index: 1;\n\n    .navbar-brand-box {\n     display: none;\n    }\n   }\n\n   &:is(\n     [data-sidebar=\"dark\"],\n     [data-sidebar=\"gradient\"],\n     [data-sidebar=\"gradient-2\"],\n     [data-sidebar=\"gradient-3\"],\n     [data-sidebar=\"gradient-4\"]\n    ) {\n    .logo-dark {\n     display: inline-block;\n    }\n\n    .logo-light {\n     display: none;\n    }\n   }\n  }\n\n  .footer {\n   border-top: 1px dashed $border-color;\n  }\n\n  .auth-page-wrapper {\n   .footer {\n    border-top: none;\n   }\n  }\n\n  &[data-sidebar-size=\"sm\"] {\n   @media (min-width: 768px) {\n    #layout-wrapper,\n    .main-content {\n     min-height: 1400px;\n    }\n   }\n  }\n }\n\n &:is(\n   [data-sidebar=\"gradient\"],\n   [data-sidebar=\"gradient-2\"],\n   [data-sidebar=\"gradient-3\"],\n   [data-sidebar=\"gradient-4\"]\n  ) {\n  .logo-dark {\n   display: none;\n  }\n\n  .logo-light {\n   display: inline-block;\n  }\n }\n}\n\n.menu-title {\n letter-spacing: 0.05em;\n cursor: default;\n font-size: 11px;\n text-transform: uppercase;\n color: $vertical-menu-title-color;\n font-weight: $font-weight-semibold;\n\n span {\n  padding: 12px 20px;\n  display: inline-block;\n }\n\n i {\n  display: none;\n }\n}\n\n.vertical-overlay {\n position: fixed;\n top: 0;\n left: 0;\n width: 100vw;\n height: 100vh;\n background-color: rgba($dark, 0.35);\n z-index: 1003;\n display: none;\n}\n\n// Mobile Menu\n.vertical-sidebar-enable {\n .vertical-overlay {\n  display: block;\n }\n\n .app-menu {\n  margin-left: 0 !important;\n  z-index: 1004;\n }\n}\n\n// rtl\n[dir=\"rtl\"] {\n .navbar-menu {\n  .navbar-nav {\n   .nav-link[data-bs-toggle=\"collapse\"] {\n    &:after {\n     transform: rotate(180deg);\n    }\n\n    &[aria-expanded=\"true\"]:after {\n     transform: rotate(270deg);\n    }\n   }\n  }\n }\n}\n\n//gradient sidebar\n:is(\n  [data-sidebar=\"gradient\"],\n  [data-sidebar=\"gradient-2\"],\n  [data-sidebar=\"gradient-3\"],\n  [data-sidebar=\"gradient-4\"]\n ) {\n .navbar-menu {\n  background: $vertical-menu-bg-gradient;\n  border-right: 1px solid $vertical-menu-border-gradient;\n\n  .hamburger-icon {\n   span {\n    background-color: $vertical-menu-item-color-gradient;\n   }\n  }\n\n  .btn-vertical-sm-hover {\n   color: $vertical-menu-item-color-gradient;\n  }\n }\n\n .navbar-nav {\n  .nav-link {\n   color: $vertical-menu-item-color-gradient;\n\n   &.active {\n    color: $vertical-menu-item-active-color-dark;\n   }\n\n   &[data-bs-toggle=\"collapse\"] {\n    &:after {\n     color: inherit;\n    }\n\n    &[aria-expanded=\"true\"] {\n     color: $vertical-menu-item-active-color-dark;\n\n     &:after {\n      color: inherit;\n     }\n\n     .icon-dual {\n      color: $vertical-menu-item-active-color-dark;\n      fill: rgba($white, 0.1);\n     }\n    }\n   }\n\n   svg {\n    color: $vertical-menu-item-color-gradient;\n    fill: rgba($white, 0.1);\n   }\n\n   &:hover {\n    color: $vertical-menu-item-hover-color-dark;\n\n    .icon-dual {\n     color: $vertical-menu-item-hover-color-dark;\n     fill: rgba($white, 0.16);\n    }\n   }\n  }\n\n  > .nav-item {\n   .nav-link.active {\n    color: $vertical-menu-item-active-color-dark;\n\n    .icon-dual {\n     color: $vertical-menu-item-hover-color-dark;\n     fill: rgba($white, 0.16);\n    }\n   }\n  }\n\n  .nav-sm {\n   .nav-link {\n    color: $vertical-menu-sub-item-color-gradient;\n\n    &:before {\n     background-color: $vertical-menu-sub-item-color-gradient !important;\n    }\n\n    &:hover {\n     color: $vertical-menu-item-hover-color-dark;\n\n     &:before {\n      background-color: $vertical-menu-item-hover-color-dark !important;\n     }\n    }\n\n    &.active {\n     color: $vertical-menu-item-active-color-dark;\n    }\n   }\n\n   .nav-sm {\n    .nav-link {\n     &:before {\n      background-color: transparent !important;\n     }\n\n     &:hover {\n      &:before {\n       background-color: $vertical-menu-item-hover-color-dark !important;\n      }\n     }\n\n     &.active {\n      color: $vertical-menu-item-active-color-dark;\n\n      &:before {\n       background-color: $vertical-menu-item-active-color-dark !important;\n      }\n     }\n    }\n   }\n  }\n }\n\n &[data-sidebar-size=\"sm\"] {\n  .navbar-brand-box {\n   background: $vertical-menu-bg-gradient;\n  }\n\n  // Side menu\n  .navbar-menu {\n   .navbar-nav {\n    .nav-item {\n     &:hover {\n      > .menu-dropdown {\n       background: $vertical-menu-bg-dark;\n      }\n     }\n    }\n\n    .nav-sm {\n     padding: 0;\n\n     .nav-link {\n      &:after {\n       display: block !important;\n       transform: rotate(0deg) !important;\n      }\n     }\n\n     .nav-item {\n      &:hover {\n       > .nav-link {\n        color: $vertical-menu-item-active-color-dark;\n\n        &:after {\n         color: inherit;\n        }\n       }\n      }\n     }\n\n     .menu-dropdown {\n      left: 100% !important;\n      top: 0;\n      border-radius: 3px !important;\n     }\n    }\n   }\n  }\n\n  &[data-layout=\"vertical\"] {\n   .navbar-menu {\n    .navbar-nav {\n     .nav-item {\n      &:hover {\n       > a.menu-link {\n        background: $vertical-menu-bg-gradient;\n       }\n      }\n     }\n    }\n   }\n  }\n }\n\n .menu-title {\n  color: $vertical-menu-title-color-gradient;\n }\n}\n\n.bg-vertical-gradient {\n background: linear-gradient(\n  to right,\n  var(--#{$prefix}primary),\n  var(--#{$prefix}success)\n );\n}\n\n.bg-vertical-gradient-2 {\n background: linear-gradient(\n  to right,\n  var(--#{$prefix}info),\n  var(--#{$prefix}secondary)\n );\n}\n\n.bg-vertical-gradient-3 {\n background: linear-gradient(\n  to right,\n  var(--#{$prefix}info),\n  var(--#{$prefix}success)\n );\n}\n\n.bg-vertical-gradient-4 {\n background: linear-gradient(\n  to right,\n  var(--#{$prefix}dark),\n  var(--#{$prefix}primary)\n );\n}\n\n//sidebar-images\n.sidebar-background {\n position: absolute;\n z-index: -1;\n height: 100%;\n width: 100%;\n display: block;\n top: 0;\n left: 0;\n background-size: cover;\n background-position: 50%;\n opacity: 0.07;\n}\n\n[data-sidebar-image=\"img-1\"] {\n .sidebar-background {\n  background-image: url(\"../../images/sidebar/img-1.jpg\");\n }\n}\n\n[data-sidebar-image=\"img-2\"] {\n .sidebar-background {\n  background-image: url(\"../../images/sidebar/img-2.jpg\");\n }\n}\n\n[data-sidebar-image=\"img-3\"] {\n .sidebar-background {\n  background-image: url(\"../../images/sidebar/img-3.jpg\");\n }\n}\n\n[data-sidebar-image=\"img-4\"] {\n .sidebar-background {\n  background-image: url(\"../../images/sidebar/img-4.jpg\");\n }\n}\n\n[data-layout=\"semibox\"] {\n .page-title-box {\n  padding: 10px 0;\n  background-color: transparent;\n  box-shadow: none;\n  margin: -15px 0 1.5rem 0;\n }\n\n @media (min-width: 768px) {\n  &[data-sidebar-size=\"sm\"],\n  &[data-sidebar-size=\"sm-hover\"] {\n   .main-content {\n    margin-left: $vertical-menu-width-sm;\n   }\n\n   #page-topbar {\n    left: $vertical-menu-width-sm;\n   }\n\n   .footer {\n    left: $vertical-menu-width-sm;\n   }\n  }\n\n  &[data-sidebar-size=\"md\"] {\n   #page-topbar {\n    left: $vertical-menu-width-md;\n   }\n\n   .footer {\n    left: $vertical-menu-width-md;\n   }\n  }\n }\n\n @media (min-width: 1440px) {\n  .page-content {\n   padding: calc(#{$header-height} + #{$grid-gutter-width} * 2)\n    calc(#{$grid-gutter-width} * 0.5) $footer-height\n    calc(#{$grid-gutter-width} * 0.5);\n  }\n\n  .navbar-menu {\n   margin: 25px;\n   border-radius: $border-radius;\n  }\n\n  .main-content {\n   margin-left: calc(#{$vertical-menu-width} + 25px);\n   padding: 0 $semibox-width;\n  }\n\n  .footer {\n   left: calc(\n    #{$vertical-menu-width} + #{$semibox-width} + #{$grid-gutter-width} + 25px\n   );\n   right: calc(#{$semibox-width} + #{$grid-gutter-width});\n  }\n\n  #page-topbar {\n   left: calc(\n    #{$vertical-menu-width} + #{$semibox-width} + #{$grid-gutter-width} + 25px\n   );\n   right: calc(#{$semibox-width} + #{$grid-gutter-width});\n   top: 25px;\n   border-radius: $border-radius;\n   transition: all 0.5s ease;\n\n   &.topbar-shadow {\n    top: 0px;\n   }\n  }\n\n  &[data-sidebar-size=\"md\"] {\n   .main-content {\n    margin-left: calc(#{$vertical-menu-width-md} + 25px);\n   }\n\n   #page-topbar {\n    left: calc(\n     #{$vertical-menu-width-md} + #{$semibox-width} + #{$grid-gutter-width} + 25px\n    );\n   }\n\n   .footer {\n    left: calc(\n     #{$vertical-menu-width-md} + #{$semibox-width} + #{$grid-gutter-width} + 25px\n    );\n   }\n  }\n\n  &[data-sidebar-size=\"sm\"] {\n   .main-content {\n    margin-left: calc(#{$vertical-menu-width-sm} + 25px);\n   }\n\n   .navbar-brand-box {\n    top: 25px;\n   }\n\n   #page-topbar {\n    left: calc(\n     #{$vertical-menu-width-sm} + #{$semibox-width} + #{$grid-gutter-width} + 25px\n    );\n   }\n\n   .footer {\n    left: calc(\n     #{$vertical-menu-width-sm} + #{$semibox-width} + #{$grid-gutter-width} + 25px\n    );\n   }\n  }\n\n  &[data-sidebar-size=\"sm-hover\"] {\n   .main-content {\n    margin-left: calc(#{$vertical-menu-width-sm} + 25px);\n   }\n\n   #page-topbar {\n    left: calc(\n     #{$vertical-menu-width-sm} + #{$semibox-width} + #{$grid-gutter-width} + 25px\n    );\n   }\n\n   .footer {\n    left: calc(\n     #{$vertical-menu-width-sm} + #{$semibox-width} + #{$grid-gutter-width} + 25px\n    );\n   }\n  }\n }\n\n .mx-n4 {\n  margin-left: 0px !important;\n  margin-right: 0px !important;\n\n  &.p-1 {\n   padding-left: 0px !important;\n   padding-right: 0px !important;\n  }\n }\n}\n","//\n// _horizontal.scss\n// \n\n[data-layout=\"horizontal\"] {\n\n    .main-content {\n        margin-left: 0;\n    }\n\n    @media (min-width: 1024.1px) {\n\n        .layout-width,\n        .container-fluid {\n            max-width: 90%;\n            margin: 0 auto;\n        }\n\n        .topnav-hamburger {\n            visibility: hidden;\n        }\n    }\n\n    .horizontal-logo {\n        padding-left: calc(#{$grid-gutter-width} / 2);\n\n        @media (max-width: 1024.98px) {\n            padding-left: $grid-gutter-width;\n        }\n    }\n\n    .navbar-menu {\n        background: $topnav-bg;\n        border-right-color: transparent;\n        padding: 0 calc(#{$grid-gutter-width} / 2);\n        box-shadow: $horizontal-menu-box-shadow;\n        margin-top: $header-height;\n        position: fixed;\n        left: 0;\n        right: 0;\n        z-index: 100;\n        width: 100%;\n        bottom: auto;\n\n        @media (max-width:575.98px) {\n            .container-fluid {\n                padding: 0;\n            }\n        }\n\n        .navbar-nav {\n            flex-direction: row;\n\n            .nav-sm {\n                padding-left: 0;\n\n                .nav-link {\n                    &:before {\n                        opacity: 0 !important;\n                    }\n\n                    &:hover,\n                    &.active {\n                        color: $topnav-item-color-active;\n                    }\n                }\n            }\n\n            .nav-link {\n                color: $topnav-item-color;\n                padding: $horizontal-menu-item-padding-y $horizontal-menu-item-padding-x;\n\n                i {\n                    line-height: 1;\n                }\n\n                &.active {\n                    color: $topnav-item-color-active;\n                    &:after {\n                        color: $topnav-item-color-active;\n                    }\n                    .icon-dual {\n                        color: $topnav-item-color-active;\n                        fill: rgba($primary, 0.10);\n                    }\n                }\n\n                &[data-bs-toggle=collapse][aria-expanded=true] {\n                    color: $topnav-item-color-active;\n\n                    .icon-dual {\n                        color: $topnav-item-color-active;\n                        fill: rgba($primary, 0.10);\n                    }\n\n                    &:after {\n                        color: $topnav-item-color-active;\n                    }\n                }\n\n                &:hover {\n                    .icon-dual {\n                        color: $topnav-item-color-active;\n                        fill: rgba($primary, 0.10);\n                    }\n                }\n            }\n\n            >.nav-item {\n                >.nav-link[data-bs-toggle=collapse]:after {\n                    right: 0px;\n                    transform: rotate(90deg) !important;\n                }\n            }\n\n            >li:nth-of-type(2) {\n                >.nav-link.menu-link {\n                    padding-left: 0;\n                }\n            }\n        }\n\n        .navbar-brand-box {\n            display: none;\n        }\n    }\n\n    .navbar-nav {\n        .nav-item {\n            position: relative;\n\n            .nav-link[data-bs-toggle=collapse]:after {\n                right: 10px;\n                transform: rotate(0deg) !important;\n            }\n\n            >.nav-link {\n                >.badge {\n                    display: none;\n                }\n            }\n\n            &:hover {\n                >.nav-link {\n                    color: $topnav-item-color-active;\n\n                    .icon-dual {\n                        color: $topnav-item-color-active;\n                        fill: rgba($primary, 0.10);\n                    }\n\n                    &:after {\n                        color: $topnav-item-color-active;\n                    }\n                }\n\n                @media (min-width: 1024.1px) {\n                    >.menu-dropdown {\n                        display: block;\n                        height: auto !important;\n                    }\n                }\n            }\n\n            &.active {\n                color: $topnav-item-color-active;\n            }\n        }\n    }\n\n    .menu-dropdown {\n        position: absolute;\n        min-width: $horizontal-menu-dropdown-min-width;\n        padding: $dropdown-padding-y $dropdown-padding-x;\n        box-shadow: $horizontal-menu-dropdown-box-shadow;\n        animation-name: DropDownSlide;\n        animation-duration: .3s;\n        animation-fill-mode: both;\n        margin: 0;\n        z-index: $zindex-dropdown;\n        background-color: var(--#{$prefix}choices-bg);\n        background-clip: padding-box;\n        border: $dropdown-border-width solid $dropdown-border-color;\n        border-radius: $dropdown-border-radius;\n        display: none;\n\n        .menu-dropdown {\n            top: 0;\n            left: 100%;\n        }\n    }\n\n    .mega-dropdown-menu {\n        width: 40rem;\n    }\n\n    .menu-title {\n        display: none;\n    }\n\n    .dropdown-custom-right {\n        left: -100% !important;\n        right: 100%;\n    }\n\n    @media (max-width: 1024px) {\n        .navbar-menu {\n            display: none;\n        }\n    }\n}\n\n[data-layout=\"horizontal\"] {\n    .menu {\n        @media (max-width: 1024px) {\n            .navbar-menu {\n                display: block;\n                max-height: 360px;\n                overflow-y: auto;\n                padding-left: 0;\n\n                .navbar-nav {\n                    flex-direction: column;\n\n                    >li:nth-of-type(2)>.nav-link.menu-link {\n                        padding-left: $vertical-menu-item-padding-x;\n                    }\n\n                    .nav-sm .nav-link:before {\n                        opacity: 1 !important;\n                    }\n                }\n            }\n\n            .menu-dropdown {\n                position: relative;\n                min-width: 100%;\n                box-shadow: none;\n                padding-left: 28px;\n                left: 0;\n                animation: none;\n                padding-top: 0;\n\n                &.show {\n                    display: block;\n                }\n            }\n\n            .dropdown-custom-right {\n                left: 0 !important;\n            }\n\n            .nav-item .nav-link[data-bs-toggle=collapse]:after {\n                right: 0px;\n            }\n\n            .mega-dropdown-menu {\n                width: 100%;\n            }\n        }\n    }\n}\n\n// theme dark\n[data-layout-mode=\"dark\"] {\n    &[data-topbar=\"light\"] {\n        .navbar-header {\n            .horizontal-logo {\n                .logo-dark {\n                    display: none;\n                }\n\n                .logo-light {\n                    display: block;\n                }\n            }\n        }\n    }\n}\n\n// rtl\n[dir=\"rtl\"]{\n    &[data-layout=horizontal] {\n        .navbar-menu {\n            .navbar-nav>.nav-item>.nav-link[data-bs-toggle=collapse]{\n                &:after{\n                    transform: rotate(-90deg) !important;\n                }\n            }\n        }\n\n        .navbar-nav{\n            .nav-item {\n                .nav-link[data-bs-toggle=collapse]{\n                    &:after{\n                        transform: rotate(-180deg)!important;\n                    }\n                }\n            }\n        }\n    }\n}","//\n// _two-column.scss\n// \n\n[data-layout=\"twocolumn\"] {\n    .app-menu {\n        padding-bottom: 0;\n        width: $twocolumn-menu-width;\n        left: $twocolumn-menu-iconview-width;\n\n        .menu-link {\n            letter-spacing: .05em;\n            cursor: default;\n            font-size: 11px;\n            text-transform: uppercase;\n            color: $vertical-menu-title-color !important;\n            font-weight: $font-weight-semibold;\n\n            &:after {\n                display: none !important;\n            }\n\n            i {\n                display: none;\n            }\n        }\n\n        .navbar-nav {\n            height: calc(100vh - #{$header-height});\n\n            @media (max-width: 767.98px) {\n                padding-top: 16px;\n            }\n\n            >li:not(.twocolumn-item-show) {\n                display: none;\n            }\n\n            .twocolumn-item-show {\n                >div {\n                    display: block !important;\n                    height: auto !important;\n                }\n            }\n\n            >.nav-item {\n                >.menu-dropdown {\n                    display: block !important;\n                    height: auto !important;\n                }\n            }\n\n            .nav-item {\n                .menu-dropdown {\n                    .row {\n                        margin: 0;\n\n                        .col-lg-4 {\n                            width: 100%;\n                            padding: 0;\n                        }\n                    }\n                }\n            }\n\n            .nav-sm {\n                .nav-link {\n                    color: $vertical-menu-item-color;\n\n                    &.active {\n                        color: $vertical-menu-item-active-color;\n                    }\n                }\n            }\n        }\n\n        .container-fluid {\n            padding: 0;\n        }\n    }\n\n    .main-content {\n        margin-left: calc(#{$twocolumn-menu-width} + #{$twocolumn-menu-iconview-width});\n\n        @media (max-width:767.98px) {\n            margin-left: $twocolumn-menu-iconview-width;\n        }\n    }\n\n    .twocolumn-iconview {\n        width: $twocolumn-menu-iconview-width;\n        background-color: $twocolumn-menu-iconview-bg;\n        height: 100%;\n        left: -$twocolumn-menu-iconview-width;\n        box-shadow: $twocolumn-menu-box-shadow;\n        top: 0;\n        position: absolute;\n        padding: 0;\n        text-align: center;\n\n        li {\n            position: relative;\n            list-style: none;\n\n            .nav-icon {\n                &::after {\n                    content: \"\";\n                    position: absolute;\n                    top: 0;\n                    right: 0;\n                    bottom: 0;\n                    left: 0;\n                }\n            }\n        }\n\n        .nav-icon {\n            width: 42px;\n            height: 42px;\n            line-height: 42px;\n            color: $vertical-menu-item-color;\n            z-index: 1;\n            font-size: 22px;\n            text-align: center;\n            border-radius: 3px;\n            margin: 5px 0;\n            display: inline-flex;\n            justify-content: center;\n            align-items: center;\n\n            .icon-dual {\n                width: 18px;\n                color: $vertical-menu-item-color;\n            }\n\n            &.active {\n                background-color: rgba($primary, 0.15);\n                color: $primary;\n\n                .icon-dual {\n                    color: $primary;\n                    fill: rgba($primary, 0.10);\n                }\n            }\n        }\n    }\n\n    .menu-title {\n        display: none;\n    }\n\n    @media (max-width: 991.98px) {\n        .logo {\n\n            span.logo-lg {\n                display: block;\n            }\n\n            span.logo-sm {\n                display: none;\n            }\n        }\n    }\n\n    &[data-sidebar=\"light\"] {\n        .app-menu {\n            .navbar-brand-box {\n                .logo-light {\n                    display: none;\n                }\n\n                .logo-dark {\n                    display: block;\n                }\n            }\n        }\n    }\n\n    &[data-sidebar=\"dark\"] {\n        .twocolumn-iconview {\n            background-color: $twocolumn-menu-iconview-bg-dark;\n\n            .nav-icon {\n                color: $twocolumn-menu-item-color-dark;\n\n                &.active {\n                    color: $twocolumn-menu-item-active-color-dark;\n                    background-color: $twocolumn-menu-item-active-bg-dark;\n                }\n            }\n        }\n\n        .app-menu {\n            background-color: $twocolumn-menu-bg-dark;\n            border-right-color: $twocolumn-menu-border-dark;\n\n            .navbar-brand-box {\n                .logo-light {\n                    display: block;\n                }\n\n                .logo-dark {\n                    display: none;\n                }\n            }\n\n            .navbar-nav {\n                .nav-sm {\n                    .nav-link {\n                        color: $twocolumn-menu-item-color-dark;\n                    }\n                }\n            }\n        }\n\n        .navbar-menu {\n            .navbar-nav {\n                .nav-sm {\n                    .nav-link {\n\n                        &:hover,\n                        &.active {\n                            color: $twocolumn-menu-item-active-color-dark;\n\n                            &::before {\n                                background-color: $twocolumn-menu-item-active-color-dark !important;\n                            }\n                        }\n                    }\n                }\n\n                .nav-link {\n                    &[data-bs-toggle=collapse][aria-expanded=true] {\n                        color: $twocolumn-menu-item-active-color-dark;\n\n                        &:before {\n                            background-color: $twocolumn-menu-item-active-color-dark;\n                        }\n\n                        &::after {\n                            color: $twocolumn-menu-item-active-color-dark !important;\n                        }\n                    }\n                }\n            }\n        }\n    }\n\n    &:is([data-sidebar=\"gradient\"], [data-sidebar=\"gradient-2\"], [data-sidebar=\"gradient-3\"], [data-sidebar=\"gradient-4\"]) {\n        .twocolumn-iconview {\n            background-color: $twocolumn-menu-iconview-bg-dark;\n    \n            .nav-icon {\n                color: $twocolumn-menu-item-color-gradient;\n    \n                &.active {\n                    color: $twocolumn-menu-item-active-color-dark;\n                    background-color: $twocolumn-menu-item-active-bg-dark;\n                }\n            }\n        }\n    \n        .app-menu {\n            background-color: $twocolumn-menu-bg-dark;\n            border-right-color: $twocolumn-menu-border-dark;\n    \n            .navbar-brand-box {\n                .logo-light {\n                    display: block;\n                }\n    \n                .logo-dark {\n                    display: none;\n                }\n            }\n    \n            .navbar-nav {\n                .nav-sm {\n                    .nav-link {\n                        color: $twocolumn-menu-item-color-gradient;\n                    }\n                }\n            }\n        }\n    \n        .navbar-menu {\n            .navbar-nav {\n                .nav-sm {\n                    .nav-link {\n    \n                        &:hover,\n                        &.active {\n                            color: $twocolumn-menu-item-active-color-dark;\n    \n                            &::before {\n                                background-color: $twocolumn-menu-item-active-color-dark !important;\n                            }\n                        }\n                    }\n                }\n    \n                .nav-link {\n                    &[data-bs-toggle=collapse][aria-expanded=true] {\n                        color: $twocolumn-menu-item-active-color-dark;\n    \n                        &:before {\n                            background-color: $twocolumn-menu-item-active-color-dark;\n                        }\n    \n                        &::after {\n                            color: $twocolumn-menu-item-active-color-dark !important;\n                        }\n                    }\n                }\n            }\n        }\n\n        &[data-layout-mode=\"dark\"] {\n            .app-menu {\n                border-right-color: $gray-700; \n            }\n        }\n    }\n\n    .twocolumn-panel {\n        .app-menu {\n            width: 0;\n            border-right: 0;\n\n            @media (max-width: 575.98px) {\n                display: none;\n            }\n        }\n\n        .navbar-brand-box,\n        .navbar-nav {\n            display: none;\n        }\n\n        .main-content {\n            margin-left: $twocolumn-menu-iconview-width;\n        }\n\n        #page-topbar,\n        .footer {\n            left: $twocolumn-menu-iconview-width;\n        }\n\n        @media (max-width: 575.98px) {\n            .main-content {\n                margin-left: 0;\n            }\n\n            #page-topbar,\n            .footer {\n                left: 0;\n            }\n        }\n\n    }\n\n    #page-topbar,\n    .footer {\n        @media (max-width: 767.98px) {\n            left: $twocolumn-menu-iconview-width;\n        }\n    }\n\n    @media (max-width: 575.98px) {\n        .main-content {\n            margin-left: 0;\n        }\n\n        #page-topbar,\n        .footer {\n            left: 0;\n        }\n    }\n}","//\n// _layouts.scss\n//\n\n[data-layout-width=\"boxed\"] {\n body {\n  background-color: $boxed-body-bg;\n }\n\n #layout-wrapper {\n  max-width: $boxed-layout-width;\n  margin: 0 auto;\n  box-shadow: $box-shadow;\n  background-color: var(--#{$prefix}body-bg);\n }\n\n &[data-layout=\"vertical\"] {\n  #layout-wrapper {\n   min-height: 100vh;\n  }\n }\n\n #page-topbar,\n .footer {\n  max-width: $boxed-layout-width;\n  margin: 0 auto;\n  left: 0 !important;\n }\n\n &[data-sidebar-size=\"sm-hover\"],\n &[data-sidebar-size=\"sm\"] {\n  &[data-layout=\"vertical\"] {\n   @media (min-width: 768px) {\n    #layout-wrapper {\n     min-height: 1400px;\n    }\n   }\n\n   .main-content {\n    @media (max-width: 767.98px) {\n     margin-left: 0;\n    }\n   }\n  }\n\n  #page-topbar,\n  .footer {\n   left: 0 !important;\n   max-width: calc(#{$boxed-layout-width} - #{$vertical-menu-width-sm});\n\n   @media (min-width: 768px) {\n    left: $vertical-menu-width-sm !important;\n   }\n  }\n }\n\n &[data-sidebar-size=\"sm-hover-active\"],\n &[data-sidebar-size=\"lg\"] {\n  #page-topbar,\n  .footer {\n   max-width: calc(#{$boxed-layout-width} - #{$vertical-menu-width});\n\n   @media (min-width: 768px) {\n    left: $vertical-menu-width !important;\n   }\n  }\n }\n\n &[data-sidebar-size=\"md\"] {\n  #page-topbar,\n  .footer {\n   max-width: calc(#{$boxed-layout-width} - #{$vertical-menu-width-md});\n\n   @media (min-width: 768px) {\n    left: $vertical-menu-width-md !important;\n   }\n  }\n }\n\n // deteched\n\n &[data-layout=\"vertical\"][data-layout-style=\"detached\"] {\n  body {\n   background-color: var(--#{$prefix}body-bg);\n  }\n\n  @media (min-width: 1024.1px) {\n   #layout-wrapper {\n    max-width: 1300px;\n    box-shadow: none;\n   }\n\n   .layout-width {\n    max-width: 1300px;\n   }\n  }\n\n  &[data-sidebar-size=\"sm-hover\"],\n  &[data-sidebar-size=\"sm\"],\n  &[data-sidebar-size=\"md\"],\n  &[data-sidebar-size=\"lg\"] {\n   #page-topbar,\n   .footer {\n    max-width: 100%;\n    left: 0 !important;\n   }\n  }\n }\n}\n\n// Horizontal Boxed Layout\n\n[data-layout=\"horizontal\"][data-layout-width=\"boxed\"] {\n #page-topbar,\n #layout-wrapper,\n .footer {\n  max-width: 100%;\n }\n\n .container-fluid,\n .navbar-header {\n  max-width: $boxed-layout-width;\n }\n\n .navbar-header {\n  padding: 0 calc(#{$grid-gutter-width} / 2) 0 0;\n }\n\n &[data-sidebar-size=\"sm-hover\"],\n &[data-sidebar-size=\"sm\"] &[data-sidebar-size=\"sm-hover-active\"],\n &[data-sidebar-size=\"lg\"] {\n  #page-topbar,\n  .footer {\n   left: 0 !important;\n  }\n }\n}\n\n// Scrollable layout\n\n[data-layout-position=\"scrollable\"] {\n @media (min-width: 992px) {\n  #page-topbar,\n  .navbar-menu {\n   position: absolute;\n  }\n }\n\n &[data-layout=\"horizontal\"] {\n  @media (min-width: 992px) {\n   #page-topbar,\n   .topnav {\n    position: absolute;\n   }\n  }\n }\n}\n\n//Semibox Sidebar Action\n\n[data-layout=\"semibox\"][data-sidebar-visibility=\"hidden\"] {\n @media (min-width: 768px) {\n  .navbar-menu {\n   display: none;\n  }\n\n  .horizontal-logo {\n   display: inline-block;\n   width: auto;\n  }\n\n  .footer {\n   left: 0;\n  }\n\n  #page-topbar {\n   left: 0;\n  }\n\n  .main-content {\n   margin-left: 0px;\n  }\n\n  &[data-sidebar-size=\"sm\"],\n  &[data-sidebar-size=\"sm-hover\"] {\n   .navbar-brand-box {\n    position: static;\n    padding: 0 1.3rem;\n   }\n\n   .logo {\n    span.logo-lg {\n     display: inline-block;\n    }\n\n    span.logo-sm {\n     display: none;\n    }\n   }\n  }\n }\n\n &:is(\n   [data-sidebar=\"dark\"],\n   [data-sidebar=\"gradient\"],\n   [data-sidebar=\"gradient-2\"],\n   [data-sidebar=\"gradient-3\"],\n   [data-sidebar=\"gradient-4\"]\n  ) {\n  .logo-dark {\n   display: inline-block;\n  }\n\n  .logo-light {\n   display: none;\n  }\n }\n\n &[data-topbar=\"dark\"]:is(\n   [data-sidebar=\"dark\"],\n   [data-sidebar=\"light\"],\n   [data-sidebar=\"gradient\"],\n   [data-sidebar=\"gradient-2\"],\n   [data-sidebar=\"gradient-3\"],\n   [data-sidebar=\"gradient-4\"]\n  ) {\n  .logo-dark {\n   display: none;\n  }\n\n  .logo-light {\n   display: block;\n  }\n }\n\n @media (min-width: 1440px) {\n  .navbar-menu {\n   display: none;\n  }\n\n  .horizontal-logo {\n   display: inline-block;\n   width: auto;\n  }\n\n  .footer {\n   left: calc(#{$semibox-width} + #{$grid-gutter-width});\n  }\n\n  #page-topbar {\n   left: calc(#{$semibox-width} + #{$grid-gutter-width});\n  }\n\n  .main-content {\n   margin-left: 0px;\n  }\n\n  &[data-sidebar-size=\"sm\"],\n  &[data-sidebar-size=\"sm-hover\"] {\n   .navbar-brand-box {\n    position: static;\n    padding: 0 1.3rem;\n   }\n\n   .logo {\n    span.logo-lg {\n     display: inline-block;\n    }\n\n    span.logo-sm {\n     display: none;\n    }\n   }\n  }\n }\n}\n","\n/*!\n * Waves v0.7.6\n * http://fian.my.id/Waves \n * \n * Copyright 2014-2018 Alfiana E. Sibuea and other contributors \n * Released under the MIT license \n * https://github.com/fians/Waves/blob/master/LICENSE */\n .waves-effect {\n    position: relative;\n    cursor: pointer;\n    display: inline-block;\n    overflow: hidden;\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    -webkit-tap-highlight-color: transparent;\n  }\n  .waves-effect .waves-ripple {\n    position: absolute;\n    border-radius: 50%;\n    width: 100px;\n    height: 100px;\n    margin-top: -50px;\n    margin-left: -50px;\n    opacity: 0;\n    background: rgba(0, 0, 0, 0.2);\n    background: -webkit-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -o-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -moz-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    -webkit-transition: all 0.5s ease-out;\n    -moz-transition: all 0.5s ease-out;\n    -o-transition: all 0.5s ease-out;\n    transition: all 0.5s ease-out;\n    -webkit-transition-property: -webkit-transform, opacity;\n    -moz-transition-property: -moz-transform, opacity;\n    -o-transition-property: -o-transform, opacity;\n    transition-property: transform, opacity;\n    -webkit-transform: scale(0) translate(0, 0);\n    -moz-transform: scale(0) translate(0, 0);\n    -ms-transform: scale(0) translate(0, 0);\n    -o-transform: scale(0) translate(0, 0);\n    transform: scale(0) translate(0, 0);\n    pointer-events: none;\n  }\n  .waves-effect.waves-light .waves-ripple {\n    background: rgba(255, 255, 255, 0.4);\n    background: -webkit-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -o-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: -moz-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n    background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\n  }\n  .waves-effect.waves-classic .waves-ripple {\n    background: rgba(0, 0, 0, 0.2);\n  }\n  .waves-effect.waves-classic.waves-light .waves-ripple {\n    background: rgba(255, 255, 255, 0.4);\n  }\n  .waves-notransition {\n    -webkit-transition: none !important;\n    -moz-transition: none !important;\n    -o-transition: none !important;\n    transition: none !important;\n  }\n  .waves-button,\n  .waves-circle {\n    -webkit-transform: translateZ(0);\n    -moz-transform: translateZ(0);\n    -ms-transform: translateZ(0);\n    -o-transform: translateZ(0);\n    transform: translateZ(0);\n    -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);\n  }\n  .waves-button,\n  .waves-button:hover,\n  .waves-button:visited,\n  .waves-button-input {\n    white-space: nowrap;\n    vertical-align: middle;\n    cursor: pointer;\n    border: none;\n    outline: none;\n    color: inherit;\n    background-color: rgba(0, 0, 0, 0);\n    font-size: 1em;\n    line-height: 1em;\n    text-align: center;\n    text-decoration: none;\n    z-index: 1;\n  }\n  .waves-button {\n    padding: 0.85em 1.1em;\n    border-radius: 0.2em;\n  }\n  .waves-button-input {\n    margin: 0;\n    padding: 0.85em 1.1em;\n  }\n  .waves-input-wrapper {\n    border-radius: 0.2em;\n    vertical-align: bottom;\n  }\n  .waves-input-wrapper.waves-button {\n    padding: 0;\n  }\n  .waves-input-wrapper .waves-button-input {\n    position: relative;\n    top: 0;\n    left: 0;\n    z-index: 1;\n  }\n  .waves-circle {\n    text-align: center;\n    width: 2.5em;\n    height: 2.5em;\n    line-height: 2.5em;\n    border-radius: 50%;\n  }\n  .waves-float {\n    -webkit-mask-image: none;\n    -webkit-box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\n    box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\n    -webkit-transition: all 300ms;\n    -moz-transition: all 300ms;\n    -o-transition: all 300ms;\n    transition: all 300ms;\n  }\n  .waves-float:active {\n    -webkit-box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\n    box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\n  }\n  .waves-block {\n    display: block;\n  }\n\n.waves-effect.waves-light {\n    .waves-ripple {\n        background-color: rgba($white, 0.4);\n    }\n}\n\n.waves-effect.waves-primary {\n    .waves-ripple {\n        background-color: rgba($primary, 0.4);\n    }\n}\n.waves-effect.waves-success {\n    .waves-ripple {\n        background-color: rgba($success, 0.4);\n    }\n}\n.waves-effect.waves-info {\n    .waves-ripple {\n        background-color: rgba($info, 0.4);\n    }\n}\n.waves-effect.waves-warning {\n    .waves-ripple {\n        background-color: rgba($warning, 0.4);\n    }\n}\n.waves-effect.waves-danger {\n    .waves-ripple {\n        background-color: rgba($danger, 0.4);\n    }\n}","//\n// avatar.scss\n//\n\n.avatar-xxs {\n    height: 1.5rem;\n    width: 1.5rem;\n}\n\n.avatar-xs {\n    height: 2rem;\n    width: 2rem;\n}\n\n.avatar-sm {\n    height: 3rem;\n    width: 3rem;\n}\n\n.avatar-md {\n    height: 4.5rem;\n    width: 4.5rem;\n}\n\n.avatar-lg {\n    height: 6rem;\n    width: 6rem;\n}\n\n.avatar-xl {\n    height: 7.5rem;\n    width: 7.5rem;\n}\n\n.avatar-title {\n    align-items: center;\n    background-color: $primary;\n    color: $white;\n    display: flex;\n    font-weight: $font-weight-medium;\n    height: 100%;\n    justify-content: center;\n    width: 100%;\n}\n\n// avatar group\n.avatar-group {\n    padding-left: 12px;\n    display: flex;\n    flex-wrap: wrap;\n\n    .avatar-group-item {\n        margin-left: -12px;\n        border: 2px solid var(--#{$prefix}card-bg-custom);\n        border-radius: 50%;\n        transition: all 0.2s;\n\n        &:hover {\n            position: relative;\n            transform: translateY(-2px);\n            z-index: 1;\n        }\n    }\n}","//\n// accordion.scss\n//\n\n.accordion {\n    .accordion-button {\n        font-weight: $font-weight-medium;\n    }\n\n    .accordion-body {\n        color: $text-muted;\n    }\n\n    &.accordion-icon-none {\n        .accordion-button {\n            &::after {\n                content: \"\";\n                background-image: none !important;\n            }\n\n            &:not(.collapsed) {\n                &::after {\n                    content: \"\";\n                }\n            }\n        }\n    }\n}\n\n// Accordion with icon\n\n.custom-accordionwithicon {\n    .accordion-button {\n        &::after {\n            background-image: none !important;\n            font-family: \"Material Design Icons\";\n            content: \"\\F0142\";\n            font-size: 1.1rem;\n            vertical-align: middle;\n            line-height: 0.8;\n        }\n\n        &:not(.collapsed) {\n            &::after {\n                background-image: none !important;\n                content: \"\\F0140\";\n                margin-right: -3px;\n            }\n        }\n    }\n}\n\n// Accordion with plus icon\n\n.custom-accordionwithicon-plus {\n    .accordion-button {\n        &::after {\n            background-image: none !important;\n            font-family: \"Material Design Icons\";\n            content: \"\\F0415\";\n            font-size: 1.1rem;\n            vertical-align: middle;\n            line-height: 0.8;\n        }\n\n        &:not(.collapsed) {\n            &::after {\n                background-image: none !important;\n                content: \"\\F0374\";\n                margin-right: -3px;\n            }\n        }\n    }\n}\n\n\n// left Icon accordion\n\n.lefticon-accordion {\n    .accordion-button {\n        padding-left: 2.75rem;\n\n        &::after {\n            position: absolute;\n            left: $accordion-button-padding-x;\n            top: 14px;\n        }\n\n        &:not(.collapsed) {\n            &::after {\n                top: 20px;\n            }\n        }\n    }\n}\n\n// border accordion\n\n.accordion-border-box {\n    .accordion-item {\n        border-top: $accordion-border-width solid $accordion-border-color;\n        border-radius: $accordion-border-radius;\n\n        &:not(:first-of-type) {\n            margin-top: 8px;\n        }\n\n        .accordion-button {\n            border-radius: $accordion-border-radius;\n\n            &:not(.collapsed) {\n                border-bottom-left-radius: 0;\n                border-bottom-right-radius: 0;\n            }\n        }\n    }\n}\n\n.custom-accordion-border {\n    .accordion-item {\n        border-left: 3px solid $accordion-border-color;\n    }\n}\n\n//accordion Color \n\n@each $color,\n$value in $theme-colors {\n    .accordion-#{$color} {\n        .accordion-item {\n            border-color: rgba($value, 0.6);\n\n            .accordion-button {\n                box-shadow: none;\n\n                &:not(.collapsed) {\n                    color: $value;\n                    background-color: rgba($value, 0.1) !important;\n                }\n\n                &::after {\n                    color: $value;\n                }\n            }\n        }\n    }\n\n    .accordion-fill-#{$color} {\n        .accordion-item {\n            .accordion-button {\n                box-shadow: none;\n\n                &:not(.collapsed) {\n                    color: $white;\n                    background-color: $value !important;\n                }\n            }\n        }\n    }\n}\n\n\n// theme dark\n\n[data-layout-mode=\"dark\"]{\n    .accordion-button {\n        &:not(.collapsed) {\n            color: var(--#{$prefix}accordion-button-active-color);\n            &:after{\n                background-image: escape-svg(url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$white}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\"));\n            }\n        }\n\n        &:after{\n            background-image: escape-svg(url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$gray-500}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\"));\n        }\n    }\n}\n\n// rtl\n[dir=\"rtl\"]{\n    .custom-accordionwithicon {\n        .accordion-button::after{\n            transform: rotate(180deg);\n        }\n    }\n}","//\n// _helper.scss\n//\n\n$font-size-mixing: 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 36, 48;\n\n@each $font-size-mixing in $font-size-mixing {\n  .fs-#{$font-size-mixing} {\n    font-size: #{$font-size-mixing}px !important;\n  }\n}\n\n// border-color\n.border-dark {\n    border-color: var(--#{$prefix}dark)!important;\n}\n.border-light {\n    border-color: var(--#{$prefix}light)!important;\n}\n\n// Border Style\n$border-style-mixing: double, dashed, groove, outset, ridge, dotted, inset;\n@each $border-style-mixing in $border-style-mixing {\n    .border-#{$border-style-mixing} {\n        border-style: #{$border-style-mixing} !important;\n    }\n    .border-top-#{$border-style-mixing} {\n        border-top-style: #{$border-style-mixing} !important;\n    }\n    .border-bottom-#{$border-style-mixing} {\n        border-bottom-style: #{$border-style-mixing} !important;\n    }\n    .border-end-#{$border-style-mixing} {\n        border-right-style: #{$border-style-mixing} !important;\n    }\n    .border-start-#{$border-style-mixing} {\n        border-left-style: #{$border-style-mixing} !important;\n    }\n    \n    // List Group Flush Style\n    .list-group-flush {\n        &.border-#{$border-style-mixing} { \n            border: none !important;\n            .list-group-item {\n                border-style: #{$border-style-mixing} !important;\n            }\n        }\n    }\n}\n\n//link\n[data-layout-mode=\"dark\"]{\n    .link-dark, .link-light{\n        color: var(--#{$prefix}dark) !important;\n        &:is(:focus, :hover){\n            color: rgba(var(--#{$prefix}dark-rgb), 0.75) !important;\n        }\n    }\n}\n\n\n// Font Family\n\n.ff-base {\n    font-family: $font-family-base;\n}\n\n.ff-secondary {\n    font-family: $font-family-secondary;\n}\n\n// Font weight help class\n\n.fw-medium {\n    font-weight: $font-weight-medium;\n}\n\n// Flex\n\n.flex-1 {\n    flex: 1;\n}\n\n// Social\n\n.social-list-item {\n    height: 2rem;\n    width: 2rem;\n    line-height: calc(2rem - 4px);\n    display: block;\n    border: 2px solid $gray-500;\n    border-radius: 50%;\n    color: $gray-500;\n    text-align: center;\n    transition: all 0.4s;\n\n    &:hover {\n        color: $gray-600;\n        background-color: $gray-200;\n    }\n}\n\n\n// Backgroun pattern\n.bg-pattern {\n    background: url(\"../../images/modal-bg.png\") $modal-content-bg;\n}\n\n// Fixed minimum width\n.w-xs {\n    min-width: 80px;\n}\n\n.w-sm {\n    min-width: 95px;\n}\n\n.w-md {\n    min-width: 110px;\n}\n\n.w-lg {\n    min-width: 140px;\n}\n\n.w-xl {\n    min-width: 160px;\n}\n\n// Icons Sizes\n.icon-xs {\n    height: 16px;\n    width: 16px;\n}\n\n.icon-sm {\n    height: 18px;\n    width: 18px;\n}\n\n.icon-md {\n    height: 22px;\n    width: 22px;\n}\n\n.icon-lg {\n    height: 24px;\n    width: 24px;\n}\n\n.icon-xl {\n    height: 28px;\n    width: 28px;\n}\n\n.icon-xxl {\n    height: 32px;\n    width: 32px;\n}\n\n// Dual Icons\n.icon-dual {\n    color: $gray-500;\n    fill: rgba($gray-500,0.16);\n}\n\n@each $color,\n$value in $theme-colors {\n    .icon-dual-#{$color} {\n        color: $value;\n        fill: rgba($value, 0.16);\n    }\n}\n\n// Search \n.search-box{\n    position: relative;\n    .form-control{\n        padding-left: 40px;\n    }\n    .search-icon{\n        font-size: 14px;\n        position: absolute;\n        left: 13px;\n        top: 0;\n        height: 100%;\n        display: flex;\n        align-items: center;\n        color: $text-muted;\n    }\n}\n\n\n// overlay\n\n.bg-overlay {\n    position: absolute;\n    height: 100%;\n    width: 100%;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    top: 0;\n    opacity: 0.1;\n    background-color: $black;\n}\n\n// Btn Customizer\n\n.customizer-setting {\n    position: fixed;\n    bottom: 40px;\n    right: 20px;\n    z-index: 1000;\n}\n\n// \ncode {\n    user-select: all;\n}\n\n.layout-rightside {\n    width: 280px;\n    margin-right: -#{$grid-gutter-width};\n    margin-top: calc(1px - #{$grid-gutter-width} * 1.1);\n    height: calc(100% + #{$grid-gutter-width} * 1.1);\n}\n\n.layout-rightside-col {\n\n    @media (max-width: 1699.98px) { \n        display: none;\n        position: fixed !important;\n        height: 100vh;\n        right: 0px;\n        top: 0px;\n        bottom: 0px;\n        z-index: 1004;\n        .overlay{\n            position: fixed;\n            top: 0;\n            right: 0px;\n            bottom: 0px;\n            left: 0px;\n            background-color: rgba($dark, 0.2);\n           \n        }\n        .layout-rightside {\n            margin-top: 0px;\n            height: 100%;\n            margin-left: auto;\n        }\n        .card-body {\n            overflow-y: auto;\n            padding-bottom: 1rem !important;\n        }\n    }\n}\n\n[data-layout=\"horizontal\"], [data-layout-style=detached]{\n    @media (min-width: 1700px) {\n        .layout-rightside{\n            margin-top: calc(28px - #{$grid-gutter-width});\n            margin-right: 0;\n            height: calc(100% - calc(#{$grid-gutter-width} / 5));\n        }\n    }\n}\n\n// object fit cover\n.object-cover{\n    object-fit: cover;\n}\n\n// text-truncate-two-lines\n.text-truncate-two-lines{\n    overflow: hidden;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 2;\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    white-space: normal;\n}\n\n// Favourite button \n.favourite-btn{\n    border-color: transparent;\n    .ri-star-fill{\n        color: $text-muted;\n    }\n    &.active{\n        border-color: transparent;\n        .ri-star-fill{\n            color: $warning;\n            \n            &:before{\n                content: \"\\f186\";\n            }\n        }\n    }\n}\n// card\n.card-logo-light{\n    display: var(--#{$prefix}card-logo-light);\n}\n\n.card-logo-dark{\n    display: var(--#{$prefix}card-logo-dark);\n}\n\n[data-layout-mode=\"dark\"]{\n    .btn-close{\n        filter: invert(1) grayscale(100%) brightness(200%);\n    }\n}\n\n\n#back-to-top {\n    position: fixed;\n    bottom: 100px;\n    right: 28px;\n    transition: all 0.5s ease;\n    display: none;\n    z-index: 1000;\n    &:hover {\n        animation: fade-up 1.5s infinite linear;\n    }\n}\n\n@keyframes fade-up {\n  0% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n\n  75% {\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n}\n\n.cursor-pointer {\n    cursor: pointer;\n}","// \n// preloader.scss\n//\n\n#preloader {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: var(--#{$prefix}card-bg-custom);\n    z-index: 9999;\n}\n\n[data-preloader=\"disable\"] #preloader {\n    opacity: 0;\n    visibility: hidden;\n}\n\n#status {\n    width: 40px;\n    height: 40px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    margin: -20px 0 0 -20px;\n}","//\n// forms.scss\n//\n\n:is([type=\"tel\"], [type=\"url\"], [type=\"email\"], [type=\"number\"]){\n    &::placeholder {\n        text-align: left /*rtl: right*/;\n    }\n}\n","// \n// Widgets.scss\n// \n\n.main-chart {\n    .chart-border-left {\n        border-left: 1.4px solid $border-color;\n        padding: 2px 20px;\n\n        &:last-child {\n            margin-right: 0px;\n        }\n    }\n}\n\n\n\n/* Activity */\n\n.activity-feed {\n    list-style: none;\n\n    .feed-item {\n        position: relative;\n        padding-bottom: 27px;\n        padding-left: 16px;\n        border-left: 2px solid $light;\n\n        &:after {\n            content: \"\";\n            display: block;\n            position: absolute;\n            top: 4px;\n            left: -6px;\n            width: 10px;\n            height: 10px;\n            border-radius: 50%;\n            border: 2px solid $primary;\n            background-color: $card-bg;\n        }\n\n        &:last-child {\n            border-color: transparent;\n        }\n    }\n}\n\n// mini-stats-wid\n.mini-stats-wid {\n    position: relative;\n\n    .mini-stat-icon {\n        overflow: hidden;\n        position: relative;\n\n        &:before,\n        &:after {\n            content: \"\";\n            position: absolute;\n            width: 8px;\n            height: 69px;\n            background-color: rgba($success, .1);\n            left: 3px;\n            transform: rotate(32deg);\n            top: -8px;\n            transition: all 0.4s;\n        }\n\n        &::after {\n            left: 27px;\n            width: 8px;\n            transition: all 0.2s;\n        }\n    }\n\n    &:hover {\n        .mini-stat-icon {\n            &::after {\n                left: 60px;\n            }\n\n            &::before {\n                left: 50px;\n            }\n        }\n    }\n}\n\n// credit card widget\n.card-wrapper{\n    .jp-card{\n        .jp-card-back, .jp-card-front{\n            background-color: $success;\n        }\n    }\n}\n\n.notification-elem{\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-color: var(--#{$prefix}card-bg-custom);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    visibility: hidden;\n    opacity: 0;\n}\n\n//ecommerce widgets\n.clothes-size {\n    li {\n        input[type=\"radio\"] {\n            display: none;\n        }\n\n        label {\n            display: inline-block;\n            font-size: 14px;\n            border-radius: 5px;\n            border: 1px solid $border-color;\n            text-transform: none;\n            letter-spacing: 0;\n            color: $primary;\n        }\n\n        input[type=\"radio\"]:checked+label {\n            background-color: $primary;\n            border-color: $primary;\n            color: $white;\n        }\n    }\n}","// \n// _demos.scss\n// \n\n// Buttons demo\n.button-items {\n    margin-left: -8px;\n    margin-bottom: -12px;\n\n    .btn {\n        margin-bottom: 12px;\n        margin-left: 8px;\n    }\n}\n\n// Modals\n.bs-example-modal {\n    position: relative;\n    top: auto;\n    right: auto;\n    bottom: auto;\n    left: auto;\n    z-index: 1;\n    display: block;\n}\n\n[dir=\"rtl\"] {\n    .modal-open {\n        padding-left: 0px !important;\n    }\n}\n\n// Icon demo ( Demo only )\n.icon-demo-content {\n    color: var(--#{$prefix}gray-500);\n\n    i {\n        font-size: 24px;\n        margin-right: 10px;\n        color: var(--#{$prefix}gray-600);\n        transition: all 0.4s;\n        vertical-align: middle;\n    }\n\n    svg {\n        margin-right: 10px;\n        transition: all 0.4s;\n        height: 20px;\n    }\n\n    .col-lg-4 {\n        margin-top: 24px;\n\n        &:hover {\n            i, svg {\n                color: $primary;\n                transform: scale(1.5);\n            }\n        }\n    }\n}\n\n// Grid\n\n.grid-structure {\n    .grid-container {\n        background-color: $gray-100;\n        margin-top: 10px;\n        font-size: .8rem;\n        font-weight: $font-weight-medium;\n        padding: 10px 20px;\n    }\n}\n\n// customizer switch\n\n.img-switch{\n    .card-radio{\n        .form-check-input {\n            display: none;\n    \n            &:checked+.form-check-label {\n                &::before{\n                    content: \"\";\n                    position: absolute;\n                    top: 0;\n                    right: 0;\n                    bottom: 0;\n                    left: 0;\n                    background-color: rgba($primary, 0.5);\n                }\n                &::after{\n                    content: '\\eb80';\n                    font-family: \"remixicon\";\n                    position: absolute;\n                    top: 50%;\n                    left: 50%;\n                    transform: translateY(-50%) translateX(-50%);\n                    font-size: 18px;\n                    color: $white;\n                }\n            }\n        }\n    }\n}\n\n[data-bs-target=\"#collapseBgGradient\"]{\n    &.active{\n        border-color: $primary !important;\n        &::before{\n            content: \"\\eb80\";\n            font-family: remixicon;\n            position: absolute;\n            top: 2px;\n            right: 6px;\n            font-size: 16px;\n            color: $primary;\n        }\n    }\n}\n\n[data-layout-mode=\"dark\"]{\n    .colorscheme-cardradio{\n        .form-check-label{\n            background-color: var(--#{$prefix}dark);\n        }\n        .bg-light{\n            background-color: rgba(var(--#{$prefix}light-rgb), 0.1)!important;\n        }\n\n        .bg-soft-light {\n            background-color: rgba(var(--#{$prefix}dark-rgb),.1)!important;\n        }\n\n        .dark{\n            .bg-dark{\n                background-color: var(--#{$prefix}card-bg-custom)!important;\n            }\n        }\n    }\n}","// \n// print.scss\n//\n\n// Used invoice page\n@media print {\n    .vertical-menu,\n    .right-bar,\n    .page-title-box,\n    .navbar-header,\n    .app-menu,\n    .footer,\n    #back-to-top {\n        display: none !important;\n    }\n    .card-body,\n    .main-content,\n    .right-bar,\n    .page-content,\n    body {\n        padding: 0;\n        margin: 0;\n    }\n\n    .card{\n        border: 0;\n        box-shadow: none !important;\n    }\n\n    .invoice-details{\n        .d-sm-flex{\n            display: flex !important;\n        }\n    }\n    .address{\n        &.col-sm-6 {\n            flex: 0 0 auto !important;\n            width: 50% !important;\n            max-width: 100% !important;\n        }\n    }\n}","// \n// ribbons.scss\n//\n\n.ribbon-box {\n    position: relative;\n\n    .ribbon {\n        padding: 5px 12px;\n        box-shadow: 2px 5px 10px rgba($dark, 0.15);\n        color: $white;\n        font-size: $font-size-base;\n        font-weight: $font-weight-semibold;\n        position: absolute;\n        left: -1px;\n        top: 5px;\n\n        &.round-shape {\n            border-radius: 0 30px 30px 0;\n        }\n\n        &.ribbon-shape {\n            display: inline-block;\n\n            &::before {\n                content: \"\";\n                position: absolute;\n                right: -17px;\n                top: 0;\n                border: 14px solid transparent;\n            }\n\n            &::after {\n                content: \"\";\n                position: absolute;\n                right: -17px;\n                bottom: 0;\n                border: 14px solid transparent;\n            }\n        }\n\n    }\n\n    // ribbon circle\n    &.ribbon-circle {\n        .ribbon {\n            width: 48px;\n            height: 48px;\n            border-radius: 50%;\n            padding: 0;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            left: 20px;\n            top: 20px;\n        }\n    }\n\n    // ribbon fill\n\n    &.ribbon-fill {\n        overflow: hidden;\n            \n        .ribbon {\n            transform: rotate(-45deg);\n            width: 93px;\n            height: 52px;\n            left: -36px;\n            top: -16px;\n            display: flex;\n            justify-content: center;\n            align-items: flex-end;\n        }\n        &.ribbon-sm {\n            .ribbon {\n                padding: 2px 12px;\n                width: 78px;\n                height: 42px;\n                font-size: 12px;\n                box-shadow: none;\n            }\n        }\n    }\n\n    // right\n    &.right {\n        .ribbon {\n            position: absolute;\n            left: auto;\n            right: 0;\n\n            &.round-shape {\n                border-radius: 30px 0 0 30px;\n            }\n\n            &.ribbon-shape {\n                text-align: right;\n\n                &::before,\n                &::after {\n                    right: auto;\n                    left: -17px;\n                    border-left-color: transparent;\n                }\n            }\n        }\n\n        &.ribbon-circle {\n            .ribbon {\n                left: auto;\n                right: 20px;\n            }\n        }\n\n        .icon-ribbon {\n            right: 24px;\n            left: auto;\n        }\n\n        &.ribbon-fill {\n            .ribbon {\n                transform: rotate(45deg);\n                right: -38px;\n                left: auto;\n            }\n        }\n\n        &.ribbon-box {\n            .ribbon-two {\n                left: auto;\n                right: -5px;\n\n                span {\n                    left: auto;\n                    right: -21px;\n                    transform: rotate(45deg);\n                }\n            }\n        }\n\n    }\n\n    .ribbon-content {\n        clear: both;\n    }\n\n    @each $color,\n    $value in $theme-colors {\n        .ribbon-#{$color} {\n            background: ($value);\n\n            &:before {\n                border-color: darken(($value), 10%) transparent transparent;\n            }\n\n            &.ribbon-shape {\n                &::before {\n                    border-left-color: ($value);\n                    border-top-color: ($value);\n                }\n\n                &::after {\n                    border-left-color: ($value);\n                    border-bottom-color: ($value);\n                }\n            }\n        }\n\n        &.right {\n            .ribbon-#{$color} {\n                background: ($value);\n\n                &.ribbon-shape {\n                    &::before {\n                        border-right-color: ($value);\n                        border-top-color: ($value);\n                    }\n\n                    &::after {\n                        border-right-color: ($value);\n                        border-bottom-color: ($value);\n                    }\n                }\n            }\n        }\n    }\n\n\n    // Icon ribbon\n\n    .icon-ribbon {\n        box-shadow: none;\n        left: 24px;\n        top: -12px;\n        font-size: 40px;\n        padding: 0;\n    }\n\n\n    /* Ribbon two */\n    .ribbon-two {\n        position: absolute;\n        left: -5px;\n        top: -5px;\n        z-index: 1;\n        overflow: hidden;\n        width: 75px;\n        height: 75px;\n        text-align: right;\n\n        span {\n            font-size: 13px;\n            color: $white;\n            text-align: center;\n            line-height: 20px;\n            transform: rotate(-45deg);\n            width: 100px;\n            display: block;\n            box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);\n            position: absolute;\n            top: 19px;\n            left: -21px;\n            font-weight: $font-weight-semibold;\n\n            &:before {\n                content: \"\";\n                position: absolute;\n                left: 0;\n                top: 100%;\n                z-index: -1;\n                border-right: 3px solid transparent;\n                border-bottom: 3px solid transparent;\n            }\n\n            &:after {\n                content: \"\";\n                position: absolute;\n                right: 0;\n                top: 100%;\n                z-index: -1;\n                border-left: 3px solid transparent;\n                border-bottom: 3px solid transparent;\n            }\n        }\n    }\n\n    @each $color,\n    $value in $theme-colors {\n        .ribbon-two-#{$color} {\n\n            span {\n                background: ($value);\n\n                &:before {\n                    border-left: 3px solid darken(($value), 15%);\n                    border-top: 3px solid darken(($value), 15%);\n                }\n\n                &:after {\n                    border-right: 3px solid darken(($value), 15%);\n                    border-top: 3px solid darken(($value), 15%);\n                }\n            }\n        }\n    }\n\n}\n\n\n.ribbon-box {\n    &.right {\n        .ribbon-three {\n            position: absolute;\n            top: -6.1px;\n            right: 10px;\n            left: auto;\n        }\n    }\n}\n\n.ribbon-three {\n    position: absolute;\n    top: -6.1px;\n    left: 10px;\n\n    span {\n        position: relative;\n        display: block;\n        text-align: center;\n        color: $white;\n        font-size: 14px;\n        line-height: 1;\n        padding: 12px 8px 10px;\n        border-top-right-radius: 8px;\n        width: 90px;\n\n        &::after,\n        &::before {\n            position: absolute;\n            content: \"\";\n        }\n\n        &::before {\n            height: 6px;\n            width: 6px;\n            left: -6px;\n            top: 0;\n        }\n\n        &::after {\n            height: 6px;\n            width: 8px;\n            left: -8px;\n            top: 0;\n            border-radius: 8px 8px 0 0;\n        }\n    }\n\n    &::after {\n        position: absolute;\n        content: \"\";\n        width: 0;\n        height: 0;\n        border-left: 44px solid transparent;\n        border-right: 44px solid transparent;\n        border-top: 10px solid;\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .ribbon-three-#{$color} {\n\n        span {\n            background: ($value);\n\n            &:before {\n                background: ($value);\n            }\n\n            &:after {\n                background: darken($value, 10%);\n            }\n        }\n\n        &::after {\n            border-top-color: ($value);\n        }\n    }\n}\n\n//Ribbon Hover\n.ribbon-box {\n    .trending-ribbon {\n        transform: translateX(-50px);\n        transition: all 0.5s ease;\n\n        .trending-ribbon-text {\n            transition: all 0.5s ease;\n            opacity: 0;\n        }\n    }\n\n    &:hover {\n        .trending-ribbon {\n            transform: translateX(0);\n\n            .trending-ribbon-text {\n                opacity: 1;\n            }\n        }\n    }\n    &.right {\n        .trending-ribbon {\n            transform: translateX(50px);\n            transition: all 0.5s ease;\n    \n            .trending-ribbon-text {\n                transition: all 0.5s ease;\n                opacity: 0;\n            }\n        }\n    \n        &:hover {\n            .trending-ribbon {\n                transform: translateX(0);\n    \n                .trending-ribbon-text {\n                    opacity: 1;\n                }\n            }\n        }\n    }\n}","//\n// toast.scss\n//\n\n\n// toast\n.toast { \n    &:not(:last-child) {\n      margin-bottom: $toast-padding-x;\n    }\n}\n\n@mixin toast-border-variant($bg) {\n    .toast-body{\n        color: $bg;\n        border-bottom: 3px solid $bg;\n    }\n}\n\n@each $color, $value in $theme-colors {\n    .toast-border-#{$color} {\n        @include toast-border-variant($value);\n    }\n}","//\n// scrollspy.scss\n//\n\n// Scrollspy\n.scrollspy-example {\n  position: relative;\n  height: 200px;\n  margin-top: .5rem;\n  overflow: auto;\n}\n\n.scrollspy-example-2 {\n  position: relative;\n  height: 370px;\n  overflow: auto;\n}","// \n// reboot.scss\n//\n\nhtml {\n    position: relative;\n    min-height: 100%;\n}\n\n:is(.h1,\n.h2,\n.h3,\n.h4,\n.h5,\n.h6,\nh1,\nh2,\nh3,\nh4,\nh5,\nh6) {\n    color: $heading-color;\n    font-family: $heading-font-family;\n}\n\na {\n    text-decoration: none !important;\n}\n\nlabel {\n    font-weight: $font-weight-medium;\n    margin-bottom: $form-label-margin-bottom;\n}\nb,\nstrong {\n  font-weight: $font-weight-semibold;\n}\n\n// blockquote\n\n.blockquote {\n    padding: 10px 20px;\n    border-left: 4px solid var(--#{$prefix}gray-300);\n}\n\n.blockquote-reverse {\n    border-left: 0;\n    border-right: 4px solid var(--#{$prefix}gray-300);\n    text-align: right;\n}\n\n// container\n\n:is(.container,\n.container-lg,\n.container-md,\n.container-sm,\n.container-xl,\n.container-xxl) {\n    @media (min-width: 1200px) {\n        max-width: 1140px;\n    }\n}\n\n// row\n.row>*{\n    position: relative;\n}\n\n// mixing\n\n@function set-color-from-background($color) {\n    @if (lightness($color) > 70) {\n        @return $color-contrast-dark;\n    }\n    @else {\n        @return $color-contrast-light;\n    }\n}","//\n// alerts.scss\n//\n\n// alert solid\n\n.alert-solid {\n    .alert-link {\n        color: $white;\n    }\n}\n\n// alert outline\n\n.alert-outline {\n    background-color: var(--#{$prefix}card-bg-custom);\n    border-width: 2px;\n}\n\n// alert borderless\n\n.alert-borderless {\n    border-width: 0;\n}\n\n// alert-label-icon\n\n.alert-label-icon {\n    position: relative;\n    padding-left: 60px;\n    border: 0;\n\n    .label-icon {\n        position: absolute;\n        width: 45px;\n        height: 100%;\n        left: 0;\n        top: 0;\n        background-color: rgba($white, 0.15);\n        font-size: 16px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    // label arrow\n    &.label-arrow {\n        overflow: hidden;\n        .label-icon {\n            &:after {\n                content: \"\";\n                position: absolute;\n                border: 6px solid transparent;\n                border-left-color: $primary;\n                right: -12px;\n            }\n        }\n    }\n}\n\n\n// Alert border left example\n\n.alert-border-left {\n    border-left: 3px solid;\n}\n\n// alert top border example\n\n.alert-top-border {\n    background-color: var(--#{$prefix}card-bg-custom);\n    border-color: $border-color;\n    border-top: 2px solid;\n    color: var(--#{$prefix}body-color);\n}\n\n//alert additional example\n\n.alert-additional { \n    padding: 0;\n\n    .alert-body{\n        padding: $alert-padding-y $alert-padding-x;\n    }\n    .alert-content {\n        padding: $alert-padding-y $alert-padding-x;\n        border-bottom-left-radius: $alert-border-radius;\n        border-bottom-right-radius: $alert-border-radius;\n        margin: 0 (-$alert-border-width) (-$alert-border-width) (-$alert-border-width);\n    }\n}\n\n// rounded label example\n\n.rounded-label {\n    .label-icon {\n        width: 45px;\n        height: 26px;\n        left: 0px;\n        top: 50%;\n        transform: translateY(-50%);\n        border-radius: 0 30px 30px 0;\n    }\n}\n\n// Alert example loop\n\n@each $color, $value in $theme-colors {\n    // alert solid\n    .alert-solid {\n        &.alert-#{$color} {\n            background-color: $value;\n            border-color: $value;\n            color: set-color-from-background($value);\n        }\n    }\n\n    // alert outline\n    .alert-outline {\n        &.alert-#{$color} {\n            color: $value;\n        }\n    }\n\n    // alert border left\n    .alert-border-left {\n        &.alert-#{$color} {\n            border-left-color: $value;\n        }\n    }\n\n    // alert top border\n    .alert-top-border {\n        &.alert-#{$color} {\n            border-top-color: $value;\n        }\n    }\n    \n\n    // rounded label\n\n    .rounded-label {\n        &.alert-#{$color} {\n            .label-icon {\n                background-color: $value;\n                color: set-color-from-background($value);\n            }\n        }\n    }\n\n    // label arrow\n\n    .label-arrow {\n        &.alert-#{$color} {\n            .label-icon {\n                color: set-color-from-background($value);\n                background-color: $value;\n                &:after {\n                    border-left-color: $value !important;\n                }\n            }\n        }\n    }\n\n    .alert{\n        &.alert-#{$color} {\n            .btn-close::after{\n                color: $value;\n            }\n        }\n        \n    }\n\n    //alert additional example\n    .alert-additional {\n        &.alert-#{$color} {\n            .alert-content {\n                background-color: $value;\n                color: set-color-from-background($value);\n            }\n        }\n    }   \n}\n.alert-dismissible {\n    .btn-close {\n        background: transparent !important;\n        &::after {\n            background: transparent !important;\n            content: \"\\F0156\" !important;\n            font-size: 18px;\n            line-height:15px;\n            font-family: \"Material Design Icons\" !important;\n        }\n    }\n}\n\n.alert-outline.alert-dark{\n    color: var(--#{$prefix}dark);\n}\n   ","// \n// backgrounds.scss\n//\n\n\n@each $color,\n$value in $theme-colors {\n    .bg-soft-#{$color} {\n        background-color: rgba(($value), 0.18) !important;\n    }\n}\n\n.bg-soft-dark{\n    background-color: rgba(var(--#{$prefix}dark-rgb),.18)!important;\n}\n\n.bg-soft-light{\n    background-color: rgba(var(--#{$prefix}light-rgb),.18)!important;\n}\n\n","// \n// badge.scss\n//\n\n// Soft badge\n@mixin badge-variant-soft($bg) {\n    color: $bg;\n    background-color: rgba($bg, 0.1);\n}\n\n\n// Outline badge\n@mixin badge-variant-outline($bg) {\n    color: $bg;\n    border: 1px solid $bg;\n    background-color: transparent;\n}\n\n@each $color, $value in $theme-colors {\n    .badge-outline-#{$color} {\n        @include badge-variant-outline($value);\n    }\n}\n\n// badge outline\n\n.badge-outline {\n    background-color: var(--#{$prefix}card-bg-custom);\n    border: 1px solid;\n}\n\n@each $color, $value in $theme-colors {\n    .badge-soft-#{$color} {\n        @include badge-variant-soft($value);\n    }\n\n    .badge-outline {\n        &.badge-#{$color} {\n            @include badge-variant-outline($value);\n        }\n    }\n\n    .badge-label {\n        &.bg-#{$color} {\n            &:before {\n                border-right-color: $value;\n            }\n        }\n    }\n}\n\n// badge-border\n\n.badge-border {\n    border-left: 2px solid;\n}\n\n// badge-label\n\n.badge-label {\n    margin-left: 8px;\n    position: relative;\n    &:before {\n        content: \"\";\n        position: absolute;\n        border: 8px solid transparent;\n        border-right-color: $primary;\n        left: -14px;\n        top: 0;\n    }\n}\n\n// [data-layout-mode=\"dark\"]{\n//     .badge{\n//         &.bg-dark{\n//             background-color: var(--#{$prefix}light) !important;\n//         }\n\n//         &.bg-light{\n//             background-color: var(--#{$prefix}dark) !important;\n//             color: var(--#{$prefix}light) !important;\n//         }\n//     }\n// }\n\n//Badge Gradient Style\n$gradients: ();\n$gradients: map-merge((primary: linear-gradient(135deg, $primary 0%, $success 100%),\n        secondary: linear-gradient(135deg, $secondary 0%, $info 100%),\n        success: linear-gradient(135deg, $success 0%, $warning 100%),\n        danger: linear-gradient(135deg, $danger 0%, $secondary 100%),\n        warning: linear-gradient(135deg, $warning 0%, darken($warning, 15%) 100%),\n        info: linear-gradient(135deg, $info 0%, $success 100%),\n        dark: linear-gradient(135deg, $dark 0%, $primary 100%)),\n    $gradients);\n\n@mixin badge-gradient($parent, $gradient) {\n    #{$parent} {\n        background: $gradient;\n    }\n}\n\n@each $gradient,\n$value in $gradients {\n    @include badge-gradient(\".badge-gradient-#{$gradient}\", $value);\n}","// \n// _buttons.scss\n// \n\nbutton,\na {\n    outline: none !important;\n    position: relative;\n}\n\n.btn {\n    box-shadow: $element-shadow;\n}\n\n:is(.btn.show, .btn:first-child:active, :not(.btn-check)+.btn:active) {\n    border-color: transparent;\n}\n\n// Rounded Buttons\n.btn-rounded {\n    border-radius: 30px;\n}\n\n\n.btn-icon {\n    display: inline-flex;\n    justify-content: center;\n    align-items: center;\n    height: calc(#{$btn-padding-y * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\n    width: calc(#{$btn-padding-y * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\n    padding: 0;\n\n    :is(i, svg, img) {\n        vertical-align: middle;\n    }\n\n    &.btn-sm {\n        height: calc(#{$btn-padding-y-sm * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\n        width: calc(#{$btn-padding-y-sm * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\n    }\n\n    &.btn-lg {\n        height: calc(#{$btn-padding-y-lg * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\n        width: calc(#{$btn-padding-y-lg * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\n    }\n}\n\n//\n// Soft Buttons\n// \n\n@each $color,\n$value in $theme-colors {\n    .btn-soft-#{$color} {\n        --#{$prefix}btn-color: #{$value};\n        --#{$prefix}btn-bg: #{rgba($value, .1)};\n        --#{$prefix}btn-border-color: transparent;\n        --#{$prefix}btn-hover-color: #{$white};\n        --#{$prefix}btn-hover-bg: #{shade-color($value, 10%)};\n        --#{$prefix}btn-hover-border-color: transparent;\n        --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($value)};\n        --#{$prefix}btn-active-color: var(--#{$prefix}btn-hover-color);\n        --#{$prefix}btn-active-bg: #{shade-color($value, 20%)};\n        --#{$prefix}btn-active-border-color: transparent;\n    }\n}\n\n//\n// Ghost Buttons\n// \n\n@each $color,\n$value in $theme-colors {\n    .btn-ghost-#{$color} {\n        --#{$prefix}btn-color: #{$value};\n        --#{$prefix}btn-bg: transparent;\n        --#{$prefix}btn-border-color: transparent;\n        --#{$prefix}btn-hover-color: #{$value};\n        --#{$prefix}btn-hover-bg: #{rgba($value, .1)};\n        --#{$prefix}btn-hover-border-color: transparent;\n        --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($value)};\n        --#{$prefix}btn-active-color: #{$value};\n        --#{$prefix}btn-active-bg: #{rgba($value, .1)};\n        --#{$prefix}btn-active-border-color: transparent;\n    }\n}\n\n.btn-ghost-secondary {\n    color: var(--#{$prefix}gray-700);\n}\n\n//button with icon\n.btn-label {\n    position: relative;\n    padding-left: 44px;\n\n    .label-icon {\n        position: absolute;\n        width: 35.5px;\n        left: -$btn-border-width;\n        top: -$btn-border-width;\n        bottom: -$btn-border-width;\n        background-color: rgba($white, 0.1);\n        font-size: 16px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n\n    &.btn-light {\n        .label-icon {\n            background-color: rgba($dark, 0.05);\n        }\n    }\n\n    &.right {\n        padding-left: $btn-padding-x;\n        padding-right: 44px;\n\n        .label-icon {\n            right: -$btn-border-width;\n            left: auto;\n        }\n    }\n}\n\n// Animation Button\n\n.btn-animation {\n    overflow: hidden;\n    transition: border-color 0.3s, background-color 0.3s;\n    transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\n\n    &::after {\n        content: attr(data-text);\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n        opacity: 0;\n        transform: translate3d(0, 25%, 0);\n        padding: $btn-padding-y $btn-padding-x;\n        transition: transform 0.3s, opacity 0.3s;\n        transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\n    }\n\n    >span {\n        display: block;\n        transition: transform 0.3s, opacity 0.3s;\n        transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\n    }\n\n    &:hover {\n        &::after {\n            opacity: 1;\n            transform: translate3d(0, 0, 0);\n        }\n\n        >span {\n            opacity: 0;\n            transform: translate3d(0, -25%, 0);\n        }\n    }\n}\n\n\n@mixin button-variant($bg) {\n    &.btn-animation {\n        background-color: $bg;\n        border-color: $bg !important;\n\n        &:is(:hover, :focus, :active, :focus-visible) {\n            color: $bg;\n            background-color: rgba($bg, 0.1);\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .btn-#{$color} {\n        @include button-variant($value);\n    }\n}\n\n//btn group\n.btn-group-vertical {\n    label {\n        margin-bottom: 0;\n    }\n}\n\n// btn group radio\n.btn-group.radio {\n    .btn {\n        border: none;\n    }\n\n    .btn-check:active+.btn-light,\n    .btn-check:checked+.btn-light,\n    .btn-light.active,\n    .btn-light.dropdown-toggle.show,\n    .btn-light:active {\n        background-color: rgba($info, 0.2);\n        color: $info;\n    }\n}\n\n// theme dark\n[data-layout-mode=\"dark\"] {\n\n    .btn-check:focus+.btn-light,\n    .btn-check:focus+.btn-outline-light,\n    .btn-check:focus+.btn-soft-light,\n    .btn-soft-light:focus {\n        color: var(--#{$prefix}dark);\n        background-color: rgba(var(--#{$prefix}light-rgb), 0.75);\n        border-color: rgba(var(--#{$prefix}light-rgb), 0.75);\n    }\n\n    .btn-check:active+.btn-light,\n    .btn-check:active+.btn-outline-light,\n    .btn-check:active+.btn-soft-light,\n    .btn-check:checked+.btn-light,\n    .btn-check:checked+.btn-outline-light,\n    .btn-check:checked+.btn-soft-light,\n    .btn-light.active,\n    .btn-light:active,\n    .btn-outline-light.active,\n    .btn-outline-light:active,\n    .btn-soft-light.active,\n    .btn-soft-light:active,\n    .show>.btn-light.dropdown-toggle,\n    .show>.btn-outline-light.dropdown-toggle,\n    .show>.btn-soft-light.dropdown-toggle {\n        color: var(--#{$prefix}dark);\n        background-color: rgba(var(--#{$prefix}light-rgb), 0.75);\n        border-color: rgba(var(--#{$prefix}light-rgb), 0.75);\n    }\n\n    .btn-check:focus+.btn-dark,\n    .btn-check:focus+.btn-outline-dark,\n    .btn-check:focus+.btn-soft-dark,\n    .btn-soft-dark:focus {\n        color: var(--#{$prefix}light);\n        background-color: rgba(var(--#{$prefix}dark-rgb), 0.75);\n        border-color: rgba(var(--#{$prefix}dark-rgb), 0.75);\n    }\n\n    .btn-check:active+.btn-dark,\n    .btn-check:active+.btn-outline-dark,\n    .btn-check:active+.btn-soft-dark,\n    .btn-check:checked+.btn-dark,\n    .btn-check:checked+.btn-outline-dark,\n    .btn-check:checked+.btn-soft-dark,\n    .btn-dark.active,\n    .btn-dark:active,\n    .btn-outline-dark.active,\n    .btn-outline-dark:active,\n    .btn-soft-dark.active,\n    .btn-soft-dark:active,\n    .show>.btn-dark.dropdown-toggle,\n    .show>.btn-outline-dark.dropdown-toggle,\n    .show>.btn-soft-dark.dropdown-toggle {\n        color: var(--#{$prefix}light);\n        background-color: rgba(var(--#{$prefix}dark-rgb), 0.75);\n        border-color: rgba(var(--#{$prefix}dark-rgb), 0.75);\n    }\n\n    // soft\n\n    .btn-soft-light {\n        color: var(--#{$prefix}dark);\n        background-color: rgba(var(--#{$prefix}light-rgb), 0.1);\n\n        &:hover {\n            color: var(--#{$prefix}dark);\n            background-color: var(--#{$prefix}light);\n        }\n    }\n\n    .btn-soft-dark {\n        color: var(--#{$prefix}dark);\n        background-color: rgba(var(--#{$prefix}dark-rgb), 0.1);\n\n        &:hover {\n            color: var(--#{$prefix}light);\n            background-color: var(--#{$prefix}dark);\n        }\n    }\n\n    // ghost\n    .btn-ghost-light {\n        color: var(--#{$prefix}dark);\n\n        &:is(:hover, :focus, :active, :focus-visible) {\n            color: var(--#{$prefix}dark);\n            background-color: rgba(var(--#{$prefix}light-rgb), 0.5);\n        }\n    }\n\n    .btn-ghost-dark {\n        color: var(--#{$prefix}dark);\n\n        &:is(:hover, :focus, :active, :focus-visible) {\n            color: var(--#{$prefix}dark);\n            background-color: rgba(var(--#{$prefix}dark-rgb), 0.1);\n        }\n    }\n}\n\n.btn-load {\n\n    .spinner-border,\n    .spinner-grow {\n        height: 19px;\n        width: 19px;\n    }\n}\n\n//Border Bottom Buttons Style\n@each $color,\n$value in $theme-colors {\n\n    :is(.btn-#{$color}, .btn-outline-#{$color}, .btn-soft-#{$color}) {\n        &.btn-border {\n            border-bottom: 2px solid darken($value, 8%);\n        }\n    }\n}\n\n//custom toggle\n.custom-toggle {\n    .icon-off {\n        display: none;\n    }\n\n    &.active {\n        .icon-on {\n            display: none;\n        }\n\n        .icon-off {\n            display: block;\n        }\n    }\n}","// \n// breadcrumb.scss\n//\n\n\n// Breadcrumb item arrow\n.breadcrumb-item {\n    > a {\n        color: var(--#{$prefix}gray-700);\n    }\n    +.breadcrumb-item {\n        &::before {\n            font-family: \"Material Design Icons\";\n            font-size: 15px;\n            line-height: 20px;\n        }\n    }\n}\n  ","// \n// _card.scss\n// \n\n.card {\n    margin-bottom: $grid-gutter-width;\n    box-shadow: $card-box-shadow;\n}\n\n.card-header {\n    border-bottom: 1px solid $border-color;\n}\n\n//Card Header Dropdown\n.card-header-dropdown {\n    .dropdown-btn {\n        padding: $card-cap-padding-y 0;\n    }\n}\n\n.card-footer {\n    border-top: 1px solid $border-color;\n}\n\n.card-drop {\n    color: $body-color;\n}\n\n.card-title {\n    font-size: 16px;\n    margin: 0 0 7px 0;\n}\n\n.card-title-desc {\n    margin-bottom: 24px;\n}\n\n.card-height-100 {\n    height: calc(100% - #{$grid-gutter-width});\n}\n\n.card-animate{\n    transition: all 0.4s;\n\n    &:hover{\n        transform: translateY(calc(#{-$grid-gutter-width} / 5));\n        box-shadow: $box-shadow-lg;\n    }\n}\n\n\n// card color variant\n\n@mixin card-variant($bg) {\n    color: $white;\n    background-color: $bg;\n}\n\n@each $color,\n$value in $theme-colors {\n    .card-#{$color} {\n        @include card-variant($value);\n\n        .card-header, .card-footer {\n            background-color: rgba($white, 0.1);\n            color: $white;\n            border-color: transparent;\n        }\n\n        .card-title {\n            color: $white;\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .card-border-#{$color} {\n        border-color: $value !important;\n        .card-header, .card-footer {\n            border-color: $value;\n        }\n\n    }\n}\n\n.card-light{\n    background-color: var(--#{$prefix}light);\n    .card-header, .card-footer{\n        color: var(--#{$prefix}body-color) !important;\n        background-color: rgba(var(--#{$prefix}dark-rgb), 0.1);\n    }\n    .card-title, .card-text { \n        color: var(--#{$prefix}body-color) !important;\n    }\n}\n\n.stretched-link {\n    position: static;\n}\n\n\n// Loader\n\n.card-preloader {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(var(--#{$prefix}light-rgb), 0.6);\n    z-index: 9999;\n}\n\n.card-status {\n    width: 40px;\n    height: 40px;\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%,-50%)!important;\n}\n\n.custom-loader {\n    animation: spin 2s linear infinite;\n}\n\n@keyframes spin {\n\tto { transform: rotate(360deg) }\n}\n\n.card-overlay{\n    position: relative;\n    overflow: hidden;\n    &:before {\n        content: \"\";\n        background-color: rgba($primary, 0.20);\n        position: absolute;\n        top: 0;\n        right: 0;\n        left: 0;\n        bottom: 0;\n    }\n    :is(.card-header, .card-footer) {\n        border-color: rgba($white, 0.15) !important;\n    }\n}\n\n.card-toolbar-menu {\n    line-height: 0.8;\n    a {\n        font-size: 17px;\n    }\n    .minimize-card {\n        .plus{\n            display: none;\n        }  \n        .minus {\n            display: block;\n        }\n        &.collapsed{\n            .plus{\n                display: block;\n            }  \n            .minus {\n                display: none;\n            }\n        }\n    }\n}","// \n// _dropdown.scss\n// \n\n.dropdown-toggle::after {\n    display: inline-block;\n    margin-left: .255em;\n    font-size: 15px;\n    line-height: 15px;\n    content: \"\\F0140\";\n    font-family: \"Material Design Icons\";\n}\n\n.dropdown-menu {\n    box-shadow: $box-shadow-lg;\n    animation-name: DropDownSlide;\n    animation-duration: .3s;\n    animation-fill-mode: both;\n    position: absolute;\n    z-index: 1000;\n\n    &.dropdown-megamenu {\n        padding: 20px;\n        left: 0 !important;\n        right: 0 !important;\n    }\n\n    &[data-popper-placement=\"top-start\"] {\n        animation-name: DropDownSlideDown;\n    }\n}\n\n@keyframes DropDownSlide {\n    100% {\n        margin-top: -1px;\n    }\n\n    0% {\n        margin-top: 8px;\n    }\n}\n\n@keyframes DropDownSlideDown {\n    100% {\n        margin-bottom: 0;\n    }\n\n    0% {\n        margin-bottom: 8px;\n    }\n}\n\n@media (min-width: 600px) {\n    .dropdown-menu-xl {\n        width: 420px;\n    }\n\n    .dropdown-menu-lg {\n        width: 320px;\n    }\n\n    .dropdown-menu-md {\n        width: 240px;\n    }\n}\n\n.dropdown-toggle-split {\n    border-left: none;\n    &::after {\n        margin-left: 0px;\n    }\n\n    &:before {\n        content: \"\";\n        position: absolute;\n        background-color: rgba($white,0.12);\n        top: -$btn-border-width;\n        bottom: -$btn-border-width;\n        right: -$btn-border-width;\n        left: 0;\n        border-radius: 0 $btn-border-radius $btn-border-radius 0;\n    }\n}\n\n// Dropdown Mega Menu\n\n.dropdown-mega {\n    position: static !important;\n}\n\n\n\n// Dropdown size\n\n.dropdown-mega-menu-xl {\n    width: 38rem;\n}\n\n.dropdown-mega-menu-lg {\n    width: 26rem;\n}\n\n[dir=\"ltr\"] {\n    .dropdown-menu-start {\n        --bs-position: end;\n    }\n\n    .dropdown-menu-end {\n        --bs-position: start;\n    }\n}\n// Custom Dropdown with Tabs\n.dropdown-head{\n    .nav-tabs-custom{\n        border: 0;\n        .nav-link  {\n            color: rgba($white, 0.6);\n            &.active {\n                background-color: var(--#{$prefix}dropdown-bg);\n            }\n            &:hover {\n                color: $white;\n            }\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .dropdownmenu-#{$color} {\n      .dropdown-item{\n        &:is(:focus, :hover, .active){\n          background-color: rgba(($value), 0.07);\n          color: $value;\n        }\n      }\n    }\n}","//\n// _nav.scss\n//\n\n:is(.nav-tabs, .nav-pills) {\n    >li {\n        >a {\n            color: var(--#{$prefix}gray-700);\n            font-weight: $font-weight-medium;\n        }\n    }\n}\n\n.nav-pills {\n    >a {\n        color: var(--#{$prefix}gray-700);\n        font-weight: $font-weight-medium;\n    }\n}\n\n.nav-pills {\n\n    :is(.nav-link.active, .show>.nav-link) {\n        box-shadow: $element-shadow;\n    }\n}\n\n.nav-tabs-custom {\n    border-bottom: 1px solid var(--#{$prefix}gray-300);\n\n    .nav-item {\n        position: relative;\n\n        .nav-link {\n            border: none;\n            font-weight: $font-weight-medium;\n\n            &::after {\n                content: \"\";\n                background: $primary;\n                height: 1px;\n                position: absolute;\n                width: 100%;\n                left: 0;\n                bottom: 0;\n                transition: all 250ms ease 0s;\n                transform: scale(0);\n            }\n\n            &.active {\n                color: $primary;\n\n                &:after {\n                    transform: scale(1);\n                }\n            }\n        }\n    }\n\n    &.card-header-tabs {\n        margin-top: -1rem;\n\n        .nav-link {\n            padding: $card-cap-padding-y $card-cap-padding-x;\n        }\n    }\n}\n\n// vertical nav\n\n.vertical-nav {\n    .nav {\n        .nav-link {\n            padding: 24px 16px;\n            text-align: center;\n            margin-bottom: 8px;\n\n            .nav-icon {\n                font-size: 24px;\n            }\n        }\n    }\n}\n\n//Navtab custom\n.navtab-bg {\n    li {\n        >a {\n            background-color: $gray-300;\n            margin: 0 5px;\n        }\n    }\n}\n\n// arrow-navtabs\n\n.arrow-navtabs {\n    .nav-item {\n        .nav-link {\n            position: relative;\n            text-align: center;\n\n            &:before {\n                content: \"\";\n                position: absolute;\n                border: 6px solid transparent;\n                bottom: -12px;\n                left: 50%;\n                transform: translateX(-50%);\n                @include transition($nav-link-transition);\n            }\n\n            &.active {\n                &:before {\n                    border-top-color: $primary;\n                }\n            }\n        }\n    }\n}\n\n// custom hover tab\n.custom-hover-nav-tabs {\n    .nav-item {\n        text-align: center;\n        overflow: hidden;\n\n        .nav-link {\n            width: 120px;\n            height: 45px;\n            position: relative;\n            border-radius: 0px;\n\n            .nav-icon {\n                font-size: 22px;\n            }\n\n            .nav-titl {\n                font-size: 14px;\n            }\n\n            &.active {\n                .nav-tab-position {\n                    color: $white;\n                }\n            }\n\n            .nav-tab-position {\n                position: absolute;\n                left: 0;\n                right: 0;\n                transition: all 0.4s;\n\n                &.nav-icon {\n                    top: 50%;\n                    transform: translateY(-50%);\n                }\n\n                &.nav-titl {\n                    bottom: -20px;\n                }\n            }\n\n            &:hover {\n                .nav-titl {\n                    bottom: 50%;\n                    transform: translateY(50%);\n                }\n\n                .nav-icon {\n                    top: -20px;\n                }\n            }\n        }\n    }\n}\n\n// custom vertical tab\n\n.custom-verti-nav-pills {\n    .nav-link {\n        background-color: var(--#{$prefix}light);\n        margin-top: 7px;\n        position: relative;\n\n        @media (min-width: 992px) {\n            &::before {\n                content: \"\";\n                position: absolute;\n                right: -20px;\n                top: 50%;\n                transform: translateY(-50%);\n                border: 12px solid transparent;\n                border-left-color: transparent;\n                transition: border-left-color 0.04 ease;\n            }\n\n            &.active {\n                &::before {\n                    border-left-color: $primary;\n                }\n            }\n        }\n    }\n}\n\n// animation nav\n.animation-nav {\n    li {\n        position: relative;\n\n        a {\n            color: var(--#{$prefix}body-color);\n            border-radius: 4px;\n            position: relative;\n            overflow: hidden;\n            transition: all 0.4s;\n            z-index: 1;\n\n            span {\n                position: relative;\n            }\n\n            &::before {\n                content: \"\";\n                position: absolute;\n                top: 0;\n                width: 0;\n                right: 0;\n                height: 100%;\n                transition: width 0.4s cubic-bezier(0.51, 0.18, 0, 0.88) 0.1s;\n                background-color: $primary;\n                z-index: -1;\n            }\n\n            &:hover,\n            &.active {\n                color: $white;\n                background-color: transparent !important;\n\n                &::before {\n                    width: 100%;\n                    left: 0;\n                }\n            }\n        }\n    }\n}\n\n.nav-border-top {\n    .nav-link {\n        border-top: 3px solid transparent;\n\n        &.active {\n            border-top-color: $primary;\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .nav-border-top-#{$color} {\n        .nav-link {\n            &.active {\n                color: $value;\n                border-top-color: $value;\n            }\n        }\n    }\n}\n\n.nav-custom {\n    background-color: $primary;\n    border-radius: $card-border-radius;\n\n    .nav-item {\n        .nav-link {\n            color: rgba($white, 0.75);\n\n            &.active {\n                color: $white;\n                background-color: rgba($white, 0.1);\n            }\n        }\n    }\n\n    &.nav-custom-light {\n        .nav-item {\n            .nav-link {\n                color: rgba(var(--#{$prefix}dark-rgb), 0.75);\n\n                &.active {\n                    color: $light;\n                    background-color: $primary;\n                }\n            }\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .nav-custom-#{$color} {\n        background-color: $value;\n    }\n}\n\n.nav-custom-light {\n    background-color: var(--#{$prefix}light);\n}\n\n@each $color,\n$value in $theme-colors {\n    .nav-#{$color} {\n        .nav-link {\n            &.active {\n                color: $white;\n                background-color: $value;\n            }\n        }\n\n        &.nav-tabs {\n            .nav-link {\n                &.active {\n                    color: $value;\n                    background-color: var(--#{$prefix}card-bg-custom);\n                }\n            }\n        }\n\n        &.nav-tabs-custom {\n            .nav-link {\n                &.active {\n                    color: $value;\n                    background-color: var(--#{$prefix}card-bg-custom);\n\n                    &::after {\n                        background-color: $value;\n                    }\n                }\n            }\n        }\n\n        &.arrow-navtabs {\n            .nav-link {\n                &.active {\n                    &::before {\n                        border-top-color: $value;\n                    }\n                }\n            }\n        }\n\n        &.custom-verti-nav-pills {\n            .nav-link {\n                &.active {\n                    &::before {\n                        border-left-color: $value;\n                    }\n                }\n            }\n        }\n    }\n}\n\n// progress nav\n.progress-nav {\n    position: relative;\n    margin-right: 1rem;\n    margin-left: 1rem;\n\n    .progress {\n        position: absolute;\n        left: 0;\n        top: 50%;\n        transform: translateY(-50%);\n        width: 100%;\n    }\n\n    .nav {\n        margin-right: -1rem;\n        margin-left: -1rem;\n        justify-content: space-between;\n\n        .nav-link {\n            width: 2rem;\n            height: 2rem;\n            background-color: var(--#{$prefix}light);\n            padding: 0;\n            color: var(--#{$prefix}dark);\n            font-weight: $font-weight-medium;\n\n            &.active,\n            &.done {\n                background-color: $primary;\n                color: $white;\n            }\n        }\n    }\n}\n\n// Step arrow nav\n.step-arrow-nav {\n    .nav {\n        background-color: var(--#{$prefix}light);\n\n        .nav-link {\n            border-radius: 0;\n            position: relative;\n            font-weight: $font-weight-medium;\n            color: var(--#{$prefix}dark);\n\n            &::before {\n                content: \"\";\n                position: absolute;\n                border: 7px solid transparent;\n                right: -14px;\n                top: 50%;\n                transform: translateY(-50%);\n            }\n\n            &.done {\n                background-color: rgba($primary, 0.05);\n                color: $primary;\n\n                &::before {\n                    border-left-color: transparent;\n                }\n            }\n\n            &.active {\n                background-color: rgba($primary, 0.1);\n                color: $primary;\n                box-shadow: none;\n\n                &::before {\n                    border-left-color: rgba($primary, 0.1);\n                }\n            }\n        }\n\n        .nav-item {\n            &:last-child {\n                .nav-link {\n                    &:before {\n                        display: none;\n                    }\n                }\n            }\n        }\n    }\n}\n\n// vertical nav step\n.vertical-navs-step {\n    .nav {\n        gap: 16px;\n\n        .nav-link {\n            text-align: left;\n            background-color: rgba(var(--#{$prefix}light-rgb), 0.4);\n            border: 1px solid var(--#{$prefix}border-color);\n            color: var(--#{$prefix}dark);\n\n            .step-title {\n                font-weight: $font-weight-semibold;\n            }\n\n            .step-icon {\n                color: $danger;\n                vertical-align: middle;\n                font-weight: $font-weight-medium;\n                float: left;\n            }\n\n            &.active,\n            &.done {\n                .step-icon {\n                    color: $success;\n\n                    &:before {\n                        content: \"\\eb80\";\n                    }\n                }\n            }\n\n            &.active {\n                border-color: $primary;\n            }\n\n            &.done {\n                border-color: $success;\n            }\n        }\n    }\n}\n\n//Outline Border Nav\n.nav-custom-outline {\n    &.nav {\n        .nav-link {\n            border: 1px solid transparent;\n            border-bottom: 2px solid transparent;\n\n            &.active {\n                border-color: $primary;\n                background-color: transparent;\n                color: $primary;\n            }\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .nav-#{$color} {\n        &.nav-custom-outline {\n            .nav-link {\n                &.active {\n                    color: $value;\n                    border-color: $value;\n                }\n            }\n        }\n    }\n}\n\n//customs nav\n.nav-customs {\n    &.nav {\n        padding-left: 34px;\n        overflow: hidden;\n\n        .nav-link {\n            position: relative;\n            display: block;\n            float: right;\n            background-color: var(--#{$prefix}body-bg);\n            margin-right: 46px;\n            transition: all 0.5s ease;\n\n            &::before,\n            &::after {\n                display: block;\n                content: \" \";\n                position: absolute;\n                top: -1px;\n                bottom: -1px;\n                width: 37px;\n                background-color: var(--#{$prefix}body-bg);\n                transition: all 0.5s ease;\n            }\n\n            &::before {\n                border-radius: 0 8px 0 0;\n                right: -24px;\n                transform: skew(30deg, 0deg);\n            }\n\n            &::after {\n                border-radius: 8px 0 0 0;\n                left: -24px;\n                transform: skew(-30deg, 0deg);\n            }\n\n            &.active,\n            &.active:before,\n            &.active:after {\n                background-color: $primary;\n                color: $white;\n            }\n\n            &.active {\n                z-index: 1;\n            }\n        }\n    }\n}","// \n// _table.scss\n// \n\n.table {\n    th {\n        font-weight: $font-weight-semibold;\n    }\n\n    >thead {\n        border-color: $table-border-color;\n    }\n    >:not(:first-child) {\n        border-top-width: $table-border-width;\n    }\n}\n\n\n.table-nowrap {\n\n    th,\n    td {\n        white-space: nowrap;\n    }\n}\n\n// card table\n\n.table-card{\n    margin: (-$card-spacer-y) (-$card-spacer-x);\n\n    th,\n    td {\n\n        &:first-child{\n            padding-left: 16px;\n        }\n\n        &:last-child{\n            padding-right: 16px;\n        }\n    }\n\n    .table > :not(:first-child) {\n        border-top-width: $table-border-width;\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .border-#{$color} {\n        &.table {\n            > thead {\n                border-color: $value !important;\n            }\n        }\n    }\n    .table-#{$color} {\n        &.table {\n            > thead {\n                border-bottom-color:lighten($value, 10%) !important;\n            }\n        }\n    }\n}\n\n.table {\n    .form-check {\n        padding-left: 0px;\n        margin-bottom: 0px;\n        .form-check-input {\n            margin-left: 0px;\n            margin-top: 0px;\n            float: none;\n            vertical-align: middle;\n        }\n    }\n    .sort {\n        position: relative;\n        &::before {\n            content: \"\\f035d\";\n            position: absolute;\n            right: 0.5rem;\n            top: 18px;\n            font-size: 0.8rem;\n            font-family: \"Material Design Icons\";\n        }\n        &::after {\n            position:absolute;\n            right: 0.5rem;\n            content: \"\\f0360\";\n            font-family: \"Material Design Icons\";\n            font-size: 0.8rem;\n            top: 12px;\n        }\n    }\n}\n\n[data-layout-mode=\"dark\"] {\n    .table-light {\n        background-color: var(--#{$variable-prefix}light);\n        color: var(--#{$variable-prefix}body-color);\n        th,td {\n            background-color: var(--#{$variable-prefix}light);\n        }\n    }\n}\n\n.rdt_Table {\n    &.eSTlnH {\n        background-color: var(--#{$variable-prefix}card-bg) !important;\n        color: var(--#{$variable-prefix}body-color);\n    }\n\n    .gZWIKX,\n    .jVeafb {\n        color: var(--#{$variable-prefix}body-color);\n        background-color: var(--#{$variable-prefix}card-bg);\n    }\n\n    .jVeafb:not(:last-of-type),\n    .gZWIKX {\n        border-bottom-color: var(--#{$variable-prefix}border-color);\n    }\n}\n\n.rdt_Pagination {\n    &.jxflYm {\n        background-color: var(--#{$variable-prefix}card-bg);\n        color: var(--#{$variable-prefix}body-color);\n        border-top-color: var(--#{$variable-prefix}border-color);\n    }\n\n    .bvxQGL {\n        fill: var(--#{$variable-prefix}dark);\n    }\n\n    .bvxQGL:disabled {\n        fill: rgba(var(--#{$variable-prefix}dark-rgb), 0.25);\n    }\n}","//\n// _modal.scss\n//\n\n.modal-title {\n    font-weight: $font-weight-semibold;\n}\n\n.modal-dialog:not(.modal-dialog-scrollable) {\n    .modal-header {\n        padding-bottom: 0;\n    \n        .btn-close {\n            margin-top: -$modal-header-padding;\n        }\n    }\n    \n    .modal-footer {\n        padding-top: 0;\n    }\n}\n\n.modal {\n\t&.fadeInRight {\n\t\t.modal-dialog {\n\t\t\topacity: 0;\n\t\t\ttransform: translateX(20%);\n\t\t\ttransition: all .3s ease-in-out;\n\t\t}\n\n\t\t&.show {\n\t\t\t.modal-dialog {\n\t\t\t\topacity: 1;\n\t\t\t\ttransform: translateX(0);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.fadeInLeft {\n\t\t.modal-dialog {\n\t\t\tanimation: fadeInLeft 0.3s ease-in-out;\n\t\t\ttransform: translate(-50%, 0);\n\t\t}\n\n\t\t&.show {\n\t\t\t.modal-dialog {\n\t\t\t\ttransform: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.fadeInUp {\n\t\t.modal-dialog {\n\t\t\tanimation: fadeInUp 0.3s ease-in-out;\n\t\t\ttransform: translate(0, 30%);\n\t\t}\n\n\t\t&.show {\n\t\t\t.modal-dialog {\n\t\t\t\ttransform: none;\n\t\t\t}\n\t\t}\n\t}\n\n\t&.flip {\n\t\tperspective: 1300px;\n\n\t\t.modal-dialog {\n\t\t\topacity: 0;\n\t\t\ttransform: rotateY(-70deg);\n\t\t\ttransition: all .3s;\n\t\t}\n\n\t\t&.show {\n\t\t\t.modal-dialog {\n\t\t\t\topacity: 1;\n\t\t\t\ttransform: rotateY(0deg);\n\t\t\t}\n\t\t}\n\t}\n\n\t&.zoomIn {\n\t\t.modal-dialog {\n\t\t\topacity: 0;\n\t\t\ttransform: scale(.7);\n\t\t\ttransition: all .3s ease;\n\t\t}\n\n\t\t&.show {\n\t\t\t.modal-dialog {\n\t\t\t\topacity: 1;\n\t\t\t\ttransform: scale(1)\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n.modal-dialog-right {\n\tmargin-right: $modal-dialog-margin-y-sm-up;\n}\n\n// modal-dialog-bottom\n.modal-dialog-bottom {\n\tdisplay: flex;\n\talign-items: flex-end;\n\tmin-height: calc(100% - #{$modal-dialog-margin-y-sm-up});\n\n\t@media (min-width: 576px) {\n\t\tmin-height: calc(100% - #{$modal-dialog-margin-y-sm-up*2 });\n\t}\n}\n\n.modal-dialog-bottom-right {\n\tdisplay: flex;\n\talign-items: flex-end;\n\tmin-height: calc(100% - #{$modal-dialog-margin-y-sm-up});\n\tmargin-right: $modal-dialog-margin-y-sm-up;\n\n\t@media (min-width: 576px) {\n\t\tmin-height: calc(100% - #{$modal-dialog-margin-y-sm-up*2 });\n\t}\n}\n\n@keyframes fadeInLeft {\n\t0% {\n\t\topacity: 0;\n\t\ttransform: translate3d(-30%, 0, 0);\n\t}\n\n\tto {\n\t\topacity: 1;\n\t\ttransform: translateZ(0);\n\t}\n}\n\n\n@keyframes fadeInUp {\n\t0% {\n\t\topacity: 0;\n\t\ttransform: translate3d(0, 30%, 0);\n\t}\n\n\tto {\n\t\topacity: 1;\n\t\ttransform: translateZ(0);\n\t}\n}\n\n@keyframes zoomIn {\n\t0% {\n\t\topacity: 0;\n\t\ttransform: scale3d(.3, .3, .3);\n\t}\n\n\t50% {\n\t\topacity: 1\n\t}\n}\n\n.login-modal {\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1016%26quot%3b)' fill='none'%3e%3crect width='1440' height='560' x='0' y='0' fill='rgba(64%2c 81%2c 137%2c 1)'%3e%3c/rect%3e%3cpath d='M0%2c650.704C122.328%2c648.746%2c159.175%2c473.043%2c255.674%2c397.837C339.724%2c332.333%2c461.529%2c324.924%2c526.449%2c240.421C598.428%2c146.73%2c655.546%2c24.847%2c631.015%2c-90.726C606.666%2c-205.444%2c482.926%2c-263.497%2c401.565%2c-347.958C325.215%2c-427.217%2c275.543%2c-549.012%2c167.826%2c-571.563C60.344%2c-594.065%2c-27.703%2c-482.932%2c-135.163%2c-460.325C-256.336%2c-434.833%2c-401.929%2c-509.651%2c-497.972%2c-431.495C-592.807%2c-354.321%2c-579.865%2c-206.886%2c-595.603%2c-85.635C-611.133%2c34.016%2c-656.761%2c169.183%2c-588.884%2c268.934C-520.854%2c368.909%2c-362.458%2c340.324%2c-260.989%2c406.106C-158.875%2c472.306%2c-121.679%2c652.651%2c0%2c650.704' fill='%2333416e'%3e%3c/path%3e%3cpath d='M1440 995.672C1519.728 984.741 1563.12 899.779 1626.466 850.1469999999999 1682.6390000000001 806.135 1756.261 782.602 1791.2939999999999 720.431 1827.571 656.052 1835.537 577.6610000000001 1820.814 505.247 1806.518 434.933 1753.2640000000001 383.16999999999996 1710.941 325.228 1664.475 261.614 1634.992 175.16000000000003 1560.657 149.07999999999998 1485.96 122.87299999999999 1402.146 155.543 1332.03 192.289 1269.541 225.038 1232.754 287.251 1189.969 343.347 1149.925 395.849 1115.781 448.9 1089.96 509.672 1056 589.599 988.9680000000001 671.1659999999999 1015.557 753.837 1041.91 835.774 1142.714 863.61 1217.498 906.22 1288.388 946.611 1359.167 1006.755 1440 995.672' fill='%234d61a4'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1016'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e\");\n\tbackground-size: cover;\n\tbackground-position: center;\n}","// \n// _pagination.scss\n// \n\n// Pagination Separated\n.pagination-separated {\n    .page-item {\n        .page-link {\n            margin-left: 0.35rem;\n            border-radius: $border-radius;\n        }\n    }\n}\n\n// Pagination rounded (Custom)\n.pagination-rounded {\n    .page-link {\n        border-radius: 30px !important;\n        margin: 0 3px !important;\n        border: none;\n        min-width: 32px;\n        min-height: 32px;\n        text-align: center;\n    }\n\n    &.pagination-sm {\n        .page-link {\n            min-width: 25px;\n            min-height: 25px;\n        }\n    }\n}\n\n.page-item.active {\n    .page-link{\n        box-shadow: $element-shadow;\n    }\n}","// \n// _progress.scss\n// \n\n// Progress height small\n.progress-sm {\n    height: 5px;\n}\n\n// Progress height large\n.progress-lg {\n    height: 12px;\n}\n\n// Progress height Extra large\n.progress-xl {\n    height: 16px;\n}\n\n.custom-progess {\n    position: relative;\n\n    .progress-icon {\n        position: absolute;\n        top: -12px;\n\n        .avatar-title {\n            background: var(--#{$prefix}card-bg-custom);\n        }\n    }\n}\n\n// animated-progress\n\n.animated-progress {\n    position: relative;\n\n    .progress-bar {\n        position: relative;\n        border-radius: 6px;\n        animation: animate-positive 2s;\n    }\n}\n\n@keyframes animate-positive {\n    0% {\n        width: 0;\n    }\n}\n\n// custom-progress\n\n.custom-progress {\n    height: 15px;\n    padding: 4px;\n    border-radius: 30px;\n\n    .progress-bar {\n        position: relative;\n        border-radius: 30px;\n\n        &::before {\n            content: \"\";\n            position: absolute;\n            width: 4px;\n            height: 4px;\n            background-color: $white;\n            border-radius: 7px;\n            right: 2px;\n            top: 50%;\n            transform: translateY(-50%);\n\n        }\n    }\n}\n\n// progress withlabel\n.progress-label {\n    overflow: visible;\n\n    .progress-bar {\n        position: relative;\n        overflow: visible;\n\n        .label {\n            position: absolute;\n            top: -25px;\n            right: -9px;\n            background-color: $primary;\n            color: $white;\n            display: inline-block;\n            line-height: 18px;\n            padding: 0 4px;\n            border-radius: 4px;\n\n            &:after {\n                content: \"\";\n                position: absolute;\n                border: 4px solid transparent;\n                border-top-color: $primary;\n                bottom: -7px;\n                left: 50%;\n                transform: translateX(-50%);\n            }\n        }\n    }\n}\n\n\n.progress-step-arrow {\n    height: 3.25rem;\n\n    .progress-bar {\n        position: relative;\n        overflow: initial;\n        font-size: .875rem;\n        color: $white;\n        &::after {\n            content: \"\";\n            position: absolute;\n            border: 10px solid transparent;\n            bottom: 15px;\n            right: -20px;\n            z-index: 1;\n        }\n    }\n}\n\n\n@mixin progress-variant($bg) {\n    .progress-bar {\n        background-color: $bg;\n        &::after { \n            border-left-color: $bg;\n        }\n        &:nth-child(2) {\n            background-color: rgba($bg, 0.1) !important;\n            color: $bg !important;\n            &::after { \n                border-left-color: rgba($bg, 0.1);\n            }\n        }\n    }\n}\n\n@each $color, $value in $theme-colors {\n    .progress-#{$color} {\n        @include progress-variant($value);\n    }\n}\n\n","// \n// _popover.scss\n// \n\n.popover {\n    box-shadow: $popover-box-shadow;\n}","// \n// type.scss\n//\n\n// Text colors\n.text-white-75 {\n    color: rgba($white, 0.75) !important;\n}\n\n// Blockquote\n.custom-blockquote {\n    &.blockquote {\n        padding: 16px;\n        border-left: 3px solid;\n        \n        &.blockquote-outline{\n            background-color: var(--#{$prefix}card-bg-custom) !important;\n            border: 1px solid;\n            border-left: 3px solid;\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .custom-blockquote {\n        &.blockquote {\n            &.blockquote-#{$color} {\n                color: #{$value};\n                border-color: #{$value};\n                background-color: rgba($value, 0.15);\n\n                .blockquote-footer {\n                    color: #{$value};\n                }\n            }\n\n            &.blockquote-outline{\n                &.blockquote-#{$color} {\n                    border-color: #{$value};\n\n                    .blockquote-footer {\n                        color: #{$value};\n                    }\n                }\n            }\n        }\n    }\n}\n\n.custom-blockquote{\n    &.blockquote{\n        &.blockquote-dark{\n            color: var(--#{$prefix}dark);\n            border-color: var(--#{$prefix}dark);\n            background-color: rgba(var(--#{$prefix}dark-rgb), 0.15);\n            .blockquote-footer {\n                color: var(--#{$prefix}dark);\n            }\n        }\n        &.blockquote-outline{\n            &.blockquote-dark{\n                border-color: var(--#{$prefix}dark);\n                .blockquote-footer {\n                    color: var(--#{$prefix}dark);\n                }\n            }\n        }\n    }\n}","//\n// _form-check.scss\n//\n\n.form-check {\n    position: relative;\n    text-align: left\n        /*rtl: right*/;\n\n    .form-check-input {\n        cursor: pointer;\n    }\n\n    label {\n        cursor: pointer;\n    }\n}\n\n\n// checkbox color\n\n@each $color,\n$value in $theme-colors {\n    .form-check-#{$color} {\n        .form-check-input {\n            &:checked {\n                background-color: $value;\n                border-color: $value;\n            }\n        }\n    }\n\n    .form-radio-#{$color} {\n        .form-check-input {\n            &:checked {\n                border-color: $value;\n                background-color: $value;\n\n                &:after {\n                    background-color: $value;\n                }\n            }\n        }\n    }\n}\n\n.form-check-label {\n    cursor: pointer;\n    margin-bottom: 0;\n}\n\n// checkbox input right\n.form-check-right {\n    padding-left: 0;\n    display: inline-block;\n\n    .form-check-input {\n        float: right;\n        margin-left: 0;\n        margin-right: $form-check-padding-start * -1;\n    }\n\n    .form-check-label {\n        display: block;\n    }\n\n    &.form-switch {\n        .form-check-input {\n            margin-right: $form-check-padding-start * -1.6;\n        }\n    }\n}\n\n\n// Checkbox outline\n\n@each $color,\n$value in $theme-colors {\n    .form-check-outline {\n        &.form-check-#{$color} {\n            .form-check-input {\n                &:checked[type=checkbox] {\n                    color: $value;\n                    background-color: transparent;\n                    border-color: $value;\n                }\n            }\n        }\n    }\n}\n\n.form-check-outline {\n    .form-check-input {\n        position: relative;\n\n        &:checked[type=checkbox] {\n            background-image: none;\n\n            &::before {\n                content: \"\\F012C\";\n                font-family: \"Material Design Icons\";\n                top: -2px;\n                position: absolute;\n                font-weight: 700;\n                font-size: 11px;\n                left: 1px;\n            }\n        }\n\n    }\n}\n\n// Radio\n\n@each $color,\n$value in $theme-colors {\n    .form-radio-outline {\n        &.form-radio-#{$color} {\n            .form-check-input {\n                &:checked[type=radio] {\n                    color: $value;\n                    background-color: transparent;\n                    border-color: $value;\n                }\n            }\n        }\n    }\n}\n\n.form-radio-outline {\n    .form-check-input {\n        position: relative;\n\n        &:checked[type=radio] {\n            background-image: none;\n\n            &::before {\n                content: \"\\F0765\";\n                font-family: \"Material Design Icons\";\n                top: 0px;\n                position: absolute;\n                font-size: 8px;\n                left: 2.2px;\n            }\n        }\n\n    }\n}\n\n// Switch sizes\n\n.form-switch-md {\n    padding-left: 2.5rem;\n    min-height: 22px;\n    line-height: 22px;\n\n    .form-check-input {\n        width: 40px;\n        height: 20px;\n        left: -0.5rem;\n        position: relative;\n    }\n\n    .form-check-label {\n        vertical-align: middle;\n    }\n}\n\n.form-switch-lg {\n    padding-left: 2.75rem;\n    min-height: 28px;\n    line-height: 28px;\n\n    .form-check-input {\n        width: 48px;\n        height: 24px;\n        left: -0.75rem;\n        position: relative;\n    }\n}\n\n.input-group-text {\n    margin-bottom: 0px;\n}\n\n\n@each $color,\n$value in $theme-colors {\n    .form-switch-#{$color} {\n        .form-check-input {\n\n            &:checked {\n                background-color: $value;\n                border-color: $value;\n            }\n        }\n    }\n\n    .form-switch-custom {\n        &.form-switch-#{$color} {\n            .form-check-input {\n                &:checked {\n                    &::before {\n                        color: $value;\n                    }\n\n                }\n            }\n        }\n    }\n}\n\n// Custom Switch style\n\n.form-switch-custom {\n    .form-check-input {\n        position: relative;\n        background-image: none;\n\n        &::before {\n            content: \"\\F0765\";\n            font-family: \"Material Design Icons\";\n            top: -9px;\n            position: absolute;\n            font-size: 20px;\n            left: -3px;\n            color: $text-muted;\n            @include transition($form-switch-transition);\n        }\n\n        &:checked {\n            background-image: none;\n            background-color: $form-check-input-bg;\n            @include transition($form-switch-transition);\n\n            &::before {\n                right: -3px;\n                left: auto;\n            }\n        }\n\n        &:focus {\n            background-image: none;\n        }\n    }\n}\n\n// Switch - Right\n\n.form-switch-right {\n    display: inline-block;\n    padding-right: $form-check-padding-start * .5;\n    margin-bottom: 0;\n    padding-left: 0 !important;\n\n    .form-check-input {\n        float: right;\n        margin-left: 0;\n        margin-right: $form-check-padding-start * -1;\n        margin-top: .1em !important;\n    }\n\n    label {\n        margin-bottom: 0;\n        margin-right: 1rem;\n    }\n}\n\n// card radio\n.card-radio {\n    padding: 0;\n\n    .form-check-label {\n        background-color: var(--#{$prefix}card-bg-custom);\n        border: 1px solid var(--#{$prefix}input-check-border);\n        border-radius: $border-radius;\n        padding: 1rem;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        display: block;\n        position: relative;\n        padding-right: 32px;\n\n        &:hover {\n            cursor: pointer;\n        }\n    }\n\n    .form-check-input {\n        display: none;\n\n        &:checked+.form-check-label {\n            border-color: $primary !important;\n\n            &:before {\n                content: '\\eb80';\n                font-family: \"remixicon\";\n                position: absolute;\n                top: 2px;\n                right: 6px;\n                font-size: 16px;\n                color: $primary;\n            }\n        }\n    }\n\n    &.dark {\n        .form-check-input {\n            &:checked+.form-check-label {\n                &:before {\n                    color: $white;\n                }\n            }\n        }\n    }\n}\n\n[data-layout-mode=\"dark\"]{\n    .form-switch{\n        .form-check-input, .form-check-input:focus{\n            background-image: escape-svg(url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$gray-400}'/></svg>\"));\n        }\n    }\n}","//\n// _form-control.scss\n//\n\n\n.form-icon{\n    position: relative;\n    .form-control-icon {\n        padding-left: $input-padding-x*3;\n        position: relative;\n    }\n    i {\n        position: absolute;\n        top: 0px;\n        bottom: 0px;\n        left: 18px;\n        display: flex;\n        align-items: center;\n    }\n    &.right{\n        .form-control-icon {\n            padding-right: $input-padding-x*3;\n            padding-left: $input-padding-x;\n            position: relative;\n        }\n        i {\n            left: auto;\n            right: 18px;\n        }\n    }\n}\n\n[data-layout-mode=\"dark\"]{\n    .form-select {\n        background-image: escape-svg(url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$gray-400}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\"));\n        background-color: var(--#{$prefix}gray-200) !important;\n        border-color: var(--#{$prefix}border-color) !important;\n    }\n\n    .form-control {\n        background-color: var(--#{$prefix}gray-200) !important;\n        border-color: var(--#{$prefix}border-color) !important;\n    }\n  }","//\n// _list-group.scss\n//\n\n\n@each $color,\n$value in $theme-colors {\n    .list-group-fill-#{$color} {\n        .list-group-item {\n            &.active {\n                background-color: $value !important;\n                border-color: $value;\n            }\n        }\n    }\n}\n\n.list-group-fill-light {\n    color: $dark !important;\n}\n\n.list-group-item {\n    margin-bottom: 0px;\n    .list-text {\n        color: $text-muted;\n    }\n    &.active {\n        box-shadow: $element-shadow;\n        .list-title {\n            color: $white;\n        }\n        .list-text {\n            color: rgba($white, 0.50);\n        }\n    }\n}","//\n// _custom-scrollbar.scss\n//\n\n[data-simplebar] {\n  position: relative;\n  flex-direction: column;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n  align-content: flex-start;\n  align-items: flex-start;\n}\n\n.simplebar-wrapper {\n  overflow: hidden;\n  width: inherit;\n  height: inherit;\n  max-width: inherit;\n  max-height: inherit;\n}\n\n.simplebar-mask {\n  direction: inherit;\n  position: absolute;\n  overflow: hidden;\n  padding: 0;\n  margin: 0;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  right: 0;\n  width: auto !important;\n  height: auto !important;\n  z-index: 0;\n}\n\n.simplebar-offset {\n  direction: inherit !important;\n  box-sizing: inherit !important;\n  resize: none !important;\n  position: absolute;\n  top: 0;\n  left: 0 !important;\n  bottom: 0;\n  right: 0 !important;\n  padding: 0;\n  margin: 0;\n  -webkit-overflow-scrolling: touch;\n}\n\n.simplebar-content-wrapper {\n  direction: inherit;\n  box-sizing: border-box !important;\n  position: relative;\n  display: block;\n  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */\n  width: auto;\n  visibility: visible;\n  overflow: auto; /* Scroll on this element otherwise element can't have a padding applied properly */\n  max-width: 100%; /* Not required for horizontal scroll to trigger */\n  max-height: 100%; /* Needed for vertical scroll to trigger */\n  scrollbar-width: none;\n  padding: 0px !important;\n}\n\n.simplebar-content-wrapper::-webkit-scrollbar,\n.simplebar-hide-scrollbar::-webkit-scrollbar {\n  display: none;\n}\n\n.simplebar-content:before,\n.simplebar-content:after {\n  content: ' ';\n  display: table;\n}\n\n.simplebar-placeholder {\n  max-height: 100%;\n  max-width: 100%;\n  width: 100%;\n  pointer-events: none;\n}\n\n.simplebar-height-auto-observer-wrapper {\n  box-sizing: inherit !important;\n  height: 100%;\n  width: 100%;\n  max-width: 1px;\n  position: relative;\n  float: left;\n  max-height: 1px;\n  overflow: hidden;\n  z-index: -1;\n  padding: 0;\n  margin: 0;\n  pointer-events: none;\n  flex-grow: inherit;\n  flex-shrink: 0;\n  flex-basis: 0;\n}\n\n.simplebar-height-auto-observer {\n  box-sizing: inherit;\n  display: block;\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 1000%;\n  width: 1000%;\n  min-height: 1px;\n  min-width: 1px;\n  overflow: hidden;\n  pointer-events: none;\n  z-index: -1;\n}\n\n.simplebar-track {\n  z-index: 1;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-content {\n  pointer-events: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n\n[data-simplebar].simplebar-dragging .simplebar-track {\n  pointer-events: all;\n}\n\n.simplebar-scrollbar {\n  position: absolute;\n  right: 2px;\n  width: 6px;\n  min-height: 10px;\n}\n\n.simplebar-scrollbar:before {\n  position: absolute;\n  content: '';\n  background: #a2adb7;\n  border-radius: 7px;\n  left: 0;\n  right: 0;\n  opacity: 0;\n  transition: opacity 0.2s linear;\n}\n\n.simplebar-scrollbar.simplebar-visible:before {\n  /* When hovered, remove all transitions from drag handle */\n  opacity: 0.5;\n  transition: opacity 0s linear;\n}\n\n.simplebar-track.simplebar-vertical {\n  top: 0;\n  width: 11px;\n}\n\n.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {\n  top: 2px;\n  bottom: 2px;\n}\n\n.simplebar-track.simplebar-horizontal {\n  left: 0;\n  height: 11px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {\n  height: 100%;\n  left: 2px;\n  right: 2px;\n}\n\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar {\n  right: auto;\n  left: 0;\n  top: 2px;\n  height: 7px;\n  min-height: 0;\n  min-width: 10px;\n  width: auto;\n}\n\n/* Rtl support */\n[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {\n  right: auto;\n  left: 0;\n}\n\n.hs-dummy-scrollbar-size {\n  direction: rtl;\n  position: fixed;\n  opacity: 0;\n  visibility: hidden;\n  height: 500px;\n  width: 500px;\n  overflow-y: hidden;\n  overflow-x: scroll;\n}\n\n.simplebar-hide-scrollbar {\n  position: fixed;\n  left: 0;\n  visibility: hidden;\n  overflow-y: scroll;\n  scrollbar-width: none;\n}\n\n.custom-scroll {\n  height: 100%;\n}\n\n@each $color, $value in $theme-colors {\n  [data-simplebar-track=\"#{$color}\"]{\n    .simplebar-scrollbar:before{\n      background: $value;\n    }\n  }\n}","/**\n * prism.js default theme for JavaScript, CSS and HTML\n * Based on dabblet (http://dabblet.com)\n * @author Lea Verou\n */\n\ncode[class*=\"language-\"],\npre[class*=\"language-\"] {\n    color: black;\n    background: none;\n    text-shadow: 0 1px white;\n    font-family: Consolas, Monaco, \"Andale Mono\", \"Ubuntu Mono\", monospace;\n    font-size: 1em;\n    text-align: left;\n    white-space: pre;\n    word-spacing: normal;\n    word-break: normal;\n    word-wrap: normal;\n    line-height: 1.5;\n\n    -moz-tab-size: 4;\n    -o-tab-size: 4;\n    tab-size: 4;\n\n    -webkit-hyphens: none;\n    -moz-hyphens: none;\n    -ms-hyphens: none;\n    hyphens: none;\n}\n\npre[class*=\"language-\"]::-moz-selection,\npre[class*=\"language-\"] ::-moz-selection,\ncode[class*=\"language-\"]::-moz-selection,\ncode[class*=\"language-\"] ::-moz-selection {\n    text-shadow: none;\n    background: #b3d4fc;\n}\n\npre[class*=\"language-\"]::selection,\npre[class*=\"language-\"] ::selection,\ncode[class*=\"language-\"]::selection,\ncode[class*=\"language-\"] ::selection {\n    text-shadow: none;\n    background: #b3d4fc;\n}\n\n@media print {\n    code[class*=\"language-\"],\n    pre[class*=\"language-\"] {\n        text-shadow: none;\n    }\n}\n\n/* Code blocks */\npre[class*=\"language-\"] {\n    padding: 1em;\n    margin: 0;\n    overflow: auto;\n}\n\n:not(pre) > code[class*=\"language-\"],\npre[class*=\"language-\"] {\n    background: var(--#{$prefix}light) !important;\n}\n\n/* Inline code */\n:not(pre) > code[class*=\"language-\"] {\n    padding: 0.1em;\n    border-radius: 0.3em;\n    white-space: normal;\n}\n\n.token.comment,\n.token.prolog,\n.token.doctype,\n.token.cdata {\n    color: slategray;\n}\n\n.token.punctuation {\n    color: #999;\n}\n\n.token.namespace {\n    opacity: 0.7;\n}\n\n.token.property,\n.token.tag,\n.token.boolean,\n.token.number,\n.token.constant,\n.token.symbol,\n.token.deleted {\n    color: $danger;\n}\n\n.token.selector,\n.token.attr-name,\n.token.string,\n.token.char,\n.token.builtin,\n.token.inserted {\n    color: #690;\n}\n\n.token.operator,\n.token.entity,\n.token.url,\n.language-css .token.string,\n.style .token.string {\n    color: #9a6e3a;\n    /* This background color was intended by the author of this theme. */\n    background: hsla(0, 0%, 100%, 0.5);\n}\n\n.token.atrule,\n.token.attr-value,\n.token.keyword {\n    color: #07a;\n}\n\n.token.function,\n.token.class-name {\n    color: #dd4a68;\n}\n\n.token.regex,\n.token.important,\n.token.variable {\n    color: #e90;\n}\n\n.token.important,\n.token.bold {\n    font-weight: bold;\n}\n.token.italic {\n    font-style: italic;\n}\n\n.token.entity {\n    cursor: help;\n}\n\n/* Prism editor */\n:not(pre) > code[class*=\"language-\"],\npre[class*=\"language-\"] {\n    background: $gray-200;\n}\n\ncode[class*=\"language-\"],\npre[class*=\"language-\"] {\n    color: $gray-600;\n    text-shadow: none;\n}\n\n\n\n// Scrollbar\n\n.language-markup {\n    &::-webkit-scrollbar {\n        -webkit-appearance: none;\n    }\n\n    &::-webkit-scrollbar:vertical {\n        width: 10px;\n    }\n\n    &::-webkit-scrollbar:horizontal {\n        height: 10px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: rgba(var(--#{$prefix}dark-rgb), .1);\n        border-radius: 10px;\n        border: 2px solid var(--#{$prefix}light)\n    }\n\n    &::-webkit-scrollbar-track {\n        border-radius: 10px;\n        background-color: var(--#{$prefix}light)\n    }\n}\n\n\n// Scroll-top\n\n#scroll-top {\n    width: 30px;\n    height: 30px;\n    position: fixed;\n    bottom: 65px;\n    right: 30px;\n    background: #343a40;\n    border-color: transparent;\n    border-radius: 3px;\n    color: #ffffff;\n    transition: all 0.5s ease;\n}\n\n// Toolbar (Copy button)\n\n.btn-clipboard {\n    position: absolute !important;\n    right: 15px !important;\n    z-index: 1 !important;\n}\n\ndiv.code-toolbar > .toolbar {\n    opacity: 1 !important;\n    button {\n        display: inline-block !important;\n        margin: 0.375rem 0.5rem !important;\n        padding: 0.25rem 0.75rem !important;\n        transition: $btn-transition !important;\n        border-radius: $border-radius-sm !important;\n        border: $border-width solid rgba($primary, 0.35) !important;\n        background-color: transparent;\n        color: $primary !important;\n        box-shadow: none !important;\n        &:focus {\n            outline: none !important;\n            box-shadow: none !important;\n        }\n        &:hover {\n            background-color: $primary !important;\n            color: $white !important;\n        }\n    }\n}\n","\n//\n//  _sweetalert2.scss\n//\n\n.swal2-container {\n  .swal2-title{\n    padding: 24px 24px 0;\n    font-size: 20px;\n    font-weight: $font-weight-medium;\n  }  \n}\n\n.swal2-popup{\n  padding-bottom: 24px;\n  border-radius: $modal-content-border-radius;\n  background-color: var(--#{$prefix}card-bg-custom);\n  color: var(--#{$prefix}body-color);\n\n  .swal2-title{\n    color: var(--#{$prefix}heading-color);\n  }\n\n  .swal2-html-container{\n    color: var(--#{$prefix}body-color);\n  }\n}\n\n.swal2-footer{\n  border-top: 1px solid var(--#{$prefix}border-color);\n  color: var(--#{$prefix}body-color);\n}\n\n.swal2-html-container{\n  font-size: 16px;\n}\n\n.swal2-icon{\n  &.swal2-question{\n    border-color: $info;\n    color: $info;\n  }\n  &.swal2-success {\n    [class^=swal2-success-line]{\n      background-color: $success;\n    }\n\n    .swal2-success-ring{\n      border-color: rgba($success, 0.3);\n    }\n  }\n  &.swal2-warning{\n    border-color: $warning;\n    color: $warning;\n  }\n}\n\n.swal2-styled{\n  &:focus{\n    box-shadow: none;\n  }\n}\n\n.swal2-loader{\n  border-color: $primary transparent $primary transparent;\n}\n\n.swal2-timer-progress-bar{\n  background-color: rgba($success, 0.4);\n}\n\n.swal2-progress-steps {\n  .swal2-progress-step{\n    background: $primary;\n    &.swal2-active-progress-step{\n      background: $primary;\n      &~.swal2-progress-step, &~.swal2-progress-step-line{\n        background: rgba($primary, 0.3);\n      }\n    }\n  }\n  .swal2-progress-step-line{\n    background: $primary;\n  }\n}\n\n.swal2-actions.swal2-loading{\n  .swal2-styled.swal2-confirm{\n    border-left-color: $primary !important;\n    border-right-color: $primary !important;\n  }\n}\n\n.swal2-file, .swal2-input, .swal2-textarea{\n  border: 1px solid $input-border-color;\n  &:focus{\n    box-shadow: none;\n    border-color: $input-focus-border-color;\n  }\n}\n\n.swal2-input{\n  height: auto;\n  display: block;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n}\n\n.swal2-close{\n  font-family: $font-family-base;\n  font-weight: $font-weight-light;\n  font-size: 28px;\n  &:focus{\n    box-shadow: none;\n  }\n\n  &:hover{\n    color: $primary;\n  }\n}\n\n.swal2-validation-message{\n  background-color: transparent;\n}","//\n// Dropzone\n//\n\n\n.dropzone {\n  min-height: 230px;\n  border: 2px dashed var(--#{$prefix}border-color);\n  background: var(--#{$prefix}card-bg-custom);\n  border-radius: 6px;\n\n  .dz-message {\n    font-size: 24px;\n    width: 100%;\n    margin: 1em 0;\n  }\n}\n","\n//\n// _range-slider.scss\n//\n\n.noUi-connect{\n  background: $success;\n}\n\n.noUi-handle{\n  background: $success;\n  border: 2px solid var(--#{$prefix}card-bg);\n  box-shadow: none;\n}\n\n.noUi-horizontal{\n  height: 4px;\n  .noUi-handle{\n    height: 16px;\n    width: 16px;\n    border-radius: 50%;\n    right: -10px !important;\n    top: -7px;\n\n    &::before, &::after{\n      display: none;\n    }\n    &:focus{\n      outline: 0;\n    }\n  }\n}\n\n.noUi-pips-horizontal{\n  height: 50px;\n}\n\n// tooltip\n\n.noUi-tooltip{\n  padding: $tooltip-padding-y $tooltip-padding-x;\n  border-color: $border-color;\n  border-radius: $tooltip-border-radius;\n  background-color: var(--#{$prefix}card-bg-custom);\n  color: var(--#{$prefix}body-color);\n}\n\n// Vertical Slider\n\n.noUi-vertical{\n  width: 4px;\n  .noUi-handle{\n    height: 16px;\n    width: 16px;\n    right: -8px;\n    top: -12px;\n    left: auto;\n    border-radius: 50%;\n    &::before, &::after{\n      display: none;\n    }\n    &:focus{\n      outline: 0;\n    }\n  }\n\n  .noUi-origin{\n    top: 0;\n  }\n}\n\n.noUi-value{\n  font-size: 12px;\n}\n\n.noUi-marker-horizontal{\n  &.noUi-marker-large{\n    height: 12px;\n  }\n}\n\n.noUi-value-horizontal{\n  padding-top: 4px;\n}\n\n.noUi-target{\n  box-shadow: none;\n  background-color: var(--#{$prefix}light);\n  border-color: var(--#{$prefix}light);\n}\n\n.noUi-touch-area{\n  &:focus{\n    outline: 0;\n  }\n}\n\n// Colorpicker\n\n#red, #green, #blue {\n\tmargin: 10px;\n\tdisplay: inline-block;\n\theight: 200px;\n}\n\n#colorpicker {\n\theight: 240px;\n\twidth: 310px;\n\tmargin: 0 auto;\n\tpadding: 10px;\n\tborder: 1px solid $border-color;\n}\n\n#result {\n\tmargin: 60px 26px;\n\theight: 100px;\n\twidth: 100px;\n\tdisplay: inline-block;\n\tvertical-align: top;\n\tborder: 1px solid $border-color;\n    box-shadow: 0 0 3px;\n    border-radius: 7px;\n}\n\n#red {\n    .noUi-connect {\n        background: $danger;\n    }\n}\n\n#green {\n    .noUi-connect {\n        background: $success;\n    }\n}\n\n#blue {\n    .noUi-connect {\n        background: $primary;\n    }\n}\n\n// Adding keyboard support\n\n.form-control{\n    &.keyboard{\n        max-width: 340px !important;\n    }\n}\n\n\n// Non linear slider\n\n.example-val{\n    font-size: 12px;\n    color: $text-muted;\n    display: block;\n    margin: 15px 0;\n    &:before{\n        content: \"Value: \";\n        font-size: 12px;\n        font-weight: 600;\n    }\n}\n\n// showing tooltips\n\n.noUi-tooltip {\n    display: none;\n}\n.noUi-active .noUi-tooltip {\n    display: block;\n}\n\n// Colored Connect Elements\n\n.c-1-color { background: $danger; }\n.c-2-color { background: $warning; }\n.c-3-color { background: $success; }\n.c-4-color { background: $primary; }\n.c-5-color { background: $purple; }\n\n//  slider togle\n\n#slider-toggle {\n    height: 50px;\n    &.off{\n        .noUi-handle{\n            border-color: $danger;\n        }\n    }\n}\n\n// rangeslider color\n\n@each $color, $value in $theme-colors {\n  [data-slider-color=\"#{$color}\"] {\n    .noUi-connect{\n      background: $value;\n    }\n\n    .noUi-handle{\n      background: $value;\n    }\n\n    &[data-slider-style=\"border\"], &[data-slider-style=\"square\"]{\n      .noUi-handle{\n        border-color: $value;\n      }\n    }\n  }\n}\n\n// rangeslider sizes\n\n[data-slider-size=\"lg\"]{\n  &.noUi-horizontal{\n    height: 12px;\n\n    .noUi-handle{\n      width: 24px;\n      height: 24px;\n    }\n  }\n}\n\n[data-slider-size=\"md\"]{\n  &.noUi-horizontal{\n    height: 8px;\n\n    .noUi-handle{\n      width: 20px;\n      height: 20px;\n    }\n  }\n}\n\n[data-slider-size=\"sm\"]{\n  &.noUi-horizontal{\n    height: 4px;\n\n    .noUi-handle{\n      width: 16px;\n      height: 16px;\n    }\n  }\n}\n\n// rangeslider style\n\n[data-slider-style=\"line\"]{\n  &.noUi-horizontal .noUi-handle{\n    width: 8px;\n    border-radius: 4px;\n    right: -8px;\n  }\n  &.noUi-vertical .noUi-handle{\n    height: 8px;\n    border-radius: 4px;\n    top: -3px;\n  }\n}\n\n[data-slider-style=\"border\"]{\n  .noUi-handle{\n    border-color: $success;\n    background-color: $card-bg;\n  }\n}\n\n[data-slider-style=\"square\"]{\n  .noUi-handle{\n    border-radius: 0px;\n    transform: rotate(45deg);\n    height: 10px;\n    width: 10px;\n    top: -4px;\n    border-color: $success;\n    background-color: $card-bg;\n  }\n}\n\n","// \n// _sortablejs.scss\n// \n\n\n.nested-list{\n    .list-group-item{\n        background-color: rgba($primary, 0.05);\n        border-color: rgba($primary, 0.05);\n    }\n}\n\n.nested-list, .nested-1, .nested-2, .nested-3{\n    margin-top: 5px;\n}\n\n\n.nested-sortable-handle{\n    .handle{\n        position: absolute;\n        left: 0;\n        top: 0;\n        width: 42px;\n        height: 42px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        cursor: grab;\n    }\n    .list-group-item{\n        padding-left: 42px;\n    }\n}","// \n// tour.scss\n// \n\n.shepherd-element{\n    background: var(--#{$prefix}card-bg-custom);\n    box-shadow: $box-shadow;\n}\n\n.shepherd-has-title{\n    .shepherd-content{\n        .shepherd-header{\n            background-color: var(--#{$prefix}light);\n            padding: $toast-padding-y $toast-padding-x;\n        }\n\n        .shepherd-cancel-icon{\n            color: rgba(var(--#{$prefix}dark-rgb), .75);\n            &:hover{\n                color: rgba(var(--#{$prefix}dark-rgb), .75);\n            }\n        }\n    }\n}\n\n.shepherd-element.shepherd-has-title[data-popper-placement^=bottom]>.shepherd-arrow:before{\n    background-color: var(--#{$prefix}light);\n}\n\n.shepherd-title{\n    font-size: 15px;\n    font-weight: $font-weight-medium;\n    color: var(--#{$prefix}body-color);\n}\n\n.shepherd-text{\n    padding: $toast-padding-x;\n    font-size: $font-size-base;\n    color: var(--#{$prefix}body-color);\n}\n\n.shepherd-button{\n    &.btn-success:not(:disabled):hover{\n        background: darken($success, 2.5%);\n        color: $white;\n    }\n\n    &.btn-light:not(:disabled):hover{\n        background: rgba(var(--#{$prefix}light-rgb), .75);\n        color: var(--#{$prefix}dark);\n    }\n\n    &.btn-primary:not(:disabled):hover{\n        background: darken($primary, 2.5%);\n        color: $white;\n    }\n}\n\n.shepherd-footer{\n    padding: 0 $toast-padding-x $toast-padding-x;\n}\n.shepherd-arrow,\n.shepherd-arrow:before{\n    content: \"\\ea75\";\n    font-family: 'remixicon';\n    font-size: 24px;\n    z-index: 1;\n    background-color: transparent !important;\n    transform: rotate(0deg);\n    color: $primary;\n}\n\n.shepherd-element[data-popper-placement^=bottom]>.shepherd-arrow{\n    top: -18px;\n}\n\n.shepherd-button{\n    margin-right: 0.5rem;\n}","//\n// _swiper.scss\n//\n\n.swiper-button-next, .swiper-button-prev {\n    height: 32px !important;\n    width: 32px !important;\n    background-color: rgba($primary, 0.2);\n    backdrop-filter: blur(2px);\n    border-radius: 8px;\n    &::after {\n        font-family: remixicon !important;\n        font-size: 28px !important;\n        color: rgba($primary, 1);\n        transition: all 0.3s ease;\n    }\n}\n\n.swiper-button-prev {\n    &::after {\n        content: \"\\ea64\" !important;\n    }\n}\n.swiper-button-next {\n    &::after {\n        content: \"\\ea6e\" !important;\n    }\n}\n\n.swiper-pagination-bullet{\n    width: 22px !important;\n    height: 5px !important;\n    background-color: $white !important;\n    border-radius: 50px !important;\n    box-shadow: $element-shadow;\n    .swiper-pagination-bullet-active{\n        opacity: 1;\n    }\n}\n\n.dynamic-pagination{\n    .swiper-pagination-bullet {\n        width: 8px;\n        height: 8px;\n        background-color: $white;\n        opacity: 0.5;\n        transition: all 0.5s ease;\n        &.swiper-pagination-bullet-active{\n            opacity: 1;\n            width: 20px;\n        }\n    }\n}\n\n.swiper-pagination-fraction {\n    color: $white;\n    font-size: 16px;\n    background-color: rgba($black, 0.3);\n    backdrop-filter: blur(2px);\n}\n\n\n.pagination-custom{\n    .swiper-pagination-bullet {\n        height: 25px !important;\n        width: 25px !important;\n        line-height: 25px !important;\n        border-radius: 8px !important;\n        background-color: $white !important;\n        opacity: 0.5 !important;\n        transition: all 0.5s ease;\n        &.swiper-pagination-bullet-active{\n            color: $secondary !important;\n            opacity: 1 !important;\n        }\n    }\n}\n\n.swiper-pagination-progressbar{\n    height: 6px !important;\n    background-color: rgba($success, 0.25) !important;\n    .swiper-pagination-progressbar-fill {\n        background-color: $success !important;\n    }\n}\n\n\n.swiper-scrollbar {\n    background-color: rgba($white, 0.35);\n    backdrop-filter: blur(2px);\n    padding: 1.2px;\n    height: 6px !important;\n    .swiper-scrollbar-drag {\n        background-color: $white;\n    }\n}\n\n.swiper-pagination-dark {\n    .swiper-pagination-bullet {\n        background-color: $secondary !important;\n    }\n    .dynamic-pagination{\n        .swiper-pagination-bullet { \n            background-color: $secondary !important;\n        }\n    }\n    &.pagination-custom{\n        .swiper-pagination-bullet { \n            color: $white;\n            &.swiper-pagination-bullet-active{\n                opacity: 1;\n            }\n        }\n    }\n    &.swiper-scrollbar { \n        background-color: rgba($dark, 0.35); \n    }\n}","\n//\n// _multijs.scss\n//\n\n.multi-wrapper{\n  border: none;\n  position: relative;\n\n  &::before{\n    content: \"\\ea61\";\n    position: absolute;\n    font-family: \"remixicon\";\n    left: 50%;\n    transform: translateX(-50%);\n    bottom: 86px;\n    width: 32px;\n    height: 32px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    font-size: 16px;\n    border-radius: 50%;\n    color: $text-muted;\n    background-color: var(--#{$prefix}light);\n    z-index: 1;\n  }\n  \n  .non-selected-wrapper{\n    border: 1px solid $input-border-color;\n    background-color: $input-bg;\n    border-top-left-radius: $border-radius;\n    border-bottom-left-radius: $border-radius;\n  }\n\n  .selected-wrapper, .non-selected-wrapper{\n    &::-webkit-scrollbar {\n      -webkit-appearance: none;\n    }\n  \n    &::-webkit-scrollbar:vertical {\n      width: 10px;\n    }\n  \n    &::-webkit-scrollbar:horizontal {\n      height: 9px;\n    }\n  \n    &::-webkit-scrollbar-thumb {\n      background-color: rgba(var(--#{$prefix}dark-rgb), .2);\n      border-radius: 10px;\n      border: 2px solid $input-bg;\n    }\n  \n    &::-webkit-scrollbar-track {\n      border-radius: 10px;  \n      background-color: $input-bg; \n    }\n}\n\n  .item-group .group-label{\n    font-size: 12px;\n  }\n\n  .item{\n    color: $input-color;\n    &:hover{\n      background-color: rgba($primary, 0.1);\n    }\n  }\n\n  .selected-wrapper{\n    border: 1px solid $input-border-color;\n    background: $input-bg;\n    border-top-right-radius: $border-radius;\n    border-bottom-right-radius: $border-radius;\n  }\n\n  .search-input{\n    flex: 0 0 auto;\n    padding: $input-padding-y $input-padding-x;\n    font-family: $input-font-family;\n    font-size: $input-font-size;\n    color: $input-color;\n    background-color: $input-bg;\n    border: $input-border-width solid $input-border-color;\n    border-radius: $input-border-radius;\n    margin-bottom: 16px;\n    &::placeholder{\n      color: $input-placeholder-color;\n    }\n  }\n\n  .header{\n    font-weight: $font-weight-semibold;\n    color: var(--#{$prefix}gray-600);\n  }\n}","//\n// _colorpicker.scss\n//\n\n.pcr-app{\n  background: var(--#{$prefix}card-bg-custom);\n  box-shadow: $box-shadow-lg;\n  border-radius: 4px;\n  border: 1px solid $border-color;\n}\n\n.pickr{\n  .pcr-button{\n    border: 4px solid var(--#{$prefix}card-bg-custom);\n    box-shadow: 0px 0px 0 2px $border-color;\n    border-radius: 50%;\n    box-shadow: $element-shadow;\n    &::after, &::before{\n      border-radius: 50%;\n    }\n  }\n}\n\n.pcr-app{\n  &[data-theme=classic]{\n    .pcr-selection {\n      .pcr-color-preview{\n        margin-right: .75em;\n        margin-left: 0;\n      }\n  \n      .pcr-color-chooser, .pcr-color-opacity{\n        margin-left: .75em;\n        margin-right: 0;\n      }\n    }\n  }\n\n  &[data-theme=\"monolith\"]{\n    .pcr-result{\n      min-width: 100%;\n    }\n  }\n\n  .pcr-interaction{\n    .pcr-type.active{\n      background: $primary;\n    }\n\n    .pcr-result{\n      background-color: $input-bg;\n      color: $input-color;\n      border: 1px solid $input-border-color;\n      border-radius: $input-border-radius;\n    }\n\n    input{\n      border-radius: $input-border-radius !important;\n      &:focus{\n        box-shadow: none;\n        background-color: $input-focus-bg;\n        border-color: $input-focus-border-color;\n      }\n    }\n\n    .pcr-save{\n      background: $success !important;\n    }\n\n    .pcr-clear, .pcr-cancel{\n      background: $danger !important;\n    }\n  }\n}","//\n// filepond\n//\n\n.filepond--root{\n  margin-bottom: 0;\n\n  &[data-style-panel-layout~=circle]{\n    .filepond--drop-label label{\n      font-size: 14px;\n    }\n  }\n}\n\n.filepond--panel-root{\n  border: 2px dashed var(--#{$prefix}border-color);\n  background: var(--#{$prefix}card-bg-custom);\n}\n\n.filepond--drop-label {\n  color: var(--#{$prefix}body-color);\n  label{\n    font-weight: $font-weight-medium;\n  }\n}\n\n.filepond--credits {\n  display: none;\n}\n\n.filepond--item-panel {\n  background-color: $primary !important;\n}","//\n// _form-input-spin.scss\n//\n\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    height: auto;\n}\n\n.input-step {\n    border: 1px solid $input-border-color;\n    display: inline-flex;\n    overflow: visible;\n    height: 37.5px;\n    @include border-radius($input-border-radius, 0);\n    background: $input-bg;\n    padding: 4px;\n\n    input {\n        width: 4em;\n        height: 100%;\n        text-align: center;\n        border: 0;\n        background: transparent;\n        color: $input-color;\n        border-radius: $input-border-radius;\n\n        &:focus-visible {\n            outline: 0;\n        }\n    }\n\n    button {\n        width: 1.4em;\n        font-weight: 300;\n        height: 100%;\n        line-height: 0.1em;\n        font-size: 1.4em;\n        padding: 0.2em !important;\n        background: var(--#{$prefix}light);\n        color: var(--#{$prefix}body-color);\n        border: none;\n        border-radius: $btn-border-radius;\n    }\n\n    &.light {\n        background: var(--#{$prefix}light);\n\n        button {\n            background-color: $input-bg;\n        }\n    }\n\n    &.light-input {\n        background: var(--#{$prefix}light);\n\n        input {\n            background-color: $input-bg;\n        }\n    }\n\n    &.full-width {\n        display: flex;\n        width: 100%;\n\n        button {\n            flex-shrink: 0;\n        }\n\n        input {\n            flex-grow: 1;\n        }\n    }\n}\n\n@each $color,\n$value in $theme-colors {\n    .input-step {\n        &.step-#{$color} {\n            button {\n                background-color: $value;\n                color: $white;\n            }\n        }\n    }\n}","//\n// _ckeditor.scss\n//\n\n.ck {\n    font-family: $font-family-base !important;\n\n    &.ck-reset_all, &.ck-reset_all *{\n        color: var(--#{$prefix}body-color) !important;\n    }\n    &.ck-toolbar{\n        background: #{rgba(var(--#{$prefix}light-rgb), .75)} !important;\n    }\n\n    p {\n        margin-bottom: 0;\n    }\n\n    &.ck-toolbar {\n        border: 1px solid $input-border-color !important;\n\n        &.ck-toolbar_grouping>.ck-toolbar__items {\n            flex-wrap: wrap !important;\n        }\n\n        .ck.ck-toolbar__separator {\n            background: transparent !important;\n        }\n    }\n\n    &.ck-editor__main>.ck-editor__editable {\n        border-top: 0 !important;\n        background-color: var(--#{$prefix}card-bg-custom) !important;\n        border-color: $input-border-color !important;\n        box-shadow: none !important;\n    }\n\n    &.ck-dropdown__panel{\n        background: var(--#{$prefix}choices-bg) !important;\n        box-shadow: $box-shadow-lg;\n        animation-name: DropDownSlide;\n        animation-duration: .3s;\n        animation-fill-mode: both;\n        border-radius: $dropdown-border-radius;\n    }\n\n    &.ck-list {\n        background: var(--#{$prefix}choices-bg) !important;\n    }\n\n    &.ck-dropdown {\n        .ck-dropdown__panel {\n            &.ck-dropdown__panel_ne,\n            &.ck-dropdown__panel_se {\n                left: 0;\n                right: auto !important;\n            }\n        }\n    }\n\n    &.ck-editor__editable_inline {\n        &[dir=ltr] {\n            text-align: left !important;\n        }\n    }\n\n    &.ck-dropdown__panel {\n        box-shadow: $dropdown-box-shadow !important;\n        border-radius: $dropdown-border-radius !important;\n        border: 1px solid $dropdown-border-color !important;\n    }\n}\n\n.ck.ck-button, \na.ck.ck-button{\n\n    &:focus, &:active{\n        box-shadow: none !important;\n        border: 1px solid var(--#{$prefix}light) !important;\n    }\n\n    &:not(.ck-disabled){\n        &:hover{\n            background: var(--#{$prefix}light) !important;\n        }\n    }\n\n    &.ck-on{\n        background: var(--#{$prefix}light) !important;\n    }\n}\n\n.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar, \n.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{\n    border-radius: $border-radius !important;\n    border-bottom-left-radius: 0 !important;\n    border-bottom-right-radius: 0 !important;\n}\n\n.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable, \n.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{\n    border-radius: $border-radius !important;\n    border-top-left-radius: 0 !important;\n    border-top-right-radius: 0 !important;\n}\n\n.ck-editor__editable {\n    min-height: 245px !important;\n}\n\n.ck[class*=ck-heading_heading] {\n    font-weight: $font-weight-medium !important;\n}\n\n.ck,\na.ck {\n    &.ck-button {\n        &.ck-on:not(.ck-disabled) {\n            &:hover,\n            &:active {\n                box-shadow: none !important;\n            }\n        }\n    }\n}\n\n.ck{\n    &.ck-tooltip{\n        .ck-tooltip__text {\n            background: $dark !important;\n            color: $light !important;\n        }\n    }\n\n    &.ck-input-text{\n        background: $input-bg !important;\n        border: 1px solid $input-border-color !important;\n        &:focus{\n            border: 1px solid $input-focus-border-color !important;\n            box-shadow: none !important;\n        }\n    }\n\n    &.ck-balloon-panel{\n        background: $dropdown-bg !important;\n        border: 1px solid $dropdown-border-color !important;\n\n        &[class*=arrow_n]{\n            &:after{\n                border-bottom-color: $dropdown-bg !important;\n            }\n\n            &::before{\n                border-bottom-color: $dropdown-border-color !important;\n            }\n        }\n    }\n}\n\n\n\n.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{\n    background: $dropdown-bg !important;\n}\n\n// ck-editor-reverse\n\n.ck-editor-reverse{\n    .ck-editor{\n      display: flex;\n      flex-direction: column-reverse;\n    }\n  \n    .ck{\n      &.ck-editor__main>.ck-editor__editable{\n        border: 1px solid $input-border-color !important;\n        border-bottom: 0 !important;\n      }\n    }\n  \n    .ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable, \n    .ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{\n      border-radius: $border-radius !important;\n      border-bottom-left-radius: 0 !important;\n      border-bottom-right-radius: 0 !important;\n    }\n  \n    .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar, \n    .ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{\n      border-radius: $border-radius !important;\n      border-top-left-radius: 0 !important;\n      border-top-right-radius: 0 !important;\n    }\n}\n\n[dir=\"rtl\"] {\n    .ck.ck-toolbar>.ck-toolbar__items {\n        flex-direction: row-reverse;\n    }\n}","//\n// _quilljs.scss\n//\n\n.ql-editor {\n    text-align: left;\n\n    ol,\n    ul {\n        padding-left: 1.5em;\n        padding-right: 0;\n    }\n\n    li:not(.ql-direction-rtl)::before {\n        margin-left: -1.5em;\n        margin-right: 0.3em;\n        text-align: right;\n    }\n}\n\n.ql-container {\n    font-family: $font-family-base;\n\n    &.ql-snow {\n        border-color: $input-border-color;\n        border-bottom-left-radius: 4px;\n        border-bottom-right-radius: 4px;\n    }\n}\n\n.ql-bubble {\n    border: $input-border-width solid $input-border-color;\n    border-radius: $input-border-radius;\n}\n\n.ql-toolbar {\n    font-family: $font-family-base !important;\n\n    span {\n        outline: none !important;\n        color: var(--#{$prefix}choices-link-color);\n\n        &:hover {\n            color: $primary !important;\n        }\n    }\n\n    &.ql-snow {\n        border-top-left-radius: 4px;\n        border-top-right-radius: 4px;\n        border-color: $input-border-color;\n\n        .ql-picker.ql-expanded {\n            .ql-picker-label {\n                border-color: transparent;\n            }\n        }\n\n        .ql-picker-options {\n            box-shadow: $dropdown-box-shadow;\n            border-radius: $dropdown-border-radius;\n        }\n    }\n}\n\n.ql-snow {\n\n    .ql-stroke,\n    .ql-script,\n    .ql-strike svg {\n        stroke: var(--#{$prefix}choices-link-color);\n    }\n\n    .ql-fill {\n        fill: var(--#{$prefix}choices-link-color);\n    }\n\n    .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) {\n        svg {\n            right: 0;\n            left: auto;\n        }\n    }\n\n    .ql-picker {\n        &.ql-expanded .ql-picker-label {\n            color: var(--#{$prefix}choices-link-color);\n        }\n    }\n}\n\n.ql-snow {\n    .ql-picker-options {\n        background-color: var(--#{$prefix}choices-bg);\n        border-color: $dropdown-border-color !important;\n    }\n}","// \n// _gridjs.scss\n// \n\n.gridjs-container {\n    color: $table-color;\n    padding: 0;\n    display: block;\n}\n\n.gridjs-wrapper {\n    box-shadow: none;\n    border: 1px solid $table-border-color;\n    border-radius: 0px;\n\n    &::-webkit-scrollbar {\n        -webkit-appearance: none;\n    }\n\n    &::-webkit-scrollbar:vertical {\n        width: 12px;\n    }\n\n    &::-webkit-scrollbar:horizontal {\n        height: 12px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: rgba(var(--#{$prefix}dark-rgb), .075);\n        border-radius: 10px;\n        border: 2px solid var(--#{$prefix}card-bg-custom);\n    }\n\n    &::-webkit-scrollbar-track {\n        border-radius: 10px;\n        background-color: var(--#{$prefix}card-bg-custom);\n    }\n}\n\n.gridjs-footer {\n    border: none !important;\n    padding: 12px 0 0;\n}\n\n.gridjs-table {\n    width: 100%;\n}\n\n.gridjs-tbody, td.gridjs-td{\n    background-color: $table-bg;\n}\n\nth.gridjs-th,\ntd.gridjs-td {\n    border: 1px solid $table-border-color;\n    padding: $table-cell-padding-y $table-cell-padding-x;\n}\n\nth {\n    &.gridjs-th {\n        border-top: 0;\n        color: $table-color;\n        background-color: rgba(var(--#{$prefix}light-rgb), .75);\n\n    }\n\n    &.gridjs-th-sort {\n\n        &:focus,\n        &:hover {\n            background-color: rgba(var(--#{$prefix}light-rgb), .85);\n        }\n    }\n}\n\n.gridjs-head{\n    padding-top: 0;\n}\n\n.gridjs-footer {\n    box-shadow: none;\n    border: 1px solid $table-border-color;\n    border-top: 0;\n    background-color: $table-bg;\n}\n\n.gridjs-summary {\n    color: $text-muted;\n    margin-top: 8px !important;\n}\n\n.gridjs-pagination {\n\n    .gridjs-pages button {\n        margin-left: 0.3rem;\n        border-radius: $border-radius !important;\n        border: 1px solid $pagination-border-color;\n        background-color: $pagination-bg;\n        color: $pagination-color;\n\n        &:last-child{\n            border-right: 1px solid $pagination-border-color;\n        }\n\n        &:disabled,\n        &:hover:disabled,\n        &[disabled] {\n            color: $pagination-disabled-color;\n            background-color: $pagination-bg;\n        }\n\n        &:hover {\n            background-color: $pagination-hover-bg;\n            color: $pagination-hover-color;\n        }\n\n        &:focus {\n            box-shadow: none;\n        }\n\n        &:last-child,\n        &:first-child {\n            &:hover {\n                background-color: transparent;\n            }\n        }\n\n        &.gridjs-currentPage {\n            background-color: $pagination-active-bg;\n            color: $pagination-active-color;\n            border-color: $pagination-active-border-color;\n            font-weight: $font-weight-medium;\n        }\n    }\n}\n\n.gridjs-search {\n    position: relative;\n    float: left;\n\n    &::before {\n        content: \"\\f0d1\";\n        font-family: \"remixicon\";\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        left: 10px;\n        font-size: 14px;\n        color: $text-muted;\n    }\n}\n\ninput.gridjs-input {\n    border-color: $input-border-color;\n    background-color: $input-bg;\n    color: $input-color;\n    line-height: $input-line-height;\n    padding: $input-padding-y $input-padding-x $input-padding-y $input-padding-x*2.25;\n    border-radius: $input-border-radius;\n    @include font-size($input-font-size);\n\n    &:focus {\n        box-shadow: none;\n        border-color: $input-focus-border-color;\n        background-color: $input-focus-bg;\n    }\n\n    &::placeholder{\n        color: $input-placeholder-color;\n    }\n}\n\nth.gridjs-th {\n    .gridjs-th-content {\n        float: none;\n        display: inline-block;\n        vertical-align: middle;\n        font-weight: $font-weight-semibold;\n    }\n}\n\nbutton.gridjs-sort {\n    float: none;\n    display: inline-block;\n    vertical-align: middle;\n    width: 10px;\n    height: 20px;\n}\n\nth.gridjs-th-sort .gridjs-th-content {\n    width: calc(100% - 10px);\n}\n\nbutton{\n    &.gridjs-sort-asc, &.gridjs-sort-desc{\n        background-size: 7px;\n    }\n}\n\n\n// card table\n\n.table-card{\n\n    .gridjs-head{\n        padding: 16px 16px 5px;\n    }\n\n    .gridjs-wrapper{\n        border-top: 0;\n        border-radius: 0;\n        border-width: 1px 0;\n    }\n\n    .gridjs-footer{\n        padding: 8px 16px;\n    }\n}\n\n// gridjs selection\n.gridjs-tr-selected {\n    td{\n        background-color: $table-active-bg;\n    }\n    .gridjs-td .gridjs-checkbox[type=checkbox]{\n        background-color: $form-check-input-checked-bg-color;\n        border-color: $form-check-input-checked-border-color;\n        @if $enable-gradients {\n            background-image: escape-svg($form-check-input-checked-bg-image), var(--#{$prefix}gradient);\n          } @else {\n            background-image: escape-svg($form-check-input-checked-bg-image);\n          }\n    }\n}\n.gridjs-td{\n    .gridjs-checkbox{\n        width: $form-check-input-width;\n        height: $form-check-input-width;\n        vertical-align: top;\n        background-color: $form-check-input-bg;\n        background-repeat: no-repeat;\n        background-position: center;\n        background-size: contain;\n        border: $form-check-input-border;\n        appearance: none;\n        print-color-adjust: exact; // Keep themed appearance for print\n        @include transition($form-check-transition);\n        &[type=\"checkbox\"] {\n          @include border-radius($form-check-input-border-radius);\n        }\n    }\n}\n\n.gridjs-border-none{\n    td.gridjs-td, th.gridjs-th{\n        border-right-width: 0;\n        border-left-width: 0;\n    }\n}\n\n.gridjs-loading-bar {\n    background-color: var(--#{$prefix}card-bg-custom);\n}\n\n[data-layout-mode=\"dark\"]{\n    button{\n        &.gridjs-sort-neutral, &.gridjs-sort-asc, &.gridjs-sort-desc{\n            filter: $btn-close-white-filter;\n        }\n    }\n}","// \n// _listjs.scss\n// \n\n.listjs-pagination{\n    margin-bottom: 0;\n    justify-content: flex-end;\n    gap: 8px;\n    li{\n        .page{\n            display: block;\n            padding: $pagination-padding-y $pagination-padding-x;\n            color: $pagination-color;\n            background-color: $pagination-bg;\n            border: $pagination-border-width solid $pagination-border-color;\n            border-radius: $border-radius;\n        }\n\n        &.active{\n            .page{\n                color: $pagination-active-color;\n                @include gradient-bg($pagination-active-bg);\n                border-color: $pagination-active-border-color;\n            }\n        }\n    }\n}\n\n.pagination-wrap {\n    user-select: none;\n    display: flex;\n    align-items: center;\n    a {\n        text-decoration: none;\n        display: inline-block;\n    }\n}\n\n.pagination-next,\n.pagination-prev {\n    color: $primary;\n    font-weight: $font-weight-medium;\n    padding: $pagination-padding-y $pagination-padding-x;\n    background-color: $pagination-bg;\n    border: $pagination-border-width solid $pagination-border-color;\n    border-radius: $border-radius; \n    &:hover {\n        color: lighten($primary, 20%);\n    }\n\n    &.disabled {\n        color: $text-muted;\n        cursor: default;\n\n        &:hover {\n            color: $text-muted;\n        }\n    }\n}","//\n// apexcharts.scss\n//\n\n.apex-charts {\n    min-height: 10px !important;\n    text {\n        font-family: $font-family-base !important;\n    }\n    .apexcharts-canvas {\n        margin: 0 auto;\n    }\n}\n\n.apexcharts-tooltip-title,\n.apexcharts-tooltip-text {\n    font-family: $font-family-base !important;  \n}\n\n.apexcharts-tooltip{\n    border: 1px solid $border-color !important;\n    background-color: var(--#{$prefix}card-bg-custom) !important;\n    box-shadow: $box-shadow !important;\n    * {\n        font-family: $font-family-base !important;\n        color: $gray-600 !important;\n    }\n\n    .apexcharts-tooltip-title{\n        background-color: rgba(var(--#{$prefix}light-rgb), .75) !important;\n        border-bottom: 1px solid $border-color !important;\n    }\n}\n\n.apexcharts-tooltip.apexcharts-theme-dark{\n    * {\n        color: $white !important;\n    }\n}\n\n.apexcharts-legend-series {\n    font-weight: $font-weight-medium;\n}\n\n.apexcharts-gridline {\n    pointer-events: none;\n    stroke: rgba(var(--#{$prefix}light-rgb), .75);\n}\n\n.apexcharts-legend-text {\n    color: $gray-600 !important;\n    font-family: $font-family-base !important;\n    font-size: 13px !important;\n}\n\n.apexcharts-pie-label {\n    fill: $white !important;\n}\n\n.apexcharts-title-text, .apexcharts-subtitle-text{\n    fill: $gray-500;\n}\n\n.apexcharts-yaxis,\n.apexcharts-xaxis {\n    text {\n        font-family: $font-family-base !important;\n        fill: $gray-500;\n    }\n}\n\n.apexcharts-yaxis-title {\n    font-weight: 500;\n}\n\n// column dynamic loaded chart\n\n#dynamicloadedchart-wrap {\n    margin: 0px auto;\n    max-width: 800px;\n    position: relative;\n}\n\n.chart-box {\n    padding-left: 0;\n}\n\n#chart-year,\n#chart-quarter {\n    width: 96%;\n    max-width: 48%;\n    box-shadow: none;\n    padding-left: 0;\n    padding-top: 20px;\n    background: var(--#{$prefix}card-bg-custom);\n    border: 1px solid $border-color;\n}\n\n#chart-year {\n    float: left;\n    position: relative;\n    transition: 1s ease transform;\n    z-index: 3;\n    &.chart-quarter-activated {\n        transform: translateX(0);\n        transition: 1s ease transform;\n    }\n}\n\n#chart-quarter {\n    float: left;\n    position: relative;\n    z-index: -2;\n    transition: 1s ease transform;\n    &.active {\n        transition: 1.1s ease-in-out transform;\n        transform: translateX(0);\n        z-index: 1;\n    }\n}\n\n@media screen and (min-width: 480px) {\n    #chart-year {\n        transform: translateX(50%);\n    }\n    #chart-quarter {\n        transform: translateX(-50%);\n    }\n}\n\n// radar chart\n\n.apexcharts-radar-series{\n    polygon, line{\n        stroke: $border-color;\n    }\n}\n\n.apexcharts-pie{\n    circle ,line{\n        stroke: $border-color;\n    }\n    text{\n        fill: var(--#{$prefix}body-color);\n    }\n}\n\n.apex-charts {\n\n    .apexcharts-xaxis,\n    .apexcharts-yaxis {\n        line {\n            stroke: var(--#{$prefix}border-color);\n        }\n    }\n\n    .apexcharts-xaxis-tick {\n        stroke: var(--#{$prefix}border-color);\n    }\n\n    .apexcharts-pie-series,\n    .apexcharts-bar-series {\n        path {\n            stroke: var(--#{$prefix}card-bg-custom);\n        }\n    }\n\n    .apexcharts-radialbar-track {\n        path {\n            stroke: var(--#{$prefix}light);\n        }\n    }\n\n    .apexcharts-marker {\n        stroke: var(--#{$prefix}card-bg-custom);\n    }\n\n    .apexcharts-boxPlot-series {\n        path {\n            stroke: var(--#{$prefix}border-color);\n        }\n    }\n\n    .apexcharts-treemap,\n    .apexcharts-heatmap-series {\n        rect {\n            stroke: var(--#{$prefix}card-bg-custom);\n        }\n    }\n}","\n//\n// _chartjs.scss\n//\n\n.chartjs-chart{\n  max-height: 320px;\n}\n  ","//\n// echarts.scss\n//\n\n.e-charts{\n    height: 350px;\n}\n\n.e-charts-height{\n    height: 300px;\n}","\n//\n// _google-map.scss\n//\n\n.gmaps, .gmaps-panaroma {\n  height: 300px;\n  background: $gray-100;\n  border-radius: 3px;\n}\n\n.gmaps-overlay {\n  display: block;\n  text-align: center;\n  color: $white;\n  font-size: 16px;\n  line-height: 40px;\n  background: $primary;\n  border-radius: 4px;\n  padding: 10px 20px;\n}\n\n.gmaps-overlay_arrow {\n  left: 50%;\n  margin-left: -16px;\n  width: 0;\n  height: 0;\n  position: absolute;\n  &.above {\n    bottom: -15px;\n    border-left: 16px solid transparent;\n    border-right: 16px solid transparent;\n    border-top: 16px solid $primary;\n  }\n  &.below {\n    top: -15px;\n    border-left: 16px solid transparent;\n    border-right: 16px solid transparent;\n    border-bottom: 16px solid $primary;\n  }\n  \n}","//\n// _autocomplete.scss\n//\n\n.autoComplete_wrapper {\n    display: block;\n\n    >input {\n        display: block;\n        width: 100%;\n        height: auto;\n        padding: $input-padding-y $input-padding-x;\n        font-family: $input-font-family;\n        font-size: $input-font-size;\n        font-weight: $input-font-weight;\n        line-height: $input-line-height;\n        color: $input-color;\n        background-color: $input-bg;\n        background-clip: padding-box;\n        border: $input-border-width solid $input-border-color;\n        border-radius: $input-border-radius;\n        background-image: none;\n\n        &::placeholder {\n            padding: 0 !important;\n            color: $input-placeholder-color !important;\n            font-size: $input-font-size !important;\n        }\n\n        &:focus {\n            border: $input-border-width solid $input-focus-border-color;\n            color: $input-focus-color;\n        }\n\n        &:hover {\n            color: $input-color;\n        }\n    }\n\n    >ul {\n        border-radius: $border-radius;\n        border-color: $dropdown-border-color;\n        background-color: $dropdown-bg;\n        box-shadow: $dropdown-box-shadow;\n        padding: 0;\n        overflow: auto;\n        max-height: 160px;\n        margin: 0;\n        animation-name: DropDownSlide;\n        animation-duration: .3s;\n        animation-fill-mode: both;\n\n        > li {\n            font-size: $dropdown-font-size;\n            margin: 0;\n            padding: $dropdown-item-padding-y $dropdown-item-padding-x;\n            border-radius: 0;\n            background-color: $dropdown-bg;\n            color: $dropdown-color;\n\n            mark {\n                color: $danger;\n                font-weight: $font-weight-semibold;\n                padding: 1px;\n            }\n\n            &[aria-selected=true],\n            &:hover {\n                color: $dropdown-link-hover-color;\n                @include gradient-bg($dropdown-link-hover-bg);\n            }\n        }\n\n        .no_result {\n            padding: $dropdown-item-padding-y *2 $dropdown-item-padding-x;\n            font-style: italic;\n            font-weight: $font-weight-medium;\n        }\n    }\n}","//\n// vector-maps.scss\n//\n\n.jvm-tooltip {\n    border-radius: 3px;\n    background-color: $primary;\n    font-family: $font-family-base;\n    box-shadow: $box-shadow-lg;\n    padding: 5px 9px;\n}\n\n.jvm-container {\n    text {\n        font-family: $font-family-base;\n        font-size: $font-size-base;\n        fill: var(--#{$prefix}gray-700);\n    }\n}\n\n.jvm-zoom-btn {\n    background-color: $primary;\n}","//\n// _leaflet-maps.scss\n//\n\n.leaflet-map {\n    height: 300px;\n    &.leaflet-container{\n        z-index: 0;\n        font-family: $font-family-primary;\n    }\n}","// \n// _fullcalendar.scss\n// \n\n\n.fc td,\n.fc th {\n    border: $table-border-width solid $table-border-color;\n}\n\n.fc {\n    .fc-toolbar {\n        h2 {\n            font-size: 16px;\n            line-height: 30px;\n            text-transform: uppercase;\n        }\n\n        @media (max-width: 767.98px) {\n\n            .fc-left,\n            .fc-right,\n            .fc-center {\n                float: none;\n                display: block;\n                text-align: center;\n                clear: both;\n                margin: 10px 0;\n            }\n\n            >*>* {\n                float: none;\n            }\n\n            .fc-today-button {\n                display: none;\n            }\n        }\n\n        .btn {\n            text-transform: capitalize;\n        }\n    }\n\n    .fc-col-header-cell {\n        background-color: var(--#{$prefix}light);\n    }\n\n    .fc-col-header-cell-cushion {\n        display: block;\n        padding: 8px 4px;\n    }\n\n    .fc-daygrid-day-number {\n        width: 24px;\n        height: 24px;\n        border-radius: 50%;\n        padding: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        font-size: 12px;\n        font-weight: $font-weight-medium;\n        margin: 2px;\n    }\n\n    .fc-daygrid-day {\n        &.fc-day-today {\n            background-color: rgba($primary, 0.1);\n    \n            .fc-daygrid-day-number {\n                background-color: $primary;\n                color: $white;\n            }\n        }\n    }\n\n    .fc-daygrid-day {\n        &.fc-day-today {\n            background-color: rgba($primary, 0.1);\n        }\n    }\n    \n    .fc-timegrid-col {\n        &.fc-day-today {\n            background-color: rgba($primary, 0.1);\n        }\n    }\n\n    .fc-list-event:hover td {\n        background: transparent;\n    }\n\n    .fc-list-event-title {\n        a {\n            color: $white !important;\n        }\n    }\n\n    .fc-col-header,\n    .fc-daygrid-body,\n    .fc-scrollgrid-sync-table {\n        width: 100% !important;\n    }\n\n    .fc-scrollgrid-section>*{\n        border-left: $table-border-width solid $table-border-color;\n        border-top: $table-border-width solid $table-border-color;\n    }\n\n    .fc-scrollgrid-section-liquid>td{\n        border-top: 0;\n    }\n}\n\n.fc-theme-bootstrap a:not([href]) {\n    color: var(--#{$prefix}body-color);\n}\n\n.fc-event {\n    color: $white;\n}\n\n.fc {\n    th.fc-widget-header {\n        background: $gray-300;\n        line-height: 20px;\n        padding: 10px 0;\n        text-transform: uppercase;\n        font-weight: $font-weight-bold;\n    }\n}\n\n.fc-unthemed {\n\n    .fc-content,\n    .fc-divider,\n    .fc-list-heading td,\n    .fc-list-view,\n    .fc-popover,\n    .fc-row,\n    tbody,\n    td,\n    th,\n    thead {\n        border-color: $gray-300;\n    }\n\n    td.fc-today {\n        background: lighten($gray-200, 2%);\n    }\n}\n\n.fc-button {\n    background: var(--#{$prefix}card-bg-custom);\n    border-color: $border-color;\n    color: $gray-700;\n    text-transform: capitalize;\n    box-shadow: none;\n    padding: 6px 12px !important;\n    height: auto !important;\n}\n\n.fc-state-down,\n.fc-state-active,\n.fc-state-disabled {\n    background-color: $primary;\n    color: $white;\n    text-shadow: none;\n}\n\n.fc-event {\n    border-radius: 2px;\n    border: none;\n    cursor: move;\n    font-size: 0.8125rem;\n    margin: 5px 7px;\n    padding: 5px 5px;\n    text-align: center;\n}\n\n.fc-event,\n.fc-event-dot {\n    background-color: $primary;\n}\n\n.fc-daygrid-dot-event.fc-event-mirror,\n.fc-daygrid-dot-event:hover {\n    background-color: $primary;\n}\n\n// .fc-daygrid-dot-event {\n//     color: $white !important;\n// }\n\n.fc-event-title,\n.fc-sticky {\n    font-weight: $font-weight-semibold !important;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.fc-daygrid-event-dot {\n    border-color: $white !important;\n    display: none;\n}\n\n.fc-event-time {\n    display: none;\n}\n\n.fc-event .fc-content {\n    color: $white;\n}\n\n#external-events {\n    .external-event {\n        text-align: left;\n        padding: 8px 16px;\n        margin: 6px 0;\n    }\n}\n\n\n.fc-day-grid-event.fc-h-event.fc-event.fc-start.fc-end.bg-dark {\n    .fc-content {\n        color: $light;\n    }\n}\n\n.fc-prev-button,\n.fc-next-button {\n    position: relative;\n    height: 37.5px;\n    width: 37.5px;\n\n    &::before {\n        position: absolute;\n        font-family: remixicon !important;\n        font-size: 20px;\n        top: 0;\n        bottom: 0px;\n        left: 0;\n        right: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n}\n\n.fc-prev-button {\n    &::before {\n        content: \"\\ea64\";\n    }\n}\n\n.fc-next-button {\n    &::before {\n        content: \"\\ea6e\";\n    }\n}\n\n.fc-toolbar-chunk {\n    .btn-group {\n        box-shadow: $element-shadow;\n        .btn {\n            color: $secondary;\n            background-color: rgba($secondary, 0.15);\n            border: none;\n            box-shadow: none;\n\n            &:hover,\n            &.active {\n                color: $white;\n                background-color: $secondary;\n            }\n        }\n    }\n\n    .fc-today-button {\n        background-color: $secondary !important;\n        border: $secondary;\n    }\n}\n\n.fc-toolbar {\n    @media (max-width: 575.98px) {\n        flex-direction: column;\n        gap: 16px;\n    }\n}\n\n#upcoming-event-list {\n    .card {\n        &:last-child {\n            margin-bottom: 6px !important;\n        }\n    }\n}\n\n#event-modal {\n    .event-details {\n        display: none;\n    }\n\n    .view-event {\n        .event-form {\n            display: none;\n        }\n\n        #event-category-tag {\n            display: none;\n        }\n\n        .event-details {\n            display: block;\n        }\n    }\n}\n\n.fc-daygrid-event-harness {\n    .fc-daygrid-event {\n        backdrop-filter: blur(4px);\n    }\n}\n\n.fc-timegrid-event-harness {\n    .fc-timegrid-event {\n        backdrop-filter: blur(4px);\n    }\n}\n\n\n.fc-timegrid-slots {\n    table {\n        tr {\n            border-color: $border-color !important;\n        }\n    }\n}\n\n.fc-list-table {\n    border-color: $border-color;\n}\n\n@each $color,\n$value in $theme-colors {\n    .fc-daygrid-event-harness {\n        .fc-daygrid-event {\n            &.bg-soft-#{$color} {\n\n                .fc-event-title,\n                .fc-event-main {\n                    color: $value !important;\n                }\n            }\n        }\n    }\n\n    .fc-timegrid-event-harness {\n        .fc-timegrid-event {\n            &.bg-soft-#{$color} {\n                .fc-event-title {\n                    color: $value !important;\n                }\n            }\n        }\n    }\n\n    .fc-list-table {\n        .fc-list-event {\n            &.bg-soft-#{$color} {\n                color: $value !important;\n\n                .fc-list-event-title {\n                    >a {\n                        color: $value !important;\n                    }\n                }\n\n                .fc-list-event-dot {\n                    border-color: $value;\n                }\n            }\n        }\n    }\n}\n\n.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark{\n    .fc-event-main, .fc-event-title {\n        color:  var(--#{$prefix}dark) !important;\n    }\n}\n\n.fc-direction-ltr{\n    direction: ltr;\n    .fc-toolbar>*>:not(:first-child){\n        margin-left: 0.75em;\n    }\n}","//\n// emoji-picker.scss\n//\n\n.fg-emoji-picker{\n    width: 250px !important;\n    box-shadow: $box-shadow !important;\n    top: auto !important;\n    bottom: 130px;\n\n    *{\n        font-family: $font-family-base !important;\n        color: var(--#{$prefix}body-color) !important;\n    }\n    @media (max-width:991.98px) {\n        left: 14px !important;\n        top: auto !important;\n        bottom: 118px;\n    }\n\n    .fg-emoji-picker-container-title{\n        color: $dark !important;\n    }\n\n    .fg-emoji-picker-search{\n        height: 40px !important;\n        input{\n            background-color: $input-bg !important;\n            color: $input-color !important;\n            padding: $input-btn-padding-y $input-btn-padding-x !important;\n            font-size: $font-size-base !important;\n            &::placeholder{\n                color: $input-placeholder-color !important;\n            }\n        }\n\n        svg{\n            fill: var(--#{$prefix}body-color) !important;\n            right: 11px;\n            top: 12px;\n        }\n    }\n\n    .fg-emoji-picker-categories{\n        background-color: $light !important;\n        li.active{\n            background-color: rgba(var(--bs-primary-rgb), 0.2);\n        }\n        a{\n            &:hover{\n                background-color: rgba(var(--bs-primary-rgb), 0.2);\n            }\n        }\n        \n    }\n}\n\n.fg-emoji-picker-grid > li:hover{\n    background-color: rgba(var(--bs-primary-rgb), 0.2) !important;\n}\n\na.fg-emoji-picker-close-button{\n    background-color: darken($light, 4%) !important;\n}","//\n// _datatables.scss\n//\n\ntable.dataTable td.dataTables_empty,\ntable.dataTable th.dataTables_empty {\n    text-align: center;\n    padding: 50px;\n    font-weight: $font-weight-semibold;\n    --vz-table-accent-bg: var(--#{$prefix}card-bg-custom);\n}\n\ntable.dataTable>thead .sorting:before,\ntable.dataTable>thead .sorting_asc:before,\ntable.dataTable>thead .sorting_desc:before,\ntable.dataTable>thead .sorting_asc_disabled:before,\ntable.dataTable>thead .sorting_desc_disabled:before {\n    content:\"\\f0360\";\n    position: absolute;\n    right: 0.5rem;\n    top: 12px;\n    font-size: .8rem;\n    font-family: \"Material Design Icons\";\n}\n\ntable.dataTable>thead .sorting:after,\ntable.dataTable>thead .sorting_asc:after,\ntable.dataTable>thead .sorting_desc:after,\ntable.dataTable>thead .sorting_asc_disabled:after,\ntable.dataTable>thead .sorting_desc_disabled:after {\n    content: \"\\f035d\";\n    position: absolute;\n    right: 0.5rem;\n    top: 18px;\n    font-size: .8rem;\n    font-family: \"Material Design Icons\";\n}\n\ntable.dataTable>tbody>tr.child span.dtr-title {\n    font-weight: $font-weight-semibold;\n    min-width: 150px;\n}\n\n\n//responsive \ntable {\n    &.dataTable {\n        &.dtr-inline {\n            &.collapsed {\n                >tbody {\n                    >tr {\n\n                        >th,\n                        >td {\n                            &.dtr-control {\n                                &::before {\n                                    background-color: $primary;\n                                    border-color: var(--#{$prefix}card-bg-custom);\n                                }\n                            }\n                        }\n\n                        &.parent {\n                            &.parent {\n                                >th {\n                                    &.dtr-control {\n                                        &::before {\n                                            background-color: $danger;\n                                        }\n                                    }\n                                }\n                            }\n\n                            >td {\n                                &.dtr-control {\n                                    &::before {\n                                        background-color: $danger;\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n\n        >tbody {\n            >tr {\n                &.child {\n                    span {\n                        &.dtr-title {\n                            min-width: 135px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n\n.table-card {\n\n    .dataTables_length,\n    .dataTables_filter {\n        padding: $card-cap-padding-y $card-cap-padding-x;\n        padding-bottom: 0px;\n    }\n\n    .dataTables_info,\n    .dataTables_paginate {\n        padding: $card-cap-padding-y $card-cap-padding-x;\n    }\n\n    div.dataTables_wrapper {\n        .col-md-6 {\n            width: 100%;\n        }\n\n        div {\n            &.dataTables_filter {\n                input {\n                    width: calc(100% - 52px);\n                }\n\n                label {\n                    display: block;\n                }\n            }\n        }\n    }\n}\n\n\ndiv{\n    &.dtr-modal {\n        div {\n            &.dtr-modal-display {\n                background-color: $modal-content-bg;\n                border-color: $border-color;\n                box-shadow: none;\n                height: 70%;\n            }\n            &.dtr-modal-content {\n                padding: $modal-inner-padding;\n                h2 {\n                    font-size: $font-size-lg;\n                    font-weight: $font-weight-semibold;\n                    margin-bottom: 15px;\n                }\n                .dtr-details{\n                    tr {\n                        td {\n                            padding: $table-cell-padding-y $table-cell-padding-x;\n                        }\n                    }\n                }\n            }\n            &.dtr-modal-close {\n                font-size: 24px;\n                top: 9px;\n                right: 11px;\n                width: 30px;\n                height: 30px;\n                line-height: 30px;\n                background-color: var(--#{$prefix}card-bg-custom);\n                border-color: $border-color;\n                &:hover {\n                    background-color: var(--#{$prefix}light);\n                }\n            }\n        }\n    }\n}\n\n.dt-buttons {\n    button.dt-button,\n    div.dt-button,\n    a.dt-button,\n    input.dt-button {\n        border-color: $border-color;\n        background: var(--#{$prefix}light);\n        color: var(--#{$prefix}gray-800);\n    }\n}\n\n.rdt_Table{\n\t.rdt_TableBody{\n        .rdt_TableRow{\n        background-color :$table-bg;\n        color: $table-color;\n        border-bottom-color :$table-border-color;\n        outline-color :$table-border-color;\n        }\n  }\n}","//\n// Select 2\n//\n\n.select2.select2-container{\n    width: 100% !important;\n}\n.select2-container {\n    .select2-selection--single {\n        border: $input-border-width solid $input-border-color;\n        height: $input-height;\n        background-color: $input-bg;\n        outline: none;\n        .select2-selection__rendered {\n            line-height: 36px;\n            padding-left: 12px;\n            color: $input-color;\n        }\n        .select2-selection__arrow {\n            height: 34px;\n            width: 34px;\n            /*rtl:ignore*/\n            right: 3px;\n            b {\n                border-color: $input-border-color transparent transparent transparent;\n                border-width: 6px 6px 0 6px;\n            }\n        }\n    }\n}\n\n.select2-container--open {\n    .select2-selection--single {\n        .select2-selection__arrow {\n            b {\n                border-color: transparent transparent $input-border-color transparent !important;\n                border-width: 0 6px 6px 6px !important;\n            }\n        }\n    }\n}\n\n.select2-results__option {\n    padding: 6px 12px;\n}\n\n.select2-dropdown {\n    border: $dropdown-border-width solid $dropdown-border-color;\n    box-shadow: $box-shadow;\n    background-color: var(--#{$prefix}choices-bg);\n    z-index: $zindex-modal + 1;\n}\n\n.select2-container--default {\n    .select2-results__option--selected {\n        background-color: $input-disabled-bg;\n    }\n    .select2-search--dropdown {\n        padding: 10px;\n        background-color: var(--#{$prefix}choices-bg);\n        .select2-search__field {\n            outline: none;\n            border: 1px solid $input-border-color;\n            background-color: $input-bg;\n            color: $input-color;\n            border-radius: $input-border-radius;\n        }\n    }\n    .select2-results__option--highlighted[aria-selected] {\n        background-color: $primary;\n    }\n    .select2-results__option[aria-selected=true] {\n        background-color: var(--#{$prefix}choices-bg);\n        color: var(--#{$prefix}choices-link-active-color);\n        &:hover {\n            background-color: $primary;\n            color: $white;\n        }\n    }\n    .select2-selection--multiple {\n        .select2-selection__choice__display {\n            padding-left: 36px;\n            padding-right: 5px;\n        }\n    }\n    .select2-selection--single {\n        .select2-selection__arrow {\n            /*rtl:ignore*/\n            right: 1px;\n            /*rtl:ignore*/\n            left: auto;\n        }\n    }\n    \n}\n\n.select2-container {\n    .select2-selection--multiple {\n        min-height: $input-height;\n        border: $input-border-width solid $input-border-color !important;\n        background-color: $input-bg;\n\n        .select2-selection__rendered {\n            padding: 1px 4px;\n        }\n        .select2-search__field {\n            border: 0;\n            color: $input-color;\n        }\n        .select2-selection__choice {\n            background-color: $primary;\n            border: none;\n            color: $white;\n            border-radius: 3px;\n            padding: 3px;\n            margin-top: 6px;\n        }\n        .select2-selection__choice__remove {\n            color: $white;\n            margin-right: 7px;\n            border-color: tint-color($primary, 10%);\n            padding: 0 8px;\n            top: 3px;\n            &:hover {\n                color: $white;\n                background-color: $primary;\n            }\n        }\n    }\n    .select2-search--inline {\n        .select2-search__field {\n            margin-top: 7px;\n            font-family: $font-family-base;\n        }\n    }\n    .select2-search {\n        textarea {\n            &::placeholder {\n                color: $input-placeholder-color;\n            }\n        }\n    }\n}\n\n.select2-container--default{\n    &.select2-container--disabled {\n        .select2-selection--single, .select2-selection--multiple {\n            background-color: $input-disabled-bg;\n            cursor: default;\n        }\n    }\n}\n","// \n// toastify.scss\n// \n\n\n.toastify {\n    padding: 12px 16px;\n    color: $white;\n    display: inline-block;\n    box-shadow: 0 3px 6px -1px rgba(0, 0, 0, 0.12), 0 10px 36px -4px rgba(77, 96, 232, 0.3);\n    background: $success;\n    position: fixed;\n    opacity: 0;\n    transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);\n    border-radius: 2px;\n    cursor: pointer;\n    text-decoration: none;\n    max-width: calc(50% - 20px);\n    z-index: 2147483647;\n    &.on {\n        opacity: 1;\n    }\n}\n\n\n.toast-close {\n    opacity: 0.4;\n    padding: 0 5px;\n    position: relative;\n    left: 4px;\n    margin-left: 4px;\n    border: none;\n    background: none;\n}\n\n.toastify-right {\n    right: 15px;\n}\n\n.toastify-left {\n    left: 15px;\n    .toast-close {\n        left: -4px;\n        margin-left: 0;\n        margin-right: 4px;\n    }\n}\n\n.toastify-top {\n    top: -150px;\n}\n\n.toastify-bottom {\n    bottom: -150px;\n}\n\n.toastify-rounded {\n    border-radius: 25px;\n}\n\n.toastify-avatar {\n    width: 1.5em;\n    height: 1.5em;\n    margin: -7px 5px;\n    border-radius: 2px;\n}\n\n.toastify-center {\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    right: 0;\n    max-width: fit-content;\n    max-width: -moz-fit-content;\n}\n\n@media only screen and (max-width: 360px) {\n    .toastify-right, .toastify-left {\n        margin-left: auto;\n        margin-right: auto;\n        left: 0;\n        right: 0;\n        max-width: fit-content;\n    }\n}","//\n// _choices.scss\n//\n\n.choices {\n    position: relative;\n    margin-bottom: 24px;\n    font-size: 16px;\n\n    &:focus {\n        outline: none;\n    }\n\n    &:last-child {\n        margin-bottom: 0;\n    }\n\n    &.is-disabled{\n        .choices__inner,\n        .choices__input {\n            background-color: rgba(var(--#{$prefix}light-rgb), 0.75);\n            cursor: not-allowed;\n            user-select: none;\n        }\n\n        .choices__item {\n            cursor: not-allowed;\n        }\n    }\n\n    [hidden] {\n        display: none !important;\n    }\n    \n    // data-type = select-one\n    &[data-type*='select-one'] {\n        cursor: pointer;\n        .choices__inner{\n            padding-bottom: 0.25rem;\n        }\n\n        .choices__input{\n            display: block;\n            width: 100%;\n            padding: $input-padding-y $input-padding-x;\n            background-color: $input-bg;\n            border: 1px solid $input-border-color;\n            font-size: $input-font-size;\n            border-radius: $input-border-radius;\n            color: $input-color;\n            margin-bottom: 10px;\n        }\n\n        .choices__button{\n            background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==);\n            padding: 0;\n            background-size: 8px;\n            position: absolute;\n            top: 50%;\n            right: 0;\n            left: auto;\n            margin-top: -10px;\n            margin-right: 25px;\n            margin-left: 0;\n            height: 20px;\n            width: 20px;\n            border-radius: 10em;\n            opacity: 0.5;\n\n            &:hover, &:focus {\n                opacity: 1;\n            }\n\n            &:focus {\n                box-shadow: 0px 0px 0px 2px #00bcd4;\n            }\n        }\n\n        .choices__item[data-value=''] .choices__button {\n            display: none;\n        }\n\n        &:after {\n            content: \"\\F0140\";\n            position: absolute;\n            border: 0;\n            border-color: $dark transparent transparent;\n            right: 11.5px;\n            left: auto;\n            font-family: 'Material Design Icons';\n            width: auto;\n            height: auto;\n            margin-top: 0;\n            top: 50%;\n            transform: translateY(-50%);\n            pointer-events: none;\n        }\n\n        &.is-open:after {\n            margin-top: 0;\n            transform: translateY(-50%) rotate(-180deg);\n        }\n\n    }\n\n\n    // data-type = select- multiple & text\n\n    &[data-type*='select-multiple'],\n    &[data-type*='text'] {\n        .choices__inner {\n            cursor: text;\n            padding-right: $form-select-padding-x;\n        }\n\n        .choices__button {\n            position: relative;\n            display: inline-block;\n            margin-top: 0;\n            margin-right: -4px;\n            margin-bottom: 0;\n            margin-left: 8px;\n            padding-left: 16px;\n            border-left: 1px solid rgba($white, 0.5);\n            border-right: 0;\n            background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==);\n            background-size: 8px;\n            width: 8px;\n            line-height: 1;\n            opacity: 0.75;\n            border-radius: 0;\n            &:hover, &:focus {\n                opacity: 1;\n            }\n        }\n        .choices__list--dropdown{\n            padding-bottom: 10px;\n            .choices__list{\n                margin-bottom: 0;\n            }\n        }\n    }\n\n    &[data-type*=select-multiple] {\n        .choices__input {\n            padding-top: 3px;\n        }\n    }\n}\n\n//Select Light\n.input-light {\n    .choices__inner { \n        background-color: var(--#{$prefix}light);\n        border: none;\n    }\n}\n  \n.choices__inner {\n    display: inline-block;\n    vertical-align: middle;\n    width: 100%;\n    background-color: $form-select-bg;\n    padding: 0.25rem ($form-select-padding-x + $form-select-indicator-padding) 0.1rem 0.5rem;\n    border: $form-select-border-width solid $form-select-border-color;\n    border-radius: $form-select-border-radius !important;\n    font-size: $input-font-size;\n    min-height: 37.5px;\n    overflow: hidden;\n}\n\n  \n.is-focused,\n.is-open {\n    .choices__inner {\n        border-color: $input-focus-border-color;\n    }\n}\n  \n.choices__list {\n    margin: 0;\n    padding-left: 0;\n    list-style: none;\n}\n  \n.choices__list--single {\n    display: inline-block;\n    padding: 4px 16px 4px 4px;\n    width: 100%;\n\n    .choices__item {\n        width: 100%;\n    }\n}\n\n.choices__list--multiple {\n    display: inline;\n    .choices__item {\n        display: inline-block;\n        vertical-align: initial;\n        border-radius: 7px;\n        padding: 2px 7px;\n        font-size: 11px;\n        font-weight: $font-weight-normal;\n        margin-right: 3.75px;\n        margin-bottom: 3.75px;\n        margin-top: 2px;\n        background-color: $primary;\n        border: 1px solid $primary;\n        word-break: break-all;\n        box-sizing: border-box;\n        color: $white;\n        box-shadow: $element-shadow;\n        &[data-deletable] {\n            padding-right: 5px;\n        }\n\n        &.is-highlighted {\n            background-color: $primary;\n            border: 1px solid $primary;\n        }\n    }\n}\n\n  \n.is-disabled {\n    .choices__list--multiple {\n        .choices__item {\n            background-color: $secondary;\n            border: 1px solid $secondary\n        }\n    }\n}\n  \n.choices__list--dropdown {\n    visibility: hidden;\n    z-index: 1;\n    position: absolute;\n    width: 100%;\n    background-color: var(--#{$prefix}choices-bg);\n    border: 1px solid var(--#{$prefix}border-color);\n    box-shadow: $dropdown-box-shadow;\n    top: 100%;\n    margin-top: 0;\n    padding: 10px 10px 20px 10px;\n    border-bottom-left-radius: 2.5px;\n    border-bottom-right-radius: 2.5px;\n    overflow: hidden;\n    word-break: break-all;\n    will-change: visibility;\n    animation-duration: .3s;\n    animation-fill-mode: both;\n    transform: translateY(1px);\n    &.is-active {\n        visibility: visible;\n        animation-name: DropDownSlide;\n    }\n\n    .choices__item--selectable.is-highlighted {\n        background-color: var(--#{$prefix}choices-link-hover-bg);\n    }\n\n    .choices__list {\n        margin: 0 -16px -16px;\n    }\n\n    .has-no-results {\n        font-style: italic;\n        font-weight: $font-weight-medium;\n    }\n\n    .choices__item--selectable:after{\n        display: none;\n    }\n}\n  \n.is-open{\n    .choices__list--dropdown {\n        border-color: $dropdown-border-color;\n    }\n}\n  \n.is-flipped{\n    .choices__list--dropdown {\n        top: auto;\n        bottom: 100%;\n        margin-top: 0;\n        margin-bottom: -1px;\n        border-radius: 0.25rem 0.25rem 0 0;\n        &.is-active {\n            animation-name: DropDownSlideDown;\n            transform: translateY(-1px);\n        }\n    }\n}\n  \n.choices__list--dropdown{\n    .choices__list {\n        position: relative;\n        max-height: 300px;\n        overflow: auto;\n        -webkit-overflow-scrolling: touch;\n        will-change: scroll-position;\n    }\n\n    .choices__item {\n        position: relative;\n        font-size: $dropdown-font-size;\n        padding: $dropdown-item-padding-y $dropdown-item-padding-x $dropdown-item-padding-y 16px;\n    }\n}\n  \n\n  \n@media (min-width: 640px) {\n    .choices__list--dropdown {\n        .choices__item--selectable {\n\n            &:after {\n                content: attr(data-select-text);\n                font-size: 12px;\n                opacity: 0;\n                position: absolute;\n                right: 10px;\n                top: 50%;\n                transform: translateY(-50%);\n            }\n\n            &.is-highlighted {\n                &:after {\n                    opacity: 0.5;\n                }\n            }\n        }\n    }\n    \n\n}\n  \n.choices__item {\n    cursor: default;\n}\n  \n.choices__item--selectable {\n    cursor: pointer;\n}\n  \n.choices__item--disabled {\n    cursor: not-allowed;\n    user-select: none;\n    opacity: 0.5;\n}\n  \n.choices__heading {\n    font-weight: $font-weight-semibold;\n    font-size: 12px;\n    padding: 10px 16px;\n    border-bottom: 1px solid $border-color;\n    color: $text-muted;\n}\n  \n.choices__button {\n    text-indent: -9999px;\n    appearance: none;\n    border: 0;\n    background-color: transparent;\n    background-repeat: no-repeat;\n    background-position: center;\n    cursor: pointer;\n    &:focus {\n        outline: none;\n    }\n}\n  \n.choices__input {\n    display: inline-block;\n    vertical-align: baseline;\n    background-color: $input-bg;\n    color: $input-color;\n    font-size: $input-font-size;\n    margin-bottom: 0;\n    border: 0;\n    border-radius: 0;\n    max-width: 100%;\n    padding: 2px 0 2px 2px;\n    &:focus {\n        outline: 0;\n    }\n    &::placeholder {\n        color: $input-placeholder-color;\n    }\n}\n  \n.choices__placeholder {\n    color: $input-placeholder-color;\n    opacity: 1;\n}\n\n\n[data-layout-mode=\"dark\"]{\n    .choices[data-type*=select-one]{\n        .choices__button{\n            filter: $btn-close-white-filter;\n        }\n    }\n}","//\n// _flatpicker.scss\n//\n\n.flatpickr-calendar {\n    background: transparent;\n    opacity: 0;\n    display: none;\n    text-align: center;\n    visibility: hidden;\n    padding: 0;\n    animation: none;\n    direction: ltr;\n    border: 0;\n    font-size: 14px;\n    line-height: 24px;\n    border-radius: 5px;\n    position: absolute;\n    width: 307.875px;\n    box-sizing: border-box;\n    touch-action: manipulation;\n    background: var(--#{$prefix}choices-bg);\n    box-shadow: 1px 0 0 $border-color, -1px 0 0 $border-color, 0 1px 0 $border-color, 0 -1px 0 $border-color, 0 3px 13px rgba(0, 0, 0, 0.08);\n\n    &.open,\n    &.inline {\n        opacity: 1;\n        max-height: 640px;\n        visibility: visible;\n    }\n\n    &.open {\n        display: inline-block;\n        z-index: 1056;\n    }\n\n    &.animate.open {\n            animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);\n    }\n\n    &.inline {\n        display: block;\n        position: relative;\n        top: 2px;\n        width: 100%;\n        box-shadow: none;\n\n        .flatpickr-rContainer {\n            display: block;\n            width: 100%;\n\n            .flatpickr-days {\n                width: 100%;\n                border: $input-border-width solid $input-border-color;\n                border-top: none;\n                border-radius: 0 0 5px 5px;\n\n\n                .dayContainer {\n                    width: 100%;\n                    min-width: 100%;\n                    max-width: 100%;\n\n                    .flatpickr-day {\n                        max-width: 100%;\n                        border-radius: 4px;\n                    }\n                }\n            }\n        }\n\n        .flatpickr-time {\n            border: $input-border-width solid $input-border-color !important;\n            border-radius: $input-border-radius;\n        }\n    }\n\n    &.static {\n        position: absolute;\n        top: calc(100% + 2px);\n        &.open {\n            z-index: 999;\n            display: block;\n        }\n    }\n\n    &.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7) {\n        box-shadow: none !important;\n    }\n\n    &.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1) {\n        box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\n    }\n\n    .hasWeeks .dayContainer,\n    .hasTime .dayContainer {\n        border-bottom: 0;\n        border-bottom-right-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n\n    .hasWeeks .dayContainer {\n        border-left: 0;\n    }\n\n    &.hasTime .flatpickr-time {\n        height: 40px;\n        border-top: 1px solid $border-color;\n    }\n\n    &.noCalendar.hasTime .flatpickr-time {\n        height: auto;\n    }\n\n    &::before,\n    &::after {\n        position: absolute;\n        display: block;\n        pointer-events: none;\n        border: solid transparent;\n        content: '';\n        height: 0;\n        width: 0;\n        left: 22px;\n    }\n\n    &.rightMost::before,\n    &.arrowRight::before,\n    &.rightMost::after,\n    &.arrowRight::after {\n      left: auto;\n      right: 22px;\n    }\n\n    &.arrowCenter::before,\n    &.arrowCenter::after {\n      left: 50%;\n      right: 50%;\n    }\n\n    &::before {\n        border-width: 5px;\n        margin: 0 -5px;\n    }\n    &::after {\n        border-width: 4px;\n        margin: 0 -4px;\n    }\n\n    &.arrowTop::before,\n    &.arrowTop::after {\n        bottom: 100%;\n    }\n    &.arrowTop::before {\n        border-bottom-color: $primary;\n    }\n    &.arrowTop::after {\n        border-bottom-color: $primary;\n    }\n\n    &.arrowBottom::before,\n    &.arrowBottom::after {\n        top: 100%;\n    }\n    &.arrowBottom::before {\n        border-top-color: $primary;\n    }\n    &.arrowBottom::after {\n        border-top-color: $primary;\n    }\n    &:focus {\n        outline: 0;\n    }\n}\n\n.flatpickr-wrapper {\n    position: relative;\n    display: inline-block;\n}\n\n.flatpickr-months {\n    display: flex;\n    background-color: $primary;\n    border-radius: 5px 5px 0px 0px;\n\n    .flatpickr-month {\n        background: transparent;\n        color: rgba($white, 0.9);\n        fill: rgba($white, 0.9);\n        height: 34px;\n        line-height: 1;\n        text-align: center;\n        position: relative;\n        user-select: none;\n        overflow: hidden;\n        flex: 1;\n    }\n\n    .flatpickr-prev-month,\n    .flatpickr-next-month {\n        text-decoration: none;\n        cursor: pointer;\n        position: absolute;\n        top: 0;\n        height: 34px;\n        padding: 10px;\n        z-index: 3;\n        color: rgba($white, 0.9);\n        fill: rgba($white, 0.9);\n\n        &.flatpickr-disabled{\n          display: none;\n        }\n\n        i {\n            position: relative;\n        }\n\n        &.flatpickr-prev-month {\n            /*\n                  /*rtl:begin:ignore*/\n            /*\n                  */\n              left: 0;\n            /*\n                  /*rtl:end:ignore*/\n            /*\n                  */\n        }\n          /*\n        /*rtl:begin:ignore*/\n        /*\n        /*rtl:end:ignore*/\n\n        &.flatpickr-next-month {\n            /*\n                  /*rtl:begin:ignore*/\n            /*\n                  */\n              right: 0;\n            /*\n                  /*rtl:end:ignore*/\n            /*\n                  */\n        }\n          /*\n        /*rtl:begin:ignore*/\n        /*\n        /*rtl:end:ignore*/\n\n        &:hover {\n            color: #959ea9;\n\n            svg {\n                fill: rgba($white, 0.9);\n            }\n        }\n\n        svg {\n            width: 14px;\n            height: 14px;\n\n            path {\n                transition: fill 0.1s;\n                fill: inherit;\n            }\n        }\n    }\n}\n\n.numInputWrapper {\n    position: relative;\n    height: auto;\n\n    input,\n    span {\n        display: inline-block;\n    }\n\n    input {\n        width: 100%;\n\n        &::-ms-clear {\n            display: none;\n        }\n\n        &::-webkit-outer-spin-button,\n        &::-webkit-inner-spin-button {\n            margin: 0;\n            -webkit-appearance: none;\n        }\n    }\n\n    span {\n        position: absolute;\n        right: 0;\n        width: 14px;\n        padding: 0 4px 0 2px;\n        height: 50%;\n        line-height: 50%;\n        opacity: 0;\n        cursor: pointer;\n        border: 1px solid rgba(var(--#{$prefix}dark-rgb),0.15);\n        box-sizing: border-box;\n\n        &:hover {\n            background: rgba(0,0,0,0.1);\n        }\n\n        &:active {\n            background: rgba(0,0,0,0.2);\n        }\n\n        &:after {\n            display: block;\n            content: \"\";\n            position: absolute;\n        }\n\n        &.arrowUp {\n            top: 0;\n            border-bottom: 0;\n\n            &:after {\n                border-left: 4px solid transparent;\n                border-right: 4px solid transparent;\n                border-bottom: 4px solid rgba(57,57,57,0.6);\n                top: 26%;\n            }\n        }\n\n        &.arrowDown {\n            top: 50%;\n\n            &:after {\n                border-left: 4px solid transparent;\n                border-right: 4px solid transparent;\n                border-top: 4px solid rgba(57,57,57,0.6);\n                top: 40%;\n            }\n        }\n\n        svg {\n            width: inherit;\n            height: auto;\n\n            path {\n                fill: rgba(0,0,0,0.5);\n            }\n        }\n    }\n\n\n    &:hover {\n        background: rgba(0,0,0,0.05);\n        span {\n            opacity: 1;\n        }\n    }\n}\n\n.flatpickr-current-month {\n    font-size: 100%;\n    line-height: inherit;\n    font-weight: 300;\n    color: inherit;\n    position: absolute;\n    width: 75%;\n    left: 12.5%;\n    padding: 7.48px 0 0 0;\n    line-height: 1;\n    height: 34px;\n    display: inline-block;\n    text-align: center;\n    transform: translate3d(0px, 0px, 0px);\n\n    span.cur-month {\n        font-family: inherit;\n        font-weight: 700;\n        color: inherit;\n        display: inline-block;\n        margin-left: 0.5ch;\n        padding: 0;\n\n        &:hover {\n            background: rgba(0,0,0,0.05);\n        }\n    }\n\n    .numInputWrapper {\n        width: 6ch;\n        width: 7ch\\0;\n        display: inline-block;\n    }\n\n    span{\n        &.arrowUp::after {\n            border-bottom-color: rgba(0,0,0,0.9);\n        }\n        &.arrowDown:after {\n            border-top-color: rgba(0,0,0,0.9);\n        }\n    }\n\n    input.cur-year {\n        background: transparent;\n        box-sizing: border-box;\n        color: inherit;\n        cursor: text;\n        padding: 0 0 0 0.5ch;\n        margin: 0;\n        display: inline-block;\n        font-size: inherit;\n        font-family: inherit;\n        font-weight: $font-weight-semibold;\n        line-height: inherit;\n        height: auto;\n        border: 0;\n        border-radius: 0;\n        vertical-align: initial;\n        appearance: textfield;\n\n        &:focus {\n            outline: 0;\n        }\n\n        &[disabled],\n        &[disabled]:hover {\n            font-size: 100%;\n            color: rgba($white, 0.9);\n            background: transparent;\n            pointer-events: none;\n        }\n    }\n\n    .flatpickr-monthDropdown-months {\n        appearance: menulist;\n        background: transparent;\n        border: none;\n        border-radius: 0;\n        box-sizing: border-box;\n        color: inherit;\n        cursor: pointer;\n        font-size: inherit;\n        font-family: inherit;\n        font-weight: $font-weight-semibold;\n        height: auto;\n        line-height: inherit;\n        margin: -1px 0 0 0;\n        outline: none;\n        padding: 0 0 0 0.5ch;\n        position: relative;\n        vertical-align: initial;\n        width: auto;\n\n        &:focus,\n        &:active {\n            outline: none;\n        }\n\n        &:hover {\n            background-color: transparent;\n        }\n\n        .flatpickr-monthDropdown-month {\n            background-color: transparent;\n            outline: none;\n            padding: 0;\n            color: rgba($black, 0.8);\n        }\n    }\n}\n\n\n.flatpickr-weekdays {\n    background-color: $primary;\n    text-align: center;\n    overflow: hidden;\n    width: 100%;\n    display: flex;\n    align-items: center;\n    height: 36px;\n    border-bottom: 1px solid $border-color;\n    .flatpickr-weekdaycontainer {\n        display: flex;\n        flex: 1;\n    }\n}\n\nspan.flatpickr-weekday {\n    cursor: default;\n    font-size: 90%;\n    background: $primary;\n    color: $white;\n    line-height: 1;\n    margin: 0;\n    text-align: center;\n    display: block;\n    flex: 1;\n    font-weight: $font-weight-medium;\n}\n\n.dayContainer,\n.flatpickr-weeks {\n    padding: 1px 0 0 0;\n}\n.flatpickr-days {\n    position: relative;\n    overflow: hidden;\n    display: flex;\n    align-items: flex-start;\n    width: 307.875px;\n    &:focus {\n        outline: 0;\n    }\n}\n\n.dayContainer {\n    padding: 0;\n    outline: 0;\n    text-align: left;\n    width: 307.875px;\n    min-width: 307.875px;\n    max-width: 307.875px;\n    box-sizing: border-box;\n    display: inline-block;\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: space-around;\n    transform: translate3d(0px, 0px, 0px);\n    opacity: 1;\n    + .dayContainer {\n        box-shadow: -1px 0 0 #e6e6e6;\n    }\n}\n\n.flatpickr-day {\n    background: none;\n    border: 1px solid transparent;\n    border-radius: 150px;\n    box-sizing: border-box;\n    color: var(--#{$prefix}body-color);\n    cursor: pointer;\n    font-weight: 400;\n    width: 14.2857143%;\n    flex-basis: 14.2857143%;\n    max-width: 39px;\n    height: 39px;\n    line-height: 39px;\n    margin: 0;\n    display: inline-block;\n    position: relative;\n    justify-content: center;\n    text-align: center;\n\n    &:hover,\n    &:focus {\n        background-color: rgba(var(--#{$prefix}light-rgb), 0.7);\n    }\n\n    &.inRange,\n    &.prevMonthDay.inRange,\n    &.nextMonthDay.inRange,\n    &.today.inRange,\n    &.prevMonthDay.today.inRange,\n    &.nextMonthDay.today.inRange,\n    &:hover,\n    &.prevMonthDay:hover,\n    &.nextMonthDay:hover,\n    &:focus,\n    &.prevMonthDay:focus,\n    &.nextMonthDay:focus {\n        cursor: pointer;\n        outline: 0;\n        background-color: var(--#{$prefix}light);\n        border-color: var(--#{$prefix}light);\n    }\n\n    &.today {\n        border-color: $primary;\n        background-color: rgba($primary, 0.1);\n        box-shadow: $element-shadow;\n\n        &:hover,\n        &:focus {\n            border-color: $primary;\n            background-color: rgba($primary, 0.15);\n            color: var(--#{$prefix}dark);\n        }\n    }\n\n    &.selected,\n    &.startRange,\n    &.endRange,\n    &.selected.inRange,\n    &.startRange.inRange,\n    &.endRange.inRange,\n    &.selected:focus,\n    &.startRange:focus,\n    &.endRange:focus,\n    &.selected:hover,\n    &.startRange:hover,\n    &.endRange:hover,\n    &.selected.prevMonthDay,\n    &.startRange.prevMonthDay,\n    &.endRange.prevMonthDay,\n    &.selected.nextMonthDay,\n    &.startRange.nextMonthDay,\n    &.endRange.nextMonthDay {\n        background: $primary;\n        box-shadow: $element-shadow;\n        color: $white;\n        border-color: $primary;\n    }\n\n    &.selected,\n    &.startRange,\n    &.endRange{\n        &.startRange {\n            border-radius: 50px 0 0 50px;\n            + .endRange:not(:nth-child(7n+1)) {\n                box-shadow: -10px 0 0 $primary;\n            }\n\n            .endRange{\n                border-radius: 50px;\n            }\n        }\n    }\n\n    &.selected,\n    &.startRange,\n    &.endRange{\n        &.endRange {\n            border-radius: 0 50px 50px 0;\n        }\n    }\n\n    &.inRange {\n        border-radius: 0;\n        box-shadow: -5px 0 0 var(--#{$prefix}light), 5px 0 0 var(--#{$prefix}light);\n    }\n\n    &.flatpickr-disabled,\n    &.flatpickr-disabled:hover,\n    &.prevMonthDay,\n    &.nextMonthDay,\n    &.notAllowed,\n    &.notAllowed.prevMonthDay,\n    &.notAllowed.nextMonthDay {\n        color: rgba(var(--#{$prefix}body-color-rgb),0.3);\n        background: transparent;\n        border-color: transparent;\n        cursor: default;\n    }\n\n    &.flatpickr-disabled,\n    &.flatpickr-disabled:hover {\n        cursor: not-allowed;\n        color: rgba(var(--#{$prefix}body-color-rgb),0.3);\n    }\n\n    &.week.selected {\n        border-radius: 0;\n        box-shadow: -5px 0 0 $primary, 5px 0 0 $primary;\n    }\n\n    &.hidden {\n        visibility: hidden;\n    }\n}\n\n.rangeMode .flatpickr-day {\n    margin-top: 1px;\n}\n\n.flatpickr-weekwrapper {\n    float: left;\n    .flatpickr-weeks {\n        padding: 0 12px;\n        box-shadow: 1px 0 0 #e6e6e6;\n    }\n\n    .flatpickr-weekday {\n        float: none;\n        width: 100%;\n        line-height: 35px;\n    }\n\n    span{\n        &.flatpickr-day,\n        &.flatpickr-day:hover {\n            display: block;\n            width: 100%;\n            max-width: none;\n            color: rgba(var(--#{$prefix}dark-rgb),0.3);\n            background: transparent;\n            cursor: default;\n            border: none;\n        }\n    }\n}\n\n\n.flatpickr-innerContainer {\n    display: block;\n    display: flex;\n    box-sizing: border-box;\n    overflow: hidden;\n}\n\n.flatpickr-rContainer {\n    display: inline-block;\n    padding: 0;\n    box-sizing: border-box;\n}\n\n.flatpickr-time {\n    text-align: center;\n    outline: 0;\n    display: block;\n    height: 0;\n    line-height: 40px;\n    max-height: 40px;\n    box-sizing: border-box;\n    overflow: hidden;\n    display: flex;\n\n    &:after {\n        content: \"\";\n        display: table;\n        clear: both;\n    }\n    .numInputWrapper {\n        flex: 1;\n        width: 40%;\n        height: 40px;\n        float: left;\n        span{\n            &.arrowUp, &.arrowDown{\n                &:after {\n                    border-bottom-color: $border-color;\n                }\n            }\n        }\n    }\n\n    &.hasSeconds .numInputWrapper {\n        width: 26%;\n    }\n\n    &.time24hr .numInputWrapper {\n        width: 49%;\n    }\n\n\n    input {\n        background: transparent;\n        box-shadow: none;\n        border: 0;\n        border-radius: 0;\n        text-align: center;\n        margin: 0;\n        padding: 0;\n        height: inherit;\n        line-height: inherit;\n        color: var(--#{$prefix}body-color);\n        font-size: 14px;\n        position: relative;\n        box-sizing: border-box;\n        appearance: textfield;\n\n        &.flatpickr-hour {\n            font-weight: bold;\n        }\n\n        &.flatpickr-minute,\n        &.flatpickr-second {\n          font-weight: 400;\n        }\n\n        &:focus {\n            outline: 0;\n            border: 0;\n        }\n    }\n\n\n    .flatpickr-time-separator,\n    .flatpickr-am-pm {\n        height: inherit;\n        float: left;\n        line-height: inherit;\n        color: var(--#{$prefix}body-color);\n        font-weight: bold;\n        width: 2%;\n        user-select: none;\n        align-self: center;\n    }\n\n    .flatpickr-am-pm {\n        outline: 0;\n        width: 18%;\n        cursor: pointer;\n        text-align: center;\n        font-weight: 400;\n    }\n\n    input, .flatpickr-am-pm{\n        &:hover, &:focus{\n            background: rgba($primary, 0.04);\n        }\n    }\n}\n\n.flatpickr-am-pm,\n.numInput,\n.numInputWrapper {\n    &:focus,\n    &:hover {\n        background-color: transparent;\n    }\n}\n\n.flatpickr-input[readonly] {\n    cursor: pointer;\n    background-color: $input-bg;\n}\n\n[data-inline-date=\"true\"],[data-time-inline] {\n    display: none;\n}\n\n@keyframes fpFadeInDown {\n    from {\n        opacity: 0;\n        transform: translate3d(0, -20px, 0);\n    }\n    to {\n        opacity: 1;\n        transform: translate3d(0, 0, 0);\n    }\n}\n  \n[datepicker-inline],\n[timepicker-inline] {\n    display: none;\n}","// flag input\n\n[data-input-flag] {\n    position: relative;\n\n    .dropdown-menu {\n        .dropdown-menu-list {\n            max-height: 158px;\n            overflow-y: auto;\n\n            &::-webkit-scrollbar {\n                -webkit-appearance: none;\n            }\n\n            &::-webkit-scrollbar:vertical {\n                width: 8px;\n            }\n\n            &::-webkit-scrollbar:horizontal {\n                height: 10px;\n            }\n\n            &::-webkit-scrollbar-thumb {\n                background-color: rgba(var(--#{$prefix}dark-rgb), .075);\n                border-radius: 8px;\n            }\n\n            &::-webkit-scrollbar-track {\n                border-radius: 8px;\n            }\n        }\n    }\n}\n\n[data-option-flag-img-name] {\n    .flag-input {\n        padding-left: 45px;\n        background-image: url(\"../../images/flags/us.svg\");\n        background-repeat: no-repeat;\n        background-position: 14px 8px;\n        background-size: 18px;\n    }\n}\n\n[data-option-flag-name],\n[data-option-flag-img-name] {\n    &::before {\n        content: \"\\f0140\";\n        font-family: \"Material Design Icons\";\n        position: absolute;\n        right: $input-padding-x;\n        top: $input-padding-y;\n        font-size: 16px;\n    }\n}\n\n[data-option-countrycode=\"false\"] {\n    .country-codeno {\n        display: none;\n    }\n}\n\n[data-search-input=\"false\"] {\n    .searchlist-input {\n        display: none;\n    }\n}","//\n// _authentication.scss\n//\n\n\n.auth-page-wrapper{\n    .auth-page-content{\n        padding-bottom: $footer-height;\n        position: relative;\n        z-index: 2;\n        width: 100%;\n    }\n    .footer{\n        left: 0;\n        background-color: transparent;\n        color: var(--#{$prefix}body-color);\n    }\n}\n\n.auth-one-bg-position{\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    width: 100%;\n    height: 580px;\n    \n    @media (max-width: 575.98px) {\n        height: 280px;\n    }\n}\n\n.auth-one-bg{\n    background-image: url(\"../../images/kuzelogo.jpeg\");\n    background-size: cover;\n\n    .bg-overlay{\n        background: linear-gradient(to right, darken($primary, 6%), $primary);\n        opacity: 0.1;\n    }\n}\n\n.shape{\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    left: 0;\n    z-index: 1;\n    pointer-events: none;\n    >svg {\n        width: 100%;\n        height: auto;\n        fill: var(--#{$prefix}body-bg);\n    }\n}\n\n// auth-pass-inputgroup\n\n.auth-pass-inputgroup{\n    input[type=\"text\"] + .btn .ri-eye-fill{\n        &:before{\n            content: \"\\ecb6\";\n        }\n    }\n}\n\n.particles-js-canvas-el{\n    position: relative;\n}\n\n// signin card title\n\n.signin-other-title{\n    position: relative;\n    &:after{\n        content: \"\";\n        position: absolute;\n        width: 100%;\n        height: 1px;\n        left: 0;\n        right: 0;\n        border-top: 1px dashed var(--#{$prefix}border-color);\n        top: 10px;\n    }\n\n    .title{\n        display: inline-block;\n        position: relative;\n        z-index: 9;\n        background-color: var(--#{$prefix}card-bg-custom);\n        padding: 2px 16px;\n    }\n}\n\n// Auth cover\n\n.auth-bg-cover{\n    background: $auth-bg-cover;\n\n    > .bg-overlay{\n        background-image: url(\"../../images/cover-pattern.png\");\n        background-position: center;\n        background-size: cover;\n        opacity: 1;\n        background-color: transparent;\n    }\n\n    .footer{\n        color: rgba($white, .5);\n    }\n}\n\n//passowrd validations \n#password-contain {\n    display: none;\n\n    p {\n        padding-left: 13px;\n\n        &.valid {\n            color: $success;\n\n            &::before {\n                position: relative;\n                left: -8px;\n                content: \"✔\";\n            }\n        }\n\n        &.invalid {\n            color: $danger;\n\n            &::before {\n                position: relative;\n                left: -8px;\n                content: \"✖\";\n            }\n        }\n    }\n}","//\n// _dashboard.scss\n//\n\n.dash-filter-picker {\n  min-width: 210px !important;\n}\n\n// Flatpickr Calendar\n\n.upcoming-scheduled {\n  position: relative;\n  @media (max-width: 575.98px) {\n    top: 35px !important;\n  }\n  .flatpickr-months {\n    position: absolute !important;\n    top: -45px !important;\n    left: auto !important;\n    right: 0px !important;\n    width: 200px;\n    background-color: transparent;\n\n    .flatpickr-month {\n      color: $gray-600 !important;\n      fill: $gray-600 !important;\n    }\n    .flatpickr-prev-month,\n    .flatpickr-next-month {\n      display: none;\n    }\n  }\n  .flatpickr-calendar {\n    box-shadow: none !important;\n    .flatpickr-current-month {\n      font-size: 13px;\n      width: 100%;\n      left: 0;\n    }\n    .flatpickr-monthDropdown-months {\n      border: 1px solid $border-color;\n      border-radius: 4px;\n      height: 26px;\n    }\n    .flatpickr-weekdays {\n      background-color: var(--#{$prefix}light);\n      border: none;\n      span.flatpickr-weekday {\n        color: var(--#{$prefix}dark);\n        background-color: var(--#{$prefix}light);\n      }\n    }\n    .flatpickr-day {\n      &.today {\n        color: $white !important;\n        background-color: $success;\n        border-color: $success !important;\n        &:hover {\n          color: $success !important;\n          background-color: rgba($success, 0.2) !important;\n        }\n      }\n      &.selected {\n        background-color: $success !important;\n        border-color: $success !important;\n        color: $white;\n      }\n    }\n    .numInputWrapper {\n      width: 7.5ch;\n      margin-left: 10px;\n    }\n  }\n\n  .flatpickr-days {\n    border: none !important;\n  }\n}\n\n.crm-widget {\n  .col {\n    border-right: 1px solid $border-color;\n    &:last-child {\n      border: 0px;\n    }\n    @media (min-width: 768px) and (max-width: 1399.98px) {\n      &:nth-child(3) {\n        border-right: 0px;\n      }\n      &:last-child {\n        border-right: 1px solid $border-color;\n      }\n    }\n    @media (max-width: 767.98px) {\n      border-right: 0px;\n      border-bottom: 1px solid $border-color;\n    }\n  }\n}\n\n@media (min-width: 1400px) and (max-width: 1599.98px) {\n  .project-wrapper {\n    > .col-xxl-8,\n    .col-xxl-4 {\n      width: 100%;\n    }\n  }\n}\n\n.crypto-widget {\n  max-width: 130px !important;\n}\n\n//nft dashboard\n\n.bg-marketplace {\n  background-image: url(../../images/nft/marketplace.png);\n  background-size: cover;\n}\n\n.dash-countdown {\n  .countdownlist {\n    .count-num {\n      background-color: var(--#{$prefix}card-bg-custom);\n      padding: 16px 8px;\n      font-size: 22px;\n\n      @media (max-width: 575.98px) {\n        font-size: 16px;\n        padding: 8px 6px;\n      }\n    }\n\n    .count-title {\n      @media (max-width: 575.98px) {\n        font-size: 10px;\n      }\n    }\n  }\n}\n\n.marketplace-icon {\n  position: absolute;\n  float: right;\n  top: 30px;\n  left: 30px;\n}\n\n.marketplace-swiper {\n  .swiper-button-next,\n  .swiper-button-prev {\n    top: 34px;\n    width: 28px;\n    height: 28px;\n    background-color: rgba($primary, 0.1);\n    color: $primary;\n    border-radius: 0.3rem;\n    right: 16px !important;\n  }\n  .swiper-button-prev {\n    right: 58px !important;\n    left: auto !important;\n  }\n}\n\n.dash-collection {\n  .content {\n    background-color: rgba($white, 0.25);\n    backdrop-filter: blur(5px);\n  }\n}\n\n.dash-nft {\n  @media (max-width: 1441.98px) {\n    .col-xxl-9,\n    .col-xxl-3 {\n      width: 100% !important;\n      max-width: 100% !important;\n    }\n  }\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {\n  width: 32px;\n  height: 32px;\n  display: inline-block;\n  vertical-align: middle;\n}\n","//\n// _timeline.scss\n//\n\n.timeline {\n  position: relative;\n  width: 100%;\n  max-width: 1400px;\n  margin: 0 auto;\n\n  &::after {\n    content: \"\";\n    position: absolute;\n    width: 2px;\n    background: $timeline-color;\n    top: 57px;\n    bottom: 166px;\n    left: 50%;\n    margin-left: -1.5px;\n  }\n}\n\n.timeline-item {\n  padding: 30px 60px;\n  position: relative;\n  background: inherit;\n  width: 50%;\n\n  .icon {\n    position: absolute;\n    display: inline-flex;\n    width: 60px;\n    height: 60px;\n    align-items: center;\n    justify-content: center;\n    font-size: 25px;\n    top: 30px;\n    right: -30px;\n    padding: 9px 0;\n    background: var(--#{$prefix}card-bg-custom);\n    border: 1px solid $border-color;\n    border-radius: 50px;\n    color: $success;\n    z-index: 1;\n  }\n\n  .date {\n    position: absolute;\n    display: inline-block;\n    width: calc(100% - 48px);\n    top: 50px;\n    font-size: 14px;\n    font-weight: 500;\n    font-style: italic;\n  }\n\n  .content {\n    padding: 20px;\n    background: var(--#{$prefix}card-bg-custom);\n    position: relative;\n    border: 1px solid $border-color;\n    border-radius: $border-radius;\n    box-shadow: $box-shadow-sm;\n  }\n\n  &.left {\n    left: 0;\n\n    .date {\n      left: calc(100% + 48px);\n      text-align: start;\n    }\n  }\n\n  &.right {\n    left: 50%;\n\n    .icon {\n      left: -30px;\n    }\n\n    .date {\n      right: calc(100% + 48px);\n      text-align: end;\n    }\n\n    &::before {\n      left: 28px;\n      border-color: transparent transparent transparent $white;\n    }\n  }\n}\n\n@media (max-width: 991.98px) {\n  .timeline {\n    &::after {\n      left: 24px;\n      bottom: 180px;\n    }\n  }\n\n  .timeline-item {\n    width: 100%;\n    padding-left: 48px;\n    padding-right: 0px;\n\n    &.right,\n    &.left {\n      left: 0%;\n\n      .icon {\n        width: 45px;\n        height: 45px;\n        top: 0;\n        font-size: 18px;\n        left: 0;\n      }\n\n      &::before {\n        left: 110px;\n        border-color: transparent transparent transparent $border-color;\n      }\n\n      .date {\n        right: auto;\n        left: 48px;\n        width: 79px;\n        top: 8px;\n        text-align: left;\n      }\n    }\n  }\n}\n\n.timeline-2 {\n  position: relative;\n\n  &::after {\n    position: absolute;\n    content: \"\";\n    width: 2px;\n    height: 83%;\n    top: 50px;\n    left: 40px;\n    margin-left: -1px;\n    background: $timeline-color;\n  }\n\n  .timeline-year {\n    position: relative;\n    width: 100%;\n    text-align: left;\n    z-index: 1;\n\n    p {\n      display: inline-flex;\n      width: 80px;\n      height: 80px;\n      margin: 0;\n      padding: 23px 10px;\n      background: $timeline-color;\n      border-radius: 50px;\n      text-transform: uppercase;\n      align-items: center;\n      justify-content: center;\n      text-align: center;\n      span {\n        display: -webkit-box;\n        -webkit-line-clamp: 2;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        text-overflow: ellipsis;\n      }\n    }\n  }\n\n  .timeline-date {\n    font-size: 14px;\n    font-weight: $font-weight-medium;\n    margin: 24px 0 0 0;\n    margin-left: 55px;\n\n    &::after {\n      content: \"\";\n      display: block;\n      position: absolute;\n      width: 14px;\n      height: 14px;\n      top: 26px;\n      left: 45px;\n      align-items: left;\n      background: $success;\n      border: 3px solid $timeline-color;\n      border-radius: 50px;\n      z-index: 1;\n    }\n  }\n\n  .timeline-box {\n    position: relative;\n    display: inline-block;\n    margin: 23px 62px;\n    padding: 20px;\n    border: 1px solid $border-color;\n    border-radius: 6px;\n    background: var(--#{$prefix}card-bg-custom);\n    max-width: 695px;\n    @media (max-width: 991.98px) {\n      margin-right: 0;\n    }\n\n    &::after {\n      content: \"\";\n      display: block;\n      position: absolute;\n      width: 0;\n      height: 0;\n      border-style: solid;\n      top: 26px;\n      right: 100%;\n      border-color: transparent var(--#{$prefix}card-bg-custom) transparent\n        transparent;\n      border-width: 10px;\n    }\n\n    &::before {\n      content: \"\";\n      display: block;\n      position: absolute;\n      width: 0;\n      height: 0;\n      border-style: solid;\n      right: 100%;\n      top: 24px;\n      border-color: transparent $border-color transparent transparent;\n      border-width: 12px;\n    }\n\n    .timeline-text {\n      position: relative;\n      float: left;\n    }\n  }\n\n  .timeline-launch {\n    position: relative;\n    display: inline-block;\n    border: 1px solid $border-color;\n    border-radius: 6px;\n    background: $white;\n    width: 100%;\n    margin-top: 15px;\n    padding: 0;\n    border: none;\n    text-align: left;\n    background: transparent;\n\n    .timeline-box {\n      margin-left: 0;\n\n      &::after {\n        left: 30px;\n        margin-left: 0px;\n        top: -20px;\n        border-color: transparent transparent $border-color transparent;\n      }\n\n      &::before {\n        left: 30px;\n        margin-left: 0px;\n        top: -19px;\n        border-color: transparent transparent var(--#{$prefix}card-bg-custom)\n          transparent;\n        border-width: 10px;\n        z-index: 1;\n      }\n    }\n  }\n}\n\n// Horizontal Timeline\n.horizontal-timeline {\n  position: relative;\n  width: 100%;\n  margin: 0 auto;\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    width: 100%;\n    top: 174px;\n    left: 0;\n    height: 2px;\n    background-color: $timeline-color;\n  }\n\n  .swiper-slide {\n    .item-box {\n      margin: 227px 0px 0px;\n      background-color: transparent;\n      box-shadow: none;\n\n      &::after {\n        content: \"\";\n        position: absolute;\n        left: 0px;\n        right: 0px;\n        margin: 0px auto;\n        background: $primary;\n        width: 13px;\n        height: 13px;\n        top: -59px;\n        border-radius: 50px;\n        border: 3px solid $timeline-color;\n      }\n    }\n\n    .timeline-content {\n      min-height: 110px;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      position: relative;\n      background-color: $timeline-color;\n\n      &::before {\n        content: \"\";\n        display: block;\n        position: absolute;\n        width: 0;\n        height: 0;\n        border-style: solid;\n        left: 0px;\n        top: -23px;\n        border-color: transparent transparent $timeline-color transparent;\n        border-width: 12px;\n        right: 0;\n        margin: 0 auto;\n      }\n    }\n\n    .time {\n      position: absolute;\n      top: -86px;\n      right: 0px;\n      left: 0px;\n      margin: 0px auto;\n    }\n\n    &:nth-child(even) {\n      margin-top: 5px;\n      transform: rotate(-180deg);\n\n      .timeline-content {\n        transform: rotate(180deg);\n\n        &::before {\n          bottom: -23px;\n          top: auto;\n          border-color: $timeline-color transparent transparent transparent;\n        }\n      }\n\n      .time {\n        transform: rotate(180deg);\n      }\n    }\n  }\n\n  .swiper-button-next,\n  .swiper-button-prev {\n    height: 40px;\n    width: 40px;\n    line-height: 40px;\n    border-radius: 50%;\n    background-color: lighten($primary, 2.5%);\n\n    &::after {\n      font-size: 24px;\n      color: $white;\n    }\n    &.swiper-button-disabled {\n      background-color: rgba($primary, 0.5);\n      opacity: 1;\n      cursor: auto;\n      backdrop-filter: blur(25px);\n      pointer-events: none;\n    }\n  }\n\n  .swiper-button-next {\n    right: 0;\n\n    &::after {\n      content: \"\\EA6E\";\n      font-family: remixicon;\n    }\n  }\n\n  .swiper-button-prev {\n    left: 0;\n\n    &::after {\n      content: \"\\EA64\";\n      font-family: remixicon;\n    }\n  }\n}\n\n//activity-timeline\n\n.acitivity-timeline {\n  position: relative;\n  overflow: hidden;\n\n  .acitivity-item {\n    position: relative;\n\n    .flex-shrink-0 {\n      z-index: 2;\n    }\n\n    .acitivity-avatar {\n      background-color: var(--#{$prefix}card-bg-custom);\n      border: 3px solid var(--#{$prefix}card-bg-custom);\n      height: 32px;\n      width: 32px;\n    }\n\n    &:before {\n      content: \"\";\n      position: absolute;\n      border-left: 1px dashed $border-color;\n      left: 16px;\n      height: 100%;\n      top: 5px;\n      z-index: 0;\n    }\n    &:last-child {\n      &::before {\n        border-color: transparent;\n      }\n    }\n  }\n}\n","    //\n// _gallery.scss\n//\n\n.categories-filter {\n    .list-inline-item {\n        position: relative;\n        margin-right: 0;\n\n        a {\n            display: block;\n            color: var(--#{$prefix}body-color);\n            font-weight: $font-weight-semibold;\n            padding: 8px 15px;\n            margin: 5px;\n            cursor: pointer;\n        }\n    }\n}\n\n.gallery-box {\n    position: relative;\n    overflow: hidden;\n    border: 1px solid transparent;\n    margin-bottom: 10px;\n    box-shadow: none;\n    background-color: transparent;\n    padding: 8px;\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        width: 100%;\n        height: 0;\n        background-color: var(--#{$prefix}card-bg-custom);\n        transition: all 0.4s;\n    }\n\n    .gallery-container {\n        position: relative;\n        overflow: hidden;\n        border-radius: 4px;\n\n        a {\n            display: block;\n        }\n\n        .gallery-overlay {\n            position: absolute;\n            top: 0px;\n            left: 0px;\n            bottom: 0px;\n            right: 0px;\n            opacity: 0;\n            background: linear-gradient(180deg, rgba(0, 0, 0, 0) 10%, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, .5) 100%);\n            visibility: hidden;\n            overflow: hidden;\n            transition: all 0.4s ease-in-out 0s;\n            display: flex;\n            width: 100%;\n            align-items: flex-end;\n            padding: 16px;\n\n            .overlay-caption {\n                color: $white;\n                margin: 0;\n                font-size: 16px;\n            }\n        }\n    }\n\n    .gallery-img {\n        transition: all 0.2s ease-in-out;\n    }\n\n    .box-content {\n        position: relative;\n\n        .title {\n            font-size: 14px;\n            margin-bottom: 4px;\n            display: none;\n        }\n\n        .post {\n            margin: 0;\n            transition: all 0.2s;\n            color: $text-muted;\n        }\n    }\n\n    &:hover {\n        &::before {\n            height: 100%;\n        }\n\n        .box-content {\n            bottom: 0;\n\n            .post {\n                opacity: 1;\n            }\n        }\n\n        .gallery-overlay {\n            opacity: 1;\n            visibility: visible;\n        }\n    }\n}\n\n.gallery-light {\n    .gallery-box {\n        &::before {\n            background-color: var(--#{$prefix}light);\n        }\n    }\n}","//\n// _errors.scss\n//\n\n.error-basic-img{\n    max-width: 450px;\n}\n\n.error-500 {\n    .title {\n        font-size: 250px;\n    }\n\n    .error-500-img {\n        position: absolute;\n        top: 57px;\n        left: 0;\n        right: 0;\n        margin: 0 auto;\n    }\n\n    @media (min-width: 768px) and (max-width: 991.98px) {\n        .title {\n            font-size: 150px;\n        }\n\n        .error-500-img {\n            width: 20% !important;\n            top: 43px;\n        }\n    }\n\n    @media (max-width: 767.98px) {\n        .title {\n            font-size: 68px;\n            margin-top: 35px;\n        }\n\n        .error-500-img {\n            position: relative;\n            top: 0px;\n        }\n    }\n}\n\n\n@keyframes errorAnimation {\n    0% {\n        transform: translateX(0%);\n    }\n\n    15% {\n        transform: translateX(-25%) rotate(-5deg);\n    }\n\n    30% {\n        transform: translateX(20%) rotate(3deg);\n    }\n\n    45% {\n        transform: translateX(-15%) rotate(-3deg);\n    }\n\n    60% {\n        transform: translateX(10%) rotate(2deg);\n    }\n\n    75% {\n        transform: translateX(-5%) rotate(-1deg);\n    }\n\n    100% {\n        transform: translateX(0%);\n    }\n}\n\n.error-img {\n    animation: errorAnimation 20s infinite;\n}","//\n// _profile.scss\n//\n\n.error-text {\n    text-shadow: 4px 4px rgba($success, 0.4);\n\n    @media (min-width: 1200px) {\n        font-size: 10rem;\n    }\n}\n\n\n// profile\n\n.profile-wid-bg {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    height: 320px;\n    @media (max-width: 575.98px) {\n        height: 445px;\n    }\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        opacity: 0.9;\n        background: $primary;\n        background: linear-gradient(to top, darken($primary, 25%), $primary);\n\n    }\n\n    .profile-wid-img {\n        width: 100%;\n        height: 100%;\n        object-fit: cover;\n    }\n}\n\n.profile-nav {\n    &.nav-pills {\n        .nav-link {\n            color: rgba($white, 0.8);\n\n            &::before {\n                background-color: rgba($white, 0.1);\n            }\n        }\n    }\n}\n\n.profile-project-card {\n    border: 1px solid $border-color;\n    border-left: 3px solid $border-color;\n}\n\n@each $color,\n$value in $theme-colors {\n    .profile-project-card {\n        &.profile-project-#{$color} {\n            border-left-color: $value;\n        }\n    }\n}\n\n.user-profile-img {\n    position: relative;\n\n    .profile-img {\n        width: 100%;\n        height: 250px;\n        object-fit: cover;\n\n        @media (max-width:991px) {\n            height: 160px;\n        }\n    }\n\n    .profile-foreground-img-file-input {\n        display: none;\n    }\n\n    .profile-photo-edit {\n        cursor: pointer;\n    }\n}\n\n.profile-user {\n    position: relative;\n    display: inline-block;\n\n    .profile-photo-edit {\n        position: absolute;\n        right: 0;\n        left: auto;\n        bottom: 0;\n        cursor: pointer;\n    }\n\n    .user-profile-image {\n        object-fit: cover;\n    }\n\n    .profile-img-file-input {\n        display: none;\n    }\n}\n\n.profile-timeline {\n    .accordion-item {\n        position: relative;\n\n        .accordion-button {\n            background-color: transparent;\n\n            &::after {\n                background: none;\n            }\n        }\n\n        &::before {\n            content: \"\";\n            border-left: 2px dashed $border-color;\n            position: absolute;\n            height: 100%;\n            left: 23px;\n        }\n\n        &:first-child {\n            &::before {\n                top: 8px;\n            }\n        }\n\n        &:last-child {\n            &::before {\n                height: 20px;\n                top: 3px;\n            }\n        }\n    }\n}\n\n.profile-setting-img {\n    position: relative;\n    height: 260px;\n\n    .overlay-content {\n        content: \"\";\n        position: absolute;\n        top: 0;\n        right: 0;\n    }\n\n    .profile-img {\n        width: 100%;\n        height: 250px;\n        object-fit: cover;\n\n        @media (max-width:991.98px) {\n            height: 160px;\n        }\n    }\n\n    .profile-foreground-img-file-input {\n        display: none;\n    }\n\n    .profile-photo-edit {\n        cursor: pointer;\n    }\n}\n\n@media (max-width:575.98px) {\n\n    [data-layout=\"horizontal\"]{\n        .profile-foreground{\n            margin-top: 0 !important;\n        }\n    }\n}\n\n[data-layout=\"semibox\"] {\n    .profile-wrapper {\n        padding: 0 $card-spacer-x;\n    }\n}","//\n// _sitemap.scss\n//\n\n.sitemap-content {\n    width: 100%;\n    max-width: 1142px;\n    margin: 0 auto;\n    padding: 0 20px;\n\n    * {\n        position: relative;\n    }\n}\n\n.sitemap-horizontal {\n    position: relative;\n\n    ul {\n        padding: 0;\n        margin: 0;\n        list-style: none;\n\n        a {\n            display: block;\n            background: var(--#{$prefix}light);\n            border: 2px solid var(--#{$prefix}card-bg-custom);\n            box-shadow: $box-shadow;\n            font-size: $font-size-base;\n            height: 60px;\n            padding: 8px;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            span {\n                display: -webkit-box;\n                -webkit-line-clamp: 2;\n                -webkit-box-orient: vertical;\n                overflow: hidden;\n                text-overflow: ellipsis;\n            }\n        }\n    }\n}\n\n.administration {\n    .director {\n        >li {\n            >a {\n                width: 50%;\n                margin: 0 auto 0px auto;\n                border-radius: 4px;\n            }\n        }\n    }\n\n    .subdirector {\n        position: absolute;\n        width: 100%;\n\n        &::after {\n            content: \"\";\n            display: block;\n            width: 0;\n            height: 130px;\n            border-left: 2px dashed $border-color;\n            left: 45.45%;\n            position: relative;\n        }\n\n        >li {\n            &:first-child {\n                width: 18.59%;\n                height: 64px;\n                margin: 0 auto 92px auto;\n                padding-top: 25px;\n                border-bottom: 2px dashed $border-color;\n                z-index: 1;\n                float: right;\n                right: 27.2%;\n                border-left: 2px dashed $border-color;\n\n                a {\n                    width: 100%;\n                    left: 25px;\n                }\n            }\n        }\n    }\n\n    @media screen and (max-width: 767px) {\n        .subdirector {\n            >li {\n                &:first-child {\n                    width: 40%;\n                    right: 10%;\n                    margin-right: 2px;\n                }\n            }\n\n            &::after {\n                left: 49.8%;\n            }\n        }\n    }\n}\n\n.departments {\n    width: 100%;\n\n    >li {\n        &:first-child {\n            width: 18.59%;\n            height: 64px;\n            margin: 0 auto 92px auto;\n            padding-top: 25px;\n            border-bottom: 2px dashed $border-color;\n            z-index: 1;\n            float: left;\n            left: 27%;\n\n            a {\n                width: 100%;\n                right: 25px;\n            }\n        }\n\n        &:nth-child(2) {\n            margin-left: 0;\n            clear: left;\n\n            &.department {\n                &:before {\n                    border: none;\n                }\n            }\n        }\n    }\n\n    &::after {\n        content: \"\";\n        display: block;\n        position: absolute;\n        width: 81.1%;\n        height: 22px;\n        border-top: 2px dashed $border-color;\n        border-right: 2px dashed $border-color;\n        border-left: 2px dashed $border-color;\n        margin: 0 auto;\n        top: 130px;\n        left: 9.1%\n    }\n\n    @media screen and (max-width: 767px) {\n        >li {\n            &:first-child {\n                width: 40%;\n                left: 10%;\n                margin-left: 2px;\n            }\n        }\n\n        &::after {\n            border-right: none;\n            left: 0;\n            width: 50%;\n        }\n    }\n}\n\n.department {\n    border-left: 2px dashed $border-color;\n    float: left;\n    margin-left: 1.75%;\n    margin-bottom: 60px;\n    width: 18.25%;\n\n    &::before {\n        content: \"\";\n        display: block;\n        position: absolute;\n        width: 0;\n        height: 22px;\n        border-left: 2px dashed $border-color;\n        z-index: 1;\n        top: -22px;\n        left: 50%;\n        margin-left: -4px;\n    }\n\n    >a {\n        margin: 0 0 -26px -4px;\n        z-index: 1;\n    }\n\n    ul {\n        margin-top: 0px;\n        margin-bottom: 0px;\n\n        li {\n            padding-left: 25px;\n            border-bottom: 2px dashed $border-color;\n            height: 80px;\n\n            a {\n                background: var(--#{$prefix}card-bg-custom);\n                margin-top: 48px;\n                position: absolute;\n                z-index: 1;\n                width: 90%;\n                height: 60px;\n                vertical-align: middle;\n                right: -1px;\n                text-align: center;\n            }\n        }\n    }\n\n    &:first-child {\n        margin-left: 0;\n        clear: left;\n    }\n\n    @media screen and (min-width: 768px) {\n        &:last-child:before {\n            border: none;\n        }\n    }\n\n    @media screen and (max-width: 767px) {\n        float: none;\n        width: 100%;\n        margin-left: 0;\n\n        &::before {\n            content: \"\";\n            display: block;\n            position: absolute;\n            width: 0;\n            height: 60px;\n            border-left: 2px dashed $white;\n            z-index: 1;\n            top: -60px;\n            left: 0%;\n            margin-left: -4px;\n        }\n\n        &:nth-child(2) {\n            &::before {\n                display: none;\n            }\n        }\n    }\n}\n\n\n\n// sitemap\n\n.hori-sitemap {\n    ul {\n        padding: 0;\n        padding-top: 10px;\n        text-align: center;\n        li {\n            position: relative;\n        }\n        @media (max-width: 575.98px) {\n            text-align: left;\n            .parent-title {\n                a {\n                    padding-left: 0;\n                    &:after {\n                        display: none;\n                    }\n                }\n\n                &:before {\n                    display: none;\n                }\n            }\n        }\n    }\n\n    @media (max-width: 575.98px) {\n        >ul {\n            position: relative;\n            li {\n                padding-top: 10px;\n                .second-list,\n                .sub-list {\n                    position: relative;\n\n                    &:before {\n                        content: \"\";\n                        height: calc(100% - 14px);\n                        border-right: 2px dashed $border-color;\n                        position: absolute;\n                        top: 0px;\n                        left: 0px;\n                    }\n                }\n                .sub-list {\n                    &:before {\n                        height: 38%;\n                    }\n                }\n                a {\n                    position: relative;\n                    padding: 4px 16px 4px 36px;\n\n                    &:after {\n                        content: \"\";\n                        width: 24px;\n                        border-top: 2px dashed $border-color;\n                        position: absolute;\n                        top: 50%;\n                        transform: translateY(-50%);\n                        left: 0;\n                    }\n                }\n\n                ul {\n                    margin-left: 36px;\n                }\n            }\n        }\n    }\n    @media (min-width: 576px) {\n        ul {\n            padding-top: 20px;\n            li {\n                padding-top: 30px;\n\n                &:before {\n                    content: \"\";\n                    height: 24px;\n                    width: 0;\n                    border-right: 2px dashed $border-color;\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    right: 0;\n                    margin: 0px auto;\n                }\n\n                &:after {\n                    content: \"\";\n                    width: 100%;\n                    border-top: 2px dashed $border-color;\n                    position: absolute;\n                    top: 0;\n                    left: 50%;\n                }\n\n                &:last-of-type {\n                    &:after {\n                        display: none;\n                    }\n                }\n\n                &.parent-title {\n                    &::before {\n                        content: \"\";\n                        height: 23px;\n                        border-right: 2px dashed $border-color;\n                        position: absolute;\n                        top: 28px;\n                        left: 0;\n                    }\n                    &::after {\n                        border: none;\n                    }\n                }\n\n                .sub-title {\n                    position: relative;\n\n                    &::before {\n                        content: \"\";\n                        height: 21px;\n                        border-right: 2px dashed $border-color;\n                        position: absolute;\n                        top: 27px;\n                        left: 49%;\n                        margin: 0 auto;\n                    }\n                }\n            }\n        }\n    }\n\n    a {\n        color: var(--#{$prefix}body-color);\n        padding: 4px 0px;\n        display: block;\n\n    }\n}\n\n\n// vertical sitemap\n.verti-sitemap { \n    a {\n        color: var(--#{$prefix}body-color);\n        display: block;\n    }\n    .parent-title {\n        a {\n            padding-left: 0;\n\n            &:before {\n                display: none;\n            }\n        }\n\n        &:before {\n            display: none;\n        }\n    }\n    .first-list {\n        position: relative;\n        padding-top: 10px;\n        &:before {\n            content: \"\";\n            border-left: 2px dashed $border-color;\n            position: absolute;\n            top: 0;\n            height: 100%;\n            bottom: 0;\n            left: 0;\n        }\n        .list-wrap, li {\n            a {\n                position: relative;\n                padding: 10px 16px 4px 36px;\n                &::before {\n                    content: \"\";\n                    width: 24px;\n                    border-top: 2px dashed $border-color;\n                    position: absolute;\n                    top: 50%;\n                    transform: translateY(-50%);\n                    left: 0;\n                }\n            }\n        }\n        .second-list, .third-list {\n            margin-left: 42px;\n            \n        }\n\n        .third-list, .second-list {\n            position: relative;\n            li {\n                position: relative;\n                &:before {\n                    content: \"\";\n                    height: 100%;\n                    border-left: 2px dashed $border-color;\n                    position: absolute;\n                    top: 0;\n                    left: 0;\n                    margin: 0px auto;\n                }\n                &:last-child {\n                    &::before {\n                        height: 13px;\n                    }\n                }\n            }\n        }\n        \n        &:last-child {\n            &::before {\n                height: 25px;\n            }\n        }\n    }\n}\n\n","//\n// _team.scss\n//\n\n.team-box .team-cover, .profile-offcanvas .team-cover, .modal-team-cover{\n    display: none;\n    position: relative;\n    margin-bottom: -140px;\n\n    img {\n        height: 140px;\n        width: 100%;\n        object-fit: cover;\n    }\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        background: linear-gradient(to top, darken($primary, 25%), $primary);\n        opacity: 0.6;\n    }\n}\n\n.team-list {\n    &.grid-view-filter {\n        flex-flow: row wrap;\n\n        .col {\n            flex: 0 0 auto;\n            width: 25%;\n        }\n\n        .team-box {\n            overflow: hidden;\n\n            .team-row {\n                align-items: start;\n\n                .col {\n                    width: 100%;\n                }\n            }\n\n            .team-cover {\n                display: block;\n            }\n\n            .team-settings {\n                .col {\n                    width: 50% !important;\n                    flex: 0 0 auto;\n                }\n\n                .btn-star {\n                    color: $white;\n                }\n\n                .dropdown {\n                    >a {\n                        color: $white;\n                    }\n                }\n            }\n\n            .team-profile-img {\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n                margin-bottom: 25px;\n                margin-top: 36px;\n\n                .avatar-lg {\n                    font-size: 22px;\n                }\n\n                .team-content {\n                    margin-left: 0px;\n                    margin-top: 25px;\n                    text-align: center;\n                }\n            }\n\n            .view-btn {\n                width: 100%;\n                margin-top: 25px;\n            }\n        }\n\n        @media (min-width: 1200px) and (max-width: 1399.98px) {\n            .col {\n                flex: 0 0 auto;\n                width: 33.33%;\n            }\n        }\n\n        @media (max-width: 1199.98px) {\n            .col {\n                flex: 0 0 auto;\n                width: 50%;\n            }\n        }\n\n        @media (max-width: 767.98px) {\n            .col {\n                flex: 0 0 auto;\n                width: 100%;\n            }\n        }\n    }\n\n    &.list-view-filter {\n        flex-direction: column;\n\n        .team-box {\n            margin-bottom: 10px;\n\n            .team-row {\n                align-items: center;\n                justify-content: space-between;\n            }\n\n            .team-profile-img {\n                display: flex;\n                align-items: center;\n\n                .avatar-lg {\n                    height: 4rem;\n                    width: 4rem;\n                    font-size: 16px;\n                }\n\n                .team-content {\n                    margin-left: 15px;\n                }\n            }\n\n            .team-settings {\n                width: auto;\n                flex: 0 0 auto;\n                -webkit-box-ordinal-group: 7;\n                order: 6;\n            }\n\n            .btn-star {\n                color: $primary;\n            }\n        }\n\n        @media (max-width: 767.98px) {\n            flex-direction: row;\n            .col {\n                -webkit-box-flex: 0;\n                -ms-flex: 0 0 auto;\n                flex: 0 0 auto;\n                width: 100%;\n            }\n            .team-box {\n\n                .team-settings {\n                    width: 100%;\n                    flex: 0 0 auto;\n                    order: -1;\n                    margin-bottom: 10px;\n\n                    .col {\n                        width: 50%;\n                    }\n                }\n\n                .team-profile-img {\n                    margin-bottom: 25px;\n                }\n\n                .view-btn {\n                    width: 100%;\n                    margin-top: 25px;\n                }\n            }\n        }\n    }\n}\n\n.modal-team-cover{\n    display: block;\n}\n\n.list-grid-nav {\n    .nav-link {\n        &.active {\n            background-color: $info;\n            color: $white;\n        }\n    }\n}\n\n.profile-offcanvas  {\n    .team-cover {\n        margin-bottom: -132px;\n        display: block;\n        z-index: -1;\n    }\n    .btn-star {\n        color: $white;\n    }\n\n    .dropdown {\n        >a {\n            color: $white;\n        }\n    }\n}","// \n// _coming-soon.scss\n//\n\n// countdownlist\n\n.countdownlist {\n    text-align: center;\n    display: flex;\n    gap: 24px;\n\n\n    .countdownlist-item{\n        width: 25%;\n        &:last-of-type{\n            .count-num{\n                &::after{\n                    display: none;\n                }\n            }\n        }\n    }\n    .count-title{\n        font-size: 13px;\n        font-weight: $font-weight-medium;\n        display: block;\n        margin-bottom: 8px;\n        color: rgba(var(--#{$prefix}dark-rgb), 0.5);\n        text-transform: uppercase;\n    }\n\n    .count-num{\n        background-color: var(--#{$prefix}card-bg-custom);\n        padding: 16px 8px;\n        position: relative;\n        border-radius: $card-border-radius;\n        box-shadow: $box-shadow;\n        font-weight: $font-weight-semibold;\n        font-size: 32px;\n        @media (max-width: 575.98px) {\n            font-size: 18px;\n        }\n    \n        &::after{\n            content: \":\";\n            font-size: 20px;\n            position: absolute;\n            right: -16px;\n            top: 50%;\n            transform: translateY(-50%);\n            color: var(--#{$prefix}dark);\n        }\n    }\n}\n// coming soon \n\n.move-animation{\n    animation: mover 1s infinite  alternate;\n}\n\n@keyframes mover {\n    0% { transform: translateY(0); }\n    100% { transform: translateY(-16px); }\n}\n\n.coming-soon-text{\n    font-weight: $font-weight-semibold;\n    text-transform: uppercase;\n    color: $white;\n    text-shadow: 3px 4px $success;\n}\n\n.countdown-input-group{\n    max-width: 400px;\n}\n","//\n// _search-results.scss\n//\n\n.search-more-results {\n    position: relative;\n    overflow: hidden;\n\n    .nav-icon {\n        font-size: 14px;\n        color: $white;\n        position: absolute;\n        top: 50%;\n        transform: translateY(-50%);\n        text-align: center;\n        left: 0;\n        right: 0;\n\n        i {\n            font-size: 20px;\n        }\n\n        @media (max-width: 767.98px) {\n            font-size: 14px;\n\n            i {\n                font-size: 18px;\n            }\n        }\n    }\n}\n\n.video-list {\n    .list-element {\n        display: none;\n        &:nth-child(1) {\n            display: block;\n        }\n        &:nth-child(2) {\n            display: block;\n        }\n        &:nth-child(3) {\n            display: block;\n        }\n    }\n}\n\n.search-voice {\n    height: 120px;\n    width: 120px;\n    line-height: 120px;\n    margin: 0px auto;\n    text-align: center;\n    border-radius: 50%;\n    z-index: 1;\n    position: relative;\n\n    i {\n        line-height: 56px;\n        font-size: 30px;\n    }\n\n    .voice-wave {\n        position: absolute;\n        width: 120px;\n        height: 120px;\n        z-index: -1;\n        left: 0px;\n        right: 0px;\n        margin: 0px auto;\n        opacity: 0;\n        border-radius: 100px;\n        animation: voice-wave 1.8s infinite;\n        background-color: var(--#{$prefix}light);\n\n        &:nth-child(2) {\n            animation-delay: 0.3s;\n        }\n\n        &:nth-child(3) {\n            animation-delay: 0.6s;\n        }\n    }\n}\n\n@keyframes voice-wave {\n    0% {\n        opacity: 1;\n        transform: scale(0);\n    }\n\n    100% {\n        opacity: 0;\n        transform: scale(1);\n    }\n}\n\n.images-menu {\n    .swiper-slide {\n        width: auto;\n        display: inline-block;\n    }\n}","//\n// _ecommerce.scss\n//\n\n// product list\n\n#selection-element { \n    display: none;\n}\n\n.filter-choices-input{\n    .choices__inner{\n        padding: 0;\n        border: none;\n        background-color: var(--#{$prefix}card-bg-custom);\n    }\n\n    .choices__input{\n        background-color: var(--#{$prefix}card-bg-custom);\n    }\n}\n\n//  product detail\n\n.sticky-side-div{\n    @media (min-width: 992px){\n        position: sticky;\n        top: calc(#{$header-height} + #{$grid-gutter-width});\n    }\n}\n\n.product-img-slider{\n    .product-nav-slider{\n        .nav-slide-item{\n            border: 1px solid $border-color;\n            border-radius: $border-radius;\n            padding: 0.5rem;\n            cursor: pointer;\n        }\n\n        .swiper-slide-thumb-active{\n            .nav-slide-item{\n                background-color: var(--#{$prefix}light);\n            }\n        }\n    }\n}\n\n.filter-list{\n    a {\n        &.active {\n            .listname {\n                color: $success;\n            }\n        }   \n    }\n}","//\n// _invoice.scss\n//\n\n.invoice-table {\n    tbody {\n        &:last-child {\n            border: none;\n        }\n    }\n}\n\n.currency-select {\n    .choices__inner {\n        padding:0px;\n        padding-right: 15px;\n        min-height: 0px;\n    }\n    .choices__list--single {\n        padding: 0px 16px 0 4px;\n    }\n    .choices[data-type*=select-one]{\n        bottom: 0px;\n        :after { \n            top: 4px;\n        }\n        .choices__inner {\n            padding-bottom: 0px;\n        }\n    }\n}","//\n// _chat.scss\n//\n\n.chat-wrapper {\n  position: relative;\n  overflow-x: hidden;\n}\n\n// chat left sidebar\n\n.chat-leftsidebar {\n  height: calc(100vh - 137px);\n  position: relative;\n  background-color: var(--#{$prefix}card-bg-custom);\n\n  @media (min-width: 992px) {\n    min-width: 300px;\n    max-width: 300px;\n    height: calc(100vh - #{$header-height} - #{$footer-height} - 8px);\n  }\n}\n\n.chat-list {\n  margin: 0;\n\n  > li {\n    &.active {\n      a {\n        background-color: $chat-secondary-bg;\n        color: $chat-secondary-color;\n\n        .badge {\n          background-color: rgba(var(--#{$prefix}success-rgb), 0.15) !important;\n          color: $success !important;\n        }\n      }\n    }\n\n    a {\n      display: block;\n      padding: 7px 24px;\n      color: var(--#{$prefix}body-color);\n      transition: all 0.4s;\n      font-family: $font-family-secondary;\n      font-weight: $font-weight-medium;\n      font-size: $font-size-base;\n    }\n\n    .chat-user-message {\n      font-size: 14px;\n    }\n\n    .unread-msg-user {\n      font-weight: $font-weight-semibold;\n    }\n\n    .unread-message {\n      position: absolute;\n      display: inline-block;\n      right: 24px /*rtl:auto*/;\n      left: auto /*rtl:0*/;\n      top: 33px;\n\n      .badge {\n        line-height: 16px;\n        font-weight: $font-weight-semibold;\n        font-size: 10px;\n      }\n    }\n  }\n}\n\n.chat-user-img {\n  position: relative;\n\n  .user-status {\n    width: 10px;\n    height: 10px;\n    background-color: $gray-500;\n    border-radius: 50%;\n    border: 2px solid var(--#{$prefix}card-bg-custom);\n    position: absolute;\n    right: 0;\n    left: auto;\n    bottom: 0;\n  }\n\n  &.online {\n    .user-status {\n      background-color: $success;\n    }\n  }\n\n  &.away {\n    .user-status {\n      background-color: $warning;\n    }\n  }\n}\n\n.chat-room-list {\n  max-height: calc(100vh - 296px);\n\n  @media (max-width: 991.98px) {\n    height: calc(100vh - 296px);\n  }\n}\n\n// contact list\n\n.contact-list {\n  li {\n    cursor: pointer;\n    padding: 8px 24px;\n    transition: all 0.4s;\n    color: var(--#{$prefix}body-color);\n    font-family: $font-family-secondary;\n    font-weight: $font-weight-medium;\n    font-size: $font-size-base;\n  }\n}\n\n.contact-list-title {\n  padding: 6px 24px;\n  color: $primary;\n  font-weight: $font-weight-medium;\n  position: relative;\n  font-size: 12px;\n  &:after {\n    content: \"\";\n    height: 1px;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 50px;\n    right: 0;\n    background-color: var(--#{$prefix}light);\n  }\n}\n\n// user chat\n\n.user-chat {\n  background: url(\"../../images/chat-bg-pattern.png\");\n  transition: all 0.4s;\n  position: relative;\n  background-color: var(--#{$prefix}body-bg);\n\n  @media (max-width: 991.98px) {\n    position: absolute;\n    left: 0;\n    top: 3px;\n    width: 100%;\n    height: calc(100% - 3px);\n    visibility: hidden;\n    transform: translateX(100%);\n    z-index: 99;\n    padding-top: 70px;\n\n    &.user-chat-show {\n      visibility: visible;\n      transform: translateX(0);\n    }\n  }\n\n  .chat-content {\n    position: relative;\n  }\n\n  &.user-chat-show {\n    .chat-welcome-section {\n      display: none;\n    }\n    .chat-content {\n      @media (min-width: 992px) {\n        display: flex !important;\n      }\n    }\n  }\n}\n\n.user-chat-topbar {\n  border-bottom: 1px solid transparent;\n  background-color: var(--#{$prefix}card-bg-custom);\n  @media (max-width: 991.98px) {\n    position: fixed;\n    left: 0;\n    right: 0;\n    top: 0;\n    z-index: 1;\n  }\n}\n\n.user-chat-nav {\n  .nav-btn {\n    height: 40px;\n    width: 40px;\n    line-height: 40px;\n    box-shadow: none;\n    padding: 0;\n    font-size: 20px;\n    color: $gray-800;\n  }\n  @media (max-width: 575.98px) {\n    display: flex;\n    justify-content: flex-end;\n  }\n}\n\n.chat-conversation {\n  height: calc(100vh - 299px) !important;\n  @media (max-width: 991.98px) {\n    height: calc(100vh - 275px) !important;\n  }\n\n  .simplebar-content-wrapper {\n    display: flex;\n    flex-direction: column;\n\n    .simplebar-content {\n      margin-top: auto;\n    }\n  }\n\n  .chat-conversation-list {\n    padding-top: 10px;\n    margin-bottom: 0;\n    > li {\n      display: flex;\n    }\n  }\n\n  li {\n    &:last-of-type {\n      .conversation-list {\n        margin-bottom: 0;\n      }\n    }\n  }\n\n  .chat-list {\n    &.left {\n      .check-message-icon {\n        display: none;\n      }\n    }\n    .message-box-drop {\n      visibility: hidden;\n    }\n\n    &:hover {\n      .message-box-drop {\n        visibility: visible;\n      }\n    }\n  }\n\n  .chat-avatar {\n    margin: 0 16px 0 0 /*rtl:0 0 0 16px*/;\n\n    img {\n      width: 28px;\n      height: 28px;\n      border-radius: 50%;\n    }\n  }\n\n  .chat-day-title {\n    position: relative;\n    text-align: center;\n    margin-bottom: 24px;\n    margin-top: 12px;\n    width: 100%;\n\n    .title {\n      background-color: $white;\n      position: relative;\n      font-size: 13px;\n      z-index: 1;\n      padding: 6px 12px;\n      border-radius: 5px;\n    }\n\n    &:before {\n      content: \"\";\n      position: absolute;\n      width: 100%;\n      height: 1px;\n      left: 0;\n      right: 0;\n      background-color: rgba($primary, 0.2);\n      top: 10px;\n    }\n\n    .badge {\n      font-size: 12px;\n    }\n  }\n\n  .conversation-list {\n    margin-bottom: 24px;\n    display: inline-flex;\n    position: relative;\n    align-items: flex-end;\n    max-width: 80%;\n\n    @media (max-width: 575.98px) {\n      max-width: 90%;\n    }\n\n    .ctext-wrap {\n      display: flex;\n      margin-bottom: 10px;\n    }\n\n    .ctext-content {\n      word-wrap: break-word;\n      word-break: break-word;\n    }\n\n    .ctext-wrap-content {\n      padding: 12px 20px;\n      background-color: $chat-primary-bg;\n      position: relative;\n      border-radius: 3px;\n      box-shadow: $box-shadow-lg;\n\n      .attached-file {\n        @media (max-width: 575.98px) {\n          .attached-file-avatar {\n            display: none;\n          }\n\n          .dropdown .dropdown-toggle {\n            display: block;\n          }\n        }\n      }\n    }\n\n    .conversation-name {\n      font-weight: $font-weight-medium;\n      display: flex;\n      flex-wrap: wrap;\n      align-items: center;\n      gap: 8px;\n    }\n\n    .dropdown {\n      .dropdown-toggle {\n        font-size: 18px;\n        padding: 4px;\n        color: $gray-600;\n        &::after {\n          display: none;\n        }\n\n        @media (max-width: 575.98px) {\n          display: none;\n        }\n      }\n    }\n\n    .chat-time {\n      font-size: 12px;\n      margin-top: 4px;\n      text-align: right;\n    }\n\n    .message-img {\n      border-radius: 0.2rem;\n      position: relative;\n      display: flex;\n      flex-wrap: wrap;\n      gap: 8px;\n\n      .message-img-list {\n        position: relative;\n      }\n\n      img {\n        max-width: 150px;\n      }\n\n      .message-img-link {\n        position: absolute;\n        right: 10px /*rtl:auto*/;\n        left: auto /*rtl:0*/;\n        bottom: 10px;\n\n        li {\n          > a {\n            font-size: 18px;\n            color: $white;\n            display: inline-block;\n            line-height: 20px;\n            width: 26px;\n            height: 24px;\n            border-radius: 3px;\n            background-color: rgba($dark, 0.7);\n            text-align: center;\n          }\n        }\n      }\n    }\n  }\n\n  .right {\n    justify-content: flex-end;\n\n    .chat-avatar {\n      order: 3;\n      margin-right: 0px;\n      margin-left: 16px;\n    }\n\n    .chat-time {\n      text-align: left;\n      color: $gray-600;\n    }\n\n    .conversation-list {\n      text-align: right;\n\n      .ctext-wrap {\n        justify-content: flex-end;\n\n        .ctext-wrap-content {\n          order: 2;\n          background-color: $chat-secondary-bg;\n          color: $chat-secondary-color;\n          text-align: right;\n          box-shadow: $element-shadow;\n\n          .replymessage-block {\n            background-color: rgba($white, 0.5);\n            border-color: rgba(var(--vz-success-rgb), 1);\n            color: $body-color;\n\n            .conversation-name {\n              color: rgba(var(--vz-success-rgb), 1);\n            }\n          }\n        }\n      }\n\n      .conversation-name {\n        justify-content: flex-end;\n\n        .check-message-icon {\n          order: 1;\n        }\n\n        .time {\n          order: 2;\n        }\n\n        .name {\n          order: 3;\n        }\n      }\n\n      .dropdown {\n        order: 1;\n      }\n    }\n\n    .dot {\n      background-color: $dark;\n    }\n  }\n}\n\n.chat-input-section {\n  border-top: 1px solid transparent;\n  background-color: var(--#{$prefix}card-bg-custom);\n  position: relative;\n  z-index: 1;\n\n  .chat-input-feedback {\n    display: none;\n    position: absolute;\n    top: -20px;\n    left: 4px;\n    font-size: 12px;\n    color: $danger;\n  }\n  .show {\n    display: block;\n  }\n}\n\n.chat-input-links {\n  display: flex;\n  .links-list-item {\n    > .btn {\n      box-shadow: none;\n      padding: 0;\n      font-size: 20px;\n      width: 37.5px;\n      height: 37.5px;\n      &.btn-link {\n        color: $gray-600;\n      }\n    }\n  }\n}\n\n//Copy Message Alert\n.copyclipboard-alert {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  display: none;\n}\n\n.replyCard {\n  position: absolute;\n  left: 0;\n  right: 0;\n  border-top: 1px solid $border-color;\n  overflow: hidden;\n  opacity: 0;\n  bottom: 0;\n  border-radius: 0;\n  transition: all 0.4s;\n\n  @media (max-width: 991.98px) {\n    bottom: -12px;\n  }\n\n  &.show {\n    transform: translateY(-88px);\n    opacity: 1;\n\n    @media (max-width: 991.98px) {\n      transform: translateY(-83px);\n    }\n  }\n}\n\n.replymessage-block {\n  padding: 12px 20px;\n  margin-bottom: 8px;\n  text-align: left;\n  border-radius: 4px;\n  background-color: rgba(var(--vz-success-rgb), 0.1);\n  border-left: 2px solid rgba(var(--vz-success-rgb), 1);\n\n  .conversation-name {\n    color: rgba(var(--vz-success-rgb), 1);\n    font-size: 14px;\n  }\n}\n\n// Chat Small\n.chat-sm {\n  .ctext-wrap-content {\n    box-shadow: none !important;\n  }\n\n  .message-img {\n    img {\n      max-width: 90px !important;\n    }\n  }\n\n  .message-img-link {\n    bottom: 0 !important;\n    right: 5px !important;\n  }\n}\n\n// for horizontal layout\n[data-layout=\"horizontal\"] {\n  .chat-wrapper {\n    @media (min-width: 1025px) {\n      margin-left: 0 !important;\n      margin-right: 0 !important;\n    }\n    @media (max-width: 991.98px) {\n      margin-top: 0 !important;\n    }\n  }\n\n  .chat-leftsidebar {\n    height: calc(100vh - #{$header-height} - #{$footer-height} - 54px);\n    @media (max-width: 991.98px) {\n      height: calc(100vh - #{$header-height} - #{$footer-height} - 8px);\n    }\n  }\n\n  .chat-room-list {\n    height: calc(100vh - 352px);\n    @media (max-width: 991.98px) {\n      height: calc(100vh - 265px);\n    }\n  }\n\n  .chat-conversation {\n    height: calc(100vh - 343px) !important;\n    @media (max-width: 991.98px) {\n      height: calc(100vh - 275px) !important;\n    }\n  }\n}\n","//\n// _email.scss\n//\n\n.email-wrapper {\n  position: relative;\n  overflow-x: hidden;\n}\n\n// chat left sidebar\n\n.email-menu-sidebar {\n  height: calc(100vh - 137px);\n  position: relative;\n  background-color: var(--#{$prefix}card-bg-custom);\n  transition: all 0.2s;\n\n  @media (min-width: 992px) {\n    min-width: 250px;\n    max-width: 250px;\n    height: calc(100vh - #{$header-height} - #{$footer-height} - 8px);\n  }\n\n  @media (max-width: 991.98px) {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 200px;\n    max-width: 100%;\n    z-index: 1003;\n    box-shadow: $box-shadow-lg;\n    transform: translateX(-100%);\n    visibility: hidden;\n    height: 100vh;\n\n    &.menubar-show {\n      visibility: visible;\n      transform: none;\n    }\n  }\n\n  .email-menu-sidebar-scroll {\n    height: calc(100vh - 295px);\n\n    @media (max-width: 991.98px) {\n      height: calc(100vh - 150px);\n    }\n  }\n}\n\n.mail-list {\n  a {\n    display: flex;\n    align-items: center;\n    color: $gray-600;\n    padding: 5px 0;\n    font-weight: $font-weight-medium;\n\n    &:hover {\n      color: $primary;\n    }\n\n    i {\n      font-size: 14px;\n    }\n\n    &.active {\n      color: $success;\n      font-weight: $font-weight-semibold;\n\n      i {\n        color: $success;\n      }\n    }\n  }\n}\n\n.email-chat-list {\n  a {\n    padding: 6px 24px;\n    &.active {\n      background-color: rgba(var(--#{$prefix}light-rgb), 0.7);\n    }\n  }\n}\n.email-topbar-link {\n  .btn-ghost-secondary {\n    color: $text-muted;\n\n    &:hover {\n      color: $secondary;\n    }\n  }\n}\n\n.email-content {\n  width: 100%;\n  background-color: var(--#{$prefix}card-bg-custom);\n  transition: all 0.2s;\n}\n\n.unreadConversations-alert {\n  position: fixed;\n  bottom: $footer-height;\n  left: 50%;\n  transform: translateX(-50%);\n  z-index: 1;\n}\n\n.email-detail-content {\n  position: absolute;\n  top: 4px;\n  bottom: 4px;\n  left: 68%;\n  width: 32%;\n  background-color: var(--#{$prefix}card-bg-custom);\n  transform: translateX(200%);\n  transition: all 0.2s;\n  visibility: hidden;\n  border-left: 2px solid var(--#{$prefix}body-bg);\n}\n\n.email-detail-show {\n  .email-detail-content {\n    transform: none;\n    visibility: visible;\n  }\n\n  .email-content {\n    margin-right: 32%;\n\n    @media (max-width: 1349.98px) {\n      margin-right: 0;\n    }\n  }\n}\n\n.email-detail-content-scroll {\n  height: calc(100vh - 390px);\n\n  @media (max-width: 1349.98px) {\n    height: calc(100vh - 252px);\n  }\n}\n\n.message-list-content {\n  height: calc(100vh - 242px);\n\n  @media (max-width: 575.98px) {\n    height: calc(100vh - 230px);\n  }\n}\n\n.message-list {\n  display: block;\n  padding-left: 0;\n  margin: 0;\n\n  li {\n    position: relative;\n    display: block;\n    height: 50px;\n    line-height: 50px;\n    cursor: default;\n    transition-duration: 0.3s;\n    clear: both;\n\n    a {\n      color: var(--#{$prefix}gray-700);\n    }\n\n    &:hover {\n      background: var(--#{$prefix}light);\n      transition-duration: 0.05s;\n    }\n\n    .col-mail {\n      float: left;\n      position: relative;\n    }\n\n    .col-mail-1 {\n      width: 280px;\n\n      .star-toggle,\n      .checkbox-wrapper-mail,\n      .dot {\n        display: block;\n        float: left;\n      }\n\n      .dot {\n        border: 4px solid transparent;\n        border-radius: 100px;\n        margin: 22px 26px 0;\n        height: 0;\n        width: 0;\n        line-height: 0;\n        font-size: 0;\n      }\n\n      .checkbox-wrapper-mail {\n        margin: 15px 0 0 20px;\n        line-height: normal;\n      }\n\n      .star-toggle {\n        margin-top: 18px;\n        margin-left: 5px;\n      }\n\n      .title {\n        position: absolute;\n        top: 0;\n        left: 95px;\n        right: 0;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n        margin-bottom: 0;\n\n        @media (max-width: 575.98px) {\n          left: 95px;\n        }\n      }\n    }\n\n    .col-mail-2 {\n      position: absolute;\n      top: 0;\n      left: 280px;\n      right: 0;\n      bottom: 0;\n\n      .subject,\n      .date {\n        position: absolute;\n        top: 0;\n      }\n\n      .subject {\n        left: 0;\n        right: 110px;\n        text-overflow: ellipsis;\n        overflow: hidden;\n        white-space: nowrap;\n\n        .teaser {\n          color: var(--#{$prefix}gray-600);\n        }\n      }\n\n      .date {\n        right: 0;\n        width: 100px;\n        padding-left: 20px;\n      }\n    }\n\n    &.active,\n    &.active:hover {\n      box-shadow: inset 3px 0 0 $primary;\n      background-color: var(--#{$prefix}light);\n    }\n\n    &.unread {\n      color: var(--#{$prefix}gray-800);\n\n      a {\n        color: var(--#{$prefix}gray-800);\n        font-weight: $font-weight-semibold;\n      }\n    }\n  }\n}\n\n#unreadConversations,\n#email-topbar-actions {\n  display: none;\n}\n\n#elmLoader {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n  align-items: center;\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n}\n\n.email-compose-input {\n  padding-right: 80px;\n}\n\n@media (max-width: 1349.98px) {\n  .email-detail-content {\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: auto;\n    right: 0;\n    width: 400px;\n    max-width: 100%;\n    z-index: 1003;\n    box-shadow: $box-shadow-lg;\n    transform: translateX(100%);\n  }\n\n  .email-detail-show {\n    .email-detail-content {\n      transform: none;\n    }\n  }\n}\n\n@media (max-width: 575.98px) {\n  .message-list li .col-mail-1 {\n    width: 180px;\n  }\n}\n\n.email-editor {\n  .ck-editor__editable_inline {\n    min-height: 200px !important;\n  }\n}\n\n.email-chat-detail {\n  width: 350px;\n  position: fixed;\n  max-width: 100%;\n  bottom: $footer-height;\n  right: $footer-height;\n  z-index: 9;\n  display: none;\n  .card {\n    box-shadow: $box-shadow-lg;\n  }\n\n  @media (max-width: 515.98px) {\n    left: 16px;\n    right: 16px;\n  }\n}\n\n// for horizontal layout\n[data-layout=\"horizontal\"] {\n  .email-wrapper {\n    @media (min-width: 1025px) {\n      margin-left: 0 !important;\n      margin-right: 0 !important;\n    }\n    @media (max-width: 991.98px) {\n      margin-top: 0 !important;\n    }\n  }\n\n  .email-menu-sidebar {\n    height: calc(100vh - #{$header-height} - #{$footer-height} - 54px);\n    @media (max-width: 991.98px) {\n      height: 100vh;\n    }\n    .email-menu-sidebar-scroll {\n      height: calc(100vh - 330px);\n      @media (max-width: 991.98px) {\n        height: calc(100vh - 150px);\n      }\n    }\n  }\n\n  .message-list-content {\n    height: calc(100vh - 289px);\n  }\n\n  .email-detail-content-scroll {\n    height: calc(100vh - 435px);\n    @media (max-width: 1349.98px) {\n      height: calc(100vh - 252px);\n    }\n  }\n}\n\n.email-chat-element {\n  .chat-conversation1 {\n    height: 250px !important;\n  }\n}\n","//\n// _kanban.scss\n//\n\n.tasks-board {\n    display: flex;\n    overflow-x: auto;\n    align-items: stretch;\n\n    .tasks-list {\n        min-width: 300px;\n        margin-right: 24px;\n    }\n\n    &::-webkit-scrollbar {\n        -webkit-appearance: none;\n    }\n\n    &::-webkit-scrollbar:vertical {\n        width: 10px;\n    }\n\n    &::-webkit-scrollbar:horizontal {\n        height: 8px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: rgba(var(--#{$prefix}dark-rgb), .075);\n        border-radius: 8px;\n    }\n\n    &::-webkit-scrollbar-track {\n        border-radius: 8px;\n    }\n}\n\n.tasks-box {\n    .progress {\n        border-radius: 0px 0px $card-border-radius $card-border-radius;\n    }\n\n    .tasks-img {\n        height: 135px;\n        width: 100%;\n        object-fit: cover;\n        object-position: center;\n        margin: 12px 0px;\n    }\n\n    &:last-child {\n        margin-bottom: 0px;\n    }\n}\n\n.tasks-wrapper {\n    max-height: calc(100vh - 418px);\n}\n\n\n.tasks {\n    min-height: 180px;\n    position: relative;\n\n    &.noTask{\n        &::before {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        right: 0;\n        top: 0;\n        bottom: 0;\n        height: 180px;\n        width: 270px;\n        margin: 0 auto;\n        background-image: url('../../images/file.png');\n        background-size: cover;\n        background-position: center;\n    }\n    }\n}\n\n#tasksList {\n    tr {\n        .tasks-list-menu {\n            opacity: 0;\n        }\n\n        &:hover {\n            .tasks-list-menu {\n                opacity: 1;\n            }\n        }\n    }\n}","//\n// _landing.scss\n//\n\n.layout-wrapper {\n    &.landing {\n        background-color: var(--#{$prefix}card-bg-custom);\n        font-size: 15px;\n    }\n}\n\n// helper\n\n.section {\n    padding: 90px 0;\n    position: relative;\n\n    @media (max-width:767.98px) {\n        padding: 50px 0;\n    }\n}\n\n.icon-effect {\n    position: relative;\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        width: 24px;\n        height: 24px;\n        background-color: rgba($success, 0.2);\n        border-radius: 50%;\n        bottom: 0;\n        left: 0;\n    }\n}\n\n// navbar\n\n.navbar-landing {\n    padding: 10px 0px;\n    transition: all 0.5s ease;\n    @media (max-width: 991.98px) {\n        background-color: var(--#{$prefix}card-bg-custom);\n        box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);\n        padding: 10px 8px;\n    }\n\n    .navbar-nav {\n        .nav-item {\n            .nav-link {\n                font-size: 16px;\n                font-weight: $font-weight-medium;\n                transition: all 0.4s;\n                font-family: $font-family-secondary;\n                color: var(--#{$prefix}dark);\n                padding: 14px;\n\n                @media (max-width: 991.98px) {\n                    padding: 8px 0px;\n                }\n\n                &:hover,\n                &.active,\n                &:focus {\n                    color: $success !important;\n                }\n            }\n            &.active {\n                .nav-link {\n                    color: $success !important;\n                }\n            }\n        }\n    }\n\n    &.is-sticky {\n        background-color: var(--#{$prefix}card-bg-custom);\n        box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);\n    }\n}\n\n//navbar-light\n.navbar-light{\n    .navbar-brand {\n        .card-logo-dark {\n            display: none;\n        }\n    \n        .card-logo-light {\n            display: block;\n        }\n    }\n    .navbar-nav {\n        .nav-item {\n            .nav-link {\n                color: rgba(var(--#{$prefix}white-rgb), 0.75);\n            }\n        }\n    }\n    &.is-sticky {\n        .navbar-nav {\n            .nav-item {\n                .nav-link {\n                    color: var(--#{$prefix}dark);\n                }\n            }\n        }\n        .navbar-brand {\n            .card-logo-dark {\n                display: block;\n            }\n        \n            .card-logo-light {\n                display: none;\n            }\n        }\n    }\n}\n\n// hero section\n\n.hero-section {\n    background-color: rgba(var(--#{$prefix}light-rgb), 0.5);\n\n    .hero-shape-svg {\n        svg {\n            path {\n                fill: var(--#{$prefix}card-bg-custom);\n            }\n        }\n    }\n}\n\n.bg-overlay-pattern {\n    background-image: url(\"../../images/landing/bg-pattern.png\");\n    background-color: transparent;\n    background-position: center;\n    background-size: cover;\n    opacity: 0.2;\n}\n\n.demo-carousel {\n    position: relative;\n    z-index: 1;\n\n    .carousel-item {\n        .demo-item {\n            background-color: var(--#{$prefix}card-bg-custom);\n            padding: 8px;\n            border-radius: 7px;\n        }\n    }\n\n    .demo-img-patten-top {\n        position: absolute;\n        right: -50px;\n        top: -16px;\n        max-width: 230px;\n    }\n\n    .demo-img-patten-bottom {\n        position: absolute;\n        left: -70px;\n        bottom: -50px;\n        max-width: 230px;\n    }\n}\n\n// client images\n.client-images img {\n    max-height: 45px;\n    width: auto;\n    margin: 12px auto;\n    transition: all .4s;\n}\n\n// plan\n\n.plan-box {\n    max-width: 356px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n// work process\n.process-card {\n    position: relative;\n\n    .process-arrow-img {\n        position: absolute;\n        left: 75%;\n        top: 7%;\n        width: 50%;\n        opacity: .1;\n    }\n}\n\n.custom-footer {\n    color: #9ba7b3;\n}\n\n.footer-list {\n    li {\n        a {\n            color: #9ba7b3;\n            padding: 7px 0;\n            display: block;\n            transition: all 0.3s ease-in-out;\n\n            &:hover {\n                color: rgba($white, 0.9);\n            }\n        }\n    }\n}\n\n.footer-social-link {\n    .avatar-title {\n        color: #778089;\n        background-color: rgba($white, 0.05);\n        transition: all 0.3s ease;\n\n        &:hover {\n            color: $white;\n            background-color: $primary;\n        }\n    }\n}\n\n#back-to-top {\n    &.landing-back-top {\n        bottom: 35px;\n    }\n}\n\n// dark\n\n[data-layout-mode=\"dark\"] {\n    .layout-wrapper.landing {\n\n        .demo-img-patten-top,\n        .demo-img-patten-bottom {\n            opacity: .2;\n        }\n\n        footer.bg-dark {\n            background-color: var(--#{$prefix}card-bg-custom) !important;\n        }\n    }\n\n    //navbar-light\n    .navbar-light{\n        &.is-sticky { \n            .navbar-brand {\n                .card-logo-dark {\n                    display: none;\n                }\n        \n                .card-logo-light {\n                    display: block;\n                }\n            }\n        }\n    }\n}","//\n// _nft-landing.scss\n//\n\n.bookmark-icon {\n    .btn {\n        color: $text-muted;\n        background-color: var(--#{$prefix}light);\n        box-shadow: $box-shadow;\n        font-size: $font-size-base;\n        &:hover,\n        &.active {\n            border-color: transparent;\n            color: $danger;\n        }\n    }\n}\n\n.explore-box {\n    border-radius: 9px;\n    overflow: hidden;\n    .explore-img {\n        height: 280px;\n        object-fit: cover;\n    }\n    .explore-place-bid-img {\n        position: relative;\n        overflow: hidden;\n        z-index: 0;\n        .bg-overlay {\n            position: absolute;\n            right: 0;\n            left: 0;\n            top: 0;\n            bottom: 0;\n            background-color: rgba($dark, 0.4);\n            opacity: 0;\n            transition: all 0.5s ease;\n        }\n    \n        .place-bid-btn {\n            top: 50%;\n            position: absolute;\n            left: 50%;\n            transform: translate(-50%, -50%);\n    \n            .btn {\n                opacity: 0;\n                bottom: -25px;\n                transition: 0.5s ease;\n            }\n        }\n    }\n    \n    &:hover {\n        .explore-place-bid-img {\n            .place-bid-btn {\n                .btn {\n                    opacity: 1;\n                    bottom: 0;\n                }\n            }\n    \n            .bg-overlay {\n                opacity: 1;\n            }\n        }\n    }\n    .discount-time {\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        right: 0;\n        text-align: center;\n        background-color: rgba($white, 0.4);\n        backdrop-filter: blur(5px);\n        padding: 8px;\n    }\n}\n\n//\n.nft-hero {\n    // background-image: url('../../images/nft/bg-home.jpg');\n    background-size: cover;\n    background-position: bottom;\n    padding: 222px 0 150px 0;\n    .bg-overlay {\n        background-color: #05175f;\n        opacity: 0.85;\n    }\n}\n\n#explorecard-list {\n    .list-element {\n        display: none;\n\n        &:nth-child(-n+10) {\n            display: block;\n        }\n    }\n}","//\n// _file-manager.scss\n//\n\n.file-manager-menu {\n    max-height: calc(100vh - 296px);\n\n    @media (max-width: 991.98px) {\n        height: calc(100vh - 296px);\n    }\n\n    li {\n        padding: 5px 0px;\n\n        a {\n            color: var(--#{$prefix}dark);\n            font-weight: $font-weight-medium;\n            transition: all 0.5s ease;\n\n            &.active,\n            &:hover,\n            &[aria-expanded=\"true\"]{\n                color: $success;\n            }\n        }\n\n        .sub-menu {\n            li {\n                padding-left: 25px;\n                position: relative;\n\n                &::before {\n                    content: \"\\f0374\";\n                    position: absolute;\n                    left: 0px;\n                    font-family: Material Design Icons;\n                    color: rgba(var(--#{$prefix}dark-rgb), 0.4);\n                }\n            }\n        }\n    }\n}\n\n.file-manager-sidebar {\n    position: relative;\n    background-color: var(--#{$prefix}card-bg-custom);\n\n    @media (min-width: 992px) {\n        min-width: 300px;\n        max-width: 300px;\n        height: calc(100vh - #{$header-height} - #{$footer-height} - 8px);\n    }\n\n    @media (max-width: 991.98px) {\n        position: fixed;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        width: 200px;\n        max-width: 100%;\n        z-index: 1003;\n        box-shadow: $box-shadow-lg;\n        transform: translateX(-100%);\n        visibility: hidden;\n        height: 100vh;\n\n        &.menubar-show {\n            visibility: visible;\n            transform: none;\n        }\n    }\n}\n\n.file-menu-sidebar-scroll{\n    height: calc(100vh - 375px);\n    @media (max-width: 991.98px) {\n        height: calc(100vh - 190px);\n    }\n}\n\n.file-manager-content {\n    background-color: var(--#{$prefix}card-bg-custom);\n}\n\n.file-manager-content-scroll{\n    height: calc(100vh - 185px);\n    overflow-y: auto;\n\n        &::-webkit-scrollbar {\n            -webkit-appearance: none;\n        }\n    \n        &::-webkit-scrollbar:vertical {\n            width: 12px;\n        }\n    \n        &::-webkit-scrollbar:horizontal {\n            height: 12px;\n        }\n    \n        &::-webkit-scrollbar-thumb {\n            background-color: rgba(var(--#{$prefix}dark-rgb), .075);\n            border-radius: 10px;\n            border: 2px solid var(--#{$prefix}card-bg-custom);\n        }\n    \n        &::-webkit-scrollbar-track {\n            border-radius: 10px;\n            background-color: var(--#{$prefix}card-bg-custom);\n        }\n    @media (max-width: 991.98px) {\n        height: calc(100vh - 144px);\n    }\n\n    .simplebar-content{\n        height: 100%;\n    }\n}\n\n.file-detail-content-scroll{\n    height: calc(100vh - 180px);\n    @media (max-width: 991.98px) {\n        height: 100vh;\n    }\n\n    .simplebar-content{\n        height: 100%;\n    }\n}\n\n.file-manager-detail-content {\n    width: 32%;\n    max-width: 100%;\n    background-color: var(--#{$prefix}card-bg-custom);\n    display: none;\n}\n\n.file-detail-show{\n    .file-manager-detail-content{\n        display: block;\n    }\n}\n\n#file-overview{\n    display: none;\n}\n\n@media (max-width: 1399.98px) {\n    .file-manager-detail-content {\n        position: fixed;\n        top: 0;\n        bottom: 0;\n        left: auto;\n        right: 0;\n        width: 400px;\n        max-width: 100%;\n        z-index: 1003;\n        box-shadow: $box-shadow-lg;\n        transform: translateX(100%);\n    }\n\n    .file-detail-show {\n        .file-manager-detail-content {\n            transform: none;\n        }\n    }\n}\n\n.file-details-box {\n    height: 195px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}","//\n// _to-do.scss\n//\n\n.to-do-menu {\n    li {\n        .nav-link {\n            color: var(--#{$prefix}body-color);\n            padding-left: 0;\n            font-weight: $font-weight-medium;\n            background-color: var(--#{$prefix}light);\n            padding: 10px 12px;\n            border-radius: 4px;\n            display: block;\n            margin-bottom: 8px;\n            &:hover, &.active {\n                color: $success;\n            }\n        }\n    }\n}\n\n.todo-content {\n    height: calc(100vh - 362px);\n    overflow-y: auto;\n    &::-webkit-scrollbar {\n        -webkit-appearance: none;\n    }\n\n    &::-webkit-scrollbar:vertical {\n        width: 8px;\n    }\n\n    &::-webkit-scrollbar:horizontal {\n        height: 10px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n        background-color: rgba(var(--#{$prefix}dark-rgb), .075);\n        border-radius: 8px;\n    }\n\n    &::-webkit-scrollbar-track {\n        border-radius: 8px;\n    }\n}\n\n.todo-task {\n    table{\n        .form-check{\n            .form-check-input {\n                &:checked+.form-check-label {\n                    text-decoration: line-through;\n                }\n            }\n        }\n    }\n}\n\n.task-handle{\n    cursor: move;\n}\n\n#task-error-msg{\n    display: none;\n}","//\n// _invoice.scss\n//\n\n.bg-job {\n    background-image: url(../../images/new.png);\n    background-size: cover;\n    background-position: center;\n}\n\n.job-list-view-card{\n    .background {\n        height: 130px;\n    }\n}\n\n.job-list-row {\n    &.row {\n        .col-xxl-3 {\n            @media (min-width: 1400px) and (max-width: 1499.98px) {\n                width: 33%; \n            }\n        }\n    }\n}",".custom-container {\n    width: 90%;\n}\n\n//********** Navbar **********//\n.job-navbar {\n    .dropdown-menu {\n        .dropdown-item {\n            .avatar-sm {\n                height: 2.5rem;\n                width: 2.5rem;\n            }\n        }\n    }\n\n    @media (max-width: 991.98px) {\n        background-color: var(--#{$prefix}card-bg-custom);\n        padding: 16px 0;\n    }\n}\n\n//********** Home **********//\n.job-hero-section {\n    position: relative;\n    padding: 165px 0;\n    overflow-x: hidden;\n}\n\n.job-panel-filter {\n    background-color: var(--#{$prefix}card-bg-custom);\n    border-radius: $border-radius;\n    overflow: hidden;\n\n    .form-control {\n        height: 45px;\n        border: none;\n        border-radius: 0;\n        background-color: transparent;\n    }\n\n    .btn {\n        border-radius: 0;\n    }\n\n    input.form-control {\n        border-right: 1px solid $border-color;\n    }\n\n    @media (max-width: 767.98px) {\n        background-color: transparent;\n\n        .form-control {\n            background-color: $white;\n            border-radius: $input-border-radius;\n        }\n\n        input.form-control {\n            border: 0;\n        }\n\n        .btn {\n            border-radius: $btn-border-radius;\n        }\n    }\n}\n\n.circle-effect {\n    position: absolute;\n    top: 0;\n    z-index: 0;\n    right: -55px;\n    margin: 0 auto;\n\n    .circle {\n        border: 1px solid $border-color;\n        height: 240px;\n        width: 240px;\n        margin: 0 auto;\n        border-radius: 50%;\n    }\n\n    .circle2 {\n        position: absolute;\n        top: -20px;\n        right: -20px;\n        border: 1px solid $border-color;\n        height: 280px;\n        width: 280px;\n        margin: 0 auto;\n        border-radius: 50%;\n    }\n\n    .circle3 {\n        position: absolute;\n        top: -40px;\n        right: -40px;\n        border: 1px solid $border-color;\n        height: 320px;\n        width: 320px;\n        margin: 0 auto;\n        border-radius: 50%;\n    }\n\n    .circle4 {\n        position: absolute;\n        top: -60px;\n        right: -60px;\n        border: 1px solid $border-color;\n        height: 360px;\n        width: 360px;\n        margin: 0 auto;\n        border-radius: 50%;\n    }\n\n    @media (max-width: 991.98px) {\n        display: none;\n    }\n}\n\n.home-img {\n    .user-img {\n        position: relative;\n        z-index: 1;\n    }\n}\n\n//********** About **********//\n.application-box,\n.feedback-box,\n.inquiry-box {\n    max-width: 240px;\n    position: absolute;\n    z-index: 2;\n    transition: all 0.5s ease;\n\n    &:hover {\n        transform: translateY(-5px);\n    }\n}\n\n.inquiry-box {\n    left: -134px;\n    top: 90px;\n\n    @media (max-width: 991.98px) {\n        left: 0;\n    }\n}\n\n.application-box {\n    bottom: 50px;\n    right: -160px;\n\n    @media (max-width: 991.98px) {\n        right: 0;\n    }\n}\n\n.feedback-box {\n    right: -50px;\n    bottom: -54px;\n\n    @media (max-width: 576.98px) {\n        right: 0;\n        bottom: 0;\n    }\n}\n\n.job-icon-effect {\n    height: 30px;\n    width: 30px;\n    position: absolute;\n    top: 0px;\n    left: -2%;\n    border-radius: 50%;\n    background: repeating-linear-gradient(-55deg, rgba($white, 0) 0.8px, $success 1.6px, $success 2px, rgba($white, 0) 3.8px, rgba($white, 0) 5px);\n    z-index: 0;\n    opacity: 0.20;\n\n    span {\n        position: relative;\n        z-index: 1;\n    }\n}\n\n.about-img-section {\n    position: relative;\n\n    &::before {\n        content: \"\";\n        position: absolute;\n        left: 20px;\n        right: -20px;\n        top: -20px;\n        bottom: 20px;\n        border: 1px solid $info;\n        z-index: 0;\n        border-radius: $border-radius;\n\n        @media (max-width: 576.98px) {\n            right: 20px;\n            top: 20px;\n        }\n    }\n\n}\n\n.features-company-widgets {\n    position: absolute;\n    bottom: -18px;\n    right: -35px;\n}","/*\nTemplate Name: Velzon - Admin & Dashboard Template\nAuthor: Themesbrand\nWebsite: https://themesbrand.com/\nContact: support@themesbrand.com\nFile: Custom Css File\n*/\n\n.css-b62m3t-container {\n  .css-13cymwt-control {\n    background-color: #fff; /* input bg */\n    border-color: var(--#{$prefix}border-color);\n    &:hover {\n      border-color: var(--#{$prefix}border-color);\n    }\n  }\n  .css-t3ipsp-control {\n    background-color: var(--#{$prefix}gray-200);\n    border-color: var(--#{$prefix}border-color);\n    box-shadow: none;\n    &:hover {\n      border-color: var(--#{$prefix}border-color) !important;\n    }\n  }\n  .css-1nmdiq5-menu {\n    background-color: var(--#{$prefix}gray-200);\n    .css-10wo9uf-option {\n      cursor: pointer;\n      background-color: var(--#{$prefix}gray-200);\n      &:active {\n        background-color: var(--#{$prefix}gray-200);\n      }\n    }\n    .css-d7l1ni-option {\n      cursor: pointer;\n      background-color: var(--#{$prefix}gray-100);\n    }\n  }\n  .css-1p3m7a8-multiValue {\n    background-color: var(--#{$variable-prefix}light);\n  }\n  .css-wsp0cs-MultiValueGeneric {\n    color: $heading-color;\n  }\n  .css-12jo7m5 {\n    color: $heading-color;\n  }\n  .css-6j8wv5-Input,\n  .css-qc6sy-singleValue {\n    color: $heading-color;\n  }\n\n  .css-1dimb5e-singleValue {\n    color: var(--vz-body-color);\n  }\n}\n\n.marketplace-swiper .swiper-button-next,\n.marketplace-swiper .swiper-button-prev {\n  top: 24px;\n}\n\n.marquee {\n  width: 100%;\n  overflow: hidden;\n  position: relative;\n  height: 22px;\n  line-height: 2;\n}\n\n.marquee div {\n  display: block;\n  width: 200%;\n  height: 30px;\n  position: absolute;\n  overflow: hidden;\n  animation: marquee 35s linear infinite;\n}\n\n.marquee span {\n  float: left;\n  width: 50%;\n}\n\n@keyframes marquee {\n  0% {\n    left: 0;\n  }\n\n  100% {\n    left: -100%;\n  }\n}\n\n// Data Table\n\n.kVrXuC,\n.dwPlXY,\n.gKbhqU,\n.iSAVrt {\n  background-color: $table-bg !important;\n  color: $table-color !important;\n}\n\n.fyrdjl {\n  color: rgba(var(--#{$prefix}body-color-rgb), 0.54) !important;\n  fill: rgba(var(--#{$prefix}body-color-rgb), 0.54) !important;\n}\n\n.fyrdjl:disabled {\n  color: rgba(var(--#{$prefix}body-color-rgb), 0.18) !important;\n  fill: rgba(var(--#{$prefix}body-color-rgb), 0.18) !important;\n}\n\n.iSAVrt {\n  background-color: var(--#{$prefix}card-bg-custom) !important;\n  border-bottom-color: $table-border-color !important;\n}\n\n.dwPlXY:not(:last-of-type) {\n  border-bottom-color: $table-border-color !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
